const FORMINFO= {
    "manufacturerId": "HDFC",
    "productId": "P1C2PL",
    "productGroupId": "LifeTerm",
    "productGroupType": "Insurance",
    "fieldGroups": {
        "proposerDetails": {
            "id": 24,
            "name": "proposerDetails",
            "description": "Proposer Details",
            "parent": null,
            "label": "Proposer Details",
            "type": null,
            "sizeOfArray": null,
            "visibility": null,
            "validation": null,
            "order": 3,
            "fieldGroups": {
                "personalDetails": {
                    "id": 25,
                    "name": "personalDetails",
                    "description": "Personal Details",
                    "parent": 24,
                    "label": "Personal Details",
                    "type": null,
                    "sizeOfArray": null,
                    "visibility": null,
                    "validation": null,
                    "order": 1,
                    "fields": {
                        "relationWithLA": {
                            "id": "1392",
                            "label": "Relation with Life Assured",
                            "name": "relationWithLA",
                            "description": "Relationship of proposer with first or primary life assured.",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Father",
                                    "Value": "Father"
                                },
                                {
                                    "Text": "Grandfather",
                                    "Value": "Grandfather"
                                },
                                {
                                    "Text": "Grandmother",
                                    "Value": "Grandmother"
                                },
                                {
                                    "Text": "Husband",
                                    "Value": "Husband"
                                },
                                {
                                    "Text": "Mother",
                                    "Value": "Mother"
                                },
                                {
                                    "Text": "Spouse",
                                    "Value": "Spouse"
                                },
                                {
                                    "Text": "Self",
                                    "Value": "Self"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "title": {
                            "id": "198",
                            "label": "Title",
                            "name": "title",
                            "description": "Choose appropriate Title to define the Gender of member",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Dr",
                                    "Value": "Dr"
                                },
                                {
                                    "Text": "Kumar",
                                    "Value": "Kumar"
                                },
                                {
                                    "Text": "Kumari",
                                    "Value": "Kumari"
                                },
                                {
                                    "Text": "Miss",
                                    "Value": "Miss"
                                },
                                {
                                    "Text": "Mr",
                                    "Value": "Mr"
                                },
                                {
                                    "Text": "Mrs",
                                    "Value": "Mrs"
                                },
                                {
                                    "Text": "Ms",
                                    "Value": "Ms"
                                },
                                {
                                    "Text": "Shri",
                                    "Value": "Shri"
                                },
                                {
                                    "Text": "Smt",
                                    "Value": "Smt"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": "((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Daughter' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Grandmother' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Mother' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Sister') && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Kumari' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Miss' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Mrs' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Smt' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Ms') ) || ((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Son' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Grandfather' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Father' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Brother' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Husband') && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Kumar' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Mr' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Shri')) || ( formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Self' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']==='Spouse') || ( formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Dr')"
                        },
                        "firstName": {
                            "id": "199",
                            "label": "First Name",
                            "name": "firstName",
                            "description": "No special characters allowed #Name should be exactly as per valid Id Proof.",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['firstName']['input'] = quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['firstName']\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['firstName']['mandatory'] = 2\r\n}\r\nelse if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self'){\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['firstName']['mandatory'] = 1\r\n}",
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[A-Za-z\\\\s]+$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "middleName": {
                            "id": "193",
                            "label": "Middle Name",
                            "name": "middleName",
                            "description": "No special characters allowed # Middle Name should be exactly as per valid Id Proof.",
                            "mandatory": 0,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[A-Za-z\\\\s]+$/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "lastName": {
                            "id": "200",
                            "label": "Last Name",
                            "name": "lastName",
                            "description": "No special characters allowed #Last Name should be exactly as per valid Id Proof",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['lastName']['input'] = quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['lastName']\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['lastName']['mandatory'] = 2\r\n}\r\nelse if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self'){\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['lastName']['mandatory'] = 1\r\n}",
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[A-Za-z\\\\s]+$/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "gender": {
                            "id": "201",
                            "label": "Gender",
                            "name": "gender",
                            "description": "Choose appropriate title for the Gender",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Female",
                                    "Value": "F"
                                },
                                {
                                    "Text": "Male",
                                    "Value": "M"
                                }
                            ],
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  if (quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['gender'] != 'Other'){\r\n     if (quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['gender'] == 'Male') {\r\n        formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input'] = 'M'\r\n     }\r\n     else if (quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['gender'] == 'Female') {\r\n        formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input'] = 'F'\r\n     }\r\n  }\r\n  else if (quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['gender'] == 'Other'){\r\n    formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['mandatory'] = 1\r\n  }\r\n}",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input']==='F' &&  (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Kumari' ||  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Miss' ||  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Ms' ||  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Mrs' ||  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Smt')) || (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input']==='M' &&   (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Kumar' ||  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Mr' ||  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Shri')) || ( formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Dr')"
                        },
                        "dateOfBirth": {
                            "id": "1407",
                            "label": "Date Of Birth",
                            "name": "dateOfBirth",
                            "description": "Provide as per valid id proof #No future dates allowed",
                            "mandatory": 1,
                            "type": "date",
                            "value": null,
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'] = quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['dateOfBirth']\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['mandatory'] = 2\r\n}\r\nelse if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self'){\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['mandatory'] = 1\r\n}",
                            "min": null,
                            "max": 20,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": "((new Date(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input']) < new Date() ) &&  \r\n(parseInt((new Date() - new Date((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'])))/1000/60/60/24/365) <= 100))"
                        },
                        "placeOfBirth": {
                            "id": "209",
                            "label": "Place of Birth",
                            "name": "placeOfBirth",
                            "description": "Place of birth cannot contain special characters or numbers #Type your place of birth",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[A-Za-z\\s]+$/",
                            "input": "",
                            "visibility": "",
                            "validation": "'input' in formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['placeOfBirth'] && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['placeOfBirth']['input'] !== null) && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['placeOfBirth']['input'].trimEnd() === formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['placeOfBirth']['input']) && !(/(.)\\1{2,}/.test(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['placeOfBirth']['input'])) && !/[!@#$%^&()+\\-=\\[\\]{};':\"\\\\|,.<>\/?0-9]+/.test(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['placeOfBirth']['input'])"
                        },
                        "ftitle": {
                            "id": "1418",
                            "label": "Title",
                            "name": "ftitle",
                            "description": "Choose appropriate Title to define the Gender of member",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Dr",
                                    "Value": "Dr"
                                },
                                {
                                    "Text": "Mr",
                                    "Value": "Mr"
                                },
                                {
                                    "Text": "Shri",
                                    "Value": "Shri"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "fatherName": {
                            "id": "203",
                            "label": "Fathers Name",
                            "name": "fatherName",
                            "description": "Name cannot contain special characters or numbers #Name should be exactly as per valid Id Proof. Please mention full name",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[A-Za-z\\s]+$/",
                            "input": "",
                            "visibility": "",
                            "validation": "'input' in formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fatherName'] && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fatherName']['input'] !== null) && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fatherName']['input'].trimEnd() === formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fatherName']['input']) && !(/(.)\\1{2,}/.test(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fatherName']['input'])) && !/[!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\/?0-9]+/.test(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['fatherName']['input'])"
                        },
                        "mtitle": {
                            "id": "2183",
                            "label": "Title",
                            "name": "mtitle",
                            "description": "Choose appropriate Title to define the Gender of member",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Dr",
                                    "Value": "Dr"
                                },
                                {
                                    "Text": "Mrs",
                                    "Value": "Mrs"
                                },
                                {
                                    "Text": "Smt",
                                    "Value": "Smt"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "motherName": {
                            "id": "195",
                            "label": "Mothers Name",
                            "name": "motherName",
                            "description": "Name cannot contain special characters or numbers #Name should be exactly as per valid Id Proof. Please mention full name",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[A-Za-z\\s]+$/",
                            "input": "",
                            "visibility": "",
                            "validation": "'input' in formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['motherName'] && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['motherName']['input'] !== null) && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['motherName']['input'].trimEnd() === formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['motherName']['input']) && !(/(.)\\1{2,}/.test(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['motherName']['input'])) && !/[!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\/?0-9]+/.test(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['motherName']['input'])"
                        },
                        "maritalStatus": {
                            "id": "204",
                            "label": "Marital Status",
                            "name": "maritalStatus",
                            "description": "Select your correct marital status",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Divorced",
                                    "Value": "divorced"
                                },
                                {
                                    "Text": "Married",
                                    "Value": "married"
                                },
                                {
                                    "Text": "Single",
                                    "Value": "single"
                                },
                                {
                                    "Text": "Widowed",
                                    "Value": "widowed"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": "(((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Kumar' ||\r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Kumari' || \r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Miss' || \r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Ms' ) && \r\n(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input']!=='married' )) || \r\n((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Mrs') && \r\n(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input']!=='single')) || \r\n(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Mr' || \r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Dr'  || \r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Shri' || \r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['title']['input']==='Smt' )) &&\r\n(((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'married') && \r\n(parseInt((new Date() - new Date((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'])))/1000/60/60/24/365) >= 18 )) || \r\n((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'divorced') && \r\n(parseInt((new Date() - new Date((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'])))/1000/60/60/24/365) >= 18 )) ||\r\n((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'widowed') && \r\n(parseInt((new Date() - new Date((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'])))/1000/60/60/24/365) >= 18 )) ||\r\n((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'single'))) &&\r\n((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'single' && \r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input'] !== 'housewife') || \r\n(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] !== 'single')) && \r\n((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input']==='M' && \r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'married' && \r\nformInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input'] !== 'housewife') || \r\n(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'single') || \r\n(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'widowed') || \r\n(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input'] === 'divorced') || \r\n(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input']==='F'))"
                        },
                        "stitle": {
                            "id": "2625",
                            "label": "Title",
                            "name": "stitle",
                            "description": "Choose appropriate Title to define the Gender of member",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Dr",
                                    "Value": "Dr"
                                },
                                {
                                    "Text": "Mr",
                                    "Value": "Mr"
                                },
                                {
                                    "Text": "Ms",
                                    "Value": "Ms"
                                },
                                {
                                    "Text": "Shri",
                                    "Value": "Shri"
                                },
                                {
                                    "Text": "Smt",
                                    "Value": "Smt"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input']==='married'",
                            "validation": "((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input']!=='M') &&(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['stitle']['input']==='Mr' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['stitle']['input']==='Shri' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['stitle']['input']==='Dr')) ||((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['gender']['input']!=='F') &&(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['stitle']['input']==='Mrs' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['stitle']['input']==='Smt' || formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['stitle']['input']==='Dr'))"
                        },
                        "spouseName": {
                            "id": "196",
                            "label": "Spouse Name",
                            "name": "spouseName",
                            "description": "Name cannot contain special characters or numbers #Name should be exactly as per valid Id Proof. Please mention full name",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[A-Za-z\\s]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['maritalStatus']['input']==='married'",
                            "validation": "'input' in formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['spouseName'] && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['spouseName']['input'] !== null) && (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['spouseName']['input'].trimEnd() === formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['spouseName']['input']) && !(/(.)\\1{2,}/.test(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['spouseName']['input'])) && !/[!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\/?0-9]+/.test(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['spouseName']['input'])"
                        },
                        "mobileNumber": {
                            "id": "2645",
                            "label": "Mobile Number",
                            "name": "mobileNumber",
                            "description": "Mobile number can only have numbers #Please enter 10 digits for Indian Number and 15 for NRI/OCI/PIO/FN",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self') {\\r\\n  formInfo['fieldGroups']['firstLifeAssuredDetails']['fieldGroups']['personalDetails']['fields']['mobileNumber']['input'] = ''+quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['mobileNumber']\\r\\n}",
                            "min": 10,
                            "max": 10,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "email": {
                            "id": "218",
                            "label": "Email ID",
                            "name": "email",
                            "description": "Email ID of proposer Example abc@example.com ",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 100,
                            "pattern": "/[a-zA-Z0-9]+@[a-zA-Z0-9]+.[a-zA-Z]{2,}/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "nationality": {
                            "id": "205",
                            "label": "Nationality",
                            "name": "nationality",
                            "description": "What is your Nationality?",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Indian",
                                    "Value": "indian"
                                },
                                {
                                    "Text": "Non Indian",
                                    "Value": "nonIndian"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "residentStatus": {
                            "id": "206",
                            "label": "Resident Status",
                            "name": "residentStatus",
                            "description": "Select your resident status",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Foreign National",
                                    "Value": "foreignNational"
                                },
                                {
                                    "Text": "NRI",
                                    "Value": "NRI"
                                },
                                {
                                    "Text": "OCI",
                                    "Value": "oci"
                                },
                                {
                                    "Text": "PIO",
                                    "Value": "pio"
                                },
                                {
                                    "Text": "Resident Indian",
                                    "Value": "residentIndian"
                                }
                            ],
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['residentStatus']['input'] = quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['residentStatus']\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['residentStatus']['mandatory'] = 2\r\n}\r\nelse if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self'){\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['residentStatus']['mandatory'] = 1\r\n}",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "panNumber": {
                            "id": "208",
                            "label": "PAN Number",
                            "name": "panNumber",
                            "description": "Incorrect PAN Pattern #Provide valid PAN as per document",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 10,
                            "max": 10,
                            "pattern": "/^([A-Z]{5}[0-9]{4}[A-Z]{1})$/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "pepFlag": {
                            "id": "235",
                            "label": "Are you a Politically Exposed Person?",
                            "name": "pepFlag",
                            "description": "Are you a Politically Exposed Person?",
                            "mandatory": 1,
                            "type": "boolean",
                            "value": null,
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "historyOfConviction": {
                            "id": "211",
                            "label": "Do you have any History of conviction ?",
                            "name": "historyOfConviction",
                            "description": "Do you have any History of conviction ?",
                            "mandatory": 1,
                            "type": "boolean",
                            "value": null,
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        }
                    }
                },
                "professionalDetails": {
                    "id": 26,
                    "name": "professionalDetails",
                    "description": "Professional Details",
                    "parent": 24,
                    "label": "Professional Details",
                    "type": null,
                    "sizeOfArray": null,
                    "visibility": null,
                    "validation": null,
                    "order": 2,
                    "fields": {
                        "qualification": {
                            "id": "219",
                            "label": "Qualification",
                            "name": "qualification",
                            "description": "If your highest qualification is not in the list, please select 'Others'",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "B A",
                                    "Value": "B A"
                                },
                                {
                                    "Text": "BAMS",
                                    "Value": "BAMS"
                                },
                                {
                                    "Text": "BAC",
                                    "Value": "BAC"
                                },
                                {
                                    "Text": "B B A",
                                    "Value": "B B A"
                                },
                                {
                                    "Text": "BCA",
                                    "Value": "BCA"
                                },
                                {
                                    "Text": "B Com",
                                    "Value": "B Com"
                                },
                                {
                                    "Text": "BDS",
                                    "Value": "BDS"
                                },
                                {
                                    "Text": "B E",
                                    "Value": "B E"
                                },
                                {
                                    "Text": "B Ed",
                                    "Value": "B Ed"
                                },
                                {
                                    "Text": "BHMS",
                                    "Value": "BHMS"
                                },
                                {
                                    "Text": "BMLT",
                                    "Value": "BMLT"
                                },
                                {
                                    "Text": "B M S",
                                    "Value": "B M S"
                                },
                                {
                                    "Text": "B Pharm",
                                    "Value": "B Pharm"
                                },
                                {
                                    "Text": "BPY",
                                    "Value": "BPY"
                                },
                                {
                                    "Text": "B Sc",
                                    "Value": "B Sc"
                                },
                                {
                                    "Text": "B Tech",
                                    "Value": "B Tech"
                                },
                                {
                                    "Text": "BUMS",
                                    "Value": "BUMS"
                                },
                                {
                                    "Text": "Bachelor of Veterinary Science",
                                    "Value": "Bachelor of Veterinary Science"
                                },
                                {
                                    "Text": "CA",
                                    "Value": "CA"
                                },
                                {
                                    "Text": "CFA",
                                    "Value": "CFA"
                                },
                                {
                                    "Text": "CSC",
                                    "Value": "CSC"
                                },
                                {
                                    "Text": "DCE",
                                    "Value": "DCE"
                                },
                                {
                                    "Text": "Diploma in Civil Engineering",
                                    "Value": "Diploma in Civil Engineering"
                                },
                                {
                                    "Text": "D Ed",
                                    "Value": "D Ed"
                                },
                                {
                                    "Text": "Diploma in Electrical Engineering",
                                    "Value": "Diploma in Electrical Engineering"
                                },
                                {
                                    "Text": "Diploma in Fashion designing",
                                    "Value": "Diploma in Fashion designing"
                                },
                                {
                                    "Text": "Diploma in General Nursing",
                                    "Value": "Diploma in General Nursing"
                                },
                                {
                                    "Text": "Diploma in Interior Designing",
                                    "Value": "Diploma in Interior Designing"
                                },
                                {
                                    "Text": "Diploma in Instrumentation Engineering",
                                    "Value": "Diploma in Instrumentation Engineering"
                                },
                                {
                                    "Text": "Diploma",
                                    "Value": "Diploma"
                                },
                                {
                                    "Text": "Diploma in Mechanical Engineering",
                                    "Value": "Diploma in Mechanical Engineering"
                                },
                                {
                                    "Text": "DMLT",
                                    "Value": "DMLT"
                                },
                                {
                                    "Text": "Diploma in Pharmacy",
                                    "Value": "Diploma in Pharmacy"
                                },
                                {
                                    "Text": "DTE",
                                    "Value": "DTE"
                                },
                                {
                                    "Text": "Graduation",
                                    "Value": "Graduation"
                                },
                                {
                                    "Text": "H S C",
                                    "Value": "H S C"
                                },
                                {
                                    "Text": "ICWA",
                                    "Value": "ICWA"
                                },
                                {
                                    "Text": "Illiterate",
                                    "Value": "Illiterate"
                                },
                                {
                                    "Text": "ITI",
                                    "Value": "ITI"
                                },
                                {
                                    "Text": "LLB",
                                    "Value": "LLB"
                                },
                                {
                                    "Text": "Master of Law",
                                    "Value": "Master of Law"
                                },
                                {
                                    "Text": "M A",
                                    "Value": "M A"
                                },
                                {
                                    "Text": "M. Arch.",
                                    "Value": "M. Arch."
                                },
                                {
                                    "Text": "MBA",
                                    "Value": "MBA"
                                },
                                {
                                    "Text": "MBBS",
                                    "Value": "MBBS"
                                },
                                {
                                    "Text": "MCA",
                                    "Value": "MCA"
                                },
                                {
                                    "Text": "M.Ch",
                                    "Value": "M.Ch"
                                },
                                {
                                    "Text": "MCM",
                                    "Value": "MCM"
                                },
                                {
                                    "Text": "M D",
                                    "Value": "M D"
                                },
                                {
                                    "Text": "M E",
                                    "Value": "M E"
                                },
                                {
                                    "Text": "MED",
                                    "Value": "MED"
                                },
                                {
                                    "Text": "MMS",
                                    "Value": "MMS"
                                },
                                {
                                    "Text": "M Pharm",
                                    "Value": "M Pharm"
                                },
                                {
                                    "Text": "M. Phil",
                                    "Value": "M. Phil"
                                },
                                {
                                    "Text": "MPY",
                                    "Value": "MPY"
                                },
                                {
                                    "Text": "M S",
                                    "Value": "M S"
                                },
                                {
                                    "Text": "M Sc",
                                    "Value": "M Sc"
                                },
                                {
                                    "Text": "M Tech",
                                    "Value": "M Tech"
                                },
                                {
                                    "Text": "Others",
                                    "Value": "Others"
                                },
                                {
                                    "Text": "Post Graduation",
                                    "Value": "Post Graduation"
                                },
                                {
                                    "Text": "PG Diploma  Business Admin",
                                    "Value": "PG Diploma  Business Admin"
                                },
                                {
                                    "Text": "PBM",
                                    "Value": "PBM"
                                },
                                {
                                    "Text": "PG Diploma Marketing management",
                                    "Value": "PG Diploma Marketing management"
                                },
                                {
                                    "Text": "PharmD",
                                    "Value": "PharmD"
                                },
                                {
                                    "Text": "Ph.D.",
                                    "Value": "Ph.D."
                                },
                                {
                                    "Text": "S S C",
                                    "Value": "S S C"
                                },
                                {
                                    "Text": "Under Matric (Class l to lX)",
                                    "Value": "Under Matric (Class l to lX)"
                                }
                            ],
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['qualification']['input'] = quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['qualification']\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['qualification']['mandatory'] = 2\r\n}\r\nelse if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self'){\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['qualification']['mandatory'] = 1\r\n}",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "qualificationOther": {
                            "id": "236",
                            "label": "Educational Qualification - Others",
                            "name": "qualificationOther",
                            "description": "Select your highest qualification",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[A-Za-z\\\\s]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['qualification']['input']==='Others'",
                            "validation": ""
                        },
                        "occupation": {
                            "id": "1266",
                            "label": "Occupation",
                            "name": "occupation",
                            "description": "If your Occupation is not in the list, please select 'Others'",
                            "mandatory": 2,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Agriculturist",
                                    "Value": "Agriculturist"
                                },
                                {
                                    "Text": "Housewife",
                                    "Value": "housewife"
                                },
                                {
                                    "Text": "Others",
                                    "Value": "others"
                                },
                                {
                                    "Text": "Retired",
                                    "Value": "retired"
                                },
                                {
                                    "Text": "Salaried",
                                    "Value": "salaried"
                                },
                                {
                                    "Text": "Self employed/ Business",
                                    "Value": "Self employed/ Business"
                                },
                                {
                                    "Text": "Student",
                                    "Value": "student"
                                },
                                {
                                    "Text": "Unemployed",
                                    "Value": "Unemployed"
                                }
                            ],
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input'] = quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['occupation']\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['mandatory'] = 2\r\n}\r\nelse if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self'){\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['mandatory'] = 1\r\n}",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "occupationDesc": {
                            "id": "237",
                            "label": "Other Occupation ",
                            "name": "occupationDesc",
                            "description": "Enter your Occupation.",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 100,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='others'",
                            "validation": ""
                        },
                        "occRisk": {
                            "id": "1491",
                            "label": "Does your occupation involve any specific hazard ?",
                            "name": "occRisk",
                            "description": "Does your occupation involve any specific hazard ?",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Working at heights",
                                    "Value": "OHRD_WAH"
                                },
                                {
                                    "Text": "None of these",
                                    "Value": "OHRD_NOT"
                                },
                                {
                                    "Text": "Handling heavy machinery",
                                    "Value": "OHRD_HHM"
                                },
                                {
                                    "Text": "Handling explosives",
                                    "Value": "OHRD_HE"
                                },
                                {
                                    "Text": "Exposure to hazardous materials",
                                    "Value": "OHRD_ETHM"
                                },
                                {
                                    "Text": "Exposure to harmful dust or gases",
                                    "Value": "OHRD_ETHDG"
                                },
                                {
                                    "Text": "Exposure to chemical substances",
                                    "Value": "OHRD_ETCS"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='housewife' && formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='student'&&formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='Unemployed'&&formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='retired'",
                            "validation": ""
                        },
                        "currentQualification": {
                            "id": "1492",
                            "label": "Course currently being pursued\r ",
                            "name": "currentQualification",
                            "description": "No special characters allowed #Course currently being pursued",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[0-9a-zA-Z\\s]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='student'",
                            "validation": ""
                        },
                        "schoolName": {
                            "id": "1493",
                            "label": "Name and address of the School/College/Institution being attended \r ",
                            "name": "schoolName",
                            "description": "Name and address of the School/College/Institution being attended ",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='student'",
                            "validation": ""
                        },
                        "parentCover": {
                            "id": "1494",
                            "label": "Parents Total Life Cover",
                            "name": "parentCover",
                            "description": "Parents Total Life Cover",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 12,
                            "pattern": "/^[0-9]*$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='student'",
                            "validation": ""
                        },
                        "noOfChildrn": {
                            "id": "1495",
                            "label": "How many children do you have?",
                            "name": "noOfChildrn",
                            "description": "Enter Number of Children you have",
                            "mandatory": 1,
                            "type": "number",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": 12,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='housewife'",
                            "validation": ""
                        },
                        "marriageDate": {
                            "id": "1496",
                            "label": "Date of marriage",
                            "name": "marriageDate",
                            "description": "Enter Marriage Date as per marriage certificate",
                            "mandatory": 1,
                            "type": "date",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='housewife'",
                            "validation": "(( parseInt((new Date() - new Date((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'])))/1000/60/60/24/365) >= 18) && (new Date(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['marriageDate']['input']) < new Date()) && ((parseFloat((new Date() - new Date((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'])))/1000/60/60/24/365)) - ( parseFloat((new Date() - new Date((formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['marriageDate']['input'])))/1000/60/60/24/365))) >= 18.01095890410959)"
                        },
                        "husbandOcc": {
                            "id": "1497",
                            "label": "Husband's occupation",
                            "name": "husbandOcc",
                            "description": "Enter Husband's occupation",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": "/^[A-Za-z\\s]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='housewife'",
                            "validation": ""
                        },
                        "husbandIncome": {
                            "id": "1498",
                            "label": "Husband's annual income (Rs)",
                            "name": "husbandIncome",
                            "description": "Husband's annual income (Rs)",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[0-9]{1,20}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='housewife'",
                            "validation": ""
                        },
                        "husbandCover": {
                            "id": "1499",
                            "label": "Husband's total life insurance cover with HDFCSL",
                            "name": "husbandCover",
                            "description": "Husband's total life insurance cover with HDFCSL",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 12,
                            "pattern": "/^[0-9]{1,20}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='housewife'",
                            "validation": ""
                        },
                        "husbandCover1": {
                            "id": "1500",
                            "label": "Husband's total In-force life insurance cover with other insurance company/ companies (Do not include Withdrawn and Lapsed policies).",
                            "name": "husbandCover1",
                            "description": "Husband's total In-force life insurance cover with other insurance company/ companies (Do not include Withdrawn and Lapsed policies).",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 12,
                            "pattern": "/^[0-9]{1,20}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='housewife'",
                            "validation": ""
                        },
                        "profession": {
                            "id": "1269",
                            "label": "Designation",
                            "name": "profession",
                            "description": "Designation",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Aaganwadi Worker",
                                    "Value": "Aaganwadi Worker"
                                },
                                {
                                    "Text": "Assistant Branch Manager EM",
                                    "Value": "Assistant Branch Manager EM"
                                },
                                {
                                    "Text": "Assistant Manager Group Sales",
                                    "Value": "Assistant Manager Group Sales"
                                },
                                {
                                    "Text": "Assistant Branch Manager",
                                    "Value": "Assistant Branch Manager"
                                },
                                {
                                    "Text": "Assistant Manager",
                                    "Value": "Assistant Manager"
                                },
                                {
                                    "Text": "Asbestos Worker",
                                    "Value": "Asbestos Worker"
                                },
                                {
                                    "Text": "A.B.M",
                                    "Value": "A.B.M"
                                },
                                {
                                    "Text": "A.R.M",
                                    "Value": "A.R.M"
                                },
                                {
                                    "Text": "AC Engineer",
                                    "Value": "AC Engineer"
                                },
                                {
                                    "Text": "Academic Counselor",
                                    "Value": "Academic Counselor"
                                },
                                {
                                    "Text": "Accountant & Proprietor",
                                    "Value": "Accountant & Proprietor"
                                },
                                {
                                    "Text": "Accountant Assistant",
                                    "Value": "Accountant Assistant"
                                },
                                {
                                    "Text": "Accounting Analyst",
                                    "Value": "Accounting Analyst"
                                },
                                {
                                    "Text": "Accounting Consultant",
                                    "Value": "Accounting Consultant"
                                },
                                {
                                    "Text": "Accounting Head",
                                    "Value": "Accounting Head"
                                },
                                {
                                    "Text": "Accounting Project Consultant",
                                    "Value": "Accounting Project Consultant"
                                },
                                {
                                    "Text": "AC Technician",
                                    "Value": "AC Technician"
                                },
                                {
                                    "Text": "Accounts & Support Officer",
                                    "Value": "Accounts & Support Officer"
                                },
                                {
                                    "Text": "Accounts Associate",
                                    "Value": "Accounts Associate"
                                },
                                {
                                    "Text": "Accounts Consultant",
                                    "Value": "Accounts Consultant"
                                },
                                {
                                    "Text": "Assistant Teacher",
                                    "Value": "Assistant Teacher"
                                },
                                {
                                    "Text": "Accounts Cum Cash Clerk",
                                    "Value": "Accounts Cum Cash Clerk"
                                },
                                {
                                    "Text": "Accounts Director",
                                    "Value": "Accounts Director"
                                },
                                {
                                    "Text": "Accounts Directorate",
                                    "Value": "Accounts Directorate"
                                },
                                {
                                    "Text": "Accounts Group Head",
                                    "Value": "Accounts Group Head"
                                },
                                {
                                    "Text": "Accounts Head",
                                    "Value": "Accounts Head"
                                },
                                {
                                    "Text": "Accounts Head & Sr. Accountant",
                                    "Value": "Accounts Head & Sr. Accountant"
                                },
                                {
                                    "Text": "Accounts Incharge",
                                    "Value": "Accounts Incharge"
                                },
                                {
                                    "Text": "Accounts Logistics Manager",
                                    "Value": "Accounts Logistics Manager"
                                },
                                {
                                    "Text": "Accounts Receivable Manager",
                                    "Value": "Accounts Receivable Manager"
                                },
                                {
                                    "Text": "Accounts Supervisor",
                                    "Value": "Accounts Supervisor"
                                },
                                {
                                    "Text": "Accounts Writing",
                                    "Value": "Accounts Writing"
                                },
                                {
                                    "Text": "Accountant",
                                    "Value": "Accountant"
                                },
                                {
                                    "Text": "Accounting Consultancy",
                                    "Value": "Accounting Consultancy"
                                },
                                {
                                    "Text": "Accounts-Estate Officer",
                                    "Value": "Accounts-Estate Officer"
                                },
                                {
                                    "Text": "Accounts Manager Sales",
                                    "Value": "Accounts Manager Sales"
                                },
                                {
                                    "Text": "Accountant & FC",
                                    "Value": "Accountant & FC"
                                },
                                {
                                    "Text": "Accounts Staff",
                                    "Value": "Accounts Staff"
                                },
                                {
                                    "Text": "Academic Incharge",
                                    "Value": "Academic Incharge"
                                },
                                {
                                    "Text": "Accounts Officer II",
                                    "Value": "Accounts Officer II"
                                },
                                {
                                    "Text": "Accounts Officer Retail",
                                    "Value": "Accounts Officer Retail"
                                },
                                {
                                    "Text": "A/C Mechanic",
                                    "Value": "A/C Mechanic"
                                },
                                {
                                    "Text": "Accounts Manager Servicing",
                                    "Value": "Accounts Manager Servicing"
                                },
                                {
                                    "Text": "Accountant Operations",
                                    "Value": "Accountant Operations"
                                },
                                {
                                    "Text": "Accounts Assistant",
                                    "Value": "Accounts Assistant"
                                },
                                {
                                    "Text": "Applications Consultant",
                                    "Value": "Applications Consultant"
                                },
                                {
                                    "Text": "Academic Fellow",
                                    "Value": "Academic Fellow"
                                },
                                {
                                    "Text": "Account Processor",
                                    "Value": "Account Processor"
                                },
                                {
                                    "Text": "Accounts Clerk",
                                    "Value": "Accounts Clerk"
                                },
                                {
                                    "Text": "Actuarial Analyst",
                                    "Value": "Actuarial Analyst"
                                },
                                {
                                    "Text": "Academic Associate",
                                    "Value": "Academic Associate"
                                },
                                {
                                    "Text": "Acupuncturist",
                                    "Value": "Acupuncturist"
                                },
                                {
                                    "Text": "AC Officer",
                                    "Value": "AC Officer"
                                },
                                {
                                    "Text": "Accounting Technician I",
                                    "Value": "Accounting Technician I"
                                },
                                {
                                    "Text": "Accounts Coordinator",
                                    "Value": "Accounts Coordinator"
                                },
                                {
                                    "Text": "Public relations manager",
                                    "Value": "Public relations manager"
                                },
                                {
                                    "Text": "Public relations officer",
                                    "Value": "Public relations officer"
                                },
                                {
                                    "Text": "Brand manager",
                                    "Value": "Brand manager"
                                },
                                {
                                    "Text": "Publicity manager",
                                    "Value": "Publicity manager"
                                },
                                {
                                    "Text": "Office boy",
                                    "Value": "Office boy"
                                },
                                {
                                    "Text": "Business analyst",
                                    "Value": "Business analyst"
                                },
                                {
                                    "Text": "Customer service assistant",
                                    "Value": "Customer service assistant"
                                },
                                {
                                    "Text": "Customer service officer",
                                    "Value": "Customer service officer"
                                },
                                {
                                    "Text": "Customer service executive",
                                    "Value": "Customer service executive"
                                },
                                {
                                    "Text": "Human resources executive",
                                    "Value": "Human resources executive"
                                },
                                {
                                    "Text": "Human resources manager",
                                    "Value": "Human resources manager"
                                },
                                {
                                    "Text": "Loans officer",
                                    "Value": "Loans officer"
                                },
                                {
                                    "Text": "Management trainee",
                                    "Value": "Management trainee"
                                },
                                {
                                    "Text": "Market research executive",
                                    "Value": "Market research executive"
                                },
                                {
                                    "Text": "Assistant buyer",
                                    "Value": "Assistant buyer"
                                },
                                {
                                    "Text": "Purchase manager",
                                    "Value": "Purchase manager"
                                },
                                {
                                    "Text": "Administrative Assistant",
                                    "Value": "Administrative Assistant"
                                },
                                {
                                    "Text": "Training officer",
                                    "Value": "Training officer"
                                },
                                {
                                    "Text": "Payroll manager",
                                    "Value": "Payroll manager"
                                },
                                {
                                    "Text": "Payroll supervisor",
                                    "Value": "Payroll supervisor"
                                },
                                {
                                    "Text": "Counsellor",
                                    "Value": "Counsellor"
                                },
                                {
                                    "Text": "Personnel manager",
                                    "Value": "Personnel manager"
                                },
                                {
                                    "Text": "Recruitment consultant",
                                    "Value": "Recruitment consultant"
                                },
                                {
                                    "Text": "Public relations executive",
                                    "Value": "Public relations executive"
                                },
                                {
                                    "Text": "Personal secretary",
                                    "Value": "Personal secretary"
                                },
                                {
                                    "Text": "Team leader",
                                    "Value": "Team leader"
                                },
                                {
                                    "Text": "Team manager",
                                    "Value": "Team manager"
                                },
                                {
                                    "Text": "Data entry operator",
                                    "Value": "Data entry operator"
                                },
                                {
                                    "Text": "Compliance manager",
                                    "Value": "Compliance manager"
                                },
                                {
                                    "Text": "Department head",
                                    "Value": "Department head"
                                },
                                {
                                    "Text": "Appraiser",
                                    "Value": "Appraiser"
                                },
                                {
                                    "Text": "Additional Chief Manager",
                                    "Value": "Additional Chief Manager"
                                },
                                {
                                    "Text": "Audit officer",
                                    "Value": "Audit officer"
                                },
                                {
                                    "Text": "Officer-administration",
                                    "Value": "Officer-administration"
                                },
                                {
                                    "Text": "Section officer",
                                    "Value": "Section officer"
                                },
                                {
                                    "Text": "Ward officer",
                                    "Value": "Ward officer"
                                },
                                {
                                    "Text": "Assessment officer",
                                    "Value": "Assessment officer"
                                },
                                {
                                    "Text": "Weights measures inspector",
                                    "Value": "Weights measures inspector"
                                },
                                {
                                    "Text": "Additional Master",
                                    "Value": "Additional Master"
                                },
                                {
                                    "Text": "Postmaster",
                                    "Value": "Postmaster"
                                },
                                {
                                    "Text": "RTO Officer",
                                    "Value": "RTO Officer"
                                },
                                {
                                    "Text": "Floor manager",
                                    "Value": "Floor manager"
                                },
                                {
                                    "Text": "Sales verifier",
                                    "Value": "Sales verifier"
                                },
                                {
                                    "Text": "Officer opeartion",
                                    "Value": "Officer opeartion"
                                },
                                {
                                    "Text": "Addtl Development Commissioner",
                                    "Value": "Addtl Development Commissioner"
                                },
                                {
                                    "Text": "Admin Department Clerk",
                                    "Value": "Admin Department Clerk"
                                },
                                {
                                    "Text": "Admin Incharge",
                                    "Value": "Admin Incharge"
                                },
                                {
                                    "Text": "Advisor Training Force",
                                    "Value": "Advisor Training Force"
                                },
                                {
                                    "Text": "Admin Officer",
                                    "Value": "Admin Officer"
                                },
                                {
                                    "Text": "Administative Officer",
                                    "Value": "Administative Officer"
                                },
                                {
                                    "Text": "Administration Coordinator",
                                    "Value": "Administration Coordinator"
                                },
                                {
                                    "Text": "Administration Incharge",
                                    "Value": "Administration Incharge"
                                },
                                {
                                    "Text": "Administration Officer",
                                    "Value": "Administration Officer"
                                },
                                {
                                    "Text": "Administrative Fin. Sr. Officr",
                                    "Value": "Administrative Fin. Sr. Officr"
                                },
                                {
                                    "Text": "Administrative Head",
                                    "Value": "Administrative Head"
                                },
                                {
                                    "Text": "Administrative Manager",
                                    "Value": "Administrative Manager"
                                },
                                {
                                    "Text": "Administrative Officer",
                                    "Value": "Administrative Officer"
                                },
                                {
                                    "Text": "Admin. & Finance Senior Officr",
                                    "Value": "Admin. & Finance Senior Officr"
                                },
                                {
                                    "Text": "Administrator & Partner",
                                    "Value": "Administrator & Partner"
                                },
                                {
                                    "Text": "Administratr & Fin. Consultant",
                                    "Value": "Administratr & Fin. Consultant"
                                },
                                {
                                    "Text": "Advertisement Controller",
                                    "Value": "Advertisement Controller"
                                },
                                {
                                    "Text": "Advertisement Executive",
                                    "Value": "Advertisement Executive"
                                },
                                {
                                    "Text": "Advertisement Manager",
                                    "Value": "Advertisement Manager"
                                },
                                {
                                    "Text": "Advertising Contractor",
                                    "Value": "Advertising Contractor"
                                },
                                {
                                    "Text": "Advisor",
                                    "Value": "Advisor"
                                },
                                {
                                    "Text": "Advisor Marketing",
                                    "Value": "Advisor Marketing"
                                },
                                {
                                    "Text": "Advocate & Income Tax Lawyer",
                                    "Value": "Advocate & Income Tax Lawyer"
                                },
                                {
                                    "Text": "Advocate & Notary",
                                    "Value": "Advocate & Notary"
                                },
                                {
                                    "Text": "Advocate & Partner",
                                    "Value": "Advocate & Partner"
                                },
                                {
                                    "Text": "Advocate & Property Consultant",
                                    "Value": "Advocate & Property Consultant"
                                },
                                {
                                    "Text": "Advocate & Proprietor",
                                    "Value": "Advocate & Proprietor"
                                },
                                {
                                    "Text": "Advocate Clerk",
                                    "Value": "Advocate Clerk"
                                },
                                {
                                    "Text": "Advocate Government",
                                    "Value": "Advocate Government"
                                },
                                {
                                    "Text": "Advocate Income Tax",
                                    "Value": "Advocate Income Tax"
                                },
                                {
                                    "Text": "Advocate Supreme Court",
                                    "Value": "Advocate Supreme Court"
                                },
                                {
                                    "Text": "Advocate Tax Consultant",
                                    "Value": "Advocate Tax Consultant"
                                },
                                {
                                    "Text": "Additional Inc Tax Commisioner",
                                    "Value": "Additional Inc Tax Commisioner"
                                },
                                {
                                    "Text": "Administration Sales",
                                    "Value": "Administration Sales"
                                },
                                {
                                    "Text": "Administration Staff",
                                    "Value": "Administration Staff"
                                },
                                {
                                    "Text": "Admin In charge",
                                    "Value": "Admin In charge"
                                },
                                {
                                    "Text": "Additional Superintendent Engg",
                                    "Value": "Additional Superintendent Engg"
                                },
                                {
                                    "Text": "Admin Tahasil",
                                    "Value": "Admin Tahasil"
                                },
                                {
                                    "Text": "Vice president",
                                    "Value": "Vice president"
                                },
                                {
                                    "Text": "President",
                                    "Value": "President"
                                },
                                {
                                    "Text": "CFO",
                                    "Value": "CFO"
                                },
                                {
                                    "Text": "Executive assistant",
                                    "Value": "Executive assistant"
                                },
                                {
                                    "Text": "Audit clerk",
                                    "Value": "Audit clerk"
                                },
                                {
                                    "Text": "Office assistant",
                                    "Value": "Office assistant"
                                },
                                {
                                    "Text": "Accounts officer",
                                    "Value": "Accounts officer"
                                },
                                {
                                    "Text": "Audit manager",
                                    "Value": "Audit manager"
                                },
                                {
                                    "Text": "Account executive",
                                    "Value": "Account executive"
                                },
                                {
                                    "Text": "Assistant accountant",
                                    "Value": "Assistant accountant"
                                },
                                {
                                    "Text": "Staff accountant",
                                    "Value": "Staff accountant"
                                },
                                {
                                    "Text": "Cost accountant",
                                    "Value": "Cost accountant"
                                },
                                {
                                    "Text": "Finance manager",
                                    "Value": "Finance manager"
                                },
                                {
                                    "Text": "Financial officer",
                                    "Value": "Financial officer"
                                },
                                {
                                    "Text": "Management accountant",
                                    "Value": "Management accountant"
                                },
                                {
                                    "Text": "Administration manager",
                                    "Value": "Administration manager"
                                },
                                {
                                    "Text": "Administrative",
                                    "Value": "Administrative"
                                },
                                {
                                    "Text": "Executive administartion",
                                    "Value": "Executive administartion"
                                },
                                {
                                    "Text": "Administrator",
                                    "Value": "Administrator"
                                },
                                {
                                    "Text": "Asst administrative officer",
                                    "Value": "Asst administrative officer"
                                },
                                {
                                    "Text": "IAS officer",
                                    "Value": "IAS officer"
                                },
                                {
                                    "Text": "Revenue officer",
                                    "Value": "Revenue officer"
                                },
                                {
                                    "Text": "Assistant Clerk",
                                    "Value": "Assistant Clerk"
                                },
                                {
                                    "Text": "General manager",
                                    "Value": "General manager"
                                },
                                {
                                    "Text": "Trustee",
                                    "Value": "Trustee"
                                },
                                {
                                    "Text": "Makreting executive",
                                    "Value": "Makreting executive"
                                },
                                {
                                    "Text": "Administrator Training",
                                    "Value": "Administrator Training"
                                },
                                {
                                    "Text": "Administration Assistant",
                                    "Value": "Administration Assistant"
                                },
                                {
                                    "Text": "Additional Director",
                                    "Value": "Additional Director"
                                },
                                {
                                    "Text": "Additional Basic Sikh Adhikari",
                                    "Value": "Additional Basic Sikh Adhikari"
                                },
                                {
                                    "Text": "Administration Clerk",
                                    "Value": "Administration Clerk"
                                },
                                {
                                    "Text": "Admiral",
                                    "Value": "Admiral"
                                },
                                {
                                    "Text": "Admin Back Office Support",
                                    "Value": "Admin Back Office Support"
                                },
                                {
                                    "Text": "Advisor Corporate",
                                    "Value": "Advisor Corporate"
                                },
                                {
                                    "Text": "Additional Director Accounts",
                                    "Value": "Additional Director Accounts"
                                },
                                {
                                    "Text": "Advocate",
                                    "Value": "Advocate"
                                },
                                {
                                    "Text": "ACP Hindi Typist",
                                    "Value": "ACP Hindi Typist"
                                },
                                {
                                    "Text": "Activation Officer",
                                    "Value": "Activation Officer"
                                },
                                {
                                    "Text": "Additional Assistant Engineer",
                                    "Value": "Additional Assistant Engineer"
                                },
                                {
                                    "Text": "Additional Chief Engineer",
                                    "Value": "Additional Chief Engineer"
                                },
                                {
                                    "Text": "Additional Chief Exec. Officer",
                                    "Value": "Additional Chief Exec. Officer"
                                },
                                {
                                    "Text": "Additional Director Income Tax",
                                    "Value": "Additional Director Income Tax"
                                },
                                {
                                    "Text": "Additional Dist Session Judge",
                                    "Value": "Additional Dist Session Judge"
                                },
                                {
                                    "Text": "Additional District Judge",
                                    "Value": "Additional District Judge"
                                },
                                {
                                    "Text": "Additional Engineer",
                                    "Value": "Additional Engineer"
                                },
                                {
                                    "Text": "Additional General Manager",
                                    "Value": "Additional General Manager"
                                },
                                {
                                    "Text": "Additional Manager",
                                    "Value": "Additional Manager"
                                },
                                {
                                    "Text": "Additional Registrar",
                                    "Value": "Additional Registrar"
                                },
                                {
                                    "Text": "Additional Registrar Railway",
                                    "Value": "Additional Registrar Railway"
                                },
                                {
                                    "Text": "Additional Senior Manager",
                                    "Value": "Additional Senior Manager"
                                },
                                {
                                    "Text": "Additional Testing Supervisor",
                                    "Value": "Additional Testing Supervisor"
                                },
                                {
                                    "Text": "Administrative Proprietor",
                                    "Value": "Administrative Proprietor"
                                },
                                {
                                    "Text": "Administratn/Reception Officer",
                                    "Value": "Administratn/Reception Officer"
                                },
                                {
                                    "Text": "Assistant editor",
                                    "Value": "Assistant editor"
                                },
                                {
                                    "Text": "Aerobatics pilot instructor",
                                    "Value": "Aerobatics pilot instructor"
                                },
                                {
                                    "Text": "Aerial erector",
                                    "Value": "Aerial erector"
                                },
                                {
                                    "Text": "Agency Owner",
                                    "Value": "Agency Owner"
                                },
                                {
                                    "Text": "Agent & Proprietor",
                                    "Value": "Agent & Proprietor"
                                },
                                {
                                    "Text": "Agent Daily Collection",
                                    "Value": "Agent Daily Collection"
                                },
                                {
                                    "Text": "Agrochemical Division Head",
                                    "Value": "Agrochemical Division Head"
                                },
                                {
                                    "Text": "Agent Promoter",
                                    "Value": "Agent Promoter"
                                },
                                {
                                    "Text": "AGM Corporation Bank",
                                    "Value": "AGM Corporation Bank"
                                },
                                {
                                    "Text": "AGM Finance & Accounts",
                                    "Value": "AGM Finance & Accounts"
                                },
                                {
                                    "Text": "AGM Marketing",
                                    "Value": "AGM Marketing"
                                },
                                {
                                    "Text": "AGM Projects",
                                    "Value": "AGM Projects"
                                },
                                {
                                    "Text": "AGM Regional Operations",
                                    "Value": "AGM Regional Operations"
                                },
                                {
                                    "Text": "Agricultural Assistant",
                                    "Value": "Agricultural Assistant"
                                },
                                {
                                    "Text": "Agriculture Assistant",
                                    "Value": "Agriculture Assistant"
                                },
                                {
                                    "Text": "Agriculturist & Chairman",
                                    "Value": "Agriculturist & Chairman"
                                },
                                {
                                    "Text": "Agriculture Farmer",
                                    "Value": "Agriculture Farmer"
                                },
                                {
                                    "Text": "Agriculture Land Farmer",
                                    "Value": "Agriculture Land Farmer"
                                },
                                {
                                    "Text": "Agriculture Land Owner",
                                    "Value": "Agriculture Land Owner"
                                },
                                {
                                    "Text": "Agriculture Officer",
                                    "Value": "Agriculture Officer"
                                },
                                {
                                    "Text": "Agriculture Research Officer",
                                    "Value": "Agriculture Research Officer"
                                },
                                {
                                    "Text": "Agriculturist & Dairy Farmer",
                                    "Value": "Agriculturist & Dairy Farmer"
                                },
                                {
                                    "Text": "Agriculturist & Farmer",
                                    "Value": "Agriculturist & Farmer"
                                },
                                {
                                    "Text": "Agriculturist & Landlord",
                                    "Value": "Agriculturist & Landlord"
                                },
                                {
                                    "Text": "Agriculturist & Pensioner",
                                    "Value": "Agriculturist & Pensioner"
                                },
                                {
                                    "Text": "Agriculturist Farming",
                                    "Value": "Agriculturist Farming"
                                },
                                {
                                    "Text": "Agriculturl Developmnt Officer",
                                    "Value": "Agriculturl Developmnt Officer"
                                },
                                {
                                    "Text": "Agent National Gen. Insurance",
                                    "Value": "Agent National Gen. Insurance"
                                },
                                {
                                    "Text": "Coconut planter",
                                    "Value": "Coconut planter"
                                },
                                {
                                    "Text": "Agriculture Development Officr",
                                    "Value": "Agriculture Development Officr"
                                },
                                {
                                    "Text": "Agency Manager",
                                    "Value": "Agency Manager"
                                },
                                {
                                    "Text": "AGM",
                                    "Value": "AGM"
                                },
                                {
                                    "Text": "Forest worker",
                                    "Value": "Forest worker"
                                },
                                {
                                    "Text": "Sheep shearer",
                                    "Value": "Sheep shearer"
                                },
                                {
                                    "Text": "Shepherd",
                                    "Value": "Shepherd"
                                },
                                {
                                    "Text": "Stockman",
                                    "Value": "Stockman"
                                },
                                {
                                    "Text": "Lumberjack",
                                    "Value": "Lumberjack"
                                },
                                {
                                    "Text": "Tree feller",
                                    "Value": "Tree feller"
                                },
                                {
                                    "Text": "Crocodile farmer",
                                    "Value": "Crocodile farmer"
                                },
                                {
                                    "Text": "Coconut climber",
                                    "Value": "Coconut climber"
                                },
                                {
                                    "Text": "Agent LIC",
                                    "Value": "Agent LIC"
                                },
                                {
                                    "Text": "AGM Chemicals",
                                    "Value": "AGM Chemicals"
                                },
                                {
                                    "Text": "Agriculture Income",
                                    "Value": "Agriculture Income"
                                },
                                {
                                    "Text": "Farm owner",
                                    "Value": "Farm owner"
                                },
                                {
                                    "Text": "Agricultural worker",
                                    "Value": "Agricultural worker"
                                },
                                {
                                    "Text": "Agriculturist",
                                    "Value": "Agriculturist"
                                },
                                {
                                    "Text": "Plantation owner",
                                    "Value": "Plantation owner"
                                },
                                {
                                    "Text": "Agronomist",
                                    "Value": "Agronomist"
                                },
                                {
                                    "Text": "Beekeeper",
                                    "Value": "Beekeeper"
                                },
                                {
                                    "Text": "Hatchery worker",
                                    "Value": "Hatchery worker"
                                },
                                {
                                    "Text": "Forest ranger",
                                    "Value": "Forest ranger"
                                },
                                {
                                    "Text": "Forester",
                                    "Value": "Forester"
                                },
                                {
                                    "Text": "Poultryman",
                                    "Value": "Poultryman"
                                },
                                {
                                    "Text": "Agriculture engineer",
                                    "Value": "Agriculture engineer"
                                },
                                {
                                    "Text": "Agricultural engineering tech.",
                                    "Value": "Agricultural engineering tech."
                                },
                                {
                                    "Text": "Fish farmer",
                                    "Value": "Fish farmer"
                                },
                                {
                                    "Text": "Palm oil farmer",
                                    "Value": "Palm oil farmer"
                                },
                                {
                                    "Text": "Plantation",
                                    "Value": "Plantation"
                                },
                                {
                                    "Text": "Orchard worker",
                                    "Value": "Orchard worker"
                                },
                                {
                                    "Text": "Inseminator",
                                    "Value": "Inseminator"
                                },
                                {
                                    "Text": "Crofter",
                                    "Value": "Crofter"
                                },
                                {
                                    "Text": "Aquaculture",
                                    "Value": "Aquaculture"
                                },
                                {
                                    "Text": "Sericulturist",
                                    "Value": "Sericulturist"
                                },
                                {
                                    "Text": "AGM Telecom",
                                    "Value": "AGM Telecom"
                                },
                                {
                                    "Text": "AGM Production",
                                    "Value": "AGM Production"
                                },
                                {
                                    "Text": "Agriculture Supervisor",
                                    "Value": "Agriculture Supervisor"
                                },
                                {
                                    "Text": "Agricultre & Floriculture Supv",
                                    "Value": "Agricultre & Floriculture Supv"
                                },
                                {
                                    "Text": "Agriculture Marketing Board",
                                    "Value": "Agriculture Marketing Board"
                                },
                                {
                                    "Text": "Agency Clerk",
                                    "Value": "Agency Clerk"
                                },
                                {
                                    "Text": "Agriculturist & Dairy Business",
                                    "Value": "Agriculturist & Dairy Business"
                                },
                                {
                                    "Text": "Agriculture Scientist",
                                    "Value": "Agriculture Scientist"
                                },
                                {
                                    "Text": "AGM Accounts",
                                    "Value": "AGM Accounts"
                                },
                                {
                                    "Text": "Agent Transporter Authority",
                                    "Value": "Agent Transporter Authority"
                                },
                                {
                                    "Text": "Agriculture Labour",
                                    "Value": "Agriculture Labour"
                                },
                                {
                                    "Text": "Agent Supporting Executive",
                                    "Value": "Agent Supporting Executive"
                                },
                                {
                                    "Text": "Agent Postal",
                                    "Value": "Agent Postal"
                                },
                                {
                                    "Text": "Agricultural Officer",
                                    "Value": "Agricultural Officer"
                                },
                                {
                                    "Text": "Agriculture Consultant",
                                    "Value": "Agriculture Consultant"
                                },
                                {
                                    "Text": "Air Craft Technician",
                                    "Value": "Air Craft Technician"
                                },
                                {
                                    "Text": "Air Force Officer",
                                    "Value": "Air Force Officer"
                                },
                                {
                                    "Text": "Air Conditioner Mechanic",
                                    "Value": "Air Conditioner Mechanic"
                                },
                                {
                                    "Text": "Aircondition Contractor",
                                    "Value": "Aircondition Contractor"
                                },
                                {
                                    "Text": "Wing commander",
                                    "Value": "Wing commander"
                                },
                                {
                                    "Text": "Flying officer",
                                    "Value": "Flying officer"
                                },
                                {
                                    "Text": "Retailer",
                                    "Value": "Retailer"
                                },
                                {
                                    "Text": "Fighter pilot",
                                    "Value": "Fighter pilot"
                                },
                                {
                                    "Text": "Air chief marshal",
                                    "Value": "Air chief marshal"
                                },
                                {
                                    "Text": "Air marshal",
                                    "Value": "Air marshal"
                                },
                                {
                                    "Text": "Air vice-marshal",
                                    "Value": "Air vice-marshal"
                                },
                                {
                                    "Text": "Air commodore",
                                    "Value": "Air commodore"
                                },
                                {
                                    "Text": "Group captain",
                                    "Value": "Group captain"
                                },
                                {
                                    "Text": "Squadron leader",
                                    "Value": "Squadron leader"
                                },
                                {
                                    "Text": "Flight lieutenant",
                                    "Value": "Flight lieutenant"
                                },
                                {
                                    "Text": "Area Manager Direct DSF",
                                    "Value": "Area Manager Direct DSF"
                                },
                                {
                                    "Text": "Area Manager EM",
                                    "Value": "Area Manager EM"
                                },
                                {
                                    "Text": "Area Manager Direct Loyalty",
                                    "Value": "Area Manager Direct Loyalty"
                                },
                                {
                                    "Text": "Amway Distributor",
                                    "Value": "Amway Distributor"
                                },
                                {
                                    "Text": "Asst. Manager Regional",
                                    "Value": "Asst. Manager Regional"
                                },
                                {
                                    "Text": "Area Manager  Telemarketing",
                                    "Value": "Area Manager  Telemarketing"
                                },
                                {
                                    "Text": "Anaesthesiologist Doctor",
                                    "Value": "Anaesthesiologist Doctor"
                                },
                                {
                                    "Text": "Anaesthetic Doctor",
                                    "Value": "Anaesthetic Doctor"
                                },
                                {
                                    "Text": "Analyst Cum Programmer",
                                    "Value": "Analyst Cum Programmer"
                                },
                                {
                                    "Text": "Analyst Manager",
                                    "Value": "Analyst Manager"
                                },
                                {
                                    "Text": "Analytical Consultant",
                                    "Value": "Analytical Consultant"
                                },
                                {
                                    "Text": "Anesthetic Doctor",
                                    "Value": "Anesthetic Doctor"
                                },
                                {
                                    "Text": "Anaesthesian",
                                    "Value": "Anaesthesian"
                                },
                                {
                                    "Text": "Anchor",
                                    "Value": "Anchor"
                                },
                                {
                                    "Text": "Analysis Manager",
                                    "Value": "Analysis Manager"
                                },
                                {
                                    "Text": "Analyst IT",
                                    "Value": "Analyst IT"
                                },
                                {
                                    "Text": "Animation Director",
                                    "Value": "Animation Director"
                                },
                                {
                                    "Text": "Anaesthesiologist",
                                    "Value": "Anaesthesiologist"
                                },
                                {
                                    "Text": "Analyst Programmer",
                                    "Value": "Analyst Programmer"
                                },
                                {
                                    "Text": "Application Developer",
                                    "Value": "Application Developer"
                                },
                                {
                                    "Text": "Application Engineer",
                                    "Value": "Application Engineer"
                                },
                                {
                                    "Text": "Application Programmer",
                                    "Value": "Application Programmer"
                                },
                                {
                                    "Text": "Application Specialist",
                                    "Value": "Application Specialist"
                                },
                                {
                                    "Text": "Application Support Specialist",
                                    "Value": "Application Support Specialist"
                                },
                                {
                                    "Text": "Approved Guide",
                                    "Value": "Approved Guide"
                                },
                                {
                                    "Text": "Application Designer",
                                    "Value": "Application Designer"
                                },
                                {
                                    "Text": "AVP Human Resources",
                                    "Value": "AVP Human Resources"
                                },
                                {
                                    "Text": "Application Consultant",
                                    "Value": "Application Consultant"
                                },
                                {
                                    "Text": "Apple Orchadist",
                                    "Value": "Apple Orchadist"
                                },
                                {
                                    "Text": "Asst Quality Controller",
                                    "Value": "Asst Quality Controller"
                                },
                                {
                                    "Text": "Aqua Traders",
                                    "Value": "Aqua Traders"
                                },
                                {
                                    "Text": "Drummer",
                                    "Value": "Drummer"
                                },
                                {
                                    "Text": "Engraver",
                                    "Value": "Engraver"
                                },
                                {
                                    "Text": "Architectural Consultant",
                                    "Value": "Architectural Consultant"
                                },
                                {
                                    "Text": "Poet",
                                    "Value": "Poet"
                                },
                                {
                                    "Text": "Area Business Manager",
                                    "Value": "Area Business Manager"
                                },
                                {
                                    "Text": "Calligrapher",
                                    "Value": "Calligrapher"
                                },
                                {
                                    "Text": "Lithographic plate grainer",
                                    "Value": "Lithographic plate grainer"
                                },
                                {
                                    "Text": "Vocalist",
                                    "Value": "Vocalist"
                                },
                                {
                                    "Text": "Area Field Manager",
                                    "Value": "Area Field Manager"
                                },
                                {
                                    "Text": "Area General Manager",
                                    "Value": "Area General Manager"
                                },
                                {
                                    "Text": "Area Mgr Industrial/Commercial",
                                    "Value": "Area Mgr Industrial/Commercial"
                                },
                                {
                                    "Text": "Area Head",
                                    "Value": "Area Head"
                                },
                                {
                                    "Text": "Architect & Technician",
                                    "Value": "Architect & Technician"
                                },
                                {
                                    "Text": "Area Manager Corporate",
                                    "Value": "Area Manager Corporate"
                                },
                                {
                                    "Text": "Area Marketing Representative",
                                    "Value": "Area Marketing Representative"
                                },
                                {
                                    "Text": "Area Medical Officer",
                                    "Value": "Area Medical Officer"
                                },
                                {
                                    "Text": "Area Project Officer",
                                    "Value": "Area Project Officer"
                                },
                                {
                                    "Text": "Area Service Manager",
                                    "Value": "Area Service Manager"
                                },
                                {
                                    "Text": "Army Clerk",
                                    "Value": "Army Clerk"
                                },
                                {
                                    "Text": "Army Officer",
                                    "Value": "Army Officer"
                                },
                                {
                                    "Text": "Art Director & Proprietor",
                                    "Value": "Art Director & Proprietor"
                                },
                                {
                                    "Text": "Art Teacher",
                                    "Value": "Art Teacher"
                                },
                                {
                                    "Text": "Artist Painting",
                                    "Value": "Artist Painting"
                                },
                                {
                                    "Text": "Archaeologist",
                                    "Value": "Archaeologist"
                                },
                                {
                                    "Text": "Area Field Risk Manager",
                                    "Value": "Area Field Risk Manager"
                                },
                                {
                                    "Text": "Area Incharge",
                                    "Value": "Area Incharge"
                                },
                                {
                                    "Text": "Arch Interior Desgnr Consult",
                                    "Value": "Arch Interior Desgnr Consult"
                                },
                                {
                                    "Text": "Major general",
                                    "Value": "Major general"
                                },
                                {
                                    "Text": "Sepoy",
                                    "Value": "Sepoy"
                                },
                                {
                                    "Text": "Army doctor",
                                    "Value": "Army doctor"
                                },
                                {
                                    "Text": "Naik",
                                    "Value": "Naik"
                                },
                                {
                                    "Text": "Subedar major",
                                    "Value": "Subedar major"
                                },
                                {
                                    "Text": "Lieutenant colonel",
                                    "Value": "Lieutenant colonel"
                                },
                                {
                                    "Text": "Colonel",
                                    "Value": "Colonel"
                                },
                                {
                                    "Text": "Brigadier",
                                    "Value": "Brigadier"
                                },
                                {
                                    "Text": "Naik subedar",
                                    "Value": "Naik subedar"
                                },
                                {
                                    "Text": "Subedar",
                                    "Value": "Subedar"
                                },
                                {
                                    "Text": "Second lieutenant",
                                    "Value": "Second lieutenant"
                                },
                                {
                                    "Text": "Jawan",
                                    "Value": "Jawan"
                                },
                                {
                                    "Text": "Flight crew",
                                    "Value": "Flight crew"
                                },
                                {
                                    "Text": "Trainee crew",
                                    "Value": "Trainee crew"
                                },
                                {
                                    "Text": "Lieutenant general",
                                    "Value": "Lieutenant general"
                                },
                                {
                                    "Text": "Architect Consultant",
                                    "Value": "Architect Consultant"
                                },
                                {
                                    "Text": "Area Officer",
                                    "Value": "Area Officer"
                                },
                                {
                                    "Text": "Army Retired Person",
                                    "Value": "Army Retired Person"
                                },
                                {
                                    "Text": "Army Sepoy",
                                    "Value": "Army Sepoy"
                                },
                                {
                                    "Text": "Armed Guard",
                                    "Value": "Armed Guard"
                                },
                                {
                                    "Text": "Architect Software",
                                    "Value": "Architect Software"
                                },
                                {
                                    "Text": "ARM",
                                    "Value": "ARM"
                                },
                                {
                                    "Text": "Artist Fine Art",
                                    "Value": "Artist Fine Art"
                                },
                                {
                                    "Text": "Artist Jewellery",
                                    "Value": "Artist Jewellery"
                                },
                                {
                                    "Text": "Typographer",
                                    "Value": "Typographer"
                                },
                                {
                                    "Text": "Dress designer",
                                    "Value": "Dress designer"
                                },
                                {
                                    "Text": "Illustrator",
                                    "Value": "Illustrator"
                                },
                                {
                                    "Text": "Book binder",
                                    "Value": "Book binder"
                                },
                                {
                                    "Text": "Candle maker",
                                    "Value": "Candle maker"
                                },
                                {
                                    "Text": "Ceramicist",
                                    "Value": "Ceramicist"
                                },
                                {
                                    "Text": "Chain maker",
                                    "Value": "Chain maker"
                                },
                                {
                                    "Text": "Band master",
                                    "Value": "Band master"
                                },
                                {
                                    "Text": "Cartoonist",
                                    "Value": "Cartoonist"
                                },
                                {
                                    "Text": "Commercial artist",
                                    "Value": "Commercial artist"
                                },
                                {
                                    "Text": "Lithographer",
                                    "Value": "Lithographer"
                                },
                                {
                                    "Text": "Lithographic assistant",
                                    "Value": "Lithographic assistant"
                                },
                                {
                                    "Text": "Art gallery curator",
                                    "Value": "Art gallery curator"
                                },
                                {
                                    "Text": "Art gallery manager",
                                    "Value": "Art gallery manager"
                                },
                                {
                                    "Text": "Art gallery guide",
                                    "Value": "Art gallery guide"
                                },
                                {
                                    "Text": "Music director",
                                    "Value": "Music director"
                                },
                                {
                                    "Text": "Wood carver",
                                    "Value": "Wood carver"
                                },
                                {
                                    "Text": "Silver smith",
                                    "Value": "Silver smith"
                                },
                                {
                                    "Text": "Lyricist",
                                    "Value": "Lyricist"
                                },
                                {
                                    "Text": "Recording artist",
                                    "Value": "Recording artist"
                                },
                                {
                                    "Text": "Costume designer",
                                    "Value": "Costume designer"
                                },
                                {
                                    "Text": "Design consultant",
                                    "Value": "Design consultant"
                                },
                                {
                                    "Text": "Fashion designer",
                                    "Value": "Fashion designer"
                                },
                                {
                                    "Text": "Furniture designer",
                                    "Value": "Furniture designer"
                                },
                                {
                                    "Text": "Glass designer",
                                    "Value": "Glass designer"
                                },
                                {
                                    "Text": "Landscape designer",
                                    "Value": "Landscape designer"
                                },
                                {
                                    "Text": "Area Business Executive",
                                    "Value": "Area Business Executive"
                                },
                                {
                                    "Text": "Archery Designer",
                                    "Value": "Archery Designer"
                                },
                                {
                                    "Text": "Architect & Partner",
                                    "Value": "Architect & Partner"
                                },
                                {
                                    "Text": "Architectural Draughtsman",
                                    "Value": "Architectural Draughtsman"
                                },
                                {
                                    "Text": "Area Collection Manager",
                                    "Value": "Area Collection Manager"
                                },
                                {
                                    "Text": "Area Development Manager",
                                    "Value": "Area Development Manager"
                                },
                                {
                                    "Text": "Area Executive",
                                    "Value": "Area Executive"
                                },
                                {
                                    "Text": "Area Growth Manager",
                                    "Value": "Area Growth Manager"
                                },
                                {
                                    "Text": "Area Insurance Head",
                                    "Value": "Area Insurance Head"
                                },
                                {
                                    "Text": "Assistant Officer P&A",
                                    "Value": "Assistant Officer P&A"
                                },
                                {
                                    "Text": "Assessor",
                                    "Value": "Assessor"
                                },
                                {
                                    "Text": "Assistant & Typist",
                                    "Value": "Assistant & Typist"
                                },
                                {
                                    "Text": "Assistant Advertising Manager",
                                    "Value": "Assistant Advertising Manager"
                                },
                                {
                                    "Text": "Assistant Agricultural Officer",
                                    "Value": "Assistant Agricultural Officer"
                                },
                                {
                                    "Text": "Assistant Archeologist",
                                    "Value": "Assistant Archeologist"
                                },
                                {
                                    "Text": "Assistant Area Manager",
                                    "Value": "Assistant Area Manager"
                                },
                                {
                                    "Text": "Assistant Art Director",
                                    "Value": "Assistant Art Director"
                                },
                                {
                                    "Text": "Assistant Inspector General",
                                    "Value": "Assistant Inspector General"
                                },
                                {
                                    "Text": "Assistant Draftsman",
                                    "Value": "Assistant Draftsman"
                                },
                                {
                                    "Text": "Associate Consultant SAP",
                                    "Value": "Associate Consultant SAP"
                                },
                                {
                                    "Text": "Assistant Chemical Analyst",
                                    "Value": "Assistant Chemical Analyst"
                                },
                                {
                                    "Text": "Assistant Registrar",
                                    "Value": "Assistant Registrar"
                                },
                                {
                                    "Text": "Assistant Circulation Manager",
                                    "Value": "Assistant Circulation Manager"
                                },
                                {
                                    "Text": "Assistant Civil Engineer",
                                    "Value": "Assistant Civil Engineer"
                                },
                                {
                                    "Text": "Assistant Civil Manager",
                                    "Value": "Assistant Civil Manager"
                                },
                                {
                                    "Text": "Assistant Civil Surgeon",
                                    "Value": "Assistant Civil Surgeon"
                                },
                                {
                                    "Text": "Assistant Consultant",
                                    "Value": "Assistant Consultant"
                                },
                                {
                                    "Text": "Assistant Controller",
                                    "Value": "Assistant Controller"
                                },
                                {
                                    "Text": "Assistant Coordinator",
                                    "Value": "Assistant Coordinator"
                                },
                                {
                                    "Text": "Assistant Deputy Controller",
                                    "Value": "Assistant Deputy Controller"
                                },
                                {
                                    "Text": "Assistant Design Engineer",
                                    "Value": "Assistant Design Engineer"
                                },
                                {
                                    "Text": "Assistant Designer",
                                    "Value": "Assistant Designer"
                                },
                                {
                                    "Text": "Assistant Development Engineer",
                                    "Value": "Assistant Development Engineer"
                                },
                                {
                                    "Text": "Assistant Director Agriculture",
                                    "Value": "Assistant Director Agriculture"
                                },
                                {
                                    "Text": "Assistant Distributor",
                                    "Value": "Assistant Distributor"
                                },
                                {
                                    "Text": "Assistant Divisional Engineer",
                                    "Value": "Assistant Divisional Engineer"
                                },
                                {
                                    "Text": "Assistant Dyeing Manager",
                                    "Value": "Assistant Dyeing Manager"
                                },
                                {
                                    "Text": "Assistant Economic Advisor",
                                    "Value": "Assistant Economic Advisor"
                                },
                                {
                                    "Text": "Assistant Electrical Inspector",
                                    "Value": "Assistant Electrical Inspector"
                                },
                                {
                                    "Text": "Assistant Electrician",
                                    "Value": "Assistant Electrician"
                                },
                                {
                                    "Text": "Assistant Engg Govt Services",
                                    "Value": "Assistant Engg Govt Services"
                                },
                                {
                                    "Text": "Assistant Engg Tool Planning",
                                    "Value": "Assistant Engg Tool Planning"
                                },
                                {
                                    "Text": "Assistant Engineer",
                                    "Value": "Assistant Engineer"
                                },
                                {
                                    "Text": "Asbestos stripper",
                                    "Value": "Asbestos stripper"
                                },
                                {
                                    "Text": "Assistant Engineer Production",
                                    "Value": "Assistant Engineer Production"
                                },
                                {
                                    "Text": "Assistant Executive Engineer",
                                    "Value": "Assistant Executive Engineer"
                                },
                                {
                                    "Text": "Assistant General Manager",
                                    "Value": "Assistant General Manager"
                                },
                                {
                                    "Text": "Assistant GM",
                                    "Value": "Assistant GM"
                                },
                                {
                                    "Text": "Assistant Grade Officer",
                                    "Value": "Assistant Grade Officer"
                                },
                                {
                                    "Text": "Assistant HR Manager",
                                    "Value": "Assistant HR Manager"
                                },
                                {
                                    "Text": "Assistant HRD Officer",
                                    "Value": "Assistant HRD Officer"
                                },
                                {
                                    "Text": "Assistant IT Engineer",
                                    "Value": "Assistant IT Engineer"
                                },
                                {
                                    "Text": "Assistant Junior Engineer",
                                    "Value": "Assistant Junior Engineer"
                                },
                                {
                                    "Text": "Assistant General Mgr Finance",
                                    "Value": "Assistant General Mgr Finance"
                                },
                                {
                                    "Text": "Assistant Lab Technician",
                                    "Value": "Assistant Lab Technician"
                                },
                                {
                                    "Text": "Assistant Labour Officer",
                                    "Value": "Assistant Labour Officer"
                                },
                                {
                                    "Text": "Assistant Law Manager",
                                    "Value": "Assistant Law Manager"
                                },
                                {
                                    "Text": "Assistant Lecturer",
                                    "Value": "Assistant Lecturer"
                                },
                                {
                                    "Text": "Assistant Librarian",
                                    "Value": "Assistant Librarian"
                                },
                                {
                                    "Text": "Assistant Loco Pilot",
                                    "Value": "Assistant Loco Pilot"
                                },
                                {
                                    "Text": "Assistant Management Accountnt",
                                    "Value": "Assistant Management Accountnt"
                                },
                                {
                                    "Text": "Assistant Manager Commercial",
                                    "Value": "Assistant Manager Commercial"
                                },
                                {
                                    "Text": "Assistant Manager Contracts",
                                    "Value": "Assistant Manager Contracts"
                                },
                                {
                                    "Text": "Assistant Administratve Officr",
                                    "Value": "Assistant Administratve Officr"
                                },
                                {
                                    "Text": "Asst. Mgr Material Logistics",
                                    "Value": "Asst. Mgr Material Logistics"
                                },
                                {
                                    "Text": "Assistant Architect",
                                    "Value": "Assistant Architect"
                                },
                                {
                                    "Text": "Assistant Manager Legal",
                                    "Value": "Assistant Manager Legal"
                                },
                                {
                                    "Text": "Assistant Manager Maintenance",
                                    "Value": "Assistant Manager Maintenance"
                                },
                                {
                                    "Text": "Assistant Manager Marketing",
                                    "Value": "Assistant Manager Marketing"
                                },
                                {
                                    "Text": "Assistant Manager Material",
                                    "Value": "Assistant Manager Material"
                                },
                                {
                                    "Text": "Assistant Manager Opern Sales",
                                    "Value": "Assistant Manager Opern Sales"
                                },
                                {
                                    "Text": "Assistant Manager Packing",
                                    "Value": "Assistant Manager Packing"
                                },
                                {
                                    "Text": "Assistant Manager Production",
                                    "Value": "Assistant Manager Production"
                                },
                                {
                                    "Text": "Assistant Manager Project",
                                    "Value": "Assistant Manager Project"
                                },
                                {
                                    "Text": "Assistant Manager Secretarial",
                                    "Value": "Assistant Manager Secretarial"
                                },
                                {
                                    "Text": "Assistant Manager Services",
                                    "Value": "Assistant Manager Services"
                                },
                                {
                                    "Text": "Assistant Manager Taxes",
                                    "Value": "Assistant Manager Taxes"
                                },
                                {
                                    "Text": "Assistant Manager Trading",
                                    "Value": "Assistant Manager Trading"
                                },
                                {
                                    "Text": "Assistant Manufacturing Mgr",
                                    "Value": "Assistant Manufacturing Mgr"
                                },
                                {
                                    "Text": "Assistant Market Intelligence",
                                    "Value": "Assistant Market Intelligence"
                                },
                                {
                                    "Text": "Assistant Marketing Manager",
                                    "Value": "Assistant Marketing Manager"
                                },
                                {
                                    "Text": "Assistant Medical Officer",
                                    "Value": "Assistant Medical Officer"
                                },
                                {
                                    "Text": "Assistant Merchant Manager",
                                    "Value": "Assistant Merchant Manager"
                                },
                                {
                                    "Text": "Assistant Meterologist",
                                    "Value": "Assistant Meterologist"
                                },
                                {
                                    "Text": "Assistant Mgr Accounts & Admin",
                                    "Value": "Assistant Mgr Accounts & Admin"
                                },
                                {
                                    "Text": "Assistant Mgr Buss Development",
                                    "Value": "Assistant Mgr Buss Development"
                                },
                                {
                                    "Text": "Assistant Mgr Expense Reportng",
                                    "Value": "Assistant Mgr Expense Reportng"
                                },
                                {
                                    "Text": "Assistant Mgr Garments Export",
                                    "Value": "Assistant Mgr Garments Export"
                                },
                                {
                                    "Text": "Assistant Mgr Internal Audit",
                                    "Value": "Assistant Mgr Internal Audit"
                                },
                                {
                                    "Text": "Assistant Mgr Retail Services",
                                    "Value": "Assistant Mgr Retail Services"
                                },
                                {
                                    "Text": "Assistant Mgr Sales Accounting",
                                    "Value": "Assistant Mgr Sales Accounting"
                                },
                                {
                                    "Text": "Assistant Mgr Telemarketing",
                                    "Value": "Assistant Mgr Telemarketing"
                                },
                                {
                                    "Text": "Assistant Mistress",
                                    "Value": "Assistant Mistress"
                                },
                                {
                                    "Text": "Assistant Manager Retired",
                                    "Value": "Assistant Manager Retired"
                                },
                                {
                                    "Text": "Assistant System Engg. Trainee",
                                    "Value": "Assistant System Engg. Trainee"
                                },
                                {
                                    "Text": "Assistant Officer Accounts",
                                    "Value": "Assistant Officer Accounts"
                                },
                                {
                                    "Text": "Assistant Officer Finance",
                                    "Value": "Assistant Officer Finance"
                                },
                                {
                                    "Text": "Assistant Paramedical Officer",
                                    "Value": "Assistant Paramedical Officer"
                                },
                                {
                                    "Text": "Assistant Personnel Department",
                                    "Value": "Assistant Personnel Department"
                                },
                                {
                                    "Text": "Assistant Personnel Manager",
                                    "Value": "Assistant Personnel Manager"
                                },
                                {
                                    "Text": "Assistant Production Manager",
                                    "Value": "Assistant Production Manager"
                                },
                                {
                                    "Text": "Assistant Professor & Lecturer",
                                    "Value": "Assistant Professor & Lecturer"
                                },
                                {
                                    "Text": "Assistant Professor In Geology",
                                    "Value": "Assistant Professor In Geology"
                                },
                                {
                                    "Text": "Asst. RTO Officer",
                                    "Value": "Asst. RTO Officer"
                                },
                                {
                                    "Text": "Assistant Project Officer",
                                    "Value": "Assistant Project Officer"
                                },
                                {
                                    "Text": "Assistant Prosecuting Officer",
                                    "Value": "Assistant Prosecuting Officer"
                                },
                                {
                                    "Text": "Assistant Public Prosecutor",
                                    "Value": "Assistant Public Prosecutor"
                                },
                                {
                                    "Text": "Assistant Purchaser",
                                    "Value": "Assistant Purchaser"
                                },
                                {
                                    "Text": "Assistant District Attorney",
                                    "Value": "Assistant District Attorney"
                                },
                                {
                                    "Text": "Assistant Quality Control Mgr",
                                    "Value": "Assistant Quality Control Mgr"
                                },
                                {
                                    "Text": "Assistant Range Officer",
                                    "Value": "Assistant Range Officer"
                                },
                                {
                                    "Text": "Assistant Regional Accountant",
                                    "Value": "Assistant Regional Accountant"
                                },
                                {
                                    "Text": "Assistant Regional Planner",
                                    "Value": "Assistant Regional Planner"
                                },
                                {
                                    "Text": "Assistant Registar Cum Auditor",
                                    "Value": "Assistant Registar Cum Auditor"
                                },
                                {
                                    "Text": "Assistant Registrar Finance",
                                    "Value": "Assistant Registrar Finance"
                                },
                                {
                                    "Text": "Assistant Relationship Manager",
                                    "Value": "Assistant Relationship Manager"
                                },
                                {
                                    "Text": "Assistant Restaurant Manager",
                                    "Value": "Assistant Restaurant Manager"
                                },
                                {
                                    "Text": "Assistant Revenue Accountant",
                                    "Value": "Assistant Revenue Accountant"
                                },
                                {
                                    "Text": "Assistant Revenue Department",
                                    "Value": "Assistant Revenue Department"
                                },
                                {
                                    "Text": "Assistant Revenue Officer",
                                    "Value": "Assistant Revenue Officer"
                                },
                                {
                                    "Text": "Assistant Sales Officer",
                                    "Value": "Assistant Sales Officer"
                                },
                                {
                                    "Text": "Assistant Secretary",
                                    "Value": "Assistant Secretary"
                                },
                                {
                                    "Text": "Assistant Section Officer",
                                    "Value": "Assistant Section Officer"
                                },
                                {
                                    "Text": "Assistant Service Engineer",
                                    "Value": "Assistant Service Engineer"
                                },
                                {
                                    "Text": "Assistant Service Manager",
                                    "Value": "Assistant Service Manager"
                                },
                                {
                                    "Text": "Assistant Social Officer",
                                    "Value": "Assistant Social Officer"
                                },
                                {
                                    "Text": "Assistant Statistical Officer",
                                    "Value": "Assistant Statistical Officer"
                                },
                                {
                                    "Text": "Assistant Storekeeper",
                                    "Value": "Assistant Storekeeper"
                                },
                                {
                                    "Text": "Assistant Sub Engineer",
                                    "Value": "Assistant Sub Engineer"
                                },
                                {
                                    "Text": "Assistant Sub Inspector",
                                    "Value": "Assistant Sub Inspector"
                                },
                                {
                                    "Text": "Assistant Surgeon",
                                    "Value": "Assistant Surgeon"
                                },
                                {
                                    "Text": "Assistant System Administrator",
                                    "Value": "Assistant System Administrator"
                                },
                                {
                                    "Text": "Assistant System Analyst",
                                    "Value": "Assistant System Analyst"
                                },
                                {
                                    "Text": "Assistant Superintendent Engg",
                                    "Value": "Assistant Superintendent Engg"
                                },
                                {
                                    "Text": "Assistant System Manager",
                                    "Value": "Assistant System Manager"
                                },
                                {
                                    "Text": "Assistant Systems Engineer",
                                    "Value": "Assistant Systems Engineer"
                                },
                                {
                                    "Text": "Assistant Teacher & Owner",
                                    "Value": "Assistant Teacher & Owner"
                                },
                                {
                                    "Text": "Assistant Team Leader",
                                    "Value": "Assistant Team Leader"
                                },
                                {
                                    "Text": "Asst general manager",
                                    "Value": "Asst general manager"
                                },
                                {
                                    "Text": "Assistant Technical Engineer",
                                    "Value": "Assistant Technical Engineer"
                                },
                                {
                                    "Text": "Assistant Technician",
                                    "Value": "Assistant Technician"
                                },
                                {
                                    "Text": "Assistant Territory Manager",
                                    "Value": "Assistant Territory Manager"
                                },
                                {
                                    "Text": "Associate Manager",
                                    "Value": "Associate Manager"
                                },
                                {
                                    "Text": "Assistant Town Planner",
                                    "Value": "Assistant Town Planner"
                                },
                                {
                                    "Text": "Assistant Trader",
                                    "Value": "Assistant Trader"
                                },
                                {
                                    "Text": "Assistant Transportation Engg",
                                    "Value": "Assistant Transportation Engg"
                                },
                                {
                                    "Text": "Assistant Treasurer",
                                    "Value": "Assistant Treasurer"
                                },
                                {
                                    "Text": "Assistant Vice-President",
                                    "Value": "Assistant Vice-President"
                                },
                                {
                                    "Text": "Asst Professor Of Pathology",
                                    "Value": "Asst Professor Of Pathology"
                                },
                                {
                                    "Text": "Assistant Zoologist",
                                    "Value": "Assistant Zoologist"
                                },
                                {
                                    "Text": "Assistat Software Engineer",
                                    "Value": "Assistat Software Engineer"
                                },
                                {
                                    "Text": "Assistnt Engg Engineering Serv",
                                    "Value": "Assistnt Engg Engineering Serv"
                                },
                                {
                                    "Text": "Assitant Sales Inspector",
                                    "Value": "Assitant Sales Inspector"
                                },
                                {
                                    "Text": "Ash Engineer",
                                    "Value": "Ash Engineer"
                                },
                                {
                                    "Text": "Associate Advocate",
                                    "Value": "Associate Advocate"
                                },
                                {
                                    "Text": "Associate Analyst",
                                    "Value": "Associate Analyst"
                                },
                                {
                                    "Text": "Associate Architect",
                                    "Value": "Associate Architect"
                                },
                                {
                                    "Text": "Associate Business Analyst",
                                    "Value": "Associate Business Analyst"
                                },
                                {
                                    "Text": "Associate Business Consultant",
                                    "Value": "Associate Business Consultant"
                                },
                                {
                                    "Text": "Associate Business Develop Mgr",
                                    "Value": "Associate Business Develop Mgr"
                                },
                                {
                                    "Text": "Associate Creative Director",
                                    "Value": "Associate Creative Director"
                                },
                                {
                                    "Text": "Associate Database Administrtr",
                                    "Value": "Associate Database Administrtr"
                                },
                                {
                                    "Text": "Associate Director",
                                    "Value": "Associate Director"
                                },
                                {
                                    "Text": "Associate Director Commercial",
                                    "Value": "Associate Director Commercial"
                                },
                                {
                                    "Text": "Associate Director Scientist",
                                    "Value": "Associate Director Scientist"
                                },
                                {
                                    "Text": "Assistant HR",
                                    "Value": "Assistant HR"
                                },
                                {
                                    "Text": "Associate Engineer",
                                    "Value": "Associate Engineer"
                                },
                                {
                                    "Text": "Associate Executive Producer",
                                    "Value": "Associate Executive Producer"
                                },
                                {
                                    "Text": "Associate General Manager",
                                    "Value": "Associate General Manager"
                                },
                                {
                                    "Text": "Associate HR",
                                    "Value": "Associate HR"
                                },
                                {
                                    "Text": "Associate Mechanical Designer",
                                    "Value": "Associate Mechanical Designer"
                                },
                                {
                                    "Text": "Associate Member Technical",
                                    "Value": "Associate Member Technical"
                                },
                                {
                                    "Text": "Associate Office Executive",
                                    "Value": "Associate Office Executive"
                                },
                                {
                                    "Text": "Associate Officer",
                                    "Value": "Associate Officer"
                                },
                                {
                                    "Text": "Assistant Manager Media",
                                    "Value": "Assistant Manager Media"
                                },
                                {
                                    "Text": "Associate Productions",
                                    "Value": "Associate Productions"
                                },
                                {
                                    "Text": "Associate Professor Medical",
                                    "Value": "Associate Professor Medical"
                                },
                                {
                                    "Text": "Associate Professor Of Surgery",
                                    "Value": "Associate Professor Of Surgery"
                                },
                                {
                                    "Text": "Associate Project Leader",
                                    "Value": "Associate Project Leader"
                                },
                                {
                                    "Text": "Associate Project Manager",
                                    "Value": "Associate Project Manager"
                                },
                                {
                                    "Text": "Associate QA Engineer",
                                    "Value": "Associate QA Engineer"
                                },
                                {
                                    "Text": "Associate Quality Analyst",
                                    "Value": "Associate Quality Analyst"
                                },
                                {
                                    "Text": "Assistant Engineer Grade II",
                                    "Value": "Assistant Engineer Grade II"
                                },
                                {
                                    "Text": "Associate Sales Mgr Liability",
                                    "Value": "Associate Sales Mgr Liability"
                                },
                                {
                                    "Text": "Assistant Manager HR & Admin",
                                    "Value": "Assistant Manager HR & Admin"
                                },
                                {
                                    "Text": "Associate Secretary",
                                    "Value": "Associate Secretary"
                                },
                                {
                                    "Text": "Associate Software Engineer",
                                    "Value": "Associate Software Engineer"
                                },
                                {
                                    "Text": "Associate System Engineer",
                                    "Value": "Associate System Engineer"
                                },
                                {
                                    "Text": "Associate Tax Consultant",
                                    "Value": "Associate Tax Consultant"
                                },
                                {
                                    "Text": "Assistant Manager MIS",
                                    "Value": "Assistant Manager MIS"
                                },
                                {
                                    "Text": "Assistant Manager IT",
                                    "Value": "Assistant Manager IT"
                                },
                                {
                                    "Text": "Associate Team Member",
                                    "Value": "Associate Team Member"
                                },
                                {
                                    "Text": "Associate Technical",
                                    "Value": "Associate Technical"
                                },
                                {
                                    "Text": "Associate Technical Manager",
                                    "Value": "Associate Technical Manager"
                                },
                                {
                                    "Text": "Associate Technical Writer",
                                    "Value": "Associate Technical Writer"
                                },
                                {
                                    "Text": "Associate Underwriter",
                                    "Value": "Associate Underwriter"
                                },
                                {
                                    "Text": "Associate Vice President Accts",
                                    "Value": "Associate Vice President Accts"
                                },
                                {
                                    "Text": "Associate VP Operations",
                                    "Value": "Associate VP Operations"
                                },
                                {
                                    "Text": "Associated Business Analyst",
                                    "Value": "Associated Business Analyst"
                                },
                                {
                                    "Text": "Asst Central Intellignce Offcr",
                                    "Value": "Asst Central Intellignce Offcr"
                                },
                                {
                                    "Text": "Asst Cntrl Intelligence Offcr",
                                    "Value": "Asst Cntrl Intelligence Offcr"
                                },
                                {
                                    "Text": "Asst Commissioner Comm. Taxes",
                                    "Value": "Asst Commissioner Comm. Taxes"
                                },
                                {
                                    "Text": "Asst Insurance Medical Officer",
                                    "Value": "Asst Insurance Medical Officer"
                                },
                                {
                                    "Text": "Asst Manager Administration",
                                    "Value": "Asst Manager Administration"
                                },
                                {
                                    "Text": "Asst Manager Customer Support",
                                    "Value": "Asst Manager Customer Support"
                                },
                                {
                                    "Text": "Asst Mgr & Cust Serv Associate",
                                    "Value": "Asst Mgr & Cust Serv Associate"
                                },
                                {
                                    "Text": "Asst Professor Dept. Surgeon",
                                    "Value": "Asst Professor Dept. Surgeon"
                                },
                                {
                                    "Text": "Asst Proff. & Urology Doctor",
                                    "Value": "Asst Proff. & Urology Doctor"
                                },
                                {
                                    "Text": "Asst Seed Certification Officr",
                                    "Value": "Asst Seed Certification Officr"
                                },
                                {
                                    "Text": "Asst Seed Production Officer",
                                    "Value": "Asst Seed Production Officer"
                                },
                                {
                                    "Text": "Asst Statistical Investigator",
                                    "Value": "Asst Statistical Investigator"
                                },
                                {
                                    "Text": "Asst. Administration Officer",
                                    "Value": "Asst. Administration Officer"
                                },
                                {
                                    "Text": "Asst. Commercial Tax Officer",
                                    "Value": "Asst. Commercial Tax Officer"
                                },
                                {
                                    "Text": "Asst. Professor Horticulture",
                                    "Value": "Asst. Professor Horticulture"
                                },
                                {
                                    "Text": "Assurance Executive",
                                    "Value": "Assurance Executive"
                                },
                                {
                                    "Text": "Astrologer & Vaastu Consultant",
                                    "Value": "Astrologer & Vaastu Consultant"
                                },
                                {
                                    "Text": "Astrologist",
                                    "Value": "Astrologist"
                                },
                                {
                                    "Text": "Assistant Sales Manager",
                                    "Value": "Assistant Sales Manager"
                                },
                                {
                                    "Text": "Assistant Sales Manager BSC",
                                    "Value": "Assistant Sales Manager BSC"
                                },
                                {
                                    "Text": "Assistant Sales Manager (EM)",
                                    "Value": "Assistant Sales Manager (EM)"
                                },
                                {
                                    "Text": "Assistant Sales Manager DSF",
                                    "Value": "Assistant Sales Manager DSF"
                                },
                                {
                                    "Text": "Assitant Salesman",
                                    "Value": "Assitant Salesman"
                                },
                                {
                                    "Text": "Assistant Manager Claims",
                                    "Value": "Assistant Manager Claims"
                                },
                                {
                                    "Text": "Assistant Manager Billing",
                                    "Value": "Assistant Manager Billing"
                                },
                                {
                                    "Text": "Assistant Manager Operations",
                                    "Value": "Assistant Manager Operations"
                                },
                                {
                                    "Text": "Associate consultant",
                                    "Value": "Associate consultant"
                                },
                                {
                                    "Text": "Assistant Professor & HOD",
                                    "Value": "Assistant Professor & HOD"
                                },
                                {
                                    "Text": "Assistant Mgr Quality Control",
                                    "Value": "Assistant Mgr Quality Control"
                                },
                                {
                                    "Text": "Asset Management Operation",
                                    "Value": "Asset Management Operation"
                                },
                                {
                                    "Text": "Associate Member Buss Develop",
                                    "Value": "Associate Member Buss Develop"
                                },
                                {
                                    "Text": "Assistant Professor",
                                    "Value": "Assistant Professor"
                                },
                                {
                                    "Text": "Assistant Electric Loco Pilot",
                                    "Value": "Assistant Electric Loco Pilot"
                                },
                                {
                                    "Text": "Assistant Officer PA",
                                    "Value": "Assistant Officer PA"
                                },
                                {
                                    "Text": "Assistant Manager QC",
                                    "Value": "Assistant Manager QC"
                                },
                                {
                                    "Text": "Assistant Steward",
                                    "Value": "Assistant Steward"
                                },
                                {
                                    "Text": "Associate Customer Care",
                                    "Value": "Associate Customer Care"
                                },
                                {
                                    "Text": "Astt. Regional Manager",
                                    "Value": "Astt. Regional Manager"
                                },
                                {
                                    "Text": "Associate Circle Head",
                                    "Value": "Associate Circle Head"
                                },
                                {
                                    "Text": "Asst. Basic Shiksha Adhikari",
                                    "Value": "Asst. Basic Shiksha Adhikari"
                                },
                                {
                                    "Text": "Assistant Commercial Clerk",
                                    "Value": "Assistant Commercial Clerk"
                                },
                                {
                                    "Text": "Assistant RM",
                                    "Value": "Assistant RM"
                                },
                                {
                                    "Text": "Assistant Manager Export",
                                    "Value": "Assistant Manager Export"
                                },
                                {
                                    "Text": "Associate VP/Mgr Customer Serv",
                                    "Value": "Associate VP/Mgr Customer Serv"
                                },
                                {
                                    "Text": "Assistant Company Secretary",
                                    "Value": "Assistant Company Secretary"
                                },
                                {
                                    "Text": "Assistant Managr Credit & Risk",
                                    "Value": "Assistant Managr Credit & Risk"
                                },
                                {
                                    "Text": "Assembler",
                                    "Value": "Assembler"
                                },
                                {
                                    "Text": "Assistant Procurement",
                                    "Value": "Assistant Procurement"
                                },
                                {
                                    "Text": "Assistant Head Mistress",
                                    "Value": "Assistant Head Mistress"
                                },
                                {
                                    "Text": "Assistant",
                                    "Value": "Assistant"
                                },
                                {
                                    "Text": "Palmist",
                                    "Value": "Palmist"
                                },
                                {
                                    "Text": "Numerolgist",
                                    "Value": "Numerolgist"
                                },
                                {
                                    "Text": "Fengshui specialist",
                                    "Value": "Fengshui specialist"
                                },
                                {
                                    "Text": "Reiki master",
                                    "Value": "Reiki master"
                                },
                                {
                                    "Text": "Vaastu consultant",
                                    "Value": "Vaastu consultant"
                                },
                                {
                                    "Text": "Tarot card reader",
                                    "Value": "Tarot card reader"
                                },
                                {
                                    "Text": "Jyotishi",
                                    "Value": "Jyotishi"
                                },
                                {
                                    "Text": "Fortune teller",
                                    "Value": "Fortune teller"
                                },
                                {
                                    "Text": "Area Sales Training Manager",
                                    "Value": "Area Sales Training Manager"
                                },
                                {
                                    "Text": "Assistant Finance & Accounts",
                                    "Value": "Assistant Finance & Accounts"
                                },
                                {
                                    "Text": "Associate Senior Faculty",
                                    "Value": "Associate Senior Faculty"
                                },
                                {
                                    "Text": "Assistant HRD Executive",
                                    "Value": "Assistant HRD Executive"
                                },
                                {
                                    "Text": "Associate Teacher",
                                    "Value": "Associate Teacher"
                                },
                                {
                                    "Text": "Associate Team Leader",
                                    "Value": "Associate Team Leader"
                                },
                                {
                                    "Text": "Associate Scientist",
                                    "Value": "Associate Scientist"
                                },
                                {
                                    "Text": "Asst Sub Inspector Railways",
                                    "Value": "Asst Sub Inspector Railways"
                                },
                                {
                                    "Text": "Assistant Accounts Officer",
                                    "Value": "Assistant Accounts Officer"
                                },
                                {
                                    "Text": "Assistant Chartered Accountant",
                                    "Value": "Assistant Chartered Accountant"
                                },
                                {
                                    "Text": "Assistant Chief Engineer",
                                    "Value": "Assistant Chief Engineer"
                                },
                                {
                                    "Text": "Assistant Commissioner",
                                    "Value": "Assistant Commissioner"
                                },
                                {
                                    "Text": "Assistant Engineer Grade I",
                                    "Value": "Assistant Engineer Grade I"
                                },
                                {
                                    "Text": "Assistant Junior Scientist",
                                    "Value": "Assistant Junior Scientist"
                                },
                                {
                                    "Text": "Assistant Manager Finance",
                                    "Value": "Assistant Manager Finance"
                                },
                                {
                                    "Text": "Assistant Manager HR",
                                    "Value": "Assistant Manager HR"
                                },
                                {
                                    "Text": "Assistant Manager HR Operation",
                                    "Value": "Assistant Manager HR Operation"
                                },
                                {
                                    "Text": "Assistant Mkt Mgr & Fin Analst",
                                    "Value": "Assistant Mkt Mgr & Fin Analst"
                                },
                                {
                                    "Text": "Assistant Officer",
                                    "Value": "Assistant Officer"
                                },
                                {
                                    "Text": "Assistant Project Director",
                                    "Value": "Assistant Project Director"
                                },
                                {
                                    "Text": "Assistant Project Manager",
                                    "Value": "Assistant Project Manager"
                                },
                                {
                                    "Text": "Assistant QA Manager",
                                    "Value": "Assistant QA Manager"
                                },
                                {
                                    "Text": "Assistant Senior Engineer",
                                    "Value": "Assistant Senior Engineer"
                                },
                                {
                                    "Text": "Assistant System Engg. Trainer",
                                    "Value": "Assistant System Engg. Trainer"
                                },
                                {
                                    "Text": "Assistant Technical Consultant",
                                    "Value": "Assistant Technical Consultant"
                                },
                                {
                                    "Text": "Assistant Territory Officer",
                                    "Value": "Assistant Territory Officer"
                                },
                                {
                                    "Text": "Assistant Works Manager",
                                    "Value": "Assistant Works Manager"
                                },
                                {
                                    "Text": "Associate Editor",
                                    "Value": "Associate Editor"
                                },
                                {
                                    "Text": "Associate Quality Assurance",
                                    "Value": "Associate Quality Assurance"
                                },
                                {
                                    "Text": "Associate",
                                    "Value": "Associate"
                                },
                                {
                                    "Text": "ATM Officer",
                                    "Value": "ATM Officer"
                                },
                                {
                                    "Text": "Attorney",
                                    "Value": "Attorney"
                                },
                                {
                                    "Text": "Artist",
                                    "Value": "Artist"
                                },
                                {
                                    "Text": "Attendant",
                                    "Value": "Attendant"
                                },
                                {
                                    "Text": "Audit Taxation Manager",
                                    "Value": "Audit Taxation Manager"
                                },
                                {
                                    "Text": "Authorised Dealer",
                                    "Value": "Authorised Dealer"
                                },
                                {
                                    "Text": "Authorised Ration Dealer",
                                    "Value": "Authorised Ration Dealer"
                                },
                                {
                                    "Text": "Authorised Retail Dealer",
                                    "Value": "Authorised Retail Dealer"
                                },
                                {
                                    "Text": "Auto Electrician",
                                    "Value": "Auto Electrician"
                                },
                                {
                                    "Text": "Automobile Officer",
                                    "Value": "Automobile Officer"
                                },
                                {
                                    "Text": "Audiologist",
                                    "Value": "Audiologist"
                                },
                                {
                                    "Text": "Auction Recorder",
                                    "Value": "Auction Recorder"
                                },
                                {
                                    "Text": "Autocad Operator",
                                    "Value": "Autocad Operator"
                                },
                                {
                                    "Text": "Audit Analyst",
                                    "Value": "Audit Analyst"
                                },
                                {
                                    "Text": "Duco-sprayer",
                                    "Value": "Duco-sprayer"
                                },
                                {
                                    "Text": "Electroplater",
                                    "Value": "Electroplater"
                                },
                                {
                                    "Text": "Emery user",
                                    "Value": "Emery user"
                                },
                                {
                                    "Text": "Sander",
                                    "Value": "Sander"
                                },
                                {
                                    "Text": "Brush painter",
                                    "Value": "Brush painter"
                                },
                                {
                                    "Text": "Audit Executive",
                                    "Value": "Audit Executive"
                                },
                                {
                                    "Text": "AVP Administration",
                                    "Value": "AVP Administration"
                                },
                                {
                                    "Text": "AVP Agency",
                                    "Value": "AVP Agency"
                                },
                                {
                                    "Text": "AVP Audit and Risk Management",
                                    "Value": "AVP Audit and Risk Management"
                                },
                                {
                                    "Text": "AVP Accounts",
                                    "Value": "AVP Accounts"
                                },
                                {
                                    "Text": "AVP Business Insights",
                                    "Value": "AVP Business Insights"
                                },
                                {
                                    "Text": "AVP Bancassurance",
                                    "Value": "AVP Bancassurance"
                                },
                                {
                                    "Text": "AVP Business Planning",
                                    "Value": "AVP Business Planning"
                                },
                                {
                                    "Text": "AVP Business & Service",
                                    "Value": "AVP Business & Service"
                                },
                                {
                                    "Text": "AVP Channel Development",
                                    "Value": "AVP Channel Development"
                                },
                                {
                                    "Text": "AVP Finance",
                                    "Value": "AVP Finance"
                                },
                                {
                                    "Text": "AVP Central Operations",
                                    "Value": "AVP Central Operations"
                                },
                                {
                                    "Text": "AVP Direct Sales-DSF",
                                    "Value": "AVP Direct Sales-DSF"
                                },
                                {
                                    "Text": "AVP Direct Sales",
                                    "Value": "AVP Direct Sales"
                                },
                                {
                                    "Text": "AVP -Bancassurance Servicing",
                                    "Value": "AVP -Bancassurance Servicing"
                                },
                                {
                                    "Text": "AVP Group Operations",
                                    "Value": "AVP Group Operations"
                                },
                                {
                                    "Text": "AVP Group Sales",
                                    "Value": "AVP Group Sales"
                                },
                                {
                                    "Text": "Trainee airline pilot",
                                    "Value": "Trainee airline pilot"
                                },
                                {
                                    "Text": "Commercial pilot",
                                    "Value": "Commercial pilot"
                                },
                                {
                                    "Text": "Airline instructor",
                                    "Value": "Airline instructor"
                                },
                                {
                                    "Text": "Flagman",
                                    "Value": "Flagman"
                                },
                                {
                                    "Text": "Baggage worker",
                                    "Value": "Baggage worker"
                                },
                                {
                                    "Text": "Aviation instructor",
                                    "Value": "Aviation instructor"
                                },
                                {
                                    "Text": "Flying instructor",
                                    "Value": "Flying instructor"
                                },
                                {
                                    "Text": "Test flight pilot",
                                    "Value": "Test flight pilot"
                                },
                                {
                                    "Text": "Test flight technician",
                                    "Value": "Test flight technician"
                                },
                                {
                                    "Text": "Radar controller",
                                    "Value": "Radar controller"
                                },
                                {
                                    "Text": "Co-pilot",
                                    "Value": "Co-pilot"
                                },
                                {
                                    "Text": "AVP HNI",
                                    "Value": "AVP HNI"
                                },
                                {
                                    "Text": "Aerial surveyor",
                                    "Value": "Aerial surveyor"
                                },
                                {
                                    "Text": "Airhostess",
                                    "Value": "Airhostess"
                                },
                                {
                                    "Text": "Stewardess",
                                    "Value": "Stewardess"
                                },
                                {
                                    "Text": "Airline cabin crew",
                                    "Value": "Airline cabin crew"
                                },
                                {
                                    "Text": "Airline purser",
                                    "Value": "Airline purser"
                                },
                                {
                                    "Text": "Flight attendant",
                                    "Value": "Flight attendant"
                                },
                                {
                                    "Text": "Commercial or club instructor",
                                    "Value": "Commercial or club instructor"
                                },
                                {
                                    "Text": "Airships flight crew",
                                    "Value": "Airships flight crew"
                                },
                                {
                                    "Text": "Demonstrator",
                                    "Value": "Demonstrator"
                                },
                                {
                                    "Text": "Police patrols",
                                    "Value": "Police patrols"
                                },
                                {
                                    "Text": "Aerial photography",
                                    "Value": "Aerial photography"
                                },
                                {
                                    "Text": "Private pilot",
                                    "Value": "Private pilot"
                                },
                                {
                                    "Text": "Technical observer",
                                    "Value": "Technical observer"
                                },
                                {
                                    "Text": "AVP Investment BO/MO",
                                    "Value": "AVP Investment BO/MO"
                                },
                                {
                                    "Text": "AVP Investment Front Desk",
                                    "Value": "AVP Investment Front Desk"
                                },
                                {
                                    "Text": "AVP Learning & Development",
                                    "Value": "AVP Learning & Development"
                                },
                                {
                                    "Text": "AVP Marketing",
                                    "Value": "AVP Marketing"
                                },
                                {
                                    "Text": "Airtraffic controller",
                                    "Value": "Airtraffic controller"
                                },
                                {
                                    "Text": "Aircraft assembler",
                                    "Value": "Aircraft assembler"
                                },
                                {
                                    "Text": "Aviation inspector",
                                    "Value": "Aviation inspector"
                                },
                                {
                                    "Text": "Aircraft designer",
                                    "Value": "Aircraft designer"
                                },
                                {
                                    "Text": "Cabin cleaner",
                                    "Value": "Cabin cleaner"
                                },
                                {
                                    "Text": "AVP Actuarial",
                                    "Value": "AVP Actuarial"
                                },
                                {
                                    "Text": "AVP Business Systems and",
                                    "Value": "AVP Business Systems and"
                                },
                                {
                                    "Text": "AVP DPPM",
                                    "Value": "AVP DPPM"
                                },
                                {
                                    "Text": "AVP EM Sales",
                                    "Value": "AVP EM Sales"
                                },
                                {
                                    "Text": "AVP-Strategy & Product",
                                    "Value": "AVP-Strategy & Product"
                                },
                                {
                                    "Text": "AVP Taxation",
                                    "Value": "AVP Taxation"
                                },
                                {
                                    "Text": "AVP Underwriting",
                                    "Value": "AVP Underwriting"
                                },
                                {
                                    "Text": "AVP Consumer Business",
                                    "Value": "AVP Consumer Business"
                                },
                                {
                                    "Text": "AVP",
                                    "Value": "AVP"
                                },
                                {
                                    "Text": "AVP Zonal Accounts",
                                    "Value": "AVP Zonal Accounts"
                                },
                                {
                                    "Text": "Ayurvedic Practitioner",
                                    "Value": "Ayurvedic Practitioner"
                                },
                                {
                                    "Text": "Ayurvedic Pandith Practitioner",
                                    "Value": "Ayurvedic Pandith Practitioner"
                                },
                                {
                                    "Text": "Ayurvedic Pandith",
                                    "Value": "Ayurvedic Pandith"
                                },
                                {
                                    "Text": "Ayurvedic Vaidya",
                                    "Value": "Ayurvedic Vaidya"
                                },
                                {
                                    "Text": "Back Ground Artist",
                                    "Value": "Back Ground Artist"
                                },
                                {
                                    "Text": "Back Office Officer",
                                    "Value": "Back Office Officer"
                                },
                                {
                                    "Text": "Back Officer",
                                    "Value": "Back Officer"
                                },
                                {
                                    "Text": "Back Support Officer",
                                    "Value": "Back Support Officer"
                                },
                                {
                                    "Text": "Backend Executive",
                                    "Value": "Backend Executive"
                                },
                                {
                                    "Text": "Baliff Judicial Department",
                                    "Value": "Baliff Judicial Department"
                                },
                                {
                                    "Text": "Bank Agent",
                                    "Value": "Bank Agent"
                                },
                                {
                                    "Text": "Bank Cashier",
                                    "Value": "Bank Cashier"
                                },
                                {
                                    "Text": "Bank Inspector",
                                    "Value": "Bank Inspector"
                                },
                                {
                                    "Text": "Bank Reconciliation Analyst",
                                    "Value": "Bank Reconciliation Analyst"
                                },
                                {
                                    "Text": "Bank Special Assistant",
                                    "Value": "Bank Special Assistant"
                                },
                                {
                                    "Text": "Banking Assistant",
                                    "Value": "Banking Assistant"
                                },
                                {
                                    "Text": "Banquet Manager",
                                    "Value": "Banquet Manager"
                                },
                                {
                                    "Text": "Basic Office Assistant",
                                    "Value": "Basic Office Assistant"
                                },
                                {
                                    "Text": "Back Office Cust Serv Associat",
                                    "Value": "Back Office Cust Serv Associat"
                                },
                                {
                                    "Text": "Bank Employee",
                                    "Value": "Bank Employee"
                                },
                                {
                                    "Text": "Bakery Chef",
                                    "Value": "Bakery Chef"
                                },
                                {
                                    "Text": "Back Office Manager",
                                    "Value": "Back Office Manager"
                                },
                                {
                                    "Text": "Bank Employee Substaff",
                                    "Value": "Bank Employee Substaff"
                                },
                                {
                                    "Text": "Banksman",
                                    "Value": "Banksman"
                                },
                                {
                                    "Text": "Back Office Assistant",
                                    "Value": "Back Office Assistant"
                                },
                                {
                                    "Text": "Bank Clerk",
                                    "Value": "Bank Clerk"
                                },
                                {
                                    "Text": "Baby sitter",
                                    "Value": "Baby sitter"
                                },
                                {
                                    "Text": "Back Office Executive",
                                    "Value": "Back Office Executive"
                                },
                                {
                                    "Text": "BDM",
                                    "Value": "BDM"
                                },
                                {
                                    "Text": "Bull dozer operator",
                                    "Value": "Bull dozer operator"
                                },
                                {
                                    "Text": "BDS Doctor",
                                    "Value": "BDS Doctor"
                                },
                                {
                                    "Text": "Beautician Helper",
                                    "Value": "Beautician Helper"
                                },
                                {
                                    "Text": "Beedi Roller",
                                    "Value": "Beedi Roller"
                                },
                                {
                                    "Text": "Bhagat",
                                    "Value": "Bhagat"
                                },
                                {
                                    "Text": "Bidi Worker",
                                    "Value": "Bidi Worker"
                                },
                                {
                                    "Text": "Billing Engineer",
                                    "Value": "Billing Engineer"
                                },
                                {
                                    "Text": "Biscuit Maker",
                                    "Value": "Biscuit Maker"
                                },
                                {
                                    "Text": "Bill Passing Officer",
                                    "Value": "Bill Passing Officer"
                                },
                                {
                                    "Text": "Bill Recovery Agent",
                                    "Value": "Bill Recovery Agent"
                                },
                                {
                                    "Text": "Bill Collector",
                                    "Value": "Bill Collector"
                                },
                                {
                                    "Text": "Bill Clerk",
                                    "Value": "Bill Clerk"
                                },
                                {
                                    "Text": "Biochemist",
                                    "Value": "Biochemist"
                                },
                                {
                                    "Text": "Block Education Officer",
                                    "Value": "Block Education Officer"
                                },
                                {
                                    "Text": "Block Elementary Edu. Officer",
                                    "Value": "Block Elementary Edu. Officer"
                                },
                                {
                                    "Text": "Block Medical Officer",
                                    "Value": "Block Medical Officer"
                                },
                                {
                                    "Text": "Block Officer",
                                    "Value": "Block Officer"
                                },
                                {
                                    "Text": "Block Live Stock Develop Offcr",
                                    "Value": "Block Live Stock Develop Offcr"
                                },
                                {
                                    "Text": "Block Cutter",
                                    "Value": "Block Cutter"
                                },
                                {
                                    "Text": "Boiler operator",
                                    "Value": "Boiler operator"
                                },
                                {
                                    "Text": "Block Investigator",
                                    "Value": "Block Investigator"
                                },
                                {
                                    "Text": "Boilerman",
                                    "Value": "Boilerman"
                                },
                                {
                                    "Text": "Branch Manager Branch Sales",
                                    "Value": "Branch Manager Branch Sales"
                                },
                                {
                                    "Text": "Branch Manager Direct DSF",
                                    "Value": "Branch Manager Direct DSF"
                                },
                                {
                                    "Text": "BMD Telemarketing",
                                    "Value": "BMD Telemarketing"
                                },
                                {
                                    "Text": "Branch Manager International",
                                    "Value": "Branch Manager International"
                                },
                                {
                                    "Text": "Branch Manager Direct  Loyalty",
                                    "Value": "Branch Manager Direct  Loyalty"
                                },
                                {
                                    "Text": "BM Worksite Marketing",
                                    "Value": "BM Worksite Marketing"
                                },
                                {
                                    "Text": "Book Seller",
                                    "Value": "Book Seller"
                                },
                                {
                                    "Text": "Booking Officer",
                                    "Value": "Booking Officer"
                                },
                                {
                                    "Text": "Boiler Attendant & Technician",
                                    "Value": "Boiler Attendant & Technician"
                                },
                                {
                                    "Text": "Boat Builder",
                                    "Value": "Boat Builder"
                                },
                                {
                                    "Text": "Boys Hostel Warden",
                                    "Value": "Boys Hostel Warden"
                                },
                                {
                                    "Text": "Body Shop Manager",
                                    "Value": "Body Shop Manager"
                                },
                                {
                                    "Text": "Boilermaker",
                                    "Value": "Boilermaker"
                                },
                                {
                                    "Text": "Business owner",
                                    "Value": "Business owner"
                                },
                                {
                                    "Text": "Owner",
                                    "Value": "Owner"
                                },
                                {
                                    "Text": "Business partner",
                                    "Value": "Business partner"
                                },
                                {
                                    "Text": "Properietor",
                                    "Value": "Properietor"
                                },
                                {
                                    "Text": "Entrepreneur",
                                    "Value": "Entrepreneur"
                                },
                                {
                                    "Text": "Factory owner",
                                    "Value": "Factory owner"
                                },
                                {
                                    "Text": "Shop owner",
                                    "Value": "Shop owner"
                                },
                                {
                                    "Text": "Export business owner",
                                    "Value": "Export business owner"
                                },
                                {
                                    "Text": "Transportation company owner",
                                    "Value": "Transportation company owner"
                                },
                                {
                                    "Text": "Truck owner",
                                    "Value": "Truck owner"
                                },
                                {
                                    "Text": "Booking Clerk",
                                    "Value": "Booking Clerk"
                                },
                                {
                                    "Text": "Borer",
                                    "Value": "Borer"
                                },
                                {
                                    "Text": "Jewellery merchant",
                                    "Value": "Jewellery merchant"
                                },
                                {
                                    "Text": "Workshop owner",
                                    "Value": "Workshop owner"
                                },
                                {
                                    "Text": "Garage owner",
                                    "Value": "Garage owner"
                                },
                                {
                                    "Text": "Building material supplier",
                                    "Value": "Building material supplier"
                                },
                                {
                                    "Text": "Dealer",
                                    "Value": "Dealer"
                                },
                                {
                                    "Text": "Wholeseller",
                                    "Value": "Wholeseller"
                                },
                                {
                                    "Text": "Confectionery",
                                    "Value": "Confectionery"
                                },
                                {
                                    "Text": "Karyana merchant",
                                    "Value": "Karyana merchant"
                                },
                                {
                                    "Text": "Kirana merchant",
                                    "Value": "Kirana merchant"
                                },
                                {
                                    "Text": "Logistics",
                                    "Value": "Logistics"
                                },
                                {
                                    "Text": "Gems & Jewelllery owner/ buss",
                                    "Value": "Gems & Jewelllery owner/ buss"
                                },
                                {
                                    "Text": "Diamond plating business",
                                    "Value": "Diamond plating business"
                                },
                                {
                                    "Text": "General stores",
                                    "Value": "General stores"
                                },
                                {
                                    "Text": "Grocery shopowner",
                                    "Value": "Grocery shopowner"
                                },
                                {
                                    "Text": "Medical Store owner",
                                    "Value": "Medical Store owner"
                                },
                                {
                                    "Text": "Commision agent",
                                    "Value": "Commision agent"
                                },
                                {
                                    "Text": "BPO Officer",
                                    "Value": "BPO Officer"
                                },
                                {
                                    "Text": "BPO Executive",
                                    "Value": "BPO Executive"
                                },
                                {
                                    "Text": "Branch Credit Manager",
                                    "Value": "Branch Credit Manager"
                                },
                                {
                                    "Text": "Branch Engineer",
                                    "Value": "Branch Engineer"
                                },
                                {
                                    "Text": "Branch Operations Officer",
                                    "Value": "Branch Operations Officer"
                                },
                                {
                                    "Text": "Branch Post Master",
                                    "Value": "Branch Post Master"
                                },
                                {
                                    "Text": "Branch Sales Manager",
                                    "Value": "Branch Sales Manager"
                                },
                                {
                                    "Text": "Branch Supervisor",
                                    "Value": "Branch Supervisor"
                                },
                                {
                                    "Text": "Branch Support Officer",
                                    "Value": "Branch Support Officer"
                                },
                                {
                                    "Text": "Branch Training Officer",
                                    "Value": "Branch Training Officer"
                                },
                                {
                                    "Text": "Bricks Manufacturer",
                                    "Value": "Bricks Manufacturer"
                                },
                                {
                                    "Text": "Broker",
                                    "Value": "Broker"
                                },
                                {
                                    "Text": "Broker & Commission Agent",
                                    "Value": "Broker & Commission Agent"
                                },
                                {
                                    "Text": "Broker & Farmer",
                                    "Value": "Broker & Farmer"
                                },
                                {
                                    "Text": "Broker Agent",
                                    "Value": "Broker Agent"
                                },
                                {
                                    "Text": "Broker Commission Agent",
                                    "Value": "Broker Commission Agent"
                                },
                                {
                                    "Text": "Broker Cum Sales Officer",
                                    "Value": "Broker Cum Sales Officer"
                                },
                                {
                                    "Text": "Broker & Service",
                                    "Value": "Broker & Service"
                                },
                                {
                                    "Text": "Broker Grain Mandi",
                                    "Value": "Broker Grain Mandi"
                                },
                                {
                                    "Text": "Broker In Railway Goods",
                                    "Value": "Broker In Railway Goods"
                                },
                                {
                                    "Text": "Branch Collection Manager",
                                    "Value": "Branch Collection Manager"
                                },
                                {
                                    "Text": "Branch Head Manager Sales",
                                    "Value": "Branch Head Manager Sales"
                                },
                                {
                                    "Text": "Branch Executive",
                                    "Value": "Branch Executive"
                                },
                                {
                                    "Text": "Branch Accountant",
                                    "Value": "Branch Accountant"
                                },
                                {
                                    "Text": "Branch Coordinator",
                                    "Value": "Branch Coordinator"
                                },
                                {
                                    "Text": "Brand Associate",
                                    "Value": "Brand Associate"
                                },
                                {
                                    "Text": "Broker Cloth",
                                    "Value": "Broker Cloth"
                                },
                                {
                                    "Text": "Branch Trainer",
                                    "Value": "Branch Trainer"
                                },
                                {
                                    "Text": "Branch Officer",
                                    "Value": "Branch Officer"
                                },
                                {
                                    "Text": "Business Planning Manager BL",
                                    "Value": "Business Planning Manager BL"
                                },
                                {
                                    "Text": "BSNL Officer",
                                    "Value": "BSNL Officer"
                                },
                                {
                                    "Text": "Business Insights Analyst",
                                    "Value": "Business Insights Analyst"
                                },
                                {
                                    "Text": "BSNL Operator",
                                    "Value": "BSNL Operator"
                                },
                                {
                                    "Text": "Business Planning Manager",
                                    "Value": "Business Planning Manager"
                                },
                                {
                                    "Text": "Builder & Contractor",
                                    "Value": "Builder & Contractor"
                                },
                                {
                                    "Text": "Builder & Proprietor",
                                    "Value": "Builder & Proprietor"
                                },
                                {
                                    "Text": "Building Manager",
                                    "Value": "Building Manager"
                                },
                                {
                                    "Text": "Business Head",
                                    "Value": "Business Head"
                                },
                                {
                                    "Text": "Business Contractor",
                                    "Value": "Business Contractor"
                                },
                                {
                                    "Text": "Business Developer",
                                    "Value": "Business Developer"
                                },
                                {
                                    "Text": "Business Development Engineer",
                                    "Value": "Business Development Engineer"
                                },
                                {
                                    "Text": "Business Development Executive",
                                    "Value": "Business Development Executive"
                                },
                                {
                                    "Text": "Business Director",
                                    "Value": "Business Director"
                                },
                                {
                                    "Text": "Business Executive",
                                    "Value": "Business Executive"
                                },
                                {
                                    "Text": "Business Head Software Solutn.",
                                    "Value": "Business Head Software Solutn."
                                },
                                {
                                    "Text": "Businessman",
                                    "Value": "Businessman"
                                },
                                {
                                    "Text": "Business Manager",
                                    "Value": "Business Manager"
                                },
                                {
                                    "Text": "Business Managing Partner",
                                    "Value": "Business Managing Partner"
                                },
                                {
                                    "Text": "Business Officer",
                                    "Value": "Business Officer"
                                },
                                {
                                    "Text": "Business Owner & Proprietor",
                                    "Value": "Business Owner & Proprietor"
                                },
                                {
                                    "Text": "Business Planning Analyst",
                                    "Value": "Business Planning Analyst"
                                },
                                {
                                    "Text": "Business Proprietor",
                                    "Value": "Business Proprietor"
                                },
                                {
                                    "Text": "Business Shopkeeper",
                                    "Value": "Business Shopkeeper"
                                },
                                {
                                    "Text": "Business Women & Owner",
                                    "Value": "Business Women & Owner"
                                },
                                {
                                    "Text": "Businessman & Owner",
                                    "Value": "Businessman & Owner"
                                },
                                {
                                    "Text": "Buss Head & Managing Partner",
                                    "Value": "Buss Head & Managing Partner"
                                },
                                {
                                    "Text": "Buyer Executive",
                                    "Value": "Buyer Executive"
                                },
                                {
                                    "Text": "Business Manager Direct",
                                    "Value": "Business Manager Direct"
                                },
                                {
                                    "Text": "Bureau Chief",
                                    "Value": "Bureau Chief"
                                },
                                {
                                    "Text": "Bus Manager",
                                    "Value": "Bus Manager"
                                },
                                {
                                    "Text": "Bulldozer driver",
                                    "Value": "Bulldozer driver"
                                },
                                {
                                    "Text": "Business Consultant Enginering",
                                    "Value": "Business Consultant Enginering"
                                },
                                {
                                    "Text": "Bus Agent",
                                    "Value": "Bus Agent"
                                },
                                {
                                    "Text": "Business Ambassador",
                                    "Value": "Business Ambassador"
                                },
                                {
                                    "Text": "Business Agriculture",
                                    "Value": "Business Agriculture"
                                },
                                {
                                    "Text": "Business Of Jari",
                                    "Value": "Business Of Jari"
                                },
                                {
                                    "Text": "Bus Builder",
                                    "Value": "Bus Builder"
                                },
                                {
                                    "Text": "Business",
                                    "Value": "Business"
                                },
                                {
                                    "Text": "Business Strategist",
                                    "Value": "Business Strategist"
                                },
                                {
                                    "Text": "Business Associate",
                                    "Value": "Business Associate"
                                },
                                {
                                    "Text": "Beauty parlour owner",
                                    "Value": "Beauty parlour owner"
                                },
                                {
                                    "Text": "Business HUF",
                                    "Value": "Business HUF"
                                },
                                {
                                    "Text": "Business Banking Executive",
                                    "Value": "Business Banking Executive"
                                },
                                {
                                    "Text": "Buyer",
                                    "Value": "Buyer"
                                },
                                {
                                    "Text": "Business Information Developer",
                                    "Value": "Business Information Developer"
                                },
                                {
                                    "Text": "CA & Proprietor",
                                    "Value": "CA & Proprietor"
                                },
                                {
                                    "Text": "CA Software Engineer",
                                    "Value": "CA Software Engineer"
                                },
                                {
                                    "Text": "Cable Operator",
                                    "Value": "Cable Operator"
                                },
                                {
                                    "Text": "CAD Designer",
                                    "Value": "CAD Designer"
                                },
                                {
                                    "Text": "CAD Engineer",
                                    "Value": "CAD Engineer"
                                },
                                {
                                    "Text": "CAD Executive",
                                    "Value": "CAD Executive"
                                },
                                {
                                    "Text": "CAD Manager",
                                    "Value": "CAD Manager"
                                },
                                {
                                    "Text": "Cadet Officer",
                                    "Value": "Cadet Officer"
                                },
                                {
                                    "Text": "Cane Contractor",
                                    "Value": "Cane Contractor"
                                },
                                {
                                    "Text": "Cane Contractor & Farmer",
                                    "Value": "Cane Contractor & Farmer"
                                },
                                {
                                    "Text": "Carpenter & Proprietor",
                                    "Value": "Carpenter & Proprietor"
                                },
                                {
                                    "Text": "CAD Technician",
                                    "Value": "CAD Technician"
                                },
                                {
                                    "Text": "Cartering Agent",
                                    "Value": "Cartering Agent"
                                },
                                {
                                    "Text": "Cash Collection Executive",
                                    "Value": "Cash Collection Executive"
                                },
                                {
                                    "Text": "Cash Collector",
                                    "Value": "Cash Collector"
                                },
                                {
                                    "Text": "Cash Manager",
                                    "Value": "Cash Manager"
                                },
                                {
                                    "Text": "Cashew Trader",
                                    "Value": "Cashew Trader"
                                },
                                {
                                    "Text": "Cashier & Clerk",
                                    "Value": "Cashier & Clerk"
                                },
                                {
                                    "Text": "Cashier Chit Section",
                                    "Value": "Cashier Chit Section"
                                },
                                {
                                    "Text": "Cashier Clerk",
                                    "Value": "Cashier Clerk"
                                },
                                {
                                    "Text": "Cashier Cum Accounts Clerk",
                                    "Value": "Cashier Cum Accounts Clerk"
                                },
                                {
                                    "Text": "Cashier Cum Clerk",
                                    "Value": "Cashier Cum Clerk"
                                },
                                {
                                    "Text": "Cashier Cum Computer Operator",
                                    "Value": "Cashier Cum Computer Operator"
                                },
                                {
                                    "Text": "Catering Contractor",
                                    "Value": "Catering Contractor"
                                },
                                {
                                    "Text": "Catering Executive",
                                    "Value": "Catering Executive"
                                },
                                {
                                    "Text": "Cable Former",
                                    "Value": "Cable Former"
                                },
                                {
                                    "Text": "CA",
                                    "Value": "CA"
                                },
                                {
                                    "Text": "Cadet Defence",
                                    "Value": "Cadet Defence"
                                },
                                {
                                    "Text": "Customs and excise worker",
                                    "Value": "Customs and excise worker"
                                },
                                {
                                    "Text": "Caulker",
                                    "Value": "Caulker"
                                },
                                {
                                    "Text": "C.A.M",
                                    "Value": "C.A.M"
                                },
                                {
                                    "Text": "Corporate Agency Manager Broka",
                                    "Value": "Corporate Agency Manager Broka"
                                },
                                {
                                    "Text": "Corporate Relationship Manager",
                                    "Value": "Corporate Relationship Manager"
                                },
                                {
                                    "Text": "Cameraman",
                                    "Value": "Cameraman"
                                },
                                {
                                    "Text": "Canvassing Agent",
                                    "Value": "Canvassing Agent"
                                },
                                {
                                    "Text": "Call Operator",
                                    "Value": "Call Operator"
                                },
                                {
                                    "Text": "Captain",
                                    "Value": "Captain"
                                },
                                {
                                    "Text": "Cash & Accounts Clerk",
                                    "Value": "Cash & Accounts Clerk"
                                },
                                {
                                    "Text": "Carpenter",
                                    "Value": "Carpenter"
                                },
                                {
                                    "Text": "Caster",
                                    "Value": "Caster"
                                },
                                {
                                    "Text": "Call Center Executive",
                                    "Value": "Call Center Executive"
                                },
                                {
                                    "Text": "Carpenter Contractor",
                                    "Value": "Carpenter Contractor"
                                },
                                {
                                    "Text": "Cash Officer",
                                    "Value": "Cash Officer"
                                },
                                {
                                    "Text": "Cable Jointer",
                                    "Value": "Cable Jointer"
                                },
                                {
                                    "Text": "Customer Care Agent",
                                    "Value": "Customer Care Agent"
                                },
                                {
                                    "Text": "Child Care Worker",
                                    "Value": "Child Care Worker"
                                },
                                {
                                    "Text": "Center Manager",
                                    "Value": "Center Manager"
                                },
                                {
                                    "Text": "CEO & Managing Director",
                                    "Value": "CEO & Managing Director"
                                },
                                {
                                    "Text": "Center Head",
                                    "Value": "Center Head"
                                },
                                {
                                    "Text": "Certified Accountant",
                                    "Value": "Certified Accountant"
                                },
                                {
                                    "Text": "Certified Civil Engineer",
                                    "Value": "Certified Civil Engineer"
                                },
                                {
                                    "Text": "Certified Consultant",
                                    "Value": "Certified Consultant"
                                },
                                {
                                    "Text": "Certified Financial Consultant",
                                    "Value": "Certified Financial Consultant"
                                },
                                {
                                    "Text": "CEO & Businessman",
                                    "Value": "CEO & Businessman"
                                },
                                {
                                    "Text": "Center Chief",
                                    "Value": "Center Chief"
                                },
                                {
                                    "Text": "Center Business Manager",
                                    "Value": "Center Business Manager"
                                },
                                {
                                    "Text": "Chemical Engineer",
                                    "Value": "Chemical Engineer"
                                },
                                {
                                    "Text": "CEO & President",
                                    "Value": "CEO & President"
                                },
                                {
                                    "Text": "CEO",
                                    "Value": "CEO"
                                },
                                {
                                    "Text": "Cell Executive Production",
                                    "Value": "Cell Executive Production"
                                },
                                {
                                    "Text": "Central Excise Inspector",
                                    "Value": "Central Excise Inspector"
                                },
                                {
                                    "Text": "Certified Doctor Hypnotherapy",
                                    "Value": "Certified Doctor Hypnotherapy"
                                },
                                {
                                    "Text": "Assistant custom officer",
                                    "Value": "Assistant custom officer"
                                },
                                {
                                    "Text": "Custom officer",
                                    "Value": "Custom officer"
                                },
                                {
                                    "Text": "Excise officer",
                                    "Value": "Excise officer"
                                },
                                {
                                    "Text": "Cert Fin Consultant/Beautician",
                                    "Value": "Cert Fin Consultant/Beautician"
                                },
                                {
                                    "Text": "Cargo officer",
                                    "Value": "Cargo officer"
                                },
                                {
                                    "Text": "Cargo agent",
                                    "Value": "Cargo agent"
                                },
                                {
                                    "Text": "Export agent",
                                    "Value": "Export agent"
                                },
                                {
                                    "Text": "Forwarding agent",
                                    "Value": "Forwarding agent"
                                },
                                {
                                    "Text": "Freight agent",
                                    "Value": "Freight agent"
                                },
                                {
                                    "Text": "Import export manager",
                                    "Value": "Import export manager"
                                },
                                {
                                    "Text": "Import export supervisor",
                                    "Value": "Import export supervisor"
                                },
                                {
                                    "Text": "Freight manager",
                                    "Value": "Freight manager"
                                },
                                {
                                    "Text": "Freight supervisor",
                                    "Value": "Freight supervisor"
                                },
                                {
                                    "Text": "C & F agent",
                                    "Value": "C & F agent"
                                },
                                {
                                    "Text": "Chief & Appointed Actuary",
                                    "Value": "Chief & Appointed Actuary"
                                },
                                {
                                    "Text": "CFA",
                                    "Value": "CFA"
                                },
                                {
                                    "Text": "CFC",
                                    "Value": "CFC"
                                },
                                {
                                    "Text": "CFC & Certified Fin Consultant",
                                    "Value": "CFC & Certified Fin Consultant"
                                },
                                {
                                    "Text": "CFC & MF Agent",
                                    "Value": "CFC & MF Agent"
                                },
                                {
                                    "Text": "Chairman & Director",
                                    "Value": "Chairman & Director"
                                },
                                {
                                    "Text": "Chairman & Managing Director",
                                    "Value": "Chairman & Managing Director"
                                },
                                {
                                    "Text": "Chairman & MD",
                                    "Value": "Chairman & MD"
                                },
                                {
                                    "Text": "Channel Manager",
                                    "Value": "Channel Manager"
                                },
                                {
                                    "Text": "Channel Sales Manager",
                                    "Value": "Channel Sales Manager"
                                },
                                {
                                    "Text": "Chartered Accountant & Partner",
                                    "Value": "Chartered Accountant & Partner"
                                },
                                {
                                    "Text": "Chartered Engg Govt Valuer",
                                    "Value": "Chartered Engg Govt Valuer"
                                },
                                {
                                    "Text": "Chartered Engineer",
                                    "Value": "Chartered Engineer"
                                },
                                {
                                    "Text": "Chief Manager Commercial",
                                    "Value": "Chief Manager Commercial"
                                },
                                {
                                    "Text": "Chemist Shop Owner",
                                    "Value": "Chemist Shop Owner"
                                },
                                {
                                    "Text": "Chief Technician",
                                    "Value": "Chief Technician"
                                },
                                {
                                    "Text": "Chief",
                                    "Value": "Chief"
                                },
                                {
                                    "Text": "Chief Accounts Assistant",
                                    "Value": "Chief Accounts Assistant"
                                },
                                {
                                    "Text": "Chief Accounts Officer",
                                    "Value": "Chief Accounts Officer"
                                },
                                {
                                    "Text": "Chairman",
                                    "Value": "Chairman"
                                },
                                {
                                    "Text": "Chief Cantonment Exec Officer",
                                    "Value": "Chief Cantonment Exec Officer"
                                },
                                {
                                    "Text": "Chief Cashier",
                                    "Value": "Chief Cashier"
                                },
                                {
                                    "Text": "Chief Consultant",
                                    "Value": "Chief Consultant"
                                },
                                {
                                    "Text": "Chief Coordinator",
                                    "Value": "Chief Coordinator"
                                },
                                {
                                    "Text": "Chief Copy Editor",
                                    "Value": "Chief Copy Editor"
                                },
                                {
                                    "Text": "Chief Editor",
                                    "Value": "Chief Editor"
                                },
                                {
                                    "Text": "Chief Electrician",
                                    "Value": "Chief Electrician"
                                },
                                {
                                    "Text": "Chief Engineer Production",
                                    "Value": "Chief Engineer Production"
                                },
                                {
                                    "Text": "Chief Environment Officer",
                                    "Value": "Chief Environment Officer"
                                },
                                {
                                    "Text": "Chief Executive Officer",
                                    "Value": "Chief Executive Officer"
                                },
                                {
                                    "Text": "Chief Executive Sales",
                                    "Value": "Chief Executive Sales"
                                },
                                {
                                    "Text": "Chief Fin. Officer Consultant",
                                    "Value": "Chief Fin. Officer Consultant"
                                },
                                {
                                    "Text": "Chief Financial Officer",
                                    "Value": "Chief Financial Officer"
                                },
                                {
                                    "Text": "Chief General Manager",
                                    "Value": "Chief General Manager"
                                },
                                {
                                    "Text": "Chief Geophysicist",
                                    "Value": "Chief Geophysicist"
                                },
                                {
                                    "Text": "Chief Loco Inspector",
                                    "Value": "Chief Loco Inspector"
                                },
                                {
                                    "Text": "Chief Manager",
                                    "Value": "Chief Manager"
                                },
                                {
                                    "Text": "Chief Manager Operations",
                                    "Value": "Chief Manager Operations"
                                },
                                {
                                    "Text": "Chief Manager Projects",
                                    "Value": "Chief Manager Projects"
                                },
                                {
                                    "Text": "Chief Nutritionist",
                                    "Value": "Chief Nutritionist"
                                },
                                {
                                    "Text": "Chief Office Superintendent",
                                    "Value": "Chief Office Superintendent"
                                },
                                {
                                    "Text": "Chief Officer",
                                    "Value": "Chief Officer"
                                },
                                {
                                    "Text": "Chief Operations",
                                    "Value": "Chief Operations"
                                },
                                {
                                    "Text": "Chief Paediatric Surgeon",
                                    "Value": "Chief Paediatric Surgeon"
                                },
                                {
                                    "Text": "Chief Parcel Supervisor",
                                    "Value": "Chief Parcel Supervisor"
                                },
                                {
                                    "Text": "Chief Perfusionist",
                                    "Value": "Chief Perfusionist"
                                },
                                {
                                    "Text": "Chief Personnel Manager",
                                    "Value": "Chief Personnel Manager"
                                },
                                {
                                    "Text": "Chief Pharmacist",
                                    "Value": "Chief Pharmacist"
                                },
                                {
                                    "Text": "Chief Photographer",
                                    "Value": "Chief Photographer"
                                },
                                {
                                    "Text": "Chief Regional Manager",
                                    "Value": "Chief Regional Manager"
                                },
                                {
                                    "Text": "Chief Sales Representative",
                                    "Value": "Chief Sales Representative"
                                },
                                {
                                    "Text": "Chief Manager Finance",
                                    "Value": "Chief Manager Finance"
                                },
                                {
                                    "Text": "Chief Section Supervisor",
                                    "Value": "Chief Section Supervisor"
                                },
                                {
                                    "Text": "Chief Services Director",
                                    "Value": "Chief Services Director"
                                },
                                {
                                    "Text": "Chief Sound Engineer",
                                    "Value": "Chief Sound Engineer"
                                },
                                {
                                    "Text": "Chief Sub Editor",
                                    "Value": "Chief Sub Editor"
                                },
                                {
                                    "Text": "Chief Supervisor",
                                    "Value": "Chief Supervisor"
                                },
                                {
                                    "Text": "Chief Tax Officer",
                                    "Value": "Chief Tax Officer"
                                },
                                {
                                    "Text": "Chief Technical Officer",
                                    "Value": "Chief Technical Officer"
                                },
                                {
                                    "Text": "Chief Technological Officer",
                                    "Value": "Chief Technological Officer"
                                },
                                {
                                    "Text": "Child Development Officer",
                                    "Value": "Child Development Officer"
                                },
                                {
                                    "Text": "Child Specialist Doctor",
                                    "Value": "Child Specialist Doctor"
                                },
                                {
                                    "Text": "Chief Architect",
                                    "Value": "Chief Architect"
                                },
                                {
                                    "Text": "Channel Development Manager",
                                    "Value": "Channel Development Manager"
                                },
                                {
                                    "Text": "Chief Engineer Retired",
                                    "Value": "Chief Engineer Retired"
                                },
                                {
                                    "Text": "Chemist",
                                    "Value": "Chemist"
                                },
                                {
                                    "Text": "Chief sales manager",
                                    "Value": "Chief sales manager"
                                },
                                {
                                    "Text": "Channel Manager Sales",
                                    "Value": "Channel Manager Sales"
                                },
                                {
                                    "Text": "Chipper",
                                    "Value": "Chipper"
                                },
                                {
                                    "Text": "Chief Matron",
                                    "Value": "Chief Matron"
                                },
                                {
                                    "Text": "Chairman and Managing Director",
                                    "Value": "Chairman and Managing Director"
                                },
                                {
                                    "Text": "Chief Of Marketing",
                                    "Value": "Chief Of Marketing"
                                },
                                {
                                    "Text": "Chief Executive Operations",
                                    "Value": "Chief Executive Operations"
                                },
                                {
                                    "Text": "Chief Accountant",
                                    "Value": "Chief Accountant"
                                },
                                {
                                    "Text": "Chaukidar",
                                    "Value": "Chaukidar"
                                },
                                {
                                    "Text": "Chairperson",
                                    "Value": "Chairperson"
                                },
                                {
                                    "Text": "Chemist Business Shop",
                                    "Value": "Chemist Business Shop"
                                },
                                {
                                    "Text": "Choreographer",
                                    "Value": "Choreographer"
                                },
                                {
                                    "Text": "Chief Clerk",
                                    "Value": "Chief Clerk"
                                },
                                {
                                    "Text": "Chief Expert",
                                    "Value": "Chief Expert"
                                },
                                {
                                    "Text": "Chief Pediatric Cardiac Surgry",
                                    "Value": "Chief Pediatric Cardiac Surgry"
                                },
                                {
                                    "Text": "Chief Software Architect",
                                    "Value": "Chief Software Architect"
                                },
                                {
                                    "Text": "Chief Chemist",
                                    "Value": "Chief Chemist"
                                },
                                {
                                    "Text": "Chief Judicial Magistrate",
                                    "Value": "Chief Judicial Magistrate"
                                },
                                {
                                    "Text": "Chief Manager Fin & Accounts",
                                    "Value": "Chief Manager Fin & Accounts"
                                },
                                {
                                    "Text": "Chain Process Executive",
                                    "Value": "Chain Process Executive"
                                },
                                {
                                    "Text": "Chemist & Druggist",
                                    "Value": "Chemist & Druggist"
                                },
                                {
                                    "Text": "Chest Physiotherapist",
                                    "Value": "Chest Physiotherapist"
                                },
                                {
                                    "Text": "Chief Commercial Clerk",
                                    "Value": "Chief Commercial Clerk"
                                },
                                {
                                    "Text": "Chief Scientific Officer",
                                    "Value": "Chief Scientific Officer"
                                },
                                {
                                    "Text": "Chief Labour Welfare Inspector",
                                    "Value": "Chief Labour Welfare Inspector"
                                },
                                {
                                    "Text": "Circulation Executive",
                                    "Value": "Circulation Executive"
                                },
                                {
                                    "Text": "Citi Phone Officer",
                                    "Value": "Citi Phone Officer"
                                },
                                {
                                    "Text": "City Engineer",
                                    "Value": "City Engineer"
                                },
                                {
                                    "Text": "City Head",
                                    "Value": "City Head"
                                },
                                {
                                    "Text": "City Sales Executive",
                                    "Value": "City Sales Executive"
                                },
                                {
                                    "Text": "City Sales Manager",
                                    "Value": "City Sales Manager"
                                },
                                {
                                    "Text": "Civil Contractor",
                                    "Value": "Civil Contractor"
                                },
                                {
                                    "Text": "Civil Enggineering Contractor",
                                    "Value": "Civil Enggineering Contractor"
                                },
                                {
                                    "Text": "Civil Engineer Project Manager",
                                    "Value": "Civil Engineer Project Manager"
                                },
                                {
                                    "Text": "Civil Engineering Assistant",
                                    "Value": "Civil Engineering Assistant"
                                },
                                {
                                    "Text": "Civil Junior Engineer",
                                    "Value": "Civil Junior Engineer"
                                },
                                {
                                    "Text": "Civil Works Contractor",
                                    "Value": "Civil Works Contractor"
                                },
                                {
                                    "Text": "Civil Court Employee",
                                    "Value": "Civil Court Employee"
                                },
                                {
                                    "Text": "Civil Judge",
                                    "Value": "Civil Judge"
                                },
                                {
                                    "Text": "Clown",
                                    "Value": "Clown"
                                },
                                {
                                    "Text": "Curator",
                                    "Value": "Curator"
                                },
                                {
                                    "Text": "Head keeper",
                                    "Value": "Head keeper"
                                },
                                {
                                    "Text": "CIO Investment Front Desk",
                                    "Value": "CIO Investment Front Desk"
                                },
                                {
                                    "Text": "Civil Assistant Surgeon",
                                    "Value": "Civil Assistant Surgeon"
                                },
                                {
                                    "Text": "Civil & Labour Contractor",
                                    "Value": "Civil & Labour Contractor"
                                },
                                {
                                    "Text": "Animal trainer",
                                    "Value": "Animal trainer"
                                },
                                {
                                    "Text": "Trapeze artist",
                                    "Value": "Trapeze artist"
                                },
                                {
                                    "Text": "Acrobat",
                                    "Value": "Acrobat"
                                },
                                {
                                    "Text": "Tightrope artist",
                                    "Value": "Tightrope artist"
                                },
                                {
                                    "Text": "Aerialist",
                                    "Value": "Aerialist"
                                },
                                {
                                    "Text": "Fire eater",
                                    "Value": "Fire eater"
                                },
                                {
                                    "Text": "Circle Inspector Excise",
                                    "Value": "Circle Inspector Excise"
                                },
                                {
                                    "Text": "Civil Engineer",
                                    "Value": "Civil Engineer"
                                },
                                {
                                    "Text": "City Manager",
                                    "Value": "City Manager"
                                },
                                {
                                    "Text": "Class I Contractor",
                                    "Value": "Class I Contractor"
                                },
                                {
                                    "Text": "Clerical Assistant",
                                    "Value": "Clerical Assistant"
                                },
                                {
                                    "Text": "Cluster Head",
                                    "Value": "Cluster Head"
                                },
                                {
                                    "Text": "Clerk Cum Sheriff",
                                    "Value": "Clerk Cum Sheriff"
                                },
                                {
                                    "Text": "Clerk Furnishing",
                                    "Value": "Clerk Furnishing"
                                },
                                {
                                    "Text": "Clerk Government Servant",
                                    "Value": "Clerk Government Servant"
                                },
                                {
                                    "Text": "Clerk Grade I",
                                    "Value": "Clerk Grade I"
                                },
                                {
                                    "Text": "Clerk Retired & Pensioner",
                                    "Value": "Clerk Retired & Pensioner"
                                },
                                {
                                    "Text": "Clerk/ Cashier",
                                    "Value": "Clerk/ Cashier"
                                },
                                {
                                    "Text": "Client Service Executive",
                                    "Value": "Client Service Executive"
                                },
                                {
                                    "Text": "Client Service Officer",
                                    "Value": "Client Service Officer"
                                },
                                {
                                    "Text": "Client Services Director",
                                    "Value": "Client Services Director"
                                },
                                {
                                    "Text": "Client Support Specialist",
                                    "Value": "Client Support Specialist"
                                },
                                {
                                    "Text": "Clinic Incharge",
                                    "Value": "Clinic Incharge"
                                },
                                {
                                    "Text": "Clinical Assistant",
                                    "Value": "Clinical Assistant"
                                },
                                {
                                    "Text": "Clinical Business Associate",
                                    "Value": "Clinical Business Associate"
                                },
                                {
                                    "Text": "Clinical Psychologist",
                                    "Value": "Clinical Psychologist"
                                },
                                {
                                    "Text": "Clerk Highway",
                                    "Value": "Clerk Highway"
                                },
                                {
                                    "Text": "Cloth Business & Proprietor",
                                    "Value": "Cloth Business & Proprietor"
                                },
                                {
                                    "Text": "Cloth Merchant",
                                    "Value": "Cloth Merchant"
                                },
                                {
                                    "Text": "Cluster Manager",
                                    "Value": "Cluster Manager"
                                },
                                {
                                    "Text": "Constuction labourer",
                                    "Value": "Constuction labourer"
                                },
                                {
                                    "Text": "Cluster Manager -Bancassurance",
                                    "Value": "Cluster Manager -Bancassurance"
                                },
                                {
                                    "Text": "Clerk Retired",
                                    "Value": "Clerk Retired"
                                },
                                {
                                    "Text": "Clerk Bank Employee",
                                    "Value": "Clerk Bank Employee"
                                },
                                {
                                    "Text": "Clerk Cashier",
                                    "Value": "Clerk Cashier"
                                },
                                {
                                    "Text": "Clerical Staff",
                                    "Value": "Clerical Staff"
                                },
                                {
                                    "Text": "Clerical Office Incharge",
                                    "Value": "Clerical Office Incharge"
                                },
                                {
                                    "Text": "Clergyman",
                                    "Value": "Clergyman"
                                },
                                {
                                    "Text": "Clerk Office Assistant II",
                                    "Value": "Clerk Office Assistant II"
                                },
                                {
                                    "Text": "Claims Assessor",
                                    "Value": "Claims Assessor"
                                },
                                {
                                    "Text": "Clerk Indian Army",
                                    "Value": "Clerk Indian Army"
                                },
                                {
                                    "Text": "Clerk Farming",
                                    "Value": "Clerk Farming"
                                },
                                {
                                    "Text": "Clock Maker",
                                    "Value": "Clock Maker"
                                },
                                {
                                    "Text": "Claim Assessor",
                                    "Value": "Claim Assessor"
                                },
                                {
                                    "Text": "Cleaning Staff",
                                    "Value": "Cleaning Staff"
                                },
                                {
                                    "Text": "Clerk Cum Typist",
                                    "Value": "Clerk Cum Typist"
                                },
                                {
                                    "Text": "Client Support Analyst",
                                    "Value": "Client Support Analyst"
                                },
                                {
                                    "Text": "Class I Contractor & Proprietr",
                                    "Value": "Class I Contractor & Proprietr"
                                },
                                {
                                    "Text": "Clearance Executive",
                                    "Value": "Clearance Executive"
                                },
                                {
                                    "Text": "Clerk Cum Cashier",
                                    "Value": "Clerk Cum Cashier"
                                },
                                {
                                    "Text": "Clinical Research Assistant II",
                                    "Value": "Clinical Research Assistant II"
                                },
                                {
                                    "Text": "Cluster Manager Agency",
                                    "Value": "Cluster Manager Agency"
                                },
                                {
                                    "Text": "Cluster Manager Branch Support",
                                    "Value": "Cluster Manager Branch Support"
                                },
                                {
                                    "Text": "Cluster Manager Claims",
                                    "Value": "Cluster Manager Claims"
                                },
                                {
                                    "Text": "Cluster Manager  Central",
                                    "Value": "Cluster Manager  Central"
                                },
                                {
                                    "Text": "Cluster Manager-Operations(CS",
                                    "Value": "Cluster Manager-Operations(CS"
                                },
                                {
                                    "Text": "CMS Worker",
                                    "Value": "CMS Worker"
                                },
                                {
                                    "Text": "Cluster Manager Operations",
                                    "Value": "Cluster Manager Operations"
                                },
                                {
                                    "Text": "Cluster Manager Group",
                                    "Value": "Cluster Manager Group"
                                },
                                {
                                    "Text": "Crop sprayer, chemicals",
                                    "Value": "Crop sprayer, chemicals"
                                },
                                {
                                    "Text": "Cluster Manager-International",
                                    "Value": "Cluster Manager-International"
                                },
                                {
                                    "Text": "Cluster Manager Online",
                                    "Value": "Cluster Manager Online"
                                },
                                {
                                    "Text": "Cluster Manager Hub Operations",
                                    "Value": "Cluster Manager Hub Operations"
                                },
                                {
                                    "Text": "Cluster Manager-ops(Persisteny",
                                    "Value": "Cluster Manager-ops(Persisteny"
                                },
                                {
                                    "Text": "Cluster Manager Shared",
                                    "Value": "Cluster Manager Shared"
                                },
                                {
                                    "Text": "Cluster Manager Underwriting",
                                    "Value": "Cluster Manager Underwriting"
                                },
                                {
                                    "Text": "Construction",
                                    "Value": "Construction"
                                },
                                {
                                    "Text": "Consultant (General)",
                                    "Value": "Consultant (General)"
                                },
                                {
                                    "Text": "Control Room Operator",
                                    "Value": "Control Room Operator"
                                },
                                {
                                    "Text": "Tunnelminer's labourer",
                                    "Value": "Tunnelminer's labourer"
                                },
                                {
                                    "Text": "Tunneller",
                                    "Value": "Tunneller"
                                },
                                {
                                    "Text": "Coach (Sports)",
                                    "Value": "Coach (Sports)"
                                },
                                {
                                    "Text": "Collection Head",
                                    "Value": "Collection Head"
                                },
                                {
                                    "Text": "Power loader operator",
                                    "Value": "Power loader operator"
                                },
                                {
                                    "Text": "Mechanical shovel driver",
                                    "Value": "Mechanical shovel driver"
                                },
                                {
                                    "Text": "Manhole maker",
                                    "Value": "Manhole maker"
                                },
                                {
                                    "Text": "Commercial Assistant",
                                    "Value": "Commercial Assistant"
                                },
                                {
                                    "Text": "Commercial Executive",
                                    "Value": "Commercial Executive"
                                },
                                {
                                    "Text": "Concrete erector",
                                    "Value": "Concrete erector"
                                },
                                {
                                    "Text": "Flame cutter",
                                    "Value": "Flame cutter"
                                },
                                {
                                    "Text": "Restorer",
                                    "Value": "Restorer"
                                },
                                {
                                    "Text": "Roofer",
                                    "Value": "Roofer"
                                },
                                {
                                    "Text": "Company Chairman",
                                    "Value": "Company Chairman"
                                },
                                {
                                    "Text": "Slater",
                                    "Value": "Slater"
                                },
                                {
                                    "Text": "Steel erector",
                                    "Value": "Steel erector"
                                },
                                {
                                    "Text": "Commission Agent",
                                    "Value": "Commission Agent"
                                },
                                {
                                    "Text": "Commission Agent & Proprietor",
                                    "Value": "Commission Agent & Proprietor"
                                },
                                {
                                    "Text": "Commission Agent & Trader",
                                    "Value": "Commission Agent & Trader"
                                },
                                {
                                    "Text": "Commission Agnt Transportation",
                                    "Value": "Commission Agnt Transportation"
                                },
                                {
                                    "Text": "Commission Agnt/Fin Consultant",
                                    "Value": "Commission Agnt/Fin Consultant"
                                },
                                {
                                    "Text": "Commissioner",
                                    "Value": "Commissioner"
                                },
                                {
                                    "Text": "Commissioner Of Income Tax",
                                    "Value": "Commissioner Of Income Tax"
                                },
                                {
                                    "Text": "Communication Coordinator",
                                    "Value": "Communication Coordinator"
                                },
                                {
                                    "Text": "Communication Engineer",
                                    "Value": "Communication Engineer"
                                },
                                {
                                    "Text": "Community Organizer",
                                    "Value": "Community Organizer"
                                },
                                {
                                    "Text": "Comp Secretary Head Compliance",
                                    "Value": "Comp Secretary Head Compliance"
                                },
                                {
                                    "Text": "Company Auditor",
                                    "Value": "Company Auditor"
                                },
                                {
                                    "Text": "Company Coordinator",
                                    "Value": "Company Coordinator"
                                },
                                {
                                    "Text": "Company Executive",
                                    "Value": "Company Executive"
                                },
                                {
                                    "Text": "Company Secretary & GM Legal",
                                    "Value": "Company Secretary & GM Legal"
                                },
                                {
                                    "Text": "Company Secretary In Practice",
                                    "Value": "Company Secretary In Practice"
                                },
                                {
                                    "Text": "Computer Accountant",
                                    "Value": "Computer Accountant"
                                },
                                {
                                    "Text": "Coach Builder",
                                    "Value": "Coach Builder"
                                },
                                {
                                    "Text": "Computer Analyst",
                                    "Value": "Computer Analyst"
                                },
                                {
                                    "Text": "Computer Assistant",
                                    "Value": "Computer Assistant"
                                },
                                {
                                    "Text": "Computer Attendant",
                                    "Value": "Computer Attendant"
                                },
                                {
                                    "Text": "Computer Designer",
                                    "Value": "Computer Designer"
                                },
                                {
                                    "Text": "Computer Faculty",
                                    "Value": "Computer Faculty"
                                },
                                {
                                    "Text": "Computer Faculty Teacher",
                                    "Value": "Computer Faculty Teacher"
                                },
                                {
                                    "Text": "Computer Hardware Engineer",
                                    "Value": "Computer Hardware Engineer"
                                },
                                {
                                    "Text": "Computer Jobworker",
                                    "Value": "Computer Jobworker"
                                },
                                {
                                    "Text": "Computer Manager",
                                    "Value": "Computer Manager"
                                },
                                {
                                    "Text": "Computer Operator Cum Acct.",
                                    "Value": "Computer Operator Cum Acct."
                                },
                                {
                                    "Text": "Computer Professional",
                                    "Value": "Computer Professional"
                                },
                                {
                                    "Text": "Computer Sales/Serv Proprietor",
                                    "Value": "Computer Sales/Serv Proprietor"
                                },
                                {
                                    "Text": "Computer Supervisor",
                                    "Value": "Computer Supervisor"
                                },
                                {
                                    "Text": "Computer Teacher",
                                    "Value": "Computer Teacher"
                                },
                                {
                                    "Text": "Computer Terminal Operator",
                                    "Value": "Computer Terminal Operator"
                                },
                                {
                                    "Text": "Computer Trainer Operator",
                                    "Value": "Computer Trainer Operator"
                                },
                                {
                                    "Text": "Controller of Finance",
                                    "Value": "Controller of Finance"
                                },
                                {
                                    "Text": "Connection Engineer",
                                    "Value": "Connection Engineer"
                                },
                                {
                                    "Text": "Consignment Selling Agent",
                                    "Value": "Consignment Selling Agent"
                                },
                                {
                                    "Text": "Const Peridontst/Dental Surgon",
                                    "Value": "Const Peridontst/Dental Surgon"
                                },
                                {
                                    "Text": "Construction Builder",
                                    "Value": "Construction Builder"
                                },
                                {
                                    "Text": "Constructor",
                                    "Value": "Constructor"
                                },
                                {
                                    "Text": "Consultant & Accountant",
                                    "Value": "Consultant & Accountant"
                                },
                                {
                                    "Text": "Consultant Clinical Biochemist",
                                    "Value": "Consultant Clinical Biochemist"
                                },
                                {
                                    "Text": "Consultant Counsellor",
                                    "Value": "Consultant Counsellor"
                                },
                                {
                                    "Text": "Consultant Doctor",
                                    "Value": "Consultant Doctor"
                                },
                                {
                                    "Text": "Consultant Engineer",
                                    "Value": "Consultant Engineer"
                                },
                                {
                                    "Text": "Consultant Intensivist",
                                    "Value": "Consultant Intensivist"
                                },
                                {
                                    "Text": "Consultant LIC",
                                    "Value": "Consultant LIC"
                                },
                                {
                                    "Text": "Consultant Life & General",
                                    "Value": "Consultant Life & General"
                                },
                                {
                                    "Text": "Consultant Manager",
                                    "Value": "Consultant Manager"
                                },
                                {
                                    "Text": "Consultant Neurologist",
                                    "Value": "Consultant Neurologist"
                                },
                                {
                                    "Text": "Consultant Numerologist",
                                    "Value": "Consultant Numerologist"
                                },
                                {
                                    "Text": "Consultant Orthopedic Surgeon",
                                    "Value": "Consultant Orthopedic Surgeon"
                                },
                                {
                                    "Text": "Consultant Pathologist",
                                    "Value": "Consultant Pathologist"
                                },
                                {
                                    "Text": "Consultant Pediatrician",
                                    "Value": "Consultant Pediatrician"
                                },
                                {
                                    "Text": "Chipping driver",
                                    "Value": "Chipping driver"
                                },
                                {
                                    "Text": "Concrete mixer driver",
                                    "Value": "Concrete mixer driver"
                                },
                                {
                                    "Text": "Concrete paving driver",
                                    "Value": "Concrete paving driver"
                                },
                                {
                                    "Text": "Long description",
                                    "Value": "Long description"
                                },
                                {
                                    "Text": "Dumper truck driver",
                                    "Value": "Dumper truck driver"
                                },
                                {
                                    "Text": "Consultant Trainer",
                                    "Value": "Consultant Trainer"
                                },
                                {
                                    "Text": "Pile driver",
                                    "Value": "Pile driver"
                                },
                                {
                                    "Text": "Road rolling driver",
                                    "Value": "Road rolling driver"
                                },
                                {
                                    "Text": "Surface laying machine driver",
                                    "Value": "Surface laying machine driver"
                                },
                                {
                                    "Text": "Jib driver",
                                    "Value": "Jib driver"
                                },
                                {
                                    "Text": "Mobile driver",
                                    "Value": "Mobile driver"
                                },
                                {
                                    "Text": "Tower driver",
                                    "Value": "Tower driver"
                                },
                                {
                                    "Text": "Content Developer",
                                    "Value": "Content Developer"
                                },
                                {
                                    "Text": "Contractor & Civil Supplier",
                                    "Value": "Contractor & Civil Supplier"
                                },
                                {
                                    "Text": "Contractor & Farmer",
                                    "Value": "Contractor & Farmer"
                                },
                                {
                                    "Text": "Contractor & Trader",
                                    "Value": "Contractor & Trader"
                                },
                                {
                                    "Text": "Contractor Civil",
                                    "Value": "Contractor Civil"
                                },
                                {
                                    "Text": "Contractor Interior Designing",
                                    "Value": "Contractor Interior Designing"
                                },
                                {
                                    "Text": "Contracts Engineer",
                                    "Value": "Contracts Engineer"
                                },
                                {
                                    "Text": "Controller Of Examinations",
                                    "Value": "Controller Of Examinations"
                                },
                                {
                                    "Text": "Cooperative Operation Officer",
                                    "Value": "Cooperative Operation Officer"
                                },
                                {
                                    "Text": "Coordinating Service Executive",
                                    "Value": "Coordinating Service Executive"
                                },
                                {
                                    "Text": "Coordinator",
                                    "Value": "Coordinator"
                                },
                                {
                                    "Text": "Co-Owner",
                                    "Value": "Co-Owner"
                                },
                                {
                                    "Text": "Copy Editor",
                                    "Value": "Copy Editor"
                                },
                                {
                                    "Text": "Corporal",
                                    "Value": "Corporal"
                                },
                                {
                                    "Text": "Corporate Accounts Manager",
                                    "Value": "Corporate Accounts Manager"
                                },
                                {
                                    "Text": "Corporate Agency Manager",
                                    "Value": "Corporate Agency Manager"
                                },
                                {
                                    "Text": "Corporate Communication Head",
                                    "Value": "Corporate Communication Head"
                                },
                                {
                                    "Text": "Corporate HR",
                                    "Value": "Corporate HR"
                                },
                                {
                                    "Text": "Commission Agent Iron & Steel",
                                    "Value": "Commission Agent Iron & Steel"
                                },
                                {
                                    "Text": "Computer Engineer",
                                    "Value": "Computer Engineer"
                                },
                                {
                                    "Text": "Corporate Sales Executive",
                                    "Value": "Corporate Sales Executive"
                                },
                                {
                                    "Text": "Corporate Sales Officer",
                                    "Value": "Corporate Sales Officer"
                                },
                                {
                                    "Text": "Collection Manager",
                                    "Value": "Collection Manager"
                                },
                                {
                                    "Text": "Co-Sales Manager",
                                    "Value": "Co-Sales Manager"
                                },
                                {
                                    "Text": "Cost Control Engineer",
                                    "Value": "Cost Control Engineer"
                                },
                                {
                                    "Text": "Costume Stylist",
                                    "Value": "Costume Stylist"
                                },
                                {
                                    "Text": "Cotton Purchase Officer",
                                    "Value": "Cotton Purchase Officer"
                                },
                                {
                                    "Text": "Counter Supervisor",
                                    "Value": "Counter Supervisor"
                                },
                                {
                                    "Text": "Country Group Representative",
                                    "Value": "Country Group Representative"
                                },
                                {
                                    "Text": "Country Manager",
                                    "Value": "Country Manager"
                                },
                                {
                                    "Text": "Company Secretary & Senior Mgr",
                                    "Value": "Company Secretary & Senior Mgr"
                                },
                                {
                                    "Text": "Crane erector",
                                    "Value": "Crane erector"
                                },
                                {
                                    "Text": "Spiderman",
                                    "Value": "Spiderman"
                                },
                                {
                                    "Text": "Steeplejack",
                                    "Value": "Steeplejack"
                                },
                                {
                                    "Text": "Steeplejack labourer",
                                    "Value": "Steeplejack labourer"
                                },
                                {
                                    "Text": "Tunnel miner",
                                    "Value": "Tunnel miner"
                                },
                                {
                                    "Text": "Concreter",
                                    "Value": "Concreter"
                                },
                                {
                                    "Text": "Asphalt maker",
                                    "Value": "Asphalt maker"
                                },
                                {
                                    "Text": "Asphalter",
                                    "Value": "Asphalter"
                                },
                                {
                                    "Text": "Bricklayer",
                                    "Value": "Bricklayer"
                                },
                                {
                                    "Text": "Construction superintendent",
                                    "Value": "Construction superintendent"
                                },
                                {
                                    "Text": "Ganger",
                                    "Value": "Ganger"
                                },
                                {
                                    "Text": "Glazier",
                                    "Value": "Glazier"
                                },
                                {
                                    "Text": "Hammerman",
                                    "Value": "Hammerman"
                                },
                                {
                                    "Text": "Land drainage worker",
                                    "Value": "Land drainage worker"
                                },
                                {
                                    "Text": "Leveller",
                                    "Value": "Leveller"
                                },
                                {
                                    "Text": "Street mason",
                                    "Value": "Street mason"
                                },
                                {
                                    "Text": "Pneumaic drill operator",
                                    "Value": "Pneumaic drill operator"
                                },
                                {
                                    "Text": "Road maker",
                                    "Value": "Road maker"
                                },
                                {
                                    "Text": "Road lengthsman",
                                    "Value": "Road lengthsman"
                                },
                                {
                                    "Text": "Screw man",
                                    "Value": "Screw man"
                                },
                                {
                                    "Text": "Sheet fixer",
                                    "Value": "Sheet fixer"
                                },
                                {
                                    "Text": "Sprayer",
                                    "Value": "Sprayer"
                                },
                                {
                                    "Text": "Trench man",
                                    "Value": "Trench man"
                                },
                                {
                                    "Text": "Demolition worker",
                                    "Value": "Demolition worker"
                                },
                                {
                                    "Text": "Constructional plater",
                                    "Value": "Constructional plater"
                                },
                                {
                                    "Text": "Consultant Cardiac Anesthesia",
                                    "Value": "Consultant Cardiac Anesthesia"
                                },
                                {
                                    "Text": "Consultant HDFCSLIC",
                                    "Value": "Consultant HDFCSLIC"
                                },
                                {
                                    "Text": "Coil Former",
                                    "Value": "Coil Former"
                                },
                                {
                                    "Text": "Collection Admin",
                                    "Value": "Collection Admin"
                                },
                                {
                                    "Text": "Columnist",
                                    "Value": "Columnist"
                                },
                                {
                                    "Text": "System manager",
                                    "Value": "System manager"
                                },
                                {
                                    "Text": "Project leader",
                                    "Value": "Project leader"
                                },
                                {
                                    "Text": "Project manager",
                                    "Value": "Project manager"
                                },
                                {
                                    "Text": "Software consultant",
                                    "Value": "Software consultant"
                                },
                                {
                                    "Text": "Database manager",
                                    "Value": "Database manager"
                                },
                                {
                                    "Text": "Data processor",
                                    "Value": "Data processor"
                                },
                                {
                                    "Text": "Data processing officer",
                                    "Value": "Data processing officer"
                                },
                                {
                                    "Text": "EDP manager",
                                    "Value": "EDP manager"
                                },
                                {
                                    "Text": "Internet technician",
                                    "Value": "Internet technician"
                                },
                                {
                                    "Text": "IT consultant",
                                    "Value": "IT consultant"
                                },
                                {
                                    "Text": "Senior software engineer",
                                    "Value": "Senior software engineer"
                                },
                                {
                                    "Text": "Software developer",
                                    "Value": "Software developer"
                                },
                                {
                                    "Text": "Coal Melter",
                                    "Value": "Coal Melter"
                                },
                                {
                                    "Text": "Chief technology officer",
                                    "Value": "Chief technology officer"
                                },
                                {
                                    "Text": "Chief information officer",
                                    "Value": "Chief information officer"
                                },
                                {
                                    "Text": "Network Manager",
                                    "Value": "Network Manager"
                                },
                                {
                                    "Text": "System administrator",
                                    "Value": "System administrator"
                                },
                                {
                                    "Text": "System Engineer",
                                    "Value": "System Engineer"
                                },
                                {
                                    "Text": "Building contractor",
                                    "Value": "Building contractor"
                                },
                                {
                                    "Text": "Contractor",
                                    "Value": "Contractor"
                                },
                                {
                                    "Text": "Building inspector",
                                    "Value": "Building inspector"
                                },
                                {
                                    "Text": "Consultant Marketing",
                                    "Value": "Consultant Marketing"
                                },
                                {
                                    "Text": "Structural engineer",
                                    "Value": "Structural engineer"
                                },
                                {
                                    "Text": "Engineering geologist",
                                    "Value": "Engineering geologist"
                                },
                                {
                                    "Text": "Building technician",
                                    "Value": "Building technician"
                                },
                                {
                                    "Text": "Floor layer",
                                    "Value": "Floor layer"
                                },
                                {
                                    "Text": "Floor tiler",
                                    "Value": "Floor tiler"
                                },
                                {
                                    "Text": "Conveyor operator",
                                    "Value": "Conveyor operator"
                                },
                                {
                                    "Text": "Concrete shutterer",
                                    "Value": "Concrete shutterer"
                                },
                                {
                                    "Text": "Air compressor operator",
                                    "Value": "Air compressor operator"
                                },
                                {
                                    "Text": "Container Clerk",
                                    "Value": "Container Clerk"
                                },
                                {
                                    "Text": "Consultant",
                                    "Value": "Consultant"
                                },
                                {
                                    "Text": "Plasterer",
                                    "Value": "Plasterer"
                                },
                                {
                                    "Text": "Ceiling fixer",
                                    "Value": "Ceiling fixer"
                                },
                                {
                                    "Text": "Contractor Food",
                                    "Value": "Contractor Food"
                                },
                                {
                                    "Text": "Cook",
                                    "Value": "Cook"
                                },
                                {
                                    "Text": "Consultant Project Execution",
                                    "Value": "Consultant Project Execution"
                                },
                                {
                                    "Text": "Commercial Coordinator",
                                    "Value": "Commercial Coordinator"
                                },
                                {
                                    "Text": "Computer Programmer",
                                    "Value": "Computer Programmer"
                                },
                                {
                                    "Text": "Country Manager SAARC",
                                    "Value": "Country Manager SAARC"
                                },
                                {
                                    "Text": "Consultant Software",
                                    "Value": "Consultant Software"
                                },
                                {
                                    "Text": "Composer",
                                    "Value": "Composer"
                                },
                                {
                                    "Text": "Commercial Clerk",
                                    "Value": "Commercial Clerk"
                                },
                                {
                                    "Text": "Correspondent",
                                    "Value": "Correspondent"
                                },
                                {
                                    "Text": "Consultant Import & Export",
                                    "Value": "Consultant Import & Export"
                                },
                                {
                                    "Text": "Construction Mistry",
                                    "Value": "Construction Mistry"
                                },
                                {
                                    "Text": "Counter Staff",
                                    "Value": "Counter Staff"
                                },
                                {
                                    "Text": "Site engineer",
                                    "Value": "Site engineer"
                                },
                                {
                                    "Text": "Conductor",
                                    "Value": "Conductor"
                                },
                                {
                                    "Text": "Consultant Faculty",
                                    "Value": "Consultant Faculty"
                                },
                                {
                                    "Text": "Courier boy",
                                    "Value": "Courier boy"
                                },
                                {
                                    "Text": "Courier",
                                    "Value": "Courier"
                                },
                                {
                                    "Text": "Dispatch clerk",
                                    "Value": "Dispatch clerk"
                                },
                                {
                                    "Text": "Course Workers",
                                    "Value": "Course Workers"
                                },
                                {
                                    "Text": "Collection Executive",
                                    "Value": "Collection Executive"
                                },
                                {
                                    "Text": "Coal Winder",
                                    "Value": "Coal Winder"
                                },
                                {
                                    "Text": "Content Writer",
                                    "Value": "Content Writer"
                                },
                                {
                                    "Text": "Consulting Engineer",
                                    "Value": "Consulting Engineer"
                                },
                                {
                                    "Text": "Consulting Manager",
                                    "Value": "Consulting Manager"
                                },
                                {
                                    "Text": "Consulting Surgeon",
                                    "Value": "Consulting Surgeon"
                                },
                                {
                                    "Text": "Consulting Technician",
                                    "Value": "Consulting Technician"
                                },
                                {
                                    "Text": "Consumer Support Engineer",
                                    "Value": "Consumer Support Engineer"
                                },
                                {
                                    "Text": "Corporate Marketing Manager",
                                    "Value": "Corporate Marketing Manager"
                                },
                                {
                                    "Text": "Corporate Strategist",
                                    "Value": "Corporate Strategist"
                                },
                                {
                                    "Text": "Corporate Trainer",
                                    "Value": "Corporate Trainer"
                                },
                                {
                                    "Text": "Consultant Vascular Surgeon",
                                    "Value": "Consultant Vascular Surgeon"
                                },
                                {
                                    "Text": "Computer Consultant",
                                    "Value": "Computer Consultant"
                                },
                                {
                                    "Text": "Collection Incharge Head",
                                    "Value": "Collection Incharge Head"
                                },
                                {
                                    "Text": "Collection Officer",
                                    "Value": "Collection Officer"
                                },
                                {
                                    "Text": "Collections Manager",
                                    "Value": "Collections Manager"
                                },
                                {
                                    "Text": "Colour Contractor",
                                    "Value": "Colour Contractor"
                                },
                                {
                                    "Text": "Commercial Agent",
                                    "Value": "Commercial Agent"
                                },
                                {
                                    "Text": "Commercial Head",
                                    "Value": "Commercial Head"
                                },
                                {
                                    "Text": "Commercial Manager",
                                    "Value": "Commercial Manager"
                                },
                                {
                                    "Text": "Commercial Officer",
                                    "Value": "Commercial Officer"
                                },
                                {
                                    "Text": "Commercial Tax Inspector",
                                    "Value": "Commercial Tax Inspector"
                                },
                                {
                                    "Text": "Commercial Tax Officer",
                                    "Value": "Commercial Tax Officer"
                                },
                                {
                                    "Text": "Commercial Teacher",
                                    "Value": "Commercial Teacher"
                                },
                                {
                                    "Text": "Commission Agent & Broker",
                                    "Value": "Commission Agent & Broker"
                                },
                                {
                                    "Text": "Commodities Officer",
                                    "Value": "Commodities Officer"
                                },
                                {
                                    "Text": "Company Administrator",
                                    "Value": "Company Administrator"
                                },
                                {
                                    "Text": "Computer Administrator",
                                    "Value": "Computer Administrator"
                                },
                                {
                                    "Text": "Consultant Business Developmnt",
                                    "Value": "Consultant Business Developmnt"
                                },
                                {
                                    "Text": "Consultant Physician",
                                    "Value": "Consultant Physician"
                                },
                                {
                                    "Text": "Consultant Radiologist",
                                    "Value": "Consultant Radiologist"
                                },
                                {
                                    "Text": "Consultant Resource Management",
                                    "Value": "Consultant Resource Management"
                                },
                                {
                                    "Text": "Consultant Software Engineer",
                                    "Value": "Consultant Software Engineer"
                                },
                                {
                                    "Text": "Consultant Haematologist",
                                    "Value": "Consultant Haematologist"
                                },
                                {
                                    "Text": "Car Park Attendant",
                                    "Value": "Car Park Attendant"
                                },
                                {
                                    "Text": "CPA Manager",
                                    "Value": "CPA Manager"
                                },
                                {
                                    "Text": "CPA Coordinator",
                                    "Value": "CPA Coordinator"
                                },
                                {
                                    "Text": "Copywriter",
                                    "Value": "Copywriter"
                                },
                                {
                                    "Text": "Creative Maximizer",
                                    "Value": "Creative Maximizer"
                                },
                                {
                                    "Text": "Credit Controller",
                                    "Value": "Credit Controller"
                                },
                                {
                                    "Text": "Creative Head",
                                    "Value": "Creative Head"
                                },
                                {
                                    "Text": "Credit Analyst",
                                    "Value": "Credit Analyst"
                                },
                                {
                                    "Text": "Cricket Coach",
                                    "Value": "Cricket Coach"
                                },
                                {
                                    "Text": "Crop Duster",
                                    "Value": "Crop Duster"
                                },
                                {
                                    "Text": "Credit Relationship Manager",
                                    "Value": "Credit Relationship Manager"
                                },
                                {
                                    "Text": "Counter Crew",
                                    "Value": "Counter Crew"
                                },
                                {
                                    "Text": "Critic",
                                    "Value": "Critic"
                                },
                                {
                                    "Text": "Crane Manufacturer",
                                    "Value": "Crane Manufacturer"
                                },
                                {
                                    "Text": "Craft Assistant",
                                    "Value": "Craft Assistant"
                                },
                                {
                                    "Text": "Crime Investigator",
                                    "Value": "Crime Investigator"
                                },
                                {
                                    "Text": "Crane slinger",
                                    "Value": "Crane slinger"
                                },
                                {
                                    "Text": "Credit Executive",
                                    "Value": "Credit Executive"
                                },
                                {
                                    "Text": "kircus Worker",
                                    "Value": "kircus Worker"
                                },
                                {
                                    "Text": "Credit Manager",
                                    "Value": "Credit Manager"
                                },
                                {
                                    "Text": "Cost Assistant",
                                    "Value": "Cost Assistant"
                                },
                                {
                                    "Text": "Civil Servant",
                                    "Value": "Civil Servant"
                                },
                                {
                                    "Text": "Customer Support Incharge",
                                    "Value": "Customer Support Incharge"
                                },
                                {
                                    "Text": "Corporate Sales Manager Broka",
                                    "Value": "Corporate Sales Manager Broka"
                                },
                                {
                                    "Text": "Head Constable",
                                    "Value": "Head Constable"
                                },
                                {
                                    "Text": "Cement Shop Wholeseller",
                                    "Value": "Cement Shop Wholeseller"
                                },
                                {
                                    "Text": "Control Panel Fitter",
                                    "Value": "Control Panel Fitter"
                                },
                                {
                                    "Text": "Cultivation Farmer",
                                    "Value": "Cultivation Farmer"
                                },
                                {
                                    "Text": "Cultivator",
                                    "Value": "Cultivator"
                                },
                                {
                                    "Text": "Customer Associate",
                                    "Value": "Customer Associate"
                                },
                                {
                                    "Text": "Customer Care Head",
                                    "Value": "Customer Care Head"
                                },
                                {
                                    "Text": "Customer Care Executive",
                                    "Value": "Customer Care Executive"
                                },
                                {
                                    "Text": "Customer Care Officer",
                                    "Value": "Customer Care Officer"
                                },
                                {
                                    "Text": "Customer Care Representative",
                                    "Value": "Customer Care Representative"
                                },
                                {
                                    "Text": "Customer Care Specialist",
                                    "Value": "Customer Care Specialist"
                                },
                                {
                                    "Text": "Customer Relation Executive",
                                    "Value": "Customer Relation Executive"
                                },
                                {
                                    "Text": "Customer Relation Manager",
                                    "Value": "Customer Relation Manager"
                                },
                                {
                                    "Text": "Customer Service Professional",
                                    "Value": "Customer Service Professional"
                                },
                                {
                                    "Text": "Customer Relationship Officer",
                                    "Value": "Customer Relationship Officer"
                                },
                                {
                                    "Text": "Customer Relationshp Executive",
                                    "Value": "Customer Relationshp Executive"
                                },
                                {
                                    "Text": "Customer Service Agent",
                                    "Value": "Customer Service Agent"
                                },
                                {
                                    "Text": "Customer Service Engineer",
                                    "Value": "Customer Service Engineer"
                                },
                                {
                                    "Text": "Customer Service Representatve",
                                    "Value": "Customer Service Representatve"
                                },
                                {
                                    "Text": "Customer Service Supervisor",
                                    "Value": "Customer Service Supervisor"
                                },
                                {
                                    "Text": "Customer Support Engineer",
                                    "Value": "Customer Support Engineer"
                                },
                                {
                                    "Text": "Customer Support Executive",
                                    "Value": "Customer Support Executive"
                                },
                                {
                                    "Text": "Customer Support Officer",
                                    "Value": "Customer Support Officer"
                                },
                                {
                                    "Text": "Customr Care Serv Represntatve",
                                    "Value": "Customr Care Serv Represntatve"
                                },
                                {
                                    "Text": "Customs Inspector",
                                    "Value": "Customs Inspector"
                                },
                                {
                                    "Text": "Customer Care Back Office",
                                    "Value": "Customer Care Back Office"
                                },
                                {
                                    "Text": "CUE1otine Operator",
                                    "Value": "CUE1otine Operator"
                                },
                                {
                                    "Text": "Customer Support Personnel",
                                    "Value": "Customer Support Personnel"
                                },
                                {
                                    "Text": "Customer Accounts Manager",
                                    "Value": "Customer Accounts Manager"
                                },
                                {
                                    "Text": "Cullotine Operator",
                                    "Value": "Cullotine Operator"
                                },
                                {
                                    "Text": "Cutting Machine Operator",
                                    "Value": "Cutting Machine Operator"
                                },
                                {
                                    "Text": "Customer Care Assistant",
                                    "Value": "Customer Care Assistant"
                                },
                                {
                                    "Text": "Custom Development Coordinator",
                                    "Value": "Custom Development Coordinator"
                                },
                                {
                                    "Text": "Customer service associate",
                                    "Value": "Customer service associate"
                                },
                                {
                                    "Text": "Cutter",
                                    "Value": "Cutter"
                                },
                                {
                                    "Text": "Customer Care Associate",
                                    "Value": "Customer Care Associate"
                                },
                                {
                                    "Text": "Customer Relation Officer",
                                    "Value": "Customer Relation Officer"
                                },
                                {
                                    "Text": "Conveyancing Search Clerk",
                                    "Value": "Conveyancing Search Clerk"
                                },
                                {
                                    "Text": "Car Washer",
                                    "Value": "Car Washer"
                                },
                                {
                                    "Text": "Data Centre Officer",
                                    "Value": "Data Centre Officer"
                                },
                                {
                                    "Text": "Data Entry & Support Operator",
                                    "Value": "Data Entry & Support Operator"
                                },
                                {
                                    "Text": "Daftari",
                                    "Value": "Daftari"
                                },
                                {
                                    "Text": "Dairy",
                                    "Value": "Dairy"
                                },
                                {
                                    "Text": "Data Analyst",
                                    "Value": "Data Analyst"
                                },
                                {
                                    "Text": "Debt Collector",
                                    "Value": "Debt Collector"
                                },
                                {
                                    "Text": "Derrick crane driver",
                                    "Value": "Derrick crane driver"
                                },
                                {
                                    "Text": "Dealer Equity & Fin Consultant",
                                    "Value": "Dealer Equity & Fin Consultant"
                                },
                                {
                                    "Text": "Dean Reader",
                                    "Value": "Dean Reader"
                                },
                                {
                                    "Text": "Deed Writer",
                                    "Value": "Deed Writer"
                                },
                                {
                                    "Text": "Design Engineer R&D",
                                    "Value": "Design Engineer R&D"
                                },
                                {
                                    "Text": "Dental Hygienist",
                                    "Value": "Dental Hygienist"
                                },
                                {
                                    "Text": "Dental Surgeon",
                                    "Value": "Dental Surgeon"
                                },
                                {
                                    "Text": "Dentist & Assistant Professor",
                                    "Value": "Dentist & Assistant Professor"
                                },
                                {
                                    "Text": "Depot Manager",
                                    "Value": "Depot Manager"
                                },
                                {
                                    "Text": "Deputy Area Manager",
                                    "Value": "Deputy Area Manager"
                                },
                                {
                                    "Text": "Deputy Charge Engineer",
                                    "Value": "Deputy Charge Engineer"
                                },
                                {
                                    "Text": "Deputy General Mgr Commercial",
                                    "Value": "Deputy General Mgr Commercial"
                                },
                                {
                                    "Text": "Deputy Commercial Tax Officer",
                                    "Value": "Deputy Commercial Tax Officer"
                                },
                                {
                                    "Text": "Dental Technician",
                                    "Value": "Dental Technician"
                                },
                                {
                                    "Text": "Deputy Director Of Account",
                                    "Value": "Deputy Director Of Account"
                                },
                                {
                                    "Text": "Deputy Director Of Industries",
                                    "Value": "Deputy Director Of Industries"
                                },
                                {
                                    "Text": "Deputy Editor",
                                    "Value": "Deputy Editor"
                                },
                                {
                                    "Text": "Deputy Registrar",
                                    "Value": "Deputy Registrar"
                                },
                                {
                                    "Text": "Associate Vice President",
                                    "Value": "Associate Vice President"
                                },
                                {
                                    "Text": "Deputy Engineering Manager",
                                    "Value": "Deputy Engineering Manager"
                                },
                                {
                                    "Text": "Deputy Environmental Engineer",
                                    "Value": "Deputy Environmental Engineer"
                                },
                                {
                                    "Text": "Deputy Excise Collector",
                                    "Value": "Deputy Excise Collector"
                                },
                                {
                                    "Text": "Deputy Executive",
                                    "Value": "Deputy Executive"
                                },
                                {
                                    "Text": "Deputy Executive Engineer",
                                    "Value": "Deputy Executive Engineer"
                                },
                                {
                                    "Text": "Deputy Field Officer",
                                    "Value": "Deputy Field Officer"
                                },
                                {
                                    "Text": "Deputy Finance Manager",
                                    "Value": "Deputy Finance Manager"
                                },
                                {
                                    "Text": "Deputy Head Of Operation",
                                    "Value": "Deputy Head Of Operation"
                                },
                                {
                                    "Text": "Deputy Manager Accounts",
                                    "Value": "Deputy Manager Accounts"
                                },
                                {
                                    "Text": "Deputy Manager Administration",
                                    "Value": "Deputy Manager Administration"
                                },
                                {
                                    "Text": "Deputy Manager Commercial",
                                    "Value": "Deputy Manager Commercial"
                                },
                                {
                                    "Text": "Deputy Manager Credit",
                                    "Value": "Deputy Manager Credit"
                                },
                                {
                                    "Text": "Deputy Manager Engineering",
                                    "Value": "Deputy Manager Engineering"
                                },
                                {
                                    "Text": "Deputy Manager Marketing",
                                    "Value": "Deputy Manager Marketing"
                                },
                                {
                                    "Text": "Deputy Manager Planning",
                                    "Value": "Deputy Manager Planning"
                                },
                                {
                                    "Text": "Deputy Manager Production",
                                    "Value": "Deputy Manager Production"
                                },
                                {
                                    "Text": "Deputy Manager Sales",
                                    "Value": "Deputy Manager Sales"
                                },
                                {
                                    "Text": "Deputy Manager Services",
                                    "Value": "Deputy Manager Services"
                                },
                                {
                                    "Text": "Deputy Managing Director",
                                    "Value": "Deputy Managing Director"
                                },
                                {
                                    "Text": "Deputy Mgr Project Commercial",
                                    "Value": "Deputy Mgr Project Commercial"
                                },
                                {
                                    "Text": "Deputy Mgr Quality Assurance",
                                    "Value": "Deputy Mgr Quality Assurance"
                                },
                                {
                                    "Text": "Deputy Officer",
                                    "Value": "Deputy Officer"
                                },
                                {
                                    "Text": "Deputy Physical Instructor",
                                    "Value": "Deputy Physical Instructor"
                                },
                                {
                                    "Text": "Deputy Project Manager",
                                    "Value": "Deputy Project Manager"
                                },
                                {
                                    "Text": "Deputy Regional Manager",
                                    "Value": "Deputy Regional Manager"
                                },
                                {
                                    "Text": "Deputy Sales Manager",
                                    "Value": "Deputy Sales Manager"
                                },
                                {
                                    "Text": "Deputy Station Superintendent",
                                    "Value": "Deputy Station Superintendent"
                                },
                                {
                                    "Text": "Deputy Superintendent Engineer",
                                    "Value": "Deputy Superintendent Engineer"
                                },
                                {
                                    "Text": "Deputy Supervisor",
                                    "Value": "Deputy Supervisor"
                                },
                                {
                                    "Text": "Derma Sales Officer",
                                    "Value": "Derma Sales Officer"
                                },
                                {
                                    "Text": "Design Engineering Manager",
                                    "Value": "Design Engineering Manager"
                                },
                                {
                                    "Text": "Design Lead",
                                    "Value": "Design Lead"
                                },
                                {
                                    "Text": "Design Supervisor",
                                    "Value": "Design Supervisor"
                                },
                                {
                                    "Text": "Designer & Carpenter",
                                    "Value": "Designer & Carpenter"
                                },
                                {
                                    "Text": "Designer & Diamond Polisher",
                                    "Value": "Designer & Diamond Polisher"
                                },
                                {
                                    "Text": "Designer Engineer",
                                    "Value": "Designer Engineer"
                                },
                                {
                                    "Text": "Data Entry Clerk",
                                    "Value": "Data Entry Clerk"
                                },
                                {
                                    "Text": "Developer & Builder",
                                    "Value": "Developer & Builder"
                                },
                                {
                                    "Text": "Development Engineer",
                                    "Value": "Development Engineer"
                                },
                                {
                                    "Text": "Development Officer",
                                    "Value": "Development Officer"
                                },
                                {
                                    "Text": "Development Technologist",
                                    "Value": "Development Technologist"
                                },
                                {
                                    "Text": "Develpoment Officer",
                                    "Value": "Develpoment Officer"
                                },
                                {
                                    "Text": "Depot Manager Retired",
                                    "Value": "Depot Manager Retired"
                                },
                                {
                                    "Text": "Deputy General Mgr Personnel",
                                    "Value": "Deputy General Mgr Personnel"
                                },
                                {
                                    "Text": "Design Engineer",
                                    "Value": "Design Engineer"
                                },
                                {
                                    "Text": "Deputy Manager",
                                    "Value": "Deputy Manager"
                                },
                                {
                                    "Text": "Dean Faculty Managemnt Studies",
                                    "Value": "Dean Faculty Managemnt Studies"
                                },
                                {
                                    "Text": "Design Incharge",
                                    "Value": "Design Incharge"
                                },
                                {
                                    "Text": "Deputy Chief Electrical Engg",
                                    "Value": "Deputy Chief Electrical Engg"
                                },
                                {
                                    "Text": "Deputy general manager",
                                    "Value": "Deputy general manager"
                                },
                                {
                                    "Text": "Dental Mechanic",
                                    "Value": "Dental Mechanic"
                                },
                                {
                                    "Text": "Development Officer Admin",
                                    "Value": "Development Officer Admin"
                                },
                                {
                                    "Text": "Deputy Director IT",
                                    "Value": "Deputy Director IT"
                                },
                                {
                                    "Text": "Deck hand",
                                    "Value": "Deck hand"
                                },
                                {
                                    "Text": "Designer Gold",
                                    "Value": "Designer Gold"
                                },
                                {
                                    "Text": "Deliveryman",
                                    "Value": "Deliveryman"
                                },
                                {
                                    "Text": "Delivery Head",
                                    "Value": "Delivery Head"
                                },
                                {
                                    "Text": "Department Incharge Designing",
                                    "Value": "Department Incharge Designing"
                                },
                                {
                                    "Text": "Dental Surgeons",
                                    "Value": "Dental Surgeons"
                                },
                                {
                                    "Text": "Deputy Chief Engg Construction",
                                    "Value": "Deputy Chief Engg Construction"
                                },
                                {
                                    "Text": "Deputy Collector",
                                    "Value": "Deputy Collector"
                                },
                                {
                                    "Text": "Dealer In Stock & Share",
                                    "Value": "Dealer In Stock & Share"
                                },
                                {
                                    "Text": "Despatch Riders",
                                    "Value": "Despatch Riders"
                                },
                                {
                                    "Text": "Designist",
                                    "Value": "Designist"
                                },
                                {
                                    "Text": "Deputy Director Health",
                                    "Value": "Deputy Director Health"
                                },
                                {
                                    "Text": "Deputy Commisioner Administrtn",
                                    "Value": "Deputy Commisioner Administrtn"
                                },
                                {
                                    "Text": "Detonator Filler",
                                    "Value": "Detonator Filler"
                                },
                                {
                                    "Text": "Developer Trainee",
                                    "Value": "Developer Trainee"
                                },
                                {
                                    "Text": "Dental Doctor",
                                    "Value": "Dental Doctor"
                                },
                                {
                                    "Text": "Deputy Chief Engineer",
                                    "Value": "Deputy Chief Engineer"
                                },
                                {
                                    "Text": "Deputy Director",
                                    "Value": "Deputy Director"
                                },
                                {
                                    "Text": "Deputy Engineer Retired",
                                    "Value": "Deputy Engineer Retired"
                                },
                                {
                                    "Text": "Design Manager",
                                    "Value": "Design Manager"
                                },
                                {
                                    "Text": "Desktop Engineer",
                                    "Value": "Desktop Engineer"
                                },
                                {
                                    "Text": "Development Analyst",
                                    "Value": "Development Analyst"
                                },
                                {
                                    "Text": "Development Specialist",
                                    "Value": "Development Specialist"
                                },
                                {
                                    "Text": "DGM taxation",
                                    "Value": "DGM taxation"
                                },
                                {
                                    "Text": "DGM Material",
                                    "Value": "DGM Material"
                                },
                                {
                                    "Text": "DGM",
                                    "Value": "DGM"
                                },
                                {
                                    "Text": "DGM Marketing",
                                    "Value": "DGM Marketing"
                                },
                                {
                                    "Text": "DGM Finance & Administration",
                                    "Value": "DGM Finance & Administration"
                                },
                                {
                                    "Text": "DGM Foundry",
                                    "Value": "DGM Foundry"
                                },
                                {
                                    "Text": "Dhobi",
                                    "Value": "Dhobi"
                                },
                                {
                                    "Text": "Truck Driver",
                                    "Value": "Truck Driver"
                                },
                                {
                                    "Text": "Lorry attendant",
                                    "Value": "Lorry attendant"
                                },
                                {
                                    "Text": "Lorry driver",
                                    "Value": "Lorry driver"
                                },
                                {
                                    "Text": "Heavy goods vehicle driver",
                                    "Value": "Heavy goods vehicle driver"
                                },
                                {
                                    "Text": "HCV driver",
                                    "Value": "HCV driver"
                                },
                                {
                                    "Text": "Trailer Driver",
                                    "Value": "Trailer Driver"
                                },
                                {
                                    "Text": "Coal Delivery Vehicle Driver",
                                    "Value": "Coal Delivery Vehicle Driver"
                                },
                                {
                                    "Text": "Dishwasher",
                                    "Value": "Dishwasher"
                                },
                                {
                                    "Text": "Diamond Agent",
                                    "Value": "Diamond Agent"
                                },
                                {
                                    "Text": "Diamond Cutter",
                                    "Value": "Diamond Cutter"
                                },
                                {
                                    "Text": "Diamond Director",
                                    "Value": "Diamond Director"
                                },
                                {
                                    "Text": "Divisional Head",
                                    "Value": "Divisional Head"
                                },
                                {
                                    "Text": "Diamond Merchant & Proprietor",
                                    "Value": "Diamond Merchant & Proprietor"
                                },
                                {
                                    "Text": "Diploma Trainee Engineer",
                                    "Value": "Diploma Trainee Engineer"
                                },
                                {
                                    "Text": "Director & Chief Executive",
                                    "Value": "Director & Chief Executive"
                                },
                                {
                                    "Text": "Director & Financial Consultnt",
                                    "Value": "Director & Financial Consultnt"
                                },
                                {
                                    "Text": "Director Commercial",
                                    "Value": "Director Commercial"
                                },
                                {
                                    "Text": "Director & Owner",
                                    "Value": "Director & Owner"
                                },
                                {
                                    "Text": "Dialysis Technician",
                                    "Value": "Dialysis Technician"
                                },
                                {
                                    "Text": "Director Cum Business Partner",
                                    "Value": "Director Cum Business Partner"
                                },
                                {
                                    "Text": "Director Food Production",
                                    "Value": "Director Food Production"
                                },
                                {
                                    "Text": "Director Legal",
                                    "Value": "Director Legal"
                                },
                                {
                                    "Text": "Director Of Marketing",
                                    "Value": "Director Of Marketing"
                                },
                                {
                                    "Text": "Director Performance Devlopmnt",
                                    "Value": "Director Performance Devlopmnt"
                                },
                                {
                                    "Text": "Director Physical Education",
                                    "Value": "Director Physical Education"
                                },
                                {
                                    "Text": "Director Postal Services",
                                    "Value": "Director Postal Services"
                                },
                                {
                                    "Text": "Director Principal",
                                    "Value": "Director Principal"
                                },
                                {
                                    "Text": "Director Project Management",
                                    "Value": "Director Project Management"
                                },
                                {
                                    "Text": "Director Sales",
                                    "Value": "Director Sales"
                                },
                                {
                                    "Text": "Director Sales & Marketing",
                                    "Value": "Director Sales & Marketing"
                                },
                                {
                                    "Text": "Dispatch Operator",
                                    "Value": "Dispatch Operator"
                                },
                                {
                                    "Text": "Distillery Manager",
                                    "Value": "Distillery Manager"
                                },
                                {
                                    "Text": "Distribution Agent",
                                    "Value": "Distribution Agent"
                                },
                                {
                                    "Text": "Distribution Management Exec.",
                                    "Value": "Distribution Management Exec."
                                },
                                {
                                    "Text": "Distribution Manager",
                                    "Value": "Distribution Manager"
                                },
                                {
                                    "Text": "Distribution Officer",
                                    "Value": "Distribution Officer"
                                },
                                {
                                    "Text": "Distribution Representative",
                                    "Value": "Distribution Representative"
                                },
                                {
                                    "Text": "Distributor Support Executive",
                                    "Value": "Distributor Support Executive"
                                },
                                {
                                    "Text": "District Admin Officer",
                                    "Value": "District Admin Officer"
                                },
                                {
                                    "Text": "District Business Manager",
                                    "Value": "District Business Manager"
                                },
                                {
                                    "Text": "District Commercial Incharge",
                                    "Value": "District Commercial Incharge"
                                },
                                {
                                    "Text": "District Commissioner",
                                    "Value": "District Commissioner"
                                },
                                {
                                    "Text": "District Development Officer",
                                    "Value": "District Development Officer"
                                },
                                {
                                    "Text": "District Enforcement Officer",
                                    "Value": "District Enforcement Officer"
                                },
                                {
                                    "Text": "District Homeo Medical Officer",
                                    "Value": "District Homeo Medical Officer"
                                },
                                {
                                    "Text": "District Leprosy Officer",
                                    "Value": "District Leprosy Officer"
                                },
                                {
                                    "Text": "District Manager",
                                    "Value": "District Manager"
                                },
                                {
                                    "Text": "District Programme Manager",
                                    "Value": "District Programme Manager"
                                },
                                {
                                    "Text": "District Programme Officer",
                                    "Value": "District Programme Officer"
                                },
                                {
                                    "Text": "District Sainik Welfare Officr",
                                    "Value": "District Sainik Welfare Officr"
                                },
                                {
                                    "Text": "District Sales Officer",
                                    "Value": "District Sales Officer"
                                },
                                {
                                    "Text": "District Social Welfare Officr",
                                    "Value": "District Social Welfare Officr"
                                },
                                {
                                    "Text": "District Statistics Officer",
                                    "Value": "District Statistics Officer"
                                },
                                {
                                    "Text": "District Transfer Officer",
                                    "Value": "District Transfer Officer"
                                },
                                {
                                    "Text": "Divisional Accountant",
                                    "Value": "Divisional Accountant"
                                },
                                {
                                    "Text": "Divisional Engineer",
                                    "Value": "Divisional Engineer"
                                },
                                {
                                    "Text": "Divisional Executive",
                                    "Value": "Divisional Executive"
                                },
                                {
                                    "Text": "Divisional Forest Officer",
                                    "Value": "Divisional Forest Officer"
                                },
                                {
                                    "Text": "Divisional General Manager",
                                    "Value": "Divisional General Manager"
                                },
                                {
                                    "Text": "Divisional Manager",
                                    "Value": "Divisional Manager"
                                },
                                {
                                    "Text": "Divisional Sales Executive",
                                    "Value": "Divisional Sales Executive"
                                },
                                {
                                    "Text": "Digital Subscriber Lines Offcr",
                                    "Value": "Digital Subscriber Lines Offcr"
                                },
                                {
                                    "Text": "Director Academics",
                                    "Value": "Director Academics"
                                },
                                {
                                    "Text": "Diamond Desiner",
                                    "Value": "Diamond Desiner"
                                },
                                {
                                    "Text": "Die-Cutting Machine Operator",
                                    "Value": "Die-Cutting Machine Operator"
                                },
                                {
                                    "Text": "Dispatch Manager",
                                    "Value": "Dispatch Manager"
                                },
                                {
                                    "Text": "Director Health Services",
                                    "Value": "Director Health Services"
                                },
                                {
                                    "Text": "Dietician",
                                    "Value": "Dietician"
                                },
                                {
                                    "Text": "Displace Incharge",
                                    "Value": "Displace Incharge"
                                },
                                {
                                    "Text": "Director HR",
                                    "Value": "Director HR"
                                },
                                {
                                    "Text": "Director Commercial Audit",
                                    "Value": "Director Commercial Audit"
                                },
                                {
                                    "Text": "Diamond Labour",
                                    "Value": "Diamond Labour"
                                },
                                {
                                    "Text": "Diamond Maker",
                                    "Value": "Diamond Maker"
                                },
                                {
                                    "Text": "Diamond Manufacturer",
                                    "Value": "Diamond Manufacturer"
                                },
                                {
                                    "Text": "Director Engineering",
                                    "Value": "Director Engineering"
                                },
                                {
                                    "Text": "Director Customs Control",
                                    "Value": "Director Customs Control"
                                },
                                {
                                    "Text": "Director & Physical Education",
                                    "Value": "Director & Physical Education"
                                },
                                {
                                    "Text": "Dish Operator",
                                    "Value": "Dish Operator"
                                },
                                {
                                    "Text": "Director",
                                    "Value": "Director"
                                },
                                {
                                    "Text": "Diamond Asorter",
                                    "Value": "Diamond Asorter"
                                },
                                {
                                    "Text": "Director Projects",
                                    "Value": "Director Projects"
                                },
                                {
                                    "Text": "Distributor & Boutique",
                                    "Value": "Distributor & Boutique"
                                },
                                {
                                    "Text": "Diver (Commercial/Military)",
                                    "Value": "Diver (Commercial/Military)"
                                },
                                {
                                    "Text": "Divisional Officer",
                                    "Value": "Divisional Officer"
                                },
                                {
                                    "Text": "Diamond Worker",
                                    "Value": "Diamond Worker"
                                },
                                {
                                    "Text": "Diamond Merchant",
                                    "Value": "Diamond Merchant"
                                },
                                {
                                    "Text": "Director & Managing Partner",
                                    "Value": "Director & Managing Partner"
                                },
                                {
                                    "Text": "Director & Partner",
                                    "Value": "Director & Partner"
                                },
                                {
                                    "Text": "Dry Leaves Merchant",
                                    "Value": "Dry Leaves Merchant"
                                },
                                {
                                    "Text": "DM Sales",
                                    "Value": "DM Sales"
                                },
                                {
                                    "Text": "Dancer",
                                    "Value": "Dancer"
                                },
                                {
                                    "Text": "Dentist",
                                    "Value": "Dentist"
                                },
                                {
                                    "Text": "Doctor & Consultant",
                                    "Value": "Doctor & Consultant"
                                },
                                {
                                    "Text": "Doctor & Lecturer",
                                    "Value": "Doctor & Lecturer"
                                },
                                {
                                    "Text": "Doctor & Medical Officer",
                                    "Value": "Doctor & Medical Officer"
                                },
                                {
                                    "Text": "Doctor & Proprietor",
                                    "Value": "Doctor & Proprietor"
                                },
                                {
                                    "Text": "Doctor & Radiologist",
                                    "Value": "Doctor & Radiologist"
                                },
                                {
                                    "Text": "Doctor Assistant",
                                    "Value": "Doctor Assistant"
                                },
                                {
                                    "Text": "Doctor Civil Assistant Surgeon",
                                    "Value": "Doctor Civil Assistant Surgeon"
                                },
                                {
                                    "Text": "Doctor Civil Surgeon Specialst",
                                    "Value": "Doctor Civil Surgeon Specialst"
                                },
                                {
                                    "Text": "Doctor Consultant",
                                    "Value": "Doctor Consultant"
                                },
                                {
                                    "Text": "Doctor Dentist",
                                    "Value": "Doctor Dentist"
                                },
                                {
                                    "Text": "Doctor Professional",
                                    "Value": "Doctor Professional"
                                },
                                {
                                    "Text": "Doctor General Surgeon",
                                    "Value": "Doctor General Surgeon"
                                },
                                {
                                    "Text": "Doctor Physician",
                                    "Value": "Doctor Physician"
                                },
                                {
                                    "Text": "Doctor Lecturer",
                                    "Value": "Doctor Lecturer"
                                },
                                {
                                    "Text": "Doctor Medical Officer",
                                    "Value": "Doctor Medical Officer"
                                },
                                {
                                    "Text": "Doctor MS",
                                    "Value": "Doctor MS"
                                },
                                {
                                    "Text": "Doctor Neurologist",
                                    "Value": "Doctor Neurologist"
                                },
                                {
                                    "Text": "Doctor Neurosurgeon",
                                    "Value": "Doctor Neurosurgeon"
                                },
                                {
                                    "Text": "Doctor Nutrition",
                                    "Value": "Doctor Nutrition"
                                },
                                {
                                    "Text": "Doctor Practicing Ayur Medicne",
                                    "Value": "Doctor Practicing Ayur Medicne"
                                },
                                {
                                    "Text": "Doctor Sonologist",
                                    "Value": "Doctor Sonologist"
                                },
                                {
                                    "Text": "Doctor Specialist",
                                    "Value": "Doctor Specialist"
                                },
                                {
                                    "Text": "Doctor Surgeon",
                                    "Value": "Doctor Surgeon"
                                },
                                {
                                    "Text": "Document Writer",
                                    "Value": "Document Writer"
                                },
                                {
                                    "Text": "Documentation Officer",
                                    "Value": "Documentation Officer"
                                },
                                {
                                    "Text": "Doctor",
                                    "Value": "Doctor"
                                },
                                {
                                    "Text": "Doctor Self Employed",
                                    "Value": "Doctor Self Employed"
                                },
                                {
                                    "Text": "Documentation Personnel",
                                    "Value": "Documentation Personnel"
                                },
                                {
                                    "Text": "Document Controller",
                                    "Value": "Document Controller"
                                },
                                {
                                    "Text": "Doctor Ophthalmology",
                                    "Value": "Doctor Ophthalmology"
                                },
                                {
                                    "Text": "Doctor Of Naturopathy",
                                    "Value": "Doctor Of Naturopathy"
                                },
                                {
                                    "Text": "Doctor Ayurvedic",
                                    "Value": "Doctor Ayurvedic"
                                },
                                {
                                    "Text": "Domestic Servant",
                                    "Value": "Domestic Servant"
                                },
                                {
                                    "Text": "Doctor Of Medicine",
                                    "Value": "Doctor Of Medicine"
                                },
                                {
                                    "Text": "Doctor Professionl Practitionr",
                                    "Value": "Doctor Professionl Practitionr"
                                },
                                {
                                    "Text": "Documentation Assistant",
                                    "Value": "Documentation Assistant"
                                },
                                {
                                    "Text": "Doctor & Assistant Surgeon",
                                    "Value": "Doctor & Assistant Surgeon"
                                },
                                {
                                    "Text": "Doorman",
                                    "Value": "Doorman"
                                },
                                {
                                    "Text": "Domain Expert",
                                    "Value": "Domain Expert"
                                },
                                {
                                    "Text": "Documents Supervisor",
                                    "Value": "Documents Supervisor"
                                },
                                {
                                    "Text": "Door Usher",
                                    "Value": "Door Usher"
                                },
                                {
                                    "Text": "Documentation Executive",
                                    "Value": "Documentation Executive"
                                },
                                {
                                    "Text": "Doctor Eye Specialist",
                                    "Value": "Doctor Eye Specialist"
                                },
                                {
                                    "Text": "Doctor Gynaecologist",
                                    "Value": "Doctor Gynaecologist"
                                },
                                {
                                    "Text": "Dispenser",
                                    "Value": "Dispenser"
                                },
                                {
                                    "Text": "Cycle rickshaw driver",
                                    "Value": "Cycle rickshaw driver"
                                },
                                {
                                    "Text": "Tram Driver",
                                    "Value": "Tram Driver"
                                },
                                {
                                    "Text": "Bus conductor",
                                    "Value": "Bus conductor"
                                },
                                {
                                    "Text": "Driving instructor",
                                    "Value": "Driving instructor"
                                },
                                {
                                    "Text": "Draftperson",
                                    "Value": "Draftperson"
                                },
                                {
                                    "Text": "Draughtmen",
                                    "Value": "Draughtmen"
                                },
                                {
                                    "Text": "Drug Control Officer",
                                    "Value": "Drug Control Officer"
                                },
                                {
                                    "Text": "Dressmakers",
                                    "Value": "Dressmakers"
                                },
                                {
                                    "Text": "Driver",
                                    "Value": "Driver"
                                },
                                {
                                    "Text": "Light goods vehicle driver",
                                    "Value": "Light goods vehicle driver"
                                },
                                {
                                    "Text": "Light vehicle driver",
                                    "Value": "Light vehicle driver"
                                },
                                {
                                    "Text": "Van driver",
                                    "Value": "Van driver"
                                },
                                {
                                    "Text": "Bus driver",
                                    "Value": "Bus driver"
                                },
                                {
                                    "Text": "Mini truck driver",
                                    "Value": "Mini truck driver"
                                },
                                {
                                    "Text": "Mini matador",
                                    "Value": "Mini matador"
                                },
                                {
                                    "Text": "Matador",
                                    "Value": "Matador"
                                },
                                {
                                    "Text": "Commercial vehicle driver",
                                    "Value": "Commercial vehicle driver"
                                },
                                {
                                    "Text": "Helper",
                                    "Value": "Helper"
                                },
                                {
                                    "Text": "Tempo Driver",
                                    "Value": "Tempo Driver"
                                },
                                {
                                    "Text": "Mini Tempo Driver",
                                    "Value": "Mini Tempo Driver"
                                },
                                {
                                    "Text": "Auto rickshaw driver",
                                    "Value": "Auto rickshaw driver"
                                },
                                {
                                    "Text": "Cab driver",
                                    "Value": "Cab driver"
                                },
                                {
                                    "Text": "Tourist Taxi driver",
                                    "Value": "Tourist Taxi driver"
                                },
                                {
                                    "Text": "Dry Cleaners",
                                    "Value": "Dry Cleaners"
                                },
                                {
                                    "Text": "Distributor",
                                    "Value": "Distributor"
                                },
                                {
                                    "Text": "Designer",
                                    "Value": "Designer"
                                },
                                {
                                    "Text": "DTP Operator",
                                    "Value": "DTP Operator"
                                },
                                {
                                    "Text": "Duty Doctor",
                                    "Value": "Duty Doctor"
                                },
                                {
                                    "Text": "Duty Manager",
                                    "Value": "Duty Manager"
                                },
                                {
                                    "Text": "Duty Medical Officer",
                                    "Value": "Duty Medical Officer"
                                },
                                {
                                    "Text": "Daily Wage Earner",
                                    "Value": "Daily Wage Earner"
                                },
                                {
                                    "Text": "Daily Wage Earner (Agriculture",
                                    "Value": "Daily Wage Earner (Agriculture"
                                },
                                {
                                    "Text": "Drinks Waitstaff",
                                    "Value": "Drinks Waitstaff"
                                },
                                {
                                    "Text": "Dy. Chief Accounts Officer",
                                    "Value": "Dy. Chief Accounts Officer"
                                },
                                {
                                    "Text": "Dy. Chief Engineer",
                                    "Value": "Dy. Chief Engineer"
                                },
                                {
                                    "Text": "Dy. Engineer",
                                    "Value": "Dy. Engineer"
                                },
                                {
                                    "Text": "Dy. Executive Engineer",
                                    "Value": "Dy. Executive Engineer"
                                },
                                {
                                    "Text": "Dy. Finance Manager",
                                    "Value": "Dy. Finance Manager"
                                },
                                {
                                    "Text": "Dy. Financial Advisor",
                                    "Value": "Dy. Financial Advisor"
                                },
                                {
                                    "Text": "Dy. Manager",
                                    "Value": "Dy. Manager"
                                },
                                {
                                    "Text": "Dy. Manager Customer",
                                    "Value": "Dy. Manager Customer"
                                },
                                {
                                    "Text": "Dy. Manager Customer Relation",
                                    "Value": "Dy. Manager Customer Relation"
                                },
                                {
                                    "Text": "Dy. Manager Designer",
                                    "Value": "Dy. Manager Designer"
                                },
                                {
                                    "Text": "Dy. Manager Secretarial",
                                    "Value": "Dy. Manager Secretarial"
                                },
                                {
                                    "Text": "Dy. Plant Manager",
                                    "Value": "Dy. Plant Manager"
                                },
                                {
                                    "Text": "Dy. Sales Manager",
                                    "Value": "Dy. Sales Manager"
                                },
                                {
                                    "Text": "Dy. Superintendent Engineer",
                                    "Value": "Dy. Superintendent Engineer"
                                },
                                {
                                    "Text": "Dy. Mamlatdar",
                                    "Value": "Dy. Mamlatdar"
                                },
                                {
                                    "Text": "Dy. Team Leader",
                                    "Value": "Dy. Team Leader"
                                },
                                {
                                    "Text": "Dye Maker",
                                    "Value": "Dye Maker"
                                },
                                {
                                    "Text": "Dyeing Master",
                                    "Value": "Dyeing Master"
                                },
                                {
                                    "Text": "Dyeing Supervisor",
                                    "Value": "Dyeing Supervisor"
                                },
                                {
                                    "Text": "Dy. Manager Front Office",
                                    "Value": "Dy. Manager Front Office"
                                },
                                {
                                    "Text": "Dy. GM",
                                    "Value": "Dy. GM"
                                },
                                {
                                    "Text": "Dy. Manager Admin",
                                    "Value": "Dy. Manager Admin"
                                },
                                {
                                    "Text": "Dy. Manager Marketing",
                                    "Value": "Dy. Manager Marketing"
                                },
                                {
                                    "Text": "Dy. Accountant",
                                    "Value": "Dy. Accountant"
                                },
                                {
                                    "Text": "Dy. Manager Aviation",
                                    "Value": "Dy. Manager Aviation"
                                },
                                {
                                    "Text": "Dy. Director",
                                    "Value": "Dy. Director"
                                },
                                {
                                    "Text": "Dy. Manager HRD",
                                    "Value": "Dy. Manager HRD"
                                },
                                {
                                    "Text": "Dy. Ex. Magistrate",
                                    "Value": "Dy. Ex. Magistrate"
                                },
                                {
                                    "Text": "Dy.Town Planner",
                                    "Value": "Dy.Town Planner"
                                },
                                {
                                    "Text": "Dy. General Manager Exports",
                                    "Value": "Dy. General Manager Exports"
                                },
                                {
                                    "Text": "Dy. GM Commodity",
                                    "Value": "Dy. GM Commodity"
                                },
                                {
                                    "Text": "Dy. Manager Production",
                                    "Value": "Dy. Manager Production"
                                },
                                {
                                    "Text": "Dy. Surveyor",
                                    "Value": "Dy. Surveyor"
                                },
                                {
                                    "Text": "Earning Through Capital Gains",
                                    "Value": "Earning Through Capital Gains"
                                },
                                {
                                    "Text": "Executive Audit & Risk",
                                    "Value": "Executive Audit & Risk"
                                },
                                {
                                    "Text": "Earning From Interest",
                                    "Value": "Earning From Interest"
                                },
                                {
                                    "Text": "Economist",
                                    "Value": "Economist"
                                },
                                {
                                    "Text": "Executive Director & COO",
                                    "Value": "Executive Director & COO"
                                },
                                {
                                    "Text": "Education Officer",
                                    "Value": "Education Officer"
                                },
                                {
                                    "Text": "E.D.P. Incharge",
                                    "Value": "E.D.P. Incharge"
                                },
                                {
                                    "Text": "Editors",
                                    "Value": "Editors"
                                },
                                {
                                    "Text": "Education Counsellor",
                                    "Value": "Education Counsellor"
                                },
                                {
                                    "Text": "EDP Operator",
                                    "Value": "EDP Operator"
                                },
                                {
                                    "Text": "Chancellor",
                                    "Value": "Chancellor"
                                },
                                {
                                    "Text": "Education Consultant",
                                    "Value": "Education Consultant"
                                },
                                {
                                    "Text": "Dean",
                                    "Value": "Dean"
                                },
                                {
                                    "Text": "Electrical Industry-Ht > 20 ft",
                                    "Value": "Electrical Industry-Ht > 20 ft"
                                },
                                {
                                    "Text": "Electric Signal Maintainer",
                                    "Value": "Electric Signal Maintainer"
                                },
                                {
                                    "Text": "Electrical Assistant",
                                    "Value": "Electrical Assistant"
                                },
                                {
                                    "Text": "Electrical Designer",
                                    "Value": "Electrical Designer"
                                },
                                {
                                    "Text": "Electrical Foreman",
                                    "Value": "Electrical Foreman"
                                },
                                {
                                    "Text": "Electrical Officer",
                                    "Value": "Electrical Officer"
                                },
                                {
                                    "Text": "Electrical Shop Owner",
                                    "Value": "Electrical Shop Owner"
                                },
                                {
                                    "Text": "Electrician Signal Maintenance",
                                    "Value": "Electrician Signal Maintenance"
                                },
                                {
                                    "Text": "Electronics Shop Owner",
                                    "Value": "Electronics Shop Owner"
                                },
                                {
                                    "Text": "Electronics Technician",
                                    "Value": "Electronics Technician"
                                },
                                {
                                    "Text": "Electric Motor Rewinder",
                                    "Value": "Electric Motor Rewinder"
                                },
                                {
                                    "Text": "Electronics Fitter",
                                    "Value": "Electronics Fitter"
                                },
                                {
                                    "Text": "Electronics Installer",
                                    "Value": "Electronics Installer"
                                },
                                {
                                    "Text": "Electronics Engineer",
                                    "Value": "Electronics Engineer"
                                },
                                {
                                    "Text": "Electronics Repairer",
                                    "Value": "Electronics Repairer"
                                },
                                {
                                    "Text": "Elevator/escalator repair/Inst",
                                    "Value": "Elevator/escalator repair/Inst"
                                },
                                {
                                    "Text": "Electricians",
                                    "Value": "Electricians"
                                },
                                {
                                    "Text": "Electronics Wireman",
                                    "Value": "Electronics Wireman"
                                },
                                {
                                    "Text": "Electrical Incharge",
                                    "Value": "Electrical Incharge"
                                },
                                {
                                    "Text": "Electrical Consultant",
                                    "Value": "Electrical Consultant"
                                },
                                {
                                    "Text": "Electrician Production",
                                    "Value": "Electrician Production"
                                },
                                {
                                    "Text": "Employee Relation Officer",
                                    "Value": "Employee Relation Officer"
                                },
                                {
                                    "Text": "Emergency Physician",
                                    "Value": "Emergency Physician"
                                },
                                {
                                    "Text": "Embroidery Worker",
                                    "Value": "Embroidery Worker"
                                },
                                {
                                    "Text": "Employee Collection Agent",
                                    "Value": "Employee Collection Agent"
                                },
                                {
                                    "Text": "Employee",
                                    "Value": "Employee"
                                },
                                {
                                    "Text": "Estate Maintenance Officer",
                                    "Value": "Estate Maintenance Officer"
                                },
                                {
                                    "Text": "Engineer Contractor",
                                    "Value": "Engineer Contractor"
                                },
                                {
                                    "Text": "Engineer Craftsman",
                                    "Value": "Engineer Craftsman"
                                },
                                {
                                    "Text": "Engineer Designing",
                                    "Value": "Engineer Designing"
                                },
                                {
                                    "Text": "Engineer Development",
                                    "Value": "Engineer Development"
                                },
                                {
                                    "Text": "Engineer Grade I",
                                    "Value": "Engineer Grade I"
                                },
                                {
                                    "Text": "Engineer Mechanical",
                                    "Value": "Engineer Mechanical"
                                },
                                {
                                    "Text": "Engineer Production",
                                    "Value": "Engineer Production"
                                },
                                {
                                    "Text": "Engineer Electrical",
                                    "Value": "Engineer Electrical"
                                },
                                {
                                    "Text": "Engineering Assistant",
                                    "Value": "Engineering Assistant"
                                },
                                {
                                    "Text": "ENT Physician",
                                    "Value": "ENT Physician"
                                },
                                {
                                    "Text": "Engineering Contractor",
                                    "Value": "Engineering Contractor"
                                },
                                {
                                    "Text": "Enforcement Deputy Tahsildar",
                                    "Value": "Enforcement Deputy Tahsildar"
                                },
                                {
                                    "Text": "ENT Specialist",
                                    "Value": "ENT Specialist"
                                },
                                {
                                    "Text": "Entertainment Editor",
                                    "Value": "Entertainment Editor"
                                },
                                {
                                    "Text": "Environmental Engineer",
                                    "Value": "Environmental Engineer"
                                },
                                {
                                    "Text": "Environmentl Health Specialist",
                                    "Value": "Environmentl Health Specialist"
                                },
                                {
                                    "Text": "Engineer Consultancy",
                                    "Value": "Engineer Consultancy"
                                },
                                {
                                    "Text": "Engine driver",
                                    "Value": "Engine driver"
                                },
                                {
                                    "Text": "Engineer Trainee",
                                    "Value": "Engineer Trainee"
                                },
                                {
                                    "Text": "Environment Engineer",
                                    "Value": "Environment Engineer"
                                },
                                {
                                    "Text": "Enterprise Account Mgr Sales",
                                    "Value": "Enterprise Account Mgr Sales"
                                },
                                {
                                    "Text": "Engine Man",
                                    "Value": "Engine Man"
                                },
                                {
                                    "Text": "Engineer",
                                    "Value": "Engineer"
                                },
                                {
                                    "Text": "Enquiry Holder",
                                    "Value": "Enquiry Holder"
                                },
                                {
                                    "Text": "Engineering Mechanic",
                                    "Value": "Engineering Mechanic"
                                },
                                {
                                    "Text": "Engineer Grade II",
                                    "Value": "Engineer Grade II"
                                },
                                {
                                    "Text": "Engineer Civil",
                                    "Value": "Engineer Civil"
                                },
                                {
                                    "Text": "Engineer Operations",
                                    "Value": "Engineer Operations"
                                },
                                {
                                    "Text": "Engineer Quality Control",
                                    "Value": "Engineer Quality Control"
                                },
                                {
                                    "Text": "Engineer System Administration",
                                    "Value": "Engineer System Administration"
                                },
                                {
                                    "Text": "Enforcement Inspector",
                                    "Value": "Enforcement Inspector"
                                },
                                {
                                    "Text": "Engineer QA",
                                    "Value": "Engineer QA"
                                },
                                {
                                    "Text": "Environmentalist",
                                    "Value": "Environmentalist"
                                },
                                {
                                    "Text": "Engineer Quality",
                                    "Value": "Engineer Quality"
                                },
                                {
                                    "Text": "Engineering Executive",
                                    "Value": "Engineering Executive"
                                },
                                {
                                    "Text": "Engineering Administrator",
                                    "Value": "Engineering Administrator"
                                },
                                {
                                    "Text": "Engineering Buss Develop. Mgr",
                                    "Value": "Engineering Buss Develop. Mgr"
                                },
                                {
                                    "Text": "Engineering Operation",
                                    "Value": "Engineering Operation"
                                },
                                {
                                    "Text": "Equity Trader",
                                    "Value": "Equity Trader"
                                },
                                {
                                    "Text": "Equity Sales Officer",
                                    "Value": "Equity Sales Officer"
                                },
                                {
                                    "Text": "Equity Analyst",
                                    "Value": "Equity Analyst"
                                },
                                {
                                    "Text": "Erection Manager",
                                    "Value": "Erection Manager"
                                },
                                {
                                    "Text": "Executive Regional Human",
                                    "Value": "Executive Regional Human"
                                },
                                {
                                    "Text": "Estate Broker",
                                    "Value": "Estate Broker"
                                },
                                {
                                    "Text": "Estate Officer",
                                    "Value": "Estate Officer"
                                },
                                {
                                    "Text": "Associate Professor",
                                    "Value": "Associate Professor"
                                },
                                {
                                    "Text": "Estimation Engineer",
                                    "Value": "Estimation Engineer"
                                },
                                {
                                    "Text": "Estate Agent",
                                    "Value": "Estate Agent"
                                },
                                {
                                    "Text": "Event Management Executive",
                                    "Value": "Event Management Executive"
                                },
                                {
                                    "Text": "EVP DPPM",
                                    "Value": "EVP DPPM"
                                },
                                {
                                    "Text": "EVP Finance",
                                    "Value": "EVP Finance"
                                },
                                {
                                    "Text": "EVP Group Sales",
                                    "Value": "EVP Group Sales"
                                },
                                {
                                    "Text": "EVP HR L&D and Administration",
                                    "Value": "EVP HR L&D and Administration"
                                },
                                {
                                    "Text": "EVP L &  D",
                                    "Value": "EVP L &  D"
                                },
                                {
                                    "Text": "EVP Marketing",
                                    "Value": "EVP Marketing"
                                },
                                {
                                    "Text": "EVP Sales",
                                    "Value": "EVP Sales"
                                },
                                {
                                    "Text": "Evaluator",
                                    "Value": "Evaluator"
                                },
                                {
                                    "Text": "Ex Assistant Chief Officer",
                                    "Value": "Ex Assistant Chief Officer"
                                },
                                {
                                    "Text": "Ex Engineer",
                                    "Value": "Ex Engineer"
                                },
                                {
                                    "Text": "Excise Incharge",
                                    "Value": "Excise Incharge"
                                },
                                {
                                    "Text": "Excise Sub Inspector",
                                    "Value": "Excise Sub Inspector"
                                },
                                {
                                    "Text": "Excise Supervisor",
                                    "Value": "Excise Supervisor"
                                },
                                {
                                    "Text": "Exec. Relationship Management",
                                    "Value": "Exec. Relationship Management"
                                },
                                {
                                    "Text": "Executive Administration",
                                    "Value": "Executive Administration"
                                },
                                {
                                    "Text": "Executive Assistant Director",
                                    "Value": "Executive Assistant Director"
                                },
                                {
                                    "Text": "Executive Assistant Manager",
                                    "Value": "Executive Assistant Manager"
                                },
                                {
                                    "Text": "Examiner",
                                    "Value": "Examiner"
                                },
                                {
                                    "Text": "Ex Serviceman",
                                    "Value": "Ex Serviceman"
                                },
                                {
                                    "Text": "Executive Customer Support",
                                    "Value": "Executive Customer Support"
                                },
                                {
                                    "Text": "Executive Demat",
                                    "Value": "Executive Demat"
                                },
                                {
                                    "Text": "Executive Documentation",
                                    "Value": "Executive Documentation"
                                },
                                {
                                    "Text": "Executive Engineer",
                                    "Value": "Executive Engineer"
                                },
                                {
                                    "Text": "Executive CAT",
                                    "Value": "Executive CAT"
                                },
                                {
                                    "Text": "Executive Fabrication",
                                    "Value": "Executive Fabrication"
                                },
                                {
                                    "Text": "Executive Finance",
                                    "Value": "Executive Finance"
                                },
                                {
                                    "Text": "Executive Human Resources",
                                    "Value": "Executive Human Resources"
                                },
                                {
                                    "Text": "Executive Imports",
                                    "Value": "Executive Imports"
                                },
                                {
                                    "Text": "Executive Legal Manager",
                                    "Value": "Executive Legal Manager"
                                },
                                {
                                    "Text": "Executive Maintenance",
                                    "Value": "Executive Maintenance"
                                },
                                {
                                    "Text": "Executive Marketing",
                                    "Value": "Executive Marketing"
                                },
                                {
                                    "Text": "Executive Operations Officer",
                                    "Value": "Executive Operations Officer"
                                },
                                {
                                    "Text": "Executive Planning",
                                    "Value": "Executive Planning"
                                },
                                {
                                    "Text": "Executive Projects",
                                    "Value": "Executive Projects"
                                },
                                {
                                    "Text": "Executive Sales",
                                    "Value": "Executive Sales"
                                },
                                {
                                    "Text": "Executive Sales & Marketing",
                                    "Value": "Executive Sales & Marketing"
                                },
                                {
                                    "Text": "Executive Stores",
                                    "Value": "Executive Stores"
                                },
                                {
                                    "Text": "Executive Subscription",
                                    "Value": "Executive Subscription"
                                },
                                {
                                    "Text": "Executive Surgeon",
                                    "Value": "Executive Surgeon"
                                },
                                {
                                    "Text": "Executive Telesales",
                                    "Value": "Executive Telesales"
                                },
                                {
                                    "Text": "Executive Training",
                                    "Value": "Executive Training"
                                },
                                {
                                    "Text": "Executive Visual Merchandiser",
                                    "Value": "Executive Visual Merchandiser"
                                },
                                {
                                    "Text": "Expediting Engineer",
                                    "Value": "Expediting Engineer"
                                },
                                {
                                    "Text": "Export Executive",
                                    "Value": "Export Executive"
                                },
                                {
                                    "Text": "Exporter",
                                    "Value": "Exporter"
                                },
                                {
                                    "Text": "Extra Additional Commissioner",
                                    "Value": "Extra Additional Commissioner"
                                },
                                {
                                    "Text": "Executive Channel Development",
                                    "Value": "Executive Channel Development"
                                },
                                {
                                    "Text": "Executive Director Finance",
                                    "Value": "Executive Director Finance"
                                },
                                {
                                    "Text": "Executive Compliance",
                                    "Value": "Executive Compliance"
                                },
                                {
                                    "Text": "Executive Officer",
                                    "Value": "Executive Officer"
                                },
                                {
                                    "Text": "Executive Logistics",
                                    "Value": "Executive Logistics"
                                },
                                {
                                    "Text": "Executive Product",
                                    "Value": "Executive Product"
                                },
                                {
                                    "Text": "Executive Procurement",
                                    "Value": "Executive Procurement"
                                },
                                {
                                    "Text": "Executive Database Management",
                                    "Value": "Executive Database Management"
                                },
                                {
                                    "Text": "Executive DPPM",
                                    "Value": "Executive DPPM"
                                },
                                {
                                    "Text": "Executive Direct Sales",
                                    "Value": "Executive Direct Sales"
                                },
                                {
                                    "Text": "Executive Graphics & Web",
                                    "Value": "Executive Graphics & Web"
                                },
                                {
                                    "Text": "Executive",
                                    "Value": "Executive"
                                },
                                {
                                    "Text": "Ex-Seargent Retired",
                                    "Value": "Ex-Seargent Retired"
                                },
                                {
                                    "Text": "Executive Trainee",
                                    "Value": "Executive Trainee"
                                },
                                {
                                    "Text": "Executive Chief",
                                    "Value": "Executive Chief"
                                },
                                {
                                    "Text": "Executive International Travel",
                                    "Value": "Executive International Travel"
                                },
                                {
                                    "Text": "Exceutive Material Stores",
                                    "Value": "Exceutive Material Stores"
                                },
                                {
                                    "Text": "Senior Manager DirectSales-DSF",
                                    "Value": "Senior Manager DirectSales-DSF"
                                },
                                {
                                    "Text": "Executive to GM",
                                    "Value": "Executive to GM"
                                },
                                {
                                    "Text": "Executive Group Sales Support",
                                    "Value": "Executive Group Sales Support"
                                },
                                {
                                    "Text": "Executive HNI",
                                    "Value": "Executive HNI"
                                },
                                {
                                    "Text": "Executive HR",
                                    "Value": "Executive HR"
                                },
                                {
                                    "Text": "Executive Trainee Civil",
                                    "Value": "Executive Trainee Civil"
                                },
                                {
                                    "Text": "Executive Client Relationship",
                                    "Value": "Executive Client Relationship"
                                },
                                {
                                    "Text": "Executive DPPM Inctv Contest",
                                    "Value": "Executive DPPM Inctv Contest"
                                },
                                {
                                    "Text": "Executive Legal",
                                    "Value": "Executive Legal"
                                },
                                {
                                    "Text": "Executive Business & Service",
                                    "Value": "Executive Business & Service"
                                },
                                {
                                    "Text": "Executive LMS",
                                    "Value": "Executive LMS"
                                },
                                {
                                    "Text": "Executive Materials",
                                    "Value": "Executive Materials"
                                },
                                {
                                    "Text": "Executive Investments MO/BO",
                                    "Value": "Executive Investments MO/BO"
                                },
                                {
                                    "Text": "Executive Mid Office",
                                    "Value": "Executive Mid Office"
                                },
                                {
                                    "Text": "Executive Medical Payments",
                                    "Value": "Executive Medical Payments"
                                },
                                {
                                    "Text": "Executive Medical Services",
                                    "Value": "Executive Medical Services"
                                },
                                {
                                    "Text": "Executive Medical Support",
                                    "Value": "Executive Medical Support"
                                },
                                {
                                    "Text": "Exec Electronic Data Procesing",
                                    "Value": "Exec Electronic Data Procesing"
                                },
                                {
                                    "Text": "Excise Assistant",
                                    "Value": "Excise Assistant"
                                },
                                {
                                    "Text": "Exceutive Administration",
                                    "Value": "Exceutive Administration"
                                },
                                {
                                    "Text": "Excise Inspector",
                                    "Value": "Excise Inspector"
                                },
                                {
                                    "Text": "Explosives",
                                    "Value": "Explosives"
                                },
                                {
                                    "Text": "Exhibition Promoter",
                                    "Value": "Exhibition Promoter"
                                },
                                {
                                    "Text": "Executive CRA",
                                    "Value": "Executive CRA"
                                },
                                {
                                    "Text": "Executive Customer Care",
                                    "Value": "Executive Customer Care"
                                },
                                {
                                    "Text": "Executive Regional",
                                    "Value": "Executive Regional"
                                },
                                {
                                    "Text": "Executive Bancassurance",
                                    "Value": "Executive Bancassurance"
                                },
                                {
                                    "Text": "Executive ERP",
                                    "Value": "Executive ERP"
                                },
                                {
                                    "Text": "Executive DPPM (Reward &",
                                    "Value": "Executive DPPM (Reward &"
                                },
                                {
                                    "Text": "Executive Secretary",
                                    "Value": "Executive Secretary"
                                },
                                {
                                    "Text": "Executive Sales Coordinator",
                                    "Value": "Executive Sales Coordinator"
                                },
                                {
                                    "Text": "Executive Purchase",
                                    "Value": "Executive Purchase"
                                },
                                {
                                    "Text": "Executive Strategy & Product",
                                    "Value": "Executive Strategy & Product"
                                },
                                {
                                    "Text": "Executive Process",
                                    "Value": "Executive Process"
                                },
                                {
                                    "Text": "Exec. Medical Transcriptionist",
                                    "Value": "Exec. Medical Transcriptionist"
                                },
                                {
                                    "Text": "Executive Magistrate",
                                    "Value": "Executive Magistrate"
                                },
                                {
                                    "Text": "Executive BS&T",
                                    "Value": "Executive BS&T"
                                },
                                {
                                    "Text": "Executive Telemarketing",
                                    "Value": "Executive Telemarketing"
                                },
                                {
                                    "Text": "Executive Accounts",
                                    "Value": "Executive Accounts"
                                },
                                {
                                    "Text": "Executive Taxation",
                                    "Value": "Executive Taxation"
                                },
                                {
                                    "Text": "Executive Facility",
                                    "Value": "Executive Facility"
                                },
                                {
                                    "Text": "Executive Sales Support",
                                    "Value": "Executive Sales Support"
                                },
                                {
                                    "Text": "Executive Visual Designer",
                                    "Value": "Executive Visual Designer"
                                },
                                {
                                    "Text": "Export Documentation Executive",
                                    "Value": "Export Documentation Executive"
                                },
                                {
                                    "Text": "Executive Chief Manager",
                                    "Value": "Executive Chief Manager"
                                },
                                {
                                    "Text": "Executive Corporate Sales",
                                    "Value": "Executive Corporate Sales"
                                },
                                {
                                    "Text": "Executive Customer Relation",
                                    "Value": "Executive Customer Relation"
                                },
                                {
                                    "Text": "Executive Engineer Civil",
                                    "Value": "Executive Engineer Civil"
                                },
                                {
                                    "Text": "Eye Specialst Med Superintndnt",
                                    "Value": "Eye Specialst Med Superintndnt"
                                },
                                {
                                    "Text": "Eye Surgeon",
                                    "Value": "Eye Surgeon"
                                },
                                {
                                    "Text": "Facilities Executive",
                                    "Value": "Facilities Executive"
                                },
                                {
                                    "Text": "Facility Engineer",
                                    "Value": "Facility Engineer"
                                },
                                {
                                    "Text": "Facility Manager",
                                    "Value": "Facility Manager"
                                },
                                {
                                    "Text": "Factory Proprietor",
                                    "Value": "Factory Proprietor"
                                },
                                {
                                    "Text": "Factory Supervisor",
                                    "Value": "Factory Supervisor"
                                },
                                {
                                    "Text": "Faculty & Career Counselor",
                                    "Value": "Faculty & Career Counselor"
                                },
                                {
                                    "Text": "Faculty Executive",
                                    "Value": "Faculty Executive"
                                },
                                {
                                    "Text": "Faculty Member",
                                    "Value": "Faculty Member"
                                },
                                {
                                    "Text": "Farm Incharge",
                                    "Value": "Farm Incharge"
                                },
                                {
                                    "Text": "Farm Manager",
                                    "Value": "Farm Manager"
                                },
                                {
                                    "Text": "Farmer & Agriculture Vendor",
                                    "Value": "Farmer & Agriculture Vendor"
                                },
                                {
                                    "Text": "Farmer & Contractor",
                                    "Value": "Farmer & Contractor"
                                },
                                {
                                    "Text": "Farmer & Farm Owner",
                                    "Value": "Farmer & Farm Owner"
                                },
                                {
                                    "Text": "Farmer & Owner",
                                    "Value": "Farmer & Owner"
                                },
                                {
                                    "Text": "Farmer & Pastor",
                                    "Value": "Farmer & Pastor"
                                },
                                {
                                    "Text": "Farmer & Proprietor",
                                    "Value": "Farmer & Proprietor"
                                },
                                {
                                    "Text": "Farmer & Zamindar",
                                    "Value": "Farmer & Zamindar"
                                },
                                {
                                    "Text": "F & B Assistant",
                                    "Value": "F & B Assistant"
                                },
                                {
                                    "Text": "fabricator",
                                    "Value": "fabricator"
                                },
                                {
                                    "Text": "F & B Manager",
                                    "Value": "F & B Manager"
                                },
                                {
                                    "Text": "Factory Worker",
                                    "Value": "Factory Worker"
                                },
                                {
                                    "Text": "Fabric Manager",
                                    "Value": "Fabric Manager"
                                },
                                {
                                    "Text": "F A Graphic Artist",
                                    "Value": "F A Graphic Artist"
                                },
                                {
                                    "Text": "Fabric Incharge",
                                    "Value": "Fabric Incharge"
                                },
                                {
                                    "Text": "Farm Labourer",
                                    "Value": "Farm Labourer"
                                },
                                {
                                    "Text": "Faculty Teaching",
                                    "Value": "Faculty Teaching"
                                },
                                {
                                    "Text": "Facilitator",
                                    "Value": "Facilitator"
                                },
                                {
                                    "Text": "Farmer & Landlord",
                                    "Value": "Farmer & Landlord"
                                },
                                {
                                    "Text": "Farmer & Agriculturist",
                                    "Value": "Farmer & Agriculturist"
                                },
                                {
                                    "Text": "Faculty Associate",
                                    "Value": "Faculty Associate"
                                },
                                {
                                    "Text": "Faculty",
                                    "Value": "Faculty"
                                },
                                {
                                    "Text": "F & B Cashier",
                                    "Value": "F & B Cashier"
                                },
                                {
                                    "Text": "F & B Service Crew",
                                    "Value": "F & B Service Crew"
                                },
                                {
                                    "Text": "FC & Owner",
                                    "Value": "FC & Owner"
                                },
                                {
                                    "Text": "FC",
                                    "Value": "FC"
                                },
                                {
                                    "Text": "FC In HDFCSLIC",
                                    "Value": "FC In HDFCSLIC"
                                },
                                {
                                    "Text": "Fashion Consultant",
                                    "Value": "Fashion Consultant"
                                },
                                {
                                    "Text": "Facilities Specialist",
                                    "Value": "Facilities Specialist"
                                },
                                {
                                    "Text": "Fencing Contractor",
                                    "Value": "Fencing Contractor"
                                },
                                {
                                    "Text": "Field Support Engineer",
                                    "Value": "Field Support Engineer"
                                },
                                {
                                    "Text": "Daftary",
                                    "Value": "Daftary"
                                },
                                {
                                    "Text": "Fin Consultant/Property Dealer",
                                    "Value": "Fin Consultant/Property Dealer"
                                },
                                {
                                    "Text": "Fin. Consultant & Coaching",
                                    "Value": "Fin. Consultant & Coaching"
                                },
                                {
                                    "Text": "Fin. Consultant & Coordinator",
                                    "Value": "Fin. Consultant & Coordinator"
                                },
                                {
                                    "Text": "Fin. Consultant & MF Advisor",
                                    "Value": "Fin. Consultant & MF Advisor"
                                },
                                {
                                    "Text": "Fin. Consultant & UTI Agent",
                                    "Value": "Fin. Consultant & UTI Agent"
                                },
                                {
                                    "Text": "Finance & Accounts Manager",
                                    "Value": "Finance & Accounts Manager"
                                },
                                {
                                    "Text": "Field Officer Technical",
                                    "Value": "Field Officer Technical"
                                },
                                {
                                    "Text": "Finance Consultant",
                                    "Value": "Finance Consultant"
                                },
                                {
                                    "Text": "Finance Controller",
                                    "Value": "Finance Controller"
                                },
                                {
                                    "Text": "Finance Executive",
                                    "Value": "Finance Executive"
                                },
                                {
                                    "Text": "Finance Lender",
                                    "Value": "Finance Lender"
                                },
                                {
                                    "Text": "Finance Officer",
                                    "Value": "Finance Officer"
                                },
                                {
                                    "Text": "Finance Supervisor",
                                    "Value": "Finance Supervisor"
                                },
                                {
                                    "Text": "Finance/Administration Manager",
                                    "Value": "Finance/Administration Manager"
                                },
                                {
                                    "Text": "Financer",
                                    "Value": "Financer"
                                },
                                {
                                    "Text": "Financial Agent",
                                    "Value": "Financial Agent"
                                },
                                {
                                    "Text": "Financial Assistant",
                                    "Value": "Financial Assistant"
                                },
                                {
                                    "Text": "Financial Consultant & Agent",
                                    "Value": "Financial Consultant & Agent"
                                },
                                {
                                    "Text": "Financial Consultant & Trading",
                                    "Value": "Financial Consultant & Trading"
                                },
                                {
                                    "Text": "Financial Consultnt/Proprietor",
                                    "Value": "Financial Consultnt/Proprietor"
                                },
                                {
                                    "Text": "Financial Cum Proprietor",
                                    "Value": "Financial Cum Proprietor"
                                },
                                {
                                    "Text": "Financial Executive",
                                    "Value": "Financial Executive"
                                },
                                {
                                    "Text": "Financial Planning Consultant",
                                    "Value": "Financial Planning Consultant"
                                },
                                {
                                    "Text": "Financial Planning Officer",
                                    "Value": "Financial Planning Officer"
                                },
                                {
                                    "Text": "Financial Services Consultant",
                                    "Value": "Financial Services Consultant"
                                },
                                {
                                    "Text": "First Divisional Assitant",
                                    "Value": "First Divisional Assitant"
                                },
                                {
                                    "Text": "Fish Dealer",
                                    "Value": "Fish Dealer"
                                },
                                {
                                    "Text": "Fish Trader",
                                    "Value": "Fish Trader"
                                },
                                {
                                    "Text": "Field Boy",
                                    "Value": "Field Boy"
                                },
                                {
                                    "Text": "Field Engineer",
                                    "Value": "Field Engineer"
                                },
                                {
                                    "Text": "Field Promotion Manager",
                                    "Value": "Field Promotion Manager"
                                },
                                {
                                    "Text": "Field Investigator",
                                    "Value": "Field Investigator"
                                },
                                {
                                    "Text": "Junior Officer",
                                    "Value": "Junior Officer"
                                },
                                {
                                    "Text": "Filing Clerk",
                                    "Value": "Filing Clerk"
                                },
                                {
                                    "Text": "Fin. Consultnt & Rental Income",
                                    "Value": "Fin. Consultnt & Rental Income"
                                },
                                {
                                    "Text": "Fish Merchant",
                                    "Value": "Fish Merchant"
                                },
                                {
                                    "Text": "Financial Consultant & Tuition",
                                    "Value": "Financial Consultant & Tuition"
                                },
                                {
                                    "Text": "Field Representive",
                                    "Value": "Field Representive"
                                },
                                {
                                    "Text": "Purchase Officer",
                                    "Value": "Purchase Officer"
                                },
                                {
                                    "Text": "Fireman",
                                    "Value": "Fireman"
                                },
                                {
                                    "Text": "First Divisional Clerk",
                                    "Value": "First Divisional Clerk"
                                },
                                {
                                    "Text": "Senior officer",
                                    "Value": "Senior officer"
                                },
                                {
                                    "Text": "Fishery",
                                    "Value": "Fishery"
                                },
                                {
                                    "Text": "Yoga teacher",
                                    "Value": "Yoga teacher"
                                },
                                {
                                    "Text": "Field Relationship Officer",
                                    "Value": "Field Relationship Officer"
                                },
                                {
                                    "Text": "Field Sales Officer",
                                    "Value": "Field Sales Officer"
                                },
                                {
                                    "Text": "Field Team Leader",
                                    "Value": "Field Team Leader"
                                },
                                {
                                    "Text": "Fin Consultant HDFCSL & Tutor",
                                    "Value": "Fin Consultant HDFCSL & Tutor"
                                },
                                {
                                    "Text": "Finance & Pawn Broking",
                                    "Value": "Finance & Pawn Broking"
                                },
                                {
                                    "Text": "Forklift Operator",
                                    "Value": "Forklift Operator"
                                },
                                {
                                    "Text": "Fleet Manager",
                                    "Value": "Fleet Manager"
                                },
                                {
                                    "Text": "Fleet Sales Manager",
                                    "Value": "Fleet Sales Manager"
                                },
                                {
                                    "Text": "Floor Officer",
                                    "Value": "Floor Officer"
                                },
                                {
                                    "Text": "Film Layout Assistant",
                                    "Value": "Film Layout Assistant"
                                },
                                {
                                    "Text": "Flower Manager",
                                    "Value": "Flower Manager"
                                },
                                {
                                    "Text": "Floor Housekeeper",
                                    "Value": "Floor Housekeeper"
                                },
                                {
                                    "Text": "Flight Steward",
                                    "Value": "Flight Steward"
                                },
                                {
                                    "Text": "Florists",
                                    "Value": "Florists"
                                },
                                {
                                    "Text": "Fund Manager Equity",
                                    "Value": "Fund Manager Equity"
                                },
                                {
                                    "Text": "Fund Manager Fixed Income",
                                    "Value": "Fund Manager Fixed Income"
                                },
                                {
                                    "Text": "Female/Male K J",
                                    "Value": "Female/Male K J"
                                },
                                {
                                    "Text": "Financial Controller",
                                    "Value": "Financial Controller"
                                },
                                {
                                    "Text": "F&B Assistant",
                                    "Value": "F&B Assistant"
                                },
                                {
                                    "Text": "Food Production Supervisor",
                                    "Value": "Food Production Supervisor"
                                },
                                {
                                    "Text": "Food Stall Owner & Proprietor",
                                    "Value": "Food Stall Owner & Proprietor"
                                },
                                {
                                    "Text": "Food Supply Inspector",
                                    "Value": "Food Supply Inspector"
                                },
                                {
                                    "Text": "Footwear Shop Owner",
                                    "Value": "Footwear Shop Owner"
                                },
                                {
                                    "Text": "Foreign Trade Develop Officer",
                                    "Value": "Foreign Trade Develop Officer"
                                },
                                {
                                    "Text": "Foreign Currency Cashier",
                                    "Value": "Foreign Currency Cashier"
                                },
                                {
                                    "Text": "Forest Guard",
                                    "Value": "Forest Guard"
                                },
                                {
                                    "Text": "Food Inspector",
                                    "Value": "Food Inspector"
                                },
                                {
                                    "Text": "Footballer",
                                    "Value": "Footballer"
                                },
                                {
                                    "Text": "Foreign Currency Agent",
                                    "Value": "Foreign Currency Agent"
                                },
                                {
                                    "Text": "Foreman",
                                    "Value": "Foreman"
                                },
                                {
                                    "Text": "Foreman Furnace",
                                    "Value": "Foreman Furnace"
                                },
                                {
                                    "Text": "Forest Officer",
                                    "Value": "Forest Officer"
                                },
                                {
                                    "Text": "Forex Remisier",
                                    "Value": "Forex Remisier"
                                },
                                {
                                    "Text": "Foundary Worker",
                                    "Value": "Foundary Worker"
                                },
                                {
                                    "Text": "Financial Planning Manager BSC",
                                    "Value": "Financial Planning Manager BSC"
                                },
                                {
                                    "Text": "Financial Planning Manager DSF",
                                    "Value": "Financial Planning Manager DSF"
                                },
                                {
                                    "Text": "Financial Planning Manager TM",
                                    "Value": "Financial Planning Manager TM"
                                },
                                {
                                    "Text": "Freelance Artist",
                                    "Value": "Freelance Artist"
                                },
                                {
                                    "Text": "Freelance Designer",
                                    "Value": "Freelance Designer"
                                },
                                {
                                    "Text": "Franchisee Head",
                                    "Value": "Franchisee Head"
                                },
                                {
                                    "Text": "Freelancer",
                                    "Value": "Freelancer"
                                },
                                {
                                    "Text": "Front Desk Cashier",
                                    "Value": "Front Desk Cashier"
                                },
                                {
                                    "Text": "Front Desk Officer",
                                    "Value": "Front Desk Officer"
                                },
                                {
                                    "Text": "Front Desk Supervisor",
                                    "Value": "Front Desk Supervisor"
                                },
                                {
                                    "Text": "Front Office Assistant",
                                    "Value": "Front Office Assistant"
                                },
                                {
                                    "Text": "Front Office Manager",
                                    "Value": "Front Office Manager"
                                },
                                {
                                    "Text": "Front Officer",
                                    "Value": "Front Officer"
                                },
                                {
                                    "Text": "Fruit Merchant",
                                    "Value": "Fruit Merchant"
                                },
                                {
                                    "Text": "Freelance Investr & Beautician",
                                    "Value": "Freelance Investr & Beautician"
                                },
                                {
                                    "Text": "Freelance Architect",
                                    "Value": "Freelance Architect"
                                },
                                {
                                    "Text": "Franchisee",
                                    "Value": "Franchisee"
                                },
                                {
                                    "Text": "Free Lancer",
                                    "Value": "Free Lancer"
                                },
                                {
                                    "Text": "Firefighter",
                                    "Value": "Firefighter"
                                },
                                {
                                    "Text": "Front Assistant",
                                    "Value": "Front Assistant"
                                },
                                {
                                    "Text": "Front Office Executive",
                                    "Value": "Front Office Executive"
                                },
                                {
                                    "Text": "Front Desk Operator",
                                    "Value": "Front Desk Operator"
                                },
                                {
                                    "Text": "Free Lance Artist",
                                    "Value": "Free Lance Artist"
                                },
                                {
                                    "Text": "Forestry Worker",
                                    "Value": "Forestry Worker"
                                },
                                {
                                    "Text": "Freelance Journalist",
                                    "Value": "Freelance Journalist"
                                },
                                {
                                    "Text": "Fruit Vendor",
                                    "Value": "Fruit Vendor"
                                },
                                {
                                    "Text": "Fitness Trainer",
                                    "Value": "Fitness Trainer"
                                },
                                {
                                    "Text": "Fund Accountant",
                                    "Value": "Fund Accountant"
                                },
                                {
                                    "Text": "Fumigator",
                                    "Value": "Fumigator"
                                },
                                {
                                    "Text": "Funiture Dealer",
                                    "Value": "Funiture Dealer"
                                },
                                {
                                    "Text": "Furnacemen",
                                    "Value": "Furnacemen"
                                },
                                {
                                    "Text": "Garment Owner",
                                    "Value": "Garment Owner"
                                },
                                {
                                    "Text": "Garments Dealer",
                                    "Value": "Garments Dealer"
                                },
                                {
                                    "Text": "Garments Manufacturer",
                                    "Value": "Garments Manufacturer"
                                },
                                {
                                    "Text": "Gazetted Officer",
                                    "Value": "Gazetted Officer"
                                },
                                {
                                    "Text": "Gastrointestinal Surgeon",
                                    "Value": "Gastrointestinal Surgeon"
                                },
                                {
                                    "Text": "Gardener",
                                    "Value": "Gardener"
                                },
                                {
                                    "Text": "Gam Panchayat Adhikari",
                                    "Value": "Gam Panchayat Adhikari"
                                },
                                {
                                    "Text": "Garage Worker",
                                    "Value": "Garage Worker"
                                },
                                {
                                    "Text": "Gas Attendant",
                                    "Value": "Gas Attendant"
                                },
                                {
                                    "Text": "Gas Distributor",
                                    "Value": "Gas Distributor"
                                },
                                {
                                    "Text": "Home service advisor",
                                    "Value": "Home service advisor"
                                },
                                {
                                    "Text": "Gen. Merchant/Commission Agent",
                                    "Value": "Gen. Merchant/Commission Agent"
                                },
                                {
                                    "Text": "General Assitant Surgeon",
                                    "Value": "General Assitant Surgeon"
                                },
                                {
                                    "Text": "General Insurance Agent",
                                    "Value": "General Insurance Agent"
                                },
                                {
                                    "Text": "General Manager Manufacturing",
                                    "Value": "General Manager Manufacturing"
                                },
                                {
                                    "Text": "General Manager Marketing",
                                    "Value": "General Manager Marketing"
                                },
                                {
                                    "Text": "General Manager Merchandising",
                                    "Value": "General Manager Merchandising"
                                },
                                {
                                    "Text": "General Manager Production",
                                    "Value": "General Manager Production"
                                },
                                {
                                    "Text": "General Merchant",
                                    "Value": "General Merchant"
                                },
                                {
                                    "Text": "General Mgr Admin & Commercial",
                                    "Value": "General Mgr Admin & Commercial"
                                },
                                {
                                    "Text": "General Manager Material",
                                    "Value": "General Manager Material"
                                },
                                {
                                    "Text": "Geologist Engineer",
                                    "Value": "Geologist Engineer"
                                },
                                {
                                    "Text": "General Manager Finance",
                                    "Value": "General Manager Finance"
                                },
                                {
                                    "Text": "General Manager Personnel",
                                    "Value": "General Manager Personnel"
                                },
                                {
                                    "Text": "General Sales Manager",
                                    "Value": "General Sales Manager"
                                },
                                {
                                    "Text": "General Manager Sales",
                                    "Value": "General Manager Sales"
                                },
                                {
                                    "Text": "Gentleman Cadet",
                                    "Value": "Gentleman Cadet"
                                },
                                {
                                    "Text": "General Manager Rolling Mills",
                                    "Value": "General Manager Rolling Mills"
                                },
                                {
                                    "Text": "General Manager Engineering",
                                    "Value": "General Manager Engineering"
                                },
                                {
                                    "Text": "General Accountant",
                                    "Value": "General Accountant"
                                },
                                {
                                    "Text": "Geologist",
                                    "Value": "Geologist"
                                },
                                {
                                    "Text": "General Manager Administration",
                                    "Value": "General Manager Administration"
                                },
                                {
                                    "Text": "General Surgeon Doctor",
                                    "Value": "General Surgeon Doctor"
                                },
                                {
                                    "Text": "General Manager QA",
                                    "Value": "General Manager QA"
                                },
                                {
                                    "Text": "General Manager Agriculture",
                                    "Value": "General Manager Agriculture"
                                },
                                {
                                    "Text": "General Clerk",
                                    "Value": "General Clerk"
                                },
                                {
                                    "Text": "General Practitioner",
                                    "Value": "General Practitioner"
                                },
                                {
                                    "Text": "Glass Fabricator",
                                    "Value": "Glass Fabricator"
                                },
                                {
                                    "Text": "Glass Heat Tester",
                                    "Value": "Glass Heat Tester"
                                },
                                {
                                    "Text": "Glass Packer",
                                    "Value": "Glass Packer"
                                },
                                {
                                    "Text": "Glass Cutter",
                                    "Value": "Glass Cutter"
                                },
                                {
                                    "Text": "Global Head-Quality",
                                    "Value": "Global Head-Quality"
                                },
                                {
                                    "Text": "GM Legal",
                                    "Value": "GM Legal"
                                },
                                {
                                    "Text": "GM Production",
                                    "Value": "GM Production"
                                },
                                {
                                    "Text": "GM Projects",
                                    "Value": "GM Projects"
                                },
                                {
                                    "Text": "GM Commercial",
                                    "Value": "GM Commercial"
                                },
                                {
                                    "Text": "GM Finance",
                                    "Value": "GM Finance"
                                },
                                {
                                    "Text": "GM Foreign Trader",
                                    "Value": "GM Foreign Trader"
                                },
                                {
                                    "Text": "GM",
                                    "Value": "GM"
                                },
                                {
                                    "Text": "GM Business Developmnt & Admin",
                                    "Value": "GM Business Developmnt & Admin"
                                },
                                {
                                    "Text": "Group Sales Manager Key",
                                    "Value": "Group Sales Manager Key"
                                },
                                {
                                    "Text": "GM Operations",
                                    "Value": "GM Operations"
                                },
                                {
                                    "Text": "GM Business Development",
                                    "Value": "GM Business Development"
                                },
                                {
                                    "Text": "Gold Ornaments Maker",
                                    "Value": "Gold Ornaments Maker"
                                },
                                {
                                    "Text": "Goods Supplier",
                                    "Value": "Goods Supplier"
                                },
                                {
                                    "Text": "Government Contractor",
                                    "Value": "Government Contractor"
                                },
                                {
                                    "Text": "Government Lawyer",
                                    "Value": "Government Lawyer"
                                },
                                {
                                    "Text": "Government Officer",
                                    "Value": "Government Officer"
                                },
                                {
                                    "Text": "Government Retailer",
                                    "Value": "Government Retailer"
                                },
                                {
                                    "Text": "Government Service Trainer",
                                    "Value": "Government Service Trainer"
                                },
                                {
                                    "Text": "Government Teacher",
                                    "Value": "Government Teacher"
                                },
                                {
                                    "Text": "Government Service",
                                    "Value": "Government Service"
                                },
                                {
                                    "Text": "Goods Officer",
                                    "Value": "Goods Officer"
                                },
                                {
                                    "Text": "Goldsmiths",
                                    "Value": "Goldsmiths"
                                },
                                {
                                    "Text": "Government Employee Army",
                                    "Value": "Government Employee Army"
                                },
                                {
                                    "Text": "Gondola Supervisor",
                                    "Value": "Gondola Supervisor"
                                },
                                {
                                    "Text": "Goldsmith & Proprietor",
                                    "Value": "Goldsmith & Proprietor"
                                },
                                {
                                    "Text": "Goods Guard",
                                    "Value": "Goods Guard"
                                },
                                {
                                    "Text": "Goods Booking Clerk",
                                    "Value": "Goods Booking Clerk"
                                },
                                {
                                    "Text": "Goldsmith",
                                    "Value": "Goldsmith"
                                },
                                {
                                    "Text": "Government Job",
                                    "Value": "Government Job"
                                },
                                {
                                    "Text": "Goldsmith Worker",
                                    "Value": "Goldsmith Worker"
                                },
                                {
                                    "Text": "Grade II Engineer",
                                    "Value": "Grade II Engineer"
                                },
                                {
                                    "Text": "Grade IV Engineer",
                                    "Value": "Grade IV Engineer"
                                },
                                {
                                    "Text": "Graduate Engineer",
                                    "Value": "Graduate Engineer"
                                },
                                {
                                    "Text": "Graphic Arts Designer",
                                    "Value": "Graphic Arts Designer"
                                },
                                {
                                    "Text": "Grain Merchant",
                                    "Value": "Grain Merchant"
                                },
                                {
                                    "Text": "Grain Retailer",
                                    "Value": "Grain Retailer"
                                },
                                {
                                    "Text": "Grain Trader",
                                    "Value": "Grain Trader"
                                },
                                {
                                    "Text": "Grey Broker",
                                    "Value": "Grey Broker"
                                },
                                {
                                    "Text": "Gram Sevak",
                                    "Value": "Gram Sevak"
                                },
                                {
                                    "Text": "Grocery Business & Proprietor",
                                    "Value": "Grocery Business & Proprietor"
                                },
                                {
                                    "Text": "Gram Pradhan",
                                    "Value": "Gram Pradhan"
                                },
                                {
                                    "Text": "Group Head",
                                    "Value": "Group Head"
                                },
                                {
                                    "Text": "Group Instructor",
                                    "Value": "Group Instructor"
                                },
                                {
                                    "Text": "Group Leader",
                                    "Value": "Group Leader"
                                },
                                {
                                    "Text": "Group Manager",
                                    "Value": "Group Manager"
                                },
                                {
                                    "Text": "Group Project Manager",
                                    "Value": "Group Project Manager"
                                },
                                {
                                    "Text": "Garbage collection",
                                    "Value": "Garbage collection"
                                },
                                {
                                    "Text": "Group Manager Utility Service",
                                    "Value": "Group Manager Utility Service"
                                },
                                {
                                    "Text": "Grass Cutter",
                                    "Value": "Grass Cutter"
                                },
                                {
                                    "Text": "Greengrocers",
                                    "Value": "Greengrocers"
                                },
                                {
                                    "Text": "Graphical Designer",
                                    "Value": "Graphical Designer"
                                },
                                {
                                    "Text": "Graduate Executive Training",
                                    "Value": "Graduate Executive Training"
                                },
                                {
                                    "Text": "Grampanchayat servant",
                                    "Value": "Grampanchayat servant"
                                },
                                {
                                    "Text": "Guest Relations Officer",
                                    "Value": "Guest Relations Officer"
                                },
                                {
                                    "Text": "Group Accounts Director",
                                    "Value": "Group Accounts Director"
                                },
                                {
                                    "Text": "Gram Panchayat Secretary",
                                    "Value": "Gram Panchayat Secretary"
                                },
                                {
                                    "Text": "Graphic Artist",
                                    "Value": "Graphic Artist"
                                },
                                {
                                    "Text": "Graduate Trainee",
                                    "Value": "Graduate Trainee"
                                },
                                {
                                    "Text": "Graphic Executive",
                                    "Value": "Graphic Executive"
                                },
                                {
                                    "Text": "Graduate Engineer Trainee",
                                    "Value": "Graduate Engineer Trainee"
                                },
                                {
                                    "Text": "Group Executive",
                                    "Value": "Group Executive"
                                },
                                {
                                    "Text": "Guest Service Associate",
                                    "Value": "Guest Service Associate"
                                },
                                {
                                    "Text": "Hawker",
                                    "Value": "Hawker"
                                },
                                {
                                    "Text": "Hairdresser & Beauty Cullture",
                                    "Value": "Hairdresser & Beauty Cullture"
                                },
                                {
                                    "Text": "Handyman",
                                    "Value": "Handyman"
                                },
                                {
                                    "Text": "Health Assurance Specialist",
                                    "Value": "Health Assurance Specialist"
                                },
                                {
                                    "Text": "Hair Stylist",
                                    "Value": "Hair Stylist"
                                },
                                {
                                    "Text": "Hawkers",
                                    "Value": "Hawkers"
                                },
                                {
                                    "Text": "HDFCSLIC FC",
                                    "Value": "HDFCSLIC FC"
                                },
                                {
                                    "Text": "HDFC Staff",
                                    "Value": "HDFC Staff"
                                },
                                {
                                    "Text": "Head Accountant",
                                    "Value": "Head Accountant"
                                },
                                {
                                    "Text": "Head Accounts Department",
                                    "Value": "Head Accounts Department"
                                },
                                {
                                    "Text": "Head Assistant",
                                    "Value": "Head Assistant"
                                },
                                {
                                    "Text": "Head R&D",
                                    "Value": "Head R&D"
                                },
                                {
                                    "Text": "Head Consultant",
                                    "Value": "Head Consultant"
                                },
                                {
                                    "Text": "Head Customer Services",
                                    "Value": "Head Customer Services"
                                },
                                {
                                    "Text": "Head Customer Support",
                                    "Value": "Head Customer Support"
                                },
                                {
                                    "Text": "Head Designer",
                                    "Value": "Head Designer"
                                },
                                {
                                    "Text": "Head Electric Engineer",
                                    "Value": "Head Electric Engineer"
                                },
                                {
                                    "Text": "Health Inspectors",
                                    "Value": "Health Inspectors"
                                },
                                {
                                    "Text": "Head HR & Commercial",
                                    "Value": "Head HR & Commercial"
                                },
                                {
                                    "Text": "Head Human Resources",
                                    "Value": "Head Human Resources"
                                },
                                {
                                    "Text": "Head International Marketing",
                                    "Value": "Head International Marketing"
                                },
                                {
                                    "Text": "Head Luggage Clerk",
                                    "Value": "Head Luggage Clerk"
                                },
                                {
                                    "Text": "Head New Products Registrar",
                                    "Value": "Head New Products Registrar"
                                },
                                {
                                    "Text": "Heat Treatment Technician",
                                    "Value": "Heat Treatment Technician"
                                },
                                {
                                    "Text": "Head National Institution",
                                    "Value": "Head National Institution"
                                },
                                {
                                    "Text": "Head Network Planning",
                                    "Value": "Head Network Planning"
                                },
                                {
                                    "Text": "Head Of Business Unit",
                                    "Value": "Head Of Business Unit"
                                },
                                {
                                    "Text": "Head Of Department",
                                    "Value": "Head Of Department"
                                },
                                {
                                    "Text": "Head Of Department Sanskrit",
                                    "Value": "Head Of Department Sanskrit"
                                },
                                {
                                    "Text": "Head Of Department Training",
                                    "Value": "Head Of Department Training"
                                },
                                {
                                    "Text": "Head Of Engineering",
                                    "Value": "Head Of Engineering"
                                },
                                {
                                    "Text": "Head Of Group Stores",
                                    "Value": "Head Of Group Stores"
                                },
                                {
                                    "Text": "Head Of Human Resources",
                                    "Value": "Head Of Human Resources"
                                },
                                {
                                    "Text": "Head Of Import & Export",
                                    "Value": "Head Of Import & Export"
                                },
                                {
                                    "Text": "Head Of Internal Audit",
                                    "Value": "Head Of Internal Audit"
                                },
                                {
                                    "Text": "Head Of Lecturer",
                                    "Value": "Head Of Lecturer"
                                },
                                {
                                    "Text": "Head Of Municipality",
                                    "Value": "Head Of Municipality"
                                },
                                {
                                    "Text": "Head Office Manager",
                                    "Value": "Head Office Manager"
                                },
                                {
                                    "Text": "Head Operations",
                                    "Value": "Head Operations"
                                },
                                {
                                    "Text": "Head Peon",
                                    "Value": "Head Peon"
                                },
                                {
                                    "Text": "Head Pharmacist",
                                    "Value": "Head Pharmacist"
                                },
                                {
                                    "Text": "Head Project Management",
                                    "Value": "Head Project Management"
                                },
                                {
                                    "Text": "Head Project Manager",
                                    "Value": "Head Project Manager"
                                },
                                {
                                    "Text": "Head TTE",
                                    "Value": "Head TTE"
                                },
                                {
                                    "Text": "Health Assistant",
                                    "Value": "Health Assistant"
                                },
                                {
                                    "Text": "Health Inspector Grade I",
                                    "Value": "Health Inspector Grade I"
                                },
                                {
                                    "Text": "Health Officer",
                                    "Value": "Health Officer"
                                },
                                {
                                    "Text": "Health Supervisor",
                                    "Value": "Health Supervisor"
                                },
                                {
                                    "Text": "Health Worker",
                                    "Value": "Health Worker"
                                },
                                {
                                    "Text": "Hero Honda Agency Owner",
                                    "Value": "Hero Honda Agency Owner"
                                },
                                {
                                    "Text": "Head Of Department Commerce",
                                    "Value": "Head Of Department Commerce"
                                },
                                {
                                    "Text": "Head Graphics",
                                    "Value": "Head Graphics"
                                },
                                {
                                    "Text": "Head",
                                    "Value": "Head"
                                },
                                {
                                    "Text": "Head Prepaid Cards",
                                    "Value": "Head Prepaid Cards"
                                },
                                {
                                    "Text": "Head Alternate Channel",
                                    "Value": "Head Alternate Channel"
                                },
                                {
                                    "Text": "Head Cashier",
                                    "Value": "Head Cashier"
                                },
                                {
                                    "Text": "Head-Portfolio Management Serv",
                                    "Value": "Head-Portfolio Management Serv"
                                },
                                {
                                    "Text": "Head Corporate Quality Engg",
                                    "Value": "Head Corporate Quality Engg"
                                },
                                {
                                    "Text": "Head HR",
                                    "Value": "Head HR"
                                },
                                {
                                    "Text": "Head HR & Admin",
                                    "Value": "Head HR & Admin"
                                },
                                {
                                    "Text": "Head IT",
                                    "Value": "Head IT"
                                },
                                {
                                    "Text": "Head Banking",
                                    "Value": "Head Banking"
                                },
                                {
                                    "Text": "Head Loan Operations",
                                    "Value": "Head Loan Operations"
                                },
                                {
                                    "Text": "Head International Wealth Mgnt",
                                    "Value": "Head International Wealth Mgnt"
                                },
                                {
                                    "Text": "Head Corporate Communication",
                                    "Value": "Head Corporate Communication"
                                },
                                {
                                    "Text": "Head PA",
                                    "Value": "Head PA"
                                },
                                {
                                    "Text": "Hepler",
                                    "Value": "Hepler"
                                },
                                {
                                    "Text": "Head EVPS",
                                    "Value": "Head EVPS"
                                },
                                {
                                    "Text": "Head Of Mechanical Dept",
                                    "Value": "Head Of Mechanical Dept"
                                },
                                {
                                    "Text": "Head IT Support",
                                    "Value": "Head IT Support"
                                },
                                {
                                    "Text": "Head Of Department Chemistry",
                                    "Value": "Head Of Department Chemistry"
                                },
                                {
                                    "Text": "Head Bio Analyst",
                                    "Value": "Head Bio Analyst"
                                },
                                {
                                    "Text": "Head Logistics & Administratn",
                                    "Value": "Head Logistics & Administratn"
                                },
                                {
                                    "Text": "Head Corporate Quality",
                                    "Value": "Head Corporate Quality"
                                },
                                {
                                    "Text": "Head Corporate Support Group",
                                    "Value": "Head Corporate Support Group"
                                },
                                {
                                    "Text": "Head Welder",
                                    "Value": "Head Welder"
                                },
                                {
                                    "Text": "Head Business Development",
                                    "Value": "Head Business Development"
                                },
                                {
                                    "Text": "Head Goods Clerk",
                                    "Value": "Head Goods Clerk"
                                },
                                {
                                    "Text": "Head Marketing & Alliances",
                                    "Value": "Head Marketing & Alliances"
                                },
                                {
                                    "Text": "Head Mechanical Department",
                                    "Value": "Head Mechanical Department"
                                },
                                {
                                    "Text": "Hindi Typist",
                                    "Value": "Hindi Typist"
                                },
                                {
                                    "Text": "High Skilled Technician",
                                    "Value": "High Skilled Technician"
                                },
                                {
                                    "Text": "Higher Secondary School Teachr",
                                    "Value": "Higher Secondary School Teachr"
                                },
                                {
                                    "Text": "Higher Grade Assistant",
                                    "Value": "Higher Grade Assistant"
                                },
                                {
                                    "Text": "Historian",
                                    "Value": "Historian"
                                },
                                {
                                    "Text": "Head Legal and Company",
                                    "Value": "Head Legal and Company"
                                },
                                {
                                    "Text": "HOD English Department",
                                    "Value": "HOD English Department"
                                },
                                {
                                    "Text": "Home Loan Agent",
                                    "Value": "Home Loan Agent"
                                },
                                {
                                    "Text": "Home Tutor",
                                    "Value": "Home Tutor"
                                },
                                {
                                    "Text": "Homeopathic Consultant",
                                    "Value": "Homeopathic Consultant"
                                },
                                {
                                    "Text": "Homeopathic Doctor Consultant",
                                    "Value": "Homeopathic Doctor Consultant"
                                },
                                {
                                    "Text": "Homeopathic Physician",
                                    "Value": "Homeopathic Physician"
                                },
                                {
                                    "Text": "Hosiery Agent",
                                    "Value": "Hosiery Agent"
                                },
                                {
                                    "Text": "Hospital Incharge",
                                    "Value": "Hospital Incharge"
                                },
                                {
                                    "Text": "Hospital Nurse",
                                    "Value": "Hospital Nurse"
                                },
                                {
                                    "Text": "Hostel Superintendent",
                                    "Value": "Hostel Superintendent"
                                },
                                {
                                    "Text": "HOD Electrical",
                                    "Value": "HOD Electrical"
                                },
                                {
                                    "Text": "House Officer Doctor",
                                    "Value": "House Officer Doctor"
                                },
                                {
                                    "Text": "Home Physician",
                                    "Value": "Home Physician"
                                },
                                {
                                    "Text": "Housewife & Rental Income",
                                    "Value": "Housewife & Rental Income"
                                },
                                {
                                    "Text": "Hospital Attendant",
                                    "Value": "Hospital Attendant"
                                },
                                {
                                    "Text": "HOD Commerce",
                                    "Value": "HOD Commerce"
                                },
                                {
                                    "Text": "Hockey Coach",
                                    "Value": "Hockey Coach"
                                },
                                {
                                    "Text": "HOD in Mathematics",
                                    "Value": "HOD in Mathematics"
                                },
                                {
                                    "Text": "Hostel Welfare Officer",
                                    "Value": "Hostel Welfare Officer"
                                },
                                {
                                    "Text": "Hotel Incharge",
                                    "Value": "Hotel Incharge"
                                },
                                {
                                    "Text": "Home Guard",
                                    "Value": "Home Guard"
                                },
                                {
                                    "Text": "HOD Pharmacology",
                                    "Value": "HOD Pharmacology"
                                },
                                {
                                    "Text": "Housemaid",
                                    "Value": "Housemaid"
                                },
                                {
                                    "Text": "Hotel & Restaurant Chef",
                                    "Value": "Hotel & Restaurant Chef"
                                },
                                {
                                    "Text": "Night club dancer",
                                    "Value": "Night club dancer"
                                },
                                {
                                    "Text": "Housewife & Interest Income",
                                    "Value": "Housewife & Interest Income"
                                },
                                {
                                    "Text": "HOD",
                                    "Value": "HOD"
                                },
                                {
                                    "Text": "Home Loan Counselor",
                                    "Value": "Home Loan Counselor"
                                },
                                {
                                    "Text": "Home Nurse",
                                    "Value": "Home Nurse"
                                },
                                {
                                    "Text": "Hospital Care-Taker",
                                    "Value": "Hospital Care-Taker"
                                },
                                {
                                    "Text": "Canteen manager",
                                    "Value": "Canteen manager"
                                },
                                {
                                    "Text": "Bouncer",
                                    "Value": "Bouncer"
                                },
                                {
                                    "Text": "Hotel & Restaurant Waiters",
                                    "Value": "Hotel & Restaurant Waiters"
                                },
                                {
                                    "Text": "Hotel Owner",
                                    "Value": "Hotel Owner"
                                },
                                {
                                    "Text": "Housewife & Investment Income",
                                    "Value": "Housewife & Investment Income"
                                },
                                {
                                    "Text": "HR Advisor",
                                    "Value": "HR Advisor"
                                },
                                {
                                    "Text": "HR Director",
                                    "Value": "HR Director"
                                },
                                {
                                    "Text": "HR Officer",
                                    "Value": "HR Officer"
                                },
                                {
                                    "Text": "HR Senior Supervisor",
                                    "Value": "HR Senior Supervisor"
                                },
                                {
                                    "Text": "HRD Consultant",
                                    "Value": "HRD Consultant"
                                },
                                {
                                    "Text": "HRD Manager",
                                    "Value": "HRD Manager"
                                },
                                {
                                    "Text": "HR Manager",
                                    "Value": "HR Manager"
                                },
                                {
                                    "Text": "HR Consultant",
                                    "Value": "HR Consultant"
                                },
                                {
                                    "Text": "Human Resource Officer",
                                    "Value": "Human Resource Officer"
                                },
                                {
                                    "Text": "HR Coordinator",
                                    "Value": "HR Coordinator"
                                },
                                {
                                    "Text": "HR Analyst",
                                    "Value": "HR Analyst"
                                },
                                {
                                    "Text": "HR Executive",
                                    "Value": "HR Executive"
                                },
                                {
                                    "Text": "Housekeeping Clerk",
                                    "Value": "Housekeeping Clerk"
                                },
                                {
                                    "Text": "Houseman",
                                    "Value": "Houseman"
                                },
                                {
                                    "Text": "House Officer",
                                    "Value": "House Officer"
                                },
                                {
                                    "Text": "Housewife",
                                    "Value": "Housewife"
                                },
                                {
                                    "Text": "HUF Member",
                                    "Value": "HUF Member"
                                },
                                {
                                    "Text": "Hutch Shop Manager",
                                    "Value": "Hutch Shop Manager"
                                },
                                {
                                    "Text": "Human Resource Specialist",
                                    "Value": "Human Resource Specialist"
                                },
                                {
                                    "Text": "HUF Karta",
                                    "Value": "HUF Karta"
                                },
                                {
                                    "Text": "Hydrogeologist",
                                    "Value": "Hydrogeologist"
                                },
                                {
                                    "Text": "Idea Distributor",
                                    "Value": "Idea Distributor"
                                },
                                {
                                    "Text": "Image Consultant/Comp Graphics",
                                    "Value": "Image Consultant/Comp Graphics"
                                },
                                {
                                    "Text": "Importer & Exporter",
                                    "Value": "Importer & Exporter"
                                },
                                {
                                    "Text": "Immigration Officer",
                                    "Value": "Immigration Officer"
                                },
                                {
                                    "Text": "Import Export Business",
                                    "Value": "Import Export Business"
                                },
                                {
                                    "Text": "Inc From House Proprty/Interst",
                                    "Value": "Inc From House Proprty/Interst"
                                },
                                {
                                    "Text": "Income Auditor",
                                    "Value": "Income Auditor"
                                },
                                {
                                    "Text": "Incharge Head",
                                    "Value": "Incharge Head"
                                },
                                {
                                    "Text": "Income From Interest",
                                    "Value": "Income From Interest"
                                },
                                {
                                    "Text": "Income From Interest & Shares",
                                    "Value": "Income From Interest & Shares"
                                },
                                {
                                    "Text": "Income From Investment",
                                    "Value": "Income From Investment"
                                },
                                {
                                    "Text": "Income From Land & Property",
                                    "Value": "Income From Land & Property"
                                },
                                {
                                    "Text": "Income From Rent & Interest",
                                    "Value": "Income From Rent & Interest"
                                },
                                {
                                    "Text": "Income Taxation Advocate",
                                    "Value": "Income Taxation Advocate"
                                },
                                {
                                    "Text": "Independent Sales Officer",
                                    "Value": "Independent Sales Officer"
                                },
                                {
                                    "Text": "Incharge Principal",
                                    "Value": "Incharge Principal"
                                },
                                {
                                    "Text": "Indian Naval Commander",
                                    "Value": "Indian Naval Commander"
                                },
                                {
                                    "Text": "Indian Naval Officer Commander",
                                    "Value": "Indian Naval Officer Commander"
                                },
                                {
                                    "Text": "Individual Estate Agent",
                                    "Value": "Individual Estate Agent"
                                },
                                {
                                    "Text": "Army Engineer",
                                    "Value": "Army Engineer"
                                },
                                {
                                    "Text": "Assistant System Engineer",
                                    "Value": "Assistant System Engineer"
                                },
                                {
                                    "Text": "Individual Trader",
                                    "Value": "Individual Trader"
                                },
                                {
                                    "Text": "Industrial Engineer",
                                    "Value": "Industrial Engineer"
                                },
                                {
                                    "Text": "Inspector Income Tax",
                                    "Value": "Inspector Income Tax"
                                },
                                {
                                    "Text": "Information Associate",
                                    "Value": "Information Associate"
                                },
                                {
                                    "Text": "Information Manager",
                                    "Value": "Information Manager"
                                },
                                {
                                    "Text": "Information Officer",
                                    "Value": "Information Officer"
                                },
                                {
                                    "Text": "Infrastructre Managmnt Analyst",
                                    "Value": "Infrastructre Managmnt Analyst"
                                },
                                {
                                    "Text": "Inspection & Maintanance Engg.",
                                    "Value": "Inspection & Maintanance Engg."
                                },
                                {
                                    "Text": "Inspection Engineer",
                                    "Value": "Inspection Engineer"
                                },
                                {
                                    "Text": "Instrumentation Engineer",
                                    "Value": "Instrumentation Engineer"
                                },
                                {
                                    "Text": "Instrumentl Maintence Inchrge",
                                    "Value": "Instrumentl Maintence Inchrge"
                                },
                                {
                                    "Text": "Insurance & Investnt Consultnt",
                                    "Value": "Insurance & Investnt Consultnt"
                                },
                                {
                                    "Text": "Insurance & Tax Consultant",
                                    "Value": "Insurance & Tax Consultant"
                                },
                                {
                                    "Text": "Insurance Advisr & Prop Dealer",
                                    "Value": "Insurance Advisr & Prop Dealer"
                                },
                                {
                                    "Text": "Insurance Associate",
                                    "Value": "Insurance Associate"
                                },
                                {
                                    "Text": "Insurance Associate Agent",
                                    "Value": "Insurance Associate Agent"
                                },
                                {
                                    "Text": "Insurance Manager",
                                    "Value": "Insurance Manager"
                                },
                                {
                                    "Text": "Insurance Medical Officer",
                                    "Value": "Insurance Medical Officer"
                                },
                                {
                                    "Text": "Insurance Officer",
                                    "Value": "Insurance Officer"
                                },
                                {
                                    "Text": "Insurance Surveyor",
                                    "Value": "Insurance Surveyor"
                                },
                                {
                                    "Text": "Interest Earner",
                                    "Value": "Interest Earner"
                                },
                                {
                                    "Text": "Interest Income & Rental Inc.",
                                    "Value": "Interest Income & Rental Inc."
                                },
                                {
                                    "Text": "Interior Contractor",
                                    "Value": "Interior Contractor"
                                },
                                {
                                    "Text": "Interior Designer",
                                    "Value": "Interior Designer"
                                },
                                {
                                    "Text": "Internal Auditor",
                                    "Value": "Internal Auditor"
                                },
                                {
                                    "Text": "Internet Coordinator",
                                    "Value": "Internet Coordinator"
                                },
                                {
                                    "Text": "Interventional Cardiologist",
                                    "Value": "Interventional Cardiologist"
                                },
                                {
                                    "Text": "Intranet Engineer",
                                    "Value": "Intranet Engineer"
                                },
                                {
                                    "Text": "Investment & Pension Income",
                                    "Value": "Investment & Pension Income"
                                },
                                {
                                    "Text": "Investment Banker",
                                    "Value": "Investment Banker"
                                },
                                {
                                    "Text": "Investment Consultant",
                                    "Value": "Investment Consultant"
                                },
                                {
                                    "Text": "Investment Counsellor",
                                    "Value": "Investment Counsellor"
                                },
                                {
                                    "Text": "Investment Officer",
                                    "Value": "Investment Officer"
                                },
                                {
                                    "Text": "Investor & Farmer",
                                    "Value": "Investor & Farmer"
                                },
                                {
                                    "Text": "Investor & Proprietor",
                                    "Value": "Investor & Proprietor"
                                },
                                {
                                    "Text": "Income Accountant",
                                    "Value": "Income Accountant"
                                },
                                {
                                    "Text": "Interior Decorators",
                                    "Value": "Interior Decorators"
                                },
                                {
                                    "Text": "Interest Income & Landlady",
                                    "Value": "Interest Income & Landlady"
                                },
                                {
                                    "Text": "Income Tax Practitioner",
                                    "Value": "Income Tax Practitioner"
                                },
                                {
                                    "Text": "Incharge Stores",
                                    "Value": "Incharge Stores"
                                },
                                {
                                    "Text": "Interest Income & Housewife",
                                    "Value": "Interest Income & Housewife"
                                },
                                {
                                    "Text": "Information Technology",
                                    "Value": "Information Technology"
                                },
                                {
                                    "Text": "Incharge",
                                    "Value": "Incharge"
                                },
                                {
                                    "Text": "Integrated Buss Developmnt Mgr",
                                    "Value": "Integrated Buss Developmnt Mgr"
                                },
                                {
                                    "Text": "In-house Detective",
                                    "Value": "In-house Detective"
                                },
                                {
                                    "Text": "Insurance Agent LIC",
                                    "Value": "Insurance Agent LIC"
                                },
                                {
                                    "Text": "Insurance Med Officer Grade II",
                                    "Value": "Insurance Med Officer Grade II"
                                },
                                {
                                    "Text": "Interest & Rental Income",
                                    "Value": "Interest & Rental Income"
                                },
                                {
                                    "Text": "Income From Agriculture Land",
                                    "Value": "Income From Agriculture Land"
                                },
                                {
                                    "Text": "Income From Share Trading",
                                    "Value": "Income From Share Trading"
                                },
                                {
                                    "Text": "Income From Capital Gains",
                                    "Value": "Income From Capital Gains"
                                },
                                {
                                    "Text": "Income Tax Consultant",
                                    "Value": "Income Tax Consultant"
                                },
                                {
                                    "Text": "Insurance Sales Officer",
                                    "Value": "Insurance Sales Officer"
                                },
                                {
                                    "Text": "Inspector Communication",
                                    "Value": "Inspector Communication"
                                },
                                {
                                    "Text": "Income Tax Inspector",
                                    "Value": "Income Tax Inspector"
                                },
                                {
                                    "Text": "Inward/Outward Executive",
                                    "Value": "Inward/Outward Executive"
                                },
                                {
                                    "Text": "Infrastructure Specialst Compu",
                                    "Value": "Infrastructure Specialst Compu"
                                },
                                {
                                    "Text": "Inspector Central Excise",
                                    "Value": "Inspector Central Excise"
                                },
                                {
                                    "Text": "Investment Business",
                                    "Value": "Investment Business"
                                },
                                {
                                    "Text": "Instructor",
                                    "Value": "Instructor"
                                },
                                {
                                    "Text": "Income Tax Lawyer & Advocate",
                                    "Value": "Income Tax Lawyer & Advocate"
                                },
                                {
                                    "Text": "Interpreter",
                                    "Value": "Interpreter"
                                },
                                {
                                    "Text": "Interviewer",
                                    "Value": "Interviewer"
                                },
                                {
                                    "Text": "Income From House Property",
                                    "Value": "Income From House Property"
                                },
                                {
                                    "Text": "Inventory Executive",
                                    "Value": "Inventory Executive"
                                },
                                {
                                    "Text": "Income From Coaching Classes",
                                    "Value": "Income From Coaching Classes"
                                },
                                {
                                    "Text": "Independnt Financial Consultnt",
                                    "Value": "Independnt Financial Consultnt"
                                },
                                {
                                    "Text": "Indian Naval Officer",
                                    "Value": "Indian Naval Officer"
                                },
                                {
                                    "Text": "Individual Sales Officer",
                                    "Value": "Individual Sales Officer"
                                },
                                {
                                    "Text": "Individual Stock Trader",
                                    "Value": "Individual Stock Trader"
                                },
                                {
                                    "Text": "Industry Officer",
                                    "Value": "Industry Officer"
                                },
                                {
                                    "Text": "Infinite quality Analyst",
                                    "Value": "Infinite quality Analyst"
                                },
                                {
                                    "Text": "Iron Merchant",
                                    "Value": "Iron Merchant"
                                },
                                {
                                    "Text": "Isabela Occupation",
                                    "Value": "Isabela Occupation"
                                },
                                {
                                    "Text": "Insecticide industry",
                                    "Value": "Insecticide industry"
                                },
                                {
                                    "Text": "IT Support Specialist",
                                    "Value": "IT Support Specialist"
                                },
                                {
                                    "Text": "IT Analyst",
                                    "Value": "IT Analyst"
                                },
                                {
                                    "Text": "IT Analyst Executive",
                                    "Value": "IT Analyst Executive"
                                },
                                {
                                    "Text": "Inventory Assistant",
                                    "Value": "Inventory Assistant"
                                },
                                {
                                    "Text": "Investment Analyst",
                                    "Value": "Investment Analyst"
                                },
                                {
                                    "Text": "Jackpot Attendant",
                                    "Value": "Jackpot Attendant"
                                },
                                {
                                    "Text": "Jewellery Shop Owner",
                                    "Value": "Jewellery Shop Owner"
                                },
                                {
                                    "Text": "Joint Commissioner",
                                    "Value": "Joint Commissioner"
                                },
                                {
                                    "Text": "Joint General Manager",
                                    "Value": "Joint General Manager"
                                },
                                {
                                    "Text": "Joint Manager",
                                    "Value": "Joint Manager"
                                },
                                {
                                    "Text": "Joint Managing Director",
                                    "Value": "Joint Managing Director"
                                },
                                {
                                    "Text": "Joint Partner",
                                    "Value": "Joint Partner"
                                },
                                {
                                    "Text": "Joint Proprietor",
                                    "Value": "Joint Proprietor"
                                },
                                {
                                    "Text": "Joint Treasurer",
                                    "Value": "Joint Treasurer"
                                },
                                {
                                    "Text": "Joint Venture Partner",
                                    "Value": "Joint Venture Partner"
                                },
                                {
                                    "Text": "Jockey",
                                    "Value": "Jockey"
                                },
                                {
                                    "Text": "Joint Chief Engineer",
                                    "Value": "Joint Chief Engineer"
                                },
                                {
                                    "Text": "Political correspondent",
                                    "Value": "Political correspondent"
                                },
                                {
                                    "Text": "News editor",
                                    "Value": "News editor"
                                },
                                {
                                    "Text": "Newspaper interviewer",
                                    "Value": "Newspaper interviewer"
                                },
                                {
                                    "Text": "Jointer",
                                    "Value": "Jointer"
                                },
                                {
                                    "Text": "Magazine subeditor",
                                    "Value": "Magazine subeditor"
                                },
                                {
                                    "Text": "Joint Director",
                                    "Value": "Joint Director"
                                },
                                {
                                    "Text": "Joint Director Agriculture",
                                    "Value": "Joint Director Agriculture"
                                },
                                {
                                    "Text": "Joint secretary",
                                    "Value": "Joint secretary"
                                },
                                {
                                    "Text": "Journalist",
                                    "Value": "Journalist"
                                },
                                {
                                    "Text": "Junior Research Fellow",
                                    "Value": "Junior Research Fellow"
                                },
                                {
                                    "Text": "Junior Administrative Assistnt",
                                    "Value": "Junior Administrative Assistnt"
                                },
                                {
                                    "Text": "Junior Administrative Officer",
                                    "Value": "Junior Administrative Officer"
                                },
                                {
                                    "Text": "Junior Agricultural Assistant",
                                    "Value": "Junior Agricultural Assistant"
                                },
                                {
                                    "Text": "Junior Assistant Accountant",
                                    "Value": "Junior Assistant Accountant"
                                },
                                {
                                    "Text": "Junior Clerk",
                                    "Value": "Junior Clerk"
                                },
                                {
                                    "Text": "Junior College Teacher",
                                    "Value": "Junior College Teacher"
                                },
                                {
                                    "Text": "Junior Commercial Officer",
                                    "Value": "Junior Commercial Officer"
                                },
                                {
                                    "Text": "Junior Commission Officer",
                                    "Value": "Junior Commission Officer"
                                },
                                {
                                    "Text": "Junior Manager Electrical",
                                    "Value": "Junior Manager Electrical"
                                },
                                {
                                    "Text": "Junior Doctor",
                                    "Value": "Junior Doctor"
                                },
                                {
                                    "Text": "Junior Technician",
                                    "Value": "Junior Technician"
                                },
                                {
                                    "Text": "Junior Engineer Civil",
                                    "Value": "Junior Engineer Civil"
                                },
                                {
                                    "Text": "Junior Engineer Grade I",
                                    "Value": "Junior Engineer Grade I"
                                },
                                {
                                    "Text": "Junior Health Assistant",
                                    "Value": "Junior Health Assistant"
                                },
                                {
                                    "Text": "Junior Input & Output Assistnt",
                                    "Value": "Junior Input & Output Assistnt"
                                },
                                {
                                    "Text": "Junior Lawyer",
                                    "Value": "Junior Lawyer"
                                },
                                {
                                    "Text": "Junior Manager",
                                    "Value": "Junior Manager"
                                },
                                {
                                    "Text": "Junior Manager Mechanical",
                                    "Value": "Junior Manager Mechanical"
                                },
                                {
                                    "Text": "Junior Marketing Officer",
                                    "Value": "Junior Marketing Officer"
                                },
                                {
                                    "Text": "Junior Office Assistant",
                                    "Value": "Junior Office Assistant"
                                },
                                {
                                    "Text": "Junior Personnel Officer",
                                    "Value": "Junior Personnel Officer"
                                },
                                {
                                    "Text": "Junior Phone Banking Officer",
                                    "Value": "Junior Phone Banking Officer"
                                },
                                {
                                    "Text": "Junior Processing Officer",
                                    "Value": "Junior Processing Officer"
                                },
                                {
                                    "Text": "Junior Programmer",
                                    "Value": "Junior Programmer"
                                },
                                {
                                    "Text": "Junior Radio Engineer",
                                    "Value": "Junior Radio Engineer"
                                },
                                {
                                    "Text": "Junior Radio Officer",
                                    "Value": "Junior Radio Officer"
                                },
                                {
                                    "Text": "Junior Research Officer",
                                    "Value": "Junior Research Officer"
                                },
                                {
                                    "Text": "Junior Resident",
                                    "Value": "Junior Resident"
                                },
                                {
                                    "Text": "Junior Resident Doctor",
                                    "Value": "Junior Resident Doctor"
                                },
                                {
                                    "Text": "Junior Resident Officer",
                                    "Value": "Junior Resident Officer"
                                },
                                {
                                    "Text": "Junior Section Officer",
                                    "Value": "Junior Section Officer"
                                },
                                {
                                    "Text": "Junior Specialist",
                                    "Value": "Junior Specialist"
                                },
                                {
                                    "Text": "Junior Technician Cum Operator",
                                    "Value": "Junior Technician Cum Operator"
                                },
                                {
                                    "Text": "Junior Telecom Officer",
                                    "Value": "Junior Telecom Officer"
                                },
                                {
                                    "Text": "Junior Translator",
                                    "Value": "Junior Translator"
                                },
                                {
                                    "Text": "Junior Warrant Officer",
                                    "Value": "Junior Warrant Officer"
                                },
                                {
                                    "Text": "Junior Works Manager",
                                    "Value": "Junior Works Manager"
                                },
                                {
                                    "Text": "Junior Architect",
                                    "Value": "Junior Architect"
                                },
                                {
                                    "Text": "Judge",
                                    "Value": "Judge"
                                },
                                {
                                    "Text": "Junior Officer Personnel",
                                    "Value": "Junior Officer Personnel"
                                },
                                {
                                    "Text": "Junior Lecturer",
                                    "Value": "Junior Lecturer"
                                },
                                {
                                    "Text": "Junior Manager Services",
                                    "Value": "Junior Manager Services"
                                },
                                {
                                    "Text": "Junior Staff",
                                    "Value": "Junior Staff"
                                },
                                {
                                    "Text": "Junior Engineer Grade II",
                                    "Value": "Junior Engineer Grade II"
                                },
                                {
                                    "Text": "Junior Manager Civil",
                                    "Value": "Junior Manager Civil"
                                },
                                {
                                    "Text": "Junior Officer Processing",
                                    "Value": "Junior Officer Processing"
                                },
                                {
                                    "Text": "Junior Accountant",
                                    "Value": "Junior Accountant"
                                },
                                {
                                    "Text": "Junior Engineer Automation",
                                    "Value": "Junior Engineer Automation"
                                },
                                {
                                    "Text": "Junior Director",
                                    "Value": "Junior Director"
                                },
                                {
                                    "Text": "Junior Accounts Clerk",
                                    "Value": "Junior Accounts Clerk"
                                },
                                {
                                    "Text": "Junior Digital Artist",
                                    "Value": "Junior Digital Artist"
                                },
                                {
                                    "Text": "Junior Associate",
                                    "Value": "Junior Associate"
                                },
                                {
                                    "Text": "Junior Executive",
                                    "Value": "Junior Executive"
                                },
                                {
                                    "Text": "Junior Officer Technical Servs",
                                    "Value": "Junior Officer Technical Servs"
                                },
                                {
                                    "Text": "Junior Consultant",
                                    "Value": "Junior Consultant"
                                },
                                {
                                    "Text": "Junior Engineer",
                                    "Value": "Junior Engineer"
                                },
                                {
                                    "Text": "Jeweler",
                                    "Value": "Jeweler"
                                },
                                {
                                    "Text": "Karta & Proprietor",
                                    "Value": "Karta & Proprietor"
                                },
                                {
                                    "Text": "Karta",
                                    "Value": "Karta"
                                },
                                {
                                    "Text": "Karta HUF",
                                    "Value": "Karta HUF"
                                },
                                {
                                    "Text": "Keeper",
                                    "Value": "Keeper"
                                },
                                {
                                    "Text": "Key Accounts Manager",
                                    "Value": "Key Accounts Manager"
                                },
                                {
                                    "Text": "Kennel Assistant",
                                    "Value": "Kennel Assistant"
                                },
                                {
                                    "Text": "Kerosene & Vegetable Agent",
                                    "Value": "Kerosene & Vegetable Agent"
                                },
                                {
                                    "Text": "Kerosene Vendor",
                                    "Value": "Kerosene Vendor"
                                },
                                {
                                    "Text": "Kiln Attendant",
                                    "Value": "Kiln Attendant"
                                },
                                {
                                    "Text": "Kiln Operator",
                                    "Value": "Kiln Operator"
                                },
                                {
                                    "Text": "Kirana Business",
                                    "Value": "Kirana Business"
                                },
                                {
                                    "Text": "Kiln Worker",
                                    "Value": "Kiln Worker"
                                },
                                {
                                    "Text": "KTV Receptionist",
                                    "Value": "KTV Receptionist"
                                },
                                {
                                    "Text": "Lab Officer",
                                    "Value": "Lab Officer"
                                },
                                {
                                    "Text": "Labour Contractor & Proprietor",
                                    "Value": "Labour Contractor & Proprietor"
                                },
                                {
                                    "Text": "Labour Officer",
                                    "Value": "Labour Officer"
                                },
                                {
                                    "Text": "Ladies Tailor",
                                    "Value": "Ladies Tailor"
                                },
                                {
                                    "Text": "Land Developer",
                                    "Value": "Land Developer"
                                },
                                {
                                    "Text": "Land Owner",
                                    "Value": "Land Owner"
                                },
                                {
                                    "Text": "Land Owner & Farmer",
                                    "Value": "Land Owner & Farmer"
                                },
                                {
                                    "Text": "Landlord & Owner",
                                    "Value": "Landlord & Owner"
                                },
                                {
                                    "Text": "Landlord Aquaculture",
                                    "Value": "Landlord Aquaculture"
                                },
                                {
                                    "Text": "Law Officer",
                                    "Value": "Law Officer"
                                },
                                {
                                    "Text": "Lawyer Practitioner",
                                    "Value": "Lawyer Practitioner"
                                },
                                {
                                    "Text": "Lab Technician",
                                    "Value": "Lab Technician"
                                },
                                {
                                    "Text": "Lab Attandant",
                                    "Value": "Lab Attandant"
                                },
                                {
                                    "Text": "Labourer",
                                    "Value": "Labourer"
                                },
                                {
                                    "Text": "Laboratory Technician",
                                    "Value": "Laboratory Technician"
                                },
                                {
                                    "Text": "Labour Commissioner",
                                    "Value": "Labour Commissioner"
                                },
                                {
                                    "Text": "lacquerer",
                                    "Value": "lacquerer"
                                },
                                {
                                    "Text": "Lead Developer",
                                    "Value": "Lead Developer"
                                },
                                {
                                    "Text": "Labour Enforcement Officer",
                                    "Value": "Labour Enforcement Officer"
                                },
                                {
                                    "Text": "Labour Inspector",
                                    "Value": "Labour Inspector"
                                },
                                {
                                    "Text": "Laminator",
                                    "Value": "Laminator"
                                },
                                {
                                    "Text": "Labour Contractor",
                                    "Value": "Labour Contractor"
                                },
                                {
                                    "Text": "Land Owner & Agriculture",
                                    "Value": "Land Owner & Agriculture"
                                },
                                {
                                    "Text": "Landlord Agriculturist",
                                    "Value": "Landlord Agriculturist"
                                },
                                {
                                    "Text": "Labour Supplier",
                                    "Value": "Labour Supplier"
                                },
                                {
                                    "Text": "Lawyer & Advocate",
                                    "Value": "Lawyer & Advocate"
                                },
                                {
                                    "Text": "Lathe Operator",
                                    "Value": "Lathe Operator"
                                },
                                {
                                    "Text": "Lawyer Human Rights",
                                    "Value": "Lawyer Human Rights"
                                },
                                {
                                    "Text": "Laundrymen",
                                    "Value": "Laundrymen"
                                },
                                {
                                    "Text": "Lawyer",
                                    "Value": "Lawyer"
                                },
                                {
                                    "Text": "Layout Artist",
                                    "Value": "Layout Artist"
                                },
                                {
                                    "Text": "Lecturer",
                                    "Value": "Lecturer"
                                },
                                {
                                    "Text": "LDC",
                                    "Value": "LDC"
                                },
                                {
                                    "Text": "Leading Hostess",
                                    "Value": "Leading Hostess"
                                },
                                {
                                    "Text": "LD Clerk",
                                    "Value": "LD Clerk"
                                },
                                {
                                    "Text": "LD Typist",
                                    "Value": "LD Typist"
                                },
                                {
                                    "Text": "Land Surveyor",
                                    "Value": "Land Surveyor"
                                },
                                {
                                    "Text": "Lead Piping Engineer",
                                    "Value": "Lead Piping Engineer"
                                },
                                {
                                    "Text": "Lead System Designer",
                                    "Value": "Lead System Designer"
                                },
                                {
                                    "Text": "Leather Commission Agent",
                                    "Value": "Leather Commission Agent"
                                },
                                {
                                    "Text": "Legal & Administration Advisor",
                                    "Value": "Legal & Administration Advisor"
                                },
                                {
                                    "Text": "Legal Manager",
                                    "Value": "Legal Manager"
                                },
                                {
                                    "Text": "Legal Officer",
                                    "Value": "Legal Officer"
                                },
                                {
                                    "Text": "Lekhpal",
                                    "Value": "Lekhpal"
                                },
                                {
                                    "Text": "Legal Advisor",
                                    "Value": "Legal Advisor"
                                },
                                {
                                    "Text": "Lead Cook",
                                    "Value": "Lead Cook"
                                },
                                {
                                    "Text": "Lecturer Retired",
                                    "Value": "Lecturer Retired"
                                },
                                {
                                    "Text": "Leading Medical Assistant",
                                    "Value": "Leading Medical Assistant"
                                },
                                {
                                    "Text": "Lecturer & Doctor",
                                    "Value": "Lecturer & Doctor"
                                },
                                {
                                    "Text": "Lead Sales Support",
                                    "Value": "Lead Sales Support"
                                },
                                {
                                    "Text": "Legal Practitioner Advocate",
                                    "Value": "Legal Practitioner Advocate"
                                },
                                {
                                    "Text": "Legal Practitioner",
                                    "Value": "Legal Practitioner"
                                },
                                {
                                    "Text": "Lift Attendant",
                                    "Value": "Lift Attendant"
                                },
                                {
                                    "Text": "Liaisoning Officer",
                                    "Value": "Liaisoning Officer"
                                },
                                {
                                    "Text": "Librarian Grade I",
                                    "Value": "Librarian Grade I"
                                },
                                {
                                    "Text": "Librarian Grade III",
                                    "Value": "Librarian Grade III"
                                },
                                {
                                    "Text": "LIC Agent",
                                    "Value": "LIC Agent"
                                },
                                {
                                    "Text": "Librarian",
                                    "Value": "Librarian"
                                },
                                {
                                    "Text": "Liaison Officer",
                                    "Value": "Liaison Officer"
                                },
                                {
                                    "Text": "Life Guard",
                                    "Value": "Life Guard"
                                },
                                {
                                    "Text": "Librarian Grade II",
                                    "Value": "Librarian Grade II"
                                },
                                {
                                    "Text": "Line Leader",
                                    "Value": "Line Leader"
                                },
                                {
                                    "Text": "Livestock Development Assistnt",
                                    "Value": "Livestock Development Assistnt"
                                },
                                {
                                    "Text": "License Inspector",
                                    "Value": "License Inspector"
                                },
                                {
                                    "Text": "Liner Executive",
                                    "Value": "Liner Executive"
                                },
                                {
                                    "Text": "Location Manager",
                                    "Value": "Location Manager"
                                },
                                {
                                    "Text": "Logistics Manager",
                                    "Value": "Logistics Manager"
                                },
                                {
                                    "Text": "Loco Pilot Indian Railway",
                                    "Value": "Loco Pilot Indian Railway"
                                },
                                {
                                    "Text": "Locker Room Attendant",
                                    "Value": "Locker Room Attendant"
                                },
                                {
                                    "Text": "Logistics Engineering",
                                    "Value": "Logistics Engineering"
                                },
                                {
                                    "Text": "Loco Pilot",
                                    "Value": "Loco Pilot"
                                },
                                {
                                    "Text": "Lower Division Clerk",
                                    "Value": "Lower Division Clerk"
                                },
                                {
                                    "Text": "Locksmith",
                                    "Value": "Locksmith"
                                },
                                {
                                    "Text": "Logistics Executive",
                                    "Value": "Logistics Executive"
                                },
                                {
                                    "Text": "Logistics Officer",
                                    "Value": "Logistics Officer"
                                },
                                {
                                    "Text": "Linen Room Attendant",
                                    "Value": "Linen Room Attendant"
                                },
                                {
                                    "Text": "Lab Technical Assistant",
                                    "Value": "Lab Technical Assistant"
                                },
                                {
                                    "Text": "Lt. Colonel",
                                    "Value": "Lt. Colonel"
                                },
                                {
                                    "Text": "Lt. Colonel Army",
                                    "Value": "Lt. Colonel Army"
                                },
                                {
                                    "Text": "Lt. Colonel Engineering",
                                    "Value": "Lt. Colonel Engineering"
                                },
                                {
                                    "Text": "Lt. Colonel Doctor",
                                    "Value": "Lt. Colonel Doctor"
                                },
                                {
                                    "Text": "Magistrate Class I",
                                    "Value": "Magistrate Class I"
                                },
                                {
                                    "Text": "Major Accounts Manager",
                                    "Value": "Major Accounts Manager"
                                },
                                {
                                    "Text": "Management Member",
                                    "Value": "Management Member"
                                },
                                {
                                    "Text": "Mamlatdar",
                                    "Value": "Mamlatdar"
                                },
                                {
                                    "Text": "Manager Branch",
                                    "Value": "Manager Branch"
                                },
                                {
                                    "Text": "Manager Channel Development",
                                    "Value": "Manager Channel Development"
                                },
                                {
                                    "Text": "Manager Commercial & Admin",
                                    "Value": "Manager Commercial & Admin"
                                },
                                {
                                    "Text": "Manager Commercial Department",
                                    "Value": "Manager Commercial Department"
                                },
                                {
                                    "Text": "Passenger officer",
                                    "Value": "Passenger officer"
                                },
                                {
                                    "Text": "Manager Corporate Finance",
                                    "Value": "Manager Corporate Finance"
                                },
                                {
                                    "Text": "Manager Cum Proprietor",
                                    "Value": "Manager Cum Proprietor"
                                },
                                {
                                    "Text": "Manager Customer Relation",
                                    "Value": "Manager Customer Relation"
                                },
                                {
                                    "Text": "Manager Customer Services",
                                    "Value": "Manager Customer Services"
                                },
                                {
                                    "Text": "Manager Customer Support",
                                    "Value": "Manager Customer Support"
                                },
                                {
                                    "Text": "Manager Design & Development",
                                    "Value": "Manager Design & Development"
                                },
                                {
                                    "Text": "Manager Designing",
                                    "Value": "Manager Designing"
                                },
                                {
                                    "Text": "Manager Development",
                                    "Value": "Manager Development"
                                },
                                {
                                    "Text": "Manager Direct Sales",
                                    "Value": "Manager Direct Sales"
                                },
                                {
                                    "Text": "Manager Distribution",
                                    "Value": "Manager Distribution"
                                },
                                {
                                    "Text": "Manager Education",
                                    "Value": "Manager Education"
                                },
                                {
                                    "Text": "Manager Electrical",
                                    "Value": "Manager Electrical"
                                },
                                {
                                    "Text": "Manager Eng Construction",
                                    "Value": "Manager Eng Construction"
                                },
                                {
                                    "Text": "Manager Engineering",
                                    "Value": "Manager Engineering"
                                },
                                {
                                    "Text": "Manager Enterprise Sales",
                                    "Value": "Manager Enterprise Sales"
                                },
                                {
                                    "Text": "Manager Export & Import",
                                    "Value": "Manager Export & Import"
                                },
                                {
                                    "Text": "Manager Exports",
                                    "Value": "Manager Exports"
                                },
                                {
                                    "Text": "Manager Finance",
                                    "Value": "Manager Finance"
                                },
                                {
                                    "Text": "Manager Finance & Accounts",
                                    "Value": "Manager Finance & Accounts"
                                },
                                {
                                    "Text": "Machinery Cleaner",
                                    "Value": "Machinery Cleaner"
                                },
                                {
                                    "Text": "Manager Financial Reporting",
                                    "Value": "Manager Financial Reporting"
                                },
                                {
                                    "Text": "Manager Accounts & Finance",
                                    "Value": "Manager Accounts & Finance"
                                },
                                {
                                    "Text": "Manager HRD",
                                    "Value": "Manager HRD"
                                },
                                {
                                    "Text": "Machinist",
                                    "Value": "Machinist"
                                },
                                {
                                    "Text": "Manager Improvement",
                                    "Value": "Manager Improvement"
                                },
                                {
                                    "Text": "Manager Installed Business",
                                    "Value": "Manager Installed Business"
                                },
                                {
                                    "Text": "Manager Institutional Sales",
                                    "Value": "Manager Institutional Sales"
                                },
                                {
                                    "Text": "Manager Instrumentation",
                                    "Value": "Manager Instrumentation"
                                },
                                {
                                    "Text": "Machine Maintainance Carbonisr",
                                    "Value": "Machine Maintainance Carbonisr"
                                },
                                {
                                    "Text": "Manager IT Infrastructure",
                                    "Value": "Manager IT Infrastructure"
                                },
                                {
                                    "Text": "Manager Jute",
                                    "Value": "Manager Jute"
                                },
                                {
                                    "Text": "Manager Legal",
                                    "Value": "Manager Legal"
                                },
                                {
                                    "Text": "Manager Library",
                                    "Value": "Manager Library"
                                },
                                {
                                    "Text": "Manager Electronics",
                                    "Value": "Manager Electronics"
                                },
                                {
                                    "Text": "Manager Logistics",
                                    "Value": "Manager Logistics"
                                },
                                {
                                    "Text": "Manager Manufacturing",
                                    "Value": "Manager Manufacturing"
                                },
                                {
                                    "Text": "Manager Manufacturing Unit",
                                    "Value": "Manager Manufacturing Unit"
                                },
                                {
                                    "Text": "Manager Marketing Services",
                                    "Value": "Manager Marketing Services"
                                },
                                {
                                    "Text": "Manager Mechanical",
                                    "Value": "Manager Mechanical"
                                },
                                {
                                    "Text": "Manager Mechanical Maintenance",
                                    "Value": "Manager Mechanical Maintenance"
                                },
                                {
                                    "Text": "Manager Media Services",
                                    "Value": "Manager Media Services"
                                },
                                {
                                    "Text": "Manager Medical Services",
                                    "Value": "Manager Medical Services"
                                },
                                {
                                    "Text": "Manager Operations",
                                    "Value": "Manager Operations"
                                },
                                {
                                    "Text": "Manager Outsourcing",
                                    "Value": "Manager Outsourcing"
                                },
                                {
                                    "Text": "Manager Phonebanking",
                                    "Value": "Manager Phonebanking"
                                },
                                {
                                    "Text": "Manager Planning & Coordinaton",
                                    "Value": "Manager Planning & Coordinaton"
                                },
                                {
                                    "Text": "Manager Post Paid Sales",
                                    "Value": "Manager Post Paid Sales"
                                },
                                {
                                    "Text": "Manager Printing",
                                    "Value": "Manager Printing"
                                },
                                {
                                    "Text": "Manager Product Development",
                                    "Value": "Manager Product Development"
                                },
                                {
                                    "Text": "Manager Production",
                                    "Value": "Manager Production"
                                },
                                {
                                    "Text": "Manager Professional Services",
                                    "Value": "Manager Professional Services"
                                },
                                {
                                    "Text": "Manager Purchase",
                                    "Value": "Manager Purchase"
                                },
                                {
                                    "Text": "Manager QC/QA",
                                    "Value": "Manager QC/QA"
                                },
                                {
                                    "Text": "Manager Quality & Compliance",
                                    "Value": "Manager Quality & Compliance"
                                },
                                {
                                    "Text": "Manager Quality Assurance",
                                    "Value": "Manager Quality Assurance"
                                },
                                {
                                    "Text": "Manager R & D",
                                    "Value": "Manager R & D"
                                },
                                {
                                    "Text": "Manager Relieving",
                                    "Value": "Manager Relieving"
                                },
                                {
                                    "Text": "Manager Research",
                                    "Value": "Manager Research"
                                },
                                {
                                    "Text": "Manager Sales",
                                    "Value": "Manager Sales"
                                },
                                {
                                    "Text": "Manager Sales & Marketing",
                                    "Value": "Manager Sales & Marketing"
                                },
                                {
                                    "Text": "Manager Sales Administration",
                                    "Value": "Manager Sales Administration"
                                },
                                {
                                    "Text": "Manager Sales Promotion",
                                    "Value": "Manager Sales Promotion"
                                },
                                {
                                    "Text": "Manager Retired",
                                    "Value": "Manager Retired"
                                },
                                {
                                    "Text": "Marketing Trainee",
                                    "Value": "Marketing Trainee"
                                },
                                {
                                    "Text": "Manager Solution Development",
                                    "Value": "Manager Solution Development"
                                },
                                {
                                    "Text": "Manager Sourcing",
                                    "Value": "Manager Sourcing"
                                },
                                {
                                    "Text": "Manager Stores",
                                    "Value": "Manager Stores"
                                },
                                {
                                    "Text": "Manager Supply Chain",
                                    "Value": "Manager Supply Chain"
                                },
                                {
                                    "Text": "Manager Legal & Personnel",
                                    "Value": "Manager Legal & Personnel"
                                },
                                {
                                    "Text": "Manager Technical Sales",
                                    "Value": "Manager Technical Sales"
                                },
                                {
                                    "Text": "Manager Transition",
                                    "Value": "Manager Transition"
                                },
                                {
                                    "Text": "Manager Travel",
                                    "Value": "Manager Travel"
                                },
                                {
                                    "Text": "Materials Manager",
                                    "Value": "Materials Manager"
                                },
                                {
                                    "Text": "Manager Civil Supplies",
                                    "Value": "Manager Civil Supplies"
                                },
                                {
                                    "Text": "Manager Utility",
                                    "Value": "Manager Utility"
                                },
                                {
                                    "Text": "Manager Vendor Development",
                                    "Value": "Manager Vendor Development"
                                },
                                {
                                    "Text": "Manager Weaving",
                                    "Value": "Manager Weaving"
                                },
                                {
                                    "Text": "Manager Forex",
                                    "Value": "Manager Forex"
                                },
                                {
                                    "Text": "Managing Director Mkt. & Sales",
                                    "Value": "Managing Director Mkt. & Sales"
                                },
                                {
                                    "Text": "Managing Partner",
                                    "Value": "Managing Partner"
                                },
                                {
                                    "Text": "Managmnt Traine Human Resource",
                                    "Value": "Managmnt Traine Human Resource"
                                },
                                {
                                    "Text": "Managr Buss Project Developmnt",
                                    "Value": "Managr Buss Project Developmnt"
                                },
                                {
                                    "Text": "Mandal Educational Officer",
                                    "Value": "Mandal Educational Officer"
                                },
                                {
                                    "Text": "Mandal Revenue Officer",
                                    "Value": "Mandal Revenue Officer"
                                },
                                {
                                    "Text": "Management Staff",
                                    "Value": "Management Staff"
                                },
                                {
                                    "Text": "Mango Trader & Cultivator",
                                    "Value": "Mango Trader & Cultivator"
                                },
                                {
                                    "Text": "Manufacturer Gems Stone",
                                    "Value": "Manufacturer Gems Stone"
                                },
                                {
                                    "Text": "Marine Engineer Retired",
                                    "Value": "Marine Engineer Retired"
                                },
                                {
                                    "Text": "Market Consultant",
                                    "Value": "Market Consultant"
                                },
                                {
                                    "Text": "Market Dealer",
                                    "Value": "Market Dealer"
                                },
                                {
                                    "Text": "Market Development In Charge",
                                    "Value": "Market Development In Charge"
                                },
                                {
                                    "Text": "Market Officer",
                                    "Value": "Market Officer"
                                },
                                {
                                    "Text": "Market Representative",
                                    "Value": "Market Representative"
                                },
                                {
                                    "Text": "Market Research Manager",
                                    "Value": "Market Research Manager"
                                },
                                {
                                    "Text": "Market Researcher",
                                    "Value": "Market Researcher"
                                },
                                {
                                    "Text": "Marketing & Admin Executive",
                                    "Value": "Marketing & Admin Executive"
                                },
                                {
                                    "Text": "Marketing & Admin Incharge",
                                    "Value": "Marketing & Admin Incharge"
                                },
                                {
                                    "Text": "Marketing Agent",
                                    "Value": "Marketing Agent"
                                },
                                {
                                    "Text": "Marketing Assistant",
                                    "Value": "Marketing Assistant"
                                },
                                {
                                    "Text": "Marketing Associate",
                                    "Value": "Marketing Associate"
                                },
                                {
                                    "Text": "Marketing Consultant",
                                    "Value": "Marketing Consultant"
                                },
                                {
                                    "Text": "Marketing Controlling Manager",
                                    "Value": "Marketing Controlling Manager"
                                },
                                {
                                    "Text": "Marketing Director",
                                    "Value": "Marketing Director"
                                },
                                {
                                    "Text": "Marketing Execuitve",
                                    "Value": "Marketing Execuitve"
                                },
                                {
                                    "Text": "Marketing Inspector",
                                    "Value": "Marketing Inspector"
                                },
                                {
                                    "Text": "Marketing Officer",
                                    "Value": "Marketing Officer"
                                },
                                {
                                    "Text": "Marketing Operationl Executive",
                                    "Value": "Marketing Operationl Executive"
                                },
                                {
                                    "Text": "Marketing Planning Manager",
                                    "Value": "Marketing Planning Manager"
                                },
                                {
                                    "Text": "Marketing Representative",
                                    "Value": "Marketing Representative"
                                },
                                {
                                    "Text": "Manager Incharge",
                                    "Value": "Manager Incharge"
                                },
                                {
                                    "Text": "Marketing Sales Representative",
                                    "Value": "Marketing Sales Representative"
                                },
                                {
                                    "Text": "Marketng Representatve & Admin",
                                    "Value": "Marketng Representatve & Admin"
                                },
                                {
                                    "Text": "Marriage Contractor",
                                    "Value": "Marriage Contractor"
                                },
                                {
                                    "Text": "Master Civil Engineering",
                                    "Value": "Master Civil Engineering"
                                },
                                {
                                    "Text": "Master Social Studies",
                                    "Value": "Master Social Studies"
                                },
                                {
                                    "Text": "Mate Supervisor",
                                    "Value": "Mate Supervisor"
                                },
                                {
                                    "Text": "Material Coordinator",
                                    "Value": "Material Coordinator"
                                },
                                {
                                    "Text": "Material Executive",
                                    "Value": "Material Executive"
                                },
                                {
                                    "Text": "Material Man",
                                    "Value": "Material Man"
                                },
                                {
                                    "Text": "Material Manager",
                                    "Value": "Material Manager"
                                },
                                {
                                    "Text": "Material Superintendent",
                                    "Value": "Material Superintendent"
                                },
                                {
                                    "Text": "Material Team Leader",
                                    "Value": "Material Team Leader"
                                },
                                {
                                    "Text": "Material Handlers",
                                    "Value": "Material Handlers"
                                },
                                {
                                    "Text": "Management Trainee HR",
                                    "Value": "Management Trainee HR"
                                },
                                {
                                    "Text": "Manager Retail",
                                    "Value": "Manager Retail"
                                },
                                {
                                    "Text": "Maintenance",
                                    "Value": "Maintenance"
                                },
                                {
                                    "Text": "Manager-ship Repair",
                                    "Value": "Manager-ship Repair"
                                },
                                {
                                    "Text": "Manager Shares & Stocks",
                                    "Value": "Manager Shares & Stocks"
                                },
                                {
                                    "Text": "Mali",
                                    "Value": "Mali"
                                },
                                {
                                    "Text": "Manager Tours & Travels",
                                    "Value": "Manager Tours & Travels"
                                },
                                {
                                    "Text": "Machinery Manufacturer",
                                    "Value": "Machinery Manufacturer"
                                },
                                {
                                    "Text": "Major Army",
                                    "Value": "Major Army"
                                },
                                {
                                    "Text": "Maintenance Engineer",
                                    "Value": "Maintenance Engineer"
                                },
                                {
                                    "Text": "Manager Collection & Billing",
                                    "Value": "Manager Collection & Billing"
                                },
                                {
                                    "Text": "Manager Communications",
                                    "Value": "Manager Communications"
                                },
                                {
                                    "Text": "Management Assistant",
                                    "Value": "Management Assistant"
                                },
                                {
                                    "Text": "Manager Body Shop",
                                    "Value": "Manager Body Shop"
                                },
                                {
                                    "Text": "Manager & Director",
                                    "Value": "Manager & Director"
                                },
                                {
                                    "Text": "Manager Internal Audit Dept",
                                    "Value": "Manager Internal Audit Dept"
                                },
                                {
                                    "Text": "Attendent jet foil",
                                    "Value": "Attendent jet foil"
                                },
                                {
                                    "Text": "Manager Credit Card",
                                    "Value": "Manager Credit Card"
                                },
                                {
                                    "Text": "Marine Engineer",
                                    "Value": "Marine Engineer"
                                },
                                {
                                    "Text": "Quarter master",
                                    "Value": "Quarter master"
                                },
                                {
                                    "Text": "Manager & Secretary",
                                    "Value": "Manager & Secretary"
                                },
                                {
                                    "Text": "Manager Excise",
                                    "Value": "Manager Excise"
                                },
                                {
                                    "Text": "Mason/ Plasterer",
                                    "Value": "Mason/ Plasterer"
                                },
                                {
                                    "Text": "Masseuse",
                                    "Value": "Masseuse"
                                },
                                {
                                    "Text": "Mango Supplier",
                                    "Value": "Mango Supplier"
                                },
                                {
                                    "Text": "Maintainance Technician",
                                    "Value": "Maintainance Technician"
                                },
                                {
                                    "Text": "Manager Corporate",
                                    "Value": "Manager Corporate"
                                },
                                {
                                    "Text": "Manager Quality",
                                    "Value": "Manager Quality"
                                },
                                {
                                    "Text": "Major Accounts Executive",
                                    "Value": "Major Accounts Executive"
                                },
                                {
                                    "Text": "Manager Insurance",
                                    "Value": "Manager Insurance"
                                },
                                {
                                    "Text": "Manager Loans",
                                    "Value": "Manager Loans"
                                },
                                {
                                    "Text": "Manager Sales Tax",
                                    "Value": "Manager Sales Tax"
                                },
                                {
                                    "Text": "Manager Security",
                                    "Value": "Manager Security"
                                },
                                {
                                    "Text": "Manager Treasury Office",
                                    "Value": "Manager Treasury Office"
                                },
                                {
                                    "Text": "Manager Underwriting",
                                    "Value": "Manager Underwriting"
                                },
                                {
                                    "Text": "Manager Works Accounts",
                                    "Value": "Manager Works Accounts"
                                },
                                {
                                    "Text": "Mandi Instructor",
                                    "Value": "Mandi Instructor"
                                },
                                {
                                    "Text": "Marketing Sales Officer",
                                    "Value": "Marketing Sales Officer"
                                },
                                {
                                    "Text": "Marketing Supervisor",
                                    "Value": "Marketing Supervisor"
                                },
                                {
                                    "Text": "Machine Maintenance Officer",
                                    "Value": "Machine Maintenance Officer"
                                },
                                {
                                    "Text": "Maintenance Officer",
                                    "Value": "Maintenance Officer"
                                },
                                {
                                    "Text": "Maintenance Planner",
                                    "Value": "Maintenance Planner"
                                },
                                {
                                    "Text": "Management Executive",
                                    "Value": "Management Executive"
                                },
                                {
                                    "Text": "Manager & Owner",
                                    "Value": "Manager & Owner"
                                },
                                {
                                    "Text": "Manager & Tax Consultant",
                                    "Value": "Manager & Tax Consultant"
                                },
                                {
                                    "Text": "Manager Accounts & Admin",
                                    "Value": "Manager Accounts & Admin"
                                },
                                {
                                    "Text": "Manager Accounts & Admin.",
                                    "Value": "Manager Accounts & Admin."
                                },
                                {
                                    "Text": "Manager Accounts Department",
                                    "Value": "Manager Accounts Department"
                                },
                                {
                                    "Text": "Manager Admin",
                                    "Value": "Manager Admin"
                                },
                                {
                                    "Text": "Manager Analytical Development",
                                    "Value": "Manager Analytical Development"
                                },
                                {
                                    "Text": "Manager Application",
                                    "Value": "Manager Application"
                                },
                                {
                                    "Text": "Manager Business Development",
                                    "Value": "Manager Business Development"
                                },
                                {
                                    "Text": "Manager Business Promotion",
                                    "Value": "Manager Business Promotion"
                                },
                                {
                                    "Text": "Manager Channel Sales",
                                    "Value": "Manager Channel Sales"
                                },
                                {
                                    "Text": "Manager Clinical Research",
                                    "Value": "Manager Clinical Research"
                                },
                                {
                                    "Text": "Manager Contracts",
                                    "Value": "Manager Contracts"
                                },
                                {
                                    "Text": "Manager Corporate Planning",
                                    "Value": "Manager Corporate Planning"
                                },
                                {
                                    "Text": "Manager Corporate Sales",
                                    "Value": "Manager Corporate Sales"
                                },
                                {
                                    "Text": "Manager Cum Clerk",
                                    "Value": "Manager Cum Clerk"
                                },
                                {
                                    "Text": "Manager Cum Owner",
                                    "Value": "Manager Cum Owner"
                                },
                                {
                                    "Text": "Manager Finance Administration",
                                    "Value": "Manager Finance Administration"
                                },
                                {
                                    "Text": "Manager HR & Admin",
                                    "Value": "Manager HR & Admin"
                                },
                                {
                                    "Text": "Manager Business Insights",
                                    "Value": "Manager Business Insights"
                                },
                                {
                                    "Text": "MBBS Doctor",
                                    "Value": "MBBS Doctor"
                                },
                                {
                                    "Text": "Manager Business Planning",
                                    "Value": "Manager Business Planning"
                                },
                                {
                                    "Text": "Manager Business & Service",
                                    "Value": "Manager Business & Service"
                                },
                                {
                                    "Text": "Manager Bancassurance  Service",
                                    "Value": "Manager Bancassurance  Service"
                                },
                                {
                                    "Text": "Merchandising Assistant",
                                    "Value": "Merchandising Assistant"
                                },
                                {
                                    "Text": "Microbiologist",
                                    "Value": "Microbiologist"
                                },
                                {
                                    "Text": "MD & Proprietor",
                                    "Value": "MD & Proprietor"
                                },
                                {
                                    "Text": "MD Doctor",
                                    "Value": "MD Doctor"
                                },
                                {
                                    "Text": "MD Physician Doctor",
                                    "Value": "MD Physician Doctor"
                                },
                                {
                                    "Text": "Mazdoor",
                                    "Value": "Mazdoor"
                                },
                                {
                                    "Text": "MD",
                                    "Value": "MD"
                                },
                                {
                                    "Text": "Assistant director",
                                    "Value": "Assistant director"
                                },
                                {
                                    "Text": "Film director",
                                    "Value": "Film director"
                                },
                                {
                                    "Text": "Television director",
                                    "Value": "Television director"
                                },
                                {
                                    "Text": "Television editor",
                                    "Value": "Television editor"
                                },
                                {
                                    "Text": "Television producer",
                                    "Value": "Television producer"
                                },
                                {
                                    "Text": "Film editor",
                                    "Value": "Film editor"
                                },
                                {
                                    "Text": "Commentator",
                                    "Value": "Commentator"
                                },
                                {
                                    "Text": "Make-up artist",
                                    "Value": "Make-up artist"
                                },
                                {
                                    "Text": "MD & MBBS Doctor",
                                    "Value": "MD & MBBS Doctor"
                                },
                                {
                                    "Text": "MD Pathologist",
                                    "Value": "MD Pathologist"
                                },
                                {
                                    "Text": "Medical Underwriter",
                                    "Value": "Medical Underwriter"
                                },
                                {
                                    "Text": "Homeopathic doctor",
                                    "Value": "Homeopathic doctor"
                                },
                                {
                                    "Text": "Reflexologist",
                                    "Value": "Reflexologist"
                                },
                                {
                                    "Text": "Male nurse",
                                    "Value": "Male nurse"
                                },
                                {
                                    "Text": "Media Planning Manager",
                                    "Value": "Media Planning Manager"
                                },
                                {
                                    "Text": "Wardboy",
                                    "Value": "Wardboy"
                                },
                                {
                                    "Text": "Bio-medical officer",
                                    "Value": "Bio-medical officer"
                                },
                                {
                                    "Text": "Medical Executive",
                                    "Value": "Medical Executive"
                                },
                                {
                                    "Text": "Nephrologist",
                                    "Value": "Nephrologist"
                                },
                                {
                                    "Text": "Ophthalmologist",
                                    "Value": "Ophthalmologist"
                                },
                                {
                                    "Text": "Oncologist",
                                    "Value": "Oncologist"
                                },
                                {
                                    "Text": "Bronchologist",
                                    "Value": "Bronchologist"
                                },
                                {
                                    "Text": "Chest physician",
                                    "Value": "Chest physician"
                                },
                                {
                                    "Text": "Neurosurgeon",
                                    "Value": "Neurosurgeon"
                                },
                                {
                                    "Text": "Medical Sales Representative",
                                    "Value": "Medical Sales Representative"
                                },
                                {
                                    "Text": "Medical Social Worker",
                                    "Value": "Medical Social Worker"
                                },
                                {
                                    "Text": "Medical Superintendent",
                                    "Value": "Medical Superintendent"
                                },
                                {
                                    "Text": "Medical Transcriber",
                                    "Value": "Medical Transcriber"
                                },
                                {
                                    "Text": "Medical Transcriber & Proffer",
                                    "Value": "Medical Transcriber & Proffer"
                                },
                                {
                                    "Text": "Medical Transcriptor Editor",
                                    "Value": "Medical Transcriptor Editor"
                                },
                                {
                                    "Text": "Medicine Representative",
                                    "Value": "Medicine Representative"
                                },
                                {
                                    "Text": "Member Finance & Accounts",
                                    "Value": "Member Finance & Accounts"
                                },
                                {
                                    "Text": "Member R&D Department",
                                    "Value": "Member R&D Department"
                                },
                                {
                                    "Text": "Member Technical Staff Server",
                                    "Value": "Member Technical Staff Server"
                                },
                                {
                                    "Text": "Merchadiser",
                                    "Value": "Merchadiser"
                                },
                                {
                                    "Text": "Merchandising Manager",
                                    "Value": "Merchandising Manager"
                                },
                                {
                                    "Text": "Mess Manager",
                                    "Value": "Mess Manager"
                                },
                                {
                                    "Text": "Mess Supervisor",
                                    "Value": "Mess Supervisor"
                                },
                                {
                                    "Text": "Meter Inspector",
                                    "Value": "Meter Inspector"
                                },
                                {
                                    "Text": "Member Finance",
                                    "Value": "Member Finance"
                                },
                                {
                                    "Text": "Mechanic",
                                    "Value": "Mechanic"
                                },
                                {
                                    "Text": "Medical Coder",
                                    "Value": "Medical Coder"
                                },
                                {
                                    "Text": "Member Logistics",
                                    "Value": "Member Logistics"
                                },
                                {
                                    "Text": "Matron",
                                    "Value": "Matron"
                                },
                                {
                                    "Text": "Hospital administrator",
                                    "Value": "Hospital administrator"
                                },
                                {
                                    "Text": "Ayurvedic doctor",
                                    "Value": "Ayurvedic doctor"
                                },
                                {
                                    "Text": "Chiropractor",
                                    "Value": "Chiropractor"
                                },
                                {
                                    "Text": "Veterinarian",
                                    "Value": "Veterinarian"
                                },
                                {
                                    "Text": "Chief medical officer",
                                    "Value": "Chief medical officer"
                                },
                                {
                                    "Text": "Gynaecologist",
                                    "Value": "Gynaecologist"
                                },
                                {
                                    "Text": "Dermatologist",
                                    "Value": "Dermatologist"
                                },
                                {
                                    "Text": "ENT surgeon",
                                    "Value": "ENT surgeon"
                                },
                                {
                                    "Text": "Gastroenterologist",
                                    "Value": "Gastroenterologist"
                                },
                                {
                                    "Text": "General physician",
                                    "Value": "General physician"
                                },
                                {
                                    "Text": "Medical officer",
                                    "Value": "Medical officer"
                                },
                                {
                                    "Text": "Medical practitioner",
                                    "Value": "Medical practitioner"
                                },
                                {
                                    "Text": "Medical examiner",
                                    "Value": "Medical examiner"
                                },
                                {
                                    "Text": "Ambulance Driver",
                                    "Value": "Ambulance Driver"
                                },
                                {
                                    "Text": "Neurologist",
                                    "Value": "Neurologist"
                                },
                                {
                                    "Text": "Medical Transcription",
                                    "Value": "Medical Transcription"
                                },
                                {
                                    "Text": "Orthopaedic",
                                    "Value": "Orthopaedic"
                                },
                                {
                                    "Text": "Paediatrician",
                                    "Value": "Paediatrician"
                                },
                                {
                                    "Text": "Urologist",
                                    "Value": "Urologist"
                                },
                                {
                                    "Text": "Mechanical Engineer",
                                    "Value": "Mechanical Engineer"
                                },
                                {
                                    "Text": "Media Manager",
                                    "Value": "Media Manager"
                                },
                                {
                                    "Text": "Member Of Mahanagarpalika",
                                    "Value": "Member Of Mahanagarpalika"
                                },
                                {
                                    "Text": "Melter",
                                    "Value": "Melter"
                                },
                                {
                                    "Text": "ME",
                                    "Value": "ME"
                                },
                                {
                                    "Text": "Medical Assistant",
                                    "Value": "Medical Assistant"
                                },
                                {
                                    "Text": "Medical Surgeon",
                                    "Value": "Medical Surgeon"
                                },
                                {
                                    "Text": "Medical Supervisor",
                                    "Value": "Medical Supervisor"
                                },
                                {
                                    "Text": "Mess Incharge",
                                    "Value": "Mess Incharge"
                                },
                                {
                                    "Text": "Medical Transcriptionist",
                                    "Value": "Medical Transcriptionist"
                                },
                                {
                                    "Text": "Meteorologist",
                                    "Value": "Meteorologist"
                                },
                                {
                                    "Text": "Metrologist",
                                    "Value": "Metrologist"
                                },
                                {
                                    "Text": "Member Accounts",
                                    "Value": "Member Accounts"
                                },
                                {
                                    "Text": "Media Marketing Executive",
                                    "Value": "Media Marketing Executive"
                                },
                                {
                                    "Text": "Medical Detailing Officer",
                                    "Value": "Medical Detailing Officer"
                                },
                                {
                                    "Text": "Medical Distributor Partner",
                                    "Value": "Medical Distributor Partner"
                                },
                                {
                                    "Text": "Medical Lab Assistant",
                                    "Value": "Medical Lab Assistant"
                                },
                                {
                                    "Text": "Medical Lab Technician",
                                    "Value": "Medical Lab Technician"
                                },
                                {
                                    "Text": "Medical Officer Doctor",
                                    "Value": "Medical Officer Doctor"
                                },
                                {
                                    "Text": "Medical Practice Doctor",
                                    "Value": "Medical Practice Doctor"
                                },
                                {
                                    "Text": "Medical Professional & Doctor",
                                    "Value": "Medical Professional & Doctor"
                                },
                                {
                                    "Text": "Medical Sales Professional",
                                    "Value": "Medical Sales Professional"
                                },
                                {
                                    "Text": "Mechanical Draughtsman",
                                    "Value": "Mechanical Draughtsman"
                                },
                                {
                                    "Text": "Die caster",
                                    "Value": "Die caster"
                                },
                                {
                                    "Text": "Die cutter",
                                    "Value": "Die cutter"
                                },
                                {
                                    "Text": "Die piercer",
                                    "Value": "Die piercer"
                                },
                                {
                                    "Text": "Die setter",
                                    "Value": "Die setter"
                                },
                                {
                                    "Text": "Die sinker",
                                    "Value": "Die sinker"
                                },
                                {
                                    "Text": "Die stamper",
                                    "Value": "Die stamper"
                                },
                                {
                                    "Text": "Press tool setter",
                                    "Value": "Press tool setter"
                                },
                                {
                                    "Text": "Casting worker",
                                    "Value": "Casting worker"
                                },
                                {
                                    "Text": "Grinder",
                                    "Value": "Grinder"
                                },
                                {
                                    "Text": "Manager F&A",
                                    "Value": "Manager F&A"
                                },
                                {
                                    "Text": "Manager Actuarial",
                                    "Value": "Manager Actuarial"
                                },
                                {
                                    "Text": "Manager Agency Operations",
                                    "Value": "Manager Agency Operations"
                                },
                                {
                                    "Text": "Manager ARM",
                                    "Value": "Manager ARM"
                                },
                                {
                                    "Text": "Manager Bancassurance",
                                    "Value": "Manager Bancassurance"
                                },
                                {
                                    "Text": "Program Manager Business",
                                    "Value": "Program Manager Business"
                                },
                                {
                                    "Text": "Manager Branch Support",
                                    "Value": "Manager Branch Support"
                                },
                                {
                                    "Text": "Manager Business Systems &",
                                    "Value": "Manager Business Systems &"
                                },
                                {
                                    "Text": "Manager Central Operations",
                                    "Value": "Manager Central Operations"
                                },
                                {
                                    "Text": "Circle Head",
                                    "Value": "Circle Head"
                                },
                                {
                                    "Text": "Manager Claims",
                                    "Value": "Manager Claims"
                                },
                                {
                                    "Text": "Content Specialist",
                                    "Value": "Content Specialist"
                                },
                                {
                                    "Text": "Manager DPPM",
                                    "Value": "Manager DPPM"
                                },
                                {
                                    "Text": "Territory Manager EM",
                                    "Value": "Territory Manager EM"
                                },
                                {
                                    "Text": "Mgr Engg & Customer Supplier",
                                    "Value": "Mgr Engg & Customer Supplier"
                                },
                                {
                                    "Text": "Manager Group Operations",
                                    "Value": "Manager Group Operations"
                                },
                                {
                                    "Text": "Key Account Manager Group",
                                    "Value": "Key Account Manager Group"
                                },
                                {
                                    "Text": "Manager Health Insurance",
                                    "Value": "Manager Health Insurance"
                                },
                                {
                                    "Text": "Manager HNI Sales",
                                    "Value": "Manager HNI Sales"
                                },
                                {
                                    "Text": "Manager HR Admin and Accounts",
                                    "Value": "Manager HR Admin and Accounts"
                                },
                                {
                                    "Text": "Manager Hub Operations",
                                    "Value": "Manager Hub Operations"
                                },
                                {
                                    "Text": "PR REL Manager International",
                                    "Value": "PR REL Manager International"
                                },
                                {
                                    "Text": "Manager Investment Front Desk",
                                    "Value": "Manager Investment Front Desk"
                                },
                                {
                                    "Text": "Key Account Manager",
                                    "Value": "Key Account Manager"
                                },
                                {
                                    "Text": "Manager Learning and",
                                    "Value": "Manager Learning and"
                                },
                                {
                                    "Text": "Manager LMS",
                                    "Value": "Manager LMS"
                                },
                                {
                                    "Text": "Territory Manager Broka",
                                    "Value": "Territory Manager Broka"
                                },
                                {
                                    "Text": "Territory Manager Direct-DSF",
                                    "Value": "Territory Manager Direct-DSF"
                                },
                                {
                                    "Text": "Mgr Formulation & Development",
                                    "Value": "Mgr Formulation & Development"
                                },
                                {
                                    "Text": "Regional Operations Manager",
                                    "Value": "Regional Operations Manager"
                                },
                                {
                                    "Text": "Mgr Contact Point Verification",
                                    "Value": "Mgr Contact Point Verification"
                                },
                                {
                                    "Text": "Manager Operations Customer",
                                    "Value": "Manager Operations Customer"
                                },
                                {
                                    "Text": "Manager Persistency",
                                    "Value": "Manager Persistency"
                                },
                                {
                                    "Text": "Manager Procurement",
                                    "Value": "Manager Procurement"
                                },
                                {
                                    "Text": "Managing director",
                                    "Value": "Managing director"
                                },
                                {
                                    "Text": "Manager Regional Human",
                                    "Value": "Manager Regional Human"
                                },
                                {
                                    "Text": "Manager Risk Management",
                                    "Value": "Manager Risk Management"
                                },
                                {
                                    "Text": "Manager Grp Sales Support",
                                    "Value": "Manager Grp Sales Support"
                                },
                                {
                                    "Text": "Manager",
                                    "Value": "Manager"
                                },
                                {
                                    "Text": "Manager Group Sales Support",
                                    "Value": "Manager Group Sales Support"
                                },
                                {
                                    "Text": "Territory Manager",
                                    "Value": "Territory Manager"
                                },
                                {
                                    "Text": "Key Account Mgr Business",
                                    "Value": "Key Account Mgr Business"
                                },
                                {
                                    "Text": "Territory Manager Worksite",
                                    "Value": "Territory Manager Worksite"
                                },
                                {
                                    "Text": "Manager Zonal Administration",
                                    "Value": "Manager Zonal Administration"
                                },
                                {
                                    "Text": "Manager Zonal Marketing",
                                    "Value": "Manager Zonal Marketing"
                                },
                                {
                                    "Text": "Manager Zonal Legal",
                                    "Value": "Manager Zonal Legal"
                                },
                                {
                                    "Text": "Collier",
                                    "Value": "Collier"
                                },
                                {
                                    "Text": "Milk Supplier",
                                    "Value": "Milk Supplier"
                                },
                                {
                                    "Text": "Worker in coalmine",
                                    "Value": "Worker in coalmine"
                                },
                                {
                                    "Text": "Cutting-loading mach operator",
                                    "Value": "Cutting-loading mach operator"
                                },
                                {
                                    "Text": "Hard groundman",
                                    "Value": "Hard groundman"
                                },
                                {
                                    "Text": "Locomotive driver",
                                    "Value": "Locomotive driver"
                                },
                                {
                                    "Text": "Locomotive guard",
                                    "Value": "Locomotive guard"
                                },
                                {
                                    "Text": "Rope runner",
                                    "Value": "Rope runner"
                                },
                                {
                                    "Text": "Rope changer",
                                    "Value": "Rope changer"
                                },
                                {
                                    "Text": "Steel straightener",
                                    "Value": "Steel straightener"
                                },
                                {
                                    "Text": "Water infusion man",
                                    "Value": "Water infusion man"
                                },
                                {
                                    "Text": "Check weighman",
                                    "Value": "Check weighman"
                                },
                                {
                                    "Text": "Banksman's assistant",
                                    "Value": "Banksman's assistant"
                                },
                                {
                                    "Text": "Bunker control man",
                                    "Value": "Bunker control man"
                                },
                                {
                                    "Text": "Dragline driver",
                                    "Value": "Dragline driver"
                                },
                                {
                                    "Text": "Dumper driver",
                                    "Value": "Dumper driver"
                                },
                                {
                                    "Text": "Scraper driver",
                                    "Value": "Scraper driver"
                                },
                                {
                                    "Text": "Milk Merchant",
                                    "Value": "Milk Merchant"
                                },
                                {
                                    "Text": "Manager Investment MO / BO",
                                    "Value": "Manager Investment MO / BO"
                                },
                                {
                                    "Text": "Clipper",
                                    "Value": "Clipper"
                                },
                                {
                                    "Text": "Shakler",
                                    "Value": "Shakler"
                                },
                                {
                                    "Text": "Gummer",
                                    "Value": "Gummer"
                                },
                                {
                                    "Text": "Coal cutter mover",
                                    "Value": "Coal cutter mover"
                                },
                                {
                                    "Text": "Tracker",
                                    "Value": "Tracker"
                                },
                                {
                                    "Text": "Coal cutterman",
                                    "Value": "Coal cutterman"
                                },
                                {
                                    "Text": "Coal washery operator",
                                    "Value": "Coal washery operator"
                                },
                                {
                                    "Text": "Coal miner",
                                    "Value": "Coal miner"
                                },
                                {
                                    "Text": "Mining Engineer",
                                    "Value": "Mining Engineer"
                                },
                                {
                                    "Text": "Mineralogist",
                                    "Value": "Mineralogist"
                                },
                                {
                                    "Text": "Mining officer",
                                    "Value": "Mining officer"
                                },
                                {
                                    "Text": "Mini Laboratory Operator",
                                    "Value": "Mini Laboratory Operator"
                                },
                                {
                                    "Text": "Slusher operator",
                                    "Value": "Slusher operator"
                                },
                                {
                                    "Text": "Miner",
                                    "Value": "Miner"
                                },
                                {
                                    "Text": "Automatic train attendant",
                                    "Value": "Automatic train attendant"
                                },
                                {
                                    "Text": "Brakesman",
                                    "Value": "Brakesman"
                                },
                                {
                                    "Text": "Cageman(surface)",
                                    "Value": "Cageman(surface)"
                                },
                                {
                                    "Text": "Burster",
                                    "Value": "Burster"
                                },
                                {
                                    "Text": "Mind Educator",
                                    "Value": "Mind Educator"
                                },
                                {
                                    "Text": "Coal dry cleaning plt operator",
                                    "Value": "Coal dry cleaning plt operator"
                                },
                                {
                                    "Text": "Mistri",
                                    "Value": "Mistri"
                                },
                                {
                                    "Text": "MidWifery",
                                    "Value": "MidWifery"
                                },
                                {
                                    "Text": "Milk Business",
                                    "Value": "Milk Business"
                                },
                                {
                                    "Text": "Milk Dairy Owner",
                                    "Value": "Milk Dairy Owner"
                                },
                                {
                                    "Text": "Milk Vendor",
                                    "Value": "Milk Vendor"
                                },
                                {
                                    "Text": "Milkman & Dairy Farmer",
                                    "Value": "Milkman & Dairy Farmer"
                                },
                                {
                                    "Text": "Market Analyst",
                                    "Value": "Market Analyst"
                                },
                                {
                                    "Text": "Mkt. Officer Administration",
                                    "Value": "Mkt. Officer Administration"
                                },
                                {
                                    "Text": "Marketing Executive",
                                    "Value": "Marketing Executive"
                                },
                                {
                                    "Text": "Milkman",
                                    "Value": "Milkman"
                                },
                                {
                                    "Text": "Merchant",
                                    "Value": "Merchant"
                                },
                                {
                                    "Text": "Module Lead",
                                    "Value": "Module Lead"
                                },
                                {
                                    "Text": "Money Broker",
                                    "Value": "Money Broker"
                                },
                                {
                                    "Text": "Monitoring Engineer",
                                    "Value": "Monitoring Engineer"
                                },
                                {
                                    "Text": "Module Administrator",
                                    "Value": "Module Administrator"
                                },
                                {
                                    "Text": "Motor Agent",
                                    "Value": "Motor Agent"
                                },
                                {
                                    "Text": "Motor Vehicle Sub Inspector",
                                    "Value": "Motor Vehicle Sub Inspector"
                                },
                                {
                                    "Text": "Mobile crane driver",
                                    "Value": "Mobile crane driver"
                                },
                                {
                                    "Text": "Money Changer",
                                    "Value": "Money Changer"
                                },
                                {
                                    "Text": "Monitoring & Evaluation Officr",
                                    "Value": "Monitoring & Evaluation Officr"
                                },
                                {
                                    "Text": "Motorcycle Deliveryman",
                                    "Value": "Motorcycle Deliveryman"
                                },
                                {
                                    "Text": "Manager Operations Fin.& Risk",
                                    "Value": "Manager Operations Fin.& Risk"
                                },
                                {
                                    "Text": "Moulder",
                                    "Value": "Moulder"
                                },
                                {
                                    "Text": "Mould Maker",
                                    "Value": "Mould Maker"
                                },
                                {
                                    "Text": "Motorman",
                                    "Value": "Motorman"
                                },
                                {
                                    "Text": "Money Lending",
                                    "Value": "Money Lending"
                                },
                                {
                                    "Text": "Money Lender",
                                    "Value": "Money Lender"
                                },
                                {
                                    "Text": "Money Lender/Real Estate Agent",
                                    "Value": "Money Lender/Real Estate Agent"
                                },
                                {
                                    "Text": "Motor Vehicle Inspector",
                                    "Value": "Motor Vehicle Inspector"
                                },
                                {
                                    "Text": "Machine Operators",
                                    "Value": "Machine Operators"
                                },
                                {
                                    "Text": "Mortgage Officer",
                                    "Value": "Mortgage Officer"
                                },
                                {
                                    "Text": "MRI Technician",
                                    "Value": "MRI Technician"
                                },
                                {
                                    "Text": "Manager Risk and Compliance",
                                    "Value": "Manager Risk and Compliance"
                                },
                                {
                                    "Text": "Train Driver",
                                    "Value": "Train Driver"
                                },
                                {
                                    "Text": "Mango Seller",
                                    "Value": "Mango Seller"
                                },
                                {
                                    "Text": "Maintenance technician",
                                    "Value": "Maintenance technician"
                                },
                                {
                                    "Text": "MTNL Officer",
                                    "Value": "MTNL Officer"
                                },
                                {
                                    "Text": "Material Expeditor",
                                    "Value": "Material Expeditor"
                                },
                                {
                                    "Text": "Metal Fabricator",
                                    "Value": "Metal Fabricator"
                                },
                                {
                                    "Text": "MTNL Operator",
                                    "Value": "MTNL Operator"
                                },
                                {
                                    "Text": "Municipal Engineer",
                                    "Value": "Municipal Engineer"
                                },
                                {
                                    "Text": "Music Teacher",
                                    "Value": "Music Teacher"
                                },
                                {
                                    "Text": "Music & Audio Professional",
                                    "Value": "Music & Audio Professional"
                                },
                                {
                                    "Text": "Multimedia Web Designer",
                                    "Value": "Multimedia Web Designer"
                                },
                                {
                                    "Text": "Munim",
                                    "Value": "Munim"
                                },
                                {
                                    "Text": "Mutual Fund Advisor",
                                    "Value": "Mutual Fund Advisor"
                                },
                                {
                                    "Text": "Musician",
                                    "Value": "Musician"
                                },
                                {
                                    "Text": "National Account Manager",
                                    "Value": "National Account Manager"
                                },
                                {
                                    "Text": "National Business Manager",
                                    "Value": "National Business Manager"
                                },
                                {
                                    "Text": "Accounts Manager",
                                    "Value": "Accounts Manager"
                                },
                                {
                                    "Text": "National Sales Head",
                                    "Value": "National Sales Head"
                                },
                                {
                                    "Text": "National Service Manager",
                                    "Value": "National Service Manager"
                                },
                                {
                                    "Text": "Naval diver",
                                    "Value": "Naval diver"
                                },
                                {
                                    "Text": "Army diver",
                                    "Value": "Army diver"
                                },
                                {
                                    "Text": "Frogman",
                                    "Value": "Frogman"
                                },
                                {
                                    "Text": "Navy diver",
                                    "Value": "Navy diver"
                                },
                                {
                                    "Text": "National sales manager",
                                    "Value": "National sales manager"
                                },
                                {
                                    "Text": "Relationship Manager",
                                    "Value": "Relationship Manager"
                                },
                                {
                                    "Text": "National Savings Agent",
                                    "Value": "National Savings Agent"
                                },
                                {
                                    "Text": "Retail Outlet Manager",
                                    "Value": "Retail Outlet Manager"
                                },
                                {
                                    "Text": "Commander",
                                    "Value": "Commander"
                                },
                                {
                                    "Text": "Naval officer",
                                    "Value": "Naval officer"
                                },
                                {
                                    "Text": "Navigator",
                                    "Value": "Navigator"
                                },
                                {
                                    "Text": "Vice admiral",
                                    "Value": "Vice admiral"
                                },
                                {
                                    "Text": "Commodore",
                                    "Value": "Commodore"
                                },
                                {
                                    "Text": "Rear admiral",
                                    "Value": "Rear admiral"
                                },
                                {
                                    "Text": "Lieutenant commander",
                                    "Value": "Lieutenant commander"
                                },
                                {
                                    "Text": "Sailors",
                                    "Value": "Sailors"
                                },
                                {
                                    "Text": "Navy officer",
                                    "Value": "Navy officer"
                                },
                                {
                                    "Text": "Navy",
                                    "Value": "Navy"
                                },
                                {
                                    "Text": "National Manager",
                                    "Value": "National Manager"
                                },
                                {
                                    "Text": "National Plastic Manager",
                                    "Value": "National Plastic Manager"
                                },
                                {
                                    "Text": "Network Engineer",
                                    "Value": "Network Engineer"
                                },
                                {
                                    "Text": "Network Planning Engg Lead",
                                    "Value": "Network Planning Engg Lead"
                                },
                                {
                                    "Text": "Network Coordinator & Admin",
                                    "Value": "Network Coordinator & Admin"
                                },
                                {
                                    "Text": "News Paper Agent",
                                    "Value": "News Paper Agent"
                                },
                                {
                                    "Text": "Neuro Surgeon",
                                    "Value": "Neuro Surgeon"
                                },
                                {
                                    "Text": "Nodal Officer",
                                    "Value": "Nodal Officer"
                                },
                                {
                                    "Text": "Non Vocational Teacher",
                                    "Value": "Non Vocational Teacher"
                                },
                                {
                                    "Text": "NOC Officer",
                                    "Value": "NOC Officer"
                                },
                                {
                                    "Text": "Nursery",
                                    "Value": "Nursery"
                                },
                                {
                                    "Text": "Numerologist & Astrologist",
                                    "Value": "Numerologist & Astrologist"
                                },
                                {
                                    "Text": "Nursing Sister",
                                    "Value": "Nursing Sister"
                                },
                                {
                                    "Text": "Nurse II",
                                    "Value": "Nurse II"
                                },
                                {
                                    "Text": "Nursing Assistant",
                                    "Value": "Nursing Assistant"
                                },
                                {
                                    "Text": "Nursing Asst Children Ward",
                                    "Value": "Nursing Asst Children Ward"
                                },
                                {
                                    "Text": "Nurse",
                                    "Value": "Nurse"
                                },
                                {
                                    "Text": "Nutritionist",
                                    "Value": "Nutritionist"
                                },
                                {
                                    "Text": "Officer Administration",
                                    "Value": "Officer Administration"
                                },
                                {
                                    "Text": "Officer Agency Operations",
                                    "Value": "Officer Agency Operations"
                                },
                                {
                                    "Text": "Octroi Collection Man",
                                    "Value": "Octroi Collection Man"
                                },
                                {
                                    "Text": "Octroi Inspector",
                                    "Value": "Octroi Inspector"
                                },
                                {
                                    "Text": "Octroi Clerk",
                                    "Value": "Octroi Clerk"
                                },
                                {
                                    "Text": "Occupational Therapist",
                                    "Value": "Occupational Therapist"
                                },
                                {
                                    "Text": "Officer DPPM",
                                    "Value": "Officer DPPM"
                                },
                                {
                                    "Text": "Officer Emerging Markets",
                                    "Value": "Officer Emerging Markets"
                                },
                                {
                                    "Text": "Office Assistant Grade I",
                                    "Value": "Office Assistant Grade I"
                                },
                                {
                                    "Text": "Office Coordinator",
                                    "Value": "Office Coordinator"
                                },
                                {
                                    "Text": "Office Secretary",
                                    "Value": "Office Secretary"
                                },
                                {
                                    "Text": "Office Superintendent",
                                    "Value": "Office Superintendent"
                                },
                                {
                                    "Text": "Office Support Staff",
                                    "Value": "Office Support Staff"
                                },
                                {
                                    "Text": "Officer Assistant",
                                    "Value": "Officer Assistant"
                                },
                                {
                                    "Text": "Officer Clerk",
                                    "Value": "Officer Clerk"
                                },
                                {
                                    "Text": "Officer Coordinator",
                                    "Value": "Officer Coordinator"
                                },
                                {
                                    "Text": "Officer Corporate Relation",
                                    "Value": "Officer Corporate Relation"
                                },
                                {
                                    "Text": "Officer Electrical",
                                    "Value": "Officer Electrical"
                                },
                                {
                                    "Text": "Officer Technician",
                                    "Value": "Officer Technician"
                                },
                                {
                                    "Text": "Officer Grade II",
                                    "Value": "Officer Grade II"
                                },
                                {
                                    "Text": "Officer Purchase Department",
                                    "Value": "Officer Purchase Department"
                                },
                                {
                                    "Text": "Officer Sales",
                                    "Value": "Officer Sales"
                                },
                                {
                                    "Text": "Officer Scale II",
                                    "Value": "Officer Scale II"
                                },
                                {
                                    "Text": "Officer Supervisor",
                                    "Value": "Officer Supervisor"
                                },
                                {
                                    "Text": "Officer Teleservices",
                                    "Value": "Officer Teleservices"
                                },
                                {
                                    "Text": "Officiating Principal",
                                    "Value": "Officiating Principal"
                                },
                                {
                                    "Text": "Officer Branch Accounts",
                                    "Value": "Officer Branch Accounts"
                                },
                                {
                                    "Text": "Officer Business Insights",
                                    "Value": "Officer Business Insights"
                                },
                                {
                                    "Text": "Officer Business Planning",
                                    "Value": "Officer Business Planning"
                                },
                                {
                                    "Text": "Officer Channel Development",
                                    "Value": "Officer Channel Development"
                                },
                                {
                                    "Text": "Officer Customer Service",
                                    "Value": "Officer Customer Service"
                                },
                                {
                                    "Text": "Officer Claims",
                                    "Value": "Officer Claims"
                                },
                                {
                                    "Text": "Officer Central Operations",
                                    "Value": "Officer Central Operations"
                                },
                                {
                                    "Text": "Officer Logistics",
                                    "Value": "Officer Logistics"
                                },
                                {
                                    "Text": "Officer DPPM (sales support)",
                                    "Value": "Officer DPPM (sales support)"
                                },
                                {
                                    "Text": "Office Assistant Retired",
                                    "Value": "Office Assistant Retired"
                                },
                                {
                                    "Text": "Officer Trainee",
                                    "Value": "Officer Trainee"
                                },
                                {
                                    "Text": "Officer Stores",
                                    "Value": "Officer Stores"
                                },
                                {
                                    "Text": "Officer Front Desk",
                                    "Value": "Officer Front Desk"
                                },
                                {
                                    "Text": "Office Staff",
                                    "Value": "Office Staff"
                                },
                                {
                                    "Text": "Offset Machine Operator",
                                    "Value": "Offset Machine Operator"
                                },
                                {
                                    "Text": "Officer",
                                    "Value": "Officer"
                                },
                                {
                                    "Text": "Officer Ops(Customer Service",
                                    "Value": "Officer Ops(Customer Service"
                                },
                                {
                                    "Text": "Office Incharge",
                                    "Value": "Office Incharge"
                                },
                                {
                                    "Text": "Officer Group Operations",
                                    "Value": "Officer Group Operations"
                                },
                                {
                                    "Text": "Officer HR",
                                    "Value": "Officer HR"
                                },
                                {
                                    "Text": "Office Superintendent II",
                                    "Value": "Office Superintendent II"
                                },
                                {
                                    "Text": "Officer Investment MO / BO",
                                    "Value": "Officer Investment MO / BO"
                                },
                                {
                                    "Text": "Officer Legal",
                                    "Value": "Officer Legal"
                                },
                                {
                                    "Text": "Officer LMS",
                                    "Value": "Officer LMS"
                                },
                                {
                                    "Text": "Officer Materials",
                                    "Value": "Officer Materials"
                                },
                                {
                                    "Text": "Officer Marketing Services",
                                    "Value": "Officer Marketing Services"
                                },
                                {
                                    "Text": "Officer Medical Payments",
                                    "Value": "Officer Medical Payments"
                                },
                                {
                                    "Text": "Officer Systems",
                                    "Value": "Officer Systems"
                                },
                                {
                                    "Text": "Officer Operations",
                                    "Value": "Officer Operations"
                                },
                                {
                                    "Text": "Office Attendant",
                                    "Value": "Office Attendant"
                                },
                                {
                                    "Text": "Officer Quality Control",
                                    "Value": "Officer Quality Control"
                                },
                                {
                                    "Text": "Officer Online Marketing",
                                    "Value": "Officer Online Marketing"
                                },
                                {
                                    "Text": "Officer Hub Operations",
                                    "Value": "Officer Hub Operations"
                                },
                                {
                                    "Text": "Office Administrator",
                                    "Value": "Office Administrator"
                                },
                                {
                                    "Text": "Officer Ops(Persistency)",
                                    "Value": "Officer Ops(Persistency)"
                                },
                                {
                                    "Text": "Officer QC",
                                    "Value": "Officer QC"
                                },
                                {
                                    "Text": "Officer Customer Care",
                                    "Value": "Officer Customer Care"
                                },
                                {
                                    "Text": "Office Clerk",
                                    "Value": "Office Clerk"
                                },
                                {
                                    "Text": "Officer Ops(Finance and Risk",
                                    "Value": "Officer Ops(Finance and Risk"
                                },
                                {
                                    "Text": "Officer Service Support",
                                    "Value": "Officer Service Support"
                                },
                                {
                                    "Text": "Office Treasury",
                                    "Value": "Office Treasury"
                                },
                                {
                                    "Text": "Officer Shared Services",
                                    "Value": "Officer Shared Services"
                                },
                                {
                                    "Text": "Officer Sales Support",
                                    "Value": "Officer Sales Support"
                                },
                                {
                                    "Text": "Office Associate",
                                    "Value": "Office Associate"
                                },
                                {
                                    "Text": "Office Executive",
                                    "Value": "Office Executive"
                                },
                                {
                                    "Text": "Officer Documentation",
                                    "Value": "Officer Documentation"
                                },
                                {
                                    "Text": "Officer Excise Inspector",
                                    "Value": "Officer Excise Inspector"
                                },
                                {
                                    "Text": "Cosmetologist",
                                    "Value": "Cosmetologist"
                                },
                                {
                                    "Text": "Overhead crane driver",
                                    "Value": "Overhead crane driver"
                                },
                                {
                                    "Text": "Officer Human Resources",
                                    "Value": "Officer Human Resources"
                                },
                                {
                                    "Text": "Officer Accounts",
                                    "Value": "Officer Accounts"
                                },
                                {
                                    "Text": "Oil Refinery Worker",
                                    "Value": "Oil Refinery Worker"
                                },
                                {
                                    "Text": "Account Controller",
                                    "Value": "Account Controller"
                                },
                                {
                                    "Text": "Officer Medical Support",
                                    "Value": "Officer Medical Support"
                                },
                                {
                                    "Text": "Rig mechanic",
                                    "Value": "Rig mechanic"
                                },
                                {
                                    "Text": "Roughneck",
                                    "Value": "Roughneck"
                                },
                                {
                                    "Text": "Roustabout pusher",
                                    "Value": "Roustabout pusher"
                                },
                                {
                                    "Text": "Sub-sea Engineer",
                                    "Value": "Sub-sea Engineer"
                                },
                                {
                                    "Text": "Tool dresser",
                                    "Value": "Tool dresser"
                                },
                                {
                                    "Text": "Tool pusher",
                                    "Value": "Tool pusher"
                                },
                                {
                                    "Text": "Watchstander",
                                    "Value": "Watchstander"
                                },
                                {
                                    "Text": "Welder cutter",
                                    "Value": "Welder cutter"
                                },
                                {
                                    "Text": "Well logger",
                                    "Value": "Well logger"
                                },
                                {
                                    "Text": "Well tester",
                                    "Value": "Well tester"
                                },
                                {
                                    "Text": "Wireline operator",
                                    "Value": "Wireline operator"
                                },
                                {
                                    "Text": "ONGC Retired",
                                    "Value": "ONGC Retired"
                                },
                                {
                                    "Text": "Online share Trader",
                                    "Value": "Online share Trader"
                                },
                                {
                                    "Text": "Mud man",
                                    "Value": "Mud man"
                                },
                                {
                                    "Text": "Oil rigger",
                                    "Value": "Oil rigger"
                                },
                                {
                                    "Text": "Oilfield operator",
                                    "Value": "Oilfield operator"
                                },
                                {
                                    "Text": "Pumpman operator",
                                    "Value": "Pumpman operator"
                                },
                                {
                                    "Text": "Radio operator",
                                    "Value": "Radio operator"
                                },
                                {
                                    "Text": "Rig electrician",
                                    "Value": "Rig electrician"
                                },
                                {
                                    "Text": "Assistant driller",
                                    "Value": "Assistant driller"
                                },
                                {
                                    "Text": "Assistant tool pusher",
                                    "Value": "Assistant tool pusher"
                                },
                                {
                                    "Text": "Bargemaster",
                                    "Value": "Bargemaster"
                                },
                                {
                                    "Text": "Cementer",
                                    "Value": "Cementer"
                                },
                                {
                                    "Text": "Chargeman",
                                    "Value": "Chargeman"
                                },
                                {
                                    "Text": "Derrickman",
                                    "Value": "Derrickman"
                                },
                                {
                                    "Text": "Driller",
                                    "Value": "Driller"
                                },
                                {
                                    "Text": "Driller-tool dresser",
                                    "Value": "Driller-tool dresser"
                                },
                                {
                                    "Text": "Drilling supervisor",
                                    "Value": "Drilling supervisor"
                                },
                                {
                                    "Text": "Electric logger",
                                    "Value": "Electric logger"
                                },
                                {
                                    "Text": "Fieldman",
                                    "Value": "Fieldman"
                                },
                                {
                                    "Text": "Floorman",
                                    "Value": "Floorman"
                                },
                                {
                                    "Text": "Fuel technologist",
                                    "Value": "Fuel technologist"
                                },
                                {
                                    "Text": "Gang pusher",
                                    "Value": "Gang pusher"
                                },
                                {
                                    "Text": "Head roustabout",
                                    "Value": "Head roustabout"
                                },
                                {
                                    "Text": "Mud engineer",
                                    "Value": "Mud engineer"
                                },
                                {
                                    "Text": "Mud logger",
                                    "Value": "Mud logger"
                                },
                                {
                                    "Text": "Onion Merchant",
                                    "Value": "Onion Merchant"
                                },
                                {
                                    "Text": "Chief operator",
                                    "Value": "Chief operator"
                                },
                                {
                                    "Text": "Operation Assistant",
                                    "Value": "Operation Assistant"
                                },
                                {
                                    "Text": "Operations Manager",
                                    "Value": "Operations Manager"
                                },
                                {
                                    "Text": "Operations Officer",
                                    "Value": "Operations Officer"
                                },
                                {
                                    "Text": "Operations Superintendent",
                                    "Value": "Operations Superintendent"
                                },
                                {
                                    "Text": "Operator Cum Technician",
                                    "Value": "Operator Cum Technician"
                                },
                                {
                                    "Text": "Operator Grade I",
                                    "Value": "Operator Grade I"
                                },
                                {
                                    "Text": "Operator I",
                                    "Value": "Operator I"
                                },
                                {
                                    "Text": "Operator II",
                                    "Value": "Operator II"
                                },
                                {
                                    "Text": "Operator Supervisor",
                                    "Value": "Operator Supervisor"
                                },
                                {
                                    "Text": "Optometrist & Proprietor",
                                    "Value": "Optometrist & Proprietor"
                                },
                                {
                                    "Text": "Operative Technician",
                                    "Value": "Operative Technician"
                                },
                                {
                                    "Text": "Operation Engineer",
                                    "Value": "Operation Engineer"
                                },
                                {
                                    "Text": "Operating Engineer",
                                    "Value": "Operating Engineer"
                                },
                                {
                                    "Text": "Operations Incharge",
                                    "Value": "Operations Incharge"
                                },
                                {
                                    "Text": "Operator Grade II",
                                    "Value": "Operator Grade II"
                                },
                                {
                                    "Text": "Ophthalmic Assistant",
                                    "Value": "Ophthalmic Assistant"
                                },
                                {
                                    "Text": "Operation Coordinator",
                                    "Value": "Operation Coordinator"
                                },
                                {
                                    "Text": "Officer Procurement",
                                    "Value": "Officer Procurement"
                                },
                                {
                                    "Text": "Operator",
                                    "Value": "Operator"
                                },
                                {
                                    "Text": "Opthalmologist",
                                    "Value": "Opthalmologist"
                                },
                                {
                                    "Text": "Contact lens specialist",
                                    "Value": "Contact lens specialist"
                                },
                                {
                                    "Text": "Dispensing optician",
                                    "Value": "Dispensing optician"
                                },
                                {
                                    "Text": "Optical dispenser",
                                    "Value": "Optical dispenser"
                                },
                                {
                                    "Text": "Optologist",
                                    "Value": "Optologist"
                                },
                                {
                                    "Text": "Optometrist",
                                    "Value": "Optometrist"
                                },
                                {
                                    "Text": "Optician",
                                    "Value": "Optician"
                                },
                                {
                                    "Text": "Operations Executive",
                                    "Value": "Operations Executive"
                                },
                                {
                                    "Text": "Orthopaedic Surgeon",
                                    "Value": "Orthopaedic Surgeon"
                                },
                                {
                                    "Text": "Orchestrator",
                                    "Value": "Orchestrator"
                                },
                                {
                                    "Text": "Ammunition technical officer",
                                    "Value": "Ammunition technical officer"
                                },
                                {
                                    "Text": "Ammunition technician",
                                    "Value": "Ammunition technician"
                                },
                                {
                                    "Text": "Order Management",
                                    "Value": "Order Management"
                                },
                                {
                                    "Text": "Orthopaedic Consultant",
                                    "Value": "Orthopaedic Consultant"
                                },
                                {
                                    "Text": "Oral Maxilla Facial Surgeon",
                                    "Value": "Oral Maxilla Facial Surgeon"
                                },
                                {
                                    "Text": "Orthodontist",
                                    "Value": "Orthodontist"
                                },
                                {
                                    "Text": "OT Incharge",
                                    "Value": "OT Incharge"
                                },
                                {
                                    "Text": "OT Assistant",
                                    "Value": "OT Assistant"
                                },
                                {
                                    "Text": "Otherwise",
                                    "Value": "Otherwise"
                                },
                                {
                                    "Text": "Owner & Agriculture",
                                    "Value": "Owner & Agriculture"
                                },
                                {
                                    "Text": "Owner & Consultant",
                                    "Value": "Owner & Consultant"
                                },
                                {
                                    "Text": "Owner & Contractor",
                                    "Value": "Owner & Contractor"
                                },
                                {
                                    "Text": "Owner & Director",
                                    "Value": "Owner & Director"
                                },
                                {
                                    "Text": "Owner & Farmer",
                                    "Value": "Owner & Farmer"
                                },
                                {
                                    "Text": "Owner & Financial Consultant",
                                    "Value": "Owner & Financial Consultant"
                                },
                                {
                                    "Text": "Owner & Lawyer",
                                    "Value": "Owner & Lawyer"
                                },
                                {
                                    "Text": "Owner & Manager",
                                    "Value": "Owner & Manager"
                                },
                                {
                                    "Text": "Owner & Partner",
                                    "Value": "Owner & Partner"
                                },
                                {
                                    "Text": "Owner & Shoekeeper",
                                    "Value": "Owner & Shoekeeper"
                                },
                                {
                                    "Text": "Owner (Proprietor)",
                                    "Value": "Owner (Proprietor)"
                                },
                                {
                                    "Text": "Owner Firm",
                                    "Value": "Owner Firm"
                                },
                                {
                                    "Text": "Owner Jewellery Shop",
                                    "Value": "Owner Jewellery Shop"
                                },
                                {
                                    "Text": "Owner Kirana Merchant",
                                    "Value": "Owner Kirana Merchant"
                                },
                                {
                                    "Text": "Owner Landlord",
                                    "Value": "Owner Landlord"
                                },
                                {
                                    "Text": "Owner Medical Shop",
                                    "Value": "Owner Medical Shop"
                                },
                                {
                                    "Text": "Owner Of Agriculture Farm",
                                    "Value": "Owner Of Agriculture Farm"
                                },
                                {
                                    "Text": "Owner Of Beauty Parlour",
                                    "Value": "Owner Of Beauty Parlour"
                                },
                                {
                                    "Text": "Owner Pan Shop",
                                    "Value": "Owner Pan Shop"
                                },
                                {
                                    "Text": "Owner Restaurant",
                                    "Value": "Owner Restaurant"
                                },
                                {
                                    "Text": "Owner Shopkeeper",
                                    "Value": "Owner Shopkeeper"
                                },
                                {
                                    "Text": "Owner Stationary Shop",
                                    "Value": "Owner Stationary Shop"
                                },
                                {
                                    "Text": "Owner Tailor",
                                    "Value": "Owner Tailor"
                                },
                                {
                                    "Text": "Owner Tyre Shop",
                                    "Value": "Owner Tyre Shop"
                                },
                                {
                                    "Text": "Owner Workshop",
                                    "Value": "Owner Workshop"
                                },
                                {
                                    "Text": "Owner & CA",
                                    "Value": "Owner & CA"
                                },
                                {
                                    "Text": "Owner Travel Agency",
                                    "Value": "Owner Travel Agency"
                                },
                                {
                                    "Text": "Owner & Depot Holder",
                                    "Value": "Owner & Depot Holder"
                                },
                                {
                                    "Text": "Owner Interest Income",
                                    "Value": "Owner Interest Income"
                                },
                                {
                                    "Text": "Owner Of Agricultural Land",
                                    "Value": "Owner Of Agricultural Land"
                                },
                                {
                                    "Text": "Owner & Tailoring",
                                    "Value": "Owner & Tailoring"
                                },
                                {
                                    "Text": "Owner & Commission Agent",
                                    "Value": "Owner & Commission Agent"
                                },
                                {
                                    "Text": "Owner Tuition",
                                    "Value": "Owner Tuition"
                                },
                                {
                                    "Text": "Owner Cloth Shop",
                                    "Value": "Owner Cloth Shop"
                                },
                                {
                                    "Text": "Owner & Landlord",
                                    "Value": "Owner & Landlord"
                                },
                                {
                                    "Text": "Owner General Store",
                                    "Value": "Owner General Store"
                                },
                                {
                                    "Text": "Owner Farm",
                                    "Value": "Owner Farm"
                                },
                                {
                                    "Text": "Owner Business House",
                                    "Value": "Owner Business House"
                                },
                                {
                                    "Text": "Owner Coaching Institute",
                                    "Value": "Owner Coaching Institute"
                                },
                                {
                                    "Text": "Owner Of Boutique",
                                    "Value": "Owner Of Boutique"
                                },
                                {
                                    "Text": "Owner Beauty Parlour",
                                    "Value": "Owner Beauty Parlour"
                                },
                                {
                                    "Text": "Owner & Trader",
                                    "Value": "Owner & Trader"
                                },
                                {
                                    "Text": "PA To Finance Director",
                                    "Value": "PA To Finance Director"
                                },
                                {
                                    "Text": "PA To Sub Area Manager",
                                    "Value": "PA To Sub Area Manager"
                                },
                                {
                                    "Text": "Packaging Contractor",
                                    "Value": "Packaging Contractor"
                                },
                                {
                                    "Text": "Packaging Dealer",
                                    "Value": "Packaging Dealer"
                                },
                                {
                                    "Text": "Packaging Supervisor",
                                    "Value": "Packaging Supervisor"
                                },
                                {
                                    "Text": "Paediatric Dentist",
                                    "Value": "Paediatric Dentist"
                                },
                                {
                                    "Text": "Panchayat President",
                                    "Value": "Panchayat President"
                                },
                                {
                                    "Text": "Panchayat Secrtry & Agricltrst",
                                    "Value": "Panchayat Secrtry & Agricltrst"
                                },
                                {
                                    "Text": "Paramedical Officer",
                                    "Value": "Paramedical Officer"
                                },
                                {
                                    "Text": "Paramedical Ophthalmic Asst",
                                    "Value": "Paramedical Ophthalmic Asst"
                                },
                                {
                                    "Text": "Parcel Clerk",
                                    "Value": "Parcel Clerk"
                                },
                                {
                                    "Text": "Partner Technical",
                                    "Value": "Partner Technical"
                                },
                                {
                                    "Text": "Partner & Doctor",
                                    "Value": "Partner & Doctor"
                                },
                                {
                                    "Text": "Partner & Farmer",
                                    "Value": "Partner & Farmer"
                                },
                                {
                                    "Text": "Partner & Manager",
                                    "Value": "Partner & Manager"
                                },
                                {
                                    "Text": "Partner & Manaing Partner",
                                    "Value": "Partner & Manaing Partner"
                                },
                                {
                                    "Text": "Partner Family Business",
                                    "Value": "Partner Family Business"
                                },
                                {
                                    "Text": "Partner In Business",
                                    "Value": "Partner In Business"
                                },
                                {
                                    "Text": "Partner Joint Venture",
                                    "Value": "Partner Joint Venture"
                                },
                                {
                                    "Text": "Patwari",
                                    "Value": "Patwari"
                                },
                                {
                                    "Text": "P.R.O",
                                    "Value": "P.R.O"
                                },
                                {
                                    "Text": "Partner Architect",
                                    "Value": "Partner Architect"
                                },
                                {
                                    "Text": "Partner",
                                    "Value": "Partner"
                                },
                                {
                                    "Text": "Panchayat Executive Officer",
                                    "Value": "Panchayat Executive Officer"
                                },
                                {
                                    "Text": "Patwari Revenue Department",
                                    "Value": "Patwari Revenue Department"
                                },
                                {
                                    "Text": "PA Administration",
                                    "Value": "PA Administration"
                                },
                                {
                                    "Text": "PA To Director",
                                    "Value": "PA To Director"
                                },
                                {
                                    "Text": "Paramedic",
                                    "Value": "Paramedic"
                                },
                                {
                                    "Text": "CISF police inspector",
                                    "Value": "CISF police inspector"
                                },
                                {
                                    "Text": "RPF Jawan",
                                    "Value": "RPF Jawan"
                                },
                                {
                                    "Text": "CISF Jawan",
                                    "Value": "CISF Jawan"
                                },
                                {
                                    "Text": "Auxillary police",
                                    "Value": "Auxillary police"
                                },
                                {
                                    "Text": "Sergeant",
                                    "Value": "Sergeant"
                                },
                                {
                                    "Text": "RAF Inspector",
                                    "Value": "RAF Inspector"
                                },
                                {
                                    "Text": "RAF Constable",
                                    "Value": "RAF Constable"
                                },
                                {
                                    "Text": "BSF-Border Security Force",
                                    "Value": "BSF-Border Security Force"
                                },
                                {
                                    "Text": "CRPF-Central Res Police Force",
                                    "Value": "CRPF-Central Res Police Force"
                                },
                                {
                                    "Text": "ITBP-Indo Tibetan Bord. Police",
                                    "Value": "ITBP-Indo Tibetan Bord. Police"
                                },
                                {
                                    "Text": "DSC-Defence security corps",
                                    "Value": "DSC-Defence security corps"
                                },
                                {
                                    "Text": "SPG-Special Protection Group",
                                    "Value": "SPG-Special Protection Group"
                                },
                                {
                                    "Text": "Commando",
                                    "Value": "Commando"
                                },
                                {
                                    "Text": "Panchayat Secretary",
                                    "Value": "Panchayat Secretary"
                                },
                                {
                                    "Text": "Paint Business",
                                    "Value": "Paint Business"
                                },
                                {
                                    "Text": "Paddy Supplier",
                                    "Value": "Paddy Supplier"
                                },
                                {
                                    "Text": "Partner Karta",
                                    "Value": "Partner Karta"
                                },
                                {
                                    "Text": "Prof.Audit & Tax Consultant",
                                    "Value": "Prof.Audit & Tax Consultant"
                                },
                                {
                                    "Text": "Pastor & Advocate",
                                    "Value": "Pastor & Advocate"
                                },
                                {
                                    "Text": "Pathologist",
                                    "Value": "Pathologist"
                                },
                                {
                                    "Text": "Partner & Director",
                                    "Value": "Partner & Director"
                                },
                                {
                                    "Text": "Pediatrician Doctor",
                                    "Value": "Pediatrician Doctor"
                                },
                                {
                                    "Text": "Pension Holder",
                                    "Value": "Pension Holder"
                                },
                                {
                                    "Text": "Pensioner & Investor",
                                    "Value": "Pensioner & Investor"
                                },
                                {
                                    "Text": "Pensioner & Retired",
                                    "Value": "Pensioner & Retired"
                                },
                                {
                                    "Text": "Pensioner Retired",
                                    "Value": "Pensioner Retired"
                                },
                                {
                                    "Text": "Pensioner Subedar Major",
                                    "Value": "Pensioner Subedar Major"
                                },
                                {
                                    "Text": "Personal Banker",
                                    "Value": "Personal Banker"
                                },
                                {
                                    "Text": "Personal Dept. Personnel Asst.",
                                    "Value": "Personal Dept. Personnel Asst."
                                },
                                {
                                    "Text": "Personal Loan Executive",
                                    "Value": "Personal Loan Executive"
                                },
                                {
                                    "Text": "Personnel Officer",
                                    "Value": "Personnel Officer"
                                },
                                {
                                    "Text": "Petty Officer Writer",
                                    "Value": "Petty Officer Writer"
                                },
                                {
                                    "Text": "Pediatrician",
                                    "Value": "Pediatrician"
                                },
                                {
                                    "Text": "Pension Holder & Retired",
                                    "Value": "Pension Holder & Retired"
                                },
                                {
                                    "Text": "Personnel Department Staff",
                                    "Value": "Personnel Department Staff"
                                },
                                {
                                    "Text": "Pension & Interest Income",
                                    "Value": "Pension & Interest Income"
                                },
                                {
                                    "Text": "Personal Assistant",
                                    "Value": "Personal Assistant"
                                },
                                {
                                    "Text": "Peon",
                                    "Value": "Peon"
                                },
                                {
                                    "Text": "Pensioner & Landlord",
                                    "Value": "Pensioner & Landlord"
                                },
                                {
                                    "Text": "Pension Income & Agriculture",
                                    "Value": "Pension Income & Agriculture"
                                },
                                {
                                    "Text": "Personnel Secretary",
                                    "Value": "Personnel Secretary"
                                },
                                {
                                    "Text": "Pensioner Defense",
                                    "Value": "Pensioner Defense"
                                },
                                {
                                    "Text": "Pensioner",
                                    "Value": "Pensioner"
                                },
                                {
                                    "Text": "Personal Finance Executive",
                                    "Value": "Personal Finance Executive"
                                },
                                {
                                    "Text": "Professional",
                                    "Value": "Professional"
                                },
                                {
                                    "Text": "Pharma Consultant",
                                    "Value": "Pharma Consultant"
                                },
                                {
                                    "Text": "Pharma Sales Officer",
                                    "Value": "Pharma Sales Officer"
                                },
                                {
                                    "Text": "Physical Director",
                                    "Value": "Physical Director"
                                },
                                {
                                    "Text": "Physical Education Teacher",
                                    "Value": "Physical Education Teacher"
                                },
                                {
                                    "Text": "Physical Training Teacher",
                                    "Value": "Physical Training Teacher"
                                },
                                {
                                    "Text": "Physician Doctor",
                                    "Value": "Physician Doctor"
                                },
                                {
                                    "Text": "Photo Colour Lab Technician",
                                    "Value": "Photo Colour Lab Technician"
                                },
                                {
                                    "Text": "Phone Banking Officer",
                                    "Value": "Phone Banking Officer"
                                },
                                {
                                    "Text": "Pharma Assitant",
                                    "Value": "Pharma Assitant"
                                },
                                {
                                    "Text": "Photographer",
                                    "Value": "Photographer"
                                },
                                {
                                    "Text": "Pharma Sales Executive",
                                    "Value": "Pharma Sales Executive"
                                },
                                {
                                    "Text": "Physician",
                                    "Value": "Physician"
                                },
                                {
                                    "Text": "Pharmaceutical Analyst",
                                    "Value": "Pharmaceutical Analyst"
                                },
                                {
                                    "Text": "Planning Officer",
                                    "Value": "Planning Officer"
                                },
                                {
                                    "Text": "Planning Sub Inspector",
                                    "Value": "Planning Sub Inspector"
                                },
                                {
                                    "Text": "Plant Engineer",
                                    "Value": "Plant Engineer"
                                },
                                {
                                    "Text": "Plant Manager",
                                    "Value": "Plant Manager"
                                },
                                {
                                    "Text": "Planter",
                                    "Value": "Planter"
                                },
                                {
                                    "Text": "Plant attendant",
                                    "Value": "Plant attendant"
                                },
                                {
                                    "Text": "Power loader",
                                    "Value": "Power loader"
                                },
                                {
                                    "Text": "Plant electrician",
                                    "Value": "Plant electrician"
                                },
                                {
                                    "Text": "Planning Manager",
                                    "Value": "Planning Manager"
                                },
                                {
                                    "Text": "Plumber Mistry",
                                    "Value": "Plumber Mistry"
                                },
                                {
                                    "Text": "Placement Consultant",
                                    "Value": "Placement Consultant"
                                },
                                {
                                    "Text": "Plastic Surgeon",
                                    "Value": "Plastic Surgeon"
                                },
                                {
                                    "Text": "Plant Operator",
                                    "Value": "Plant Operator"
                                },
                                {
                                    "Text": "Planning Coordinator",
                                    "Value": "Planning Coordinator"
                                },
                                {
                                    "Text": "Plumber's mate",
                                    "Value": "Plumber's mate"
                                },
                                {
                                    "Text": "Plant Researcher",
                                    "Value": "Plant Researcher"
                                },
                                {
                                    "Text": "Project Manager Business",
                                    "Value": "Project Manager Business"
                                },
                                {
                                    "Text": "Gantry crane driver",
                                    "Value": "Gantry crane driver"
                                },
                                {
                                    "Text": "Post Master",
                                    "Value": "Post Master"
                                },
                                {
                                    "Text": "Post Office Agent",
                                    "Value": "Post Office Agent"
                                },
                                {
                                    "Text": "Postal Agent",
                                    "Value": "Postal Agent"
                                },
                                {
                                    "Text": "Hoist",
                                    "Value": "Hoist"
                                },
                                {
                                    "Text": "Potato Supplier",
                                    "Value": "Potato Supplier"
                                },
                                {
                                    "Text": "Jetty hand",
                                    "Value": "Jetty hand"
                                },
                                {
                                    "Text": "Transport Operator",
                                    "Value": "Transport Operator"
                                },
                                {
                                    "Text": "Polaris Aptitude Trainee",
                                    "Value": "Polaris Aptitude Trainee"
                                },
                                {
                                    "Text": "Portfolio Control Manager",
                                    "Value": "Portfolio Control Manager"
                                },
                                {
                                    "Text": "Linesman",
                                    "Value": "Linesman"
                                },
                                {
                                    "Text": "Linesman erector",
                                    "Value": "Linesman erector"
                                },
                                {
                                    "Text": "Linesman mate",
                                    "Value": "Linesman mate"
                                },
                                {
                                    "Text": "Machinery electrician",
                                    "Value": "Machinery electrician"
                                },
                                {
                                    "Text": "Boiler cleaner",
                                    "Value": "Boiler cleaner"
                                },
                                {
                                    "Text": "Cable layer",
                                    "Value": "Cable layer"
                                },
                                {
                                    "Text": "Cable tester",
                                    "Value": "Cable tester"
                                },
                                {
                                    "Text": "Cable installer",
                                    "Value": "Cable installer"
                                },
                                {
                                    "Text": "Maintenance electrician",
                                    "Value": "Maintenance electrician"
                                },
                                {
                                    "Text": "Ship bld & repair electrician",
                                    "Value": "Ship bld & repair electrician"
                                },
                                {
                                    "Text": "Electrician quarrying",
                                    "Value": "Electrician quarrying"
                                },
                                {
                                    "Text": "Electrician Motorvehicle mfg.",
                                    "Value": "Electrician Motorvehicle mfg."
                                },
                                {
                                    "Text": "Leader",
                                    "Value": "Leader"
                                },
                                {
                                    "Text": "MLA",
                                    "Value": "MLA"
                                },
                                {
                                    "Text": "MP",
                                    "Value": "MP"
                                },
                                {
                                    "Text": "Dock master",
                                    "Value": "Dock master"
                                },
                                {
                                    "Text": "Harbour master",
                                    "Value": "Harbour master"
                                },
                                {
                                    "Text": "Pier master",
                                    "Value": "Pier master"
                                },
                                {
                                    "Text": "Port control signalman",
                                    "Value": "Port control signalman"
                                },
                                {
                                    "Text": "Weigh bridgeman",
                                    "Value": "Weigh bridgeman"
                                },
                                {
                                    "Text": "Dock foreman",
                                    "Value": "Dock foreman"
                                },
                                {
                                    "Text": "Dock overseer",
                                    "Value": "Dock overseer"
                                },
                                {
                                    "Text": "Post Agent",
                                    "Value": "Post Agent"
                                },
                                {
                                    "Text": "Docker",
                                    "Value": "Docker"
                                },
                                {
                                    "Text": "Port worker",
                                    "Value": "Port worker"
                                },
                                {
                                    "Text": "Shore Donkeyman",
                                    "Value": "Shore Donkeyman"
                                },
                                {
                                    "Text": "Stevedore",
                                    "Value": "Stevedore"
                                },
                                {
                                    "Text": "Coolie",
                                    "Value": "Coolie"
                                },
                                {
                                    "Text": "Dock cargo handler",
                                    "Value": "Dock cargo handler"
                                },
                                {
                                    "Text": "Dock waterman",
                                    "Value": "Dock waterman"
                                },
                                {
                                    "Text": "Dock assistant",
                                    "Value": "Dock assistant"
                                },
                                {
                                    "Text": "Dockyard worker",
                                    "Value": "Dockyard worker"
                                },
                                {
                                    "Text": "Rafter",
                                    "Value": "Rafter"
                                },
                                {
                                    "Text": "Port assistant",
                                    "Value": "Port assistant"
                                },
                                {
                                    "Text": "Superintendent stevedore",
                                    "Value": "Superintendent stevedore"
                                },
                                {
                                    "Text": "Winchworker",
                                    "Value": "Winchworker"
                                },
                                {
                                    "Text": "Fork lift driver",
                                    "Value": "Fork lift driver"
                                },
                                {
                                    "Text": "Fork lift operator in dock",
                                    "Value": "Fork lift operator in dock"
                                },
                                {
                                    "Text": "Fork lift truck driver",
                                    "Value": "Fork lift truck driver"
                                },
                                {
                                    "Text": "Yard checker",
                                    "Value": "Yard checker"
                                },
                                {
                                    "Text": "Winch driver",
                                    "Value": "Winch driver"
                                },
                                {
                                    "Text": "Dock worker",
                                    "Value": "Dock worker"
                                },
                                {
                                    "Text": "Potter",
                                    "Value": "Potter"
                                },
                                {
                                    "Text": "Poutry",
                                    "Value": "Poutry"
                                },
                                {
                                    "Text": "Cable engineer",
                                    "Value": "Cable engineer"
                                },
                                {
                                    "Text": "Substation attendant",
                                    "Value": "Substation attendant"
                                },
                                {
                                    "Text": "Electrical wireman",
                                    "Value": "Electrical wireman"
                                },
                                {
                                    "Text": "Electrical contractor",
                                    "Value": "Electrical contractor"
                                },
                                {
                                    "Text": "Electrical fitter",
                                    "Value": "Electrical fitter"
                                },
                                {
                                    "Text": "Meter fixer",
                                    "Value": "Meter fixer"
                                },
                                {
                                    "Text": "Meter reader",
                                    "Value": "Meter reader"
                                },
                                {
                                    "Text": "Meter tester",
                                    "Value": "Meter tester"
                                },
                                {
                                    "Text": "Power plant attendant",
                                    "Value": "Power plant attendant"
                                },
                                {
                                    "Text": "Postal Assistant",
                                    "Value": "Postal Assistant"
                                },
                                {
                                    "Text": "Proprietor Rent A Cab",
                                    "Value": "Proprietor Rent A Cab"
                                },
                                {
                                    "Text": "Practicing Dentist",
                                    "Value": "Practicing Dentist"
                                },
                                {
                                    "Text": "Prepaid Lead",
                                    "Value": "Prepaid Lead"
                                },
                                {
                                    "Text": "Practicing Lawyer",
                                    "Value": "Practicing Lawyer"
                                },
                                {
                                    "Text": "Practicing Radiologist",
                                    "Value": "Practicing Radiologist"
                                },
                                {
                                    "Text": "Prawn Commission Agent",
                                    "Value": "Prawn Commission Agent"
                                },
                                {
                                    "Text": "President Operation",
                                    "Value": "President Operation"
                                },
                                {
                                    "Text": "Prevention Officer",
                                    "Value": "Prevention Officer"
                                },
                                {
                                    "Text": "Procurement Professional",
                                    "Value": "Procurement Professional"
                                },
                                {
                                    "Text": "Primary Health Worker",
                                    "Value": "Primary Health Worker"
                                },
                                {
                                    "Text": "Primary Teacher",
                                    "Value": "Primary Teacher"
                                },
                                {
                                    "Text": "Principal Coaching Institute",
                                    "Value": "Principal Coaching Institute"
                                },
                                {
                                    "Text": "Principal Consultant",
                                    "Value": "Principal Consultant"
                                },
                                {
                                    "Text": "Principal Of School",
                                    "Value": "Principal Of School"
                                },
                                {
                                    "Text": "Principal Scientist",
                                    "Value": "Principal Scientist"
                                },
                                {
                                    "Text": "Principle Design Engineer",
                                    "Value": "Principle Design Engineer"
                                },
                                {
                                    "Text": "Principle Facilities Engineer",
                                    "Value": "Principle Facilities Engineer"
                                },
                                {
                                    "Text": "Printing & Design Engineer",
                                    "Value": "Printing & Design Engineer"
                                },
                                {
                                    "Text": "Printing Master",
                                    "Value": "Printing Master"
                                },
                                {
                                    "Text": "Printing Supervisor",
                                    "Value": "Printing Supervisor"
                                },
                                {
                                    "Text": "Private Financer",
                                    "Value": "Private Financer"
                                },
                                {
                                    "Text": "Private Practitioner Doctor",
                                    "Value": "Private Practitioner Doctor"
                                },
                                {
                                    "Text": "Private Pratice Clinic Owner",
                                    "Value": "Private Pratice Clinic Owner"
                                },
                                {
                                    "Text": "Private Teacher",
                                    "Value": "Private Teacher"
                                },
                                {
                                    "Text": "Private Tuition Teacher",
                                    "Value": "Private Tuition Teacher"
                                },
                                {
                                    "Text": "Private Tutor",
                                    "Value": "Private Tutor"
                                },
                                {
                                    "Text": "Probationary Executive",
                                    "Value": "Probationary Executive"
                                },
                                {
                                    "Text": "Probationary Manager",
                                    "Value": "Probationary Manager"
                                },
                                {
                                    "Text": "Process Administrator",
                                    "Value": "Process Administrator"
                                },
                                {
                                    "Text": "Process Analyst",
                                    "Value": "Process Analyst"
                                },
                                {
                                    "Text": "Process Consultant",
                                    "Value": "Process Consultant"
                                },
                                {
                                    "Text": "Process Controller",
                                    "Value": "Process Controller"
                                },
                                {
                                    "Text": "Process Department Engineer",
                                    "Value": "Process Department Engineer"
                                },
                                {
                                    "Text": "Process Developer",
                                    "Value": "Process Developer"
                                },
                                {
                                    "Text": "Process Engineer",
                                    "Value": "Process Engineer"
                                },
                                {
                                    "Text": "Process Incharge",
                                    "Value": "Process Incharge"
                                },
                                {
                                    "Text": "Process Leader",
                                    "Value": "Process Leader"
                                },
                                {
                                    "Text": "Process Manager",
                                    "Value": "Process Manager"
                                },
                                {
                                    "Text": "Process Operator",
                                    "Value": "Process Operator"
                                },
                                {
                                    "Text": "Process Shift Supervisor",
                                    "Value": "Process Shift Supervisor"
                                },
                                {
                                    "Text": "Process Specialist",
                                    "Value": "Process Specialist"
                                },
                                {
                                    "Text": "Process Surveyor",
                                    "Value": "Process Surveyor"
                                },
                                {
                                    "Text": "Procurement Executive",
                                    "Value": "Procurement Executive"
                                },
                                {
                                    "Text": "Procurement Manager",
                                    "Value": "Procurement Manager"
                                },
                                {
                                    "Text": "Product Manager Bankassurance",
                                    "Value": "Product Manager Bankassurance"
                                },
                                {
                                    "Text": "Product Developer",
                                    "Value": "Product Developer"
                                },
                                {
                                    "Text": "Product Development Executive",
                                    "Value": "Product Development Executive"
                                },
                                {
                                    "Text": "Archaka",
                                    "Value": "Archaka"
                                },
                                {
                                    "Text": "Product Engineer",
                                    "Value": "Product Engineer"
                                },
                                {
                                    "Text": "Product Executive",
                                    "Value": "Product Executive"
                                },
                                {
                                    "Text": "Product Manager",
                                    "Value": "Product Manager"
                                },
                                {
                                    "Text": "Product Marketing Manager",
                                    "Value": "Product Marketing Manager"
                                },
                                {
                                    "Text": "Product Promotion Incharge",
                                    "Value": "Product Promotion Incharge"
                                },
                                {
                                    "Text": "Product Specialist",
                                    "Value": "Product Specialist"
                                },
                                {
                                    "Text": "Product Technology Leader",
                                    "Value": "Product Technology Leader"
                                },
                                {
                                    "Text": "Product Unit Manager",
                                    "Value": "Product Unit Manager"
                                },
                                {
                                    "Text": "Project Architect",
                                    "Value": "Project Architect"
                                },
                                {
                                    "Text": "Production Packing Assistant",
                                    "Value": "Production Packing Assistant"
                                },
                                {
                                    "Text": "Production Technology Leader",
                                    "Value": "Production Technology Leader"
                                },
                                {
                                    "Text": "Productivity Improvement Engg.",
                                    "Value": "Productivity Improvement Engg."
                                },
                                {
                                    "Text": "Proprietor Courier Agency",
                                    "Value": "Proprietor Courier Agency"
                                },
                                {
                                    "Text": "Professional Architect",
                                    "Value": "Professional Architect"
                                },
                                {
                                    "Text": "Professional Artist",
                                    "Value": "Professional Artist"
                                },
                                {
                                    "Text": "Professional Consultant",
                                    "Value": "Professional Consultant"
                                },
                                {
                                    "Text": "Professional Designer",
                                    "Value": "Professional Designer"
                                },
                                {
                                    "Text": "Professional Doctor",
                                    "Value": "Professional Doctor"
                                },
                                {
                                    "Text": "Professional Football Player",
                                    "Value": "Professional Football Player"
                                },
                                {
                                    "Text": "Professional Musician",
                                    "Value": "Professional Musician"
                                },
                                {
                                    "Text": "Professional Photographer",
                                    "Value": "Professional Photographer"
                                },
                                {
                                    "Text": "Professional Sales Officer",
                                    "Value": "Professional Sales Officer"
                                },
                                {
                                    "Text": "Professional Service Officer",
                                    "Value": "Professional Service Officer"
                                },
                                {
                                    "Text": "Professional Tax Consultant",
                                    "Value": "Professional Tax Consultant"
                                },
                                {
                                    "Text": "Professional Trainer",
                                    "Value": "Professional Trainer"
                                },
                                {
                                    "Text": "Professionl Serv Representatve",
                                    "Value": "Professionl Serv Representatve"
                                },
                                {
                                    "Text": "Professor & Doctor",
                                    "Value": "Professor & Doctor"
                                },
                                {
                                    "Text": "Professor & Head",
                                    "Value": "Professor & Head"
                                },
                                {
                                    "Text": "Professor & Principal",
                                    "Value": "Professor & Principal"
                                },
                                {
                                    "Text": "Professor Accountant",
                                    "Value": "Professor Accountant"
                                },
                                {
                                    "Text": "Professor Head Mechanical",
                                    "Value": "Professor Head Mechanical"
                                },
                                {
                                    "Text": "Professor Of Cardiology",
                                    "Value": "Professor Of Cardiology"
                                },
                                {
                                    "Text": "Professor Of Statistics",
                                    "Value": "Professor Of Statistics"
                                },
                                {
                                    "Text": "Professor Of Surgery",
                                    "Value": "Professor Of Surgery"
                                },
                                {
                                    "Text": "Professor Service Officer",
                                    "Value": "Professor Service Officer"
                                },
                                {
                                    "Text": "Profnl Surveyr & Loss Assessor",
                                    "Value": "Profnl Surveyr & Loss Assessor"
                                },
                                {
                                    "Text": "Programme Director",
                                    "Value": "Programme Director"
                                },
                                {
                                    "Text": "Principal Retired",
                                    "Value": "Principal Retired"
                                },
                                {
                                    "Text": "Project Advisor",
                                    "Value": "Project Advisor"
                                },
                                {
                                    "Text": "Project Assistant",
                                    "Value": "Project Assistant"
                                },
                                {
                                    "Text": "Project Associate",
                                    "Value": "Project Associate"
                                },
                                {
                                    "Text": "Project Contractor",
                                    "Value": "Project Contractor"
                                },
                                {
                                    "Text": "Project Development Officer",
                                    "Value": "Project Development Officer"
                                },
                                {
                                    "Text": "Project Director",
                                    "Value": "Project Director"
                                },
                                {
                                    "Text": "Project Engineer",
                                    "Value": "Project Engineer"
                                },
                                {
                                    "Text": "Project Executive",
                                    "Value": "Project Executive"
                                },
                                {
                                    "Text": "Proprietor & Tuition Classes",
                                    "Value": "Proprietor & Tuition Classes"
                                },
                                {
                                    "Text": "Project Lead Softwre Develpmnt",
                                    "Value": "Project Lead Softwre Develpmnt"
                                },
                                {
                                    "Text": "Project Management Executive",
                                    "Value": "Project Management Executive"
                                },
                                {
                                    "Text": "Project Management Officer",
                                    "Value": "Project Management Officer"
                                },
                                {
                                    "Text": "Project Officer",
                                    "Value": "Project Officer"
                                },
                                {
                                    "Text": "Project Sales Engineer",
                                    "Value": "Project Sales Engineer"
                                },
                                {
                                    "Text": "Project Supervisor",
                                    "Value": "Project Supervisor"
                                },
                                {
                                    "Text": "Promotion Manager",
                                    "Value": "Promotion Manager"
                                },
                                {
                                    "Text": "Promotional Executive",
                                    "Value": "Promotional Executive"
                                },
                                {
                                    "Text": "Promotions Officer",
                                    "Value": "Promotions Officer"
                                },
                                {
                                    "Text": "Proof Verifying Executive",
                                    "Value": "Proof Verifying Executive"
                                },
                                {
                                    "Text": "Property Broker",
                                    "Value": "Property Broker"
                                },
                                {
                                    "Text": "Property Consultant",
                                    "Value": "Property Consultant"
                                },
                                {
                                    "Text": "Property Development Officer",
                                    "Value": "Property Development Officer"
                                },
                                {
                                    "Text": "Property Owner",
                                    "Value": "Property Owner"
                                },
                                {
                                    "Text": "Proprietor & Agent",
                                    "Value": "Proprietor & Agent"
                                },
                                {
                                    "Text": "Proprietor & Farm Owner",
                                    "Value": "Proprietor & Farm Owner"
                                },
                                {
                                    "Text": "Proprietor & Farmer",
                                    "Value": "Proprietor & Farmer"
                                },
                                {
                                    "Text": "Proprietor & FC HDFCSLIC",
                                    "Value": "Proprietor & FC HDFCSLIC"
                                },
                                {
                                    "Text": "Proprietor & LIC Agent",
                                    "Value": "Proprietor & LIC Agent"
                                },
                                {
                                    "Text": "Proprietor & Partner",
                                    "Value": "Proprietor & Partner"
                                },
                                {
                                    "Text": "Proprietor & Post Office Agent",
                                    "Value": "Proprietor & Post Office Agent"
                                },
                                {
                                    "Text": "Proprietor & Tailor",
                                    "Value": "Proprietor & Tailor"
                                },
                                {
                                    "Text": "Proprietor Doctor",
                                    "Value": "Proprietor Doctor"
                                },
                                {
                                    "Text": "Proprietor Firm",
                                    "Value": "Proprietor Firm"
                                },
                                {
                                    "Text": "Proprietor Mechanic",
                                    "Value": "Proprietor Mechanic"
                                },
                                {
                                    "Text": "Proprietor Owner",
                                    "Value": "Proprietor Owner"
                                },
                                {
                                    "Text": "Proprietor Property Dealer",
                                    "Value": "Proprietor Property Dealer"
                                },
                                {
                                    "Text": "Proprietor Stationery Store",
                                    "Value": "Proprietor Stationery Store"
                                },
                                {
                                    "Text": "Protocol Officer",
                                    "Value": "Protocol Officer"
                                },
                                {
                                    "Text": "Printing Incharge",
                                    "Value": "Printing Incharge"
                                },
                                {
                                    "Text": "Professor In Ophthalmology",
                                    "Value": "Professor In Ophthalmology"
                                },
                                {
                                    "Text": "Arch bishop",
                                    "Value": "Arch bishop"
                                },
                                {
                                    "Text": "Bishop",
                                    "Value": "Bishop"
                                },
                                {
                                    "Text": "Church worker",
                                    "Value": "Church worker"
                                },
                                {
                                    "Text": "Clergy man",
                                    "Value": "Clergy man"
                                },
                                {
                                    "Text": "Missionary",
                                    "Value": "Missionary"
                                },
                                {
                                    "Text": "Monk",
                                    "Value": "Monk"
                                },
                                {
                                    "Text": "Nun",
                                    "Value": "Nun"
                                },
                                {
                                    "Text": "Poojari",
                                    "Value": "Poojari"
                                },
                                {
                                    "Text": "Pandit",
                                    "Value": "Pandit"
                                },
                                {
                                    "Text": "Principal",
                                    "Value": "Principal"
                                },
                                {
                                    "Text": "Granthi",
                                    "Value": "Granthi"
                                },
                                {
                                    "Text": "Panch pyare",
                                    "Value": "Panch pyare"
                                },
                                {
                                    "Text": "Mulla",
                                    "Value": "Mulla"
                                },
                                {
                                    "Text": "Pastor",
                                    "Value": "Pastor"
                                },
                                {
                                    "Text": "Process Trainer IT",
                                    "Value": "Process Trainer IT"
                                },
                                {
                                    "Text": "Private Tuition Tutorial Home",
                                    "Value": "Private Tuition Tutorial Home"
                                },
                                {
                                    "Text": "Professor MD Internal Medicine",
                                    "Value": "Professor MD Internal Medicine"
                                },
                                {
                                    "Text": "President Investment Banking",
                                    "Value": "President Investment Banking"
                                },
                                {
                                    "Text": "Process worker",
                                    "Value": "Process worker"
                                },
                                {
                                    "Text": "Production Line Worker",
                                    "Value": "Production Line Worker"
                                },
                                {
                                    "Text": "Production Engineer",
                                    "Value": "Production Engineer"
                                },
                                {
                                    "Text": "Project Coordinator",
                                    "Value": "Project Coordinator"
                                },
                                {
                                    "Text": "Notary",
                                    "Value": "Notary"
                                },
                                {
                                    "Text": "Magistrate",
                                    "Value": "Magistrate"
                                },
                                {
                                    "Text": "Chartered accountant",
                                    "Value": "Chartered accountant"
                                },
                                {
                                    "Text": "Certified financial analyst",
                                    "Value": "Certified financial analyst"
                                },
                                {
                                    "Text": "Company secretary",
                                    "Value": "Company secretary"
                                },
                                {
                                    "Text": "Production Planning Coordinato",
                                    "Value": "Production Planning Coordinato"
                                },
                                {
                                    "Text": "Bailiff",
                                    "Value": "Bailiff"
                                },
                                {
                                    "Text": "Author",
                                    "Value": "Author"
                                },
                                {
                                    "Text": "Novelist",
                                    "Value": "Novelist"
                                },
                                {
                                    "Text": "Scientific assistant",
                                    "Value": "Scientific assistant"
                                },
                                {
                                    "Text": "Scientific officer",
                                    "Value": "Scientific officer"
                                },
                                {
                                    "Text": "Proprietor General Store",
                                    "Value": "Proprietor General Store"
                                },
                                {
                                    "Text": "Proprietor Cable Network",
                                    "Value": "Proprietor Cable Network"
                                },
                                {
                                    "Text": "Proprietor Transport",
                                    "Value": "Proprietor Transport"
                                },
                                {
                                    "Text": "Production Technician",
                                    "Value": "Production Technician"
                                },
                                {
                                    "Text": "Priest",
                                    "Value": "Priest"
                                },
                                {
                                    "Text": "Process Associate",
                                    "Value": "Process Associate"
                                },
                                {
                                    "Text": "Producer",
                                    "Value": "Producer"
                                },
                                {
                                    "Text": "PR Executive",
                                    "Value": "PR Executive"
                                },
                                {
                                    "Text": "Practicing Consultant",
                                    "Value": "Practicing Consultant"
                                },
                                {
                                    "Text": "Practicing Doctor",
                                    "Value": "Practicing Doctor"
                                },
                                {
                                    "Text": "Pradhan Yantrik",
                                    "Value": "Pradhan Yantrik"
                                },
                                {
                                    "Text": "Product Development Manager",
                                    "Value": "Product Development Manager"
                                },
                                {
                                    "Text": "Product Sales Manager",
                                    "Value": "Product Sales Manager"
                                },
                                {
                                    "Text": "Production Head Supervisor",
                                    "Value": "Production Head Supervisor"
                                },
                                {
                                    "Text": "Production Officer",
                                    "Value": "Production Officer"
                                },
                                {
                                    "Text": "Professional Accountant",
                                    "Value": "Professional Accountant"
                                },
                                {
                                    "Text": "Property Advisor",
                                    "Value": "Property Advisor"
                                },
                                {
                                    "Text": "PSA Whaft",
                                    "Value": "PSA Whaft"
                                },
                                {
                                    "Text": "Psychologist",
                                    "Value": "Psychologist"
                                },
                                {
                                    "Text": "Psychiatrist",
                                    "Value": "Psychiatrist"
                                },
                                {
                                    "Text": "Public Health Nursing Officer",
                                    "Value": "Public Health Nursing Officer"
                                },
                                {
                                    "Text": "Public Prosecutor",
                                    "Value": "Public Prosecutor"
                                },
                                {
                                    "Text": "Purchase Executive",
                                    "Value": "Purchase Executive"
                                },
                                {
                                    "Text": "Purchase Store Assistant",
                                    "Value": "Purchase Store Assistant"
                                },
                                {
                                    "Text": "Purchaser",
                                    "Value": "Purchaser"
                                },
                                {
                                    "Text": "Purohit",
                                    "Value": "Purohit"
                                },
                                {
                                    "Text": "Public Relation Officer",
                                    "Value": "Public Relation Officer"
                                },
                                {
                                    "Text": "Pujari Pandit",
                                    "Value": "Pujari Pandit"
                                },
                                {
                                    "Text": "Publisher & Editor",
                                    "Value": "Publisher & Editor"
                                },
                                {
                                    "Text": "Pujari",
                                    "Value": "Pujari"
                                },
                                {
                                    "Text": "Public Health Nurse",
                                    "Value": "Public Health Nurse"
                                },
                                {
                                    "Text": "Purser",
                                    "Value": "Purser"
                                },
                                {
                                    "Text": "Power Plant Operator",
                                    "Value": "Power Plant Operator"
                                },
                                {
                                    "Text": "P&A Officer",
                                    "Value": "P&A Officer"
                                },
                                {
                                    "Text": "QA Engineer",
                                    "Value": "QA Engineer"
                                },
                                {
                                    "Text": "QA Officer",
                                    "Value": "QA Officer"
                                },
                                {
                                    "Text": "QA Technician",
                                    "Value": "QA Technician"
                                },
                                {
                                    "Text": "Quality Checker",
                                    "Value": "Quality Checker"
                                },
                                {
                                    "Text": "Quality Checking Officer",
                                    "Value": "Quality Checking Officer"
                                },
                                {
                                    "Text": "Quality engineer",
                                    "Value": "Quality engineer"
                                },
                                {
                                    "Text": "QA & QC Engineer",
                                    "Value": "QA & QC Engineer"
                                },
                                {
                                    "Text": "Quality Assurance Executive",
                                    "Value": "Quality Assurance Executive"
                                },
                                {
                                    "Text": "QC Engineer",
                                    "Value": "QC Engineer"
                                },
                                {
                                    "Text": "QC Incharge",
                                    "Value": "QC Incharge"
                                },
                                {
                                    "Text": "Quality Analyst",
                                    "Value": "Quality Analyst"
                                },
                                {
                                    "Text": "Quality Assurance Officer",
                                    "Value": "Quality Assurance Officer"
                                },
                                {
                                    "Text": "Quality Control Executive",
                                    "Value": "Quality Control Executive"
                                },
                                {
                                    "Text": "Quality Control Officer",
                                    "Value": "Quality Control Officer"
                                },
                                {
                                    "Text": "Quality Officer",
                                    "Value": "Quality Officer"
                                },
                                {
                                    "Text": "Quality Assurance Engineer",
                                    "Value": "Quality Assurance Engineer"
                                },
                                {
                                    "Text": "Quality Compliance Analyst",
                                    "Value": "Quality Compliance Analyst"
                                },
                                {
                                    "Text": "Quality Assurance Test Engg.",
                                    "Value": "Quality Assurance Test Engg."
                                },
                                {
                                    "Text": "Radio Station Operator",
                                    "Value": "Radio Station Operator"
                                },
                                {
                                    "Text": "Radio Telephone Operator",
                                    "Value": "Radio Telephone Operator"
                                },
                                {
                                    "Text": "Radiologist Medical Officer",
                                    "Value": "Radiologist Medical Officer"
                                },
                                {
                                    "Text": "Railway ACC Driver",
                                    "Value": "Railway ACC Driver"
                                },
                                {
                                    "Text": "Railway Contractor",
                                    "Value": "Railway Contractor"
                                },
                                {
                                    "Text": "Railway Engineer",
                                    "Value": "Railway Engineer"
                                },
                                {
                                    "Text": "Ration Dealer",
                                    "Value": "Ration Dealer"
                                },
                                {
                                    "Text": "Ration Depot Owner",
                                    "Value": "Ration Depot Owner"
                                },
                                {
                                    "Text": "Ration Inspector",
                                    "Value": "Ration Inspector"
                                },
                                {
                                    "Text": "Railway Startman",
                                    "Value": "Railway Startman"
                                },
                                {
                                    "Text": "Regional Accounts Executive",
                                    "Value": "Regional Accounts Executive"
                                },
                                {
                                    "Text": "Radio Broadcaster/Radio Jockey",
                                    "Value": "Radio Broadcaster/Radio Jockey"
                                },
                                {
                                    "Text": "Radar Controler",
                                    "Value": "Radar Controler"
                                },
                                {
                                    "Text": "Radiographer",
                                    "Value": "Radiographer"
                                },
                                {
                                    "Text": "Radiologist",
                                    "Value": "Radiologist"
                                },
                                {
                                    "Text": "Radio Service Manager",
                                    "Value": "Radio Service Manager"
                                },
                                {
                                    "Text": "Radio Inspector",
                                    "Value": "Radio Inspector"
                                },
                                {
                                    "Text": "Railway Service Clerk",
                                    "Value": "Railway Service Clerk"
                                },
                                {
                                    "Text": "R&D Chemist",
                                    "Value": "R&D Chemist"
                                },
                                {
                                    "Text": "R&D Executive",
                                    "Value": "R&D Executive"
                                },
                                {
                                    "Text": "Reader & Lecturer",
                                    "Value": "Reader & Lecturer"
                                },
                                {
                                    "Text": "Reader Applied Chemistry Dept",
                                    "Value": "Reader Applied Chemistry Dept"
                                },
                                {
                                    "Text": "Reader In Chemistry",
                                    "Value": "Reader In Chemistry"
                                },
                                {
                                    "Text": "Recovery Head",
                                    "Value": "Recovery Head"
                                },
                                {
                                    "Text": "Real Estate Broker",
                                    "Value": "Real Estate Broker"
                                },
                                {
                                    "Text": "Real Estate Business Owner",
                                    "Value": "Real Estate Business Owner"
                                },
                                {
                                    "Text": "Real Estate Businessman",
                                    "Value": "Real Estate Businessman"
                                },
                                {
                                    "Text": "Real Estate Consultant",
                                    "Value": "Real Estate Consultant"
                                },
                                {
                                    "Text": "Real Estate Proprietor",
                                    "Value": "Real Estate Proprietor"
                                },
                                {
                                    "Text": "Receptionst & Cust Serv Offcer",
                                    "Value": "Receptionst & Cust Serv Offcer"
                                },
                                {
                                    "Text": "Record Keeper",
                                    "Value": "Record Keeper"
                                },
                                {
                                    "Text": "Recovery Officer Legal",
                                    "Value": "Recovery Officer Legal"
                                },
                                {
                                    "Text": "Recorder",
                                    "Value": "Recorder"
                                },
                                {
                                    "Text": "Refinery Technician",
                                    "Value": "Refinery Technician"
                                },
                                {
                                    "Text": "Recovery Officer",
                                    "Value": "Recovery Officer"
                                },
                                {
                                    "Text": "Recovery Supervisor",
                                    "Value": "Recovery Supervisor"
                                },
                                {
                                    "Text": "Regional Accounts Manager",
                                    "Value": "Regional Accounts Manager"
                                },
                                {
                                    "Text": "Research Scholar",
                                    "Value": "Research Scholar"
                                },
                                {
                                    "Text": "Regional Business Manager",
                                    "Value": "Regional Business Manager"
                                },
                                {
                                    "Text": "Regional Channel Manager",
                                    "Value": "Regional Channel Manager"
                                },
                                {
                                    "Text": "Regional Design Executive",
                                    "Value": "Regional Design Executive"
                                },
                                {
                                    "Text": "Regional Director",
                                    "Value": "Regional Director"
                                },
                                {
                                    "Text": "Regional HR Officer",
                                    "Value": "Regional HR Officer"
                                },
                                {
                                    "Text": "Regional Manager",
                                    "Value": "Regional Manager"
                                },
                                {
                                    "Text": "Regional Marketing Manager",
                                    "Value": "Regional Marketing Manager"
                                },
                                {
                                    "Text": "Regional Mkt Operation Officer",
                                    "Value": "Regional Mkt Operation Officer"
                                },
                                {
                                    "Text": "Regional Officer",
                                    "Value": "Regional Officer"
                                },
                                {
                                    "Text": "Regional Sales Executive",
                                    "Value": "Regional Sales Executive"
                                },
                                {
                                    "Text": "Regional Service Manager",
                                    "Value": "Regional Service Manager"
                                },
                                {
                                    "Text": "Regional Support Manager",
                                    "Value": "Regional Support Manager"
                                },
                                {
                                    "Text": "Retired from RBI",
                                    "Value": "Retired from RBI"
                                },
                                {
                                    "Text": "Regional Vice President",
                                    "Value": "Regional Vice President"
                                },
                                {
                                    "Text": "Register Keeper",
                                    "Value": "Register Keeper"
                                },
                                {
                                    "Text": "Registerd Medical Practitioner",
                                    "Value": "Registerd Medical Practitioner"
                                },
                                {
                                    "Text": "Registered Building Supervisor",
                                    "Value": "Registered Building Supervisor"
                                },
                                {
                                    "Text": "Registered Medical Officer",
                                    "Value": "Registered Medical Officer"
                                },
                                {
                                    "Text": "Registrar Doctor",
                                    "Value": "Registrar Doctor"
                                },
                                {
                                    "Text": "Regulatory Affairs Manager",
                                    "Value": "Regulatory Affairs Manager"
                                },
                                {
                                    "Text": "Regulatory Affairs Officer",
                                    "Value": "Regulatory Affairs Officer"
                                },
                                {
                                    "Text": "Reiki Master & Reiki Therapist",
                                    "Value": "Reiki Master & Reiki Therapist"
                                },
                                {
                                    "Text": "Reiki Therapist",
                                    "Value": "Reiki Therapist"
                                },
                                {
                                    "Text": "Relationship Executive",
                                    "Value": "Relationship Executive"
                                },
                                {
                                    "Text": "Relationship Officer",
                                    "Value": "Relationship Officer"
                                },
                                {
                                    "Text": "Religious Priest",
                                    "Value": "Religious Priest"
                                },
                                {
                                    "Text": "Research & Development Enginer",
                                    "Value": "Research & Development Enginer"
                                },
                                {
                                    "Text": "Regional Manager Service",
                                    "Value": "Regional Manager Service"
                                },
                                {
                                    "Text": "Research Assistant",
                                    "Value": "Research Assistant"
                                },
                                {
                                    "Text": "Research Chemist",
                                    "Value": "Research Chemist"
                                },
                                {
                                    "Text": "Researcher",
                                    "Value": "Researcher"
                                },
                                {
                                    "Text": "Research Executive",
                                    "Value": "Research Executive"
                                },
                                {
                                    "Text": "Research Medical Officer",
                                    "Value": "Research Medical Officer"
                                },
                                {
                                    "Text": "Research Scientist",
                                    "Value": "Research Scientist"
                                },
                                {
                                    "Text": "Research Specialist",
                                    "Value": "Research Specialist"
                                },
                                {
                                    "Text": "Research Staff Member",
                                    "Value": "Research Staff Member"
                                },
                                {
                                    "Text": "Reservation Manager",
                                    "Value": "Reservation Manager"
                                },
                                {
                                    "Text": "Reservation Officer",
                                    "Value": "Reservation Officer"
                                },
                                {
                                    "Text": "Resident Anaesthesian",
                                    "Value": "Resident Anaesthesian"
                                },
                                {
                                    "Text": "Resident Director",
                                    "Value": "Resident Director"
                                },
                                {
                                    "Text": "Resident Engineer",
                                    "Value": "Resident Engineer"
                                },
                                {
                                    "Text": "Resident Gynaecologist",
                                    "Value": "Resident Gynaecologist"
                                },
                                {
                                    "Text": "Resident Medical Officer",
                                    "Value": "Resident Medical Officer"
                                },
                                {
                                    "Text": "Resident Representative",
                                    "Value": "Resident Representative"
                                },
                                {
                                    "Text": "Resident Sales Officer",
                                    "Value": "Resident Sales Officer"
                                },
                                {
                                    "Text": "Residential Director",
                                    "Value": "Residential Director"
                                },
                                {
                                    "Text": "Retail Channel Manager",
                                    "Value": "Retail Channel Manager"
                                },
                                {
                                    "Text": "Retail Engineer",
                                    "Value": "Retail Engineer"
                                },
                                {
                                    "Text": "Retail Executive",
                                    "Value": "Retail Executive"
                                },
                                {
                                    "Text": "Retail Sales Executive",
                                    "Value": "Retail Sales Executive"
                                },
                                {
                                    "Text": "Retention Executive",
                                    "Value": "Retention Executive"
                                },
                                {
                                    "Text": "Retention Supervisor",
                                    "Value": "Retention Supervisor"
                                },
                                {
                                    "Text": "Retired & Agriculturist",
                                    "Value": "Retired & Agriculturist"
                                },
                                {
                                    "Text": "Retired & Pensioner",
                                    "Value": "Retired & Pensioner"
                                },
                                {
                                    "Text": "Retired Assistant Director",
                                    "Value": "Retired Assistant Director"
                                },
                                {
                                    "Text": "Retired Bank Officer",
                                    "Value": "Retired Bank Officer"
                                },
                                {
                                    "Text": "Retired Branch Manager",
                                    "Value": "Retired Branch Manager"
                                },
                                {
                                    "Text": "Retired Buss Development Mgr.",
                                    "Value": "Retired Buss Development Mgr."
                                },
                                {
                                    "Text": "Retired Clerk",
                                    "Value": "Retired Clerk"
                                },
                                {
                                    "Text": "Retired Deputy Commissioner",
                                    "Value": "Retired Deputy Commissioner"
                                },
                                {
                                    "Text": "Retired Doctor",
                                    "Value": "Retired Doctor"
                                },
                                {
                                    "Text": "Retired General Manager",
                                    "Value": "Retired General Manager"
                                },
                                {
                                    "Text": "Retired Joint Director",
                                    "Value": "Retired Joint Director"
                                },
                                {
                                    "Text": "Retired Lecturer",
                                    "Value": "Retired Lecturer"
                                },
                                {
                                    "Text": "Retired Manager",
                                    "Value": "Retired Manager"
                                },
                                {
                                    "Text": "Retired NRI",
                                    "Value": "Retired NRI"
                                },
                                {
                                    "Text": "Retired Nursing Assistant",
                                    "Value": "Retired Nursing Assistant"
                                },
                                {
                                    "Text": "Retired Nursing Sister",
                                    "Value": "Retired Nursing Sister"
                                },
                                {
                                    "Text": "Retired Officer",
                                    "Value": "Retired Officer"
                                },
                                {
                                    "Text": "Retired Pension Holder",
                                    "Value": "Retired Pension Holder"
                                },
                                {
                                    "Text": "Retired Pensioner/Agriculturst",
                                    "Value": "Retired Pensioner/Agriculturst"
                                },
                                {
                                    "Text": "Retired Primary School Teacher",
                                    "Value": "Retired Primary School Teacher"
                                },
                                {
                                    "Text": "Retired Teacher",
                                    "Value": "Retired Teacher"
                                },
                                {
                                    "Text": "Retired Government Employee",
                                    "Value": "Retired Government Employee"
                                },
                                {
                                    "Text": "Revenue Consultant",
                                    "Value": "Revenue Consultant"
                                },
                                {
                                    "Text": "Revenue Inspector",
                                    "Value": "Revenue Inspector"
                                },
                                {
                                    "Text": "Review Officer",
                                    "Value": "Review Officer"
                                },
                                {
                                    "Text": "Retired Army Personnel",
                                    "Value": "Retired Army Personnel"
                                },
                                {
                                    "Text": "Reader",
                                    "Value": "Reader"
                                },
                                {
                                    "Text": "Reader Planetary & Geosciences",
                                    "Value": "Reader Planetary & Geosciences"
                                },
                                {
                                    "Text": "Receipt Incharge",
                                    "Value": "Receipt Incharge"
                                },
                                {
                                    "Text": "Resident Manager & Branch Mgr",
                                    "Value": "Resident Manager & Branch Mgr"
                                },
                                {
                                    "Text": "Reserve Guard",
                                    "Value": "Reserve Guard"
                                },
                                {
                                    "Text": "Reader In Tamil",
                                    "Value": "Reader In Tamil"
                                },
                                {
                                    "Text": "Resident manager",
                                    "Value": "Resident manager"
                                },
                                {
                                    "Text": "Recurring Agent",
                                    "Value": "Recurring Agent"
                                },
                                {
                                    "Text": "Recruitment Officer",
                                    "Value": "Recruitment Officer"
                                },
                                {
                                    "Text": "Retired Person",
                                    "Value": "Retired Person"
                                },
                                {
                                    "Text": "Resident Doctor",
                                    "Value": "Resident Doctor"
                                },
                                {
                                    "Text": "Repairer",
                                    "Value": "Repairer"
                                },
                                {
                                    "Text": "Reporter",
                                    "Value": "Reporter"
                                },
                                {
                                    "Text": "Revenue Patwari",
                                    "Value": "Revenue Patwari"
                                },
                                {
                                    "Text": "Resident Expert",
                                    "Value": "Resident Expert"
                                },
                                {
                                    "Text": "Regional Counsel/Comp Secretry",
                                    "Value": "Regional Counsel/Comp Secretry"
                                },
                                {
                                    "Text": "Registered Nurse",
                                    "Value": "Registered Nurse"
                                },
                                {
                                    "Text": "Real Estate Business",
                                    "Value": "Real Estate Business"
                                },
                                {
                                    "Text": "Recordist",
                                    "Value": "Recordist"
                                },
                                {
                                    "Text": "Retired",
                                    "Value": "Retired"
                                },
                                {
                                    "Text": "Research Associate",
                                    "Value": "Research Associate"
                                },
                                {
                                    "Text": "Retired Officer Accounts",
                                    "Value": "Retired Officer Accounts"
                                },
                                {
                                    "Text": "Recovery Executive",
                                    "Value": "Recovery Executive"
                                },
                                {
                                    "Text": "Reader In Computer Science",
                                    "Value": "Reader In Computer Science"
                                },
                                {
                                    "Text": "Regional Training Manager",
                                    "Value": "Regional Training Manager"
                                },
                                {
                                    "Text": "Research Analyst",
                                    "Value": "Research Analyst"
                                },
                                {
                                    "Text": "Research Consultant",
                                    "Value": "Research Consultant"
                                },
                                {
                                    "Text": "Researcher Assistant",
                                    "Value": "Researcher Assistant"
                                },
                                {
                                    "Text": "Retired Technical Officer",
                                    "Value": "Retired Technical Officer"
                                },
                                {
                                    "Text": "Regional Accounts Officer",
                                    "Value": "Regional Accounts Officer"
                                },
                                {
                                    "Text": "Rice Canvassing Agent",
                                    "Value": "Rice Canvassing Agent"
                                },
                                {
                                    "Text": "Risk Management Consultant",
                                    "Value": "Risk Management Consultant"
                                },
                                {
                                    "Text": "Risk Manager",
                                    "Value": "Risk Manager"
                                },
                                {
                                    "Text": "Rickshaw puller",
                                    "Value": "Rickshaw puller"
                                },
                                {
                                    "Text": "Rigger",
                                    "Value": "Rigger"
                                },
                                {
                                    "Text": "Rice Merchant",
                                    "Value": "Rice Merchant"
                                },
                                {
                                    "Text": "Risk Consultant",
                                    "Value": "Risk Consultant"
                                },
                                {
                                    "Text": "Risk Analyst",
                                    "Value": "Risk Analyst"
                                },
                                {
                                    "Text": "Riveter",
                                    "Value": "Riveter"
                                },
                                {
                                    "Text": "Relationship Manager Group",
                                    "Value": "Relationship Manager Group"
                                },
                                {
                                    "Text": "Relationship Manager HNI Sales",
                                    "Value": "Relationship Manager HNI Sales"
                                },
                                {
                                    "Text": "Relationship Mgr-International",
                                    "Value": "Relationship Mgr-International"
                                },
                                {
                                    "Text": "RMO Doctor",
                                    "Value": "RMO Doctor"
                                },
                                {
                                    "Text": "RM",
                                    "Value": "RM"
                                },
                                {
                                    "Text": "Room Boy",
                                    "Value": "Room Boy"
                                },
                                {
                                    "Text": "Roof bolter",
                                    "Value": "Roof bolter"
                                },
                                {
                                    "Text": "Routine Grade Clerk",
                                    "Value": "Routine Grade Clerk"
                                },
                                {
                                    "Text": "Repairman",
                                    "Value": "Repairman"
                                },
                                {
                                    "Text": "RSM",
                                    "Value": "RSM"
                                },
                                {
                                    "Text": "Radiotherapist",
                                    "Value": "Radiotherapist"
                                },
                                {
                                    "Text": "RTO Agent",
                                    "Value": "RTO Agent"
                                },
                                {
                                    "Text": "Maintenance fitter",
                                    "Value": "Maintenance fitter"
                                },
                                {
                                    "Text": "Maintenance repairer",
                                    "Value": "Maintenance repairer"
                                },
                                {
                                    "Text": "Railway wagon fitter",
                                    "Value": "Railway wagon fitter"
                                },
                                {
                                    "Text": "Vehicle body builder",
                                    "Value": "Vehicle body builder"
                                },
                                {
                                    "Text": "Wagon lifter",
                                    "Value": "Wagon lifter"
                                },
                                {
                                    "Text": "Rail tanker filler",
                                    "Value": "Rail tanker filler"
                                },
                                {
                                    "Text": "Track laying machine operator",
                                    "Value": "Track laying machine operator"
                                },
                                {
                                    "Text": "Wagon traverser operator",
                                    "Value": "Wagon traverser operator"
                                },
                                {
                                    "Text": "Track equipment installer",
                                    "Value": "Track equipment installer"
                                },
                                {
                                    "Text": "Track maintenance",
                                    "Value": "Track maintenance"
                                },
                                {
                                    "Text": "Track chargeman",
                                    "Value": "Track chargeman"
                                },
                                {
                                    "Text": "Lengthman",
                                    "Value": "Lengthman"
                                },
                                {
                                    "Text": "Overhead linesman",
                                    "Value": "Overhead linesman"
                                },
                                {
                                    "Text": "Plate layer",
                                    "Value": "Plate layer"
                                },
                                {
                                    "Text": "Shunter",
                                    "Value": "Shunter"
                                },
                                {
                                    "Text": "Tippler operator",
                                    "Value": "Tippler operator"
                                },
                                {
                                    "Text": "Track layer",
                                    "Value": "Track layer"
                                },
                                {
                                    "Text": "Trackman",
                                    "Value": "Trackman"
                                },
                                {
                                    "Text": "Station assistant",
                                    "Value": "Station assistant"
                                },
                                {
                                    "Text": "Station manager",
                                    "Value": "Station manager"
                                },
                                {
                                    "Text": "Station master",
                                    "Value": "Station master"
                                },
                                {
                                    "Text": "Station officer",
                                    "Value": "Station officer"
                                },
                                {
                                    "Text": "Station superintendent",
                                    "Value": "Station superintendent"
                                },
                                {
                                    "Text": "Ticket checker",
                                    "Value": "Ticket checker"
                                },
                                {
                                    "Text": "Crossing keeper",
                                    "Value": "Crossing keeper"
                                },
                                {
                                    "Text": "Attendant-railways",
                                    "Value": "Attendant-railways"
                                },
                                {
                                    "Text": "Carriage examiner",
                                    "Value": "Carriage examiner"
                                },
                                {
                                    "Text": "Railway signal fitter",
                                    "Value": "Railway signal fitter"
                                },
                                {
                                    "Text": "Head shunter",
                                    "Value": "Head shunter"
                                },
                                {
                                    "Text": "Station announcer",
                                    "Value": "Station announcer"
                                },
                                {
                                    "Text": "Stationman",
                                    "Value": "Stationman"
                                },
                                {
                                    "Text": "Ticket collecter",
                                    "Value": "Ticket collecter"
                                },
                                {
                                    "Text": "Dispatcher",
                                    "Value": "Dispatcher"
                                },
                                {
                                    "Text": "Travelling ticket examiner",
                                    "Value": "Travelling ticket examiner"
                                },
                                {
                                    "Text": "Straddle carrier driver",
                                    "Value": "Straddle carrier driver"
                                },
                                {
                                    "Text": "Track maintenance inspector",
                                    "Value": "Track maintenance inspector"
                                },
                                {
                                    "Text": "Sahara Agent",
                                    "Value": "Sahara Agent"
                                },
                                {
                                    "Text": "Sahayak Engineer",
                                    "Value": "Sahayak Engineer"
                                },
                                {
                                    "Text": "Sales Head",
                                    "Value": "Sales Head"
                                },
                                {
                                    "Text": "Sales & Service Engineer",
                                    "Value": "Sales & Service Engineer"
                                },
                                {
                                    "Text": "Sales Advisor",
                                    "Value": "Sales Advisor"
                                },
                                {
                                    "Text": "Sales Assistant",
                                    "Value": "Sales Assistant"
                                },
                                {
                                    "Text": "Sales Compliance Manager",
                                    "Value": "Sales Compliance Manager"
                                },
                                {
                                    "Text": "Sales Consultant",
                                    "Value": "Sales Consultant"
                                },
                                {
                                    "Text": "Sales Consulting Manager",
                                    "Value": "Sales Consulting Manager"
                                },
                                {
                                    "Text": "Sales Professional",
                                    "Value": "Sales Professional"
                                },
                                {
                                    "Text": "Sales Department Team Leader",
                                    "Value": "Sales Department Team Leader"
                                },
                                {
                                    "Text": "Salesman",
                                    "Value": "Salesman"
                                },
                                {
                                    "Text": "Sales Engineer",
                                    "Value": "Sales Engineer"
                                },
                                {
                                    "Text": "Sales Exec & Med. Represntitve",
                                    "Value": "Sales Exec & Med. Represntitve"
                                },
                                {
                                    "Text": "Sales Executive & Consultant",
                                    "Value": "Sales Executive & Consultant"
                                },
                                {
                                    "Text": "Sales Insurance Manager",
                                    "Value": "Sales Insurance Manager"
                                },
                                {
                                    "Text": "Sales Marketing Manager",
                                    "Value": "Sales Marketing Manager"
                                },
                                {
                                    "Text": "Sales Marketing Officer",
                                    "Value": "Sales Marketing Officer"
                                },
                                {
                                    "Text": "Sales Office Manager",
                                    "Value": "Sales Office Manager"
                                },
                                {
                                    "Text": "Sales Officer",
                                    "Value": "Sales Officer"
                                },
                                {
                                    "Text": "Sales Project Coordinator",
                                    "Value": "Sales Project Coordinator"
                                },
                                {
                                    "Text": "S.M",
                                    "Value": "S.M"
                                },
                                {
                                    "Text": "Sales Promotion Officer",
                                    "Value": "Sales Promotion Officer"
                                },
                                {
                                    "Text": "Sales Quality Auditor",
                                    "Value": "Sales Quality Auditor"
                                },
                                {
                                    "Text": "Sales Service Engineer",
                                    "Value": "Sales Service Engineer"
                                },
                                {
                                    "Text": "Sales Service Manager",
                                    "Value": "Sales Service Manager"
                                },
                                {
                                    "Text": "Sales Service Officer",
                                    "Value": "Sales Service Officer"
                                },
                                {
                                    "Text": "Sales Supervisor",
                                    "Value": "Sales Supervisor"
                                },
                                {
                                    "Text": "Sales Support Officer",
                                    "Value": "Sales Support Officer"
                                },
                                {
                                    "Text": "Sales Tax Auditor",
                                    "Value": "Sales Tax Auditor"
                                },
                                {
                                    "Text": "Sales Tax Consultant",
                                    "Value": "Sales Tax Consultant"
                                },
                                {
                                    "Text": "Sales Tax Inspector",
                                    "Value": "Sales Tax Inspector"
                                },
                                {
                                    "Text": "Sales Tax Officer",
                                    "Value": "Sales Tax Officer"
                                },
                                {
                                    "Text": "Sales Tax Practitioner",
                                    "Value": "Sales Tax Practitioner"
                                },
                                {
                                    "Text": "Sales Team Leader",
                                    "Value": "Sales Team Leader"
                                },
                                {
                                    "Text": "Sales Team Manager",
                                    "Value": "Sales Team Manager"
                                },
                                {
                                    "Text": "Sr. Regional Accounts Officer",
                                    "Value": "Sr. Regional Accounts Officer"
                                },
                                {
                                    "Text": "Sales Officer Trainee",
                                    "Value": "Sales Officer Trainee"
                                },
                                {
                                    "Text": "Sales Women",
                                    "Value": "Sales Women"
                                },
                                {
                                    "Text": "Sales & Marketing Officer",
                                    "Value": "Sales & Marketing Officer"
                                },
                                {
                                    "Text": "Sales Incharge",
                                    "Value": "Sales Incharge"
                                },
                                {
                                    "Text": "Direct sales agent",
                                    "Value": "Direct sales agent"
                                },
                                {
                                    "Text": "Sales executive",
                                    "Value": "Sales executive"
                                },
                                {
                                    "Text": "Sales Manager Home Loans",
                                    "Value": "Sales Manager Home Loans"
                                },
                                {
                                    "Text": "Sales Person",
                                    "Value": "Sales Person"
                                },
                                {
                                    "Text": "Sales Promoter",
                                    "Value": "Sales Promoter"
                                },
                                {
                                    "Text": "Safai Karamchari",
                                    "Value": "Safai Karamchari"
                                },
                                {
                                    "Text": "Sales Specialist",
                                    "Value": "Sales Specialist"
                                },
                                {
                                    "Text": "Sales Associate",
                                    "Value": "Sales Associate"
                                },
                                {
                                    "Text": "Sales & Marketing Executive",
                                    "Value": "Sales & Marketing Executive"
                                },
                                {
                                    "Text": "Sales & Marketing Incharge",
                                    "Value": "Sales & Marketing Incharge"
                                },
                                {
                                    "Text": "Sales Coordinator",
                                    "Value": "Sales Coordinator"
                                },
                                {
                                    "Text": "School Master",
                                    "Value": "School Master"
                                },
                                {
                                    "Text": "Science Teacher",
                                    "Value": "Science Teacher"
                                },
                                {
                                    "Text": "Scientist & Engineer",
                                    "Value": "Scientist & Engineer"
                                },
                                {
                                    "Text": "Scientist Assistant",
                                    "Value": "Scientist Assistant"
                                },
                                {
                                    "Text": "Scientist B",
                                    "Value": "Scientist B"
                                },
                                {
                                    "Text": "Scientist C",
                                    "Value": "Scientist C"
                                },
                                {
                                    "Text": "Scientist E",
                                    "Value": "Scientist E"
                                },
                                {
                                    "Text": "Scientist F",
                                    "Value": "Scientist F"
                                },
                                {
                                    "Text": "School Principal",
                                    "Value": "School Principal"
                                },
                                {
                                    "Text": "Sr. Corporate Agency Manager",
                                    "Value": "Sr. Corporate Agency Manager"
                                },
                                {
                                    "Text": "Shift Charge Engineer",
                                    "Value": "Shift Charge Engineer"
                                },
                                {
                                    "Text": "Scientific Sales Officer",
                                    "Value": "Scientific Sales Officer"
                                },
                                {
                                    "Text": "School Inspector",
                                    "Value": "School Inspector"
                                },
                                {
                                    "Text": "School Assistant Grade II",
                                    "Value": "School Assistant Grade II"
                                },
                                {
                                    "Text": "Scientist",
                                    "Value": "Scientist"
                                },
                                {
                                    "Text": "School Assistant",
                                    "Value": "School Assistant"
                                },
                                {
                                    "Text": "School Peon",
                                    "Value": "School Peon"
                                },
                                {
                                    "Text": "Scriptwriter",
                                    "Value": "Scriptwriter"
                                },
                                {
                                    "Text": "Scrap Dealer",
                                    "Value": "Scrap Dealer"
                                },
                                {
                                    "Text": "Sculptor",
                                    "Value": "Sculptor"
                                },
                                {
                                    "Text": "Sales Development",
                                    "Value": "Sales Development"
                                },
                                {
                                    "Text": "SDM",
                                    "Value": "SDM"
                                },
                                {
                                    "Text": "SDM Corporate Agency Broka",
                                    "Value": "SDM Corporate Agency Broka"
                                },
                                {
                                    "Text": "SDM Corporate Agency",
                                    "Value": "SDM Corporate Agency"
                                },
                                {
                                    "Text": "Officer Group Sales Support",
                                    "Value": "Officer Group Sales Support"
                                },
                                {
                                    "Text": "Sales Development Manager EM",
                                    "Value": "Sales Development Manager EM"
                                },
                                {
                                    "Text": "Sales Development Manager",
                                    "Value": "Sales Development Manager"
                                },
                                {
                                    "Text": "SDM Telemarketing",
                                    "Value": "SDM Telemarketing"
                                },
                                {
                                    "Text": "SE Electrical",
                                    "Value": "SE Electrical"
                                },
                                {
                                    "Text": "Secondary Teacher",
                                    "Value": "Secondary Teacher"
                                },
                                {
                                    "Text": "Senior Engineer R&D",
                                    "Value": "Senior Engineer R&D"
                                },
                                {
                                    "Text": "Section Engineer",
                                    "Value": "Section Engineer"
                                },
                                {
                                    "Text": "Section Grade Teacher",
                                    "Value": "Section Grade Teacher"
                                },
                                {
                                    "Text": "Section Writer",
                                    "Value": "Section Writer"
                                },
                                {
                                    "Text": "Secretary General",
                                    "Value": "Secretary General"
                                },
                                {
                                    "Text": "Senior CAM",
                                    "Value": "Senior CAM"
                                },
                                {
                                    "Text": "Senior Draftsman",
                                    "Value": "Senior Draftsman"
                                },
                                {
                                    "Text": "Self Employed & Proprietor",
                                    "Value": "Self Employed & Proprietor"
                                },
                                {
                                    "Text": "Self Employed Business",
                                    "Value": "Self Employed Business"
                                },
                                {
                                    "Text": "Self Employed Diamond Merchant",
                                    "Value": "Self Employed Diamond Merchant"
                                },
                                {
                                    "Text": "Senior Registrar",
                                    "Value": "Senior Registrar"
                                },
                                {
                                    "Text": "Self Employed Tution",
                                    "Value": "Self Employed Tution"
                                },
                                {
                                    "Text": "Self Owned Business",
                                    "Value": "Self Owned Business"
                                },
                                {
                                    "Text": "Self Owner",
                                    "Value": "Self Owner"
                                },
                                {
                                    "Text": "Seller",
                                    "Value": "Seller"
                                },
                                {
                                    "Text": "Senior Accounts Assistant",
                                    "Value": "Senior Accounts Assistant"
                                },
                                {
                                    "Text": "Senior Accounts Clerk",
                                    "Value": "Senior Accounts Clerk"
                                },
                                {
                                    "Text": "Senior Accounts Manager",
                                    "Value": "Senior Accounts Manager"
                                },
                                {
                                    "Text": "Senior Accounts Officer",
                                    "Value": "Senior Accounts Officer"
                                },
                                {
                                    "Text": "Senior Admin Assistant",
                                    "Value": "Senior Admin Assistant"
                                },
                                {
                                    "Text": "Senior Admin Officer",
                                    "Value": "Senior Admin Officer"
                                },
                                {
                                    "Text": "Senior Administrative Officer",
                                    "Value": "Senior Administrative Officer"
                                },
                                {
                                    "Text": "Senior Administrator",
                                    "Value": "Senior Administrator"
                                },
                                {
                                    "Text": "Senior Aircraft Technician",
                                    "Value": "Senior Aircraft Technician"
                                },
                                {
                                    "Text": "Senior Anaesthetist",
                                    "Value": "Senior Anaesthetist"
                                },
                                {
                                    "Text": "Senior Application Engineer",
                                    "Value": "Senior Application Engineer"
                                },
                                {
                                    "Text": "Senior Area Manager",
                                    "Value": "Senior Area Manager"
                                },
                                {
                                    "Text": "Senior Area Sales Officer",
                                    "Value": "Senior Area Sales Officer"
                                },
                                {
                                    "Text": "Senior Assistant Clerk",
                                    "Value": "Senior Assistant Clerk"
                                },
                                {
                                    "Text": "Senior Assistant Editor",
                                    "Value": "Senior Assistant Editor"
                                },
                                {
                                    "Text": "Senior Assitant Officer",
                                    "Value": "Senior Assitant Officer"
                                },
                                {
                                    "Text": "Senior Associate",
                                    "Value": "Senior Associate"
                                },
                                {
                                    "Text": "Senior Branch Manager",
                                    "Value": "Senior Branch Manager"
                                },
                                {
                                    "Text": "Senior Cancer Specialist",
                                    "Value": "Senior Cancer Specialist"
                                },
                                {
                                    "Text": "Senior Chemist",
                                    "Value": "Senior Chemist"
                                },
                                {
                                    "Text": "Senior Civil Engineer",
                                    "Value": "Senior Civil Engineer"
                                },
                                {
                                    "Text": "Senior Clerk",
                                    "Value": "Senior Clerk"
                                },
                                {
                                    "Text": "Senior Client Service Exec.",
                                    "Value": "Senior Client Service Exec."
                                },
                                {
                                    "Text": "Senior Coordinator",
                                    "Value": "Senior Coordinator"
                                },
                                {
                                    "Text": "Senior Correspondent",
                                    "Value": "Senior Correspondent"
                                },
                                {
                                    "Text": "Senior Councellor",
                                    "Value": "Senior Councellor"
                                },
                                {
                                    "Text": "Senior Customer Care Executive",
                                    "Value": "Senior Customer Care Executive"
                                },
                                {
                                    "Text": "Senior Customer Executive",
                                    "Value": "Senior Customer Executive"
                                },
                                {
                                    "Text": "Senior Customer Relation Exec",
                                    "Value": "Senior Customer Relation Exec"
                                },
                                {
                                    "Text": "Senior Customer Service Agent",
                                    "Value": "Senior Customer Service Agent"
                                },
                                {
                                    "Text": "Senior Manager Logistics",
                                    "Value": "Senior Manager Logistics"
                                },
                                {
                                    "Text": "Senior architect",
                                    "Value": "Senior architect"
                                },
                                {
                                    "Text": "Senior Customer Support Engg.",
                                    "Value": "Senior Customer Support Engg."
                                },
                                {
                                    "Text": "Senior Customer Support Exec.",
                                    "Value": "Senior Customer Support Exec."
                                },
                                {
                                    "Text": "Senior Customr Care Specialist",
                                    "Value": "Senior Customr Care Specialist"
                                },
                                {
                                    "Text": "Senior Database Administrator",
                                    "Value": "Senior Database Administrator"
                                },
                                {
                                    "Text": "Senior Dealer",
                                    "Value": "Senior Dealer"
                                },
                                {
                                    "Text": "Senior Deputy General Manager",
                                    "Value": "Senior Deputy General Manager"
                                },
                                {
                                    "Text": "Senior Design Researcher",
                                    "Value": "Senior Design Researcher"
                                },
                                {
                                    "Text": "Senior Executive Intl Trade",
                                    "Value": "Senior Executive Intl Trade"
                                },
                                {
                                    "Text": "Senior Development Consultant",
                                    "Value": "Senior Development Consultant"
                                },
                                {
                                    "Text": "Senior Director",
                                    "Value": "Senior Director"
                                },
                                {
                                    "Text": "Senior Director Buss Develpmnt",
                                    "Value": "Senior Director Buss Develpmnt"
                                },
                                {
                                    "Text": "Senior Divisional Engineer",
                                    "Value": "Senior Divisional Engineer"
                                },
                                {
                                    "Text": "Senior Doctor",
                                    "Value": "Senior Doctor"
                                },
                                {
                                    "Text": "Senior Draughtsman",
                                    "Value": "Senior Draughtsman"
                                },
                                {
                                    "Text": "Senior Dy. General Manager",
                                    "Value": "Senior Dy. General Manager"
                                },
                                {
                                    "Text": "Senior Electrician",
                                    "Value": "Senior Electrician"
                                },
                                {
                                    "Text": "Senior Electrician Spcl Grade.",
                                    "Value": "Senior Electrician Spcl Grade."
                                },
                                {
                                    "Text": "Senior Engagement Manager",
                                    "Value": "Senior Engagement Manager"
                                },
                                {
                                    "Text": "Senior Engg. Quality Assurance",
                                    "Value": "Senior Engg. Quality Assurance"
                                },
                                {
                                    "Text": "Senior Engineer",
                                    "Value": "Senior Engineer"
                                },
                                {
                                    "Text": "Senior Engineer Equipments",
                                    "Value": "Senior Engineer Equipments"
                                },
                                {
                                    "Text": "Senior Engineer Grade ll",
                                    "Value": "Senior Engineer Grade ll"
                                },
                                {
                                    "Text": "Senior Engineer Sales",
                                    "Value": "Senior Engineer Sales"
                                },
                                {
                                    "Text": "Senior Engineer Servicing",
                                    "Value": "Senior Engineer Servicing"
                                },
                                {
                                    "Text": "Senior Engineering Assistant",
                                    "Value": "Senior Engineering Assistant"
                                },
                                {
                                    "Text": "Senior Engineering Consultant",
                                    "Value": "Senior Engineering Consultant"
                                },
                                {
                                    "Text": "Senior Excise Manager",
                                    "Value": "Senior Excise Manager"
                                },
                                {
                                    "Text": "Senior Exec Med Transcriptnst",
                                    "Value": "Senior Exec Med Transcriptnst"
                                },
                                {
                                    "Text": "Senior Exec Professional Serv.",
                                    "Value": "Senior Exec Professional Serv."
                                },
                                {
                                    "Text": "Senior Business Research Exec",
                                    "Value": "Senior Business Research Exec"
                                },
                                {
                                    "Text": "Self Employed",
                                    "Value": "Self Employed"
                                },
                                {
                                    "Text": "Senior Executive Engineer",
                                    "Value": "Senior Executive Engineer"
                                },
                                {
                                    "Text": "Senior Executive Finance",
                                    "Value": "Senior Executive Finance"
                                },
                                {
                                    "Text": "Senior Executive Officer",
                                    "Value": "Senior Executive Officer"
                                },
                                {
                                    "Text": "Senior Executive Sales",
                                    "Value": "Senior Executive Sales"
                                },
                                {
                                    "Text": "Senior Executive Stores",
                                    "Value": "Senior Executive Stores"
                                },
                                {
                                    "Text": "Senior Eye Surgeon",
                                    "Value": "Senior Eye Surgeon"
                                },
                                {
                                    "Text": "Senior Fabric Technician",
                                    "Value": "Senior Fabric Technician"
                                },
                                {
                                    "Text": "Secretary To CEO",
                                    "Value": "Secretary To CEO"
                                },
                                {
                                    "Text": "Senior Field Officer",
                                    "Value": "Senior Field Officer"
                                },
                                {
                                    "Text": "Senior Fin. & Accounts Officr",
                                    "Value": "Senior Fin. & Accounts Officr"
                                },
                                {
                                    "Text": "Senior Analyst Commodities",
                                    "Value": "Senior Analyst Commodities"
                                },
                                {
                                    "Text": "Senior Financial Executive",
                                    "Value": "Senior Financial Executive"
                                },
                                {
                                    "Text": "Senior Fund Administrator",
                                    "Value": "Senior Fund Administrator"
                                },
                                {
                                    "Text": "Senior General Manager",
                                    "Value": "Senior General Manager"
                                },
                                {
                                    "Text": "Senior Grade Lecturer",
                                    "Value": "Senior Grade Lecturer"
                                },
                                {
                                    "Text": "Senior Graphic Designer",
                                    "Value": "Senior Graphic Designer"
                                },
                                {
                                    "Text": "Senior Hindi Translator",
                                    "Value": "Senior Hindi Translator"
                                },
                                {
                                    "Text": "Senior HR Executive",
                                    "Value": "Senior HR Executive"
                                },
                                {
                                    "Text": "Senior Informatn System Offcr",
                                    "Value": "Senior Informatn System Offcr"
                                },
                                {
                                    "Text": "Senior Instructor",
                                    "Value": "Senior Instructor"
                                },
                                {
                                    "Text": "Senior Interior Designer",
                                    "Value": "Senior Interior Designer"
                                },
                                {
                                    "Text": "Senior Service Staff",
                                    "Value": "Senior Service Staff"
                                },
                                {
                                    "Text": "Senior Land Developer",
                                    "Value": "Senior Land Developer"
                                },
                                {
                                    "Text": "Senior Law Officer",
                                    "Value": "Senior Law Officer"
                                },
                                {
                                    "Text": "Senior Lecturer",
                                    "Value": "Senior Lecturer"
                                },
                                {
                                    "Text": "Senior Lecturer & Consultant",
                                    "Value": "Senior Lecturer & Consultant"
                                },
                                {
                                    "Text": "Senior Lecturer Dental Surgery",
                                    "Value": "Senior Lecturer Dental Surgery"
                                },
                                {
                                    "Text": "Senior Lecturer Retired",
                                    "Value": "Senior Lecturer Retired"
                                },
                                {
                                    "Text": "Senior Library Assistant",
                                    "Value": "Senior Library Assistant"
                                },
                                {
                                    "Text": "Senior Logistics Executive",
                                    "Value": "Senior Logistics Executive"
                                },
                                {
                                    "Text": "Senior Maintenance Engineer",
                                    "Value": "Senior Maintenance Engineer"
                                },
                                {
                                    "Text": "Senior Manager Administration",
                                    "Value": "Senior Manager Administration"
                                },
                                {
                                    "Text": "Senior Manager Buss Developmnt",
                                    "Value": "Senior Manager Buss Developmnt"
                                },
                                {
                                    "Text": "Senior Manager Commercial",
                                    "Value": "Senior Manager Commercial"
                                },
                                {
                                    "Text": "Senior Manager Costing",
                                    "Value": "Senior Manager Costing"
                                },
                                {
                                    "Text": "Senior Manager Customer Care",
                                    "Value": "Senior Manager Customer Care"
                                },
                                {
                                    "Text": "Senior Manager Engineer",
                                    "Value": "Senior Manager Engineer"
                                },
                                {
                                    "Text": "Senior Manager Exports",
                                    "Value": "Senior Manager Exports"
                                },
                                {
                                    "Text": "Senior Manager Fin & Accounts",
                                    "Value": "Senior Manager Fin & Accounts"
                                },
                                {
                                    "Text": "Senior Manager Finance",
                                    "Value": "Senior Manager Finance"
                                },
                                {
                                    "Text": "Senior Manager Marketing",
                                    "Value": "Senior Manager Marketing"
                                },
                                {
                                    "Text": "Senior Lecturer In Civil Engg",
                                    "Value": "Senior Lecturer In Civil Engg"
                                },
                                {
                                    "Text": "Senior Manager Procurement",
                                    "Value": "Senior Manager Procurement"
                                },
                                {
                                    "Text": "Senior Manager Purchase",
                                    "Value": "Senior Manager Purchase"
                                },
                                {
                                    "Text": "Senior Manager Sales",
                                    "Value": "Senior Manager Sales"
                                },
                                {
                                    "Text": "Senior Manager Stores",
                                    "Value": "Senior Manager Stores"
                                },
                                {
                                    "Text": "Senior Managr Foreign Exchange",
                                    "Value": "Senior Managr Foreign Exchange"
                                },
                                {
                                    "Text": "Senior Marketing Engineer",
                                    "Value": "Senior Marketing Engineer"
                                },
                                {
                                    "Text": "Senior Marketing Executive",
                                    "Value": "Senior Marketing Executive"
                                },
                                {
                                    "Text": "Senior Business Developmnt Mgr",
                                    "Value": "Senior Business Developmnt Mgr"
                                },
                                {
                                    "Text": "Senior Marketing Representatve",
                                    "Value": "Senior Marketing Representatve"
                                },
                                {
                                    "Text": "Senior Master Technician",
                                    "Value": "Senior Master Technician"
                                },
                                {
                                    "Text": "Senior Maths Faculty",
                                    "Value": "Senior Maths Faculty"
                                },
                                {
                                    "Text": "Senior Mechanical Engineer",
                                    "Value": "Senior Mechanical Engineer"
                                },
                                {
                                    "Text": "Senior Med Sales Representatve",
                                    "Value": "Senior Med Sales Representatve"
                                },
                                {
                                    "Text": "Senior Medical Officer",
                                    "Value": "Senior Medical Officer"
                                },
                                {
                                    "Text": "Senior Medical Registrar",
                                    "Value": "Senior Medical Registrar"
                                },
                                {
                                    "Text": "Senior Medical Representative",
                                    "Value": "Senior Medical Representative"
                                },
                                {
                                    "Text": "Senior Medical Transcriptionst",
                                    "Value": "Senior Medical Transcriptionst"
                                },
                                {
                                    "Text": "Senior Member Technical Staff",
                                    "Value": "Senior Member Technical Staff"
                                },
                                {
                                    "Text": "Senior Mgr Control Equipment",
                                    "Value": "Senior Mgr Control Equipment"
                                },
                                {
                                    "Text": "Senior Mgr Corporate Planning",
                                    "Value": "Senior Mgr Corporate Planning"
                                },
                                {
                                    "Text": "Senior Mgr Mech. Maintenance",
                                    "Value": "Senior Mgr Mech. Maintenance"
                                },
                                {
                                    "Text": "Senior Non-Commissioned Officr",
                                    "Value": "Senior Non-Commissioned Officr"
                                },
                                {
                                    "Text": "Senior Offcr Quality Assurance",
                                    "Value": "Senior Offcr Quality Assurance"
                                },
                                {
                                    "Text": "Senior Officer & Engineer",
                                    "Value": "Senior Officer & Engineer"
                                },
                                {
                                    "Text": "Senior Officer Accounts",
                                    "Value": "Senior Officer Accounts"
                                },
                                {
                                    "Text": "Senior Officer Commercial",
                                    "Value": "Senior Officer Commercial"
                                },
                                {
                                    "Text": "Senior Officer Finance",
                                    "Value": "Senior Officer Finance"
                                },
                                {
                                    "Text": "Senior Officer Planning",
                                    "Value": "Senior Officer Planning"
                                },
                                {
                                    "Text": "Senior Officer Production",
                                    "Value": "Senior Officer Production"
                                },
                                {
                                    "Text": "Senior Officer Stores",
                                    "Value": "Senior Officer Stores"
                                },
                                {
                                    "Text": "Senior Executive HR",
                                    "Value": "Senior Executive HR"
                                },
                                {
                                    "Text": "Senior Operations Officer",
                                    "Value": "Senior Operations Officer"
                                },
                                {
                                    "Text": "Senior Operator Cum Technician",
                                    "Value": "Senior Operator Cum Technician"
                                },
                                {
                                    "Text": "Senior Personnel Officer",
                                    "Value": "Senior Personnel Officer"
                                },
                                {
                                    "Text": "Senior Pharmacist",
                                    "Value": "Senior Pharmacist"
                                },
                                {
                                    "Text": "Senior Plant Manager",
                                    "Value": "Senior Plant Manager"
                                },
                                {
                                    "Text": "Senior Plant Technician",
                                    "Value": "Senior Plant Technician"
                                },
                                {
                                    "Text": "Senior Principle Engineer",
                                    "Value": "Senior Principle Engineer"
                                },
                                {
                                    "Text": "Senior Private Secretary",
                                    "Value": "Senior Private Secretary"
                                },
                                {
                                    "Text": "Senior Process Associate",
                                    "Value": "Senior Process Associate"
                                },
                                {
                                    "Text": "Sewing Machine Mechanic",
                                    "Value": "Sewing Machine Mechanic"
                                },
                                {
                                    "Text": "Senior Production Engineer",
                                    "Value": "Senior Production Engineer"
                                },
                                {
                                    "Text": "Senior Production Officer",
                                    "Value": "Senior Production Officer"
                                },
                                {
                                    "Text": "Senior Profesionl Serv Officr.",
                                    "Value": "Senior Profesionl Serv Officr."
                                },
                                {
                                    "Text": "Senior Professional Serv Exec",
                                    "Value": "Senior Professional Serv Exec"
                                },
                                {
                                    "Text": "Senior Engineer Grade III",
                                    "Value": "Senior Engineer Grade III"
                                },
                                {
                                    "Text": "Senior Project Auditor",
                                    "Value": "Senior Project Auditor"
                                },
                                {
                                    "Text": "Senior Exec. Finance & Admin",
                                    "Value": "Senior Exec. Finance & Admin"
                                },
                                {
                                    "Text": "Senior Project Leader",
                                    "Value": "Senior Project Leader"
                                },
                                {
                                    "Text": "Senior Project Manager",
                                    "Value": "Senior Project Manager"
                                },
                                {
                                    "Text": "Seismologist",
                                    "Value": "Seismologist"
                                },
                                {
                                    "Text": "Senior Executive IT",
                                    "Value": "Senior Executive IT"
                                },
                                {
                                    "Text": "Senior Quality Control Officer",
                                    "Value": "Senior Quality Control Officer"
                                },
                                {
                                    "Text": "Senior R&D Manager",
                                    "Value": "Senior R&D Manager"
                                },
                                {
                                    "Text": "Senior Reader",
                                    "Value": "Senior Reader"
                                },
                                {
                                    "Text": "Senior Receptionist",
                                    "Value": "Senior Receptionist"
                                },
                                {
                                    "Text": "Senior Record Keeper",
                                    "Value": "Senior Record Keeper"
                                },
                                {
                                    "Text": "Senior Regional Manager",
                                    "Value": "Senior Regional Manager"
                                },
                                {
                                    "Text": "Senior Relationship Officer",
                                    "Value": "Senior Relationship Officer"
                                },
                                {
                                    "Text": "Senior Research Assistant",
                                    "Value": "Senior Research Assistant"
                                },
                                {
                                    "Text": "Senior Research Associate",
                                    "Value": "Senior Research Associate"
                                },
                                {
                                    "Text": "Senior Research Officer",
                                    "Value": "Senior Research Officer"
                                },
                                {
                                    "Text": "Senior Research Scientist",
                                    "Value": "Senior Research Scientist"
                                },
                                {
                                    "Text": "Senior Resident",
                                    "Value": "Senior Resident"
                                },
                                {
                                    "Text": "Senior RMO",
                                    "Value": "Senior RMO"
                                },
                                {
                                    "Text": "Senior Sales Associate",
                                    "Value": "Senior Sales Associate"
                                },
                                {
                                    "Text": "Senior Sales Consultant",
                                    "Value": "Senior Sales Consultant"
                                },
                                {
                                    "Text": "Senior Sales Engineer",
                                    "Value": "Senior Sales Engineer"
                                },
                                {
                                    "Text": "Senior Sales Executive",
                                    "Value": "Senior Sales Executive"
                                },
                                {
                                    "Text": "Senior Sales Manager",
                                    "Value": "Senior Sales Manager"
                                },
                                {
                                    "Text": "Senior Salesman",
                                    "Value": "Senior Salesman"
                                },
                                {
                                    "Text": "Senior Scale Lecturer",
                                    "Value": "Senior Scale Lecturer"
                                },
                                {
                                    "Text": "Senior Scientist",
                                    "Value": "Senior Scientist"
                                },
                                {
                                    "Text": "Senior Secondary Teacher",
                                    "Value": "Senior Secondary Teacher"
                                },
                                {
                                    "Text": "Senior Section Engineer",
                                    "Value": "Senior Section Engineer"
                                },
                                {
                                    "Text": "Senior Service Engineer",
                                    "Value": "Senior Service Engineer"
                                },
                                {
                                    "Text": "Senior Service Executive",
                                    "Value": "Senior Service Executive"
                                },
                                {
                                    "Text": "Senior Software Quality Engg.",
                                    "Value": "Senior Software Quality Engg."
                                },
                                {
                                    "Text": "Senior Software Test Engineer",
                                    "Value": "Senior Software Test Engineer"
                                },
                                {
                                    "Text": "Senior Solutions Architect",
                                    "Value": "Senior Solutions Architect"
                                },
                                {
                                    "Text": "Senior Solutions Manager",
                                    "Value": "Senior Solutions Manager"
                                },
                                {
                                    "Text": "Senior Specialist",
                                    "Value": "Senior Specialist"
                                },
                                {
                                    "Text": "Senior Staff Nurse",
                                    "Value": "Senior Staff Nurse"
                                },
                                {
                                    "Text": "Senior Stenographer",
                                    "Value": "Senior Stenographer"
                                },
                                {
                                    "Text": "Senior Superintndnt Technician",
                                    "Value": "Senior Superintndnt Technician"
                                },
                                {
                                    "Text": "Senior Systems Officer",
                                    "Value": "Senior Systems Officer"
                                },
                                {
                                    "Text": "Senior Teacher",
                                    "Value": "Senior Teacher"
                                },
                                {
                                    "Text": "Senior Team Coach",
                                    "Value": "Senior Team Coach"
                                },
                                {
                                    "Text": "Senior Team Manager",
                                    "Value": "Senior Team Manager"
                                },
                                {
                                    "Text": "Senior Tech. Support Associate",
                                    "Value": "Senior Tech. Support Associate"
                                },
                                {
                                    "Text": "Senior Technical Engineer",
                                    "Value": "Senior Technical Engineer"
                                },
                                {
                                    "Text": "Senior Technical Leader",
                                    "Value": "Senior Technical Leader"
                                },
                                {
                                    "Text": "Senior Technical Support Engg.",
                                    "Value": "Senior Technical Support Engg."
                                },
                                {
                                    "Text": "Senior Technician",
                                    "Value": "Senior Technician"
                                },
                                {
                                    "Text": "Senior Technician & Chargeman",
                                    "Value": "Senior Technician & Chargeman"
                                },
                                {
                                    "Text": "Senior Technician Grade II",
                                    "Value": "Senior Technician Grade II"
                                },
                                {
                                    "Text": "Senior Technician Lead",
                                    "Value": "Senior Technician Lead"
                                },
                                {
                                    "Text": "Senior Technician Operator",
                                    "Value": "Senior Technician Operator"
                                },
                                {
                                    "Text": "Senior Telecom Assistant",
                                    "Value": "Senior Telecom Assistant"
                                },
                                {
                                    "Text": "Senior Telecom Office Asst",
                                    "Value": "Senior Telecom Office Asst"
                                },
                                {
                                    "Text": "Senior Telecom Operator",
                                    "Value": "Senior Telecom Operator"
                                },
                                {
                                    "Text": "Senior Telephone Operator",
                                    "Value": "Senior Telephone Operator"
                                },
                                {
                                    "Text": "Senior Territory Manager",
                                    "Value": "Senior Territory Manager"
                                },
                                {
                                    "Text": "Senior Test Engineer",
                                    "Value": "Senior Test Engineer"
                                },
                                {
                                    "Text": "Senior Trainer",
                                    "Value": "Senior Trainer"
                                },
                                {
                                    "Text": "Senior Transportation Engineer",
                                    "Value": "Senior Transportation Engineer"
                                },
                                {
                                    "Text": "Senior Vice President",
                                    "Value": "Senior Vice President"
                                },
                                {
                                    "Text": "Senior Writer",
                                    "Value": "Senior Writer"
                                },
                                {
                                    "Text": "Service Branch Manager",
                                    "Value": "Service Branch Manager"
                                },
                                {
                                    "Text": "Service Clerk",
                                    "Value": "Service Clerk"
                                },
                                {
                                    "Text": "Service Dy. Mgr Administration",
                                    "Value": "Service Dy. Mgr Administration"
                                },
                                {
                                    "Text": "Service Incharge",
                                    "Value": "Service Incharge"
                                },
                                {
                                    "Text": "Service Manager",
                                    "Value": "Service Manager"
                                },
                                {
                                    "Text": "Service Mould Engineer",
                                    "Value": "Service Mould Engineer"
                                },
                                {
                                    "Text": "Service Officer",
                                    "Value": "Service Officer"
                                },
                                {
                                    "Text": "Service Representative",
                                    "Value": "Service Representative"
                                },
                                {
                                    "Text": "Service Sales Execuitve",
                                    "Value": "Service Sales Execuitve"
                                },
                                {
                                    "Text": "Service Specialist",
                                    "Value": "Service Specialist"
                                },
                                {
                                    "Text": "Service Vice President",
                                    "Value": "Service Vice President"
                                },
                                {
                                    "Text": "Senior Executive Operations",
                                    "Value": "Senior Executive Operations"
                                },
                                {
                                    "Text": "Senior Accountant",
                                    "Value": "Senior Accountant"
                                },
                                {
                                    "Text": "Senior surgeon",
                                    "Value": "Senior surgeon"
                                },
                                {
                                    "Text": "Senior Auditor",
                                    "Value": "Senior Auditor"
                                },
                                {
                                    "Text": "Senior Assistant Loco Pilot",
                                    "Value": "Senior Assistant Loco Pilot"
                                },
                                {
                                    "Text": "Senior Supervisor",
                                    "Value": "Senior Supervisor"
                                },
                                {
                                    "Text": "Senior Research Fellow",
                                    "Value": "Senior Research Fellow"
                                },
                                {
                                    "Text": "Service Engineer",
                                    "Value": "Service Engineer"
                                },
                                {
                                    "Text": "Sr. Executive Regional Human",
                                    "Value": "Sr. Executive Regional Human"
                                },
                                {
                                    "Text": "Section Divisional Clerk",
                                    "Value": "Section Divisional Clerk"
                                },
                                {
                                    "Text": "Senior Exec Mkt & Tech. Supprt",
                                    "Value": "Senior Exec Mkt & Tech. Supprt"
                                },
                                {
                                    "Text": "Service",
                                    "Value": "Service"
                                },
                                {
                                    "Text": "Senior Dealer Treasury",
                                    "Value": "Senior Dealer Treasury"
                                },
                                {
                                    "Text": "Senior Executive Purchase",
                                    "Value": "Senior Executive Purchase"
                                },
                                {
                                    "Text": "Senior Executive Process",
                                    "Value": "Senior Executive Process"
                                },
                                {
                                    "Text": "Senior Analytical Chemist",
                                    "Value": "Senior Analytical Chemist"
                                },
                                {
                                    "Text": "Section Supervisor",
                                    "Value": "Section Supervisor"
                                },
                                {
                                    "Text": "Senior Steward",
                                    "Value": "Senior Steward"
                                },
                                {
                                    "Text": "Set Designer",
                                    "Value": "Set Designer"
                                },
                                {
                                    "Text": "Secretary Mandi Samiti",
                                    "Value": "Secretary Mandi Samiti"
                                },
                                {
                                    "Text": "Senior Mgr Sales & Distributn",
                                    "Value": "Senior Mgr Sales & Distributn"
                                },
                                {
                                    "Text": "Senior Manager Accounts",
                                    "Value": "Senior Manager Accounts"
                                },
                                {
                                    "Text": "Senior Faculty",
                                    "Value": "Senior Faculty"
                                },
                                {
                                    "Text": "Senior Accounts Executive",
                                    "Value": "Senior Accounts Executive"
                                },
                                {
                                    "Text": "Senior Operation Engineer",
                                    "Value": "Senior Operation Engineer"
                                },
                                {
                                    "Text": "Senior Processing Officer",
                                    "Value": "Senior Processing Officer"
                                },
                                {
                                    "Text": "Senior Project Associate",
                                    "Value": "Senior Project Associate"
                                },
                                {
                                    "Text": "Senior Project Engineer",
                                    "Value": "Senior Project Engineer"
                                },
                                {
                                    "Text": "Senior Purchaser",
                                    "Value": "Senior Purchaser"
                                },
                                {
                                    "Text": "Senior Quality Assurance Engg",
                                    "Value": "Senior Quality Assurance Engg"
                                },
                                {
                                    "Text": "Senior Training Officer",
                                    "Value": "Senior Training Officer"
                                },
                                {
                                    "Text": "Senior Travel Consultant",
                                    "Value": "Senior Travel Consultant"
                                },
                                {
                                    "Text": "Senior Typist",
                                    "Value": "Senior Typist"
                                },
                                {
                                    "Text": "Senior Veterinary Inspector",
                                    "Value": "Senior Veterinary Inspector"
                                },
                                {
                                    "Text": "Senior Veterinary Surgeon",
                                    "Value": "Senior Veterinary Surgeon"
                                },
                                {
                                    "Text": "Senior Web Developer",
                                    "Value": "Senior Web Developer"
                                },
                                {
                                    "Text": "Senior X-Ray Technologist",
                                    "Value": "Senior X-Ray Technologist"
                                },
                                {
                                    "Text": "Server Supervisor",
                                    "Value": "Server Supervisor"
                                },
                                {
                                    "Text": "Service Advisor",
                                    "Value": "Service Advisor"
                                },
                                {
                                    "Text": "Service Associate",
                                    "Value": "Service Associate"
                                },
                                {
                                    "Text": "Service Center Officer",
                                    "Value": "Service Center Officer"
                                },
                                {
                                    "Text": "Secretary To Director",
                                    "Value": "Secretary To Director"
                                },
                                {
                                    "Text": "Selection Grade Officer",
                                    "Value": "Selection Grade Officer"
                                },
                                {
                                    "Text": "Self Emp Rent & Interst Income",
                                    "Value": "Self Emp Rent & Interst Income"
                                },
                                {
                                    "Text": "Self Employed & Owner",
                                    "Value": "Self Employed & Owner"
                                },
                                {
                                    "Text": "Self Employed Tailoring",
                                    "Value": "Self Employed Tailoring"
                                },
                                {
                                    "Text": "Senior Commercial Executive",
                                    "Value": "Senior Commercial Executive"
                                },
                                {
                                    "Text": "Senior Commercial Inspector",
                                    "Value": "Senior Commercial Inspector"
                                },
                                {
                                    "Text": "Senior Commercial Manager",
                                    "Value": "Senior Commercial Manager"
                                },
                                {
                                    "Text": "Senior Comp. Terminal Operator",
                                    "Value": "Senior Comp. Terminal Operator"
                                },
                                {
                                    "Text": "Senior Consultant",
                                    "Value": "Senior Consultant"
                                },
                                {
                                    "Text": "Senior Customer Service Asst.",
                                    "Value": "Senior Customer Service Asst."
                                },
                                {
                                    "Text": "Senior Customer Service Exec.",
                                    "Value": "Senior Customer Service Exec."
                                },
                                {
                                    "Text": "Senior Customer Support",
                                    "Value": "Senior Customer Support"
                                },
                                {
                                    "Text": "Senior Designer",
                                    "Value": "Senior Designer"
                                },
                                {
                                    "Text": "Senior Executive Corporate",
                                    "Value": "Senior Executive Corporate"
                                },
                                {
                                    "Text": "Senior Finance Manager",
                                    "Value": "Senior Finance Manager"
                                },
                                {
                                    "Text": "Senior Manager IT",
                                    "Value": "Senior Manager IT"
                                },
                                {
                                    "Text": "Senior Manager MIS",
                                    "Value": "Senior Manager MIS"
                                },
                                {
                                    "Text": "Sea Freight Operation Asst",
                                    "Value": "Sea Freight Operation Asst"
                                },
                                {
                                    "Text": "Share Dealer",
                                    "Value": "Share Dealer"
                                },
                                {
                                    "Text": "Share Trader",
                                    "Value": "Share Trader"
                                },
                                {
                                    "Text": "Shawl Broker",
                                    "Value": "Shawl Broker"
                                },
                                {
                                    "Text": "Shift Incharge Engineer",
                                    "Value": "Shift Incharge Engineer"
                                },
                                {
                                    "Text": "Shop In Charge",
                                    "Value": "Shop In Charge"
                                },
                                {
                                    "Text": "Shopkeeper & Owner",
                                    "Value": "Shopkeeper & Owner"
                                },
                                {
                                    "Text": "Showroom Assistant Manager",
                                    "Value": "Showroom Assistant Manager"
                                },
                                {
                                    "Text": "Showroom Incharge",
                                    "Value": "Showroom Incharge"
                                },
                                {
                                    "Text": "Showroom Salesman",
                                    "Value": "Showroom Salesman"
                                },
                                {
                                    "Text": "Sr. Channel Development",
                                    "Value": "Sr. Channel Development"
                                },
                                {
                                    "Text": "Shop Manager",
                                    "Value": "Shop Manager"
                                },
                                {
                                    "Text": "Shift Incharge",
                                    "Value": "Shift Incharge"
                                },
                                {
                                    "Text": "Shiksha Karmi",
                                    "Value": "Shiksha Karmi"
                                },
                                {
                                    "Text": "Showroom Supervisor",
                                    "Value": "Showroom Supervisor"
                                },
                                {
                                    "Text": "Shopkeeper",
                                    "Value": "Shopkeeper"
                                },
                                {
                                    "Text": "Showroom Executive",
                                    "Value": "Showroom Executive"
                                },
                                {
                                    "Text": "Site Manager",
                                    "Value": "Site Manager"
                                },
                                {
                                    "Text": "Site Incharge",
                                    "Value": "Site Incharge"
                                },
                                {
                                    "Text": "Singer",
                                    "Value": "Singer"
                                },
                                {
                                    "Text": "Site Supervisor",
                                    "Value": "Site Supervisor"
                                },
                                {
                                    "Text": "Singing Teacher",
                                    "Value": "Singing Teacher"
                                },
                                {
                                    "Text": "Sewak",
                                    "Value": "Sewak"
                                },
                                {
                                    "Text": "Skin Specialist Doctor",
                                    "Value": "Skin Specialist Doctor"
                                },
                                {
                                    "Text": "Silk Merchant",
                                    "Value": "Silk Merchant"
                                },
                                {
                                    "Text": "Sr. Manager  Accounts",
                                    "Value": "Sr. Manager  Accounts"
                                },
                                {
                                    "Text": "Sr. Manager Audit & Risk",
                                    "Value": "Sr. Manager Audit & Risk"
                                },
                                {
                                    "Text": "Sr. Manager Business Insights",
                                    "Value": "Sr. Manager Business Insights"
                                },
                                {
                                    "Text": "Sr. Manager  Bancassurance",
                                    "Value": "Sr. Manager  Bancassurance"
                                },
                                {
                                    "Text": "Sr. Manager  Broka",
                                    "Value": "Sr. Manager  Broka"
                                },
                                {
                                    "Text": "Sr. Manager  B & SE",
                                    "Value": "Sr. Manager  B & SE"
                                },
                                {
                                    "Text": "Sr. Manager BS & T",
                                    "Value": "Sr. Manager BS & T"
                                },
                                {
                                    "Text": "Sr. Mgr Central Ops. & OS",
                                    "Value": "Sr. Mgr Central Ops. & OS"
                                },
                                {
                                    "Text": "Sr. Manager Customer Service",
                                    "Value": "Sr. Manager Customer Service"
                                },
                                {
                                    "Text": "Senior Manager Direct",
                                    "Value": "Senior Manager Direct"
                                },
                                {
                                    "Text": "Sr. Manager DPPM",
                                    "Value": "Sr. Manager DPPM"
                                },
                                {
                                    "Text": "Sr. Manager Direct Sales",
                                    "Value": "Sr. Manager Direct Sales"
                                },
                                {
                                    "Text": "Senior Merchandiser",
                                    "Value": "Senior Merchandiser"
                                },
                                {
                                    "Text": "Sr. Manager  ERP",
                                    "Value": "Sr. Manager  ERP"
                                },
                                {
                                    "Text": "Area Manager Group Sales",
                                    "Value": "Area Manager Group Sales"
                                },
                                {
                                    "Text": "Sr. Manager Health Insurance",
                                    "Value": "Sr. Manager Health Insurance"
                                },
                                {
                                    "Text": "Sr. Manager HNI",
                                    "Value": "Sr. Manager HNI"
                                },
                                {
                                    "Text": "Sr. Manager Zonal Human",
                                    "Value": "Sr. Manager Zonal Human"
                                },
                                {
                                    "Text": "Sr. Manager HNI & Strategic",
                                    "Value": "Sr. Manager HNI & Strategic"
                                },
                                {
                                    "Text": "Sr. Manager Learning and",
                                    "Value": "Sr. Manager Learning and"
                                },
                                {
                                    "Text": "Sr. Manager Medical Support",
                                    "Value": "Sr. Manager Medical Support"
                                },
                                {
                                    "Text": "Sr. Manager Marketing",
                                    "Value": "Sr. Manager Marketing"
                                },
                                {
                                    "Text": "Senior Manager Mid Office",
                                    "Value": "Senior Manager Mid Office"
                                },
                                {
                                    "Text": "Sr. Manager Operations (Hub)",
                                    "Value": "Sr. Manager Operations (Hub)"
                                },
                                {
                                    "Text": "Sr. Manager CS (Persistency)",
                                    "Value": "Sr. Manager CS (Persistency)"
                                },
                                {
                                    "Text": "Sr. Manager Strategy & Product",
                                    "Value": "Sr. Manager Strategy & Product"
                                },
                                {
                                    "Text": "Sr. Manager CSR",
                                    "Value": "Sr. Manager CSR"
                                },
                                {
                                    "Text": "Sr. Manager Telemarketing",
                                    "Value": "Sr. Manager Telemarketing"
                                },
                                {
                                    "Text": "Sr. Manager Zonal",
                                    "Value": "Sr. Manager Zonal"
                                },
                                {
                                    "Text": "Sr. Manager Zonal Marketing",
                                    "Value": "Sr. Manager Zonal Marketing"
                                },
                                {
                                    "Text": "Sr. Manager Zonal Medical",
                                    "Value": "Sr. Manager Zonal Medical"
                                },
                                {
                                    "Text": "Sr. Manager Zonal Operations",
                                    "Value": "Sr. Manager Zonal Operations"
                                },
                                {
                                    "Text": "sandblaster",
                                    "Value": "sandblaster"
                                },
                                {
                                    "Text": "Software Development Manager",
                                    "Value": "Software Development Manager"
                                },
                                {
                                    "Text": "Software Financial Analyst",
                                    "Value": "Software Financial Analyst"
                                },
                                {
                                    "Text": "Society Chairman",
                                    "Value": "Society Chairman"
                                },
                                {
                                    "Text": "Solutions Manager",
                                    "Value": "Solutions Manager"
                                },
                                {
                                    "Text": "Software programmer",
                                    "Value": "Software programmer"
                                },
                                {
                                    "Text": "Software Engineer",
                                    "Value": "Software Engineer"
                                },
                                {
                                    "Text": "Solderer",
                                    "Value": "Solderer"
                                },
                                {
                                    "Text": "Sorting Assistant",
                                    "Value": "Sorting Assistant"
                                },
                                {
                                    "Text": "Soil Conservation Inspector",
                                    "Value": "Soil Conservation Inspector"
                                },
                                {
                                    "Text": "Soft Skills Trainer",
                                    "Value": "Soft Skills Trainer"
                                },
                                {
                                    "Text": "Sourcing Executive",
                                    "Value": "Sourcing Executive"
                                },
                                {
                                    "Text": "Sole Proprietor",
                                    "Value": "Sole Proprietor"
                                },
                                {
                                    "Text": "Special Information Officer",
                                    "Value": "Special Information Officer"
                                },
                                {
                                    "Text": "Specialist Mechanical Engineer",
                                    "Value": "Specialist Mechanical Engineer"
                                },
                                {
                                    "Text": "Specialst Training & Develpmnt",
                                    "Value": "Specialst Training & Develpmnt"
                                },
                                {
                                    "Text": "Specification Consultant",
                                    "Value": "Specification Consultant"
                                },
                                {
                                    "Text": "Speech Physiotherapist",
                                    "Value": "Speech Physiotherapist"
                                },
                                {
                                    "Text": "Sports Auditor",
                                    "Value": "Sports Auditor"
                                },
                                {
                                    "Text": "Sports Teacher",
                                    "Value": "Sports Teacher"
                                },
                                {
                                    "Text": "Specialist Software Professnal",
                                    "Value": "Specialist Software Professnal"
                                },
                                {
                                    "Text": "Specialist Technician",
                                    "Value": "Specialist Technician"
                                },
                                {
                                    "Text": "Swimming Pool Attendant",
                                    "Value": "Swimming Pool Attendant"
                                },
                                {
                                    "Text": "Special Secretary Finance",
                                    "Value": "Special Secretary Finance"
                                },
                                {
                                    "Text": "Special duties",
                                    "Value": "Special duties"
                                },
                                {
                                    "Text": "Special Revenue officer",
                                    "Value": "Special Revenue officer"
                                },
                                {
                                    "Text": "Boxer",
                                    "Value": "Boxer"
                                },
                                {
                                    "Text": "Wrestler",
                                    "Value": "Wrestler"
                                },
                                {
                                    "Text": "Rugby",
                                    "Value": "Rugby"
                                },
                                {
                                    "Text": "Athlete",
                                    "Value": "Athlete"
                                },
                                {
                                    "Text": "Circuit driver",
                                    "Value": "Circuit driver"
                                },
                                {
                                    "Text": "Circuit racer",
                                    "Value": "Circuit racer"
                                },
                                {
                                    "Text": "Formula four driver",
                                    "Value": "Formula four driver"
                                },
                                {
                                    "Text": "Formula one driver",
                                    "Value": "Formula one driver"
                                },
                                {
                                    "Text": "Formula two driver",
                                    "Value": "Formula two driver"
                                },
                                {
                                    "Text": "Motocross racing driver",
                                    "Value": "Motocross racing driver"
                                },
                                {
                                    "Text": "Motorcycle racing driver",
                                    "Value": "Motorcycle racing driver"
                                },
                                {
                                    "Text": "Motor racing",
                                    "Value": "Motor racing"
                                },
                                {
                                    "Text": "Professional car racing driver",
                                    "Value": "Professional car racing driver"
                                },
                                {
                                    "Text": "Professional racing driver",
                                    "Value": "Professional racing driver"
                                },
                                {
                                    "Text": "Rally driver",
                                    "Value": "Rally driver"
                                },
                                {
                                    "Text": "Speedway rider",
                                    "Value": "Speedway rider"
                                },
                                {
                                    "Text": "Hand gliding",
                                    "Value": "Hand gliding"
                                },
                                {
                                    "Text": "Para gliding",
                                    "Value": "Para gliding"
                                },
                                {
                                    "Text": "Parascending",
                                    "Value": "Parascending"
                                },
                                {
                                    "Text": "Ballooning",
                                    "Value": "Ballooning"
                                },
                                {
                                    "Text": "Micro lighting",
                                    "Value": "Micro lighting"
                                },
                                {
                                    "Text": "Parachuting",
                                    "Value": "Parachuting"
                                },
                                {
                                    "Text": "Bungee jumping",
                                    "Value": "Bungee jumping"
                                },
                                {
                                    "Text": "Swimming",
                                    "Value": "Swimming"
                                },
                                {
                                    "Text": "Specialist In Anaesthesia",
                                    "Value": "Specialist In Anaesthesia"
                                },
                                {
                                    "Text": "Judo",
                                    "Value": "Judo"
                                },
                                {
                                    "Text": "Kickboxing instructor",
                                    "Value": "Kickboxing instructor"
                                },
                                {
                                    "Text": "Martial arts",
                                    "Value": "Martial arts"
                                },
                                {
                                    "Text": "Taekwondo",
                                    "Value": "Taekwondo"
                                },
                                {
                                    "Text": "Karate",
                                    "Value": "Karate"
                                },
                                {
                                    "Text": "Basketball coach",
                                    "Value": "Basketball coach"
                                },
                                {
                                    "Text": "Golf",
                                    "Value": "Golf"
                                },
                                {
                                    "Text": "Hockey",
                                    "Value": "Hockey"
                                },
                                {
                                    "Text": "Tennis",
                                    "Value": "Tennis"
                                },
                                {
                                    "Text": "Badminton",
                                    "Value": "Badminton"
                                },
                                {
                                    "Text": "Table tennis",
                                    "Value": "Table tennis"
                                },
                                {
                                    "Text": "Cricket",
                                    "Value": "Cricket"
                                },
                                {
                                    "Text": "Billiards",
                                    "Value": "Billiards"
                                },
                                {
                                    "Text": "Chess",
                                    "Value": "Chess"
                                },
                                {
                                    "Text": "Special Correspondent",
                                    "Value": "Special Correspondent"
                                },
                                {
                                    "Text": "Special Dental Surgeon",
                                    "Value": "Special Dental Surgeon"
                                },
                                {
                                    "Text": "Specialist Registr Gen Surgery",
                                    "Value": "Specialist Registr Gen Surgery"
                                },
                                {
                                    "Text": "Sr Customer Serv Representatve",
                                    "Value": "Sr Customer Serv Representatve"
                                },
                                {
                                    "Text": "Sr. Officer Accounts",
                                    "Value": "Sr. Officer Accounts"
                                },
                                {
                                    "Text": "Sr. Draughtsman",
                                    "Value": "Sr. Draughtsman"
                                },
                                {
                                    "Text": "Sr. Officer Agency Operations",
                                    "Value": "Sr. Officer Agency Operations"
                                },
                                {
                                    "Text": "Sr. Business Analyst",
                                    "Value": "Sr. Business Analyst"
                                },
                                {
                                    "Text": "Sr. Claims Assessor",
                                    "Value": "Sr. Claims Assessor"
                                },
                                {
                                    "Text": "Sr. Officer Claims",
                                    "Value": "Sr. Officer Claims"
                                },
                                {
                                    "Text": "Sr. Officer Central Operations",
                                    "Value": "Sr. Officer Central Operations"
                                },
                                {
                                    "Text": "Sr. Off. Ops Customer Serv.",
                                    "Value": "Sr. Off. Ops Customer Serv."
                                },
                                {
                                    "Text": "Sr. Engineer",
                                    "Value": "Sr. Engineer"
                                },
                                {
                                    "Text": "Service Executive",
                                    "Value": "Service Executive"
                                },
                                {
                                    "Text": "Senior Management",
                                    "Value": "Senior Management"
                                },
                                {
                                    "Text": "Senior Manager",
                                    "Value": "Senior Manager"
                                },
                                {
                                    "Text": "Sr Mgr Sale & Prodct Devlopmnt",
                                    "Value": "Sr Mgr Sale & Prodct Devlopmnt"
                                },
                                {
                                    "Text": "Sr. Officer Hub Operations",
                                    "Value": "Sr. Officer Hub Operations"
                                },
                                {
                                    "Text": "Sr. Officer Group Operations",
                                    "Value": "Sr. Officer Group Operations"
                                },
                                {
                                    "Text": "Sr. Doctor",
                                    "Value": "Sr. Doctor"
                                },
                                {
                                    "Text": "Search & rescue instructor",
                                    "Value": "Search & rescue instructor"
                                },
                                {
                                    "Text": "Sr. Officer Ops(Finance and",
                                    "Value": "Sr. Officer Ops(Finance and"
                                },
                                {
                                    "Text": "Sr. Officer Shared Services",
                                    "Value": "Sr. Officer Shared Services"
                                },
                                {
                                    "Text": "Sr. Analyst",
                                    "Value": "Sr. Analyst"
                                },
                                {
                                    "Text": "Sr. Executive",
                                    "Value": "Sr. Executive"
                                },
                                {
                                    "Text": "Sr. Systems Analyst",
                                    "Value": "Sr. Systems Analyst"
                                },
                                {
                                    "Text": "Senior Support Consultant",
                                    "Value": "Senior Support Consultant"
                                },
                                {
                                    "Text": "Sr. Sales Manager",
                                    "Value": "Sr. Sales Manager"
                                },
                                {
                                    "Text": "Staff Engineer",
                                    "Value": "Staff Engineer"
                                },
                                {
                                    "Text": "Stamp Vendor",
                                    "Value": "Stamp Vendor"
                                },
                                {
                                    "Text": "Station Engineer",
                                    "Value": "Station Engineer"
                                },
                                {
                                    "Text": "Steno",
                                    "Value": "Steno"
                                },
                                {
                                    "Text": "Stenographer Grade I",
                                    "Value": "Stenographer Grade I"
                                },
                                {
                                    "Text": "Stenographer Grade II",
                                    "Value": "Stenographer Grade II"
                                },
                                {
                                    "Text": "Steongrapher",
                                    "Value": "Steongrapher"
                                },
                                {
                                    "Text": "Stock Holder",
                                    "Value": "Stock Holder"
                                },
                                {
                                    "Text": "Stock Manager",
                                    "Value": "Stock Manager"
                                },
                                {
                                    "Text": "Stock Yard Manager",
                                    "Value": "Stock Yard Manager"
                                },
                                {
                                    "Text": "Stockist",
                                    "Value": "Stockist"
                                },
                                {
                                    "Text": "Stocks Dealer",
                                    "Value": "Stocks Dealer"
                                },
                                {
                                    "Text": "Stores Clerk",
                                    "Value": "Stores Clerk"
                                },
                                {
                                    "Text": "Stores Purchase Officer",
                                    "Value": "Stores Purchase Officer"
                                },
                                {
                                    "Text": "Statistician",
                                    "Value": "Statistician"
                                },
                                {
                                    "Text": "Statistical Officer",
                                    "Value": "Statistical Officer"
                                },
                                {
                                    "Text": "Steel Erectors",
                                    "Value": "Steel Erectors"
                                },
                                {
                                    "Text": "Site Foreman",
                                    "Value": "Site Foreman"
                                },
                                {
                                    "Text": "Steno Grade II",
                                    "Value": "Steno Grade II"
                                },
                                {
                                    "Text": "Stenographer",
                                    "Value": "Stenographer"
                                },
                                {
                                    "Text": "Statistical Assistant",
                                    "Value": "Statistical Assistant"
                                },
                                {
                                    "Text": "Stores Peon",
                                    "Value": "Stores Peon"
                                },
                                {
                                    "Text": "Statistical Inspector",
                                    "Value": "Statistical Inspector"
                                },
                                {
                                    "Text": "Storekeeper",
                                    "Value": "Storekeeper"
                                },
                                {
                                    "Text": "Stripper",
                                    "Value": "Stripper"
                                },
                                {
                                    "Text": "Steno Secretary",
                                    "Value": "Steno Secretary"
                                },
                                {
                                    "Text": "Staff Nurse",
                                    "Value": "Staff Nurse"
                                },
                                {
                                    "Text": "Steel Trader",
                                    "Value": "Steel Trader"
                                },
                                {
                                    "Text": "Stunt performer",
                                    "Value": "Stunt performer"
                                },
                                {
                                    "Text": "Stock Dealer",
                                    "Value": "Stock Dealer"
                                },
                                {
                                    "Text": "Structure Engineer",
                                    "Value": "Structure Engineer"
                                },
                                {
                                    "Text": "Sub Assistant Engineer",
                                    "Value": "Sub Assistant Engineer"
                                },
                                {
                                    "Text": "Sub Broker",
                                    "Value": "Sub Broker"
                                },
                                {
                                    "Text": "Sub Contractor",
                                    "Value": "Sub Contractor"
                                },
                                {
                                    "Text": "Sub Divisional Engineer",
                                    "Value": "Sub Divisional Engineer"
                                },
                                {
                                    "Text": "Sub Engineer",
                                    "Value": "Sub Engineer"
                                },
                                {
                                    "Text": "Sub Technical Editor",
                                    "Value": "Sub Technical Editor"
                                },
                                {
                                    "Text": "Superintendent Engineer",
                                    "Value": "Superintendent Engineer"
                                },
                                {
                                    "Text": "Superintendenting Engineer",
                                    "Value": "Superintendenting Engineer"
                                },
                                {
                                    "Text": "Supervising Engineer",
                                    "Value": "Supervising Engineer"
                                },
                                {
                                    "Text": "Sub Inspector Technical",
                                    "Value": "Sub Inspector Technical"
                                },
                                {
                                    "Text": "Supplier Contractor",
                                    "Value": "Supplier Contractor"
                                },
                                {
                                    "Text": "Supervisor Cum Technician",
                                    "Value": "Supervisor Cum Technician"
                                },
                                {
                                    "Text": "Supply Clerk",
                                    "Value": "Supply Clerk"
                                },
                                {
                                    "Text": "Supply Inspector",
                                    "Value": "Supply Inspector"
                                },
                                {
                                    "Text": "Sub Registrar",
                                    "Value": "Sub Registrar"
                                },
                                {
                                    "Text": "Surgeon & Assitant Professor",
                                    "Value": "Surgeon & Assitant Professor"
                                },
                                {
                                    "Text": "Survey Assistant",
                                    "Value": "Survey Assistant"
                                },
                                {
                                    "Text": "Survey Engineer",
                                    "Value": "Survey Engineer"
                                },
                                {
                                    "Text": "Survey Officer",
                                    "Value": "Survey Officer"
                                },
                                {
                                    "Text": "Surveyor Grade I",
                                    "Value": "Surveyor Grade I"
                                },
                                {
                                    "Text": "Sub Officer",
                                    "Value": "Sub Officer"
                                },
                                {
                                    "Text": "Superintendent In Chief",
                                    "Value": "Superintendent In Chief"
                                },
                                {
                                    "Text": "Superintendent",
                                    "Value": "Superintendent"
                                },
                                {
                                    "Text": "Sub Divisional Officer",
                                    "Value": "Sub Divisional Officer"
                                },
                                {
                                    "Text": "Superintendent Of Taxes",
                                    "Value": "Superintendent Of Taxes"
                                },
                                {
                                    "Text": "Bag barrel filler",
                                    "Value": "Bag barrel filler"
                                },
                                {
                                    "Text": "Bag repairer",
                                    "Value": "Bag repairer"
                                },
                                {
                                    "Text": "Bag sewer",
                                    "Value": "Bag sewer"
                                },
                                {
                                    "Text": "Can filler",
                                    "Value": "Can filler"
                                },
                                {
                                    "Text": "Separator-man",
                                    "Value": "Separator-man"
                                },
                                {
                                    "Text": "Starch grinder",
                                    "Value": "Starch grinder"
                                },
                                {
                                    "Text": "Sugar grinder",
                                    "Value": "Sugar grinder"
                                },
                                {
                                    "Text": "Weigher",
                                    "Value": "Weigher"
                                },
                                {
                                    "Text": "Dumper",
                                    "Value": "Dumper"
                                },
                                {
                                    "Text": "Kiln-cleaner",
                                    "Value": "Kiln-cleaner"
                                },
                                {
                                    "Text": "Piler",
                                    "Value": "Piler"
                                },
                                {
                                    "Text": "Washer",
                                    "Value": "Washer"
                                },
                                {
                                    "Text": "Surgeon Opthalmology",
                                    "Value": "Surgeon Opthalmology"
                                },
                                {
                                    "Text": "Superintendent Engg. Mechanic",
                                    "Value": "Superintendent Engg. Mechanic"
                                },
                                {
                                    "Text": "Sub Engineer Civil",
                                    "Value": "Sub Engineer Civil"
                                },
                                {
                                    "Text": "Superintendent Data Processing",
                                    "Value": "Superintendent Data Processing"
                                },
                                {
                                    "Text": "Sub Accountant",
                                    "Value": "Sub Accountant"
                                },
                                {
                                    "Text": "Sub Editor",
                                    "Value": "Sub Editor"
                                },
                                {
                                    "Text": "Supplier",
                                    "Value": "Supplier"
                                },
                                {
                                    "Text": "Supervisor",
                                    "Value": "Supervisor"
                                },
                                {
                                    "Text": "Surgeon",
                                    "Value": "Surgeon"
                                },
                                {
                                    "Text": "Surveyor",
                                    "Value": "Surveyor"
                                },
                                {
                                    "Text": "Surveillance Executive",
                                    "Value": "Surveillance Executive"
                                },
                                {
                                    "Text": "Supervision Engineer",
                                    "Value": "Supervision Engineer"
                                },
                                {
                                    "Text": "Supplier Coordinator",
                                    "Value": "Supplier Coordinator"
                                },
                                {
                                    "Text": "Support Engineer",
                                    "Value": "Support Engineer"
                                },
                                {
                                    "Text": "SVP Audit & Risk Management",
                                    "Value": "SVP Audit & Risk Management"
                                },
                                {
                                    "Text": "SVP Bancassurance",
                                    "Value": "SVP Bancassurance"
                                },
                                {
                                    "Text": "SVP Agency",
                                    "Value": "SVP Agency"
                                },
                                {
                                    "Text": "SVP Operations",
                                    "Value": "SVP Operations"
                                },
                                {
                                    "Text": "SVP Strategy & Product",
                                    "Value": "SVP Strategy & Product"
                                },
                                {
                                    "Text": "SVP Underwriting claims and",
                                    "Value": "SVP Underwriting claims and"
                                },
                                {
                                    "Text": "Sweeper",
                                    "Value": "Sweeper"
                                },
                                {
                                    "Text": "Switch Engineer",
                                    "Value": "Switch Engineer"
                                },
                                {
                                    "Text": "Sewage work",
                                    "Value": "Sewage work"
                                },
                                {
                                    "Text": "System Operations Specialist",
                                    "Value": "System Operations Specialist"
                                },
                                {
                                    "Text": "Systems Officer",
                                    "Value": "Systems Officer"
                                },
                                {
                                    "Text": "Syrup Process Operator",
                                    "Value": "Syrup Process Operator"
                                },
                                {
                                    "Text": "Systems Specialist",
                                    "Value": "Systems Specialist"
                                },
                                {
                                    "Text": "Taluka Agriculture Officer",
                                    "Value": "Taluka Agriculture Officer"
                                },
                                {
                                    "Text": "Tax Collector",
                                    "Value": "Tax Collector"
                                },
                                {
                                    "Text": "Taxation Inspector",
                                    "Value": "Taxation Inspector"
                                },
                                {
                                    "Text": "Taxation Officer",
                                    "Value": "Taxation Officer"
                                },
                                {
                                    "Text": "Tahsildar",
                                    "Value": "Tahsildar"
                                },
                                {
                                    "Text": "Tax Practitioner",
                                    "Value": "Tax Practitioner"
                                },
                                {
                                    "Text": "Talathi",
                                    "Value": "Talathi"
                                },
                                {
                                    "Text": "Tax Inspector",
                                    "Value": "Tax Inspector"
                                },
                                {
                                    "Text": "Tailor Master",
                                    "Value": "Tailor Master"
                                },
                                {
                                    "Text": "Tax advisor",
                                    "Value": "Tax advisor"
                                },
                                {
                                    "Text": "Tally Clerk",
                                    "Value": "Tally Clerk"
                                },
                                {
                                    "Text": "Tax Analyst",
                                    "Value": "Tax Analyst"
                                },
                                {
                                    "Text": "Tower crane driver",
                                    "Value": "Tower crane driver"
                                },
                                {
                                    "Text": "Tele Caller",
                                    "Value": "Tele Caller"
                                },
                                {
                                    "Text": "Teacher & Junior Lecturer",
                                    "Value": "Teacher & Junior Lecturer"
                                },
                                {
                                    "Text": "Teacher & Lecturer",
                                    "Value": "Teacher & Lecturer"
                                },
                                {
                                    "Text": "Team Head",
                                    "Value": "Team Head"
                                },
                                {
                                    "Text": "Teacher Grade I",
                                    "Value": "Teacher Grade I"
                                },
                                {
                                    "Text": "Teacher Home Tuition",
                                    "Value": "Teacher Home Tuition"
                                },
                                {
                                    "Text": "Teaching Assistant",
                                    "Value": "Teaching Assistant"
                                },
                                {
                                    "Text": "Team Coach",
                                    "Value": "Team Coach"
                                },
                                {
                                    "Text": "Team Lead",
                                    "Value": "Team Lead"
                                },
                                {
                                    "Text": "Technical & Production Manager",
                                    "Value": "Technical & Production Manager"
                                },
                                {
                                    "Text": "Technical Acupuncture Assistnt",
                                    "Value": "Technical Acupuncture Assistnt"
                                },
                                {
                                    "Text": "Teacher & Principal",
                                    "Value": "Teacher & Principal"
                                },
                                {
                                    "Text": "Technical Analyst",
                                    "Value": "Technical Analyst"
                                },
                                {
                                    "Text": "Testing Technician",
                                    "Value": "Testing Technician"
                                },
                                {
                                    "Text": "Technical Consultant",
                                    "Value": "Technical Consultant"
                                },
                                {
                                    "Text": "Technical Consultant & Editor",
                                    "Value": "Technical Consultant & Editor"
                                },
                                {
                                    "Text": "Technical Director",
                                    "Value": "Technical Director"
                                },
                                {
                                    "Text": "Technical Engineer",
                                    "Value": "Technical Engineer"
                                },
                                {
                                    "Text": "Technical Expert",
                                    "Value": "Technical Expert"
                                },
                                {
                                    "Text": "Technical Head",
                                    "Value": "Technical Head"
                                },
                                {
                                    "Text": "Technical Investigator",
                                    "Value": "Technical Investigator"
                                },
                                {
                                    "Text": "Technical Lead",
                                    "Value": "Technical Lead"
                                },
                                {
                                    "Text": "Technical Leader",
                                    "Value": "Technical Leader"
                                },
                                {
                                    "Text": "Technical Manager",
                                    "Value": "Technical Manager"
                                },
                                {
                                    "Text": "Technical Officer",
                                    "Value": "Technical Officer"
                                },
                                {
                                    "Text": "Technical Production Manager",
                                    "Value": "Technical Production Manager"
                                },
                                {
                                    "Text": "Technical Publication Engineer",
                                    "Value": "Technical Publication Engineer"
                                },
                                {
                                    "Text": "Technical Recruiter",
                                    "Value": "Technical Recruiter"
                                },
                                {
                                    "Text": "Technical Representative",
                                    "Value": "Technical Representative"
                                },
                                {
                                    "Text": "Technical Sales Executive",
                                    "Value": "Technical Sales Executive"
                                },
                                {
                                    "Text": "Technical Sales Officer",
                                    "Value": "Technical Sales Officer"
                                },
                                {
                                    "Text": "Technical Serv. Representative",
                                    "Value": "Technical Serv. Representative"
                                },
                                {
                                    "Text": "Technical Solution Manager",
                                    "Value": "Technical Solution Manager"
                                },
                                {
                                    "Text": "Technical Specialist",
                                    "Value": "Technical Specialist"
                                },
                                {
                                    "Text": "Technical Superintendent",
                                    "Value": "Technical Superintendent"
                                },
                                {
                                    "Text": "Technical Supervisor",
                                    "Value": "Technical Supervisor"
                                },
                                {
                                    "Text": "Technical Support Analyst",
                                    "Value": "Technical Support Analyst"
                                },
                                {
                                    "Text": "Technical Support Associate",
                                    "Value": "Technical Support Associate"
                                },
                                {
                                    "Text": "Technical Support Executive",
                                    "Value": "Technical Support Executive"
                                },
                                {
                                    "Text": "Technical Support Expert",
                                    "Value": "Technical Support Expert"
                                },
                                {
                                    "Text": "Technical Support Officer",
                                    "Value": "Technical Support Officer"
                                },
                                {
                                    "Text": "Technical Supporter",
                                    "Value": "Technical Supporter"
                                },
                                {
                                    "Text": "Technical Telecom Assistant",
                                    "Value": "Technical Telecom Assistant"
                                },
                                {
                                    "Text": "Technical Writer",
                                    "Value": "Technical Writer"
                                },
                                {
                                    "Text": "Technician Cum Operator",
                                    "Value": "Technician Cum Operator"
                                },
                                {
                                    "Text": "Technician Electrical",
                                    "Value": "Technician Electrical"
                                },
                                {
                                    "Text": "Technician Electronics",
                                    "Value": "Technician Electronics"
                                },
                                {
                                    "Text": "Technician Fitter",
                                    "Value": "Technician Fitter"
                                },
                                {
                                    "Text": "Technician Grade I",
                                    "Value": "Technician Grade I"
                                },
                                {
                                    "Text": "Technician Grade III",
                                    "Value": "Technician Grade III"
                                },
                                {
                                    "Text": "Technical assistant",
                                    "Value": "Technical assistant"
                                },
                                {
                                    "Text": "Technician Welder",
                                    "Value": "Technician Welder"
                                },
                                {
                                    "Text": "Technical controller",
                                    "Value": "Technical controller"
                                },
                                {
                                    "Text": "Technology Specialist",
                                    "Value": "Technology Specialist"
                                },
                                {
                                    "Text": "Telecom Engineer",
                                    "Value": "Telecom Engineer"
                                },
                                {
                                    "Text": "Telecom Officer",
                                    "Value": "Telecom Officer"
                                },
                                {
                                    "Text": "Telegrapher & Messanger",
                                    "Value": "Telegrapher & Messanger"
                                },
                                {
                                    "Text": "Telephone Mechanic",
                                    "Value": "Telephone Mechanic"
                                },
                                {
                                    "Text": "Technologist",
                                    "Value": "Technologist"
                                },
                                {
                                    "Text": "Temple Priest",
                                    "Value": "Temple Priest"
                                },
                                {
                                    "Text": "Territory Business Executive",
                                    "Value": "Territory Business Executive"
                                },
                                {
                                    "Text": "Territory Manager Sales",
                                    "Value": "Territory Manager Sales"
                                },
                                {
                                    "Text": "Technical Assistnt Electronics",
                                    "Value": "Technical Assistnt Electronics"
                                },
                                {
                                    "Text": "Technical Architect",
                                    "Value": "Technical Architect"
                                },
                                {
                                    "Text": "Territory Sales Officer",
                                    "Value": "Territory Sales Officer"
                                },
                                {
                                    "Text": "Testing Engineer",
                                    "Value": "Testing Engineer"
                                },
                                {
                                    "Text": "Textile Testing Engineer",
                                    "Value": "Textile Testing Engineer"
                                },
                                {
                                    "Text": "Team Member",
                                    "Value": "Team Member"
                                },
                                {
                                    "Text": "Team Leader Sales",
                                    "Value": "Team Leader Sales"
                                },
                                {
                                    "Text": "Technical Staff",
                                    "Value": "Technical Staff"
                                },
                                {
                                    "Text": "Territory Incharge",
                                    "Value": "Territory Incharge"
                                },
                                {
                                    "Text": "Telecom Mechanic",
                                    "Value": "Telecom Mechanic"
                                },
                                {
                                    "Text": "Technician Grade II",
                                    "Value": "Technician Grade II"
                                },
                                {
                                    "Text": "Telecom",
                                    "Value": "Telecom"
                                },
                                {
                                    "Text": "Telephone Operator",
                                    "Value": "Telephone Operator"
                                },
                                {
                                    "Text": "Telex Operator",
                                    "Value": "Telex Operator"
                                },
                                {
                                    "Text": "Tele Marketing Executive",
                                    "Value": "Tele Marketing Executive"
                                },
                                {
                                    "Text": "Test engineer",
                                    "Value": "Test engineer"
                                },
                                {
                                    "Text": "Telecom Consultant",
                                    "Value": "Telecom Consultant"
                                },
                                {
                                    "Text": "Technical Mgr Software Develop",
                                    "Value": "Technical Mgr Software Develop"
                                },
                                {
                                    "Text": "Tele Supervisor",
                                    "Value": "Tele Supervisor"
                                },
                                {
                                    "Text": "Transporter",
                                    "Value": "Transporter"
                                },
                                {
                                    "Text": "Technician Laboratory",
                                    "Value": "Technician Laboratory"
                                },
                                {
                                    "Text": "Teacher Cum Headmistress",
                                    "Value": "Teacher Cum Headmistress"
                                },
                                {
                                    "Text": "Tester",
                                    "Value": "Tester"
                                },
                                {
                                    "Text": "Technical Associate",
                                    "Value": "Technical Associate"
                                },
                                {
                                    "Text": "Telephone Operator/Comp Opratr",
                                    "Value": "Telephone Operator/Comp Opratr"
                                },
                                {
                                    "Text": "Territory Accounts Executive",
                                    "Value": "Territory Accounts Executive"
                                },
                                {
                                    "Text": "Bleacher",
                                    "Value": "Bleacher"
                                },
                                {
                                    "Text": "Machine attendent",
                                    "Value": "Machine attendent"
                                },
                                {
                                    "Text": "Maintenance worker",
                                    "Value": "Maintenance worker"
                                },
                                {
                                    "Text": "Mender",
                                    "Value": "Mender"
                                },
                                {
                                    "Text": "Carding worker",
                                    "Value": "Carding worker"
                                },
                                {
                                    "Text": "Dryer",
                                    "Value": "Dryer"
                                },
                                {
                                    "Text": "Dye-mixer",
                                    "Value": "Dye-mixer"
                                },
                                {
                                    "Text": "Ironer",
                                    "Value": "Ironer"
                                },
                                {
                                    "Text": "Sewer",
                                    "Value": "Sewer"
                                },
                                {
                                    "Text": "Spinning worker",
                                    "Value": "Spinning worker"
                                },
                                {
                                    "Text": "Cloth worker",
                                    "Value": "Cloth worker"
                                },
                                {
                                    "Text": "Fabric worker",
                                    "Value": "Fabric worker"
                                },
                                {
                                    "Text": "Textile worker",
                                    "Value": "Textile worker"
                                },
                                {
                                    "Text": "Teacher & Tutor",
                                    "Value": "Teacher & Tutor"
                                },
                                {
                                    "Text": "Teacher Government",
                                    "Value": "Teacher Government"
                                },
                                {
                                    "Text": "Technical Advisor",
                                    "Value": "Technical Advisor"
                                },
                                {
                                    "Text": "Technical Assistant Manager",
                                    "Value": "Technical Assistant Manager"
                                },
                                {
                                    "Text": "Technician Supervision",
                                    "Value": "Technician Supervision"
                                },
                                {
                                    "Text": "Technology Officer",
                                    "Value": "Technology Officer"
                                },
                                {
                                    "Text": "Telegraph Supervisor",
                                    "Value": "Telegraph Supervisor"
                                },
                                {
                                    "Text": "Telephone Operator/Receptionst",
                                    "Value": "Telephone Operator/Receptionst"
                                },
                                {
                                    "Text": "Territory Sales Leader",
                                    "Value": "Territory Sales Leader"
                                },
                                {
                                    "Text": "Territory Sales Manager",
                                    "Value": "Territory Sales Manager"
                                },
                                {
                                    "Text": "Test Analyst",
                                    "Value": "Test Analyst"
                                },
                                {
                                    "Text": "Therapist",
                                    "Value": "Therapist"
                                },
                                {
                                    "Text": "Ticket Examiner",
                                    "Value": "Ticket Examiner"
                                },
                                {
                                    "Text": "Ticket Booking Officer",
                                    "Value": "Ticket Booking Officer"
                                },
                                {
                                    "Text": "Timberman",
                                    "Value": "Timberman"
                                },
                                {
                                    "Text": "Timber Merchant",
                                    "Value": "Timber Merchant"
                                },
                                {
                                    "Text": "Ticket Collector",
                                    "Value": "Ticket Collector"
                                },
                                {
                                    "Text": "Tools Engineer",
                                    "Value": "Tools Engineer"
                                },
                                {
                                    "Text": "Tour Planning Officer",
                                    "Value": "Tour Planning Officer"
                                },
                                {
                                    "Text": "Tourist Guide",
                                    "Value": "Tourist Guide"
                                },
                                {
                                    "Text": "Town Project Officer",
                                    "Value": "Town Project Officer"
                                },
                                {
                                    "Text": "Tours Consultant",
                                    "Value": "Tours Consultant"
                                },
                                {
                                    "Text": "Town Planning Supervisor",
                                    "Value": "Town Planning Supervisor"
                                },
                                {
                                    "Text": "Topman",
                                    "Value": "Topman"
                                },
                                {
                                    "Text": "Guide",
                                    "Value": "Guide"
                                },
                                {
                                    "Text": "Trainee pilot",
                                    "Value": "Trainee pilot"
                                },
                                {
                                    "Text": "Trade Manager",
                                    "Value": "Trade Manager"
                                },
                                {
                                    "Text": "Trader & Stock Broker",
                                    "Value": "Trader & Stock Broker"
                                },
                                {
                                    "Text": "Tradesman Technician",
                                    "Value": "Tradesman Technician"
                                },
                                {
                                    "Text": "Trading Merchant",
                                    "Value": "Trading Merchant"
                                },
                                {
                                    "Text": "Trainee Doctor",
                                    "Value": "Trainee Doctor"
                                },
                                {
                                    "Text": "Trainee Engineer",
                                    "Value": "Trainee Engineer"
                                },
                                {
                                    "Text": "Trainee Sales Representative",
                                    "Value": "Trainee Sales Representative"
                                },
                                {
                                    "Text": "Trainee Software Developer",
                                    "Value": "Trainee Software Developer"
                                },
                                {
                                    "Text": "Trainee Software Engineer",
                                    "Value": "Trainee Software Engineer"
                                },
                                {
                                    "Text": "Trainer Teacher",
                                    "Value": "Trainer Teacher"
                                },
                                {
                                    "Text": "Translator",
                                    "Value": "Translator"
                                },
                                {
                                    "Text": "Transaction Monitoring Officer",
                                    "Value": "Transaction Monitoring Officer"
                                },
                                {
                                    "Text": "Transmission Engineer",
                                    "Value": "Transmission Engineer"
                                },
                                {
                                    "Text": "Treasury Assistant",
                                    "Value": "Treasury Assistant"
                                },
                                {
                                    "Text": "Travel Counsellor",
                                    "Value": "Travel Counsellor"
                                },
                                {
                                    "Text": "Travel Executive",
                                    "Value": "Travel Executive"
                                },
                                {
                                    "Text": "Treasury Executive Officer",
                                    "Value": "Treasury Executive Officer"
                                },
                                {
                                    "Text": "Treasury Manager",
                                    "Value": "Treasury Manager"
                                },
                                {
                                    "Text": "Traffic Controller",
                                    "Value": "Traffic Controller"
                                },
                                {
                                    "Text": "Transport Contractor",
                                    "Value": "Transport Contractor"
                                },
                                {
                                    "Text": "Trip Organiser",
                                    "Value": "Trip Organiser"
                                },
                                {
                                    "Text": "Trainee Engg Ground Services",
                                    "Value": "Trainee Engg Ground Services"
                                },
                                {
                                    "Text": "Trainee Aircraft Maintnce Engg",
                                    "Value": "Trainee Aircraft Maintnce Engg"
                                },
                                {
                                    "Text": "training manager",
                                    "Value": "training manager"
                                },
                                {
                                    "Text": "Transmisioner",
                                    "Value": "Transmisioner"
                                },
                                {
                                    "Text": "Travel Cordinator",
                                    "Value": "Travel Cordinator"
                                },
                                {
                                    "Text": "Trainer",
                                    "Value": "Trainer"
                                },
                                {
                                    "Text": "Transmission Assistant",
                                    "Value": "Transmission Assistant"
                                },
                                {
                                    "Text": "Trade Coordinator",
                                    "Value": "Trade Coordinator"
                                },
                                {
                                    "Text": "Tribal Development Specialist",
                                    "Value": "Tribal Development Specialist"
                                },
                                {
                                    "Text": "Trait Development Executive",
                                    "Value": "Trait Development Executive"
                                },
                                {
                                    "Text": "Tradesman",
                                    "Value": "Tradesman"
                                },
                                {
                                    "Text": "Trading Manager",
                                    "Value": "Trading Manager"
                                },
                                {
                                    "Text": "Training Coordinator",
                                    "Value": "Training Coordinator"
                                },
                                {
                                    "Text": "Travel Agency Owner",
                                    "Value": "Travel Agency Owner"
                                },
                                {
                                    "Text": "Travelling Agent",
                                    "Value": "Travelling Agent"
                                },
                                {
                                    "Text": "Technical Support Advisor",
                                    "Value": "Technical Support Advisor"
                                },
                                {
                                    "Text": "Teaching Staff",
                                    "Value": "Teaching Staff"
                                },
                                {
                                    "Text": "Tuition Teacher & Tutor",
                                    "Value": "Tuition Teacher & Tutor"
                                },
                                {
                                    "Text": "Tuition teacher",
                                    "Value": "Tuition teacher"
                                },
                                {
                                    "Text": "Tunnel Worker",
                                    "Value": "Tunnel Worker"
                                },
                                {
                                    "Text": "Tv & Mobile Mechanic",
                                    "Value": "Tv & Mobile Mechanic"
                                },
                                {
                                    "Text": "Typist Cum Steno",
                                    "Value": "Typist Cum Steno"
                                },
                                {
                                    "Text": "Typist & Computer Operator",
                                    "Value": "Typist & Computer Operator"
                                },
                                {
                                    "Text": "Typist Cum Clerk",
                                    "Value": "Typist Cum Clerk"
                                },
                                {
                                    "Text": "UDC Clerk",
                                    "Value": "UDC Clerk"
                                },
                                {
                                    "Text": "Senior Technical Recruiter",
                                    "Value": "Senior Technical Recruiter"
                                },
                                {
                                    "Text": "Unit Sales Manager",
                                    "Value": "Unit Sales Manager"
                                },
                                {
                                    "Text": "Universal Banking Officer",
                                    "Value": "Universal Banking Officer"
                                },
                                {
                                    "Text": "University Professor",
                                    "Value": "University Professor"
                                },
                                {
                                    "Text": "Unix System Administrator",
                                    "Value": "Unix System Administrator"
                                },
                                {
                                    "Text": "Landlady",
                                    "Value": "Landlady"
                                },
                                {
                                    "Text": "Interest income",
                                    "Value": "Interest income"
                                },
                                {
                                    "Text": "Investor",
                                    "Value": "Investor"
                                },
                                {
                                    "Text": "Investment income",
                                    "Value": "Investment income"
                                },
                                {
                                    "Text": "Unemployed",
                                    "Value": "Unemployed"
                                },
                                {
                                    "Text": "Unit Manager",
                                    "Value": "Unit Manager"
                                },
                                {
                                    "Text": "Unit Head Collection",
                                    "Value": "Unit Head Collection"
                                },
                                {
                                    "Text": "Unit Supervisor",
                                    "Value": "Unit Supervisor"
                                },
                                {
                                    "Text": "Unskilled Workers",
                                    "Value": "Unskilled Workers"
                                },
                                {
                                    "Text": "Upper Primary School Assistant",
                                    "Value": "Upper Primary School Assistant"
                                },
                                {
                                    "Text": "Upper Division Teacher",
                                    "Value": "Upper Division Teacher"
                                },
                                {
                                    "Text": "Upper Division Assistant",
                                    "Value": "Upper Division Assistant"
                                },
                                {
                                    "Text": "Upper Divisional Clerk",
                                    "Value": "Upper Divisional Clerk"
                                },
                                {
                                    "Text": "Utility Engineer",
                                    "Value": "Utility Engineer"
                                },
                                {
                                    "Text": "Underwriting Assistant",
                                    "Value": "Underwriting Assistant"
                                },
                                {
                                    "Text": "Vaidya Ayurved",
                                    "Value": "Vaidya Ayurved"
                                },
                                {
                                    "Text": "Valuer",
                                    "Value": "Valuer"
                                },
                                {
                                    "Text": "Valveman",
                                    "Value": "Valveman"
                                },
                                {
                                    "Text": "Vaidya Ayurvedic Medicine",
                                    "Value": "Vaidya Ayurvedic Medicine"
                                },
                                {
                                    "Text": "varnisher",
                                    "Value": "varnisher"
                                },
                                {
                                    "Text": "Vaidya",
                                    "Value": "Vaidya"
                                },
                                {
                                    "Text": "Vegetable Seller",
                                    "Value": "Vegetable Seller"
                                },
                                {
                                    "Text": "Veterinary Compounder",
                                    "Value": "Veterinary Compounder"
                                },
                                {
                                    "Text": "Veterinary Doctor",
                                    "Value": "Veterinary Doctor"
                                },
                                {
                                    "Text": "Veterinary Officer",
                                    "Value": "Veterinary Officer"
                                },
                                {
                                    "Text": "Verification Officer",
                                    "Value": "Verification Officer"
                                },
                                {
                                    "Text": "Vegetable Trader",
                                    "Value": "Vegetable Trader"
                                },
                                {
                                    "Text": "Veterinary Line Stock Assistnt",
                                    "Value": "Veterinary Line Stock Assistnt"
                                },
                                {
                                    "Text": "Veterinary Assistant Surgeon",
                                    "Value": "Veterinary Assistant Surgeon"
                                },
                                {
                                    "Text": "Vendor Grocery",
                                    "Value": "Vendor Grocery"
                                },
                                {
                                    "Text": "Veterinary Pharmacist",
                                    "Value": "Veterinary Pharmacist"
                                },
                                {
                                    "Text": "Vet",
                                    "Value": "Vet"
                                },
                                {
                                    "Text": "Vice President Manufacturing",
                                    "Value": "Vice President Manufacturing"
                                },
                                {
                                    "Text": "Vice President Marketing",
                                    "Value": "Vice President Marketing"
                                },
                                {
                                    "Text": "Vice President Sales & Engg.",
                                    "Value": "Vice President Sales & Engg."
                                },
                                {
                                    "Text": "Village Assistant",
                                    "Value": "Village Assistant"
                                },
                                {
                                    "Text": "Vice President Technical",
                                    "Value": "Vice President Technical"
                                },
                                {
                                    "Text": "Vice Chairman",
                                    "Value": "Vice Chairman"
                                },
                                {
                                    "Text": "Vice President Finance",
                                    "Value": "Vice President Finance"
                                },
                                {
                                    "Text": "Videographer",
                                    "Value": "Videographer"
                                },
                                {
                                    "Text": "Village development officer",
                                    "Value": "Village development officer"
                                },
                                {
                                    "Text": "Vice President Sales",
                                    "Value": "Vice President Sales"
                                },
                                {
                                    "Text": "Vice President Group Marketing",
                                    "Value": "Vice President Group Marketing"
                                },
                                {
                                    "Text": "Vice President Operations",
                                    "Value": "Vice President Operations"
                                },
                                {
                                    "Text": "Vice President Buss Developmnt",
                                    "Value": "Vice President Buss Developmnt"
                                },
                                {
                                    "Text": "Violinist",
                                    "Value": "Violinist"
                                },
                                {
                                    "Text": "Vice President Production",
                                    "Value": "Vice President Production"
                                },
                                {
                                    "Text": "Video Technical Operator",
                                    "Value": "Video Technical Operator"
                                },
                                {
                                    "Text": "Village Panchayat Secretary",
                                    "Value": "Village Panchayat Secretary"
                                },
                                {
                                    "Text": "Visual Database Developer",
                                    "Value": "Visual Database Developer"
                                },
                                {
                                    "Text": "Vice President Exports",
                                    "Value": "Vice President Exports"
                                },
                                {
                                    "Text": "Visiting Faculty",
                                    "Value": "Visiting Faculty"
                                },
                                {
                                    "Text": "Visa Executive",
                                    "Value": "Visa Executive"
                                },
                                {
                                    "Text": "Voice Support Officer",
                                    "Value": "Voice Support Officer"
                                },
                                {
                                    "Text": "Voice Trainer",
                                    "Value": "Voice Trainer"
                                },
                                {
                                    "Text": "Vocational Trainer",
                                    "Value": "Vocational Trainer"
                                },
                                {
                                    "Text": "VP Marketing",
                                    "Value": "VP Marketing"
                                },
                                {
                                    "Text": "VP Strategic Planning",
                                    "Value": "VP Strategic Planning"
                                },
                                {
                                    "Text": "VP Administration",
                                    "Value": "VP Administration"
                                },
                                {
                                    "Text": "VP Agency",
                                    "Value": "VP Agency"
                                },
                                {
                                    "Text": "VP Audit and Risk Management",
                                    "Value": "VP Audit and Risk Management"
                                },
                                {
                                    "Text": "VP Business Leader",
                                    "Value": "VP Business Leader"
                                },
                                {
                                    "Text": "VP Bancassurance",
                                    "Value": "VP Bancassurance"
                                },
                                {
                                    "Text": "VP Branch Operations",
                                    "Value": "VP Branch Operations"
                                },
                                {
                                    "Text": "VP Business Planning",
                                    "Value": "VP Business Planning"
                                },
                                {
                                    "Text": "VP Business & Service",
                                    "Value": "VP Business & Service"
                                },
                                {
                                    "Text": "VP Business Systems and",
                                    "Value": "VP Business Systems and"
                                },
                                {
                                    "Text": "VP Customer Service",
                                    "Value": "VP Customer Service"
                                },
                                {
                                    "Text": "VP DPPM",
                                    "Value": "VP DPPM"
                                },
                                {
                                    "Text": "VP Direct Sales",
                                    "Value": "VP Direct Sales"
                                },
                                {
                                    "Text": "VP Operations (FRM)",
                                    "Value": "VP Operations (FRM)"
                                },
                                {
                                    "Text": "VP Group Sales",
                                    "Value": "VP Group Sales"
                                },
                                {
                                    "Text": "VP Health Insurance",
                                    "Value": "VP Health Insurance"
                                },
                                {
                                    "Text": "VP Human Resources",
                                    "Value": "VP Human Resources"
                                },
                                {
                                    "Text": "VP International Business",
                                    "Value": "VP International Business"
                                },
                                {
                                    "Text": "VP Life & Health Claims",
                                    "Value": "VP Life & Health Claims"
                                },
                                {
                                    "Text": "VP Operations",
                                    "Value": "VP Operations"
                                },
                                {
                                    "Text": "VP Finance & Administration",
                                    "Value": "VP Finance & Administration"
                                },
                                {
                                    "Text": "VP Procurement",
                                    "Value": "VP Procurement"
                                },
                                {
                                    "Text": "VP Strategy & Product",
                                    "Value": "VP Strategy & Product"
                                },
                                {
                                    "Text": "VP Taxation",
                                    "Value": "VP Taxation"
                                },
                                {
                                    "Text": "VSNL Officer",
                                    "Value": "VSNL Officer"
                                },
                                {
                                    "Text": "VSNL Operator",
                                    "Value": "VSNL Operator"
                                },
                                {
                                    "Text": "Ware House Manager",
                                    "Value": "Ware House Manager"
                                },
                                {
                                    "Text": "Water Work Inspector",
                                    "Value": "Water Work Inspector"
                                },
                                {
                                    "Text": "Wood Cutter",
                                    "Value": "Wood Cutter"
                                },
                                {
                                    "Text": "Web Developer",
                                    "Value": "Web Developer"
                                },
                                {
                                    "Text": "Web Research Executive",
                                    "Value": "Web Research Executive"
                                },
                                {
                                    "Text": "Webshop Member",
                                    "Value": "Webshop Member"
                                },
                                {
                                    "Text": "Welfare Officers Lecturer",
                                    "Value": "Welfare Officers Lecturer"
                                },
                                {
                                    "Text": "Welfare Extension Officer",
                                    "Value": "Welfare Extension Officer"
                                },
                                {
                                    "Text": "Welder Machine Opeartor",
                                    "Value": "Welder Machine Opeartor"
                                },
                                {
                                    "Text": "Welfare service",
                                    "Value": "Welfare service"
                                },
                                {
                                    "Text": "Web Security Analyst",
                                    "Value": "Web Security Analyst"
                                },
                                {
                                    "Text": "Welfare Executive",
                                    "Value": "Welfare Executive"
                                },
                                {
                                    "Text": "Working at heights > 20 ft",
                                    "Value": "Working at heights > 20 ft"
                                },
                                {
                                    "Text": "Warehouseman",
                                    "Value": "Warehouseman"
                                },
                                {
                                    "Text": "Winchman",
                                    "Value": "Winchman"
                                },
                                {
                                    "Text": "Wireless Operator",
                                    "Value": "Wireless Operator"
                                },
                                {
                                    "Text": "Work Shop Controller",
                                    "Value": "Work Shop Controller"
                                },
                                {
                                    "Text": "Work Shop Manager",
                                    "Value": "Work Shop Manager"
                                },
                                {
                                    "Text": "Works Engineer",
                                    "Value": "Works Engineer"
                                },
                                {
                                    "Text": "Works Supervisor Incharge",
                                    "Value": "Works Supervisor Incharge"
                                },
                                {
                                    "Text": "Works Supervisor",
                                    "Value": "Works Supervisor"
                                },
                                {
                                    "Text": "Works manager",
                                    "Value": "Works manager"
                                },
                                {
                                    "Text": "Work Flow Management",
                                    "Value": "Work Flow Management"
                                },
                                {
                                    "Text": "Worker",
                                    "Value": "Worker"
                                },
                                {
                                    "Text": "Writer & Director",
                                    "Value": "Writer & Director"
                                },
                                {
                                    "Text": "X-Ray Technician",
                                    "Value": "X-Ray Technician"
                                },
                                {
                                    "Text": "Yoga Coach",
                                    "Value": "Yoga Coach"
                                },
                                {
                                    "Text": "Yoga Master",
                                    "Value": "Yoga Master"
                                },
                                {
                                    "Text": "Zamindar",
                                    "Value": "Zamindar"
                                },
                                {
                                    "Text": "Zonal Accounts Manager",
                                    "Value": "Zonal Accounts Manager"
                                },
                                {
                                    "Text": "Zonal Business Head",
                                    "Value": "Zonal Business Head"
                                },
                                {
                                    "Text": "Zonal Business Manager",
                                    "Value": "Zonal Business Manager"
                                },
                                {
                                    "Text": "Zonal Controller",
                                    "Value": "Zonal Controller"
                                },
                                {
                                    "Text": "Zonal Head",
                                    "Value": "Zonal Head"
                                },
                                {
                                    "Text": "Zonal Officer",
                                    "Value": "Zonal Officer"
                                },
                                {
                                    "Text": "Zonal Sales Manager",
                                    "Value": "Zonal Sales Manager"
                                },
                                {
                                    "Text": "Zonal Coordinator",
                                    "Value": "Zonal Coordinator"
                                },
                                {
                                    "Text": "Zonal Executive",
                                    "Value": "Zonal Executive"
                                },
                                {
                                    "Text": "Zonal Manager",
                                    "Value": "Zonal Manager"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='student'",
                            "validation": ""
                        },
                        "annualIncome": {
                            "id": "1270",
                            "label": "Annual Income",
                            "name": "annualIncome",
                            "description": "Annual Income",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['annualIncome']['input'] = ''+quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['annualIncome']\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['annualIncome']['mandatory'] = 2\r\n}\r\nelse if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self'){\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['annualIncome']['mandatory'] = 1\r\n}",
                            "min": 1,
                            "max": 20,
                            "pattern": "/^[0-9]{1,20}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='housewife' && formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='student' && formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='Unemployed'",
                            "validation": ""
                        },
                        "nameOfOrganisation": {
                            "id": "1271",
                            "label": "Name Of Organisation",
                            "name": "nameOfOrganisation",
                            "description": "Enter Name of Organization ",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "3 M GULF LTD",
                                    "Value": "3 M GULF LTD"
                                },
                                {
                                    "Text": "3M India Ltd",
                                    "Value": "3M India Ltd"
                                },
                                {
                                    "Text": "A and A Dukaan Financial services Pvt Ltd",
                                    "Value": "A and A Dukaan Financial services Pvt Ltd"
                                },
                                {
                                    "Text": "A2ZMES  A2X Maitainence and engineering services  ",
                                    "Value": "A2ZMES  A2X Maitainence and engineering services  "
                                },
                                {
                                    "Text": "Aarti Industries Ltd",
                                    "Value": "Aarti Industries Ltd"
                                },
                                {
                                    "Text": "Aban Offshore Ltd",
                                    "Value": "Aban Offshore Ltd"
                                },
                                {
                                    "Text": "Abbott India Ltd",
                                    "Value": "Abbott India Ltd"
                                },
                                {
                                    "Text": "Abu Dhabi Investment Authority",
                                    "Value": "Abu Dhabi Investment Authority"
                                },
                                {
                                    "Text": "Abu Dhabi Islamic Bank",
                                    "Value": "Abu Dhabi Islamic Bank"
                                },
                                {
                                    "Text": "ACC Ltd",
                                    "Value": "ACC Ltd"
                                },
                                {
                                    "Text": "ACER INDIA ",
                                    "Value": "ACER INDIA "
                                },
                                {
                                    "Text": "ACKRUTI",
                                    "Value": "ACKRUTI"
                                },
                                {
                                    "Text": "ADANI AGRO LOGISTICS",
                                    "Value": "ADANI AGRO LOGISTICS"
                                },
                                {
                                    "Text": "Adani Gas Ltd",
                                    "Value": "Adani Gas Ltd"
                                },
                                {
                                    "Text": "Adani Green Energy Ltd",
                                    "Value": "Adani Green Energy Ltd"
                                },
                                {
                                    "Text": "ADANI MINING",
                                    "Value": "ADANI MINING"
                                },
                                {
                                    "Text": "Adani Ports and Special Economic Zone Ltd",
                                    "Value": "Adani Ports and Special Economic Zone Ltd"
                                },
                                {
                                    "Text": "ADANI REALTY",
                                    "Value": "ADANI REALTY"
                                },
                                {
                                    "Text": "Adani Transmission Ltd",
                                    "Value": "Adani Transmission Ltd"
                                },
                                {
                                    "Text": "ADANI WILMAR",
                                    "Value": "ADANI WILMAR"
                                },
                                {
                                    "Text": "Adhunik Metaliks Ltd",
                                    "Value": "Adhunik Metaliks Ltd"
                                },
                                {
                                    "Text": "Aditya Birla Capital Ltd",
                                    "Value": "Aditya Birla Capital Ltd"
                                },
                                {
                                    "Text": "ADITYA BIRLA CHEMICALS  THAILAND  Ltd",
                                    "Value": "ADITYA BIRLA CHEMICALS  THAILAND  Ltd"
                                },
                                {
                                    "Text": "ADITYA BIRLA FINANCE Ltd",
                                    "Value": "ADITYA BIRLA FINANCE Ltd"
                                },
                                {
                                    "Text": "Aditya Birla Health Insurance",
                                    "Value": "Aditya Birla Health Insurance"
                                },
                                {
                                    "Text": "ADITYA BIRLA MINERALS",
                                    "Value": "ADITYA BIRLA MINERALS"
                                },
                                {
                                    "Text": "Aditya Birla Nuvo Ltd",
                                    "Value": "Aditya Birla Nuvo Ltd"
                                },
                                {
                                    "Text": "ADITYA BIRLA RETAIL",
                                    "Value": "ADITYA BIRLA RETAIL"
                                },
                                {
                                    "Text": "Aditya Birla Sun Life Insurance Co Ltd",
                                    "Value": "Aditya Birla Sun Life Insurance Co Ltd"
                                },
                                {
                                    "Text": "ADNOC   Abu Dhabhi National Oil Company  ",
                                    "Value": "ADNOC   Abu Dhabhi National Oil Company  "
                                },
                                {
                                    "Text": "Advanced Enzyme Technologies Ltd",
                                    "Value": "Advanced Enzyme Technologies Ltd"
                                },
                                {
                                    "Text": "Aegis Logistics Ltd",
                                    "Value": "Aegis Logistics Ltd"
                                },
                                {
                                    "Text": "AFCONS INFRASTRUCTURE ",
                                    "Value": "AFCONS INFRASTRUCTURE "
                                },
                                {
                                    "Text": "Agriculture Insurance Company of India",
                                    "Value": "Agriculture Insurance Company of India"
                                },
                                {
                                    "Text": "Ahluwalia Contracts  India  Ltd",
                                    "Value": "Ahluwalia Contracts  India  Ltd"
                                },
                                {
                                    "Text": "AIRCEL GROUP ",
                                    "Value": "AIRCEL GROUP "
                                },
                                {
                                    "Text": "AIRTEL JERSEY AND GUERNSEY",
                                    "Value": "AIRTEL JERSEY AND GUERNSEY"
                                },
                                {
                                    "Text": "Ajanta Pharma Ltd",
                                    "Value": "Ajanta Pharma Ltd"
                                },
                                {
                                    "Text": "AL ABBAS GROUP",
                                    "Value": "AL ABBAS GROUP"
                                },
                                {
                                    "Text": "Al Aberah Electrical  and  Mechanical Works",
                                    "Value": "Al Aberah Electrical  and  Mechanical Works"
                                },
                                {
                                    "Text": "Al Futtaim Engineering Organisation",
                                    "Value": "Al Futtaim Engineering Organisation"
                                },
                                {
                                    "Text": "Al Janahi  Group",
                                    "Value": "Al Janahi  Group"
                                },
                                {
                                    "Text": "AL NABOODAH Grorp",
                                    "Value": "AL NABOODAH Grorp"
                                },
                                {
                                    "Text": "AL RAFA HOSPITAL",
                                    "Value": "AL RAFA HOSPITAL"
                                },
                                {
                                    "Text": "AL TAYER GROUP",
                                    "Value": "AL TAYER GROUP"
                                },
                                {
                                    "Text": "ALBONAIR GMBH GERMANY",
                                    "Value": "ALBONAIR GMBH GERMANY"
                                },
                                {
                                    "Text": "ALEXANDRIA CARBON BLACK COMPANY SAE",
                                    "Value": "ALEXANDRIA CARBON BLACK COMPANY SAE"
                                },
                                {
                                    "Text": "ALFA LAVAL",
                                    "Value": "ALFA LAVAL"
                                },
                                {
                                    "Text": "Alkyl Amines Chemicals Ltd",
                                    "Value": "Alkyl Amines Chemicals Ltd"
                                },
                                {
                                    "Text": "ALLANASONS  PVT LTD",
                                    "Value": "ALLANASONS  PVT LTD"
                                },
                                {
                                    "Text": "Allcargo Logistics Ltd",
                                    "Value": "Allcargo Logistics Ltd"
                                },
                                {
                                    "Text": "ALLIED DIGITAL",
                                    "Value": "ALLIED DIGITAL"
                                },
                                {
                                    "Text": "ALSTOM India Ltd",
                                    "Value": "ALSTOM India Ltd"
                                },
                                {
                                    "Text": "Alstom T and D India Ltd",
                                    "Value": "Alstom T and D India Ltd"
                                },
                                {
                                    "Text": "AMAZON",
                                    "Value": "AMAZON"
                                },
                                {
                                    "Text": "Ambuja Cements Ltd",
                                    "Value": "Ambuja Cements Ltd"
                                },
                                {
                                    "Text": "AMIRA PURE FOODS ",
                                    "Value": "AMIRA PURE FOODS "
                                },
                                {
                                    "Text": "Amtek Auto Ltd",
                                    "Value": "Amtek Auto Ltd"
                                },
                                {
                                    "Text": "Amul India",
                                    "Value": "Amul India"
                                },
                                {
                                    "Text": "Anand Rathi Capital Advisors Private Ltd",
                                    "Value": "Anand Rathi Capital Advisors Private Ltd"
                                },
                                {
                                    "Text": "Anand Rathi Financial Services Ltd",
                                    "Value": "Anand Rathi Financial Services Ltd"
                                },
                                {
                                    "Text": "Anand Rathi Insurance Brokers Ltd",
                                    "Value": "Anand Rathi Insurance Brokers Ltd"
                                },
                                {
                                    "Text": "Anand Rathi Share and Stock Brokers Ltd ",
                                    "Value": "Anand Rathi Share and Stock Brokers Ltd "
                                },
                                {
                                    "Text": "ANAND RATHI WEALTH SERVICES Ltd",
                                    "Value": "ANAND RATHI WEALTH SERVICES Ltd"
                                },
                                {
                                    "Text": "ANANT RAJ Ltd",
                                    "Value": "ANANT RAJ Ltd"
                                },
                                {
                                    "Text": "Angel Broking Pvt Ltd",
                                    "Value": "Angel Broking Pvt Ltd"
                                },
                                {
                                    "Text": "ANI Technologies  OLA Cabs ",
                                    "Value": "ANI Technologies  OLA Cabs "
                                },
                                {
                                    "Text": "ANSAL INFRAS",
                                    "Value": "ANSAL INFRAS"
                                },
                                {
                                    "Text": "APL Apollo Tubes Ltd",
                                    "Value": "APL Apollo Tubes Ltd"
                                },
                                {
                                    "Text": "Apollo Munich Health Insurance",
                                    "Value": "Apollo Munich Health Insurance"
                                },
                                {
                                    "Text": "APTECH LTD",
                                    "Value": "APTECH LTD"
                                },
                                {
                                    "Text": "AR Trustee Company Pvt Ltd",
                                    "Value": "AR Trustee Company Pvt Ltd"
                                },
                                {
                                    "Text": "AREVA",
                                    "Value": "AREVA"
                                },
                                {
                                    "Text": "Ariba Technologies India Pvt Ltd",
                                    "Value": "Ariba Technologies India Pvt Ltd"
                                },
                                {
                                    "Text": "ARSS INFRA",
                                    "Value": "ARSS INFRA"
                                },
                                {
                                    "Text": "Arvind Ltd",
                                    "Value": "Arvind Ltd"
                                },
                                {
                                    "Text": "Ashok Leyland Ltd",
                                    "Value": "Ashok Leyland Ltd"
                                },
                                {
                                    "Text": "Ashoka Buildcon Ltd",
                                    "Value": "Ashoka Buildcon Ltd"
                                },
                                {
                                    "Text": "Asian Paints Ltd",
                                    "Value": "Asian Paints Ltd"
                                },
                                {
                                    "Text": "ASSAMCO",
                                    "Value": "ASSAMCO"
                                },
                                {
                                    "Text": "Aster DM Healthcare Ltd",
                                    "Value": "Aster DM Healthcare Ltd"
                                },
                                {
                                    "Text": "Astra Zeneca India  P  Ltd",
                                    "Value": "Astra Zeneca India  P  Ltd"
                                },
                                {
                                    "Text": "Astral Poly Technik Ltd",
                                    "Value": "Astral Poly Technik Ltd"
                                },
                                {
                                    "Text": "ATLAS COPCO  INDIA  ",
                                    "Value": "ATLAS COPCO  INDIA  "
                                },
                                {
                                    "Text": "Au Insurance Broking Services Pvt Ltd",
                                    "Value": "Au Insurance Broking Services Pvt Ltd"
                                },
                                {
                                    "Text": "Aurobindo Pharma Ltd",
                                    "Value": "Aurobindo Pharma Ltd"
                                },
                                {
                                    "Text": "Avanti Feeds Ltd",
                                    "Value": "Avanti Feeds Ltd"
                                },
                                {
                                    "Text": "Avenue Supermarts Ltd",
                                    "Value": "Avenue Supermarts Ltd"
                                },
                                {
                                    "Text": "AXA France Vie   India Reinsurance Branch",
                                    "Value": "AXA France Vie   India Reinsurance Branch"
                                },
                                {
                                    "Text": "Axles India Ltd",
                                    "Value": "Axles India Ltd"
                                },
                                {
                                    "Text": "BACHHRAJ  and  COMPANY PVT LTD",
                                    "Value": "BACHHRAJ  and  COMPANY PVT LTD"
                                },
                                {
                                    "Text": "Badur Travels",
                                    "Value": "Badur Travels"
                                },
                                {
                                    "Text": "BAJAJ ALLIANZ GENERAL INSURANCE COMPANY LTD",
                                    "Value": "BAJAJ ALLIANZ GENERAL INSURANCE COMPANY LTD"
                                },
                                {
                                    "Text": "BAJAJ AUTO FINANCE LTD",
                                    "Value": "BAJAJ AUTO FINANCE LTD"
                                },
                                {
                                    "Text": "Bajaj Auto Ltd",
                                    "Value": "Bajaj Auto Ltd"
                                },
                                {
                                    "Text": "Bajaj Capital Insurance Broking Ltd",
                                    "Value": "Bajaj Capital Insurance Broking Ltd"
                                },
                                {
                                    "Text": "Bajaj capital ltd",
                                    "Value": "Bajaj capital ltd"
                                },
                                {
                                    "Text": "Bajaj Corp Ltd",
                                    "Value": "Bajaj Corp Ltd"
                                },
                                {
                                    "Text": "Bajaj Finance Ltd",
                                    "Value": "Bajaj Finance Ltd"
                                },
                                {
                                    "Text": "Bajaj Finserv Ltd",
                                    "Value": "Bajaj Finserv Ltd"
                                },
                                {
                                    "Text": "Bajaj Hindustan Ltd",
                                    "Value": "Bajaj Hindustan Ltd"
                                },
                                {
                                    "Text": "Bajaj Holdings and Investment Ltd",
                                    "Value": "Bajaj Holdings and Investment Ltd"
                                },
                                {
                                    "Text": "BAJAJ SEVASHRAM PVT LTD",
                                    "Value": "BAJAJ SEVASHRAM PVT LTD"
                                },
                                {
                                    "Text": "Balkrishna Industries Ltd",
                                    "Value": "Balkrishna Industries Ltd"
                                },
                                {
                                    "Text": "Balrampur Chini Mills Ltd",
                                    "Value": "Balrampur Chini Mills Ltd"
                                },
                                {
                                    "Text": "BANGALORE ELECTRICITY SUPPLY CO ",
                                    "Value": "BANGALORE ELECTRICITY SUPPLY CO "
                                },
                                {
                                    "Text": "Bank of America",
                                    "Value": "Bank of America"
                                },
                                {
                                    "Text": "Bank of India",
                                    "Value": "Bank of India"
                                },
                                {
                                    "Text": "Banswara Syntex Ltd",
                                    "Value": "Banswara Syntex Ltd"
                                },
                                {
                                    "Text": "Barjeel Geojit Securities  LLC Dubai",
                                    "Value": "Barjeel Geojit Securities  LLC Dubai"
                                },
                                {
                                    "Text": "BARTRONICS INDIA LTD",
                                    "Value": "BARTRONICS INDIA LTD"
                                },
                                {
                                    "Text": "Bata India Ltd",
                                    "Value": "Bata India Ltd"
                                },
                                {
                                    "Text": "BBK Geojit Securities KSC",
                                    "Value": "BBK Geojit Securities KSC"
                                },
                                {
                                    "Text": "BELHASA PROJECTS",
                                    "Value": "BELHASA PROJECTS"
                                },
                                {
                                    "Text": "Bengal  and  Assam Company Ltd",
                                    "Value": "Bengal  and  Assam Company Ltd"
                                },
                                {
                                    "Text": "Berger Paints India Ltd",
                                    "Value": "Berger Paints India Ltd"
                                },
                                {
                                    "Text": "BF Utilities Ltd",
                                    "Value": "BF Utilities Ltd"
                                },
                                {
                                    "Text": "BHARAT BIJLI",
                                    "Value": "BHARAT BIJLI"
                                },
                                {
                                    "Text": "Bharat Electronics Ltd",
                                    "Value": "Bharat Electronics Ltd"
                                },
                                {
                                    "Text": "Bharat Forge Ltd",
                                    "Value": "Bharat Forge Ltd"
                                },
                                {
                                    "Text": "Bharat Petroleum Corporation Ltd",
                                    "Value": "Bharat Petroleum Corporation Ltd"
                                },
                                {
                                    "Text": "BHARATI SHIP",
                                    "Value": "BHARATI SHIP"
                                },
                                {
                                    "Text": "Bharti  SBM  Resources Pvt Ltd",
                                    "Value": "Bharti  SBM  Resources Pvt Ltd"
                                },
                                {
                                    "Text": "Bharti Airtel Ltd",
                                    "Value": "Bharti Airtel Ltd"
                                },
                                {
                                    "Text": "Bharti AXA Life Insurance Co Ltd",
                                    "Value": "Bharti AXA Life Insurance Co Ltd"
                                },
                                {
                                    "Text": "Bharti Infratel Ltd",
                                    "Value": "Bharti Infratel Ltd"
                                },
                                {
                                    "Text": "Bharti Realty Pvt Ltd",
                                    "Value": "Bharti Realty Pvt Ltd"
                                },
                                {
                                    "Text": "Bharti Telecom Ltd",
                                    "Value": "Bharti Telecom Ltd"
                                },
                                {
                                    "Text": "BHUSHAN POWER  and  STEEL ",
                                    "Value": "BHUSHAN POWER  and  STEEL "
                                },
                                {
                                    "Text": "Big Basket",
                                    "Value": "Big Basket"
                                },
                                {
                                    "Text": "BINANI CEMENT ",
                                    "Value": "BINANI CEMENT "
                                },
                                {
                                    "Text": "Biocon Ltd",
                                    "Value": "Biocon Ltd"
                                },
                                {
                                    "Text": "BIRLA JINGWEI FIBRES COMPANY Ltd",
                                    "Value": "BIRLA JINGWEI FIBRES COMPANY Ltd"
                                },
                                {
                                    "Text": "BIRLA SUN LIFE ASSET MANAGEMENT COMPANY LTD",
                                    "Value": "BIRLA SUN LIFE ASSET MANAGEMENT COMPANY LTD"
                                },
                                {
                                    "Text": "Birlasoft Ltd",
                                    "Value": "Birlasoft Ltd"
                                },
                                {
                                    "Text": "Bliss GVS Pharma Ltd",
                                    "Value": "Bliss GVS Pharma Ltd"
                                },
                                {
                                    "Text": "Blue Star Ltd",
                                    "Value": "Blue Star Ltd"
                                },
                                {
                                    "Text": "Bluechip Insurance Broking Private Ltd",
                                    "Value": "Bluechip Insurance Broking Private Ltd"
                                },
                                {
                                    "Text": "BNP PARIBAS",
                                    "Value": "BNP PARIBAS"
                                },
                                {
                                    "Text": "Bodal Chemicals Ltd",
                                    "Value": "Bodal Chemicals Ltd"
                                },
                                {
                                    "Text": "Bombay Dyeing and Manufacturing Company Ltd",
                                    "Value": "Bombay Dyeing and Manufacturing Company Ltd"
                                },
                                {
                                    "Text": "BOMBAY REALTY",
                                    "Value": "BOMBAY REALTY"
                                },
                                {
                                    "Text": "BOSTON CONSULTANCY GROUP",
                                    "Value": "BOSTON CONSULTANCY GROUP"
                                },
                                {
                                    "Text": "BPL_PRM_NM",
                                    "Value": "BPL_PRM_NM"
                                },
                                {
                                    "Text": "BRIDGESTONE INDIA ",
                                    "Value": "BRIDGESTONE INDIA "
                                },
                                {
                                    "Text": "Brigade Enterprises Ltd",
                                    "Value": "Brigade Enterprises Ltd"
                                },
                                {
                                    "Text": "Britannia Industries Ltd",
                                    "Value": "Britannia Industries Ltd"
                                },
                                {
                                    "Text": "BS Ltd",
                                    "Value": "BS Ltd"
                                },
                                {
                                    "Text": "BUNGE INDIA Ltd",
                                    "Value": "BUNGE INDIA Ltd"
                                },
                                {
                                    "Text": "BYJUs  The Learning App ",
                                    "Value": "BYJUs  The Learning App "
                                },
                                {
                                    "Text": "Cadila Healthcare Ltd",
                                    "Value": "Cadila Healthcare Ltd"
                                },
                                {
                                    "Text": "Can Fin Homes Ltd",
                                    "Value": "Can Fin Homes Ltd"
                                },
                                {
                                    "Text": "CANARA HSBC ORIENTAL BANK OF COMMERCE LIFE INSURANCE CO LTD",
                                    "Value": "CANARA HSBC ORIENTAL BANK OF COMMERCE LIFE INSURANCE CO LTD"
                                },
                                {
                                    "Text": "Capgemini",
                                    "Value": "Capgemini"
                                },
                                {
                                    "Text": "Capital First Ltd",
                                    "Value": "Capital First Ltd"
                                },
                                {
                                    "Text": "Caplin Point Laboratories Ltd",
                                    "Value": "Caplin Point Laboratories Ltd"
                                },
                                {
                                    "Text": "Carborundum Universal Ltd",
                                    "Value": "Carborundum Universal Ltd"
                                },
                                {
                                    "Text": "CARGILL INDIA PRIVATE ",
                                    "Value": "CARGILL INDIA PRIVATE "
                                },
                                {
                                    "Text": "Casa Decor",
                                    "Value": "Casa Decor"
                                },
                                {
                                    "Text": "CATERPILLAR INDIA ",
                                    "Value": "CATERPILLAR INDIA "
                                },
                                {
                                    "Text": "CCL Products  India  Ltd",
                                    "Value": "CCL Products  India  Ltd"
                                },
                                {
                                    "Text": "CELEBRATIONS APPAREL LTD ",
                                    "Value": "CELEBRATIONS APPAREL LTD "
                                },
                                {
                                    "Text": "Central Depository Services  India  Ltd",
                                    "Value": "Central Depository Services  India  Ltd"
                                },
                                {
                                    "Text": "CENTUM LEARNING",
                                    "Value": "CENTUM LEARNING"
                                },
                                {
                                    "Text": "Century Plyboards India Ltd",
                                    "Value": "Century Plyboards India Ltd"
                                },
                                {
                                    "Text": "Cera Sanitaryware Ltd",
                                    "Value": "Cera Sanitaryware Ltd"
                                },
                                {
                                    "Text": "CESC Ventures Ltd",
                                    "Value": "CESC Ventures Ltd"
                                },
                                {
                                    "Text": "Chalet Hotels Ltd",
                                    "Value": "Chalet Hotels Ltd"
                                },
                                {
                                    "Text": "Chennai Petroleum Corporation Ltd",
                                    "Value": "Chennai Petroleum Corporation Ltd"
                                },
                                {
                                    "Text": "China National Petrolium Corporation",
                                    "Value": "China National Petrolium Corporation"
                                },
                                {
                                    "Text": "Cholamandalam Investment and Finance Company Ltd",
                                    "Value": "Cholamandalam Investment and Finance Company Ltd"
                                },
                                {
                                    "Text": "CIGNA TTK",
                                    "Value": "CIGNA TTK"
                                },
                                {
                                    "Text": "CITI BANK",
                                    "Value": "CITI BANK"
                                },
                                {
                                    "Text": "CITI BANK INDIA",
                                    "Value": "CITI BANK INDIA"
                                },
                                {
                                    "Text": "City Union Bank Ltd",
                                    "Value": "City Union Bank Ltd"
                                },
                                {
                                    "Text": "CMC Ltd",
                                    "Value": "CMC Ltd"
                                },
                                {
                                    "Text": "COCA COLA INDIA ",
                                    "Value": "COCA COLA INDIA "
                                },
                                {
                                    "Text": "Cochin Shipyard Ltd",
                                    "Value": "Cochin Shipyard Ltd"
                                },
                                {
                                    "Text": "Coffee Day Global Ltd",
                                    "Value": "Coffee Day Global Ltd"
                                },
                                {
                                    "Text": "Coffee Day Trading Ltd",
                                    "Value": "Coffee Day Trading Ltd"
                                },
                                {
                                    "Text": "COGNIZANT TECHNOLOGY SOLUTIONS INDIA ",
                                    "Value": "COGNIZANT TECHNOLOGY SOLUTIONS INDIA "
                                },
                                {
                                    "Text": "COLORPLUS FASHIONS LTD ",
                                    "Value": "COLORPLUS FASHIONS LTD "
                                },
                                {
                                    "Text": "Compuage Infocom Ltd",
                                    "Value": "Compuage Infocom Ltd"
                                },
                                {
                                    "Text": "Container Corporation of India Ltd",
                                    "Value": "Container Corporation of India Ltd"
                                },
                                {
                                    "Text": "CORE PROJECT",
                                    "Value": "CORE PROJECT"
                                },
                                {
                                    "Text": "Coromandel International Ltd",
                                    "Value": "Coromandel International Ltd"
                                },
                                {
                                    "Text": "Cosmo Films Ltd",
                                    "Value": "Cosmo Films Ltd"
                                },
                                {
                                    "Text": "Cox  and  Kings Ltd",
                                    "Value": "Cox  and  Kings Ltd"
                                },
                                {
                                    "Text": "CREDIT SUISSE",
                                    "Value": "CREDIT SUISSE"
                                },
                                {
                                    "Text": "CRISIL LTD",
                                    "Value": "CRISIL LTD"
                                },
                                {
                                    "Text": "Crompton Greaves Ltd",
                                    "Value": "Crompton Greaves Ltd"
                                },
                                {
                                    "Text": "Cyient Ltd",
                                    "Value": "Cyient Ltd"
                                },
                                {
                                    "Text": "Dabur India Ltd",
                                    "Value": "Dabur India Ltd"
                                },
                                {
                                    "Text": "DAKSHIN GUJARAT VIJ CO ",
                                    "Value": "DAKSHIN GUJARAT VIJ CO "
                                },
                                {
                                    "Text": "Dalmia Bharat Sugar and Industries Ltd",
                                    "Value": "Dalmia Bharat Sugar and Industries Ltd"
                                },
                                {
                                    "Text": "DAMAS JEWELLERY",
                                    "Value": "DAMAS JEWELLERY"
                                },
                                {
                                    "Text": "DB Corp Ltd",
                                    "Value": "DB Corp Ltd"
                                },
                                {
                                    "Text": "DCB Bank Ltd",
                                    "Value": "DCB Bank Ltd"
                                },
                                {
                                    "Text": "DCM Shriram Ltd",
                                    "Value": "DCM Shriram Ltd"
                                },
                                {
                                    "Text": "DECCAN CHR",
                                    "Value": "DECCAN CHR"
                                },
                                {
                                    "Text": "Deepak Fertilisers and Petrochemicals Corporation Ltd",
                                    "Value": "Deepak Fertilisers and Petrochemicals Corporation Ltd"
                                },
                                {
                                    "Text": "DEFENCE LAND SYSTEMS",
                                    "Value": "DEFENCE LAND SYSTEMS"
                                },
                                {
                                    "Text": "DELL",
                                    "Value": "DELL"
                                },
                                {
                                    "Text": "Delphi TVS ",
                                    "Value": "Delphi TVS "
                                },
                                {
                                    "Text": "Dena Bank",
                                    "Value": "Dena Bank"
                                },
                                {
                                    "Text": "Desco Copy  and  print Centre",
                                    "Value": "Desco Copy  and  print Centre"
                                },
                                {
                                    "Text": "DEV CREDIT BANK   DCB BANK  ",
                                    "Value": "DEV CREDIT BANK   DCB BANK  "
                                },
                                {
                                    "Text": "Dhampur Sugar Mills Ltd",
                                    "Value": "Dhampur Sugar Mills Ltd"
                                },
                                {
                                    "Text": "Dhanuka Agritech Ltd",
                                    "Value": "Dhanuka Agritech Ltd"
                                },
                                {
                                    "Text": "DHFL General Insurance",
                                    "Value": "DHFL General Insurance"
                                },
                                {
                                    "Text": "Dhunseri Investments Ltd",
                                    "Value": "Dhunseri Investments Ltd"
                                },
                                {
                                    "Text": "Diamond Power Infrastructure Ltd",
                                    "Value": "Diamond Power Infrastructure Ltd"
                                },
                                {
                                    "Text": "Dilip Buildcon Ltd",
                                    "Value": "Dilip Buildcon Ltd"
                                },
                                {
                                    "Text": "Dish TV Ltd",
                                    "Value": "Dish TV Ltd"
                                },
                                {
                                    "Text": "Dishman Carbogen Amcis Ltd",
                                    "Value": "Dishman Carbogen Amcis Ltd"
                                },
                                {
                                    "Text": "Divils Laboratories Ltd",
                                    "Value": "Divils Laboratories Ltd"
                                },
                                {
                                    "Text": "DLF Ltd",
                                    "Value": "DLF Ltd"
                                },
                                {
                                    "Text": "DOHA BANK",
                                    "Value": "DOHA BANK"
                                },
                                {
                                    "Text": "DOW CHEMICAL INTERNATIONAL ",
                                    "Value": "DOW CHEMICAL INTERNATIONAL "
                                },
                                {
                                    "Text": "Dr Reddys Laboratories Ltd",
                                    "Value": "Dr Reddys Laboratories Ltd"
                                },
                                {
                                    "Text": "Drive India Enterprise Solutions",
                                    "Value": "Drive India Enterprise Solutions"
                                },
                                {
                                    "Text": "DUBAI AIRPORT",
                                    "Value": "DUBAI AIRPORT"
                                },
                                {
                                    "Text": "DUBAI ISLAMIC BANK",
                                    "Value": "DUBAI ISLAMIC BANK"
                                },
                                {
                                    "Text": "DUBAI NATIONAL INSURANCE",
                                    "Value": "DUBAI NATIONAL INSURANCE"
                                },
                                {
                                    "Text": "DUNLOP AUTO TYRES PVT LTD INDIA",
                                    "Value": "DUNLOP AUTO TYRES PVT LTD INDIA"
                                },
                                {
                                    "Text": "DUNLOP POLYMERS PVT LTD INDIA",
                                    "Value": "DUNLOP POLYMERS PVT LTD INDIA"
                                },
                                {
                                    "Text": "EASTERN POWER DISTRIBUTION CO",
                                    "Value": "EASTERN POWER DISTRIBUTION CO"
                                },
                                {
                                    "Text": "Ebixcash World Money India Ltd",
                                    "Value": "Ebixcash World Money India Ltd"
                                },
                                {
                                    "Text": "eClerx Services Ltd",
                                    "Value": "eClerx Services Ltd"
                                },
                                {
                                    "Text": "Edelweiss Financial Services Ltd",
                                    "Value": "Edelweiss Financial Services Ltd"
                                },
                                {
                                    "Text": "EDELWEISS TOKIO LIFE INSURANCE CO LTD",
                                    "Value": "EDELWEISS TOKIO LIFE INSURANCE CO LTD"
                                },
                                {
                                    "Text": "Eew Gulf Steel",
                                    "Value": "Eew Gulf Steel"
                                },
                                {
                                    "Text": "Eicher Motors Ltd",
                                    "Value": "Eicher Motors Ltd"
                                },
                                {
                                    "Text": "EIH Ltd",
                                    "Value": "EIH Ltd"
                                },
                                {
                                    "Text": "Electrosteel Castings Ltd",
                                    "Value": "Electrosteel Castings Ltd"
                                },
                                {
                                    "Text": "Elgi Equipments Ltd",
                                    "Value": "Elgi Equipments Ltd"
                                },
                                {
                                    "Text": "EMAMI BIOTECH ",
                                    "Value": "EMAMI BIOTECH "
                                },
                                {
                                    "Text": "EMARAT",
                                    "Value": "EMARAT"
                                },
                                {
                                    "Text": "EMIRATES AIRLINES",
                                    "Value": "EMIRATES AIRLINES"
                                },
                                {
                                    "Text": "EMIRATES BANK",
                                    "Value": "EMIRATES BANK"
                                },
                                {
                                    "Text": "EMIRATES ISLAMIC BANK",
                                    "Value": "EMIRATES ISLAMIC BANK"
                                },
                                {
                                    "Text": "Emkay Global Financial Services Ltd",
                                    "Value": "Emkay Global Financial Services Ltd"
                                },
                                {
                                    "Text": "Emmsons International Ltd",
                                    "Value": "Emmsons International Ltd"
                                },
                                {
                                    "Text": "Endurance Technologies Ltd",
                                    "Value": "Endurance Technologies Ltd"
                                },
                                {
                                    "Text": "ENT NETWORK",
                                    "Value": "ENT NETWORK"
                                },
                                {
                                    "Text": "e nxt Financials",
                                    "Value": "e nxt Financials"
                                },
                                {
                                    "Text": "Equitas Holdings Ltd",
                                    "Value": "Equitas Holdings Ltd"
                                },
                                {
                                    "Text": "Era Infra Engineering Ltd",
                                    "Value": "Era Infra Engineering Ltd"
                                },
                                {
                                    "Text": "Eris Lifesciences Ltd",
                                    "Value": "Eris Lifesciences Ltd"
                                },
                                {
                                    "Text": "Esab India Ltd",
                                    "Value": "Esab India Ltd"
                                },
                                {
                                    "Text": "Escorts Ltd",
                                    "Value": "Escorts Ltd"
                                },
                                {
                                    "Text": "Essar Oil Ltd",
                                    "Value": "Essar Oil Ltd"
                                },
                                {
                                    "Text": "Essar Shipping Ltd",
                                    "Value": "Essar Shipping Ltd"
                                },
                                {
                                    "Text": "Essel Finance AMC Ltd",
                                    "Value": "Essel Finance AMC Ltd"
                                },
                                {
                                    "Text": "ESSEL MINING AND INDUSTRIES Ltd",
                                    "Value": "ESSEL MINING AND INDUSTRIES Ltd"
                                },
                                {
                                    "Text": "ETISALAT",
                                    "Value": "ETISALAT"
                                },
                                {
                                    "Text": "Eveready Industries India Ltd",
                                    "Value": "Eveready Industries India Ltd"
                                },
                                {
                                    "Text": "EVEREST KANT",
                                    "Value": "EVEREST KANT"
                                },
                                {
                                    "Text": "Excel Crop Care Ltd",
                                    "Value": "Excel Crop Care Ltd"
                                },
                                {
                                    "Text": "EXIDE LIFE INSURANCE CO LTD",
                                    "Value": "EXIDE LIFE INSURANCE CO LTD"
                                },
                                {
                                    "Text": "Export Import Bank of India",
                                    "Value": "Export Import Bank of India"
                                },
                                {
                                    "Text": "Facebook",
                                    "Value": "Facebook"
                                },
                                {
                                    "Text": "FALCON TYRES LTD INDIA",
                                    "Value": "FALCON TYRES LTD INDIA"
                                },
                                {
                                    "Text": "Fedders Lloyd Corporation Ltd",
                                    "Value": "Fedders Lloyd Corporation Ltd"
                                },
                                {
                                    "Text": "Federal Mogul Goetze  India  Ltd",
                                    "Value": "Federal Mogul Goetze  India  Ltd"
                                },
                                {
                                    "Text": "FIAT INDIA AUTOMOBILES ",
                                    "Value": "FIAT INDIA AUTOMOBILES "
                                },
                                {
                                    "Text": "FIELDFRESH FOODS",
                                    "Value": "FIELDFRESH FOODS"
                                },
                                {
                                    "Text": "FINANCIAL  TECHNOLOGY",
                                    "Value": "FINANCIAL  TECHNOLOGY"
                                },
                                {
                                    "Text": "Fine Organic Industries Ltd",
                                    "Value": "Fine Organic Industries Ltd"
                                },
                                {
                                    "Text": "FINO PAYMENT BANK Ltd",
                                    "Value": "FINO PAYMENT BANK Ltd"
                                },
                                {
                                    "Text": "Finolex Cables Ltd",
                                    "Value": "Finolex Cables Ltd"
                                },
                                {
                                    "Text": "Firestone TVS Private Ltd ",
                                    "Value": "Firestone TVS Private Ltd "
                                },
                                {
                                    "Text": "Firstsource Solutions Ltd",
                                    "Value": "Firstsource Solutions Ltd"
                                },
                                {
                                    "Text": "Flexituff International Ltd",
                                    "Value": "Flexituff International Ltd"
                                },
                                {
                                    "Text": "FLIPKART INDIA ",
                                    "Value": "FLIPKART INDIA "
                                },
                                {
                                    "Text": "Force Motors Ltd",
                                    "Value": "Force Motors Ltd"
                                },
                                {
                                    "Text": "Fortis Healthcare Ltd",
                                    "Value": "Fortis Healthcare Ltd"
                                },
                                {
                                    "Text": "FRIGORIFCO ALLANA ",
                                    "Value": "FRIGORIFCO ALLANA "
                                },
                                {
                                    "Text": "Fullerton India Credit Company Ltd",
                                    "Value": "Fullerton India Credit Company Ltd"
                                },
                                {
                                    "Text": "FUTURE BRANDS",
                                    "Value": "FUTURE BRANDS"
                                },
                                {
                                    "Text": "Future Consumer Ltd",
                                    "Value": "Future Consumer Ltd"
                                },
                                {
                                    "Text": "FUTURE GENERALI GENERAL INSURANCE",
                                    "Value": "FUTURE GENERALI GENERAL INSURANCE"
                                },
                                {
                                    "Text": "FUTURE INNOVERSITY",
                                    "Value": "FUTURE INNOVERSITY"
                                },
                                {
                                    "Text": "Future Lifestyle Fashions Ltd",
                                    "Value": "Future Lifestyle Fashions Ltd"
                                },
                                {
                                    "Text": "FUTURE SUPPLY CHAINS",
                                    "Value": "FUTURE SUPPLY CHAINS"
                                },
                                {
                                    "Text": "Gabriel India Ltd",
                                    "Value": "Gabriel India Ltd"
                                },
                                {
                                    "Text": "Galaxy Surfactants Ltd",
                                    "Value": "Galaxy Surfactants Ltd"
                                },
                                {
                                    "Text": "GAMMON INFRA",
                                    "Value": "GAMMON INFRA"
                                },
                                {
                                    "Text": "Garden Reach Shipbuilders  and  Engineers Ltd",
                                    "Value": "Garden Reach Shipbuilders  and  Engineers Ltd"
                                },
                                {
                                    "Text": "Garden Silk Mills Ltd",
                                    "Value": "Garden Silk Mills Ltd"
                                },
                                {
                                    "Text": "GASCO",
                                    "Value": "GASCO"
                                },
                                {
                                    "Text": "Gati Ltd",
                                    "Value": "Gati Ltd"
                                },
                                {
                                    "Text": "GE Power India Ltd",
                                    "Value": "GE Power India Ltd"
                                },
                                {
                                    "Text": "General Insurance Corporation of India Ltd",
                                    "Value": "General Insurance Corporation of India Ltd"
                                },
                                {
                                    "Text": "General Trading  and  Equipment Co",
                                    "Value": "General Trading  and  Equipment Co"
                                },
                                {
                                    "Text": "GENPACT INDIA ",
                                    "Value": "GENPACT INDIA "
                                },
                                {
                                    "Text": "Geojit Credits Pvt Ltd",
                                    "Value": "Geojit Credits Pvt Ltd"
                                },
                                {
                                    "Text": "Geojit Technologies Pvt Ltd",
                                    "Value": "Geojit Technologies Pvt Ltd"
                                },
                                {
                                    "Text": "GHCL Ltd",
                                    "Value": "GHCL Ltd"
                                },
                                {
                                    "Text": "Gillette India Ltd",
                                    "Value": "Gillette India Ltd"
                                },
                                {
                                    "Text": "GlaxoSmithKline Consumer Healthcare Ltd",
                                    "Value": "GlaxoSmithKline Consumer Healthcare Ltd"
                                },
                                {
                                    "Text": "Glenmark Pharmaceuticals Ltd",
                                    "Value": "Glenmark Pharmaceuticals Ltd"
                                },
                                {
                                    "Text": "Glodyne Technoserve Ltd",
                                    "Value": "Glodyne Technoserve Ltd"
                                },
                                {
                                    "Text": "GMR Infrastructure Ltd",
                                    "Value": "GMR Infrastructure Ltd"
                                },
                                {
                                    "Text": "GO AIRLINES INDIA  PVT LTD",
                                    "Value": "GO AIRLINES INDIA  PVT LTD"
                                },
                                {
                                    "Text": "Godfrey Phillips India Ltd",
                                    "Value": "Godfrey Phillips India Ltd"
                                },
                                {
                                    "Text": "Godrej Agrovet Ltd",
                                    "Value": "Godrej Agrovet Ltd"
                                },
                                {
                                    "Text": "Godrej Industries Ltd",
                                    "Value": "Godrej Industries Ltd"
                                },
                                {
                                    "Text": "GOIBIBO",
                                    "Value": "GOIBIBO"
                                },
                                {
                                    "Text": "Gokul Agro Resources",
                                    "Value": "Gokul Agro Resources"
                                },
                                {
                                    "Text": "Gokul Refoils  and  Solvent Ltd",
                                    "Value": "Gokul Refoils  and  Solvent Ltd"
                                },
                                {
                                    "Text": "Good Luck Steel Tubes Ltd",
                                    "Value": "Good Luck Steel Tubes Ltd"
                                },
                                {
                                    "Text": "Google",
                                    "Value": "Google"
                                },
                                {
                                    "Text": "GOURMET INVESTMENTS",
                                    "Value": "GOURMET INVESTMENTS"
                                },
                                {
                                    "Text": "Granules India Ltd",
                                    "Value": "Granules India Ltd"
                                },
                                {
                                    "Text": "Grasim Industries Ltd",
                                    "Value": "Grasim Industries Ltd"
                                },
                                {
                                    "Text": "GREAT OFFSHORE Ltd",
                                    "Value": "GREAT OFFSHORE Ltd"
                                },
                                {
                                    "Text": "Greenply Industries Ltd",
                                    "Value": "Greenply Industries Ltd"
                                },
                                {
                                    "Text": "GRUH Finance Ltd",
                                    "Value": "GRUH Finance Ltd"
                                },
                                {
                                    "Text": "GSK Consumer Healthcare",
                                    "Value": "GSK Consumer Healthcare"
                                },
                                {
                                    "Text": "GTL INFRAST",
                                    "Value": "GTL INFRAST"
                                },
                                {
                                    "Text": "GUJARA NRE COKE LTD",
                                    "Value": "GUJARA NRE COKE LTD"
                                },
                                {
                                    "Text": "Gujarat Ambuja Exports Ltd",
                                    "Value": "Gujarat Ambuja Exports Ltd"
                                },
                                {
                                    "Text": "Gujarat Fluorochemicals Ltd",
                                    "Value": "Gujarat Fluorochemicals Ltd"
                                },
                                {
                                    "Text": "Gujarat Gas Ltd",
                                    "Value": "Gujarat Gas Ltd"
                                },
                                {
                                    "Text": "Gujarat Mineral Development Corporation Ltd",
                                    "Value": "Gujarat Mineral Development Corporation Ltd"
                                },
                                {
                                    "Text": "Gujarat Pipavav Port Ltd",
                                    "Value": "Gujarat Pipavav Port Ltd"
                                },
                                {
                                    "Text": "Gujarat State Fertilizers  and  Chemicals Ltd",
                                    "Value": "Gujarat State Fertilizers  and  Chemicals Ltd"
                                },
                                {
                                    "Text": "Gujarat State Petronet Ltd",
                                    "Value": "Gujarat State Petronet Ltd"
                                },
                                {
                                    "Text": "GULF OIL CORPORATION LTD",
                                    "Value": "GULF OIL CORPORATION LTD"
                                },
                                {
                                    "Text": "GULF OIL MIDDLE EAST LTD",
                                    "Value": "GULF OIL MIDDLE EAST LTD"
                                },
                                {
                                    "Text": "GVK Power  and  Infrastructure Ltd",
                                    "Value": "GVK Power  and  Infrastructure Ltd"
                                },
                                {
                                    "Text": "Hannover Rï¿½ï¿½ck SE ï¿½ï¿½ï¿½",
                                    "Value": "Hannover Rï¿½ï¿½ck SE ï¿½ï¿½ï¿½"
                                },
                                {
                                    "Text": "HARI KRISHNA EXPORTS ",
                                    "Value": "HARI KRISHNA EXPORTS "
                                },
                                {
                                    "Text": "Harrisons Malayalam Ltd",
                                    "Value": "Harrisons Malayalam Ltd"
                                },
                                {
                                    "Text": "Hathway Cable  and  Datacom Ltd",
                                    "Value": "Hathway Cable  and  Datacom Ltd"
                                },
                                {
                                    "Text": "Havells India Ltd",
                                    "Value": "Havells India Ltd"
                                },
                                {
                                    "Text": "HBL Power Systems Ltd",
                                    "Value": "HBL Power Systems Ltd"
                                },
                                {
                                    "Text": "HCL Technologies Ltd",
                                    "Value": "HCL Technologies Ltd"
                                },
                                {
                                    "Text": "HDFC",
                                    "Value": "HDFC"
                                },
                                {
                                    "Text": "HDFC Bank Ltd",
                                    "Value": "HDFC Bank Ltd"
                                },
                                {
                                    "Text": "HDFC Life Insurance Company Ltd",
                                    "Value": "HDFC Life Insurance Company Ltd"
                                },
                                {
                                    "Text": "HDFC Mutual Fund",
                                    "Value": "HDFC Mutual Fund"
                                },
                                {
                                    "Text": "Heidelberg Cement India Ltd",
                                    "Value": "Heidelberg Cement India Ltd"
                                },
                                {
                                    "Text": "Heritage Foods Ltd",
                                    "Value": "Heritage Foods Ltd"
                                },
                                {
                                    "Text": "Hero Cycles Ltd",
                                    "Value": "Hero Cycles Ltd"
                                },
                                {
                                    "Text": "Hero MotoCorp Ltd",
                                    "Value": "Hero MotoCorp Ltd"
                                },
                                {
                                    "Text": "HEROHONDA M",
                                    "Value": "HEROHONDA M"
                                },
                                {
                                    "Text": "HEWLETT PACKARD",
                                    "Value": "HEWLETT PACKARD"
                                },
                                {
                                    "Text": "HEWLETT PACKARD INDIA SALES ",
                                    "Value": "HEWLETT PACKARD INDIA SALES "
                                },
                                {
                                    "Text": "HFCL Ltd",
                                    "Value": "HFCL Ltd"
                                },
                                {
                                    "Text": "HIL Ltd",
                                    "Value": "HIL Ltd"
                                },
                                {
                                    "Text": "HIMADRI  CHEMICLALS  Speciality LTD ",
                                    "Value": "HIMADRI  CHEMICLALS  Speciality LTD "
                                },
                                {
                                    "Text": "Himadri Speciality Chemical Ltd",
                                    "Value": "Himadri Speciality Chemical Ltd"
                                },
                                {
                                    "Text": "Himatsingka Seide Ltd",
                                    "Value": "Himatsingka Seide Ltd"
                                },
                                {
                                    "Text": "HIND MUSAFIR AGENCY LTD",
                                    "Value": "HIND MUSAFIR AGENCY LTD"
                                },
                                {
                                    "Text": "Hindalco Industries Ltd",
                                    "Value": "Hindalco Industries Ltd"
                                },
                                {
                                    "Text": "HINDOIL EXP",
                                    "Value": "HINDOIL EXP"
                                },
                                {
                                    "Text": "HINDUJA BANK LTD",
                                    "Value": "HINDUJA BANK LTD"
                                },
                                {
                                    "Text": "Hinduja Global Solutions Ltd",
                                    "Value": "Hinduja Global Solutions Ltd"
                                },
                                {
                                    "Text": "HINDUJA HEALTHCARE LTD",
                                    "Value": "HINDUJA HEALTHCARE LTD"
                                },
                                {
                                    "Text": "HINDUJA NATIONAL POWER CORPORATION LTD",
                                    "Value": "HINDUJA NATIONAL POWER CORPORATION LTD"
                                },
                                {
                                    "Text": "HINDUJA TECH Ltd  FORMERLY DEFIANCE TECHNOLOGIES Ltd ",
                                    "Value": "HINDUJA TECH Ltd  FORMERLY DEFIANCE TECHNOLOGIES Ltd "
                                },
                                {
                                    "Text": "HINDUS CONST",
                                    "Value": "HINDUS CONST"
                                },
                                {
                                    "Text": "HINDUSTAN COCA COLA BEVERAGES ",
                                    "Value": "HINDUSTAN COCA COLA BEVERAGES "
                                },
                                {
                                    "Text": "Hindustan Copper Ltd",
                                    "Value": "Hindustan Copper Ltd"
                                },
                                {
                                    "Text": "HINDUSTAN OIL EXP",
                                    "Value": "HINDUSTAN OIL EXP"
                                },
                                {
                                    "Text": "Hindustan Unilever Ltd",
                                    "Value": "Hindustan Unilever Ltd"
                                },
                                {
                                    "Text": "Hindusthan National Glass  and  Industries",
                                    "Value": "Hindusthan National Glass  and  Industries"
                                },
                                {
                                    "Text": "Hitachi Home and Life Solutions  India  Ltd",
                                    "Value": "Hitachi Home and Life Solutions  India  Ltd"
                                },
                                {
                                    "Text": "HONDA CARS INDIA ",
                                    "Value": "HONDA CARS INDIA "
                                },
                                {
                                    "Text": "HONEYWELL",
                                    "Value": "HONEYWELL"
                                },
                                {
                                    "Text": "Hooghly Met Coke and Power Company",
                                    "Value": "Hooghly Met Coke and Power Company"
                                },
                                {
                                    "Text": "HOUGHTON INTERNATIONAL",
                                    "Value": "HOUGHTON INTERNATIONAL"
                                },
                                {
                                    "Text": "Housing Development  and  Infrastructure Ltd",
                                    "Value": "Housing Development  and  Infrastructure Ltd"
                                },
                                {
                                    "Text": "HP ",
                                    "Value": "HP "
                                },
                                {
                                    "Text": "HSBC ELECTRONIC DATA PROCESSING INDIA ",
                                    "Value": "HSBC ELECTRONIC DATA PROCESSING INDIA "
                                },
                                {
                                    "Text": "HSIL Ltd",
                                    "Value": "HSIL Ltd"
                                },
                                {
                                    "Text": "HUBLI ELECTRICITY SUPPLY CO ",
                                    "Value": "HUBLI ELECTRICITY SUPPLY CO "
                                },
                                {
                                    "Text": "Huhtamaki PPL Ltd",
                                    "Value": "Huhtamaki PPL Ltd"
                                },
                                {
                                    "Text": "HYUNDAI MOTOR INDIA ",
                                    "Value": "HYUNDAI MOTOR INDIA "
                                },
                                {
                                    "Text": "I T C LTD",
                                    "Value": "I T C LTD"
                                },
                                {
                                    "Text": "IBM",
                                    "Value": "IBM"
                                },
                                {
                                    "Text": "IBM INDIA ",
                                    "Value": "IBM INDIA "
                                },
                                {
                                    "Text": "ICICI Bank Ltd",
                                    "Value": "ICICI Bank Ltd"
                                },
                                {
                                    "Text": "ICICI Foundation",
                                    "Value": "ICICI Foundation"
                                },
                                {
                                    "Text": "ICICI Lombard General Insurance Company Ltd",
                                    "Value": "ICICI Lombard General Insurance Company Ltd"
                                },
                                {
                                    "Text": "ICICI Prudential Life Insurance Company Ltd",
                                    "Value": "ICICI Prudential Life Insurance Company Ltd"
                                },
                                {
                                    "Text": "ICICI Securities Primary Dealership",
                                    "Value": "ICICI Securities Primary Dealership"
                                },
                                {
                                    "Text": "ICRA Ltd",
                                    "Value": "ICRA Ltd"
                                },
                                {
                                    "Text": "IDBI Bank Ltd",
                                    "Value": "IDBI Bank Ltd"
                                },
                                {
                                    "Text": "IDEA",
                                    "Value": "IDEA"
                                },
                                {
                                    "Text": "IDFC Bank Ltd",
                                    "Value": "IDFC Bank Ltd"
                                },
                                {
                                    "Text": "IDFC Ltd",
                                    "Value": "IDFC Ltd"
                                },
                                {
                                    "Text": "IFB Industries",
                                    "Value": "IFB Industries"
                                },
                                {
                                    "Text": "IFCI Ltd",
                                    "Value": "IFCI Ltd"
                                },
                                {
                                    "Text": "IGATE GLOBAL SOLUTIONS ",
                                    "Value": "IGATE GLOBAL SOLUTIONS "
                                },
                                {
                                    "Text": "IIFL Finance Ltd",
                                    "Value": "IIFL Finance Ltd"
                                },
                                {
                                    "Text": "IL and FS Engineering  and  Construction Company",
                                    "Value": "IL and FS Engineering  and  Construction Company"
                                },
                                {
                                    "Text": "India Cements Ltd",
                                    "Value": "India Cements Ltd"
                                },
                                {
                                    "Text": "India Infoline Finance Ltd",
                                    "Value": "India Infoline Finance Ltd"
                                },
                                {
                                    "Text": "India Infoline Insurance Brokers Ltd",
                                    "Value": "India Infoline Insurance Brokers Ltd"
                                },
                                {
                                    "Text": "India Infoline Securities Ltd",
                                    "Value": "India Infoline Securities Ltd"
                                },
                                {
                                    "Text": "India Infoline Wealth NBFC",
                                    "Value": "India Infoline Wealth NBFC"
                                },
                                {
                                    "Text": "India Japan Lighting Private Ltd",
                                    "Value": "India Japan Lighting Private Ltd"
                                },
                                {
                                    "Text": "India Nippon Electricals Ltd",
                                    "Value": "India Nippon Electricals Ltd"
                                },
                                {
                                    "Text": "INDIA TYRE  and  RUBBER COMPANY  INDIA  Ltd INDIA",
                                    "Value": "INDIA TYRE  and  RUBBER COMPANY  INDIA  Ltd INDIA"
                                },
                                {
                                    "Text": "INDIAB POWER",
                                    "Value": "INDIAB POWER"
                                },
                                {
                                    "Text": "Indiabulls Integrated Services Ltd",
                                    "Value": "Indiabulls Integrated Services Ltd"
                                },
                                {
                                    "Text": "Indiabulls Ventures Ltd",
                                    "Value": "Indiabulls Ventures Ltd"
                                },
                                {
                                    "Text": "Indiamart Intermesh Ltd",
                                    "Value": "Indiamart Intermesh Ltd"
                                },
                                {
                                    "Text": "Indian Energy Exchange Ltd",
                                    "Value": "Indian Energy Exchange Ltd"
                                },
                                {
                                    "Text": "Indian Hotels Company Ltd",
                                    "Value": "Indian Hotels Company Ltd"
                                },
                                {
                                    "Text": "Indian Metals and Ferro Alloys Ltd",
                                    "Value": "Indian Metals and Ferro Alloys Ltd"
                                },
                                {
                                    "Text": "Indian Overseas Bank",
                                    "Value": "Indian Overseas Bank"
                                },
                                {
                                    "Text": "Indian Steel and Wire Products",
                                    "Value": "Indian Steel and Wire Products"
                                },
                                {
                                    "Text": "Indo Rama Synthetics  India  Ltd",
                                    "Value": "Indo Rama Synthetics  India  Ltd"
                                },
                                {
                                    "Text": "Indoco Remedies Ltd",
                                    "Value": "Indoco Remedies Ltd"
                                },
                                {
                                    "Text": "Indraprastha Gas Ltd",
                                    "Value": "Indraprastha Gas Ltd"
                                },
                                {
                                    "Text": "IndusInd Bank Ltd",
                                    "Value": "IndusInd Bank Ltd"
                                },
                                {
                                    "Text": "Industries Qatar",
                                    "Value": "Industries Qatar"
                                },
                                {
                                    "Text": "Infibeam Avenues Ltd",
                                    "Value": "Infibeam Avenues Ltd"
                                },
                                {
                                    "Text": "Infinite Computer Solutions India",
                                    "Value": "Infinite Computer Solutions India"
                                },
                                {
                                    "Text": "Info Edge  India  Ltd",
                                    "Value": "Info Edge  India  Ltd"
                                },
                                {
                                    "Text": "INFOTECH ENR",
                                    "Value": "INFOTECH ENR"
                                },
                                {
                                    "Text": "ING Vysya Bank Ltd",
                                    "Value": "ING Vysya Bank Ltd"
                                },
                                {
                                    "Text": "Ingersoll Rand  India  Ltd",
                                    "Value": "Ingersoll Rand  India  Ltd"
                                },
                                {
                                    "Text": "Inox link Fzco",
                                    "Value": "Inox link Fzco"
                                },
                                {
                                    "Text": "Insecticides  India  Ltd",
                                    "Value": "Insecticides  India  Ltd"
                                },
                                {
                                    "Text": "Integrated Enterprises  India  Private Ltd",
                                    "Value": "Integrated Enterprises  India  Private Ltd"
                                },
                                {
                                    "Text": "INTEL TECHNOLOGY INDIA ",
                                    "Value": "INTEL TECHNOLOGY INDIA "
                                },
                                {
                                    "Text": "InterGlobe Aviation Ltd",
                                    "Value": "InterGlobe Aviation Ltd"
                                },
                                {
                                    "Text": "INTERNATIONAL TRACTORS ",
                                    "Value": "INTERNATIONAL TRACTORS "
                                },
                                {
                                    "Text": "INZPERA HEALTH SCIENCES",
                                    "Value": "INZPERA HEALTH SCIENCES"
                                },
                                {
                                    "Text": "Ipca Laboratories Ltd",
                                    "Value": "Ipca Laboratories Ltd"
                                },
                                {
                                    "Text": "Ircon International Ltd",
                                    "Value": "Ircon International Ltd"
                                },
                                {
                                    "Text": "ISGEC Heavy Engineering Ltd",
                                    "Value": "ISGEC Heavy Engineering Ltd"
                                },
                                {
                                    "Text": "ISPAT INDUST",
                                    "Value": "ISPAT INDUST"
                                },
                                {
                                    "Text": "ITD Cementation India Ltd",
                                    "Value": "ITD Cementation India Ltd"
                                },
                                {
                                    "Text": "IVRCL Ltd",
                                    "Value": "IVRCL Ltd"
                                },
                                {
                                    "Text": "J K Tyre Industries Ltd",
                                    "Value": "J K Tyre Industries Ltd"
                                },
                                {
                                    "Text": "J P Morgan",
                                    "Value": "J P Morgan"
                                },
                                {
                                    "Text": "Jagran Prakashan Ltd",
                                    "Value": "Jagran Prakashan Ltd"
                                },
                                {
                                    "Text": "Jai Balaji Industries Ltd",
                                    "Value": "Jai Balaji Industries Ltd"
                                },
                                {
                                    "Text": "JAIBALA IND",
                                    "Value": "JAIBALA IND"
                                },
                                {
                                    "Text": "Jaiprakash Associates Ltd",
                                    "Value": "Jaiprakash Associates Ltd"
                                },
                                {
                                    "Text": "JAMIPOL",
                                    "Value": "JAMIPOL"
                                },
                                {
                                    "Text": "Jamna Auto Industries Ltd",
                                    "Value": "Jamna Auto Industries Ltd"
                                },
                                {
                                    "Text": "Jamshedour utilities  and  services corp",
                                    "Value": "Jamshedour utilities  and  services corp"
                                },
                                {
                                    "Text": "Jamshedpur Utilities and Servics Co",
                                    "Value": "Jamshedpur Utilities and Servics Co"
                                },
                                {
                                    "Text": "Janalakshmi Financial Services",
                                    "Value": "Janalakshmi Financial Services"
                                },
                                {
                                    "Text": "Jayant Agro Organics Ltd",
                                    "Value": "Jayant Agro Organics Ltd"
                                },
                                {
                                    "Text": "Jaypee Infratech Ltd",
                                    "Value": "Jaypee Infratech Ltd"
                                },
                                {
                                    "Text": "JBF Industries Ltd",
                                    "Value": "JBF Industries Ltd"
                                },
                                {
                                    "Text": "JEEVAN LTD",
                                    "Value": "JEEVAN LTD"
                                },
                                {
                                    "Text": "JESSOP  and  COMPANY LTD INDIA",
                                    "Value": "JESSOP  and  COMPANY LTD INDIA"
                                },
                                {
                                    "Text": "JHAJJAR POWER ",
                                    "Value": "JHAJJAR POWER "
                                },
                                {
                                    "Text": "JINDAL INDIA",
                                    "Value": "JINDAL INDIA"
                                },
                                {
                                    "Text": "Jindal Poly Films Ltd",
                                    "Value": "Jindal Poly Films Ltd"
                                },
                                {
                                    "Text": "Jindal Saw Ltd",
                                    "Value": "Jindal Saw Ltd"
                                },
                                {
                                    "Text": "Jindal Stainless  Hisar  Ltd",
                                    "Value": "Jindal Stainless  Hisar  Ltd"
                                },
                                {
                                    "Text": "Jindal Steel  and  Power Ltd",
                                    "Value": "Jindal Steel  and  Power Ltd"
                                },
                                {
                                    "Text": "JK Cement Ltd",
                                    "Value": "JK Cement Ltd"
                                },
                                {
                                    "Text": "JK HELENE CURTIS LTD ",
                                    "Value": "JK HELENE CURTIS LTD "
                                },
                                {
                                    "Text": "JK Lakshmi Cement Ltd",
                                    "Value": "JK Lakshmi Cement Ltd"
                                },
                                {
                                    "Text": "JM Financial Ltd",
                                    "Value": "JM Financial Ltd"
                                },
                                {
                                    "Text": "JMD OILS ",
                                    "Value": "JMD OILS "
                                },
                                {
                                    "Text": "JOHNSON  and  JOHNSON ",
                                    "Value": "JOHNSON  and  JOHNSON "
                                },
                                {
                                    "Text": "Johnson Controls   Hitachi Air Conditioning India Ltd",
                                    "Value": "Johnson Controls   Hitachi Air Conditioning India Ltd"
                                },
                                {
                                    "Text": "JP MORGAN",
                                    "Value": "JP MORGAN"
                                },
                                {
                                    "Text": "JPPOWER",
                                    "Value": "JPPOWER"
                                },
                                {
                                    "Text": "JSW Energy Ltd",
                                    "Value": "JSW Energy Ltd"
                                },
                                {
                                    "Text": "JTEKT India Ltd",
                                    "Value": "JTEKT India Ltd"
                                },
                                {
                                    "Text": "Jubilant Life Sciences Ltd",
                                    "Value": "Jubilant Life Sciences Ltd"
                                },
                                {
                                    "Text": "Jumerica Hotels  and   Retrect Centre ",
                                    "Value": "Jumerica Hotels  and   Retrect Centre "
                                },
                                {
                                    "Text": "Just Dial Ltd",
                                    "Value": "Just Dial Ltd"
                                },
                                {
                                    "Text": "JVL Agro Industries Ltd",
                                    "Value": "JVL Agro Industries Ltd"
                                },
                                {
                                    "Text": "Jyothy Laboratories Ltd",
                                    "Value": "Jyothy Laboratories Ltd"
                                },
                                {
                                    "Text": "Jyoti Structures Ltd",
                                    "Value": "Jyoti Structures Ltd"
                                },
                                {
                                    "Text": "K S Oils Ltd",
                                    "Value": "K S Oils Ltd"
                                },
                                {
                                    "Text": "Kailash Auto Finance Ltd",
                                    "Value": "Kailash Auto Finance Ltd"
                                },
                                {
                                    "Text": "KALEESUWARI REFINERY ",
                                    "Value": "KALEESUWARI REFINERY "
                                },
                                {
                                    "Text": "Kalyani Steels Ltd",
                                    "Value": "Kalyani Steels Ltd"
                                },
                                {
                                    "Text": "KANAN DEVAN HILLS PLANTATIONS CI PVT LTD",
                                    "Value": "KANAN DEVAN HILLS PLANTATIONS CI PVT LTD"
                                },
                                {
                                    "Text": "Karnataka Bank Ltd",
                                    "Value": "Karnataka Bank Ltd"
                                },
                                {
                                    "Text": "KARNATAKA POWER TRANSMISSION CORP ",
                                    "Value": "KARNATAKA POWER TRANSMISSION CORP "
                                },
                                {
                                    "Text": "Karur Vysya Bank Ltd",
                                    "Value": "Karur Vysya Bank Ltd"
                                },
                                {
                                    "Text": "Kaveri Seed Company Ltd",
                                    "Value": "Kaveri Seed Company Ltd"
                                },
                                {
                                    "Text": "KEI Industries Ltd",
                                    "Value": "KEI Industries Ltd"
                                },
                                {
                                    "Text": "Kesoram Industries Ltd",
                                    "Value": "Kesoram Industries Ltd"
                                },
                                {
                                    "Text": "KGN IND LTD",
                                    "Value": "KGN IND LTD"
                                },
                                {
                                    "Text": "Kirloskar Brothers Investments Ltd",
                                    "Value": "Kirloskar Brothers Investments Ltd"
                                },
                                {
                                    "Text": "Kirloskar Ferrous Industries Ltd",
                                    "Value": "Kirloskar Ferrous Industries Ltd"
                                },
                                {
                                    "Text": "Kirloskar Oil Engines Ltd",
                                    "Value": "Kirloskar Oil Engines Ltd"
                                },
                                {
                                    "Text": "Kkalpana Industries  India  Ltd",
                                    "Value": "Kkalpana Industries  India  Ltd"
                                },
                                {
                                    "Text": "Kohinoor Foods Ltd",
                                    "Value": "Kohinoor Foods Ltd"
                                },
                                {
                                    "Text": "Konkan Railway Corporation",
                                    "Value": "Konkan Railway Corporation"
                                },
                                {
                                    "Text": "Kotak Mahindra Bank Ltd",
                                    "Value": "Kotak Mahindra Bank Ltd"
                                },
                                {
                                    "Text": "KOTAK MAHINDRA GENERAL INSURANCE COMPANY LTD",
                                    "Value": "KOTAK MAHINDRA GENERAL INSURANCE COMPANY LTD"
                                },
                                {
                                    "Text": "KOTAK MAHINDRA PRIME Ltd ",
                                    "Value": "KOTAK MAHINDRA PRIME Ltd "
                                },
                                {
                                    "Text": "KOTAK REALTY FUND",
                                    "Value": "KOTAK REALTY FUND"
                                },
                                {
                                    "Text": "KOTAK SECURITIES Ltd   INSTITUTIONAL EQUITIES",
                                    "Value": "KOTAK SECURITIES Ltd   INSTITUTIONAL EQUITIES"
                                },
                                {
                                    "Text": "KPB HINDUJA COLLEGE OF COMMERCE",
                                    "Value": "KPB HINDUJA COLLEGE OF COMMERCE"
                                },
                                {
                                    "Text": "KPIT Technologies Ltd",
                                    "Value": "KPIT Technologies Ltd"
                                },
                                {
                                    "Text": "KPR Mills Ltd",
                                    "Value": "KPR Mills Ltd"
                                },
                                {
                                    "Text": "KRISHAK BHARATI CO OPERATIVE ",
                                    "Value": "KRISHAK BHARATI CO OPERATIVE "
                                },
                                {
                                    "Text": "KSK Energy Ventures Ltd",
                                    "Value": "KSK Energy Ventures Ltd"
                                },
                                {
                                    "Text": "Kwality Ltd",
                                    "Value": "Kwality Ltd"
                                },
                                {
                                    "Text": "L  and  T Technology Services Ltd",
                                    "Value": "L  and  T Technology Services Ltd"
                                },
                                {
                                    "Text": "L and T Technology Services Ltd",
                                    "Value": "L and T Technology Services Ltd"
                                },
                                {
                                    "Text": "LAFARGE INDIA ",
                                    "Value": "LAFARGE INDIA "
                                },
                                {
                                    "Text": "LAKSHMI OVER",
                                    "Value": "LAKSHMI OVER"
                                },
                                {
                                    "Text": "LALITHAA JEWELLERY MART ",
                                    "Value": "LALITHAA JEWELLERY MART "
                                },
                                {
                                    "Text": "LANDMARK GROUP",
                                    "Value": "LANDMARK GROUP"
                                },
                                {
                                    "Text": "Larsen  and  Toubro",
                                    "Value": "Larsen  and  Toubro"
                                },
                                {
                                    "Text": "Larsen  and  Toubro Ltd",
                                    "Value": "Larsen  and  Toubro Ltd"
                                },
                                {
                                    "Text": "LAXMI DIAMOND ",
                                    "Value": "LAXMI DIAMOND "
                                },
                                {
                                    "Text": "Lemon Tree Hotels Ltd",
                                    "Value": "Lemon Tree Hotels Ltd"
                                },
                                {
                                    "Text": "LG ELECTRONICS INDIA ",
                                    "Value": "LG ELECTRONICS INDIA "
                                },
                                {
                                    "Text": "LIC Housing Finance Ltd",
                                    "Value": "LIC Housing Finance Ltd"
                                },
                                {
                                    "Text": "Life Line Hospital",
                                    "Value": "Life Line Hospital"
                                },
                                {
                                    "Text": "Linkedin",
                                    "Value": "Linkedin"
                                },
                                {
                                    "Text": "LKP Wealth Advisory Private Ltd",
                                    "Value": "LKP Wealth Advisory Private Ltd"
                                },
                                {
                                    "Text": "Lloyds India Reinsurance Branch",
                                    "Value": "Lloyds India Reinsurance Branch"
                                },
                                {
                                    "Text": "LOREAL INDIA",
                                    "Value": "LOREAL INDIA"
                                },
                                {
                                    "Text": "Loyal Textile Mills Ltd",
                                    "Value": "Loyal Textile Mills Ltd"
                                },
                                {
                                    "Text": "LU LU",
                                    "Value": "LU LU"
                                },
                                {
                                    "Text": "Lucas TVS Ltd",
                                    "Value": "Lucas TVS Ltd"
                                },
                                {
                                    "Text": "LUMINIOUS POWER TECHNOLOGIES ",
                                    "Value": "LUMINIOUS POWER TECHNOLOGIES "
                                },
                                {
                                    "Text": "Lux Industries Ltd",
                                    "Value": "Lux Industries Ltd"
                                },
                                {
                                    "Text": "M and M FINANSER",
                                    "Value": "M and M FINANSER"
                                },
                                {
                                    "Text": "Macrotech Developers",
                                    "Value": "Macrotech Developers"
                                },
                                {
                                    "Text": "MADHYA GUJARAT VIJ CO ",
                                    "Value": "MADHYA GUJARAT VIJ CO "
                                },
                                {
                                    "Text": "Madras Fertilizers Ltd",
                                    "Value": "Madras Fertilizers Ltd"
                                },
                                {
                                    "Text": "Magma Fincorp Ltd",
                                    "Value": "Magma Fincorp Ltd"
                                },
                                {
                                    "Text": "MAH HOLIDAY",
                                    "Value": "MAH HOLIDAY"
                                },
                                {
                                    "Text": "Mahanagar Telephone Nigam Ltd",
                                    "Value": "Mahanagar Telephone Nigam Ltd"
                                },
                                {
                                    "Text": "Maharashtra Seamless Ltd",
                                    "Value": "Maharashtra Seamless Ltd"
                                },
                                {
                                    "Text": "MAHINDRA  and  MAHINDRA   ENERGY",
                                    "Value": "MAHINDRA  and  MAHINDRA   ENERGY"
                                },
                                {
                                    "Text": "MAHINDRA  and  MAHINDRA   MILITARY DEFENCE",
                                    "Value": "MAHINDRA  and  MAHINDRA   MILITARY DEFENCE"
                                },
                                {
                                    "Text": "Mahindra  and  Mahindra Ltd",
                                    "Value": "Mahindra  and  Mahindra Ltd"
                                },
                                {
                                    "Text": "MAHINDRA AGRIBUSINESS",
                                    "Value": "MAHINDRA AGRIBUSINESS"
                                },
                                {
                                    "Text": "Mahindra CIE Automotive Ltd",
                                    "Value": "Mahindra CIE Automotive Ltd"
                                },
                                {
                                    "Text": "MAHINDRA COMVIVA",
                                    "Value": "MAHINDRA COMVIVA"
                                },
                                {
                                    "Text": "MAHINDRA CONVEYOR SYSTEMS",
                                    "Value": "MAHINDRA CONVEYOR SYSTEMS"
                                },
                                {
                                    "Text": "MAHINDRA FIRST CHOICE SERVICES",
                                    "Value": "MAHINDRA FIRST CHOICE SERVICES"
                                },
                                {
                                    "Text": "MAHINDRA GEARS AND TRANSMISSIONS",
                                    "Value": "MAHINDRA GEARS AND TRANSMISSIONS"
                                },
                                {
                                    "Text": "Mahindra Holidays  and  Resorts India Ltd",
                                    "Value": "Mahindra Holidays  and  Resorts India Ltd"
                                },
                                {
                                    "Text": "MAHINDRA INTERTRADE",
                                    "Value": "MAHINDRA INTERTRADE"
                                },
                                {
                                    "Text": "MAHINDRA LIFESPACES",
                                    "Value": "MAHINDRA LIFESPACES"
                                },
                                {
                                    "Text": "Mahindra Logistics Ltd",
                                    "Value": "Mahindra Logistics Ltd"
                                },
                                {
                                    "Text": "MAHINDRA MUTUAL FUND",
                                    "Value": "MAHINDRA MUTUAL FUND"
                                },
                                {
                                    "Text": "MAHINDRA RETAI",
                                    "Value": "MAHINDRA RETAI"
                                },
                                {
                                    "Text": "Mahindra Rural Housing Finance Ltd",
                                    "Value": "Mahindra Rural Housing Finance Ltd"
                                },
                                {
                                    "Text": "MAHINDRA SONA LTD",
                                    "Value": "MAHINDRA SONA LTD"
                                },
                                {
                                    "Text": "MAHINDRA STEEL SERVICE CENTRE",
                                    "Value": "MAHINDRA STEEL SERVICE CENTRE"
                                },
                                {
                                    "Text": "MAHINDRA SYSTECH",
                                    "Value": "MAHINDRA SYSTECH"
                                },
                                {
                                    "Text": "MAHINDRA TRUCK  and  BUS",
                                    "Value": "MAHINDRA TRUCK  and  BUS"
                                },
                                {
                                    "Text": "Mahindra Ugine Steel Company Ltd",
                                    "Value": "Mahindra Ugine Steel Company Ltd"
                                },
                                {
                                    "Text": "MAHINDRA WORLD CITY",
                                    "Value": "MAHINDRA WORLD CITY"
                                },
                                {
                                    "Text": "MAHINDRALIFE",
                                    "Value": "MAHINDRALIFE"
                                },
                                {
                                    "Text": "Makemytrip",
                                    "Value": "Makemytrip"
                                },
                                {
                                    "Text": "Manaksia Ltd",
                                    "Value": "Manaksia Ltd"
                                },
                                {
                                    "Text": "Manappuram Finance Ltd",
                                    "Value": "Manappuram Finance Ltd"
                                },
                                {
                                    "Text": "Mangalore Chemicals and Fertilizers Ltd",
                                    "Value": "Mangalore Chemicals and Fertilizers Ltd"
                                },
                                {
                                    "Text": "MANKIND PHARMA ",
                                    "Value": "MANKIND PHARMA "
                                },
                                {
                                    "Text": "Manufacturers Equipment and Supply Company  MESCO ",
                                    "Value": "Manufacturers Equipment and Supply Company  MESCO "
                                },
                                {
                                    "Text": "Marico Ltd",
                                    "Value": "Marico Ltd"
                                },
                                {
                                    "Text": "Marksans Pharma Ltd",
                                    "Value": "Marksans Pharma Ltd"
                                },
                                {
                                    "Text": "Maruti Suzuki India Ltd",
                                    "Value": "Maruti Suzuki India Ltd"
                                },
                                {
                                    "Text": "MASHREQ BANK",
                                    "Value": "MASHREQ BANK"
                                },
                                {
                                    "Text": "Masraf Al Rayan",
                                    "Value": "Masraf Al Rayan"
                                },
                                {
                                    "Text": "Max Bupa Health Insurance",
                                    "Value": "Max Bupa Health Insurance"
                                },
                                {
                                    "Text": "Max India Ltd",
                                    "Value": "Max India Ltd"
                                },
                                {
                                    "Text": "MAZAGON DOCK ",
                                    "Value": "MAZAGON DOCK "
                                },
                                {
                                    "Text": "MCC PTA INDIA CORPORATION ",
                                    "Value": "MCC PTA INDIA CORPORATION "
                                },
                                {
                                    "Text": "Mcleod Russel India Ltd",
                                    "Value": "Mcleod Russel India Ltd"
                                },
                                {
                                    "Text": "Meaieed Petrochemical Holdings Co",
                                    "Value": "Meaieed Petrochemical Holdings Co"
                                },
                                {
                                    "Text": "MEP Infrastructure Developers Ltd",
                                    "Value": "MEP Infrastructure Developers Ltd"
                                },
                                {
                                    "Text": "METITO OVERSEAS",
                                    "Value": "METITO OVERSEAS"
                                },
                                {
                                    "Text": "MICRO INKS ",
                                    "Value": "MICRO INKS "
                                },
                                {
                                    "Text": "MICROSOFT CORPORATION INDIA ",
                                    "Value": "MICROSOFT CORPORATION INDIA "
                                },
                                {
                                    "Text": "Minda Corporation Ltd",
                                    "Value": "Minda Corporation Ltd"
                                },
                                {
                                    "Text": "Mindtree Ltd",
                                    "Value": "Mindtree Ltd"
                                },
                                {
                                    "Text": "MITSUBISHI CORPORATION INDIA ",
                                    "Value": "MITSUBISHI CORPORATION INDIA "
                                },
                                {
                                    "Text": "MMTC Ltd",
                                    "Value": "MMTC Ltd"
                                },
                                {
                                    "Text": "MODEL ECONOMIC TOWNSHIP Ltd",
                                    "Value": "MODEL ECONOMIC TOWNSHIP Ltd"
                                },
                                {
                                    "Text": "MOIL Ltd",
                                    "Value": "MOIL Ltd"
                                },
                                {
                                    "Text": "Monnet Ispat  and  Energy Ltd",
                                    "Value": "Monnet Ispat  and  Energy Ltd"
                                },
                                {
                                    "Text": "Monsanto India Ltd",
                                    "Value": "Monsanto India Ltd"
                                },
                                {
                                    "Text": "Moser Baer India Ltd",
                                    "Value": "Moser Baer India Ltd"
                                },
                                {
                                    "Text": "Motherson Sumi Systems Ltd",
                                    "Value": "Motherson Sumi Systems Ltd"
                                },
                                {
                                    "Text": "MP PASCHIM KSHETRA VIDYUT VITARAN CO ",
                                    "Value": "MP PASCHIM KSHETRA VIDYUT VITARAN CO "
                                },
                                {
                                    "Text": "MRF Ltd",
                                    "Value": "MRF Ltd"
                                },
                                {
                                    "Text": "MUKAND GLOBAL FINANCE LTD",
                                    "Value": "MUKAND GLOBAL FINANCE LTD"
                                },
                                {
                                    "Text": "Mukand Ltd",
                                    "Value": "Mukand Ltd"
                                },
                                {
                                    "Text": "MUMBAI INTERNATIONAL AIRPORT ",
                                    "Value": "MUMBAI INTERNATIONAL AIRPORT "
                                },
                                {
                                    "Text": "MUNDRA PORT",
                                    "Value": "MUNDRA PORT"
                                },
                                {
                                    "Text": "Muthoot Finance Ltd",
                                    "Value": "Muthoot Finance Ltd"
                                },
                                {
                                    "Text": "Muthoot Risk Insurance and Broking Services Pvt Ltd",
                                    "Value": "Muthoot Risk Insurance and Broking Services Pvt Ltd"
                                },
                                {
                                    "Text": "MVL Ltd",
                                    "Value": "MVL Ltd"
                                },
                                {
                                    "Text": "Myntra",
                                    "Value": "Myntra"
                                },
                                {
                                    "Text": "Nagarjuna Fertilizers  and  Chemicals ",
                                    "Value": "Nagarjuna Fertilizers  and  Chemicals "
                                },
                                {
                                    "Text": "Nahar Spinning Mills Ltd",
                                    "Value": "Nahar Spinning Mills Ltd"
                                },
                                {
                                    "Text": "NAKHEEL",
                                    "Value": "NAKHEEL"
                                },
                                {
                                    "Text": "Nandan Denim Ltd",
                                    "Value": "Nandan Denim Ltd"
                                },
                                {
                                    "Text": "NAT ALUM CO",
                                    "Value": "NAT ALUM CO"
                                },
                                {
                                    "Text": "Natco Pharma Ltd",
                                    "Value": "Natco Pharma Ltd"
                                },
                                {
                                    "Text": "National Bank of Kuwait",
                                    "Value": "National Bank of Kuwait"
                                },
                                {
                                    "Text": "National Fertilizers Ltd",
                                    "Value": "National Fertilizers Ltd"
                                },
                                {
                                    "Text": "National Insurance Company",
                                    "Value": "National Insurance Company"
                                },
                                {
                                    "Text": "NATIONAL PEROXIDE",
                                    "Value": "NATIONAL PEROXIDE"
                                },
                                {
                                    "Text": "National Steel and Agro Industries Ltd",
                                    "Value": "National Steel and Agro Industries Ltd"
                                },
                                {
                                    "Text": "NAV BHAR VEN",
                                    "Value": "NAV BHAR VEN"
                                },
                                {
                                    "Text": "Navin Fluorine International Ltd",
                                    "Value": "Navin Fluorine International Ltd"
                                },
                                {
                                    "Text": "Navneet Education Ltd",
                                    "Value": "Navneet Education Ltd"
                                },
                                {
                                    "Text": "NBAD",
                                    "Value": "NBAD"
                                },
                                {
                                    "Text": "NCC Ltd",
                                    "Value": "NCC Ltd"
                                },
                                {
                                    "Text": "Nectar Lifesciences Ltd",
                                    "Value": "Nectar Lifesciences Ltd"
                                },
                                {
                                    "Text": "Nelito Systems",
                                    "Value": "Nelito Systems"
                                },
                                {
                                    "Text": "Nesco Ltd",
                                    "Value": "Nesco Ltd"
                                },
                                {
                                    "Text": "Network18 Media  and  Investments Ltd",
                                    "Value": "Network18 Media  and  Investments Ltd"
                                },
                                {
                                    "Text": "New India Assurance Company Ltd",
                                    "Value": "New India Assurance Company Ltd"
                                },
                                {
                                    "Text": "Neyveli Lignite Corporation Ltd",
                                    "Value": "Neyveli Lignite Corporation Ltd"
                                },
                                {
                                    "Text": "NIIT LTD",
                                    "Value": "NIIT LTD"
                                },
                                {
                                    "Text": "Nilkamal Ltd",
                                    "Value": "Nilkamal Ltd"
                                },
                                {
                                    "Text": "NIRMA ",
                                    "Value": "NIRMA "
                                },
                                {
                                    "Text": "Nissan Renault Financial Services India",
                                    "Value": "Nissan Renault Financial Services India"
                                },
                                {
                                    "Text": "NJ INSURANCE BROKERS PVT LTD",
                                    "Value": "NJ INSURANCE BROKERS PVT LTD"
                                },
                                {
                                    "Text": "NLC India Ltd",
                                    "Value": "NLC India Ltd"
                                },
                                {
                                    "Text": "NMDC Ltd",
                                    "Value": "NMDC Ltd"
                                },
                                {
                                    "Text": "Noida Toll Bridge Company Limited",
                                    "Value": "Noida Toll Bridge Company Limited"
                                },
                                {
                                    "Text": "NORLAKE HOSPITALITY ",
                                    "Value": "NORLAKE HOSPITALITY "
                                },
                                {
                                    "Text": "Novartis India Ltd",
                                    "Value": "Novartis India Ltd"
                                },
                                {
                                    "Text": "NTPC Ltd",
                                    "Value": "NTPC Ltd"
                                },
                                {
                                    "Text": "NUCLEAR POWER CORPORATION ",
                                    "Value": "NUCLEAR POWER CORPORATION "
                                },
                                {
                                    "Text": "NXT DIGITAL HITS",
                                    "Value": "NXT DIGITAL HITS"
                                },
                                {
                                    "Text": "OCL India Ltd",
                                    "Value": "OCL India Ltd"
                                },
                                {
                                    "Text": "Oil and Natural Gas Corporation Ltd",
                                    "Value": "Oil and Natural Gas Corporation Ltd"
                                },
                                {
                                    "Text": "OLA INDIA",
                                    "Value": "OLA INDIA"
                                },
                                {
                                    "Text": "OMAN INSURANCE",
                                    "Value": "OMAN INSURANCE"
                                },
                                {
                                    "Text": "Omaxe Ltd",
                                    "Value": "Omaxe Ltd"
                                },
                                {
                                    "Text": "One 97 communications Ltd  Paytm ",
                                    "Value": "One 97 communications Ltd  Paytm "
                                },
                                {
                                    "Text": "ONEWEB",
                                    "Value": "ONEWEB"
                                },
                                {
                                    "Text": "ONMOBILE",
                                    "Value": "ONMOBILE"
                                },
                                {
                                    "Text": "Opto Circuits India Ltd",
                                    "Value": "Opto Circuits India Ltd"
                                },
                                {
                                    "Text": "Oracle Financial Services Software Ltd",
                                    "Value": "Oracle Financial Services Software Ltd"
                                },
                                {
                                    "Text": "ORBIT CO",
                                    "Value": "ORBIT CO"
                                },
                                {
                                    "Text": "Orient Cement Ltd",
                                    "Value": "Orient Cement Ltd"
                                },
                                {
                                    "Text": "Orient Exchange  and  Financial Services  P  Ltd",
                                    "Value": "Orient Exchange  and  Financial Services  P  Ltd"
                                },
                                {
                                    "Text": "Orient Paper  and  Industries Ltd",
                                    "Value": "Orient Paper  and  Industries Ltd"
                                },
                                {
                                    "Text": "Oriental Bank of Commerce",
                                    "Value": "Oriental Bank of Commerce"
                                },
                                {
                                    "Text": "P D HINDUJA NATIONAL HOSPITAL AND MEDICAL RESEARCH CENTRE",
                                    "Value": "P D HINDUJA NATIONAL HOSPITAL AND MEDICAL RESEARCH CENTRE"
                                },
                                {
                                    "Text": "Page Industries Ltd",
                                    "Value": "Page Industries Ltd"
                                },
                                {
                                    "Text": "PANTAL RETAI",
                                    "Value": "PANTAL RETAI"
                                },
                                {
                                    "Text": "PARADEEP PHOSPHATES ",
                                    "Value": "PARADEEP PHOSPHATES "
                                },
                                {
                                    "Text": "PARLE BISCUITS ",
                                    "Value": "PARLE BISCUITS "
                                },
                                {
                                    "Text": "PARSVNATH",
                                    "Value": "PARSVNATH"
                                },
                                {
                                    "Text": "Patanjali Ayurved",
                                    "Value": "Patanjali Ayurved"
                                },
                                {
                                    "Text": "PATNI COMPUTERS LTD",
                                    "Value": "PATNI COMPUTERS LTD"
                                },
                                {
                                    "Text": "Paytm",
                                    "Value": "Paytm"
                                },
                                {
                                    "Text": "Paytm Entertainment Ltd",
                                    "Value": "Paytm Entertainment Ltd"
                                },
                                {
                                    "Text": "Paytm General Insurance Corp Ltd",
                                    "Value": "Paytm General Insurance Corp Ltd"
                                },
                                {
                                    "Text": "Paytm Mobile Solutions Pvt Ltd",
                                    "Value": "Paytm Mobile Solutions Pvt Ltd"
                                },
                                {
                                    "Text": "Paytm Payments Bank Ltd",
                                    "Value": "Paytm Payments Bank Ltd"
                                },
                                {
                                    "Text": "PD RUIA KAYAKALP NATUROPATHY  and  HEALTH RESORT INDIA",
                                    "Value": "PD RUIA KAYAKALP NATUROPATHY  and  HEALTH RESORT INDIA"
                                },
                                {
                                    "Text": "Pearl Global Industries Ltd",
                                    "Value": "Pearl Global Industries Ltd"
                                },
                                {
                                    "Text": "PENLAND LTD",
                                    "Value": "PENLAND LTD"
                                },
                                {
                                    "Text": "Pepsico India Holdings ",
                                    "Value": "Pepsico India Holdings "
                                },
                                {
                                    "Text": "PETROFAC",
                                    "Value": "PETROFAC"
                                },
                                {
                                    "Text": "Petronet LNG Ltd",
                                    "Value": "Petronet LNG Ltd"
                                },
                                {
                                    "Text": "PHEROZE FRAMROZE  and  CO ",
                                    "Value": "PHEROZE FRAMROZE  and  CO "
                                },
                                {
                                    "Text": "Phillips Carbon Black Ltd",
                                    "Value": "Phillips Carbon Black Ltd"
                                },
                                {
                                    "Text": "PI Industries Ltd",
                                    "Value": "PI Industries Ltd"
                                },
                                {
                                    "Text": "Pidilite Industries Ltd",
                                    "Value": "Pidilite Industries Ltd"
                                },
                                {
                                    "Text": "Pipavav Defence  and  Offshore Engg Company",
                                    "Value": "Pipavav Defence  and  Offshore Engg Company"
                                },
                                {
                                    "Text": "PIRAMA HEALT",
                                    "Value": "PIRAMA HEALT"
                                },
                                {
                                    "Text": "Piramal Glass Ltd",
                                    "Value": "Piramal Glass Ltd"
                                },
                                {
                                    "Text": "Plethico Pharmaceuticals Ltd",
                                    "Value": "Plethico Pharmaceuticals Ltd"
                                },
                                {
                                    "Text": "PNB Housing Finance Ltd",
                                    "Value": "PNB Housing Finance Ltd"
                                },
                                {
                                    "Text": "PNC Infratech Ltd",
                                    "Value": "PNC Infratech Ltd"
                                },
                                {
                                    "Text": "Polaris Financial Technology Ltd",
                                    "Value": "Polaris Financial Technology Ltd"
                                },
                                {
                                    "Text": "Policy Bazaar",
                                    "Value": "Policy Bazaar"
                                },
                                {
                                    "Text": "Polycab India Ltd",
                                    "Value": "Polycab India Ltd"
                                },
                                {
                                    "Text": "Power Finance Corporation Ltd",
                                    "Value": "Power Finance Corporation Ltd"
                                },
                                {
                                    "Text": "Power Mech Projects",
                                    "Value": "Power Mech Projects"
                                },
                                {
                                    "Text": "Powerlinks Transmission",
                                    "Value": "Powerlinks Transmission"
                                },
                                {
                                    "Text": "Prakash Industries Ltd",
                                    "Value": "Prakash Industries Ltd"
                                },
                                {
                                    "Text": "Pratibha Industries Ltd",
                                    "Value": "Pratibha Industries Ltd"
                                },
                                {
                                    "Text": "PRICEWATERHOUSE COOPERS",
                                    "Value": "PRICEWATERHOUSE COOPERS"
                                },
                                {
                                    "Text": "Prism Cement Ltd",
                                    "Value": "Prism Cement Ltd"
                                },
                                {
                                    "Text": "Prithvi Information Solutions Ltd",
                                    "Value": "Prithvi Information Solutions Ltd"
                                },
                                {
                                    "Text": "Procter  and  Gamble Hygiene  and  Health Care Ltd",
                                    "Value": "Procter  and  Gamble Hygiene  and  Health Care Ltd"
                                },
                                {
                                    "Text": "Prudent Broking Services Pvt Ltd",
                                    "Value": "Prudent Broking Services Pvt Ltd"
                                },
                                {
                                    "Text": "PSL Ltd",
                                    "Value": "PSL Ltd"
                                },
                                {
                                    "Text": "PTC India Financial Services Ltd",
                                    "Value": "PTC India Financial Services Ltd"
                                },
                                {
                                    "Text": "Punj Lloyd Ltd",
                                    "Value": "Punj Lloyd Ltd"
                                },
                                {
                                    "Text": "Punjab National Bank",
                                    "Value": "Punjab National Bank"
                                },
                                {
                                    "Text": "PURAVANKARA",
                                    "Value": "PURAVANKARA"
                                },
                                {
                                    "Text": "PVR Ltd",
                                    "Value": "PVR Ltd"
                                },
                                {
                                    "Text": "Qatar Fuel",
                                    "Value": "Qatar Fuel"
                                },
                                {
                                    "Text": "Qatar Islamic Bank",
                                    "Value": "Qatar Islamic Bank"
                                },
                                {
                                    "Text": "QBG Geojit Financial Services LLC",
                                    "Value": "QBG Geojit Financial Services LLC"
                                },
                                {
                                    "Text": "Radico Khaitan Ltd",
                                    "Value": "Radico Khaitan Ltd"
                                },
                                {
                                    "Text": "Rail Vikas Nigam Ltd",
                                    "Value": "Rail Vikas Nigam Ltd"
                                },
                                {
                                    "Text": "RAIN COMMODI",
                                    "Value": "RAIN COMMODI"
                                },
                                {
                                    "Text": "Raj West Power ",
                                    "Value": "Raj West Power "
                                },
                                {
                                    "Text": "Rajesh Exports Ltd",
                                    "Value": "Rajesh Exports Ltd"
                                },
                                {
                                    "Text": "Rallis India Ltd",
                                    "Value": "Rallis India Ltd"
                                },
                                {
                                    "Text": "Ramky Infrastructure Ltd",
                                    "Value": "Ramky Infrastructure Ltd"
                                },
                                {
                                    "Text": "Rane Holdings Ltd",
                                    "Value": "Rane Holdings Ltd"
                                },
                                {
                                    "Text": "Rashtriya Chemicals  and  Fertilizers Ltd",
                                    "Value": "Rashtriya Chemicals  and  Fertilizers Ltd"
                                },
                                {
                                    "Text": "Ratnamani Metals  and  Tubes Ltd",
                                    "Value": "Ratnamani Metals  and  Tubes Ltd"
                                },
                                {
                                    "Text": "Raychem RPG Private Ltd",
                                    "Value": "Raychem RPG Private Ltd"
                                },
                                {
                                    "Text": "Raymond Ltd",
                                    "Value": "Raymond Ltd"
                                },
                                {
                                    "Text": "RAYMOND UCO DENIM PVT LTD",
                                    "Value": "RAYMOND UCO DENIM PVT LTD"
                                },
                                {
                                    "Text": "REC Ltd",
                                    "Value": "REC Ltd"
                                },
                                {
                                    "Text": "Redington  India  Ltd",
                                    "Value": "Redington  India  Ltd"
                                },
                                {
                                    "Text": "REISIX TENR",
                                    "Value": "REISIX TENR"
                                },
                                {
                                    "Text": "RELAX PHARMACEUTICALS ",
                                    "Value": "RELAX PHARMACEUTICALS "
                                },
                                {
                                    "Text": "RELIANCE  COMMUNICATIONS  LTD",
                                    "Value": "RELIANCE  COMMUNICATIONS  LTD"
                                },
                                {
                                    "Text": "RELIANCE AMBIT TRADE PRIVATE Ltd",
                                    "Value": "RELIANCE AMBIT TRADE PRIVATE Ltd"
                                },
                                {
                                    "Text": "RELIANCE BIG ENTERTAINMENT",
                                    "Value": "RELIANCE BIG ENTERTAINMENT"
                                },
                                {
                                    "Text": "RELIANCE CAPITAL",
                                    "Value": "RELIANCE CAPITAL"
                                },
                                {
                                    "Text": "RELIANCE CHEMICALS Ltd",
                                    "Value": "RELIANCE CHEMICALS Ltd"
                                },
                                {
                                    "Text": "RELIANCE COMMERCIAL FINANCE",
                                    "Value": "RELIANCE COMMERCIAL FINANCE"
                                },
                                {
                                    "Text": "RELIANCE COMMUNICATIONS",
                                    "Value": "RELIANCE COMMUNICATIONS"
                                },
                                {
                                    "Text": "Reliance Communications Ltd",
                                    "Value": "Reliance Communications Ltd"
                                },
                                {
                                    "Text": "RELIANCE CORPORATE IT PARK Ltd",
                                    "Value": "RELIANCE CORPORATE IT PARK Ltd"
                                },
                                {
                                    "Text": "RELIANCE EMINENT TRADING  and  COMMERCIAL PRIVATE Ltd",
                                    "Value": "RELIANCE EMINENT TRADING  and  COMMERCIAL PRIVATE Ltd"
                                },
                                {
                                    "Text": "RELIANCE ENERGY GENERATION AND DISTRIBUTION Ltd",
                                    "Value": "RELIANCE ENERGY GENERATION AND DISTRIBUTION Ltd"
                                },
                                {
                                    "Text": "RELIANCE EXPLORATION  and  PRODUCTION DMCC",
                                    "Value": "RELIANCE EXPLORATION  and  PRODUCTION DMCC"
                                },
                                {
                                    "Text": "RELIANCE GENERAL INSURANCE",
                                    "Value": "RELIANCE GENERAL INSURANCE"
                                },
                                {
                                    "Text": "RELIANCE GLOBAL COMMERCIAL Ltd",
                                    "Value": "RELIANCE GLOBAL COMMERCIAL Ltd"
                                },
                                {
                                    "Text": "Reliance Health Insurance",
                                    "Value": "Reliance Health Insurance"
                                },
                                {
                                    "Text": "RELIANCE INDUSTRIAL INFRASTRUCTURE Ltd",
                                    "Value": "RELIANCE INDUSTRIAL INFRASTRUCTURE Ltd"
                                },
                                {
                                    "Text": "RELIANCE INDUSTRIES  MIDDLE EAST  DMCC",
                                    "Value": "RELIANCE INDUSTRIES  MIDDLE EAST  DMCC"
                                },
                                {
                                    "Text": "Reliance Infrastructure Ltd",
                                    "Value": "Reliance Infrastructure Ltd"
                                },
                                {
                                    "Text": "RELIANCE JIO INFOCOMM Ltd",
                                    "Value": "RELIANCE JIO INFOCOMM Ltd"
                                },
                                {
                                    "Text": "RELIANCE LIFESTYLE HOLDINGS Ltd",
                                    "Value": "RELIANCE LIFESTYLE HOLDINGS Ltd"
                                },
                                {
                                    "Text": "RELIANCE MONEY",
                                    "Value": "RELIANCE MONEY"
                                },
                                {
                                    "Text": "RELIANCE MUTUAL FUND",
                                    "Value": "RELIANCE MUTUAL FUND"
                                },
                                {
                                    "Text": "Reliance Nippon Life Insurance Company",
                                    "Value": "Reliance Nippon Life Insurance Company"
                                },
                                {
                                    "Text": "RELIANCE PETRO MARKETING Ltd",
                                    "Value": "RELIANCE PETRO MARKETING Ltd"
                                },
                                {
                                    "Text": "RELIANCE POLYOLEFINS Ltd",
                                    "Value": "RELIANCE POLYOLEFINS Ltd"
                                },
                                {
                                    "Text": "Reliance Power Ltd",
                                    "Value": "Reliance Power Ltd"
                                },
                                {
                                    "Text": "RELIANCE PROLIFIC COMMERCIAL PRIVATE Ltd",
                                    "Value": "RELIANCE PROLIFIC COMMERCIAL PRIVATE Ltd"
                                },
                                {
                                    "Text": "RELIANCE RETAIL FINANCE Ltd",
                                    "Value": "RELIANCE RETAIL FINANCE Ltd"
                                },
                                {
                                    "Text": "Reliance Retail Ltd",
                                    "Value": "Reliance Retail Ltd"
                                },
                                {
                                    "Text": "RELIANCE ROADS",
                                    "Value": "RELIANCE ROADS"
                                },
                                {
                                    "Text": "RELIANCE SIBUR ELASTOMERS PRIVATE Ltd",
                                    "Value": "RELIANCE SIBUR ELASTOMERS PRIVATE Ltd"
                                },
                                {
                                    "Text": "RELIANCE SUPPLY SOLUTIONS PRIVATE Ltd",
                                    "Value": "RELIANCE SUPPLY SOLUTIONS PRIVATE Ltd"
                                },
                                {
                                    "Text": "RELIANCE TRADING Ltd",
                                    "Value": "RELIANCE TRADING Ltd"
                                },
                                {
                                    "Text": "RELIANCE UNIVERSAL ENTERPRISES Ltd",
                                    "Value": "RELIANCE UNIVERSAL ENTERPRISES Ltd"
                                },
                                {
                                    "Text": "RELIANCE USA GAS MARKETING LLC",
                                    "Value": "RELIANCE USA GAS MARKETING LLC"
                                },
                                {
                                    "Text": "RELIANCE VENTURES Ltd",
                                    "Value": "RELIANCE VENTURES Ltd"
                                },
                                {
                                    "Text": "RELIANCE GRANDOPTICAL PRIVATE Ltd",
                                    "Value": "RELIANCE GRANDOPTICAL PRIVATE Ltd"
                                },
                                {
                                    "Text": "Religare Health Insurance Company Ltd",
                                    "Value": "Religare Health Insurance Company Ltd"
                                },
                                {
                                    "Text": "Renaissance Global Ltd",
                                    "Value": "Renaissance Global Ltd"
                                },
                                {
                                    "Text": "Renault India private Ltd",
                                    "Value": "Renault India private Ltd"
                                },
                                {
                                    "Text": "Renault Nissan Technical Business Centre India",
                                    "Value": "Renault Nissan Technical Business Centre India"
                                },
                                {
                                    "Text": "Repco Home Finance Ltd",
                                    "Value": "Repco Home Finance Ltd"
                                },
                                {
                                    "Text": "RGA Life Reinsurance Company of Canada India Branch",
                                    "Value": "RGA Life Reinsurance Company of Canada India Branch"
                                },
                                {
                                    "Text": "RING PLUS AQUA LTD ",
                                    "Value": "RING PLUS AQUA LTD "
                                },
                                {
                                    "Text": "RIVOLI",
                                    "Value": "RIVOLI"
                                },
                                {
                                    "Text": "Rohit Ferro Tech Ltd",
                                    "Value": "Rohit Ferro Tech Ltd"
                                },
                                {
                                    "Text": "Roots Corporation",
                                    "Value": "Roots Corporation"
                                },
                                {
                                    "Text": "Rover Logistics Freight LLC",
                                    "Value": "Rover Logistics Freight LLC"
                                },
                                {
                                    "Text": "RPG Life Sciences Ltd",
                                    "Value": "RPG Life Sciences Ltd"
                                },
                                {
                                    "Text": "Ruchi Infrastructure Ltd",
                                    "Value": "Ruchi Infrastructure Ltd"
                                },
                                {
                                    "Text": "RUNGTA MINES ",
                                    "Value": "RUNGTA MINES "
                                },
                                {
                                    "Text": "Rupee Boss Financial services Pvt Ltd",
                                    "Value": "Rupee Boss Financial services Pvt Ltd"
                                },
                                {
                                    "Text": "Rural Electrification Corporation Ltd",
                                    "Value": "Rural Electrification Corporation Ltd"
                                },
                                {
                                    "Text": "S H Kelkar and Company Ltd",
                                    "Value": "S H Kelkar and Company Ltd"
                                },
                                {
                                    "Text": "SABMILLER INDIA ",
                                    "Value": "SABMILLER INDIA "
                                },
                                {
                                    "Text": "Sadbhav Infrastructure Project Ltd",
                                    "Value": "Sadbhav Infrastructure Project Ltd"
                                },
                                {
                                    "Text": "Sakthi Sugars Ltd",
                                    "Value": "Sakthi Sugars Ltd"
                                },
                                {
                                    "Text": "SAMSUNG ELECTRONICS",
                                    "Value": "SAMSUNG ELECTRONICS"
                                },
                                {
                                    "Text": "Sandhar Technologies Ltd",
                                    "Value": "Sandhar Technologies Ltd"
                                },
                                {
                                    "Text": "Sangam  India  Ltd",
                                    "Value": "Sangam  India  Ltd"
                                },
                                {
                                    "Text": "Sanwaria Agro Oils Ltd",
                                    "Value": "Sanwaria Agro Oils Ltd"
                                },
                                {
                                    "Text": "SAP India Pvt Ltd",
                                    "Value": "SAP India Pvt Ltd"
                                },
                                {
                                    "Text": "Saraswat Co operative Bank",
                                    "Value": "Saraswat Co operative Bank"
                                },
                                {
                                    "Text": "SASKEN COMM",
                                    "Value": "SASKEN COMM"
                                },
                                {
                                    "Text": "SB ENERGY ",
                                    "Value": "SB ENERGY "
                                },
                                {
                                    "Text": "SBI Life Insurance Company Ltd",
                                    "Value": "SBI Life Insurance Company Ltd"
                                },
                                {
                                    "Text": "Schaeffler India Ltd",
                                    "Value": "Schaeffler India Ltd"
                                },
                                {
                                    "Text": "Schneider Electric India Private ",
                                    "Value": "Schneider Electric India Private "
                                },
                                {
                                    "Text": "SCOR SE   India Branch",
                                    "Value": "SCOR SE   India Branch"
                                },
                                {
                                    "Text": "Security  and  Intelligence Services India",
                                    "Value": "Security  and  Intelligence Services India"
                                },
                                {
                                    "Text": "SECURITY PRINTING  and  MINTING CORP ",
                                    "Value": "SECURITY PRINTING  and  MINTING CORP "
                                },
                                {
                                    "Text": "Sequent Scientific Ltd",
                                    "Value": "Sequent Scientific Ltd"
                                },
                                {
                                    "Text": "Service Companies of Lloyds India",
                                    "Value": "Service Companies of Lloyds India"
                                },
                                {
                                    "Text": "Sesa Sterlite Ltd",
                                    "Value": "Sesa Sterlite Ltd"
                                },
                                {
                                    "Text": "SH Kelkar  and  Co Ltd",
                                    "Value": "SH Kelkar  and  Co Ltd"
                                },
                                {
                                    "Text": "Shankara Building Products Ltd",
                                    "Value": "Shankara Building Products Ltd"
                                },
                                {
                                    "Text": "SHAPOORJI PALLONJI  and  CO ",
                                    "Value": "SHAPOORJI PALLONJI  and  CO "
                                },
                                {
                                    "Text": "Sharekhan",
                                    "Value": "Sharekhan"
                                },
                                {
                                    "Text": "SHCIL Services Ltd",
                                    "Value": "SHCIL Services Ltd"
                                },
                                {
                                    "Text": "Shell",
                                    "Value": "Shell"
                                },
                                {
                                    "Text": "Shilpa Medicare Ltd",
                                    "Value": "Shilpa Medicare Ltd"
                                },
                                {
                                    "Text": "Shipping Corporation of India Ltd",
                                    "Value": "Shipping Corporation of India Ltd"
                                },
                                {
                                    "Text": "SHIVVANI OIL",
                                    "Value": "SHIVVANI OIL"
                                },
                                {
                                    "Text": "SHREE ASHTA",
                                    "Value": "SHREE ASHTA"
                                },
                                {
                                    "Text": "Shree Cement Ltd",
                                    "Value": "Shree Cement Ltd"
                                },
                                {
                                    "Text": "SHREE GLOBAL",
                                    "Value": "SHREE GLOBAL"
                                },
                                {
                                    "Text": "Shrenuj  and  Company Ltd",
                                    "Value": "Shrenuj  and  Company Ltd"
                                },
                                {
                                    "Text": "Shri Lal Mahal ",
                                    "Value": "Shri Lal Mahal "
                                },
                                {
                                    "Text": "Shriram EPC Ltd",
                                    "Value": "Shriram EPC Ltd"
                                },
                                {
                                    "Text": "SHRIRAM LIFE INSURANCE CO LTD",
                                    "Value": "SHRIRAM LIFE INSURANCE CO LTD"
                                },
                                {
                                    "Text": "SHUBHALAKSHMI POLYESTERS ",
                                    "Value": "SHUBHALAKSHMI POLYESTERS "
                                },
                                {
                                    "Text": "Siemens India Ltd",
                                    "Value": "Siemens India Ltd"
                                },
                                {
                                    "Text": "Silver Point Printing Press",
                                    "Value": "Silver Point Printing Press"
                                },
                                {
                                    "Text": "Simplex Infrastructures Ltd",
                                    "Value": "Simplex Infrastructures Ltd"
                                },
                                {
                                    "Text": "Sintex Plastics Technology",
                                    "Value": "Sintex Plastics Technology"
                                },
                                {
                                    "Text": "Siyana Travel and Tourism LLC",
                                    "Value": "Siyana Travel and Tourism LLC"
                                },
                                {
                                    "Text": "SJVN Ltd",
                                    "Value": "SJVN Ltd"
                                },
                                {
                                    "Text": "Skipper Ltd",
                                    "Value": "Skipper Ltd"
                                },
                                {
                                    "Text": "SKS MICRO",
                                    "Value": "SKS MICRO"
                                },
                                {
                                    "Text": "SML Isuzu Ltd",
                                    "Value": "SML Isuzu Ltd"
                                },
                                {
                                    "Text": "Sobha Ltd",
                                    "Value": "Sobha Ltd"
                                },
                                {
                                    "Text": "Somany Ceramics Ltd",
                                    "Value": "Somany Ceramics Ltd"
                                },
                                {
                                    "Text": "Sonata Software Ltd",
                                    "Value": "Sonata Software Ltd"
                                },
                                {
                                    "Text": "South Indian Bank Ltd",
                                    "Value": "South Indian Bank Ltd"
                                },
                                {
                                    "Text": "Southern Roadways Ltd",
                                    "Value": "Southern Roadways Ltd"
                                },
                                {
                                    "Text": "Spencers Retail Ltd",
                                    "Value": "Spencers Retail Ltd"
                                },
                                {
                                    "Text": "SPML Infra Ltd",
                                    "Value": "SPML Infra Ltd"
                                },
                                {
                                    "Text": "SRF Ltd",
                                    "Value": "SRF Ltd"
                                },
                                {
                                    "Text": "SRS Ltd",
                                    "Value": "SRS Ltd"
                                },
                                {
                                    "Text": "ST TRAD CORP",
                                    "Value": "ST TRAD CORP"
                                },
                                {
                                    "Text": "Standard Chartered Bank",
                                    "Value": "Standard Chartered Bank"
                                },
                                {
                                    "Text": "Star Health and Allied Insurance",
                                    "Value": "Star Health and Allied Insurance"
                                },
                                {
                                    "Text": "STAR UNION DAI ICHI LIFE INSURANCE CO LTD",
                                    "Value": "STAR UNION DAI ICHI LIFE INSURANCE CO LTD"
                                },
                                {
                                    "Text": "State Bank Of Bikaner and Jaipur",
                                    "Value": "State Bank Of Bikaner and Jaipur"
                                },
                                {
                                    "Text": "State Bank of Mysore",
                                    "Value": "State Bank of Mysore"
                                },
                                {
                                    "Text": "STATE BK MYS",
                                    "Value": "STATE BK MYS"
                                },
                                {
                                    "Text": "Steel Authority of India Ltd  SAIL ",
                                    "Value": "Steel Authority of India Ltd  SAIL "
                                },
                                {
                                    "Text": "Steel Strips Wheels Ltd",
                                    "Value": "Steel Strips Wheels Ltd"
                                },
                                {
                                    "Text": "STERL INTER",
                                    "Value": "STERL INTER"
                                },
                                {
                                    "Text": "STERLING AGRO INDUSTRIES ",
                                    "Value": "STERLING AGRO INDUSTRIES "
                                },
                                {
                                    "Text": "STERLITE BIOTEC",
                                    "Value": "STERLITE BIOTEC"
                                },
                                {
                                    "Text": "Sterlite Technologies Ltd",
                                    "Value": "Sterlite Technologies Ltd"
                                },
                                {
                                    "Text": "Stovekraft  Pigeon Appliances ",
                                    "Value": "Stovekraft  Pigeon Appliances "
                                },
                                {
                                    "Text": "STRIDES ARCO",
                                    "Value": "STRIDES ARCO"
                                },
                                {
                                    "Text": "Strides Shasun Ltd",
                                    "Value": "Strides Shasun Ltd"
                                },
                                {
                                    "Text": "SUBEX LTX",
                                    "Value": "SUBEX LTX"
                                },
                                {
                                    "Text": "Sudarshan Chemical Industries Ltd",
                                    "Value": "Sudarshan Chemical Industries Ltd"
                                },
                                {
                                    "Text": "Sujana Towers Ltd",
                                    "Value": "Sujana Towers Ltd"
                                },
                                {
                                    "Text": "Sun Pharma Advanced Research Company Ltd",
                                    "Value": "Sun Pharma Advanced Research Company Ltd"
                                },
                                {
                                    "Text": "Sun TV Network Ltd",
                                    "Value": "Sun TV Network Ltd"
                                },
                                {
                                    "Text": "Sundaram Auto Components Ltd   Plastics Division",
                                    "Value": "Sundaram Auto Components Ltd   Plastics Division"
                                },
                                {
                                    "Text": "Sundaram BNP Paribas Fund Services",
                                    "Value": "Sundaram BNP Paribas Fund Services"
                                },
                                {
                                    "Text": "Sundaram Brake Linings Ltd",
                                    "Value": "Sundaram Brake Linings Ltd"
                                },
                                {
                                    "Text": "Sundaram Clayton Ltd",
                                    "Value": "Sundaram Clayton Ltd"
                                },
                                {
                                    "Text": "Sundaram Fastners",
                                    "Value": "Sundaram Fastners"
                                },
                                {
                                    "Text": "Sundaram Finance Ltd",
                                    "Value": "Sundaram Finance Ltd"
                                },
                                {
                                    "Text": "Sundaram Industries Ltd   Tyre Solutions Division",
                                    "Value": "Sundaram Industries Ltd   Tyre Solutions Division"
                                },
                                {
                                    "Text": "Sundaram Textiles Ltd",
                                    "Value": "Sundaram Textiles Ltd"
                                },
                                {
                                    "Text": "Sundram Fasteners Ltd",
                                    "Value": "Sundram Fasteners Ltd"
                                },
                                {
                                    "Text": "Sunil Hitech Engineers Ltd",
                                    "Value": "Sunil Hitech Engineers Ltd"
                                },
                                {
                                    "Text": "Sunrise Asian Ltd",
                                    "Value": "Sunrise Asian Ltd"
                                },
                                {
                                    "Text": "Sunteck Realty Ltd",
                                    "Value": "Sunteck Realty Ltd"
                                },
                                {
                                    "Text": "Suprajit Engineering Ltd",
                                    "Value": "Suprajit Engineering Ltd"
                                },
                                {
                                    "Text": "Supreme Infrastructure India Ltd",
                                    "Value": "Supreme Infrastructure India Ltd"
                                },
                                {
                                    "Text": "Surana Industries Ltd",
                                    "Value": "Surana Industries Ltd"
                                },
                                {
                                    "Text": "Suryodaya Small Finance Bank",
                                    "Value": "Suryodaya Small Finance Bank"
                                },
                                {
                                    "Text": "Suven Life Sciences Ltd",
                                    "Value": "Suven Life Sciences Ltd"
                                },
                                {
                                    "Text": "Swan Energy Ltd",
                                    "Value": "Swan Energy Ltd"
                                },
                                {
                                    "Text": "Swiss Reinsurance Company Ltd India Branch",
                                    "Value": "Swiss Reinsurance Company Ltd India Branch"
                                },
                                {
                                    "Text": "Symphony Ltd",
                                    "Value": "Symphony Ltd"
                                },
                                {
                                    "Text": "Syngene International Ltd",
                                    "Value": "Syngene International Ltd"
                                },
                                {
                                    "Text": "SYNTEL ",
                                    "Value": "SYNTEL "
                                },
                                {
                                    "Text": "TAFE Ltd",
                                    "Value": "TAFE Ltd"
                                },
                                {
                                    "Text": "Taj Air",
                                    "Value": "Taj Air"
                                },
                                {
                                    "Text": "TAL Manufacturing Solutions",
                                    "Value": "TAL Manufacturing Solutions"
                                },
                                {
                                    "Text": "Tamilnad Mercantile Bank Ltd",
                                    "Value": "Tamilnad Mercantile Bank Ltd"
                                },
                                {
                                    "Text": "Tamilnadu Newsprint  and  Papers",
                                    "Value": "Tamilnadu Newsprint  and  Papers"
                                },
                                {
                                    "Text": "TAS AGT Systems",
                                    "Value": "TAS AGT Systems"
                                },
                                {
                                    "Text": "Tasty Bite Eatables Ltd",
                                    "Value": "Tasty Bite Eatables Ltd"
                                },
                                {
                                    "Text": "Tata Advanced Systems",
                                    "Value": "Tata Advanced Systems"
                                },
                                {
                                    "Text": "Tata AG",
                                    "Value": "Tata AG"
                                },
                                {
                                    "Text": "Tata AIG General Insurance",
                                    "Value": "Tata AIG General Insurance"
                                },
                                {
                                    "Text": "Tata AutoComp Systems",
                                    "Value": "Tata AutoComp Systems"
                                },
                                {
                                    "Text": "TATA BUSINESS EXCELLENCE GROUP",
                                    "Value": "TATA BUSINESS EXCELLENCE GROUP"
                                },
                                {
                                    "Text": "Tata Capital",
                                    "Value": "Tata Capital"
                                },
                                {
                                    "Text": "Tata Chemicals Europe",
                                    "Value": "Tata Chemicals Europe"
                                },
                                {
                                    "Text": "Tata Chemicals Magadi",
                                    "Value": "Tata Chemicals Magadi"
                                },
                                {
                                    "Text": "TATA CLASSEDGE",
                                    "Value": "TATA CLASSEDGE"
                                },
                                {
                                    "Text": "Tata Communications Ltd",
                                    "Value": "Tata Communications Ltd"
                                },
                                {
                                    "Text": "TATA CONSULTANCYSERVICES",
                                    "Value": "TATA CONSULTANCYSERVICES"
                                },
                                {
                                    "Text": "Tata Consumer Products Ltd",
                                    "Value": "Tata Consumer Products Ltd"
                                },
                                {
                                    "Text": "Tata Daewoo Commercial Vehicle Company",
                                    "Value": "Tata Daewoo Commercial Vehicle Company"
                                },
                                {
                                    "Text": "Tata Global Beverages Ltd",
                                    "Value": "Tata Global Beverages Ltd"
                                },
                                {
                                    "Text": "Tata Housing Development Company",
                                    "Value": "Tata Housing Development Company"
                                },
                                {
                                    "Text": "Tata Industries",
                                    "Value": "Tata Industries"
                                },
                                {
                                    "Text": "Tata International",
                                    "Value": "Tata International"
                                },
                                {
                                    "Text": "TATA INV COR",
                                    "Value": "TATA INV COR"
                                },
                                {
                                    "Text": "Tata Investment Corporation",
                                    "Value": "Tata Investment Corporation"
                                },
                                {
                                    "Text": "Tata Ltd",
                                    "Value": "Tata Ltd"
                                },
                                {
                                    "Text": "Tata Motors",
                                    "Value": "Tata Motors"
                                },
                                {
                                    "Text": "Tata Motors European Technical Centre",
                                    "Value": "Tata Motors European Technical Centre"
                                },
                                {
                                    "Text": "Tata Motors Ltd DVR",
                                    "Value": "Tata Motors Ltd DVR"
                                },
                                {
                                    "Text": "Tata NYK",
                                    "Value": "Tata NYK"
                                },
                                {
                                    "Text": "Tata Pigments",
                                    "Value": "Tata Pigments"
                                },
                                {
                                    "Text": "Tata Power Delhi Distribution",
                                    "Value": "Tata Power Delhi Distribution"
                                },
                                {
                                    "Text": "Tata Power Trading",
                                    "Value": "Tata Power Trading"
                                },
                                {
                                    "Text": "Tata Quality Management Services",
                                    "Value": "Tata Quality Management Services"
                                },
                                {
                                    "Text": "Tata Services",
                                    "Value": "Tata Services"
                                },
                                {
                                    "Text": "Tata Sky",
                                    "Value": "Tata Sky"
                                },
                                {
                                    "Text": "Tata Sponge Iron Ltd",
                                    "Value": "Tata Sponge Iron Ltd"
                                },
                                {
                                    "Text": "Tata Steel",
                                    "Value": "Tata Steel"
                                },
                                {
                                    "Text": "Tata Steel Europe",
                                    "Value": "Tata Steel Europe"
                                },
                                {
                                    "Text": "Tata Steel Ltd",
                                    "Value": "Tata Steel Ltd"
                                },
                                {
                                    "Text": "Tata Steel Thailand",
                                    "Value": "Tata Steel Thailand"
                                },
                                {
                                    "Text": "Tata Strategic Management Group",
                                    "Value": "Tata Strategic Management Group"
                                },
                                {
                                    "Text": "Tata Technologies",
                                    "Value": "Tata Technologies"
                                },
                                {
                                    "Text": "Tata Teleservices  Maharashtra ",
                                    "Value": "Tata Teleservices  Maharashtra "
                                },
                                {
                                    "Text": "TATA TELESRV",
                                    "Value": "TATA TELESRV"
                                },
                                {
                                    "Text": "TATAGLOBAL",
                                    "Value": "TATAGLOBAL"
                                },
                                {
                                    "Text": "Tayo Rolls",
                                    "Value": "Tayo Rolls"
                                },
                                {
                                    "Text": "TCNS Clothing Co Ltd",
                                    "Value": "TCNS Clothing Co Ltd"
                                },
                                {
                                    "Text": "Team Lease Services",
                                    "Value": "Team Lease Services"
                                },
                                {
                                    "Text": "Tech Mahindra Ltd",
                                    "Value": "Tech Mahindra Ltd"
                                },
                                {
                                    "Text": "Techno Electric  and  Engineering Company Ltd",
                                    "Value": "Techno Electric  and  Engineering Company Ltd"
                                },
                                {
                                    "Text": "Tejas Networks Ltd",
                                    "Value": "Tejas Networks Ltd"
                                },
                                {
                                    "Text": "TELECOMMUNICATIONS CONSULTANTS INDIA ",
                                    "Value": "TELECOMMUNICATIONS CONSULTANTS INDIA "
                                },
                                {
                                    "Text": "Thangamayil Jewellery Ltd",
                                    "Value": "Thangamayil Jewellery Ltd"
                                },
                                {
                                    "Text": "Cosmos Co Operative Bank Ltd",
                                    "Value": "Cosmos Co Operative Bank Ltd"
                                },
                                {
                                    "Text": "Jammu  and  Kashmir Bank Ltd",
                                    "Value": "Jammu  and  Kashmir Bank Ltd"
                                },
                                {
                                    "Text": "Oriental Insurance Company",
                                    "Value": "Oriental Insurance Company"
                                },
                                {
                                    "Text": "Thermax Ltd",
                                    "Value": "Thermax Ltd"
                                },
                                {
                                    "Text": "Thyrocare Technologies Ltd",
                                    "Value": "Thyrocare Technologies Ltd"
                                },
                                {
                                    "Text": "TIFFANY FOODS LTD",
                                    "Value": "TIFFANY FOODS LTD"
                                },
                                {
                                    "Text": "Timken India Ltd",
                                    "Value": "Timken India Ltd"
                                },
                                {
                                    "Text": "Tinplate Company of India Ltd",
                                    "Value": "Tinplate Company of India Ltd"
                                },
                                {
                                    "Text": "Titagarh Wagons Ltd",
                                    "Value": "Titagarh Wagons Ltd"
                                },
                                {
                                    "Text": "TITAN IND",
                                    "Value": "TITAN IND"
                                },
                                {
                                    "Text": "TM International Logistics",
                                    "Value": "TM International Logistics"
                                },
                                {
                                    "Text": "Torrent Pharmaceuticals Ltd",
                                    "Value": "Torrent Pharmaceuticals Ltd"
                                },
                                {
                                    "Text": "TOYOTA KIRLOSKAR MOTOR ",
                                    "Value": "TOYOTA KIRLOSKAR MOTOR "
                                },
                                {
                                    "Text": "Transport Corporation of India Ltd",
                                    "Value": "Transport Corporation of India Ltd"
                                },
                                {
                                    "Text": "Trent Ltd",
                                    "Value": "Trent Ltd"
                                },
                                {
                                    "Text": "Tribhovandas Bhimji Zaveri Ltd",
                                    "Value": "Tribhovandas Bhimji Zaveri Ltd"
                                },
                                {
                                    "Text": "Trillion Gas  and  Oil field Trading",
                                    "Value": "Trillion Gas  and  Oil field Trading"
                                },
                                {
                                    "Text": "Triveni Engineering  and  Industries Ltd",
                                    "Value": "Triveni Engineering  and  Industries Ltd"
                                },
                                {
                                    "Text": "TRL Krosaki Refractories",
                                    "Value": "TRL Krosaki Refractories"
                                },
                                {
                                    "Text": "Tube Investments of India Ltd",
                                    "Value": "Tube Investments of India Ltd"
                                },
                                {
                                    "Text": "Turbo Energy Ltd",
                                    "Value": "Turbo Energy Ltd"
                                },
                                {
                                    "Text": "TV18 Broadcast Ltd",
                                    "Value": "TV18 Broadcast Ltd"
                                },
                                {
                                    "Text": "TVS Credit Services Ltd",
                                    "Value": "TVS Credit Services Ltd"
                                },
                                {
                                    "Text": "TVS Electronics Ltd",
                                    "Value": "TVS Electronics Ltd"
                                },
                                {
                                    "Text": "TVS Interconnect Systems Ltd",
                                    "Value": "TVS Interconnect Systems Ltd"
                                },
                                {
                                    "Text": "TVS Motor Company Ltd",
                                    "Value": "TVS Motor Company Ltd"
                                },
                                {
                                    "Text": "TVS Srichakra Ltd",
                                    "Value": "TVS Srichakra Ltd"
                                },
                                {
                                    "Text": "TVS Supply Chain Solutions",
                                    "Value": "TVS Supply Chain Solutions"
                                },
                                {
                                    "Text": "UAE Exchange",
                                    "Value": "UAE Exchange"
                                },
                                {
                                    "Text": "UCO Bank",
                                    "Value": "UCO Bank"
                                },
                                {
                                    "Text": "Ujjivan Financial Services Ltd",
                                    "Value": "Ujjivan Financial Services Ltd"
                                },
                                {
                                    "Text": "Ultratech Cement Ltd",
                                    "Value": "Ultratech Cement Ltd"
                                },
                                {
                                    "Text": "Unichem Laboratories Ltd",
                                    "Value": "Unichem Laboratories Ltd"
                                },
                                {
                                    "Text": "UNION NATIONAL BANK",
                                    "Value": "UNION NATIONAL BANK"
                                },
                                {
                                    "Text": "Unitech Ltd",
                                    "Value": "Unitech Ltd"
                                },
                                {
                                    "Text": "United Breweries Ltd",
                                    "Value": "United Breweries Ltd"
                                },
                                {
                                    "Text": "UNITED PHOSPOrous INDIA LTD",
                                    "Value": "UNITED PHOSPOrous INDIA LTD"
                                },
                                {
                                    "Text": "Unity Infraprojects Ltd",
                                    "Value": "Unity Infraprojects Ltd"
                                },
                                {
                                    "Text": "UP RAJYA VIDYUT UTPADAN NIGAM ",
                                    "Value": "UP RAJYA VIDYUT UTPADAN NIGAM "
                                },
                                {
                                    "Text": "Uranus Intrenationa LLC",
                                    "Value": "Uranus Intrenationa LLC"
                                },
                                {
                                    "Text": "Ushdev International Ltd",
                                    "Value": "Ushdev International Ltd"
                                },
                                {
                                    "Text": "USV ",
                                    "Value": "USV "
                                },
                                {
                                    "Text": "UTKAL ALUMINA INTERNATIONAL Ltd",
                                    "Value": "UTKAL ALUMINA INTERNATIONAL Ltd"
                                },
                                {
                                    "Text": "Utkarsh Small Finance Bank Ltd",
                                    "Value": "Utkarsh Small Finance Bank Ltd"
                                },
                                {
                                    "Text": "Uttam Value Steels Ltd",
                                    "Value": "Uttam Value Steels Ltd"
                                },
                                {
                                    "Text": "UTV SOFTWARE",
                                    "Value": "UTV SOFTWARE"
                                },
                                {
                                    "Text": "Vaibhav Global Ltd",
                                    "Value": "Vaibhav Global Ltd"
                                },
                                {
                                    "Text": "Vardhman Textiles Ltd",
                                    "Value": "Vardhman Textiles Ltd"
                                },
                                {
                                    "Text": "Varun Beverages Ltd",
                                    "Value": "Varun Beverages Ltd"
                                },
                                {
                                    "Text": "VASCON ENG",
                                    "Value": "VASCON ENG"
                                },
                                {
                                    "Text": "VENKATESHWARA HATCHERIES ",
                                    "Value": "VENKATESHWARA HATCHERIES "
                                },
                                {
                                    "Text": "V Guard Industries Ltd",
                                    "Value": "V Guard Industries Ltd"
                                },
                                {
                                    "Text": "Vijaya Bank",
                                    "Value": "Vijaya Bank"
                                },
                                {
                                    "Text": "Vimal Oil  and  Foods Ltd",
                                    "Value": "Vimal Oil  and  Foods Ltd"
                                },
                                {
                                    "Text": "Vindhya Telelinks Ltd",
                                    "Value": "Vindhya Telelinks Ltd"
                                },
                                {
                                    "Text": "VIP INDUSTRI",
                                    "Value": "VIP INDUSTRI"
                                },
                                {
                                    "Text": "VIRAJ PROFILES LTD",
                                    "Value": "VIRAJ PROFILES LTD"
                                },
                                {
                                    "Text": "VLS Finance Ltd",
                                    "Value": "VLS Finance Ltd"
                                },
                                {
                                    "Text": "Vodafone Idea Ltd",
                                    "Value": "Vodafone Idea Ltd"
                                },
                                {
                                    "Text": "VOLKSWAGEN GROUP SALES INDIA ",
                                    "Value": "VOLKSWAGEN GROUP SALES INDIA "
                                },
                                {
                                    "Text": "Voltas Ltd",
                                    "Value": "Voltas Ltd"
                                },
                                {
                                    "Text": "VRL Logistics Ltd",
                                    "Value": "VRL Logistics Ltd"
                                },
                                {
                                    "Text": "VVF INDIA ",
                                    "Value": "VVF INDIA "
                                },
                                {
                                    "Text": "WADIA TECHNO ENGINEERING SERVICES",
                                    "Value": "WADIA TECHNO ENGINEERING SERVICES"
                                },
                                {
                                    "Text": "Wall Street Finance",
                                    "Value": "Wall Street Finance"
                                },
                                {
                                    "Text": "Way2Wealth Capital Pvt Ltd",
                                    "Value": "Way2Wealth Capital Pvt Ltd"
                                },
                                {
                                    "Text": "Way2Wealth Distributors Pvt Ltd",
                                    "Value": "Way2Wealth Distributors Pvt Ltd"
                                },
                                {
                                    "Text": "Way2Wealth Insurance Brokers Pvt Ltd",
                                    "Value": "Way2Wealth Insurance Brokers Pvt Ltd"
                                },
                                {
                                    "Text": "WELCARE HOSPITAL",
                                    "Value": "WELCARE HOSPITAL"
                                },
                                {
                                    "Text": "WELLKNOWN POLYESTERS ",
                                    "Value": "WELLKNOWN POLYESTERS "
                                },
                                {
                                    "Text": "Welspun India Ltd",
                                    "Value": "Welspun India Ltd"
                                },
                                {
                                    "Text": "Westcon Middle East ",
                                    "Value": "Westcon Middle East "
                                },
                                {
                                    "Text": "Westland",
                                    "Value": "Westland"
                                },
                                {
                                    "Text": "Wheels India Ltd",
                                    "Value": "Wheels India Ltd"
                                },
                                {
                                    "Text": "WIPRO ENTERPRISES ",
                                    "Value": "WIPRO ENTERPRISES "
                                },
                                {
                                    "Text": "Wipro Ltd",
                                    "Value": "Wipro Ltd"
                                },
                                {
                                    "Text": "WNS",
                                    "Value": "WNS"
                                },
                                {
                                    "Text": "Wonderla Holidays Ltd",
                                    "Value": "Wonderla Holidays Ltd"
                                },
                                {
                                    "Text": "WS RETAIL SERVICES ",
                                    "Value": "WS RETAIL SERVICES "
                                },
                                {
                                    "Text": "X  Calibur Construction Chemistry",
                                    "Value": "X  Calibur Construction Chemistry"
                                },
                                {
                                    "Text": "YATRA",
                                    "Value": "YATRA"
                                },
                                {
                                    "Text": "Yes Bank Ltd",
                                    "Value": "Yes Bank Ltd"
                                },
                                {
                                    "Text": "ZAVERI  and  CO",
                                    "Value": "ZAVERI  and  CO"
                                },
                                {
                                    "Text": "Zee Entertainment Enterprises Ltd",
                                    "Value": "Zee Entertainment Enterprises Ltd"
                                },
                                {
                                    "Text": "Zensar Technologies Ltd",
                                    "Value": "Zensar Technologies Ltd"
                                },
                                {
                                    "Text": "Zomato",
                                    "Value": "Zomato"
                                },
                                {
                                    "Text": "ZUARI INDUST",
                                    "Value": "ZUARI INDUST"
                                },
                                {
                                    "Text": "Zydus Wellness Ltd",
                                    "Value": "Zydus Wellness Ltd"
                                },
                                {
                                    "Text": "Other",
                                    "Value": "Other"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": 50,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='housewife'&&formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='student'&&formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='Unemployed'&&formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='retired' && formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='Agriculturist'",
                            "validation": ""
                        },
                        "nameOfOrganisationOther": {
                            "id": "2583",
                            "label": "Enter name of organisation if not in list",
                            "name": "nameOfOrganisationOther",
                            "description": "Enter Name of Organization ",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['nameOfOrganisation']['input']=='Other'",
                            "validation": ""
                        },
                        "industry": {
                            "id": "1275",
                            "label": "Industry",
                            "name": "industry",
                            "description": "Industry",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Auto Ancillary",
                                    "Value": "Auto Ancillary"
                                },
                                {
                                    "Text": "Auto - Batteries",
                                    "Value": "Auto - Batteries"
                                },
                                {
                                    "Text": "Accounts",
                                    "Value": "Accounts"
                                },
                                {
                                    "Text": "Audit And Accounts",
                                    "Value": "Audit And Accounts"
                                },
                                {
                                    "Text": "Ad Agency",
                                    "Value": "Ad Agency"
                                },
                                {
                                    "Text": "Advertising",
                                    "Value": "Advertising"
                                },
                                {
                                    "Text": "Agrochemicals",
                                    "Value": "Agrochemicals"
                                },
                                {
                                    "Text": "Agriculture",
                                    "Value": "Agriculture"
                                },
                                {
                                    "Text": "Aluminium",
                                    "Value": "Aluminium"
                                },
                                {
                                    "Text": "Animal Husbandry",
                                    "Value": "Animal Husbandry"
                                },
                                {
                                    "Text": "Apparels",
                                    "Value": "Apparels"
                                },
                                {
                                    "Text": "Aquaculture",
                                    "Value": "Aquaculture"
                                },
                                {
                                    "Text": "Air Condition",
                                    "Value": "Air Condition"
                                },
                                {
                                    "Text": "Art And Culture",
                                    "Value": "Art And Culture"
                                },
                                {
                                    "Text": "Airforce",
                                    "Value": "Airforce"
                                },
                                {
                                    "Text": "Armed Forces",
                                    "Value": "Armed Forces"
                                },
                                {
                                    "Text": "Air Lines",
                                    "Value": "Air Lines"
                                },
                                {
                                    "Text": "Airlines",
                                    "Value": "Airlines"
                                },
                                {
                                    "Text": "Army",
                                    "Value": "Army"
                                },
                                {
                                    "Text": "Aeronautics",
                                    "Value": "Aeronautics"
                                },
                                {
                                    "Text": "Asbestos",
                                    "Value": "Asbestos"
                                },
                                {
                                    "Text": "Assam Rifles",
                                    "Value": "Assam Rifles"
                                },
                                {
                                    "Text": "Astrology",
                                    "Value": "Astrology"
                                },
                                {
                                    "Text": "Atomic Energy",
                                    "Value": "Atomic Energy"
                                },
                                {
                                    "Text": "Automobile",
                                    "Value": "Automobile"
                                },
                                {
                                    "Text": "Automobiles",
                                    "Value": "Automobiles"
                                },
                                {
                                    "Text": "Aviation",
                                    "Value": "Aviation"
                                },
                                {
                                    "Text": "Ayurvedic",
                                    "Value": "Ayurvedic"
                                },
                                {
                                    "Text": "B2B",
                                    "Value": "B2B"
                                },
                                {
                                    "Text": "B2C",
                                    "Value": "B2C"
                                },
                                {
                                    "Text": "Border Security Force",
                                    "Value": "Border Security Force"
                                },
                                {
                                    "Text": "Building Materials",
                                    "Value": "Building Materials"
                                },
                                {
                                    "Text": "Bearings",
                                    "Value": "Bearings"
                                },
                                {
                                    "Text": "Biotech",
                                    "Value": "Biotech"
                                },
                                {
                                    "Text": "Brick Manufacturing",
                                    "Value": "Brick Manufacturing"
                                },
                                {
                                    "Text": "Banking & Finance",
                                    "Value": "Banking & Finance"
                                },
                                {
                                    "Text": "Banking Finance And Investment",
                                    "Value": "Banking Finance And Investment"
                                },
                                {
                                    "Text": "Banking",
                                    "Value": "Banking"
                                },
                                {
                                    "Text": "BPO",
                                    "Value": "BPO"
                                },
                                {
                                    "Text": "Business",
                                    "Value": "Business"
                                },
                                {
                                    "Text": "Beauty & Cosmetics",
                                    "Value": "Beauty & Cosmetics"
                                },
                                {
                                    "Text": "Beverages",
                                    "Value": "Beverages"
                                },
                                {
                                    "Text": "Breweries & Distilleries",
                                    "Value": "Breweries & Distilleries"
                                },
                                {
                                    "Text": "Cable",
                                    "Value": "Cable"
                                },
                                {
                                    "Text": "Cable & Satellite TV",
                                    "Value": "Cable & Satellite TV"
                                },
                                {
                                    "Text": "Cell",
                                    "Value": "Cell"
                                },
                                {
                                    "Text": "Chemical",
                                    "Value": "Chemical"
                                },
                                {
                                    "Text": "Cid",
                                    "Value": "Cid"
                                },
                                {
                                    "Text": "Cinema",
                                    "Value": "Cinema"
                                },
                                {
                                    "Text": "Civil",
                                    "Value": "Civil"
                                },
                                {
                                    "Text": "Call Center",
                                    "Value": "Call Center"
                                },
                                {
                                    "Text": "Coal Mining",
                                    "Value": "Coal Mining"
                                },
                                {
                                    "Text": "Cloth",
                                    "Value": "Cloth"
                                },
                                {
                                    "Text": "Clothes",
                                    "Value": "Clothes"
                                },
                                {
                                    "Text": "Comodity Industry",
                                    "Value": "Comodity Industry"
                                },
                                {
                                    "Text": "Computers",
                                    "Value": "Computers"
                                },
                                {
                                    "Text": "Cement",
                                    "Value": "Cement"
                                },
                                {
                                    "Text": "Construction Equipment Mfg.",
                                    "Value": "Construction Equipment Mfg."
                                },
                                {
                                    "Text": "Construction",
                                    "Value": "Construction"
                                },
                                {
                                    "Text": "Consultant",
                                    "Value": "Consultant"
                                },
                                {
                                    "Text": "Cement Pipe Manufacturing",
                                    "Value": "Cement Pipe Manufacturing"
                                },
                                {
                                    "Text": "Computer Professional",
                                    "Value": "Computer Professional"
                                },
                                {
                                    "Text": "Copper",
                                    "Value": "Copper"
                                },
                                {
                                    "Text": "CPWD",
                                    "Value": "CPWD"
                                },
                                {
                                    "Text": "Circus",
                                    "Value": "Circus"
                                },
                                {
                                    "Text": "Courier And Despatch",
                                    "Value": "Courier And Despatch"
                                },
                                {
                                    "Text": "Courier",
                                    "Value": "Courier"
                                },
                                {
                                    "Text": "Clearing And Forwarding",
                                    "Value": "Clearing And Forwarding"
                                },
                                {
                                    "Text": "Ceramics",
                                    "Value": "Ceramics"
                                },
                                {
                                    "Text": "Central Reserve Police Force",
                                    "Value": "Central Reserve Police Force"
                                },
                                {
                                    "Text": "Consumer Durables",
                                    "Value": "Consumer Durables"
                                },
                                {
                                    "Text": "Customs And Excise",
                                    "Value": "Customs And Excise"
                                },
                                {
                                    "Text": "Cosmetics",
                                    "Value": "Cosmetics"
                                },
                                {
                                    "Text": "Consumer Products",
                                    "Value": "Consumer Products"
                                },
                                {
                                    "Text": "Central Excise",
                                    "Value": "Central Excise"
                                },
                                {
                                    "Text": "Central Government",
                                    "Value": "Central Government"
                                },
                                {
                                    "Text": "Central Industrial Security Force",
                                    "Value": "Central Industrial Security Force"
                                },
                                {
                                    "Text": "Content & Media",
                                    "Value": "Content & Media"
                                },
                                {
                                    "Text": "Catering",
                                    "Value": "Catering"
                                },
                                {
                                    "Text": "Cycle",
                                    "Value": "Cycle"
                                },
                                {
                                    "Text": "Defence",
                                    "Value": "Defence"
                                },
                                {
                                    "Text": "Diamond",
                                    "Value": "Diamond"
                                },
                                {
                                    "Text": "Dental",
                                    "Value": "Dental"
                                },
                                {
                                    "Text": "Doctor",
                                    "Value": "Doctor"
                                },
                                {
                                    "Text": "Docks",
                                    "Value": "Docks"
                                },
                                {
                                    "Text": "Docks And Port",
                                    "Value": "Docks And Port"
                                },
                                {
                                    "Text": "Driving",
                                    "Value": "Driving"
                                },
                                {
                                    "Text": "Dairy",
                                    "Value": "Dairy"
                                },
                                {
                                    "Text": "Distribution",
                                    "Value": "Distribution"
                                },
                                {
                                    "Text": "Detective",
                                    "Value": "Detective"
                                },
                                {
                                    "Text": "e-banking",
                                    "Value": "e-banking"
                                },
                                {
                                    "Text": "e-broking",
                                    "Value": "e-broking"
                                },
                                {
                                    "Text": "e-Commerce",
                                    "Value": "e-Commerce"
                                },
                                {
                                    "Text": "Electronics And Telecommunication",
                                    "Value": "Electronics And Telecommunication"
                                },
                                {
                                    "Text": "Electronics",
                                    "Value": "Electronics"
                                },
                                {
                                    "Text": "Electricity",
                                    "Value": "Electricity"
                                },
                                {
                                    "Text": "Education",
                                    "Value": "Education"
                                },
                                {
                                    "Text": "e-finance",
                                    "Value": "e-finance"
                                },
                                {
                                    "Text": "Electricals",
                                    "Value": "Electricals"
                                },
                                {
                                    "Text": "Event Management",
                                    "Value": "Event Management"
                                },
                                {
                                    "Text": "Engineering",
                                    "Value": "Engineering"
                                },
                                {
                                    "Text": "Engines & Gensets",
                                    "Value": "Engines & Gensets"
                                },
                                {
                                    "Text": "Entertainment",
                                    "Value": "Entertainment"
                                },
                                {
                                    "Text": "Export House",
                                    "Value": "Export House"
                                },
                                {
                                    "Text": "Emergency Serv./Law Enforcemnt",
                                    "Value": "Emergency Serv./Law Enforcemnt"
                                },
                                {
                                    "Text": "Export",
                                    "Value": "Export"
                                },
                                {
                                    "Text": "Explosives",
                                    "Value": "Explosives"
                                },
                                {
                                    "Text": "Fabrication Industry",
                                    "Value": "Fabrication Industry"
                                },
                                {
                                    "Text": "Fibre Manufacturing",
                                    "Value": "Fibre Manufacturing"
                                },
                                {
                                    "Text": "Food & Dairy Products",
                                    "Value": "Food & Dairy Products"
                                },
                                {
                                    "Text": "Fire Fighting",
                                    "Value": "Fire Fighting"
                                },
                                {
                                    "Text": "Finance",
                                    "Value": "Finance"
                                },
                                {
                                    "Text": "Fishing",
                                    "Value": "Fishing"
                                },
                                {
                                    "Text": "Fitness",
                                    "Value": "Fitness"
                                },
                                {
                                    "Text": "Film",
                                    "Value": "Film"
                                },
                                {
                                    "Text": "Fmcg",
                                    "Value": "Fmcg"
                                },
                                {
                                    "Text": "Film Industry",
                                    "Value": "Film Industry"
                                },
                                {
                                    "Text": "Food & beverages (F&B)",
                                    "Value": "Food & beverages (F&B)"
                                },
                                {
                                    "Text": "Food",
                                    "Value": "Food"
                                },
                                {
                                    "Text": "Fire Brigade",
                                    "Value": "Fire Brigade"
                                },
                                {
                                    "Text": "Forgings",
                                    "Value": "Forgings"
                                },
                                {
                                    "Text": "Farming",
                                    "Value": "Farming"
                                },
                                {
                                    "Text": "Furniture",
                                    "Value": "Furniture"
                                },
                                {
                                    "Text": "Forestry",
                                    "Value": "Forestry"
                                },
                                {
                                    "Text": "Fertilizer",
                                    "Value": "Fertilizer"
                                },
                                {
                                    "Text": "Gas Supply",
                                    "Value": "Gas Supply"
                                },
                                {
                                    "Text": "Gold",
                                    "Value": "Gold"
                                },
                                {
                                    "Text": "Glass",
                                    "Value": "Glass"
                                },
                                {
                                    "Text": "General Physician",
                                    "Value": "General Physician"
                                },
                                {
                                    "Text": "Government Officer",
                                    "Value": "Government Officer"
                                },
                                {
                                    "Text": "Government Sector",
                                    "Value": "Government Sector"
                                },
                                {
                                    "Text": "Graphic",
                                    "Value": "Graphic"
                                },
                                {
                                    "Text": "Grocery",
                                    "Value": "Grocery"
                                },
                                {
                                    "Text": "Garments",
                                    "Value": "Garments"
                                },
                                {
                                    "Text": "Greeting Cards / Gifts",
                                    "Value": "Greeting Cards / Gifts"
                                },
                                {
                                    "Text": "Healthcare",
                                    "Value": "Healthcare"
                                },
                                {
                                    "Text": "H.R.Consultancy",
                                    "Value": "H.R.Consultancy"
                                },
                                {
                                    "Text": "Handicrafts",
                                    "Value": "Handicrafts"
                                },
                                {
                                    "Text": "Handicraft",
                                    "Value": "Handicraft"
                                },
                                {
                                    "Text": "Handloom",
                                    "Value": "Handloom"
                                },
                                {
                                    "Text": "Hardware",
                                    "Value": "Hardware"
                                },
                                {
                                    "Text": "Highways",
                                    "Value": "Highways"
                                },
                                {
                                    "Text": "Household Appliances / Utensils",
                                    "Value": "Household Appliances / Utensils"
                                },
                                {
                                    "Text": "Household Products",
                                    "Value": "Household Products"
                                },
                                {
                                    "Text": "Health",
                                    "Value": "Health"
                                },
                                {
                                    "Text": "Home Loans",
                                    "Value": "Home Loans"
                                },
                                {
                                    "Text": "Homeopathy",
                                    "Value": "Homeopathy"
                                },
                                {
                                    "Text": "Housing Finance",
                                    "Value": "Housing Finance"
                                },
                                {
                                    "Text": "Hospital",
                                    "Value": "Hospital"
                                },
                                {
                                    "Text": "Hospitality",
                                    "Value": "Hospitality"
                                },
                                {
                                    "Text": "Hoisery",
                                    "Value": "Hoisery"
                                },
                                {
                                    "Text": "Hosiery",
                                    "Value": "Hosiery"
                                },
                                {
                                    "Text": "Horticulture",
                                    "Value": "Horticulture"
                                },
                                {
                                    "Text": "Hotel",
                                    "Value": "Hotel"
                                },
                                {
                                    "Text": "Housewife",
                                    "Value": "Housewife"
                                },
                                {
                                    "Text": "Income Tax",
                                    "Value": "Income Tax"
                                },
                                {
                                    "Text": "Import",
                                    "Value": "Import"
                                },
                                {
                                    "Text": "Investment Banking",
                                    "Value": "Investment Banking"
                                },
                                {
                                    "Text": "Info Communication",
                                    "Value": "Info Communication"
                                },
                                {
                                    "Text": "Information Technology",
                                    "Value": "Information Technology"
                                },
                                {
                                    "Text": "Inks",
                                    "Value": "Inks"
                                },
                                {
                                    "Text": "Insurance",
                                    "Value": "Insurance"
                                },
                                {
                                    "Text": "Interiors",
                                    "Value": "Interiors"
                                },
                                {
                                    "Text": "Instrumentation",
                                    "Value": "Instrumentation"
                                },
                                {
                                    "Text": "IT - Peripherals",
                                    "Value": "IT - Peripherals"
                                },
                                {
                                    "Text": "Import And Export",
                                    "Value": "Import And Export"
                                },
                                {
                                    "Text": "Irrigation",
                                    "Value": "Irrigation"
                                },
                                {
                                    "Text": "Iron",
                                    "Value": "Iron"
                                },
                                {
                                    "Text": "Indo - Tibetan Border Police",
                                    "Value": "Indo - Tibetan Border Police"
                                },
                                {
                                    "Text": "Interior Design",
                                    "Value": "Interior Design"
                                },
                                {
                                    "Text": "IT - Hardware",
                                    "Value": "IT - Hardware"
                                },
                                {
                                    "Text": "IT Industry",
                                    "Value": "IT Industry"
                                },
                                {
                                    "Text": "Internet",
                                    "Value": "Internet"
                                },
                                {
                                    "Text": "Journalism",
                                    "Value": "Journalism"
                                },
                                {
                                    "Text": "Jewellery",
                                    "Value": "Jewellery"
                                },
                                {
                                    "Text": "Knitwears",
                                    "Value": "Knitwears"
                                },
                                {
                                    "Text": "Kirana",
                                    "Value": "Kirana"
                                },
                                {
                                    "Text": "Leather",
                                    "Value": "Leather"
                                },
                                {
                                    "Text": "Lubricants",
                                    "Value": "Lubricants"
                                },
                                {
                                    "Text": "Labour",
                                    "Value": "Labour"
                                },
                                {
                                    "Text": "Lodge & Guest House",
                                    "Value": "Lodge & Guest House"
                                },
                                {
                                    "Text": "Legal And Justice",
                                    "Value": "Legal And Justice"
                                },
                                {
                                    "Text": "Logistics",
                                    "Value": "Logistics"
                                },
                                {
                                    "Text": "Liquor",
                                    "Value": "Liquor"
                                },
                                {
                                    "Text": "Luggage",
                                    "Value": "Luggage"
                                },
                                {
                                    "Text": "Machinery",
                                    "Value": "Machinery"
                                },
                                {
                                    "Text": "Mobile",
                                    "Value": "Mobile"
                                },
                                {
                                    "Text": "Marble Industry",
                                    "Value": "Marble Industry"
                                },
                                {
                                    "Text": "Mechanical",
                                    "Value": "Mechanical"
                                },
                                {
                                    "Text": "Medicine",
                                    "Value": "Medicine"
                                },
                                {
                                    "Text": "Medical",
                                    "Value": "Medical"
                                },
                                {
                                    "Text": "Media And Entertainment",
                                    "Value": "Media And Entertainment"
                                },
                                {
                                    "Text": "Medical Officer",
                                    "Value": "Medical Officer"
                                },
                                {
                                    "Text": "Medical Practitioner",
                                    "Value": "Medical Practitioner"
                                },
                                {
                                    "Text": "Media",
                                    "Value": "Media"
                                },
                                {
                                    "Text": "Merchant Marine",
                                    "Value": "Merchant Marine"
                                },
                                {
                                    "Text": "Merchant Navy",
                                    "Value": "Merchant Navy"
                                },
                                {
                                    "Text": "Manufacturing",
                                    "Value": "Manufacturing"
                                },
                                {
                                    "Text": "Mining",
                                    "Value": "Mining"
                                },
                                {
                                    "Text": "Mining And Quarrying",
                                    "Value": "Mining And Quarrying"
                                },
                                {
                                    "Text": "Milk Plant",
                                    "Value": "Milk Plant"
                                },
                                {
                                    "Text": "Merchant Banking",
                                    "Value": "Merchant Banking"
                                },
                                {
                                    "Text": "Marine",
                                    "Value": "Marine"
                                },
                                {
                                    "Text": "Metals",
                                    "Value": "Metals"
                                },
                                {
                                    "Text": "Motor Parts",
                                    "Value": "Motor Parts"
                                },
                                {
                                    "Text": "Motor Vehicles",
                                    "Value": "Motor Vehicles"
                                },
                                {
                                    "Text": "Music",
                                    "Value": "Music"
                                },
                                {
                                    "Text": "Navy",
                                    "Value": "Navy"
                                },
                                {
                                    "Text": "News",
                                    "Value": "News"
                                },
                                {
                                    "Text": "Non-ferrous Metals",
                                    "Value": "Non-ferrous Metals"
                                },
                                {
                                    "Text": "National Security Guard",
                                    "Value": "National Security Guard"
                                },
                                {
                                    "Text": "Office Automation",
                                    "Value": "Office Automation"
                                },
                                {
                                    "Text": "Oil",
                                    "Value": "Oil"
                                },
                                {
                                    "Text": "Oil And Lubricants",
                                    "Value": "Oil And Lubricants"
                                },
                                {
                                    "Text": "ONGC",
                                    "Value": "ONGC"
                                },
                                {
                                    "Text": "Oil And Natural Gas",
                                    "Value": "Oil And Natural Gas"
                                },
                                {
                                    "Text": "Optical",
                                    "Value": "Optical"
                                },
                                {
                                    "Text": "Ordnance",
                                    "Value": "Ordnance"
                                },
                                {
                                    "Text": "Oil Refining",
                                    "Value": "Oil Refining"
                                },
                                {
                                    "Text": "Oil Refinery",
                                    "Value": "Oil Refinery"
                                },
                                {
                                    "Text": "Oil Rig",
                                    "Value": "Oil Rig"
                                },
                                {
                                    "Text": "Outsourcing",
                                    "Value": "Outsourcing"
                                },
                                {
                                    "Text": "Other",
                                    "Value": "Other"
                                },
                                {
                                    "Text": "Power Cables",
                                    "Value": "Power Cables"
                                },
                                {
                                    "Text": "Pharmaceutical",
                                    "Value": "Pharmaceutical"
                                },
                                {
                                    "Text": "Power Equipment",
                                    "Value": "Power Equipment"
                                },
                                {
                                    "Text": "Pesticides",
                                    "Value": "Pesticides"
                                },
                                {
                                    "Text": "Poultry Farming",
                                    "Value": "Poultry Farming"
                                },
                                {
                                    "Text": "Professional",
                                    "Value": "Professional"
                                },
                                {
                                    "Text": "Paying Hobbies",
                                    "Value": "Paying Hobbies"
                                },
                                {
                                    "Text": "Property Dealing",
                                    "Value": "Property Dealing"
                                },
                                {
                                    "Text": "Pipe",
                                    "Value": "Pipe"
                                },
                                {
                                    "Text": "Placement",
                                    "Value": "Placement"
                                },
                                {
                                    "Text": "Plastics",
                                    "Value": "Plastics"
                                },
                                {
                                    "Text": "Politics",
                                    "Value": "Politics"
                                },
                                {
                                    "Text": "Plantation",
                                    "Value": "Plantation"
                                },
                                {
                                    "Text": "Pharmaceutials",
                                    "Value": "Pharmaceutials"
                                },
                                {
                                    "Text": "Paper Manufacturing",
                                    "Value": "Paper Manufacturing"
                                },
                                {
                                    "Text": "Petroleum Refinery",
                                    "Value": "Petroleum Refinery"
                                },
                                {
                                    "Text": "Printing and Stationery",
                                    "Value": "Printing and Stationery"
                                },
                                {
                                    "Text": "Paint",
                                    "Value": "Paint"
                                },
                                {
                                    "Text": "Painting",
                                    "Value": "Painting"
                                },
                                {
                                    "Text": "Police",
                                    "Value": "Police"
                                },
                                {
                                    "Text": "Port",
                                    "Value": "Port"
                                },
                                {
                                    "Text": "Public relations",
                                    "Value": "Public relations"
                                },
                                {
                                    "Text": "Priest",
                                    "Value": "Priest"
                                },
                                {
                                    "Text": "Power Supply",
                                    "Value": "Power Supply"
                                },
                                {
                                    "Text": "Petroleum",
                                    "Value": "Petroleum"
                                },
                                {
                                    "Text": "Publishing",
                                    "Value": "Publishing"
                                },
                                {
                                    "Text": "PWD",
                                    "Value": "PWD"
                                },
                                {
                                    "Text": "Power",
                                    "Value": "Power"
                                },
                                {
                                    "Text": "Polyester Yarn",
                                    "Value": "Polyester Yarn"
                                },
                                {
                                    "Text": "Physiotherapy",
                                    "Value": "Physiotherapy"
                                },
                                {
                                    "Text": "Quarrying",
                                    "Value": "Quarrying"
                                },
                                {
                                    "Text": "Radio AM & FM",
                                    "Value": "Radio AM & FM"
                                },
                                {
                                    "Text": "Roads And Construction",
                                    "Value": "Roads And Construction"
                                },
                                {
                                    "Text": "Radio",
                                    "Value": "Radio"
                                },
                                {
                                    "Text": "Roadways",
                                    "Value": "Roadways"
                                },
                                {
                                    "Text": "Real Estate",
                                    "Value": "Real Estate"
                                },
                                {
                                    "Text": "Refinery",
                                    "Value": "Refinery"
                                },
                                {
                                    "Text": "Railways",
                                    "Value": "Railways"
                                },
                                {
                                    "Text": "Research",
                                    "Value": "Research"
                                },
                                {
                                    "Text": "Retired Army Personal",
                                    "Value": "Retired Army Personal"
                                },
                                {
                                    "Text": "Retail",
                                    "Value": "Retail"
                                },
                                {
                                    "Text": "Retired",
                                    "Value": "Retired"
                                },
                                {
                                    "Text": "Rubber",
                                    "Value": "Rubber"
                                },
                                {
                                    "Text": "Sales",
                                    "Value": "Sales"
                                },
                                {
                                    "Text": "School",
                                    "Value": "School"
                                },
                                {
                                    "Text": "Security",
                                    "Value": "Security"
                                },
                                {
                                    "Text": "Social Welfare",
                                    "Value": "Social Welfare"
                                },
                                {
                                    "Text": "Sand & Granite",
                                    "Value": "Sand & Granite"
                                },
                                {
                                    "Text": "Service",
                                    "Value": "Service"
                                },
                                {
                                    "Text": "Soft Drinks",
                                    "Value": "Soft Drinks"
                                },
                                {
                                    "Text": "Software",
                                    "Value": "Software"
                                },
                                {
                                    "Text": "Sugar",
                                    "Value": "Sugar"
                                },
                                {
                                    "Text": "Shipping",
                                    "Value": "Shipping"
                                },
                                {
                                    "Text": "Shares",
                                    "Value": "Shares"
                                },
                                {
                                    "Text": "Sashastra Seema Bal",
                                    "Value": "Sashastra Seema Bal"
                                },
                                {
                                    "Text": "Silk",
                                    "Value": "Silk"
                                },
                                {
                                    "Text": "Sales And Marketing",
                                    "Value": "Sales And Marketing"
                                },
                                {
                                    "Text": "Salesman",
                                    "Value": "Salesman"
                                },
                                {
                                    "Text": "Sanitary",
                                    "Value": "Sanitary"
                                },
                                {
                                    "Text": "Ship Building",
                                    "Value": "Ship Building"
                                },
                                {
                                    "Text": "Soaps & Detergents",
                                    "Value": "Soaps & Detergents"
                                },
                                {
                                    "Text": "Special Frontier Force",
                                    "Value": "Special Frontier Force"
                                },
                                {
                                    "Text": "Sports And Games",
                                    "Value": "Sports And Games"
                                },
                                {
                                    "Text": "Sports",
                                    "Value": "Sports"
                                },
                                {
                                    "Text": "Sericulture",
                                    "Value": "Sericulture"
                                },
                                {
                                    "Text": "Surgeon",
                                    "Value": "Surgeon"
                                },
                                {
                                    "Text": "Stock Broking",
                                    "Value": "Stock Broking"
                                },
                                {
                                    "Text": "Student",
                                    "Value": "Student"
                                },
                                {
                                    "Text": "Steel",
                                    "Value": "Steel"
                                },
                                {
                                    "Text": "State Government",
                                    "Value": "State Government"
                                },
                                {
                                    "Text": "Stationary",
                                    "Value": "Stationary"
                                },
                                {
                                    "Text": "Travel And Tour",
                                    "Value": "Travel And Tour"
                                },
                                {
                                    "Text": "Taxation",
                                    "Value": "Taxation"
                                },
                                {
                                    "Text": "Tobacco & Cigarettes",
                                    "Value": "Tobacco & Cigarettes"
                                },
                                {
                                    "Text": "Teaching",
                                    "Value": "Teaching"
                                },
                                {
                                    "Text": "Telecommunications",
                                    "Value": "Telecommunications"
                                },
                                {
                                    "Text": "Technology",
                                    "Value": "Technology"
                                },
                                {
                                    "Text": "Telecom",
                                    "Value": "Telecom"
                                },
                                {
                                    "Text": "Theatre",
                                    "Value": "Theatre"
                                },
                                {
                                    "Text": "Travel Industry",
                                    "Value": "Travel Industry"
                                },
                                {
                                    "Text": "Tiles",
                                    "Value": "Tiles"
                                },
                                {
                                    "Text": "Trading",
                                    "Value": "Trading"
                                },
                                {
                                    "Text": "Trader",
                                    "Value": "Trader"
                                },
                                {
                                    "Text": "Tourism",
                                    "Value": "Tourism"
                                },
                                {
                                    "Text": "Transport",
                                    "Value": "Transport"
                                },
                                {
                                    "Text": "Tourisum",
                                    "Value": "Tourisum"
                                },
                                {
                                    "Text": "Tuition",
                                    "Value": "Tuition"
                                },
                                {
                                    "Text": "TV",
                                    "Value": "TV"
                                },
                                {
                                    "Text": "TV Broadcasting",
                                    "Value": "TV Broadcasting"
                                },
                                {
                                    "Text": "Television Production",
                                    "Value": "Television Production"
                                },
                                {
                                    "Text": "Television",
                                    "Value": "Television"
                                },
                                {
                                    "Text": "Tax And Finance",
                                    "Value": "Tax And Finance"
                                },
                                {
                                    "Text": "Textile",
                                    "Value": "Textile"
                                },
                                {
                                    "Text": "Unemployed",
                                    "Value": "Unemployed"
                                },
                                {
                                    "Text": "Unearned Income",
                                    "Value": "Unearned Income"
                                },
                                {
                                    "Text": "Veterenary",
                                    "Value": "Veterenary"
                                },
                                {
                                    "Text": "Water",
                                    "Value": "Water"
                                },
                                {
                                    "Text": "White Goods",
                                    "Value": "White Goods"
                                },
                                {
                                    "Text": "Wool",
                                    "Value": "Wool"
                                },
                                {
                                    "Text": "Watch",
                                    "Value": "Watch"
                                },
                                {
                                    "Text": "Water Treatment",
                                    "Value": "Water Treatment"
                                },
                                {
                                    "Text": "Weaving",
                                    "Value": "Weaving"
                                },
                                {
                                    "Text": "Yarn",
                                    "Value": "Yarn"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='housewife' && formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='Unemployed' && formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='retired'  ",
                            "validation": ""
                        },
                        "natureOfWork": {
                            "id": "238",
                            "label": "Nature of work",
                            "name": "natureOfWork",
                            "description": "Nature of work",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Administrator",
                                    "Value": "administrator"
                                },
                                {
                                    "Text": "Clerical",
                                    "Value": "clerical"
                                },
                                {
                                    "Text": "Manual/labor",
                                    "Value": "manual/labor"
                                },
                                {
                                    "Text": "Manager",
                                    "Value": "manager"
                                },
                                {
                                    "Text": "Mechanical",
                                    "Value": "mechanical"
                                },
                                {
                                    "Text": "Supervisor",
                                    "Value": "supervisor"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "employerAddressLine1": {
                            "id": "1379",
                            "label": "Office Address Line 1",
                            "name": "employerAddressLine1",
                            "description": "Office Address Line 1",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 30,
                            "pattern": "/^[#.0-9a-zA-Z\\s,-]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "employerAddressLine2": {
                            "id": "1380",
                            "label": "Office Address line 2",
                            "name": "employerAddressLine2",
                            "description": "Office Address line 2",
                            "mandatory": 0,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": 30,
                            "pattern": "/^[#.0-9a-zA-Z\\s,-]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "employerAddressLine3": {
                            "id": "1381",
                            "label": "Office Address Line 3",
                            "name": "employerAddressLine3",
                            "description": "Office Address Line 3",
                            "mandatory": 0,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": 30,
                            "pattern": "/^[#.0-9a-zA-Z\\s,-]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "employerLandmark": {
                            "id": "1382",
                            "label": "Office Landmark",
                            "name": "employerLandmark",
                            "description": "Office Landmark",
                            "mandatory": 0,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": 40,
                            "pattern": "/^[#.0-9a-zA-Z\\s,-]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "zipCode": {
                            "id": "1383",
                            "label": "Office Pincode",
                            "name": "zipCode",
                            "description": "Maximum 6 Numbers for Indian and 10 for NRI/OCI/PIO/FN #Zip Code of the area provided",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 6,
                            "max": 6,
                            "pattern": "/^[1-9][0-9]{5}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "city": {
                            "id": "1273",
                            "label": "Office city",
                            "name": "city",
                            "description": "Select name of city",
                            "mandatory": 0,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "",
                                    "Value": ""
                                },
                                {
                                    "Text": "MANDYA",
                                    "Value": "MANDYA"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ARMOOR",
                                    "Value": "ARMOOR"
                                },
                                {
                                    "Text": "BANSWADA",
                                    "Value": "BANSWADA"
                                },
                                {
                                    "Text": "BELLAMPALLE",
                                    "Value": "BELLAMPALLE"
                                },
                                {
                                    "Text": "BHADRACHALAM",
                                    "Value": "BHADRACHALAM"
                                },
                                {
                                    "Text": "BHAINSA",
                                    "Value": "BHAINSA"
                                },
                                {
                                    "Text": "BHONGIR",
                                    "Value": "BHONGIR"
                                },
                                {
                                    "Text": "BODHAN",
                                    "Value": "BODHAN"
                                },
                                {
                                    "Text": "BOMMAKAL",
                                    "Value": "BOMMAKAL"
                                },
                                {
                                    "Text": "CHANDANAGAR",
                                    "Value": "CHANDANAGAR"
                                },
                                {
                                    "Text": "CHIMRAJPALLE",
                                    "Value": "CHIMRAJPALLE"
                                },
                                {
                                    "Text": "CHOUTUPPAL",
                                    "Value": "CHOUTUPPAL"
                                },
                                {
                                    "Text": "DWARKA SUB CITY",
                                    "Value": "DWARKA SUB CITY"
                                },
                                {
                                    "Text": "FILM NAGAR",
                                    "Value": "FILM NAGAR"
                                },
                                {
                                    "Text": "GADWAL",
                                    "Value": "GADWAL"
                                },
                                {
                                    "Text": "GENOME VALLEY",
                                    "Value": "GENOME VALLEY"
                                },
                                {
                                    "Text": "GODAVARIKHANI",
                                    "Value": "GODAVARIKHANI"
                                },
                                {
                                    "Text": "GOPANAPALLE",
                                    "Value": "GOPANAPALLE"
                                },
                                {
                                    "Text": "GOVINDPET",
                                    "Value": "GOVINDPET"
                                },
                                {
                                    "Text": "HANUMAKONDA",
                                    "Value": "HANUMAKONDA"
                                },
                                {
                                    "Text": "HAYATNAGAR",
                                    "Value": "HAYATNAGAR"
                                },
                                {
                                    "Text": "HUNSA",
                                    "Value": "HUNSA"
                                },
                                {
                                    "Text": "HUSNABAD",
                                    "Value": "HUSNABAD"
                                },
                                {
                                    "Text": "HUZURABAD",
                                    "Value": "HUZURABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "JADCHERLA",
                                    "Value": "JADCHERLA"
                                },
                                {
                                    "Text": "JAGITYALA",
                                    "Value": "JAGITYALA"
                                },
                                {
                                    "Text": "JAMMIKUNTA",
                                    "Value": "JAMMIKUNTA"
                                },
                                {
                                    "Text": "JANGAON",
                                    "Value": "JANGAON"
                                },
                                {
                                    "Text": "JANJAON",
                                    "Value": "JANJAON"
                                },
                                {
                                    "Text": "JANKAMPET",
                                    "Value": "JANKAMPET"
                                },
                                {
                                    "Text": "JEELGUL",
                                    "Value": "JEELGUL"
                                },
                                {
                                    "Text": "JOGIPET",
                                    "Value": "JOGIPET"
                                },
                                {
                                    "Text": "K.V.RANGAREDDY",
                                    "Value": "K.V.RANGAREDDY"
                                },
                                {
                                    "Text": "KALIGOTE",
                                    "Value": "KALIGOTE"
                                },
                                {
                                    "Text": "KALWAKURTHY",
                                    "Value": "KALWAKURTHY"
                                },
                                {
                                    "Text": "KAMAREDDY",
                                    "Value": "KAMAREDDY"
                                },
                                {
                                    "Text": "KAPRA",
                                    "Value": "KAPRA"
                                },
                                {
                                    "Text": "KARIM NAGAR",
                                    "Value": "KARIM NAGAR"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KASIBUGGA",
                                    "Value": "KASIBUGGA"
                                },
                                {
                                    "Text": "KHAMMAM",
                                    "Value": "KHAMMAM"
                                },
                                {
                                    "Text": "KODADA",
                                    "Value": "KODADA"
                                },
                                {
                                    "Text": "KODAD",
                                    "Value": "KODAD"
                                },
                                {
                                    "Text": "KOMPALLE",
                                    "Value": "KOMPALLE"
                                },
                                {
                                    "Text": "KONDAGATTU",
                                    "Value": "KONDAGATTU"
                                },
                                {
                                    "Text": "KONDAPUR",
                                    "Value": "KONDAPUR"
                                },
                                {
                                    "Text": "KORATLA",
                                    "Value": "KORATLA"
                                },
                                {
                                    "Text": "KOTHAGUDEM",
                                    "Value": "KOTHAGUDEM"
                                },
                                {
                                    "Text": "KOTHAPALLE",
                                    "Value": "KOTHAPALLE"
                                },
                                {
                                    "Text": "KUKATPALLY",
                                    "Value": "KUKATPALLY"
                                },
                                {
                                    "Text": "LAXITTIPET",
                                    "Value": "LAXITTIPET"
                                },
                                {
                                    "Text": "MAHABUB NAGAR",
                                    "Value": "MAHABUB NAGAR"
                                },
                                {
                                    "Text": "MAHABUBNAGAR",
                                    "Value": "MAHABUBNAGAR"
                                },
                                {
                                    "Text": "MAHABUBABAD",
                                    "Value": "MAHABUBABAD"
                                },
                                {
                                    "Text": "MANCHERIAL",
                                    "Value": "MANCHERIAL"
                                },
                                {
                                    "Text": "MANTHANI",
                                    "Value": "MANTHANI"
                                },
                                {
                                    "Text": "MEDAK",
                                    "Value": "MEDAK"
                                },
                                {
                                    "Text": "MEDCHAL",
                                    "Value": "MEDCHAL"
                                },
                                {
                                    "Text": "MEHBUBNAGAR",
                                    "Value": "MEHBUBNAGAR"
                                },
                                {
                                    "Text": "METPALLE",
                                    "Value": "METPALLE"
                                },
                                {
                                    "Text": "MIRYALGUDA",
                                    "Value": "MIRYALGUDA"
                                },
                                {
                                    "Text": "MUGPAL",
                                    "Value": "MUGPAL"
                                },
                                {
                                    "Text": "MUNPALLE",
                                    "Value": "MUNPALLE"
                                },
                                {
                                    "Text": "NADEPALLE",
                                    "Value": "NADEPALLE"
                                },
                                {
                                    "Text": "NAKREKAL",
                                    "Value": "NAKREKAL"
                                },
                                {
                                    "Text": "NALGONDA",
                                    "Value": "NALGONDA"
                                },
                                {
                                    "Text": "NARASAMPET",
                                    "Value": "NARASAMPET"
                                },
                                {
                                    "Text": "NARAYANPET",
                                    "Value": "NARAYANPET"
                                },
                                {
                                    "Text": "NARSAMPET",
                                    "Value": "NARSAMPET"
                                },
                                {
                                    "Text": "NIRMAL",
                                    "Value": "NIRMAL"
                                },
                                {
                                    "Text": "NIZAMABAD",
                                    "Value": "NIZAMABAD"
                                },
                                {
                                    "Text": "PACHCHUNUR",
                                    "Value": "PACHCHUNUR"
                                },
                                {
                                    "Text": "PALWANCHA",
                                    "Value": "PALWANCHA"
                                },
                                {
                                    "Text": "PARKAL",
                                    "Value": "PARKAL"
                                },
                                {
                                    "Text": "PATANCHERU",
                                    "Value": "PATANCHERU"
                                },
                                {
                                    "Text": "PEDDAPALLE",
                                    "Value": "PEDDAPALLE"
                                },
                                {
                                    "Text": "PEDDAPUR",
                                    "Value": "PEDDAPUR"
                                },
                                {
                                    "Text": "PEGADAPALLI",
                                    "Value": "PEGADAPALLI"
                                },
                                {
                                    "Text": "RAGHAVAPET",
                                    "Value": "RAGHAVAPET"
                                },
                                {
                                    "Text": "RAMAGUNDAM",
                                    "Value": "RAMAGUNDAM"
                                },
                                {
                                    "Text": "RANGAREDDI",
                                    "Value": "RANGAREDDI"
                                },
                                {
                                    "Text": "RANGAREDDY",
                                    "Value": "RANGAREDDY"
                                },
                                {
                                    "Text": "REDDIPALLE",
                                    "Value": "REDDIPALLE"
                                },
                                {
                                    "Text": "SATHUPALLE",
                                    "Value": "SATHUPALLE"
                                },
                                {
                                    "Text": "SECUNDERABAD",
                                    "Value": "SECUNDERABAD"
                                },
                                {
                                    "Text": "SECUNDERABAD CANTT.",
                                    "Value": "SECUNDERABAD CANTT."
                                },
                                {
                                    "Text": "SHADNAGAR",
                                    "Value": "SHADNAGAR"
                                },
                                {
                                    "Text": "SHAMSHABAD",
                                    "Value": "SHAMSHABAD"
                                },
                                {
                                    "Text": "SHANKARPALLY",
                                    "Value": "SHANKARPALLY"
                                },
                                {
                                    "Text": "SIDDIPET",
                                    "Value": "SIDDIPET"
                                },
                                {
                                    "Text": "SIRCILLA",
                                    "Value": "SIRCILLA"
                                },
                                {
                                    "Text": "SULTANABAD",
                                    "Value": "SULTANABAD"
                                },
                                {
                                    "Text": "SURYAPET",
                                    "Value": "SURYAPET"
                                },
                                {
                                    "Text": "TANDUR",
                                    "Value": "TANDUR"
                                },
                                {
                                    "Text": "THADIKAL",
                                    "Value": "THADIKAL"
                                },
                                {
                                    "Text": "VANNEL K",
                                    "Value": "VANNEL K"
                                },
                                {
                                    "Text": "VEMULAKURTHI",
                                    "Value": "VEMULAKURTHI"
                                },
                                {
                                    "Text": "VEMULAWADA",
                                    "Value": "VEMULAWADA"
                                },
                                {
                                    "Text": "VICARABAD",
                                    "Value": "VICARABAD"
                                },
                                {
                                    "Text": "WANAPARTHY",
                                    "Value": "WANAPARTHY"
                                },
                                {
                                    "Text": "WARANGAL",
                                    "Value": "WARANGAL"
                                },
                                {
                                    "Text": "ZAHIRABAD",
                                    "Value": "ZAHIRABAD"
                                },
                                {
                                    "Text": "ABOHAR",
                                    "Value": "ABOHAR"
                                },
                                {
                                    "Text": "ABU DHABI",
                                    "Value": "ABU DHABI"
                                },
                                {
                                    "Text": "ABU ROAD",
                                    "Value": "ABU ROAD"
                                },
                                {
                                    "Text": "ACHALPUR",
                                    "Value": "ACHALPUR"
                                },
                                {
                                    "Text": "ADALAJ",
                                    "Value": "ADALAJ"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMWAL",
                                    "Value": "ADAMWAL"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADARCHAK ",
                                    "Value": "ADARCHAK "
                                },
                                {
                                    "Text": "ADAVDEVULAPALLY ",
                                    "Value": "ADAVDEVULAPALLY "
                                },
                                {
                                    "Text": "ADDANKI",
                                    "Value": "ADDANKI"
                                },
                                {
                                    "Text": "ADHARTAL",
                                    "Value": "ADHARTAL"
                                },
                                {
                                    "Text": "ADHEWADA",
                                    "Value": "ADHEWADA"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ADIMALI",
                                    "Value": "ADIMALI"
                                },
                                {
                                    "Text": "ADIPUR",
                                    "Value": "ADIPUR"
                                },
                                {
                                    "Text": "ADITYAPUR",
                                    "Value": "ADITYAPUR"
                                },
                                {
                                    "Text": "ADAJAN",
                                    "Value": "ADAJAN"
                                },
                                {
                                    "Text": "ADLOOR ",
                                    "Value": "ADLOOR "
                                },
                                {
                                    "Text": "AZAD NAGAR",
                                    "Value": "AZAD NAGAR"
                                },
                                {
                                    "Text": "ADONI",
                                    "Value": "ADONI"
                                },
                                {
                                    "Text": "ADOOR",
                                    "Value": "ADOOR"
                                },
                                {
                                    "Text": "AGARTALA",
                                    "Value": "AGARTALA"
                                },
                                {
                                    "Text": "AGAR",
                                    "Value": "AGAR"
                                },
                                {
                                    "Text": "AGASHI",
                                    "Value": "AGASHI"
                                },
                                {
                                    "Text": "AGONDA",
                                    "Value": "AGONDA"
                                },
                                {
                                    "Text": "AGONDH",
                                    "Value": "AGONDH"
                                },
                                {
                                    "Text": "AGRA",
                                    "Value": "AGRA"
                                },
                                {
                                    "Text": "AGROHA",
                                    "Value": "AGROHA"
                                },
                                {
                                    "Text": "ACHABAL",
                                    "Value": "ACHABAL"
                                },
                                {
                                    "Text": "AHMADPUR",
                                    "Value": "AHMADPUR"
                                },
                                {
                                    "Text": "AHMEDNAGAR",
                                    "Value": "AHMEDNAGAR"
                                },
                                {
                                    "Text": "AHMEDPUR",
                                    "Value": "AHMEDPUR"
                                },
                                {
                                    "Text": "AHMEDGARH",
                                    "Value": "AHMEDGARH"
                                },
                                {
                                    "Text": "AHMED NAGAR",
                                    "Value": "AHMED NAGAR"
                                },
                                {
                                    "Text": "AHMEDABAD",
                                    "Value": "AHMEDABAD"
                                },
                                {
                                    "Text": "AHMEDPUR ",
                                    "Value": "AHMEDPUR "
                                },
                                {
                                    "Text": "AHRWAN",
                                    "Value": "AHRWAN"
                                },
                                {
                                    "Text": "AIROLI",
                                    "Value": "AIROLI"
                                },
                                {
                                    "Text": "AIZAWL",
                                    "Value": "AIZAWL"
                                },
                                {
                                    "Text": "AJEETGARH",
                                    "Value": "AJEETGARH"
                                },
                                {
                                    "Text": "AJGAIN",
                                    "Value": "AJGAIN"
                                },
                                {
                                    "Text": "AJIT WAL",
                                    "Value": "AJIT WAL"
                                },
                                {
                                    "Text": "AJMER",
                                    "Value": "AJMER"
                                },
                                {
                                    "Text": "AJNALA",
                                    "Value": "AJNALA"
                                },
                                {
                                    "Text": "AJOD",
                                    "Value": "AJOD"
                                },
                                {
                                    "Text": "AJOL",
                                    "Value": "AJOL"
                                },
                                {
                                    "Text": "AKALTARA",
                                    "Value": "AKALTARA"
                                },
                                {
                                    "Text": "AKBARPUR",
                                    "Value": "AKBARPUR"
                                },
                                {
                                    "Text": "AKCHA",
                                    "Value": "AKCHA"
                                },
                                {
                                    "Text": "AKHNOOR",
                                    "Value": "AKHNOOR"
                                },
                                {
                                    "Text": "AKIVIDU",
                                    "Value": "AKIVIDU"
                                },
                                {
                                    "Text": "AKKAMPETA ",
                                    "Value": "AKKAMPETA "
                                },
                                {
                                    "Text": "AKKALKUWA",
                                    "Value": "AKKALKUWA"
                                },
                                {
                                    "Text": "AKKULAPETA ",
                                    "Value": "AKKULAPETA "
                                },
                                {
                                    "Text": "AKLUJ",
                                    "Value": "AKLUJ"
                                },
                                {
                                    "Text": "AKOLA",
                                    "Value": "AKOLA"
                                },
                                {
                                    "Text": "AKOT",
                                    "Value": "AKOT"
                                },
                                {
                                    "Text": "ALAGADAPA ",
                                    "Value": "ALAGADAPA "
                                },
                                {
                                    "Text": "ALAIR ",
                                    "Value": "ALAIR "
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ALAPPUZHA",
                                    "Value": "ALAPPUZHA"
                                },
                                {
                                    "Text": "ALAS",
                                    "Value": "ALAS"
                                },
                                {
                                    "Text": "ALATHUR",
                                    "Value": "ALATHUR"
                                },
                                {
                                    "Text": "ALDONA",
                                    "Value": "ALDONA"
                                },
                                {
                                    "Text": "ALHADPURA",
                                    "Value": "ALHADPURA"
                                },
                                {
                                    "Text": "ALIBAG",
                                    "Value": "ALIBAG"
                                },
                                {
                                    "Text": "ALIGANJ",
                                    "Value": "ALIGANJ"
                                },
                                {
                                    "Text": "ALIGARH",
                                    "Value": "ALIGARH"
                                },
                                {
                                    "Text": "ALIKAM ",
                                    "Value": "ALIKAM "
                                },
                                {
                                    "Text": "ALI PUR",
                                    "Value": "ALI PUR"
                                },
                                {
                                    "Text": "ALIPUR",
                                    "Value": "ALIPUR"
                                },
                                {
                                    "Text": "ALIPURDUAR",
                                    "Value": "ALIPURDUAR"
                                },
                                {
                                    "Text": "ALIRAJPUR",
                                    "Value": "ALIRAJPUR"
                                },
                                {
                                    "Text": "ALLAHABAD",
                                    "Value": "ALLAHABAD"
                                },
                                {
                                    "Text": "ALLAMPALLI .",
                                    "Value": "ALLAMPALLI ."
                                },
                                {
                                    "Text": "ALLAGADDA",
                                    "Value": "ALLAGADDA"
                                },
                                {
                                    "Text": "ALMORA",
                                    "Value": "ALMORA"
                                },
                                {
                                    "Text": "ALOOR ",
                                    "Value": "ALOOR "
                                },
                                {
                                    "Text": "ALLEPPEY",
                                    "Value": "ALLEPPEY"
                                },
                                {
                                    "Text": "ALUVA",
                                    "Value": "ALUVA"
                                },
                                {
                                    "Text": "ALWAYE",
                                    "Value": "ALWAYE"
                                },
                                {
                                    "Text": "ALWAR",
                                    "Value": "ALWAR"
                                },
                                {
                                    "Text": "AMALNER",
                                    "Value": "AMALNER"
                                },
                                {
                                    "Text": "AMALAPURAM",
                                    "Value": "AMALAPURAM"
                                },
                                {
                                    "Text": "AMALSAD",
                                    "Value": "AMALSAD"
                                },
                                {
                                    "Text": "AMANGALA ",
                                    "Value": "AMANGALA "
                                },
                                {
                                    "Text": "AMARGARH",
                                    "Value": "AMARGARH"
                                },
                                {
                                    "Text": "AMARKOT",
                                    "Value": "AMARKOT"
                                },
                                {
                                    "Text": "AMBAJI",
                                    "Value": "AMBAJI"
                                },
                                {
                                    "Text": "AMBALA",
                                    "Value": "AMBALA"
                                },
                                {
                                    "Text": "AMBAKAPALLE ",
                                    "Value": "AMBAKAPALLE "
                                },
                                {
                                    "Text": "AMBALATHADI ",
                                    "Value": "AMBALATHADI "
                                },
                                {
                                    "Text": "AMBALA CANTT",
                                    "Value": "AMBALA CANTT"
                                },
                                {
                                    "Text": "AMBALA CITY",
                                    "Value": "AMBALA CITY"
                                },
                                {
                                    "Text": "AMBEJOGAI",
                                    "Value": "AMBEJOGAI"
                                },
                                {
                                    "Text": "AMBERNATH",
                                    "Value": "AMBERNATH"
                                },
                                {
                                    "Text": "AMBEDKAR NAGAR",
                                    "Value": "AMBEDKAR NAGAR"
                                },
                                {
                                    "Text": "AMBEDKARNAGAR",
                                    "Value": "AMBEDKARNAGAR"
                                },
                                {
                                    "Text": "AMBELIM",
                                    "Value": "AMBELIM"
                                },
                                {
                                    "Text": "AMBIKAPUR",
                                    "Value": "AMBIKAPUR"
                                },
                                {
                                    "Text": "AMBARNATH",
                                    "Value": "AMBARNATH"
                                },
                                {
                                    "Text": "AMBUR",
                                    "Value": "AMBUR"
                                },
                                {
                                    "Text": "AMB",
                                    "Value": "AMB"
                                },
                                {
                                    "Text": "AMDADA",
                                    "Value": "AMDADA"
                                },
                                {
                                    "Text": "AMETHI",
                                    "Value": "AMETHI"
                                },
                                {
                                    "Text": "AMETHI",
                                    "Value": "AMETHI"
                                },
                                {
                                    "Text": "AMNAN",
                                    "Value": "AMNAN"
                                },
                                {
                                    "Text": "AMPATI",
                                    "Value": "AMPATI"
                                },
                                {
                                    "Text": "AMPATI",
                                    "Value": "AMPATI"
                                },
                                {
                                    "Text": "AMRAVATI",
                                    "Value": "AMRAVATI"
                                },
                                {
                                    "Text": "AMRAPUR",
                                    "Value": "AMRAPUR"
                                },
                                {
                                    "Text": "AMRELI",
                                    "Value": "AMRELI"
                                },
                                {
                                    "Text": "AMRITSAR",
                                    "Value": "AMRITSAR"
                                },
                                {
                                    "Text": "AMROHA",
                                    "Value": "AMROHA"
                                },
                                {
                                    "Text": "AMROLI",
                                    "Value": "AMROLI"
                                },
                                {
                                    "Text": "AMRUTH NAGAR ",
                                    "Value": "AMRUTH NAGAR "
                                },
                                {
                                    "Text": "AMTALA",
                                    "Value": "AMTALA"
                                },
                                {
                                    "Text": "ANAKAPALLE",
                                    "Value": "ANAKAPALLE"
                                },
                                {
                                    "Text": "ANANTAPUR",
                                    "Value": "ANANTAPUR"
                                },
                                {
                                    "Text": "ANANTHAPUR",
                                    "Value": "ANANTHAPUR"
                                },
                                {
                                    "Text": "ANANTNAG",
                                    "Value": "ANANTNAG"
                                },
                                {
                                    "Text": "ANANDPUR SAHIB",
                                    "Value": "ANANDPUR SAHIB"
                                },
                                {
                                    "Text": "ANAND",
                                    "Value": "ANAND"
                                },
                                {
                                    "Text": "ANANTHNAG",
                                    "Value": "ANANTHNAG"
                                },
                                {
                                    "Text": "ANANTHARAM ",
                                    "Value": "ANANTHARAM "
                                },
                                {
                                    "Text": "ANANTAGIRIPALLY ",
                                    "Value": "ANANTAGIRIPALLY "
                                },
                                {
                                    "Text": "ANAND NAGAR",
                                    "Value": "ANAND NAGAR"
                                },
                                {
                                    "Text": "ANANDPUR",
                                    "Value": "ANANDPUR"
                                },
                                {
                                    "Text": "ANASARAPUR",
                                    "Value": "ANASARAPUR"
                                },
                                {
                                    "Text": "ANATHARAM ",
                                    "Value": "ANATHARAM "
                                },
                                {
                                    "Text": "ANDAL GRAM",
                                    "Value": "ANDAL GRAM"
                                },
                                {
                                    "Text": "ANDHERI",
                                    "Value": "ANDHERI"
                                },
                                {
                                    "Text": "ANDUL",
                                    "Value": "ANDUL"
                                },
                                {
                                    "Text": "ANGAMALY",
                                    "Value": "ANGAMALY"
                                },
                                {
                                    "Text": "ANGUL",
                                    "Value": "ANGUL"
                                },
                                {
                                    "Text": "ANJAR",
                                    "Value": "ANJAR"
                                },
                                {
                                    "Text": "ANJAD",
                                    "Value": "ANJAD"
                                },
                                {
                                    "Text": "ANJAD",
                                    "Value": "ANJAD"
                                },
                                {
                                    "Text": "ANJANAPALLY ",
                                    "Value": "ANJANAPALLY "
                                },
                                {
                                    "Text": "ANJUNA",
                                    "Value": "ANJUNA"
                                },
                                {
                                    "Text": "ANKAPOOR ",
                                    "Value": "ANKAPOOR "
                                },
                                {
                                    "Text": "ANKLESHWAR",
                                    "Value": "ANKLESHWAR"
                                },
                                {
                                    "Text": "ANNARAM ",
                                    "Value": "ANNARAM "
                                },
                                {
                                    "Text": "ANNAVARAM ",
                                    "Value": "ANNAVARAM "
                                },
                                {
                                    "Text": "ANTARJAR",
                                    "Value": "ANTARJAR"
                                },
                                {
                                    "Text": "ANTPARA",
                                    "Value": "ANTPARA"
                                },
                                {
                                    "Text": "ANUGUL",
                                    "Value": "ANUGUL"
                                },
                                {
                                    "Text": "ANUPGARH",
                                    "Value": "ANUPGARH"
                                },
                                {
                                    "Text": "ANUPPUR",
                                    "Value": "ANUPPUR"
                                },
                                {
                                    "Text": "ANUPSHAHR",
                                    "Value": "ANUPSHAHR"
                                },
                                {
                                    "Text": "AONLA",
                                    "Value": "AONLA"
                                },
                                {
                                    "Text": "APPARAJPALLI ",
                                    "Value": "APPARAJPALLI "
                                },
                                {
                                    "Text": "APRA",
                                    "Value": "APRA"
                                },
                                {
                                    "Text": "ALTO PORVORIM",
                                    "Value": "ALTO PORVORIM"
                                },
                                {
                                    "Text": "ARA",
                                    "Value": "ARA"
                                },
                                {
                                    "Text": "ARAKONAM",
                                    "Value": "ARAKONAM"
                                },
                                {
                                    "Text": "ARAMBAGH",
                                    "Value": "ARAMBAGH"
                                },
                                {
                                    "Text": "ARAMPOONDI ",
                                    "Value": "ARAMPOONDI "
                                },
                                {
                                    "Text": "ARANTHANGI",
                                    "Value": "ARANTHANGI"
                                },
                                {
                                    "Text": "ARARIA",
                                    "Value": "ARARIA"
                                },
                                {
                                    "Text": "ARASIKERE",
                                    "Value": "ARASIKERE"
                                },
                                {
                                    "Text": "ARCOT",
                                    "Value": "ARCOT"
                                },
                                {
                                    "Text": "ARGUL ",
                                    "Value": "ARGUL "
                                },
                                {
                                    "Text": "ARIKAREVULA ",
                                    "Value": "ARIKAREVULA "
                                },
                                {
                                    "Text": "ARIYALUR",
                                    "Value": "ARIYALUR"
                                },
                                {
                                    "Text": "ARKKUPARAMBA ",
                                    "Value": "ARKKUPARAMBA "
                                },
                                {
                                    "Text": "ARMOOR",
                                    "Value": "ARMOOR"
                                },
                                {
                                    "Text": "ARNIWALA SHEIKH SUBHA",
                                    "Value": "ARNIWALA SHEIKH SUBHA"
                                },
                                {
                                    "Text": "ARNI",
                                    "Value": "ARNI"
                                },
                                {
                                    "Text": "ARNIWALA SHEIKH SUBHA",
                                    "Value": "ARNIWALA SHEIKH SUBHA"
                                },
                                {
                                    "Text": "ARNIWALA WAZIRAN",
                                    "Value": "ARNIWALA WAZIRAN"
                                },
                                {
                                    "Text": "ARPORA",
                                    "Value": "ARPORA"
                                },
                                {
                                    "Text": "ARRAH",
                                    "Value": "ARRAH"
                                },
                                {
                                    "Text": "ARRYAN WALA ",
                                    "Value": "ARRYAN WALA "
                                },
                                {
                                    "Text": "ARSIKERE",
                                    "Value": "ARSIKERE"
                                },
                                {
                                    "Text": "ARUPPUKKOTTAI",
                                    "Value": "ARUPPUKKOTTAI"
                                },
                                {
                                    "Text": "ARVI",
                                    "Value": "ARVI"
                                },
                                {
                                    "Text": "ARWAL",
                                    "Value": "ARWAL"
                                },
                                {
                                    "Text": "ASAFPUR",
                                    "Value": "ASAFPUR"
                                },
                                {
                                    "Text": "ASANSOL",
                                    "Value": "ASANSOL"
                                },
                                {
                                    "Text": "ASHOKNAGAR",
                                    "Value": "ASHOKNAGAR"
                                },
                                {
                                    "Text": "ASHOK NAGAR",
                                    "Value": "ASHOK NAGAR"
                                },
                                {
                                    "Text": "ASHOK NAGAR",
                                    "Value": "ASHOK NAGAR"
                                },
                                {
                                    "Text": "ASHTA",
                                    "Value": "ASHTA"
                                },
                                {
                                    "Text": "ASKA",
                                    "Value": "ASKA"
                                },
                                {
                                    "Text": "ASOLA",
                                    "Value": "ASOLA"
                                },
                                {
                                    "Text": "ASSANDH",
                                    "Value": "ASSANDH"
                                },
                                {
                                    "Text": "ASSONORA",
                                    "Value": "ASSONORA"
                                },
                                {
                                    "Text": "ASTA",
                                    "Value": "ASTA"
                                },
                                {
                                    "Text": "ATELI",
                                    "Value": "ATELI"
                                },
                                {
                                    "Text": "ATHANI",
                                    "Value": "ATHANI"
                                },
                                {
                                    "Text": "ATHANI",
                                    "Value": "ATHANI"
                                },
                                {
                                    "Text": "ATHGARH",
                                    "Value": "ATHGARH"
                                },
                                {
                                    "Text": "ATHNI",
                                    "Value": "ATHNI"
                                },
                                {
                                    "Text": "ATMAKUR",
                                    "Value": "ATMAKUR"
                                },
                                {
                                    "Text": "ATTAPUR",
                                    "Value": "ATTAPUR"
                                },
                                {
                                    "Text": "ATTARI",
                                    "Value": "ATTARI"
                                },
                                {
                                    "Text": "ATTUNGAL",
                                    "Value": "ATTUNGAL"
                                },
                                {
                                    "Text": "ATTUR",
                                    "Value": "ATTUR"
                                },
                                {
                                    "Text": "ATVELI ",
                                    "Value": "ATVELI "
                                },
                                {
                                    "Text": "AUJLA JOGI ",
                                    "Value": "AUJLA JOGI "
                                },
                                {
                                    "Text": "AUNDH",
                                    "Value": "AUNDH"
                                },
                                {
                                    "Text": "AURANGABAD",
                                    "Value": "AURANGABAD"
                                },
                                {
                                    "Text": "AURAIYA",
                                    "Value": "AURAIYA"
                                },
                                {
                                    "Text": "AURANGABAD(BH)",
                                    "Value": "AURANGABAD(BH)"
                                },
                                {
                                    "Text": "AURANGABAD",
                                    "Value": "AURANGABAD"
                                },
                                {
                                    "Text": "AUR",
                                    "Value": "AUR"
                                },
                                {
                                    "Text": "AVADI",
                                    "Value": "AVADI"
                                },
                                {
                                    "Text": "AVANASHI",
                                    "Value": "AVANASHI"
                                },
                                {
                                    "Text": "AVATHI",
                                    "Value": "AVATHI"
                                },
                                {
                                    "Text": "AWANTIPORA",
                                    "Value": "AWANTIPORA"
                                },
                                {
                                    "Text": "AYYAPPANTHANGAL",
                                    "Value": "AYYAPPANTHANGAL"
                                },
                                {
                                    "Text": "AZAMGARH",
                                    "Value": "AZAMGARH"
                                },
                                {
                                    "Text": "AZHIYANNUR",
                                    "Value": "AZHIYANNUR"
                                },
                                {
                                    "Text": "BABA SAHEB PETA ",
                                    "Value": "BABA SAHEB PETA "
                                },
                                {
                                    "Text": "BABA BAKALA",
                                    "Value": "BABA BAKALA"
                                },
                                {
                                    "Text": "BABHANAN",
                                    "Value": "BABHANAN"
                                },
                                {
                                    "Text": "BABINA",
                                    "Value": "BABINA"
                                },
                                {
                                    "Text": "BABRA",
                                    "Value": "BABRA"
                                },
                                {
                                    "Text": "BABURA ",
                                    "Value": "BABURA "
                                },
                                {
                                    "Text": "BABUGANJ",
                                    "Value": "BABUGANJ"
                                },
                                {
                                    "Text": "BACHHRAWAN",
                                    "Value": "BACHHRAWAN"
                                },
                                {
                                    "Text": "BADAKERA",
                                    "Value": "BADAKERA"
                                },
                                {
                                    "Text": "BADAL",
                                    "Value": "BADAL"
                                },
                                {
                                    "Text": "BADALI ALA SINGH",
                                    "Value": "BADALI ALA SINGH"
                                },
                                {
                                    "Text": "BADAULI",
                                    "Value": "BADAULI"
                                },
                                {
                                    "Text": "BADDI",
                                    "Value": "BADDI"
                                },
                                {
                                    "Text": "BADGAM",
                                    "Value": "BADGAM"
                                },
                                {
                                    "Text": "BADHNI KALAN",
                                    "Value": "BADHNI KALAN"
                                },
                                {
                                    "Text": "BADLAPUR",
                                    "Value": "BADLAPUR"
                                },
                                {
                                    "Text": "BADNAGAR",
                                    "Value": "BADNAGAR"
                                },
                                {
                                    "Text": "BADNAWAR",
                                    "Value": "BADNAWAR"
                                },
                                {
                                    "Text": "BADOL ",
                                    "Value": "BADOL "
                                },
                                {
                                    "Text": "BADUD",
                                    "Value": "BADUD"
                                },
                                {
                                    "Text": "BADVEL",
                                    "Value": "BADVEL"
                                },
                                {
                                    "Text": "BAGALKOT",
                                    "Value": "BAGALKOT"
                                },
                                {
                                    "Text": "BAGALKOT UHS CAMPUS ",
                                    "Value": "BAGALKOT UHS CAMPUS "
                                },
                                {
                                    "Text": "BAGALKOTE",
                                    "Value": "BAGALKOTE"
                                },
                                {
                                    "Text": "BAGDEHI",
                                    "Value": "BAGDEHI"
                                },
                                {
                                    "Text": "BAGESHWAR",
                                    "Value": "BAGESHWAR"
                                },
                                {
                                    "Text": "BAGHPAT",
                                    "Value": "BAGHPAT"
                                },
                                {
                                    "Text": "BAGHA PURANA",
                                    "Value": "BAGHA PURANA"
                                },
                                {
                                    "Text": "BAGHA",
                                    "Value": "BAGHA"
                                },
                                {
                                    "Text": "BAGNAN",
                                    "Value": "BAGNAN"
                                },
                                {
                                    "Text": "BAGPAT",
                                    "Value": "BAGPAT"
                                },
                                {
                                    "Text": "BAGPUR",
                                    "Value": "BAGPUR"
                                },
                                {
                                    "Text": "BAGRU",
                                    "Value": "BAGRU"
                                },
                                {
                                    "Text": "BAGRIAN ",
                                    "Value": "BAGRIAN "
                                },
                                {
                                    "Text": "BAHADURGARH",
                                    "Value": "BAHADURGARH"
                                },
                                {
                                    "Text": "BAHADURPUR",
                                    "Value": "BAHADURPUR"
                                },
                                {
                                    "Text": "BAHERI",
                                    "Value": "BAHERI"
                                },
                                {
                                    "Text": "BAHRAICH",
                                    "Value": "BAHRAICH"
                                },
                                {
                                    "Text": "BAHRAIN",
                                    "Value": "BAHRAIN"
                                },
                                {
                                    "Text": "BAHU JAMALPUR",
                                    "Value": "BAHU JAMALPUR"
                                },
                                {
                                    "Text": "BAIDPURA",
                                    "Value": "BAIDPURA"
                                },
                                {
                                    "Text": "BAIJNATH",
                                    "Value": "BAIJNATH"
                                },
                                {
                                    "Text": "BAIKUNTHPUR",
                                    "Value": "BAIKUNTHPUR"
                                },
                                {
                                    "Text": "BAINA",
                                    "Value": "BAINA"
                                },
                                {
                                    "Text": "BAIRAGARH",
                                    "Value": "BAIRAGARH"
                                },
                                {
                                    "Text": "BAJAHI ",
                                    "Value": "BAJAHI "
                                },
                                {
                                    "Text": "BAKARPUR",
                                    "Value": "BAKARPUR"
                                },
                                {
                                    "Text": "BAKHTIARPUR",
                                    "Value": "BAKHTIARPUR"
                                },
                                {
                                    "Text": "BANKNER",
                                    "Value": "BANKNER"
                                },
                                {
                                    "Text": "BAKSA",
                                    "Value": "BAKSA"
                                },
                                {
                                    "Text": "BALASORE",
                                    "Value": "BALASORE"
                                },
                                {
                                    "Text": "BALACHAUR",
                                    "Value": "BALACHAUR"
                                },
                                {
                                    "Text": "BALAGHAT",
                                    "Value": "BALAGHAT"
                                },
                                {
                                    "Text": "BALANGIR",
                                    "Value": "BALANGIR"
                                },
                                {
                                    "Text": "BALASINOR",
                                    "Value": "BALASINOR"
                                },
                                {
                                    "Text": "BALANA",
                                    "Value": "BALANA"
                                },
                                {
                                    "Text": "BALESWAR",
                                    "Value": "BALESWAR"
                                },
                                {
                                    "Text": "BALER KHANPUR ",
                                    "Value": "BALER KHANPUR "
                                },
                                {
                                    "Text": "BALIGHATTAM ",
                                    "Value": "BALIGHATTAM "
                                },
                                {
                                    "Text": "BALLARPUR",
                                    "Value": "BALLARPUR"
                                },
                                {
                                    "Text": "BALLIA",
                                    "Value": "BALLIA"
                                },
                                {
                                    "Text": "BALLIA",
                                    "Value": "BALLIA"
                                },
                                {
                                    "Text": "BALLA",
                                    "Value": "BALLA"
                                },
                                {
                                    "Text": "BALLABHGARH",
                                    "Value": "BALLABHGARH"
                                },
                                {
                                    "Text": "BALLARY",
                                    "Value": "BALLARY"
                                },
                                {
                                    "Text": "BALMATTA",
                                    "Value": "BALMATTA"
                                },
                                {
                                    "Text": "BALODA BAZAR",
                                    "Value": "BALODA BAZAR"
                                },
                                {
                                    "Text": "BALOTRA",
                                    "Value": "BALOTRA"
                                },
                                {
                                    "Text": "BALOD",
                                    "Value": "BALOD"
                                },
                                {
                                    "Text": "BALODA",
                                    "Value": "BALODA"
                                },
                                {
                                    "Text": "BALRAMPUR",
                                    "Value": "BALRAMPUR"
                                },
                                {
                                    "Text": "BALRAMPUR",
                                    "Value": "BALRAMPUR"
                                },
                                {
                                    "Text": "BALUGAON",
                                    "Value": "BALUGAON"
                                },
                                {
                                    "Text": "BALURGHAT",
                                    "Value": "BALURGHAT"
                                },
                                {
                                    "Text": "BAMAILA",
                                    "Value": "BAMAILA"
                                },
                                {
                                    "Text": "BAMOSANA",
                                    "Value": "BAMOSANA"
                                },
                                {
                                    "Text": "BAMRAULI KATARA",
                                    "Value": "BAMRAULI KATARA"
                                },
                                {
                                    "Text": "BAMUNARA",
                                    "Value": "BAMUNARA"
                                },
                                {
                                    "Text": "BANASKANTHA",
                                    "Value": "BANASKANTHA"
                                },
                                {
                                    "Text": "BANAPURA",
                                    "Value": "BANAPURA"
                                },
                                {
                                    "Text": "BANAGANAPALLE",
                                    "Value": "BANAGANAPALLE"
                                },
                                {
                                    "Text": "BANAS KANTHA",
                                    "Value": "BANAS KANTHA"
                                },
                                {
                                    "Text": "BANASINGA",
                                    "Value": "BANASINGA"
                                },
                                {
                                    "Text": "BANDA",
                                    "Value": "BANDA"
                                },
                                {
                                    "Text": "BANDIPUR",
                                    "Value": "BANDIPUR"
                                },
                                {
                                    "Text": "BANDRA",
                                    "Value": "BANDRA"
                                },
                                {
                                    "Text": "BANDIPORA",
                                    "Value": "BANDIPORA"
                                },
                                {
                                    "Text": "BANDIKUI",
                                    "Value": "BANDIKUI"
                                },
                                {
                                    "Text": "BANDIPORE",
                                    "Value": "BANDIPORE"
                                },
                                {
                                    "Text": "BANGA",
                                    "Value": "BANGA"
                                },
                                {
                                    "Text": "BANGALORE",
                                    "Value": "BANGALORE"
                                },
                                {
                                    "Text": "BANGALORE RURAL",
                                    "Value": "BANGALORE RURAL"
                                },
                                {
                                    "Text": "BANGARIGADDA ",
                                    "Value": "BANGARIGADDA "
                                },
                                {
                                    "Text": "BANGO DAM ",
                                    "Value": "BANGO DAM "
                                },
                                {
                                    "Text": "BANGARAPET",
                                    "Value": "BANGARAPET"
                                },
                                {
                                    "Text": "BANGARMAU",
                                    "Value": "BANGARMAU"
                                },
                                {
                                    "Text": "BANKA",
                                    "Value": "BANKA"
                                },
                                {
                                    "Text": "BANKURA",
                                    "Value": "BANKURA"
                                },
                                {
                                    "Text": "BANKATI ",
                                    "Value": "BANKATI "
                                },
                                {
                                    "Text": "BANNUR",
                                    "Value": "BANNUR"
                                },
                                {
                                    "Text": "BANS KHERI",
                                    "Value": "BANS KHERI"
                                },
                                {
                                    "Text": "BANSUR ALWAR",
                                    "Value": "BANSUR ALWAR"
                                },
                                {
                                    "Text": "BANSWARA",
                                    "Value": "BANSWARA"
                                },
                                {
                                    "Text": "BANS KHERI",
                                    "Value": "BANS KHERI"
                                },
                                {
                                    "Text": "BANSI",
                                    "Value": "BANSI"
                                },
                                {
                                    "Text": "BANSUR-ALWAR",
                                    "Value": "BANSUR-ALWAR"
                                },
                                {
                                    "Text": "BANSWADA",
                                    "Value": "BANSWADA"
                                },
                                {
                                    "Text": "BANTWAL",
                                    "Value": "BANTWAL"
                                },
                                {
                                    "Text": "BANTVAL",
                                    "Value": "BANTVAL"
                                },
                                {
                                    "Text": "BANUR",
                                    "Value": "BANUR"
                                },
                                {
                                    "Text": "BAPATLA",
                                    "Value": "BAPATLA"
                                },
                                {
                                    "Text": "BAPURASAPURAM",
                                    "Value": "BAPURASAPURAM"
                                },
                                {
                                    "Text": "BARASAT",
                                    "Value": "BARASAT"
                                },
                                {
                                    "Text": "BARAMATI",
                                    "Value": "BARAMATI"
                                },
                                {
                                    "Text": "BARABANKI",
                                    "Value": "BARABANKI"
                                },
                                {
                                    "Text": "BARAMULLA",
                                    "Value": "BARAMULLA"
                                },
                                {
                                    "Text": "BARAN",
                                    "Value": "BARAN"
                                },
                                {
                                    "Text": "BARAKAR",
                                    "Value": "BARAKAR"
                                },
                                {
                                    "Text": "BARACHIRKA ",
                                    "Value": "BARACHIRKA "
                                },
                                {
                                    "Text": "BARAMA",
                                    "Value": "BARAMA"
                                },
                                {
                                    "Text": "BARANA",
                                    "Value": "BARANA"
                                },
                                {
                                    "Text": "BARARA",
                                    "Value": "BARARA"
                                },
                                {
                                    "Text": "BARAULI",
                                    "Value": "BARAULI"
                                },
                                {
                                    "Text": "BARAUT",
                                    "Value": "BARAUT"
                                },
                                {
                                    "Text": "BARBIL",
                                    "Value": "BARBIL"
                                },
                                {
                                    "Text": "BARDEZ",
                                    "Value": "BARDEZ"
                                },
                                {
                                    "Text": "BARDOLI",
                                    "Value": "BARDOLI"
                                },
                                {
                                    "Text": "BARDHAMAN",
                                    "Value": "BARDHAMAN"
                                },
                                {
                                    "Text": "BAREILLY",
                                    "Value": "BAREILLY"
                                },
                                {
                                    "Text": "BARELI",
                                    "Value": "BARELI"
                                },
                                {
                                    "Text": "BARETHI",
                                    "Value": "BARETHI"
                                },
                                {
                                    "Text": "BAREWAL AWANNA",
                                    "Value": "BAREWAL AWANNA"
                                },
                                {
                                    "Text": "BARFUNG",
                                    "Value": "BARFUNG"
                                },
                                {
                                    "Text": "BARGARH",
                                    "Value": "BARGARH"
                                },
                                {
                                    "Text": "BARGARI",
                                    "Value": "BARGARI"
                                },
                                {
                                    "Text": "BARH",
                                    "Value": "BARH"
                                },
                                {
                                    "Text": "BARHAJ",
                                    "Value": "BARHAJ"
                                },
                                {
                                    "Text": "BARHALGANJ",
                                    "Value": "BARHALGANJ"
                                },
                                {
                                    "Text": "BARHERI BADI",
                                    "Value": "BARHERI BADI"
                                },
                                {
                                    "Text": "BARHI",
                                    "Value": "BARHI"
                                },
                                {
                                    "Text": "BARIPADA",
                                    "Value": "BARIPADA"
                                },
                                {
                                    "Text": "BARI BRAHMANA",
                                    "Value": "BARI BRAHMANA"
                                },
                                {
                                    "Text": "BARIAN KALAN",
                                    "Value": "BARIAN KALAN"
                                },
                                {
                                    "Text": "BARIWALA",
                                    "Value": "BARIWALA"
                                },
                                {
                                    "Text": "BARKATABAD",
                                    "Value": "BARKATABAD"
                                },
                                {
                                    "Text": "BARMER",
                                    "Value": "BARMER"
                                },
                                {
                                    "Text": "BARNALA",
                                    "Value": "BARNALA"
                                },
                                {
                                    "Text": "BARODA",
                                    "Value": "BARODA"
                                },
                                {
                                    "Text": "BARPETA",
                                    "Value": "BARPETA"
                                },
                                {
                                    "Text": "BARRACKPORE",
                                    "Value": "BARRACKPORE"
                                },
                                {
                                    "Text": "BARSHI",
                                    "Value": "BARSHI"
                                },
                                {
                                    "Text": "BARSAR",
                                    "Value": "BARSAR"
                                },
                                {
                                    "Text": "BARWALA",
                                    "Value": "BARWALA"
                                },
                                {
                                    "Text": "BARWANI",
                                    "Value": "BARWANI"
                                },
                                {
                                    "Text": "BARWAHA",
                                    "Value": "BARWAHA"
                                },
                                {
                                    "Text": "BARWALA",
                                    "Value": "BARWALA"
                                },
                                {
                                    "Text": "BASAR",
                                    "Value": "BASAR"
                                },
                                {
                                    "Text": "BASANTPURA ",
                                    "Value": "BASANTPURA "
                                },
                                {
                                    "Text": "BASAVAKALYAN",
                                    "Value": "BASAVAKALYAN"
                                },
                                {
                                    "Text": "BASKHARI",
                                    "Value": "BASKHARI"
                                },
                                {
                                    "Text": "BASKUSHLA",
                                    "Value": "BASKUSHLA"
                                },
                                {
                                    "Text": "BASNA",
                                    "Value": "BASNA"
                                },
                                {
                                    "Text": "BASNI SILAWANTAN",
                                    "Value": "BASNI SILAWANTAN"
                                },
                                {
                                    "Text": "BASODA",
                                    "Value": "BASODA"
                                },
                                {
                                    "Text": "BASSI PATHANA",
                                    "Value": "BASSI PATHANA"
                                },
                                {
                                    "Text": "BASTAR",
                                    "Value": "BASTAR"
                                },
                                {
                                    "Text": "BASTI",
                                    "Value": "BASTI"
                                },
                                {
                                    "Text": "BASWAPUR ",
                                    "Value": "BASWAPUR "
                                },
                                {
                                    "Text": "BATALA",
                                    "Value": "BATALA"
                                },
                                {
                                    "Text": "BATHINDA",
                                    "Value": "BATHINDA"
                                },
                                {
                                    "Text": "BATLAGUNDU",
                                    "Value": "BATLAGUNDU"
                                },
                                {
                                    "Text": "BAUDHGARH",
                                    "Value": "BAUDHGARH"
                                },
                                {
                                    "Text": "BAVLA",
                                    "Value": "BAVLA"
                                },
                                {
                                    "Text": "BAWAL",
                                    "Value": "BAWAL"
                                },
                                {
                                    "Text": "BAWANI KHERA",
                                    "Value": "BAWANI KHERA"
                                },
                                {
                                    "Text": "BAWNE PANGRI ",
                                    "Value": "BAWNE PANGRI "
                                },
                                {
                                    "Text": "BAZPUR",
                                    "Value": "BAZPUR"
                                },
                                {
                                    "Text": "BABAR PUR",
                                    "Value": "BABAR PUR"
                                },
                                {
                                    "Text": "BADHOI",
                                    "Value": "BADHOI"
                                },
                                {
                                    "Text": "BADHAIU",
                                    "Value": "BADHAIU"
                                },
                                {
                                    "Text": "BADAUN",
                                    "Value": "BADAUN"
                                },
                                {
                                    "Text": "BUDHWARIA",
                                    "Value": "BUDHWARIA"
                                },
                                {
                                    "Text": "BEAS",
                                    "Value": "BEAS"
                                },
                                {
                                    "Text": "BEAWAR",
                                    "Value": "BEAWAR"
                                },
                                {
                                    "Text": "BEBAD OHOL",
                                    "Value": "BEBAD OHOL"
                                },
                                {
                                    "Text": "BECHARAJI",
                                    "Value": "BECHARAJI"
                                },
                                {
                                    "Text": "BEDI APMC",
                                    "Value": "BEDI APMC"
                                },
                                {
                                    "Text": "BEDI-APMC",
                                    "Value": "BEDI-APMC"
                                },
                                {
                                    "Text": "BEED",
                                    "Value": "BEED"
                                },
                                {
                                    "Text": "BEGOWAL",
                                    "Value": "BEGOWAL"
                                },
                                {
                                    "Text": "BEGUM PUR",
                                    "Value": "BEGUM PUR"
                                },
                                {
                                    "Text": "BEGUSARAI",
                                    "Value": "BEGUSARAI"
                                },
                                {
                                    "Text": "BEGUN",
                                    "Value": "BEGUN"
                                },
                                {
                                    "Text": "BEHAT",
                                    "Value": "BEHAT"
                                },
                                {
                                    "Text": "BEHRAMPUR",
                                    "Value": "BEHRAMPUR"
                                },
                                {
                                    "Text": "BEHRAICH",
                                    "Value": "BEHRAICH"
                                },
                                {
                                    "Text": "BEHROR",
                                    "Value": "BEHROR"
                                },
                                {
                                    "Text": "BEHRAM",
                                    "Value": "BEHRAM"
                                },
                                {
                                    "Text": "BEHRAMPUR",
                                    "Value": "BEHRAMPUR"
                                },
                                {
                                    "Text": "BELDIH ",
                                    "Value": "BELDIH "
                                },
                                {
                                    "Text": "BELGAUM",
                                    "Value": "BELGAUM"
                                },
                                {
                                    "Text": "BELLARY",
                                    "Value": "BELLARY"
                                },
                                {
                                    "Text": "BELLAMPALLE",
                                    "Value": "BELLAMPALLE"
                                },
                                {
                                    "Text": "BELTHANGADY",
                                    "Value": "BELTHANGADY"
                                },
                                {
                                    "Text": "BELTHARA ROAD",
                                    "Value": "BELTHARA ROAD"
                                },
                                {
                                    "Text": "BELTOLA",
                                    "Value": "BELTOLA"
                                },
                                {
                                    "Text": "BEMBAL ",
                                    "Value": "BEMBAL "
                                },
                                {
                                    "Text": "BEMETARA",
                                    "Value": "BEMETARA"
                                },
                                {
                                    "Text": "BENAPUR",
                                    "Value": "BENAPUR"
                                },
                                {
                                    "Text": "BENAULIM",
                                    "Value": "BENAULIM"
                                },
                                {
                                    "Text": "BENGALURU",
                                    "Value": "BENGALURU"
                                },
                                {
                                    "Text": "BENNABHUPALAPATNAM ",
                                    "Value": "BENNABHUPALAPATNAM "
                                },
                                {
                                    "Text": "BEN",
                                    "Value": "BEN"
                                },
                                {
                                    "Text": "BERHAMPORE",
                                    "Value": "BERHAMPORE"
                                },
                                {
                                    "Text": "BESA ROAD ",
                                    "Value": "BESA ROAD "
                                },
                                {
                                    "Text": "BETASING",
                                    "Value": "BETASING"
                                },
                                {
                                    "Text": "BETIAH",
                                    "Value": "BETIAH"
                                },
                                {
                                    "Text": "BETTIAH",
                                    "Value": "BETTIAH"
                                },
                                {
                                    "Text": "BETUL",
                                    "Value": "BETUL"
                                },
                                {
                                    "Text": "BAGAHA-I",
                                    "Value": "BAGAHA-I"
                                },
                                {
                                    "Text": "BEGUMABAD BUDHANA",
                                    "Value": "BEGUMABAD BUDHANA"
                                },
                                {
                                    "Text": "BAGASARA",
                                    "Value": "BAGASARA"
                                },
                                {
                                    "Text": "BHADRA",
                                    "Value": "BHADRA"
                                },
                                {
                                    "Text": "BHACHAU",
                                    "Value": "BHACHAU"
                                },
                                {
                                    "Text": "BHADOHI",
                                    "Value": "BHADOHI"
                                },
                                {
                                    "Text": "BHADRACHALAM",
                                    "Value": "BHADRACHALAM"
                                },
                                {
                                    "Text": "BHADRAK",
                                    "Value": "BHADRAK"
                                },
                                {
                                    "Text": "BHADRAVATI",
                                    "Value": "BHADRAVATI"
                                },
                                {
                                    "Text": "BHADAUR",
                                    "Value": "BHADAUR"
                                },
                                {
                                    "Text": "BHADERWAH",
                                    "Value": "BHADERWAH"
                                },
                                {
                                    "Text": "BHADKODRA",
                                    "Value": "BHADKODRA"
                                },
                                {
                                    "Text": "BHADRAWATI",
                                    "Value": "BHADRAWATI"
                                },
                                {
                                    "Text": "BHADSON",
                                    "Value": "BHADSON"
                                },
                                {
                                    "Text": "BHAGALPUR",
                                    "Value": "BHAGALPUR"
                                },
                                {
                                    "Text": "BHAGTHALA KALAN ",
                                    "Value": "BHAGTHALA KALAN "
                                },
                                {
                                    "Text": "BHAGAN",
                                    "Value": "BHAGAN"
                                },
                                {
                                    "Text": "BHAGO MAJRA",
                                    "Value": "BHAGO MAJRA"
                                },
                                {
                                    "Text": "BHAGOKE",
                                    "Value": "BHAGOKE"
                                },
                                {
                                    "Text": "BHAGRANA",
                                    "Value": "BHAGRANA"
                                },
                                {
                                    "Text": "BHAGTA",
                                    "Value": "BHAGTA"
                                },
                                {
                                    "Text": "BHAINSA",
                                    "Value": "BHAINSA"
                                },
                                {
                                    "Text": "BHAINSORI ",
                                    "Value": "BHAINSORI "
                                },
                                {
                                    "Text": "BHAKARWADI ",
                                    "Value": "BHAKARWADI "
                                },
                                {
                                    "Text": "BHALGAMDA",
                                    "Value": "BHALGAMDA"
                                },
                                {
                                    "Text": "BHALONA ",
                                    "Value": "BHALONA "
                                },
                                {
                                    "Text": "BHALIABHOLKATENI",
                                    "Value": "BHALIABHOLKATENI"
                                },
                                {
                                    "Text": "BHALKI",
                                    "Value": "BHALKI"
                                },
                                {
                                    "Text": "BHAMARSI",
                                    "Value": "BHAMARSI"
                                },
                                {
                                    "Text": "BHAMBOLI",
                                    "Value": "BHAMBOLI"
                                },
                                {
                                    "Text": "BHANDARA",
                                    "Value": "BHANDARA"
                                },
                                {
                                    "Text": "BHANVAD",
                                    "Value": "BHANVAD"
                                },
                                {
                                    "Text": "BHANGALA",
                                    "Value": "BHANGALA"
                                },
                                {
                                    "Text": "BHANJANAGAR",
                                    "Value": "BHANJANAGAR"
                                },
                                {
                                    "Text": "BHANPURI",
                                    "Value": "BHANPURI"
                                },
                                {
                                    "Text": "BHANVAD",
                                    "Value": "BHANVAD"
                                },
                                {
                                    "Text": "BHAPAL ",
                                    "Value": "BHAPAL "
                                },
                                {
                                    "Text": "BHARATPUR",
                                    "Value": "BHARATPUR"
                                },
                                {
                                    "Text": "BHARUCH",
                                    "Value": "BHARUCH"
                                },
                                {
                                    "Text": "BHARMOUR",
                                    "Value": "BHARMOUR"
                                },
                                {
                                    "Text": "BHARNI",
                                    "Value": "BHARNI"
                                },
                                {
                                    "Text": "BHARTHANA",
                                    "Value": "BHARTHANA"
                                },
                                {
                                    "Text": "BHATPARA",
                                    "Value": "BHATPARA"
                                },
                                {
                                    "Text": "BHATAPARA",
                                    "Value": "BHATAPARA"
                                },
                                {
                                    "Text": "BHATINDA",
                                    "Value": "BHATINDA"
                                },
                                {
                                    "Text": "BHATKAL",
                                    "Value": "BHATKAL"
                                },
                                {
                                    "Text": "BHATEPURI ",
                                    "Value": "BHATEPURI "
                                },
                                {
                                    "Text": "BHATRAMARENAHALLI",
                                    "Value": "BHATRAMARENAHALLI"
                                },
                                {
                                    "Text": "BHATTIAN",
                                    "Value": "BHATTIAN"
                                },
                                {
                                    "Text": "BHATTU KALAN",
                                    "Value": "BHATTU KALAN"
                                },
                                {
                                    "Text": "BHAVNAGAR",
                                    "Value": "BHAVNAGAR"
                                },
                                {
                                    "Text": "BHAVANAGAR",
                                    "Value": "BHAVANAGAR"
                                },
                                {
                                    "Text": "BHAVANIPET ",
                                    "Value": "BHAVANIPET "
                                },
                                {
                                    "Text": "BHAWANIGARH",
                                    "Value": "BHAWANIGARH"
                                },
                                {
                                    "Text": "BHAWANIPATNA",
                                    "Value": "BHAWANIPATNA"
                                },
                                {
                                    "Text": "BHAWAI ",
                                    "Value": "BHAWAI "
                                },
                                {
                                    "Text": "BHAWANIPUR ",
                                    "Value": "BHAWANIPUR "
                                },
                                {
                                    "Text": "BHAYANDER",
                                    "Value": "BHAYANDER"
                                },
                                {
                                    "Text": "BHEDWAL ",
                                    "Value": "BHEDWAL "
                                },
                                {
                                    "Text": "BHEJGAON ",
                                    "Value": "BHEJGAON "
                                },
                                {
                                    "Text": "BHERIWADA ",
                                    "Value": "BHERIWADA "
                                },
                                {
                                    "Text": "BHALGAMDA",
                                    "Value": "BHALGAMDA"
                                },
                                {
                                    "Text": "BHIKHIWIND",
                                    "Value": "BHIKHIWIND"
                                },
                                {
                                    "Text": "BHIKHI",
                                    "Value": "BHIKHI"
                                },
                                {
                                    "Text": "BHILAI",
                                    "Value": "BHILAI"
                                },
                                {
                                    "Text": "BHILWARA",
                                    "Value": "BHILWARA"
                                },
                                {
                                    "Text": "BHILAI CHARODA",
                                    "Value": "BHILAI CHARODA"
                                },
                                {
                                    "Text": "BHIMAVARAM",
                                    "Value": "BHIMAVARAM"
                                },
                                {
                                    "Text": "BHIND",
                                    "Value": "BHIND"
                                },
                                {
                                    "Text": "BHINGA",
                                    "Value": "BHINGA"
                                },
                                {
                                    "Text": "BHINMAL",
                                    "Value": "BHINMAL"
                                },
                                {
                                    "Text": "BHIWADI",
                                    "Value": "BHIWADI"
                                },
                                {
                                    "Text": "BHIWANI",
                                    "Value": "BHIWANI"
                                },
                                {
                                    "Text": "BHANDUP",
                                    "Value": "BHANDUP"
                                },
                                {
                                    "Text": "BHODIPURA",
                                    "Value": "BHODIPURA"
                                },
                                {
                                    "Text": "BHOGPUR",
                                    "Value": "BHOGPUR"
                                },
                                {
                                    "Text": "BHOGA SAMUDRAM",
                                    "Value": "BHOGA SAMUDRAM"
                                },
                                {
                                    "Text": "BHOJPUR",
                                    "Value": "BHOJPUR"
                                },
                                {
                                    "Text": "BHOKHRA",
                                    "Value": "BHOKHRA"
                                },
                                {
                                    "Text": "BHOLATH",
                                    "Value": "BHOLATH"
                                },
                                {
                                    "Text": "BHONGIR",
                                    "Value": "BHONGIR"
                                },
                                {
                                    "Text": "BHONGIR GUNJ ",
                                    "Value": "BHONGIR GUNJ "
                                },
                                {
                                    "Text": "BHONRKA ",
                                    "Value": "BHONRKA "
                                },
                                {
                                    "Text": "BHOORA ",
                                    "Value": "BHOORA "
                                },
                                {
                                    "Text": "BHOPAL",
                                    "Value": "BHOPAL"
                                },
                                {
                                    "Text": "BHOPANI",
                                    "Value": "BHOPANI"
                                },
                                {
                                    "Text": "BHORING",
                                    "Value": "BHORING"
                                },
                                {
                                    "Text": "BHOSARI",
                                    "Value": "BHOSARI"
                                },
                                {
                                    "Text": "BIHARSHARIF",
                                    "Value": "BIHARSHARIF"
                                },
                                {
                                    "Text": "BEHTA HAJIPUR",
                                    "Value": "BEHTA HAJIPUR"
                                },
                                {
                                    "Text": "BHATI",
                                    "Value": "BHATI"
                                },
                                {
                                    "Text": "BHUBANESHWAR",
                                    "Value": "BHUBANESHWAR"
                                },
                                {
                                    "Text": "BHUBANESWAR",
                                    "Value": "BHUBANESWAR"
                                },
                                {
                                    "Text": "BHUCHO MANDI",
                                    "Value": "BHUCHO MANDI"
                                },
                                {
                                    "Text": "BHUJ",
                                    "Value": "BHUJ"
                                },
                                {
                                    "Text": "BHUJODI",
                                    "Value": "BHUJODI"
                                },
                                {
                                    "Text": "BHULATH",
                                    "Value": "BHULATH"
                                },
                                {
                                    "Text": "BHUNDRI",
                                    "Value": "BHUNDRI"
                                },
                                {
                                    "Text": "BHUNTAR",
                                    "Value": "BHUNTAR"
                                },
                                {
                                    "Text": "BHUSAWAL",
                                    "Value": "BHUSAWAL"
                                },
                                {
                                    "Text": "BHUSAWAL",
                                    "Value": "BHUSAWAL"
                                },
                                {
                                    "Text": "BIAORA",
                                    "Value": "BIAORA"
                                },
                                {
                                    "Text": "BICHOLIM",
                                    "Value": "BICHOLIM"
                                },
                                {
                                    "Text": "BIDADI",
                                    "Value": "BIDADI"
                                },
                                {
                                    "Text": "BIDAR",
                                    "Value": "BIDAR"
                                },
                                {
                                    "Text": "BIDAR",
                                    "Value": "BIDAR"
                                },
                                {
                                    "Text": "BIDALUR ",
                                    "Value": "BIDALUR "
                                },
                                {
                                    "Text": "BIDHAN NAGAR",
                                    "Value": "BIDHAN NAGAR"
                                },
                                {
                                    "Text": "BIDHUNA",
                                    "Value": "BIDHUNA"
                                },
                                {
                                    "Text": "BID",
                                    "Value": "BID"
                                },
                                {
                                    "Text": "BIHAR",
                                    "Value": "BIHAR"
                                },
                                {
                                    "Text": "BIHAT BIRAM",
                                    "Value": "BIHAT BIRAM"
                                },
                                {
                                    "Text": "BIJAINAGAR",
                                    "Value": "BIJAINAGAR"
                                },
                                {
                                    "Text": "BIJAPUR",
                                    "Value": "BIJAPUR"
                                },
                                {
                                    "Text": "BIJAPUR(CGH)",
                                    "Value": "BIJAPUR(CGH)"
                                },
                                {
                                    "Text": "BIJAPUR(KAR)",
                                    "Value": "BIJAPUR(KAR)"
                                },
                                {
                                    "Text": "BIJAPUR",
                                    "Value": "BIJAPUR"
                                },
                                {
                                    "Text": "BIJA",
                                    "Value": "BIJA"
                                },
                                {
                                    "Text": "BIJBEHARA",
                                    "Value": "BIJBEHARA"
                                },
                                {
                                    "Text": "BIJJAWARA ",
                                    "Value": "BIJJAWARA "
                                },
                                {
                                    "Text": "BIJJAWARA",
                                    "Value": "BIJJAWARA"
                                },
                                {
                                    "Text": "BIJNOR",
                                    "Value": "BIJNOR"
                                },
                                {
                                    "Text": "BIJOYNAGAR",
                                    "Value": "BIJOYNAGAR"
                                },
                                {
                                    "Text": "BIKANER",
                                    "Value": "BIKANER"
                                },
                                {
                                    "Text": "BIKRAMGANJ",
                                    "Value": "BIKRAMGANJ"
                                },
                                {
                                    "Text": "BILASPUR(CGH)",
                                    "Value": "BILASPUR(CGH)"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILARA",
                                    "Value": "BILARA"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILASPUR (HP)",
                                    "Value": "BILASPUR (HP)"
                                },
                                {
                                    "Text": "BILARI",
                                    "Value": "BILARI"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILGA",
                                    "Value": "BILGA"
                                },
                                {
                                    "Text": "BILGI",
                                    "Value": "BILGI"
                                },
                                {
                                    "Text": "BILHA",
                                    "Value": "BILHA"
                                },
                                {
                                    "Text": "BILIMORA",
                                    "Value": "BILIMORA"
                                },
                                {
                                    "Text": "BILLIMORA",
                                    "Value": "BILLIMORA"
                                },
                                {
                                    "Text": "BINA",
                                    "Value": "BINA"
                                },
                                {
                                    "Text": "BINDKI",
                                    "Value": "BINDKI"
                                },
                                {
                                    "Text": "BINDKI",
                                    "Value": "BINDKI"
                                },
                                {
                                    "Text": "BINOVANAGAR",
                                    "Value": "BINOVANAGAR"
                                },
                                {
                                    "Text": "BINOLA",
                                    "Value": "BINOLA"
                                },
                                {
                                    "Text": "BIRAMITRAPUR",
                                    "Value": "BIRAMITRAPUR"
                                },
                                {
                                    "Text": "BIRBHUM",
                                    "Value": "BIRBHUM"
                                },
                                {
                                    "Text": "BIRKONA",
                                    "Value": "BIRKONA"
                                },
                                {
                                    "Text": "BIRMITRAPUR",
                                    "Value": "BIRMITRAPUR"
                                },
                                {
                                    "Text": "BISALPUR",
                                    "Value": "BISALPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNA",
                                    "Value": "BISHNA"
                                },
                                {
                                    "Text": "BISTAULI KHURD",
                                    "Value": "BISTAULI KHURD"
                                },
                                {
                                    "Text": "BISWANATH CHAIRALI",
                                    "Value": "BISWANATH CHAIRALI"
                                },
                                {
                                    "Text": "BISWANATH CHARIALI",
                                    "Value": "BISWANATH CHARIALI"
                                },
                                {
                                    "Text": "BALIBAT",
                                    "Value": "BALIBAT"
                                },
                                {
                                    "Text": "BHILODA",
                                    "Value": "BHILODA"
                                },
                                {
                                    "Text": "BALLARD ESTATE",
                                    "Value": "BALLARD ESTATE"
                                },
                                {
                                    "Text": "BALAGUNDA (BELAGULA)",
                                    "Value": "BALAGUNDA (BELAGULA)"
                                },
                                {
                                    "Text": "BHALSWA JAHANGIR PUR",
                                    "Value": "BHALSWA JAHANGIR PUR"
                                },
                                {
                                    "Text": "BANDEL",
                                    "Value": "BANDEL"
                                },
                                {
                                    "Text": "BOBBILI",
                                    "Value": "BOBBILI"
                                },
                                {
                                    "Text": "BODAKDEV",
                                    "Value": "BODAKDEV"
                                },
                                {
                                    "Text": "BODELI",
                                    "Value": "BODELI"
                                },
                                {
                                    "Text": "BODHI BIGHA ",
                                    "Value": "BODHI BIGHA "
                                },
                                {
                                    "Text": "BODHAN",
                                    "Value": "BODHAN"
                                },
                                {
                                    "Text": "BODHGAYA",
                                    "Value": "BODHGAYA"
                                },
                                {
                                    "Text": "BODINAYAKKANNUR",
                                    "Value": "BODINAYAKKANNUR"
                                },
                                {
                                    "Text": "BOHA",
                                    "Value": "BOHA"
                                },
                                {
                                    "Text": "BOISAR",
                                    "Value": "BOISAR"
                                },
                                {
                                    "Text": "BOISAR II CHITRALAYA",
                                    "Value": "BOISAR II CHITRALAYA"
                                },
                                {
                                    "Text": "BOISAR II, CHITRALAYA",
                                    "Value": "BOISAR II, CHITRALAYA"
                                },
                                {
                                    "Text": "BOKARO",
                                    "Value": "BOKARO"
                                },
                                {
                                    "Text": "BOKAKHAT",
                                    "Value": "BOKAKHAT"
                                },
                                {
                                    "Text": "BOKAKHAT",
                                    "Value": "BOKAKHAT"
                                },
                                {
                                    "Text": "BOKKUDUPALLE ",
                                    "Value": "BOKKUDUPALLE "
                                },
                                {
                                    "Text": "BOLANGIR",
                                    "Value": "BOLANGIR"
                                },
                                {
                                    "Text": "BOLAGARH",
                                    "Value": "BOLAGARH"
                                },
                                {
                                    "Text": "BOLPUR",
                                    "Value": "BOLPUR"
                                },
                                {
                                    "Text": "BOL",
                                    "Value": "BOL"
                                },
                                {
                                    "Text": "BOMDILA",
                                    "Value": "BOMDILA"
                                },
                                {
                                    "Text": "BOMMAKAL",
                                    "Value": "BOMMAKAL"
                                },
                                {
                                    "Text": "BONGAIGAON",
                                    "Value": "BONGAIGAON"
                                },
                                {
                                    "Text": "BOPAL",
                                    "Value": "BOPAL"
                                },
                                {
                                    "Text": "BORAM ",
                                    "Value": "BORAM "
                                },
                                {
                                    "Text": "BORBATA ",
                                    "Value": "BORBATA "
                                },
                                {
                                    "Text": "BORBHATHA BET",
                                    "Value": "BORBHATHA BET"
                                },
                                {
                                    "Text": "BORGAON ",
                                    "Value": "BORGAON "
                                },
                                {
                                    "Text": "BORONILPUR",
                                    "Value": "BORONILPUR"
                                },
                                {
                                    "Text": "BORSAD",
                                    "Value": "BORSAD"
                                },
                                {
                                    "Text": "BORIVALI (W)",
                                    "Value": "BORIVALI (W)"
                                },
                                {
                                    "Text": "BOTAD",
                                    "Value": "BOTAD"
                                },
                                {
                                    "Text": "BOUDH",
                                    "Value": "BOUDH"
                                },
                                {
                                    "Text": "BOYTAWALA",
                                    "Value": "BOYTAWALA"
                                },
                                {
                                    "Text": "BASSI PATHTANA",
                                    "Value": "BASSI PATHTANA"
                                },
                                {
                                    "Text": "BRAHMANPALLI ",
                                    "Value": "BRAHMANPALLI "
                                },
                                {
                                    "Text": "BRAHMANAPALLE ",
                                    "Value": "BRAHMANAPALLE "
                                },
                                {
                                    "Text": "BRAHMAPORE",
                                    "Value": "BRAHMAPORE"
                                },
                                {
                                    "Text": "BRAHMAPUR",
                                    "Value": "BRAHMAPUR"
                                },
                                {
                                    "Text": "BRAMHAPURI",
                                    "Value": "BRAMHAPURI"
                                },
                                {
                                    "Text": "BAREJA",
                                    "Value": "BAREJA"
                                },
                                {
                                    "Text": "BRAJRAJ NAGAR",
                                    "Value": "BRAJRAJ NAGAR"
                                },
                                {
                                    "Text": "BARIK",
                                    "Value": "BARIK"
                                },
                                {
                                    "Text": "BURARI",
                                    "Value": "BURARI"
                                },
                                {
                                    "Text": "BISHALGARH",
                                    "Value": "BISHALGARH"
                                },
                                {
                                    "Text": "BISOKHAR",
                                    "Value": "BISOKHAR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "B.S.PURAM ",
                                    "Value": "B.S.PURAM "
                                },
                                {
                                    "Text": "BASIRHAT",
                                    "Value": "BASIRHAT"
                                },
                                {
                                    "Text": "BETASING",
                                    "Value": "BETASING"
                                },
                                {
                                    "Text": "BUDAUN",
                                    "Value": "BUDAUN"
                                },
                                {
                                    "Text": "BUDDUGONDA ",
                                    "Value": "BUDDUGONDA "
                                },
                                {
                                    "Text": "BUDGAM",
                                    "Value": "BUDGAM"
                                },
                                {
                                    "Text": "BUDGE BUDGE",
                                    "Value": "BUDGE BUDGE"
                                },
                                {
                                    "Text": "BUDHLADA",
                                    "Value": "BUDHLADA"
                                },
                                {
                                    "Text": "BUDH SINGH WALA ",
                                    "Value": "BUDH SINGH WALA "
                                },
                                {
                                    "Text": "BUDHALDA",
                                    "Value": "BUDHALDA"
                                },
                                {
                                    "Text": "BUDHANA",
                                    "Value": "BUDHANA"
                                },
                                {
                                    "Text": "BUDHERA",
                                    "Value": "BUDHERA"
                                },
                                {
                                    "Text": "BULANDSHARE",
                                    "Value": "BULANDSHARE"
                                },
                                {
                                    "Text": "BULANDSHAHAR",
                                    "Value": "BULANDSHAHAR"
                                },
                                {
                                    "Text": "BULANDSHAHR",
                                    "Value": "BULANDSHAHR"
                                },
                                {
                                    "Text": "BULDANA",
                                    "Value": "BULDANA"
                                },
                                {
                                    "Text": "BULDHANA",
                                    "Value": "BULDHANA"
                                },
                                {
                                    "Text": "BULHOWAL",
                                    "Value": "BULHOWAL"
                                },
                                {
                                    "Text": "BUNDI",
                                    "Value": "BUNDI"
                                },
                                {
                                    "Text": "BURDWAN",
                                    "Value": "BURDWAN"
                                },
                                {
                                    "Text": "BURHAR",
                                    "Value": "BURHAR"
                                },
                                {
                                    "Text": "BURHANPUR",
                                    "Value": "BURHANPUR"
                                },
                                {
                                    "Text": "BURLA",
                                    "Value": "BURLA"
                                },
                                {
                                    "Text": "BURNPUR",
                                    "Value": "BURNPUR"
                                },
                                {
                                    "Text": "BURNIHAT",
                                    "Value": "BURNIHAT"
                                },
                                {
                                    "Text": "BUTALA",
                                    "Value": "BUTALA"
                                },
                                {
                                    "Text": "BUTCHAMPETA ",
                                    "Value": "BUTCHAMPETA "
                                },
                                {
                                    "Text": "BUTIBORI",
                                    "Value": "BUTIBORI"
                                },
                                {
                                    "Text": "BUXAR",
                                    "Value": "BUXAR"
                                },
                                {
                                    "Text": "BHIWANDI",
                                    "Value": "BHIWANDI"
                                },
                                {
                                    "Text": "BAWANA",
                                    "Value": "BAWANA"
                                },
                                {
                                    "Text": "BHOWANIPORE",
                                    "Value": "BHOWANIPORE"
                                },
                                {
                                    "Text": "BILLAWAR",
                                    "Value": "BILLAWAR"
                                },
                                {
                                    "Text": "BYRNIHAT",
                                    "Value": "BYRNIHAT"
                                },
                                {
                                    "Text": "BYRNIHAT",
                                    "Value": "BYRNIHAT"
                                },
                                {
                                    "Text": "CACHAR",
                                    "Value": "CACHAR"
                                },
                                {
                                    "Text": "CALANGUTE",
                                    "Value": "CALANGUTE"
                                },
                                {
                                    "Text": "CALICUT",
                                    "Value": "CALICUT"
                                },
                                {
                                    "Text": "CANACONA",
                                    "Value": "CANACONA"
                                },
                                {
                                    "Text": "CANDOLIM",
                                    "Value": "CANDOLIM"
                                },
                                {
                                    "Text": "CANNANORE",
                                    "Value": "CANNANORE"
                                },
                                {
                                    "Text": "CANSAULIM",
                                    "Value": "CANSAULIM"
                                },
                                {
                                    "Text": "CARAMBOLIM",
                                    "Value": "CARAMBOLIM"
                                },
                                {
                                    "Text": "CAVELOSIM",
                                    "Value": "CAVELOSIM"
                                },
                                {
                                    "Text": "GRAND CAYMAN",
                                    "Value": "GRAND CAYMAN"
                                },
                                {
                                    "Text": "CBD BELAPUR",
                                    "Value": "CBD BELAPUR"
                                },
                                {
                                    "Text": "CENTRAL DELHI",
                                    "Value": "CENTRAL DELHI"
                                },
                                {
                                    "Text": "CENTRAL UNIVERSITY OF KARNATAKA,KAD",
                                    "Value": "CENTRAL UNIVERSITY OF KARNATAKA,KAD"
                                },
                                {
                                    "Text": "CHABAL KALAN",
                                    "Value": "CHABAL KALAN"
                                },
                                {
                                    "Text": "CHABEWAL",
                                    "Value": "CHABEWAL"
                                },
                                {
                                    "Text": "CHADURA",
                                    "Value": "CHADURA"
                                },
                                {
                                    "Text": "CHAIBASA",
                                    "Value": "CHAIBASA"
                                },
                                {
                                    "Text": "CHAKSU",
                                    "Value": "CHAKSU"
                                },
                                {
                                    "Text": "CHAKAN",
                                    "Value": "CHAKAN"
                                },
                                {
                                    "Text": "CHAK KALAN",
                                    "Value": "CHAK KALAN"
                                },
                                {
                                    "Text": "CHAK PAKHI",
                                    "Value": "CHAK PAKHI"
                                },
                                {
                                    "Text": "CHAKARBHATHA",
                                    "Value": "CHAKARBHATHA"
                                },
                                {
                                    "Text": "CHAKDANA",
                                    "Value": "CHAKDANA"
                                },
                                {
                                    "Text": "CHAKRADHARPUR",
                                    "Value": "CHAKRADHARPUR"
                                },
                                {
                                    "Text": "CHALISGAON",
                                    "Value": "CHALISGAON"
                                },
                                {
                                    "Text": "CHALLAKERE",
                                    "Value": "CHALLAKERE"
                                },
                                {
                                    "Text": "CHALAKUDY",
                                    "Value": "CHALAKUDY"
                                },
                                {
                                    "Text": "CHALIKKAVATTOM",
                                    "Value": "CHALIKKAVATTOM"
                                },
                                {
                                    "Text": "CHALLAVARIGUDEM ",
                                    "Value": "CHALLAVARIGUDEM "
                                },
                                {
                                    "Text": "CHALHERI ",
                                    "Value": "CHALHERI "
                                },
                                {
                                    "Text": "CHAMPA",
                                    "Value": "CHAMPA"
                                },
                                {
                                    "Text": "CHAMOLI",
                                    "Value": "CHAMOLI"
                                },
                                {
                                    "Text": "CHAMPAWAT",
                                    "Value": "CHAMPAWAT"
                                },
                                {
                                    "Text": "CHAMRAJNAGAR",
                                    "Value": "CHAMRAJNAGAR"
                                },
                                {
                                    "Text": "CHAMPHAI",
                                    "Value": "CHAMPHAI"
                                },
                                {
                                    "Text": "CHAMPADANGA",
                                    "Value": "CHAMPADANGA"
                                },
                                {
                                    "Text": "CHAMBA",
                                    "Value": "CHAMBA"
                                },
                                {
                                    "Text": "CHAMARU ",
                                    "Value": "CHAMARU "
                                },
                                {
                                    "Text": "CHAMARAJANAGAR",
                                    "Value": "CHAMARAJANAGAR"
                                },
                                {
                                    "Text": "CHAMKAUR SAHIB",
                                    "Value": "CHAMKAUR SAHIB"
                                },
                                {
                                    "Text": "CHAMPRAJPUR",
                                    "Value": "CHAMPRAJPUR"
                                },
                                {
                                    "Text": "CHAMYARI",
                                    "Value": "CHAMYARI"
                                },
                                {
                                    "Text": "CHANGANACHERRY",
                                    "Value": "CHANGANACHERRY"
                                },
                                {
                                    "Text": "CHANDAULI",
                                    "Value": "CHANDAULI"
                                },
                                {
                                    "Text": "CHANDEL",
                                    "Value": "CHANDEL"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANDRAPUR",
                                    "Value": "CHANDRAPUR"
                                },
                                {
                                    "Text": "CHANGLANG",
                                    "Value": "CHANGLANG"
                                },
                                {
                                    "Text": "CHANDRAPUR",
                                    "Value": "CHANDRAPUR"
                                },
                                {
                                    "Text": "CHANDAUSI",
                                    "Value": "CHANDAUSI"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANNAGIRI",
                                    "Value": "CHANNAGIRI"
                                },
                                {
                                    "Text": "CHANDANGAON ",
                                    "Value": "CHANDANGAON "
                                },
                                {
                                    "Text": "CHANDAI ECO ",
                                    "Value": "CHANDAI ECO "
                                },
                                {
                                    "Text": "CHAND NAU ",
                                    "Value": "CHAND NAU "
                                },
                                {
                                    "Text": "CHANDBAJA ",
                                    "Value": "CHANDBAJA "
                                },
                                {
                                    "Text": "CHANDAN CHAUKI ",
                                    "Value": "CHANDAN CHAUKI "
                                },
                                {
                                    "Text": "CHANDANAGAR",
                                    "Value": "CHANDANAGAR"
                                },
                                {
                                    "Text": "CHANDANNAGAR",
                                    "Value": "CHANDANNAGAR"
                                },
                                {
                                    "Text": "CHANGODAR",
                                    "Value": "CHANGODAR"
                                },
                                {
                                    "Text": "CHANDER NAGAR",
                                    "Value": "CHANDER NAGAR"
                                },
                                {
                                    "Text": "CHANDGAD",
                                    "Value": "CHANDGAD"
                                },
                                {
                                    "Text": "CHANDIKHOL",
                                    "Value": "CHANDIKHOL"
                                },
                                {
                                    "Text": "CHANDIMANDIR",
                                    "Value": "CHANDIMANDIR"
                                },
                                {
                                    "Text": "CHANDOR",
                                    "Value": "CHANDOR"
                                },
                                {
                                    "Text": "CHANDPUR",
                                    "Value": "CHANDPUR"
                                },
                                {
                                    "Text": "CHANDRANAGAR",
                                    "Value": "CHANDRANAGAR"
                                },
                                {
                                    "Text": "CHANDVAD",
                                    "Value": "CHANDVAD"
                                },
                                {
                                    "Text": "CHAPRA",
                                    "Value": "CHAPRA"
                                },
                                {
                                    "Text": "CHAPAD",
                                    "Value": "CHAPAD"
                                },
                                {
                                    "Text": "CHARKHI DADRI",
                                    "Value": "CHARKHI DADRI"
                                },
                                {
                                    "Text": "CHARKHI DADRI",
                                    "Value": "CHARKHI DADRI"
                                },
                                {
                                    "Text": "CHARNA ",
                                    "Value": "CHARNA "
                                },
                                {
                                    "Text": "CHARIK ",
                                    "Value": "CHARIK "
                                },
                                {
                                    "Text": "CHATRA",
                                    "Value": "CHATRA"
                                },
                                {
                                    "Text": "CHATARSAL",
                                    "Value": "CHATARSAL"
                                },
                                {
                                    "Text": "CHATTARPUR",
                                    "Value": "CHATTARPUR"
                                },
                                {
                                    "Text": "CHAUPAL",
                                    "Value": "CHAUPAL"
                                },
                                {
                                    "Text": "CHAVAKKAD",
                                    "Value": "CHAVAKKAD"
                                },
                                {
                                    "Text": "CHAWINDA DEVI",
                                    "Value": "CHAWINDA DEVI"
                                },
                                {
                                    "Text": "CHANDRASEKHARPUR",
                                    "Value": "CHANDRASEKHARPUR"
                                },
                                {
                                    "Text": "CHEEDIGUMMALA ",
                                    "Value": "CHEEDIGUMMALA "
                                },
                                {
                                    "Text": "CHEEMALAVALASA ",
                                    "Value": "CHEEMALAVALASA "
                                },
                                {
                                    "Text": "CHEEKA",
                                    "Value": "CHEEKA"
                                },
                                {
                                    "Text": "CHEEMA",
                                    "Value": "CHEEMA"
                                },
                                {
                                    "Text": "CHEMMAD",
                                    "Value": "CHEMMAD"
                                },
                                {
                                    "Text": "CHENNAI",
                                    "Value": "CHENNAI"
                                },
                                {
                                    "Text": "CHENGANNUR",
                                    "Value": "CHENGANNUR"
                                },
                                {
                                    "Text": "CHENGALPATTU",
                                    "Value": "CHENGALPATTU"
                                },
                                {
                                    "Text": "CHENGAM",
                                    "Value": "CHENGAM"
                                },
                                {
                                    "Text": "CHENNAIPALEM ",
                                    "Value": "CHENNAIPALEM "
                                },
                                {
                                    "Text": "CHENDRAPPINNI",
                                    "Value": "CHENDRAPPINNI"
                                },
                                {
                                    "Text": "CHEPUR ",
                                    "Value": "CHEPUR "
                                },
                                {
                                    "Text": "CHEPPAD",
                                    "Value": "CHEPPAD"
                                },
                                {
                                    "Text": "CHERAI",
                                    "Value": "CHERAI"
                                },
                                {
                                    "Text": "CHERPALACHERY",
                                    "Value": "CHERPALACHERY"
                                },
                                {
                                    "Text": "CHERTHALA",
                                    "Value": "CHERTHALA"
                                },
                                {
                                    "Text": "CHERUKUNNU",
                                    "Value": "CHERUKUNNU"
                                },
                                {
                                    "Text": "CHETTUPALLE ",
                                    "Value": "CHETTUPALLE "
                                },
                                {
                                    "Text": "CHETTIKULANGARA",
                                    "Value": "CHETTIKULANGARA"
                                },
                                {
                                    "Text": "CHHATARPUR",
                                    "Value": "CHHATARPUR"
                                },
                                {
                                    "Text": "CHHANI",
                                    "Value": "CHHANI"
                                },
                                {
                                    "Text": "CHHABRA",
                                    "Value": "CHHABRA"
                                },
                                {
                                    "Text": "CHHACHHARAULI",
                                    "Value": "CHHACHHARAULI"
                                },
                                {
                                    "Text": "CHHAT",
                                    "Value": "CHHAT"
                                },
                                {
                                    "Text": "CHHATRAL",
                                    "Value": "CHHATRAL"
                                },
                                {
                                    "Text": "CHHATRAPUR",
                                    "Value": "CHHATRAPUR"
                                },
                                {
                                    "Text": "CHHEDIA PASHCHIM ",
                                    "Value": "CHHEDIA PASHCHIM "
                                },
                                {
                                    "Text": "CHHEHERTA",
                                    "Value": "CHHEHERTA"
                                },
                                {
                                    "Text": "CHHENDIPADA",
                                    "Value": "CHHENDIPADA"
                                },
                                {
                                    "Text": "CHHIBRAMAU",
                                    "Value": "CHHIBRAMAU"
                                },
                                {
                                    "Text": "CHHINDWARA",
                                    "Value": "CHHINDWARA"
                                },
                                {
                                    "Text": "CHHIBRAMAU",
                                    "Value": "CHHIBRAMAU"
                                },
                                {
                                    "Text": "CHHOTA UDAIPUR",
                                    "Value": "CHHOTA UDAIPUR"
                                },
                                {
                                    "Text": "CHHOTA BANGURDA ",
                                    "Value": "CHHOTA BANGURDA "
                                },
                                {
                                    "Text": "CHHOTA UDAIPUR",
                                    "Value": "CHHOTA UDAIPUR"
                                },
                                {
                                    "Text": "CHHUTMALPUR",
                                    "Value": "CHHUTMALPUR"
                                },
                                {
                                    "Text": "CHHAWLA",
                                    "Value": "CHHAWLA"
                                },
                                {
                                    "Text": "CHICKMAGALUR",
                                    "Value": "CHICKMAGALUR"
                                },
                                {
                                    "Text": "CHIDAMBARAM",
                                    "Value": "CHIDAMBARAM"
                                },
                                {
                                    "Text": "CHIKALIM",
                                    "Value": "CHIKALIM"
                                },
                                {
                                    "Text": "CHIKHLI",
                                    "Value": "CHIKHLI"
                                },
                                {
                                    "Text": "CHIKODI",
                                    "Value": "CHIKODI"
                                },
                                {
                                    "Text": "CHIKKABALLAPUR",
                                    "Value": "CHIKKABALLAPUR"
                                },
                                {
                                    "Text": "CHIKHLI",
                                    "Value": "CHIKHLI"
                                },
                                {
                                    "Text": "CHIKATIMAMIDI ",
                                    "Value": "CHIKATIMAMIDI "
                                },
                                {
                                    "Text": "CHIKHALI ",
                                    "Value": "CHIKHALI "
                                },
                                {
                                    "Text": "CHIKBALLAPURA",
                                    "Value": "CHIKBALLAPURA"
                                },
                                {
                                    "Text": "CHIKMAGALUR",
                                    "Value": "CHIKMAGALUR"
                                },
                                {
                                    "Text": "CHIKHIL",
                                    "Value": "CHIKHIL"
                                },
                                {
                                    "Text": "CHIKHIL",
                                    "Value": "CHIKHIL"
                                },
                                {
                                    "Text": "CHILAKALURIPET",
                                    "Value": "CHILAKALURIPET"
                                },
                                {
                                    "Text": "CHIMRAJPALLE",
                                    "Value": "CHIMRAJPALLE"
                                },
                                {
                                    "Text": "CHINSURAH R S",
                                    "Value": "CHINSURAH R S"
                                },
                                {
                                    "Text": "CHINTAMANI",
                                    "Value": "CHINTAMANI"
                                },
                                {
                                    "Text": "CHINNARANGAPURAM ",
                                    "Value": "CHINNARANGAPURAM "
                                },
                                {
                                    "Text": "CHINTALAJUTUR ",
                                    "Value": "CHINTALAJUTUR "
                                },
                                {
                                    "Text": "CHINNAVARIGUDEM ",
                                    "Value": "CHINNAVARIGUDEM "
                                },
                                {
                                    "Text": "CHINTADA ",
                                    "Value": "CHINTADA "
                                },
                                {
                                    "Text": "CHINCHAVALI",
                                    "Value": "CHINCHAVALI"
                                },
                                {
                                    "Text": "CHINCHINIM",
                                    "Value": "CHINCHINIM"
                                },
                                {
                                    "Text": "CHINNAMIRAM",
                                    "Value": "CHINNAMIRAM"
                                },
                                {
                                    "Text": "CHIPLUN",
                                    "Value": "CHIPLUN"
                                },
                                {
                                    "Text": "CHIPARI",
                                    "Value": "CHIPARI"
                                },
                                {
                                    "Text": "CHIRALA",
                                    "Value": "CHIRALA"
                                },
                                {
                                    "Text": "CHIRAWA",
                                    "Value": "CHIRAWA"
                                },
                                {
                                    "Text": "CHIRGAON",
                                    "Value": "CHIRGAON"
                                },
                                {
                                    "Text": "CHITHARA",
                                    "Value": "CHITHARA"
                                },
                                {
                                    "Text": "CHITRADURGA",
                                    "Value": "CHITRADURGA"
                                },
                                {
                                    "Text": "CHITRAKOOT",
                                    "Value": "CHITRAKOOT"
                                },
                                {
                                    "Text": "CHITTOOR",
                                    "Value": "CHITTOOR"
                                },
                                {
                                    "Text": "CHITTORGARH",
                                    "Value": "CHITTORGARH"
                                },
                                {
                                    "Text": "CHITAKODUR ",
                                    "Value": "CHITAKODUR "
                                },
                                {
                                    "Text": "CHITTIVALASA ",
                                    "Value": "CHITTIVALASA "
                                },
                                {
                                    "Text": "CHITILI PUTLI ",
                                    "Value": "CHITILI PUTLI "
                                },
                                {
                                    "Text": "CHITHARA -SHIV NADAR UNIVERSITY",
                                    "Value": "CHITHARA -SHIV NADAR UNIVERSITY"
                                },
                                {
                                    "Text": "CHIRANG",
                                    "Value": "CHIRANG"
                                },
                                {
                                    "Text": "CHEMBUR",
                                    "Value": "CHEMBUR"
                                },
                                {
                                    "Text": "CHENGAM",
                                    "Value": "CHENGAM"
                                },
                                {
                                    "Text": "CHANNAGIRI",
                                    "Value": "CHANNAGIRI"
                                },
                                {
                                    "Text": "CHOCHRA",
                                    "Value": "CHOCHRA"
                                },
                                {
                                    "Text": "CHODAVARAM ",
                                    "Value": "CHODAVARAM "
                                },
                                {
                                    "Text": "CHOGAWAN",
                                    "Value": "CHOGAWAN"
                                },
                                {
                                    "Text": "CHOLA SAHIB",
                                    "Value": "CHOLA SAHIB"
                                },
                                {
                                    "Text": "CHOMU",
                                    "Value": "CHOMU"
                                },
                                {
                                    "Text": "CHOPDA",
                                    "Value": "CHOPDA"
                                },
                                {
                                    "Text": "CHOUTUPPAL",
                                    "Value": "CHOUTUPPAL"
                                },
                                {
                                    "Text": "CHRARI SHARIEF",
                                    "Value": "CHRARI SHARIEF"
                                },
                                {
                                    "Text": "CHITTARANJON",
                                    "Value": "CHITTARANJON"
                                },
                                {
                                    "Text": "CHILLA SARODA BANGAR",
                                    "Value": "CHILLA SARODA BANGAR"
                                },
                                {
                                    "Text": "CHUKKAPUR ",
                                    "Value": "CHUKKAPUR "
                                },
                                {
                                    "Text": "CHUNAR",
                                    "Value": "CHUNAR"
                                },
                                {
                                    "Text": "CHUNATI GADA",
                                    "Value": "CHUNATI GADA"
                                },
                                {
                                    "Text": "CHUNNI KALAN",
                                    "Value": "CHUNNI KALAN"
                                },
                                {
                                    "Text": "CHURACHANDPUR",
                                    "Value": "CHURACHANDPUR"
                                },
                                {
                                    "Text": "CHURU",
                                    "Value": "CHURU"
                                },
                                {
                                    "Text": "CHUREB",
                                    "Value": "CHUREB"
                                },
                                {
                                    "Text": "CHWADI",
                                    "Value": "CHWADI"
                                },
                                {
                                    "Text": "CHINCHWAD",
                                    "Value": "CHINCHWAD"
                                },
                                {
                                    "Text": "COLABA",
                                    "Value": "COLABA"
                                },
                                {
                                    "Text": "COLACHEL",
                                    "Value": "COLACHEL"
                                },
                                {
                                    "Text": "CUMBUM",
                                    "Value": "CUMBUM"
                                },
                                {
                                    "Text": "CANDOLIM",
                                    "Value": "CANDOLIM"
                                },
                                {
                                    "Text": "CHANNAPATNA",
                                    "Value": "CHANNAPATNA"
                                },
                                {
                                    "Text": "COCHIN",
                                    "Value": "COCHIN"
                                },
                                {
                                    "Text": "COIMBATORE",
                                    "Value": "COIMBATORE"
                                },
                                {
                                    "Text": "COLONELGANJ",
                                    "Value": "COLONELGANJ"
                                },
                                {
                                    "Text": "COLVA",
                                    "Value": "COLVA"
                                },
                                {
                                    "Text": "COLVALE",
                                    "Value": "COLVALE"
                                },
                                {
                                    "Text": "CONTAI",
                                    "Value": "CONTAI"
                                },
                                {
                                    "Text": "COOCH BEHAR",
                                    "Value": "COOCH BEHAR"
                                },
                                {
                                    "Text": "COONOOR",
                                    "Value": "COONOOR"
                                },
                                {
                                    "Text": "CARTERPURI",
                                    "Value": "CARTERPURI"
                                },
                                {
                                    "Text": "CUDDALORE",
                                    "Value": "CUDDALORE"
                                },
                                {
                                    "Text": "CUDDAPAH",
                                    "Value": "CUDDAPAH"
                                },
                                {
                                    "Text": "CUNCOLIM",
                                    "Value": "CUNCOLIM"
                                },
                                {
                                    "Text": "CURCHOREM",
                                    "Value": "CURCHOREM"
                                },
                                {
                                    "Text": "CURTORIM",
                                    "Value": "CURTORIM"
                                },
                                {
                                    "Text": "CUTTACK",
                                    "Value": "CUTTACK"
                                },
                                {
                                    "Text": "DABBASPET",
                                    "Value": "DABBASPET"
                                },
                                {
                                    "Text": "DABGAON MAKTHA ",
                                    "Value": "DABGAON MAKTHA "
                                },
                                {
                                    "Text": "DABHOI",
                                    "Value": "DABHOI"
                                },
                                {
                                    "Text": "DABHADI ",
                                    "Value": "DABHADI "
                                },
                                {
                                    "Text": "DABHEL",
                                    "Value": "DABHEL"
                                },
                                {
                                    "Text": "DABRA",
                                    "Value": "DABRA"
                                },
                                {
                                    "Text": "DABWALI",
                                    "Value": "DABWALI"
                                },
                                {
                                    "Text": "DADAHUR",
                                    "Value": "DADAHUR"
                                },
                                {
                                    "Text": "DADRA & NAGAR HAVELI",
                                    "Value": "DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "DADRI",
                                    "Value": "DADRI"
                                },
                                {
                                    "Text": "DAGAVADIYA",
                                    "Value": "DAGAVADIYA"
                                },
                                {
                                    "Text": "DAHANU ROAD",
                                    "Value": "DAHANU ROAD"
                                },
                                {
                                    "Text": "DAHANU",
                                    "Value": "DAHANU"
                                },
                                {
                                    "Text": "DAHEJ",
                                    "Value": "DAHEJ"
                                },
                                {
                                    "Text": "DAHIVALI",
                                    "Value": "DAHIVALI"
                                },
                                {
                                    "Text": "DAHOD",
                                    "Value": "DAHOD"
                                },
                                {
                                    "Text": "DAKOR",
                                    "Value": "DAKOR"
                                },
                                {
                                    "Text": "DAKSHINA KANNADA",
                                    "Value": "DAKSHINA KANNADA"
                                },
                                {
                                    "Text": "DALAM",
                                    "Value": "DALAM"
                                },
                                {
                                    "Text": "DALEKE ",
                                    "Value": "DALEKE "
                                },
                                {
                                    "Text": "DALHOUSIE",
                                    "Value": "DALHOUSIE"
                                },
                                {
                                    "Text": "DALLI RAJHARA",
                                    "Value": "DALLI RAJHARA"
                                },
                                {
                                    "Text": "DALSINGHSARAI",
                                    "Value": "DALSINGHSARAI"
                                },
                                {
                                    "Text": "DALTONGANJ",
                                    "Value": "DALTONGANJ"
                                },
                                {
                                    "Text": "DALTONGUNJ",
                                    "Value": "DALTONGUNJ"
                                },
                                {
                                    "Text": "DAMAN",
                                    "Value": "DAMAN"
                                },
                                {
                                    "Text": "DAMAN",
                                    "Value": "DAMAN"
                                },
                                {
                                    "Text": "DAMOH",
                                    "Value": "DAMOH"
                                },
                                {
                                    "Text": "DANDGAON ",
                                    "Value": "DANDGAON "
                                },
                                {
                                    "Text": "DANKUNI",
                                    "Value": "DANKUNI"
                                },
                                {
                                    "Text": "DANTEWADA",
                                    "Value": "DANTEWADA"
                                },
                                {
                                    "Text": "DAPORIJO",
                                    "Value": "DAPORIJO"
                                },
                                {
                                    "Text": "DAPOLI",
                                    "Value": "DAPOLI"
                                },
                                {
                                    "Text": "DARA",
                                    "Value": "DARA"
                                },
                                {
                                    "Text": "DARBHANGA",
                                    "Value": "DARBHANGA"
                                },
                                {
                                    "Text": "DARBARIBUR",
                                    "Value": "DARBARIBUR"
                                },
                                {
                                    "Text": "DARED",
                                    "Value": "DARED"
                                },
                                {
                                    "Text": "DARJEELING",
                                    "Value": "DARJEELING"
                                },
                                {
                                    "Text": "DARJILING",
                                    "Value": "DARJILING"
                                },
                                {
                                    "Text": "DARLA",
                                    "Value": "DARLA"
                                },
                                {
                                    "Text": "DARRANG",
                                    "Value": "DARRANG"
                                },
                                {
                                    "Text": "DARYAPUR",
                                    "Value": "DARYAPUR"
                                },
                                {
                                    "Text": "DASCROI",
                                    "Value": "DASCROI"
                                },
                                {
                                    "Text": "DASNA",
                                    "Value": "DASNA"
                                },
                                {
                                    "Text": "DASHRATH PURI",
                                    "Value": "DASHRATH PURI"
                                },
                                {
                                    "Text": "DASUYA",
                                    "Value": "DASUYA"
                                },
                                {
                                    "Text": "DATARPUR",
                                    "Value": "DATARPUR"
                                },
                                {
                                    "Text": "DATIA",
                                    "Value": "DATIA"
                                },
                                {
                                    "Text": "DATTAWADI",
                                    "Value": "DATTAWADI"
                                },
                                {
                                    "Text": "DAUND",
                                    "Value": "DAUND"
                                },
                                {
                                    "Text": "DAUSA",
                                    "Value": "DAUSA"
                                },
                                {
                                    "Text": "DAVANGERE",
                                    "Value": "DAVANGERE"
                                },
                                {
                                    "Text": "DAVANGARE",
                                    "Value": "DAVANGARE"
                                },
                                {
                                    "Text": "DAVORLIM",
                                    "Value": "DAVORLIM"
                                },
                                {
                                    "Text": "DAYALPURA MIRZA",
                                    "Value": "DAYALPURA MIRZA"
                                },
                                {
                                    "Text": "DELHI CANTONMENT",
                                    "Value": "DELHI CANTONMENT"
                                },
                                {
                                    "Text": "DEBAGARH",
                                    "Value": "DEBAGARH"
                                },
                                {
                                    "Text": "DEESA",
                                    "Value": "DEESA"
                                },
                                {
                                    "Text": "DEGLOOR",
                                    "Value": "DEGLOOR"
                                },
                                {
                                    "Text": "DEGAON ",
                                    "Value": "DEGAON "
                                },
                                {
                                    "Text": "DEHGAM",
                                    "Value": "DEHGAM"
                                },
                                {
                                    "Text": "DEHLON",
                                    "Value": "DEHLON"
                                },
                                {
                                    "Text": "DEHRADUN",
                                    "Value": "DEHRADUN"
                                },
                                {
                                    "Text": "DEHRA",
                                    "Value": "DEHRA"
                                },
                                {
                                    "Text": "DEHRI",
                                    "Value": "DEHRI"
                                },
                                {
                                    "Text": "DELA",
                                    "Value": "DELA"
                                },
                                {
                                    "Text": "DELAD",
                                    "Value": "DELAD"
                                },
                                {
                                    "Text": "DELEGAVAN ",
                                    "Value": "DELEGAVAN "
                                },
                                {
                                    "Text": "DELHI",
                                    "Value": "DELHI"
                                },
                                {
                                    "Text": "DEOLI",
                                    "Value": "DEOLI"
                                },
                                {
                                    "Text": "DEOBAND",
                                    "Value": "DEOBAND"
                                },
                                {
                                    "Text": "DEOGHAR",
                                    "Value": "DEOGHAR"
                                },
                                {
                                    "Text": "DEOGARH",
                                    "Value": "DEOGARH"
                                },
                                {
                                    "Text": "DEOGAR",
                                    "Value": "DEOGAR"
                                },
                                {
                                    "Text": "DEOLI",
                                    "Value": "DEOLI"
                                },
                                {
                                    "Text": "DEOLA",
                                    "Value": "DEOLA"
                                },
                                {
                                    "Text": "DEOLALI",
                                    "Value": "DEOLALI"
                                },
                                {
                                    "Text": "DEORIA",
                                    "Value": "DEORIA"
                                },
                                {
                                    "Text": "DERA BASSI",
                                    "Value": "DERA BASSI"
                                },
                                {
                                    "Text": "DERABASSI",
                                    "Value": "DERABASSI"
                                },
                                {
                                    "Text": "DERA BABA NANAK",
                                    "Value": "DERA BABA NANAK"
                                },
                                {
                                    "Text": "DEROL",
                                    "Value": "DEROL"
                                },
                                {
                                    "Text": "DEULGAON RAJA",
                                    "Value": "DEULGAON RAJA"
                                },
                                {
                                    "Text": "DEULGAON RAJA",
                                    "Value": "DEULGAON RAJA"
                                },
                                {
                                    "Text": "DEWAS",
                                    "Value": "DEWAS"
                                },
                                {
                                    "Text": "DEVANAPPLI ",
                                    "Value": "DEVANAPPLI "
                                },
                                {
                                    "Text": "DEVAKOTTAI",
                                    "Value": "DEVAKOTTAI"
                                },
                                {
                                    "Text": "DEVANAHALLI",
                                    "Value": "DEVANAHALLI"
                                },
                                {
                                    "Text": "DEVIGARH",
                                    "Value": "DEVIGARH"
                                },
                                {
                                    "Text": "DEVULAPALLY CALAN ",
                                    "Value": "DEVULAPALLY CALAN "
                                },
                                {
                                    "Text": "DEWAS",
                                    "Value": "DEWAS"
                                },
                                {
                                    "Text": "DEWADA KHURD ",
                                    "Value": "DEWADA KHURD "
                                },
                                {
                                    "Text": "DHAD",
                                    "Value": "DHAD"
                                },
                                {
                                    "Text": "DHAKIA ",
                                    "Value": "DHAKIA "
                                },
                                {
                                    "Text": "DHALAI",
                                    "Value": "DHALAI"
                                },
                                {
                                    "Text": "DHALLE KE ",
                                    "Value": "DHALLE KE "
                                },
                                {
                                    "Text": "DHAMPUR",
                                    "Value": "DHAMPUR"
                                },
                                {
                                    "Text": "DHAMOND",
                                    "Value": "DHAMOND"
                                },
                                {
                                    "Text": "DHAMTARI",
                                    "Value": "DHAMTARI"
                                },
                                {
                                    "Text": "DHAMORAH ",
                                    "Value": "DHAMORAH "
                                },
                                {
                                    "Text": "DHAMANGAON RAILWAY",
                                    "Value": "DHAMANGAON RAILWAY"
                                },
                                {
                                    "Text": "DHAMNOD",
                                    "Value": "DHAMNOD"
                                },
                                {
                                    "Text": "DHANERA",
                                    "Value": "DHANERA"
                                },
                                {
                                    "Text": "DHANBAD",
                                    "Value": "DHANBAD"
                                },
                                {
                                    "Text": "DHANAURI",
                                    "Value": "DHANAURI"
                                },
                                {
                                    "Text": "DHANNARAM ",
                                    "Value": "DHANNARAM "
                                },
                                {
                                    "Text": "DHANKANSU KALAN ",
                                    "Value": "DHANKANSU KALAN "
                                },
                                {
                                    "Text": "DHANELI UTTARI ",
                                    "Value": "DHANELI UTTARI "
                                },
                                {
                                    "Text": "DHANAULA",
                                    "Value": "DHANAULA"
                                },
                                {
                                    "Text": "DHAND",
                                    "Value": "DHAND"
                                },
                                {
                                    "Text": "DHANKOT",
                                    "Value": "DHANKOT"
                                },
                                {
                                    "Text": "DHANYAVI",
                                    "Value": "DHANYAVI"
                                },
                                {
                                    "Text": "DHAPAI ",
                                    "Value": "DHAPAI "
                                },
                                {
                                    "Text": "DHARMAPURI",
                                    "Value": "DHARMAPURI"
                                },
                                {
                                    "Text": "DHARI",
                                    "Value": "DHARI"
                                },
                                {
                                    "Text": "DHARAMSHALA",
                                    "Value": "DHARAMSHALA"
                                },
                                {
                                    "Text": "DHARWAD",
                                    "Value": "DHARWAD"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHARAMKOT",
                                    "Value": "DHARAMKOT"
                                },
                                {
                                    "Text": "DHARAPURAM",
                                    "Value": "DHARAPURAM"
                                },
                                {
                                    "Text": "DHARIWAL",
                                    "Value": "DHARIWAL"
                                },
                                {
                                    "Text": "DHAR",
                                    "Value": "DHAR"
                                },
                                {
                                    "Text": "DHARMAPURI",
                                    "Value": "DHARMAPURI"
                                },
                                {
                                    "Text": "DHARUHERA",
                                    "Value": "DHARUHERA"
                                },
                                {
                                    "Text": "DHARWARD",
                                    "Value": "DHARWARD"
                                },
                                {
                                    "Text": "DHARNASAGARAM ",
                                    "Value": "DHARNASAGARAM "
                                },
                                {
                                    "Text": "DHARIAWAD",
                                    "Value": "DHARIAWAD"
                                },
                                {
                                    "Text": "DHARMAJ",
                                    "Value": "DHARMAJ"
                                },
                                {
                                    "Text": "DHARMANAGAR",
                                    "Value": "DHARMANAGAR"
                                },
                                {
                                    "Text": "DHARPUR",
                                    "Value": "DHARPUR"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHAURA ",
                                    "Value": "DHAURA "
                                },
                                {
                                    "Text": "DHAULIMUNHA",
                                    "Value": "DHAULIMUNHA"
                                },
                                {
                                    "Text": "DHAURRA MAFI",
                                    "Value": "DHAURRA MAFI"
                                },
                                {
                                    "Text": "DHEMAJI",
                                    "Value": "DHEMAJI"
                                },
                                {
                                    "Text": "DHENKANAL",
                                    "Value": "DHENKANAL"
                                },
                                {
                                    "Text": "DHIANPUR",
                                    "Value": "DHIANPUR"
                                },
                                {
                                    "Text": "DHILWAN",
                                    "Value": "DHILWAN"
                                },
                                {
                                    "Text": "DHANDHUKA",
                                    "Value": "DHANDHUKA"
                                },
                                {
                                    "Text": "DHOKATA",
                                    "Value": "DHOKATA"
                                },
                                {
                                    "Text": "DHOLPUR",
                                    "Value": "DHOLPUR"
                                },
                                {
                                    "Text": "DHOLASAN",
                                    "Value": "DHOLASAN"
                                },
                                {
                                    "Text": "DHOLKA",
                                    "Value": "DHOLKA"
                                },
                                {
                                    "Text": "DHONE",
                                    "Value": "DHONE"
                                },
                                {
                                    "Text": "DHORAJI",
                                    "Value": "DHORAJI"
                                },
                                {
                                    "Text": "DHOTIAN",
                                    "Value": "DHOTIAN"
                                },
                                {
                                    "Text": "DHOYANPUR ",
                                    "Value": "DHOYANPUR "
                                },
                                {
                                    "Text": "DHRANGADHRA",
                                    "Value": "DHRANGADHRA"
                                },
                                {
                                    "Text": "DHROL",
                                    "Value": "DHROL"
                                },
                                {
                                    "Text": "DHAROTI KHURD",
                                    "Value": "DHAROTI KHURD"
                                },
                                {
                                    "Text": "DAHISAR(W)",
                                    "Value": "DAHISAR(W)"
                                },
                                {
                                    "Text": "DHUBRI",
                                    "Value": "DHUBRI"
                                },
                                {
                                    "Text": "DHUDHI ",
                                    "Value": "DHUDHI "
                                },
                                {
                                    "Text": "DHULE",
                                    "Value": "DHULE"
                                },
                                {
                                    "Text": "DHUNELA",
                                    "Value": "DHUNELA"
                                },
                                {
                                    "Text": "DHUPGURI",
                                    "Value": "DHUPGURI"
                                },
                                {
                                    "Text": "DHURI",
                                    "Value": "DHURI"
                                },
                                {
                                    "Text": "DHURKOT ",
                                    "Value": "DHURKOT "
                                },
                                {
                                    "Text": "DHUSKIYA ",
                                    "Value": "DHUSKIYA "
                                },
                                {
                                    "Text": "DIAMOND HARBOUR",
                                    "Value": "DIAMOND HARBOUR"
                                },
                                {
                                    "Text": "DIBANG VALLEY",
                                    "Value": "DIBANG VALLEY"
                                },
                                {
                                    "Text": "DIBIYAPUR",
                                    "Value": "DIBIYAPUR"
                                },
                                {
                                    "Text": "DIBRUGARH",
                                    "Value": "DIBRUGARH"
                                },
                                {
                                    "Text": "DIGBOI",
                                    "Value": "DIGBOI"
                                },
                                {
                                    "Text": "DIGHI ",
                                    "Value": "DIGHI "
                                },
                                {
                                    "Text": "DIGHORI ",
                                    "Value": "DIGHORI "
                                },
                                {
                                    "Text": "DIHIBATPUR PANCHANANTALA",
                                    "Value": "DIHIBATPUR PANCHANANTALA"
                                },
                                {
                                    "Text": "DILDAR NAGAR",
                                    "Value": "DILDAR NAGAR"
                                },
                                {
                                    "Text": "DILSHAD GARDEN",
                                    "Value": "DILSHAD GARDEN"
                                },
                                {
                                    "Text": "DIMAPUR",
                                    "Value": "DIMAPUR"
                                },
                                {
                                    "Text": "DINANAGAR",
                                    "Value": "DINANAGAR"
                                },
                                {
                                    "Text": "DANAPUR",
                                    "Value": "DANAPUR"
                                },
                                {
                                    "Text": "DINDORI",
                                    "Value": "DINDORI"
                                },
                                {
                                    "Text": "DINDIGUL",
                                    "Value": "DINDIGUL"
                                },
                                {
                                    "Text": "DINDORI",
                                    "Value": "DINDORI"
                                },
                                {
                                    "Text": "DING",
                                    "Value": "DING"
                                },
                                {
                                    "Text": "DINGRIAN",
                                    "Value": "DINGRIAN"
                                },
                                {
                                    "Text": "DINGUCHA",
                                    "Value": "DINGUCHA"
                                },
                                {
                                    "Text": "DINHATA",
                                    "Value": "DINHATA"
                                },
                                {
                                    "Text": "DIPHU",
                                    "Value": "DIPHU"
                                },
                                {
                                    "Text": "DIRBA",
                                    "Value": "DIRBA"
                                },
                                {
                                    "Text": "DISPUR",
                                    "Value": "DISPUR"
                                },
                                {
                                    "Text": "DIST AHAMADNAGAR",
                                    "Value": "DIST AHAMADNAGAR"
                                },
                                {
                                    "Text": "DIU",
                                    "Value": "DIU"
                                },
                                {
                                    "Text": "DIU",
                                    "Value": "DIU"
                                },
                                {
                                    "Text": "DALLO PURA",
                                    "Value": "DALLO PURA"
                                },
                                {
                                    "Text": "DILSUKHNAGAR",
                                    "Value": "DILSUKHNAGAR"
                                },
                                {
                                    "Text": "DODA",
                                    "Value": "DODA"
                                },
                                {
                                    "Text": "DODDAHEJJUR ",
                                    "Value": "DODDAHEJJUR "
                                },
                                {
                                    "Text": "DODDABALLAPUR",
                                    "Value": "DODDABALLAPUR"
                                },
                                {
                                    "Text": "DOGACHIA",
                                    "Value": "DOGACHIA"
                                },
                                {
                                    "Text": "DOHA",
                                    "Value": "DOHA"
                                },
                                {
                                    "Text": "DOONI",
                                    "Value": "DOONI"
                                },
                                {
                                    "Text": "DOMARAIGANJ",
                                    "Value": "DOMARAIGANJ"
                                },
                                {
                                    "Text": "DOMBIVALI",
                                    "Value": "DOMBIVALI"
                                },
                                {
                                    "Text": "DOMBIVLI",
                                    "Value": "DOMBIVLI"
                                },
                                {
                                    "Text": "DOMJUR",
                                    "Value": "DOMJUR"
                                },
                                {
                                    "Text": "DONA PAULA",
                                    "Value": "DONA PAULA"
                                },
                                {
                                    "Text": "DONAR",
                                    "Value": "DONAR"
                                },
                                {
                                    "Text": "DONGAON ",
                                    "Value": "DONGAON "
                                },
                                {
                                    "Text": "DOOMDOOMA",
                                    "Value": "DOOMDOOMA"
                                },
                                {
                                    "Text": "DOOMDOOMA",
                                    "Value": "DOOMDOOMA"
                                },
                                {
                                    "Text": "DOORU SHAHBAD",
                                    "Value": "DOORU SHAHBAD"
                                },
                                {
                                    "Text": "DORAHA",
                                    "Value": "DORAHA"
                                },
                                {
                                    "Text": "DOSANJH ",
                                    "Value": "DOSANJH "
                                },
                                {
                                    "Text": "DOWNURU ",
                                    "Value": "DOWNURU "
                                },
                                {
                                    "Text": "DRAMMAN",
                                    "Value": "DRAMMAN"
                                },
                                {
                                    "Text": "DUBAI",
                                    "Value": "DUBAI"
                                },
                                {
                                    "Text": "DUBRAJPUR",
                                    "Value": "DUBRAJPUR"
                                },
                                {
                                    "Text": "DUBURI",
                                    "Value": "DUBURI"
                                },
                                {
                                    "Text": "DUDHAD ",
                                    "Value": "DUDHAD "
                                },
                                {
                                    "Text": "DULIAJAN",
                                    "Value": "DULIAJAN"
                                },
                                {
                                    "Text": "DUMARIA ",
                                    "Value": "DUMARIA "
                                },
                                {
                                    "Text": "DUMAD",
                                    "Value": "DUMAD"
                                },
                                {
                                    "Text": "DUM DUM",
                                    "Value": "DUM DUM"
                                },
                                {
                                    "Text": "DUMKA",
                                    "Value": "DUMKA"
                                },
                                {
                                    "Text": "DUNAVADA",
                                    "Value": "DUNAVADA"
                                },
                                {
                                    "Text": "DUNDAHERA",
                                    "Value": "DUNDAHERA"
                                },
                                {
                                    "Text": "DUNGARPUR",
                                    "Value": "DUNGARPUR"
                                },
                                {
                                    "Text": "DUNGURIPALI",
                                    "Value": "DUNGURIPALI"
                                },
                                {
                                    "Text": "DUNGARI",
                                    "Value": "DUNGARI"
                                },
                                {
                                    "Text": "DURGAPUR",
                                    "Value": "DURGAPUR"
                                },
                                {
                                    "Text": "DURG",
                                    "Value": "DURG"
                                },
                                {
                                    "Text": "DURUHERA",
                                    "Value": "DURUHERA"
                                },
                                {
                                    "Text": "DWARKA",
                                    "Value": "DWARKA"
                                },
                                {
                                    "Text": "DWARKA",
                                    "Value": "DWARKA"
                                },
                                {
                                    "Text": "DAYAL PUR",
                                    "Value": "DAYAL PUR"
                                },
                                {
                                    "Text": "EAST NIMAR",
                                    "Value": "EAST NIMAR"
                                },
                                {
                                    "Text": "EAST KHASIHILL",
                                    "Value": "EAST KHASIHILL"
                                },
                                {
                                    "Text": "EAST CHAMPARAN",
                                    "Value": "EAST CHAMPARAN"
                                },
                                {
                                    "Text": "EAST DELHI",
                                    "Value": "EAST DELHI"
                                },
                                {
                                    "Text": "EAST GARO HILLS",
                                    "Value": "EAST GARO HILLS"
                                },
                                {
                                    "Text": "EAST GODAVARI",
                                    "Value": "EAST GODAVARI"
                                },
                                {
                                    "Text": "EAST KAMENG",
                                    "Value": "EAST KAMENG"
                                },
                                {
                                    "Text": "EAST KHASI HILLS",
                                    "Value": "EAST KHASI HILLS"
                                },
                                {
                                    "Text": "EAST SIANG",
                                    "Value": "EAST SIANG"
                                },
                                {
                                    "Text": "EAST SIKKIM",
                                    "Value": "EAST SIKKIM"
                                },
                                {
                                    "Text": "EAST SINGHBHUM",
                                    "Value": "EAST SINGHBHUM"
                                },
                                {
                                    "Text": "EAST MIDNAPORE",
                                    "Value": "EAST MIDNAPORE"
                                },
                                {
                                    "Text": "EDAPPAL",
                                    "Value": "EDAPPAL"
                                },
                                {
                                    "Text": "EDULAPOOSALAPALLI ",
                                    "Value": "EDULAPOOSALAPALLI "
                                },
                                {
                                    "Text": "EGRA",
                                    "Value": "EGRA"
                                },
                                {
                                    "Text": "EKLINGPURA",
                                    "Value": "EKLINGPURA"
                                },
                                {
                                    "Text": "EKMAMIDI ",
                                    "Value": "EKMAMIDI "
                                },
                                {
                                    "Text": "ELLENABAD",
                                    "Value": "ELLENABAD"
                                },
                                {
                                    "Text": "ELURU",
                                    "Value": "ELURU"
                                },
                                {
                                    "Text": "ERAMALLOOR",
                                    "Value": "ERAMALLOOR"
                                },
                                {
                                    "Text": "ERNAKULAM",
                                    "Value": "ERNAKULAM"
                                },
                                {
                                    "Text": "ERODE",
                                    "Value": "ERODE"
                                },
                                {
                                    "Text": "ERRABALLE ",
                                    "Value": "ERRABALLE "
                                },
                                {
                                    "Text": "ERRIPALLE ",
                                    "Value": "ERRIPALLE "
                                },
                                {
                                    "Text": "ERU",
                                    "Value": "ERU"
                                },
                                {
                                    "Text": "ETAH",
                                    "Value": "ETAH"
                                },
                                {
                                    "Text": "ETAWAH",
                                    "Value": "ETAWAH"
                                },
                                {
                                    "Text": "ETMADPUR",
                                    "Value": "ETMADPUR"
                                },
                                {
                                    "Text": "ETTUMANOOR",
                                    "Value": "ETTUMANOOR"
                                },
                                {
                                    "Text": "FAIZABAD",
                                    "Value": "FAIZABAD"
                                },
                                {
                                    "Text": "FALNA",
                                    "Value": "FALNA"
                                },
                                {
                                    "Text": "FARIDABAD",
                                    "Value": "FARIDABAD"
                                },
                                {
                                    "Text": "FARIDKOT",
                                    "Value": "FARIDKOT"
                                },
                                {
                                    "Text": "FARIDPUR",
                                    "Value": "FARIDPUR"
                                },
                                {
                                    "Text": "FARRUKHABAD",
                                    "Value": "FARRUKHABAD"
                                },
                                {
                                    "Text": "FARRUKHNAGAR",
                                    "Value": "FARRUKHNAGAR"
                                },
                                {
                                    "Text": "FATEGHGARH CHURIAN",
                                    "Value": "FATEGHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHABAD",
                                    "Value": "FATEHABAD"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHGARH CHURIAN",
                                    "Value": "FATEHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHPUR SHEKHAWATI",
                                    "Value": "FATEHPUR SHEKHAWATI"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHABAD",
                                    "Value": "FATEHABAD"
                                },
                                {
                                    "Text": "FATEHGARH SAHIB",
                                    "Value": "FATEHGARH SAHIB"
                                },
                                {
                                    "Text": "FATEHGARH",
                                    "Value": "FATEHGARH"
                                },
                                {
                                    "Text": "FATEHGARH - UP",
                                    "Value": "FATEHGARH - UP"
                                },
                                {
                                    "Text": "FATEHGARH CHURIAN",
                                    "Value": "FATEHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHGARH PUNJTUR",
                                    "Value": "FATEHGARH PUNJTUR"
                                },
                                {
                                    "Text": "FATEHGARH SABRAH",
                                    "Value": "FATEHGARH SABRAH"
                                },
                                {
                                    "Text": "FATEHNAGAR",
                                    "Value": "FATEHNAGAR"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATHEPUR",
                                    "Value": "FATHEPUR"
                                },
                                {
                                    "Text": "FATHEGARH SHUKARCHAK",
                                    "Value": "FATHEGARH SHUKARCHAK"
                                },
                                {
                                    "Text": "FATORDA",
                                    "Value": "FATORDA"
                                },
                                {
                                    "Text": "FAZALWAS",
                                    "Value": "FAZALWAS"
                                },
                                {
                                    "Text": "FAZILKA",
                                    "Value": "FAZILKA"
                                },
                                {
                                    "Text": "FEROKE",
                                    "Value": "FEROKE"
                                },
                                {
                                    "Text": "FEROZPUR",
                                    "Value": "FEROZPUR"
                                },
                                {
                                    "Text": "FEROZEPUR",
                                    "Value": "FEROZEPUR"
                                },
                                {
                                    "Text": "FEROZEPUR JHIRKA",
                                    "Value": "FEROZEPUR JHIRKA"
                                },
                                {
                                    "Text": "FEROZPUR CANTT",
                                    "Value": "FEROZPUR CANTT"
                                },
                                {
                                    "Text": "FILM NAGAR",
                                    "Value": "FILM NAGAR"
                                },
                                {
                                    "Text": "FIROZABAD",
                                    "Value": "FIROZABAD"
                                },
                                {
                                    "Text": "FIROZPUR",
                                    "Value": "FIROZPUR"
                                },
                                {
                                    "Text": "FORBESGANJ",
                                    "Value": "FORBESGANJ"
                                },
                                {
                                    "Text": "FARIDNAGAR",
                                    "Value": "FARIDNAGAR"
                                },
                                {
                                    "Text": "FEROZABAD",
                                    "Value": "FEROZABAD"
                                },
                                {
                                    "Text": "FUJAIRAH",
                                    "Value": "FUJAIRAH"
                                },
                                {
                                    "Text": "FUTANA ",
                                    "Value": "FUTANA "
                                },
                                {
                                    "Text": "GABBADA ",
                                    "Value": "GABBADA "
                                },
                                {
                                    "Text": "GADARWARA",
                                    "Value": "GADARWARA"
                                },
                                {
                                    "Text": "GADAG",
                                    "Value": "GADAG"
                                },
                                {
                                    "Text": "GADARPUR",
                                    "Value": "GADARPUR"
                                },
                                {
                                    "Text": "GADCHIROLI",
                                    "Value": "GADCHIROLI"
                                },
                                {
                                    "Text": "GADDAN DOAB",
                                    "Value": "GADDAN DOAB"
                                },
                                {
                                    "Text": "GADHINGLAJ",
                                    "Value": "GADHINGLAJ"
                                },
                                {
                                    "Text": "GADHEJALGAON ",
                                    "Value": "GADHEJALGAON "
                                },
                                {
                                    "Text": "GADMUDSHINGI",
                                    "Value": "GADMUDSHINGI"
                                },
                                {
                                    "Text": "GADWAL",
                                    "Value": "GADWAL"
                                },
                                {
                                    "Text": "GAGGO MAHAL",
                                    "Value": "GAGGO MAHAL"
                                },
                                {
                                    "Text": "GAGRET",
                                    "Value": "GAGRET"
                                },
                                {
                                    "Text": "GAHAM",
                                    "Value": "GAHAM"
                                },
                                {
                                    "Text": "GAHAUR",
                                    "Value": "GAHAUR"
                                },
                                {
                                    "Text": "GAJAPATI",
                                    "Value": "GAJAPATI"
                                },
                                {
                                    "Text": "GAJRAULA",
                                    "Value": "GAJRAULA"
                                },
                                {
                                    "Text": "GAJUWAKA",
                                    "Value": "GAJUWAKA"
                                },
                                {
                                    "Text": "GANAPAVARAM ",
                                    "Value": "GANAPAVARAM "
                                },
                                {
                                    "Text": "GANAUR",
                                    "Value": "GANAUR"
                                },
                                {
                                    "Text": "GANDHIDHAM",
                                    "Value": "GANDHIDHAM"
                                },
                                {
                                    "Text": "GANDHINAGAR",
                                    "Value": "GANDHINAGAR"
                                },
                                {
                                    "Text": "GANDERBAL",
                                    "Value": "GANDERBAL"
                                },
                                {
                                    "Text": "GANDHI NAGAR",
                                    "Value": "GANDHI NAGAR"
                                },
                                {
                                    "Text": "GANDHICHOWK",
                                    "Value": "GANDHICHOWK"
                                },
                                {
                                    "Text": "GANDEVI",
                                    "Value": "GANDEVI"
                                },
                                {
                                    "Text": "GANESWARPUR",
                                    "Value": "GANESWARPUR"
                                },
                                {
                                    "Text": "GANGANAGAR",
                                    "Value": "GANGANAGAR"
                                },
                                {
                                    "Text": "GANGAVATI",
                                    "Value": "GANGAVATI"
                                },
                                {
                                    "Text": "GANGTOK",
                                    "Value": "GANGTOK"
                                },
                                {
                                    "Text": "GANGUPAHAD ",
                                    "Value": "GANGUPAHAD "
                                },
                                {
                                    "Text": "GANGAPUR PURVI ",
                                    "Value": "GANGAPUR PURVI "
                                },
                                {
                                    "Text": "GANGAKHED",
                                    "Value": "GANGAKHED"
                                },
                                {
                                    "Text": "GANGAPUR CITY",
                                    "Value": "GANGAPUR CITY"
                                },
                                {
                                    "Text": "GANGAWATI",
                                    "Value": "GANGAWATI"
                                },
                                {
                                    "Text": "GANGOH",
                                    "Value": "GANGOH"
                                },
                                {
                                    "Text": "GANJ BASODA",
                                    "Value": "GANJ BASODA"
                                },
                                {
                                    "Text": "GANJAM",
                                    "Value": "GANJAM"
                                },
                                {
                                    "Text": "GANNAVARAM",
                                    "Value": "GANNAVARAM"
                                },
                                {
                                    "Text": "GARDHIWAL",
                                    "Value": "GARDHIWAL"
                                },
                                {
                                    "Text": "GARGOTI",
                                    "Value": "GARGOTI"
                                },
                                {
                                    "Text": "GARHSHANKAR",
                                    "Value": "GARHSHANKAR"
                                },
                                {
                                    "Text": "GARHWA",
                                    "Value": "GARHWA"
                                },
                                {
                                    "Text": "GARIABAND",
                                    "Value": "GARIABAND"
                                },
                                {
                                    "Text": "GAROBADHA",
                                    "Value": "GAROBADHA"
                                },
                                {
                                    "Text": "GAURIBIDANUR",
                                    "Value": "GAURIBIDANUR"
                                },
                                {
                                    "Text": "GAUTAM BUDDHA NAGAR",
                                    "Value": "GAUTAM BUDDHA NAGAR"
                                },
                                {
                                    "Text": "GAYA",
                                    "Value": "GAYA"
                                },
                                {
                                    "Text": "GB NAGAR",
                                    "Value": "GB NAGAR"
                                },
                                {
                                    "Text": "GB NAGAR",
                                    "Value": "GB NAGAR"
                                },
                                {
                                    "Text": "GADHADA",
                                    "Value": "GADHADA"
                                },
                                {
                                    "Text": "GENOME VALLEY",
                                    "Value": "GENOME VALLEY"
                                },
                                {
                                    "Text": "GEORAI KUBER ",
                                    "Value": "GEORAI KUBER "
                                },
                                {
                                    "Text": "GHALLKHURD",
                                    "Value": "GHALLKHURD"
                                },
                                {
                                    "Text": "GHAMROZ",
                                    "Value": "GHAMROZ"
                                },
                                {
                                    "Text": "GHANPUR ",
                                    "Value": "GHANPUR "
                                },
                                {
                                    "Text": "GHANAUR",
                                    "Value": "GHANAUR"
                                },
                                {
                                    "Text": "GHATAMPUR",
                                    "Value": "GHATAMPUR"
                                },
                                {
                                    "Text": "GHATSHILA",
                                    "Value": "GHATSHILA"
                                },
                                {
                                    "Text": "GHAZIABAD",
                                    "Value": "GHAZIABAD"
                                },
                                {
                                    "Text": "GHAZIPUR",
                                    "Value": "GHAZIPUR"
                                },
                                {
                                    "Text": "GHAZIABAD UP",
                                    "Value": "GHAZIABAD UP"
                                },
                                {
                                    "Text": "GHILOR KALAN",
                                    "Value": "GHILOR KALAN"
                                },
                                {
                                    "Text": "GHODIYAL",
                                    "Value": "GHODIYAL"
                                },
                                {
                                    "Text": "GHOGHLA",
                                    "Value": "GHOGHLA"
                                },
                                {
                                    "Text": "GHOGRA",
                                    "Value": "GHOGRA"
                                },
                                {
                                    "Text": "GHOSI",
                                    "Value": "GHOSI"
                                },
                                {
                                    "Text": "GHOTI BUDRUK",
                                    "Value": "GHOTI BUDRUK"
                                },
                                {
                                    "Text": "GHEORA",
                                    "Value": "GHEORA"
                                },
                                {
                                    "Text": "GHARONDA NEEMKA BANGAR",
                                    "Value": "GHARONDA NEEMKA BANGAR"
                                },
                                {
                                    "Text": "GHAROLI",
                                    "Value": "GHAROLI"
                                },
                                {
                                    "Text": "GHATAL",
                                    "Value": "GHATAL"
                                },
                                {
                                    "Text": "GHITORNI",
                                    "Value": "GHITORNI"
                                },
                                {
                                    "Text": "GHUDDA",
                                    "Value": "GHUDDA"
                                },
                                {
                                    "Text": "GHUGIANA ",
                                    "Value": "GHUGIANA "
                                },
                                {
                                    "Text": "GHUMAN",
                                    "Value": "GHUMAN"
                                },
                                {
                                    "Text": "GARHWAL",
                                    "Value": "GARHWAL"
                                },
                                {
                                    "Text": "GIDDARBAHA",
                                    "Value": "GIDDARBAHA"
                                },
                                {
                                    "Text": "GIDDALUR",
                                    "Value": "GIDDALUR"
                                },
                                {
                                    "Text": "GIDDERBAHA",
                                    "Value": "GIDDERBAHA"
                                },
                                {
                                    "Text": "GILJEWALA",
                                    "Value": "GILJEWALA"
                                },
                                {
                                    "Text": "GILL ROAD",
                                    "Value": "GILL ROAD"
                                },
                                {
                                    "Text": "GILL",
                                    "Value": "GILL"
                                },
                                {
                                    "Text": "GIRGITPALLE ",
                                    "Value": "GIRGITPALLE "
                                },
                                {
                                    "Text": "GIRIDIH",
                                    "Value": "GIRIDIH"
                                },
                                {
                                    "Text": "GIRIDH",
                                    "Value": "GIRIDH"
                                },
                                {
                                    "Text": "GOKAL PUR",
                                    "Value": "GOKAL PUR"
                                },
                                {
                                    "Text": "GOMTI NAGAR",
                                    "Value": "GOMTI NAGAR"
                                },
                                {
                                    "Text": "GANGARAMPUR",
                                    "Value": "GANGARAMPUR"
                                },
                                {
                                    "Text": "GOA",
                                    "Value": "GOA"
                                },
                                {
                                    "Text": "GOALPARA",
                                    "Value": "GOALPARA"
                                },
                                {
                                    "Text": "GOA VELHA",
                                    "Value": "GOA VELHA"
                                },
                                {
                                    "Text": "GOA VELHA",
                                    "Value": "GOA VELHA"
                                },
                                {
                                    "Text": "GOBI",
                                    "Value": "GOBI"
                                },
                                {
                                    "Text": "GOBICHETTIPALAYAM",
                                    "Value": "GOBICHETTIPALAYAM"
                                },
                                {
                                    "Text": "GOBINDGARH",
                                    "Value": "GOBINDGARH"
                                },
                                {
                                    "Text": "GOBORDANGA",
                                    "Value": "GOBORDANGA"
                                },
                                {
                                    "Text": "GODAVARIKHANI",
                                    "Value": "GODAVARIKHANI"
                                },
                                {
                                    "Text": "GODAMGUDA ",
                                    "Value": "GODAMGUDA "
                                },
                                {
                                    "Text": "GODBOLEMALA",
                                    "Value": "GODBOLEMALA"
                                },
                                {
                                    "Text": "GODDA",
                                    "Value": "GODDA"
                                },
                                {
                                    "Text": "GODHRA",
                                    "Value": "GODHRA"
                                },
                                {
                                    "Text": "GODHRA BHURAVAV ",
                                    "Value": "GODHRA BHURAVAV "
                                },
                                {
                                    "Text": "GODHAVI",
                                    "Value": "GODHAVI"
                                },
                                {
                                    "Text": "GOGOANI",
                                    "Value": "GOGOANI"
                                },
                                {
                                    "Text": "GOGOANI",
                                    "Value": "GOGOANI"
                                },
                                {
                                    "Text": "GOHANA",
                                    "Value": "GOHANA"
                                },
                                {
                                    "Text": "GOINDWAL",
                                    "Value": "GOINDWAL"
                                },
                                {
                                    "Text": "GOKAK",
                                    "Value": "GOKAK"
                                },
                                {
                                    "Text": "GOLAGHAT",
                                    "Value": "GOLAGHAT"
                                },
                                {
                                    "Text": "GOLATGAON ",
                                    "Value": "GOLATGAON "
                                },
                                {
                                    "Text": "GOLA GOKARAN NATH",
                                    "Value": "GOLA GOKARAN NATH"
                                },
                                {
                                    "Text": "GOLA",
                                    "Value": "GOLA"
                                },
                                {
                                    "Text": "GOLEWALA ",
                                    "Value": "GOLEWALA "
                                },
                                {
                                    "Text": "GOLEWALA",
                                    "Value": "GOLEWALA"
                                },
                                {
                                    "Text": "GOLLALAGUDUR ",
                                    "Value": "GOLLALAGUDUR "
                                },
                                {
                                    "Text": "GOMATI",
                                    "Value": "GOMATI"
                                },
                                {
                                    "Text": "GONDAL",
                                    "Value": "GONDAL"
                                },
                                {
                                    "Text": "GONDA",
                                    "Value": "GONDA"
                                },
                                {
                                    "Text": "GONDIA",
                                    "Value": "GONDIA"
                                },
                                {
                                    "Text": "GONDIPAKALAU ",
                                    "Value": "GONDIPAKALAU "
                                },
                                {
                                    "Text": "GONIANA MANDI",
                                    "Value": "GONIANA MANDI"
                                },
                                {
                                    "Text": "GONIANA",
                                    "Value": "GONIANA"
                                },
                                {
                                    "Text": "GONIKOPPAL",
                                    "Value": "GONIKOPPAL"
                                },
                                {
                                    "Text": "GOPALGANJ",
                                    "Value": "GOPALGANJ"
                                },
                                {
                                    "Text": "GOPANAPALLE",
                                    "Value": "GOPANAPALLE"
                                },
                                {
                                    "Text": "GOPINAGAR",
                                    "Value": "GOPINAGAR"
                                },
                                {
                                    "Text": "GORAYA",
                                    "Value": "GORAYA"
                                },
                                {
                                    "Text": "GORAKHPUR",
                                    "Value": "GORAKHPUR"
                                },
                                {
                                    "Text": "GORAKNATH",
                                    "Value": "GORAKNATH"
                                },
                                {
                                    "Text": "GOREGAON",
                                    "Value": "GOREGAON"
                                },
                                {
                                    "Text": "GOTIBANDH ",
                                    "Value": "GOTIBANDH "
                                },
                                {
                                    "Text": "GOTTIMUKKALA ",
                                    "Value": "GOTTIMUKKALA "
                                },
                                {
                                    "Text": "GOTUR ",
                                    "Value": "GOTUR "
                                },
                                {
                                    "Text": "GOUDGOP",
                                    "Value": "GOUDGOP"
                                },
                                {
                                    "Text": "GOVERDHAN",
                                    "Value": "GOVERDHAN"
                                },
                                {
                                    "Text": "GOVINDPET ",
                                    "Value": "GOVINDPET "
                                },
                                {
                                    "Text": "GOVINDPET",
                                    "Value": "GOVINDPET"
                                },
                                {
                                    "Text": "GOWARDHAN ",
                                    "Value": "GOWARDHAN "
                                },
                                {
                                    "Text": "GOWRISANKARA PURAM ",
                                    "Value": "GOWRISANKARA PURAM "
                                },
                                {
                                    "Text": "G.PANGIDIGUDEM ",
                                    "Value": "G.PANGIDIGUDEM "
                                },
                                {
                                    "Text": "GANDHI PADIA",
                                    "Value": "GANDHI PADIA"
                                },
                                {
                                    "Text": "GREATER NOIDA",
                                    "Value": "GREATER NOIDA"
                                },
                                {
                                    "Text": "GAROBADHA",
                                    "Value": "GAROBADHA"
                                },
                                {
                                    "Text": "GARIYADHAR",
                                    "Value": "GARIYADHAR"
                                },
                                {
                                    "Text": "GUDIYATHAM",
                                    "Value": "GUDIYATHAM"
                                },
                                {
                                    "Text": "GUDAH",
                                    "Value": "GUDAH"
                                },
                                {
                                    "Text": "GUDIVADA",
                                    "Value": "GUDIVADA"
                                },
                                {
                                    "Text": "GUDLI",
                                    "Value": "GUDLI"
                                },
                                {
                                    "Text": "GUDUR",
                                    "Value": "GUDUR"
                                },
                                {
                                    "Text": "GUDUR ",
                                    "Value": "GUDUR "
                                },
                                {
                                    "Text": "GULAOTHI",
                                    "Value": "GULAOTHI"
                                },
                                {
                                    "Text": "GULBARGA",
                                    "Value": "GULBARGA"
                                },
                                {
                                    "Text": "GUMARWIN",
                                    "Value": "GUMARWIN"
                                },
                                {
                                    "Text": "GUMIA",
                                    "Value": "GUMIA"
                                },
                                {
                                    "Text": "GUMLA",
                                    "Value": "GUMLA"
                                },
                                {
                                    "Text": "GUNA",
                                    "Value": "GUNA"
                                },
                                {
                                    "Text": "GUNDRATHIMADUGU ",
                                    "Value": "GUNDRATHIMADUGU "
                                },
                                {
                                    "Text": "GUNDUPALA ",
                                    "Value": "GUNDUPALA "
                                },
                                {
                                    "Text": "GUNTAKAL",
                                    "Value": "GUNTAKAL"
                                },
                                {
                                    "Text": "GUNTUR",
                                    "Value": "GUNTUR"
                                },
                                {
                                    "Text": "GURANDARAPALEM ",
                                    "Value": "GURANDARAPALEM "
                                },
                                {
                                    "Text": "GURDASPUR",
                                    "Value": "GURDASPUR"
                                },
                                {
                                    "Text": "GURGAON",
                                    "Value": "GURGAON"
                                },
                                {
                                    "Text": "GURGAON",
                                    "Value": "GURGAON"
                                },
                                {
                                    "Text": "GURNE KALAN",
                                    "Value": "GURNE KALAN"
                                },
                                {
                                    "Text": "GURSIA ",
                                    "Value": "GURSIA "
                                },
                                {
                                    "Text": "GURSARAI",
                                    "Value": "GURSARAI"
                                },
                                {
                                    "Text": "GURUVAYUR",
                                    "Value": "GURUVAYUR"
                                },
                                {
                                    "Text": "GURUHARSAHAI",
                                    "Value": "GURUHARSAHAI"
                                },
                                {
                                    "Text": "GURUVAYOOR",
                                    "Value": "GURUVAYOOR"
                                },
                                {
                                    "Text": "GURVAIGUDEM ",
                                    "Value": "GURVAIGUDEM "
                                },
                                {
                                    "Text": "GUSKARA",
                                    "Value": "GUSKARA"
                                },
                                {
                                    "Text": "GUSKARA",
                                    "Value": "GUSKARA"
                                },
                                {
                                    "Text": "GUWAHATI",
                                    "Value": "GUWAHATI"
                                },
                                {
                                    "Text": "GWALIOR",
                                    "Value": "GWALIOR"
                                },
                                {
                                    "Text": "HABRA",
                                    "Value": "HABRA"
                                },
                                {
                                    "Text": "HADAMTALA",
                                    "Value": "HADAMTALA"
                                },
                                {
                                    "Text": "HADGOOD",
                                    "Value": "HADGOOD"
                                },
                                {
                                    "Text": "HADIYOL",
                                    "Value": "HADIYOL"
                                },
                                {
                                    "Text": "HAIBOWAL KALAN",
                                    "Value": "HAIBOWAL KALAN"
                                },
                                {
                                    "Text": "HAIDERGARH",
                                    "Value": "HAIDERGARH"
                                },
                                {
                                    "Text": "HAILAKANDI",
                                    "Value": "HAILAKANDI"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HAJIRA",
                                    "Value": "HAJIRA"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HALDWANI",
                                    "Value": "HALDWANI"
                                },
                                {
                                    "Text": "HALDIA",
                                    "Value": "HALDIA"
                                },
                                {
                                    "Text": "HALLY MANDI",
                                    "Value": "HALLY MANDI"
                                },
                                {
                                    "Text": "HALOL",
                                    "Value": "HALOL"
                                },
                                {
                                    "Text": "HALVAD",
                                    "Value": "HALVAD"
                                },
                                {
                                    "Text": "HAMBRAN",
                                    "Value": "HAMBRAN"
                                },
                                {
                                    "Text": "HAMIRPUR",
                                    "Value": "HAMIRPUR"
                                },
                                {
                                    "Text": "HAMIRPUR(HP)",
                                    "Value": "HAMIRPUR(HP)"
                                },
                                {
                                    "Text": "HAMIRPUR",
                                    "Value": "HAMIRPUR"
                                },
                                {
                                    "Text": "HANUMAKONDA",
                                    "Value": "HANUMAKONDA"
                                },
                                {
                                    "Text": "HANAGODU ",
                                    "Value": "HANAGODU "
                                },
                                {
                                    "Text": "HANDIA",
                                    "Value": "HANDIA"
                                },
                                {
                                    "Text": "HANDWARA",
                                    "Value": "HANDWARA"
                                },
                                {
                                    "Text": "HANSI",
                                    "Value": "HANSI"
                                },
                                {
                                    "Text": "HANUMANGARH TOWN",
                                    "Value": "HANUMANGARH TOWN"
                                },
                                {
                                    "Text": "HANUMANGARH",
                                    "Value": "HANUMANGARH"
                                },
                                {
                                    "Text": "HANUMANTHAPUR ",
                                    "Value": "HANUMANTHAPUR "
                                },
                                {
                                    "Text": "HANUMAPUR ",
                                    "Value": "HANUMAPUR "
                                },
                                {
                                    "Text": "HANUMAN JUNCTION",
                                    "Value": "HANUMAN JUNCTION"
                                },
                                {
                                    "Text": "HAPUR",
                                    "Value": "HAPUR"
                                },
                                {
                                    "Text": "HARCHOWAL",
                                    "Value": "HARCHOWAL"
                                },
                                {
                                    "Text": "HARDA",
                                    "Value": "HARDA"
                                },
                                {
                                    "Text": "HARDOI",
                                    "Value": "HARDOI"
                                },
                                {
                                    "Text": "HARIDWAR",
                                    "Value": "HARIDWAR"
                                },
                                {
                                    "Text": "HARIDWAR",
                                    "Value": "HARIDWAR"
                                },
                                {
                                    "Text": "HARIPURDHAR",
                                    "Value": "HARIPURDHAR"
                                },
                                {
                                    "Text": "HARINDRA NAGAR (FARIDKOT) ",
                                    "Value": "HARINDRA NAGAR (FARIDKOT) "
                                },
                                {
                                    "Text": "HARI KE PATTAN",
                                    "Value": "HARI KE PATTAN"
                                },
                                {
                                    "Text": "HARIANA",
                                    "Value": "HARIANA"
                                },
                                {
                                    "Text": "HARIJ",
                                    "Value": "HARIJ"
                                },
                                {
                                    "Text": "HARIPAR PAL",
                                    "Value": "HARIPAR PAL"
                                },
                                {
                                    "Text": "HARYAU",
                                    "Value": "HARYAU"
                                },
                                {
                                    "Text": "HASANPUR",
                                    "Value": "HASANPUR"
                                },
                                {
                                    "Text": "HASSAN",
                                    "Value": "HASSAN"
                                },
                                {
                                    "Text": "HASSANPUR",
                                    "Value": "HASSANPUR"
                                },
                                {
                                    "Text": "HASTEPIMPALGAON ",
                                    "Value": "HASTEPIMPALGAON "
                                },
                                {
                                    "Text": "HATA",
                                    "Value": "HATA"
                                },
                                {
                                    "Text": "HATABUZURG",
                                    "Value": "HATABUZURG"
                                },
                                {
                                    "Text": "HATHRAS",
                                    "Value": "HATHRAS"
                                },
                                {
                                    "Text": "HATHIN",
                                    "Value": "HATHIN"
                                },
                                {
                                    "Text": "HASTSAL",
                                    "Value": "HASTSAL"
                                },
                                {
                                    "Text": "HAVERI",
                                    "Value": "HAVERI"
                                },
                                {
                                    "Text": "HAYATNAGAR",
                                    "Value": "HAYATNAGAR"
                                },
                                {
                                    "Text": "HAYATPUR",
                                    "Value": "HAYATPUR"
                                },
                                {
                                    "Text": "HAZARIBAG",
                                    "Value": "HAZARIBAG"
                                },
                                {
                                    "Text": "HAZARIBAGH",
                                    "Value": "HAZARIBAGH"
                                },
                                {
                                    "Text": "HERBERTPUR",
                                    "Value": "HERBERTPUR"
                                },
                                {
                                    "Text": "HILSA",
                                    "Value": "HILSA"
                                },
                                {
                                    "Text": "HIMATNAGAR",
                                    "Value": "HIMATNAGAR"
                                },
                                {
                                    "Text": "HIMMATNAGAR",
                                    "Value": "HIMMATNAGAR"
                                },
                                {
                                    "Text": "HINDUPUR",
                                    "Value": "HINDUPUR"
                                },
                                {
                                    "Text": "HINDAUN",
                                    "Value": "HINDAUN"
                                },
                                {
                                    "Text": "HINGANGHAT",
                                    "Value": "HINGANGHAT"
                                },
                                {
                                    "Text": "HINGOLI",
                                    "Value": "HINGOLI"
                                },
                                {
                                    "Text": "HINGNA",
                                    "Value": "HINGNA"
                                },
                                {
                                    "Text": "HINDMOTOR",
                                    "Value": "HINDMOTOR"
                                },
                                {
                                    "Text": "HIRIYUR",
                                    "Value": "HIRIYUR"
                                },
                                {
                                    "Text": "HIRPURA",
                                    "Value": "HIRPURA"
                                },
                                {
                                    "Text": "HISAR",
                                    "Value": "HISAR"
                                },
                                {
                                    "Text": "HISSAR",
                                    "Value": "HISSAR"
                                },
                                {
                                    "Text": "HAILEYMANDI",
                                    "Value": "HAILEYMANDI"
                                },
                                {
                                    "Text": "HODAL",
                                    "Value": "HODAL"
                                },
                                {
                                    "Text": "HOJAI",
                                    "Value": "HOJAI"
                                },
                                {
                                    "Text": "HOMNABAD",
                                    "Value": "HOMNABAD"
                                },
                                {
                                    "Text": "HONAVAR",
                                    "Value": "HONAVAR"
                                },
                                {
                                    "Text": "HONNENAHALLI ",
                                    "Value": "HONNENAHALLI "
                                },
                                {
                                    "Text": "HOOGHLY",
                                    "Value": "HOOGHLY"
                                },
                                {
                                    "Text": "HOSHANGABAD",
                                    "Value": "HOSHANGABAD"
                                },
                                {
                                    "Text": "HOSHIARPUR",
                                    "Value": "HOSHIARPUR"
                                },
                                {
                                    "Text": "HOSPET",
                                    "Value": "HOSPET"
                                },
                                {
                                    "Text": "HOSUR",
                                    "Value": "HOSUR"
                                },
                                {
                                    "Text": "HOWRAH",
                                    "Value": "HOWRAH"
                                },
                                {
                                    "Text": "HIRANAGAR",
                                    "Value": "HIRANAGAR"
                                },
                                {
                                    "Text": "HARIPAD",
                                    "Value": "HARIPAD"
                                },
                                {
                                    "Text": "HARISHNAGAR",
                                    "Value": "HARISHNAGAR"
                                },
                                {
                                    "Text": "HUBLI",
                                    "Value": "HUBLI"
                                },
                                {
                                    "Text": "HUDLI",
                                    "Value": "HUDLI"
                                },
                                {
                                    "Text": "HUGLI",
                                    "Value": "HUGLI"
                                },
                                {
                                    "Text": "HUNASAMARANAHALLI",
                                    "Value": "HUNASAMARANAHALLI"
                                },
                                {
                                    "Text": "HUNSA",
                                    "Value": "HUNSA"
                                },
                                {
                                    "Text": "HUNSUR",
                                    "Value": "HUNSUR"
                                },
                                {
                                    "Text": "HUPARI",
                                    "Value": "HUPARI"
                                },
                                {
                                    "Text": "HUSNABAD",
                                    "Value": "HUSNABAD"
                                },
                                {
                                    "Text": "HUSSAINPUR",
                                    "Value": "HUSSAINPUR"
                                },
                                {
                                    "Text": "HUSSAINPUR (CT)",
                                    "Value": "HUSSAINPUR (CT)"
                                },
                                {
                                    "Text": "HUZURABAD",
                                    "Value": "HUZURABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "IBBAN ",
                                    "Value": "IBBAN "
                                },
                                {
                                    "Text": "IBBAN",
                                    "Value": "IBBAN"
                                },
                                {
                                    "Text": "ICHALKARANJI",
                                    "Value": "ICHALKARANJI"
                                },
                                {
                                    "Text": "IDAR",
                                    "Value": "IDAR"
                                },
                                {
                                    "Text": "IDUKKI",
                                    "Value": "IDUKKI"
                                },
                                {
                                    "Text": "IGATPURI",
                                    "Value": "IGATPURI"
                                },
                                {
                                    "Text": "IGNTU AMARKANTAK .",
                                    "Value": "IGNTU AMARKANTAK ."
                                },
                                {
                                    "Text": "IKAUNA",
                                    "Value": "IKAUNA"
                                },
                                {
                                    "Text": "ILAMPILLAI",
                                    "Value": "ILAMPILLAI"
                                },
                                {
                                    "Text": "ISLAMPUR",
                                    "Value": "ISLAMPUR"
                                },
                                {
                                    "Text": "IMALYAKA",
                                    "Value": "IMALYAKA"
                                },
                                {
                                    "Text": "IMPHAL",
                                    "Value": "IMPHAL"
                                },
                                {
                                    "Text": "IMPHAL EAST",
                                    "Value": "IMPHAL EAST"
                                },
                                {
                                    "Text": "IMPHAL WEST",
                                    "Value": "IMPHAL WEST"
                                },
                                {
                                    "Text": "IMPHAL EAST",
                                    "Value": "IMPHAL EAST"
                                },
                                {
                                    "Text": "INDAPUR",
                                    "Value": "INDAPUR"
                                },
                                {
                                    "Text": "INDORE",
                                    "Value": "INDORE"
                                },
                                {
                                    "Text": "INDIRAPURAM",
                                    "Value": "INDIRAPURAM"
                                },
                                {
                                    "Text": "INDRAD",
                                    "Value": "INDRAD"
                                },
                                {
                                    "Text": "INDRAPURA",
                                    "Value": "INDRAPURA"
                                },
                                {
                                    "Text": "INDRI",
                                    "Value": "INDRI"
                                },
                                {
                                    "Text": "INDUPUR",
                                    "Value": "INDUPUR"
                                },
                                {
                                    "Text": "INNADU ",
                                    "Value": "INNADU "
                                },
                                {
                                    "Text": "IPPATLA ",
                                    "Value": "IPPATLA "
                                },
                                {
                                    "Text": "IRINJALAKUDA",
                                    "Value": "IRINJALAKUDA"
                                },
                                {
                                    "Text": "IRINJALAGUDA",
                                    "Value": "IRINJALAGUDA"
                                },
                                {
                                    "Text": "ISLAMPUR",
                                    "Value": "ISLAMPUR"
                                },
                                {
                                    "Text": "ISMAILABAD",
                                    "Value": "ISMAILABAD"
                                },
                                {
                                    "Text": "ISPUR",
                                    "Value": "ISPUR"
                                },
                                {
                                    "Text": "ISRANA",
                                    "Value": "ISRANA"
                                },
                                {
                                    "Text": "ISSAPALLI ",
                                    "Value": "ISSAPALLI "
                                },
                                {
                                    "Text": "ITANAGAR",
                                    "Value": "ITANAGAR"
                                },
                                {
                                    "Text": "ITARSI",
                                    "Value": "ITARSI"
                                },
                                {
                                    "Text": "ITAWA KALAN",
                                    "Value": "ITAWA KALAN"
                                },
                                {
                                    "Text": "JABALPUR",
                                    "Value": "JABALPUR"
                                },
                                {
                                    "Text": "JABBOWAL",
                                    "Value": "JABBOWAL"
                                },
                                {
                                    "Text": "JADCHERLA",
                                    "Value": "JADCHERLA"
                                },
                                {
                                    "Text": "JADLA",
                                    "Value": "JADLA"
                                },
                                {
                                    "Text": "JAGATSINGHPUR",
                                    "Value": "JAGATSINGHPUR"
                                },
                                {
                                    "Text": "JAGADHRI",
                                    "Value": "JAGADHRI"
                                },
                                {
                                    "Text": "JAGADHARI",
                                    "Value": "JAGADHARI"
                                },
                                {
                                    "Text": "JAGATSINGHAPUR",
                                    "Value": "JAGATSINGHAPUR"
                                },
                                {
                                    "Text": "JAGADISHPUR",
                                    "Value": "JAGADISHPUR"
                                },
                                {
                                    "Text": "JAGATPUR",
                                    "Value": "JAGATPUR"
                                },
                                {
                                    "Text": "JAGDALPUR",
                                    "Value": "JAGDALPUR"
                                },
                                {
                                    "Text": "JAGGAYYAPET",
                                    "Value": "JAGGAYYAPET"
                                },
                                {
                                    "Text": "JAGGAYAPET",
                                    "Value": "JAGGAYAPET"
                                },
                                {
                                    "Text": "JAGIROAD",
                                    "Value": "JAGIROAD"
                                },
                                {
                                    "Text": "JAGITYALA",
                                    "Value": "JAGITYALA"
                                },
                                {
                                    "Text": "JAGRAON",
                                    "Value": "JAGRAON"
                                },
                                {
                                    "Text": "JAHANGIRABAD",
                                    "Value": "JAHANGIRABAD"
                                },
                                {
                                    "Text": "JAHANPUR",
                                    "Value": "JAHANPUR"
                                },
                                {
                                    "Text": "JAIDUPALLI ",
                                    "Value": "JAIDUPALLI "
                                },
                                {
                                    "Text": "JAIMAL WALA ",
                                    "Value": "JAIMAL WALA "
                                },
                                {
                                    "Text": "JAINTIA HILLS",
                                    "Value": "JAINTIA HILLS"
                                },
                                {
                                    "Text": "JAIPUR",
                                    "Value": "JAIPUR"
                                },
                                {
                                    "Text": "JAIRAMPUR",
                                    "Value": "JAIRAMPUR"
                                },
                                {
                                    "Text": "JAISALMER",
                                    "Value": "JAISALMER"
                                },
                                {
                                    "Text": "JAIS",
                                    "Value": "JAIS"
                                },
                                {
                                    "Text": "JAISALEMER",
                                    "Value": "JAISALEMER"
                                },
                                {
                                    "Text": "JAISINGHPUR",
                                    "Value": "JAISINGHPUR"
                                },
                                {
                                    "Text": "JAITU",
                                    "Value": "JAITU"
                                },
                                {
                                    "Text": "JAJAPUR",
                                    "Value": "JAJAPUR"
                                },
                                {
                                    "Text": "JAJPUR ROAD",
                                    "Value": "JAJPUR ROAD"
                                },
                                {
                                    "Text": "JAJPUR TOWN",
                                    "Value": "JAJPUR TOWN"
                                },
                                {
                                    "Text": "JAJPUR",
                                    "Value": "JAJPUR"
                                },
                                {
                                    "Text": "JAKHAL",
                                    "Value": "JAKHAL"
                                },
                                {
                                    "Text": "JALALABAD",
                                    "Value": "JALALABAD"
                                },
                                {
                                    "Text": "JALANDHAR",
                                    "Value": "JALANDHAR"
                                },
                                {
                                    "Text": "JALAUN",
                                    "Value": "JALAUN"
                                },
                                {
                                    "Text": "JALALPUR",
                                    "Value": "JALALPUR"
                                },
                                {
                                    "Text": "JALANDHAR CANTT",
                                    "Value": "JALANDHAR CANTT"
                                },
                                {
                                    "Text": "JALGAON",
                                    "Value": "JALGAON"
                                },
                                {
                                    "Text": "JALKE ",
                                    "Value": "JALKE "
                                },
                                {
                                    "Text": "JALMANA",
                                    "Value": "JALMANA"
                                },
                                {
                                    "Text": "JALNA",
                                    "Value": "JALNA"
                                },
                                {
                                    "Text": "JALORE",
                                    "Value": "JALORE"
                                },
                                {
                                    "Text": "JALOR",
                                    "Value": "JALOR"
                                },
                                {
                                    "Text": "JALOCHI",
                                    "Value": "JALOCHI"
                                },
                                {
                                    "Text": "JALPAIGURI",
                                    "Value": "JALPAIGURI"
                                },
                                {
                                    "Text": "JAMKHED",
                                    "Value": "JAMKHED"
                                },
                                {
                                    "Text": "JAM JODHPUR",
                                    "Value": "JAM JODHPUR"
                                },
                                {
                                    "Text": "JAMANDLAPALLI ",
                                    "Value": "JAMANDLAPALLI "
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMBUSAR",
                                    "Value": "JAMBUSAR"
                                },
                                {
                                    "Text": "JAMDIH ",
                                    "Value": "JAMDIH "
                                },
                                {
                                    "Text": "JAMGAON",
                                    "Value": "JAMGAON"
                                },
                                {
                                    "Text": "JAMIYATPURA",
                                    "Value": "JAMIYATPURA"
                                },
                                {
                                    "Text": "JAMJODHPUR",
                                    "Value": "JAMJODHPUR"
                                },
                                {
                                    "Text": "JAMKHAMBHALIA",
                                    "Value": "JAMKHAMBHALIA"
                                },
                                {
                                    "Text": "JAMKHANDI",
                                    "Value": "JAMKHANDI"
                                },
                                {
                                    "Text": "JAMMIKUNTA",
                                    "Value": "JAMMIKUNTA"
                                },
                                {
                                    "Text": "JAMMU",
                                    "Value": "JAMMU"
                                },
                                {
                                    "Text": "JAMNAGAR",
                                    "Value": "JAMNAGAR"
                                },
                                {
                                    "Text": "JAMNER",
                                    "Value": "JAMNER"
                                },
                                {
                                    "Text": "JAMSHEDPUR",
                                    "Value": "JAMSHEDPUR"
                                },
                                {
                                    "Text": "JAMSHER",
                                    "Value": "JAMSHER"
                                },
                                {
                                    "Text": "JAMTARA",
                                    "Value": "JAMTARA"
                                },
                                {
                                    "Text": "JAMTUKAM ",
                                    "Value": "JAMTUKAM "
                                },
                                {
                                    "Text": "JAMUI",
                                    "Value": "JAMUI"
                                },
                                {
                                    "Text": "JAMURIA",
                                    "Value": "JAMURIA"
                                },
                                {
                                    "Text": "JANDIALA GURU",
                                    "Value": "JANDIALA GURU"
                                },
                                {
                                    "Text": "JANDIALA",
                                    "Value": "JANDIALA"
                                },
                                {
                                    "Text": "JANDOLI",
                                    "Value": "JANDOLI"
                                },
                                {
                                    "Text": "JANDPUR",
                                    "Value": "JANDPUR"
                                },
                                {
                                    "Text": "JANDU SINGHA",
                                    "Value": "JANDU SINGHA"
                                },
                                {
                                    "Text": "JANGAON",
                                    "Value": "JANGAON"
                                },
                                {
                                    "Text": "JANGAON BAZAR ",
                                    "Value": "JANGAON BAZAR "
                                },
                                {
                                    "Text": "JANGAREDDYGUDEM",
                                    "Value": "JANGAREDDYGUDEM"
                                },
                                {
                                    "Text": "JANGIPUR",
                                    "Value": "JANGIPUR"
                                },
                                {
                                    "Text": "JANIAL",
                                    "Value": "JANIAL"
                                },
                                {
                                    "Text": "JANJAON",
                                    "Value": "JANJAON"
                                },
                                {
                                    "Text": "JANJGIR",
                                    "Value": "JANJGIR"
                                },
                                {
                                    "Text": "JANJGIR-CHAMPA",
                                    "Value": "JANJGIR-CHAMPA"
                                },
                                {
                                    "Text": "JANKAMPET",
                                    "Value": "JANKAMPET"
                                },
                                {
                                    "Text": "JANSUI",
                                    "Value": "JANSUI"
                                },
                                {
                                    "Text": "JAORA",
                                    "Value": "JAORA"
                                },
                                {
                                    "Text": "JARG",
                                    "Value": "JARG"
                                },
                                {
                                    "Text": "JASDAN",
                                    "Value": "JASDAN"
                                },
                                {
                                    "Text": "JASHPUR",
                                    "Value": "JASHPUR"
                                },
                                {
                                    "Text": "JASRA",
                                    "Value": "JASRA"
                                },
                                {
                                    "Text": "JASSUR",
                                    "Value": "JASSUR"
                                },
                                {
                                    "Text": "JASWANT NAGAR",
                                    "Value": "JASWANT NAGAR"
                                },
                                {
                                    "Text": "JATANI",
                                    "Value": "JATANI"
                                },
                                {
                                    "Text": "JATH",
                                    "Value": "JATH"
                                },
                                {
                                    "Text": "JATHERI",
                                    "Value": "JATHERI"
                                },
                                {
                                    "Text": "JATPAR",
                                    "Value": "JATPAR"
                                },
                                {
                                    "Text": "JAUNPUR",
                                    "Value": "JAUNPUR"
                                },
                                {
                                    "Text": "JAURA CHITTRAN",
                                    "Value": "JAURA CHITTRAN"
                                },
                                {
                                    "Text": "JAVKHEDA BK ",
                                    "Value": "JAVKHEDA BK "
                                },
                                {
                                    "Text": "JAWAHAR",
                                    "Value": "JAWAHAR"
                                },
                                {
                                    "Text": "JAYGAON",
                                    "Value": "JAYGAON"
                                },
                                {
                                    "Text": "JAYSINGPUR",
                                    "Value": "JAYSINGPUR"
                                },
                                {
                                    "Text": "JEELGUL",
                                    "Value": "JEELGUL"
                                },
                                {
                                    "Text": "JEHANABAD",
                                    "Value": "JEHANABAD"
                                },
                                {
                                    "Text": "JEONDAN",
                                    "Value": "JEONDAN"
                                },
                                {
                                    "Text": "JETPUR",
                                    "Value": "JETPUR"
                                },
                                {
                                    "Text": "JEWAR",
                                    "Value": "JEWAR"
                                },
                                {
                                    "Text": "JEYPORE",
                                    "Value": "JEYPORE"
                                },
                                {
                                    "Text": "JAFFRABAD (DELHI)",
                                    "Value": "JAFFRABAD (DELHI)"
                                },
                                {
                                    "Text": "JHABUA",
                                    "Value": "JHABUA"
                                },
                                {
                                    "Text": "JHAJHA",
                                    "Value": "JHAJHA"
                                },
                                {
                                    "Text": "JHAJJAR",
                                    "Value": "JHAJJAR"
                                },
                                {
                                    "Text": "JHALRAPATAN",
                                    "Value": "JHALRAPATAN"
                                },
                                {
                                    "Text": "JHALAWAR",
                                    "Value": "JHALAWAR"
                                },
                                {
                                    "Text": "JHANSI",
                                    "Value": "JHANSI"
                                },
                                {
                                    "Text": "JHANJHARPUR",
                                    "Value": "JHANJHARPUR"
                                },
                                {
                                    "Text": "JHANJHERI",
                                    "Value": "JHANJHERI"
                                },
                                {
                                    "Text": "JHARIA",
                                    "Value": "JHARIA"
                                },
                                {
                                    "Text": "JHARSUGUDA",
                                    "Value": "JHARSUGUDA"
                                },
                                {
                                    "Text": "JHARODA MAJRA BURARI",
                                    "Value": "JHARODA MAJRA BURARI"
                                },
                                {
                                    "Text": "JHUJHUNU",
                                    "Value": "JHUJHUNU"
                                },
                                {
                                    "Text": "JHUMRI TELAIYA",
                                    "Value": "JHUMRI TELAIYA"
                                },
                                {
                                    "Text": "JHUMILA",
                                    "Value": "JHUMILA"
                                },
                                {
                                    "Text": "JHUMRI TILAIYA",
                                    "Value": "JHUMRI TILAIYA"
                                },
                                {
                                    "Text": "JHUNJHUNU",
                                    "Value": "JHUNJHUNU"
                                },
                                {
                                    "Text": "JIB",
                                    "Value": "JIB"
                                },
                                {
                                    "Text": "JIGANI",
                                    "Value": "JIGANI"
                                },
                                {
                                    "Text": "JIND",
                                    "Value": "JIND"
                                },
                                {
                                    "Text": "JITWARPUR",
                                    "Value": "JITWARPUR"
                                },
                                {
                                    "Text": "JIWAI KADIM ",
                                    "Value": "JIWAI KADIM "
                                },
                                {
                                    "Text": "JANAKPURI",
                                    "Value": "JANAKPURI"
                                },
                                {
                                    "Text": "JONA PUR",
                                    "Value": "JONA PUR"
                                },
                                {
                                    "Text": "JODA",
                                    "Value": "JODA"
                                },
                                {
                                    "Text": "JODHAN",
                                    "Value": "JODHAN"
                                },
                                {
                                    "Text": "JODHPUR",
                                    "Value": "JODHPUR"
                                },
                                {
                                    "Text": "JOGINAKA",
                                    "Value": "JOGINAKA"
                                },
                                {
                                    "Text": "JOGINAKA",
                                    "Value": "JOGINAKA"
                                },
                                {
                                    "Text": "JOGINDARNAGAR",
                                    "Value": "JOGINDARNAGAR"
                                },
                                {
                                    "Text": "JOGIPET",
                                    "Value": "JOGIPET"
                                },
                                {
                                    "Text": "JOHAL RAJU SINGH ",
                                    "Value": "JOHAL RAJU SINGH "
                                },
                                {
                                    "Text": "JOLARPET",
                                    "Value": "JOLARPET"
                                },
                                {
                                    "Text": "JOLVA ",
                                    "Value": "JOLVA "
                                },
                                {
                                    "Text": "JONNAVARIGUDEM ",
                                    "Value": "JONNAVARIGUDEM "
                                },
                                {
                                    "Text": "JORETHANG",
                                    "Value": "JORETHANG"
                                },
                                {
                                    "Text": "JORHAT",
                                    "Value": "JORHAT"
                                },
                                {
                                    "Text": "JOWAI",
                                    "Value": "JOWAI"
                                },
                                {
                                    "Text": "JOYA",
                                    "Value": "JOYA"
                                },
                                {
                                    "Text": "J P AGRAHARAM ",
                                    "Value": "J P AGRAHARAM "
                                },
                                {
                                    "Text": "J.P.NAGAR ",
                                    "Value": "J.P.NAGAR "
                                },
                                {
                                    "Text": "JAITARAN",
                                    "Value": "JAITARAN"
                                },
                                {
                                    "Text": "JUGIAL",
                                    "Value": "JUGIAL"
                                },
                                {
                                    "Text": "JUGSALAI",
                                    "Value": "JUGSALAI"
                                },
                                {
                                    "Text": "JUI",
                                    "Value": "JUI"
                                },
                                {
                                    "Text": "JUJOMURA",
                                    "Value": "JUJOMURA"
                                },
                                {
                                    "Text": "JULLANA",
                                    "Value": "JULLANA"
                                },
                                {
                                    "Text": "JUNAGADH",
                                    "Value": "JUNAGADH"
                                },
                                {
                                    "Text": "JUNDLA",
                                    "Value": "JUNDLA"
                                },
                                {
                                    "Text": "JUNNAR",
                                    "Value": "JUNNAR"
                                },
                                {
                                    "Text": "JAWALAMUKHI",
                                    "Value": "JAWALAMUKHI"
                                },
                                {
                                    "Text": "JIWAN PUR",
                                    "Value": "JIWAN PUR"
                                },
                                {
                                    "Text": "JYOTIBA PHULE NAGAR",
                                    "Value": "JYOTIBA PHULE NAGAR"
                                },
                                {
                                    "Text": "K.V.RANGAREDDY",
                                    "Value": "K.V.RANGAREDDY"
                                },
                                {
                                    "Text": "KACHCHH",
                                    "Value": "KACHCHH"
                                },
                                {
                                    "Text": "KACHIGAM",
                                    "Value": "KACHIGAM"
                                },
                                {
                                    "Text": "KADAPA",
                                    "Value": "KADAPA"
                                },
                                {
                                    "Text": "KADAMGIRI",
                                    "Value": "KADAMGIRI"
                                },
                                {
                                    "Text": "KADADHE",
                                    "Value": "KADADHE"
                                },
                                {
                                    "Text": "KADARPUR",
                                    "Value": "KADARPUR"
                                },
                                {
                                    "Text": "KADAYANALLUR",
                                    "Value": "KADAYANALLUR"
                                },
                                {
                                    "Text": "KADCHERLA ",
                                    "Value": "KADCHERLA "
                                },
                                {
                                    "Text": "KADGILL ",
                                    "Value": "KADGILL "
                                },
                                {
                                    "Text": "KADI",
                                    "Value": "KADI"
                                },
                                {
                                    "Text": "KADIYAM",
                                    "Value": "KADIYAM"
                                },
                                {
                                    "Text": "KADIRI",
                                    "Value": "KADIRI"
                                },
                                {
                                    "Text": "KADODARA",
                                    "Value": "KADODARA"
                                },
                                {
                                    "Text": "KAGAL",
                                    "Value": "KAGAL"
                                },
                                {
                                    "Text": "KAHALGAON",
                                    "Value": "KAHALGAON"
                                },
                                {
                                    "Text": "KAHALGAON",
                                    "Value": "KAHALGAON"
                                },
                                {
                                    "Text": "KAHNUWAN",
                                    "Value": "KAHNUWAN"
                                },
                                {
                                    "Text": "KAILASH",
                                    "Value": "KAILASH"
                                },
                                {
                                    "Text": "KAIMUR (BHABUA)",
                                    "Value": "KAIMUR (BHABUA)"
                                },
                                {
                                    "Text": "KAIMLA",
                                    "Value": "KAIMLA"
                                },
                                {
                                    "Text": "KAIRON",
                                    "Value": "KAIRON"
                                },
                                {
                                    "Text": "KAISERGANJ",
                                    "Value": "KAISERGANJ"
                                },
                                {
                                    "Text": "KAITHAL",
                                    "Value": "KAITHAL"
                                },
                                {
                                    "Text": "KAIYAL",
                                    "Value": "KAIYAL"
                                },
                                {
                                    "Text": "KAJARIA ",
                                    "Value": "KAJARIA "
                                },
                                {
                                    "Text": "KAKADEV",
                                    "Value": "KAKADEV"
                                },
                                {
                                    "Text": "KAKCHING",
                                    "Value": "KAKCHING"
                                },
                                {
                                    "Text": "KAKINADA",
                                    "Value": "KAKINADA"
                                },
                                {
                                    "Text": "KAKKANAD",
                                    "Value": "KAKKANAD"
                                },
                                {
                                    "Text": "KAKOD",
                                    "Value": "KAKOD"
                                },
                                {
                                    "Text": "KAKODA",
                                    "Value": "KAKODA"
                                },
                                {
                                    "Text": "KALASA",
                                    "Value": "KALASA"
                                },
                                {
                                    "Text": "KALAWALI",
                                    "Value": "KALAWALI"
                                },
                                {
                                    "Text": "KALAHANDI",
                                    "Value": "KALAHANDI"
                                },
                                {
                                    "Text": "KALA AFGANA",
                                    "Value": "KALA AFGANA"
                                },
                                {
                                    "Text": "KALA AMB",
                                    "Value": "KALA AMB"
                                },
                                {
                                    "Text": "KALAUR",
                                    "Value": "KALAUR"
                                },
                                {
                                    "Text": "KALAVAD",
                                    "Value": "KALAVAD"
                                },
                                {
                                    "Text": "KALAVAR",
                                    "Value": "KALAVAR"
                                },
                                {
                                    "Text": "KALAYAT",
                                    "Value": "KALAYAT"
                                },
                                {
                                    "Text": "KALA BAKRA",
                                    "Value": "KALA BAKRA"
                                },
                                {
                                    "Text": "KALA SANGIAN",
                                    "Value": "KALA SANGIAN"
                                },
                                {
                                    "Text": "KALADY",
                                    "Value": "KALADY"
                                },
                                {
                                    "Text": "KALAMBI",
                                    "Value": "KALAMBI"
                                },
                                {
                                    "Text": "KALAMBOLI",
                                    "Value": "KALAMBOLI"
                                },
                                {
                                    "Text": "KALAMWADI",
                                    "Value": "KALAMWADI"
                                },
                                {
                                    "Text": "KALANAUR",
                                    "Value": "KALANAUR"
                                },
                                {
                                    "Text": "KALANWALI",
                                    "Value": "KALANWALI"
                                },
                                {
                                    "Text": "KALIAGANJ",
                                    "Value": "KALIAGANJ"
                                },
                                {
                                    "Text": "KALIGOTE",
                                    "Value": "KALIGOTE"
                                },
                                {
                                    "Text": "KALIMPONG",
                                    "Value": "KALIMPONG"
                                },
                                {
                                    "Text": "KALKA",
                                    "Value": "KALKA"
                                },
                                {
                                    "Text": "KALLAKURICHI",
                                    "Value": "KALLAKURICHI"
                                },
                                {
                                    "Text": "KALLAKKURICHI",
                                    "Value": "KALLAKKURICHI"
                                },
                                {
                                    "Text": "KALLUTHOTTI JUNCTION",
                                    "Value": "KALLUTHOTTI JUNCTION"
                                },
                                {
                                    "Text": "KALMESHWAR",
                                    "Value": "KALMESHWAR"
                                },
                                {
                                    "Text": "KALNA",
                                    "Value": "KALNA"
                                },
                                {
                                    "Text": "KALOL",
                                    "Value": "KALOL"
                                },
                                {
                                    "Text": "KALOOR",
                                    "Value": "KALOOR"
                                },
                                {
                                    "Text": "KALPETTA",
                                    "Value": "KALPETTA"
                                },
                                {
                                    "Text": "KALWAKURTHY",
                                    "Value": "KALWAKURTHY"
                                },
                                {
                                    "Text": "KALWAN BK",
                                    "Value": "KALWAN BK"
                                },
                                {
                                    "Text": "KALYANI",
                                    "Value": "KALYANI"
                                },
                                {
                                    "Text": "KALYAN EAST THANE",
                                    "Value": "KALYAN EAST THANE"
                                },
                                {
                                    "Text": "KALYAN",
                                    "Value": "KALYAN"
                                },
                                {
                                    "Text": "KALYAN - DOMBIVLI",
                                    "Value": "KALYAN - DOMBIVLI"
                                },
                                {
                                    "Text": "KALYANDURG",
                                    "Value": "KALYANDURG"
                                },
                                {
                                    "Text": "KAMALI",
                                    "Value": "KAMALI"
                                },
                                {
                                    "Text": "KAMAREDDY",
                                    "Value": "KAMAREDDY"
                                },
                                {
                                    "Text": "KAMBALAPALLI ",
                                    "Value": "KAMBALAPALLI "
                                },
                                {
                                    "Text": "KAMBAM",
                                    "Value": "KAMBAM"
                                },
                                {
                                    "Text": "KAMBIL",
                                    "Value": "KAMBIL"
                                },
                                {
                                    "Text": "KAMMIANA ",
                                    "Value": "KAMMIANA "
                                },
                                {
                                    "Text": "KAMOTHE",
                                    "Value": "KAMOTHE"
                                },
                                {
                                    "Text": "KAMPTEE",
                                    "Value": "KAMPTEE"
                                },
                                {
                                    "Text": "KAMPUR",
                                    "Value": "KAMPUR"
                                },
                                {
                                    "Text": "KAMRUP",
                                    "Value": "KAMRUP"
                                },
                                {
                                    "Text": "KAMREJ",
                                    "Value": "KAMREJ"
                                },
                                {
                                    "Text": "KAMSHET",
                                    "Value": "KAMSHET"
                                },
                                {
                                    "Text": "KANAKAPURA",
                                    "Value": "KANAKAPURA"
                                },
                                {
                                    "Text": "KANCHIPURAM",
                                    "Value": "KANCHIPURAM"
                                },
                                {
                                    "Text": "KANCHAPADA",
                                    "Value": "KANCHAPADA"
                                },
                                {
                                    "Text": "KANCHRAPARA",
                                    "Value": "KANCHRAPARA"
                                },
                                {
                                    "Text": "KANDHAMAL",
                                    "Value": "KANDHAMAL"
                                },
                                {
                                    "Text": "KANDLA",
                                    "Value": "KANDLA"
                                },
                                {
                                    "Text": "KANDUKURU",
                                    "Value": "KANDUKURU"
                                },
                                {
                                    "Text": "KANGAYAM",
                                    "Value": "KANGAYAM"
                                },
                                {
                                    "Text": "KANGRA",
                                    "Value": "KANGRA"
                                },
                                {
                                    "Text": "KANGAN",
                                    "Value": "KANGAN"
                                },
                                {
                                    "Text": "KANGAN",
                                    "Value": "KANGAN"
                                },
                                {
                                    "Text": "KANGEYAM",
                                    "Value": "KANGEYAM"
                                },
                                {
                                    "Text": "KANHANGAD",
                                    "Value": "KANHANGAD"
                                },
                                {
                                    "Text": "KANINA",
                                    "Value": "KANINA"
                                },
                                {
                                    "Text": "KANJIRAPALLY",
                                    "Value": "KANJIRAPALLY"
                                },
                                {
                                    "Text": "KANKAVLI",
                                    "Value": "KANKAVLI"
                                },
                                {
                                    "Text": "KANKROLI",
                                    "Value": "KANKROLI"
                                },
                                {
                                    "Text": "KANKER",
                                    "Value": "KANKER"
                                },
                                {
                                    "Text": "KANKABATI",
                                    "Value": "KANKABATI"
                                },
                                {
                                    "Text": "KANKAWLI",
                                    "Value": "KANKAWLI"
                                },
                                {
                                    "Text": "KANNUR",
                                    "Value": "KANNUR"
                                },
                                {
                                    "Text": "KANNAUJ",
                                    "Value": "KANNAUJ"
                                },
                                {
                                    "Text": "KANNAD",
                                    "Value": "KANNAD"
                                },
                                {
                                    "Text": "KANPUR",
                                    "Value": "KANPUR"
                                },
                                {
                                    "Text": "KANPUR DEHAT",
                                    "Value": "KANPUR DEHAT"
                                },
                                {
                                    "Text": "KANPUR NAGAR",
                                    "Value": "KANPUR NAGAR"
                                },
                                {
                                    "Text": "KANTABANJI",
                                    "Value": "KANTABANJI"
                                },
                                {
                                    "Text": "KANUGULAVALASA ",
                                    "Value": "KANUGULAVALASA "
                                },
                                {
                                    "Text": "KANWARSIKA",
                                    "Value": "KANWARSIKA"
                                },
                                {
                                    "Text": "KANYAKUMARI",
                                    "Value": "KANYAKUMARI"
                                },
                                {
                                    "Text": "KAPADVANJ",
                                    "Value": "KAPADVANJ"
                                },
                                {
                                    "Text": "KAPASAN",
                                    "Value": "KAPASAN"
                                },
                                {
                                    "Text": "KAPRA",
                                    "Value": "KAPRA"
                                },
                                {
                                    "Text": "KAPTANGANJ",
                                    "Value": "KAPTANGANJ"
                                },
                                {
                                    "Text": "KAPURTHALA",
                                    "Value": "KAPURTHALA"
                                },
                                {
                                    "Text": "KARAD",
                                    "Value": "KARAD"
                                },
                                {
                                    "Text": "KARAIKAL",
                                    "Value": "KARAIKAL"
                                },
                                {
                                    "Text": "KARAULI",
                                    "Value": "KARAULI"
                                },
                                {
                                    "Text": "KARANJIA",
                                    "Value": "KARANJIA"
                                },
                                {
                                    "Text": "KARAIKUDI",
                                    "Value": "KARAIKUDI"
                                },
                                {
                                    "Text": "KARAHALLI ",
                                    "Value": "KARAHALLI "
                                },
                                {
                                    "Text": "KARAKULAM",
                                    "Value": "KARAKULAM"
                                },
                                {
                                    "Text": "KARAGOUNDEN PALAYAM",
                                    "Value": "KARAGOUNDEN PALAYAM"
                                },
                                {
                                    "Text": "KARANJA",
                                    "Value": "KARANJA"
                                },
                                {
                                    "Text": "KARAPAKKAM",
                                    "Value": "KARAPAKKAM"
                                },
                                {
                                    "Text": "KARBI ANGLONG",
                                    "Value": "KARBI ANGLONG"
                                },
                                {
                                    "Text": "KARDI",
                                    "Value": "KARDI"
                                },
                                {
                                    "Text": "KAREGAON",
                                    "Value": "KAREGAON"
                                },
                                {
                                    "Text": "KARGIL",
                                    "Value": "KARGIL"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KARIM NAGAR",
                                    "Value": "KARIM NAGAR"
                                },
                                {
                                    "Text": "KARIMGANJ",
                                    "Value": "KARIMGANJ"
                                },
                                {
                                    "Text": "KARIVALI",
                                    "Value": "KARIVALI"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KARIYALUR ",
                                    "Value": "KARIYALUR "
                                },
                                {
                                    "Text": "KARJAN",
                                    "Value": "KARJAN"
                                },
                                {
                                    "Text": "KARJAT",
                                    "Value": "KARJAT"
                                },
                                {
                                    "Text": "KARKALA",
                                    "Value": "KARKALA"
                                },
                                {
                                    "Text": "KARKAL",
                                    "Value": "KARKAL"
                                },
                                {
                                    "Text": "KARMAD ",
                                    "Value": "KARMAD "
                                },
                                {
                                    "Text": "KARNAL",
                                    "Value": "KARNAL"
                                },
                                {
                                    "Text": "KARTARPUR",
                                    "Value": "KARTARPUR"
                                },
                                {
                                    "Text": "KARUNAGAPALLY",
                                    "Value": "KARUNAGAPALLY"
                                },
                                {
                                    "Text": "KARUR",
                                    "Value": "KARUR"
                                },
                                {
                                    "Text": "KARUVANNUR",
                                    "Value": "KARUVANNUR"
                                },
                                {
                                    "Text": "KARWAR",
                                    "Value": "KARWAR"
                                },
                                {
                                    "Text": "KARWI MAFI",
                                    "Value": "KARWI MAFI"
                                },
                                {
                                    "Text": "KASARAGOD",
                                    "Value": "KASARAGOD"
                                },
                                {
                                    "Text": "KASARGOD",
                                    "Value": "KASARGOD"
                                },
                                {
                                    "Text": "KASARA",
                                    "Value": "KASARA"
                                },
                                {
                                    "Text": "KASARGATTA ",
                                    "Value": "KASARGATTA "
                                },
                                {
                                    "Text": "KASARAMBOLI",
                                    "Value": "KASARAMBOLI"
                                },
                                {
                                    "Text": "KASBA",
                                    "Value": "KASBA"
                                },
                                {
                                    "Text": "KASGANJ",
                                    "Value": "KASGANJ"
                                },
                                {
                                    "Text": "KASHIPUR",
                                    "Value": "KASHIPUR"
                                },
                                {
                                    "Text": "KASIBUGGA",
                                    "Value": "KASIBUGGA"
                                },
                                {
                                    "Text": "KASIMIVALASA ",
                                    "Value": "KASIMIVALASA "
                                },
                                {
                                    "Text": "KASIA",
                                    "Value": "KASIA"
                                },
                                {
                                    "Text": "KASHMIR",
                                    "Value": "KASHMIR"
                                },
                                {
                                    "Text": "KATAI",
                                    "Value": "KATAI"
                                },
                                {
                                    "Text": "KATCH",
                                    "Value": "KATCH"
                                },
                                {
                                    "Text": "KATGAON",
                                    "Value": "KATGAON"
                                },
                                {
                                    "Text": "KATHUA",
                                    "Value": "KATHUA"
                                },
                                {
                                    "Text": "KATHGARH",
                                    "Value": "KATHGARH"
                                },
                                {
                                    "Text": "KATHLAL",
                                    "Value": "KATHLAL"
                                },
                                {
                                    "Text": "KATIHAR",
                                    "Value": "KATIHAR"
                                },
                                {
                                    "Text": "KATLAHERI",
                                    "Value": "KATLAHERI"
                                },
                                {
                                    "Text": "KATNI",
                                    "Value": "KATNI"
                                },
                                {
                                    "Text": "KATOL",
                                    "Value": "KATOL"
                                },
                                {
                                    "Text": "KATRA",
                                    "Value": "KATRA"
                                },
                                {
                                    "Text": "KATRO",
                                    "Value": "KATRO"
                                },
                                {
                                    "Text": "KATTAPPANA",
                                    "Value": "KATTAPPANA"
                                },
                                {
                                    "Text": "KATTU",
                                    "Value": "KATTU"
                                },
                                {
                                    "Text": "KATWA",
                                    "Value": "KATWA"
                                },
                                {
                                    "Text": "KATWAD",
                                    "Value": "KATWAD"
                                },
                                {
                                    "Text": "KAUSHAMBI",
                                    "Value": "KAUSHAMBI"
                                },
                                {
                                    "Text": "KAVALI",
                                    "Value": "KAVALI"
                                },
                                {
                                    "Text": "KAVERIPATTINAM",
                                    "Value": "KAVERIPATTINAM"
                                },
                                {
                                    "Text": "KAWARDHA",
                                    "Value": "KAWARDHA"
                                },
                                {
                                    "Text": "KAYAMKULAM",
                                    "Value": "KAYAMKULAM"
                                },
                                {
                                    "Text": "KECHERY",
                                    "Value": "KECHERY"
                                },
                                {
                                    "Text": "KEDARKHEDA ",
                                    "Value": "KEDARKHEDA "
                                },
                                {
                                    "Text": "KEDARKHEDA",
                                    "Value": "KEDARKHEDA"
                                },
                                {
                                    "Text": "KEDMA ",
                                    "Value": "KEDMA "
                                },
                                {
                                    "Text": "KEELADI ",
                                    "Value": "KEELADI "
                                },
                                {
                                    "Text": "KEELAKARAI",
                                    "Value": "KEELAKARAI"
                                },
                                {
                                    "Text": "KEKRI",
                                    "Value": "KEKRI"
                                },
                                {
                                    "Text": "KELAMBAKKAM",
                                    "Value": "KELAMBAKKAM"
                                },
                                {
                                    "Text": "KELOMAL",
                                    "Value": "KELOMAL"
                                },
                                {
                                    "Text": "KELZAR ",
                                    "Value": "KELZAR "
                                },
                                {
                                    "Text": "KENDRAPARA",
                                    "Value": "KENDRAPARA"
                                },
                                {
                                    "Text": "KENDUJHAR",
                                    "Value": "KENDUJHAR"
                                },
                                {
                                    "Text": "KENGARI",
                                    "Value": "KENGARI"
                                },
                                {
                                    "Text": "KENGERI SATTELITE TOWN",
                                    "Value": "KENGERI SATTELITE TOWN"
                                },
                                {
                                    "Text": "KENJAKURA",
                                    "Value": "KENJAKURA"
                                },
                                {
                                    "Text": "KEONJHAR",
                                    "Value": "KEONJHAR"
                                },
                                {
                                    "Text": "KEORAR ",
                                    "Value": "KEORAR "
                                },
                                {
                                    "Text": "KERANGA",
                                    "Value": "KERANGA"
                                },
                                {
                                    "Text": "KESARPURA",
                                    "Value": "KESARPURA"
                                },
                                {
                                    "Text": "KESHOD",
                                    "Value": "KESHOD"
                                },
                                {
                                    "Text": "KESHAVAPURAM ",
                                    "Value": "KESHAVAPURAM "
                                },
                                {
                                    "Text": "KESHPUR",
                                    "Value": "KESHPUR"
                                },
                                {
                                    "Text": "KESHRISINGHPUR",
                                    "Value": "KESHRISINGHPUR"
                                },
                                {
                                    "Text": "KESINGA",
                                    "Value": "KESINGA"
                                },
                                {
                                    "Text": "KESORI",
                                    "Value": "KESORI"
                                },
                                {
                                    "Text": "KEWALA KALA ",
                                    "Value": "KEWALA KALA "
                                },
                                {
                                    "Text": "KEWALPUR",
                                    "Value": "KEWALPUR"
                                },
                                {
                                    "Text": "KEYSANPALLI ",
                                    "Value": "KEYSANPALLI "
                                },
                                {
                                    "Text": "KHABEDOGRAN ",
                                    "Value": "KHABEDOGRAN "
                                },
                                {
                                    "Text": "KHADAULI ",
                                    "Value": "KHADAULI "
                                },
                                {
                                    "Text": "KHADANI",
                                    "Value": "KHADANI"
                                },
                                {
                                    "Text": "KHADAUR SAHIB",
                                    "Value": "KHADAUR SAHIB"
                                },
                                {
                                    "Text": "KHADIAL",
                                    "Value": "KHADIAL"
                                },
                                {
                                    "Text": "KHADOL",
                                    "Value": "KHADOL"
                                },
                                {
                                    "Text": "KHADSUPA",
                                    "Value": "KHADSUPA"
                                },
                                {
                                    "Text": "KHAGARIA",
                                    "Value": "KHAGARIA"
                                },
                                {
                                    "Text": "KHAIRTHAL",
                                    "Value": "KHAIRTHAL"
                                },
                                {
                                    "Text": "KHAIRA MAJHA ",
                                    "Value": "KHAIRA MAJHA "
                                },
                                {
                                    "Text": "KHAILAR",
                                    "Value": "KHAILAR"
                                },
                                {
                                    "Text": "KHAIR",
                                    "Value": "KHAIR"
                                },
                                {
                                    "Text": "KHAIRAGARH",
                                    "Value": "KHAIRAGARH"
                                },
                                {
                                    "Text": "KHAIRAHNIYA BEERPUR",
                                    "Value": "KHAIRAHNIYA BEERPUR"
                                },
                                {
                                    "Text": "KHAIRAV",
                                    "Value": "KHAIRAV"
                                },
                                {
                                    "Text": "KHAIRTAL",
                                    "Value": "KHAIRTAL"
                                },
                                {
                                    "Text": "KHAJURI",
                                    "Value": "KHAJURI"
                                },
                                {
                                    "Text": "KHALCHIAN",
                                    "Value": "KHALCHIAN"
                                },
                                {
                                    "Text": "KHALILABAD",
                                    "Value": "KHALILABAD"
                                },
                                {
                                    "Text": "KHALRA",
                                    "Value": "KHALRA"
                                },
                                {
                                    "Text": "KHALUMBRE",
                                    "Value": "KHALUMBRE"
                                },
                                {
                                    "Text": "KHAMGAON",
                                    "Value": "KHAMGAON"
                                },
                                {
                                    "Text": "KHAMBHAT",
                                    "Value": "KHAMBHAT"
                                },
                                {
                                    "Text": "KHAMMAM",
                                    "Value": "KHAMMAM"
                                },
                                {
                                    "Text": "KHAMANO",
                                    "Value": "KHAMANO"
                                },
                                {
                                    "Text": "KHAMHARIYA ",
                                    "Value": "KHAMHARIYA "
                                },
                                {
                                    "Text": "KHAMGAON ",
                                    "Value": "KHAMGAON "
                                },
                                {
                                    "Text": "KHAMARIA ",
                                    "Value": "KHAMARIA "
                                },
                                {
                                    "Text": "KHAMANON",
                                    "Value": "KHAMANON"
                                },
                                {
                                    "Text": "KHAMBHALIA",
                                    "Value": "KHAMBHALIA"
                                },
                                {
                                    "Text": "KHAMLA",
                                    "Value": "KHAMLA"
                                },
                                {
                                    "Text": "KHANNA",
                                    "Value": "KHANNA"
                                },
                                {
                                    "Text": "KHANDWA",
                                    "Value": "KHANDWA"
                                },
                                {
                                    "Text": "KHANAPUR ",
                                    "Value": "KHANAPUR "
                                },
                                {
                                    "Text": "KHANOWAL ",
                                    "Value": "KHANOWAL "
                                },
                                {
                                    "Text": "KHANAPARA",
                                    "Value": "KHANAPARA"
                                },
                                {
                                    "Text": "KHANAURI",
                                    "Value": "KHANAURI"
                                },
                                {
                                    "Text": "KHANDAULI",
                                    "Value": "KHANDAULI"
                                },
                                {
                                    "Text": "KHANOOR",
                                    "Value": "KHANOOR"
                                },
                                {
                                    "Text": "KHANPUR",
                                    "Value": "KHANPUR"
                                },
                                {
                                    "Text": "KHARAGPUR",
                                    "Value": "KHARAGPUR"
                                },
                                {
                                    "Text": "KHARSIA",
                                    "Value": "KHARSIA"
                                },
                                {
                                    "Text": "KHARGONE",
                                    "Value": "KHARGONE"
                                },
                                {
                                    "Text": "KHARKHODA",
                                    "Value": "KHARKHODA"
                                },
                                {
                                    "Text": "KHARAR",
                                    "Value": "KHARAR"
                                },
                                {
                                    "Text": "KHARADAHA",
                                    "Value": "KHARADAHA"
                                },
                                {
                                    "Text": "KHARKODA",
                                    "Value": "KHARKODA"
                                },
                                {
                                    "Text": "KHARTULI",
                                    "Value": "KHARTULI"
                                },
                                {
                                    "Text": "KHATAULI",
                                    "Value": "KHATAULI"
                                },
                                {
                                    "Text": "KHATEGAON",
                                    "Value": "KHATEGAON"
                                },
                                {
                                    "Text": "KHATIVALI",
                                    "Value": "KHATIVALI"
                                },
                                {
                                    "Text": "KHED",
                                    "Value": "KHED"
                                },
                                {
                                    "Text": "KHEDA",
                                    "Value": "KHEDA"
                                },
                                {
                                    "Text": "KHEDBRAHMA",
                                    "Value": "KHEDBRAHMA"
                                },
                                {
                                    "Text": "KHEMKARAN",
                                    "Value": "KHEMKARAN"
                                },
                                {
                                    "Text": "KHERI",
                                    "Value": "KHERI"
                                },
                                {
                                    "Text": "KHERI",
                                    "Value": "KHERI"
                                },
                                {
                                    "Text": "KHERGAM",
                                    "Value": "KHERGAM"
                                },
                                {
                                    "Text": "KHERI NAUDH SINGH",
                                    "Value": "KHERI NAUDH SINGH"
                                },
                                {
                                    "Text": "KHIJRABAD",
                                    "Value": "KHIJRABAD"
                                },
                                {
                                    "Text": "KHAJOORI KHAS",
                                    "Value": "KHAJOORI KHAS"
                                },
                                {
                                    "Text": "KHLIEHRIAT",
                                    "Value": "KHLIEHRIAT"
                                },
                                {
                                    "Text": "KHOKHARIYA",
                                    "Value": "KHOKHARIYA"
                                },
                                {
                                    "Text": "KHONSA",
                                    "Value": "KHONSA"
                                },
                                {
                                    "Text": "KHONI, MAHARASHTRA",
                                    "Value": "KHONI, MAHARASHTRA"
                                },
                                {
                                    "Text": "KHOPOLI",
                                    "Value": "KHOPOLI"
                                },
                                {
                                    "Text": "KHORDA",
                                    "Value": "KHORDA"
                                },
                                {
                                    "Text": "KHORDHA",
                                    "Value": "KHORDHA"
                                },
                                {
                                    "Text": "KHORHANSA",
                                    "Value": "KHORHANSA"
                                },
                                {
                                    "Text": "KHOWAI",
                                    "Value": "KHOWAI"
                                },
                                {
                                    "Text": "KHAIRHA",
                                    "Value": "KHAIRHA"
                                },
                                {
                                    "Text": "KHARGHAR",
                                    "Value": "KHARGHAR"
                                },
                                {
                                    "Text": "KHERA KHURD",
                                    "Value": "KHERA KHURD"
                                },
                                {
                                    "Text": "KHUIAN SARWAR",
                                    "Value": "KHUIAN SARWAR"
                                },
                                {
                                    "Text": "KHUMBHEPHAL ",
                                    "Value": "KHUMBHEPHAL "
                                },
                                {
                                    "Text": "KHUNTI",
                                    "Value": "KHUNTI"
                                },
                                {
                                    "Text": "KHURJA",
                                    "Value": "KHURJA"
                                },
                                {
                                    "Text": "KHURAI",
                                    "Value": "KHURAI"
                                },
                                {
                                    "Text": "KHURDA",
                                    "Value": "KHURDA"
                                },
                                {
                                    "Text": "KHUTAR",
                                    "Value": "KHUTAR"
                                },
                                {
                                    "Text": "KHUTEHNA",
                                    "Value": "KHUTEHNA"
                                },
                                {
                                    "Text": "KILLE MACHINDRA GAD",
                                    "Value": "KILLE MACHINDRA GAD"
                                },
                                {
                                    "Text": "KILLON WALI",
                                    "Value": "KILLON WALI"
                                },
                                {
                                    "Text": "KIM",
                                    "Value": "KIM"
                                },
                                {
                                    "Text": "KINNAUR",
                                    "Value": "KINNAUR"
                                },
                                {
                                    "Text": "KINNIGOLI",
                                    "Value": "KINNIGOLI"
                                },
                                {
                                    "Text": "KIPHIRE",
                                    "Value": "KIPHIRE"
                                },
                                {
                                    "Text": "KIRAMCHA ",
                                    "Value": "KIRAMCHA "
                                },
                                {
                                    "Text": "KIRAOLI",
                                    "Value": "KIRAOLI"
                                },
                                {
                                    "Text": "KIRATPUR SAHIB",
                                    "Value": "KIRATPUR SAHIB"
                                },
                                {
                                    "Text": "KIRARI SULEMAN NAGAR",
                                    "Value": "KIRARI SULEMAN NAGAR"
                                },
                                {
                                    "Text": "KISHINGARH",
                                    "Value": "KISHINGARH"
                                },
                                {
                                    "Text": "KISHANGANJ",
                                    "Value": "KISHANGANJ"
                                },
                                {
                                    "Text": "KISHAN GARH",
                                    "Value": "KISHAN GARH"
                                },
                                {
                                    "Text": "KISHAN PURA",
                                    "Value": "KISHAN PURA"
                                },
                                {
                                    "Text": "KISHANGARH RENWAL",
                                    "Value": "KISHANGARH RENWAL"
                                },
                                {
                                    "Text": "KISHANGARH",
                                    "Value": "KISHANGARH"
                                },
                                {
                                    "Text": "KISHTWAR",
                                    "Value": "KISHTWAR"
                                },
                                {
                                    "Text": "KITHANA",
                                    "Value": "KITHANA"
                                },
                                {
                                    "Text": "KITUMULA ",
                                    "Value": "KITUMULA "
                                },
                                {
                                    "Text": "KANJHAWALA",
                                    "Value": "KANJHAWALA"
                                },
                                {
                                    "Text": "KAKCHING",
                                    "Value": "KAKCHING"
                                },
                                {
                                    "Text": "KANDIVALI",
                                    "Value": "KANDIVALI"
                                },
                                {
                                    "Text": "OLD KANKSA ROAD",
                                    "Value": "OLD KANKSA ROAD"
                                },
                                {
                                    "Text": "KOCHI",
                                    "Value": "KOCHI"
                                },
                                {
                                    "Text": "KODADA",
                                    "Value": "KODADA"
                                },
                                {
                                    "Text": "KODAGU",
                                    "Value": "KODAGU"
                                },
                                {
                                    "Text": "KODAIKANAL",
                                    "Value": "KODAIKANAL"
                                },
                                {
                                    "Text": "KODAD",
                                    "Value": "KODAD"
                                },
                                {
                                    "Text": "KODAKARA",
                                    "Value": "KODAKARA"
                                },
                                {
                                    "Text": "KODERMA",
                                    "Value": "KODERMA"
                                },
                                {
                                    "Text": "KODIGEHALLI ",
                                    "Value": "KODIGEHALLI "
                                },
                                {
                                    "Text": "KODIKURICHI",
                                    "Value": "KODIKURICHI"
                                },
                                {
                                    "Text": "KODINAR",
                                    "Value": "KODINAR"
                                },
                                {
                                    "Text": "KODUNGALLUR",
                                    "Value": "KODUNGALLUR"
                                },
                                {
                                    "Text": "KODUMATHI ",
                                    "Value": "KODUMATHI "
                                },
                                {
                                    "Text": "KODUR",
                                    "Value": "KODUR"
                                },
                                {
                                    "Text": "KODUVAYOOR",
                                    "Value": "KODUVAYOOR"
                                },
                                {
                                    "Text": "KOHALI",
                                    "Value": "KOHALI"
                                },
                                {
                                    "Text": "KOHARA",
                                    "Value": "KOHARA"
                                },
                                {
                                    "Text": "KOHIMA",
                                    "Value": "KOHIMA"
                                },
                                {
                                    "Text": "KOIRA ",
                                    "Value": "KOIRA "
                                },
                                {
                                    "Text": "KOIRA ",
                                    "Value": "KOIRA "
                                },
                                {
                                    "Text": "KOKRAJHAR",
                                    "Value": "KOKRAJHAR"
                                },
                                {
                                    "Text": "KOLAR",
                                    "Value": "KOLAR"
                                },
                                {
                                    "Text": "KOLASIB",
                                    "Value": "KOLASIB"
                                },
                                {
                                    "Text": "KOLAT",
                                    "Value": "KOLAT"
                                },
                                {
                                    "Text": "KOLENCHERY",
                                    "Value": "KOLENCHERY"
                                },
                                {
                                    "Text": "KOLHAPUR",
                                    "Value": "KOLHAPUR"
                                },
                                {
                                    "Text": "KOLKATA",
                                    "Value": "KOLKATA"
                                },
                                {
                                    "Text": "KOLLAM",
                                    "Value": "KOLLAM"
                                },
                                {
                                    "Text": "KOLLAPUR ",
                                    "Value": "KOLLAPUR "
                                },
                                {
                                    "Text": "KOLPAK ",
                                    "Value": "KOLPAK "
                                },
                                {
                                    "Text": "KOMARIPALEM",
                                    "Value": "KOMARIPALEM"
                                },
                                {
                                    "Text": "KOMMAGHATTA",
                                    "Value": "KOMMAGHATTA"
                                },
                                {
                                    "Text": "KOMPALLE",
                                    "Value": "KOMPALLE"
                                },
                                {
                                    "Text": "KON",
                                    "Value": "KON"
                                },
                                {
                                    "Text": "KONDA GOAN",
                                    "Value": "KONDA GOAN"
                                },
                                {
                                    "Text": "KONDLI",
                                    "Value": "KONDLI"
                                },
                                {
                                    "Text": "KONDA GOAN",
                                    "Value": "KONDA GOAN"
                                },
                                {
                                    "Text": "KONDAGATTU",
                                    "Value": "KONDAGATTU"
                                },
                                {
                                    "Text": "KONDAPUR",
                                    "Value": "KONDAPUR"
                                },
                                {
                                    "Text": "KONDOTTY",
                                    "Value": "KONDOTTY"
                                },
                                {
                                    "Text": "KONNAGAR",
                                    "Value": "KONNAGAR"
                                },
                                {
                                    "Text": "KONTHAGAI NORTH ",
                                    "Value": "KONTHAGAI NORTH "
                                },
                                {
                                    "Text": "KOOP ",
                                    "Value": "KOOP "
                                },
                                {
                                    "Text": "KOOTHATTUKULAM",
                                    "Value": "KOOTHATTUKULAM"
                                },
                                {
                                    "Text": "KOOTHANALLUR",
                                    "Value": "KOOTHANALLUR"
                                },
                                {
                                    "Text": "KOOTHUPARAMBA",
                                    "Value": "KOOTHUPARAMBA"
                                },
                                {
                                    "Text": "KOOVAPPADY",
                                    "Value": "KOOVAPPADY"
                                },
                                {
                                    "Text": "KOPERGAON",
                                    "Value": "KOPERGAON"
                                },
                                {
                                    "Text": "KOPPA",
                                    "Value": "KOPPA"
                                },
                                {
                                    "Text": "KOPPAL",
                                    "Value": "KOPPAL"
                                },
                                {
                                    "Text": "KOPRI",
                                    "Value": "KOPRI"
                                },
                                {
                                    "Text": "KORAPUT",
                                    "Value": "KORAPUT"
                                },
                                {
                                    "Text": "KORAG ",
                                    "Value": "KORAG "
                                },
                                {
                                    "Text": "KORATLA",
                                    "Value": "KORATLA"
                                },
                                {
                                    "Text": "KORATTUR",
                                    "Value": "KORATTUR"
                                },
                                {
                                    "Text": "KORATTY",
                                    "Value": "KORATTY"
                                },
                                {
                                    "Text": "KORBA",
                                    "Value": "KORBA"
                                },
                                {
                                    "Text": "KORBI ",
                                    "Value": "KORBI "
                                },
                                {
                                    "Text": "KOREGAON",
                                    "Value": "KOREGAON"
                                },
                                {
                                    "Text": "KORIYA",
                                    "Value": "KORIYA"
                                },
                                {
                                    "Text": "KORLAKOTA ",
                                    "Value": "KORLAKOTA "
                                },
                                {
                                    "Text": "KOSAMBA",
                                    "Value": "KOSAMBA"
                                },
                                {
                                    "Text": "KOSIKALAN",
                                    "Value": "KOSIKALAN"
                                },
                                {
                                    "Text": "KOSLI",
                                    "Value": "KOSLI"
                                },
                                {
                                    "Text": "KOT ISE KHAN",
                                    "Value": "KOT ISE KHAN"
                                },
                                {
                                    "Text": "KOTA",
                                    "Value": "KOTA"
                                },
                                {
                                    "Text": "KOT BUDHA",
                                    "Value": "KOT BUDHA"
                                },
                                {
                                    "Text": "KOTDWARA",
                                    "Value": "KOTDWARA"
                                },
                                {
                                    "Text": "KOTDWAR",
                                    "Value": "KOTDWAR"
                                },
                                {
                                    "Text": "KOTESHWAR",
                                    "Value": "KOTESHWAR"
                                },
                                {
                                    "Text": "KOTFATUHI",
                                    "Value": "KOTFATUHI"
                                },
                                {
                                    "Text": "KOTFATUHI",
                                    "Value": "KOTFATUHI"
                                },
                                {
                                    "Text": "KOTHAGUDEM",
                                    "Value": "KOTHAGUDEM"
                                },
                                {
                                    "Text": "KOTHAMANGALAM",
                                    "Value": "KOTHAMANGALAM"
                                },
                                {
                                    "Text": "KOTHAREDDIAL ",
                                    "Value": "KOTHAREDDIAL "
                                },
                                {
                                    "Text": "KOTHAGDI ",
                                    "Value": "KOTHAGDI "
                                },
                                {
                                    "Text": "KOTHURU ",
                                    "Value": "KOTHURU "
                                },
                                {
                                    "Text": "KOTHAPALLE",
                                    "Value": "KOTHAPALLE"
                                },
                                {
                                    "Text": "KOT ISA KHAN",
                                    "Value": "KOT ISA KHAN"
                                },
                                {
                                    "Text": "KOTKAPURA",
                                    "Value": "KOTKAPURA"
                                },
                                {
                                    "Text": "KOTKHAI",
                                    "Value": "KOTKHAI"
                                },
                                {
                                    "Text": "KOTLA ",
                                    "Value": "KOTLA "
                                },
                                {
                                    "Text": "KOTMA",
                                    "Value": "KOTMA"
                                },
                                {
                                    "Text": "KOTPUTLI",
                                    "Value": "KOTPUTLI"
                                },
                                {
                                    "Text": "KOTRA",
                                    "Value": "KOTRA"
                                },
                                {
                                    "Text": "KOTSHAMIR",
                                    "Value": "KOTSHAMIR"
                                },
                                {
                                    "Text": "KOTTARAKARA",
                                    "Value": "KOTTARAKARA"
                                },
                                {
                                    "Text": "KOTTAKKAL",
                                    "Value": "KOTTAKKAL"
                                },
                                {
                                    "Text": "KOTTAYAM",
                                    "Value": "KOTTAYAM"
                                },
                                {
                                    "Text": "KOTTAPUDUR ",
                                    "Value": "KOTTAPUDUR "
                                },
                                {
                                    "Text": "KOTTAKAL",
                                    "Value": "KOTTAKAL"
                                },
                                {
                                    "Text": "KOTTARAKKARA",
                                    "Value": "KOTTARAKKARA"
                                },
                                {
                                    "Text": "KOVILPATTI",
                                    "Value": "KOVILPATTI"
                                },
                                {
                                    "Text": "KOVUR",
                                    "Value": "KOVUR"
                                },
                                {
                                    "Text": "KOVVUR",
                                    "Value": "KOVVUR"
                                },
                                {
                                    "Text": "KOYALI",
                                    "Value": "KOYALI"
                                },
                                {
                                    "Text": "KOYILANDY",
                                    "Value": "KOYILANDY"
                                },
                                {
                                    "Text": "KOZHENCHERRY",
                                    "Value": "KOZHENCHERRY"
                                },
                                {
                                    "Text": "KOZHIKODE",
                                    "Value": "KOZHIKODE"
                                },
                                {
                                    "Text": "KOZHENCHERY",
                                    "Value": "KOZHENCHERY"
                                },
                                {
                                    "Text": "KOPAR KHAIRANE",
                                    "Value": "KOPAR KHAIRANE"
                                },
                                {
                                    "Text": "KAPAS HERA",
                                    "Value": "KAPAS HERA"
                                },
                                {
                                    "Text": "KRISHNAGAR",
                                    "Value": "KRISHNAGAR"
                                },
                                {
                                    "Text": "KRISHNA",
                                    "Value": "KRISHNA"
                                },
                                {
                                    "Text": "KRISHNAGIRI",
                                    "Value": "KRISHNAGIRI"
                                },
                                {
                                    "Text": "KRISHNAJIVADI ",
                                    "Value": "KRISHNAJIVADI "
                                },
                                {
                                    "Text": "KRISHNA BAZAR(NARSIPATNAM) ",
                                    "Value": "KRISHNA BAZAR(NARSIPATNAM) "
                                },
                                {
                                    "Text": "KARAIKAL",
                                    "Value": "KARAIKAL"
                                },
                                {
                                    "Text": "KARAMADAI",
                                    "Value": "KARAMADAI"
                                },
                                {
                                    "Text": "KARAWAL NAGAR",
                                    "Value": "KARAWAL NAGAR"
                                },
                                {
                                    "Text": "KATKAR",
                                    "Value": "KATKAR"
                                },
                                {
                                    "Text": "KHATIMA",
                                    "Value": "KHATIMA"
                                },
                                {
                                    "Text": "KUBA",
                                    "Value": "KUBA"
                                },
                                {
                                    "Text": "KUCHAMAN CITY",
                                    "Value": "KUCHAMAN CITY"
                                },
                                {
                                    "Text": "KUCHINDA",
                                    "Value": "KUCHINDA"
                                },
                                {
                                    "Text": "KUDAL",
                                    "Value": "KUDAL"
                                },
                                {
                                    "Text": "KUDAMALOOR",
                                    "Value": "KUDAMALOOR"
                                },
                                {
                                    "Text": "KUDI KHERA",
                                    "Value": "KUDI KHERA"
                                },
                                {
                                    "Text": "KUDU",
                                    "Value": "KUDU"
                                },
                                {
                                    "Text": "KUDUMULUGUMA",
                                    "Value": "KUDUMULUGUMA"
                                },
                                {
                                    "Text": "KUIANI ",
                                    "Value": "KUIANI "
                                },
                                {
                                    "Text": "KUJANG",
                                    "Value": "KUJANG"
                                },
                                {
                                    "Text": "KUKAR PIND",
                                    "Value": "KUKAR PIND"
                                },
                                {
                                    "Text": "KUKARWADA",
                                    "Value": "KUKARWADA"
                                },
                                {
                                    "Text": "KUKATPALLY",
                                    "Value": "KUKATPALLY"
                                },
                                {
                                    "Text": "KUKSHI",
                                    "Value": "KUKSHI"
                                },
                                {
                                    "Text": "KULATHUMUZHY",
                                    "Value": "KULATHUMUZHY"
                                },
                                {
                                    "Text": "KULGAM",
                                    "Value": "KULGAM"
                                },
                                {
                                    "Text": "KULITHALAI",
                                    "Value": "KULITHALAI"
                                },
                                {
                                    "Text": "KULLU",
                                    "Value": "KULLU"
                                },
                                {
                                    "Text": "KUMBAKONAM",
                                    "Value": "KUMBAKONAM"
                                },
                                {
                                    "Text": "KUM KALAN",
                                    "Value": "KUM KALAN"
                                },
                                {
                                    "Text": "KUMTA",
                                    "Value": "KUMTA"
                                },
                                {
                                    "Text": "KUNDA",
                                    "Value": "KUNDA"
                                },
                                {
                                    "Text": "KUNDAPURA",
                                    "Value": "KUNDAPURA"
                                },
                                {
                                    "Text": "KUNDAPUR",
                                    "Value": "KUNDAPUR"
                                },
                                {
                                    "Text": "KUNDLI",
                                    "Value": "KUNDLI"
                                },
                                {
                                    "Text": "KUNNAMKULAM",
                                    "Value": "KUNNAMKULAM"
                                },
                                {
                                    "Text": "KUPWARA",
                                    "Value": "KUPWARA"
                                },
                                {
                                    "Text": "KURADIHA",
                                    "Value": "KURADIHA"
                                },
                                {
                                    "Text": "KURALI",
                                    "Value": "KURALI"
                                },
                                {
                                    "Text": "KURICHITHANAM",
                                    "Value": "KURICHITHANAM"
                                },
                                {
                                    "Text": "KURMAPURAM ",
                                    "Value": "KURMAPURAM "
                                },
                                {
                                    "Text": "KURNOOL",
                                    "Value": "KURNOOL"
                                },
                                {
                                    "Text": "KURUKSHETRA",
                                    "Value": "KURUKSHETRA"
                                },
                                {
                                    "Text": "KURUNG KUMEY",
                                    "Value": "KURUNG KUMEY"
                                },
                                {
                                    "Text": "KURUD",
                                    "Value": "KURUD"
                                },
                                {
                                    "Text": "KUSARLAPUDI ",
                                    "Value": "KUSARLAPUDI "
                                },
                                {
                                    "Text": "KUSHINAGAR",
                                    "Value": "KUSHINAGAR"
                                },
                                {
                                    "Text": "KUTCHERY CHOWK",
                                    "Value": "KUTCHERY CHOWK"
                                },
                                {
                                    "Text": "KUTCH",
                                    "Value": "KUTCH"
                                },
                                {
                                    "Text": "KUTCHH",
                                    "Value": "KUTCHH"
                                },
                                {
                                    "Text": "KUWAIT",
                                    "Value": "KUWAIT"
                                },
                                {
                                    "Text": "K YELLAVARAM ",
                                    "Value": "K YELLAVARAM "
                                },
                                {
                                    "Text": "LACHAPET ",
                                    "Value": "LACHAPET "
                                },
                                {
                                    "Text": "LADSAWANGI ",
                                    "Value": "LADSAWANGI "
                                },
                                {
                                    "Text": "LADWA",
                                    "Value": "LADWA"
                                },
                                {
                                    "Text": "LAHUL & SPITI",
                                    "Value": "LAHUL & SPITI"
                                },
                                {
                                    "Text": "LAKHIMPUR",
                                    "Value": "LAKHIMPUR"
                                },
                                {
                                    "Text": "LAKHIMPUR",
                                    "Value": "LAKHIMPUR"
                                },
                                {
                                    "Text": "LAKHISARAI",
                                    "Value": "LAKHISARAI"
                                },
                                {
                                    "Text": "LAKHAN MAJRA",
                                    "Value": "LAKHAN MAJRA"
                                },
                                {
                                    "Text": "LAKSHADWEEP",
                                    "Value": "LAKSHADWEEP"
                                },
                                {
                                    "Text": "LALGANJ KATGHAR",
                                    "Value": "LALGANJ KATGHAR"
                                },
                                {
                                    "Text": "LALGUDI",
                                    "Value": "LALGUDI"
                                },
                                {
                                    "Text": "LALGANJ",
                                    "Value": "LALGANJ"
                                },
                                {
                                    "Text": "LALGANJ-KATGHAR",
                                    "Value": "LALGANJ-KATGHAR"
                                },
                                {
                                    "Text": "LALITPUR",
                                    "Value": "LALITPUR"
                                },
                                {
                                    "Text": "LAL KALAN",
                                    "Value": "LAL KALAN"
                                },
                                {
                                    "Text": "LALPUR",
                                    "Value": "LALPUR"
                                },
                                {
                                    "Text": "LALRU",
                                    "Value": "LALRU"
                                },
                                {
                                    "Text": "LALSOT",
                                    "Value": "LALSOT"
                                },
                                {
                                    "Text": "LAMBI",
                                    "Value": "LAMBI"
                                },
                                {
                                    "Text": "LAMBRA",
                                    "Value": "LAMBRA"
                                },
                                {
                                    "Text": "LAMMASINGI ",
                                    "Value": "LAMMASINGI "
                                },
                                {
                                    "Text": "LANDRAN",
                                    "Value": "LANDRAN"
                                },
                                {
                                    "Text": "LANDE KE ",
                                    "Value": "LANDE KE "
                                },
                                {
                                    "Text": "LANDRAN",
                                    "Value": "LANDRAN"
                                },
                                {
                                    "Text": "LAOJORA ",
                                    "Value": "LAOJORA "
                                },
                                {
                                    "Text": "LAPKAMAN",
                                    "Value": "LAPKAMAN"
                                },
                                {
                                    "Text": "LASALGAON",
                                    "Value": "LASALGAON"
                                },
                                {
                                    "Text": "LATEHAR",
                                    "Value": "LATEHAR"
                                },
                                {
                                    "Text": "LATUR",
                                    "Value": "LATUR"
                                },
                                {
                                    "Text": "LAWNGTLAI",
                                    "Value": "LAWNGTLAI"
                                },
                                {
                                    "Text": "LAXITTIPET",
                                    "Value": "LAXITTIPET"
                                },
                                {
                                    "Text": "LAXMIPUR ",
                                    "Value": "LAXMIPUR "
                                },
                                {
                                    "Text": "LAXMANGARH ",
                                    "Value": "LAXMANGARH "
                                },
                                {
                                    "Text": "LIBAS PUR",
                                    "Value": "LIBAS PUR"
                                },
                                {
                                    "Text": "LADNUN",
                                    "Value": "LADNUN"
                                },
                                {
                                    "Text": "LEH",
                                    "Value": "LEH"
                                },
                                {
                                    "Text": "LEHAL",
                                    "Value": "LEHAL"
                                },
                                {
                                    "Text": "LEHRAGAGA",
                                    "Value": "LEHRAGAGA"
                                },
                                {
                                    "Text": "LIMBDI",
                                    "Value": "LIMBDI"
                                },
                                {
                                    "Text": "LINGAPUR ",
                                    "Value": "LINGAPUR "
                                },
                                {
                                    "Text": "LAKHPAT",
                                    "Value": "LAKHPAT"
                                },
                                {
                                    "Text": "LAKHIMPUR KHERI",
                                    "Value": "LAKHIMPUR KHERI"
                                },
                                {
                                    "Text": "LLKAL",
                                    "Value": "LLKAL"
                                },
                                {
                                    "Text": "LOHARDAGA",
                                    "Value": "LOHARDAGA"
                                },
                                {
                                    "Text": "LOHA ",
                                    "Value": "LOHA "
                                },
                                {
                                    "Text": "LOHARDIH",
                                    "Value": "LOHARDIH"
                                },
                                {
                                    "Text": "LOHARKA",
                                    "Value": "LOHARKA"
                                },
                                {
                                    "Text": "LOHARSI",
                                    "Value": "LOHARSI"
                                },
                                {
                                    "Text": "LOHARU",
                                    "Value": "LOHARU"
                                },
                                {
                                    "Text": "LOHIAN KHAS",
                                    "Value": "LOHIAN KHAS"
                                },
                                {
                                    "Text": "LOHIT",
                                    "Value": "LOHIT"
                                },
                                {
                                    "Text": "LOHIAN KHAS",
                                    "Value": "LOHIAN KHAS"
                                },
                                {
                                    "Text": "LOHTA",
                                    "Value": "LOHTA"
                                },
                                {
                                    "Text": "LOISINGA",
                                    "Value": "LOISINGA"
                                },
                                {
                                    "Text": "LOKAMALESWARAM",
                                    "Value": "LOKAMALESWARAM"
                                },
                                {
                                    "Text": "LONAVALA",
                                    "Value": "LONAVALA"
                                },
                                {
                                    "Text": "LONAND",
                                    "Value": "LONAND"
                                },
                                {
                                    "Text": "LONGOWAL",
                                    "Value": "LONGOWAL"
                                },
                                {
                                    "Text": "LONGLENG",
                                    "Value": "LONGLENG"
                                },
                                {
                                    "Text": "LONGAON ",
                                    "Value": "LONGAON "
                                },
                                {
                                    "Text": "LONI",
                                    "Value": "LONI"
                                },
                                {
                                    "Text": "LONI",
                                    "Value": "LONI"
                                },
                                {
                                    "Text": "LOPOKE",
                                    "Value": "LOPOKE"
                                },
                                {
                                    "Text": "LOWER DIBANG VALLEY",
                                    "Value": "LOWER DIBANG VALLEY"
                                },
                                {
                                    "Text": "LOWER SUBANSIRI",
                                    "Value": "LOWER SUBANSIRI"
                                },
                                {
                                    "Text": "LUCKNOW",
                                    "Value": "LUCKNOW"
                                },
                                {
                                    "Text": "LUDHIANA",
                                    "Value": "LUDHIANA"
                                },
                                {
                                    "Text": "LUKHI",
                                    "Value": "LUKHI"
                                },
                                {
                                    "Text": "LUNAWADA",
                                    "Value": "LUNAWADA"
                                },
                                {
                                    "Text": "LUNGLEI",
                                    "Value": "LUNGLEI"
                                },
                                {
                                    "Text": "LAXMANGARH",
                                    "Value": "LAXMANGARH"
                                },
                                {
                                    "Text": "MACHALIPATNAM",
                                    "Value": "MACHALIPATNAM"
                                },
                                {
                                    "Text": "MACHHIWARA",
                                    "Value": "MACHHIWARA"
                                },
                                {
                                    "Text": "MACHAREDDY ",
                                    "Value": "MACHAREDDY "
                                },
                                {
                                    "Text": "MACHERLA ",
                                    "Value": "MACHERLA "
                                },
                                {
                                    "Text": "MACHERLA",
                                    "Value": "MACHERLA"
                                },
                                {
                                    "Text": "MACHILIPATNAM",
                                    "Value": "MACHILIPATNAM"
                                },
                                {
                                    "Text": "MADANAPALLI",
                                    "Value": "MADANAPALLI"
                                },
                                {
                                    "Text": "MADANAPALLI ",
                                    "Value": "MADANAPALLI "
                                },
                                {
                                    "Text": "MADAI ",
                                    "Value": "MADAI "
                                },
                                {
                                    "Text": "MADANPUR ",
                                    "Value": "MADANPUR "
                                },
                                {
                                    "Text": "MADAMBAKKAM",
                                    "Value": "MADAMBAKKAM"
                                },
                                {
                                    "Text": "MADANAPALLE",
                                    "Value": "MADANAPALLE"
                                },
                                {
                                    "Text": "MADHEPURA",
                                    "Value": "MADHEPURA"
                                },
                                {
                                    "Text": "MADHUBANI",
                                    "Value": "MADHUBANI"
                                },
                                {
                                    "Text": "MADHAPUR ",
                                    "Value": "MADHAPUR "
                                },
                                {
                                    "Text": "MADHAVPUR ",
                                    "Value": "MADHAVPUR "
                                },
                                {
                                    "Text": "MADHUR ",
                                    "Value": "MADHUR "
                                },
                                {
                                    "Text": "MADHAPAR",
                                    "Value": "MADHAPAR"
                                },
                                {
                                    "Text": "MADHI",
                                    "Value": "MADHI"
                                },
                                {
                                    "Text": "MADHOPUR",
                                    "Value": "MADHOPUR"
                                },
                                {
                                    "Text": "MADHUPUR",
                                    "Value": "MADHUPUR"
                                },
                                {
                                    "Text": "MADHYAMGRAM",
                                    "Value": "MADHYAMGRAM"
                                },
                                {
                                    "Text": "MADIKERI",
                                    "Value": "MADIKERI"
                                },
                                {
                                    "Text": "MADIPPAKKAM",
                                    "Value": "MADIPPAKKAM"
                                },
                                {
                                    "Text": "MADKERI",
                                    "Value": "MADKERI"
                                },
                                {
                                    "Text": "MADLAUDA",
                                    "Value": "MADLAUDA"
                                },
                                {
                                    "Text": "MADLODA",
                                    "Value": "MADLODA"
                                },
                                {
                                    "Text": "MADURAI",
                                    "Value": "MADURAI"
                                },
                                {
                                    "Text": "MAGAM",
                                    "Value": "MAGAM"
                                },
                                {
                                    "Text": "MAGDI ",
                                    "Value": "MAGDI "
                                },
                                {
                                    "Text": "MAHAD",
                                    "Value": "MAHAD"
                                },
                                {
                                    "Text": "MAHABUBNAGAR",
                                    "Value": "MAHABUBNAGAR"
                                },
                                {
                                    "Text": "MAHABUB NAGAR",
                                    "Value": "MAHABUB NAGAR"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHASAMUND",
                                    "Value": "MAHASAMUND"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHAMAYA NAGAR",
                                    "Value": "MAHAMAYA NAGAR"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHAGAI ",
                                    "Value": "MAHAGAI "
                                },
                                {
                                    "Text": "MAHABUBABAD",
                                    "Value": "MAHABUBABAD"
                                },
                                {
                                    "Text": "MAHAL KALAN",
                                    "Value": "MAHAL KALAN"
                                },
                                {
                                    "Text": "MAHAM",
                                    "Value": "MAHAM"
                                },
                                {
                                    "Text": "MAHAMMADPUR",
                                    "Value": "MAHAMMADPUR"
                                },
                                {
                                    "Text": "MAHATPUR",
                                    "Value": "MAHATPUR"
                                },
                                {
                                    "Text": "MAHE",
                                    "Value": "MAHE"
                                },
                                {
                                    "Text": "MAHE",
                                    "Value": "MAHE"
                                },
                                {
                                    "Text": "MAHENDRAGARH",
                                    "Value": "MAHENDRAGARH"
                                },
                                {
                                    "Text": "MAHESANA",
                                    "Value": "MAHESANA"
                                },
                                {
                                    "Text": "MAHENDRAGANJ",
                                    "Value": "MAHENDRAGANJ"
                                },
                                {
                                    "Text": "MAHETPUR",
                                    "Value": "MAHETPUR"
                                },
                                {
                                    "Text": "MAHENDARGARH",
                                    "Value": "MAHENDARGARH"
                                },
                                {
                                    "Text": "MAHENDRANAGAR",
                                    "Value": "MAHENDRANAGAR"
                                },
                                {
                                    "Text": "MAHERU",
                                    "Value": "MAHERU"
                                },
                                {
                                    "Text": "MAHISAGAR",
                                    "Value": "MAHISAGAR"
                                },
                                {
                                    "Text": "MAHIDPUR",
                                    "Value": "MAHIDPUR"
                                },
                                {
                                    "Text": "MAHILPUR",
                                    "Value": "MAHILPUR"
                                },
                                {
                                    "Text": "MAHIYAWALI",
                                    "Value": "MAHIYAWALI"
                                },
                                {
                                    "Text": "MAHENDRAGANJ",
                                    "Value": "MAHENDRAGANJ"
                                },
                                {
                                    "Text": "MAHOBA",
                                    "Value": "MAHOBA"
                                },
                                {
                                    "Text": "MAHUVA",
                                    "Value": "MAHUVA"
                                },
                                {
                                    "Text": "MAIHAR",
                                    "Value": "MAIHAR"
                                },
                                {
                                    "Text": "MAINPURI",
                                    "Value": "MAINPURI"
                                },
                                {
                                    "Text": "MAIRANG",
                                    "Value": "MAIRANG"
                                },
                                {
                                    "Text": "MAISAMMAGUDEM ",
                                    "Value": "MAISAMMAGUDEM "
                                },
                                {
                                    "Text": "MAJALGAON",
                                    "Value": "MAJALGAON"
                                },
                                {
                                    "Text": "MAJARI",
                                    "Value": "MAJARI"
                                },
                                {
                                    "Text": "MAJITHA",
                                    "Value": "MAJITHA"
                                },
                                {
                                    "Text": "MAJORDA",
                                    "Value": "MAJORDA"
                                },
                                {
                                    "Text": "MAJRA",
                                    "Value": "MAJRA"
                                },
                                {
                                    "Text": "MAJRI",
                                    "Value": "MAJRI"
                                },
                                {
                                    "Text": "MAJWIND",
                                    "Value": "MAJWIND"
                                },
                                {
                                    "Text": "MAKHU",
                                    "Value": "MAKHU"
                                },
                                {
                                    "Text": "MAKRANA",
                                    "Value": "MAKRANA"
                                },
                                {
                                    "Text": "MALAPPURAM",
                                    "Value": "MALAPPURAM"
                                },
                                {
                                    "Text": "MALA",
                                    "Value": "MALA"
                                },
                                {
                                    "Text": "MALAKPUR",
                                    "Value": "MALAKPUR"
                                },
                                {
                                    "Text": "MALAPURAM",
                                    "Value": "MALAPURAM"
                                },
                                {
                                    "Text": "MALDA",
                                    "Value": "MALDA"
                                },
                                {
                                    "Text": "MALEGAON",
                                    "Value": "MALEGAON"
                                },
                                {
                                    "Text": "MALERKOTLA",
                                    "Value": "MALERKOTLA"
                                },
                                {
                                    "Text": "MALGAON",
                                    "Value": "MALGAON"
                                },
                                {
                                    "Text": "MALIYASAN",
                                    "Value": "MALIYASAN"
                                },
                                {
                                    "Text": "MALKAPUR",
                                    "Value": "MALKAPUR"
                                },
                                {
                                    "Text": "MALKANGIRI",
                                    "Value": "MALKANGIRI"
                                },
                                {
                                    "Text": "MALKHED",
                                    "Value": "MALKHED"
                                },
                                {
                                    "Text": "MALLIAL ",
                                    "Value": "MALLIAL "
                                },
                                {
                                    "Text": "MALLANWALA",
                                    "Value": "MALLANWALA"
                                },
                                {
                                    "Text": "MALLEKAN",
                                    "Value": "MALLEKAN"
                                },
                                {
                                    "Text": "MALOUT",
                                    "Value": "MALOUT"
                                },
                                {
                                    "Text": "MALOUD",
                                    "Value": "MALOUD"
                                },
                                {
                                    "Text": "MALPURA",
                                    "Value": "MALPURA"
                                },
                                {
                                    "Text": "MALRU",
                                    "Value": "MALRU"
                                },
                                {
                                    "Text": "MALSIAN",
                                    "Value": "MALSIAN"
                                },
                                {
                                    "Text": "MALUKA",
                                    "Value": "MALUKA"
                                },
                                {
                                    "Text": "MALUR",
                                    "Value": "MALUR"
                                },
                                {
                                    "Text": "MALVAN",
                                    "Value": "MALVAN"
                                },
                                {
                                    "Text": "MALWARDEVRAMPALLI ",
                                    "Value": "MALWARDEVRAMPALLI "
                                },
                                {
                                    "Text": "MAMDOT UTTAR",
                                    "Value": "MAMDOT UTTAR"
                                },
                                {
                                    "Text": "MAMIDIPALLI ",
                                    "Value": "MAMIDIPALLI "
                                },
                                {
                                    "Text": "MAMMIT",
                                    "Value": "MAMMIT"
                                },
                                {
                                    "Text": "MANANTHAVADY",
                                    "Value": "MANANTHAVADY"
                                },
                                {
                                    "Text": "MANALI",
                                    "Value": "MANALI"
                                },
                                {
                                    "Text": "MANAVADAR",
                                    "Value": "MANAVADAR"
                                },
                                {
                                    "Text": "MANAKKODY",
                                    "Value": "MANAKKODY"
                                },
                                {
                                    "Text": "MANAULI",
                                    "Value": "MANAULI"
                                },
                                {
                                    "Text": "MANAURI BAZAR",
                                    "Value": "MANAURI BAZAR"
                                },
                                {
                                    "Text": "MANAVADAR",
                                    "Value": "MANAVADAR"
                                },
                                {
                                    "Text": "MANAWALA",
                                    "Value": "MANAWALA"
                                },
                                {
                                    "Text": "MANCHERIAL",
                                    "Value": "MANCHERIAL"
                                },
                                {
                                    "Text": "MANKACHAR",
                                    "Value": "MANKACHAR"
                                },
                                {
                                    "Text": "MANDI",
                                    "Value": "MANDI"
                                },
                                {
                                    "Text": "MANDAPETA",
                                    "Value": "MANDAPETA"
                                },
                                {
                                    "Text": "MANDVI",
                                    "Value": "MANDVI"
                                },
                                {
                                    "Text": "MANDI DABWALI",
                                    "Value": "MANDI DABWALI"
                                },
                                {
                                    "Text": "MANDIDEEP",
                                    "Value": "MANDIDEEP"
                                },
                                {
                                    "Text": "MANDI GOBINDGARH",
                                    "Value": "MANDI GOBINDGARH"
                                },
                                {
                                    "Text": "MANDI",
                                    "Value": "MANDI"
                                },
                                {
                                    "Text": "MANDLA",
                                    "Value": "MANDLA"
                                },
                                {
                                    "Text": "MANDSAUR",
                                    "Value": "MANDSAUR"
                                },
                                {
                                    "Text": "MAND",
                                    "Value": "MAND"
                                },
                                {
                                    "Text": "MANDAI BUJURG",
                                    "Value": "MANDAI BUJURG"
                                },
                                {
                                    "Text": "MANDAI KHURD",
                                    "Value": "MANDAI KHURD"
                                },
                                {
                                    "Text": "MANENDRAGARH",
                                    "Value": "MANENDRAGARH"
                                },
                                {
                                    "Text": "MANEGAON ",
                                    "Value": "MANEGAON "
                                },
                                {
                                    "Text": "MANESAR",
                                    "Value": "MANESAR"
                                },
                                {
                                    "Text": "MANGALORE URBAN",
                                    "Value": "MANGALORE URBAN"
                                },
                                {
                                    "Text": "MANGALDOI",
                                    "Value": "MANGALDOI"
                                },
                                {
                                    "Text": "MANGALORE",
                                    "Value": "MANGALORE"
                                },
                                {
                                    "Text": "MANGROL",
                                    "Value": "MANGROL"
                                },
                                {
                                    "Text": "MANGALAGIRI",
                                    "Value": "MANGALAGIRI"
                                },
                                {
                                    "Text": "MANGALORE-URBAN",
                                    "Value": "MANGALORE-URBAN"
                                },
                                {
                                    "Text": "MANGAON",
                                    "Value": "MANGAON"
                                },
                                {
                                    "Text": "MANGARH",
                                    "Value": "MANGARH"
                                },
                                {
                                    "Text": "MANGLIA",
                                    "Value": "MANGLIA"
                                },
                                {
                                    "Text": "MANGROL",
                                    "Value": "MANGROL"
                                },
                                {
                                    "Text": "MANIPAL",
                                    "Value": "MANIPAL"
                                },
                                {
                                    "Text": "MANIGILLA ",
                                    "Value": "MANIGILLA "
                                },
                                {
                                    "Text": "MANIYAMPALAYAM ",
                                    "Value": "MANIYAMPALAYAM "
                                },
                                {
                                    "Text": "MANJERI",
                                    "Value": "MANJERI"
                                },
                                {
                                    "Text": "MANJALPUR",
                                    "Value": "MANJALPUR"
                                },
                                {
                                    "Text": "MANJARI",
                                    "Value": "MANJARI"
                                },
                                {
                                    "Text": "MANJUSAR",
                                    "Value": "MANJUSAR"
                                },
                                {
                                    "Text": "MANKACHAR",
                                    "Value": "MANKACHAR"
                                },
                                {
                                    "Text": "MANKARA ",
                                    "Value": "MANKARA "
                                },
                                {
                                    "Text": "MANKAPUR",
                                    "Value": "MANKAPUR"
                                },
                                {
                                    "Text": "MANKO",
                                    "Value": "MANKO"
                                },
                                {
                                    "Text": "MANMAD",
                                    "Value": "MANMAD"
                                },
                                {
                                    "Text": "MANNEGUDA ",
                                    "Value": "MANNEGUDA "
                                },
                                {
                                    "Text": "MANNARKKAD",
                                    "Value": "MANNARKKAD"
                                },
                                {
                                    "Text": "MANOR",
                                    "Value": "MANOR"
                                },
                                {
                                    "Text": "MANOCHAHAL ",
                                    "Value": "MANOCHAHAL "
                                },
                                {
                                    "Text": "MANPUR",
                                    "Value": "MANPUR"
                                },
                                {
                                    "Text": "MANSA",
                                    "Value": "MANSA"
                                },
                                {
                                    "Text": "MANSA",
                                    "Value": "MANSA"
                                },
                                {
                                    "Text": "MANSOORWAL ",
                                    "Value": "MANSOORWAL "
                                },
                                {
                                    "Text": "MANTHANI ",
                                    "Value": "MANTHANI "
                                },
                                {
                                    "Text": "MANTHANI",
                                    "Value": "MANTHANI"
                                },
                                {
                                    "Text": "MAPUSA",
                                    "Value": "MAPUSA"
                                },
                                {
                                    "Text": "MAROL",
                                    "Value": "MAROL"
                                },
                                {
                                    "Text": "MARATHALLI",
                                    "Value": "MARATHALLI"
                                },
                                {
                                    "Text": "MARAIMALAI",
                                    "Value": "MARAIMALAI"
                                },
                                {
                                    "Text": "MARCEL",
                                    "Value": "MARCEL"
                                },
                                {
                                    "Text": "MARCELA",
                                    "Value": "MARCELA"
                                },
                                {
                                    "Text": "MARDANPUR",
                                    "Value": "MARDANPUR"
                                },
                                {
                                    "Text": "MARGAO",
                                    "Value": "MARGAO"
                                },
                                {
                                    "Text": "MARGOA",
                                    "Value": "MARGOA"
                                },
                                {
                                    "Text": "MARGOA",
                                    "Value": "MARGOA"
                                },
                                {
                                    "Text": "MARIGAON",
                                    "Value": "MARIGAON"
                                },
                                {
                                    "Text": "MARIGADI ",
                                    "Value": "MARIGADI "
                                },
                                {
                                    "Text": "MARKAPUR",
                                    "Value": "MARKAPUR"
                                },
                                {
                                    "Text": "MARLAGUDEM ",
                                    "Value": "MARLAGUDEM "
                                },
                                {
                                    "Text": "MAROLI",
                                    "Value": "MAROLI"
                                },
                                {
                                    "Text": "MARTHANDAM",
                                    "Value": "MARTHANDAM"
                                },
                                {
                                    "Text": "MARYAL ",
                                    "Value": "MARYAL "
                                },
                                {
                                    "Text": "MASLANDAPUR",
                                    "Value": "MASLANDAPUR"
                                },
                                {
                                    "Text": "MASOR KHAMBH ",
                                    "Value": "MASOR KHAMBH "
                                },
                                {
                                    "Text": "MATANHAIL",
                                    "Value": "MATANHAIL"
                                },
                                {
                                    "Text": "MATHURA",
                                    "Value": "MATHURA"
                                },
                                {
                                    "Text": "MATIGARA",
                                    "Value": "MATIGARA"
                                },
                                {
                                    "Text": "MATOOR ",
                                    "Value": "MATOOR "
                                },
                                {
                                    "Text": "MATRA",
                                    "Value": "MATRA"
                                },
                                {
                                    "Text": "MATTANUR",
                                    "Value": "MATTANUR"
                                },
                                {
                                    "Text": "MATTARAKKAL ",
                                    "Value": "MATTARAKKAL "
                                },
                                {
                                    "Text": "MATTANNUR",
                                    "Value": "MATTANNUR"
                                },
                                {
                                    "Text": "MATWADA ",
                                    "Value": "MATWADA "
                                },
                                {
                                    "Text": "MAU",
                                    "Value": "MAU"
                                },
                                {
                                    "Text": "MAUDAHA",
                                    "Value": "MAUDAHA"
                                },
                                {
                                    "Text": "MAUJPURI ",
                                    "Value": "MAUJPURI "
                                },
                                {
                                    "Text": "MAUNATH BHANJAN",
                                    "Value": "MAUNATH BHANJAN"
                                },
                                {
                                    "Text": "MAURANIPUR",
                                    "Value": "MAURANIPUR"
                                },
                                {
                                    "Text": "MAUR MANDI",
                                    "Value": "MAUR MANDI"
                                },
                                {
                                    "Text": "MAUR",
                                    "Value": "MAUR"
                                },
                                {
                                    "Text": "MAURMANDI",
                                    "Value": "MAURMANDI"
                                },
                                {
                                    "Text": "MAVELIKARA",
                                    "Value": "MAVELIKARA"
                                },
                                {
                                    "Text": "MAVELIKKARA",
                                    "Value": "MAVELIKKARA"
                                },
                                {
                                    "Text": "MAWANA",
                                    "Value": "MAWANA"
                                },
                                {
                                    "Text": "MAYILADUTHURAI",
                                    "Value": "MAYILADUTHURAI"
                                },
                                {
                                    "Text": "MAYILADUTHURAI TOWN",
                                    "Value": "MAYILADUTHURAI TOWN"
                                },
                                {
                                    "Text": "MAYAPURI",
                                    "Value": "MAYAPURI"
                                },
                                {
                                    "Text": "MAYURBHANJ",
                                    "Value": "MAYURBHANJ"
                                },
                                {
                                    "Text": "MADARIA",
                                    "Value": "MADARIA"
                                },
                                {
                                    "Text": "MEDAK",
                                    "Value": "MEDAK"
                                },
                                {
                                    "Text": "MEDCHAL",
                                    "Value": "MEDCHAL"
                                },
                                {
                                    "Text": "MEDINIPUR",
                                    "Value": "MEDINIPUR"
                                },
                                {
                                    "Text": "MEDIPALLY ",
                                    "Value": "MEDIPALLY "
                                },
                                {
                                    "Text": "MEERUT",
                                    "Value": "MEERUT"
                                },
                                {
                                    "Text": "MEGH CHAPPAR",
                                    "Value": "MEGH CHAPPAR"
                                },
                                {
                                    "Text": "MEHATPUR",
                                    "Value": "MEHATPUR"
                                },
                                {
                                    "Text": "MEHAM",
                                    "Value": "MEHAM"
                                },
                                {
                                    "Text": "MEHBUBNAGAR",
                                    "Value": "MEHBUBNAGAR"
                                },
                                {
                                    "Text": "MEHDOODAN",
                                    "Value": "MEHDOODAN"
                                },
                                {
                                    "Text": "MEHELI",
                                    "Value": "MEHELI"
                                },
                                {
                                    "Text": "MEHMA SINGHWALA",
                                    "Value": "MEHMA SINGHWALA"
                                },
                                {
                                    "Text": "MEHSANA",
                                    "Value": "MEHSANA"
                                },
                                {
                                    "Text": "MEHTA",
                                    "Value": "MEHTA"
                                },
                                {
                                    "Text": "MEMADPUR",
                                    "Value": "MEMADPUR"
                                },
                                {
                                    "Text": "MEMARI",
                                    "Value": "MEMARI"
                                },
                                {
                                    "Text": "MEMAURA",
                                    "Value": "MEMAURA"
                                },
                                {
                                    "Text": "MEMNAGAR",
                                    "Value": "MEMNAGAR"
                                },
                                {
                                    "Text": "MENDHIPATHAR",
                                    "Value": "MENDHIPATHAR"
                                },
                                {
                                    "Text": "MENDHIPATHAR",
                                    "Value": "MENDHIPATHAR"
                                },
                                {
                                    "Text": "MENDRA KALAN",
                                    "Value": "MENDRA KALAN"
                                },
                                {
                                    "Text": "MERAMANDALI",
                                    "Value": "MERAMANDALI"
                                },
                                {
                                    "Text": "MERTA CITY",
                                    "Value": "MERTA CITY"
                                },
                                {
                                    "Text": "METODA",
                                    "Value": "METODA"
                                },
                                {
                                    "Text": "METPALLE",
                                    "Value": "METPALLE"
                                },
                                {
                                    "Text": "METTUPALAYAM",
                                    "Value": "METTUPALAYAM"
                                },
                                {
                                    "Text": "METTUR DAM",
                                    "Value": "METTUR DAM"
                                },
                                {
                                    "Text": "METTUR",
                                    "Value": "METTUR"
                                },
                                {
                                    "Text": "MEGHNAGAR",
                                    "Value": "MEGHNAGAR"
                                },
                                {
                                    "Text": "MHOW",
                                    "Value": "MHOW"
                                },
                                {
                                    "Text": "MIANI KHAS",
                                    "Value": "MIANI KHAS"
                                },
                                {
                                    "Text": "MIDNAPORE",
                                    "Value": "MIDNAPORE"
                                },
                                {
                                    "Text": "MILAK ",
                                    "Value": "MILAK "
                                },
                                {
                                    "Text": "MILKIPUR",
                                    "Value": "MILKIPUR"
                                },
                                {
                                    "Text": "MIRA ROAD",
                                    "Value": "MIRA ROAD"
                                },
                                {
                                    "Text": "MIRAJ",
                                    "Value": "MIRAJ"
                                },
                                {
                                    "Text": "MIRAN KOT KALAN",
                                    "Value": "MIRAN KOT KALAN"
                                },
                                {
                                    "Text": "MIRDHAPALLI ",
                                    "Value": "MIRDHAPALLI "
                                },
                                {
                                    "Text": "MIRGANJ",
                                    "Value": "MIRGANJ"
                                },
                                {
                                    "Text": "MIRYALGUDA",
                                    "Value": "MIRYALGUDA"
                                },
                                {
                                    "Text": "MIRZAPUR",
                                    "Value": "MIRZAPUR"
                                },
                                {
                                    "Text": "MITHAPUR",
                                    "Value": "MITHAPUR"
                                },
                                {
                                    "Text": "MITHI ROHAR",
                                    "Value": "MITHI ROHAR"
                                },
                                {
                                    "Text": "M K PATNAM ",
                                    "Value": "M K PATNAM "
                                },
                                {
                                    "Text": "MALIBU TOWNE",
                                    "Value": "MALIBU TOWNE"
                                },
                                {
                                    "Text": "MALPUR",
                                    "Value": "MALPUR"
                                },
                                {
                                    "Text": "MOLAR BAND",
                                    "Value": "MOLAR BAND"
                                },
                                {
                                    "Text": "MANINAGAR",
                                    "Value": "MANINAGAR"
                                },
                                {
                                    "Text": "MANARGUDI",
                                    "Value": "MANARGUDI"
                                },
                                {
                                    "Text": "MODASA",
                                    "Value": "MODASA"
                                },
                                {
                                    "Text": "MODINAGAR",
                                    "Value": "MODINAGAR"
                                },
                                {
                                    "Text": "MOGA",
                                    "Value": "MOGA"
                                },
                                {
                                    "Text": "MOGA KTY ",
                                    "Value": "MOGA KTY "
                                },
                                {
                                    "Text": "MOGRA BADSHAHPUR",
                                    "Value": "MOGRA BADSHAHPUR"
                                },
                                {
                                    "Text": "MOHALI",
                                    "Value": "MOHALI"
                                },
                                {
                                    "Text": "MOHALI",
                                    "Value": "MOHALI"
                                },
                                {
                                    "Text": "MOHAN ",
                                    "Value": "MOHAN "
                                },
                                {
                                    "Text": "MOHALI SAS NAGAR",
                                    "Value": "MOHALI SAS NAGAR"
                                },
                                {
                                    "Text": "MOHAMMADABAD",
                                    "Value": "MOHAMMADABAD"
                                },
                                {
                                    "Text": "MOHAMMADI",
                                    "Value": "MOHAMMADI"
                                },
                                {
                                    "Text": "MOHANIA",
                                    "Value": "MOHANIA"
                                },
                                {
                                    "Text": "MOHANLALGANJ",
                                    "Value": "MOHANLALGANJ"
                                },
                                {
                                    "Text": "MOHKHED ",
                                    "Value": "MOHKHED "
                                },
                                {
                                    "Text": "MOHONE",
                                    "Value": "MOHONE"
                                },
                                {
                                    "Text": "MOKAMA",
                                    "Value": "MOKAMA"
                                },
                                {
                                    "Text": "MOKAMA",
                                    "Value": "MOKAMA"
                                },
                                {
                                    "Text": "MOKAMEH",
                                    "Value": "MOKAMEH"
                                },
                                {
                                    "Text": "MOKANDPUR",
                                    "Value": "MOKANDPUR"
                                },
                                {
                                    "Text": "MOKOKCHUNG",
                                    "Value": "MOKOKCHUNG"
                                },
                                {
                                    "Text": "MOLKACHARLA ",
                                    "Value": "MOLKACHARLA "
                                },
                                {
                                    "Text": "TUE",
                                    "Value": "MON"
                                },
                                {
                                    "Text": "MOOM",
                                    "Value": "MOOM"
                                },
                                {
                                    "Text": "MOONAK",
                                    "Value": "MOONAK"
                                },
                                {
                                    "Text": "MOOTHAKUNNAM",
                                    "Value": "MOOTHAKUNNAM"
                                },
                                {
                                    "Text": "MORADABAD",
                                    "Value": "MORADABAD"
                                },
                                {
                                    "Text": "MORANWALI ",
                                    "Value": "MORANWALI "
                                },
                                {
                                    "Text": "MORAN",
                                    "Value": "MORAN"
                                },
                                {
                                    "Text": "MORANWALI",
                                    "Value": "MORANWALI"
                                },
                                {
                                    "Text": "MORBI",
                                    "Value": "MORBI"
                                },
                                {
                                    "Text": "MORENA",
                                    "Value": "MORENA"
                                },
                                {
                                    "Text": "MORGA ",
                                    "Value": "MORGA "
                                },
                                {
                                    "Text": "MORINDA",
                                    "Value": "MORINDA"
                                },
                                {
                                    "Text": "MORMUGOA",
                                    "Value": "MORMUGOA"
                                },
                                {
                                    "Text": "MORMUGOA",
                                    "Value": "MORMUGOA"
                                },
                                {
                                    "Text": "MORVI",
                                    "Value": "MORVI"
                                },
                                {
                                    "Text": "MOTATIMBLA",
                                    "Value": "MOTATIMBLA"
                                },
                                {
                                    "Text": "MOTA MAVA",
                                    "Value": "MOTA MAVA"
                                },
                                {
                                    "Text": "MOTA",
                                    "Value": "MOTA"
                                },
                                {
                                    "Text": "MOTALA",
                                    "Value": "MOTALA"
                                },
                                {
                                    "Text": "MOTEBENNUR ",
                                    "Value": "MOTEBENNUR "
                                },
                                {
                                    "Text": "MOTEERAM ADDA",
                                    "Value": "MOTEERAM ADDA"
                                },
                                {
                                    "Text": "MOTIHARI",
                                    "Value": "MOTIHARI"
                                },
                                {
                                    "Text": "MIRA-BHAYANDAR",
                                    "Value": "MIRA-BHAYANDAR"
                                },
                                {
                                    "Text": "MIRPUR TURK",
                                    "Value": "MIRPUR TURK"
                                },
                                {
                                    "Text": "MASLANDAPUR",
                                    "Value": "MASLANDAPUR"
                                },
                                {
                                    "Text": "MUSTAFABAD, DELHI",
                                    "Value": "MUSTAFABAD, DELHI"
                                },
                                {
                                    "Text": "MITHE PUR",
                                    "Value": "MITHE PUR"
                                },
                                {
                                    "Text": "MATTAN",
                                    "Value": "MATTAN"
                                },
                                {
                                    "Text": "MOTATIMBLA",
                                    "Value": "MOTATIMBLA"
                                },
                                {
                                    "Text": "MUBARAKPUR",
                                    "Value": "MUBARAKPUR"
                                },
                                {
                                    "Text": "MUCHIMILLI ",
                                    "Value": "MUCHIMILLI "
                                },
                                {
                                    "Text": "MUDBIDRI",
                                    "Value": "MUDBIDRI"
                                },
                                {
                                    "Text": "MUDGUL CHITTEMPALLE ",
                                    "Value": "MUDGUL CHITTEMPALLE "
                                },
                                {
                                    "Text": "MUDHOL",
                                    "Value": "MUDHOL"
                                },
                                {
                                    "Text": "MUDHAL",
                                    "Value": "MUDHAL"
                                },
                                {
                                    "Text": "MUDKI",
                                    "Value": "MUDKI"
                                },
                                {
                                    "Text": "MUDUPUGAL ",
                                    "Value": "MUDUPUGAL "
                                },
                                {
                                    "Text": "MUGHALSARAI",
                                    "Value": "MUGHALSARAI"
                                },
                                {
                                    "Text": "MUGPAL",
                                    "Value": "MUGPAL"
                                },
                                {
                                    "Text": "MUHAMMADABAD",
                                    "Value": "MUHAMMADABAD"
                                },
                                {
                                    "Text": "MUKHED",
                                    "Value": "MUKHED"
                                },
                                {
                                    "Text": "MUKERIAN",
                                    "Value": "MUKERIAN"
                                },
                                {
                                    "Text": "MUKTSAR",
                                    "Value": "MUKTSAR"
                                },
                                {
                                    "Text": "MULAGAMPALLY ",
                                    "Value": "MULAGAMPALLY "
                                },
                                {
                                    "Text": "MULBAGAL",
                                    "Value": "MULBAGAL"
                                },
                                {
                                    "Text": "MULKI",
                                    "Value": "MULKI"
                                },
                                {
                                    "Text": "MULLANPUR",
                                    "Value": "MULLANPUR"
                                },
                                {
                                    "Text": "MULLANA",
                                    "Value": "MULLANA"
                                },
                                {
                                    "Text": "MULLANPUR DAKHA",
                                    "Value": "MULLANPUR DAKHA"
                                },
                                {
                                    "Text": "MULLANPUR GARIBADAS",
                                    "Value": "MULLANPUR GARIBADAS"
                                },
                                {
                                    "Text": "MUL",
                                    "Value": "MUL"
                                },
                                {
                                    "Text": "MUMBAI",
                                    "Value": "MUMBAI"
                                },
                                {
                                    "Text": "MUMBRA",
                                    "Value": "MUMBRA"
                                },
                                {
                                    "Text": "MUNAK",
                                    "Value": "MUNAK"
                                },
                                {
                                    "Text": "MUNDRA",
                                    "Value": "MUNDRA"
                                },
                                {
                                    "Text": "MUNDKA",
                                    "Value": "MUNDKA"
                                },
                                {
                                    "Text": "MUNDIYUR ",
                                    "Value": "MUNDIYUR "
                                },
                                {
                                    "Text": "MUNDA",
                                    "Value": "MUNDA"
                                },
                                {
                                    "Text": "MUNDALI",
                                    "Value": "MUNDALI"
                                },
                                {
                                    "Text": "MUNGER",
                                    "Value": "MUNGER"
                                },
                                {
                                    "Text": "MUNGELI",
                                    "Value": "MUNGELI"
                                },
                                {
                                    "Text": "MUNNUR SOMARAM ",
                                    "Value": "MUNNUR SOMARAM "
                                },
                                {
                                    "Text": "MUNPALLI ",
                                    "Value": "MUNPALLI "
                                },
                                {
                                    "Text": "MUNPALLE",
                                    "Value": "MUNPALLE"
                                },
                                {
                                    "Text": "MURARICHINTALA ",
                                    "Value": "MURARICHINTALA "
                                },
                                {
                                    "Text": "MURADABAD",
                                    "Value": "MURADABAD"
                                },
                                {
                                    "Text": "MURADNAGAR",
                                    "Value": "MURADNAGAR"
                                },
                                {
                                    "Text": "MURBAD",
                                    "Value": "MURBAD"
                                },
                                {
                                    "Text": "MURGUD",
                                    "Value": "MURGUD"
                                },
                                {
                                    "Text": "MURNAL ",
                                    "Value": "MURNAL "
                                },
                                {
                                    "Text": "MURSHIDABAD",
                                    "Value": "MURSHIDABAD"
                                },
                                {
                                    "Text": "MURTIJAPUR",
                                    "Value": "MURTIJAPUR"
                                },
                                {
                                    "Text": "MUSCAT",
                                    "Value": "MUSCAT"
                                },
                                {
                                    "Text": "MUSSOORIE",
                                    "Value": "MUSSOORIE"
                                },
                                {
                                    "Text": "MUSTAFABAD",
                                    "Value": "MUSTAFABAD"
                                },
                                {
                                    "Text": "MUVATTUPUZHA",
                                    "Value": "MUVATTUPUZHA"
                                },
                                {
                                    "Text": "MUZAFFARNAGAR",
                                    "Value": "MUZAFFARNAGAR"
                                },
                                {
                                    "Text": "MUZAFFARPUR",
                                    "Value": "MUZAFFARPUR"
                                },
                                {
                                    "Text": "MUZAFFARNAGAR",
                                    "Value": "MUZAFFARNAGAR"
                                },
                                {
                                    "Text": "MUZZAFAR NAGAR",
                                    "Value": "MUZZAFAR NAGAR"
                                },
                                {
                                    "Text": "MEWAT",
                                    "Value": "MEWAT"
                                },
                                {
                                    "Text": "MYSORE",
                                    "Value": "MYSORE"
                                },
                                {
                                    "Text": "N.PARAVUR",
                                    "Value": "N.PARAVUR"
                                },
                                {
                                    "Text": "NABARANGAPUR",
                                    "Value": "NABARANGAPUR"
                                },
                                {
                                    "Text": "NABADWIP",
                                    "Value": "NABADWIP"
                                },
                                {
                                    "Text": "NABHA",
                                    "Value": "NABHA"
                                },
                                {
                                    "Text": "NADAVARAMBA P.O",
                                    "Value": "NADAVARAMBA P.O"
                                },
                                {
                                    "Text": "NADALA",
                                    "Value": "NADALA"
                                },
                                {
                                    "Text": "NADAPURAM",
                                    "Value": "NADAPURAM"
                                },
                                {
                                    "Text": "NADAUN",
                                    "Value": "NADAUN"
                                },
                                {
                                    "Text": "NADEPALLE",
                                    "Value": "NADEPALLE"
                                },
                                {
                                    "Text": "NADIAD",
                                    "Value": "NADIAD"
                                },
                                {
                                    "Text": "NADIA",
                                    "Value": "NADIA"
                                },
                                {
                                    "Text": "NADIWADA ",
                                    "Value": "NADIWADA "
                                },
                                {
                                    "Text": "NAGAON",
                                    "Value": "NAGAON"
                                },
                                {
                                    "Text": "NAGAPATTINAM",
                                    "Value": "NAGAPATTINAM"
                                },
                                {
                                    "Text": "NAGAUR",
                                    "Value": "NAGAUR"
                                },
                                {
                                    "Text": "NAGARAM",
                                    "Value": "NAGARAM"
                                },
                                {
                                    "Text": "NAGDA",
                                    "Value": "NAGDA"
                                },
                                {
                                    "Text": "NAGDHARA",
                                    "Value": "NAGDHARA"
                                },
                                {
                                    "Text": "NAGERCOIL",
                                    "Value": "NAGERCOIL"
                                },
                                {
                                    "Text": "NAGINA",
                                    "Value": "NAGINA"
                                },
                                {
                                    "Text": "NANGAL DEWAT",
                                    "Value": "NANGAL DEWAT"
                                },
                                {
                                    "Text": "NANGAL THAKRAN",
                                    "Value": "NANGAL THAKRAN"
                                },
                                {
                                    "Text": "NAGPUR",
                                    "Value": "NAGPUR"
                                },
                                {
                                    "Text": "NAGROTA BAGWAN",
                                    "Value": "NAGROTA BAGWAN"
                                },
                                {
                                    "Text": "NAHARLAGUN",
                                    "Value": "NAHARLAGUN"
                                },
                                {
                                    "Text": "NAHAN",
                                    "Value": "NAHAN"
                                },
                                {
                                    "Text": "NAHARPUR KASAN",
                                    "Value": "NAHARPUR KASAN"
                                },
                                {
                                    "Text": "NAHARPUR",
                                    "Value": "NAHARPUR"
                                },
                                {
                                    "Text": "NAHUR",
                                    "Value": "NAHUR"
                                },
                                {
                                    "Text": "NAIGAVHAN ",
                                    "Value": "NAIGAVHAN "
                                },
                                {
                                    "Text": "NAIHATI",
                                    "Value": "NAIHATI"
                                },
                                {
                                    "Text": "NAINITAL",
                                    "Value": "NAINITAL"
                                },
                                {
                                    "Text": "NAIRA ",
                                    "Value": "NAIRA "
                                },
                                {
                                    "Text": "NAISI",
                                    "Value": "NAISI"
                                },
                                {
                                    "Text": "NAJIBABAD",
                                    "Value": "NAJIBABAD"
                                },
                                {
                                    "Text": "NAKATRANA",
                                    "Value": "NAKATRANA"
                                },
                                {
                                    "Text": "NAKODAR",
                                    "Value": "NAKODAR"
                                },
                                {
                                    "Text": "NAKREKAL",
                                    "Value": "NAKREKAL"
                                },
                                {
                                    "Text": "NALAGARH",
                                    "Value": "NALAGARH"
                                },
                                {
                                    "Text": "NALANDA",
                                    "Value": "NALANDA"
                                },
                                {
                                    "Text": "NALBARI",
                                    "Value": "NALBARI"
                                },
                                {
                                    "Text": "NALGONDA",
                                    "Value": "NALGONDA"
                                },
                                {
                                    "Text": "NALLASOPARA",
                                    "Value": "NALLASOPARA"
                                },
                                {
                                    "Text": "NALLASOPARA- WEST",
                                    "Value": "NALLASOPARA- WEST"
                                },
                                {
                                    "Text": "NALLAPUREDDYPALLE ",
                                    "Value": "NALLAPUREDDYPALLE "
                                },
                                {
                                    "Text": "NALNI ",
                                    "Value": "NALNI "
                                },
                                {
                                    "Text": "NAMAKKAL",
                                    "Value": "NAMAKKAL"
                                },
                                {
                                    "Text": "NAMCHI",
                                    "Value": "NAMCHI"
                                },
                                {
                                    "Text": "NAMCHI",
                                    "Value": "NAMCHI"
                                },
                                {
                                    "Text": "NAMPUR",
                                    "Value": "NAMPUR"
                                },
                                {
                                    "Text": "NAMSAI",
                                    "Value": "NAMSAI"
                                },
                                {
                                    "Text": "NANAKSAR KALERAN",
                                    "Value": "NANAKSAR KALERAN"
                                },
                                {
                                    "Text": "NANDYAL",
                                    "Value": "NANDYAL"
                                },
                                {
                                    "Text": "NANDED",
                                    "Value": "NANDED"
                                },
                                {
                                    "Text": "NANDURBAR",
                                    "Value": "NANDURBAR"
                                },
                                {
                                    "Text": "NANDIPAHAD ",
                                    "Value": "NANDIPAHAD "
                                },
                                {
                                    "Text": "NANDGAON ",
                                    "Value": "NANDGAON "
                                },
                                {
                                    "Text": "NANDGAON",
                                    "Value": "NANDGAON"
                                },
                                {
                                    "Text": "NANDURA",
                                    "Value": "NANDURA"
                                },
                                {
                                    "Text": "NANGAL",
                                    "Value": "NANGAL"
                                },
                                {
                                    "Text": "NANGAL KALAN",
                                    "Value": "NANGAL KALAN"
                                },
                                {
                                    "Text": "NANGAL KHERI",
                                    "Value": "NANGAL KHERI"
                                },
                                {
                                    "Text": "NANJANGUD",
                                    "Value": "NANJANGUD"
                                },
                                {
                                    "Text": "NANPARA",
                                    "Value": "NANPARA"
                                },
                                {
                                    "Text": "NAPARA",
                                    "Value": "NAPARA"
                                },
                                {
                                    "Text": "NARAYANGAON",
                                    "Value": "NARAYANGAON"
                                },
                                {
                                    "Text": "NARASARAOPET",
                                    "Value": "NARASARAOPET"
                                },
                                {
                                    "Text": "NARAINGARH",
                                    "Value": "NARAINGARH"
                                },
                                {
                                    "Text": "NARAYANPUR",
                                    "Value": "NARAYANPUR"
                                },
                                {
                                    "Text": "NARAYANPUR",
                                    "Value": "NARAYANPUR"
                                },
                                {
                                    "Text": "NARAINA",
                                    "Value": "NARAINA"
                                },
                                {
                                    "Text": "NARASAPURAPUPETA ",
                                    "Value": "NARASAPURAPUPETA "
                                },
                                {
                                    "Text": "NARASAMPET",
                                    "Value": "NARASAMPET"
                                },
                                {
                                    "Text": "NARASAPUR",
                                    "Value": "NARASAPUR"
                                },
                                {
                                    "Text": "NARASARAOPETA",
                                    "Value": "NARASARAOPETA"
                                },
                                {
                                    "Text": "NARAYANPET",
                                    "Value": "NARAYANPET"
                                },
                                {
                                    "Text": "NAREDA",
                                    "Value": "NAREDA"
                                },
                                {
                                    "Text": "NARMADA",
                                    "Value": "NARMADA"
                                },
                                {
                                    "Text": "NARMETTA ",
                                    "Value": "NARMETTA "
                                },
                                {
                                    "Text": "NARNAUD",
                                    "Value": "NARNAUD"
                                },
                                {
                                    "Text": "NARNAUL",
                                    "Value": "NARNAUL"
                                },
                                {
                                    "Text": "NARNAUND",
                                    "Value": "NARNAUND"
                                },
                                {
                                    "Text": "NARSINGHPUR",
                                    "Value": "NARSINGHPUR"
                                },
                                {
                                    "Text": "NARSAMPET",
                                    "Value": "NARSAMPET"
                                },
                                {
                                    "Text": "NARSAPUR",
                                    "Value": "NARSAPUR"
                                },
                                {
                                    "Text": "NARSINGHPUR",
                                    "Value": "NARSINGHPUR"
                                },
                                {
                                    "Text": "NARSAPURA",
                                    "Value": "NARSAPURA"
                                },
                                {
                                    "Text": "NARSIPATNAM",
                                    "Value": "NARSIPATNAM"
                                },
                                {
                                    "Text": "NARUGRAM",
                                    "Value": "NARUGRAM"
                                },
                                {
                                    "Text": "NARWANA",
                                    "Value": "NARWANA"
                                },
                                {
                                    "Text": "NASHIK",
                                    "Value": "NASHIK"
                                },
                                {
                                    "Text": "NASIK",
                                    "Value": "NASIK"
                                },
                                {
                                    "Text": "NASIRABAD",
                                    "Value": "NASIRABAD"
                                },
                                {
                                    "Text": "NASVADI",
                                    "Value": "NASVADI"
                                },
                                {
                                    "Text": "NATGRAM",
                                    "Value": "NATGRAM"
                                },
                                {
                                    "Text": "NATHDWARA",
                                    "Value": "NATHDWARA"
                                },
                                {
                                    "Text": "NATHU CHAHAL ",
                                    "Value": "NATHU CHAHAL "
                                },
                                {
                                    "Text": "NATHANA",
                                    "Value": "NATHANA"
                                },
                                {
                                    "Text": "NAUGACHHIA",
                                    "Value": "NAUGACHHIA"
                                },
                                {
                                    "Text": "NAUGARH",
                                    "Value": "NAUGARH"
                                },
                                {
                                    "Text": "NAURANGABAD ",
                                    "Value": "NAURANGABAD "
                                },
                                {
                                    "Text": "NAURA",
                                    "Value": "NAURA"
                                },
                                {
                                    "Text": "NAUSHERA MAJA SINGH",
                                    "Value": "NAUSHERA MAJA SINGH"
                                },
                                {
                                    "Text": "NAUSHERA PANNUAN",
                                    "Value": "NAUSHERA PANNUAN"
                                },
                                {
                                    "Text": "NAUSHERA",
                                    "Value": "NAUSHERA"
                                },
                                {
                                    "Text": "NAUTANWA",
                                    "Value": "NAUTANWA"
                                },
                                {
                                    "Text": "NAVELIM",
                                    "Value": "NAVELIM"
                                },
                                {
                                    "Text": "NAVI MUMBAI",
                                    "Value": "NAVI MUMBAI"
                                },
                                {
                                    "Text": "NAVSARI",
                                    "Value": "NAVSARI"
                                },
                                {
                                    "Text": "NAWADA",
                                    "Value": "NAWADA"
                                },
                                {
                                    "Text": "NAWANSHAHAR",
                                    "Value": "NAWANSHAHAR"
                                },
                                {
                                    "Text": "NAWANSHAHR",
                                    "Value": "NAWANSHAHR"
                                },
                                {
                                    "Text": "NAWABGANJ",
                                    "Value": "NAWABGANJ"
                                },
                                {
                                    "Text": "NAWAGARH",
                                    "Value": "NAWAGARH"
                                },
                                {
                                    "Text": "NAWALGARH",
                                    "Value": "NAWALGARH"
                                },
                                {
                                    "Text": "NAWAN PIND",
                                    "Value": "NAWAN PIND"
                                },
                                {
                                    "Text": "NAWANAGAR",
                                    "Value": "NAWANAGAR"
                                },
                                {
                                    "Text": "NAWANSHAHAR",
                                    "Value": "NAWANSHAHAR"
                                },
                                {
                                    "Text": "NAWAPUR",
                                    "Value": "NAWAPUR"
                                },
                                {
                                    "Text": "NAYA NANGAL",
                                    "Value": "NAYA NANGAL"
                                },
                                {
                                    "Text": "NAYAGARH",
                                    "Value": "NAYAGARH"
                                },
                                {
                                    "Text": "NAZIRA",
                                    "Value": "NAZIRA"
                                },
                                {
                                    "Text": "NEW DELHI MUNICIPAL COUNCIL",
                                    "Value": "NEW DELHI MUNICIPAL COUNCIL"
                                },
                                {
                                    "Text": "NEDUMANGAD",
                                    "Value": "NEDUMANGAD"
                                },
                                {
                                    "Text": "NEELAPALLE",
                                    "Value": "NEELAPALLE"
                                },
                                {
                                    "Text": "NEEMUCH",
                                    "Value": "NEEMUCH"
                                },
                                {
                                    "Text": "NEEM KA THANA",
                                    "Value": "NEEM KA THANA"
                                },
                                {
                                    "Text": "NEEM KA THANA",
                                    "Value": "NEEM KA THANA"
                                },
                                {
                                    "Text": "NEEMRANA",
                                    "Value": "NEEMRANA"
                                },
                                {
                                    "Text": "NELLORE",
                                    "Value": "NELLORE"
                                },
                                {
                                    "Text": "NELLUTLA ",
                                    "Value": "NELLUTLA "
                                },
                                {
                                    "Text": "NERALAKUPPE ",
                                    "Value": "NERALAKUPPE "
                                },
                                {
                                    "Text": "NERAL",
                                    "Value": "NERAL"
                                },
                                {
                                    "Text": "NERUL",
                                    "Value": "NERUL"
                                },
                                {
                                    "Text": "NER ",
                                    "Value": "NER "
                                },
                                {
                                    "Text": "NER",
                                    "Value": "NER"
                                },
                                {
                                    "Text": "NESARGI",
                                    "Value": "NESARGI"
                                },
                                {
                                    "Text": "NETRAMALI",
                                    "Value": "NETRAMALI"
                                },
                                {
                                    "Text": "NETTOOR",
                                    "Value": "NETTOOR"
                                },
                                {
                                    "Text": "NEVALGANJ ",
                                    "Value": "NEVALGANJ "
                                },
                                {
                                    "Text": "NEW DELHI",
                                    "Value": "NEW DELHI"
                                },
                                {
                                    "Text": "NEWAI",
                                    "Value": "NEWAI"
                                },
                                {
                                    "Text": "NEW ABADI ",
                                    "Value": "NEW ABADI "
                                },
                                {
                                    "Text": "NEW DUDHAI",
                                    "Value": "NEW DUDHAI"
                                },
                                {
                                    "Text": "NEYVELI",
                                    "Value": "NEYVELI"
                                },
                                {
                                    "Text": "NEYYATTINKARA",
                                    "Value": "NEYYATTINKARA"
                                },
                                {
                                    "Text": "NEYYATTINKARA",
                                    "Value": "NEYYATTINKARA"
                                },
                                {
                                    "Text": "NANGLOI JAT",
                                    "Value": "NANGLOI JAT"
                                },
                                {
                                    "Text": "NHAVA SHEVA",
                                    "Value": "NHAVA SHEVA"
                                },
                                {
                                    "Text": "NOHAR",
                                    "Value": "NOHAR"
                                },
                                {
                                    "Text": "NICOBAR",
                                    "Value": "NICOBAR"
                                },
                                {
                                    "Text": "NIDADAVOLE",
                                    "Value": "NIDADAVOLE"
                                },
                                {
                                    "Text": "NIDHIPUR",
                                    "Value": "NIDHIPUR"
                                },
                                {
                                    "Text": "NIGDI",
                                    "Value": "NIGDI"
                                },
                                {
                                    "Text": "NIGHOJE",
                                    "Value": "NIGHOJE"
                                },
                                {
                                    "Text": "NIHAL SINGH WALA",
                                    "Value": "NIHAL SINGH WALA"
                                },
                                {
                                    "Text": "NIHALSINGH WALA",
                                    "Value": "NIHALSINGH WALA"
                                },
                                {
                                    "Text": "NIJHOTA ",
                                    "Value": "NIJHOTA "
                                },
                                {
                                    "Text": "NILAMBUR",
                                    "Value": "NILAMBUR"
                                },
                                {
                                    "Text": "NIVALI",
                                    "Value": "NIVALI"
                                },
                                {
                                    "Text": "NILGIRIS",
                                    "Value": "NILGIRIS"
                                },
                                {
                                    "Text": "NILOKHERI",
                                    "Value": "NILOKHERI"
                                },
                                {
                                    "Text": "NIMAPARA",
                                    "Value": "NIMAPARA"
                                },
                                {
                                    "Text": "NIMBAHERA",
                                    "Value": "NIMBAHERA"
                                },
                                {
                                    "Text": "NIMETHA",
                                    "Value": "NIMETHA"
                                },
                                {
                                    "Text": "NINDUGONDA ",
                                    "Value": "NINDUGONDA "
                                },
                                {
                                    "Text": "NIPHAD",
                                    "Value": "NIPHAD"
                                },
                                {
                                    "Text": "NIPPANI",
                                    "Value": "NIPPANI"
                                },
                                {
                                    "Text": "NIRA",
                                    "Value": "NIRA"
                                },
                                {
                                    "Text": "NIRMAL",
                                    "Value": "NIRMAL"
                                },
                                {
                                    "Text": "NIRMALI",
                                    "Value": "NIRMALI"
                                },
                                {
                                    "Text": "NISARAYA",
                                    "Value": "NISARAYA"
                                },
                                {
                                    "Text": "NISSING",
                                    "Value": "NISSING"
                                },
                                {
                                    "Text": "NIVALI",
                                    "Value": "NIVALI"
                                },
                                {
                                    "Text": "NIWAI",
                                    "Value": "NIWAI"
                                },
                                {
                                    "Text": "NIWAROO",
                                    "Value": "NIWAROO"
                                },
                                {
                                    "Text": "NIZAMABAD",
                                    "Value": "NIZAMABAD"
                                },
                                {
                                    "Text": "NAJAFGARH",
                                    "Value": "NAJAFGARH"
                                },
                                {
                                    "Text": "NILANGA",
                                    "Value": "NILANGA"
                                },
                                {
                                    "Text": "NOCHIMEDU ",
                                    "Value": "NOCHIMEDU "
                                },
                                {
                                    "Text": "NOIDA",
                                    "Value": "NOIDA"
                                },
                                {
                                    "Text": "NOIDA",
                                    "Value": "NOIDA"
                                },
                                {
                                    "Text": "NOKHA",
                                    "Value": "NOKHA"
                                },
                                {
                                    "Text": "NONGPOH",
                                    "Value": "NONGPOH"
                                },
                                {
                                    "Text": "NONGSTOIN",
                                    "Value": "NONGSTOIN"
                                },
                                {
                                    "Text": "NOONMATI",
                                    "Value": "NOONMATI"
                                },
                                {
                                    "Text": "NOORPUR",
                                    "Value": "NOORPUR"
                                },
                                {
                                    "Text": "NORTH LAKHIMPUR",
                                    "Value": "NORTH LAKHIMPUR"
                                },
                                {
                                    "Text": "NORTH EAST DELHI",
                                    "Value": "NORTH EAST DELHI"
                                },
                                {
                                    "Text": "NORTH 24 PARGANAS",
                                    "Value": "NORTH 24 PARGANAS"
                                },
                                {
                                    "Text": "NORTH AND MIDDLE ANDAMAN",
                                    "Value": "NORTH AND MIDDLE ANDAMAN"
                                },
                                {
                                    "Text": "NORTH CACHAR HILLS",
                                    "Value": "NORTH CACHAR HILLS"
                                },
                                {
                                    "Text": "NORTH DELHI",
                                    "Value": "NORTH DELHI"
                                },
                                {
                                    "Text": "NORTH DINAJPUR",
                                    "Value": "NORTH DINAJPUR"
                                },
                                {
                                    "Text": "NORTH GOA",
                                    "Value": "NORTH GOA"
                                },
                                {
                                    "Text": "NORTH SIKKIM",
                                    "Value": "NORTH SIKKIM"
                                },
                                {
                                    "Text": "NORTH TRIPURA",
                                    "Value": "NORTH TRIPURA"
                                },
                                {
                                    "Text": "NORTH WEST DELHI",
                                    "Value": "NORTH WEST DELHI"
                                },
                                {
                                    "Text": "NORTH DUMDUM",
                                    "Value": "NORTH DUMDUM"
                                },
                                {
                                    "Text": "NORTH GUWAHATI",
                                    "Value": "NORTH GUWAHATI"
                                },
                                {
                                    "Text": "NOWGONG",
                                    "Value": "NOWGONG"
                                },
                                {
                                    "Text": "NAPARA",
                                    "Value": "NAPARA"
                                },
                                {
                                    "Text": "NSP CAMP MIRYALAGUDA ",
                                    "Value": "NSP CAMP MIRYALAGUDA "
                                },
                                {
                                    "Text": "NATEPUTE",
                                    "Value": "NATEPUTE"
                                },
                                {
                                    "Text": "NUAPADA",
                                    "Value": "NUAPADA"
                                },
                                {
                                    "Text": "NUH",
                                    "Value": "NUH"
                                },
                                {
                                    "Text": "NUMALIGARH",
                                    "Value": "NUMALIGARH"
                                },
                                {
                                    "Text": "NUNA MAJRA",
                                    "Value": "NUNA MAJRA"
                                },
                                {
                                    "Text": "NURMAHAL",
                                    "Value": "NURMAHAL"
                                },
                                {
                                    "Text": "NURPUR BEDI",
                                    "Value": "NURPUR BEDI"
                                },
                                {
                                    "Text": "NUVEM",
                                    "Value": "NUVEM"
                                },
                                {
                                    "Text": "NUZVID",
                                    "Value": "NUZVID"
                                },
                                {
                                    "Text": "NIWARI",
                                    "Value": "NIWARI"
                                },
                                {
                                    "Text": "NAZIRA",
                                    "Value": "NAZIRA"
                                },
                                {
                                    "Text": "OBRA",
                                    "Value": "OBRA"
                                },
                                {
                                    "Text": "ODDANCHATRAM",
                                    "Value": "ODDANCHATRAM"
                                },
                                {
                                    "Text": "ODWARA",
                                    "Value": "ODWARA"
                                },
                                {
                                    "Text": "OLD GOA",
                                    "Value": "OLD GOA"
                                },
                                {
                                    "Text": "OLD GOA",
                                    "Value": "OLD GOA"
                                },
                                {
                                    "Text": "ONGOLE",
                                    "Value": "ONGOLE"
                                },
                                {
                                    "Text": "OOTY",
                                    "Value": "OOTY"
                                },
                                {
                                    "Text": "OPIVADA VENKAMPETA ",
                                    "Value": "OPIVADA VENKAMPETA "
                                },
                                {
                                    "Text": "OPP R K MARBLE HAZARIBAGH",
                                    "Value": "OPP R K MARBLE HAZARIBAGH"
                                },
                                {
                                    "Text": "ORAGADAM",
                                    "Value": "ORAGADAM"
                                },
                                {
                                    "Text": "ORAI",
                                    "Value": "ORAI"
                                },
                                {
                                    "Text": "ORAVACKAL",
                                    "Value": "ORAVACKAL"
                                },
                                {
                                    "Text": "OSMANABAD",
                                    "Value": "OSMANABAD"
                                },
                                {
                                    "Text": "OTHIAN",
                                    "Value": "OTHIAN"
                                },
                                {
                                    "Text": "OTTAPALAM",
                                    "Value": "OTTAPALAM"
                                },
                                {
                                    "Text": "OZAR",
                                    "Value": "OZAR"
                                },
                                {
                                    "Text": "PACHORA",
                                    "Value": "PACHORA"
                                },
                                {
                                    "Text": "PACHRA ",
                                    "Value": "PACHRA "
                                },
                                {
                                    "Text": "PACHAAT",
                                    "Value": "PACHAAT"
                                },
                                {
                                    "Text": "PACHCHUNUR",
                                    "Value": "PACHCHUNUR"
                                },
                                {
                                    "Text": "PADAMPUR",
                                    "Value": "PADAMPUR"
                                },
                                {
                                    "Text": "PADDI JAGIR",
                                    "Value": "PADDI JAGIR"
                                },
                                {
                                    "Text": "PADRAUNA",
                                    "Value": "PADRAUNA"
                                },
                                {
                                    "Text": "PADRA",
                                    "Value": "PADRA"
                                },
                                {
                                    "Text": "PAHARPUR ",
                                    "Value": "PAHARPUR "
                                },
                                {
                                    "Text": "PAITHAN",
                                    "Value": "PAITHAN"
                                },
                                {
                                    "Text": "PAI",
                                    "Value": "PAI"
                                },
                                {
                                    "Text": "PAKALAPADU ",
                                    "Value": "PAKALAPADU "
                                },
                                {
                                    "Text": "PAKHI KALAN ",
                                    "Value": "PAKHI KALAN "
                                },
                                {
                                    "Text": "PAKHARPUR",
                                    "Value": "PAKHARPUR"
                                },
                                {
                                    "Text": "PAKRI BARAMAD DEOBARI",
                                    "Value": "PAKRI BARAMAD DEOBARI"
                                },
                                {
                                    "Text": "PAKUR",
                                    "Value": "PAKUR"
                                },
                                {
                                    "Text": "PALAKOL",
                                    "Value": "PALAKOL"
                                },
                                {
                                    "Text": "PALA",
                                    "Value": "PALA"
                                },
                                {
                                    "Text": "PALANPUR",
                                    "Value": "PALANPUR"
                                },
                                {
                                    "Text": "PALAMPUR",
                                    "Value": "PALAMPUR"
                                },
                                {
                                    "Text": "PALARIVATTOM",
                                    "Value": "PALARIVATTOM"
                                },
                                {
                                    "Text": "PALAKKAD",
                                    "Value": "PALAKKAD"
                                },
                                {
                                    "Text": "PALAMAU",
                                    "Value": "PALAMAU"
                                },
                                {
                                    "Text": "PALASAUR ",
                                    "Value": "PALASAUR "
                                },
                                {
                                    "Text": "PALACOLE",
                                    "Value": "PALACOLE"
                                },
                                {
                                    "Text": "PALAMNER",
                                    "Value": "PALAMNER"
                                },
                                {
                                    "Text": "PALAVAKKAM",
                                    "Value": "PALAVAKKAM"
                                },
                                {
                                    "Text": "PALDA",
                                    "Value": "PALDA"
                                },
                                {
                                    "Text": "PALDI",
                                    "Value": "PALDI"
                                },
                                {
                                    "Text": "PALEJ",
                                    "Value": "PALEJ"
                                },
                                {
                                    "Text": "PALITANA",
                                    "Value": "PALITANA"
                                },
                                {
                                    "Text": "PALI",
                                    "Value": "PALI"
                                },
                                {
                                    "Text": "PALI ",
                                    "Value": "PALI "
                                },
                                {
                                    "Text": "PALIA KALAN",
                                    "Value": "PALIA KALAN"
                                },
                                {
                                    "Text": "PALASA KASIBUGGA",
                                    "Value": "PALASA KASIBUGGA"
                                },
                                {
                                    "Text": "PALKHANDA",
                                    "Value": "PALKHANDA"
                                },
                                {
                                    "Text": "PALLADAM",
                                    "Value": "PALLADAM"
                                },
                                {
                                    "Text": "PALLEPAHAD ",
                                    "Value": "PALLEPAHAD "
                                },
                                {
                                    "Text": "PALLAVARAM",
                                    "Value": "PALLAVARAM"
                                },
                                {
                                    "Text": "PALLIKANAI",
                                    "Value": "PALLIKANAI"
                                },
                                {
                                    "Text": "PALLIPALAYAM",
                                    "Value": "PALLIPALAYAM"
                                },
                                {
                                    "Text": "PALLIPPURAM",
                                    "Value": "PALLIPPURAM"
                                },
                                {
                                    "Text": "PALLURUTHY",
                                    "Value": "PALLURUTHY"
                                },
                                {
                                    "Text": "PALPUR",
                                    "Value": "PALPUR"
                                },
                                {
                                    "Text": "PALUS",
                                    "Value": "PALUS"
                                },
                                {
                                    "Text": "PALVANCHA ",
                                    "Value": "PALVANCHA "
                                },
                                {
                                    "Text": "PALWAL",
                                    "Value": "PALWAL"
                                },
                                {
                                    "Text": "PALWANCHA",
                                    "Value": "PALWANCHA"
                                },
                                {
                                    "Text": "PAMAL",
                                    "Value": "PAMAL"
                                },
                                {
                                    "Text": "PAMGARH",
                                    "Value": "PAMGARH"
                                },
                                {
                                    "Text": "PAMOL",
                                    "Value": "PAMOL"
                                },
                                {
                                    "Text": "PAMPORE",
                                    "Value": "PAMPORE"
                                },
                                {
                                    "Text": "PANAJI",
                                    "Value": "PANAJI"
                                },
                                {
                                    "Text": "PANAGARH",
                                    "Value": "PANAGARH"
                                },
                                {
                                    "Text": "PANCHKULA",
                                    "Value": "PANCHKULA"
                                },
                                {
                                    "Text": "PANCH MAHALS",
                                    "Value": "PANCH MAHALS"
                                },
                                {
                                    "Text": "PANCHKULA",
                                    "Value": "PANCHKULA"
                                },
                                {
                                    "Text": "PANDHARKAWADA",
                                    "Value": "PANDHARKAWADA"
                                },
                                {
                                    "Text": "PANDHURNA",
                                    "Value": "PANDHURNA"
                                },
                                {
                                    "Text": "PANDORI GOLA ",
                                    "Value": "PANDORI GOLA "
                                },
                                {
                                    "Text": "PANDORI RANSINGH ",
                                    "Value": "PANDORI RANSINGH "
                                },
                                {
                                    "Text": "PANDORI TAKHTMAL ",
                                    "Value": "PANDORI TAKHTMAL "
                                },
                                {
                                    "Text": "PANDALAM",
                                    "Value": "PANDALAM"
                                },
                                {
                                    "Text": "PANDHARKAODA",
                                    "Value": "PANDHARKAODA"
                                },
                                {
                                    "Text": "PANDHARPUR",
                                    "Value": "PANDHARPUR"
                                },
                                {
                                    "Text": "PANDUA",
                                    "Value": "PANDUA"
                                },
                                {
                                    "Text": "PANDUKA",
                                    "Value": "PANDUKA"
                                },
                                {
                                    "Text": "PANIPAT",
                                    "Value": "PANIPAT"
                                },
                                {
                                    "Text": "PANJIM",
                                    "Value": "PANJIM"
                                },
                                {
                                    "Text": "PANJABARI",
                                    "Value": "PANJABARI"
                                },
                                {
                                    "Text": "PANJE KE",
                                    "Value": "PANJE KE"
                                },
                                {
                                    "Text": "PANJGRAIN KALAN",
                                    "Value": "PANJGRAIN KALAN"
                                },
                                {
                                    "Text": "PANNA",
                                    "Value": "PANNA"
                                },
                                {
                                    "Text": "PANVEL",
                                    "Value": "PANVEL"
                                },
                                {
                                    "Text": "PAONTA SAHIB",
                                    "Value": "PAONTA SAHIB"
                                },
                                {
                                    "Text": "PAPUM PARE",
                                    "Value": "PAPUM PARE"
                                },
                                {
                                    "Text": "PARADIP PORT",
                                    "Value": "PARADIP PORT"
                                },
                                {
                                    "Text": "PARASIYA ",
                                    "Value": "PARASIYA "
                                },
                                {
                                    "Text": "PARAM ",
                                    "Value": "PARAM "
                                },
                                {
                                    "Text": "PARA BAZAR",
                                    "Value": "PARA BAZAR"
                                },
                                {
                                    "Text": "PARA SARAY",
                                    "Value": "PARA SARAY"
                                },
                                {
                                    "Text": "PARABHANI",
                                    "Value": "PARABHANI"
                                },
                                {
                                    "Text": "PARADEEP",
                                    "Value": "PARADEEP"
                                },
                                {
                                    "Text": "PARAVUR",
                                    "Value": "PARAVUR"
                                },
                                {
                                    "Text": "PARBHANI",
                                    "Value": "PARBHANI"
                                },
                                {
                                    "Text": "PARDI",
                                    "Value": "PARDI"
                                },
                                {
                                    "Text": "PARGANAS",
                                    "Value": "PARGANAS"
                                },
                                {
                                    "Text": "PARKAL",
                                    "Value": "PARKAL"
                                },
                                {
                                    "Text": "PARLAKHEMUNDI",
                                    "Value": "PARLAKHEMUNDI"
                                },
                                {
                                    "Text": "PARLI",
                                    "Value": "PARLI"
                                },
                                {
                                    "Text": "PARMANAND",
                                    "Value": "PARMANAND"
                                },
                                {
                                    "Text": "PARNER",
                                    "Value": "PARNER"
                                },
                                {
                                    "Text": "PARSHUPURA ",
                                    "Value": "PARSHUPURA "
                                },
                                {
                                    "Text": "PARSOTTAMPUR",
                                    "Value": "PARSOTTAMPUR"
                                },
                                {
                                    "Text": "PARTHALA KHANJARPUR",
                                    "Value": "PARTHALA KHANJARPUR"
                                },
                                {
                                    "Text": "PARVATHIPURAM",
                                    "Value": "PARVATHIPURAM"
                                },
                                {
                                    "Text": "PARWANOO",
                                    "Value": "PARWANOO"
                                },
                                {
                                    "Text": "PASCHIMMIDNAPUR",
                                    "Value": "PASCHIMMIDNAPUR"
                                },
                                {
                                    "Text": "PASIGHAT",
                                    "Value": "PASIGHAT"
                                },
                                {
                                    "Text": "PASCHIMI SINGHBHUM",
                                    "Value": "PASCHIMI SINGHBHUM"
                                },
                                {
                                    "Text": "PATANCHERU",
                                    "Value": "PATANCHERU"
                                },
                                {
                                    "Text": "PATAN",
                                    "Value": "PATAN"
                                },
                                {
                                    "Text": "PATAUDI",
                                    "Value": "PATAUDI"
                                },
                                {
                                    "Text": "PATALGANGA",
                                    "Value": "PATALGANGA"
                                },
                                {
                                    "Text": "PATHANKOT",
                                    "Value": "PATHANKOT"
                                },
                                {
                                    "Text": "PATHANKOT",
                                    "Value": "PATHANKOT"
                                },
                                {
                                    "Text": "PATHANAMTHITTA",
                                    "Value": "PATHANAMTHITTA"
                                },
                                {
                                    "Text": "PATHRUD ",
                                    "Value": "PATHRUD "
                                },
                                {
                                    "Text": "PATHALGAON",
                                    "Value": "PATHALGAON"
                                },
                                {
                                    "Text": "PATHSALA",
                                    "Value": "PATHSALA"
                                },
                                {
                                    "Text": "PATHWAL",
                                    "Value": "PATHWAL"
                                },
                                {
                                    "Text": "PATIALA",
                                    "Value": "PATIALA"
                                },
                                {
                                    "Text": "PATIYALI",
                                    "Value": "PATIYALI"
                                },
                                {
                                    "Text": "PATNA",
                                    "Value": "PATNA"
                                },
                                {
                                    "Text": "PATRAN",
                                    "Value": "PATRAN"
                                },
                                {
                                    "Text": "PATRATU",
                                    "Value": "PATRATU"
                                },
                                {
                                    "Text": "PATTI PRATAPGARH",
                                    "Value": "PATTI PRATAPGARH"
                                },
                                {
                                    "Text": "PATTAMUNDAI",
                                    "Value": "PATTAMUNDAI"
                                },
                                {
                                    "Text": "PATTI",
                                    "Value": "PATTI"
                                },
                                {
                                    "Text": "PATTUKOTTAI",
                                    "Value": "PATTUKOTTAI"
                                },
                                {
                                    "Text": "PATTENAPALEM ",
                                    "Value": "PATTENAPALEM "
                                },
                                {
                                    "Text": "PATTI BASANTPUR ",
                                    "Value": "PATTI BASANTPUR "
                                },
                                {
                                    "Text": "PATTAMBI",
                                    "Value": "PATTAMBI"
                                },
                                {
                                    "Text": "PATTAN",
                                    "Value": "PATTAN"
                                },
                                {
                                    "Text": "PATTI,PRATAPGARH",
                                    "Value": "PATTI,PRATAPGARH"
                                },
                                {
                                    "Text": "PATWDH",
                                    "Value": "PATWDH"
                                },
                                {
                                    "Text": "PAURI GARHWAL",
                                    "Value": "PAURI GARHWAL"
                                },
                                {
                                    "Text": "PAYAL",
                                    "Value": "PAYAL"
                                },
                                {
                                    "Text": "PAYYANUR",
                                    "Value": "PAYYANUR"
                                },
                                {
                                    "Text": "PADAGHA",
                                    "Value": "PADAGHA"
                                },
                                {
                                    "Text": "PEDAMANDDADI ",
                                    "Value": "PEDAMANDDADI "
                                },
                                {
                                    "Text": "PEDDAPURAM",
                                    "Value": "PEDDAPURAM"
                                },
                                {
                                    "Text": "PEDDAPAHAD ",
                                    "Value": "PEDDAPAHAD "
                                },
                                {
                                    "Text": "PEDDAJUTUR ",
                                    "Value": "PEDDAJUTUR "
                                },
                                {
                                    "Text": "PEDDARANGAPURAM ",
                                    "Value": "PEDDARANGAPURAM "
                                },
                                {
                                    "Text": "PULIVENDLA BUS-STAND ",
                                    "Value": "PULIVENDLA BUS-STAND "
                                },
                                {
                                    "Text": "PEDDA BODDEPALLI ",
                                    "Value": "PEDDA BODDEPALLI "
                                },
                                {
                                    "Text": "PEDDAPALLE",
                                    "Value": "PEDDAPALLE"
                                },
                                {
                                    "Text": "PEDDAPUR",
                                    "Value": "PEDDAPUR"
                                },
                                {
                                    "Text": "PEEDAMPALLI",
                                    "Value": "PEEDAMPALLI"
                                },
                                {
                                    "Text": "PEGADAPALLI",
                                    "Value": "PEGADAPALLI"
                                },
                                {
                                    "Text": "PEHOWA",
                                    "Value": "PEHOWA"
                                },
                                {
                                    "Text": "PENDRA",
                                    "Value": "PENDRA"
                                },
                                {
                                    "Text": "PENUGONDA ",
                                    "Value": "PENUGONDA "
                                },
                                {
                                    "Text": "PEN",
                                    "Value": "PEN"
                                },
                                {
                                    "Text": "PERAMBALUR",
                                    "Value": "PERAMBALUR"
                                },
                                {
                                    "Text": "PERAMPETA ",
                                    "Value": "PERAMPETA "
                                },
                                {
                                    "Text": "PEREN",
                                    "Value": "PEREN"
                                },
                                {
                                    "Text": "PERUNGUDI",
                                    "Value": "PERUNGUDI"
                                },
                                {
                                    "Text": "PERINTHALMANNA",
                                    "Value": "PERINTHALMANNA"
                                },
                                {
                                    "Text": "PERINGANAM",
                                    "Value": "PERINGANAM"
                                },
                                {
                                    "Text": "PERIYAKULAM",
                                    "Value": "PERIYAKULAM"
                                },
                                {
                                    "Text": "PERIYANAIKENPALAYAM",
                                    "Value": "PERIYANAIKENPALAYAM"
                                },
                                {
                                    "Text": "PERKIT ",
                                    "Value": "PERKIT "
                                },
                                {
                                    "Text": "PERNEM",
                                    "Value": "PERNEM"
                                },
                                {
                                    "Text": "PERUMBAVOOR",
                                    "Value": "PERUMBAVOOR"
                                },
                                {
                                    "Text": "PERUNDURAI",
                                    "Value": "PERUNDURAI"
                                },
                                {
                                    "Text": "PERUNGALATHUR",
                                    "Value": "PERUNGALATHUR"
                                },
                                {
                                    "Text": "PETH KASBA",
                                    "Value": "PETH KASBA"
                                },
                                {
                                    "Text": "PETLAD",
                                    "Value": "PETLAD"
                                },
                                {
                                    "Text": "PHAGWARA",
                                    "Value": "PHAGWARA"
                                },
                                {
                                    "Text": "PHALTAN",
                                    "Value": "PHALTAN"
                                },
                                {
                                    "Text": "PHALODI",
                                    "Value": "PHALODI"
                                },
                                {
                                    "Text": "PHAPHRANA",
                                    "Value": "PHAPHRANA"
                                },
                                {
                                    "Text": "PHEK",
                                    "Value": "PHEK"
                                },
                                {
                                    "Text": "PHILLAUR",
                                    "Value": "PHILLAUR"
                                },
                                {
                                    "Text": "PEHLAD PUR BANGAR",
                                    "Value": "PEHLAD PUR BANGAR"
                                },
                                {
                                    "Text": "PHULERA",
                                    "Value": "PHULERA"
                                },
                                {
                                    "Text": "PHULPUR",
                                    "Value": "PHULPUR"
                                },
                                {
                                    "Text": "PHULMADDI ",
                                    "Value": "PHULMADDI "
                                },
                                {
                                    "Text": "PHUL",
                                    "Value": "PHUL"
                                },
                                {
                                    "Text": "PHULABANI",
                                    "Value": "PHULABANI"
                                },
                                {
                                    "Text": "PHULLANWALA",
                                    "Value": "PHULLANWALA"
                                },
                                {
                                    "Text": "PHURSO",
                                    "Value": "PHURSO"
                                },
                                {
                                    "Text": "PIDUGURALLA",
                                    "Value": "PIDUGURALLA"
                                },
                                {
                                    "Text": "PILERU",
                                    "Value": "PILERU"
                                },
                                {
                                    "Text": "PILIBANGA",
                                    "Value": "PILIBANGA"
                                },
                                {
                                    "Text": "PILIBHIT",
                                    "Value": "PILIBHIT"
                                },
                                {
                                    "Text": "PILLAYARKUPPAM ",
                                    "Value": "PILLAYARKUPPAM "
                                },
                                {
                                    "Text": "PILU KHERA",
                                    "Value": "PILU KHERA"
                                },
                                {
                                    "Text": "PIMPRI",
                                    "Value": "PIMPRI"
                                },
                                {
                                    "Text": "PINDI BALOCHAN",
                                    "Value": "PINDI BALOCHAN"
                                },
                                {
                                    "Text": "PINJORE",
                                    "Value": "PINJORE"
                                },
                                {
                                    "Text": "PIPARIYA",
                                    "Value": "PIPARIYA"
                                },
                                {
                                    "Text": "PIPLI ",
                                    "Value": "PIPLI "
                                },
                                {
                                    "Text": "PIPLI",
                                    "Value": "PIPLI"
                                },
                                {
                                    "Text": "PIPRI ",
                                    "Value": "PIPRI "
                                },
                                {
                                    "Text": "PIPRA ",
                                    "Value": "PIPRA "
                                },
                                {
                                    "Text": "PIPRAICH",
                                    "Value": "PIPRAICH"
                                },
                                {
                                    "Text": "PIRAVOM",
                                    "Value": "PIRAVOM"
                                },
                                {
                                    "Text": "PITHAMPUR",
                                    "Value": "PITHAMPUR"
                                },
                                {
                                    "Text": "PITHORAGARH",
                                    "Value": "PITHORAGARH"
                                },
                                {
                                    "Text": "PITHAPURAM",
                                    "Value": "PITHAPURAM"
                                },
                                {
                                    "Text": "PITHLA",
                                    "Value": "PITHLA"
                                },
                                {
                                    "Text": "POKHRAN",
                                    "Value": "POKHRAN"
                                },
                                {
                                    "Text": "PALGHAR",
                                    "Value": "PALGHAR"
                                },
                                {
                                    "Text": "PALANI",
                                    "Value": "PALANI"
                                },
                                {
                                    "Text": "PILKHUWA",
                                    "Value": "PILKHUWA"
                                },
                                {
                                    "Text": "PUL PEHLAD",
                                    "Value": "PUL PEHLAD"
                                },
                                {
                                    "Text": "PURMANDAL",
                                    "Value": "PURMANDAL"
                                },
                                {
                                    "Text": "PILANI",
                                    "Value": "PILANI"
                                },
                                {
                                    "Text": "PANAJI",
                                    "Value": "PANAJI"
                                },
                                {
                                    "Text": "PANSKURA",
                                    "Value": "PANSKURA"
                                },
                                {
                                    "Text": "POATA",
                                    "Value": "POATA"
                                },
                                {
                                    "Text": "PODILI",
                                    "Value": "PODILI"
                                },
                                {
                                    "Text": "POGATHOTA",
                                    "Value": "POGATHOTA"
                                },
                                {
                                    "Text": "POJEWAL",
                                    "Value": "POJEWAL"
                                },
                                {
                                    "Text": "POKHARIA ",
                                    "Value": "POKHARIA "
                                },
                                {
                                    "Text": "POLA ",
                                    "Value": "POLA "
                                },
                                {
                                    "Text": "POLICE LINES TARN TARAN SO",
                                    "Value": "POLICE LINES TARN TARAN SO"
                                },
                                {
                                    "Text": "POLLACHI",
                                    "Value": "POLLACHI"
                                },
                                {
                                    "Text": "POMBHURNA ",
                                    "Value": "POMBHURNA "
                                },
                                {
                                    "Text": "PONATA SAHIB",
                                    "Value": "PONATA SAHIB"
                                },
                                {
                                    "Text": "PONATA SAHIB",
                                    "Value": "PONATA SAHIB"
                                },
                                {
                                    "Text": "PONDA",
                                    "Value": "PONDA"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PONDI-UPRODA ",
                                    "Value": "PONDI-UPRODA "
                                },
                                {
                                    "Text": "PONNANI",
                                    "Value": "PONNANI"
                                },
                                {
                                    "Text": "PONNAM ",
                                    "Value": "PONNAM "
                                },
                                {
                                    "Text": "PONNUR",
                                    "Value": "PONNUR"
                                },
                                {
                                    "Text": "POONCH",
                                    "Value": "POONCH"
                                },
                                {
                                    "Text": "POONDI",
                                    "Value": "POONDI"
                                },
                                {
                                    "Text": "POONGAMOODU",
                                    "Value": "POONGAMOODU"
                                },
                                {
                                    "Text": "PORANKI",
                                    "Value": "PORANKI"
                                },
                                {
                                    "Text": "PORBANDER",
                                    "Value": "PORBANDER"
                                },
                                {
                                    "Text": "PORBANDAR",
                                    "Value": "PORBANDAR"
                                },
                                {
                                    "Text": "PORT BLAIR",
                                    "Value": "PORT BLAIR"
                                },
                                {
                                    "Text": "PORVORIM",
                                    "Value": "PORVORIM"
                                },
                                {
                                    "Text": "POR",
                                    "Value": "POR"
                                },
                                {
                                    "Text": "POST LONI",
                                    "Value": "POST LONI"
                                },
                                {
                                    "Text": "POST SURAJPUR",
                                    "Value": "POST SURAJPUR"
                                },
                                {
                                    "Text": "POTTAPALAYAM ",
                                    "Value": "POTTAPALAYAM "
                                },
                                {
                                    "Text": "POWAI",
                                    "Value": "POWAI"
                                },
                                {
                                    "Text": "POWAYAN",
                                    "Value": "POWAYAN"
                                },
                                {
                                    "Text": "PRAKASAM",
                                    "Value": "PRAKASAM"
                                },
                                {
                                    "Text": "PRANTIJ",
                                    "Value": "PRANTIJ"
                                },
                                {
                                    "Text": "PRASADRAOPETA",
                                    "Value": "PRASADRAOPETA"
                                },
                                {
                                    "Text": "PRATAPGARH",
                                    "Value": "PRATAPGARH"
                                },
                                {
                                    "Text": "PRATAPGARH",
                                    "Value": "PRATAPGARH"
                                },
                                {
                                    "Text": "PIPRALI ROAD",
                                    "Value": "PIPRALI ROAD"
                                },
                                {
                                    "Text": "PRODDATUR",
                                    "Value": "PRODDATUR"
                                },
                                {
                                    "Text": "PRODDATTUR",
                                    "Value": "PRODDATTUR"
                                },
                                {
                                    "Text": "PARASIA",
                                    "Value": "PARASIA"
                                },
                                {
                                    "Text": "PARATWADA",
                                    "Value": "PARATWADA"
                                },
                                {
                                    "Text": "PASTHAL",
                                    "Value": "PASTHAL"
                                },
                                {
                                    "Text": "POOTH KHURD",
                                    "Value": "POOTH KHURD"
                                },
                                {
                                    "Text": "POOTH KALAN",
                                    "Value": "POOTH KALAN"
                                },
                                {
                                    "Text": "PATALA",
                                    "Value": "PATALA"
                                },
                                {
                                    "Text": "PTU CAMPUS KAPURTHALA ",
                                    "Value": "PTU CAMPUS KAPURTHALA "
                                },
                                {
                                    "Text": "PUDHUPAKKAM",
                                    "Value": "PUDHUPAKKAM"
                                },
                                {
                                    "Text": "PUDUKOTTAI",
                                    "Value": "PUDUKOTTAI"
                                },
                                {
                                    "Text": "PUDUKKOTTAI",
                                    "Value": "PUDUKKOTTAI"
                                },
                                {
                                    "Text": "PUDUR ",
                                    "Value": "PUDUR "
                                },
                                {
                                    "Text": "PUDUCHERRY",
                                    "Value": "PUDUCHERRY"
                                },
                                {
                                    "Text": "PUKHRAYAN",
                                    "Value": "PUKHRAYAN"
                                },
                                {
                                    "Text": "PULAPALLI ",
                                    "Value": "PULAPALLI "
                                },
                                {
                                    "Text": "PULIVENDLAKUTCHERRY ",
                                    "Value": "PULIVENDLAKUTCHERRY "
                                },
                                {
                                    "Text": "PULIVENDULA",
                                    "Value": "PULIVENDULA"
                                },
                                {
                                    "Text": "PULUSMAMIDI ",
                                    "Value": "PULUSMAMIDI "
                                },
                                {
                                    "Text": "PULWAMA",
                                    "Value": "PULWAMA"
                                },
                                {
                                    "Text": "PUNALUR",
                                    "Value": "PUNALUR"
                                },
                                {
                                    "Text": "PUNDRI",
                                    "Value": "PUNDRI"
                                },
                                {
                                    "Text": "PUNE",
                                    "Value": "PUNE"
                                },
                                {
                                    "Text": "PUNGANUR",
                                    "Value": "PUNGANUR"
                                },
                                {
                                    "Text": "PUNJABARI",
                                    "Value": "PUNJABARI"
                                },
                                {
                                    "Text": "PURANA MOGA ",
                                    "Value": "PURANA MOGA "
                                },
                                {
                                    "Text": "PURAINA ",
                                    "Value": "PURAINA "
                                },
                                {
                                    "Text": "PURANPUR",
                                    "Value": "PURANPUR"
                                },
                                {
                                    "Text": "PURBA MEDINIPUR",
                                    "Value": "PURBA MEDINIPUR"
                                },
                                {
                                    "Text": "PURI",
                                    "Value": "PURI"
                                },
                                {
                                    "Text": "PURNEA",
                                    "Value": "PURNEA"
                                },
                                {
                                    "Text": "PURNIA",
                                    "Value": "PURNIA"
                                },
                                {
                                    "Text": "PURQUAZI",
                                    "Value": "PURQUAZI"
                                },
                                {
                                    "Text": "PURULIA",
                                    "Value": "PURULIA"
                                },
                                {
                                    "Text": "PURULIYA",
                                    "Value": "PURULIYA"
                                },
                                {
                                    "Text": "PURVI CHAMPARAN",
                                    "Value": "PURVI CHAMPARAN"
                                },
                                {
                                    "Text": "PURWA",
                                    "Value": "PURWA"
                                },
                                {
                                    "Text": "PUSAD",
                                    "Value": "PUSAD"
                                },
                                {
                                    "Text": "PUSHPARAJGARH",
                                    "Value": "PUSHPARAJGARH"
                                },
                                {
                                    "Text": "PUTHENCHIRA",
                                    "Value": "PUTHENCHIRA"
                                },
                                {
                                    "Text": "PUTTAPARTHY",
                                    "Value": "PUTTAPARTHY"
                                },
                                {
                                    "Text": "PUTTUR",
                                    "Value": "PUTTUR"
                                },
                                {
                                    "Text": "PUTTAPARTHI",
                                    "Value": "PUTTAPARTHI"
                                },
                                {
                                    "Text": "PUTTUR",
                                    "Value": "PUTTUR"
                                },
                                {
                                    "Text": "PYARARAM ",
                                    "Value": "PYARARAM "
                                },
                                {
                                    "Text": "PYNURSLA",
                                    "Value": "PYNURSLA"
                                },
                                {
                                    "Text": "QADIAN",
                                    "Value": "QADIAN"
                                },
                                {
                                    "Text": "QILLA KAVI SANTOKH ",
                                    "Value": "QILLA KAVI SANTOKH "
                                },
                                {
                                    "Text": "QUAMMRUDDIN NAGAR",
                                    "Value": "QUAMMRUDDIN NAGAR"
                                },
                                {
                                    "Text": "QUEPEM",
                                    "Value": "QUEPEM"
                                },
                                {
                                    "Text": "QUILANDI",
                                    "Value": "QUILANDI"
                                },
                                {
                                    "Text": "QUILA NAU ",
                                    "Value": "QUILA NAU "
                                },
                                {
                                    "Text": "QAZIGUND",
                                    "Value": "QAZIGUND"
                                },
                                {
                                    "Text": "RADAUR",
                                    "Value": "RADAUR"
                                },
                                {
                                    "Text": "RADHANPUR",
                                    "Value": "RADHANPUR"
                                },
                                {
                                    "Text": "RAE BARELI",
                                    "Value": "RAE BARELI"
                                },
                                {
                                    "Text": "RAEBARELI",
                                    "Value": "RAEBARELI"
                                },
                                {
                                    "Text": "RAEKOT",
                                    "Value": "RAEKOT"
                                },
                                {
                                    "Text": "RAGADAPA ",
                                    "Value": "RAGADAPA "
                                },
                                {
                                    "Text": "RAGHUDEVAPURAM",
                                    "Value": "RAGHUDEVAPURAM"
                                },
                                {
                                    "Text": "RAGHAVAPET",
                                    "Value": "RAGHAVAPET"
                                },
                                {
                                    "Text": "RAHATA",
                                    "Value": "RAHATA"
                                },
                                {
                                    "Text": "RAHIAD",
                                    "Value": "RAHIAD"
                                },
                                {
                                    "Text": "RAHON",
                                    "Value": "RAHON"
                                },
                                {
                                    "Text": "RAHURI",
                                    "Value": "RAHURI"
                                },
                                {
                                    "Text": "RAICHUR",
                                    "Value": "RAICHUR"
                                },
                                {
                                    "Text": "RAIGARH(MH)",
                                    "Value": "RAIGARH(MH)"
                                },
                                {
                                    "Text": "RAIGAD",
                                    "Value": "RAIGAD"
                                },
                                {
                                    "Text": "RAIGARH",
                                    "Value": "RAIGARH"
                                },
                                {
                                    "Text": "RAIGANJ",
                                    "Value": "RAIGANJ"
                                },
                                {
                                    "Text": "RAIKOT",
                                    "Value": "RAIKOT"
                                },
                                {
                                    "Text": "RAILMAJRA",
                                    "Value": "RAILMAJRA"
                                },
                                {
                                    "Text": "RAIPUR",
                                    "Value": "RAIPUR"
                                },
                                {
                                    "Text": "RAIPUR RANI",
                                    "Value": "RAIPUR RANI"
                                },
                                {
                                    "Text": "RAIR KALAN",
                                    "Value": "RAIR KALAN"
                                },
                                {
                                    "Text": "RAIRANGPUR",
                                    "Value": "RAIRANGPUR"
                                },
                                {
                                    "Text": "RAISINGHNAGAR",
                                    "Value": "RAISINGHNAGAR"
                                },
                                {
                                    "Text": "RAISEN",
                                    "Value": "RAISEN"
                                },
                                {
                                    "Text": "RAISAR",
                                    "Value": "RAISAR"
                                },
                                {
                                    "Text": "RAJAURI",
                                    "Value": "RAJAURI"
                                },
                                {
                                    "Text": "RAJAHMUNDRY",
                                    "Value": "RAJAHMUNDRY"
                                },
                                {
                                    "Text": "RAJAM",
                                    "Value": "RAJAM"
                                },
                                {
                                    "Text": "RAJAPALAYAM",
                                    "Value": "RAJAPALAYAM"
                                },
                                {
                                    "Text": "RAJA SANSI",
                                    "Value": "RAJA SANSI"
                                },
                                {
                                    "Text": "RAJAGANGAPUR",
                                    "Value": "RAJAGANGAPUR"
                                },
                                {
                                    "Text": "RAJAMPET",
                                    "Value": "RAJAMPET"
                                },
                                {
                                    "Text": "RAJARHAT GOPALPUR",
                                    "Value": "RAJARHAT GOPALPUR"
                                },
                                {
                                    "Text": "RAJASMAND",
                                    "Value": "RAJASMAND"
                                },
                                {
                                    "Text": "RAJAUND",
                                    "Value": "RAJAUND"
                                },
                                {
                                    "Text": "RAJBALLABHPUR",
                                    "Value": "RAJBALLABHPUR"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGIR",
                                    "Value": "RAJGIR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJIM",
                                    "Value": "RAJIM"
                                },
                                {
                                    "Text": "RAJIA",
                                    "Value": "RAJIA"
                                },
                                {
                                    "Text": "RAJKOT",
                                    "Value": "RAJKOT"
                                },
                                {
                                    "Text": "RAJNANDGAON",
                                    "Value": "RAJNANDGAON"
                                },
                                {
                                    "Text": "RAJNADGAON",
                                    "Value": "RAJNADGAON"
                                },
                                {
                                    "Text": "RAJOKRI",
                                    "Value": "RAJOKRI"
                                },
                                {
                                    "Text": "RAJOLE ",
                                    "Value": "RAJOLE "
                                },
                                {
                                    "Text": "RAJOWALA ",
                                    "Value": "RAJOWALA "
                                },
                                {
                                    "Text": "RAJOSANA",
                                    "Value": "RAJOSANA"
                                },
                                {
                                    "Text": "RAJOURI",
                                    "Value": "RAJOURI"
                                },
                                {
                                    "Text": "RAJPIPLA",
                                    "Value": "RAJPIPLA"
                                },
                                {
                                    "Text": "RAJPURA",
                                    "Value": "RAJPURA"
                                },
                                {
                                    "Text": "RAJPURA TOWNSHIP ",
                                    "Value": "RAJPURA TOWNSHIP "
                                },
                                {
                                    "Text": "RAJPUR BHAIAN",
                                    "Value": "RAJPUR BHAIAN"
                                },
                                {
                                    "Text": "RAJSAMAND",
                                    "Value": "RAJSAMAND"
                                },
                                {
                                    "Text": "RAJULA",
                                    "Value": "RAJULA"
                                },
                                {
                                    "Text": "RAJUPAKALU ",
                                    "Value": "RAJUPAKALU "
                                },
                                {
                                    "Text": "RAJUR",
                                    "Value": "RAJUR"
                                },
                                {
                                    "Text": "RAJURA",
                                    "Value": "RAJURA"
                                },
                                {
                                    "Text": "RAKANPUR",
                                    "Value": "RAKANPUR"
                                },
                                {
                                    "Text": "RAMAN",
                                    "Value": "RAMAN"
                                },
                                {
                                    "Text": "RAMANAGAR",
                                    "Value": "RAMANAGAR"
                                },
                                {
                                    "Text": "RAMANATHAPURAM",
                                    "Value": "RAMANATHAPURAM"
                                },
                                {
                                    "Text": "RAMANATHGUDPALLY ",
                                    "Value": "RAMANATHGUDPALLY "
                                },
                                {
                                    "Text": "RAMACHANDRAPURAM OLD TOWN ",
                                    "Value": "RAMACHANDRAPURAM OLD TOWN "
                                },
                                {
                                    "Text": "RAMACHANDRAPURAM",
                                    "Value": "RAMACHANDRAPURAM"
                                },
                                {
                                    "Text": "RAMAGUNDAM",
                                    "Value": "RAMAGUNDAM"
                                },
                                {
                                    "Text": "RAMANAGARAM",
                                    "Value": "RAMANAGARAM"
                                },
                                {
                                    "Text": "RAMANUJGANJ",
                                    "Value": "RAMANUJGANJ"
                                },
                                {
                                    "Text": "RAMAPURAM",
                                    "Value": "RAMAPURAM"
                                },
                                {
                                    "Text": "RAMDAS",
                                    "Value": "RAMDAS"
                                },
                                {
                                    "Text": "RAMDAS (M CL)",
                                    "Value": "RAMDAS (M CL)"
                                },
                                {
                                    "Text": "RAMESWARPUR",
                                    "Value": "RAMESWARPUR"
                                },
                                {
                                    "Text": "RAMGARH CANTT",
                                    "Value": "RAMGARH CANTT"
                                },
                                {
                                    "Text": "RAMGARH",
                                    "Value": "RAMGARH"
                                },
                                {
                                    "Text": "RAMGARH",
                                    "Value": "RAMGARH"
                                },
                                {
                                    "Text": "RAMGARH CANTT.",
                                    "Value": "RAMGARH CANTT."
                                },
                                {
                                    "Text": "RAMGANJ MANDI",
                                    "Value": "RAMGANJ MANDI"
                                },
                                {
                                    "Text": "RAMNAGAR ",
                                    "Value": "RAMNAGAR "
                                },
                                {
                                    "Text": "RAMNAGAR",
                                    "Value": "RAMNAGAR"
                                },
                                {
                                    "Text": "RAMPURA PHUL",
                                    "Value": "RAMPURA PHUL"
                                },
                                {
                                    "Text": "RAMPUR",
                                    "Value": "RAMPUR"
                                },
                                {
                                    "Text": "RAMPUR",
                                    "Value": "RAMPUR"
                                },
                                {
                                    "Text": "RAMPUR JAGIR",
                                    "Value": "RAMPUR JAGIR"
                                },
                                {
                                    "Text": "RAMPURA",
                                    "Value": "RAMPURA"
                                },
                                {
                                    "Text": "RAMPURHAT",
                                    "Value": "RAMPURHAT"
                                },
                                {
                                    "Text": "RAMTEK",
                                    "Value": "RAMTEK"
                                },
                                {
                                    "Text": "RANAGHAT",
                                    "Value": "RANAGHAT"
                                },
                                {
                                    "Text": "RANBIR SINGH PORA",
                                    "Value": "RANBIR SINGH PORA"
                                },
                                {
                                    "Text": "RANCHI",
                                    "Value": "RANCHI"
                                },
                                {
                                    "Text": "RANEBENNUR",
                                    "Value": "RANEBENNUR"
                                },
                                {
                                    "Text": "RANGAREDDI",
                                    "Value": "RANGAREDDI"
                                },
                                {
                                    "Text": "RANGAREDDY",
                                    "Value": "RANGAREDDY"
                                },
                                {
                                    "Text": "RANGIA",
                                    "Value": "RANGIA"
                                },
                                {
                                    "Text": "RANGIAN",
                                    "Value": "RANGIAN"
                                },
                                {
                                    "Text": "RANGIBASAN",
                                    "Value": "RANGIBASAN"
                                },
                                {
                                    "Text": "RANGPO",
                                    "Value": "RANGPO"
                                },
                                {
                                    "Text": "RANIA",
                                    "Value": "RANIA"
                                },
                                {
                                    "Text": "RANIPET",
                                    "Value": "RANIPET"
                                },
                                {
                                    "Text": "RANIBENNUR",
                                    "Value": "RANIBENNUR"
                                },
                                {
                                    "Text": "RANIGANJ",
                                    "Value": "RANIGANJ"
                                },
                                {
                                    "Text": "RANIPETTAI",
                                    "Value": "RANIPETTAI"
                                },
                                {
                                    "Text": "RANIPOOL",
                                    "Value": "RANIPOOL"
                                },
                                {
                                    "Text": "RANIPUR",
                                    "Value": "RANIPUR"
                                },
                                {
                                    "Text": "RANJANGAON",
                                    "Value": "RANJANGAON"
                                },
                                {
                                    "Text": "RANNY",
                                    "Value": "RANNY"
                                },
                                {
                                    "Text": "RANNI",
                                    "Value": "RANNI"
                                },
                                {
                                    "Text": "RAPALLE",
                                    "Value": "RAPALLE"
                                },
                                {
                                    "Text": "RASIPURAM",
                                    "Value": "RASIPURAM"
                                },
                                {
                                    "Text": "RASUPUR BANKIYA ",
                                    "Value": "RASUPUR BANKIYA "
                                },
                                {
                                    "Text": "RASULPUR",
                                    "Value": "RASULPUR"
                                },
                                {
                                    "Text": "RATHONDA ",
                                    "Value": "RATHONDA "
                                },
                                {
                                    "Text": "RATH",
                                    "Value": "RATH"
                                },
                                {
                                    "Text": "RATIA",
                                    "Value": "RATIA"
                                },
                                {
                                    "Text": "RATLAM",
                                    "Value": "RATLAM"
                                },
                                {
                                    "Text": "RATNAGIRI",
                                    "Value": "RATNAGIRI"
                                },
                                {
                                    "Text": "RATNARI",
                                    "Value": "RATNARI"
                                },
                                {
                                    "Text": "RATTEWAL",
                                    "Value": "RATTEWAL"
                                },
                                {
                                    "Text": "RAU",
                                    "Value": "RAU"
                                },
                                {
                                    "Text": "RAULI ",
                                    "Value": "RAULI "
                                },
                                {
                                    "Text": "RAVER",
                                    "Value": "RAVER"
                                },
                                {
                                    "Text": "RAVULAPALEM",
                                    "Value": "RAVULAPALEM"
                                },
                                {
                                    "Text": "RAWAT BHATA",
                                    "Value": "RAWAT BHATA"
                                },
                                {
                                    "Text": "RAWATSAR",
                                    "Value": "RAWATSAR"
                                },
                                {
                                    "Text": "RAXAUL BAZAR",
                                    "Value": "RAXAUL BAZAR"
                                },
                                {
                                    "Text": "RAYAGADA",
                                    "Value": "RAYAGADA"
                                },
                                {
                                    "Text": "RAYA",
                                    "Value": "RAYA"
                                },
                                {
                                    "Text": "RAYACHOTI",
                                    "Value": "RAYACHOTI"
                                },
                                {
                                    "Text": "RAYADURG",
                                    "Value": "RAYADURG"
                                },
                                {
                                    "Text": "RAYINI PALEM ",
                                    "Value": "RAYINI PALEM "
                                },
                                {
                                    "Text": "RAYYA",
                                    "Value": "RAYYA"
                                },
                                {
                                    "Text": "REASI",
                                    "Value": "REASI"
                                },
                                {
                                    "Text": "REDDIAL ",
                                    "Value": "REDDIAL "
                                },
                                {
                                    "Text": "REDDICHAVADI ",
                                    "Value": "REDDICHAVADI "
                                },
                                {
                                    "Text": "REDDIPALLE",
                                    "Value": "REDDIPALLE"
                                },
                                {
                                    "Text": "RED HILLS",
                                    "Value": "RED HILLS"
                                },
                                {
                                    "Text": "REHANA JATTAN",
                                    "Value": "REHANA JATTAN"
                                },
                                {
                                    "Text": "REKANG PEO",
                                    "Value": "REKANG PEO"
                                },
                                {
                                    "Text": "RENGALI",
                                    "Value": "RENGALI"
                                },
                                {
                                    "Text": "RENUKOOT",
                                    "Value": "RENUKOOT"
                                },
                                {
                                    "Text": "REPALLE",
                                    "Value": "REPALLE"
                                },
                                {
                                    "Text": "REWA",
                                    "Value": "REWA"
                                },
                                {
                                    "Text": "REWARI",
                                    "Value": "REWARI"
                                },
                                {
                                    "Text": "RAFIGANJ",
                                    "Value": "RAFIGANJ"
                                },
                                {
                                    "Text": "RI BHOI",
                                    "Value": "RI BHOI"
                                },
                                {
                                    "Text": "RISHIKESH",
                                    "Value": "RISHIKESH"
                                },
                                {
                                    "Text": "RISHRA",
                                    "Value": "RISHRA"
                                },
                                {
                                    "Text": "RAMPUR (MOTIHARI)",
                                    "Value": "RAMPUR (MOTIHARI)"
                                },
                                {
                                    "Text": "RANIKHET",
                                    "Value": "RANIKHET"
                                },
                                {
                                    "Text": "ROBERTSGANJ",
                                    "Value": "ROBERTSGANJ"
                                },
                                {
                                    "Text": "RODHA",
                                    "Value": "RODHA"
                                },
                                {
                                    "Text": "ROHA ASHTAMI",
                                    "Value": "ROHA ASHTAMI"
                                },
                                {
                                    "Text": "ROHERIANWALI",
                                    "Value": "ROHERIANWALI"
                                },
                                {
                                    "Text": "ROHRU",
                                    "Value": "ROHRU"
                                },
                                {
                                    "Text": "ROHTAK",
                                    "Value": "ROHTAK"
                                },
                                {
                                    "Text": "ROHTAS",
                                    "Value": "ROHTAS"
                                },
                                {
                                    "Text": "ROING",
                                    "Value": "ROING"
                                },
                                {
                                    "Text": "ROORKEE",
                                    "Value": "ROORKEE"
                                },
                                {
                                    "Text": "ROORKEE",
                                    "Value": "ROORKEE"
                                },
                                {
                                    "Text": "ROPAR",
                                    "Value": "ROPAR"
                                },
                                {
                                    "Text": "RORANWALA",
                                    "Value": "RORANWALA"
                                },
                                {
                                    "Text": "ROURKELA",
                                    "Value": "ROURKELA"
                                },
                                {
                                    "Text": "RUPNARAYANPUR",
                                    "Value": "RUPNARAYANPUR"
                                },
                                {
                                    "Text": "RSARA",
                                    "Value": "RSARA"
                                },
                                {
                                    "Text": "ROSHAN PURA",
                                    "Value": "ROSHAN PURA"
                                },
                                {
                                    "Text": "RATANGARH",
                                    "Value": "RATANGARH"
                                },
                                {
                                    "Text": "R THUMMALAPALLE ",
                                    "Value": "R THUMMALAPALLE "
                                },
                                {
                                    "Text": "RUDAULI",
                                    "Value": "RUDAULI"
                                },
                                {
                                    "Text": "RUDEL",
                                    "Value": "RUDEL"
                                },
                                {
                                    "Text": "RUDRAPUR",
                                    "Value": "RUDRAPUR"
                                },
                                {
                                    "Text": "RUDRAPRAYAG",
                                    "Value": "RUDRAPRAYAG"
                                },
                                {
                                    "Text": "RUDRARAM ",
                                    "Value": "RUDRARAM "
                                },
                                {
                                    "Text": "RUPANA",
                                    "Value": "RUPANA"
                                },
                                {
                                    "Text": "RUPNAGAR",
                                    "Value": "RUPNAGAR"
                                },
                                {
                                    "Text": "RUSTAPUR ",
                                    "Value": "RUSTAPUR "
                                },
                                {
                                    "Text": "SABARKANTHA",
                                    "Value": "SABARKANTHA"
                                },
                                {
                                    "Text": "SABHRA",
                                    "Value": "SABHRA"
                                },
                                {
                                    "Text": "SABOUR",
                                    "Value": "SABOUR"
                                },
                                {
                                    "Text": "SADABAD",
                                    "Value": "SADABAD"
                                },
                                {
                                    "Text": "SADHAURA",
                                    "Value": "SADHAURA"
                                },
                                {
                                    "Text": "SADI",
                                    "Value": "SADI"
                                },
                                {
                                    "Text": "SADIQ",
                                    "Value": "SADIQ"
                                },
                                {
                                    "Text": "SADULSAHAR",
                                    "Value": "SADULSAHAR"
                                },
                                {
                                    "Text": "SAFIDON",
                                    "Value": "SAFIDON"
                                },
                                {
                                    "Text": "SAGAR",
                                    "Value": "SAGAR"
                                },
                                {
                                    "Text": "SAGAR",
                                    "Value": "SAGAR"
                                },
                                {
                                    "Text": "SAGWARA",
                                    "Value": "SAGWARA"
                                },
                                {
                                    "Text": "SAHARANPUR",
                                    "Value": "SAHARANPUR"
                                },
                                {
                                    "Text": "SAHARSA",
                                    "Value": "SAHARSA"
                                },
                                {
                                    "Text": "SAHA",
                                    "Value": "SAHA"
                                },
                                {
                                    "Text": "SAHABUDDINPUR",
                                    "Value": "SAHABUDDINPUR"
                                },
                                {
                                    "Text": "SAHAURAN",
                                    "Value": "SAHAURAN"
                                },
                                {
                                    "Text": "SAHIBZADA AJIT SINGH NAGAR",
                                    "Value": "SAHIBZADA AJIT SINGH NAGAR"
                                },
                                {
                                    "Text": "SAHIBGANJ",
                                    "Value": "SAHIBGANJ"
                                },
                                {
                                    "Text": "SAHIBABAD",
                                    "Value": "SAHIBABAD"
                                },
                                {
                                    "Text": "SAHIBZADA AJIT SINGH NAGAR",
                                    "Value": "SAHIBZADA AJIT SINGH NAGAR"
                                },
                                {
                                    "Text": "SAHJANWA",
                                    "Value": "SAHJANWA"
                                },
                                {
                                    "Text": "SAHNEWAL",
                                    "Value": "SAHNEWAL"
                                },
                                {
                                    "Text": "SAIDUL AJAIB",
                                    "Value": "SAIDUL AJAIB"
                                },
                                {
                                    "Text": "SAIHA",
                                    "Value": "SAIHA"
                                },
                                {
                                    "Text": "SAILA KHURD",
                                    "Value": "SAILA KHURD"
                                },
                                {
                                    "Text": "SAILU",
                                    "Value": "SAILU"
                                },
                                {
                                    "Text": "SAINTHIA",
                                    "Value": "SAINTHIA"
                                },
                                {
                                    "Text": "SAINI MAJRA",
                                    "Value": "SAINI MAJRA"
                                },
                                {
                                    "Text": "SAINJ",
                                    "Value": "SAINJ"
                                },
                                {
                                    "Text": "SAKAT SANALA",
                                    "Value": "SAKAT SANALA"
                                },
                                {
                                    "Text": "SALAIRANI",
                                    "Value": "SALAIRANI"
                                },
                                {
                                    "Text": "SALBARI ",
                                    "Value": "SALBARI "
                                },
                                {
                                    "Text": "SALCETTE",
                                    "Value": "SALCETTE"
                                },
                                {
                                    "Text": "SALEM",
                                    "Value": "SALEM"
                                },
                                {
                                    "Text": "SALEMPUR",
                                    "Value": "SALEMPUR"
                                },
                                {
                                    "Text": "SALEPUR",
                                    "Value": "SALEPUR"
                                },
                                {
                                    "Text": "SALIGAO",
                                    "Value": "SALIGAO"
                                },
                                {
                                    "Text": "SALKA ",
                                    "Value": "SALKA "
                                },
                                {
                                    "Text": "SALON",
                                    "Value": "SALON"
                                },
                                {
                                    "Text": "SALUR",
                                    "Value": "SALUR"
                                },
                                {
                                    "Text": "SALUNI",
                                    "Value": "SALUNI"
                                },
                                {
                                    "Text": "SAMANA",
                                    "Value": "SAMANA"
                                },
                                {
                                    "Text": "SAMALKHA",
                                    "Value": "SAMALKHA"
                                },
                                {
                                    "Text": "SAMASTIPUR",
                                    "Value": "SAMASTIPUR"
                                },
                                {
                                    "Text": "SAMADPUR HARDAS ",
                                    "Value": "SAMADPUR HARDAS "
                                },
                                {
                                    "Text": "SAMADA",
                                    "Value": "SAMADA"
                                },
                                {
                                    "Text": "SAMAIPUR",
                                    "Value": "SAMAIPUR"
                                },
                                {
                                    "Text": "SAMBALPUR",
                                    "Value": "SAMBALPUR"
                                },
                                {
                                    "Text": "SAMBA",
                                    "Value": "SAMBA"
                                },
                                {
                                    "Text": "SAMBA",
                                    "Value": "SAMBA"
                                },
                                {
                                    "Text": "SAMBHAL",
                                    "Value": "SAMBHAL"
                                },
                                {
                                    "Text": "SAMBHAR",
                                    "Value": "SAMBHAR"
                                },
                                {
                                    "Text": "SAMGAULI",
                                    "Value": "SAMGAULI"
                                },
                                {
                                    "Text": "SAMLOD",
                                    "Value": "SAMLOD"
                                },
                                {
                                    "Text": "SAMOU",
                                    "Value": "SAMOU"
                                },
                                {
                                    "Text": "SAMPLA",
                                    "Value": "SAMPLA"
                                },
                                {
                                    "Text": "SAMPURA",
                                    "Value": "SAMPURA"
                                },
                                {
                                    "Text": "SAMPURNA NAGAR",
                                    "Value": "SAMPURNA NAGAR"
                                },
                                {
                                    "Text": "SAMRALA",
                                    "Value": "SAMRALA"
                                },
                                {
                                    "Text": "SANAND",
                                    "Value": "SANAND"
                                },
                                {
                                    "Text": "SANATHAL",
                                    "Value": "SANATHAL"
                                },
                                {
                                    "Text": "SANAUR",
                                    "Value": "SANAUR"
                                },
                                {
                                    "Text": "SANAWAD",
                                    "Value": "SANAWAD"
                                },
                                {
                                    "Text": "SANCHORE",
                                    "Value": "SANCHORE"
                                },
                                {
                                    "Text": "SANDUR",
                                    "Value": "SANDUR"
                                },
                                {
                                    "Text": "SANDHAI",
                                    "Value": "SANDHAI"
                                },
                                {
                                    "Text": "SANDHAUR",
                                    "Value": "SANDHAUR"
                                },
                                {
                                    "Text": "SANDILA",
                                    "Value": "SANDILA"
                                },
                                {
                                    "Text": "SANEHWAL",
                                    "Value": "SANEHWAL"
                                },
                                {
                                    "Text": "SANETA",
                                    "Value": "SANETA"
                                },
                                {
                                    "Text": "SANGAMNER",
                                    "Value": "SANGAMNER"
                                },
                                {
                                    "Text": "SANGLI",
                                    "Value": "SANGLI"
                                },
                                {
                                    "Text": "SANGARIA",
                                    "Value": "SANGARIA"
                                },
                                {
                                    "Text": "SANGRUR",
                                    "Value": "SANGRUR"
                                },
                                {
                                    "Text": "SANGANER",
                                    "Value": "SANGANER"
                                },
                                {
                                    "Text": "SANGANA ",
                                    "Value": "SANGANA "
                                },
                                {
                                    "Text": "SANGAT",
                                    "Value": "SANGAT"
                                },
                                {
                                    "Text": "SANGLI-MIRAJ-KUPWAD",
                                    "Value": "SANGLI-MIRAJ-KUPWAD"
                                },
                                {
                                    "Text": "SANGUEM",
                                    "Value": "SANGUEM"
                                },
                                {
                                    "Text": "SANIVARAM ",
                                    "Value": "SANIVARAM "
                                },
                                {
                                    "Text": "SANJAY NAGAR ",
                                    "Value": "SANJAY NAGAR "
                                },
                                {
                                    "Text": "SANJALI",
                                    "Value": "SANJALI"
                                },
                                {
                                    "Text": "SANJAN",
                                    "Value": "SANJAN"
                                },
                                {
                                    "Text": "SANJAULI",
                                    "Value": "SANJAULI"
                                },
                                {
                                    "Text": "SANKAGIRI",
                                    "Value": "SANKAGIRI"
                                },
                                {
                                    "Text": "SANKESHWAR",
                                    "Value": "SANKESHWAR"
                                },
                                {
                                    "Text": "SANOTH",
                                    "Value": "SANOTH"
                                },
                                {
                                    "Text": "SANPERA",
                                    "Value": "SANPERA"
                                },
                                {
                                    "Text": "SANQUELIM",
                                    "Value": "SANQUELIM"
                                },
                                {
                                    "Text": "SANT KABIR NAGAR",
                                    "Value": "SANT KABIR NAGAR"
                                },
                                {
                                    "Text": "SANT RAVIDAS NAGAR",
                                    "Value": "SANT RAVIDAS NAGAR"
                                },
                                {
                                    "Text": "SANTA CRUZ",
                                    "Value": "SANTA CRUZ"
                                },
                                {
                                    "Text": "SANTA CRUZ",
                                    "Value": "SANTA CRUZ"
                                },
                                {
                                    "Text": "SAONER",
                                    "Value": "SAONER"
                                },
                                {
                                    "Text": "SAPHALE",
                                    "Value": "SAPHALE"
                                },
                                {
                                    "Text": "SARAN",
                                    "Value": "SARAN"
                                },
                                {
                                    "Text": "SARAI MIR",
                                    "Value": "SARAI MIR"
                                },
                                {
                                    "Text": "SARAIDHELA",
                                    "Value": "SARAIDHELA"
                                },
                                {
                                    "Text": "SARAIKELA",
                                    "Value": "SARAIKELA"
                                },
                                {
                                    "Text": "SARAVANAMPATTI",
                                    "Value": "SARAVANAMPATTI"
                                },
                                {
                                    "Text": "SARDAR SHAHAR",
                                    "Value": "SARDAR SHAHAR"
                                },
                                {
                                    "Text": "SARDHANA",
                                    "Value": "SARDHANA"
                                },
                                {
                                    "Text": "SARDULGARH",
                                    "Value": "SARDULGARH"
                                },
                                {
                                    "Text": "SARIGAM",
                                    "Value": "SARIGAM"
                                },
                                {
                                    "Text": "SARKAGHAT",
                                    "Value": "SARKAGHAT"
                                },
                                {
                                    "Text": "SARNA",
                                    "Value": "SARNA"
                                },
                                {
                                    "Text": "SARTHANA ",
                                    "Value": "SARTHANA "
                                },
                                {
                                    "Text": "SASARAM",
                                    "Value": "SASARAM"
                                },
                                {
                                    "Text": "SAS NAGAR ( MOHALI)",
                                    "Value": "SAS NAGAR ( MOHALI)"
                                },
                                {
                                    "Text": "SATANA",
                                    "Value": "SATANA"
                                },
                                {
                                    "Text": "SATARA",
                                    "Value": "SATARA"
                                },
                                {
                                    "Text": "SATHYAMANGALAM",
                                    "Value": "SATHYAMANGALAM"
                                },
                                {
                                    "Text": "SATHUPALLE",
                                    "Value": "SATHUPALLE"
                                },
                                {
                                    "Text": "SATLASANA",
                                    "Value": "SATLASANA"
                                },
                                {
                                    "Text": "SATNA",
                                    "Value": "SATNA"
                                },
                                {
                                    "Text": "SATTENAPALLI",
                                    "Value": "SATTENAPALLI"
                                },
                                {
                                    "Text": "SATTENAPALLE",
                                    "Value": "SATTENAPALLE"
                                },
                                {
                                    "Text": "SAUNAHA ",
                                    "Value": "SAUNAHA "
                                },
                                {
                                    "Text": "SAURI",
                                    "Value": "SAURI"
                                },
                                {
                                    "Text": "SAVARKUNDLA",
                                    "Value": "SAVARKUNDLA"
                                },
                                {
                                    "Text": "SAVAIGUDEM ",
                                    "Value": "SAVAIGUDEM "
                                },
                                {
                                    "Text": "SAVARDARI",
                                    "Value": "SAVARDARI"
                                },
                                {
                                    "Text": "SAVDA",
                                    "Value": "SAVDA"
                                },
                                {
                                    "Text": "SAVNER",
                                    "Value": "SAVNER"
                                },
                                {
                                    "Text": "SAWANTWADI",
                                    "Value": "SAWANTWADI"
                                },
                                {
                                    "Text": "SAWAI MADHOPUR",
                                    "Value": "SAWAI MADHOPUR"
                                },
                                {
                                    "Text": "SAWARGAON HADAP ",
                                    "Value": "SAWARGAON HADAP "
                                },
                                {
                                    "Text": "SAYAR ",
                                    "Value": "SAYAR "
                                },
                                {
                                    "Text": "SAYLA",
                                    "Value": "SAYLA"
                                },
                                {
                                    "Text": "SOUTH DUMDUM",
                                    "Value": "SOUTH DUMDUM"
                                },
                                {
                                    "Text": "SADAT PUR GUJRAN",
                                    "Value": "SADAT PUR GUJRAN"
                                },
                                {
                                    "Text": "SECUNDERABAD",
                                    "Value": "SECUNDERABAD"
                                },
                                {
                                    "Text": "SECUNDERABAD CANTT.",
                                    "Value": "SECUNDERABAD CANTT."
                                },
                                {
                                    "Text": "SEDAM",
                                    "Value": "SEDAM"
                                },
                                {
                                    "Text": "SEDARIYA",
                                    "Value": "SEDARIYA"
                                },
                                {
                                    "Text": "SEHJRA",
                                    "Value": "SEHJRA"
                                },
                                {
                                    "Text": "SEHORE",
                                    "Value": "SEHORE"
                                },
                                {
                                    "Text": "SELUD",
                                    "Value": "SELUD"
                                },
                                {
                                    "Text": "SEMARA CHANDRAULI",
                                    "Value": "SEMARA CHANDRAULI"
                                },
                                {
                                    "Text": "SENAPATI",
                                    "Value": "SENAPATI"
                                },
                                {
                                    "Text": "SENDHWA",
                                    "Value": "SENDHWA"
                                },
                                {
                                    "Text": "SENDRI",
                                    "Value": "SENDRI"
                                },
                                {
                                    "Text": "SEOLI ",
                                    "Value": "SEOLI "
                                },
                                {
                                    "Text": "SEOLI",
                                    "Value": "SEOLI"
                                },
                                {
                                    "Text": "SEONI",
                                    "Value": "SEONI"
                                },
                                {
                                    "Text": "SEONI MALWA",
                                    "Value": "SEONI MALWA"
                                },
                                {
                                    "Text": "SEPPA",
                                    "Value": "SEPPA"
                                },
                                {
                                    "Text": "SERAMPORE",
                                    "Value": "SERAMPORE"
                                },
                                {
                                    "Text": "SERAIKELA-KHARSAWAN",
                                    "Value": "SERAIKELA-KHARSAWAN"
                                },
                                {
                                    "Text": "SERAIKELA",
                                    "Value": "SERAIKELA"
                                },
                                {
                                    "Text": "SERAULIM",
                                    "Value": "SERAULIM"
                                },
                                {
                                    "Text": "SERCHHIP",
                                    "Value": "SERCHHIP"
                                },
                                {
                                    "Text": "SEVOOR",
                                    "Value": "SEVOOR"
                                },
                                {
                                    "Text": "SEWARHI",
                                    "Value": "SEWARHI"
                                },
                                {
                                    "Text": "SANGMESHWAR",
                                    "Value": "SANGMESHWAR"
                                },
                                {
                                    "Text": "SHAHAD",
                                    "Value": "SHAHAD"
                                },
                                {
                                    "Text": "SHADNAGAR",
                                    "Value": "SHADNAGAR"
                                },
                                {
                                    "Text": "SHAHABAD",
                                    "Value": "SHAHABAD"
                                },
                                {
                                    "Text": "SHAHDOL",
                                    "Value": "SHAHDOL"
                                },
                                {
                                    "Text": "SHAHJAHANPUR",
                                    "Value": "SHAHJAHANPUR"
                                },
                                {
                                    "Text": "SHAHID UDHAM SINGH NAGAR",
                                    "Value": "SHAHID UDHAM SINGH NAGAR"
                                },
                                {
                                    "Text": "SHAHKOT",
                                    "Value": "SHAHKOT"
                                },
                                {
                                    "Text": "SHAHPURA",
                                    "Value": "SHAHPURA"
                                },
                                {
                                    "Text": "SHAHPUR TONDA ",
                                    "Value": "SHAHPUR TONDA "
                                },
                                {
                                    "Text": "SHAHADE",
                                    "Value": "SHAHADE"
                                },
                                {
                                    "Text": "SHAHAPUR",
                                    "Value": "SHAHAPUR"
                                },
                                {
                                    "Text": "SHAHBAD",
                                    "Value": "SHAHBAD"
                                },
                                {
                                    "Text": "SHAHGANJ",
                                    "Value": "SHAHGANJ"
                                },
                                {
                                    "Text": "SHAHPUR GOVARDHANPUR BANGAR",
                                    "Value": "SHAHPUR GOVARDHANPUR BANGAR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHZADPUR",
                                    "Value": "SHAHZADPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAIKHPARA .",
                                    "Value": "SHAIKHPARA ."
                                },
                                {
                                    "Text": "SHAJAPUR",
                                    "Value": "SHAJAPUR"
                                },
                                {
                                    "Text": "SHAMLI",
                                    "Value": "SHAMLI"
                                },
                                {
                                    "Text": "SHAMSHABAD",
                                    "Value": "SHAMSHABAD"
                                },
                                {
                                    "Text": "SHAMIRPET ",
                                    "Value": "SHAMIRPET "
                                },
                                {
                                    "Text": "SHAMDOO ",
                                    "Value": "SHAMDOO "
                                },
                                {
                                    "Text": "SHAMALAJI",
                                    "Value": "SHAMALAJI"
                                },
                                {
                                    "Text": "SHAMASHPUR",
                                    "Value": "SHAMASHPUR"
                                },
                                {
                                    "Text": "SHAMCHURASI",
                                    "Value": "SHAMCHURASI"
                                },
                                {
                                    "Text": "SHAMSABAD",
                                    "Value": "SHAMSABAD"
                                },
                                {
                                    "Text": "SHAMSABAD",
                                    "Value": "SHAMSABAD"
                                },
                                {
                                    "Text": "SHANKAR",
                                    "Value": "SHANKAR"
                                },
                                {
                                    "Text": "SHANKARGARH",
                                    "Value": "SHANKARGARH"
                                },
                                {
                                    "Text": "SHANKARPALLY",
                                    "Value": "SHANKARPALLY"
                                },
                                {
                                    "Text": "SHANPUNG",
                                    "Value": "SHANPUNG"
                                },
                                {
                                    "Text": "SHAPAR",
                                    "Value": "SHAPAR"
                                },
                                {
                                    "Text": "SHARJAH",
                                    "Value": "SHARJAH"
                                },
                                {
                                    "Text": "SHAHADA",
                                    "Value": "SHAHADA"
                                },
                                {
                                    "Text": "SAHIBABAD DAULAT PUR",
                                    "Value": "SAHIBABAD DAULAT PUR"
                                },
                                {
                                    "Text": "SHEGAON",
                                    "Value": "SHEGAON"
                                },
                                {
                                    "Text": "SHEIKHPURA",
                                    "Value": "SHEIKHPURA"
                                },
                                {
                                    "Text": "SHEKTA ",
                                    "Value": "SHEKTA "
                                },
                                {
                                    "Text": "SHELAR",
                                    "Value": "SHELAR"
                                },
                                {
                                    "Text": "SHENDRA MIDC AREA ",
                                    "Value": "SHENDRA MIDC AREA "
                                },
                                {
                                    "Text": "SHEOHAR",
                                    "Value": "SHEOHAR"
                                },
                                {
                                    "Text": "SHEOPUR",
                                    "Value": "SHEOPUR"
                                },
                                {
                                    "Text": "SHEOGA ",
                                    "Value": "SHEOGA "
                                },
                                {
                                    "Text": "SHERTALLY",
                                    "Value": "SHERTALLY"
                                },
                                {
                                    "Text": "SHERKOT",
                                    "Value": "SHERKOT"
                                },
                                {
                                    "Text": "SHERPURA",
                                    "Value": "SHERPURA"
                                },
                                {
                                    "Text": "SHIHOLI MOTI",
                                    "Value": "SHIHOLI MOTI"
                                },
                                {
                                    "Text": "SHIKOHABAD",
                                    "Value": "SHIKOHABAD"
                                },
                                {
                                    "Text": "SHIKOHPUR",
                                    "Value": "SHIKOHPUR"
                                },
                                {
                                    "Text": "SHIKRAPUR",
                                    "Value": "SHIKRAPUR"
                                },
                                {
                                    "Text": "SHILLONG",
                                    "Value": "SHILLONG"
                                },
                                {
                                    "Text": "SHILARU",
                                    "Value": "SHILARU"
                                },
                                {
                                    "Text": "SHIMLA",
                                    "Value": "SHIMLA"
                                },
                                {
                                    "Text": "SHIMOGA",
                                    "Value": "SHIMOGA"
                                },
                                {
                                    "Text": "SHINDEKELGAON ",
                                    "Value": "SHINDEKELGAON "
                                },
                                {
                                    "Text": "SHIRUR",
                                    "Value": "SHIRUR"
                                },
                                {
                                    "Text": "SHIRVAL",
                                    "Value": "SHIRVAL"
                                },
                                {
                                    "Text": "SHIRPUR",
                                    "Value": "SHIRPUR"
                                },
                                {
                                    "Text": "SHIRDI",
                                    "Value": "SHIRDI"
                                },
                                {
                                    "Text": "SHIRWAL",
                                    "Value": "SHIRWAL"
                                },
                                {
                                    "Text": "SHIVPURI",
                                    "Value": "SHIVPURI"
                                },
                                {
                                    "Text": "SHIVPUR ",
                                    "Value": "SHIVPUR "
                                },
                                {
                                    "Text": "SHALIMAR BAGH",
                                    "Value": "SHALIMAR BAGH"
                                },
                                {
                                    "Text": "SHOHRATGARH",
                                    "Value": "SHOHRATGARH"
                                },
                                {
                                    "Text": "SHOPIAN",
                                    "Value": "SHOPIAN"
                                },
                                {
                                    "Text": "SHORANUR",
                                    "Value": "SHORANUR"
                                },
                                {
                                    "Text": "SHERPUR",
                                    "Value": "SHERPUR"
                                },
                                {
                                    "Text": "SHRAWASTI",
                                    "Value": "SHRAWASTI"
                                },
                                {
                                    "Text": "SHRIRAMPUR",
                                    "Value": "SHRIRAMPUR"
                                },
                                {
                                    "Text": "SHRIGONDA",
                                    "Value": "SHRIGONDA"
                                },
                                {
                                    "Text": "SHUJALPUR",
                                    "Value": "SHUJALPUR"
                                },
                                {
                                    "Text": "SHUKARTAL BANGAR",
                                    "Value": "SHUKARTAL BANGAR"
                                },
                                {
                                    "Text": "SHUKLAGANJ",
                                    "Value": "SHUKLAGANJ"
                                },
                                {
                                    "Text": "SIBSAGAR",
                                    "Value": "SIBSAGAR"
                                },
                                {
                                    "Text": "SIBSAGAR",
                                    "Value": "SIBSAGAR"
                                },
                                {
                                    "Text": "SIDDIPET",
                                    "Value": "SIDDIPET"
                                },
                                {
                                    "Text": "SIDDHARTHNAGAR",
                                    "Value": "SIDDHARTHNAGAR"
                                },
                                {
                                    "Text": "SIDDALOOR ",
                                    "Value": "SIDDALOOR "
                                },
                                {
                                    "Text": "SIDHI",
                                    "Value": "SIDHI"
                                },
                                {
                                    "Text": "SIDHPUR",
                                    "Value": "SIDHPUR"
                                },
                                {
                                    "Text": "SIDHWAN BET",
                                    "Value": "SIDHWAN BET"
                                },
                                {
                                    "Text": "SIDSAR",
                                    "Value": "SIDSAR"
                                },
                                {
                                    "Text": "SIGNAL VILLAGE",
                                    "Value": "SIGNAL VILLAGE"
                                },
                                {
                                    "Text": "SIHORA",
                                    "Value": "SIHORA"
                                },
                                {
                                    "Text": "SIHOR",
                                    "Value": "SIHOR"
                                },
                                {
                                    "Text": "SIKAR",
                                    "Value": "SIKAR"
                                },
                                {
                                    "Text": "SIKANDERPUR BADHA",
                                    "Value": "SIKANDERPUR BADHA"
                                },
                                {
                                    "Text": "SIKANDRABAD",
                                    "Value": "SIKANDRABAD"
                                },
                                {
                                    "Text": "SIKHWALA",
                                    "Value": "SIKHWALA"
                                },
                                {
                                    "Text": "SILVASSA",
                                    "Value": "SILVASSA"
                                },
                                {
                                    "Text": "SILAI BARA GAON ",
                                    "Value": "SILAI BARA GAON "
                                },
                                {
                                    "Text": "SILCHAR",
                                    "Value": "SILCHAR"
                                },
                                {
                                    "Text": "SILIGURI",
                                    "Value": "SILIGURI"
                                },
                                {
                                    "Text": "SILLOD",
                                    "Value": "SILLOD"
                                },
                                {
                                    "Text": "SILVASSA",
                                    "Value": "SILVASSA"
                                },
                                {
                                    "Text": "SIMALIYA",
                                    "Value": "SIMALIYA"
                                },
                                {
                                    "Text": "SIMDEGA",
                                    "Value": "SIMDEGA"
                                },
                                {
                                    "Text": "SIMIKERI ",
                                    "Value": "SIMIKERI "
                                },
                                {
                                    "Text": "SIMINOI",
                                    "Value": "SIMINOI"
                                },
                                {
                                    "Text": "SINDHANUR",
                                    "Value": "SINDHANUR"
                                },
                                {
                                    "Text": "SINDHUDURG",
                                    "Value": "SINDHUDURG"
                                },
                                {
                                    "Text": "SINGRAULI",
                                    "Value": "SINGRAULI"
                                },
                                {
                                    "Text": "SINGHE WALA ",
                                    "Value": "SINGHE WALA "
                                },
                                {
                                    "Text": "SINGHAUR",
                                    "Value": "SINGHAUR"
                                },
                                {
                                    "Text": "SINGTAM",
                                    "Value": "SINGTAM"
                                },
                                {
                                    "Text": "SINNAR",
                                    "Value": "SINNAR"
                                },
                                {
                                    "Text": "SIOLIM",
                                    "Value": "SIOLIM"
                                },
                                {
                                    "Text": "SIPAHIJALA",
                                    "Value": "SIPAHIJALA"
                                },
                                {
                                    "Text": "SIRATHU",
                                    "Value": "SIRATHU"
                                },
                                {
                                    "Text": "SIRATHU",
                                    "Value": "SIRATHU"
                                },
                                {
                                    "Text": "SIRCAIM",
                                    "Value": "SIRCAIM"
                                },
                                {
                                    "Text": "SIRCILLA",
                                    "Value": "SIRCILLA"
                                },
                                {
                                    "Text": "SIRHIND",
                                    "Value": "SIRHIND"
                                },
                                {
                                    "Text": "SIRMOUR",
                                    "Value": "SIRMOUR"
                                },
                                {
                                    "Text": "SIRMAUR",
                                    "Value": "SIRMAUR"
                                },
                                {
                                    "Text": "SIRMINA ",
                                    "Value": "SIRMINA "
                                },
                                {
                                    "Text": "SIRONJ",
                                    "Value": "SIRONJ"
                                },
                                {
                                    "Text": "SIROHI",
                                    "Value": "SIROHI"
                                },
                                {
                                    "Text": "SIRSI",
                                    "Value": "SIRSI"
                                },
                                {
                                    "Text": "SIRSA",
                                    "Value": "SIRSA"
                                },
                                {
                                    "Text": "SISODARA",
                                    "Value": "SISODARA"
                                },
                                {
                                    "Text": "SISWA",
                                    "Value": "SISWA"
                                },
                                {
                                    "Text": "SITAPUR",
                                    "Value": "SITAPUR"
                                },
                                {
                                    "Text": "SITAMARHI",
                                    "Value": "SITAMARHI"
                                },
                                {
                                    "Text": "SITAPUR",
                                    "Value": "SITAPUR"
                                },
                                {
                                    "Text": "SITARGANJ",
                                    "Value": "SITARGANJ"
                                },
                                {
                                    "Text": "SITO GUNNO",
                                    "Value": "SITO GUNNO"
                                },
                                {
                                    "Text": "SIVAKASI",
                                    "Value": "SIVAKASI"
                                },
                                {
                                    "Text": "SIVAGANGA",
                                    "Value": "SIVAGANGA"
                                },
                                {
                                    "Text": "SIVAREDDYPET ",
                                    "Value": "SIVAREDDYPET "
                                },
                                {
                                    "Text": "SIVASAGAR",
                                    "Value": "SIVASAGAR"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SIWANI",
                                    "Value": "SIWANI"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SUKHRALI",
                                    "Value": "SUKHRALI"
                                },
                                {
                                    "Text": "SULTAN PUR",
                                    "Value": "SULTAN PUR"
                                },
                                {
                                    "Text": "SULTAN PUR MAJRA",
                                    "Value": "SULTAN PUR MAJRA"
                                },
                                {
                                    "Text": "SAMBHALKA",
                                    "Value": "SAMBHALKA"
                                },
                                {
                                    "Text": "SANGLI MIRAJ KUPWAD",
                                    "Value": "SANGLI MIRAJ KUPWAD"
                                },
                                {
                                    "Text": "SANGAREDDY",
                                    "Value": "SANGAREDDY"
                                },
                                {
                                    "Text": "SINGUR",
                                    "Value": "SINGUR"
                                },
                                {
                                    "Text": "SANPADA",
                                    "Value": "SANPADA"
                                },
                                {
                                    "Text": "SONARPUR",
                                    "Value": "SONARPUR"
                                },
                                {
                                    "Text": "SONAWARI",
                                    "Value": "SONAWARI"
                                },
                                {
                                    "Text": "SOHANA",
                                    "Value": "SOHANA"
                                },
                                {
                                    "Text": "SOHANPUR",
                                    "Value": "SOHANPUR"
                                },
                                {
                                    "Text": "SOHNA",
                                    "Value": "SOHNA"
                                },
                                {
                                    "Text": "SOJAT CITY",
                                    "Value": "SOJAT CITY"
                                },
                                {
                                    "Text": "SOLAN",
                                    "Value": "SOLAN"
                                },
                                {
                                    "Text": "SOLAPUR",
                                    "Value": "SOLAPUR"
                                },
                                {
                                    "Text": "SOLAIYA",
                                    "Value": "SOLAIYA"
                                },
                                {
                                    "Text": "SOMATANE",
                                    "Value": "SOMATANE"
                                },
                                {
                                    "Text": "SONAPUR",
                                    "Value": "SONAPUR"
                                },
                                {
                                    "Text": "SONBHADRA",
                                    "Value": "SONBHADRA"
                                },
                                {
                                    "Text": "SONEPAT",
                                    "Value": "SONEPAT"
                                },
                                {
                                    "Text": "SONEPUR",
                                    "Value": "SONEPUR"
                                },
                                {
                                    "Text": "SONIPAT",
                                    "Value": "SONIPAT"
                                },
                                {
                                    "Text": "SONITPUR",
                                    "Value": "SONITPUR"
                                },
                                {
                                    "Text": "SONJAMB",
                                    "Value": "SONJAMB"
                                },
                                {
                                    "Text": "SONPUR",
                                    "Value": "SONPUR"
                                },
                                {
                                    "Text": "SOPORE",
                                    "Value": "SOPORE"
                                },
                                {
                                    "Text": "SORAON",
                                    "Value": "SORAON"
                                },
                                {
                                    "Text": "SORUMONA PORIA",
                                    "Value": "SORUMONA PORIA"
                                },
                                {
                                    "Text": "SOUTH SIKKIM",
                                    "Value": "SOUTH SIKKIM"
                                },
                                {
                                    "Text": "SOUTH WEST DELHI",
                                    "Value": "SOUTH WEST DELHI"
                                },
                                {
                                    "Text": "SOUTH TRIPURA",
                                    "Value": "SOUTH TRIPURA"
                                },
                                {
                                    "Text": "SOUTH 24 PARGANAS",
                                    "Value": "SOUTH 24 PARGANAS"
                                },
                                {
                                    "Text": "SOUTH ANDAMAN",
                                    "Value": "SOUTH ANDAMAN"
                                },
                                {
                                    "Text": "SOUTH DELHI",
                                    "Value": "SOUTH DELHI"
                                },
                                {
                                    "Text": "SOUTH DINAJPUR",
                                    "Value": "SOUTH DINAJPUR"
                                },
                                {
                                    "Text": "SOUTH GARO HILLS",
                                    "Value": "SOUTH GARO HILLS"
                                },
                                {
                                    "Text": "SOUTH GOA",
                                    "Value": "SOUTH GOA"
                                },
                                {
                                    "Text": "SOUTH PARUR",
                                    "Value": "SOUTH PARUR"
                                },
                                {
                                    "Text": "SRI GANGANAGAR",
                                    "Value": "SRI GANGANAGAR"
                                },
                                {
                                    "Text": "SRI HARGOBINDPUR SAHIB",
                                    "Value": "SRI HARGOBINDPUR SAHIB"
                                },
                                {
                                    "Text": "SRIKAKULAM",
                                    "Value": "SRIKAKULAM"
                                },
                                {
                                    "Text": "SRIKALAHASTI",
                                    "Value": "SRIKALAHASTI"
                                },
                                {
                                    "Text": "SRIMADHOPUR",
                                    "Value": "SRIMADHOPUR"
                                },
                                {
                                    "Text": "SRINAGAR",
                                    "Value": "SRINAGAR"
                                },
                                {
                                    "Text": "SRINIVASPURAM ",
                                    "Value": "SRINIVASPURAM "
                                },
                                {
                                    "Text": "SRINAGAR",
                                    "Value": "SRINAGAR"
                                },
                                {
                                    "Text": "SRIPERUMBUDUR",
                                    "Value": "SRIPERUMBUDUR"
                                },
                                {
                                    "Text": "SRIRANGAM",
                                    "Value": "SRIRANGAM"
                                },
                                {
                                    "Text": "SRI VIJAYNAGAR",
                                    "Value": "SRI VIJAYNAGAR"
                                },
                                {
                                    "Text": "SURANKOTE",
                                    "Value": "SURANKOTE"
                                },
                                {
                                    "Text": "SIRAS PUR",
                                    "Value": "SIRAS PUR"
                                },
                                {
                                    "Text": "STN. GUNDRATHIMADUGU ",
                                    "Value": "STN. GUNDRATHIMADUGU "
                                },
                                {
                                    "Text": "SUALKUCHI",
                                    "Value": "SUALKUCHI"
                                },
                                {
                                    "Text": "SUBHASHNAGAR ",
                                    "Value": "SUBHASHNAGAR "
                                },
                                {
                                    "Text": "SUDHAIL",
                                    "Value": "SUDHAIL"
                                },
                                {
                                    "Text": "SUDHAR",
                                    "Value": "SUDHAR"
                                },
                                {
                                    "Text": "SUGHAD",
                                    "Value": "SUGHAD"
                                },
                                {
                                    "Text": "SUHRON ",
                                    "Value": "SUHRON "
                                },
                                {
                                    "Text": "SUJANGARH",
                                    "Value": "SUJANGARH"
                                },
                                {
                                    "Text": "SUJANPUR",
                                    "Value": "SUJANPUR"
                                },
                                {
                                    "Text": "SUKHAN WALA ",
                                    "Value": "SUKHAN WALA "
                                },
                                {
                                    "Text": "SUKHDEVPURA",
                                    "Value": "SUKHDEVPURA"
                                },
                                {
                                    "Text": "SUKHER",
                                    "Value": "SUKHER"
                                },
                                {
                                    "Text": "SULAH",
                                    "Value": "SULAH"
                                },
                                {
                                    "Text": "SULLIA",
                                    "Value": "SULLIA"
                                },
                                {
                                    "Text": "SULTANPUR",
                                    "Value": "SULTANPUR"
                                },
                                {
                                    "Text": "SULTAN BATTERY",
                                    "Value": "SULTAN BATTERY"
                                },
                                {
                                    "Text": "SULTANPUR",
                                    "Value": "SULTANPUR"
                                },
                                {
                                    "Text": "SULTANPUR LODHI",
                                    "Value": "SULTANPUR LODHI"
                                },
                                {
                                    "Text": "SULTANABAD",
                                    "Value": "SULTANABAD"
                                },
                                {
                                    "Text": "SULTHAN BATHERY",
                                    "Value": "SULTHAN BATHERY"
                                },
                                {
                                    "Text": "SULYA",
                                    "Value": "SULYA"
                                },
                                {
                                    "Text": "SUMERPUR",
                                    "Value": "SUMERPUR"
                                },
                                {
                                    "Text": "SUNABEDA",
                                    "Value": "SUNABEDA"
                                },
                                {
                                    "Text": "SUNAM",
                                    "Value": "SUNAM"
                                },
                                {
                                    "Text": "SUNDLI JUBBAL",
                                    "Value": "SUNDLI JUBBAL"
                                },
                                {
                                    "Text": "SUNDERGARH",
                                    "Value": "SUNDERGARH"
                                },
                                {
                                    "Text": "SUNDERNAGAR",
                                    "Value": "SUNDERNAGAR"
                                },
                                {
                                    "Text": "SUNDERBANI",
                                    "Value": "SUNDERBANI"
                                },
                                {
                                    "Text": "SUNDA ",
                                    "Value": "SUNDA "
                                },
                                {
                                    "Text": "SUNDARAPURAM",
                                    "Value": "SUNDARAPURAM"
                                },
                                {
                                    "Text": "SUNDARGARH",
                                    "Value": "SUNDARGARH"
                                },
                                {
                                    "Text": "SUNDARNAGAR",
                                    "Value": "SUNDARNAGAR"
                                },
                                {
                                    "Text": "SUNDLI -JUBBAL (JAI-PIDI)",
                                    "Value": "SUNDLI -JUBBAL (JAI-PIDI)"
                                },
                                {
                                    "Text": "SUPAUL",
                                    "Value": "SUPAUL"
                                },
                                {
                                    "Text": "SUPASI",
                                    "Value": "SUPASI"
                                },
                                {
                                    "Text": "SUPELA",
                                    "Value": "SUPELA"
                                },
                                {
                                    "Text": "SURATGARH",
                                    "Value": "SURATGARH"
                                },
                                {
                                    "Text": "SURAT",
                                    "Value": "SURAT"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURATHKAL",
                                    "Value": "SURATHKAL"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURENDRANAGAR",
                                    "Value": "SURENDRANAGAR"
                                },
                                {
                                    "Text": "SURENDRA NAGAR",
                                    "Value": "SURENDRA NAGAR"
                                },
                                {
                                    "Text": "SURGUJA",
                                    "Value": "SURGUJA"
                                },
                                {
                                    "Text": "SURI",
                                    "Value": "SURI"
                                },
                                {
                                    "Text": "SURLA ",
                                    "Value": "SURLA "
                                },
                                {
                                    "Text": "SURMA ",
                                    "Value": "SURMA "
                                },
                                {
                                    "Text": "SUR SINGH",
                                    "Value": "SUR SINGH"
                                },
                                {
                                    "Text": "SURYAPET",
                                    "Value": "SURYAPET"
                                },
                                {
                                    "Text": "SUSARI",
                                    "Value": "SUSARI"
                                },
                                {
                                    "Text": "SWARNAVARIGUDEM ",
                                    "Value": "SWARNAVARIGUDEM "
                                },
                                {
                                    "Text": "TADA",
                                    "Value": "TADA"
                                },
                                {
                                    "Text": "TADEPALLIGUDEM",
                                    "Value": "TADEPALLIGUDEM"
                                },
                                {
                                    "Text": "TADEGAON ",
                                    "Value": "TADEGAON "
                                },
                                {
                                    "Text": "TADIPATRI",
                                    "Value": "TADIPATRI"
                                },
                                {
                                    "Text": "TADLAPOOSALAPALLI ",
                                    "Value": "TADLAPOOSALAPALLI "
                                },
                                {
                                    "Text": "TADPATRI",
                                    "Value": "TADPATRI"
                                },
                                {
                                    "Text": "TADUVAI ",
                                    "Value": "TADUVAI "
                                },
                                {
                                    "Text": "TAHLIWAL ",
                                    "Value": "TAHLIWAL "
                                },
                                {
                                    "Text": "TAHLIWALA JATTAN",
                                    "Value": "TAHLIWALA JATTAN"
                                },
                                {
                                    "Text": "TAJANGI ",
                                    "Value": "TAJANGI "
                                },
                                {
                                    "Text": "TAJ PUL",
                                    "Value": "TAJ PUL"
                                },
                                {
                                    "Text": "TAKAVE BUDRUK",
                                    "Value": "TAKAVE BUDRUK"
                                },
                                {
                                    "Text": "TAKALIMIYA",
                                    "Value": "TAKALIMIYA"
                                },
                                {
                                    "Text": "TAKAVE BUDRUK",
                                    "Value": "TAKAVE BUDRUK"
                                },
                                {
                                    "Text": "TAKHU CHAK",
                                    "Value": "TAKHU CHAK"
                                },
                                {
                                    "Text": "TAKHATPUR",
                                    "Value": "TAKHATPUR"
                                },
                                {
                                    "Text": "TAKHU CHAK",
                                    "Value": "TAKHU CHAK"
                                },
                                {
                                    "Text": "TAKKELLA PAHAD ",
                                    "Value": "TAKKELLA PAHAD "
                                },
                                {
                                    "Text": "TALAJA",
                                    "Value": "TALAJA"
                                },
                                {
                                    "Text": "TALALA",
                                    "Value": "TALALA"
                                },
                                {
                                    "Text": "TALCHER",
                                    "Value": "TALCHER"
                                },
                                {
                                    "Text": "TALEGAON",
                                    "Value": "TALEGAON"
                                },
                                {
                                    "Text": "TALEKODE",
                                    "Value": "TALEKODE"
                                },
                                {
                                    "Text": "TALEKODE WEST ",
                                    "Value": "TALEKODE WEST "
                                },
                                {
                                    "Text": "TALEGAON DABHADE",
                                    "Value": "TALEGAON DABHADE"
                                },
                                {
                                    "Text": "TALHAN",
                                    "Value": "TALHAN"
                                },
                                {
                                    "Text": "TALIPARAMBA",
                                    "Value": "TALIPARAMBA"
                                },
                                {
                                    "Text": "TALIKULAM",
                                    "Value": "TALIKULAM"
                                },
                                {
                                    "Text": "TALLAPOLAM ",
                                    "Value": "TALLAPOLAM "
                                },
                                {
                                    "Text": "TALOD",
                                    "Value": "TALOD"
                                },
                                {
                                    "Text": "TALOJE MAJKUR",
                                    "Value": "TALOJE MAJKUR"
                                },
                                {
                                    "Text": "TALWANDI SABO",
                                    "Value": "TALWANDI SABO"
                                },
                                {
                                    "Text": "TALWARA TOWNSHIP",
                                    "Value": "TALWARA TOWNSHIP"
                                },
                                {
                                    "Text": "TALWAN",
                                    "Value": "TALWAN"
                                },
                                {
                                    "Text": "TALWANDI BHAI",
                                    "Value": "TALWANDI BHAI"
                                },
                                {
                                    "Text": "TALWANDI CHAUDRIAN",
                                    "Value": "TALWANDI CHAUDRIAN"
                                },
                                {
                                    "Text": "TALWARA",
                                    "Value": "TALWARA"
                                },
                                {
                                    "Text": "TAMENGLONG",
                                    "Value": "TAMENGLONG"
                                },
                                {
                                    "Text": "TAMLUK",
                                    "Value": "TAMLUK"
                                },
                                {
                                    "Text": "TANDUR",
                                    "Value": "TANDUR"
                                },
                                {
                                    "Text": "TANDA",
                                    "Value": "TANDA"
                                },
                                {
                                    "Text": "TANDEMVALASA ",
                                    "Value": "TANDEMVALASA "
                                },
                                {
                                    "Text": "TANGI",
                                    "Value": "TANGI"
                                },
                                {
                                    "Text": "TANGRA",
                                    "Value": "TANGRA"
                                },
                                {
                                    "Text": "TANKARA",
                                    "Value": "TANKARA"
                                },
                                {
                                    "Text": "TANKARA",
                                    "Value": "TANKARA"
                                },
                                {
                                    "Text": "TANKUA",
                                    "Value": "TANKUA"
                                },
                                {
                                    "Text": "TANUKU",
                                    "Value": "TANUKU"
                                },
                                {
                                    "Text": "TAORU",
                                    "Value": "TAORU"
                                },
                                {
                                    "Text": "TAPA MANDI",
                                    "Value": "TAPA MANDI"
                                },
                                {
                                    "Text": "TAPA",
                                    "Value": "TAPA"
                                },
                                {
                                    "Text": "TAPI",
                                    "Value": "TAPI"
                                },
                                {
                                    "Text": "TAPOKDA",
                                    "Value": "TAPOKDA"
                                },
                                {
                                    "Text": "TARAORI",
                                    "Value": "TARAORI"
                                },
                                {
                                    "Text": "TARA ",
                                    "Value": "TARA "
                                },
                                {
                                    "Text": "TARAGARH",
                                    "Value": "TARAGARH"
                                },
                                {
                                    "Text": "TARAKESWAR",
                                    "Value": "TARAKESWAR"
                                },
                                {
                                    "Text": "TARAPUR",
                                    "Value": "TARAPUR"
                                },
                                {
                                    "Text": "TAREWALA ",
                                    "Value": "TAREWALA "
                                },
                                {
                                    "Text": "TARN TARAN",
                                    "Value": "TARN TARAN"
                                },
                                {
                                    "Text": "TARSIKKA",
                                    "Value": "TARSIKKA"
                                },
                                {
                                    "Text": "TARSOD",
                                    "Value": "TARSOD"
                                },
                                {
                                    "Text": "TASGAON",
                                    "Value": "TASGAON"
                                },
                                {
                                    "Text": "TATTEKERE ",
                                    "Value": "TATTEKERE "
                                },
                                {
                                    "Text": "TAWANG",
                                    "Value": "TAWANG"
                                },
                                {
                                    "Text": "TEHNA ",
                                    "Value": "TEHNA "
                                },
                                {
                                    "Text": "TEHRI GARHWAL",
                                    "Value": "TEHRI GARHWAL"
                                },
                                {
                                    "Text": "TEHRI",
                                    "Value": "TEHRI"
                                },
                                {
                                    "Text": "TEHSIL DADRI",
                                    "Value": "TEHSIL DADRI"
                                },
                                {
                                    "Text": "TEHSIL JEWAR",
                                    "Value": "TEHSIL JEWAR"
                                },
                                {
                                    "Text": "TEHSIL PHILLAUR",
                                    "Value": "TEHSIL PHILLAUR"
                                },
                                {
                                    "Text": "TEHSIL SADAR",
                                    "Value": "TEHSIL SADAR"
                                },
                                {
                                    "Text": "TEKRIYAL ",
                                    "Value": "TEKRIYAL "
                                },
                                {
                                    "Text": "TENALI",
                                    "Value": "TENALI"
                                },
                                {
                                    "Text": "TEEN BATTI",
                                    "Value": "TEEN BATTI"
                                },
                                {
                                    "Text": "TENKASI",
                                    "Value": "TENKASI"
                                },
                                {
                                    "Text": "TEZPUR",
                                    "Value": "TEZPUR"
                                },
                                {
                                    "Text": "TEZU",
                                    "Value": "TEZU"
                                },
                                {
                                    "Text": "THADIKAL",
                                    "Value": "THADIKAL"
                                },
                                {
                                    "Text": "THALASSERY",
                                    "Value": "THALASSERY"
                                },
                                {
                                    "Text": "THAMARASSERY",
                                    "Value": "THAMARASSERY"
                                },
                                {
                                    "Text": "THANGADH",
                                    "Value": "THANGADH"
                                },
                                {
                                    "Text": "THANE",
                                    "Value": "THANE"
                                },
                                {
                                    "Text": "THANJAVUR",
                                    "Value": "THANJAVUR"
                                },
                                {
                                    "Text": "THANA CHAPPAR",
                                    "Value": "THANA CHAPPAR"
                                },
                                {
                                    "Text": "THANESAR",
                                    "Value": "THANESAR"
                                },
                                {
                                    "Text": "THANNEERMUKKAM",
                                    "Value": "THANNEERMUKKAM"
                                },
                                {
                                    "Text": "THARU ",
                                    "Value": "THARU "
                                },
                                {
                                    "Text": "THARAJ",
                                    "Value": "THARAJ"
                                },
                                {
                                    "Text": "THASKA KHADAR",
                                    "Value": "THASKA KHADAR"
                                },
                                {
                                    "Text": "THATHI KHARA ",
                                    "Value": "THATHI KHARA "
                                },
                                {
                                    "Text": "THE DANGS",
                                    "Value": "THE DANGS"
                                },
                                {
                                    "Text": "THENI",
                                    "Value": "THENI"
                                },
                                {
                                    "Text": "THEOG",
                                    "Value": "THEOG"
                                },
                                {
                                    "Text": "THIRUVANANTHAPURAM",
                                    "Value": "THIRUVANANTHAPURAM"
                                },
                                {
                                    "Text": "THIRKKAKARA",
                                    "Value": "THIRKKAKARA"
                                },
                                {
                                    "Text": "THIRTHAHALLI",
                                    "Value": "THIRTHAHALLI"
                                },
                                {
                                    "Text": "THIRUMANGALAM",
                                    "Value": "THIRUMANGALAM"
                                },
                                {
                                    "Text": "THIRUVALLUR",
                                    "Value": "THIRUVALLUR"
                                },
                                {
                                    "Text": "THIRUVARUR",
                                    "Value": "THIRUVARUR"
                                },
                                {
                                    "Text": "THIRUVERAMBUR",
                                    "Value": "THIRUVERAMBUR"
                                },
                                {
                                    "Text": "THIRUVILWAMALA",
                                    "Value": "THIRUVILWAMALA"
                                },
                                {
                                    "Text": "THIRUVOTTIYUR",
                                    "Value": "THIRUVOTTIYUR"
                                },
                                {
                                    "Text": "THISAYANVILAI",
                                    "Value": "THISAYANVILAI"
                                },
                                {
                                    "Text": "THODUPUZHA",
                                    "Value": "THODUPUZHA"
                                },
                                {
                                    "Text": "THORRUR",
                                    "Value": "THORRUR"
                                },
                                {
                                    "Text": "THOUBAL",
                                    "Value": "THOUBAL"
                                },
                                {
                                    "Text": "THRISSUR",
                                    "Value": "THRISSUR"
                                },
                                {
                                    "Text": "THRIPUNITHURA",
                                    "Value": "THRIPUNITHURA"
                                },
                                {
                                    "Text": "THROADIPATTU ",
                                    "Value": "THROADIPATTU "
                                },
                                {
                                    "Text": "THUCKALAY",
                                    "Value": "THUCKALAY"
                                },
                                {
                                    "Text": "THUMBOOR",
                                    "Value": "THUMBOOR"
                                },
                                {
                                    "Text": "THUNGAPAHAD ",
                                    "Value": "THUNGAPAHAD "
                                },
                                {
                                    "Text": "TIBRI",
                                    "Value": "TIBRI"
                                },
                                {
                                    "Text": "TIGAON",
                                    "Value": "TIGAON"
                                },
                                {
                                    "Text": "TIGRANA",
                                    "Value": "TIGRANA"
                                },
                                {
                                    "Text": "TIKAMGARH",
                                    "Value": "TIKAMGARH"
                                },
                                {
                                    "Text": "TILDA",
                                    "Value": "TILDA"
                                },
                                {
                                    "Text": "TILHAR",
                                    "Value": "TILHAR"
                                },
                                {
                                    "Text": "TILPAT",
                                    "Value": "TILPAT"
                                },
                                {
                                    "Text": "TINIDVANAM",
                                    "Value": "TINIDVANAM"
                                },
                                {
                                    "Text": "TINSUKIA",
                                    "Value": "TINSUKIA"
                                },
                                {
                                    "Text": "TIPTUR",
                                    "Value": "TIPTUR"
                                },
                                {
                                    "Text": "TIRAP",
                                    "Value": "TIRAP"
                                },
                                {
                                    "Text": "TIRUR",
                                    "Value": "TIRUR"
                                },
                                {
                                    "Text": "TIRUVALLA",
                                    "Value": "TIRUVALLA"
                                },
                                {
                                    "Text": "TIRUCHIRAPPALLI",
                                    "Value": "TIRUCHIRAPPALLI"
                                },
                                {
                                    "Text": "TIRUNELVELI",
                                    "Value": "TIRUNELVELI"
                                },
                                {
                                    "Text": "TIRUVALLUR",
                                    "Value": "TIRUVALLUR"
                                },
                                {
                                    "Text": "TIRUVANNAMALAI",
                                    "Value": "TIRUVANNAMALAI"
                                },
                                {
                                    "Text": "TIRUVARUR",
                                    "Value": "TIRUVARUR"
                                },
                                {
                                    "Text": "TIRUCHENGODE",
                                    "Value": "TIRUCHENGODE"
                                },
                                {
                                    "Text": "TIRUCHENDUR",
                                    "Value": "TIRUCHENDUR"
                                },
                                {
                                    "Text": "TIRUKOLLUR",
                                    "Value": "TIRUKOLLUR"
                                },
                                {
                                    "Text": "TIRUPATI",
                                    "Value": "TIRUPATI"
                                },
                                {
                                    "Text": "TIRUVURU",
                                    "Value": "TIRUVURU"
                                },
                                {
                                    "Text": "TIRUPATTUR",
                                    "Value": "TIRUPATTUR"
                                },
                                {
                                    "Text": "TIRUPUR",
                                    "Value": "TIRUPUR"
                                },
                                {
                                    "Text": "TIRUCHIRAPALLI",
                                    "Value": "TIRUCHIRAPALLI"
                                },
                                {
                                    "Text": "TIRUPATHUR",
                                    "Value": "TIRUPATHUR"
                                },
                                {
                                    "Text": "TIRUPPUR",
                                    "Value": "TIRUPPUR"
                                },
                                {
                                    "Text": "TIRUVILLA",
                                    "Value": "TIRUVILLA"
                                },
                                {
                                    "Text": "TIRUVUR",
                                    "Value": "TIRUVUR"
                                },
                                {
                                    "Text": "TIRWAGANJ",
                                    "Value": "TIRWAGANJ"
                                },
                                {
                                    "Text": "TITLAGARH",
                                    "Value": "TITLAGARH"
                                },
                                {
                                    "Text": "TALALA  GIR",
                                    "Value": "TALALA  GIR"
                                },
                                {
                                    "Text": "TANDA",
                                    "Value": "TANDA"
                                },
                                {
                                    "Text": "TOHANA",
                                    "Value": "TOHANA"
                                },
                                {
                                    "Text": "TONK",
                                    "Value": "TONK"
                                },
                                {
                                    "Text": "TORLIKONDA ",
                                    "Value": "TORLIKONDA "
                                },
                                {
                                    "Text": "TOSHAM",
                                    "Value": "TOSHAM"
                                },
                                {
                                    "Text": "TOTU",
                                    "Value": "TOTU"
                                },
                                {
                                    "Text": "TOWN BHONGIRI ",
                                    "Value": "TOWN BHONGIRI "
                                },
                                {
                                    "Text": "TRAL",
                                    "Value": "TRAL"
                                },
                                {
                                    "Text": "TRANOL",
                                    "Value": "TRANOL"
                                },
                                {
                                    "Text": "TRICHY",
                                    "Value": "TRICHY"
                                },
                                {
                                    "Text": "TRICHUR",
                                    "Value": "TRICHUR"
                                },
                                {
                                    "Text": "TRIMBAKESHWAR",
                                    "Value": "TRIMBAKESHWAR"
                                },
                                {
                                    "Text": "TRIPUNITHURA",
                                    "Value": "TRIPUNITHURA"
                                },
                                {
                                    "Text": "TRIPURA",
                                    "Value": "TRIPURA"
                                },
                                {
                                    "Text": "TRIPURARAM ",
                                    "Value": "TRIPURARAM "
                                },
                                {
                                    "Text": "TRIPRAYAR",
                                    "Value": "TRIPRAYAR"
                                },
                                {
                                    "Text": "TRIVANDRUM",
                                    "Value": "TRIVANDRUM"
                                },
                                {
                                    "Text": "TROMBAY",
                                    "Value": "TROMBAY"
                                },
                                {
                                    "Text": "TUENSANG",
                                    "Value": "TUENSANG"
                                },
                                {
                                    "Text": "TULSIPUR",
                                    "Value": "TULSIPUR"
                                },
                                {
                                    "Text": "TUMKUR",
                                    "Value": "TUMKUR"
                                },
                                {
                                    "Text": "TUMSAR",
                                    "Value": "TUMSAR"
                                },
                                {
                                    "Text": "TUNDLA",
                                    "Value": "TUNDLA"
                                },
                                {
                                    "Text": "TUNI",
                                    "Value": "TUNI"
                                },
                                {
                                    "Text": "TURA",
                                    "Value": "TURA"
                                },
                                {
                                    "Text": "TURAKAPETA ",
                                    "Value": "TURAKAPETA "
                                },
                                {
                                    "Text": "TURBHE",
                                    "Value": "TURBHE"
                                },
                                {
                                    "Text": "TUTICORIN",
                                    "Value": "TUTICORIN"
                                },
                                {
                                    "Text": "UCHANA KALAN",
                                    "Value": "UCHANA KALAN"
                                },
                                {
                                    "Text": "UDAIPUR",
                                    "Value": "UDAIPUR"
                                },
                                {
                                    "Text": "UDAIPUR ",
                                    "Value": "UDAIPUR "
                                },
                                {
                                    "Text": "UDAIPUR",
                                    "Value": "UDAIPUR"
                                },
                                {
                                    "Text": "UDALGURI",
                                    "Value": "UDALGURI"
                                },
                                {
                                    "Text": "UDGIR",
                                    "Value": "UDGIR"
                                },
                                {
                                    "Text": "UDHAM SINGH NAGAR",
                                    "Value": "UDHAM SINGH NAGAR"
                                },
                                {
                                    "Text": "UDHAMPUR",
                                    "Value": "UDHAMPUR"
                                },
                                {
                                    "Text": "UDUMALPET",
                                    "Value": "UDUMALPET"
                                },
                                {
                                    "Text": "UDUMALAIPETTAI",
                                    "Value": "UDUMALAIPETTAI"
                                },
                                {
                                    "Text": "UDUPI",
                                    "Value": "UDUPI"
                                },
                                {
                                    "Text": "UDWADA",
                                    "Value": "UDWADA"
                                },
                                {
                                    "Text": "UGANI ",
                                    "Value": "UGANI "
                                },
                                {
                                    "Text": "UGGI",
                                    "Value": "UGGI"
                                },
                                {
                                    "Text": "UGRAWAI ",
                                    "Value": "UGRAWAI "
                                },
                                {
                                    "Text": "UGRA KHERI",
                                    "Value": "UGRA KHERI"
                                },
                                {
                                    "Text": "UJHANI",
                                    "Value": "UJHANI"
                                },
                                {
                                    "Text": "UJIRE",
                                    "Value": "UJIRE"
                                },
                                {
                                    "Text": "UJJAIN",
                                    "Value": "UJJAIN"
                                },
                                {
                                    "Text": "UKHRUL",
                                    "Value": "UKHRUL"
                                },
                                {
                                    "Text": "UKLANA MANDI",
                                    "Value": "UKLANA MANDI"
                                },
                                {
                                    "Text": "ULHASNAGAR",
                                    "Value": "ULHASNAGAR"
                                },
                                {
                                    "Text": "ULIMELLA ",
                                    "Value": "ULIMELLA "
                                },
                                {
                                    "Text": "ULLUBERIA",
                                    "Value": "ULLUBERIA"
                                },
                                {
                                    "Text": "ULUBERIA",
                                    "Value": "ULUBERIA"
                                },
                                {
                                    "Text": "UMARIA",
                                    "Value": "UMARIA"
                                },
                                {
                                    "Text": "UMBERGOAN",
                                    "Value": "UMBERGOAN"
                                },
                                {
                                    "Text": "UMBERGOAN",
                                    "Value": "UMBERGOAN"
                                },
                                {
                                    "Text": "UMBRAJ",
                                    "Value": "UMBRAJ"
                                },
                                {
                                    "Text": "UMRED",
                                    "Value": "UMRED"
                                },
                                {
                                    "Text": "UNA",
                                    "Value": "UNA"
                                },
                                {
                                    "Text": "UNA",
                                    "Value": "UNA"
                                },
                                {
                                    "Text": "UNAKOTI",
                                    "Value": "UNAKOTI"
                                },
                                {
                                    "Text": "UNCHAHAR",
                                    "Value": "UNCHAHAR"
                                },
                                {
                                    "Text": "UNJHA",
                                    "Value": "UNJHA"
                                },
                                {
                                    "Text": "UNNAO",
                                    "Value": "UNNAO"
                                },
                                {
                                    "Text": "UNTSAL",
                                    "Value": "UNTSAL"
                                },
                                {
                                    "Text": "UPLETA",
                                    "Value": "UPLETA"
                                },
                                {
                                    "Text": "UPPER SIANG",
                                    "Value": "UPPER SIANG"
                                },
                                {
                                    "Text": "UPPER SUBANSIRI",
                                    "Value": "UPPER SUBANSIRI"
                                },
                                {
                                    "Text": "UPPINIVALASA ",
                                    "Value": "UPPINIVALASA "
                                },
                                {
                                    "Text": "UPPUR ",
                                    "Value": "UPPUR "
                                },
                                {
                                    "Text": "URALI KANCHAN",
                                    "Value": "URALI KANCHAN"
                                },
                                {
                                    "Text": "URAN ISLAMPUR",
                                    "Value": "URAN ISLAMPUR"
                                },
                                {
                                    "Text": "URAN",
                                    "Value": "URAN"
                                },
                                {
                                    "Text": "URMAR TANDA",
                                    "Value": "URMAR TANDA"
                                },
                                {
                                    "Text": "URSE",
                                    "Value": "URSE"
                                },
                                {
                                    "Text": "USGAO",
                                    "Value": "USGAO"
                                },
                                {
                                    "Text": "U.T OF DADRA & NAGAR HAVELI",
                                    "Value": "U.T OF DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "UTLAPALLY ",
                                    "Value": "UTLAPALLY "
                                },
                                {
                                    "Text": "U.T OF DADRA & NAGAR HAVELI",
                                    "Value": "U.T OF DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "UTTARPARA",
                                    "Value": "UTTARPARA"
                                },
                                {
                                    "Text": "UTRAULA",
                                    "Value": "UTRAULA"
                                },
                                {
                                    "Text": "UTTARA KANNADA",
                                    "Value": "UTTARA KANNADA"
                                },
                                {
                                    "Text": "UTTARKASHI",
                                    "Value": "UTTARKASHI"
                                },
                                {
                                    "Text": "UTTAR DINAJPUR",
                                    "Value": "UTTAR DINAJPUR"
                                },
                                {
                                    "Text": "UTWAD ",
                                    "Value": "UTWAD "
                                },
                                {
                                    "Text": "VADALI",
                                    "Value": "VADALI"
                                },
                                {
                                    "Text": "VADAKARA",
                                    "Value": "VADAKARA"
                                },
                                {
                                    "Text": "VADAKKANCHERI",
                                    "Value": "VADAKKANCHERI"
                                },
                                {
                                    "Text": "VADAVALLI",
                                    "Value": "VADAVALLI"
                                },
                                {
                                    "Text": "VADDIPA ",
                                    "Value": "VADDIPA "
                                },
                                {
                                    "Text": "VADLAKONDA ",
                                    "Value": "VADLAKONDA "
                                },
                                {
                                    "Text": "VADODARA",
                                    "Value": "VADODARA"
                                },
                                {
                                    "Text": "VADUJ",
                                    "Value": "VADUJ"
                                },
                                {
                                    "Text": "VADUJ",
                                    "Value": "VADUJ"
                                },
                                {
                                    "Text": "VAIJAPUR",
                                    "Value": "VAIJAPUR"
                                },
                                {
                                    "Text": "VAIKOM",
                                    "Value": "VAIKOM"
                                },
                                {
                                    "Text": "VAISHALI",
                                    "Value": "VAISHALI"
                                },
                                {
                                    "Text": "VALANCHERY",
                                    "Value": "VALANCHERY"
                                },
                                {
                                    "Text": "VALLIOOR",
                                    "Value": "VALLIOOR"
                                },
                                {
                                    "Text": "VALLABH VIDHYA NAGAR",
                                    "Value": "VALLABH VIDHYA NAGAR"
                                },
                                {
                                    "Text": "VALPOI",
                                    "Value": "VALPOI"
                                },
                                {
                                    "Text": "VALSAD",
                                    "Value": "VALSAD"
                                },
                                {
                                    "Text": "VALSARVAKKAM",
                                    "Value": "VALSARVAKKAM"
                                },
                                {
                                    "Text": "VANAGARAM",
                                    "Value": "VANAGARAM"
                                },
                                {
                                    "Text": "VANASGAON",
                                    "Value": "VANASGAON"
                                },
                                {
                                    "Text": "VANGANI",
                                    "Value": "VANGANI"
                                },
                                {
                                    "Text": "VANIYAMBADI",
                                    "Value": "VANIYAMBADI"
                                },
                                {
                                    "Text": "VANNANKULAM",
                                    "Value": "VANNANKULAM"
                                },
                                {
                                    "Text": "VANNEL K",
                                    "Value": "VANNEL K"
                                },
                                {
                                    "Text": "VANSDA",
                                    "Value": "VANSDA"
                                },
                                {
                                    "Text": "VAPI",
                                    "Value": "VAPI"
                                },
                                {
                                    "Text": "VARANASI",
                                    "Value": "VARANASI"
                                },
                                {
                                    "Text": "VARCA",
                                    "Value": "VARCA"
                                },
                                {
                                    "Text": "VARKALA",
                                    "Value": "VARKALA"
                                },
                                {
                                    "Text": "VARSAMEDI",
                                    "Value": "VARSAMEDI"
                                },
                                {
                                    "Text": "VASAI",
                                    "Value": "VASAI"
                                },
                                {
                                    "Text": "VASAD",
                                    "Value": "VASAD"
                                },
                                {
                                    "Text": "VASCO",
                                    "Value": "VASCO"
                                },
                                {
                                    "Text": "VASHI",
                                    "Value": "VASHI"
                                },
                                {
                                    "Text": "VASAI ROAD",
                                    "Value": "VASAI ROAD"
                                },
                                {
                                    "Text": "VATAKARA",
                                    "Value": "VATAKARA"
                                },
                                {
                                    "Text": "VATANAPPILLY",
                                    "Value": "VATANAPPILLY"
                                },
                                {
                                    "Text": "VATANAPPALLY",
                                    "Value": "VATANAPPALLY"
                                },
                                {
                                    "Text": "VAVDI",
                                    "Value": "VAVDI"
                                },
                                {
                                    "Text": "VAVILALA ",
                                    "Value": "VAVILALA "
                                },
                                {
                                    "Text": "VAZHAPADI ",
                                    "Value": "VAZHAPADI "
                                },
                                {
                                    "Text": "VALLABHIPUR",
                                    "Value": "VALLABHIPUR"
                                },
                                {
                                    "Text": "VEERLAPALEM ",
                                    "Value": "VEERLAPALEM "
                                },
                                {
                                    "Text": "VEERANNAPALEM ",
                                    "Value": "VEERANNAPALEM "
                                },
                                {
                                    "Text": "VEGAVARAM ",
                                    "Value": "VEGAVARAM "
                                },
                                {
                                    "Text": "VEJALPUR",
                                    "Value": "VEJALPUR"
                                },
                                {
                                    "Text": "VEJALPUR",
                                    "Value": "VEJALPUR"
                                },
                                {
                                    "Text": "VELIYANAD",
                                    "Value": "VELIYANAD"
                                },
                                {
                                    "Text": "VELLORE",
                                    "Value": "VELLORE"
                                },
                                {
                                    "Text": "VELLA ",
                                    "Value": "VELLA "
                                },
                                {
                                    "Text": "VELLIMALAI ",
                                    "Value": "VELLIMALAI "
                                },
                                {
                                    "Text": "VEMNOOR ",
                                    "Value": "VEMNOOR "
                                },
                                {
                                    "Text": "VEMULAKURTHI",
                                    "Value": "VEMULAKURTHI"
                                },
                                {
                                    "Text": "VEMULAWADA",
                                    "Value": "VEMULAWADA"
                                },
                                {
                                    "Text": "VENGALA RAO COLONY ",
                                    "Value": "VENGALA RAO COLONY "
                                },
                                {
                                    "Text": "VENKATAGIRI",
                                    "Value": "VENKATAGIRI"
                                },
                                {
                                    "Text": "VENKATADRI PALEM ",
                                    "Value": "VENKATADRI PALEM "
                                },
                                {
                                    "Text": "VENKATAPURAM ",
                                    "Value": "VENKATAPURAM "
                                },
                                {
                                    "Text": "VENKATAGIRIKOTE ",
                                    "Value": "VENKATAGIRIKOTE "
                                },
                                {
                                    "Text": "VENTURU ",
                                    "Value": "VENTURU "
                                },
                                {
                                    "Text": "VERAVAL",
                                    "Value": "VERAVAL"
                                },
                                {
                                    "Text": "VEREM",
                                    "Value": "VEREM"
                                },
                                {
                                    "Text": "VERNA",
                                    "Value": "VERNA"
                                },
                                {
                                    "Text": "VERNA",
                                    "Value": "VERNA"
                                },
                                {
                                    "Text": "VICARABAD",
                                    "Value": "VICARABAD"
                                },
                                {
                                    "Text": "VIDISHA",
                                    "Value": "VIDISHA"
                                },
                                {
                                    "Text": "VIJAPUR",
                                    "Value": "VIJAPUR"
                                },
                                {
                                    "Text": "VIJAYWADA",
                                    "Value": "VIJAYWADA"
                                },
                                {
                                    "Text": "VIJAYANAGAR III STAGE ",
                                    "Value": "VIJAYANAGAR III STAGE "
                                },
                                {
                                    "Text": "VIJAINAGAR",
                                    "Value": "VIJAINAGAR"
                                },
                                {
                                    "Text": "VIJAIPUR",
                                    "Value": "VIJAIPUR"
                                },
                                {
                                    "Text": "VIJAYAWADA",
                                    "Value": "VIJAYAWADA"
                                },
                                {
                                    "Text": "VIJAYPURA",
                                    "Value": "VIJAYPURA"
                                },
                                {
                                    "Text": "VIKASNAGAR",
                                    "Value": "VIKASNAGAR"
                                },
                                {
                                    "Text": "VIKRAMGAD",
                                    "Value": "VIKRAMGAD"
                                },
                                {
                                    "Text": "VILLUPURAM",
                                    "Value": "VILLUPURAM"
                                },
                                {
                                    "Text": "VINUKONDA",
                                    "Value": "VINUKONDA"
                                },
                                {
                                    "Text": "VIRAMGAM",
                                    "Value": "VIRAMGAM"
                                },
                                {
                                    "Text": "VIRAR",
                                    "Value": "VIRAR"
                                },
                                {
                                    "Text": "VIRAJPET",
                                    "Value": "VIRAJPET"
                                },
                                {
                                    "Text": "VIRUDHUNAGAR",
                                    "Value": "VIRUDHUNAGAR"
                                },
                                {
                                    "Text": "VISAKHAPATNAM",
                                    "Value": "VISAKHAPATNAM"
                                },
                                {
                                    "Text": "VISAVADAR",
                                    "Value": "VISAVADAR"
                                },
                                {
                                    "Text": "VISNAGAR",
                                    "Value": "VISNAGAR"
                                },
                                {
                                    "Text": "VITA",
                                    "Value": "VITA"
                                },
                                {
                                    "Text": "VIZIANAGARAM",
                                    "Value": "VIZIANAGARAM"
                                },
                                {
                                    "Text": "VAJRESHWARI",
                                    "Value": "VAJRESHWARI"
                                },
                                {
                                    "Text": "VIKASPURI",
                                    "Value": "VIKASPURI"
                                },
                                {
                                    "Text": "VIMAN NAGAR",
                                    "Value": "VIMAN NAGAR"
                                },
                                {
                                    "Text": "VENGURLA",
                                    "Value": "VENGURLA"
                                },
                                {
                                    "Text": "VRINDAVAN",
                                    "Value": "VRINDAVAN"
                                },
                                {
                                    "Text": "VERSOVA",
                                    "Value": "VERSOVA"
                                },
                                {
                                    "Text": "VASHIND",
                                    "Value": "VASHIND"
                                },
                                {
                                    "Text": "VASNA",
                                    "Value": "VASNA"
                                },
                                {
                                    "Text": "VITHALWADI",
                                    "Value": "VITHALWADI"
                                },
                                {
                                    "Text": "VAITARNA",
                                    "Value": "VAITARNA"
                                },
                                {
                                    "Text": "VUYYURU",
                                    "Value": "VUYYURU"
                                },
                                {
                                    "Text": "VYARA",
                                    "Value": "VYARA"
                                },
                                {
                                    "Text": "WADAKANCHERY",
                                    "Value": "WADAKANCHERY"
                                },
                                {
                                    "Text": "WADAPARTHY ",
                                    "Value": "WADAPARTHY "
                                },
                                {
                                    "Text": "WADALA KALAN ",
                                    "Value": "WADALA KALAN "
                                },
                                {
                                    "Text": "WADA",
                                    "Value": "WADA"
                                },
                                {
                                    "Text": "WADAKKANCHERY",
                                    "Value": "WADAKKANCHERY"
                                },
                                {
                                    "Text": "WADHWAN",
                                    "Value": "WADHWAN"
                                },
                                {
                                    "Text": "WADI",
                                    "Value": "WADI"
                                },
                                {
                                    "Text": "WADRAFNAGAR",
                                    "Value": "WADRAFNAGAR"
                                },
                                {
                                    "Text": "WAHABWALA",
                                    "Value": "WAHABWALA"
                                },
                                {
                                    "Text": "WAI",
                                    "Value": "WAI"
                                },
                                {
                                    "Text": "WAIDHAN",
                                    "Value": "WAIDHAN"
                                },
                                {
                                    "Text": "WAIDHAN - SINGRAULI",
                                    "Value": "WAIDHAN - SINGRAULI"
                                },
                                {
                                    "Text": "WAKULNI ",
                                    "Value": "WAKULNI "
                                },
                                {
                                    "Text": "WALAJAPET",
                                    "Value": "WALAJAPET"
                                },
                                {
                                    "Text": "WALSA KHALSA ",
                                    "Value": "WALSA KHALSA "
                                },
                                {
                                    "Text": "WANAPARTHY",
                                    "Value": "WANAPARTHY"
                                },
                                {
                                    "Text": "WANI",
                                    "Value": "WANI"
                                },
                                {
                                    "Text": "WANKANER",
                                    "Value": "WANKANER"
                                },
                                {
                                    "Text": "WARANGAL",
                                    "Value": "WARANGAL"
                                },
                                {
                                    "Text": "WARDHA",
                                    "Value": "WARDHA"
                                },
                                {
                                    "Text": "WARORA",
                                    "Value": "WARORA"
                                },
                                {
                                    "Text": "WARUD",
                                    "Value": "WARUD"
                                },
                                {
                                    "Text": "WARUDKAZI ",
                                    "Value": "WARUDKAZI "
                                },
                                {
                                    "Text": "WARYAM KHERA",
                                    "Value": "WARYAM KHERA"
                                },
                                {
                                    "Text": "WARZADI ",
                                    "Value": "WARZADI "
                                },
                                {
                                    "Text": "WASHIM",
                                    "Value": "WASHIM"
                                },
                                {
                                    "Text": "WAYANAD",
                                    "Value": "WAYANAD"
                                },
                                {
                                    "Text": "WEST NIMAR",
                                    "Value": "WEST NIMAR"
                                },
                                {
                                    "Text": "WEST CHAMPARAN",
                                    "Value": "WEST CHAMPARAN"
                                },
                                {
                                    "Text": "WEST DELHI",
                                    "Value": "WEST DELHI"
                                },
                                {
                                    "Text": "WEST GARO HILLS",
                                    "Value": "WEST GARO HILLS"
                                },
                                {
                                    "Text": "WEST GODAVARI",
                                    "Value": "WEST GODAVARI"
                                },
                                {
                                    "Text": "WEST KAMENG",
                                    "Value": "WEST KAMENG"
                                },
                                {
                                    "Text": "WEST KHASI HILLS",
                                    "Value": "WEST KHASI HILLS"
                                },
                                {
                                    "Text": "WEST MIDNAPORE",
                                    "Value": "WEST MIDNAPORE"
                                },
                                {
                                    "Text": "WEST SIANG",
                                    "Value": "WEST SIANG"
                                },
                                {
                                    "Text": "WEST SIKKIM",
                                    "Value": "WEST SIKKIM"
                                },
                                {
                                    "Text": "WEST SINGHBHUM",
                                    "Value": "WEST SINGHBHUM"
                                },
                                {
                                    "Text": "WEST TRIPURA",
                                    "Value": "WEST TRIPURA"
                                },
                                {
                                    "Text": "WAGHODIA",
                                    "Value": "WAGHODIA"
                                },
                                {
                                    "Text": "WILLIAMNAGAR",
                                    "Value": "WILLIAMNAGAR"
                                },
                                {
                                    "Text": "WARANANAGAR",
                                    "Value": "WARANANAGAR"
                                },
                                {
                                    "Text": "WANOWRIE",
                                    "Value": "WANOWRIE"
                                },
                                {
                                    "Text": "WOKHA",
                                    "Value": "WOKHA"
                                },
                                {
                                    "Text": "YADGIR",
                                    "Value": "YADGIR"
                                },
                                {
                                    "Text": "YADGARPALLY ",
                                    "Value": "YADGARPALLY "
                                },
                                {
                                    "Text": "YAIRIPOK",
                                    "Value": "YAIRIPOK"
                                },
                                {
                                    "Text": "YAMUNA NAGAR",
                                    "Value": "YAMUNA NAGAR"
                                },
                                {
                                    "Text": "YAMUNA NAGAR",
                                    "Value": "YAMUNA NAGAR"
                                },
                                {
                                    "Text": "YAMUNANAGAR",
                                    "Value": "YAMUNANAGAR"
                                },
                                {
                                    "Text": "YANAM",
                                    "Value": "YANAM"
                                },
                                {
                                    "Text": "YAVATMAL",
                                    "Value": "YAVATMAL"
                                },
                                {
                                    "Text": "YELLAPUR",
                                    "Value": "YELLAPUR"
                                },
                                {
                                    "Text": "YELLAPPAGONDA ",
                                    "Value": "YELLAPPAGONDA "
                                },
                                {
                                    "Text": "YEMMIGANUR",
                                    "Value": "YEMMIGANUR"
                                },
                                {
                                    "Text": "YENKIRYAL ",
                                    "Value": "YENKIRYAL "
                                },
                                {
                                    "Text": "YERRAGOLLA PAHAD ",
                                    "Value": "YERRAGOLLA PAHAD "
                                },
                                {
                                    "Text": "YESWANTAPUR ",
                                    "Value": "YESWANTAPUR "
                                },
                                {
                                    "Text": "YEVLA",
                                    "Value": "YEVLA"
                                },
                                {
                                    "Text": "YEVOLA",
                                    "Value": "YEVOLA"
                                },
                                {
                                    "Text": "Y G PETA ",
                                    "Value": "Y G PETA "
                                },
                                {
                                    "Text": "YINGKIONG",
                                    "Value": "YINGKIONG"
                                },
                                {
                                    "Text": "YELLAPUR",
                                    "Value": "YELLAPUR"
                                },
                                {
                                    "Text": "ZAHIRABAD",
                                    "Value": "ZAHIRABAD"
                                },
                                {
                                    "Text": "ZAINAKOTE",
                                    "Value": "ZAINAKOTE"
                                },
                                {
                                    "Text": "ZINKIBHADRA",
                                    "Value": "ZINKIBHADRA"
                                },
                                {
                                    "Text": "ZIRA",
                                    "Value": "ZIRA"
                                },
                                {
                                    "Text": "ZIRAYATHNAGAR ",
                                    "Value": "ZIRAYATHNAGAR "
                                },
                                {
                                    "Text": "ZIRAKPUR",
                                    "Value": "ZIRAKPUR"
                                },
                                {
                                    "Text": "ZIRO",
                                    "Value": "ZIRO"
                                },
                                {
                                    "Text": "ZUARINAGAR",
                                    "Value": "ZUARINAGAR"
                                },
                                {
                                    "Text": "ZIAUDDIN PUR",
                                    "Value": "ZIAUDDIN PUR"
                                },
                                {
                                    "Text": "ZUNHEBOTTO",
                                    "Value": "ZUNHEBOTTO"
                                }
                            ],
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "state": {
                            "id": "1384",
                            "label": "Office State",
                            "name": "state",
                            "description": "Office State",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "ANDAMAN & NICOBAR ISLANDS",
                                    "Value": "ANDAMAN & NICOBAR ISLANDS"
                                },
                                {
                                    "Text": "ANDHRA PRADESH",
                                    "Value": "ANDHRA PRADESH"
                                },
                                {
                                    "Text": "ARUNACHAL PRADESH",
                                    "Value": "ARUNACHAL PRADESH"
                                },
                                {
                                    "Text": "ASSAM",
                                    "Value": "ASSAM"
                                },
                                {
                                    "Text": "BIHAR",
                                    "Value": "BIHAR"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHATTISGARH",
                                    "Value": "CHATTISGARH"
                                },
                                {
                                    "Text": "DAMAN & DIU",
                                    "Value": "DAMAN & DIU"
                                },
                                {
                                    "Text": "DELHI",
                                    "Value": "DELHI"
                                },
                                {
                                    "Text": "DADRA & NAGAR HAVELI",
                                    "Value": "DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "GOA",
                                    "Value": "GOA"
                                },
                                {
                                    "Text": "GUJARAT",
                                    "Value": "GUJARAT"
                                },
                                {
                                    "Text": "HARYANA",
                                    "Value": "HARYANA"
                                },
                                {
                                    "Text": "HIMACHAL PRADESH",
                                    "Value": "HIMACHAL PRADESH"
                                },
                                {
                                    "Text": "JAMMU & KASHMIR",
                                    "Value": "JAMMU & KASHMIR"
                                },
                                {
                                    "Text": "JHARKHAND",
                                    "Value": "JHARKHAND"
                                },
                                {
                                    "Text": "KARNATAKA",
                                    "Value": "KARNATAKA"
                                },
                                {
                                    "Text": "KERALA",
                                    "Value": "KERALA"
                                },
                                {
                                    "Text": "LAKSHADWEEP",
                                    "Value": "LAKSHADWEEP"
                                },
                                {
                                    "Text": "MAHARASHTRA",
                                    "Value": "MAHARASHTRA"
                                },
                                {
                                    "Text": "MANIPUR",
                                    "Value": "MANIPUR"
                                },
                                {
                                    "Text": "MEGHALAYA",
                                    "Value": "MEGHALAYA"
                                },
                                {
                                    "Text": "MIZORAM",
                                    "Value": "MIZORAM"
                                },
                                {
                                    "Text": "MADHYA PRADESH",
                                    "Value": "MADHYA PRADESH"
                                },
                                {
                                    "Text": "NAGALAND",
                                    "Value": "NAGALAND"
                                },
                                {
                                    "Text": "ODISHA",
                                    "Value": "ODISHA"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PUNJAB",
                                    "Value": "PUNJAB"
                                },
                                {
                                    "Text": "RAJASTHAN",
                                    "Value": "RAJASTHAN"
                                },
                                {
                                    "Text": "SIKKIM",
                                    "Value": "SIKKIM"
                                },
                                {
                                    "Text": "TAMIL NADU",
                                    "Value": "TAMIL NADU"
                                },
                                {
                                    "Text": "TELANGANA",
                                    "Value": "TELANGANA"
                                },
                                {
                                    "Text": "TRIPURA",
                                    "Value": "TRIPURA"
                                },
                                {
                                    "Text": "UTTAR PRADESH",
                                    "Value": "UTTAR PRADESH"
                                },
                                {
                                    "Text": "UTTARAKHAND",
                                    "Value": "UTTARAKHAND"
                                },
                                {
                                    "Text": "WEST BENGAL",
                                    "Value": "WEST BENGAL"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "country": {
                            "id": "1274",
                            "label": "Office Country",
                            "name": "country",
                            "description": "Office Country",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Austria",
                                    "Value": "Austria"
                                },
                                {
                                    "Text": "Antigua and Barbuda",
                                    "Value": "Antigua and Barbuda"
                                },
                                {
                                    "Text": "Yemen",
                                    "Value": "Yemen"
                                },
                                {
                                    "Text": "Afghanistan",
                                    "Value": "Afghanistan"
                                },
                                {
                                    "Text": "Angola",
                                    "Value": "Angola"
                                },
                                {
                                    "Text": "Anguilla",
                                    "Value": "Anguilla"
                                },
                                {
                                    "Text": "Albania",
                                    "Value": "Albania"
                                },
                                {
                                    "Text": "Andorra",
                                    "Value": "Andorra"
                                },
                                {
                                    "Text": "Aruba",
                                    "Value": "Aruba"
                                },
                                {
                                    "Text": "Armenia",
                                    "Value": "Armenia"
                                },
                                {
                                    "Text": "Australia",
                                    "Value": "Australia"
                                },
                                {
                                    "Text": "Azerbaijan",
                                    "Value": "Azerbaijan"
                                },
                                {
                                    "Text": "Belgium",
                                    "Value": "Belgium"
                                },
                                {
                                    "Text": "Bangladesh",
                                    "Value": "Bangladesh"
                                },
                                {
                                    "Text": "Barbados",
                                    "Value": "Barbados"
                                },
                                {
                                    "Text": "Bermuda",
                                    "Value": "Bermuda"
                                },
                                {
                                    "Text": "Bulgaria",
                                    "Value": "Bulgaria"
                                },
                                {
                                    "Text": "Belize",
                                    "Value": "Belize"
                                },
                                {
                                    "Text": "Bhutan",
                                    "Value": "Bhutan"
                                },
                                {
                                    "Text": "Burkina Faso",
                                    "Value": "Burkina Faso"
                                },
                                {
                                    "Text": "Belarus",
                                    "Value": "Belarus"
                                },
                                {
                                    "Text": "Brunei",
                                    "Value": "Brunei"
                                },
                                {
                                    "Text": "Bolivia",
                                    "Value": "Bolivia"
                                },
                                {
                                    "Text": "Brazil",
                                    "Value": "Brazil"
                                },
                                {
                                    "Text": "Burundi",
                                    "Value": "Burundi"
                                },
                                {
                                    "Text": "Burma",
                                    "Value": "Burma"
                                },
                                {
                                    "Text": "Bahrain",
                                    "Value": "Bahrain"
                                },
                                {
                                    "Text": "Britain",
                                    "Value": "Britain"
                                },
                                {
                                    "Text": "Bahamas",
                                    "Value": "Bahamas"
                                },
                                {
                                    "Text": "Bosnia",
                                    "Value": "Bosnia"
                                },
                                {
                                    "Text": "Myanmar",
                                    "Value": "Myanmar"
                                },
                                {
                                    "Text": "British Virgin Islands",
                                    "Value": "British Virgin Islands"
                                },
                                {
                                    "Text": "Cuba",
                                    "Value": "Cuba"
                                },
                                {
                                    "Text": "Canada",
                                    "Value": "Canada"
                                },
                                {
                                    "Text": "Switzerland",
                                    "Value": "Switzerland"
                                },
                                {
                                    "Text": "Chad",
                                    "Value": "Chad"
                                },
                                {
                                    "Text": "China",
                                    "Value": "China"
                                },
                                {
                                    "Text": "Ivory Coast",
                                    "Value": "Ivory Coast"
                                },
                                {
                                    "Text": "Sri Lanka",
                                    "Value": "Sri Lanka"
                                },
                                {
                                    "Text": "Cameroon",
                                    "Value": "Cameroon"
                                },
                                {
                                    "Text": "Canary Islands",
                                    "Value": "Canary Islands"
                                },
                                {
                                    "Text": "Colombia",
                                    "Value": "Colombia"
                                },
                                {
                                    "Text": "Comoros",
                                    "Value": "Comoros"
                                },
                                {
                                    "Text": "Cape Verde",
                                    "Value": "Cape Verde"
                                },
                                {
                                    "Text": "Costa Rica",
                                    "Value": "Costa Rica"
                                },
                                {
                                    "Text": "Curacao",
                                    "Value": "Curacao"
                                },
                                {
                                    "Text": "Cape Town",
                                    "Value": "Cape Town"
                                },
                                {
                                    "Text": "Cote dIvoire",
                                    "Value": "Cote dIvoire"
                                },
                                {
                                    "Text": "Cyprus",
                                    "Value": "Cyprus"
                                },
                                {
                                    "Text": "Cayman Islands",
                                    "Value": "Cayman Islands"
                                },
                                {
                                    "Text": "Czech",
                                    "Value": "Czech"
                                },
                                {
                                    "Text": "Germany",
                                    "Value": "Germany"
                                },
                                {
                                    "Text": "Djibouti",
                                    "Value": "Djibouti"
                                },
                                {
                                    "Text": "Denmark",
                                    "Value": "Denmark"
                                },
                                {
                                    "Text": "Dominican Republic",
                                    "Value": "Dominican Republic"
                                },
                                {
                                    "Text": "Democratic Republic of Congo",
                                    "Value": "Democratic Republic of Congo"
                                },
                                {
                                    "Text": "Benin",
                                    "Value": "Benin"
                                },
                                {
                                    "Text": "Algeria",
                                    "Value": "Algeria"
                                },
                                {
                                    "Text": "Spain",
                                    "Value": "Spain"
                                },
                                {
                                    "Text": "EastTimor",
                                    "Value": "EastTimor"
                                },
                                {
                                    "Text": "East Africa",
                                    "Value": "East Africa"
                                },
                                {
                                    "Text": "Kenya",
                                    "Value": "Kenya"
                                },
                                {
                                    "Text": "Tanzania",
                                    "Value": "Tanzania"
                                },
                                {
                                    "Text": "Uganda",
                                    "Value": "Uganda"
                                },
                                {
                                    "Text": "Ecuador",
                                    "Value": "Ecuador"
                                },
                                {
                                    "Text": "England",
                                    "Value": "England"
                                },
                                {
                                    "Text": "Equitorial Guinea",
                                    "Value": "Equitorial Guinea"
                                },
                                {
                                    "Text": "Eritrea",
                                    "Value": "Eritrea"
                                },
                                {
                                    "Text": "El Salvador",
                                    "Value": "El Salvador"
                                },
                                {
                                    "Text": "Egypt",
                                    "Value": "Egypt"
                                },
                                {
                                    "Text": "Ethiopia",
                                    "Value": "Ethiopia"
                                },
                                {
                                    "Text": "Estonia",
                                    "Value": "Estonia"
                                },
                                {
                                    "Text": "France",
                                    "Value": "France"
                                },
                                {
                                    "Text": "Finland",
                                    "Value": "Finland"
                                },
                                {
                                    "Text": "Fiji",
                                    "Value": "Fiji"
                                },
                                {
                                    "Text": "Liechtenstein",
                                    "Value": "Liechtenstein"
                                },
                                {
                                    "Text": "Falkland Islands",
                                    "Value": "Falkland Islands"
                                },
                                {
                                    "Text": "French Guiana",
                                    "Value": "French Guiana"
                                },
                                {
                                    "Text": "French Polynesia",
                                    "Value": "French Polynesia"
                                },
                                {
                                    "Text": "Great Britain",
                                    "Value": "Great Britain"
                                },
                                {
                                    "Text": "Alderney",
                                    "Value": "Alderney"
                                },
                                {
                                    "Text": "Gabon",
                                    "Value": "Gabon"
                                },
                                {
                                    "Text": "Guinea bissau",
                                    "Value": "Guinea bissau"
                                },
                                {
                                    "Text": "Gibraltar",
                                    "Value": "Gibraltar"
                                },
                                {
                                    "Text": "Guatemala",
                                    "Value": "Guatemala"
                                },
                                {
                                    "Text": "Guadeloupe",
                                    "Value": "Guadeloupe"
                                },
                                {
                                    "Text": "Ghana",
                                    "Value": "Ghana"
                                },
                                {
                                    "Text": "Gambia",
                                    "Value": "Gambia"
                                },
                                {
                                    "Text": "Greenland",
                                    "Value": "Greenland"
                                },
                                {
                                    "Text": "Greece",
                                    "Value": "Greece"
                                },
                                {
                                    "Text": "Georgia",
                                    "Value": "Georgia"
                                },
                                {
                                    "Text": "Guinea",
                                    "Value": "Guinea"
                                },
                                {
                                    "Text": "Guam",
                                    "Value": "Guam"
                                },
                                {
                                    "Text": "Guyana",
                                    "Value": "Guyana"
                                },
                                {
                                    "Text": "Hungary",
                                    "Value": "Hungary"
                                },
                                {
                                    "Text": "Honduras",
                                    "Value": "Honduras"
                                },
                                {
                                    "Text": "Hong Kong",
                                    "Value": "Hong Kong"
                                },
                                {
                                    "Text": "Croatia",
                                    "Value": "Croatia"
                                },
                                {
                                    "Text": "Italy",
                                    "Value": "Italy"
                                },
                                {
                                    "Text": "Czech Republic",
                                    "Value": "Czech Republic"
                                },
                                {
                                    "Text": "Israel",
                                    "Value": "Israel"
                                },
                                {
                                    "Text": "India",
                                    "Value": "India"
                                },
                                {
                                    "Text": "Iran",
                                    "Value": "Iran"
                                },
                                {
                                    "Text": "Ireland",
                                    "Value": "Ireland"
                                },
                                {
                                    "Text": "Iraq",
                                    "Value": "Iraq"
                                },
                                {
                                    "Text": "Iceland",
                                    "Value": "Iceland"
                                },
                                {
                                    "Text": "Japan",
                                    "Value": "Japan"
                                },
                                {
                                    "Text": "Jamaica",
                                    "Value": "Jamaica"
                                },
                                {
                                    "Text": "Jordan",
                                    "Value": "Jordan"
                                },
                                {
                                    "Text": "Cambodia",
                                    "Value": "Cambodia"
                                },
                                {
                                    "Text": "Kyrgyzstan",
                                    "Value": "Kyrgyzstan"
                                },
                                {
                                    "Text": "Kiribati",
                                    "Value": "Kiribati"
                                },
                                {
                                    "Text": "Kazhakistan",
                                    "Value": "Kazhakistan"
                                },
                                {
                                    "Text": "Kuwait",
                                    "Value": "Kuwait"
                                },
                                {
                                    "Text": "Luxembourg",
                                    "Value": "Luxembourg"
                                },
                                {
                                    "Text": "Laos",
                                    "Value": "Laos"
                                },
                                {
                                    "Text": "Libya",
                                    "Value": "Libya"
                                },
                                {
                                    "Text": "Liberia",
                                    "Value": "Liberia"
                                },
                                {
                                    "Text": "Lesotho",
                                    "Value": "Lesotho"
                                },
                                {
                                    "Text": "Lithuania",
                                    "Value": "Lithuania"
                                },
                                {
                                    "Text": "Latvia",
                                    "Value": "Latvia"
                                },
                                {
                                    "Text": "Malta",
                                    "Value": "Malta"
                                },
                                {
                                    "Text": "Morocco",
                                    "Value": "Morocco"
                                },
                                {
                                    "Text": "Malaysia",
                                    "Value": "Malaysia"
                                },
                                {
                                    "Text": "Monaco",
                                    "Value": "Monaco"
                                },
                                {
                                    "Text": "Micronesia",
                                    "Value": "Micronesia"
                                },
                                {
                                    "Text": "Macau",
                                    "Value": "Macau"
                                },
                                {
                                    "Text": "Madeira",
                                    "Value": "Madeira"
                                },
                                {
                                    "Text": "Moldova",
                                    "Value": "Moldova"
                                },
                                {
                                    "Text": "Mexico",
                                    "Value": "Mexico"
                                },
                                {
                                    "Text": "Montenegro",
                                    "Value": "Montenegro"
                                },
                                {
                                    "Text": "Mangolia",
                                    "Value": "Mangolia"
                                },
                                {
                                    "Text": "Macedonia",
                                    "Value": "Macedonia"
                                },
                                {
                                    "Text": "Maldives",
                                    "Value": "Maldives"
                                },
                                {
                                    "Text": "Mauritius",
                                    "Value": "Mauritius"
                                },
                                {
                                    "Text": "Marshall Islands",
                                    "Value": "Marshall Islands"
                                },
                                {
                                    "Text": "Martinique",
                                    "Value": "Martinique"
                                },
                                {
                                    "Text": "Monteserrat",
                                    "Value": "Monteserrat"
                                },
                                {
                                    "Text": "Malawi",
                                    "Value": "Malawi"
                                },
                                {
                                    "Text": "Mozambique",
                                    "Value": "Mozambique"
                                },
                                {
                                    "Text": "Norway",
                                    "Value": "Norway"
                                },
                                {
                                    "Text": "Nauru",
                                    "Value": "Nauru"
                                },
                                {
                                    "Text": "New Caledonia",
                                    "Value": "New Caledonia"
                                },
                                {
                                    "Text": "Nepal",
                                    "Value": "Nepal"
                                },
                                {
                                    "Text": "Nicaragua",
                                    "Value": "Nicaragua"
                                },
                                {
                                    "Text": "Northern Ireland",
                                    "Value": "Northern Ireland"
                                },
                                {
                                    "Text": "Niue",
                                    "Value": "Niue"
                                },
                                {
                                    "Text": "North Korea",
                                    "Value": "North Korea"
                                },
                                {
                                    "Text": "Netherlands",
                                    "Value": "Netherlands"
                                },
                                {
                                    "Text": "Namibia",
                                    "Value": "Namibia"
                                },
                                {
                                    "Text": "New Zealand",
                                    "Value": "New Zealand"
                                },
                                {
                                    "Text": "Oman",
                                    "Value": "Oman"
                                },
                                {
                                    "Text": "Other",
                                    "Value": "Other"
                                },
                                {
                                    "Text": "Portugal",
                                    "Value": "Portugal"
                                },
                                {
                                    "Text": "Panama",
                                    "Value": "Panama"
                                },
                                {
                                    "Text": "Peru",
                                    "Value": "Peru"
                                },
                                {
                                    "Text": "Pakistan",
                                    "Value": "Pakistan"
                                },
                                {
                                    "Text": "Poland",
                                    "Value": "Poland"
                                },
                                {
                                    "Text": "Palestine",
                                    "Value": "Palestine"
                                },
                                {
                                    "Text": "Palau",
                                    "Value": "Palau"
                                },
                                {
                                    "Text": "Papua New guinea",
                                    "Value": "Papua New guinea"
                                },
                                {
                                    "Text": "Puerto Rico",
                                    "Value": "Puerto Rico"
                                },
                                {
                                    "Text": "Paraguay",
                                    "Value": "Paraguay"
                                },
                                {
                                    "Text": "Qatar",
                                    "Value": "Qatar"
                                },
                                {
                                    "Text": "Argentina",
                                    "Value": "Argentina"
                                },
                                {
                                    "Text": "Botswana",
                                    "Value": "Botswana"
                                },
                                {
                                    "Text": "Central African Republic",
                                    "Value": "Central African Republic"
                                },
                                {
                                    "Text": "Congo",
                                    "Value": "Congo"
                                },
                                {
                                    "Text": "Chile",
                                    "Value": "Chile"
                                },
                                {
                                    "Text": "Reunion",
                                    "Value": "Reunion"
                                },
                                {
                                    "Text": "Haiti",
                                    "Value": "Haiti"
                                },
                                {
                                    "Text": "Indonesia",
                                    "Value": "Indonesia"
                                },
                                {
                                    "Text": "Mauritania",
                                    "Value": "Mauritania"
                                },
                                {
                                    "Text": "Lebanon",
                                    "Value": "Lebanon"
                                },
                                {
                                    "Text": "Madagascar",
                                    "Value": "Madagascar"
                                },
                                {
                                    "Text": "Mali",
                                    "Value": "Mali"
                                },
                                {
                                    "Text": "Niger",
                                    "Value": "Niger"
                                },
                                {
                                    "Text": "Romania",
                                    "Value": "Romania"
                                },
                                {
                                    "Text": "Republic of Congo",
                                    "Value": "Republic of Congo"
                                },
                                {
                                    "Text": "Republic of Korea",
                                    "Value": "Republic of Korea"
                                },
                                {
                                    "Text": "Uruguay",
                                    "Value": "Uruguay"
                                },
                                {
                                    "Text": "Philippines",
                                    "Value": "Philippines"
                                },
                                {
                                    "Text": "RSA",
                                    "Value": "RSA"
                                },
                                {
                                    "Text": "San Marino",
                                    "Value": "San Marino"
                                },
                                {
                                    "Text": "Russia",
                                    "Value": "Russia"
                                },
                                {
                                    "Text": "Rwanda",
                                    "Value": "Rwanda"
                                },
                                {
                                    "Text": "Sweden",
                                    "Value": "Sweden"
                                },
                                {
                                    "Text": "Saudi Arabia",
                                    "Value": "Saudi Arabia"
                                },
                                {
                                    "Text": "Scotland",
                                    "Value": "Scotland"
                                },
                                {
                                    "Text": "Swaziland",
                                    "Value": "Swaziland"
                                },
                                {
                                    "Text": "Singapore",
                                    "Value": "Singapore"
                                },
                                {
                                    "Text": "Slovakia",
                                    "Value": "Slovakia"
                                },
                                {
                                    "Text": "South Korea",
                                    "Value": "South Korea"
                                },
                                {
                                    "Text": "St Kitts and Nevis",
                                    "Value": "St Kitts and Nevis"
                                },
                                {
                                    "Text": "St Lucia",
                                    "Value": "St Lucia"
                                },
                                {
                                    "Text": "Slovenia",
                                    "Value": "Slovenia"
                                },
                                {
                                    "Text": "St Martin",
                                    "Value": "St Martin"
                                },
                                {
                                    "Text": "Surinam",
                                    "Value": "Surinam"
                                },
                                {
                                    "Text": "Solomon Islands",
                                    "Value": "Solomon Islands"
                                },
                                {
                                    "Text": "Senegal",
                                    "Value": "Senegal"
                                },
                                {
                                    "Text": "Somalia",
                                    "Value": "Somalia"
                                },
                                {
                                    "Text": "Serbia",
                                    "Value": "Serbia"
                                },
                                {
                                    "Text": "South Sudan",
                                    "Value": "South Sudan"
                                },
                                {
                                    "Text": "Sao Principe and Tome",
                                    "Value": "Sao Principe and Tome"
                                },
                                {
                                    "Text": "Sudan",
                                    "Value": "Sudan"
                                },
                                {
                                    "Text": "St Vincent and Grenadines",
                                    "Value": "St Vincent and Grenadines"
                                },
                                {
                                    "Text": "Swansea",
                                    "Value": "Swansea"
                                },
                                {
                                    "Text": "Seychelles",
                                    "Value": "Seychelles"
                                },
                                {
                                    "Text": "Syria",
                                    "Value": "Syria"
                                },
                                {
                                    "Text": "Thailand",
                                    "Value": "Thailand"
                                },
                                {
                                    "Text": "Taiwan",
                                    "Value": "Taiwan"
                                },
                                {
                                    "Text": "Tibet",
                                    "Value": "Tibet"
                                },
                                {
                                    "Text": "Togo",
                                    "Value": "Togo"
                                },
                                {
                                    "Text": "Gambia/ The Gambia",
                                    "Value": "Gambia/ The Gambia"
                                },
                                {
                                    "Text": "Tahiti",
                                    "Value": "Tahiti"
                                },
                                {
                                    "Text": "Tajikistan",
                                    "Value": "Tajikistan"
                                },
                                {
                                    "Text": "Tokelau",
                                    "Value": "Tokelau"
                                },
                                {
                                    "Text": "Turkmenistan",
                                    "Value": "Turkmenistan"
                                },
                                {
                                    "Text": "Tunisia",
                                    "Value": "Tunisia"
                                },
                                {
                                    "Text": "Tonga",
                                    "Value": "Tonga"
                                },
                                {
                                    "Text": "Turkey",
                                    "Value": "Turkey"
                                },
                                {
                                    "Text": "Trinidad and Tobago",
                                    "Value": "Trinidad and Tobago"
                                },
                                {
                                    "Text": "Turks and Caicos",
                                    "Value": "Turks and Caicos"
                                },
                                {
                                    "Text": "Tuvalu",
                                    "Value": "Tuvalu"
                                },
                                {
                                    "Text": "Ukraine",
                                    "Value": "Ukraine"
                                },
                                {
                                    "Text": "United Arab Emirates",
                                    "Value": "United Arab Emirates"
                                },
                                {
                                    "Text": "United Kingdom",
                                    "Value": "United Kingdom"
                                },
                                {
                                    "Text": "United States of America",
                                    "Value": "United States of America"
                                },
                                {
                                    "Text": "US Virgin Islands",
                                    "Value": "US Virgin Islands"
                                },
                                {
                                    "Text": "Uzbekistan",
                                    "Value": "Uzbekistan"
                                },
                                {
                                    "Text": "Vanuatu",
                                    "Value": "Vanuatu"
                                },
                                {
                                    "Text": "Vatican",
                                    "Value": "Vatican"
                                },
                                {
                                    "Text": "Vietnam",
                                    "Value": "Vietnam"
                                },
                                {
                                    "Text": "Watford",
                                    "Value": "Watford"
                                },
                                {
                                    "Text": "Sierra Leone",
                                    "Value": "Sierra Leone"
                                },
                                {
                                    "Text": "Nigeria",
                                    "Value": "Nigeria"
                                },
                                {
                                    "Text": "London",
                                    "Value": "London"
                                },
                                {
                                    "Text": "Dominica",
                                    "Value": "Dominica"
                                },
                                {
                                    "Text": "West Africa",
                                    "Value": "West Africa"
                                },
                                {
                                    "Text": "Grenada",
                                    "Value": "Grenada"
                                },
                                {
                                    "Text": "Samoa",
                                    "Value": "Samoa"
                                },
                                {
                                    "Text": "Western Sahara",
                                    "Value": "Western Sahara"
                                },
                                {
                                    "Text": "Yugoslavia",
                                    "Value": "Yugoslavia"
                                },
                                {
                                    "Text": "Venezuela",
                                    "Value": "Venezuela"
                                },
                                {
                                    "Text": "Zambia",
                                    "Value": "Zambia"
                                },
                                {
                                    "Text": "South Africa",
                                    "Value": "South Africa"
                                },
                                {
                                    "Text": "Zaire",
                                    "Value": "Zaire"
                                },
                                {
                                    "Text": "Zimbabwe",
                                    "Value": "Zimbabwe"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']==='salaried'",
                            "validation": ""
                        },
                        "sourcetype": {
                            "id": "234",
                            "label": "Income Source type",
                            "name": "sourcetype",
                            "description": "Income Source type",
                            "mandatory": 1,
                            "type": "multi-select",
                            "value": [
                                {
                                    "Text": "Agriculture",
                                    "Value": "Agriculture"
                                },
                                {
                                    "Text": "Business",
                                    "Value": "Business"
                                },
                                {
                                    "Text": "Capital Gain",
                                    "Value": "Capital Gain"
                                },
                                {
                                    "Text": "House Property",
                                    "Value": "House Property"
                                },
                                {
                                    "Text": "Investment",
                                    "Value": "Investment"
                                },
                                {
                                    "Text": "Others",
                                    "Value": "Others"
                                },
                                {
                                    "Text": "Salaries",
                                    "Value": "Salaries"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "agriculture": {
                            "id": "2630",
                            "label": "Agriculture",
                            "name": "agriculture",
                            "description": "Only Numbers Allowed #Sum of all source type should be 100",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[0-9]*$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['sourcetype']['input'].includes('Agriculture')",
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['agriculture']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['business']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['capitalGain']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['houseProperty']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['investment']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['others']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['salaries']['input']*1==100)"
                        },
                        "business": {
                            "id": "2631",
                            "label": "Business",
                            "name": "business",
                            "description": "Only Numbers Allowed #Sum of all source type should be 100",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[0-9]*$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['sourcetype']['input'].includes('Business')",
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['agriculture']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['business']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['capitalGain']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['houseProperty']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['investment']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['others']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['salaries']['input']*1==100)"
                        },
                        "capitalGain": {
                            "id": "2632",
                            "label": "Capital Gain",
                            "name": "capitalGain",
                            "description": "Only Numbers Allowed #Sum of all source type should be 100",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[0-9]*$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['sourcetype']['input'].includes('Capital Gain')",
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['agriculture']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['business']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['capitalGain']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['houseProperty']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['investment']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['others']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['salaries']['input']*1==100)"
                        },
                        "houseProperty": {
                            "id": "2633",
                            "label": "House Property",
                            "name": "houseProperty",
                            "description": "Only Numbers Allowed #Sum of all source type should be 100",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[0-9]*$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['sourcetype']['input'].includes('House Property')",
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['agriculture']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['business']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['capitalGain']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['houseProperty']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['investment']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['others']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['salaries']['input']*1==100)"
                        },
                        "investment": {
                            "id": "2634",
                            "label": "Investment",
                            "name": "investment",
                            "description": "Only Numbers Allowed #Sum of all source type should be 100",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[0-9]*$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['sourcetype']['input'].includes('Investment')",
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['agriculture']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['business']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['capitalGain']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['houseProperty']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['investment']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['others']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['salaries']['input']*1==100)"
                        },
                        "others": {
                            "id": "2635",
                            "label": "Others",
                            "name": "others",
                            "description": "Only Numbers Allowed #Sum of all source type should be 100",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[0-9]*$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['sourcetype']['input'].includes('Others')",
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['agriculture']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['business']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['capitalGain']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['houseProperty']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['investment']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['others']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['salaries']['input']*1==100)"
                        },
                        "salaries": {
                            "id": "2636",
                            "label": "Salaries",
                            "name": "salaries",
                            "description": "Only Numbers Allowed #Sum of all source type should be 100",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[0-9]*$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['sourcetype']['input'].includes('Salaries')",
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['agriculture']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['business']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['capitalGain']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['houseProperty']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['investment']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['others']['input']*1+formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['salaries']['input']*1==100)"
                        },
                        "hdfcEmployee": {
                            "id": "220",
                            "label": "Are you HDFC employee ?",
                            "name": "hdfcEmployee",
                            "description": "Are you HDFC employee ?",
                            "mandatory": 1,
                            "type": "boolean",
                            "value": null,
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='housewife'&&formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='student'&&formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['occupation']['input']!=='Unemployed'",
                            "validation": ""
                        },
                        "hdfcEmployeeNo": {
                            "id": "239",
                            "label": "HDFC Employee Number",
                            "name": "hdfcEmployeeNo",
                            "description": "HDFC Employee Number",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": null,
                            "max": 50,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['hdfcEmployee']['input']==='1'",
                            "validation": ""
                        },
                        "hdfcEmployeeLocation": {
                            "id": "240",
                            "label": "HDFC Employee Location",
                            "name": "hdfcEmployeeLocation",
                            "description": "HDFC Employee Location",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "ANDAMAN & NICOBAR ISLANDS",
                                    "Value": "ANDAMAN & NICOBAR ISLANDS"
                                },
                                {
                                    "Text": "ANDHRA PRADESH",
                                    "Value": "ANDHRA PRADESH"
                                },
                                {
                                    "Text": "ARUNACHAL PRADESH",
                                    "Value": "ARUNACHAL PRADESH"
                                },
                                {
                                    "Text": "ASSAM",
                                    "Value": "ASSAM"
                                },
                                {
                                    "Text": "BIHAR",
                                    "Value": "BIHAR"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHATTISGARH",
                                    "Value": "CHATTISGARH"
                                },
                                {
                                    "Text": "DAMAN & DIU",
                                    "Value": "DAMAN & DIU"
                                },
                                {
                                    "Text": "DELHI",
                                    "Value": "DELHI"
                                },
                                {
                                    "Text": "DADRA & NAGAR HAVELI",
                                    "Value": "DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "GOA",
                                    "Value": "GOA"
                                },
                                {
                                    "Text": "GUJARAT",
                                    "Value": "GUJARAT"
                                },
                                {
                                    "Text": "HARYANA",
                                    "Value": "HARYANA"
                                },
                                {
                                    "Text": "HIMACHAL PRADESH",
                                    "Value": "HIMACHAL PRADESH"
                                },
                                {
                                    "Text": "JAMMU & KASHMIR",
                                    "Value": "JAMMU & KASHMIR"
                                },
                                {
                                    "Text": "JHARKHAND",
                                    "Value": "JHARKHAND"
                                },
                                {
                                    "Text": "KARNATAKA",
                                    "Value": "KARNATAKA"
                                },
                                {
                                    "Text": "KERALA",
                                    "Value": "KERALA"
                                },
                                {
                                    "Text": "LAKSHADWEEP",
                                    "Value": "LAKSHADWEEP"
                                },
                                {
                                    "Text": "MAHARASHTRA",
                                    "Value": "MAHARASHTRA"
                                },
                                {
                                    "Text": "MANIPUR",
                                    "Value": "MANIPUR"
                                },
                                {
                                    "Text": "MEGHALAYA",
                                    "Value": "MEGHALAYA"
                                },
                                {
                                    "Text": "MIZORAM",
                                    "Value": "MIZORAM"
                                },
                                {
                                    "Text": "MADHYA PRADESH",
                                    "Value": "MADHYA PRADESH"
                                },
                                {
                                    "Text": "NAGALAND",
                                    "Value": "NAGALAND"
                                },
                                {
                                    "Text": "ODISHA",
                                    "Value": "ODISHA"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PUNJAB",
                                    "Value": "PUNJAB"
                                },
                                {
                                    "Text": "RAJASTHAN",
                                    "Value": "RAJASTHAN"
                                },
                                {
                                    "Text": "SIKKIM",
                                    "Value": "SIKKIM"
                                },
                                {
                                    "Text": "TAMIL NADU",
                                    "Value": "TAMIL NADU"
                                },
                                {
                                    "Text": "TELANGANA",
                                    "Value": "TELANGANA"
                                },
                                {
                                    "Text": "TRIPURA",
                                    "Value": "TRIPURA"
                                },
                                {
                                    "Text": "UTTAR PRADESH",
                                    "Value": "UTTAR PRADESH"
                                },
                                {
                                    "Text": "UTTARAKHAND",
                                    "Value": "UTTARAKHAND"
                                },
                                {
                                    "Text": "WEST BENGAL",
                                    "Value": "WEST BENGAL"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['hdfcEmployee']['input']==='1'",
                            "validation": ""
                        },
                        "dateOfJoining": {
                            "id": "1377",
                            "label": "Hdfc date of join",
                            "name": "dateOfJoining",
                            "description": "Hdfc date of join",
                            "mandatory": 1,
                            "type": "date",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['hdfcEmployee']['input']==='1'",
                            "validation": "new Date(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['dateOfJoining']['input']) < new Date()"
                        },
                        "dateOfResignation": {
                            "id": "1378",
                            "label": "Hdfc date of resignation/retired",
                            "name": "dateOfResignation",
                            "description": "Hdfc date of resignation/ retired",
                            "mandatory": 0,
                            "type": "date",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['hdfcEmployee']['input']==='1'",
                            "validation": "new Date(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['professionalDetails']['fields']['dateOfResignation']['input']) < new Date()"
                        }
                    }
                },
                "communicationAddressDetails": {
                    "id": 27,
                    "name": "communicationAddressDetails",
                    "description": "Communication Address Details",
                    "parent": 24,
                    "label": "Communication Address Details",
                    "type": null,
                    "sizeOfArray": null,
                    "visibility": null,
                    "validation": null,
                    "order": 3,
                    "fields": {
                        "addressLine1": {
                            "id": "1385",
                            "label": "Address Line 1",
                            "name": "addressLine1",
                            "description": "Address should be as per Valid Proof Your policy document will be sent to this address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "addressLine2": {
                            "id": "221",
                            "label": "Address line 2",
                            "name": "addressLine2",
                            "description": "Address should be as per Valid Proof Your policy document will be sent to this address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 2,
                            "max": 30,
                            "pattern": "/^[a-zA-z\\s]{3,30}$/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "addressLine3": {
                            "id": "222",
                            "label": "Address line 3",
                            "name": "addressLine3",
                            "description": "Address should be as per Valid Proof Your policy document will be sent to this address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 2,
                            "max": 30,
                            "pattern": "/^[a-zA-z\\s]{3,30}$/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "landmark": {
                            "id": "223",
                            "label": "Landmark",
                            "name": "landmark",
                            "description": "Landmark",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": null,
                            "max": 40,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "zipCode": {
                            "id": "227",
                            "label": "Pincode",
                            "name": "zipCode",
                            "description": "Maximum 6 Numbers for Indian and 10 for NRI/OCI/PIO/FN #Zip Code of the area provided",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  == 'Self') {\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['zipCode']['input'] = ''+quoteInfo['quoteRequest']['personalInformation']['individualDetails'][0]['zipCode']\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['zipCode']['mandatory'] = 2\r\n}\r\nelse if (formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['relationWithLA']['input']  != 'Self'){\r\n  formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['zipCode']['mandatory'] = 1\r\n}",
                            "min": 6,
                            "max": 6,
                            "pattern": "/^[1-9][0-9]{5}$/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "city": {
                            "id": "224",
                            "label": "City",
                            "name": "city",
                            "description": "Select name of city",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "",
                                    "Value": ""
                                },
                                {
                                    "Text": "MANDYA",
                                    "Value": "MANDYA"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ARMOOR",
                                    "Value": "ARMOOR"
                                },
                                {
                                    "Text": "BANSWADA",
                                    "Value": "BANSWADA"
                                },
                                {
                                    "Text": "BELLAMPALLE",
                                    "Value": "BELLAMPALLE"
                                },
                                {
                                    "Text": "BHADRACHALAM",
                                    "Value": "BHADRACHALAM"
                                },
                                {
                                    "Text": "BHAINSA",
                                    "Value": "BHAINSA"
                                },
                                {
                                    "Text": "BHONGIR",
                                    "Value": "BHONGIR"
                                },
                                {
                                    "Text": "BODHAN",
                                    "Value": "BODHAN"
                                },
                                {
                                    "Text": "BOMMAKAL",
                                    "Value": "BOMMAKAL"
                                },
                                {
                                    "Text": "CHANDANAGAR",
                                    "Value": "CHANDANAGAR"
                                },
                                {
                                    "Text": "CHIMRAJPALLE",
                                    "Value": "CHIMRAJPALLE"
                                },
                                {
                                    "Text": "CHOUTUPPAL",
                                    "Value": "CHOUTUPPAL"
                                },
                                {
                                    "Text": "DWARKA SUB CITY",
                                    "Value": "DWARKA SUB CITY"
                                },
                                {
                                    "Text": "FILM NAGAR",
                                    "Value": "FILM NAGAR"
                                },
                                {
                                    "Text": "GADWAL",
                                    "Value": "GADWAL"
                                },
                                {
                                    "Text": "GENOME VALLEY",
                                    "Value": "GENOME VALLEY"
                                },
                                {
                                    "Text": "GODAVARIKHANI",
                                    "Value": "GODAVARIKHANI"
                                },
                                {
                                    "Text": "GOPANAPALLE",
                                    "Value": "GOPANAPALLE"
                                },
                                {
                                    "Text": "GOVINDPET",
                                    "Value": "GOVINDPET"
                                },
                                {
                                    "Text": "HANUMAKONDA",
                                    "Value": "HANUMAKONDA"
                                },
                                {
                                    "Text": "HAYATNAGAR",
                                    "Value": "HAYATNAGAR"
                                },
                                {
                                    "Text": "HUNSA",
                                    "Value": "HUNSA"
                                },
                                {
                                    "Text": "HUSNABAD",
                                    "Value": "HUSNABAD"
                                },
                                {
                                    "Text": "HUZURABAD",
                                    "Value": "HUZURABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "JADCHERLA",
                                    "Value": "JADCHERLA"
                                },
                                {
                                    "Text": "JAGITYALA",
                                    "Value": "JAGITYALA"
                                },
                                {
                                    "Text": "JAMMIKUNTA",
                                    "Value": "JAMMIKUNTA"
                                },
                                {
                                    "Text": "JANGAON",
                                    "Value": "JANGAON"
                                },
                                {
                                    "Text": "JANJAON",
                                    "Value": "JANJAON"
                                },
                                {
                                    "Text": "JANKAMPET",
                                    "Value": "JANKAMPET"
                                },
                                {
                                    "Text": "JEELGUL",
                                    "Value": "JEELGUL"
                                },
                                {
                                    "Text": "JOGIPET",
                                    "Value": "JOGIPET"
                                },
                                {
                                    "Text": "K.V.RANGAREDDY",
                                    "Value": "K.V.RANGAREDDY"
                                },
                                {
                                    "Text": "KALIGOTE",
                                    "Value": "KALIGOTE"
                                },
                                {
                                    "Text": "KALWAKURTHY",
                                    "Value": "KALWAKURTHY"
                                },
                                {
                                    "Text": "KAMAREDDY",
                                    "Value": "KAMAREDDY"
                                },
                                {
                                    "Text": "KAPRA",
                                    "Value": "KAPRA"
                                },
                                {
                                    "Text": "KARIM NAGAR",
                                    "Value": "KARIM NAGAR"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KASIBUGGA",
                                    "Value": "KASIBUGGA"
                                },
                                {
                                    "Text": "KHAMMAM",
                                    "Value": "KHAMMAM"
                                },
                                {
                                    "Text": "KODADA",
                                    "Value": "KODADA"
                                },
                                {
                                    "Text": "KODAD",
                                    "Value": "KODAD"
                                },
                                {
                                    "Text": "KOMPALLE",
                                    "Value": "KOMPALLE"
                                },
                                {
                                    "Text": "KONDAGATTU",
                                    "Value": "KONDAGATTU"
                                },
                                {
                                    "Text": "KONDAPUR",
                                    "Value": "KONDAPUR"
                                },
                                {
                                    "Text": "KORATLA",
                                    "Value": "KORATLA"
                                },
                                {
                                    "Text": "KOTHAGUDEM",
                                    "Value": "KOTHAGUDEM"
                                },
                                {
                                    "Text": "KOTHAPALLE",
                                    "Value": "KOTHAPALLE"
                                },
                                {
                                    "Text": "KUKATPALLY",
                                    "Value": "KUKATPALLY"
                                },
                                {
                                    "Text": "LAXITTIPET",
                                    "Value": "LAXITTIPET"
                                },
                                {
                                    "Text": "MAHABUB NAGAR",
                                    "Value": "MAHABUB NAGAR"
                                },
                                {
                                    "Text": "MAHABUBNAGAR",
                                    "Value": "MAHABUBNAGAR"
                                },
                                {
                                    "Text": "MAHABUBABAD",
                                    "Value": "MAHABUBABAD"
                                },
                                {
                                    "Text": "MANCHERIAL",
                                    "Value": "MANCHERIAL"
                                },
                                {
                                    "Text": "MANTHANI",
                                    "Value": "MANTHANI"
                                },
                                {
                                    "Text": "MEDAK",
                                    "Value": "MEDAK"
                                },
                                {
                                    "Text": "MEDCHAL",
                                    "Value": "MEDCHAL"
                                },
                                {
                                    "Text": "MEHBUBNAGAR",
                                    "Value": "MEHBUBNAGAR"
                                },
                                {
                                    "Text": "METPALLE",
                                    "Value": "METPALLE"
                                },
                                {
                                    "Text": "MIRYALGUDA",
                                    "Value": "MIRYALGUDA"
                                },
                                {
                                    "Text": "MUGPAL",
                                    "Value": "MUGPAL"
                                },
                                {
                                    "Text": "MUNPALLE",
                                    "Value": "MUNPALLE"
                                },
                                {
                                    "Text": "NADEPALLE",
                                    "Value": "NADEPALLE"
                                },
                                {
                                    "Text": "NAKREKAL",
                                    "Value": "NAKREKAL"
                                },
                                {
                                    "Text": "NALGONDA",
                                    "Value": "NALGONDA"
                                },
                                {
                                    "Text": "NARASAMPET",
                                    "Value": "NARASAMPET"
                                },
                                {
                                    "Text": "NARAYANPET",
                                    "Value": "NARAYANPET"
                                },
                                {
                                    "Text": "NARSAMPET",
                                    "Value": "NARSAMPET"
                                },
                                {
                                    "Text": "NIRMAL",
                                    "Value": "NIRMAL"
                                },
                                {
                                    "Text": "NIZAMABAD",
                                    "Value": "NIZAMABAD"
                                },
                                {
                                    "Text": "PACHCHUNUR",
                                    "Value": "PACHCHUNUR"
                                },
                                {
                                    "Text": "PALWANCHA",
                                    "Value": "PALWANCHA"
                                },
                                {
                                    "Text": "PARKAL",
                                    "Value": "PARKAL"
                                },
                                {
                                    "Text": "PATANCHERU",
                                    "Value": "PATANCHERU"
                                },
                                {
                                    "Text": "PEDDAPALLE",
                                    "Value": "PEDDAPALLE"
                                },
                                {
                                    "Text": "PEDDAPUR",
                                    "Value": "PEDDAPUR"
                                },
                                {
                                    "Text": "PEGADAPALLI",
                                    "Value": "PEGADAPALLI"
                                },
                                {
                                    "Text": "RAGHAVAPET",
                                    "Value": "RAGHAVAPET"
                                },
                                {
                                    "Text": "RAMAGUNDAM",
                                    "Value": "RAMAGUNDAM"
                                },
                                {
                                    "Text": "RANGAREDDI",
                                    "Value": "RANGAREDDI"
                                },
                                {
                                    "Text": "RANGAREDDY",
                                    "Value": "RANGAREDDY"
                                },
                                {
                                    "Text": "REDDIPALLE",
                                    "Value": "REDDIPALLE"
                                },
                                {
                                    "Text": "SATHUPALLE",
                                    "Value": "SATHUPALLE"
                                },
                                {
                                    "Text": "SECUNDERABAD",
                                    "Value": "SECUNDERABAD"
                                },
                                {
                                    "Text": "SECUNDERABAD CANTT.",
                                    "Value": "SECUNDERABAD CANTT."
                                },
                                {
                                    "Text": "SHADNAGAR",
                                    "Value": "SHADNAGAR"
                                },
                                {
                                    "Text": "SHAMSHABAD",
                                    "Value": "SHAMSHABAD"
                                },
                                {
                                    "Text": "SHANKARPALLY",
                                    "Value": "SHANKARPALLY"
                                },
                                {
                                    "Text": "SIDDIPET",
                                    "Value": "SIDDIPET"
                                },
                                {
                                    "Text": "SIRCILLA",
                                    "Value": "SIRCILLA"
                                },
                                {
                                    "Text": "SULTANABAD",
                                    "Value": "SULTANABAD"
                                },
                                {
                                    "Text": "SURYAPET",
                                    "Value": "SURYAPET"
                                },
                                {
                                    "Text": "TANDUR",
                                    "Value": "TANDUR"
                                },
                                {
                                    "Text": "THADIKAL",
                                    "Value": "THADIKAL"
                                },
                                {
                                    "Text": "VANNEL K",
                                    "Value": "VANNEL K"
                                },
                                {
                                    "Text": "VEMULAKURTHI",
                                    "Value": "VEMULAKURTHI"
                                },
                                {
                                    "Text": "VEMULAWADA",
                                    "Value": "VEMULAWADA"
                                },
                                {
                                    "Text": "VICARABAD",
                                    "Value": "VICARABAD"
                                },
                                {
                                    "Text": "WANAPARTHY",
                                    "Value": "WANAPARTHY"
                                },
                                {
                                    "Text": "WARANGAL",
                                    "Value": "WARANGAL"
                                },
                                {
                                    "Text": "ZAHIRABAD",
                                    "Value": "ZAHIRABAD"
                                },
                                {
                                    "Text": "ABOHAR",
                                    "Value": "ABOHAR"
                                },
                                {
                                    "Text": "ABU DHABI",
                                    "Value": "ABU DHABI"
                                },
                                {
                                    "Text": "ABU ROAD",
                                    "Value": "ABU ROAD"
                                },
                                {
                                    "Text": "ACHALPUR",
                                    "Value": "ACHALPUR"
                                },
                                {
                                    "Text": "ADALAJ",
                                    "Value": "ADALAJ"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMWAL",
                                    "Value": "ADAMWAL"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADARCHAK ",
                                    "Value": "ADARCHAK "
                                },
                                {
                                    "Text": "ADAVDEVULAPALLY ",
                                    "Value": "ADAVDEVULAPALLY "
                                },
                                {
                                    "Text": "ADDANKI",
                                    "Value": "ADDANKI"
                                },
                                {
                                    "Text": "ADHARTAL",
                                    "Value": "ADHARTAL"
                                },
                                {
                                    "Text": "ADHEWADA",
                                    "Value": "ADHEWADA"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ADIMALI",
                                    "Value": "ADIMALI"
                                },
                                {
                                    "Text": "ADIPUR",
                                    "Value": "ADIPUR"
                                },
                                {
                                    "Text": "ADITYAPUR",
                                    "Value": "ADITYAPUR"
                                },
                                {
                                    "Text": "ADAJAN",
                                    "Value": "ADAJAN"
                                },
                                {
                                    "Text": "ADLOOR ",
                                    "Value": "ADLOOR "
                                },
                                {
                                    "Text": "AZAD NAGAR",
                                    "Value": "AZAD NAGAR"
                                },
                                {
                                    "Text": "ADONI",
                                    "Value": "ADONI"
                                },
                                {
                                    "Text": "ADOOR",
                                    "Value": "ADOOR"
                                },
                                {
                                    "Text": "AGARTALA",
                                    "Value": "AGARTALA"
                                },
                                {
                                    "Text": "AGAR",
                                    "Value": "AGAR"
                                },
                                {
                                    "Text": "AGASHI",
                                    "Value": "AGASHI"
                                },
                                {
                                    "Text": "AGONDA",
                                    "Value": "AGONDA"
                                },
                                {
                                    "Text": "AGONDH",
                                    "Value": "AGONDH"
                                },
                                {
                                    "Text": "AGRA",
                                    "Value": "AGRA"
                                },
                                {
                                    "Text": "AGROHA",
                                    "Value": "AGROHA"
                                },
                                {
                                    "Text": "ACHABAL",
                                    "Value": "ACHABAL"
                                },
                                {
                                    "Text": "AHMADPUR",
                                    "Value": "AHMADPUR"
                                },
                                {
                                    "Text": "AHMEDNAGAR",
                                    "Value": "AHMEDNAGAR"
                                },
                                {
                                    "Text": "AHMEDPUR",
                                    "Value": "AHMEDPUR"
                                },
                                {
                                    "Text": "AHMEDGARH",
                                    "Value": "AHMEDGARH"
                                },
                                {
                                    "Text": "AHMED NAGAR",
                                    "Value": "AHMED NAGAR"
                                },
                                {
                                    "Text": "AHMEDABAD",
                                    "Value": "AHMEDABAD"
                                },
                                {
                                    "Text": "AHMEDPUR ",
                                    "Value": "AHMEDPUR "
                                },
                                {
                                    "Text": "AHRWAN",
                                    "Value": "AHRWAN"
                                },
                                {
                                    "Text": "AIROLI",
                                    "Value": "AIROLI"
                                },
                                {
                                    "Text": "AIZAWL",
                                    "Value": "AIZAWL"
                                },
                                {
                                    "Text": "AJEETGARH",
                                    "Value": "AJEETGARH"
                                },
                                {
                                    "Text": "AJGAIN",
                                    "Value": "AJGAIN"
                                },
                                {
                                    "Text": "AJIT WAL",
                                    "Value": "AJIT WAL"
                                },
                                {
                                    "Text": "AJMER",
                                    "Value": "AJMER"
                                },
                                {
                                    "Text": "AJNALA",
                                    "Value": "AJNALA"
                                },
                                {
                                    "Text": "AJOD",
                                    "Value": "AJOD"
                                },
                                {
                                    "Text": "AJOL",
                                    "Value": "AJOL"
                                },
                                {
                                    "Text": "AKALTARA",
                                    "Value": "AKALTARA"
                                },
                                {
                                    "Text": "AKBARPUR",
                                    "Value": "AKBARPUR"
                                },
                                {
                                    "Text": "AKCHA",
                                    "Value": "AKCHA"
                                },
                                {
                                    "Text": "AKHNOOR",
                                    "Value": "AKHNOOR"
                                },
                                {
                                    "Text": "AKIVIDU",
                                    "Value": "AKIVIDU"
                                },
                                {
                                    "Text": "AKKAMPETA ",
                                    "Value": "AKKAMPETA "
                                },
                                {
                                    "Text": "AKKALKUWA",
                                    "Value": "AKKALKUWA"
                                },
                                {
                                    "Text": "AKKULAPETA ",
                                    "Value": "AKKULAPETA "
                                },
                                {
                                    "Text": "AKLUJ",
                                    "Value": "AKLUJ"
                                },
                                {
                                    "Text": "AKOLA",
                                    "Value": "AKOLA"
                                },
                                {
                                    "Text": "AKOT",
                                    "Value": "AKOT"
                                },
                                {
                                    "Text": "ALAGADAPA ",
                                    "Value": "ALAGADAPA "
                                },
                                {
                                    "Text": "ALAIR ",
                                    "Value": "ALAIR "
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ALAPPUZHA",
                                    "Value": "ALAPPUZHA"
                                },
                                {
                                    "Text": "ALAS",
                                    "Value": "ALAS"
                                },
                                {
                                    "Text": "ALATHUR",
                                    "Value": "ALATHUR"
                                },
                                {
                                    "Text": "ALDONA",
                                    "Value": "ALDONA"
                                },
                                {
                                    "Text": "ALHADPURA",
                                    "Value": "ALHADPURA"
                                },
                                {
                                    "Text": "ALIBAG",
                                    "Value": "ALIBAG"
                                },
                                {
                                    "Text": "ALIGANJ",
                                    "Value": "ALIGANJ"
                                },
                                {
                                    "Text": "ALIGARH",
                                    "Value": "ALIGARH"
                                },
                                {
                                    "Text": "ALIKAM ",
                                    "Value": "ALIKAM "
                                },
                                {
                                    "Text": "ALI PUR",
                                    "Value": "ALI PUR"
                                },
                                {
                                    "Text": "ALIPUR",
                                    "Value": "ALIPUR"
                                },
                                {
                                    "Text": "ALIPURDUAR",
                                    "Value": "ALIPURDUAR"
                                },
                                {
                                    "Text": "ALIRAJPUR",
                                    "Value": "ALIRAJPUR"
                                },
                                {
                                    "Text": "ALLAHABAD",
                                    "Value": "ALLAHABAD"
                                },
                                {
                                    "Text": "ALLAMPALLI .",
                                    "Value": "ALLAMPALLI ."
                                },
                                {
                                    "Text": "ALLAGADDA",
                                    "Value": "ALLAGADDA"
                                },
                                {
                                    "Text": "ALMORA",
                                    "Value": "ALMORA"
                                },
                                {
                                    "Text": "ALOOR ",
                                    "Value": "ALOOR "
                                },
                                {
                                    "Text": "ALLEPPEY",
                                    "Value": "ALLEPPEY"
                                },
                                {
                                    "Text": "ALUVA",
                                    "Value": "ALUVA"
                                },
                                {
                                    "Text": "ALWAYE",
                                    "Value": "ALWAYE"
                                },
                                {
                                    "Text": "ALWAR",
                                    "Value": "ALWAR"
                                },
                                {
                                    "Text": "AMALNER",
                                    "Value": "AMALNER"
                                },
                                {
                                    "Text": "AMALAPURAM",
                                    "Value": "AMALAPURAM"
                                },
                                {
                                    "Text": "AMALSAD",
                                    "Value": "AMALSAD"
                                },
                                {
                                    "Text": "AMANGALA ",
                                    "Value": "AMANGALA "
                                },
                                {
                                    "Text": "AMARGARH",
                                    "Value": "AMARGARH"
                                },
                                {
                                    "Text": "AMARKOT",
                                    "Value": "AMARKOT"
                                },
                                {
                                    "Text": "AMBAJI",
                                    "Value": "AMBAJI"
                                },
                                {
                                    "Text": "AMBALA",
                                    "Value": "AMBALA"
                                },
                                {
                                    "Text": "AMBAKAPALLE ",
                                    "Value": "AMBAKAPALLE "
                                },
                                {
                                    "Text": "AMBALATHADI ",
                                    "Value": "AMBALATHADI "
                                },
                                {
                                    "Text": "AMBALA CANTT",
                                    "Value": "AMBALA CANTT"
                                },
                                {
                                    "Text": "AMBALA CITY",
                                    "Value": "AMBALA CITY"
                                },
                                {
                                    "Text": "AMBEJOGAI",
                                    "Value": "AMBEJOGAI"
                                },
                                {
                                    "Text": "AMBERNATH",
                                    "Value": "AMBERNATH"
                                },
                                {
                                    "Text": "AMBEDKAR NAGAR",
                                    "Value": "AMBEDKAR NAGAR"
                                },
                                {
                                    "Text": "AMBEDKARNAGAR",
                                    "Value": "AMBEDKARNAGAR"
                                },
                                {
                                    "Text": "AMBELIM",
                                    "Value": "AMBELIM"
                                },
                                {
                                    "Text": "AMBIKAPUR",
                                    "Value": "AMBIKAPUR"
                                },
                                {
                                    "Text": "AMBARNATH",
                                    "Value": "AMBARNATH"
                                },
                                {
                                    "Text": "AMBUR",
                                    "Value": "AMBUR"
                                },
                                {
                                    "Text": "AMB",
                                    "Value": "AMB"
                                },
                                {
                                    "Text": "AMDADA",
                                    "Value": "AMDADA"
                                },
                                {
                                    "Text": "AMETHI",
                                    "Value": "AMETHI"
                                },
                                {
                                    "Text": "AMETHI",
                                    "Value": "AMETHI"
                                },
                                {
                                    "Text": "AMNAN",
                                    "Value": "AMNAN"
                                },
                                {
                                    "Text": "AMPATI",
                                    "Value": "AMPATI"
                                },
                                {
                                    "Text": "AMPATI",
                                    "Value": "AMPATI"
                                },
                                {
                                    "Text": "AMRAVATI",
                                    "Value": "AMRAVATI"
                                },
                                {
                                    "Text": "AMRAPUR",
                                    "Value": "AMRAPUR"
                                },
                                {
                                    "Text": "AMRELI",
                                    "Value": "AMRELI"
                                },
                                {
                                    "Text": "AMRITSAR",
                                    "Value": "AMRITSAR"
                                },
                                {
                                    "Text": "AMROHA",
                                    "Value": "AMROHA"
                                },
                                {
                                    "Text": "AMROLI",
                                    "Value": "AMROLI"
                                },
                                {
                                    "Text": "AMRUTH NAGAR ",
                                    "Value": "AMRUTH NAGAR "
                                },
                                {
                                    "Text": "AMTALA",
                                    "Value": "AMTALA"
                                },
                                {
                                    "Text": "ANAKAPALLE",
                                    "Value": "ANAKAPALLE"
                                },
                                {
                                    "Text": "ANANTAPUR",
                                    "Value": "ANANTAPUR"
                                },
                                {
                                    "Text": "ANANTHAPUR",
                                    "Value": "ANANTHAPUR"
                                },
                                {
                                    "Text": "ANANTNAG",
                                    "Value": "ANANTNAG"
                                },
                                {
                                    "Text": "ANANDPUR SAHIB",
                                    "Value": "ANANDPUR SAHIB"
                                },
                                {
                                    "Text": "ANAND",
                                    "Value": "ANAND"
                                },
                                {
                                    "Text": "ANANTHNAG",
                                    "Value": "ANANTHNAG"
                                },
                                {
                                    "Text": "ANANTHARAM ",
                                    "Value": "ANANTHARAM "
                                },
                                {
                                    "Text": "ANANTAGIRIPALLY ",
                                    "Value": "ANANTAGIRIPALLY "
                                },
                                {
                                    "Text": "ANAND NAGAR",
                                    "Value": "ANAND NAGAR"
                                },
                                {
                                    "Text": "ANANDPUR",
                                    "Value": "ANANDPUR"
                                },
                                {
                                    "Text": "ANASARAPUR",
                                    "Value": "ANASARAPUR"
                                },
                                {
                                    "Text": "ANATHARAM ",
                                    "Value": "ANATHARAM "
                                },
                                {
                                    "Text": "ANDAL GRAM",
                                    "Value": "ANDAL GRAM"
                                },
                                {
                                    "Text": "ANDHERI",
                                    "Value": "ANDHERI"
                                },
                                {
                                    "Text": "ANDUL",
                                    "Value": "ANDUL"
                                },
                                {
                                    "Text": "ANGAMALY",
                                    "Value": "ANGAMALY"
                                },
                                {
                                    "Text": "ANGUL",
                                    "Value": "ANGUL"
                                },
                                {
                                    "Text": "ANJAR",
                                    "Value": "ANJAR"
                                },
                                {
                                    "Text": "ANJAD",
                                    "Value": "ANJAD"
                                },
                                {
                                    "Text": "ANJAD",
                                    "Value": "ANJAD"
                                },
                                {
                                    "Text": "ANJANAPALLY ",
                                    "Value": "ANJANAPALLY "
                                },
                                {
                                    "Text": "ANJUNA",
                                    "Value": "ANJUNA"
                                },
                                {
                                    "Text": "ANKAPOOR ",
                                    "Value": "ANKAPOOR "
                                },
                                {
                                    "Text": "ANKLESHWAR",
                                    "Value": "ANKLESHWAR"
                                },
                                {
                                    "Text": "ANNARAM ",
                                    "Value": "ANNARAM "
                                },
                                {
                                    "Text": "ANNAVARAM ",
                                    "Value": "ANNAVARAM "
                                },
                                {
                                    "Text": "ANTARJAR",
                                    "Value": "ANTARJAR"
                                },
                                {
                                    "Text": "ANTPARA",
                                    "Value": "ANTPARA"
                                },
                                {
                                    "Text": "ANUGUL",
                                    "Value": "ANUGUL"
                                },
                                {
                                    "Text": "ANUPGARH",
                                    "Value": "ANUPGARH"
                                },
                                {
                                    "Text": "ANUPPUR",
                                    "Value": "ANUPPUR"
                                },
                                {
                                    "Text": "ANUPSHAHR",
                                    "Value": "ANUPSHAHR"
                                },
                                {
                                    "Text": "AONLA",
                                    "Value": "AONLA"
                                },
                                {
                                    "Text": "APPARAJPALLI ",
                                    "Value": "APPARAJPALLI "
                                },
                                {
                                    "Text": "APRA",
                                    "Value": "APRA"
                                },
                                {
                                    "Text": "ALTO PORVORIM",
                                    "Value": "ALTO PORVORIM"
                                },
                                {
                                    "Text": "ARA",
                                    "Value": "ARA"
                                },
                                {
                                    "Text": "ARAKONAM",
                                    "Value": "ARAKONAM"
                                },
                                {
                                    "Text": "ARAMBAGH",
                                    "Value": "ARAMBAGH"
                                },
                                {
                                    "Text": "ARAMPOONDI ",
                                    "Value": "ARAMPOONDI "
                                },
                                {
                                    "Text": "ARANTHANGI",
                                    "Value": "ARANTHANGI"
                                },
                                {
                                    "Text": "ARARIA",
                                    "Value": "ARARIA"
                                },
                                {
                                    "Text": "ARASIKERE",
                                    "Value": "ARASIKERE"
                                },
                                {
                                    "Text": "ARCOT",
                                    "Value": "ARCOT"
                                },
                                {
                                    "Text": "ARGUL ",
                                    "Value": "ARGUL "
                                },
                                {
                                    "Text": "ARIKAREVULA ",
                                    "Value": "ARIKAREVULA "
                                },
                                {
                                    "Text": "ARIYALUR",
                                    "Value": "ARIYALUR"
                                },
                                {
                                    "Text": "ARKKUPARAMBA ",
                                    "Value": "ARKKUPARAMBA "
                                },
                                {
                                    "Text": "ARMOOR",
                                    "Value": "ARMOOR"
                                },
                                {
                                    "Text": "ARNIWALA SHEIKH SUBHA",
                                    "Value": "ARNIWALA SHEIKH SUBHA"
                                },
                                {
                                    "Text": "ARNI",
                                    "Value": "ARNI"
                                },
                                {
                                    "Text": "ARNIWALA SHEIKH SUBHA",
                                    "Value": "ARNIWALA SHEIKH SUBHA"
                                },
                                {
                                    "Text": "ARNIWALA WAZIRAN",
                                    "Value": "ARNIWALA WAZIRAN"
                                },
                                {
                                    "Text": "ARPORA",
                                    "Value": "ARPORA"
                                },
                                {
                                    "Text": "ARRAH",
                                    "Value": "ARRAH"
                                },
                                {
                                    "Text": "ARRYAN WALA ",
                                    "Value": "ARRYAN WALA "
                                },
                                {
                                    "Text": "ARSIKERE",
                                    "Value": "ARSIKERE"
                                },
                                {
                                    "Text": "ARUPPUKKOTTAI",
                                    "Value": "ARUPPUKKOTTAI"
                                },
                                {
                                    "Text": "ARVI",
                                    "Value": "ARVI"
                                },
                                {
                                    "Text": "ARWAL",
                                    "Value": "ARWAL"
                                },
                                {
                                    "Text": "ASAFPUR",
                                    "Value": "ASAFPUR"
                                },
                                {
                                    "Text": "ASANSOL",
                                    "Value": "ASANSOL"
                                },
                                {
                                    "Text": "ASHOKNAGAR",
                                    "Value": "ASHOKNAGAR"
                                },
                                {
                                    "Text": "ASHOK NAGAR",
                                    "Value": "ASHOK NAGAR"
                                },
                                {
                                    "Text": "ASHOK NAGAR",
                                    "Value": "ASHOK NAGAR"
                                },
                                {
                                    "Text": "ASHTA",
                                    "Value": "ASHTA"
                                },
                                {
                                    "Text": "ASKA",
                                    "Value": "ASKA"
                                },
                                {
                                    "Text": "ASOLA",
                                    "Value": "ASOLA"
                                },
                                {
                                    "Text": "ASSANDH",
                                    "Value": "ASSANDH"
                                },
                                {
                                    "Text": "ASSONORA",
                                    "Value": "ASSONORA"
                                },
                                {
                                    "Text": "ASTA",
                                    "Value": "ASTA"
                                },
                                {
                                    "Text": "ATELI",
                                    "Value": "ATELI"
                                },
                                {
                                    "Text": "ATHANI",
                                    "Value": "ATHANI"
                                },
                                {
                                    "Text": "ATHANI",
                                    "Value": "ATHANI"
                                },
                                {
                                    "Text": "ATHGARH",
                                    "Value": "ATHGARH"
                                },
                                {
                                    "Text": "ATHNI",
                                    "Value": "ATHNI"
                                },
                                {
                                    "Text": "ATMAKUR",
                                    "Value": "ATMAKUR"
                                },
                                {
                                    "Text": "ATTAPUR",
                                    "Value": "ATTAPUR"
                                },
                                {
                                    "Text": "ATTARI",
                                    "Value": "ATTARI"
                                },
                                {
                                    "Text": "ATTUNGAL",
                                    "Value": "ATTUNGAL"
                                },
                                {
                                    "Text": "ATTUR",
                                    "Value": "ATTUR"
                                },
                                {
                                    "Text": "ATVELI ",
                                    "Value": "ATVELI "
                                },
                                {
                                    "Text": "AUJLA JOGI ",
                                    "Value": "AUJLA JOGI "
                                },
                                {
                                    "Text": "AUNDH",
                                    "Value": "AUNDH"
                                },
                                {
                                    "Text": "AURANGABAD",
                                    "Value": "AURANGABAD"
                                },
                                {
                                    "Text": "AURAIYA",
                                    "Value": "AURAIYA"
                                },
                                {
                                    "Text": "AURANGABAD(BH)",
                                    "Value": "AURANGABAD(BH)"
                                },
                                {
                                    "Text": "AURANGABAD",
                                    "Value": "AURANGABAD"
                                },
                                {
                                    "Text": "AUR",
                                    "Value": "AUR"
                                },
                                {
                                    "Text": "AVADI",
                                    "Value": "AVADI"
                                },
                                {
                                    "Text": "AVANASHI",
                                    "Value": "AVANASHI"
                                },
                                {
                                    "Text": "AVATHI",
                                    "Value": "AVATHI"
                                },
                                {
                                    "Text": "AWANTIPORA",
                                    "Value": "AWANTIPORA"
                                },
                                {
                                    "Text": "AYYAPPANTHANGAL",
                                    "Value": "AYYAPPANTHANGAL"
                                },
                                {
                                    "Text": "AZAMGARH",
                                    "Value": "AZAMGARH"
                                },
                                {
                                    "Text": "AZHIYANNUR",
                                    "Value": "AZHIYANNUR"
                                },
                                {
                                    "Text": "BABA SAHEB PETA ",
                                    "Value": "BABA SAHEB PETA "
                                },
                                {
                                    "Text": "BABA BAKALA",
                                    "Value": "BABA BAKALA"
                                },
                                {
                                    "Text": "BABHANAN",
                                    "Value": "BABHANAN"
                                },
                                {
                                    "Text": "BABINA",
                                    "Value": "BABINA"
                                },
                                {
                                    "Text": "BABRA",
                                    "Value": "BABRA"
                                },
                                {
                                    "Text": "BABURA ",
                                    "Value": "BABURA "
                                },
                                {
                                    "Text": "BABUGANJ",
                                    "Value": "BABUGANJ"
                                },
                                {
                                    "Text": "BACHHRAWAN",
                                    "Value": "BACHHRAWAN"
                                },
                                {
                                    "Text": "BADAKERA",
                                    "Value": "BADAKERA"
                                },
                                {
                                    "Text": "BADAL",
                                    "Value": "BADAL"
                                },
                                {
                                    "Text": "BADALI ALA SINGH",
                                    "Value": "BADALI ALA SINGH"
                                },
                                {
                                    "Text": "BADAULI",
                                    "Value": "BADAULI"
                                },
                                {
                                    "Text": "BADDI",
                                    "Value": "BADDI"
                                },
                                {
                                    "Text": "BADGAM",
                                    "Value": "BADGAM"
                                },
                                {
                                    "Text": "BADHNI KALAN",
                                    "Value": "BADHNI KALAN"
                                },
                                {
                                    "Text": "BADLAPUR",
                                    "Value": "BADLAPUR"
                                },
                                {
                                    "Text": "BADNAGAR",
                                    "Value": "BADNAGAR"
                                },
                                {
                                    "Text": "BADNAWAR",
                                    "Value": "BADNAWAR"
                                },
                                {
                                    "Text": "BADOL ",
                                    "Value": "BADOL "
                                },
                                {
                                    "Text": "BADUD",
                                    "Value": "BADUD"
                                },
                                {
                                    "Text": "BADVEL",
                                    "Value": "BADVEL"
                                },
                                {
                                    "Text": "BAGALKOT",
                                    "Value": "BAGALKOT"
                                },
                                {
                                    "Text": "BAGALKOT UHS CAMPUS ",
                                    "Value": "BAGALKOT UHS CAMPUS "
                                },
                                {
                                    "Text": "BAGALKOTE",
                                    "Value": "BAGALKOTE"
                                },
                                {
                                    "Text": "BAGDEHI",
                                    "Value": "BAGDEHI"
                                },
                                {
                                    "Text": "BAGESHWAR",
                                    "Value": "BAGESHWAR"
                                },
                                {
                                    "Text": "BAGHPAT",
                                    "Value": "BAGHPAT"
                                },
                                {
                                    "Text": "BAGHA PURANA",
                                    "Value": "BAGHA PURANA"
                                },
                                {
                                    "Text": "BAGHA",
                                    "Value": "BAGHA"
                                },
                                {
                                    "Text": "BAGNAN",
                                    "Value": "BAGNAN"
                                },
                                {
                                    "Text": "BAGPAT",
                                    "Value": "BAGPAT"
                                },
                                {
                                    "Text": "BAGPUR",
                                    "Value": "BAGPUR"
                                },
                                {
                                    "Text": "BAGRU",
                                    "Value": "BAGRU"
                                },
                                {
                                    "Text": "BAGRIAN ",
                                    "Value": "BAGRIAN "
                                },
                                {
                                    "Text": "BAHADURGARH",
                                    "Value": "BAHADURGARH"
                                },
                                {
                                    "Text": "BAHADURPUR",
                                    "Value": "BAHADURPUR"
                                },
                                {
                                    "Text": "BAHERI",
                                    "Value": "BAHERI"
                                },
                                {
                                    "Text": "BAHRAICH",
                                    "Value": "BAHRAICH"
                                },
                                {
                                    "Text": "BAHRAIN",
                                    "Value": "BAHRAIN"
                                },
                                {
                                    "Text": "BAHU JAMALPUR",
                                    "Value": "BAHU JAMALPUR"
                                },
                                {
                                    "Text": "BAIDPURA",
                                    "Value": "BAIDPURA"
                                },
                                {
                                    "Text": "BAIJNATH",
                                    "Value": "BAIJNATH"
                                },
                                {
                                    "Text": "BAIKUNTHPUR",
                                    "Value": "BAIKUNTHPUR"
                                },
                                {
                                    "Text": "BAINA",
                                    "Value": "BAINA"
                                },
                                {
                                    "Text": "BAIRAGARH",
                                    "Value": "BAIRAGARH"
                                },
                                {
                                    "Text": "BAJAHI ",
                                    "Value": "BAJAHI "
                                },
                                {
                                    "Text": "BAKARPUR",
                                    "Value": "BAKARPUR"
                                },
                                {
                                    "Text": "BAKHTIARPUR",
                                    "Value": "BAKHTIARPUR"
                                },
                                {
                                    "Text": "BANKNER",
                                    "Value": "BANKNER"
                                },
                                {
                                    "Text": "BAKSA",
                                    "Value": "BAKSA"
                                },
                                {
                                    "Text": "BALASORE",
                                    "Value": "BALASORE"
                                },
                                {
                                    "Text": "BALACHAUR",
                                    "Value": "BALACHAUR"
                                },
                                {
                                    "Text": "BALAGHAT",
                                    "Value": "BALAGHAT"
                                },
                                {
                                    "Text": "BALANGIR",
                                    "Value": "BALANGIR"
                                },
                                {
                                    "Text": "BALASINOR",
                                    "Value": "BALASINOR"
                                },
                                {
                                    "Text": "BALANA",
                                    "Value": "BALANA"
                                },
                                {
                                    "Text": "BALESWAR",
                                    "Value": "BALESWAR"
                                },
                                {
                                    "Text": "BALER KHANPUR ",
                                    "Value": "BALER KHANPUR "
                                },
                                {
                                    "Text": "BALIGHATTAM ",
                                    "Value": "BALIGHATTAM "
                                },
                                {
                                    "Text": "BALLARPUR",
                                    "Value": "BALLARPUR"
                                },
                                {
                                    "Text": "BALLIA",
                                    "Value": "BALLIA"
                                },
                                {
                                    "Text": "BALLIA",
                                    "Value": "BALLIA"
                                },
                                {
                                    "Text": "BALLA",
                                    "Value": "BALLA"
                                },
                                {
                                    "Text": "BALLABHGARH",
                                    "Value": "BALLABHGARH"
                                },
                                {
                                    "Text": "BALLARY",
                                    "Value": "BALLARY"
                                },
                                {
                                    "Text": "BALMATTA",
                                    "Value": "BALMATTA"
                                },
                                {
                                    "Text": "BALODA BAZAR",
                                    "Value": "BALODA BAZAR"
                                },
                                {
                                    "Text": "BALOTRA",
                                    "Value": "BALOTRA"
                                },
                                {
                                    "Text": "BALOD",
                                    "Value": "BALOD"
                                },
                                {
                                    "Text": "BALODA",
                                    "Value": "BALODA"
                                },
                                {
                                    "Text": "BALRAMPUR",
                                    "Value": "BALRAMPUR"
                                },
                                {
                                    "Text": "BALRAMPUR",
                                    "Value": "BALRAMPUR"
                                },
                                {
                                    "Text": "BALUGAON",
                                    "Value": "BALUGAON"
                                },
                                {
                                    "Text": "BALURGHAT",
                                    "Value": "BALURGHAT"
                                },
                                {
                                    "Text": "BAMAILA",
                                    "Value": "BAMAILA"
                                },
                                {
                                    "Text": "BAMOSANA",
                                    "Value": "BAMOSANA"
                                },
                                {
                                    "Text": "BAMRAULI KATARA",
                                    "Value": "BAMRAULI KATARA"
                                },
                                {
                                    "Text": "BAMUNARA",
                                    "Value": "BAMUNARA"
                                },
                                {
                                    "Text": "BANASKANTHA",
                                    "Value": "BANASKANTHA"
                                },
                                {
                                    "Text": "BANAPURA",
                                    "Value": "BANAPURA"
                                },
                                {
                                    "Text": "BANAGANAPALLE",
                                    "Value": "BANAGANAPALLE"
                                },
                                {
                                    "Text": "BANAS KANTHA",
                                    "Value": "BANAS KANTHA"
                                },
                                {
                                    "Text": "BANASINGA",
                                    "Value": "BANASINGA"
                                },
                                {
                                    "Text": "BANDA",
                                    "Value": "BANDA"
                                },
                                {
                                    "Text": "BANDIPUR",
                                    "Value": "BANDIPUR"
                                },
                                {
                                    "Text": "BANDRA",
                                    "Value": "BANDRA"
                                },
                                {
                                    "Text": "BANDIPORA",
                                    "Value": "BANDIPORA"
                                },
                                {
                                    "Text": "BANDIKUI",
                                    "Value": "BANDIKUI"
                                },
                                {
                                    "Text": "BANDIPORE",
                                    "Value": "BANDIPORE"
                                },
                                {
                                    "Text": "BANGA",
                                    "Value": "BANGA"
                                },
                                {
                                    "Text": "BANGALORE",
                                    "Value": "BANGALORE"
                                },
                                {
                                    "Text": "BANGALORE RURAL",
                                    "Value": "BANGALORE RURAL"
                                },
                                {
                                    "Text": "BANGARIGADDA ",
                                    "Value": "BANGARIGADDA "
                                },
                                {
                                    "Text": "BANGO DAM ",
                                    "Value": "BANGO DAM "
                                },
                                {
                                    "Text": "BANGARAPET",
                                    "Value": "BANGARAPET"
                                },
                                {
                                    "Text": "BANGARMAU",
                                    "Value": "BANGARMAU"
                                },
                                {
                                    "Text": "BANKA",
                                    "Value": "BANKA"
                                },
                                {
                                    "Text": "BANKURA",
                                    "Value": "BANKURA"
                                },
                                {
                                    "Text": "BANKATI ",
                                    "Value": "BANKATI "
                                },
                                {
                                    "Text": "BANNUR",
                                    "Value": "BANNUR"
                                },
                                {
                                    "Text": "BANS KHERI",
                                    "Value": "BANS KHERI"
                                },
                                {
                                    "Text": "BANSUR ALWAR",
                                    "Value": "BANSUR ALWAR"
                                },
                                {
                                    "Text": "BANSWARA",
                                    "Value": "BANSWARA"
                                },
                                {
                                    "Text": "BANS KHERI",
                                    "Value": "BANS KHERI"
                                },
                                {
                                    "Text": "BANSI",
                                    "Value": "BANSI"
                                },
                                {
                                    "Text": "BANSUR-ALWAR",
                                    "Value": "BANSUR-ALWAR"
                                },
                                {
                                    "Text": "BANSWADA",
                                    "Value": "BANSWADA"
                                },
                                {
                                    "Text": "BANTWAL",
                                    "Value": "BANTWAL"
                                },
                                {
                                    "Text": "BANTVAL",
                                    "Value": "BANTVAL"
                                },
                                {
                                    "Text": "BANUR",
                                    "Value": "BANUR"
                                },
                                {
                                    "Text": "BAPATLA",
                                    "Value": "BAPATLA"
                                },
                                {
                                    "Text": "BAPURASAPURAM",
                                    "Value": "BAPURASAPURAM"
                                },
                                {
                                    "Text": "BARASAT",
                                    "Value": "BARASAT"
                                },
                                {
                                    "Text": "BARAMATI",
                                    "Value": "BARAMATI"
                                },
                                {
                                    "Text": "BARABANKI",
                                    "Value": "BARABANKI"
                                },
                                {
                                    "Text": "BARAMULLA",
                                    "Value": "BARAMULLA"
                                },
                                {
                                    "Text": "BARAN",
                                    "Value": "BARAN"
                                },
                                {
                                    "Text": "BARAKAR",
                                    "Value": "BARAKAR"
                                },
                                {
                                    "Text": "BARACHIRKA ",
                                    "Value": "BARACHIRKA "
                                },
                                {
                                    "Text": "BARAMA",
                                    "Value": "BARAMA"
                                },
                                {
                                    "Text": "BARANA",
                                    "Value": "BARANA"
                                },
                                {
                                    "Text": "BARARA",
                                    "Value": "BARARA"
                                },
                                {
                                    "Text": "BARAULI",
                                    "Value": "BARAULI"
                                },
                                {
                                    "Text": "BARAUT",
                                    "Value": "BARAUT"
                                },
                                {
                                    "Text": "BARBIL",
                                    "Value": "BARBIL"
                                },
                                {
                                    "Text": "BARDEZ",
                                    "Value": "BARDEZ"
                                },
                                {
                                    "Text": "BARDOLI",
                                    "Value": "BARDOLI"
                                },
                                {
                                    "Text": "BARDHAMAN",
                                    "Value": "BARDHAMAN"
                                },
                                {
                                    "Text": "BAREILLY",
                                    "Value": "BAREILLY"
                                },
                                {
                                    "Text": "BARELI",
                                    "Value": "BARELI"
                                },
                                {
                                    "Text": "BARETHI",
                                    "Value": "BARETHI"
                                },
                                {
                                    "Text": "BAREWAL AWANNA",
                                    "Value": "BAREWAL AWANNA"
                                },
                                {
                                    "Text": "BARFUNG",
                                    "Value": "BARFUNG"
                                },
                                {
                                    "Text": "BARGARH",
                                    "Value": "BARGARH"
                                },
                                {
                                    "Text": "BARGARI",
                                    "Value": "BARGARI"
                                },
                                {
                                    "Text": "BARH",
                                    "Value": "BARH"
                                },
                                {
                                    "Text": "BARHAJ",
                                    "Value": "BARHAJ"
                                },
                                {
                                    "Text": "BARHALGANJ",
                                    "Value": "BARHALGANJ"
                                },
                                {
                                    "Text": "BARHERI BADI",
                                    "Value": "BARHERI BADI"
                                },
                                {
                                    "Text": "BARHI",
                                    "Value": "BARHI"
                                },
                                {
                                    "Text": "BARIPADA",
                                    "Value": "BARIPADA"
                                },
                                {
                                    "Text": "BARI BRAHMANA",
                                    "Value": "BARI BRAHMANA"
                                },
                                {
                                    "Text": "BARIAN KALAN",
                                    "Value": "BARIAN KALAN"
                                },
                                {
                                    "Text": "BARIWALA",
                                    "Value": "BARIWALA"
                                },
                                {
                                    "Text": "BARKATABAD",
                                    "Value": "BARKATABAD"
                                },
                                {
                                    "Text": "BARMER",
                                    "Value": "BARMER"
                                },
                                {
                                    "Text": "BARNALA",
                                    "Value": "BARNALA"
                                },
                                {
                                    "Text": "BARODA",
                                    "Value": "BARODA"
                                },
                                {
                                    "Text": "BARPETA",
                                    "Value": "BARPETA"
                                },
                                {
                                    "Text": "BARRACKPORE",
                                    "Value": "BARRACKPORE"
                                },
                                {
                                    "Text": "BARSHI",
                                    "Value": "BARSHI"
                                },
                                {
                                    "Text": "BARSAR",
                                    "Value": "BARSAR"
                                },
                                {
                                    "Text": "BARWALA",
                                    "Value": "BARWALA"
                                },
                                {
                                    "Text": "BARWANI",
                                    "Value": "BARWANI"
                                },
                                {
                                    "Text": "BARWAHA",
                                    "Value": "BARWAHA"
                                },
                                {
                                    "Text": "BARWALA",
                                    "Value": "BARWALA"
                                },
                                {
                                    "Text": "BASAR",
                                    "Value": "BASAR"
                                },
                                {
                                    "Text": "BASANTPURA ",
                                    "Value": "BASANTPURA "
                                },
                                {
                                    "Text": "BASAVAKALYAN",
                                    "Value": "BASAVAKALYAN"
                                },
                                {
                                    "Text": "BASKHARI",
                                    "Value": "BASKHARI"
                                },
                                {
                                    "Text": "BASKUSHLA",
                                    "Value": "BASKUSHLA"
                                },
                                {
                                    "Text": "BASNA",
                                    "Value": "BASNA"
                                },
                                {
                                    "Text": "BASNI SILAWANTAN",
                                    "Value": "BASNI SILAWANTAN"
                                },
                                {
                                    "Text": "BASODA",
                                    "Value": "BASODA"
                                },
                                {
                                    "Text": "BASSI PATHANA",
                                    "Value": "BASSI PATHANA"
                                },
                                {
                                    "Text": "BASTAR",
                                    "Value": "BASTAR"
                                },
                                {
                                    "Text": "BASTI",
                                    "Value": "BASTI"
                                },
                                {
                                    "Text": "BASWAPUR ",
                                    "Value": "BASWAPUR "
                                },
                                {
                                    "Text": "BATALA",
                                    "Value": "BATALA"
                                },
                                {
                                    "Text": "BATHINDA",
                                    "Value": "BATHINDA"
                                },
                                {
                                    "Text": "BATLAGUNDU",
                                    "Value": "BATLAGUNDU"
                                },
                                {
                                    "Text": "BAUDHGARH",
                                    "Value": "BAUDHGARH"
                                },
                                {
                                    "Text": "BAVLA",
                                    "Value": "BAVLA"
                                },
                                {
                                    "Text": "BAWAL",
                                    "Value": "BAWAL"
                                },
                                {
                                    "Text": "BAWANI KHERA",
                                    "Value": "BAWANI KHERA"
                                },
                                {
                                    "Text": "BAWNE PANGRI ",
                                    "Value": "BAWNE PANGRI "
                                },
                                {
                                    "Text": "BAZPUR",
                                    "Value": "BAZPUR"
                                },
                                {
                                    "Text": "BABAR PUR",
                                    "Value": "BABAR PUR"
                                },
                                {
                                    "Text": "BADHOI",
                                    "Value": "BADHOI"
                                },
                                {
                                    "Text": "BADHAIU",
                                    "Value": "BADHAIU"
                                },
                                {
                                    "Text": "BADAUN",
                                    "Value": "BADAUN"
                                },
                                {
                                    "Text": "BUDHWARIA",
                                    "Value": "BUDHWARIA"
                                },
                                {
                                    "Text": "BEAS",
                                    "Value": "BEAS"
                                },
                                {
                                    "Text": "BEAWAR",
                                    "Value": "BEAWAR"
                                },
                                {
                                    "Text": "BEBAD OHOL",
                                    "Value": "BEBAD OHOL"
                                },
                                {
                                    "Text": "BECHARAJI",
                                    "Value": "BECHARAJI"
                                },
                                {
                                    "Text": "BEDI APMC",
                                    "Value": "BEDI APMC"
                                },
                                {
                                    "Text": "BEDI-APMC",
                                    "Value": "BEDI-APMC"
                                },
                                {
                                    "Text": "BEED",
                                    "Value": "BEED"
                                },
                                {
                                    "Text": "BEGOWAL",
                                    "Value": "BEGOWAL"
                                },
                                {
                                    "Text": "BEGUM PUR",
                                    "Value": "BEGUM PUR"
                                },
                                {
                                    "Text": "BEGUSARAI",
                                    "Value": "BEGUSARAI"
                                },
                                {
                                    "Text": "BEGUN",
                                    "Value": "BEGUN"
                                },
                                {
                                    "Text": "BEHAT",
                                    "Value": "BEHAT"
                                },
                                {
                                    "Text": "BEHRAMPUR",
                                    "Value": "BEHRAMPUR"
                                },
                                {
                                    "Text": "BEHRAICH",
                                    "Value": "BEHRAICH"
                                },
                                {
                                    "Text": "BEHROR",
                                    "Value": "BEHROR"
                                },
                                {
                                    "Text": "BEHRAM",
                                    "Value": "BEHRAM"
                                },
                                {
                                    "Text": "BEHRAMPUR",
                                    "Value": "BEHRAMPUR"
                                },
                                {
                                    "Text": "BELDIH ",
                                    "Value": "BELDIH "
                                },
                                {
                                    "Text": "BELGAUM",
                                    "Value": "BELGAUM"
                                },
                                {
                                    "Text": "BELLARY",
                                    "Value": "BELLARY"
                                },
                                {
                                    "Text": "BELLAMPALLE",
                                    "Value": "BELLAMPALLE"
                                },
                                {
                                    "Text": "BELTHANGADY",
                                    "Value": "BELTHANGADY"
                                },
                                {
                                    "Text": "BELTHARA ROAD",
                                    "Value": "BELTHARA ROAD"
                                },
                                {
                                    "Text": "BELTOLA",
                                    "Value": "BELTOLA"
                                },
                                {
                                    "Text": "BEMBAL ",
                                    "Value": "BEMBAL "
                                },
                                {
                                    "Text": "BEMETARA",
                                    "Value": "BEMETARA"
                                },
                                {
                                    "Text": "BENAPUR",
                                    "Value": "BENAPUR"
                                },
                                {
                                    "Text": "BENAULIM",
                                    "Value": "BENAULIM"
                                },
                                {
                                    "Text": "BENGALURU",
                                    "Value": "BENGALURU"
                                },
                                {
                                    "Text": "BENNABHUPALAPATNAM ",
                                    "Value": "BENNABHUPALAPATNAM "
                                },
                                {
                                    "Text": "BEN",
                                    "Value": "BEN"
                                },
                                {
                                    "Text": "BERHAMPORE",
                                    "Value": "BERHAMPORE"
                                },
                                {
                                    "Text": "BESA ROAD ",
                                    "Value": "BESA ROAD "
                                },
                                {
                                    "Text": "BETASING",
                                    "Value": "BETASING"
                                },
                                {
                                    "Text": "BETIAH",
                                    "Value": "BETIAH"
                                },
                                {
                                    "Text": "BETTIAH",
                                    "Value": "BETTIAH"
                                },
                                {
                                    "Text": "BETUL",
                                    "Value": "BETUL"
                                },
                                {
                                    "Text": "BAGAHA-I",
                                    "Value": "BAGAHA-I"
                                },
                                {
                                    "Text": "BEGUMABAD BUDHANA",
                                    "Value": "BEGUMABAD BUDHANA"
                                },
                                {
                                    "Text": "BAGASARA",
                                    "Value": "BAGASARA"
                                },
                                {
                                    "Text": "BHADRA",
                                    "Value": "BHADRA"
                                },
                                {
                                    "Text": "BHACHAU",
                                    "Value": "BHACHAU"
                                },
                                {
                                    "Text": "BHADOHI",
                                    "Value": "BHADOHI"
                                },
                                {
                                    "Text": "BHADRACHALAM",
                                    "Value": "BHADRACHALAM"
                                },
                                {
                                    "Text": "BHADRAK",
                                    "Value": "BHADRAK"
                                },
                                {
                                    "Text": "BHADRAVATI",
                                    "Value": "BHADRAVATI"
                                },
                                {
                                    "Text": "BHADAUR",
                                    "Value": "BHADAUR"
                                },
                                {
                                    "Text": "BHADERWAH",
                                    "Value": "BHADERWAH"
                                },
                                {
                                    "Text": "BHADKODRA",
                                    "Value": "BHADKODRA"
                                },
                                {
                                    "Text": "BHADRAWATI",
                                    "Value": "BHADRAWATI"
                                },
                                {
                                    "Text": "BHADSON",
                                    "Value": "BHADSON"
                                },
                                {
                                    "Text": "BHAGALPUR",
                                    "Value": "BHAGALPUR"
                                },
                                {
                                    "Text": "BHAGTHALA KALAN ",
                                    "Value": "BHAGTHALA KALAN "
                                },
                                {
                                    "Text": "BHAGAN",
                                    "Value": "BHAGAN"
                                },
                                {
                                    "Text": "BHAGO MAJRA",
                                    "Value": "BHAGO MAJRA"
                                },
                                {
                                    "Text": "BHAGOKE",
                                    "Value": "BHAGOKE"
                                },
                                {
                                    "Text": "BHAGRANA",
                                    "Value": "BHAGRANA"
                                },
                                {
                                    "Text": "BHAGTA",
                                    "Value": "BHAGTA"
                                },
                                {
                                    "Text": "BHAINSA",
                                    "Value": "BHAINSA"
                                },
                                {
                                    "Text": "BHAINSORI ",
                                    "Value": "BHAINSORI "
                                },
                                {
                                    "Text": "BHAKARWADI ",
                                    "Value": "BHAKARWADI "
                                },
                                {
                                    "Text": "BHALGAMDA",
                                    "Value": "BHALGAMDA"
                                },
                                {
                                    "Text": "BHALONA ",
                                    "Value": "BHALONA "
                                },
                                {
                                    "Text": "BHALIABHOLKATENI",
                                    "Value": "BHALIABHOLKATENI"
                                },
                                {
                                    "Text": "BHALKI",
                                    "Value": "BHALKI"
                                },
                                {
                                    "Text": "BHAMARSI",
                                    "Value": "BHAMARSI"
                                },
                                {
                                    "Text": "BHAMBOLI",
                                    "Value": "BHAMBOLI"
                                },
                                {
                                    "Text": "BHANDARA",
                                    "Value": "BHANDARA"
                                },
                                {
                                    "Text": "BHANVAD",
                                    "Value": "BHANVAD"
                                },
                                {
                                    "Text": "BHANGALA",
                                    "Value": "BHANGALA"
                                },
                                {
                                    "Text": "BHANJANAGAR",
                                    "Value": "BHANJANAGAR"
                                },
                                {
                                    "Text": "BHANPURI",
                                    "Value": "BHANPURI"
                                },
                                {
                                    "Text": "BHANVAD",
                                    "Value": "BHANVAD"
                                },
                                {
                                    "Text": "BHAPAL ",
                                    "Value": "BHAPAL "
                                },
                                {
                                    "Text": "BHARATPUR",
                                    "Value": "BHARATPUR"
                                },
                                {
                                    "Text": "BHARUCH",
                                    "Value": "BHARUCH"
                                },
                                {
                                    "Text": "BHARMOUR",
                                    "Value": "BHARMOUR"
                                },
                                {
                                    "Text": "BHARNI",
                                    "Value": "BHARNI"
                                },
                                {
                                    "Text": "BHARTHANA",
                                    "Value": "BHARTHANA"
                                },
                                {
                                    "Text": "BHATPARA",
                                    "Value": "BHATPARA"
                                },
                                {
                                    "Text": "BHATAPARA",
                                    "Value": "BHATAPARA"
                                },
                                {
                                    "Text": "BHATINDA",
                                    "Value": "BHATINDA"
                                },
                                {
                                    "Text": "BHATKAL",
                                    "Value": "BHATKAL"
                                },
                                {
                                    "Text": "BHATEPURI ",
                                    "Value": "BHATEPURI "
                                },
                                {
                                    "Text": "BHATRAMARENAHALLI",
                                    "Value": "BHATRAMARENAHALLI"
                                },
                                {
                                    "Text": "BHATTIAN",
                                    "Value": "BHATTIAN"
                                },
                                {
                                    "Text": "BHATTU KALAN",
                                    "Value": "BHATTU KALAN"
                                },
                                {
                                    "Text": "BHAVNAGAR",
                                    "Value": "BHAVNAGAR"
                                },
                                {
                                    "Text": "BHAVANAGAR",
                                    "Value": "BHAVANAGAR"
                                },
                                {
                                    "Text": "BHAVANIPET ",
                                    "Value": "BHAVANIPET "
                                },
                                {
                                    "Text": "BHAWANIGARH",
                                    "Value": "BHAWANIGARH"
                                },
                                {
                                    "Text": "BHAWANIPATNA",
                                    "Value": "BHAWANIPATNA"
                                },
                                {
                                    "Text": "BHAWAI ",
                                    "Value": "BHAWAI "
                                },
                                {
                                    "Text": "BHAWANIPUR ",
                                    "Value": "BHAWANIPUR "
                                },
                                {
                                    "Text": "BHAYANDER",
                                    "Value": "BHAYANDER"
                                },
                                {
                                    "Text": "BHEDWAL ",
                                    "Value": "BHEDWAL "
                                },
                                {
                                    "Text": "BHEJGAON ",
                                    "Value": "BHEJGAON "
                                },
                                {
                                    "Text": "BHERIWADA ",
                                    "Value": "BHERIWADA "
                                },
                                {
                                    "Text": "BHALGAMDA",
                                    "Value": "BHALGAMDA"
                                },
                                {
                                    "Text": "BHIKHIWIND",
                                    "Value": "BHIKHIWIND"
                                },
                                {
                                    "Text": "BHIKHI",
                                    "Value": "BHIKHI"
                                },
                                {
                                    "Text": "BHILAI",
                                    "Value": "BHILAI"
                                },
                                {
                                    "Text": "BHILWARA",
                                    "Value": "BHILWARA"
                                },
                                {
                                    "Text": "BHILAI CHARODA",
                                    "Value": "BHILAI CHARODA"
                                },
                                {
                                    "Text": "BHIMAVARAM",
                                    "Value": "BHIMAVARAM"
                                },
                                {
                                    "Text": "BHIND",
                                    "Value": "BHIND"
                                },
                                {
                                    "Text": "BHINGA",
                                    "Value": "BHINGA"
                                },
                                {
                                    "Text": "BHINMAL",
                                    "Value": "BHINMAL"
                                },
                                {
                                    "Text": "BHIWADI",
                                    "Value": "BHIWADI"
                                },
                                {
                                    "Text": "BHIWANI",
                                    "Value": "BHIWANI"
                                },
                                {
                                    "Text": "BHANDUP",
                                    "Value": "BHANDUP"
                                },
                                {
                                    "Text": "BHODIPURA",
                                    "Value": "BHODIPURA"
                                },
                                {
                                    "Text": "BHOGPUR",
                                    "Value": "BHOGPUR"
                                },
                                {
                                    "Text": "BHOGA SAMUDRAM",
                                    "Value": "BHOGA SAMUDRAM"
                                },
                                {
                                    "Text": "BHOJPUR",
                                    "Value": "BHOJPUR"
                                },
                                {
                                    "Text": "BHOKHRA",
                                    "Value": "BHOKHRA"
                                },
                                {
                                    "Text": "BHOLATH",
                                    "Value": "BHOLATH"
                                },
                                {
                                    "Text": "BHONGIR",
                                    "Value": "BHONGIR"
                                },
                                {
                                    "Text": "BHONGIR GUNJ ",
                                    "Value": "BHONGIR GUNJ "
                                },
                                {
                                    "Text": "BHONRKA ",
                                    "Value": "BHONRKA "
                                },
                                {
                                    "Text": "BHOORA ",
                                    "Value": "BHOORA "
                                },
                                {
                                    "Text": "BHOPAL",
                                    "Value": "BHOPAL"
                                },
                                {
                                    "Text": "BHOPANI",
                                    "Value": "BHOPANI"
                                },
                                {
                                    "Text": "BHORING",
                                    "Value": "BHORING"
                                },
                                {
                                    "Text": "BHOSARI",
                                    "Value": "BHOSARI"
                                },
                                {
                                    "Text": "BIHARSHARIF",
                                    "Value": "BIHARSHARIF"
                                },
                                {
                                    "Text": "BEHTA HAJIPUR",
                                    "Value": "BEHTA HAJIPUR"
                                },
                                {
                                    "Text": "BHATI",
                                    "Value": "BHATI"
                                },
                                {
                                    "Text": "BHUBANESHWAR",
                                    "Value": "BHUBANESHWAR"
                                },
                                {
                                    "Text": "BHUBANESWAR",
                                    "Value": "BHUBANESWAR"
                                },
                                {
                                    "Text": "BHUCHO MANDI",
                                    "Value": "BHUCHO MANDI"
                                },
                                {
                                    "Text": "BHUJ",
                                    "Value": "BHUJ"
                                },
                                {
                                    "Text": "BHUJODI",
                                    "Value": "BHUJODI"
                                },
                                {
                                    "Text": "BHULATH",
                                    "Value": "BHULATH"
                                },
                                {
                                    "Text": "BHUNDRI",
                                    "Value": "BHUNDRI"
                                },
                                {
                                    "Text": "BHUNTAR",
                                    "Value": "BHUNTAR"
                                },
                                {
                                    "Text": "BHUSAWAL",
                                    "Value": "BHUSAWAL"
                                },
                                {
                                    "Text": "BHUSAWAL",
                                    "Value": "BHUSAWAL"
                                },
                                {
                                    "Text": "BIAORA",
                                    "Value": "BIAORA"
                                },
                                {
                                    "Text": "BICHOLIM",
                                    "Value": "BICHOLIM"
                                },
                                {
                                    "Text": "BIDADI",
                                    "Value": "BIDADI"
                                },
                                {
                                    "Text": "BIDAR",
                                    "Value": "BIDAR"
                                },
                                {
                                    "Text": "BIDAR",
                                    "Value": "BIDAR"
                                },
                                {
                                    "Text": "BIDALUR ",
                                    "Value": "BIDALUR "
                                },
                                {
                                    "Text": "BIDHAN NAGAR",
                                    "Value": "BIDHAN NAGAR"
                                },
                                {
                                    "Text": "BIDHUNA",
                                    "Value": "BIDHUNA"
                                },
                                {
                                    "Text": "BID",
                                    "Value": "BID"
                                },
                                {
                                    "Text": "BIHAR",
                                    "Value": "BIHAR"
                                },
                                {
                                    "Text": "BIHAT BIRAM",
                                    "Value": "BIHAT BIRAM"
                                },
                                {
                                    "Text": "BIJAINAGAR",
                                    "Value": "BIJAINAGAR"
                                },
                                {
                                    "Text": "BIJAPUR",
                                    "Value": "BIJAPUR"
                                },
                                {
                                    "Text": "BIJAPUR(CGH)",
                                    "Value": "BIJAPUR(CGH)"
                                },
                                {
                                    "Text": "BIJAPUR(KAR)",
                                    "Value": "BIJAPUR(KAR)"
                                },
                                {
                                    "Text": "BIJAPUR",
                                    "Value": "BIJAPUR"
                                },
                                {
                                    "Text": "BIJA",
                                    "Value": "BIJA"
                                },
                                {
                                    "Text": "BIJBEHARA",
                                    "Value": "BIJBEHARA"
                                },
                                {
                                    "Text": "BIJJAWARA ",
                                    "Value": "BIJJAWARA "
                                },
                                {
                                    "Text": "BIJJAWARA",
                                    "Value": "BIJJAWARA"
                                },
                                {
                                    "Text": "BIJNOR",
                                    "Value": "BIJNOR"
                                },
                                {
                                    "Text": "BIJOYNAGAR",
                                    "Value": "BIJOYNAGAR"
                                },
                                {
                                    "Text": "BIKANER",
                                    "Value": "BIKANER"
                                },
                                {
                                    "Text": "BIKRAMGANJ",
                                    "Value": "BIKRAMGANJ"
                                },
                                {
                                    "Text": "BILASPUR(CGH)",
                                    "Value": "BILASPUR(CGH)"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILARA",
                                    "Value": "BILARA"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILASPUR (HP)",
                                    "Value": "BILASPUR (HP)"
                                },
                                {
                                    "Text": "BILARI",
                                    "Value": "BILARI"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILGA",
                                    "Value": "BILGA"
                                },
                                {
                                    "Text": "BILGI",
                                    "Value": "BILGI"
                                },
                                {
                                    "Text": "BILHA",
                                    "Value": "BILHA"
                                },
                                {
                                    "Text": "BILIMORA",
                                    "Value": "BILIMORA"
                                },
                                {
                                    "Text": "BILLIMORA",
                                    "Value": "BILLIMORA"
                                },
                                {
                                    "Text": "BINA",
                                    "Value": "BINA"
                                },
                                {
                                    "Text": "BINDKI",
                                    "Value": "BINDKI"
                                },
                                {
                                    "Text": "BINDKI",
                                    "Value": "BINDKI"
                                },
                                {
                                    "Text": "BINOVANAGAR",
                                    "Value": "BINOVANAGAR"
                                },
                                {
                                    "Text": "BINOLA",
                                    "Value": "BINOLA"
                                },
                                {
                                    "Text": "BIRAMITRAPUR",
                                    "Value": "BIRAMITRAPUR"
                                },
                                {
                                    "Text": "BIRBHUM",
                                    "Value": "BIRBHUM"
                                },
                                {
                                    "Text": "BIRKONA",
                                    "Value": "BIRKONA"
                                },
                                {
                                    "Text": "BIRMITRAPUR",
                                    "Value": "BIRMITRAPUR"
                                },
                                {
                                    "Text": "BISALPUR",
                                    "Value": "BISALPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNA",
                                    "Value": "BISHNA"
                                },
                                {
                                    "Text": "BISTAULI KHURD",
                                    "Value": "BISTAULI KHURD"
                                },
                                {
                                    "Text": "BISWANATH CHAIRALI",
                                    "Value": "BISWANATH CHAIRALI"
                                },
                                {
                                    "Text": "BISWANATH CHARIALI",
                                    "Value": "BISWANATH CHARIALI"
                                },
                                {
                                    "Text": "BALIBAT",
                                    "Value": "BALIBAT"
                                },
                                {
                                    "Text": "BHILODA",
                                    "Value": "BHILODA"
                                },
                                {
                                    "Text": "BALLARD ESTATE",
                                    "Value": "BALLARD ESTATE"
                                },
                                {
                                    "Text": "BALAGUNDA (BELAGULA)",
                                    "Value": "BALAGUNDA (BELAGULA)"
                                },
                                {
                                    "Text": "BHALSWA JAHANGIR PUR",
                                    "Value": "BHALSWA JAHANGIR PUR"
                                },
                                {
                                    "Text": "BANDEL",
                                    "Value": "BANDEL"
                                },
                                {
                                    "Text": "BOBBILI",
                                    "Value": "BOBBILI"
                                },
                                {
                                    "Text": "BODAKDEV",
                                    "Value": "BODAKDEV"
                                },
                                {
                                    "Text": "BODELI",
                                    "Value": "BODELI"
                                },
                                {
                                    "Text": "BODHI BIGHA ",
                                    "Value": "BODHI BIGHA "
                                },
                                {
                                    "Text": "BODHAN",
                                    "Value": "BODHAN"
                                },
                                {
                                    "Text": "BODHGAYA",
                                    "Value": "BODHGAYA"
                                },
                                {
                                    "Text": "BODINAYAKKANNUR",
                                    "Value": "BODINAYAKKANNUR"
                                },
                                {
                                    "Text": "BOHA",
                                    "Value": "BOHA"
                                },
                                {
                                    "Text": "BOISAR",
                                    "Value": "BOISAR"
                                },
                                {
                                    "Text": "BOISAR II CHITRALAYA",
                                    "Value": "BOISAR II CHITRALAYA"
                                },
                                {
                                    "Text": "BOISAR II, CHITRALAYA",
                                    "Value": "BOISAR II, CHITRALAYA"
                                },
                                {
                                    "Text": "BOKARO",
                                    "Value": "BOKARO"
                                },
                                {
                                    "Text": "BOKAKHAT",
                                    "Value": "BOKAKHAT"
                                },
                                {
                                    "Text": "BOKAKHAT",
                                    "Value": "BOKAKHAT"
                                },
                                {
                                    "Text": "BOKKUDUPALLE ",
                                    "Value": "BOKKUDUPALLE "
                                },
                                {
                                    "Text": "BOLANGIR",
                                    "Value": "BOLANGIR"
                                },
                                {
                                    "Text": "BOLAGARH",
                                    "Value": "BOLAGARH"
                                },
                                {
                                    "Text": "BOLPUR",
                                    "Value": "BOLPUR"
                                },
                                {
                                    "Text": "BOL",
                                    "Value": "BOL"
                                },
                                {
                                    "Text": "BOMDILA",
                                    "Value": "BOMDILA"
                                },
                                {
                                    "Text": "BOMMAKAL",
                                    "Value": "BOMMAKAL"
                                },
                                {
                                    "Text": "BONGAIGAON",
                                    "Value": "BONGAIGAON"
                                },
                                {
                                    "Text": "BOPAL",
                                    "Value": "BOPAL"
                                },
                                {
                                    "Text": "BORAM ",
                                    "Value": "BORAM "
                                },
                                {
                                    "Text": "BORBATA ",
                                    "Value": "BORBATA "
                                },
                                {
                                    "Text": "BORBHATHA BET",
                                    "Value": "BORBHATHA BET"
                                },
                                {
                                    "Text": "BORGAON ",
                                    "Value": "BORGAON "
                                },
                                {
                                    "Text": "BORONILPUR",
                                    "Value": "BORONILPUR"
                                },
                                {
                                    "Text": "BORSAD",
                                    "Value": "BORSAD"
                                },
                                {
                                    "Text": "BORIVALI (W)",
                                    "Value": "BORIVALI (W)"
                                },
                                {
                                    "Text": "BOTAD",
                                    "Value": "BOTAD"
                                },
                                {
                                    "Text": "BOUDH",
                                    "Value": "BOUDH"
                                },
                                {
                                    "Text": "BOYTAWALA",
                                    "Value": "BOYTAWALA"
                                },
                                {
                                    "Text": "BASSI PATHTANA",
                                    "Value": "BASSI PATHTANA"
                                },
                                {
                                    "Text": "BRAHMANPALLI ",
                                    "Value": "BRAHMANPALLI "
                                },
                                {
                                    "Text": "BRAHMANAPALLE ",
                                    "Value": "BRAHMANAPALLE "
                                },
                                {
                                    "Text": "BRAHMAPORE",
                                    "Value": "BRAHMAPORE"
                                },
                                {
                                    "Text": "BRAHMAPUR",
                                    "Value": "BRAHMAPUR"
                                },
                                {
                                    "Text": "BRAMHAPURI",
                                    "Value": "BRAMHAPURI"
                                },
                                {
                                    "Text": "BAREJA",
                                    "Value": "BAREJA"
                                },
                                {
                                    "Text": "BRAJRAJ NAGAR",
                                    "Value": "BRAJRAJ NAGAR"
                                },
                                {
                                    "Text": "BARIK",
                                    "Value": "BARIK"
                                },
                                {
                                    "Text": "BURARI",
                                    "Value": "BURARI"
                                },
                                {
                                    "Text": "BISHALGARH",
                                    "Value": "BISHALGARH"
                                },
                                {
                                    "Text": "BISOKHAR",
                                    "Value": "BISOKHAR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "B.S.PURAM ",
                                    "Value": "B.S.PURAM "
                                },
                                {
                                    "Text": "BASIRHAT",
                                    "Value": "BASIRHAT"
                                },
                                {
                                    "Text": "BETASING",
                                    "Value": "BETASING"
                                },
                                {
                                    "Text": "BUDAUN",
                                    "Value": "BUDAUN"
                                },
                                {
                                    "Text": "BUDDUGONDA ",
                                    "Value": "BUDDUGONDA "
                                },
                                {
                                    "Text": "BUDGAM",
                                    "Value": "BUDGAM"
                                },
                                {
                                    "Text": "BUDGE BUDGE",
                                    "Value": "BUDGE BUDGE"
                                },
                                {
                                    "Text": "BUDHLADA",
                                    "Value": "BUDHLADA"
                                },
                                {
                                    "Text": "BUDH SINGH WALA ",
                                    "Value": "BUDH SINGH WALA "
                                },
                                {
                                    "Text": "BUDHALDA",
                                    "Value": "BUDHALDA"
                                },
                                {
                                    "Text": "BUDHANA",
                                    "Value": "BUDHANA"
                                },
                                {
                                    "Text": "BUDHERA",
                                    "Value": "BUDHERA"
                                },
                                {
                                    "Text": "BULANDSHARE",
                                    "Value": "BULANDSHARE"
                                },
                                {
                                    "Text": "BULANDSHAHAR",
                                    "Value": "BULANDSHAHAR"
                                },
                                {
                                    "Text": "BULANDSHAHR",
                                    "Value": "BULANDSHAHR"
                                },
                                {
                                    "Text": "BULDANA",
                                    "Value": "BULDANA"
                                },
                                {
                                    "Text": "BULDHANA",
                                    "Value": "BULDHANA"
                                },
                                {
                                    "Text": "BULHOWAL",
                                    "Value": "BULHOWAL"
                                },
                                {
                                    "Text": "BUNDI",
                                    "Value": "BUNDI"
                                },
                                {
                                    "Text": "BURDWAN",
                                    "Value": "BURDWAN"
                                },
                                {
                                    "Text": "BURHAR",
                                    "Value": "BURHAR"
                                },
                                {
                                    "Text": "BURHANPUR",
                                    "Value": "BURHANPUR"
                                },
                                {
                                    "Text": "BURLA",
                                    "Value": "BURLA"
                                },
                                {
                                    "Text": "BURNPUR",
                                    "Value": "BURNPUR"
                                },
                                {
                                    "Text": "BURNIHAT",
                                    "Value": "BURNIHAT"
                                },
                                {
                                    "Text": "BUTALA",
                                    "Value": "BUTALA"
                                },
                                {
                                    "Text": "BUTCHAMPETA ",
                                    "Value": "BUTCHAMPETA "
                                },
                                {
                                    "Text": "BUTIBORI",
                                    "Value": "BUTIBORI"
                                },
                                {
                                    "Text": "BUXAR",
                                    "Value": "BUXAR"
                                },
                                {
                                    "Text": "BHIWANDI",
                                    "Value": "BHIWANDI"
                                },
                                {
                                    "Text": "BAWANA",
                                    "Value": "BAWANA"
                                },
                                {
                                    "Text": "BHOWANIPORE",
                                    "Value": "BHOWANIPORE"
                                },
                                {
                                    "Text": "BILLAWAR",
                                    "Value": "BILLAWAR"
                                },
                                {
                                    "Text": "BYRNIHAT",
                                    "Value": "BYRNIHAT"
                                },
                                {
                                    "Text": "BYRNIHAT",
                                    "Value": "BYRNIHAT"
                                },
                                {
                                    "Text": "CACHAR",
                                    "Value": "CACHAR"
                                },
                                {
                                    "Text": "CALANGUTE",
                                    "Value": "CALANGUTE"
                                },
                                {
                                    "Text": "CALICUT",
                                    "Value": "CALICUT"
                                },
                                {
                                    "Text": "CANACONA",
                                    "Value": "CANACONA"
                                },
                                {
                                    "Text": "CANDOLIM",
                                    "Value": "CANDOLIM"
                                },
                                {
                                    "Text": "CANNANORE",
                                    "Value": "CANNANORE"
                                },
                                {
                                    "Text": "CANSAULIM",
                                    "Value": "CANSAULIM"
                                },
                                {
                                    "Text": "CARAMBOLIM",
                                    "Value": "CARAMBOLIM"
                                },
                                {
                                    "Text": "CAVELOSIM",
                                    "Value": "CAVELOSIM"
                                },
                                {
                                    "Text": "GRAND CAYMAN",
                                    "Value": "GRAND CAYMAN"
                                },
                                {
                                    "Text": "CBD BELAPUR",
                                    "Value": "CBD BELAPUR"
                                },
                                {
                                    "Text": "CENTRAL DELHI",
                                    "Value": "CENTRAL DELHI"
                                },
                                {
                                    "Text": "CENTRAL UNIVERSITY OF KARNATAKA,KAD",
                                    "Value": "CENTRAL UNIVERSITY OF KARNATAKA,KAD"
                                },
                                {
                                    "Text": "CHABAL KALAN",
                                    "Value": "CHABAL KALAN"
                                },
                                {
                                    "Text": "CHABEWAL",
                                    "Value": "CHABEWAL"
                                },
                                {
                                    "Text": "CHADURA",
                                    "Value": "CHADURA"
                                },
                                {
                                    "Text": "CHAIBASA",
                                    "Value": "CHAIBASA"
                                },
                                {
                                    "Text": "CHAKSU",
                                    "Value": "CHAKSU"
                                },
                                {
                                    "Text": "CHAKAN",
                                    "Value": "CHAKAN"
                                },
                                {
                                    "Text": "CHAK KALAN",
                                    "Value": "CHAK KALAN"
                                },
                                {
                                    "Text": "CHAK PAKHI",
                                    "Value": "CHAK PAKHI"
                                },
                                {
                                    "Text": "CHAKARBHATHA",
                                    "Value": "CHAKARBHATHA"
                                },
                                {
                                    "Text": "CHAKDANA",
                                    "Value": "CHAKDANA"
                                },
                                {
                                    "Text": "CHAKRADHARPUR",
                                    "Value": "CHAKRADHARPUR"
                                },
                                {
                                    "Text": "CHALISGAON",
                                    "Value": "CHALISGAON"
                                },
                                {
                                    "Text": "CHALLAKERE",
                                    "Value": "CHALLAKERE"
                                },
                                {
                                    "Text": "CHALAKUDY",
                                    "Value": "CHALAKUDY"
                                },
                                {
                                    "Text": "CHALIKKAVATTOM",
                                    "Value": "CHALIKKAVATTOM"
                                },
                                {
                                    "Text": "CHALLAVARIGUDEM ",
                                    "Value": "CHALLAVARIGUDEM "
                                },
                                {
                                    "Text": "CHALHERI ",
                                    "Value": "CHALHERI "
                                },
                                {
                                    "Text": "CHAMPA",
                                    "Value": "CHAMPA"
                                },
                                {
                                    "Text": "CHAMOLI",
                                    "Value": "CHAMOLI"
                                },
                                {
                                    "Text": "CHAMPAWAT",
                                    "Value": "CHAMPAWAT"
                                },
                                {
                                    "Text": "CHAMRAJNAGAR",
                                    "Value": "CHAMRAJNAGAR"
                                },
                                {
                                    "Text": "CHAMPHAI",
                                    "Value": "CHAMPHAI"
                                },
                                {
                                    "Text": "CHAMPADANGA",
                                    "Value": "CHAMPADANGA"
                                },
                                {
                                    "Text": "CHAMBA",
                                    "Value": "CHAMBA"
                                },
                                {
                                    "Text": "CHAMARU ",
                                    "Value": "CHAMARU "
                                },
                                {
                                    "Text": "CHAMARAJANAGAR",
                                    "Value": "CHAMARAJANAGAR"
                                },
                                {
                                    "Text": "CHAMKAUR SAHIB",
                                    "Value": "CHAMKAUR SAHIB"
                                },
                                {
                                    "Text": "CHAMPRAJPUR",
                                    "Value": "CHAMPRAJPUR"
                                },
                                {
                                    "Text": "CHAMYARI",
                                    "Value": "CHAMYARI"
                                },
                                {
                                    "Text": "CHANGANACHERRY",
                                    "Value": "CHANGANACHERRY"
                                },
                                {
                                    "Text": "CHANDAULI",
                                    "Value": "CHANDAULI"
                                },
                                {
                                    "Text": "CHANDEL",
                                    "Value": "CHANDEL"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANDRAPUR",
                                    "Value": "CHANDRAPUR"
                                },
                                {
                                    "Text": "CHANGLANG",
                                    "Value": "CHANGLANG"
                                },
                                {
                                    "Text": "CHANDRAPUR",
                                    "Value": "CHANDRAPUR"
                                },
                                {
                                    "Text": "CHANDAUSI",
                                    "Value": "CHANDAUSI"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANNAGIRI",
                                    "Value": "CHANNAGIRI"
                                },
                                {
                                    "Text": "CHANDANGAON ",
                                    "Value": "CHANDANGAON "
                                },
                                {
                                    "Text": "CHANDAI ECO ",
                                    "Value": "CHANDAI ECO "
                                },
                                {
                                    "Text": "CHAND NAU ",
                                    "Value": "CHAND NAU "
                                },
                                {
                                    "Text": "CHANDBAJA ",
                                    "Value": "CHANDBAJA "
                                },
                                {
                                    "Text": "CHANDAN CHAUKI ",
                                    "Value": "CHANDAN CHAUKI "
                                },
                                {
                                    "Text": "CHANDANAGAR",
                                    "Value": "CHANDANAGAR"
                                },
                                {
                                    "Text": "CHANDANNAGAR",
                                    "Value": "CHANDANNAGAR"
                                },
                                {
                                    "Text": "CHANGODAR",
                                    "Value": "CHANGODAR"
                                },
                                {
                                    "Text": "CHANDER NAGAR",
                                    "Value": "CHANDER NAGAR"
                                },
                                {
                                    "Text": "CHANDGAD",
                                    "Value": "CHANDGAD"
                                },
                                {
                                    "Text": "CHANDIKHOL",
                                    "Value": "CHANDIKHOL"
                                },
                                {
                                    "Text": "CHANDIMANDIR",
                                    "Value": "CHANDIMANDIR"
                                },
                                {
                                    "Text": "CHANDOR",
                                    "Value": "CHANDOR"
                                },
                                {
                                    "Text": "CHANDPUR",
                                    "Value": "CHANDPUR"
                                },
                                {
                                    "Text": "CHANDRANAGAR",
                                    "Value": "CHANDRANAGAR"
                                },
                                {
                                    "Text": "CHANDVAD",
                                    "Value": "CHANDVAD"
                                },
                                {
                                    "Text": "CHAPRA",
                                    "Value": "CHAPRA"
                                },
                                {
                                    "Text": "CHAPAD",
                                    "Value": "CHAPAD"
                                },
                                {
                                    "Text": "CHARKHI DADRI",
                                    "Value": "CHARKHI DADRI"
                                },
                                {
                                    "Text": "CHARKHI DADRI",
                                    "Value": "CHARKHI DADRI"
                                },
                                {
                                    "Text": "CHARNA ",
                                    "Value": "CHARNA "
                                },
                                {
                                    "Text": "CHARIK ",
                                    "Value": "CHARIK "
                                },
                                {
                                    "Text": "CHATRA",
                                    "Value": "CHATRA"
                                },
                                {
                                    "Text": "CHATARSAL",
                                    "Value": "CHATARSAL"
                                },
                                {
                                    "Text": "CHATTARPUR",
                                    "Value": "CHATTARPUR"
                                },
                                {
                                    "Text": "CHAUPAL",
                                    "Value": "CHAUPAL"
                                },
                                {
                                    "Text": "CHAVAKKAD",
                                    "Value": "CHAVAKKAD"
                                },
                                {
                                    "Text": "CHAWINDA DEVI",
                                    "Value": "CHAWINDA DEVI"
                                },
                                {
                                    "Text": "CHANDRASEKHARPUR",
                                    "Value": "CHANDRASEKHARPUR"
                                },
                                {
                                    "Text": "CHEEDIGUMMALA ",
                                    "Value": "CHEEDIGUMMALA "
                                },
                                {
                                    "Text": "CHEEMALAVALASA ",
                                    "Value": "CHEEMALAVALASA "
                                },
                                {
                                    "Text": "CHEEKA",
                                    "Value": "CHEEKA"
                                },
                                {
                                    "Text": "CHEEMA",
                                    "Value": "CHEEMA"
                                },
                                {
                                    "Text": "CHEMMAD",
                                    "Value": "CHEMMAD"
                                },
                                {
                                    "Text": "CHENNAI",
                                    "Value": "CHENNAI"
                                },
                                {
                                    "Text": "CHENGANNUR",
                                    "Value": "CHENGANNUR"
                                },
                                {
                                    "Text": "CHENGALPATTU",
                                    "Value": "CHENGALPATTU"
                                },
                                {
                                    "Text": "CHENGAM",
                                    "Value": "CHENGAM"
                                },
                                {
                                    "Text": "CHENNAIPALEM ",
                                    "Value": "CHENNAIPALEM "
                                },
                                {
                                    "Text": "CHENDRAPPINNI",
                                    "Value": "CHENDRAPPINNI"
                                },
                                {
                                    "Text": "CHEPUR ",
                                    "Value": "CHEPUR "
                                },
                                {
                                    "Text": "CHEPPAD",
                                    "Value": "CHEPPAD"
                                },
                                {
                                    "Text": "CHERAI",
                                    "Value": "CHERAI"
                                },
                                {
                                    "Text": "CHERPALACHERY",
                                    "Value": "CHERPALACHERY"
                                },
                                {
                                    "Text": "CHERTHALA",
                                    "Value": "CHERTHALA"
                                },
                                {
                                    "Text": "CHERUKUNNU",
                                    "Value": "CHERUKUNNU"
                                },
                                {
                                    "Text": "CHETTUPALLE ",
                                    "Value": "CHETTUPALLE "
                                },
                                {
                                    "Text": "CHETTIKULANGARA",
                                    "Value": "CHETTIKULANGARA"
                                },
                                {
                                    "Text": "CHHATARPUR",
                                    "Value": "CHHATARPUR"
                                },
                                {
                                    "Text": "CHHANI",
                                    "Value": "CHHANI"
                                },
                                {
                                    "Text": "CHHABRA",
                                    "Value": "CHHABRA"
                                },
                                {
                                    "Text": "CHHACHHARAULI",
                                    "Value": "CHHACHHARAULI"
                                },
                                {
                                    "Text": "CHHAT",
                                    "Value": "CHHAT"
                                },
                                {
                                    "Text": "CHHATRAL",
                                    "Value": "CHHATRAL"
                                },
                                {
                                    "Text": "CHHATRAPUR",
                                    "Value": "CHHATRAPUR"
                                },
                                {
                                    "Text": "CHHEDIA PASHCHIM ",
                                    "Value": "CHHEDIA PASHCHIM "
                                },
                                {
                                    "Text": "CHHEHERTA",
                                    "Value": "CHHEHERTA"
                                },
                                {
                                    "Text": "CHHENDIPADA",
                                    "Value": "CHHENDIPADA"
                                },
                                {
                                    "Text": "CHHIBRAMAU",
                                    "Value": "CHHIBRAMAU"
                                },
                                {
                                    "Text": "CHHINDWARA",
                                    "Value": "CHHINDWARA"
                                },
                                {
                                    "Text": "CHHIBRAMAU",
                                    "Value": "CHHIBRAMAU"
                                },
                                {
                                    "Text": "CHHOTA UDAIPUR",
                                    "Value": "CHHOTA UDAIPUR"
                                },
                                {
                                    "Text": "CHHOTA BANGURDA ",
                                    "Value": "CHHOTA BANGURDA "
                                },
                                {
                                    "Text": "CHHOTA UDAIPUR",
                                    "Value": "CHHOTA UDAIPUR"
                                },
                                {
                                    "Text": "CHHUTMALPUR",
                                    "Value": "CHHUTMALPUR"
                                },
                                {
                                    "Text": "CHHAWLA",
                                    "Value": "CHHAWLA"
                                },
                                {
                                    "Text": "CHICKMAGALUR",
                                    "Value": "CHICKMAGALUR"
                                },
                                {
                                    "Text": "CHIDAMBARAM",
                                    "Value": "CHIDAMBARAM"
                                },
                                {
                                    "Text": "CHIKALIM",
                                    "Value": "CHIKALIM"
                                },
                                {
                                    "Text": "CHIKHLI",
                                    "Value": "CHIKHLI"
                                },
                                {
                                    "Text": "CHIKODI",
                                    "Value": "CHIKODI"
                                },
                                {
                                    "Text": "CHIKKABALLAPUR",
                                    "Value": "CHIKKABALLAPUR"
                                },
                                {
                                    "Text": "CHIKHLI",
                                    "Value": "CHIKHLI"
                                },
                                {
                                    "Text": "CHIKATIMAMIDI ",
                                    "Value": "CHIKATIMAMIDI "
                                },
                                {
                                    "Text": "CHIKHALI ",
                                    "Value": "CHIKHALI "
                                },
                                {
                                    "Text": "CHIKBALLAPURA",
                                    "Value": "CHIKBALLAPURA"
                                },
                                {
                                    "Text": "CHIKMAGALUR",
                                    "Value": "CHIKMAGALUR"
                                },
                                {
                                    "Text": "CHIKHIL",
                                    "Value": "CHIKHIL"
                                },
                                {
                                    "Text": "CHIKHIL",
                                    "Value": "CHIKHIL"
                                },
                                {
                                    "Text": "CHILAKALURIPET",
                                    "Value": "CHILAKALURIPET"
                                },
                                {
                                    "Text": "CHIMRAJPALLE",
                                    "Value": "CHIMRAJPALLE"
                                },
                                {
                                    "Text": "CHINSURAH R S",
                                    "Value": "CHINSURAH R S"
                                },
                                {
                                    "Text": "CHINTAMANI",
                                    "Value": "CHINTAMANI"
                                },
                                {
                                    "Text": "CHINNARANGAPURAM ",
                                    "Value": "CHINNARANGAPURAM "
                                },
                                {
                                    "Text": "CHINTALAJUTUR ",
                                    "Value": "CHINTALAJUTUR "
                                },
                                {
                                    "Text": "CHINNAVARIGUDEM ",
                                    "Value": "CHINNAVARIGUDEM "
                                },
                                {
                                    "Text": "CHINTADA ",
                                    "Value": "CHINTADA "
                                },
                                {
                                    "Text": "CHINCHAVALI",
                                    "Value": "CHINCHAVALI"
                                },
                                {
                                    "Text": "CHINCHINIM",
                                    "Value": "CHINCHINIM"
                                },
                                {
                                    "Text": "CHINNAMIRAM",
                                    "Value": "CHINNAMIRAM"
                                },
                                {
                                    "Text": "CHIPLUN",
                                    "Value": "CHIPLUN"
                                },
                                {
                                    "Text": "CHIPARI",
                                    "Value": "CHIPARI"
                                },
                                {
                                    "Text": "CHIRALA",
                                    "Value": "CHIRALA"
                                },
                                {
                                    "Text": "CHIRAWA",
                                    "Value": "CHIRAWA"
                                },
                                {
                                    "Text": "CHIRGAON",
                                    "Value": "CHIRGAON"
                                },
                                {
                                    "Text": "CHITHARA",
                                    "Value": "CHITHARA"
                                },
                                {
                                    "Text": "CHITRADURGA",
                                    "Value": "CHITRADURGA"
                                },
                                {
                                    "Text": "CHITRAKOOT",
                                    "Value": "CHITRAKOOT"
                                },
                                {
                                    "Text": "CHITTOOR",
                                    "Value": "CHITTOOR"
                                },
                                {
                                    "Text": "CHITTORGARH",
                                    "Value": "CHITTORGARH"
                                },
                                {
                                    "Text": "CHITAKODUR ",
                                    "Value": "CHITAKODUR "
                                },
                                {
                                    "Text": "CHITTIVALASA ",
                                    "Value": "CHITTIVALASA "
                                },
                                {
                                    "Text": "CHITILI PUTLI ",
                                    "Value": "CHITILI PUTLI "
                                },
                                {
                                    "Text": "CHITHARA -SHIV NADAR UNIVERSITY",
                                    "Value": "CHITHARA -SHIV NADAR UNIVERSITY"
                                },
                                {
                                    "Text": "CHIRANG",
                                    "Value": "CHIRANG"
                                },
                                {
                                    "Text": "CHEMBUR",
                                    "Value": "CHEMBUR"
                                },
                                {
                                    "Text": "CHENGAM",
                                    "Value": "CHENGAM"
                                },
                                {
                                    "Text": "CHANNAGIRI",
                                    "Value": "CHANNAGIRI"
                                },
                                {
                                    "Text": "CHOCHRA",
                                    "Value": "CHOCHRA"
                                },
                                {
                                    "Text": "CHODAVARAM ",
                                    "Value": "CHODAVARAM "
                                },
                                {
                                    "Text": "CHOGAWAN",
                                    "Value": "CHOGAWAN"
                                },
                                {
                                    "Text": "CHOLA SAHIB",
                                    "Value": "CHOLA SAHIB"
                                },
                                {
                                    "Text": "CHOMU",
                                    "Value": "CHOMU"
                                },
                                {
                                    "Text": "CHOPDA",
                                    "Value": "CHOPDA"
                                },
                                {
                                    "Text": "CHOUTUPPAL",
                                    "Value": "CHOUTUPPAL"
                                },
                                {
                                    "Text": "CHRARI SHARIEF",
                                    "Value": "CHRARI SHARIEF"
                                },
                                {
                                    "Text": "CHITTARANJON",
                                    "Value": "CHITTARANJON"
                                },
                                {
                                    "Text": "CHILLA SARODA BANGAR",
                                    "Value": "CHILLA SARODA BANGAR"
                                },
                                {
                                    "Text": "CHUKKAPUR ",
                                    "Value": "CHUKKAPUR "
                                },
                                {
                                    "Text": "CHUNAR",
                                    "Value": "CHUNAR"
                                },
                                {
                                    "Text": "CHUNATI GADA",
                                    "Value": "CHUNATI GADA"
                                },
                                {
                                    "Text": "CHUNNI KALAN",
                                    "Value": "CHUNNI KALAN"
                                },
                                {
                                    "Text": "CHURACHANDPUR",
                                    "Value": "CHURACHANDPUR"
                                },
                                {
                                    "Text": "CHURU",
                                    "Value": "CHURU"
                                },
                                {
                                    "Text": "CHUREB",
                                    "Value": "CHUREB"
                                },
                                {
                                    "Text": "CHWADI",
                                    "Value": "CHWADI"
                                },
                                {
                                    "Text": "CHINCHWAD",
                                    "Value": "CHINCHWAD"
                                },
                                {
                                    "Text": "COLABA",
                                    "Value": "COLABA"
                                },
                                {
                                    "Text": "COLACHEL",
                                    "Value": "COLACHEL"
                                },
                                {
                                    "Text": "CUMBUM",
                                    "Value": "CUMBUM"
                                },
                                {
                                    "Text": "CANDOLIM",
                                    "Value": "CANDOLIM"
                                },
                                {
                                    "Text": "CHANNAPATNA",
                                    "Value": "CHANNAPATNA"
                                },
                                {
                                    "Text": "COCHIN",
                                    "Value": "COCHIN"
                                },
                                {
                                    "Text": "COIMBATORE",
                                    "Value": "COIMBATORE"
                                },
                                {
                                    "Text": "COLONELGANJ",
                                    "Value": "COLONELGANJ"
                                },
                                {
                                    "Text": "COLVA",
                                    "Value": "COLVA"
                                },
                                {
                                    "Text": "COLVALE",
                                    "Value": "COLVALE"
                                },
                                {
                                    "Text": "CONTAI",
                                    "Value": "CONTAI"
                                },
                                {
                                    "Text": "COOCH BEHAR",
                                    "Value": "COOCH BEHAR"
                                },
                                {
                                    "Text": "COONOOR",
                                    "Value": "COONOOR"
                                },
                                {
                                    "Text": "CARTERPURI",
                                    "Value": "CARTERPURI"
                                },
                                {
                                    "Text": "CUDDALORE",
                                    "Value": "CUDDALORE"
                                },
                                {
                                    "Text": "CUDDAPAH",
                                    "Value": "CUDDAPAH"
                                },
                                {
                                    "Text": "CUNCOLIM",
                                    "Value": "CUNCOLIM"
                                },
                                {
                                    "Text": "CURCHOREM",
                                    "Value": "CURCHOREM"
                                },
                                {
                                    "Text": "CURTORIM",
                                    "Value": "CURTORIM"
                                },
                                {
                                    "Text": "CUTTACK",
                                    "Value": "CUTTACK"
                                },
                                {
                                    "Text": "DABBASPET",
                                    "Value": "DABBASPET"
                                },
                                {
                                    "Text": "DABGAON MAKTHA ",
                                    "Value": "DABGAON MAKTHA "
                                },
                                {
                                    "Text": "DABHOI",
                                    "Value": "DABHOI"
                                },
                                {
                                    "Text": "DABHADI ",
                                    "Value": "DABHADI "
                                },
                                {
                                    "Text": "DABHEL",
                                    "Value": "DABHEL"
                                },
                                {
                                    "Text": "DABRA",
                                    "Value": "DABRA"
                                },
                                {
                                    "Text": "DABWALI",
                                    "Value": "DABWALI"
                                },
                                {
                                    "Text": "DADAHUR",
                                    "Value": "DADAHUR"
                                },
                                {
                                    "Text": "DADRA & NAGAR HAVELI",
                                    "Value": "DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "DADRI",
                                    "Value": "DADRI"
                                },
                                {
                                    "Text": "DAGAVADIYA",
                                    "Value": "DAGAVADIYA"
                                },
                                {
                                    "Text": "DAHANU ROAD",
                                    "Value": "DAHANU ROAD"
                                },
                                {
                                    "Text": "DAHANU",
                                    "Value": "DAHANU"
                                },
                                {
                                    "Text": "DAHEJ",
                                    "Value": "DAHEJ"
                                },
                                {
                                    "Text": "DAHIVALI",
                                    "Value": "DAHIVALI"
                                },
                                {
                                    "Text": "DAHOD",
                                    "Value": "DAHOD"
                                },
                                {
                                    "Text": "DAKOR",
                                    "Value": "DAKOR"
                                },
                                {
                                    "Text": "DAKSHINA KANNADA",
                                    "Value": "DAKSHINA KANNADA"
                                },
                                {
                                    "Text": "DALAM",
                                    "Value": "DALAM"
                                },
                                {
                                    "Text": "DALEKE ",
                                    "Value": "DALEKE "
                                },
                                {
                                    "Text": "DALHOUSIE",
                                    "Value": "DALHOUSIE"
                                },
                                {
                                    "Text": "DALLI RAJHARA",
                                    "Value": "DALLI RAJHARA"
                                },
                                {
                                    "Text": "DALSINGHSARAI",
                                    "Value": "DALSINGHSARAI"
                                },
                                {
                                    "Text": "DALTONGANJ",
                                    "Value": "DALTONGANJ"
                                },
                                {
                                    "Text": "DALTONGUNJ",
                                    "Value": "DALTONGUNJ"
                                },
                                {
                                    "Text": "DAMAN",
                                    "Value": "DAMAN"
                                },
                                {
                                    "Text": "DAMAN",
                                    "Value": "DAMAN"
                                },
                                {
                                    "Text": "DAMOH",
                                    "Value": "DAMOH"
                                },
                                {
                                    "Text": "DANDGAON ",
                                    "Value": "DANDGAON "
                                },
                                {
                                    "Text": "DANKUNI",
                                    "Value": "DANKUNI"
                                },
                                {
                                    "Text": "DANTEWADA",
                                    "Value": "DANTEWADA"
                                },
                                {
                                    "Text": "DAPORIJO",
                                    "Value": "DAPORIJO"
                                },
                                {
                                    "Text": "DAPOLI",
                                    "Value": "DAPOLI"
                                },
                                {
                                    "Text": "DARA",
                                    "Value": "DARA"
                                },
                                {
                                    "Text": "DARBHANGA",
                                    "Value": "DARBHANGA"
                                },
                                {
                                    "Text": "DARBARIBUR",
                                    "Value": "DARBARIBUR"
                                },
                                {
                                    "Text": "DARED",
                                    "Value": "DARED"
                                },
                                {
                                    "Text": "DARJEELING",
                                    "Value": "DARJEELING"
                                },
                                {
                                    "Text": "DARJILING",
                                    "Value": "DARJILING"
                                },
                                {
                                    "Text": "DARLA",
                                    "Value": "DARLA"
                                },
                                {
                                    "Text": "DARRANG",
                                    "Value": "DARRANG"
                                },
                                {
                                    "Text": "DARYAPUR",
                                    "Value": "DARYAPUR"
                                },
                                {
                                    "Text": "DASCROI",
                                    "Value": "DASCROI"
                                },
                                {
                                    "Text": "DASNA",
                                    "Value": "DASNA"
                                },
                                {
                                    "Text": "DASHRATH PURI",
                                    "Value": "DASHRATH PURI"
                                },
                                {
                                    "Text": "DASUYA",
                                    "Value": "DASUYA"
                                },
                                {
                                    "Text": "DATARPUR",
                                    "Value": "DATARPUR"
                                },
                                {
                                    "Text": "DATIA",
                                    "Value": "DATIA"
                                },
                                {
                                    "Text": "DATTAWADI",
                                    "Value": "DATTAWADI"
                                },
                                {
                                    "Text": "DAUND",
                                    "Value": "DAUND"
                                },
                                {
                                    "Text": "DAUSA",
                                    "Value": "DAUSA"
                                },
                                {
                                    "Text": "DAVANGERE",
                                    "Value": "DAVANGERE"
                                },
                                {
                                    "Text": "DAVANGARE",
                                    "Value": "DAVANGARE"
                                },
                                {
                                    "Text": "DAVORLIM",
                                    "Value": "DAVORLIM"
                                },
                                {
                                    "Text": "DAYALPURA MIRZA",
                                    "Value": "DAYALPURA MIRZA"
                                },
                                {
                                    "Text": "DELHI CANTONMENT",
                                    "Value": "DELHI CANTONMENT"
                                },
                                {
                                    "Text": "DEBAGARH",
                                    "Value": "DEBAGARH"
                                },
                                {
                                    "Text": "DEESA",
                                    "Value": "DEESA"
                                },
                                {
                                    "Text": "DEGLOOR",
                                    "Value": "DEGLOOR"
                                },
                                {
                                    "Text": "DEGAON ",
                                    "Value": "DEGAON "
                                },
                                {
                                    "Text": "DEHGAM",
                                    "Value": "DEHGAM"
                                },
                                {
                                    "Text": "DEHLON",
                                    "Value": "DEHLON"
                                },
                                {
                                    "Text": "DEHRADUN",
                                    "Value": "DEHRADUN"
                                },
                                {
                                    "Text": "DEHRA",
                                    "Value": "DEHRA"
                                },
                                {
                                    "Text": "DEHRI",
                                    "Value": "DEHRI"
                                },
                                {
                                    "Text": "DELA",
                                    "Value": "DELA"
                                },
                                {
                                    "Text": "DELAD",
                                    "Value": "DELAD"
                                },
                                {
                                    "Text": "DELEGAVAN ",
                                    "Value": "DELEGAVAN "
                                },
                                {
                                    "Text": "DELHI",
                                    "Value": "DELHI"
                                },
                                {
                                    "Text": "DEOLI",
                                    "Value": "DEOLI"
                                },
                                {
                                    "Text": "DEOBAND",
                                    "Value": "DEOBAND"
                                },
                                {
                                    "Text": "DEOGHAR",
                                    "Value": "DEOGHAR"
                                },
                                {
                                    "Text": "DEOGARH",
                                    "Value": "DEOGARH"
                                },
                                {
                                    "Text": "DEOGAR",
                                    "Value": "DEOGAR"
                                },
                                {
                                    "Text": "DEOLI",
                                    "Value": "DEOLI"
                                },
                                {
                                    "Text": "DEOLA",
                                    "Value": "DEOLA"
                                },
                                {
                                    "Text": "DEOLALI",
                                    "Value": "DEOLALI"
                                },
                                {
                                    "Text": "DEORIA",
                                    "Value": "DEORIA"
                                },
                                {
                                    "Text": "DERA BASSI",
                                    "Value": "DERA BASSI"
                                },
                                {
                                    "Text": "DERABASSI",
                                    "Value": "DERABASSI"
                                },
                                {
                                    "Text": "DERA BABA NANAK",
                                    "Value": "DERA BABA NANAK"
                                },
                                {
                                    "Text": "DEROL",
                                    "Value": "DEROL"
                                },
                                {
                                    "Text": "DEULGAON RAJA",
                                    "Value": "DEULGAON RAJA"
                                },
                                {
                                    "Text": "DEULGAON RAJA",
                                    "Value": "DEULGAON RAJA"
                                },
                                {
                                    "Text": "DEWAS",
                                    "Value": "DEWAS"
                                },
                                {
                                    "Text": "DEVANAPPLI ",
                                    "Value": "DEVANAPPLI "
                                },
                                {
                                    "Text": "DEVAKOTTAI",
                                    "Value": "DEVAKOTTAI"
                                },
                                {
                                    "Text": "DEVANAHALLI",
                                    "Value": "DEVANAHALLI"
                                },
                                {
                                    "Text": "DEVIGARH",
                                    "Value": "DEVIGARH"
                                },
                                {
                                    "Text": "DEVULAPALLY CALAN ",
                                    "Value": "DEVULAPALLY CALAN "
                                },
                                {
                                    "Text": "DEWAS",
                                    "Value": "DEWAS"
                                },
                                {
                                    "Text": "DEWADA KHURD ",
                                    "Value": "DEWADA KHURD "
                                },
                                {
                                    "Text": "DHAD",
                                    "Value": "DHAD"
                                },
                                {
                                    "Text": "DHAKIA ",
                                    "Value": "DHAKIA "
                                },
                                {
                                    "Text": "DHALAI",
                                    "Value": "DHALAI"
                                },
                                {
                                    "Text": "DHALLE KE ",
                                    "Value": "DHALLE KE "
                                },
                                {
                                    "Text": "DHAMPUR",
                                    "Value": "DHAMPUR"
                                },
                                {
                                    "Text": "DHAMOND",
                                    "Value": "DHAMOND"
                                },
                                {
                                    "Text": "DHAMTARI",
                                    "Value": "DHAMTARI"
                                },
                                {
                                    "Text": "DHAMORAH ",
                                    "Value": "DHAMORAH "
                                },
                                {
                                    "Text": "DHAMANGAON RAILWAY",
                                    "Value": "DHAMANGAON RAILWAY"
                                },
                                {
                                    "Text": "DHAMNOD",
                                    "Value": "DHAMNOD"
                                },
                                {
                                    "Text": "DHANERA",
                                    "Value": "DHANERA"
                                },
                                {
                                    "Text": "DHANBAD",
                                    "Value": "DHANBAD"
                                },
                                {
                                    "Text": "DHANAURI",
                                    "Value": "DHANAURI"
                                },
                                {
                                    "Text": "DHANNARAM ",
                                    "Value": "DHANNARAM "
                                },
                                {
                                    "Text": "DHANKANSU KALAN ",
                                    "Value": "DHANKANSU KALAN "
                                },
                                {
                                    "Text": "DHANELI UTTARI ",
                                    "Value": "DHANELI UTTARI "
                                },
                                {
                                    "Text": "DHANAULA",
                                    "Value": "DHANAULA"
                                },
                                {
                                    "Text": "DHAND",
                                    "Value": "DHAND"
                                },
                                {
                                    "Text": "DHANKOT",
                                    "Value": "DHANKOT"
                                },
                                {
                                    "Text": "DHANYAVI",
                                    "Value": "DHANYAVI"
                                },
                                {
                                    "Text": "DHAPAI ",
                                    "Value": "DHAPAI "
                                },
                                {
                                    "Text": "DHARMAPURI",
                                    "Value": "DHARMAPURI"
                                },
                                {
                                    "Text": "DHARI",
                                    "Value": "DHARI"
                                },
                                {
                                    "Text": "DHARAMSHALA",
                                    "Value": "DHARAMSHALA"
                                },
                                {
                                    "Text": "DHARWAD",
                                    "Value": "DHARWAD"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHARAMKOT",
                                    "Value": "DHARAMKOT"
                                },
                                {
                                    "Text": "DHARAPURAM",
                                    "Value": "DHARAPURAM"
                                },
                                {
                                    "Text": "DHARIWAL",
                                    "Value": "DHARIWAL"
                                },
                                {
                                    "Text": "DHAR",
                                    "Value": "DHAR"
                                },
                                {
                                    "Text": "DHARMAPURI",
                                    "Value": "DHARMAPURI"
                                },
                                {
                                    "Text": "DHARUHERA",
                                    "Value": "DHARUHERA"
                                },
                                {
                                    "Text": "DHARWARD",
                                    "Value": "DHARWARD"
                                },
                                {
                                    "Text": "DHARNASAGARAM ",
                                    "Value": "DHARNASAGARAM "
                                },
                                {
                                    "Text": "DHARIAWAD",
                                    "Value": "DHARIAWAD"
                                },
                                {
                                    "Text": "DHARMAJ",
                                    "Value": "DHARMAJ"
                                },
                                {
                                    "Text": "DHARMANAGAR",
                                    "Value": "DHARMANAGAR"
                                },
                                {
                                    "Text": "DHARPUR",
                                    "Value": "DHARPUR"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHAURA ",
                                    "Value": "DHAURA "
                                },
                                {
                                    "Text": "DHAULIMUNHA",
                                    "Value": "DHAULIMUNHA"
                                },
                                {
                                    "Text": "DHAURRA MAFI",
                                    "Value": "DHAURRA MAFI"
                                },
                                {
                                    "Text": "DHEMAJI",
                                    "Value": "DHEMAJI"
                                },
                                {
                                    "Text": "DHENKANAL",
                                    "Value": "DHENKANAL"
                                },
                                {
                                    "Text": "DHIANPUR",
                                    "Value": "DHIANPUR"
                                },
                                {
                                    "Text": "DHILWAN",
                                    "Value": "DHILWAN"
                                },
                                {
                                    "Text": "DHANDHUKA",
                                    "Value": "DHANDHUKA"
                                },
                                {
                                    "Text": "DHOKATA",
                                    "Value": "DHOKATA"
                                },
                                {
                                    "Text": "DHOLPUR",
                                    "Value": "DHOLPUR"
                                },
                                {
                                    "Text": "DHOLASAN",
                                    "Value": "DHOLASAN"
                                },
                                {
                                    "Text": "DHOLKA",
                                    "Value": "DHOLKA"
                                },
                                {
                                    "Text": "DHONE",
                                    "Value": "DHONE"
                                },
                                {
                                    "Text": "DHORAJI",
                                    "Value": "DHORAJI"
                                },
                                {
                                    "Text": "DHOTIAN",
                                    "Value": "DHOTIAN"
                                },
                                {
                                    "Text": "DHOYANPUR ",
                                    "Value": "DHOYANPUR "
                                },
                                {
                                    "Text": "DHRANGADHRA",
                                    "Value": "DHRANGADHRA"
                                },
                                {
                                    "Text": "DHROL",
                                    "Value": "DHROL"
                                },
                                {
                                    "Text": "DHAROTI KHURD",
                                    "Value": "DHAROTI KHURD"
                                },
                                {
                                    "Text": "DAHISAR(W)",
                                    "Value": "DAHISAR(W)"
                                },
                                {
                                    "Text": "DHUBRI",
                                    "Value": "DHUBRI"
                                },
                                {
                                    "Text": "DHUDHI ",
                                    "Value": "DHUDHI "
                                },
                                {
                                    "Text": "DHULE",
                                    "Value": "DHULE"
                                },
                                {
                                    "Text": "DHUNELA",
                                    "Value": "DHUNELA"
                                },
                                {
                                    "Text": "DHUPGURI",
                                    "Value": "DHUPGURI"
                                },
                                {
                                    "Text": "DHURI",
                                    "Value": "DHURI"
                                },
                                {
                                    "Text": "DHURKOT ",
                                    "Value": "DHURKOT "
                                },
                                {
                                    "Text": "DHUSKIYA ",
                                    "Value": "DHUSKIYA "
                                },
                                {
                                    "Text": "DIAMOND HARBOUR",
                                    "Value": "DIAMOND HARBOUR"
                                },
                                {
                                    "Text": "DIBANG VALLEY",
                                    "Value": "DIBANG VALLEY"
                                },
                                {
                                    "Text": "DIBIYAPUR",
                                    "Value": "DIBIYAPUR"
                                },
                                {
                                    "Text": "DIBRUGARH",
                                    "Value": "DIBRUGARH"
                                },
                                {
                                    "Text": "DIGBOI",
                                    "Value": "DIGBOI"
                                },
                                {
                                    "Text": "DIGHI ",
                                    "Value": "DIGHI "
                                },
                                {
                                    "Text": "DIGHORI ",
                                    "Value": "DIGHORI "
                                },
                                {
                                    "Text": "DIHIBATPUR PANCHANANTALA",
                                    "Value": "DIHIBATPUR PANCHANANTALA"
                                },
                                {
                                    "Text": "DILDAR NAGAR",
                                    "Value": "DILDAR NAGAR"
                                },
                                {
                                    "Text": "DILSHAD GARDEN",
                                    "Value": "DILSHAD GARDEN"
                                },
                                {
                                    "Text": "DIMAPUR",
                                    "Value": "DIMAPUR"
                                },
                                {
                                    "Text": "DINANAGAR",
                                    "Value": "DINANAGAR"
                                },
                                {
                                    "Text": "DANAPUR",
                                    "Value": "DANAPUR"
                                },
                                {
                                    "Text": "DINDORI",
                                    "Value": "DINDORI"
                                },
                                {
                                    "Text": "DINDIGUL",
                                    "Value": "DINDIGUL"
                                },
                                {
                                    "Text": "DINDORI",
                                    "Value": "DINDORI"
                                },
                                {
                                    "Text": "DING",
                                    "Value": "DING"
                                },
                                {
                                    "Text": "DINGRIAN",
                                    "Value": "DINGRIAN"
                                },
                                {
                                    "Text": "DINGUCHA",
                                    "Value": "DINGUCHA"
                                },
                                {
                                    "Text": "DINHATA",
                                    "Value": "DINHATA"
                                },
                                {
                                    "Text": "DIPHU",
                                    "Value": "DIPHU"
                                },
                                {
                                    "Text": "DIRBA",
                                    "Value": "DIRBA"
                                },
                                {
                                    "Text": "DISPUR",
                                    "Value": "DISPUR"
                                },
                                {
                                    "Text": "DIST AHAMADNAGAR",
                                    "Value": "DIST AHAMADNAGAR"
                                },
                                {
                                    "Text": "DIU",
                                    "Value": "DIU"
                                },
                                {
                                    "Text": "DIU",
                                    "Value": "DIU"
                                },
                                {
                                    "Text": "DALLO PURA",
                                    "Value": "DALLO PURA"
                                },
                                {
                                    "Text": "DILSUKHNAGAR",
                                    "Value": "DILSUKHNAGAR"
                                },
                                {
                                    "Text": "DODA",
                                    "Value": "DODA"
                                },
                                {
                                    "Text": "DODDAHEJJUR ",
                                    "Value": "DODDAHEJJUR "
                                },
                                {
                                    "Text": "DODDABALLAPUR",
                                    "Value": "DODDABALLAPUR"
                                },
                                {
                                    "Text": "DOGACHIA",
                                    "Value": "DOGACHIA"
                                },
                                {
                                    "Text": "DOHA",
                                    "Value": "DOHA"
                                },
                                {
                                    "Text": "DOONI",
                                    "Value": "DOONI"
                                },
                                {
                                    "Text": "DOMARAIGANJ",
                                    "Value": "DOMARAIGANJ"
                                },
                                {
                                    "Text": "DOMBIVALI",
                                    "Value": "DOMBIVALI"
                                },
                                {
                                    "Text": "DOMBIVLI",
                                    "Value": "DOMBIVLI"
                                },
                                {
                                    "Text": "DOMJUR",
                                    "Value": "DOMJUR"
                                },
                                {
                                    "Text": "DONA PAULA",
                                    "Value": "DONA PAULA"
                                },
                                {
                                    "Text": "DONAR",
                                    "Value": "DONAR"
                                },
                                {
                                    "Text": "DONGAON ",
                                    "Value": "DONGAON "
                                },
                                {
                                    "Text": "DOOMDOOMA",
                                    "Value": "DOOMDOOMA"
                                },
                                {
                                    "Text": "DOOMDOOMA",
                                    "Value": "DOOMDOOMA"
                                },
                                {
                                    "Text": "DOORU SHAHBAD",
                                    "Value": "DOORU SHAHBAD"
                                },
                                {
                                    "Text": "DORAHA",
                                    "Value": "DORAHA"
                                },
                                {
                                    "Text": "DOSANJH ",
                                    "Value": "DOSANJH "
                                },
                                {
                                    "Text": "DOWNURU ",
                                    "Value": "DOWNURU "
                                },
                                {
                                    "Text": "DRAMMAN",
                                    "Value": "DRAMMAN"
                                },
                                {
                                    "Text": "DUBAI",
                                    "Value": "DUBAI"
                                },
                                {
                                    "Text": "DUBRAJPUR",
                                    "Value": "DUBRAJPUR"
                                },
                                {
                                    "Text": "DUBURI",
                                    "Value": "DUBURI"
                                },
                                {
                                    "Text": "DUDHAD ",
                                    "Value": "DUDHAD "
                                },
                                {
                                    "Text": "DULIAJAN",
                                    "Value": "DULIAJAN"
                                },
                                {
                                    "Text": "DUMARIA ",
                                    "Value": "DUMARIA "
                                },
                                {
                                    "Text": "DUMAD",
                                    "Value": "DUMAD"
                                },
                                {
                                    "Text": "DUM DUM",
                                    "Value": "DUM DUM"
                                },
                                {
                                    "Text": "DUMKA",
                                    "Value": "DUMKA"
                                },
                                {
                                    "Text": "DUNAVADA",
                                    "Value": "DUNAVADA"
                                },
                                {
                                    "Text": "DUNDAHERA",
                                    "Value": "DUNDAHERA"
                                },
                                {
                                    "Text": "DUNGARPUR",
                                    "Value": "DUNGARPUR"
                                },
                                {
                                    "Text": "DUNGURIPALI",
                                    "Value": "DUNGURIPALI"
                                },
                                {
                                    "Text": "DUNGARI",
                                    "Value": "DUNGARI"
                                },
                                {
                                    "Text": "DURGAPUR",
                                    "Value": "DURGAPUR"
                                },
                                {
                                    "Text": "DURG",
                                    "Value": "DURG"
                                },
                                {
                                    "Text": "DURUHERA",
                                    "Value": "DURUHERA"
                                },
                                {
                                    "Text": "DWARKA",
                                    "Value": "DWARKA"
                                },
                                {
                                    "Text": "DWARKA",
                                    "Value": "DWARKA"
                                },
                                {
                                    "Text": "DAYAL PUR",
                                    "Value": "DAYAL PUR"
                                },
                                {
                                    "Text": "EAST NIMAR",
                                    "Value": "EAST NIMAR"
                                },
                                {
                                    "Text": "EAST KHASIHILL",
                                    "Value": "EAST KHASIHILL"
                                },
                                {
                                    "Text": "EAST CHAMPARAN",
                                    "Value": "EAST CHAMPARAN"
                                },
                                {
                                    "Text": "EAST DELHI",
                                    "Value": "EAST DELHI"
                                },
                                {
                                    "Text": "EAST GARO HILLS",
                                    "Value": "EAST GARO HILLS"
                                },
                                {
                                    "Text": "EAST GODAVARI",
                                    "Value": "EAST GODAVARI"
                                },
                                {
                                    "Text": "EAST KAMENG",
                                    "Value": "EAST KAMENG"
                                },
                                {
                                    "Text": "EAST KHASI HILLS",
                                    "Value": "EAST KHASI HILLS"
                                },
                                {
                                    "Text": "EAST SIANG",
                                    "Value": "EAST SIANG"
                                },
                                {
                                    "Text": "EAST SIKKIM",
                                    "Value": "EAST SIKKIM"
                                },
                                {
                                    "Text": "EAST SINGHBHUM",
                                    "Value": "EAST SINGHBHUM"
                                },
                                {
                                    "Text": "EAST MIDNAPORE",
                                    "Value": "EAST MIDNAPORE"
                                },
                                {
                                    "Text": "EDAPPAL",
                                    "Value": "EDAPPAL"
                                },
                                {
                                    "Text": "EDULAPOOSALAPALLI ",
                                    "Value": "EDULAPOOSALAPALLI "
                                },
                                {
                                    "Text": "EGRA",
                                    "Value": "EGRA"
                                },
                                {
                                    "Text": "EKLINGPURA",
                                    "Value": "EKLINGPURA"
                                },
                                {
                                    "Text": "EKMAMIDI ",
                                    "Value": "EKMAMIDI "
                                },
                                {
                                    "Text": "ELLENABAD",
                                    "Value": "ELLENABAD"
                                },
                                {
                                    "Text": "ELURU",
                                    "Value": "ELURU"
                                },
                                {
                                    "Text": "ERAMALLOOR",
                                    "Value": "ERAMALLOOR"
                                },
                                {
                                    "Text": "ERNAKULAM",
                                    "Value": "ERNAKULAM"
                                },
                                {
                                    "Text": "ERODE",
                                    "Value": "ERODE"
                                },
                                {
                                    "Text": "ERRABALLE ",
                                    "Value": "ERRABALLE "
                                },
                                {
                                    "Text": "ERRIPALLE ",
                                    "Value": "ERRIPALLE "
                                },
                                {
                                    "Text": "ERU",
                                    "Value": "ERU"
                                },
                                {
                                    "Text": "ETAH",
                                    "Value": "ETAH"
                                },
                                {
                                    "Text": "ETAWAH",
                                    "Value": "ETAWAH"
                                },
                                {
                                    "Text": "ETMADPUR",
                                    "Value": "ETMADPUR"
                                },
                                {
                                    "Text": "ETTUMANOOR",
                                    "Value": "ETTUMANOOR"
                                },
                                {
                                    "Text": "FAIZABAD",
                                    "Value": "FAIZABAD"
                                },
                                {
                                    "Text": "FALNA",
                                    "Value": "FALNA"
                                },
                                {
                                    "Text": "FARIDABAD",
                                    "Value": "FARIDABAD"
                                },
                                {
                                    "Text": "FARIDKOT",
                                    "Value": "FARIDKOT"
                                },
                                {
                                    "Text": "FARIDPUR",
                                    "Value": "FARIDPUR"
                                },
                                {
                                    "Text": "FARRUKHABAD",
                                    "Value": "FARRUKHABAD"
                                },
                                {
                                    "Text": "FARRUKHNAGAR",
                                    "Value": "FARRUKHNAGAR"
                                },
                                {
                                    "Text": "FATEGHGARH CHURIAN",
                                    "Value": "FATEGHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHABAD",
                                    "Value": "FATEHABAD"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHGARH CHURIAN",
                                    "Value": "FATEHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHPUR SHEKHAWATI",
                                    "Value": "FATEHPUR SHEKHAWATI"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHABAD",
                                    "Value": "FATEHABAD"
                                },
                                {
                                    "Text": "FATEHGARH SAHIB",
                                    "Value": "FATEHGARH SAHIB"
                                },
                                {
                                    "Text": "FATEHGARH",
                                    "Value": "FATEHGARH"
                                },
                                {
                                    "Text": "FATEHGARH - UP",
                                    "Value": "FATEHGARH - UP"
                                },
                                {
                                    "Text": "FATEHGARH CHURIAN",
                                    "Value": "FATEHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHGARH PUNJTUR",
                                    "Value": "FATEHGARH PUNJTUR"
                                },
                                {
                                    "Text": "FATEHGARH SABRAH",
                                    "Value": "FATEHGARH SABRAH"
                                },
                                {
                                    "Text": "FATEHNAGAR",
                                    "Value": "FATEHNAGAR"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATHEPUR",
                                    "Value": "FATHEPUR"
                                },
                                {
                                    "Text": "FATHEGARH SHUKARCHAK",
                                    "Value": "FATHEGARH SHUKARCHAK"
                                },
                                {
                                    "Text": "FATORDA",
                                    "Value": "FATORDA"
                                },
                                {
                                    "Text": "FAZALWAS",
                                    "Value": "FAZALWAS"
                                },
                                {
                                    "Text": "FAZILKA",
                                    "Value": "FAZILKA"
                                },
                                {
                                    "Text": "FEROKE",
                                    "Value": "FEROKE"
                                },
                                {
                                    "Text": "FEROZPUR",
                                    "Value": "FEROZPUR"
                                },
                                {
                                    "Text": "FEROZEPUR",
                                    "Value": "FEROZEPUR"
                                },
                                {
                                    "Text": "FEROZEPUR JHIRKA",
                                    "Value": "FEROZEPUR JHIRKA"
                                },
                                {
                                    "Text": "FEROZPUR CANTT",
                                    "Value": "FEROZPUR CANTT"
                                },
                                {
                                    "Text": "FILM NAGAR",
                                    "Value": "FILM NAGAR"
                                },
                                {
                                    "Text": "FIROZABAD",
                                    "Value": "FIROZABAD"
                                },
                                {
                                    "Text": "FIROZPUR",
                                    "Value": "FIROZPUR"
                                },
                                {
                                    "Text": "FORBESGANJ",
                                    "Value": "FORBESGANJ"
                                },
                                {
                                    "Text": "FARIDNAGAR",
                                    "Value": "FARIDNAGAR"
                                },
                                {
                                    "Text": "FEROZABAD",
                                    "Value": "FEROZABAD"
                                },
                                {
                                    "Text": "FUJAIRAH",
                                    "Value": "FUJAIRAH"
                                },
                                {
                                    "Text": "FUTANA ",
                                    "Value": "FUTANA "
                                },
                                {
                                    "Text": "GABBADA ",
                                    "Value": "GABBADA "
                                },
                                {
                                    "Text": "GADARWARA",
                                    "Value": "GADARWARA"
                                },
                                {
                                    "Text": "GADAG",
                                    "Value": "GADAG"
                                },
                                {
                                    "Text": "GADARPUR",
                                    "Value": "GADARPUR"
                                },
                                {
                                    "Text": "GADCHIROLI",
                                    "Value": "GADCHIROLI"
                                },
                                {
                                    "Text": "GADDAN DOAB",
                                    "Value": "GADDAN DOAB"
                                },
                                {
                                    "Text": "GADHINGLAJ",
                                    "Value": "GADHINGLAJ"
                                },
                                {
                                    "Text": "GADHEJALGAON ",
                                    "Value": "GADHEJALGAON "
                                },
                                {
                                    "Text": "GADMUDSHINGI",
                                    "Value": "GADMUDSHINGI"
                                },
                                {
                                    "Text": "GADWAL",
                                    "Value": "GADWAL"
                                },
                                {
                                    "Text": "GAGGO MAHAL",
                                    "Value": "GAGGO MAHAL"
                                },
                                {
                                    "Text": "GAGRET",
                                    "Value": "GAGRET"
                                },
                                {
                                    "Text": "GAHAM",
                                    "Value": "GAHAM"
                                },
                                {
                                    "Text": "GAHAUR",
                                    "Value": "GAHAUR"
                                },
                                {
                                    "Text": "GAJAPATI",
                                    "Value": "GAJAPATI"
                                },
                                {
                                    "Text": "GAJRAULA",
                                    "Value": "GAJRAULA"
                                },
                                {
                                    "Text": "GAJUWAKA",
                                    "Value": "GAJUWAKA"
                                },
                                {
                                    "Text": "GANAPAVARAM ",
                                    "Value": "GANAPAVARAM "
                                },
                                {
                                    "Text": "GANAUR",
                                    "Value": "GANAUR"
                                },
                                {
                                    "Text": "GANDHIDHAM",
                                    "Value": "GANDHIDHAM"
                                },
                                {
                                    "Text": "GANDHINAGAR",
                                    "Value": "GANDHINAGAR"
                                },
                                {
                                    "Text": "GANDERBAL",
                                    "Value": "GANDERBAL"
                                },
                                {
                                    "Text": "GANDHI NAGAR",
                                    "Value": "GANDHI NAGAR"
                                },
                                {
                                    "Text": "GANDHICHOWK",
                                    "Value": "GANDHICHOWK"
                                },
                                {
                                    "Text": "GANDEVI",
                                    "Value": "GANDEVI"
                                },
                                {
                                    "Text": "GANESWARPUR",
                                    "Value": "GANESWARPUR"
                                },
                                {
                                    "Text": "GANGANAGAR",
                                    "Value": "GANGANAGAR"
                                },
                                {
                                    "Text": "GANGAVATI",
                                    "Value": "GANGAVATI"
                                },
                                {
                                    "Text": "GANGTOK",
                                    "Value": "GANGTOK"
                                },
                                {
                                    "Text": "GANGUPAHAD ",
                                    "Value": "GANGUPAHAD "
                                },
                                {
                                    "Text": "GANGAPUR PURVI ",
                                    "Value": "GANGAPUR PURVI "
                                },
                                {
                                    "Text": "GANGAKHED",
                                    "Value": "GANGAKHED"
                                },
                                {
                                    "Text": "GANGAPUR CITY",
                                    "Value": "GANGAPUR CITY"
                                },
                                {
                                    "Text": "GANGAWATI",
                                    "Value": "GANGAWATI"
                                },
                                {
                                    "Text": "GANGOH",
                                    "Value": "GANGOH"
                                },
                                {
                                    "Text": "GANJ BASODA",
                                    "Value": "GANJ BASODA"
                                },
                                {
                                    "Text": "GANJAM",
                                    "Value": "GANJAM"
                                },
                                {
                                    "Text": "GANNAVARAM",
                                    "Value": "GANNAVARAM"
                                },
                                {
                                    "Text": "GARDHIWAL",
                                    "Value": "GARDHIWAL"
                                },
                                {
                                    "Text": "GARGOTI",
                                    "Value": "GARGOTI"
                                },
                                {
                                    "Text": "GARHSHANKAR",
                                    "Value": "GARHSHANKAR"
                                },
                                {
                                    "Text": "GARHWA",
                                    "Value": "GARHWA"
                                },
                                {
                                    "Text": "GARIABAND",
                                    "Value": "GARIABAND"
                                },
                                {
                                    "Text": "GAROBADHA",
                                    "Value": "GAROBADHA"
                                },
                                {
                                    "Text": "GAURIBIDANUR",
                                    "Value": "GAURIBIDANUR"
                                },
                                {
                                    "Text": "GAUTAM BUDDHA NAGAR",
                                    "Value": "GAUTAM BUDDHA NAGAR"
                                },
                                {
                                    "Text": "GAYA",
                                    "Value": "GAYA"
                                },
                                {
                                    "Text": "GB NAGAR",
                                    "Value": "GB NAGAR"
                                },
                                {
                                    "Text": "GB NAGAR",
                                    "Value": "GB NAGAR"
                                },
                                {
                                    "Text": "GADHADA",
                                    "Value": "GADHADA"
                                },
                                {
                                    "Text": "GENOME VALLEY",
                                    "Value": "GENOME VALLEY"
                                },
                                {
                                    "Text": "GEORAI KUBER ",
                                    "Value": "GEORAI KUBER "
                                },
                                {
                                    "Text": "GHALLKHURD",
                                    "Value": "GHALLKHURD"
                                },
                                {
                                    "Text": "GHAMROZ",
                                    "Value": "GHAMROZ"
                                },
                                {
                                    "Text": "GHANPUR ",
                                    "Value": "GHANPUR "
                                },
                                {
                                    "Text": "GHANAUR",
                                    "Value": "GHANAUR"
                                },
                                {
                                    "Text": "GHATAMPUR",
                                    "Value": "GHATAMPUR"
                                },
                                {
                                    "Text": "GHATSHILA",
                                    "Value": "GHATSHILA"
                                },
                                {
                                    "Text": "GHAZIABAD",
                                    "Value": "GHAZIABAD"
                                },
                                {
                                    "Text": "GHAZIPUR",
                                    "Value": "GHAZIPUR"
                                },
                                {
                                    "Text": "GHAZIABAD UP",
                                    "Value": "GHAZIABAD UP"
                                },
                                {
                                    "Text": "GHILOR KALAN",
                                    "Value": "GHILOR KALAN"
                                },
                                {
                                    "Text": "GHODIYAL",
                                    "Value": "GHODIYAL"
                                },
                                {
                                    "Text": "GHOGHLA",
                                    "Value": "GHOGHLA"
                                },
                                {
                                    "Text": "GHOGRA",
                                    "Value": "GHOGRA"
                                },
                                {
                                    "Text": "GHOSI",
                                    "Value": "GHOSI"
                                },
                                {
                                    "Text": "GHOTI BUDRUK",
                                    "Value": "GHOTI BUDRUK"
                                },
                                {
                                    "Text": "GHEORA",
                                    "Value": "GHEORA"
                                },
                                {
                                    "Text": "GHARONDA NEEMKA BANGAR",
                                    "Value": "GHARONDA NEEMKA BANGAR"
                                },
                                {
                                    "Text": "GHAROLI",
                                    "Value": "GHAROLI"
                                },
                                {
                                    "Text": "GHATAL",
                                    "Value": "GHATAL"
                                },
                                {
                                    "Text": "GHITORNI",
                                    "Value": "GHITORNI"
                                },
                                {
                                    "Text": "GHUDDA",
                                    "Value": "GHUDDA"
                                },
                                {
                                    "Text": "GHUGIANA ",
                                    "Value": "GHUGIANA "
                                },
                                {
                                    "Text": "GHUMAN",
                                    "Value": "GHUMAN"
                                },
                                {
                                    "Text": "GARHWAL",
                                    "Value": "GARHWAL"
                                },
                                {
                                    "Text": "GIDDARBAHA",
                                    "Value": "GIDDARBAHA"
                                },
                                {
                                    "Text": "GIDDALUR",
                                    "Value": "GIDDALUR"
                                },
                                {
                                    "Text": "GIDDERBAHA",
                                    "Value": "GIDDERBAHA"
                                },
                                {
                                    "Text": "GILJEWALA",
                                    "Value": "GILJEWALA"
                                },
                                {
                                    "Text": "GILL ROAD",
                                    "Value": "GILL ROAD"
                                },
                                {
                                    "Text": "GILL",
                                    "Value": "GILL"
                                },
                                {
                                    "Text": "GIRGITPALLE ",
                                    "Value": "GIRGITPALLE "
                                },
                                {
                                    "Text": "GIRIDIH",
                                    "Value": "GIRIDIH"
                                },
                                {
                                    "Text": "GIRIDH",
                                    "Value": "GIRIDH"
                                },
                                {
                                    "Text": "GOKAL PUR",
                                    "Value": "GOKAL PUR"
                                },
                                {
                                    "Text": "GOMTI NAGAR",
                                    "Value": "GOMTI NAGAR"
                                },
                                {
                                    "Text": "GANGARAMPUR",
                                    "Value": "GANGARAMPUR"
                                },
                                {
                                    "Text": "GOA",
                                    "Value": "GOA"
                                },
                                {
                                    "Text": "GOALPARA",
                                    "Value": "GOALPARA"
                                },
                                {
                                    "Text": "GOA VELHA",
                                    "Value": "GOA VELHA"
                                },
                                {
                                    "Text": "GOA VELHA",
                                    "Value": "GOA VELHA"
                                },
                                {
                                    "Text": "GOBI",
                                    "Value": "GOBI"
                                },
                                {
                                    "Text": "GOBICHETTIPALAYAM",
                                    "Value": "GOBICHETTIPALAYAM"
                                },
                                {
                                    "Text": "GOBINDGARH",
                                    "Value": "GOBINDGARH"
                                },
                                {
                                    "Text": "GOBORDANGA",
                                    "Value": "GOBORDANGA"
                                },
                                {
                                    "Text": "GODAVARIKHANI",
                                    "Value": "GODAVARIKHANI"
                                },
                                {
                                    "Text": "GODAMGUDA ",
                                    "Value": "GODAMGUDA "
                                },
                                {
                                    "Text": "GODBOLEMALA",
                                    "Value": "GODBOLEMALA"
                                },
                                {
                                    "Text": "GODDA",
                                    "Value": "GODDA"
                                },
                                {
                                    "Text": "GODHRA",
                                    "Value": "GODHRA"
                                },
                                {
                                    "Text": "GODHRA BHURAVAV ",
                                    "Value": "GODHRA BHURAVAV "
                                },
                                {
                                    "Text": "GODHAVI",
                                    "Value": "GODHAVI"
                                },
                                {
                                    "Text": "GOGOANI",
                                    "Value": "GOGOANI"
                                },
                                {
                                    "Text": "GOGOANI",
                                    "Value": "GOGOANI"
                                },
                                {
                                    "Text": "GOHANA",
                                    "Value": "GOHANA"
                                },
                                {
                                    "Text": "GOINDWAL",
                                    "Value": "GOINDWAL"
                                },
                                {
                                    "Text": "GOKAK",
                                    "Value": "GOKAK"
                                },
                                {
                                    "Text": "GOLAGHAT",
                                    "Value": "GOLAGHAT"
                                },
                                {
                                    "Text": "GOLATGAON ",
                                    "Value": "GOLATGAON "
                                },
                                {
                                    "Text": "GOLA GOKARAN NATH",
                                    "Value": "GOLA GOKARAN NATH"
                                },
                                {
                                    "Text": "GOLA",
                                    "Value": "GOLA"
                                },
                                {
                                    "Text": "GOLEWALA ",
                                    "Value": "GOLEWALA "
                                },
                                {
                                    "Text": "GOLEWALA",
                                    "Value": "GOLEWALA"
                                },
                                {
                                    "Text": "GOLLALAGUDUR ",
                                    "Value": "GOLLALAGUDUR "
                                },
                                {
                                    "Text": "GOMATI",
                                    "Value": "GOMATI"
                                },
                                {
                                    "Text": "GONDAL",
                                    "Value": "GONDAL"
                                },
                                {
                                    "Text": "GONDA",
                                    "Value": "GONDA"
                                },
                                {
                                    "Text": "GONDIA",
                                    "Value": "GONDIA"
                                },
                                {
                                    "Text": "GONDIPAKALAU ",
                                    "Value": "GONDIPAKALAU "
                                },
                                {
                                    "Text": "GONIANA MANDI",
                                    "Value": "GONIANA MANDI"
                                },
                                {
                                    "Text": "GONIANA",
                                    "Value": "GONIANA"
                                },
                                {
                                    "Text": "GONIKOPPAL",
                                    "Value": "GONIKOPPAL"
                                },
                                {
                                    "Text": "GOPALGANJ",
                                    "Value": "GOPALGANJ"
                                },
                                {
                                    "Text": "GOPANAPALLE",
                                    "Value": "GOPANAPALLE"
                                },
                                {
                                    "Text": "GOPINAGAR",
                                    "Value": "GOPINAGAR"
                                },
                                {
                                    "Text": "GORAYA",
                                    "Value": "GORAYA"
                                },
                                {
                                    "Text": "GORAKHPUR",
                                    "Value": "GORAKHPUR"
                                },
                                {
                                    "Text": "GORAKNATH",
                                    "Value": "GORAKNATH"
                                },
                                {
                                    "Text": "GOREGAON",
                                    "Value": "GOREGAON"
                                },
                                {
                                    "Text": "GOTIBANDH ",
                                    "Value": "GOTIBANDH "
                                },
                                {
                                    "Text": "GOTTIMUKKALA ",
                                    "Value": "GOTTIMUKKALA "
                                },
                                {
                                    "Text": "GOTUR ",
                                    "Value": "GOTUR "
                                },
                                {
                                    "Text": "GOUDGOP",
                                    "Value": "GOUDGOP"
                                },
                                {
                                    "Text": "GOVERDHAN",
                                    "Value": "GOVERDHAN"
                                },
                                {
                                    "Text": "GOVINDPET ",
                                    "Value": "GOVINDPET "
                                },
                                {
                                    "Text": "GOVINDPET",
                                    "Value": "GOVINDPET"
                                },
                                {
                                    "Text": "GOWARDHAN ",
                                    "Value": "GOWARDHAN "
                                },
                                {
                                    "Text": "GOWRISANKARA PURAM ",
                                    "Value": "GOWRISANKARA PURAM "
                                },
                                {
                                    "Text": "G.PANGIDIGUDEM ",
                                    "Value": "G.PANGIDIGUDEM "
                                },
                                {
                                    "Text": "GANDHI PADIA",
                                    "Value": "GANDHI PADIA"
                                },
                                {
                                    "Text": "GREATER NOIDA",
                                    "Value": "GREATER NOIDA"
                                },
                                {
                                    "Text": "GAROBADHA",
                                    "Value": "GAROBADHA"
                                },
                                {
                                    "Text": "GARIYADHAR",
                                    "Value": "GARIYADHAR"
                                },
                                {
                                    "Text": "GUDIYATHAM",
                                    "Value": "GUDIYATHAM"
                                },
                                {
                                    "Text": "GUDAH",
                                    "Value": "GUDAH"
                                },
                                {
                                    "Text": "GUDIVADA",
                                    "Value": "GUDIVADA"
                                },
                                {
                                    "Text": "GUDLI",
                                    "Value": "GUDLI"
                                },
                                {
                                    "Text": "GUDUR",
                                    "Value": "GUDUR"
                                },
                                {
                                    "Text": "GUDUR ",
                                    "Value": "GUDUR "
                                },
                                {
                                    "Text": "GULAOTHI",
                                    "Value": "GULAOTHI"
                                },
                                {
                                    "Text": "GULBARGA",
                                    "Value": "GULBARGA"
                                },
                                {
                                    "Text": "GUMARWIN",
                                    "Value": "GUMARWIN"
                                },
                                {
                                    "Text": "GUMIA",
                                    "Value": "GUMIA"
                                },
                                {
                                    "Text": "GUMLA",
                                    "Value": "GUMLA"
                                },
                                {
                                    "Text": "GUNA",
                                    "Value": "GUNA"
                                },
                                {
                                    "Text": "GUNDRATHIMADUGU ",
                                    "Value": "GUNDRATHIMADUGU "
                                },
                                {
                                    "Text": "GUNDUPALA ",
                                    "Value": "GUNDUPALA "
                                },
                                {
                                    "Text": "GUNTAKAL",
                                    "Value": "GUNTAKAL"
                                },
                                {
                                    "Text": "GUNTUR",
                                    "Value": "GUNTUR"
                                },
                                {
                                    "Text": "GURANDARAPALEM ",
                                    "Value": "GURANDARAPALEM "
                                },
                                {
                                    "Text": "GURDASPUR",
                                    "Value": "GURDASPUR"
                                },
                                {
                                    "Text": "GURGAON",
                                    "Value": "GURGAON"
                                },
                                {
                                    "Text": "GURGAON",
                                    "Value": "GURGAON"
                                },
                                {
                                    "Text": "GURNE KALAN",
                                    "Value": "GURNE KALAN"
                                },
                                {
                                    "Text": "GURSIA ",
                                    "Value": "GURSIA "
                                },
                                {
                                    "Text": "GURSARAI",
                                    "Value": "GURSARAI"
                                },
                                {
                                    "Text": "GURUVAYUR",
                                    "Value": "GURUVAYUR"
                                },
                                {
                                    "Text": "GURUHARSAHAI",
                                    "Value": "GURUHARSAHAI"
                                },
                                {
                                    "Text": "GURUVAYOOR",
                                    "Value": "GURUVAYOOR"
                                },
                                {
                                    "Text": "GURVAIGUDEM ",
                                    "Value": "GURVAIGUDEM "
                                },
                                {
                                    "Text": "GUSKARA",
                                    "Value": "GUSKARA"
                                },
                                {
                                    "Text": "GUSKARA",
                                    "Value": "GUSKARA"
                                },
                                {
                                    "Text": "GUWAHATI",
                                    "Value": "GUWAHATI"
                                },
                                {
                                    "Text": "GWALIOR",
                                    "Value": "GWALIOR"
                                },
                                {
                                    "Text": "HABRA",
                                    "Value": "HABRA"
                                },
                                {
                                    "Text": "HADAMTALA",
                                    "Value": "HADAMTALA"
                                },
                                {
                                    "Text": "HADGOOD",
                                    "Value": "HADGOOD"
                                },
                                {
                                    "Text": "HADIYOL",
                                    "Value": "HADIYOL"
                                },
                                {
                                    "Text": "HAIBOWAL KALAN",
                                    "Value": "HAIBOWAL KALAN"
                                },
                                {
                                    "Text": "HAIDERGARH",
                                    "Value": "HAIDERGARH"
                                },
                                {
                                    "Text": "HAILAKANDI",
                                    "Value": "HAILAKANDI"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HAJIRA",
                                    "Value": "HAJIRA"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HALDWANI",
                                    "Value": "HALDWANI"
                                },
                                {
                                    "Text": "HALDIA",
                                    "Value": "HALDIA"
                                },
                                {
                                    "Text": "HALLY MANDI",
                                    "Value": "HALLY MANDI"
                                },
                                {
                                    "Text": "HALOL",
                                    "Value": "HALOL"
                                },
                                {
                                    "Text": "HALVAD",
                                    "Value": "HALVAD"
                                },
                                {
                                    "Text": "HAMBRAN",
                                    "Value": "HAMBRAN"
                                },
                                {
                                    "Text": "HAMIRPUR",
                                    "Value": "HAMIRPUR"
                                },
                                {
                                    "Text": "HAMIRPUR(HP)",
                                    "Value": "HAMIRPUR(HP)"
                                },
                                {
                                    "Text": "HAMIRPUR",
                                    "Value": "HAMIRPUR"
                                },
                                {
                                    "Text": "HANUMAKONDA",
                                    "Value": "HANUMAKONDA"
                                },
                                {
                                    "Text": "HANAGODU ",
                                    "Value": "HANAGODU "
                                },
                                {
                                    "Text": "HANDIA",
                                    "Value": "HANDIA"
                                },
                                {
                                    "Text": "HANDWARA",
                                    "Value": "HANDWARA"
                                },
                                {
                                    "Text": "HANSI",
                                    "Value": "HANSI"
                                },
                                {
                                    "Text": "HANUMANGARH TOWN",
                                    "Value": "HANUMANGARH TOWN"
                                },
                                {
                                    "Text": "HANUMANGARH",
                                    "Value": "HANUMANGARH"
                                },
                                {
                                    "Text": "HANUMANTHAPUR ",
                                    "Value": "HANUMANTHAPUR "
                                },
                                {
                                    "Text": "HANUMAPUR ",
                                    "Value": "HANUMAPUR "
                                },
                                {
                                    "Text": "HANUMAN JUNCTION",
                                    "Value": "HANUMAN JUNCTION"
                                },
                                {
                                    "Text": "HAPUR",
                                    "Value": "HAPUR"
                                },
                                {
                                    "Text": "HARCHOWAL",
                                    "Value": "HARCHOWAL"
                                },
                                {
                                    "Text": "HARDA",
                                    "Value": "HARDA"
                                },
                                {
                                    "Text": "HARDOI",
                                    "Value": "HARDOI"
                                },
                                {
                                    "Text": "HARIDWAR",
                                    "Value": "HARIDWAR"
                                },
                                {
                                    "Text": "HARIDWAR",
                                    "Value": "HARIDWAR"
                                },
                                {
                                    "Text": "HARIPURDHAR",
                                    "Value": "HARIPURDHAR"
                                },
                                {
                                    "Text": "HARINDRA NAGAR (FARIDKOT) ",
                                    "Value": "HARINDRA NAGAR (FARIDKOT) "
                                },
                                {
                                    "Text": "HARI KE PATTAN",
                                    "Value": "HARI KE PATTAN"
                                },
                                {
                                    "Text": "HARIANA",
                                    "Value": "HARIANA"
                                },
                                {
                                    "Text": "HARIJ",
                                    "Value": "HARIJ"
                                },
                                {
                                    "Text": "HARIPAR PAL",
                                    "Value": "HARIPAR PAL"
                                },
                                {
                                    "Text": "HARYAU",
                                    "Value": "HARYAU"
                                },
                                {
                                    "Text": "HASANPUR",
                                    "Value": "HASANPUR"
                                },
                                {
                                    "Text": "HASSAN",
                                    "Value": "HASSAN"
                                },
                                {
                                    "Text": "HASSANPUR",
                                    "Value": "HASSANPUR"
                                },
                                {
                                    "Text": "HASTEPIMPALGAON ",
                                    "Value": "HASTEPIMPALGAON "
                                },
                                {
                                    "Text": "HATA",
                                    "Value": "HATA"
                                },
                                {
                                    "Text": "HATABUZURG",
                                    "Value": "HATABUZURG"
                                },
                                {
                                    "Text": "HATHRAS",
                                    "Value": "HATHRAS"
                                },
                                {
                                    "Text": "HATHIN",
                                    "Value": "HATHIN"
                                },
                                {
                                    "Text": "HASTSAL",
                                    "Value": "HASTSAL"
                                },
                                {
                                    "Text": "HAVERI",
                                    "Value": "HAVERI"
                                },
                                {
                                    "Text": "HAYATNAGAR",
                                    "Value": "HAYATNAGAR"
                                },
                                {
                                    "Text": "HAYATPUR",
                                    "Value": "HAYATPUR"
                                },
                                {
                                    "Text": "HAZARIBAG",
                                    "Value": "HAZARIBAG"
                                },
                                {
                                    "Text": "HAZARIBAGH",
                                    "Value": "HAZARIBAGH"
                                },
                                {
                                    "Text": "HERBERTPUR",
                                    "Value": "HERBERTPUR"
                                },
                                {
                                    "Text": "HILSA",
                                    "Value": "HILSA"
                                },
                                {
                                    "Text": "HIMATNAGAR",
                                    "Value": "HIMATNAGAR"
                                },
                                {
                                    "Text": "HIMMATNAGAR",
                                    "Value": "HIMMATNAGAR"
                                },
                                {
                                    "Text": "HINDUPUR",
                                    "Value": "HINDUPUR"
                                },
                                {
                                    "Text": "HINDAUN",
                                    "Value": "HINDAUN"
                                },
                                {
                                    "Text": "HINGANGHAT",
                                    "Value": "HINGANGHAT"
                                },
                                {
                                    "Text": "HINGOLI",
                                    "Value": "HINGOLI"
                                },
                                {
                                    "Text": "HINGNA",
                                    "Value": "HINGNA"
                                },
                                {
                                    "Text": "HINDMOTOR",
                                    "Value": "HINDMOTOR"
                                },
                                {
                                    "Text": "HIRIYUR",
                                    "Value": "HIRIYUR"
                                },
                                {
                                    "Text": "HIRPURA",
                                    "Value": "HIRPURA"
                                },
                                {
                                    "Text": "HISAR",
                                    "Value": "HISAR"
                                },
                                {
                                    "Text": "HISSAR",
                                    "Value": "HISSAR"
                                },
                                {
                                    "Text": "HAILEYMANDI",
                                    "Value": "HAILEYMANDI"
                                },
                                {
                                    "Text": "HODAL",
                                    "Value": "HODAL"
                                },
                                {
                                    "Text": "HOJAI",
                                    "Value": "HOJAI"
                                },
                                {
                                    "Text": "HOMNABAD",
                                    "Value": "HOMNABAD"
                                },
                                {
                                    "Text": "HONAVAR",
                                    "Value": "HONAVAR"
                                },
                                {
                                    "Text": "HONNENAHALLI ",
                                    "Value": "HONNENAHALLI "
                                },
                                {
                                    "Text": "HOOGHLY",
                                    "Value": "HOOGHLY"
                                },
                                {
                                    "Text": "HOSHANGABAD",
                                    "Value": "HOSHANGABAD"
                                },
                                {
                                    "Text": "HOSHIARPUR",
                                    "Value": "HOSHIARPUR"
                                },
                                {
                                    "Text": "HOSPET",
                                    "Value": "HOSPET"
                                },
                                {
                                    "Text": "HOSUR",
                                    "Value": "HOSUR"
                                },
                                {
                                    "Text": "HOWRAH",
                                    "Value": "HOWRAH"
                                },
                                {
                                    "Text": "HIRANAGAR",
                                    "Value": "HIRANAGAR"
                                },
                                {
                                    "Text": "HARIPAD",
                                    "Value": "HARIPAD"
                                },
                                {
                                    "Text": "HARISHNAGAR",
                                    "Value": "HARISHNAGAR"
                                },
                                {
                                    "Text": "HUBLI",
                                    "Value": "HUBLI"
                                },
                                {
                                    "Text": "HUDLI",
                                    "Value": "HUDLI"
                                },
                                {
                                    "Text": "HUGLI",
                                    "Value": "HUGLI"
                                },
                                {
                                    "Text": "HUNASAMARANAHALLI",
                                    "Value": "HUNASAMARANAHALLI"
                                },
                                {
                                    "Text": "HUNSA",
                                    "Value": "HUNSA"
                                },
                                {
                                    "Text": "HUNSUR",
                                    "Value": "HUNSUR"
                                },
                                {
                                    "Text": "HUPARI",
                                    "Value": "HUPARI"
                                },
                                {
                                    "Text": "HUSNABAD",
                                    "Value": "HUSNABAD"
                                },
                                {
                                    "Text": "HUSSAINPUR",
                                    "Value": "HUSSAINPUR"
                                },
                                {
                                    "Text": "HUSSAINPUR (CT)",
                                    "Value": "HUSSAINPUR (CT)"
                                },
                                {
                                    "Text": "HUZURABAD",
                                    "Value": "HUZURABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "IBBAN ",
                                    "Value": "IBBAN "
                                },
                                {
                                    "Text": "IBBAN",
                                    "Value": "IBBAN"
                                },
                                {
                                    "Text": "ICHALKARANJI",
                                    "Value": "ICHALKARANJI"
                                },
                                {
                                    "Text": "IDAR",
                                    "Value": "IDAR"
                                },
                                {
                                    "Text": "IDUKKI",
                                    "Value": "IDUKKI"
                                },
                                {
                                    "Text": "IGATPURI",
                                    "Value": "IGATPURI"
                                },
                                {
                                    "Text": "IGNTU AMARKANTAK .",
                                    "Value": "IGNTU AMARKANTAK ."
                                },
                                {
                                    "Text": "IKAUNA",
                                    "Value": "IKAUNA"
                                },
                                {
                                    "Text": "ILAMPILLAI",
                                    "Value": "ILAMPILLAI"
                                },
                                {
                                    "Text": "ISLAMPUR",
                                    "Value": "ISLAMPUR"
                                },
                                {
                                    "Text": "IMALYAKA",
                                    "Value": "IMALYAKA"
                                },
                                {
                                    "Text": "IMPHAL",
                                    "Value": "IMPHAL"
                                },
                                {
                                    "Text": "IMPHAL EAST",
                                    "Value": "IMPHAL EAST"
                                },
                                {
                                    "Text": "IMPHAL WEST",
                                    "Value": "IMPHAL WEST"
                                },
                                {
                                    "Text": "IMPHAL EAST",
                                    "Value": "IMPHAL EAST"
                                },
                                {
                                    "Text": "INDAPUR",
                                    "Value": "INDAPUR"
                                },
                                {
                                    "Text": "INDORE",
                                    "Value": "INDORE"
                                },
                                {
                                    "Text": "INDIRAPURAM",
                                    "Value": "INDIRAPURAM"
                                },
                                {
                                    "Text": "INDRAD",
                                    "Value": "INDRAD"
                                },
                                {
                                    "Text": "INDRAPURA",
                                    "Value": "INDRAPURA"
                                },
                                {
                                    "Text": "INDRI",
                                    "Value": "INDRI"
                                },
                                {
                                    "Text": "INDUPUR",
                                    "Value": "INDUPUR"
                                },
                                {
                                    "Text": "INNADU ",
                                    "Value": "INNADU "
                                },
                                {
                                    "Text": "IPPATLA ",
                                    "Value": "IPPATLA "
                                },
                                {
                                    "Text": "IRINJALAKUDA",
                                    "Value": "IRINJALAKUDA"
                                },
                                {
                                    "Text": "IRINJALAGUDA",
                                    "Value": "IRINJALAGUDA"
                                },
                                {
                                    "Text": "ISLAMPUR",
                                    "Value": "ISLAMPUR"
                                },
                                {
                                    "Text": "ISMAILABAD",
                                    "Value": "ISMAILABAD"
                                },
                                {
                                    "Text": "ISPUR",
                                    "Value": "ISPUR"
                                },
                                {
                                    "Text": "ISRANA",
                                    "Value": "ISRANA"
                                },
                                {
                                    "Text": "ISSAPALLI ",
                                    "Value": "ISSAPALLI "
                                },
                                {
                                    "Text": "ITANAGAR",
                                    "Value": "ITANAGAR"
                                },
                                {
                                    "Text": "ITARSI",
                                    "Value": "ITARSI"
                                },
                                {
                                    "Text": "ITAWA KALAN",
                                    "Value": "ITAWA KALAN"
                                },
                                {
                                    "Text": "JABALPUR",
                                    "Value": "JABALPUR"
                                },
                                {
                                    "Text": "JABBOWAL",
                                    "Value": "JABBOWAL"
                                },
                                {
                                    "Text": "JADCHERLA",
                                    "Value": "JADCHERLA"
                                },
                                {
                                    "Text": "JADLA",
                                    "Value": "JADLA"
                                },
                                {
                                    "Text": "JAGATSINGHPUR",
                                    "Value": "JAGATSINGHPUR"
                                },
                                {
                                    "Text": "JAGADHRI",
                                    "Value": "JAGADHRI"
                                },
                                {
                                    "Text": "JAGADHARI",
                                    "Value": "JAGADHARI"
                                },
                                {
                                    "Text": "JAGATSINGHAPUR",
                                    "Value": "JAGATSINGHAPUR"
                                },
                                {
                                    "Text": "JAGADISHPUR",
                                    "Value": "JAGADISHPUR"
                                },
                                {
                                    "Text": "JAGATPUR",
                                    "Value": "JAGATPUR"
                                },
                                {
                                    "Text": "JAGDALPUR",
                                    "Value": "JAGDALPUR"
                                },
                                {
                                    "Text": "JAGGAYYAPET",
                                    "Value": "JAGGAYYAPET"
                                },
                                {
                                    "Text": "JAGGAYAPET",
                                    "Value": "JAGGAYAPET"
                                },
                                {
                                    "Text": "JAGIROAD",
                                    "Value": "JAGIROAD"
                                },
                                {
                                    "Text": "JAGITYALA",
                                    "Value": "JAGITYALA"
                                },
                                {
                                    "Text": "JAGRAON",
                                    "Value": "JAGRAON"
                                },
                                {
                                    "Text": "JAHANGIRABAD",
                                    "Value": "JAHANGIRABAD"
                                },
                                {
                                    "Text": "JAHANPUR",
                                    "Value": "JAHANPUR"
                                },
                                {
                                    "Text": "JAIDUPALLI ",
                                    "Value": "JAIDUPALLI "
                                },
                                {
                                    "Text": "JAIMAL WALA ",
                                    "Value": "JAIMAL WALA "
                                },
                                {
                                    "Text": "JAINTIA HILLS",
                                    "Value": "JAINTIA HILLS"
                                },
                                {
                                    "Text": "JAIPUR",
                                    "Value": "JAIPUR"
                                },
                                {
                                    "Text": "JAIRAMPUR",
                                    "Value": "JAIRAMPUR"
                                },
                                {
                                    "Text": "JAISALMER",
                                    "Value": "JAISALMER"
                                },
                                {
                                    "Text": "JAIS",
                                    "Value": "JAIS"
                                },
                                {
                                    "Text": "JAISALEMER",
                                    "Value": "JAISALEMER"
                                },
                                {
                                    "Text": "JAISINGHPUR",
                                    "Value": "JAISINGHPUR"
                                },
                                {
                                    "Text": "JAITU",
                                    "Value": "JAITU"
                                },
                                {
                                    "Text": "JAJAPUR",
                                    "Value": "JAJAPUR"
                                },
                                {
                                    "Text": "JAJPUR ROAD",
                                    "Value": "JAJPUR ROAD"
                                },
                                {
                                    "Text": "JAJPUR TOWN",
                                    "Value": "JAJPUR TOWN"
                                },
                                {
                                    "Text": "JAJPUR",
                                    "Value": "JAJPUR"
                                },
                                {
                                    "Text": "JAKHAL",
                                    "Value": "JAKHAL"
                                },
                                {
                                    "Text": "JALALABAD",
                                    "Value": "JALALABAD"
                                },
                                {
                                    "Text": "JALANDHAR",
                                    "Value": "JALANDHAR"
                                },
                                {
                                    "Text": "JALAUN",
                                    "Value": "JALAUN"
                                },
                                {
                                    "Text": "JALALPUR",
                                    "Value": "JALALPUR"
                                },
                                {
                                    "Text": "JALANDHAR CANTT",
                                    "Value": "JALANDHAR CANTT"
                                },
                                {
                                    "Text": "JALGAON",
                                    "Value": "JALGAON"
                                },
                                {
                                    "Text": "JALKE ",
                                    "Value": "JALKE "
                                },
                                {
                                    "Text": "JALMANA",
                                    "Value": "JALMANA"
                                },
                                {
                                    "Text": "JALNA",
                                    "Value": "JALNA"
                                },
                                {
                                    "Text": "JALORE",
                                    "Value": "JALORE"
                                },
                                {
                                    "Text": "JALOR",
                                    "Value": "JALOR"
                                },
                                {
                                    "Text": "JALOCHI",
                                    "Value": "JALOCHI"
                                },
                                {
                                    "Text": "JALPAIGURI",
                                    "Value": "JALPAIGURI"
                                },
                                {
                                    "Text": "JAMKHED",
                                    "Value": "JAMKHED"
                                },
                                {
                                    "Text": "JAM JODHPUR",
                                    "Value": "JAM JODHPUR"
                                },
                                {
                                    "Text": "JAMANDLAPALLI ",
                                    "Value": "JAMANDLAPALLI "
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMBUSAR",
                                    "Value": "JAMBUSAR"
                                },
                                {
                                    "Text": "JAMDIH ",
                                    "Value": "JAMDIH "
                                },
                                {
                                    "Text": "JAMGAON",
                                    "Value": "JAMGAON"
                                },
                                {
                                    "Text": "JAMIYATPURA",
                                    "Value": "JAMIYATPURA"
                                },
                                {
                                    "Text": "JAMJODHPUR",
                                    "Value": "JAMJODHPUR"
                                },
                                {
                                    "Text": "JAMKHAMBHALIA",
                                    "Value": "JAMKHAMBHALIA"
                                },
                                {
                                    "Text": "JAMKHANDI",
                                    "Value": "JAMKHANDI"
                                },
                                {
                                    "Text": "JAMMIKUNTA",
                                    "Value": "JAMMIKUNTA"
                                },
                                {
                                    "Text": "JAMMU",
                                    "Value": "JAMMU"
                                },
                                {
                                    "Text": "JAMNAGAR",
                                    "Value": "JAMNAGAR"
                                },
                                {
                                    "Text": "JAMNER",
                                    "Value": "JAMNER"
                                },
                                {
                                    "Text": "JAMSHEDPUR",
                                    "Value": "JAMSHEDPUR"
                                },
                                {
                                    "Text": "JAMSHER",
                                    "Value": "JAMSHER"
                                },
                                {
                                    "Text": "JAMTARA",
                                    "Value": "JAMTARA"
                                },
                                {
                                    "Text": "JAMTUKAM ",
                                    "Value": "JAMTUKAM "
                                },
                                {
                                    "Text": "JAMUI",
                                    "Value": "JAMUI"
                                },
                                {
                                    "Text": "JAMURIA",
                                    "Value": "JAMURIA"
                                },
                                {
                                    "Text": "JANDIALA GURU",
                                    "Value": "JANDIALA GURU"
                                },
                                {
                                    "Text": "JANDIALA",
                                    "Value": "JANDIALA"
                                },
                                {
                                    "Text": "JANDOLI",
                                    "Value": "JANDOLI"
                                },
                                {
                                    "Text": "JANDPUR",
                                    "Value": "JANDPUR"
                                },
                                {
                                    "Text": "JANDU SINGHA",
                                    "Value": "JANDU SINGHA"
                                },
                                {
                                    "Text": "JANGAON",
                                    "Value": "JANGAON"
                                },
                                {
                                    "Text": "JANGAON BAZAR ",
                                    "Value": "JANGAON BAZAR "
                                },
                                {
                                    "Text": "JANGAREDDYGUDEM",
                                    "Value": "JANGAREDDYGUDEM"
                                },
                                {
                                    "Text": "JANGIPUR",
                                    "Value": "JANGIPUR"
                                },
                                {
                                    "Text": "JANIAL",
                                    "Value": "JANIAL"
                                },
                                {
                                    "Text": "JANJAON",
                                    "Value": "JANJAON"
                                },
                                {
                                    "Text": "JANJGIR",
                                    "Value": "JANJGIR"
                                },
                                {
                                    "Text": "JANJGIR-CHAMPA",
                                    "Value": "JANJGIR-CHAMPA"
                                },
                                {
                                    "Text": "JANKAMPET",
                                    "Value": "JANKAMPET"
                                },
                                {
                                    "Text": "JANSUI",
                                    "Value": "JANSUI"
                                },
                                {
                                    "Text": "JAORA",
                                    "Value": "JAORA"
                                },
                                {
                                    "Text": "JARG",
                                    "Value": "JARG"
                                },
                                {
                                    "Text": "JASDAN",
                                    "Value": "JASDAN"
                                },
                                {
                                    "Text": "JASHPUR",
                                    "Value": "JASHPUR"
                                },
                                {
                                    "Text": "JASRA",
                                    "Value": "JASRA"
                                },
                                {
                                    "Text": "JASSUR",
                                    "Value": "JASSUR"
                                },
                                {
                                    "Text": "JASWANT NAGAR",
                                    "Value": "JASWANT NAGAR"
                                },
                                {
                                    "Text": "JATANI",
                                    "Value": "JATANI"
                                },
                                {
                                    "Text": "JATH",
                                    "Value": "JATH"
                                },
                                {
                                    "Text": "JATHERI",
                                    "Value": "JATHERI"
                                },
                                {
                                    "Text": "JATPAR",
                                    "Value": "JATPAR"
                                },
                                {
                                    "Text": "JAUNPUR",
                                    "Value": "JAUNPUR"
                                },
                                {
                                    "Text": "JAURA CHITTRAN",
                                    "Value": "JAURA CHITTRAN"
                                },
                                {
                                    "Text": "JAVKHEDA BK ",
                                    "Value": "JAVKHEDA BK "
                                },
                                {
                                    "Text": "JAWAHAR",
                                    "Value": "JAWAHAR"
                                },
                                {
                                    "Text": "JAYGAON",
                                    "Value": "JAYGAON"
                                },
                                {
                                    "Text": "JAYSINGPUR",
                                    "Value": "JAYSINGPUR"
                                },
                                {
                                    "Text": "JEELGUL",
                                    "Value": "JEELGUL"
                                },
                                {
                                    "Text": "JEHANABAD",
                                    "Value": "JEHANABAD"
                                },
                                {
                                    "Text": "JEONDAN",
                                    "Value": "JEONDAN"
                                },
                                {
                                    "Text": "JETPUR",
                                    "Value": "JETPUR"
                                },
                                {
                                    "Text": "JEWAR",
                                    "Value": "JEWAR"
                                },
                                {
                                    "Text": "JEYPORE",
                                    "Value": "JEYPORE"
                                },
                                {
                                    "Text": "JAFFRABAD (DELHI)",
                                    "Value": "JAFFRABAD (DELHI)"
                                },
                                {
                                    "Text": "JHABUA",
                                    "Value": "JHABUA"
                                },
                                {
                                    "Text": "JHAJHA",
                                    "Value": "JHAJHA"
                                },
                                {
                                    "Text": "JHAJJAR",
                                    "Value": "JHAJJAR"
                                },
                                {
                                    "Text": "JHALRAPATAN",
                                    "Value": "JHALRAPATAN"
                                },
                                {
                                    "Text": "JHALAWAR",
                                    "Value": "JHALAWAR"
                                },
                                {
                                    "Text": "JHANSI",
                                    "Value": "JHANSI"
                                },
                                {
                                    "Text": "JHANJHARPUR",
                                    "Value": "JHANJHARPUR"
                                },
                                {
                                    "Text": "JHANJHERI",
                                    "Value": "JHANJHERI"
                                },
                                {
                                    "Text": "JHARIA",
                                    "Value": "JHARIA"
                                },
                                {
                                    "Text": "JHARSUGUDA",
                                    "Value": "JHARSUGUDA"
                                },
                                {
                                    "Text": "JHARODA MAJRA BURARI",
                                    "Value": "JHARODA MAJRA BURARI"
                                },
                                {
                                    "Text": "JHUJHUNU",
                                    "Value": "JHUJHUNU"
                                },
                                {
                                    "Text": "JHUMRI TELAIYA",
                                    "Value": "JHUMRI TELAIYA"
                                },
                                {
                                    "Text": "JHUMILA",
                                    "Value": "JHUMILA"
                                },
                                {
                                    "Text": "JHUMRI TILAIYA",
                                    "Value": "JHUMRI TILAIYA"
                                },
                                {
                                    "Text": "JHUNJHUNU",
                                    "Value": "JHUNJHUNU"
                                },
                                {
                                    "Text": "JIB",
                                    "Value": "JIB"
                                },
                                {
                                    "Text": "JIGANI",
                                    "Value": "JIGANI"
                                },
                                {
                                    "Text": "JIND",
                                    "Value": "JIND"
                                },
                                {
                                    "Text": "JITWARPUR",
                                    "Value": "JITWARPUR"
                                },
                                {
                                    "Text": "JIWAI KADIM ",
                                    "Value": "JIWAI KADIM "
                                },
                                {
                                    "Text": "JANAKPURI",
                                    "Value": "JANAKPURI"
                                },
                                {
                                    "Text": "JONA PUR",
                                    "Value": "JONA PUR"
                                },
                                {
                                    "Text": "JODA",
                                    "Value": "JODA"
                                },
                                {
                                    "Text": "JODHAN",
                                    "Value": "JODHAN"
                                },
                                {
                                    "Text": "JODHPUR",
                                    "Value": "JODHPUR"
                                },
                                {
                                    "Text": "JOGINAKA",
                                    "Value": "JOGINAKA"
                                },
                                {
                                    "Text": "JOGINAKA",
                                    "Value": "JOGINAKA"
                                },
                                {
                                    "Text": "JOGINDARNAGAR",
                                    "Value": "JOGINDARNAGAR"
                                },
                                {
                                    "Text": "JOGIPET",
                                    "Value": "JOGIPET"
                                },
                                {
                                    "Text": "JOHAL RAJU SINGH ",
                                    "Value": "JOHAL RAJU SINGH "
                                },
                                {
                                    "Text": "JOLARPET",
                                    "Value": "JOLARPET"
                                },
                                {
                                    "Text": "JOLVA ",
                                    "Value": "JOLVA "
                                },
                                {
                                    "Text": "JONNAVARIGUDEM ",
                                    "Value": "JONNAVARIGUDEM "
                                },
                                {
                                    "Text": "JORETHANG",
                                    "Value": "JORETHANG"
                                },
                                {
                                    "Text": "JORHAT",
                                    "Value": "JORHAT"
                                },
                                {
                                    "Text": "JOWAI",
                                    "Value": "JOWAI"
                                },
                                {
                                    "Text": "JOYA",
                                    "Value": "JOYA"
                                },
                                {
                                    "Text": "J P AGRAHARAM ",
                                    "Value": "J P AGRAHARAM "
                                },
                                {
                                    "Text": "J.P.NAGAR ",
                                    "Value": "J.P.NAGAR "
                                },
                                {
                                    "Text": "JAITARAN",
                                    "Value": "JAITARAN"
                                },
                                {
                                    "Text": "JUGIAL",
                                    "Value": "JUGIAL"
                                },
                                {
                                    "Text": "JUGSALAI",
                                    "Value": "JUGSALAI"
                                },
                                {
                                    "Text": "JUI",
                                    "Value": "JUI"
                                },
                                {
                                    "Text": "JUJOMURA",
                                    "Value": "JUJOMURA"
                                },
                                {
                                    "Text": "JULLANA",
                                    "Value": "JULLANA"
                                },
                                {
                                    "Text": "JUNAGADH",
                                    "Value": "JUNAGADH"
                                },
                                {
                                    "Text": "JUNDLA",
                                    "Value": "JUNDLA"
                                },
                                {
                                    "Text": "JUNNAR",
                                    "Value": "JUNNAR"
                                },
                                {
                                    "Text": "JAWALAMUKHI",
                                    "Value": "JAWALAMUKHI"
                                },
                                {
                                    "Text": "JIWAN PUR",
                                    "Value": "JIWAN PUR"
                                },
                                {
                                    "Text": "JYOTIBA PHULE NAGAR",
                                    "Value": "JYOTIBA PHULE NAGAR"
                                },
                                {
                                    "Text": "K.V.RANGAREDDY",
                                    "Value": "K.V.RANGAREDDY"
                                },
                                {
                                    "Text": "KACHCHH",
                                    "Value": "KACHCHH"
                                },
                                {
                                    "Text": "KACHIGAM",
                                    "Value": "KACHIGAM"
                                },
                                {
                                    "Text": "KADAPA",
                                    "Value": "KADAPA"
                                },
                                {
                                    "Text": "KADAMGIRI",
                                    "Value": "KADAMGIRI"
                                },
                                {
                                    "Text": "KADADHE",
                                    "Value": "KADADHE"
                                },
                                {
                                    "Text": "KADARPUR",
                                    "Value": "KADARPUR"
                                },
                                {
                                    "Text": "KADAYANALLUR",
                                    "Value": "KADAYANALLUR"
                                },
                                {
                                    "Text": "KADCHERLA ",
                                    "Value": "KADCHERLA "
                                },
                                {
                                    "Text": "KADGILL ",
                                    "Value": "KADGILL "
                                },
                                {
                                    "Text": "KADI",
                                    "Value": "KADI"
                                },
                                {
                                    "Text": "KADIYAM",
                                    "Value": "KADIYAM"
                                },
                                {
                                    "Text": "KADIRI",
                                    "Value": "KADIRI"
                                },
                                {
                                    "Text": "KADODARA",
                                    "Value": "KADODARA"
                                },
                                {
                                    "Text": "KAGAL",
                                    "Value": "KAGAL"
                                },
                                {
                                    "Text": "KAHALGAON",
                                    "Value": "KAHALGAON"
                                },
                                {
                                    "Text": "KAHALGAON",
                                    "Value": "KAHALGAON"
                                },
                                {
                                    "Text": "KAHNUWAN",
                                    "Value": "KAHNUWAN"
                                },
                                {
                                    "Text": "KAILASH",
                                    "Value": "KAILASH"
                                },
                                {
                                    "Text": "KAIMUR (BHABUA)",
                                    "Value": "KAIMUR (BHABUA)"
                                },
                                {
                                    "Text": "KAIMLA",
                                    "Value": "KAIMLA"
                                },
                                {
                                    "Text": "KAIRON",
                                    "Value": "KAIRON"
                                },
                                {
                                    "Text": "KAISERGANJ",
                                    "Value": "KAISERGANJ"
                                },
                                {
                                    "Text": "KAITHAL",
                                    "Value": "KAITHAL"
                                },
                                {
                                    "Text": "KAIYAL",
                                    "Value": "KAIYAL"
                                },
                                {
                                    "Text": "KAJARIA ",
                                    "Value": "KAJARIA "
                                },
                                {
                                    "Text": "KAKADEV",
                                    "Value": "KAKADEV"
                                },
                                {
                                    "Text": "KAKCHING",
                                    "Value": "KAKCHING"
                                },
                                {
                                    "Text": "KAKINADA",
                                    "Value": "KAKINADA"
                                },
                                {
                                    "Text": "KAKKANAD",
                                    "Value": "KAKKANAD"
                                },
                                {
                                    "Text": "KAKOD",
                                    "Value": "KAKOD"
                                },
                                {
                                    "Text": "KAKODA",
                                    "Value": "KAKODA"
                                },
                                {
                                    "Text": "KALASA",
                                    "Value": "KALASA"
                                },
                                {
                                    "Text": "KALAWALI",
                                    "Value": "KALAWALI"
                                },
                                {
                                    "Text": "KALAHANDI",
                                    "Value": "KALAHANDI"
                                },
                                {
                                    "Text": "KALA AFGANA",
                                    "Value": "KALA AFGANA"
                                },
                                {
                                    "Text": "KALA AMB",
                                    "Value": "KALA AMB"
                                },
                                {
                                    "Text": "KALAUR",
                                    "Value": "KALAUR"
                                },
                                {
                                    "Text": "KALAVAD",
                                    "Value": "KALAVAD"
                                },
                                {
                                    "Text": "KALAVAR",
                                    "Value": "KALAVAR"
                                },
                                {
                                    "Text": "KALAYAT",
                                    "Value": "KALAYAT"
                                },
                                {
                                    "Text": "KALA BAKRA",
                                    "Value": "KALA BAKRA"
                                },
                                {
                                    "Text": "KALA SANGIAN",
                                    "Value": "KALA SANGIAN"
                                },
                                {
                                    "Text": "KALADY",
                                    "Value": "KALADY"
                                },
                                {
                                    "Text": "KALAMBI",
                                    "Value": "KALAMBI"
                                },
                                {
                                    "Text": "KALAMBOLI",
                                    "Value": "KALAMBOLI"
                                },
                                {
                                    "Text": "KALAMWADI",
                                    "Value": "KALAMWADI"
                                },
                                {
                                    "Text": "KALANAUR",
                                    "Value": "KALANAUR"
                                },
                                {
                                    "Text": "KALANWALI",
                                    "Value": "KALANWALI"
                                },
                                {
                                    "Text": "KALIAGANJ",
                                    "Value": "KALIAGANJ"
                                },
                                {
                                    "Text": "KALIGOTE",
                                    "Value": "KALIGOTE"
                                },
                                {
                                    "Text": "KALIMPONG",
                                    "Value": "KALIMPONG"
                                },
                                {
                                    "Text": "KALKA",
                                    "Value": "KALKA"
                                },
                                {
                                    "Text": "KALLAKURICHI",
                                    "Value": "KALLAKURICHI"
                                },
                                {
                                    "Text": "KALLAKKURICHI",
                                    "Value": "KALLAKKURICHI"
                                },
                                {
                                    "Text": "KALLUTHOTTI JUNCTION",
                                    "Value": "KALLUTHOTTI JUNCTION"
                                },
                                {
                                    "Text": "KALMESHWAR",
                                    "Value": "KALMESHWAR"
                                },
                                {
                                    "Text": "KALNA",
                                    "Value": "KALNA"
                                },
                                {
                                    "Text": "KALOL",
                                    "Value": "KALOL"
                                },
                                {
                                    "Text": "KALOOR",
                                    "Value": "KALOOR"
                                },
                                {
                                    "Text": "KALPETTA",
                                    "Value": "KALPETTA"
                                },
                                {
                                    "Text": "KALWAKURTHY",
                                    "Value": "KALWAKURTHY"
                                },
                                {
                                    "Text": "KALWAN BK",
                                    "Value": "KALWAN BK"
                                },
                                {
                                    "Text": "KALYANI",
                                    "Value": "KALYANI"
                                },
                                {
                                    "Text": "KALYAN EAST THANE",
                                    "Value": "KALYAN EAST THANE"
                                },
                                {
                                    "Text": "KALYAN",
                                    "Value": "KALYAN"
                                },
                                {
                                    "Text": "KALYAN - DOMBIVLI",
                                    "Value": "KALYAN - DOMBIVLI"
                                },
                                {
                                    "Text": "KALYANDURG",
                                    "Value": "KALYANDURG"
                                },
                                {
                                    "Text": "KAMALI",
                                    "Value": "KAMALI"
                                },
                                {
                                    "Text": "KAMAREDDY",
                                    "Value": "KAMAREDDY"
                                },
                                {
                                    "Text": "KAMBALAPALLI ",
                                    "Value": "KAMBALAPALLI "
                                },
                                {
                                    "Text": "KAMBAM",
                                    "Value": "KAMBAM"
                                },
                                {
                                    "Text": "KAMBIL",
                                    "Value": "KAMBIL"
                                },
                                {
                                    "Text": "KAMMIANA ",
                                    "Value": "KAMMIANA "
                                },
                                {
                                    "Text": "KAMOTHE",
                                    "Value": "KAMOTHE"
                                },
                                {
                                    "Text": "KAMPTEE",
                                    "Value": "KAMPTEE"
                                },
                                {
                                    "Text": "KAMPUR",
                                    "Value": "KAMPUR"
                                },
                                {
                                    "Text": "KAMRUP",
                                    "Value": "KAMRUP"
                                },
                                {
                                    "Text": "KAMREJ",
                                    "Value": "KAMREJ"
                                },
                                {
                                    "Text": "KAMSHET",
                                    "Value": "KAMSHET"
                                },
                                {
                                    "Text": "KANAKAPURA",
                                    "Value": "KANAKAPURA"
                                },
                                {
                                    "Text": "KANCHIPURAM",
                                    "Value": "KANCHIPURAM"
                                },
                                {
                                    "Text": "KANCHAPADA",
                                    "Value": "KANCHAPADA"
                                },
                                {
                                    "Text": "KANCHRAPARA",
                                    "Value": "KANCHRAPARA"
                                },
                                {
                                    "Text": "KANDHAMAL",
                                    "Value": "KANDHAMAL"
                                },
                                {
                                    "Text": "KANDLA",
                                    "Value": "KANDLA"
                                },
                                {
                                    "Text": "KANDUKURU",
                                    "Value": "KANDUKURU"
                                },
                                {
                                    "Text": "KANGAYAM",
                                    "Value": "KANGAYAM"
                                },
                                {
                                    "Text": "KANGRA",
                                    "Value": "KANGRA"
                                },
                                {
                                    "Text": "KANGAN",
                                    "Value": "KANGAN"
                                },
                                {
                                    "Text": "KANGAN",
                                    "Value": "KANGAN"
                                },
                                {
                                    "Text": "KANGEYAM",
                                    "Value": "KANGEYAM"
                                },
                                {
                                    "Text": "KANHANGAD",
                                    "Value": "KANHANGAD"
                                },
                                {
                                    "Text": "KANINA",
                                    "Value": "KANINA"
                                },
                                {
                                    "Text": "KANJIRAPALLY",
                                    "Value": "KANJIRAPALLY"
                                },
                                {
                                    "Text": "KANKAVLI",
                                    "Value": "KANKAVLI"
                                },
                                {
                                    "Text": "KANKROLI",
                                    "Value": "KANKROLI"
                                },
                                {
                                    "Text": "KANKER",
                                    "Value": "KANKER"
                                },
                                {
                                    "Text": "KANKABATI",
                                    "Value": "KANKABATI"
                                },
                                {
                                    "Text": "KANKAWLI",
                                    "Value": "KANKAWLI"
                                },
                                {
                                    "Text": "KANNUR",
                                    "Value": "KANNUR"
                                },
                                {
                                    "Text": "KANNAUJ",
                                    "Value": "KANNAUJ"
                                },
                                {
                                    "Text": "KANNAD",
                                    "Value": "KANNAD"
                                },
                                {
                                    "Text": "KANPUR",
                                    "Value": "KANPUR"
                                },
                                {
                                    "Text": "KANPUR DEHAT",
                                    "Value": "KANPUR DEHAT"
                                },
                                {
                                    "Text": "KANPUR NAGAR",
                                    "Value": "KANPUR NAGAR"
                                },
                                {
                                    "Text": "KANTABANJI",
                                    "Value": "KANTABANJI"
                                },
                                {
                                    "Text": "KANUGULAVALASA ",
                                    "Value": "KANUGULAVALASA "
                                },
                                {
                                    "Text": "KANWARSIKA",
                                    "Value": "KANWARSIKA"
                                },
                                {
                                    "Text": "KANYAKUMARI",
                                    "Value": "KANYAKUMARI"
                                },
                                {
                                    "Text": "KAPADVANJ",
                                    "Value": "KAPADVANJ"
                                },
                                {
                                    "Text": "KAPASAN",
                                    "Value": "KAPASAN"
                                },
                                {
                                    "Text": "KAPRA",
                                    "Value": "KAPRA"
                                },
                                {
                                    "Text": "KAPTANGANJ",
                                    "Value": "KAPTANGANJ"
                                },
                                {
                                    "Text": "KAPURTHALA",
                                    "Value": "KAPURTHALA"
                                },
                                {
                                    "Text": "KARAD",
                                    "Value": "KARAD"
                                },
                                {
                                    "Text": "KARAIKAL",
                                    "Value": "KARAIKAL"
                                },
                                {
                                    "Text": "KARAULI",
                                    "Value": "KARAULI"
                                },
                                {
                                    "Text": "KARANJIA",
                                    "Value": "KARANJIA"
                                },
                                {
                                    "Text": "KARAIKUDI",
                                    "Value": "KARAIKUDI"
                                },
                                {
                                    "Text": "KARAHALLI ",
                                    "Value": "KARAHALLI "
                                },
                                {
                                    "Text": "KARAKULAM",
                                    "Value": "KARAKULAM"
                                },
                                {
                                    "Text": "KARAGOUNDEN PALAYAM",
                                    "Value": "KARAGOUNDEN PALAYAM"
                                },
                                {
                                    "Text": "KARANJA",
                                    "Value": "KARANJA"
                                },
                                {
                                    "Text": "KARAPAKKAM",
                                    "Value": "KARAPAKKAM"
                                },
                                {
                                    "Text": "KARBI ANGLONG",
                                    "Value": "KARBI ANGLONG"
                                },
                                {
                                    "Text": "KARDI",
                                    "Value": "KARDI"
                                },
                                {
                                    "Text": "KAREGAON",
                                    "Value": "KAREGAON"
                                },
                                {
                                    "Text": "KARGIL",
                                    "Value": "KARGIL"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KARIM NAGAR",
                                    "Value": "KARIM NAGAR"
                                },
                                {
                                    "Text": "KARIMGANJ",
                                    "Value": "KARIMGANJ"
                                },
                                {
                                    "Text": "KARIVALI",
                                    "Value": "KARIVALI"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KARIYALUR ",
                                    "Value": "KARIYALUR "
                                },
                                {
                                    "Text": "KARJAN",
                                    "Value": "KARJAN"
                                },
                                {
                                    "Text": "KARJAT",
                                    "Value": "KARJAT"
                                },
                                {
                                    "Text": "KARKALA",
                                    "Value": "KARKALA"
                                },
                                {
                                    "Text": "KARKAL",
                                    "Value": "KARKAL"
                                },
                                {
                                    "Text": "KARMAD ",
                                    "Value": "KARMAD "
                                },
                                {
                                    "Text": "KARNAL",
                                    "Value": "KARNAL"
                                },
                                {
                                    "Text": "KARTARPUR",
                                    "Value": "KARTARPUR"
                                },
                                {
                                    "Text": "KARUNAGAPALLY",
                                    "Value": "KARUNAGAPALLY"
                                },
                                {
                                    "Text": "KARUR",
                                    "Value": "KARUR"
                                },
                                {
                                    "Text": "KARUVANNUR",
                                    "Value": "KARUVANNUR"
                                },
                                {
                                    "Text": "KARWAR",
                                    "Value": "KARWAR"
                                },
                                {
                                    "Text": "KARWI MAFI",
                                    "Value": "KARWI MAFI"
                                },
                                {
                                    "Text": "KASARAGOD",
                                    "Value": "KASARAGOD"
                                },
                                {
                                    "Text": "KASARGOD",
                                    "Value": "KASARGOD"
                                },
                                {
                                    "Text": "KASARA",
                                    "Value": "KASARA"
                                },
                                {
                                    "Text": "KASARGATTA ",
                                    "Value": "KASARGATTA "
                                },
                                {
                                    "Text": "KASARAMBOLI",
                                    "Value": "KASARAMBOLI"
                                },
                                {
                                    "Text": "KASBA",
                                    "Value": "KASBA"
                                },
                                {
                                    "Text": "KASGANJ",
                                    "Value": "KASGANJ"
                                },
                                {
                                    "Text": "KASHIPUR",
                                    "Value": "KASHIPUR"
                                },
                                {
                                    "Text": "KASIBUGGA",
                                    "Value": "KASIBUGGA"
                                },
                                {
                                    "Text": "KASIMIVALASA ",
                                    "Value": "KASIMIVALASA "
                                },
                                {
                                    "Text": "KASIA",
                                    "Value": "KASIA"
                                },
                                {
                                    "Text": "KASHMIR",
                                    "Value": "KASHMIR"
                                },
                                {
                                    "Text": "KATAI",
                                    "Value": "KATAI"
                                },
                                {
                                    "Text": "KATCH",
                                    "Value": "KATCH"
                                },
                                {
                                    "Text": "KATGAON",
                                    "Value": "KATGAON"
                                },
                                {
                                    "Text": "KATHUA",
                                    "Value": "KATHUA"
                                },
                                {
                                    "Text": "KATHGARH",
                                    "Value": "KATHGARH"
                                },
                                {
                                    "Text": "KATHLAL",
                                    "Value": "KATHLAL"
                                },
                                {
                                    "Text": "KATIHAR",
                                    "Value": "KATIHAR"
                                },
                                {
                                    "Text": "KATLAHERI",
                                    "Value": "KATLAHERI"
                                },
                                {
                                    "Text": "KATNI",
                                    "Value": "KATNI"
                                },
                                {
                                    "Text": "KATOL",
                                    "Value": "KATOL"
                                },
                                {
                                    "Text": "KATRA",
                                    "Value": "KATRA"
                                },
                                {
                                    "Text": "KATRO",
                                    "Value": "KATRO"
                                },
                                {
                                    "Text": "KATTAPPANA",
                                    "Value": "KATTAPPANA"
                                },
                                {
                                    "Text": "KATTU",
                                    "Value": "KATTU"
                                },
                                {
                                    "Text": "KATWA",
                                    "Value": "KATWA"
                                },
                                {
                                    "Text": "KATWAD",
                                    "Value": "KATWAD"
                                },
                                {
                                    "Text": "KAUSHAMBI",
                                    "Value": "KAUSHAMBI"
                                },
                                {
                                    "Text": "KAVALI",
                                    "Value": "KAVALI"
                                },
                                {
                                    "Text": "KAVERIPATTINAM",
                                    "Value": "KAVERIPATTINAM"
                                },
                                {
                                    "Text": "KAWARDHA",
                                    "Value": "KAWARDHA"
                                },
                                {
                                    "Text": "KAYAMKULAM",
                                    "Value": "KAYAMKULAM"
                                },
                                {
                                    "Text": "KECHERY",
                                    "Value": "KECHERY"
                                },
                                {
                                    "Text": "KEDARKHEDA ",
                                    "Value": "KEDARKHEDA "
                                },
                                {
                                    "Text": "KEDARKHEDA",
                                    "Value": "KEDARKHEDA"
                                },
                                {
                                    "Text": "KEDMA ",
                                    "Value": "KEDMA "
                                },
                                {
                                    "Text": "KEELADI ",
                                    "Value": "KEELADI "
                                },
                                {
                                    "Text": "KEELAKARAI",
                                    "Value": "KEELAKARAI"
                                },
                                {
                                    "Text": "KEKRI",
                                    "Value": "KEKRI"
                                },
                                {
                                    "Text": "KELAMBAKKAM",
                                    "Value": "KELAMBAKKAM"
                                },
                                {
                                    "Text": "KELOMAL",
                                    "Value": "KELOMAL"
                                },
                                {
                                    "Text": "KELZAR ",
                                    "Value": "KELZAR "
                                },
                                {
                                    "Text": "KENDRAPARA",
                                    "Value": "KENDRAPARA"
                                },
                                {
                                    "Text": "KENDUJHAR",
                                    "Value": "KENDUJHAR"
                                },
                                {
                                    "Text": "KENGARI",
                                    "Value": "KENGARI"
                                },
                                {
                                    "Text": "KENGERI SATTELITE TOWN",
                                    "Value": "KENGERI SATTELITE TOWN"
                                },
                                {
                                    "Text": "KENJAKURA",
                                    "Value": "KENJAKURA"
                                },
                                {
                                    "Text": "KEONJHAR",
                                    "Value": "KEONJHAR"
                                },
                                {
                                    "Text": "KEORAR ",
                                    "Value": "KEORAR "
                                },
                                {
                                    "Text": "KERANGA",
                                    "Value": "KERANGA"
                                },
                                {
                                    "Text": "KESARPURA",
                                    "Value": "KESARPURA"
                                },
                                {
                                    "Text": "KESHOD",
                                    "Value": "KESHOD"
                                },
                                {
                                    "Text": "KESHAVAPURAM ",
                                    "Value": "KESHAVAPURAM "
                                },
                                {
                                    "Text": "KESHPUR",
                                    "Value": "KESHPUR"
                                },
                                {
                                    "Text": "KESHRISINGHPUR",
                                    "Value": "KESHRISINGHPUR"
                                },
                                {
                                    "Text": "KESINGA",
                                    "Value": "KESINGA"
                                },
                                {
                                    "Text": "KESORI",
                                    "Value": "KESORI"
                                },
                                {
                                    "Text": "KEWALA KALA ",
                                    "Value": "KEWALA KALA "
                                },
                                {
                                    "Text": "KEWALPUR",
                                    "Value": "KEWALPUR"
                                },
                                {
                                    "Text": "KEYSANPALLI ",
                                    "Value": "KEYSANPALLI "
                                },
                                {
                                    "Text": "KHABEDOGRAN ",
                                    "Value": "KHABEDOGRAN "
                                },
                                {
                                    "Text": "KHADAULI ",
                                    "Value": "KHADAULI "
                                },
                                {
                                    "Text": "KHADANI",
                                    "Value": "KHADANI"
                                },
                                {
                                    "Text": "KHADAUR SAHIB",
                                    "Value": "KHADAUR SAHIB"
                                },
                                {
                                    "Text": "KHADIAL",
                                    "Value": "KHADIAL"
                                },
                                {
                                    "Text": "KHADOL",
                                    "Value": "KHADOL"
                                },
                                {
                                    "Text": "KHADSUPA",
                                    "Value": "KHADSUPA"
                                },
                                {
                                    "Text": "KHAGARIA",
                                    "Value": "KHAGARIA"
                                },
                                {
                                    "Text": "KHAIRTHAL",
                                    "Value": "KHAIRTHAL"
                                },
                                {
                                    "Text": "KHAIRA MAJHA ",
                                    "Value": "KHAIRA MAJHA "
                                },
                                {
                                    "Text": "KHAILAR",
                                    "Value": "KHAILAR"
                                },
                                {
                                    "Text": "KHAIR",
                                    "Value": "KHAIR"
                                },
                                {
                                    "Text": "KHAIRAGARH",
                                    "Value": "KHAIRAGARH"
                                },
                                {
                                    "Text": "KHAIRAHNIYA BEERPUR",
                                    "Value": "KHAIRAHNIYA BEERPUR"
                                },
                                {
                                    "Text": "KHAIRAV",
                                    "Value": "KHAIRAV"
                                },
                                {
                                    "Text": "KHAIRTAL",
                                    "Value": "KHAIRTAL"
                                },
                                {
                                    "Text": "KHAJURI",
                                    "Value": "KHAJURI"
                                },
                                {
                                    "Text": "KHALCHIAN",
                                    "Value": "KHALCHIAN"
                                },
                                {
                                    "Text": "KHALILABAD",
                                    "Value": "KHALILABAD"
                                },
                                {
                                    "Text": "KHALRA",
                                    "Value": "KHALRA"
                                },
                                {
                                    "Text": "KHALUMBRE",
                                    "Value": "KHALUMBRE"
                                },
                                {
                                    "Text": "KHAMGAON",
                                    "Value": "KHAMGAON"
                                },
                                {
                                    "Text": "KHAMBHAT",
                                    "Value": "KHAMBHAT"
                                },
                                {
                                    "Text": "KHAMMAM",
                                    "Value": "KHAMMAM"
                                },
                                {
                                    "Text": "KHAMANO",
                                    "Value": "KHAMANO"
                                },
                                {
                                    "Text": "KHAMHARIYA ",
                                    "Value": "KHAMHARIYA "
                                },
                                {
                                    "Text": "KHAMGAON ",
                                    "Value": "KHAMGAON "
                                },
                                {
                                    "Text": "KHAMARIA ",
                                    "Value": "KHAMARIA "
                                },
                                {
                                    "Text": "KHAMANON",
                                    "Value": "KHAMANON"
                                },
                                {
                                    "Text": "KHAMBHALIA",
                                    "Value": "KHAMBHALIA"
                                },
                                {
                                    "Text": "KHAMLA",
                                    "Value": "KHAMLA"
                                },
                                {
                                    "Text": "KHANNA",
                                    "Value": "KHANNA"
                                },
                                {
                                    "Text": "KHANDWA",
                                    "Value": "KHANDWA"
                                },
                                {
                                    "Text": "KHANAPUR ",
                                    "Value": "KHANAPUR "
                                },
                                {
                                    "Text": "KHANOWAL ",
                                    "Value": "KHANOWAL "
                                },
                                {
                                    "Text": "KHANAPARA",
                                    "Value": "KHANAPARA"
                                },
                                {
                                    "Text": "KHANAURI",
                                    "Value": "KHANAURI"
                                },
                                {
                                    "Text": "KHANDAULI",
                                    "Value": "KHANDAULI"
                                },
                                {
                                    "Text": "KHANOOR",
                                    "Value": "KHANOOR"
                                },
                                {
                                    "Text": "KHANPUR",
                                    "Value": "KHANPUR"
                                },
                                {
                                    "Text": "KHARAGPUR",
                                    "Value": "KHARAGPUR"
                                },
                                {
                                    "Text": "KHARSIA",
                                    "Value": "KHARSIA"
                                },
                                {
                                    "Text": "KHARGONE",
                                    "Value": "KHARGONE"
                                },
                                {
                                    "Text": "KHARKHODA",
                                    "Value": "KHARKHODA"
                                },
                                {
                                    "Text": "KHARAR",
                                    "Value": "KHARAR"
                                },
                                {
                                    "Text": "KHARADAHA",
                                    "Value": "KHARADAHA"
                                },
                                {
                                    "Text": "KHARKODA",
                                    "Value": "KHARKODA"
                                },
                                {
                                    "Text": "KHARTULI",
                                    "Value": "KHARTULI"
                                },
                                {
                                    "Text": "KHATAULI",
                                    "Value": "KHATAULI"
                                },
                                {
                                    "Text": "KHATEGAON",
                                    "Value": "KHATEGAON"
                                },
                                {
                                    "Text": "KHATIVALI",
                                    "Value": "KHATIVALI"
                                },
                                {
                                    "Text": "KHED",
                                    "Value": "KHED"
                                },
                                {
                                    "Text": "KHEDA",
                                    "Value": "KHEDA"
                                },
                                {
                                    "Text": "KHEDBRAHMA",
                                    "Value": "KHEDBRAHMA"
                                },
                                {
                                    "Text": "KHEMKARAN",
                                    "Value": "KHEMKARAN"
                                },
                                {
                                    "Text": "KHERI",
                                    "Value": "KHERI"
                                },
                                {
                                    "Text": "KHERI",
                                    "Value": "KHERI"
                                },
                                {
                                    "Text": "KHERGAM",
                                    "Value": "KHERGAM"
                                },
                                {
                                    "Text": "KHERI NAUDH SINGH",
                                    "Value": "KHERI NAUDH SINGH"
                                },
                                {
                                    "Text": "KHIJRABAD",
                                    "Value": "KHIJRABAD"
                                },
                                {
                                    "Text": "KHAJOORI KHAS",
                                    "Value": "KHAJOORI KHAS"
                                },
                                {
                                    "Text": "KHLIEHRIAT",
                                    "Value": "KHLIEHRIAT"
                                },
                                {
                                    "Text": "KHOKHARIYA",
                                    "Value": "KHOKHARIYA"
                                },
                                {
                                    "Text": "KHONSA",
                                    "Value": "KHONSA"
                                },
                                {
                                    "Text": "KHONI, MAHARASHTRA",
                                    "Value": "KHONI, MAHARASHTRA"
                                },
                                {
                                    "Text": "KHOPOLI",
                                    "Value": "KHOPOLI"
                                },
                                {
                                    "Text": "KHORDA",
                                    "Value": "KHORDA"
                                },
                                {
                                    "Text": "KHORDHA",
                                    "Value": "KHORDHA"
                                },
                                {
                                    "Text": "KHORHANSA",
                                    "Value": "KHORHANSA"
                                },
                                {
                                    "Text": "KHOWAI",
                                    "Value": "KHOWAI"
                                },
                                {
                                    "Text": "KHAIRHA",
                                    "Value": "KHAIRHA"
                                },
                                {
                                    "Text": "KHARGHAR",
                                    "Value": "KHARGHAR"
                                },
                                {
                                    "Text": "KHERA KHURD",
                                    "Value": "KHERA KHURD"
                                },
                                {
                                    "Text": "KHUIAN SARWAR",
                                    "Value": "KHUIAN SARWAR"
                                },
                                {
                                    "Text": "KHUMBHEPHAL ",
                                    "Value": "KHUMBHEPHAL "
                                },
                                {
                                    "Text": "KHUNTI",
                                    "Value": "KHUNTI"
                                },
                                {
                                    "Text": "KHURJA",
                                    "Value": "KHURJA"
                                },
                                {
                                    "Text": "KHURAI",
                                    "Value": "KHURAI"
                                },
                                {
                                    "Text": "KHURDA",
                                    "Value": "KHURDA"
                                },
                                {
                                    "Text": "KHUTAR",
                                    "Value": "KHUTAR"
                                },
                                {
                                    "Text": "KHUTEHNA",
                                    "Value": "KHUTEHNA"
                                },
                                {
                                    "Text": "KILLE MACHINDRA GAD",
                                    "Value": "KILLE MACHINDRA GAD"
                                },
                                {
                                    "Text": "KILLON WALI",
                                    "Value": "KILLON WALI"
                                },
                                {
                                    "Text": "KIM",
                                    "Value": "KIM"
                                },
                                {
                                    "Text": "KINNAUR",
                                    "Value": "KINNAUR"
                                },
                                {
                                    "Text": "KINNIGOLI",
                                    "Value": "KINNIGOLI"
                                },
                                {
                                    "Text": "KIPHIRE",
                                    "Value": "KIPHIRE"
                                },
                                {
                                    "Text": "KIRAMCHA ",
                                    "Value": "KIRAMCHA "
                                },
                                {
                                    "Text": "KIRAOLI",
                                    "Value": "KIRAOLI"
                                },
                                {
                                    "Text": "KIRATPUR SAHIB",
                                    "Value": "KIRATPUR SAHIB"
                                },
                                {
                                    "Text": "KIRARI SULEMAN NAGAR",
                                    "Value": "KIRARI SULEMAN NAGAR"
                                },
                                {
                                    "Text": "KISHINGARH",
                                    "Value": "KISHINGARH"
                                },
                                {
                                    "Text": "KISHANGANJ",
                                    "Value": "KISHANGANJ"
                                },
                                {
                                    "Text": "KISHAN GARH",
                                    "Value": "KISHAN GARH"
                                },
                                {
                                    "Text": "KISHAN PURA",
                                    "Value": "KISHAN PURA"
                                },
                                {
                                    "Text": "KISHANGARH RENWAL",
                                    "Value": "KISHANGARH RENWAL"
                                },
                                {
                                    "Text": "KISHANGARH",
                                    "Value": "KISHANGARH"
                                },
                                {
                                    "Text": "KISHTWAR",
                                    "Value": "KISHTWAR"
                                },
                                {
                                    "Text": "KITHANA",
                                    "Value": "KITHANA"
                                },
                                {
                                    "Text": "KITUMULA ",
                                    "Value": "KITUMULA "
                                },
                                {
                                    "Text": "KANJHAWALA",
                                    "Value": "KANJHAWALA"
                                },
                                {
                                    "Text": "KAKCHING",
                                    "Value": "KAKCHING"
                                },
                                {
                                    "Text": "KANDIVALI",
                                    "Value": "KANDIVALI"
                                },
                                {
                                    "Text": "OLD KANKSA ROAD",
                                    "Value": "OLD KANKSA ROAD"
                                },
                                {
                                    "Text": "KOCHI",
                                    "Value": "KOCHI"
                                },
                                {
                                    "Text": "KODADA",
                                    "Value": "KODADA"
                                },
                                {
                                    "Text": "KODAGU",
                                    "Value": "KODAGU"
                                },
                                {
                                    "Text": "KODAIKANAL",
                                    "Value": "KODAIKANAL"
                                },
                                {
                                    "Text": "KODAD",
                                    "Value": "KODAD"
                                },
                                {
                                    "Text": "KODAKARA",
                                    "Value": "KODAKARA"
                                },
                                {
                                    "Text": "KODERMA",
                                    "Value": "KODERMA"
                                },
                                {
                                    "Text": "KODIGEHALLI ",
                                    "Value": "KODIGEHALLI "
                                },
                                {
                                    "Text": "KODIKURICHI",
                                    "Value": "KODIKURICHI"
                                },
                                {
                                    "Text": "KODINAR",
                                    "Value": "KODINAR"
                                },
                                {
                                    "Text": "KODUNGALLUR",
                                    "Value": "KODUNGALLUR"
                                },
                                {
                                    "Text": "KODUMATHI ",
                                    "Value": "KODUMATHI "
                                },
                                {
                                    "Text": "KODUR",
                                    "Value": "KODUR"
                                },
                                {
                                    "Text": "KODUVAYOOR",
                                    "Value": "KODUVAYOOR"
                                },
                                {
                                    "Text": "KOHALI",
                                    "Value": "KOHALI"
                                },
                                {
                                    "Text": "KOHARA",
                                    "Value": "KOHARA"
                                },
                                {
                                    "Text": "KOHIMA",
                                    "Value": "KOHIMA"
                                },
                                {
                                    "Text": "KOIRA ",
                                    "Value": "KOIRA "
                                },
                                {
                                    "Text": "KOIRA ",
                                    "Value": "KOIRA "
                                },
                                {
                                    "Text": "KOKRAJHAR",
                                    "Value": "KOKRAJHAR"
                                },
                                {
                                    "Text": "KOLAR",
                                    "Value": "KOLAR"
                                },
                                {
                                    "Text": "KOLASIB",
                                    "Value": "KOLASIB"
                                },
                                {
                                    "Text": "KOLAT",
                                    "Value": "KOLAT"
                                },
                                {
                                    "Text": "KOLENCHERY",
                                    "Value": "KOLENCHERY"
                                },
                                {
                                    "Text": "KOLHAPUR",
                                    "Value": "KOLHAPUR"
                                },
                                {
                                    "Text": "KOLKATA",
                                    "Value": "KOLKATA"
                                },
                                {
                                    "Text": "KOLLAM",
                                    "Value": "KOLLAM"
                                },
                                {
                                    "Text": "KOLLAPUR ",
                                    "Value": "KOLLAPUR "
                                },
                                {
                                    "Text": "KOLPAK ",
                                    "Value": "KOLPAK "
                                },
                                {
                                    "Text": "KOMARIPALEM",
                                    "Value": "KOMARIPALEM"
                                },
                                {
                                    "Text": "KOMMAGHATTA",
                                    "Value": "KOMMAGHATTA"
                                },
                                {
                                    "Text": "KOMPALLE",
                                    "Value": "KOMPALLE"
                                },
                                {
                                    "Text": "KON",
                                    "Value": "KON"
                                },
                                {
                                    "Text": "KONDA GOAN",
                                    "Value": "KONDA GOAN"
                                },
                                {
                                    "Text": "KONDLI",
                                    "Value": "KONDLI"
                                },
                                {
                                    "Text": "KONDA GOAN",
                                    "Value": "KONDA GOAN"
                                },
                                {
                                    "Text": "KONDAGATTU",
                                    "Value": "KONDAGATTU"
                                },
                                {
                                    "Text": "KONDAPUR",
                                    "Value": "KONDAPUR"
                                },
                                {
                                    "Text": "KONDOTTY",
                                    "Value": "KONDOTTY"
                                },
                                {
                                    "Text": "KONNAGAR",
                                    "Value": "KONNAGAR"
                                },
                                {
                                    "Text": "KONTHAGAI NORTH ",
                                    "Value": "KONTHAGAI NORTH "
                                },
                                {
                                    "Text": "KOOP ",
                                    "Value": "KOOP "
                                },
                                {
                                    "Text": "KOOTHATTUKULAM",
                                    "Value": "KOOTHATTUKULAM"
                                },
                                {
                                    "Text": "KOOTHANALLUR",
                                    "Value": "KOOTHANALLUR"
                                },
                                {
                                    "Text": "KOOTHUPARAMBA",
                                    "Value": "KOOTHUPARAMBA"
                                },
                                {
                                    "Text": "KOOVAPPADY",
                                    "Value": "KOOVAPPADY"
                                },
                                {
                                    "Text": "KOPERGAON",
                                    "Value": "KOPERGAON"
                                },
                                {
                                    "Text": "KOPPA",
                                    "Value": "KOPPA"
                                },
                                {
                                    "Text": "KOPPAL",
                                    "Value": "KOPPAL"
                                },
                                {
                                    "Text": "KOPRI",
                                    "Value": "KOPRI"
                                },
                                {
                                    "Text": "KORAPUT",
                                    "Value": "KORAPUT"
                                },
                                {
                                    "Text": "KORAG ",
                                    "Value": "KORAG "
                                },
                                {
                                    "Text": "KORATLA",
                                    "Value": "KORATLA"
                                },
                                {
                                    "Text": "KORATTUR",
                                    "Value": "KORATTUR"
                                },
                                {
                                    "Text": "KORATTY",
                                    "Value": "KORATTY"
                                },
                                {
                                    "Text": "KORBA",
                                    "Value": "KORBA"
                                },
                                {
                                    "Text": "KORBI ",
                                    "Value": "KORBI "
                                },
                                {
                                    "Text": "KOREGAON",
                                    "Value": "KOREGAON"
                                },
                                {
                                    "Text": "KORIYA",
                                    "Value": "KORIYA"
                                },
                                {
                                    "Text": "KORLAKOTA ",
                                    "Value": "KORLAKOTA "
                                },
                                {
                                    "Text": "KOSAMBA",
                                    "Value": "KOSAMBA"
                                },
                                {
                                    "Text": "KOSIKALAN",
                                    "Value": "KOSIKALAN"
                                },
                                {
                                    "Text": "KOSLI",
                                    "Value": "KOSLI"
                                },
                                {
                                    "Text": "KOT ISE KHAN",
                                    "Value": "KOT ISE KHAN"
                                },
                                {
                                    "Text": "KOTA",
                                    "Value": "KOTA"
                                },
                                {
                                    "Text": "KOT BUDHA",
                                    "Value": "KOT BUDHA"
                                },
                                {
                                    "Text": "KOTDWARA",
                                    "Value": "KOTDWARA"
                                },
                                {
                                    "Text": "KOTDWAR",
                                    "Value": "KOTDWAR"
                                },
                                {
                                    "Text": "KOTESHWAR",
                                    "Value": "KOTESHWAR"
                                },
                                {
                                    "Text": "KOTFATUHI",
                                    "Value": "KOTFATUHI"
                                },
                                {
                                    "Text": "KOTFATUHI",
                                    "Value": "KOTFATUHI"
                                },
                                {
                                    "Text": "KOTHAGUDEM",
                                    "Value": "KOTHAGUDEM"
                                },
                                {
                                    "Text": "KOTHAMANGALAM",
                                    "Value": "KOTHAMANGALAM"
                                },
                                {
                                    "Text": "KOTHAREDDIAL ",
                                    "Value": "KOTHAREDDIAL "
                                },
                                {
                                    "Text": "KOTHAGDI ",
                                    "Value": "KOTHAGDI "
                                },
                                {
                                    "Text": "KOTHURU ",
                                    "Value": "KOTHURU "
                                },
                                {
                                    "Text": "KOTHAPALLE",
                                    "Value": "KOTHAPALLE"
                                },
                                {
                                    "Text": "KOT ISA KHAN",
                                    "Value": "KOT ISA KHAN"
                                },
                                {
                                    "Text": "KOTKAPURA",
                                    "Value": "KOTKAPURA"
                                },
                                {
                                    "Text": "KOTKHAI",
                                    "Value": "KOTKHAI"
                                },
                                {
                                    "Text": "KOTLA ",
                                    "Value": "KOTLA "
                                },
                                {
                                    "Text": "KOTMA",
                                    "Value": "KOTMA"
                                },
                                {
                                    "Text": "KOTPUTLI",
                                    "Value": "KOTPUTLI"
                                },
                                {
                                    "Text": "KOTRA",
                                    "Value": "KOTRA"
                                },
                                {
                                    "Text": "KOTSHAMIR",
                                    "Value": "KOTSHAMIR"
                                },
                                {
                                    "Text": "KOTTARAKARA",
                                    "Value": "KOTTARAKARA"
                                },
                                {
                                    "Text": "KOTTAKKAL",
                                    "Value": "KOTTAKKAL"
                                },
                                {
                                    "Text": "KOTTAYAM",
                                    "Value": "KOTTAYAM"
                                },
                                {
                                    "Text": "KOTTAPUDUR ",
                                    "Value": "KOTTAPUDUR "
                                },
                                {
                                    "Text": "KOTTAKAL",
                                    "Value": "KOTTAKAL"
                                },
                                {
                                    "Text": "KOTTARAKKARA",
                                    "Value": "KOTTARAKKARA"
                                },
                                {
                                    "Text": "KOVILPATTI",
                                    "Value": "KOVILPATTI"
                                },
                                {
                                    "Text": "KOVUR",
                                    "Value": "KOVUR"
                                },
                                {
                                    "Text": "KOVVUR",
                                    "Value": "KOVVUR"
                                },
                                {
                                    "Text": "KOYALI",
                                    "Value": "KOYALI"
                                },
                                {
                                    "Text": "KOYILANDY",
                                    "Value": "KOYILANDY"
                                },
                                {
                                    "Text": "KOZHENCHERRY",
                                    "Value": "KOZHENCHERRY"
                                },
                                {
                                    "Text": "KOZHIKODE",
                                    "Value": "KOZHIKODE"
                                },
                                {
                                    "Text": "KOZHENCHERY",
                                    "Value": "KOZHENCHERY"
                                },
                                {
                                    "Text": "KOPAR KHAIRANE",
                                    "Value": "KOPAR KHAIRANE"
                                },
                                {
                                    "Text": "KAPAS HERA",
                                    "Value": "KAPAS HERA"
                                },
                                {
                                    "Text": "KRISHNAGAR",
                                    "Value": "KRISHNAGAR"
                                },
                                {
                                    "Text": "KRISHNA",
                                    "Value": "KRISHNA"
                                },
                                {
                                    "Text": "KRISHNAGIRI",
                                    "Value": "KRISHNAGIRI"
                                },
                                {
                                    "Text": "KRISHNAJIVADI ",
                                    "Value": "KRISHNAJIVADI "
                                },
                                {
                                    "Text": "KRISHNA BAZAR(NARSIPATNAM) ",
                                    "Value": "KRISHNA BAZAR(NARSIPATNAM) "
                                },
                                {
                                    "Text": "KARAIKAL",
                                    "Value": "KARAIKAL"
                                },
                                {
                                    "Text": "KARAMADAI",
                                    "Value": "KARAMADAI"
                                },
                                {
                                    "Text": "KARAWAL NAGAR",
                                    "Value": "KARAWAL NAGAR"
                                },
                                {
                                    "Text": "KATKAR",
                                    "Value": "KATKAR"
                                },
                                {
                                    "Text": "KHATIMA",
                                    "Value": "KHATIMA"
                                },
                                {
                                    "Text": "KUBA",
                                    "Value": "KUBA"
                                },
                                {
                                    "Text": "KUCHAMAN CITY",
                                    "Value": "KUCHAMAN CITY"
                                },
                                {
                                    "Text": "KUCHINDA",
                                    "Value": "KUCHINDA"
                                },
                                {
                                    "Text": "KUDAL",
                                    "Value": "KUDAL"
                                },
                                {
                                    "Text": "KUDAMALOOR",
                                    "Value": "KUDAMALOOR"
                                },
                                {
                                    "Text": "KUDI KHERA",
                                    "Value": "KUDI KHERA"
                                },
                                {
                                    "Text": "KUDU",
                                    "Value": "KUDU"
                                },
                                {
                                    "Text": "KUDUMULUGUMA",
                                    "Value": "KUDUMULUGUMA"
                                },
                                {
                                    "Text": "KUIANI ",
                                    "Value": "KUIANI "
                                },
                                {
                                    "Text": "KUJANG",
                                    "Value": "KUJANG"
                                },
                                {
                                    "Text": "KUKAR PIND",
                                    "Value": "KUKAR PIND"
                                },
                                {
                                    "Text": "KUKARWADA",
                                    "Value": "KUKARWADA"
                                },
                                {
                                    "Text": "KUKATPALLY",
                                    "Value": "KUKATPALLY"
                                },
                                {
                                    "Text": "KUKSHI",
                                    "Value": "KUKSHI"
                                },
                                {
                                    "Text": "KULATHUMUZHY",
                                    "Value": "KULATHUMUZHY"
                                },
                                {
                                    "Text": "KULGAM",
                                    "Value": "KULGAM"
                                },
                                {
                                    "Text": "KULITHALAI",
                                    "Value": "KULITHALAI"
                                },
                                {
                                    "Text": "KULLU",
                                    "Value": "KULLU"
                                },
                                {
                                    "Text": "KUMBAKONAM",
                                    "Value": "KUMBAKONAM"
                                },
                                {
                                    "Text": "KUM KALAN",
                                    "Value": "KUM KALAN"
                                },
                                {
                                    "Text": "KUMTA",
                                    "Value": "KUMTA"
                                },
                                {
                                    "Text": "KUNDA",
                                    "Value": "KUNDA"
                                },
                                {
                                    "Text": "KUNDAPURA",
                                    "Value": "KUNDAPURA"
                                },
                                {
                                    "Text": "KUNDAPUR",
                                    "Value": "KUNDAPUR"
                                },
                                {
                                    "Text": "KUNDLI",
                                    "Value": "KUNDLI"
                                },
                                {
                                    "Text": "KUNNAMKULAM",
                                    "Value": "KUNNAMKULAM"
                                },
                                {
                                    "Text": "KUPWARA",
                                    "Value": "KUPWARA"
                                },
                                {
                                    "Text": "KURADIHA",
                                    "Value": "KURADIHA"
                                },
                                {
                                    "Text": "KURALI",
                                    "Value": "KURALI"
                                },
                                {
                                    "Text": "KURICHITHANAM",
                                    "Value": "KURICHITHANAM"
                                },
                                {
                                    "Text": "KURMAPURAM ",
                                    "Value": "KURMAPURAM "
                                },
                                {
                                    "Text": "KURNOOL",
                                    "Value": "KURNOOL"
                                },
                                {
                                    "Text": "KURUKSHETRA",
                                    "Value": "KURUKSHETRA"
                                },
                                {
                                    "Text": "KURUNG KUMEY",
                                    "Value": "KURUNG KUMEY"
                                },
                                {
                                    "Text": "KURUD",
                                    "Value": "KURUD"
                                },
                                {
                                    "Text": "KUSARLAPUDI ",
                                    "Value": "KUSARLAPUDI "
                                },
                                {
                                    "Text": "KUSHINAGAR",
                                    "Value": "KUSHINAGAR"
                                },
                                {
                                    "Text": "KUTCHERY CHOWK",
                                    "Value": "KUTCHERY CHOWK"
                                },
                                {
                                    "Text": "KUTCH",
                                    "Value": "KUTCH"
                                },
                                {
                                    "Text": "KUTCHH",
                                    "Value": "KUTCHH"
                                },
                                {
                                    "Text": "KUWAIT",
                                    "Value": "KUWAIT"
                                },
                                {
                                    "Text": "K YELLAVARAM ",
                                    "Value": "K YELLAVARAM "
                                },
                                {
                                    "Text": "LACHAPET ",
                                    "Value": "LACHAPET "
                                },
                                {
                                    "Text": "LADSAWANGI ",
                                    "Value": "LADSAWANGI "
                                },
                                {
                                    "Text": "LADWA",
                                    "Value": "LADWA"
                                },
                                {
                                    "Text": "LAHUL & SPITI",
                                    "Value": "LAHUL & SPITI"
                                },
                                {
                                    "Text": "LAKHIMPUR",
                                    "Value": "LAKHIMPUR"
                                },
                                {
                                    "Text": "LAKHIMPUR",
                                    "Value": "LAKHIMPUR"
                                },
                                {
                                    "Text": "LAKHISARAI",
                                    "Value": "LAKHISARAI"
                                },
                                {
                                    "Text": "LAKHAN MAJRA",
                                    "Value": "LAKHAN MAJRA"
                                },
                                {
                                    "Text": "LAKSHADWEEP",
                                    "Value": "LAKSHADWEEP"
                                },
                                {
                                    "Text": "LALGANJ KATGHAR",
                                    "Value": "LALGANJ KATGHAR"
                                },
                                {
                                    "Text": "LALGUDI",
                                    "Value": "LALGUDI"
                                },
                                {
                                    "Text": "LALGANJ",
                                    "Value": "LALGANJ"
                                },
                                {
                                    "Text": "LALGANJ-KATGHAR",
                                    "Value": "LALGANJ-KATGHAR"
                                },
                                {
                                    "Text": "LALITPUR",
                                    "Value": "LALITPUR"
                                },
                                {
                                    "Text": "LAL KALAN",
                                    "Value": "LAL KALAN"
                                },
                                {
                                    "Text": "LALPUR",
                                    "Value": "LALPUR"
                                },
                                {
                                    "Text": "LALRU",
                                    "Value": "LALRU"
                                },
                                {
                                    "Text": "LALSOT",
                                    "Value": "LALSOT"
                                },
                                {
                                    "Text": "LAMBI",
                                    "Value": "LAMBI"
                                },
                                {
                                    "Text": "LAMBRA",
                                    "Value": "LAMBRA"
                                },
                                {
                                    "Text": "LAMMASINGI ",
                                    "Value": "LAMMASINGI "
                                },
                                {
                                    "Text": "LANDRAN",
                                    "Value": "LANDRAN"
                                },
                                {
                                    "Text": "LANDE KE ",
                                    "Value": "LANDE KE "
                                },
                                {
                                    "Text": "LANDRAN",
                                    "Value": "LANDRAN"
                                },
                                {
                                    "Text": "LAOJORA ",
                                    "Value": "LAOJORA "
                                },
                                {
                                    "Text": "LAPKAMAN",
                                    "Value": "LAPKAMAN"
                                },
                                {
                                    "Text": "LASALGAON",
                                    "Value": "LASALGAON"
                                },
                                {
                                    "Text": "LATEHAR",
                                    "Value": "LATEHAR"
                                },
                                {
                                    "Text": "LATUR",
                                    "Value": "LATUR"
                                },
                                {
                                    "Text": "LAWNGTLAI",
                                    "Value": "LAWNGTLAI"
                                },
                                {
                                    "Text": "LAXITTIPET",
                                    "Value": "LAXITTIPET"
                                },
                                {
                                    "Text": "LAXMIPUR ",
                                    "Value": "LAXMIPUR "
                                },
                                {
                                    "Text": "LAXMANGARH ",
                                    "Value": "LAXMANGARH "
                                },
                                {
                                    "Text": "LIBAS PUR",
                                    "Value": "LIBAS PUR"
                                },
                                {
                                    "Text": "LADNUN",
                                    "Value": "LADNUN"
                                },
                                {
                                    "Text": "LEH",
                                    "Value": "LEH"
                                },
                                {
                                    "Text": "LEHAL",
                                    "Value": "LEHAL"
                                },
                                {
                                    "Text": "LEHRAGAGA",
                                    "Value": "LEHRAGAGA"
                                },
                                {
                                    "Text": "LIMBDI",
                                    "Value": "LIMBDI"
                                },
                                {
                                    "Text": "LINGAPUR ",
                                    "Value": "LINGAPUR "
                                },
                                {
                                    "Text": "LAKHPAT",
                                    "Value": "LAKHPAT"
                                },
                                {
                                    "Text": "LAKHIMPUR KHERI",
                                    "Value": "LAKHIMPUR KHERI"
                                },
                                {
                                    "Text": "LLKAL",
                                    "Value": "LLKAL"
                                },
                                {
                                    "Text": "LOHARDAGA",
                                    "Value": "LOHARDAGA"
                                },
                                {
                                    "Text": "LOHA ",
                                    "Value": "LOHA "
                                },
                                {
                                    "Text": "LOHARDIH",
                                    "Value": "LOHARDIH"
                                },
                                {
                                    "Text": "LOHARKA",
                                    "Value": "LOHARKA"
                                },
                                {
                                    "Text": "LOHARSI",
                                    "Value": "LOHARSI"
                                },
                                {
                                    "Text": "LOHARU",
                                    "Value": "LOHARU"
                                },
                                {
                                    "Text": "LOHIAN KHAS",
                                    "Value": "LOHIAN KHAS"
                                },
                                {
                                    "Text": "LOHIT",
                                    "Value": "LOHIT"
                                },
                                {
                                    "Text": "LOHIAN KHAS",
                                    "Value": "LOHIAN KHAS"
                                },
                                {
                                    "Text": "LOHTA",
                                    "Value": "LOHTA"
                                },
                                {
                                    "Text": "LOISINGA",
                                    "Value": "LOISINGA"
                                },
                                {
                                    "Text": "LOKAMALESWARAM",
                                    "Value": "LOKAMALESWARAM"
                                },
                                {
                                    "Text": "LONAVALA",
                                    "Value": "LONAVALA"
                                },
                                {
                                    "Text": "LONAND",
                                    "Value": "LONAND"
                                },
                                {
                                    "Text": "LONGOWAL",
                                    "Value": "LONGOWAL"
                                },
                                {
                                    "Text": "LONGLENG",
                                    "Value": "LONGLENG"
                                },
                                {
                                    "Text": "LONGAON ",
                                    "Value": "LONGAON "
                                },
                                {
                                    "Text": "LONI",
                                    "Value": "LONI"
                                },
                                {
                                    "Text": "LONI",
                                    "Value": "LONI"
                                },
                                {
                                    "Text": "LOPOKE",
                                    "Value": "LOPOKE"
                                },
                                {
                                    "Text": "LOWER DIBANG VALLEY",
                                    "Value": "LOWER DIBANG VALLEY"
                                },
                                {
                                    "Text": "LOWER SUBANSIRI",
                                    "Value": "LOWER SUBANSIRI"
                                },
                                {
                                    "Text": "LUCKNOW",
                                    "Value": "LUCKNOW"
                                },
                                {
                                    "Text": "LUDHIANA",
                                    "Value": "LUDHIANA"
                                },
                                {
                                    "Text": "LUKHI",
                                    "Value": "LUKHI"
                                },
                                {
                                    "Text": "LUNAWADA",
                                    "Value": "LUNAWADA"
                                },
                                {
                                    "Text": "LUNGLEI",
                                    "Value": "LUNGLEI"
                                },
                                {
                                    "Text": "LAXMANGARH",
                                    "Value": "LAXMANGARH"
                                },
                                {
                                    "Text": "MACHALIPATNAM",
                                    "Value": "MACHALIPATNAM"
                                },
                                {
                                    "Text": "MACHHIWARA",
                                    "Value": "MACHHIWARA"
                                },
                                {
                                    "Text": "MACHAREDDY ",
                                    "Value": "MACHAREDDY "
                                },
                                {
                                    "Text": "MACHERLA ",
                                    "Value": "MACHERLA "
                                },
                                {
                                    "Text": "MACHERLA",
                                    "Value": "MACHERLA"
                                },
                                {
                                    "Text": "MACHILIPATNAM",
                                    "Value": "MACHILIPATNAM"
                                },
                                {
                                    "Text": "MADANAPALLI",
                                    "Value": "MADANAPALLI"
                                },
                                {
                                    "Text": "MADANAPALLI ",
                                    "Value": "MADANAPALLI "
                                },
                                {
                                    "Text": "MADAI ",
                                    "Value": "MADAI "
                                },
                                {
                                    "Text": "MADANPUR ",
                                    "Value": "MADANPUR "
                                },
                                {
                                    "Text": "MADAMBAKKAM",
                                    "Value": "MADAMBAKKAM"
                                },
                                {
                                    "Text": "MADANAPALLE",
                                    "Value": "MADANAPALLE"
                                },
                                {
                                    "Text": "MADHEPURA",
                                    "Value": "MADHEPURA"
                                },
                                {
                                    "Text": "MADHUBANI",
                                    "Value": "MADHUBANI"
                                },
                                {
                                    "Text": "MADHAPUR ",
                                    "Value": "MADHAPUR "
                                },
                                {
                                    "Text": "MADHAVPUR ",
                                    "Value": "MADHAVPUR "
                                },
                                {
                                    "Text": "MADHUR ",
                                    "Value": "MADHUR "
                                },
                                {
                                    "Text": "MADHAPAR",
                                    "Value": "MADHAPAR"
                                },
                                {
                                    "Text": "MADHI",
                                    "Value": "MADHI"
                                },
                                {
                                    "Text": "MADHOPUR",
                                    "Value": "MADHOPUR"
                                },
                                {
                                    "Text": "MADHUPUR",
                                    "Value": "MADHUPUR"
                                },
                                {
                                    "Text": "MADHYAMGRAM",
                                    "Value": "MADHYAMGRAM"
                                },
                                {
                                    "Text": "MADIKERI",
                                    "Value": "MADIKERI"
                                },
                                {
                                    "Text": "MADIPPAKKAM",
                                    "Value": "MADIPPAKKAM"
                                },
                                {
                                    "Text": "MADKERI",
                                    "Value": "MADKERI"
                                },
                                {
                                    "Text": "MADLAUDA",
                                    "Value": "MADLAUDA"
                                },
                                {
                                    "Text": "MADLODA",
                                    "Value": "MADLODA"
                                },
                                {
                                    "Text": "MADURAI",
                                    "Value": "MADURAI"
                                },
                                {
                                    "Text": "MAGAM",
                                    "Value": "MAGAM"
                                },
                                {
                                    "Text": "MAGDI ",
                                    "Value": "MAGDI "
                                },
                                {
                                    "Text": "MAHAD",
                                    "Value": "MAHAD"
                                },
                                {
                                    "Text": "MAHABUBNAGAR",
                                    "Value": "MAHABUBNAGAR"
                                },
                                {
                                    "Text": "MAHABUB NAGAR",
                                    "Value": "MAHABUB NAGAR"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHASAMUND",
                                    "Value": "MAHASAMUND"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHAMAYA NAGAR",
                                    "Value": "MAHAMAYA NAGAR"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHAGAI ",
                                    "Value": "MAHAGAI "
                                },
                                {
                                    "Text": "MAHABUBABAD",
                                    "Value": "MAHABUBABAD"
                                },
                                {
                                    "Text": "MAHAL KALAN",
                                    "Value": "MAHAL KALAN"
                                },
                                {
                                    "Text": "MAHAM",
                                    "Value": "MAHAM"
                                },
                                {
                                    "Text": "MAHAMMADPUR",
                                    "Value": "MAHAMMADPUR"
                                },
                                {
                                    "Text": "MAHATPUR",
                                    "Value": "MAHATPUR"
                                },
                                {
                                    "Text": "MAHE",
                                    "Value": "MAHE"
                                },
                                {
                                    "Text": "MAHE",
                                    "Value": "MAHE"
                                },
                                {
                                    "Text": "MAHENDRAGARH",
                                    "Value": "MAHENDRAGARH"
                                },
                                {
                                    "Text": "MAHESANA",
                                    "Value": "MAHESANA"
                                },
                                {
                                    "Text": "MAHENDRAGANJ",
                                    "Value": "MAHENDRAGANJ"
                                },
                                {
                                    "Text": "MAHETPUR",
                                    "Value": "MAHETPUR"
                                },
                                {
                                    "Text": "MAHENDARGARH",
                                    "Value": "MAHENDARGARH"
                                },
                                {
                                    "Text": "MAHENDRANAGAR",
                                    "Value": "MAHENDRANAGAR"
                                },
                                {
                                    "Text": "MAHERU",
                                    "Value": "MAHERU"
                                },
                                {
                                    "Text": "MAHISAGAR",
                                    "Value": "MAHISAGAR"
                                },
                                {
                                    "Text": "MAHIDPUR",
                                    "Value": "MAHIDPUR"
                                },
                                {
                                    "Text": "MAHILPUR",
                                    "Value": "MAHILPUR"
                                },
                                {
                                    "Text": "MAHIYAWALI",
                                    "Value": "MAHIYAWALI"
                                },
                                {
                                    "Text": "MAHENDRAGANJ",
                                    "Value": "MAHENDRAGANJ"
                                },
                                {
                                    "Text": "MAHOBA",
                                    "Value": "MAHOBA"
                                },
                                {
                                    "Text": "MAHUVA",
                                    "Value": "MAHUVA"
                                },
                                {
                                    "Text": "MAIHAR",
                                    "Value": "MAIHAR"
                                },
                                {
                                    "Text": "MAINPURI",
                                    "Value": "MAINPURI"
                                },
                                {
                                    "Text": "MAIRANG",
                                    "Value": "MAIRANG"
                                },
                                {
                                    "Text": "MAISAMMAGUDEM ",
                                    "Value": "MAISAMMAGUDEM "
                                },
                                {
                                    "Text": "MAJALGAON",
                                    "Value": "MAJALGAON"
                                },
                                {
                                    "Text": "MAJARI",
                                    "Value": "MAJARI"
                                },
                                {
                                    "Text": "MAJITHA",
                                    "Value": "MAJITHA"
                                },
                                {
                                    "Text": "MAJORDA",
                                    "Value": "MAJORDA"
                                },
                                {
                                    "Text": "MAJRA",
                                    "Value": "MAJRA"
                                },
                                {
                                    "Text": "MAJRI",
                                    "Value": "MAJRI"
                                },
                                {
                                    "Text": "MAJWIND",
                                    "Value": "MAJWIND"
                                },
                                {
                                    "Text": "MAKHU",
                                    "Value": "MAKHU"
                                },
                                {
                                    "Text": "MAKRANA",
                                    "Value": "MAKRANA"
                                },
                                {
                                    "Text": "MALAPPURAM",
                                    "Value": "MALAPPURAM"
                                },
                                {
                                    "Text": "MALA",
                                    "Value": "MALA"
                                },
                                {
                                    "Text": "MALAKPUR",
                                    "Value": "MALAKPUR"
                                },
                                {
                                    "Text": "MALAPURAM",
                                    "Value": "MALAPURAM"
                                },
                                {
                                    "Text": "MALDA",
                                    "Value": "MALDA"
                                },
                                {
                                    "Text": "MALEGAON",
                                    "Value": "MALEGAON"
                                },
                                {
                                    "Text": "MALERKOTLA",
                                    "Value": "MALERKOTLA"
                                },
                                {
                                    "Text": "MALGAON",
                                    "Value": "MALGAON"
                                },
                                {
                                    "Text": "MALIYASAN",
                                    "Value": "MALIYASAN"
                                },
                                {
                                    "Text": "MALKAPUR",
                                    "Value": "MALKAPUR"
                                },
                                {
                                    "Text": "MALKANGIRI",
                                    "Value": "MALKANGIRI"
                                },
                                {
                                    "Text": "MALKHED",
                                    "Value": "MALKHED"
                                },
                                {
                                    "Text": "MALLIAL ",
                                    "Value": "MALLIAL "
                                },
                                {
                                    "Text": "MALLANWALA",
                                    "Value": "MALLANWALA"
                                },
                                {
                                    "Text": "MALLEKAN",
                                    "Value": "MALLEKAN"
                                },
                                {
                                    "Text": "MALOUT",
                                    "Value": "MALOUT"
                                },
                                {
                                    "Text": "MALOUD",
                                    "Value": "MALOUD"
                                },
                                {
                                    "Text": "MALPURA",
                                    "Value": "MALPURA"
                                },
                                {
                                    "Text": "MALRU",
                                    "Value": "MALRU"
                                },
                                {
                                    "Text": "MALSIAN",
                                    "Value": "MALSIAN"
                                },
                                {
                                    "Text": "MALUKA",
                                    "Value": "MALUKA"
                                },
                                {
                                    "Text": "MALUR",
                                    "Value": "MALUR"
                                },
                                {
                                    "Text": "MALVAN",
                                    "Value": "MALVAN"
                                },
                                {
                                    "Text": "MALWARDEVRAMPALLI ",
                                    "Value": "MALWARDEVRAMPALLI "
                                },
                                {
                                    "Text": "MAMDOT UTTAR",
                                    "Value": "MAMDOT UTTAR"
                                },
                                {
                                    "Text": "MAMIDIPALLI ",
                                    "Value": "MAMIDIPALLI "
                                },
                                {
                                    "Text": "MAMMIT",
                                    "Value": "MAMMIT"
                                },
                                {
                                    "Text": "MANANTHAVADY",
                                    "Value": "MANANTHAVADY"
                                },
                                {
                                    "Text": "MANALI",
                                    "Value": "MANALI"
                                },
                                {
                                    "Text": "MANAVADAR",
                                    "Value": "MANAVADAR"
                                },
                                {
                                    "Text": "MANAKKODY",
                                    "Value": "MANAKKODY"
                                },
                                {
                                    "Text": "MANAULI",
                                    "Value": "MANAULI"
                                },
                                {
                                    "Text": "MANAURI BAZAR",
                                    "Value": "MANAURI BAZAR"
                                },
                                {
                                    "Text": "MANAVADAR",
                                    "Value": "MANAVADAR"
                                },
                                {
                                    "Text": "MANAWALA",
                                    "Value": "MANAWALA"
                                },
                                {
                                    "Text": "MANCHERIAL",
                                    "Value": "MANCHERIAL"
                                },
                                {
                                    "Text": "MANKACHAR",
                                    "Value": "MANKACHAR"
                                },
                                {
                                    "Text": "MANDI",
                                    "Value": "MANDI"
                                },
                                {
                                    "Text": "MANDAPETA",
                                    "Value": "MANDAPETA"
                                },
                                {
                                    "Text": "MANDVI",
                                    "Value": "MANDVI"
                                },
                                {
                                    "Text": "MANDI DABWALI",
                                    "Value": "MANDI DABWALI"
                                },
                                {
                                    "Text": "MANDIDEEP",
                                    "Value": "MANDIDEEP"
                                },
                                {
                                    "Text": "MANDI GOBINDGARH",
                                    "Value": "MANDI GOBINDGARH"
                                },
                                {
                                    "Text": "MANDI",
                                    "Value": "MANDI"
                                },
                                {
                                    "Text": "MANDLA",
                                    "Value": "MANDLA"
                                },
                                {
                                    "Text": "MANDSAUR",
                                    "Value": "MANDSAUR"
                                },
                                {
                                    "Text": "MAND",
                                    "Value": "MAND"
                                },
                                {
                                    "Text": "MANDAI BUJURG",
                                    "Value": "MANDAI BUJURG"
                                },
                                {
                                    "Text": "MANDAI KHURD",
                                    "Value": "MANDAI KHURD"
                                },
                                {
                                    "Text": "MANENDRAGARH",
                                    "Value": "MANENDRAGARH"
                                },
                                {
                                    "Text": "MANEGAON ",
                                    "Value": "MANEGAON "
                                },
                                {
                                    "Text": "MANESAR",
                                    "Value": "MANESAR"
                                },
                                {
                                    "Text": "MANGALORE URBAN",
                                    "Value": "MANGALORE URBAN"
                                },
                                {
                                    "Text": "MANGALDOI",
                                    "Value": "MANGALDOI"
                                },
                                {
                                    "Text": "MANGALORE",
                                    "Value": "MANGALORE"
                                },
                                {
                                    "Text": "MANGROL",
                                    "Value": "MANGROL"
                                },
                                {
                                    "Text": "MANGALAGIRI",
                                    "Value": "MANGALAGIRI"
                                },
                                {
                                    "Text": "MANGALORE-URBAN",
                                    "Value": "MANGALORE-URBAN"
                                },
                                {
                                    "Text": "MANGAON",
                                    "Value": "MANGAON"
                                },
                                {
                                    "Text": "MANGARH",
                                    "Value": "MANGARH"
                                },
                                {
                                    "Text": "MANGLIA",
                                    "Value": "MANGLIA"
                                },
                                {
                                    "Text": "MANGROL",
                                    "Value": "MANGROL"
                                },
                                {
                                    "Text": "MANIPAL",
                                    "Value": "MANIPAL"
                                },
                                {
                                    "Text": "MANIGILLA ",
                                    "Value": "MANIGILLA "
                                },
                                {
                                    "Text": "MANIYAMPALAYAM ",
                                    "Value": "MANIYAMPALAYAM "
                                },
                                {
                                    "Text": "MANJERI",
                                    "Value": "MANJERI"
                                },
                                {
                                    "Text": "MANJALPUR",
                                    "Value": "MANJALPUR"
                                },
                                {
                                    "Text": "MANJARI",
                                    "Value": "MANJARI"
                                },
                                {
                                    "Text": "MANJUSAR",
                                    "Value": "MANJUSAR"
                                },
                                {
                                    "Text": "MANKACHAR",
                                    "Value": "MANKACHAR"
                                },
                                {
                                    "Text": "MANKARA ",
                                    "Value": "MANKARA "
                                },
                                {
                                    "Text": "MANKAPUR",
                                    "Value": "MANKAPUR"
                                },
                                {
                                    "Text": "MANKO",
                                    "Value": "MANKO"
                                },
                                {
                                    "Text": "MANMAD",
                                    "Value": "MANMAD"
                                },
                                {
                                    "Text": "MANNEGUDA ",
                                    "Value": "MANNEGUDA "
                                },
                                {
                                    "Text": "MANNARKKAD",
                                    "Value": "MANNARKKAD"
                                },
                                {
                                    "Text": "MANOR",
                                    "Value": "MANOR"
                                },
                                {
                                    "Text": "MANOCHAHAL ",
                                    "Value": "MANOCHAHAL "
                                },
                                {
                                    "Text": "MANPUR",
                                    "Value": "MANPUR"
                                },
                                {
                                    "Text": "MANSA",
                                    "Value": "MANSA"
                                },
                                {
                                    "Text": "MANSA",
                                    "Value": "MANSA"
                                },
                                {
                                    "Text": "MANSOORWAL ",
                                    "Value": "MANSOORWAL "
                                },
                                {
                                    "Text": "MANTHANI ",
                                    "Value": "MANTHANI "
                                },
                                {
                                    "Text": "MANTHANI",
                                    "Value": "MANTHANI"
                                },
                                {
                                    "Text": "MAPUSA",
                                    "Value": "MAPUSA"
                                },
                                {
                                    "Text": "MAROL",
                                    "Value": "MAROL"
                                },
                                {
                                    "Text": "MARATHALLI",
                                    "Value": "MARATHALLI"
                                },
                                {
                                    "Text": "MARAIMALAI",
                                    "Value": "MARAIMALAI"
                                },
                                {
                                    "Text": "MARCEL",
                                    "Value": "MARCEL"
                                },
                                {
                                    "Text": "MARCELA",
                                    "Value": "MARCELA"
                                },
                                {
                                    "Text": "MARDANPUR",
                                    "Value": "MARDANPUR"
                                },
                                {
                                    "Text": "MARGAO",
                                    "Value": "MARGAO"
                                },
                                {
                                    "Text": "MARGOA",
                                    "Value": "MARGOA"
                                },
                                {
                                    "Text": "MARGOA",
                                    "Value": "MARGOA"
                                },
                                {
                                    "Text": "MARIGAON",
                                    "Value": "MARIGAON"
                                },
                                {
                                    "Text": "MARIGADI ",
                                    "Value": "MARIGADI "
                                },
                                {
                                    "Text": "MARKAPUR",
                                    "Value": "MARKAPUR"
                                },
                                {
                                    "Text": "MARLAGUDEM ",
                                    "Value": "MARLAGUDEM "
                                },
                                {
                                    "Text": "MAROLI",
                                    "Value": "MAROLI"
                                },
                                {
                                    "Text": "MARTHANDAM",
                                    "Value": "MARTHANDAM"
                                },
                                {
                                    "Text": "MARYAL ",
                                    "Value": "MARYAL "
                                },
                                {
                                    "Text": "MASLANDAPUR",
                                    "Value": "MASLANDAPUR"
                                },
                                {
                                    "Text": "MASOR KHAMBH ",
                                    "Value": "MASOR KHAMBH "
                                },
                                {
                                    "Text": "MATANHAIL",
                                    "Value": "MATANHAIL"
                                },
                                {
                                    "Text": "MATHURA",
                                    "Value": "MATHURA"
                                },
                                {
                                    "Text": "MATIGARA",
                                    "Value": "MATIGARA"
                                },
                                {
                                    "Text": "MATOOR ",
                                    "Value": "MATOOR "
                                },
                                {
                                    "Text": "MATRA",
                                    "Value": "MATRA"
                                },
                                {
                                    "Text": "MATTANUR",
                                    "Value": "MATTANUR"
                                },
                                {
                                    "Text": "MATTARAKKAL ",
                                    "Value": "MATTARAKKAL "
                                },
                                {
                                    "Text": "MATTANNUR",
                                    "Value": "MATTANNUR"
                                },
                                {
                                    "Text": "MATWADA ",
                                    "Value": "MATWADA "
                                },
                                {
                                    "Text": "MAU",
                                    "Value": "MAU"
                                },
                                {
                                    "Text": "MAUDAHA",
                                    "Value": "MAUDAHA"
                                },
                                {
                                    "Text": "MAUJPURI ",
                                    "Value": "MAUJPURI "
                                },
                                {
                                    "Text": "MAUNATH BHANJAN",
                                    "Value": "MAUNATH BHANJAN"
                                },
                                {
                                    "Text": "MAURANIPUR",
                                    "Value": "MAURANIPUR"
                                },
                                {
                                    "Text": "MAUR MANDI",
                                    "Value": "MAUR MANDI"
                                },
                                {
                                    "Text": "MAUR",
                                    "Value": "MAUR"
                                },
                                {
                                    "Text": "MAURMANDI",
                                    "Value": "MAURMANDI"
                                },
                                {
                                    "Text": "MAVELIKARA",
                                    "Value": "MAVELIKARA"
                                },
                                {
                                    "Text": "MAVELIKKARA",
                                    "Value": "MAVELIKKARA"
                                },
                                {
                                    "Text": "MAWANA",
                                    "Value": "MAWANA"
                                },
                                {
                                    "Text": "MAYILADUTHURAI",
                                    "Value": "MAYILADUTHURAI"
                                },
                                {
                                    "Text": "MAYILADUTHURAI TOWN",
                                    "Value": "MAYILADUTHURAI TOWN"
                                },
                                {
                                    "Text": "MAYAPURI",
                                    "Value": "MAYAPURI"
                                },
                                {
                                    "Text": "MAYURBHANJ",
                                    "Value": "MAYURBHANJ"
                                },
                                {
                                    "Text": "MADARIA",
                                    "Value": "MADARIA"
                                },
                                {
                                    "Text": "MEDAK",
                                    "Value": "MEDAK"
                                },
                                {
                                    "Text": "MEDCHAL",
                                    "Value": "MEDCHAL"
                                },
                                {
                                    "Text": "MEDINIPUR",
                                    "Value": "MEDINIPUR"
                                },
                                {
                                    "Text": "MEDIPALLY ",
                                    "Value": "MEDIPALLY "
                                },
                                {
                                    "Text": "MEERUT",
                                    "Value": "MEERUT"
                                },
                                {
                                    "Text": "MEGH CHAPPAR",
                                    "Value": "MEGH CHAPPAR"
                                },
                                {
                                    "Text": "MEHATPUR",
                                    "Value": "MEHATPUR"
                                },
                                {
                                    "Text": "MEHAM",
                                    "Value": "MEHAM"
                                },
                                {
                                    "Text": "MEHBUBNAGAR",
                                    "Value": "MEHBUBNAGAR"
                                },
                                {
                                    "Text": "MEHDOODAN",
                                    "Value": "MEHDOODAN"
                                },
                                {
                                    "Text": "MEHELI",
                                    "Value": "MEHELI"
                                },
                                {
                                    "Text": "MEHMA SINGHWALA",
                                    "Value": "MEHMA SINGHWALA"
                                },
                                {
                                    "Text": "MEHSANA",
                                    "Value": "MEHSANA"
                                },
                                {
                                    "Text": "MEHTA",
                                    "Value": "MEHTA"
                                },
                                {
                                    "Text": "MEMADPUR",
                                    "Value": "MEMADPUR"
                                },
                                {
                                    "Text": "MEMARI",
                                    "Value": "MEMARI"
                                },
                                {
                                    "Text": "MEMAURA",
                                    "Value": "MEMAURA"
                                },
                                {
                                    "Text": "MEMNAGAR",
                                    "Value": "MEMNAGAR"
                                },
                                {
                                    "Text": "MENDHIPATHAR",
                                    "Value": "MENDHIPATHAR"
                                },
                                {
                                    "Text": "MENDHIPATHAR",
                                    "Value": "MENDHIPATHAR"
                                },
                                {
                                    "Text": "MENDRA KALAN",
                                    "Value": "MENDRA KALAN"
                                },
                                {
                                    "Text": "MERAMANDALI",
                                    "Value": "MERAMANDALI"
                                },
                                {
                                    "Text": "MERTA CITY",
                                    "Value": "MERTA CITY"
                                },
                                {
                                    "Text": "METODA",
                                    "Value": "METODA"
                                },
                                {
                                    "Text": "METPALLE",
                                    "Value": "METPALLE"
                                },
                                {
                                    "Text": "METTUPALAYAM",
                                    "Value": "METTUPALAYAM"
                                },
                                {
                                    "Text": "METTUR DAM",
                                    "Value": "METTUR DAM"
                                },
                                {
                                    "Text": "METTUR",
                                    "Value": "METTUR"
                                },
                                {
                                    "Text": "MEGHNAGAR",
                                    "Value": "MEGHNAGAR"
                                },
                                {
                                    "Text": "MHOW",
                                    "Value": "MHOW"
                                },
                                {
                                    "Text": "MIANI KHAS",
                                    "Value": "MIANI KHAS"
                                },
                                {
                                    "Text": "MIDNAPORE",
                                    "Value": "MIDNAPORE"
                                },
                                {
                                    "Text": "MILAK ",
                                    "Value": "MILAK "
                                },
                                {
                                    "Text": "MILKIPUR",
                                    "Value": "MILKIPUR"
                                },
                                {
                                    "Text": "MIRA ROAD",
                                    "Value": "MIRA ROAD"
                                },
                                {
                                    "Text": "MIRAJ",
                                    "Value": "MIRAJ"
                                },
                                {
                                    "Text": "MIRAN KOT KALAN",
                                    "Value": "MIRAN KOT KALAN"
                                },
                                {
                                    "Text": "MIRDHAPALLI ",
                                    "Value": "MIRDHAPALLI "
                                },
                                {
                                    "Text": "MIRGANJ",
                                    "Value": "MIRGANJ"
                                },
                                {
                                    "Text": "MIRYALGUDA",
                                    "Value": "MIRYALGUDA"
                                },
                                {
                                    "Text": "MIRZAPUR",
                                    "Value": "MIRZAPUR"
                                },
                                {
                                    "Text": "MITHAPUR",
                                    "Value": "MITHAPUR"
                                },
                                {
                                    "Text": "MITHI ROHAR",
                                    "Value": "MITHI ROHAR"
                                },
                                {
                                    "Text": "M K PATNAM ",
                                    "Value": "M K PATNAM "
                                },
                                {
                                    "Text": "MALIBU TOWNE",
                                    "Value": "MALIBU TOWNE"
                                },
                                {
                                    "Text": "MALPUR",
                                    "Value": "MALPUR"
                                },
                                {
                                    "Text": "MOLAR BAND",
                                    "Value": "MOLAR BAND"
                                },
                                {
                                    "Text": "MANINAGAR",
                                    "Value": "MANINAGAR"
                                },
                                {
                                    "Text": "MANARGUDI",
                                    "Value": "MANARGUDI"
                                },
                                {
                                    "Text": "MODASA",
                                    "Value": "MODASA"
                                },
                                {
                                    "Text": "MODINAGAR",
                                    "Value": "MODINAGAR"
                                },
                                {
                                    "Text": "MOGA",
                                    "Value": "MOGA"
                                },
                                {
                                    "Text": "MOGA KTY ",
                                    "Value": "MOGA KTY "
                                },
                                {
                                    "Text": "MOGRA BADSHAHPUR",
                                    "Value": "MOGRA BADSHAHPUR"
                                },
                                {
                                    "Text": "MOHALI",
                                    "Value": "MOHALI"
                                },
                                {
                                    "Text": "MOHALI",
                                    "Value": "MOHALI"
                                },
                                {
                                    "Text": "MOHAN ",
                                    "Value": "MOHAN "
                                },
                                {
                                    "Text": "MOHALI SAS NAGAR",
                                    "Value": "MOHALI SAS NAGAR"
                                },
                                {
                                    "Text": "MOHAMMADABAD",
                                    "Value": "MOHAMMADABAD"
                                },
                                {
                                    "Text": "MOHAMMADI",
                                    "Value": "MOHAMMADI"
                                },
                                {
                                    "Text": "MOHANIA",
                                    "Value": "MOHANIA"
                                },
                                {
                                    "Text": "MOHANLALGANJ",
                                    "Value": "MOHANLALGANJ"
                                },
                                {
                                    "Text": "MOHKHED ",
                                    "Value": "MOHKHED "
                                },
                                {
                                    "Text": "MOHONE",
                                    "Value": "MOHONE"
                                },
                                {
                                    "Text": "MOKAMA",
                                    "Value": "MOKAMA"
                                },
                                {
                                    "Text": "MOKAMA",
                                    "Value": "MOKAMA"
                                },
                                {
                                    "Text": "MOKAMEH",
                                    "Value": "MOKAMEH"
                                },
                                {
                                    "Text": "MOKANDPUR",
                                    "Value": "MOKANDPUR"
                                },
                                {
                                    "Text": "MOKOKCHUNG",
                                    "Value": "MOKOKCHUNG"
                                },
                                {
                                    "Text": "MOLKACHARLA ",
                                    "Value": "MOLKACHARLA "
                                },
                                {
                                    "Text": "TUE",
                                    "Value": "MON"
                                },
                                {
                                    "Text": "MOOM",
                                    "Value": "MOOM"
                                },
                                {
                                    "Text": "MOONAK",
                                    "Value": "MOONAK"
                                },
                                {
                                    "Text": "MOOTHAKUNNAM",
                                    "Value": "MOOTHAKUNNAM"
                                },
                                {
                                    "Text": "MORADABAD",
                                    "Value": "MORADABAD"
                                },
                                {
                                    "Text": "MORANWALI ",
                                    "Value": "MORANWALI "
                                },
                                {
                                    "Text": "MORAN",
                                    "Value": "MORAN"
                                },
                                {
                                    "Text": "MORANWALI",
                                    "Value": "MORANWALI"
                                },
                                {
                                    "Text": "MORBI",
                                    "Value": "MORBI"
                                },
                                {
                                    "Text": "MORENA",
                                    "Value": "MORENA"
                                },
                                {
                                    "Text": "MORGA ",
                                    "Value": "MORGA "
                                },
                                {
                                    "Text": "MORINDA",
                                    "Value": "MORINDA"
                                },
                                {
                                    "Text": "MORMUGOA",
                                    "Value": "MORMUGOA"
                                },
                                {
                                    "Text": "MORMUGOA",
                                    "Value": "MORMUGOA"
                                },
                                {
                                    "Text": "MORVI",
                                    "Value": "MORVI"
                                },
                                {
                                    "Text": "MOTATIMBLA",
                                    "Value": "MOTATIMBLA"
                                },
                                {
                                    "Text": "MOTA MAVA",
                                    "Value": "MOTA MAVA"
                                },
                                {
                                    "Text": "MOTA",
                                    "Value": "MOTA"
                                },
                                {
                                    "Text": "MOTALA",
                                    "Value": "MOTALA"
                                },
                                {
                                    "Text": "MOTEBENNUR ",
                                    "Value": "MOTEBENNUR "
                                },
                                {
                                    "Text": "MOTEERAM ADDA",
                                    "Value": "MOTEERAM ADDA"
                                },
                                {
                                    "Text": "MOTIHARI",
                                    "Value": "MOTIHARI"
                                },
                                {
                                    "Text": "MIRA-BHAYANDAR",
                                    "Value": "MIRA-BHAYANDAR"
                                },
                                {
                                    "Text": "MIRPUR TURK",
                                    "Value": "MIRPUR TURK"
                                },
                                {
                                    "Text": "MASLANDAPUR",
                                    "Value": "MASLANDAPUR"
                                },
                                {
                                    "Text": "MUSTAFABAD, DELHI",
                                    "Value": "MUSTAFABAD, DELHI"
                                },
                                {
                                    "Text": "MITHE PUR",
                                    "Value": "MITHE PUR"
                                },
                                {
                                    "Text": "MATTAN",
                                    "Value": "MATTAN"
                                },
                                {
                                    "Text": "MOTATIMBLA",
                                    "Value": "MOTATIMBLA"
                                },
                                {
                                    "Text": "MUBARAKPUR",
                                    "Value": "MUBARAKPUR"
                                },
                                {
                                    "Text": "MUCHIMILLI ",
                                    "Value": "MUCHIMILLI "
                                },
                                {
                                    "Text": "MUDBIDRI",
                                    "Value": "MUDBIDRI"
                                },
                                {
                                    "Text": "MUDGUL CHITTEMPALLE ",
                                    "Value": "MUDGUL CHITTEMPALLE "
                                },
                                {
                                    "Text": "MUDHOL",
                                    "Value": "MUDHOL"
                                },
                                {
                                    "Text": "MUDHAL",
                                    "Value": "MUDHAL"
                                },
                                {
                                    "Text": "MUDKI",
                                    "Value": "MUDKI"
                                },
                                {
                                    "Text": "MUDUPUGAL ",
                                    "Value": "MUDUPUGAL "
                                },
                                {
                                    "Text": "MUGHALSARAI",
                                    "Value": "MUGHALSARAI"
                                },
                                {
                                    "Text": "MUGPAL",
                                    "Value": "MUGPAL"
                                },
                                {
                                    "Text": "MUHAMMADABAD",
                                    "Value": "MUHAMMADABAD"
                                },
                                {
                                    "Text": "MUKHED",
                                    "Value": "MUKHED"
                                },
                                {
                                    "Text": "MUKERIAN",
                                    "Value": "MUKERIAN"
                                },
                                {
                                    "Text": "MUKTSAR",
                                    "Value": "MUKTSAR"
                                },
                                {
                                    "Text": "MULAGAMPALLY ",
                                    "Value": "MULAGAMPALLY "
                                },
                                {
                                    "Text": "MULBAGAL",
                                    "Value": "MULBAGAL"
                                },
                                {
                                    "Text": "MULKI",
                                    "Value": "MULKI"
                                },
                                {
                                    "Text": "MULLANPUR",
                                    "Value": "MULLANPUR"
                                },
                                {
                                    "Text": "MULLANA",
                                    "Value": "MULLANA"
                                },
                                {
                                    "Text": "MULLANPUR DAKHA",
                                    "Value": "MULLANPUR DAKHA"
                                },
                                {
                                    "Text": "MULLANPUR GARIBADAS",
                                    "Value": "MULLANPUR GARIBADAS"
                                },
                                {
                                    "Text": "MUL",
                                    "Value": "MUL"
                                },
                                {
                                    "Text": "MUMBAI",
                                    "Value": "MUMBAI"
                                },
                                {
                                    "Text": "MUMBRA",
                                    "Value": "MUMBRA"
                                },
                                {
                                    "Text": "MUNAK",
                                    "Value": "MUNAK"
                                },
                                {
                                    "Text": "MUNDRA",
                                    "Value": "MUNDRA"
                                },
                                {
                                    "Text": "MUNDKA",
                                    "Value": "MUNDKA"
                                },
                                {
                                    "Text": "MUNDIYUR ",
                                    "Value": "MUNDIYUR "
                                },
                                {
                                    "Text": "MUNDA",
                                    "Value": "MUNDA"
                                },
                                {
                                    "Text": "MUNDALI",
                                    "Value": "MUNDALI"
                                },
                                {
                                    "Text": "MUNGER",
                                    "Value": "MUNGER"
                                },
                                {
                                    "Text": "MUNGELI",
                                    "Value": "MUNGELI"
                                },
                                {
                                    "Text": "MUNNUR SOMARAM ",
                                    "Value": "MUNNUR SOMARAM "
                                },
                                {
                                    "Text": "MUNPALLI ",
                                    "Value": "MUNPALLI "
                                },
                                {
                                    "Text": "MUNPALLE",
                                    "Value": "MUNPALLE"
                                },
                                {
                                    "Text": "MURARICHINTALA ",
                                    "Value": "MURARICHINTALA "
                                },
                                {
                                    "Text": "MURADABAD",
                                    "Value": "MURADABAD"
                                },
                                {
                                    "Text": "MURADNAGAR",
                                    "Value": "MURADNAGAR"
                                },
                                {
                                    "Text": "MURBAD",
                                    "Value": "MURBAD"
                                },
                                {
                                    "Text": "MURGUD",
                                    "Value": "MURGUD"
                                },
                                {
                                    "Text": "MURNAL ",
                                    "Value": "MURNAL "
                                },
                                {
                                    "Text": "MURSHIDABAD",
                                    "Value": "MURSHIDABAD"
                                },
                                {
                                    "Text": "MURTIJAPUR",
                                    "Value": "MURTIJAPUR"
                                },
                                {
                                    "Text": "MUSCAT",
                                    "Value": "MUSCAT"
                                },
                                {
                                    "Text": "MUSSOORIE",
                                    "Value": "MUSSOORIE"
                                },
                                {
                                    "Text": "MUSTAFABAD",
                                    "Value": "MUSTAFABAD"
                                },
                                {
                                    "Text": "MUVATTUPUZHA",
                                    "Value": "MUVATTUPUZHA"
                                },
                                {
                                    "Text": "MUZAFFARNAGAR",
                                    "Value": "MUZAFFARNAGAR"
                                },
                                {
                                    "Text": "MUZAFFARPUR",
                                    "Value": "MUZAFFARPUR"
                                },
                                {
                                    "Text": "MUZAFFARNAGAR",
                                    "Value": "MUZAFFARNAGAR"
                                },
                                {
                                    "Text": "MUZZAFAR NAGAR",
                                    "Value": "MUZZAFAR NAGAR"
                                },
                                {
                                    "Text": "MEWAT",
                                    "Value": "MEWAT"
                                },
                                {
                                    "Text": "MYSORE",
                                    "Value": "MYSORE"
                                },
                                {
                                    "Text": "N.PARAVUR",
                                    "Value": "N.PARAVUR"
                                },
                                {
                                    "Text": "NABARANGAPUR",
                                    "Value": "NABARANGAPUR"
                                },
                                {
                                    "Text": "NABADWIP",
                                    "Value": "NABADWIP"
                                },
                                {
                                    "Text": "NABHA",
                                    "Value": "NABHA"
                                },
                                {
                                    "Text": "NADAVARAMBA P.O",
                                    "Value": "NADAVARAMBA P.O"
                                },
                                {
                                    "Text": "NADALA",
                                    "Value": "NADALA"
                                },
                                {
                                    "Text": "NADAPURAM",
                                    "Value": "NADAPURAM"
                                },
                                {
                                    "Text": "NADAUN",
                                    "Value": "NADAUN"
                                },
                                {
                                    "Text": "NADEPALLE",
                                    "Value": "NADEPALLE"
                                },
                                {
                                    "Text": "NADIAD",
                                    "Value": "NADIAD"
                                },
                                {
                                    "Text": "NADIA",
                                    "Value": "NADIA"
                                },
                                {
                                    "Text": "NADIWADA ",
                                    "Value": "NADIWADA "
                                },
                                {
                                    "Text": "NAGAON",
                                    "Value": "NAGAON"
                                },
                                {
                                    "Text": "NAGAPATTINAM",
                                    "Value": "NAGAPATTINAM"
                                },
                                {
                                    "Text": "NAGAUR",
                                    "Value": "NAGAUR"
                                },
                                {
                                    "Text": "NAGARAM",
                                    "Value": "NAGARAM"
                                },
                                {
                                    "Text": "NAGDA",
                                    "Value": "NAGDA"
                                },
                                {
                                    "Text": "NAGDHARA",
                                    "Value": "NAGDHARA"
                                },
                                {
                                    "Text": "NAGERCOIL",
                                    "Value": "NAGERCOIL"
                                },
                                {
                                    "Text": "NAGINA",
                                    "Value": "NAGINA"
                                },
                                {
                                    "Text": "NANGAL DEWAT",
                                    "Value": "NANGAL DEWAT"
                                },
                                {
                                    "Text": "NANGAL THAKRAN",
                                    "Value": "NANGAL THAKRAN"
                                },
                                {
                                    "Text": "NAGPUR",
                                    "Value": "NAGPUR"
                                },
                                {
                                    "Text": "NAGROTA BAGWAN",
                                    "Value": "NAGROTA BAGWAN"
                                },
                                {
                                    "Text": "NAHARLAGUN",
                                    "Value": "NAHARLAGUN"
                                },
                                {
                                    "Text": "NAHAN",
                                    "Value": "NAHAN"
                                },
                                {
                                    "Text": "NAHARPUR KASAN",
                                    "Value": "NAHARPUR KASAN"
                                },
                                {
                                    "Text": "NAHARPUR",
                                    "Value": "NAHARPUR"
                                },
                                {
                                    "Text": "NAHUR",
                                    "Value": "NAHUR"
                                },
                                {
                                    "Text": "NAIGAVHAN ",
                                    "Value": "NAIGAVHAN "
                                },
                                {
                                    "Text": "NAIHATI",
                                    "Value": "NAIHATI"
                                },
                                {
                                    "Text": "NAINITAL",
                                    "Value": "NAINITAL"
                                },
                                {
                                    "Text": "NAIRA ",
                                    "Value": "NAIRA "
                                },
                                {
                                    "Text": "NAISI",
                                    "Value": "NAISI"
                                },
                                {
                                    "Text": "NAJIBABAD",
                                    "Value": "NAJIBABAD"
                                },
                                {
                                    "Text": "NAKATRANA",
                                    "Value": "NAKATRANA"
                                },
                                {
                                    "Text": "NAKODAR",
                                    "Value": "NAKODAR"
                                },
                                {
                                    "Text": "NAKREKAL",
                                    "Value": "NAKREKAL"
                                },
                                {
                                    "Text": "NALAGARH",
                                    "Value": "NALAGARH"
                                },
                                {
                                    "Text": "NALANDA",
                                    "Value": "NALANDA"
                                },
                                {
                                    "Text": "NALBARI",
                                    "Value": "NALBARI"
                                },
                                {
                                    "Text": "NALGONDA",
                                    "Value": "NALGONDA"
                                },
                                {
                                    "Text": "NALLASOPARA",
                                    "Value": "NALLASOPARA"
                                },
                                {
                                    "Text": "NALLASOPARA- WEST",
                                    "Value": "NALLASOPARA- WEST"
                                },
                                {
                                    "Text": "NALLAPUREDDYPALLE ",
                                    "Value": "NALLAPUREDDYPALLE "
                                },
                                {
                                    "Text": "NALNI ",
                                    "Value": "NALNI "
                                },
                                {
                                    "Text": "NAMAKKAL",
                                    "Value": "NAMAKKAL"
                                },
                                {
                                    "Text": "NAMCHI",
                                    "Value": "NAMCHI"
                                },
                                {
                                    "Text": "NAMCHI",
                                    "Value": "NAMCHI"
                                },
                                {
                                    "Text": "NAMPUR",
                                    "Value": "NAMPUR"
                                },
                                {
                                    "Text": "NAMSAI",
                                    "Value": "NAMSAI"
                                },
                                {
                                    "Text": "NANAKSAR KALERAN",
                                    "Value": "NANAKSAR KALERAN"
                                },
                                {
                                    "Text": "NANDYAL",
                                    "Value": "NANDYAL"
                                },
                                {
                                    "Text": "NANDED",
                                    "Value": "NANDED"
                                },
                                {
                                    "Text": "NANDURBAR",
                                    "Value": "NANDURBAR"
                                },
                                {
                                    "Text": "NANDIPAHAD ",
                                    "Value": "NANDIPAHAD "
                                },
                                {
                                    "Text": "NANDGAON ",
                                    "Value": "NANDGAON "
                                },
                                {
                                    "Text": "NANDGAON",
                                    "Value": "NANDGAON"
                                },
                                {
                                    "Text": "NANDURA",
                                    "Value": "NANDURA"
                                },
                                {
                                    "Text": "NANGAL",
                                    "Value": "NANGAL"
                                },
                                {
                                    "Text": "NANGAL KALAN",
                                    "Value": "NANGAL KALAN"
                                },
                                {
                                    "Text": "NANGAL KHERI",
                                    "Value": "NANGAL KHERI"
                                },
                                {
                                    "Text": "NANJANGUD",
                                    "Value": "NANJANGUD"
                                },
                                {
                                    "Text": "NANPARA",
                                    "Value": "NANPARA"
                                },
                                {
                                    "Text": "NAPARA",
                                    "Value": "NAPARA"
                                },
                                {
                                    "Text": "NARAYANGAON",
                                    "Value": "NARAYANGAON"
                                },
                                {
                                    "Text": "NARASARAOPET",
                                    "Value": "NARASARAOPET"
                                },
                                {
                                    "Text": "NARAINGARH",
                                    "Value": "NARAINGARH"
                                },
                                {
                                    "Text": "NARAYANPUR",
                                    "Value": "NARAYANPUR"
                                },
                                {
                                    "Text": "NARAYANPUR",
                                    "Value": "NARAYANPUR"
                                },
                                {
                                    "Text": "NARAINA",
                                    "Value": "NARAINA"
                                },
                                {
                                    "Text": "NARASAPURAPUPETA ",
                                    "Value": "NARASAPURAPUPETA "
                                },
                                {
                                    "Text": "NARASAMPET",
                                    "Value": "NARASAMPET"
                                },
                                {
                                    "Text": "NARASAPUR",
                                    "Value": "NARASAPUR"
                                },
                                {
                                    "Text": "NARASARAOPETA",
                                    "Value": "NARASARAOPETA"
                                },
                                {
                                    "Text": "NARAYANPET",
                                    "Value": "NARAYANPET"
                                },
                                {
                                    "Text": "NAREDA",
                                    "Value": "NAREDA"
                                },
                                {
                                    "Text": "NARMADA",
                                    "Value": "NARMADA"
                                },
                                {
                                    "Text": "NARMETTA ",
                                    "Value": "NARMETTA "
                                },
                                {
                                    "Text": "NARNAUD",
                                    "Value": "NARNAUD"
                                },
                                {
                                    "Text": "NARNAUL",
                                    "Value": "NARNAUL"
                                },
                                {
                                    "Text": "NARNAUND",
                                    "Value": "NARNAUND"
                                },
                                {
                                    "Text": "NARSINGHPUR",
                                    "Value": "NARSINGHPUR"
                                },
                                {
                                    "Text": "NARSAMPET",
                                    "Value": "NARSAMPET"
                                },
                                {
                                    "Text": "NARSAPUR",
                                    "Value": "NARSAPUR"
                                },
                                {
                                    "Text": "NARSINGHPUR",
                                    "Value": "NARSINGHPUR"
                                },
                                {
                                    "Text": "NARSAPURA",
                                    "Value": "NARSAPURA"
                                },
                                {
                                    "Text": "NARSIPATNAM",
                                    "Value": "NARSIPATNAM"
                                },
                                {
                                    "Text": "NARUGRAM",
                                    "Value": "NARUGRAM"
                                },
                                {
                                    "Text": "NARWANA",
                                    "Value": "NARWANA"
                                },
                                {
                                    "Text": "NASHIK",
                                    "Value": "NASHIK"
                                },
                                {
                                    "Text": "NASIK",
                                    "Value": "NASIK"
                                },
                                {
                                    "Text": "NASIRABAD",
                                    "Value": "NASIRABAD"
                                },
                                {
                                    "Text": "NASVADI",
                                    "Value": "NASVADI"
                                },
                                {
                                    "Text": "NATGRAM",
                                    "Value": "NATGRAM"
                                },
                                {
                                    "Text": "NATHDWARA",
                                    "Value": "NATHDWARA"
                                },
                                {
                                    "Text": "NATHU CHAHAL ",
                                    "Value": "NATHU CHAHAL "
                                },
                                {
                                    "Text": "NATHANA",
                                    "Value": "NATHANA"
                                },
                                {
                                    "Text": "NAUGACHHIA",
                                    "Value": "NAUGACHHIA"
                                },
                                {
                                    "Text": "NAUGARH",
                                    "Value": "NAUGARH"
                                },
                                {
                                    "Text": "NAURANGABAD ",
                                    "Value": "NAURANGABAD "
                                },
                                {
                                    "Text": "NAURA",
                                    "Value": "NAURA"
                                },
                                {
                                    "Text": "NAUSHERA MAJA SINGH",
                                    "Value": "NAUSHERA MAJA SINGH"
                                },
                                {
                                    "Text": "NAUSHERA PANNUAN",
                                    "Value": "NAUSHERA PANNUAN"
                                },
                                {
                                    "Text": "NAUSHERA",
                                    "Value": "NAUSHERA"
                                },
                                {
                                    "Text": "NAUTANWA",
                                    "Value": "NAUTANWA"
                                },
                                {
                                    "Text": "NAVELIM",
                                    "Value": "NAVELIM"
                                },
                                {
                                    "Text": "NAVI MUMBAI",
                                    "Value": "NAVI MUMBAI"
                                },
                                {
                                    "Text": "NAVSARI",
                                    "Value": "NAVSARI"
                                },
                                {
                                    "Text": "NAWADA",
                                    "Value": "NAWADA"
                                },
                                {
                                    "Text": "NAWANSHAHAR",
                                    "Value": "NAWANSHAHAR"
                                },
                                {
                                    "Text": "NAWANSHAHR",
                                    "Value": "NAWANSHAHR"
                                },
                                {
                                    "Text": "NAWABGANJ",
                                    "Value": "NAWABGANJ"
                                },
                                {
                                    "Text": "NAWAGARH",
                                    "Value": "NAWAGARH"
                                },
                                {
                                    "Text": "NAWALGARH",
                                    "Value": "NAWALGARH"
                                },
                                {
                                    "Text": "NAWAN PIND",
                                    "Value": "NAWAN PIND"
                                },
                                {
                                    "Text": "NAWANAGAR",
                                    "Value": "NAWANAGAR"
                                },
                                {
                                    "Text": "NAWANSHAHAR",
                                    "Value": "NAWANSHAHAR"
                                },
                                {
                                    "Text": "NAWAPUR",
                                    "Value": "NAWAPUR"
                                },
                                {
                                    "Text": "NAYA NANGAL",
                                    "Value": "NAYA NANGAL"
                                },
                                {
                                    "Text": "NAYAGARH",
                                    "Value": "NAYAGARH"
                                },
                                {
                                    "Text": "NAZIRA",
                                    "Value": "NAZIRA"
                                },
                                {
                                    "Text": "NEW DELHI MUNICIPAL COUNCIL",
                                    "Value": "NEW DELHI MUNICIPAL COUNCIL"
                                },
                                {
                                    "Text": "NEDUMANGAD",
                                    "Value": "NEDUMANGAD"
                                },
                                {
                                    "Text": "NEELAPALLE",
                                    "Value": "NEELAPALLE"
                                },
                                {
                                    "Text": "NEEMUCH",
                                    "Value": "NEEMUCH"
                                },
                                {
                                    "Text": "NEEM KA THANA",
                                    "Value": "NEEM KA THANA"
                                },
                                {
                                    "Text": "NEEM KA THANA",
                                    "Value": "NEEM KA THANA"
                                },
                                {
                                    "Text": "NEEMRANA",
                                    "Value": "NEEMRANA"
                                },
                                {
                                    "Text": "NELLORE",
                                    "Value": "NELLORE"
                                },
                                {
                                    "Text": "NELLUTLA ",
                                    "Value": "NELLUTLA "
                                },
                                {
                                    "Text": "NERALAKUPPE ",
                                    "Value": "NERALAKUPPE "
                                },
                                {
                                    "Text": "NERAL",
                                    "Value": "NERAL"
                                },
                                {
                                    "Text": "NERUL",
                                    "Value": "NERUL"
                                },
                                {
                                    "Text": "NER ",
                                    "Value": "NER "
                                },
                                {
                                    "Text": "NER",
                                    "Value": "NER"
                                },
                                {
                                    "Text": "NESARGI",
                                    "Value": "NESARGI"
                                },
                                {
                                    "Text": "NETRAMALI",
                                    "Value": "NETRAMALI"
                                },
                                {
                                    "Text": "NETTOOR",
                                    "Value": "NETTOOR"
                                },
                                {
                                    "Text": "NEVALGANJ ",
                                    "Value": "NEVALGANJ "
                                },
                                {
                                    "Text": "NEW DELHI",
                                    "Value": "NEW DELHI"
                                },
                                {
                                    "Text": "NEWAI",
                                    "Value": "NEWAI"
                                },
                                {
                                    "Text": "NEW ABADI ",
                                    "Value": "NEW ABADI "
                                },
                                {
                                    "Text": "NEW DUDHAI",
                                    "Value": "NEW DUDHAI"
                                },
                                {
                                    "Text": "NEYVELI",
                                    "Value": "NEYVELI"
                                },
                                {
                                    "Text": "NEYYATTINKARA",
                                    "Value": "NEYYATTINKARA"
                                },
                                {
                                    "Text": "NEYYATTINKARA",
                                    "Value": "NEYYATTINKARA"
                                },
                                {
                                    "Text": "NANGLOI JAT",
                                    "Value": "NANGLOI JAT"
                                },
                                {
                                    "Text": "NHAVA SHEVA",
                                    "Value": "NHAVA SHEVA"
                                },
                                {
                                    "Text": "NOHAR",
                                    "Value": "NOHAR"
                                },
                                {
                                    "Text": "NICOBAR",
                                    "Value": "NICOBAR"
                                },
                                {
                                    "Text": "NIDADAVOLE",
                                    "Value": "NIDADAVOLE"
                                },
                                {
                                    "Text": "NIDHIPUR",
                                    "Value": "NIDHIPUR"
                                },
                                {
                                    "Text": "NIGDI",
                                    "Value": "NIGDI"
                                },
                                {
                                    "Text": "NIGHOJE",
                                    "Value": "NIGHOJE"
                                },
                                {
                                    "Text": "NIHAL SINGH WALA",
                                    "Value": "NIHAL SINGH WALA"
                                },
                                {
                                    "Text": "NIHALSINGH WALA",
                                    "Value": "NIHALSINGH WALA"
                                },
                                {
                                    "Text": "NIJHOTA ",
                                    "Value": "NIJHOTA "
                                },
                                {
                                    "Text": "NILAMBUR",
                                    "Value": "NILAMBUR"
                                },
                                {
                                    "Text": "NIVALI",
                                    "Value": "NIVALI"
                                },
                                {
                                    "Text": "NILGIRIS",
                                    "Value": "NILGIRIS"
                                },
                                {
                                    "Text": "NILOKHERI",
                                    "Value": "NILOKHERI"
                                },
                                {
                                    "Text": "NIMAPARA",
                                    "Value": "NIMAPARA"
                                },
                                {
                                    "Text": "NIMBAHERA",
                                    "Value": "NIMBAHERA"
                                },
                                {
                                    "Text": "NIMETHA",
                                    "Value": "NIMETHA"
                                },
                                {
                                    "Text": "NINDUGONDA ",
                                    "Value": "NINDUGONDA "
                                },
                                {
                                    "Text": "NIPHAD",
                                    "Value": "NIPHAD"
                                },
                                {
                                    "Text": "NIPPANI",
                                    "Value": "NIPPANI"
                                },
                                {
                                    "Text": "NIRA",
                                    "Value": "NIRA"
                                },
                                {
                                    "Text": "NIRMAL",
                                    "Value": "NIRMAL"
                                },
                                {
                                    "Text": "NIRMALI",
                                    "Value": "NIRMALI"
                                },
                                {
                                    "Text": "NISARAYA",
                                    "Value": "NISARAYA"
                                },
                                {
                                    "Text": "NISSING",
                                    "Value": "NISSING"
                                },
                                {
                                    "Text": "NIVALI",
                                    "Value": "NIVALI"
                                },
                                {
                                    "Text": "NIWAI",
                                    "Value": "NIWAI"
                                },
                                {
                                    "Text": "NIWAROO",
                                    "Value": "NIWAROO"
                                },
                                {
                                    "Text": "NIZAMABAD",
                                    "Value": "NIZAMABAD"
                                },
                                {
                                    "Text": "NAJAFGARH",
                                    "Value": "NAJAFGARH"
                                },
                                {
                                    "Text": "NILANGA",
                                    "Value": "NILANGA"
                                },
                                {
                                    "Text": "NOCHIMEDU ",
                                    "Value": "NOCHIMEDU "
                                },
                                {
                                    "Text": "NOIDA",
                                    "Value": "NOIDA"
                                },
                                {
                                    "Text": "NOIDA",
                                    "Value": "NOIDA"
                                },
                                {
                                    "Text": "NOKHA",
                                    "Value": "NOKHA"
                                },
                                {
                                    "Text": "NONGPOH",
                                    "Value": "NONGPOH"
                                },
                                {
                                    "Text": "NONGSTOIN",
                                    "Value": "NONGSTOIN"
                                },
                                {
                                    "Text": "NOONMATI",
                                    "Value": "NOONMATI"
                                },
                                {
                                    "Text": "NOORPUR",
                                    "Value": "NOORPUR"
                                },
                                {
                                    "Text": "NORTH LAKHIMPUR",
                                    "Value": "NORTH LAKHIMPUR"
                                },
                                {
                                    "Text": "NORTH EAST DELHI",
                                    "Value": "NORTH EAST DELHI"
                                },
                                {
                                    "Text": "NORTH 24 PARGANAS",
                                    "Value": "NORTH 24 PARGANAS"
                                },
                                {
                                    "Text": "NORTH AND MIDDLE ANDAMAN",
                                    "Value": "NORTH AND MIDDLE ANDAMAN"
                                },
                                {
                                    "Text": "NORTH CACHAR HILLS",
                                    "Value": "NORTH CACHAR HILLS"
                                },
                                {
                                    "Text": "NORTH DELHI",
                                    "Value": "NORTH DELHI"
                                },
                                {
                                    "Text": "NORTH DINAJPUR",
                                    "Value": "NORTH DINAJPUR"
                                },
                                {
                                    "Text": "NORTH GOA",
                                    "Value": "NORTH GOA"
                                },
                                {
                                    "Text": "NORTH SIKKIM",
                                    "Value": "NORTH SIKKIM"
                                },
                                {
                                    "Text": "NORTH TRIPURA",
                                    "Value": "NORTH TRIPURA"
                                },
                                {
                                    "Text": "NORTH WEST DELHI",
                                    "Value": "NORTH WEST DELHI"
                                },
                                {
                                    "Text": "NORTH DUMDUM",
                                    "Value": "NORTH DUMDUM"
                                },
                                {
                                    "Text": "NORTH GUWAHATI",
                                    "Value": "NORTH GUWAHATI"
                                },
                                {
                                    "Text": "NOWGONG",
                                    "Value": "NOWGONG"
                                },
                                {
                                    "Text": "NAPARA",
                                    "Value": "NAPARA"
                                },
                                {
                                    "Text": "NSP CAMP MIRYALAGUDA ",
                                    "Value": "NSP CAMP MIRYALAGUDA "
                                },
                                {
                                    "Text": "NATEPUTE",
                                    "Value": "NATEPUTE"
                                },
                                {
                                    "Text": "NUAPADA",
                                    "Value": "NUAPADA"
                                },
                                {
                                    "Text": "NUH",
                                    "Value": "NUH"
                                },
                                {
                                    "Text": "NUMALIGARH",
                                    "Value": "NUMALIGARH"
                                },
                                {
                                    "Text": "NUNA MAJRA",
                                    "Value": "NUNA MAJRA"
                                },
                                {
                                    "Text": "NURMAHAL",
                                    "Value": "NURMAHAL"
                                },
                                {
                                    "Text": "NURPUR BEDI",
                                    "Value": "NURPUR BEDI"
                                },
                                {
                                    "Text": "NUVEM",
                                    "Value": "NUVEM"
                                },
                                {
                                    "Text": "NUZVID",
                                    "Value": "NUZVID"
                                },
                                {
                                    "Text": "NIWARI",
                                    "Value": "NIWARI"
                                },
                                {
                                    "Text": "NAZIRA",
                                    "Value": "NAZIRA"
                                },
                                {
                                    "Text": "OBRA",
                                    "Value": "OBRA"
                                },
                                {
                                    "Text": "ODDANCHATRAM",
                                    "Value": "ODDANCHATRAM"
                                },
                                {
                                    "Text": "ODWARA",
                                    "Value": "ODWARA"
                                },
                                {
                                    "Text": "OLD GOA",
                                    "Value": "OLD GOA"
                                },
                                {
                                    "Text": "OLD GOA",
                                    "Value": "OLD GOA"
                                },
                                {
                                    "Text": "ONGOLE",
                                    "Value": "ONGOLE"
                                },
                                {
                                    "Text": "OOTY",
                                    "Value": "OOTY"
                                },
                                {
                                    "Text": "OPIVADA VENKAMPETA ",
                                    "Value": "OPIVADA VENKAMPETA "
                                },
                                {
                                    "Text": "OPP R K MARBLE HAZARIBAGH",
                                    "Value": "OPP R K MARBLE HAZARIBAGH"
                                },
                                {
                                    "Text": "ORAGADAM",
                                    "Value": "ORAGADAM"
                                },
                                {
                                    "Text": "ORAI",
                                    "Value": "ORAI"
                                },
                                {
                                    "Text": "ORAVACKAL",
                                    "Value": "ORAVACKAL"
                                },
                                {
                                    "Text": "OSMANABAD",
                                    "Value": "OSMANABAD"
                                },
                                {
                                    "Text": "OTHIAN",
                                    "Value": "OTHIAN"
                                },
                                {
                                    "Text": "OTTAPALAM",
                                    "Value": "OTTAPALAM"
                                },
                                {
                                    "Text": "OZAR",
                                    "Value": "OZAR"
                                },
                                {
                                    "Text": "PACHORA",
                                    "Value": "PACHORA"
                                },
                                {
                                    "Text": "PACHRA ",
                                    "Value": "PACHRA "
                                },
                                {
                                    "Text": "PACHAAT",
                                    "Value": "PACHAAT"
                                },
                                {
                                    "Text": "PACHCHUNUR",
                                    "Value": "PACHCHUNUR"
                                },
                                {
                                    "Text": "PADAMPUR",
                                    "Value": "PADAMPUR"
                                },
                                {
                                    "Text": "PADDI JAGIR",
                                    "Value": "PADDI JAGIR"
                                },
                                {
                                    "Text": "PADRAUNA",
                                    "Value": "PADRAUNA"
                                },
                                {
                                    "Text": "PADRA",
                                    "Value": "PADRA"
                                },
                                {
                                    "Text": "PAHARPUR ",
                                    "Value": "PAHARPUR "
                                },
                                {
                                    "Text": "PAITHAN",
                                    "Value": "PAITHAN"
                                },
                                {
                                    "Text": "PAI",
                                    "Value": "PAI"
                                },
                                {
                                    "Text": "PAKALAPADU ",
                                    "Value": "PAKALAPADU "
                                },
                                {
                                    "Text": "PAKHI KALAN ",
                                    "Value": "PAKHI KALAN "
                                },
                                {
                                    "Text": "PAKHARPUR",
                                    "Value": "PAKHARPUR"
                                },
                                {
                                    "Text": "PAKRI BARAMAD DEOBARI",
                                    "Value": "PAKRI BARAMAD DEOBARI"
                                },
                                {
                                    "Text": "PAKUR",
                                    "Value": "PAKUR"
                                },
                                {
                                    "Text": "PALAKOL",
                                    "Value": "PALAKOL"
                                },
                                {
                                    "Text": "PALA",
                                    "Value": "PALA"
                                },
                                {
                                    "Text": "PALANPUR",
                                    "Value": "PALANPUR"
                                },
                                {
                                    "Text": "PALAMPUR",
                                    "Value": "PALAMPUR"
                                },
                                {
                                    "Text": "PALARIVATTOM",
                                    "Value": "PALARIVATTOM"
                                },
                                {
                                    "Text": "PALAKKAD",
                                    "Value": "PALAKKAD"
                                },
                                {
                                    "Text": "PALAMAU",
                                    "Value": "PALAMAU"
                                },
                                {
                                    "Text": "PALASAUR ",
                                    "Value": "PALASAUR "
                                },
                                {
                                    "Text": "PALACOLE",
                                    "Value": "PALACOLE"
                                },
                                {
                                    "Text": "PALAMNER",
                                    "Value": "PALAMNER"
                                },
                                {
                                    "Text": "PALAVAKKAM",
                                    "Value": "PALAVAKKAM"
                                },
                                {
                                    "Text": "PALDA",
                                    "Value": "PALDA"
                                },
                                {
                                    "Text": "PALDI",
                                    "Value": "PALDI"
                                },
                                {
                                    "Text": "PALEJ",
                                    "Value": "PALEJ"
                                },
                                {
                                    "Text": "PALITANA",
                                    "Value": "PALITANA"
                                },
                                {
                                    "Text": "PALI",
                                    "Value": "PALI"
                                },
                                {
                                    "Text": "PALI ",
                                    "Value": "PALI "
                                },
                                {
                                    "Text": "PALIA KALAN",
                                    "Value": "PALIA KALAN"
                                },
                                {
                                    "Text": "PALASA KASIBUGGA",
                                    "Value": "PALASA KASIBUGGA"
                                },
                                {
                                    "Text": "PALKHANDA",
                                    "Value": "PALKHANDA"
                                },
                                {
                                    "Text": "PALLADAM",
                                    "Value": "PALLADAM"
                                },
                                {
                                    "Text": "PALLEPAHAD ",
                                    "Value": "PALLEPAHAD "
                                },
                                {
                                    "Text": "PALLAVARAM",
                                    "Value": "PALLAVARAM"
                                },
                                {
                                    "Text": "PALLIKANAI",
                                    "Value": "PALLIKANAI"
                                },
                                {
                                    "Text": "PALLIPALAYAM",
                                    "Value": "PALLIPALAYAM"
                                },
                                {
                                    "Text": "PALLIPPURAM",
                                    "Value": "PALLIPPURAM"
                                },
                                {
                                    "Text": "PALLURUTHY",
                                    "Value": "PALLURUTHY"
                                },
                                {
                                    "Text": "PALPUR",
                                    "Value": "PALPUR"
                                },
                                {
                                    "Text": "PALUS",
                                    "Value": "PALUS"
                                },
                                {
                                    "Text": "PALVANCHA ",
                                    "Value": "PALVANCHA "
                                },
                                {
                                    "Text": "PALWAL",
                                    "Value": "PALWAL"
                                },
                                {
                                    "Text": "PALWANCHA",
                                    "Value": "PALWANCHA"
                                },
                                {
                                    "Text": "PAMAL",
                                    "Value": "PAMAL"
                                },
                                {
                                    "Text": "PAMGARH",
                                    "Value": "PAMGARH"
                                },
                                {
                                    "Text": "PAMOL",
                                    "Value": "PAMOL"
                                },
                                {
                                    "Text": "PAMPORE",
                                    "Value": "PAMPORE"
                                },
                                {
                                    "Text": "PANAJI",
                                    "Value": "PANAJI"
                                },
                                {
                                    "Text": "PANAGARH",
                                    "Value": "PANAGARH"
                                },
                                {
                                    "Text": "PANCHKULA",
                                    "Value": "PANCHKULA"
                                },
                                {
                                    "Text": "PANCH MAHALS",
                                    "Value": "PANCH MAHALS"
                                },
                                {
                                    "Text": "PANCHKULA",
                                    "Value": "PANCHKULA"
                                },
                                {
                                    "Text": "PANDHARKAWADA",
                                    "Value": "PANDHARKAWADA"
                                },
                                {
                                    "Text": "PANDHURNA",
                                    "Value": "PANDHURNA"
                                },
                                {
                                    "Text": "PANDORI GOLA ",
                                    "Value": "PANDORI GOLA "
                                },
                                {
                                    "Text": "PANDORI RANSINGH ",
                                    "Value": "PANDORI RANSINGH "
                                },
                                {
                                    "Text": "PANDORI TAKHTMAL ",
                                    "Value": "PANDORI TAKHTMAL "
                                },
                                {
                                    "Text": "PANDALAM",
                                    "Value": "PANDALAM"
                                },
                                {
                                    "Text": "PANDHARKAODA",
                                    "Value": "PANDHARKAODA"
                                },
                                {
                                    "Text": "PANDHARPUR",
                                    "Value": "PANDHARPUR"
                                },
                                {
                                    "Text": "PANDUA",
                                    "Value": "PANDUA"
                                },
                                {
                                    "Text": "PANDUKA",
                                    "Value": "PANDUKA"
                                },
                                {
                                    "Text": "PANIPAT",
                                    "Value": "PANIPAT"
                                },
                                {
                                    "Text": "PANJIM",
                                    "Value": "PANJIM"
                                },
                                {
                                    "Text": "PANJABARI",
                                    "Value": "PANJABARI"
                                },
                                {
                                    "Text": "PANJE KE",
                                    "Value": "PANJE KE"
                                },
                                {
                                    "Text": "PANJGRAIN KALAN",
                                    "Value": "PANJGRAIN KALAN"
                                },
                                {
                                    "Text": "PANNA",
                                    "Value": "PANNA"
                                },
                                {
                                    "Text": "PANVEL",
                                    "Value": "PANVEL"
                                },
                                {
                                    "Text": "PAONTA SAHIB",
                                    "Value": "PAONTA SAHIB"
                                },
                                {
                                    "Text": "PAPUM PARE",
                                    "Value": "PAPUM PARE"
                                },
                                {
                                    "Text": "PARADIP PORT",
                                    "Value": "PARADIP PORT"
                                },
                                {
                                    "Text": "PARASIYA ",
                                    "Value": "PARASIYA "
                                },
                                {
                                    "Text": "PARAM ",
                                    "Value": "PARAM "
                                },
                                {
                                    "Text": "PARA BAZAR",
                                    "Value": "PARA BAZAR"
                                },
                                {
                                    "Text": "PARA SARAY",
                                    "Value": "PARA SARAY"
                                },
                                {
                                    "Text": "PARABHANI",
                                    "Value": "PARABHANI"
                                },
                                {
                                    "Text": "PARADEEP",
                                    "Value": "PARADEEP"
                                },
                                {
                                    "Text": "PARAVUR",
                                    "Value": "PARAVUR"
                                },
                                {
                                    "Text": "PARBHANI",
                                    "Value": "PARBHANI"
                                },
                                {
                                    "Text": "PARDI",
                                    "Value": "PARDI"
                                },
                                {
                                    "Text": "PARGANAS",
                                    "Value": "PARGANAS"
                                },
                                {
                                    "Text": "PARKAL",
                                    "Value": "PARKAL"
                                },
                                {
                                    "Text": "PARLAKHEMUNDI",
                                    "Value": "PARLAKHEMUNDI"
                                },
                                {
                                    "Text": "PARLI",
                                    "Value": "PARLI"
                                },
                                {
                                    "Text": "PARMANAND",
                                    "Value": "PARMANAND"
                                },
                                {
                                    "Text": "PARNER",
                                    "Value": "PARNER"
                                },
                                {
                                    "Text": "PARSHUPURA ",
                                    "Value": "PARSHUPURA "
                                },
                                {
                                    "Text": "PARSOTTAMPUR",
                                    "Value": "PARSOTTAMPUR"
                                },
                                {
                                    "Text": "PARTHALA KHANJARPUR",
                                    "Value": "PARTHALA KHANJARPUR"
                                },
                                {
                                    "Text": "PARVATHIPURAM",
                                    "Value": "PARVATHIPURAM"
                                },
                                {
                                    "Text": "PARWANOO",
                                    "Value": "PARWANOO"
                                },
                                {
                                    "Text": "PASCHIMMIDNAPUR",
                                    "Value": "PASCHIMMIDNAPUR"
                                },
                                {
                                    "Text": "PASIGHAT",
                                    "Value": "PASIGHAT"
                                },
                                {
                                    "Text": "PASCHIMI SINGHBHUM",
                                    "Value": "PASCHIMI SINGHBHUM"
                                },
                                {
                                    "Text": "PATANCHERU",
                                    "Value": "PATANCHERU"
                                },
                                {
                                    "Text": "PATAN",
                                    "Value": "PATAN"
                                },
                                {
                                    "Text": "PATAUDI",
                                    "Value": "PATAUDI"
                                },
                                {
                                    "Text": "PATALGANGA",
                                    "Value": "PATALGANGA"
                                },
                                {
                                    "Text": "PATHANKOT",
                                    "Value": "PATHANKOT"
                                },
                                {
                                    "Text": "PATHANKOT",
                                    "Value": "PATHANKOT"
                                },
                                {
                                    "Text": "PATHANAMTHITTA",
                                    "Value": "PATHANAMTHITTA"
                                },
                                {
                                    "Text": "PATHRUD ",
                                    "Value": "PATHRUD "
                                },
                                {
                                    "Text": "PATHALGAON",
                                    "Value": "PATHALGAON"
                                },
                                {
                                    "Text": "PATHSALA",
                                    "Value": "PATHSALA"
                                },
                                {
                                    "Text": "PATHWAL",
                                    "Value": "PATHWAL"
                                },
                                {
                                    "Text": "PATIALA",
                                    "Value": "PATIALA"
                                },
                                {
                                    "Text": "PATIYALI",
                                    "Value": "PATIYALI"
                                },
                                {
                                    "Text": "PATNA",
                                    "Value": "PATNA"
                                },
                                {
                                    "Text": "PATRAN",
                                    "Value": "PATRAN"
                                },
                                {
                                    "Text": "PATRATU",
                                    "Value": "PATRATU"
                                },
                                {
                                    "Text": "PATTI PRATAPGARH",
                                    "Value": "PATTI PRATAPGARH"
                                },
                                {
                                    "Text": "PATTAMUNDAI",
                                    "Value": "PATTAMUNDAI"
                                },
                                {
                                    "Text": "PATTI",
                                    "Value": "PATTI"
                                },
                                {
                                    "Text": "PATTUKOTTAI",
                                    "Value": "PATTUKOTTAI"
                                },
                                {
                                    "Text": "PATTENAPALEM ",
                                    "Value": "PATTENAPALEM "
                                },
                                {
                                    "Text": "PATTI BASANTPUR ",
                                    "Value": "PATTI BASANTPUR "
                                },
                                {
                                    "Text": "PATTAMBI",
                                    "Value": "PATTAMBI"
                                },
                                {
                                    "Text": "PATTAN",
                                    "Value": "PATTAN"
                                },
                                {
                                    "Text": "PATTI,PRATAPGARH",
                                    "Value": "PATTI,PRATAPGARH"
                                },
                                {
                                    "Text": "PATWDH",
                                    "Value": "PATWDH"
                                },
                                {
                                    "Text": "PAURI GARHWAL",
                                    "Value": "PAURI GARHWAL"
                                },
                                {
                                    "Text": "PAYAL",
                                    "Value": "PAYAL"
                                },
                                {
                                    "Text": "PAYYANUR",
                                    "Value": "PAYYANUR"
                                },
                                {
                                    "Text": "PADAGHA",
                                    "Value": "PADAGHA"
                                },
                                {
                                    "Text": "PEDAMANDDADI ",
                                    "Value": "PEDAMANDDADI "
                                },
                                {
                                    "Text": "PEDDAPURAM",
                                    "Value": "PEDDAPURAM"
                                },
                                {
                                    "Text": "PEDDAPAHAD ",
                                    "Value": "PEDDAPAHAD "
                                },
                                {
                                    "Text": "PEDDAJUTUR ",
                                    "Value": "PEDDAJUTUR "
                                },
                                {
                                    "Text": "PEDDARANGAPURAM ",
                                    "Value": "PEDDARANGAPURAM "
                                },
                                {
                                    "Text": "PULIVENDLA BUS-STAND ",
                                    "Value": "PULIVENDLA BUS-STAND "
                                },
                                {
                                    "Text": "PEDDA BODDEPALLI ",
                                    "Value": "PEDDA BODDEPALLI "
                                },
                                {
                                    "Text": "PEDDAPALLE",
                                    "Value": "PEDDAPALLE"
                                },
                                {
                                    "Text": "PEDDAPUR",
                                    "Value": "PEDDAPUR"
                                },
                                {
                                    "Text": "PEEDAMPALLI",
                                    "Value": "PEEDAMPALLI"
                                },
                                {
                                    "Text": "PEGADAPALLI",
                                    "Value": "PEGADAPALLI"
                                },
                                {
                                    "Text": "PEHOWA",
                                    "Value": "PEHOWA"
                                },
                                {
                                    "Text": "PENDRA",
                                    "Value": "PENDRA"
                                },
                                {
                                    "Text": "PENUGONDA ",
                                    "Value": "PENUGONDA "
                                },
                                {
                                    "Text": "PEN",
                                    "Value": "PEN"
                                },
                                {
                                    "Text": "PERAMBALUR",
                                    "Value": "PERAMBALUR"
                                },
                                {
                                    "Text": "PERAMPETA ",
                                    "Value": "PERAMPETA "
                                },
                                {
                                    "Text": "PEREN",
                                    "Value": "PEREN"
                                },
                                {
                                    "Text": "PERUNGUDI",
                                    "Value": "PERUNGUDI"
                                },
                                {
                                    "Text": "PERINTHALMANNA",
                                    "Value": "PERINTHALMANNA"
                                },
                                {
                                    "Text": "PERINGANAM",
                                    "Value": "PERINGANAM"
                                },
                                {
                                    "Text": "PERIYAKULAM",
                                    "Value": "PERIYAKULAM"
                                },
                                {
                                    "Text": "PERIYANAIKENPALAYAM",
                                    "Value": "PERIYANAIKENPALAYAM"
                                },
                                {
                                    "Text": "PERKIT ",
                                    "Value": "PERKIT "
                                },
                                {
                                    "Text": "PERNEM",
                                    "Value": "PERNEM"
                                },
                                {
                                    "Text": "PERUMBAVOOR",
                                    "Value": "PERUMBAVOOR"
                                },
                                {
                                    "Text": "PERUNDURAI",
                                    "Value": "PERUNDURAI"
                                },
                                {
                                    "Text": "PERUNGALATHUR",
                                    "Value": "PERUNGALATHUR"
                                },
                                {
                                    "Text": "PETH KASBA",
                                    "Value": "PETH KASBA"
                                },
                                {
                                    "Text": "PETLAD",
                                    "Value": "PETLAD"
                                },
                                {
                                    "Text": "PHAGWARA",
                                    "Value": "PHAGWARA"
                                },
                                {
                                    "Text": "PHALTAN",
                                    "Value": "PHALTAN"
                                },
                                {
                                    "Text": "PHALODI",
                                    "Value": "PHALODI"
                                },
                                {
                                    "Text": "PHAPHRANA",
                                    "Value": "PHAPHRANA"
                                },
                                {
                                    "Text": "PHEK",
                                    "Value": "PHEK"
                                },
                                {
                                    "Text": "PHILLAUR",
                                    "Value": "PHILLAUR"
                                },
                                {
                                    "Text": "PEHLAD PUR BANGAR",
                                    "Value": "PEHLAD PUR BANGAR"
                                },
                                {
                                    "Text": "PHULERA",
                                    "Value": "PHULERA"
                                },
                                {
                                    "Text": "PHULPUR",
                                    "Value": "PHULPUR"
                                },
                                {
                                    "Text": "PHULMADDI ",
                                    "Value": "PHULMADDI "
                                },
                                {
                                    "Text": "PHUL",
                                    "Value": "PHUL"
                                },
                                {
                                    "Text": "PHULABANI",
                                    "Value": "PHULABANI"
                                },
                                {
                                    "Text": "PHULLANWALA",
                                    "Value": "PHULLANWALA"
                                },
                                {
                                    "Text": "PHURSO",
                                    "Value": "PHURSO"
                                },
                                {
                                    "Text": "PIDUGURALLA",
                                    "Value": "PIDUGURALLA"
                                },
                                {
                                    "Text": "PILERU",
                                    "Value": "PILERU"
                                },
                                {
                                    "Text": "PILIBANGA",
                                    "Value": "PILIBANGA"
                                },
                                {
                                    "Text": "PILIBHIT",
                                    "Value": "PILIBHIT"
                                },
                                {
                                    "Text": "PILLAYARKUPPAM ",
                                    "Value": "PILLAYARKUPPAM "
                                },
                                {
                                    "Text": "PILU KHERA",
                                    "Value": "PILU KHERA"
                                },
                                {
                                    "Text": "PIMPRI",
                                    "Value": "PIMPRI"
                                },
                                {
                                    "Text": "PINDI BALOCHAN",
                                    "Value": "PINDI BALOCHAN"
                                },
                                {
                                    "Text": "PINJORE",
                                    "Value": "PINJORE"
                                },
                                {
                                    "Text": "PIPARIYA",
                                    "Value": "PIPARIYA"
                                },
                                {
                                    "Text": "PIPLI ",
                                    "Value": "PIPLI "
                                },
                                {
                                    "Text": "PIPLI",
                                    "Value": "PIPLI"
                                },
                                {
                                    "Text": "PIPRI ",
                                    "Value": "PIPRI "
                                },
                                {
                                    "Text": "PIPRA ",
                                    "Value": "PIPRA "
                                },
                                {
                                    "Text": "PIPRAICH",
                                    "Value": "PIPRAICH"
                                },
                                {
                                    "Text": "PIRAVOM",
                                    "Value": "PIRAVOM"
                                },
                                {
                                    "Text": "PITHAMPUR",
                                    "Value": "PITHAMPUR"
                                },
                                {
                                    "Text": "PITHORAGARH",
                                    "Value": "PITHORAGARH"
                                },
                                {
                                    "Text": "PITHAPURAM",
                                    "Value": "PITHAPURAM"
                                },
                                {
                                    "Text": "PITHLA",
                                    "Value": "PITHLA"
                                },
                                {
                                    "Text": "POKHRAN",
                                    "Value": "POKHRAN"
                                },
                                {
                                    "Text": "PALGHAR",
                                    "Value": "PALGHAR"
                                },
                                {
                                    "Text": "PALANI",
                                    "Value": "PALANI"
                                },
                                {
                                    "Text": "PILKHUWA",
                                    "Value": "PILKHUWA"
                                },
                                {
                                    "Text": "PUL PEHLAD",
                                    "Value": "PUL PEHLAD"
                                },
                                {
                                    "Text": "PURMANDAL",
                                    "Value": "PURMANDAL"
                                },
                                {
                                    "Text": "PILANI",
                                    "Value": "PILANI"
                                },
                                {
                                    "Text": "PANAJI",
                                    "Value": "PANAJI"
                                },
                                {
                                    "Text": "PANSKURA",
                                    "Value": "PANSKURA"
                                },
                                {
                                    "Text": "POATA",
                                    "Value": "POATA"
                                },
                                {
                                    "Text": "PODILI",
                                    "Value": "PODILI"
                                },
                                {
                                    "Text": "POGATHOTA",
                                    "Value": "POGATHOTA"
                                },
                                {
                                    "Text": "POJEWAL",
                                    "Value": "POJEWAL"
                                },
                                {
                                    "Text": "POKHARIA ",
                                    "Value": "POKHARIA "
                                },
                                {
                                    "Text": "POLA ",
                                    "Value": "POLA "
                                },
                                {
                                    "Text": "POLICE LINES TARN TARAN SO",
                                    "Value": "POLICE LINES TARN TARAN SO"
                                },
                                {
                                    "Text": "POLLACHI",
                                    "Value": "POLLACHI"
                                },
                                {
                                    "Text": "POMBHURNA ",
                                    "Value": "POMBHURNA "
                                },
                                {
                                    "Text": "PONATA SAHIB",
                                    "Value": "PONATA SAHIB"
                                },
                                {
                                    "Text": "PONATA SAHIB",
                                    "Value": "PONATA SAHIB"
                                },
                                {
                                    "Text": "PONDA",
                                    "Value": "PONDA"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PONDI-UPRODA ",
                                    "Value": "PONDI-UPRODA "
                                },
                                {
                                    "Text": "PONNANI",
                                    "Value": "PONNANI"
                                },
                                {
                                    "Text": "PONNAM ",
                                    "Value": "PONNAM "
                                },
                                {
                                    "Text": "PONNUR",
                                    "Value": "PONNUR"
                                },
                                {
                                    "Text": "POONCH",
                                    "Value": "POONCH"
                                },
                                {
                                    "Text": "POONDI",
                                    "Value": "POONDI"
                                },
                                {
                                    "Text": "POONGAMOODU",
                                    "Value": "POONGAMOODU"
                                },
                                {
                                    "Text": "PORANKI",
                                    "Value": "PORANKI"
                                },
                                {
                                    "Text": "PORBANDER",
                                    "Value": "PORBANDER"
                                },
                                {
                                    "Text": "PORBANDAR",
                                    "Value": "PORBANDAR"
                                },
                                {
                                    "Text": "PORT BLAIR",
                                    "Value": "PORT BLAIR"
                                },
                                {
                                    "Text": "PORVORIM",
                                    "Value": "PORVORIM"
                                },
                                {
                                    "Text": "POR",
                                    "Value": "POR"
                                },
                                {
                                    "Text": "POST LONI",
                                    "Value": "POST LONI"
                                },
                                {
                                    "Text": "POST SURAJPUR",
                                    "Value": "POST SURAJPUR"
                                },
                                {
                                    "Text": "POTTAPALAYAM ",
                                    "Value": "POTTAPALAYAM "
                                },
                                {
                                    "Text": "POWAI",
                                    "Value": "POWAI"
                                },
                                {
                                    "Text": "POWAYAN",
                                    "Value": "POWAYAN"
                                },
                                {
                                    "Text": "PRAKASAM",
                                    "Value": "PRAKASAM"
                                },
                                {
                                    "Text": "PRANTIJ",
                                    "Value": "PRANTIJ"
                                },
                                {
                                    "Text": "PRASADRAOPETA",
                                    "Value": "PRASADRAOPETA"
                                },
                                {
                                    "Text": "PRATAPGARH",
                                    "Value": "PRATAPGARH"
                                },
                                {
                                    "Text": "PRATAPGARH",
                                    "Value": "PRATAPGARH"
                                },
                                {
                                    "Text": "PIPRALI ROAD",
                                    "Value": "PIPRALI ROAD"
                                },
                                {
                                    "Text": "PRODDATUR",
                                    "Value": "PRODDATUR"
                                },
                                {
                                    "Text": "PRODDATTUR",
                                    "Value": "PRODDATTUR"
                                },
                                {
                                    "Text": "PARASIA",
                                    "Value": "PARASIA"
                                },
                                {
                                    "Text": "PARATWADA",
                                    "Value": "PARATWADA"
                                },
                                {
                                    "Text": "PASTHAL",
                                    "Value": "PASTHAL"
                                },
                                {
                                    "Text": "POOTH KHURD",
                                    "Value": "POOTH KHURD"
                                },
                                {
                                    "Text": "POOTH KALAN",
                                    "Value": "POOTH KALAN"
                                },
                                {
                                    "Text": "PATALA",
                                    "Value": "PATALA"
                                },
                                {
                                    "Text": "PTU CAMPUS KAPURTHALA ",
                                    "Value": "PTU CAMPUS KAPURTHALA "
                                },
                                {
                                    "Text": "PUDHUPAKKAM",
                                    "Value": "PUDHUPAKKAM"
                                },
                                {
                                    "Text": "PUDUKOTTAI",
                                    "Value": "PUDUKOTTAI"
                                },
                                {
                                    "Text": "PUDUKKOTTAI",
                                    "Value": "PUDUKKOTTAI"
                                },
                                {
                                    "Text": "PUDUR ",
                                    "Value": "PUDUR "
                                },
                                {
                                    "Text": "PUDUCHERRY",
                                    "Value": "PUDUCHERRY"
                                },
                                {
                                    "Text": "PUKHRAYAN",
                                    "Value": "PUKHRAYAN"
                                },
                                {
                                    "Text": "PULAPALLI ",
                                    "Value": "PULAPALLI "
                                },
                                {
                                    "Text": "PULIVENDLAKUTCHERRY ",
                                    "Value": "PULIVENDLAKUTCHERRY "
                                },
                                {
                                    "Text": "PULIVENDULA",
                                    "Value": "PULIVENDULA"
                                },
                                {
                                    "Text": "PULUSMAMIDI ",
                                    "Value": "PULUSMAMIDI "
                                },
                                {
                                    "Text": "PULWAMA",
                                    "Value": "PULWAMA"
                                },
                                {
                                    "Text": "PUNALUR",
                                    "Value": "PUNALUR"
                                },
                                {
                                    "Text": "PUNDRI",
                                    "Value": "PUNDRI"
                                },
                                {
                                    "Text": "PUNE",
                                    "Value": "PUNE"
                                },
                                {
                                    "Text": "PUNGANUR",
                                    "Value": "PUNGANUR"
                                },
                                {
                                    "Text": "PUNJABARI",
                                    "Value": "PUNJABARI"
                                },
                                {
                                    "Text": "PURANA MOGA ",
                                    "Value": "PURANA MOGA "
                                },
                                {
                                    "Text": "PURAINA ",
                                    "Value": "PURAINA "
                                },
                                {
                                    "Text": "PURANPUR",
                                    "Value": "PURANPUR"
                                },
                                {
                                    "Text": "PURBA MEDINIPUR",
                                    "Value": "PURBA MEDINIPUR"
                                },
                                {
                                    "Text": "PURI",
                                    "Value": "PURI"
                                },
                                {
                                    "Text": "PURNEA",
                                    "Value": "PURNEA"
                                },
                                {
                                    "Text": "PURNIA",
                                    "Value": "PURNIA"
                                },
                                {
                                    "Text": "PURQUAZI",
                                    "Value": "PURQUAZI"
                                },
                                {
                                    "Text": "PURULIA",
                                    "Value": "PURULIA"
                                },
                                {
                                    "Text": "PURULIYA",
                                    "Value": "PURULIYA"
                                },
                                {
                                    "Text": "PURVI CHAMPARAN",
                                    "Value": "PURVI CHAMPARAN"
                                },
                                {
                                    "Text": "PURWA",
                                    "Value": "PURWA"
                                },
                                {
                                    "Text": "PUSAD",
                                    "Value": "PUSAD"
                                },
                                {
                                    "Text": "PUSHPARAJGARH",
                                    "Value": "PUSHPARAJGARH"
                                },
                                {
                                    "Text": "PUTHENCHIRA",
                                    "Value": "PUTHENCHIRA"
                                },
                                {
                                    "Text": "PUTTAPARTHY",
                                    "Value": "PUTTAPARTHY"
                                },
                                {
                                    "Text": "PUTTUR",
                                    "Value": "PUTTUR"
                                },
                                {
                                    "Text": "PUTTAPARTHI",
                                    "Value": "PUTTAPARTHI"
                                },
                                {
                                    "Text": "PUTTUR",
                                    "Value": "PUTTUR"
                                },
                                {
                                    "Text": "PYARARAM ",
                                    "Value": "PYARARAM "
                                },
                                {
                                    "Text": "PYNURSLA",
                                    "Value": "PYNURSLA"
                                },
                                {
                                    "Text": "QADIAN",
                                    "Value": "QADIAN"
                                },
                                {
                                    "Text": "QILLA KAVI SANTOKH ",
                                    "Value": "QILLA KAVI SANTOKH "
                                },
                                {
                                    "Text": "QUAMMRUDDIN NAGAR",
                                    "Value": "QUAMMRUDDIN NAGAR"
                                },
                                {
                                    "Text": "QUEPEM",
                                    "Value": "QUEPEM"
                                },
                                {
                                    "Text": "QUILANDI",
                                    "Value": "QUILANDI"
                                },
                                {
                                    "Text": "QUILA NAU ",
                                    "Value": "QUILA NAU "
                                },
                                {
                                    "Text": "QAZIGUND",
                                    "Value": "QAZIGUND"
                                },
                                {
                                    "Text": "RADAUR",
                                    "Value": "RADAUR"
                                },
                                {
                                    "Text": "RADHANPUR",
                                    "Value": "RADHANPUR"
                                },
                                {
                                    "Text": "RAE BARELI",
                                    "Value": "RAE BARELI"
                                },
                                {
                                    "Text": "RAEBARELI",
                                    "Value": "RAEBARELI"
                                },
                                {
                                    "Text": "RAEKOT",
                                    "Value": "RAEKOT"
                                },
                                {
                                    "Text": "RAGADAPA ",
                                    "Value": "RAGADAPA "
                                },
                                {
                                    "Text": "RAGHUDEVAPURAM",
                                    "Value": "RAGHUDEVAPURAM"
                                },
                                {
                                    "Text": "RAGHAVAPET",
                                    "Value": "RAGHAVAPET"
                                },
                                {
                                    "Text": "RAHATA",
                                    "Value": "RAHATA"
                                },
                                {
                                    "Text": "RAHIAD",
                                    "Value": "RAHIAD"
                                },
                                {
                                    "Text": "RAHON",
                                    "Value": "RAHON"
                                },
                                {
                                    "Text": "RAHURI",
                                    "Value": "RAHURI"
                                },
                                {
                                    "Text": "RAICHUR",
                                    "Value": "RAICHUR"
                                },
                                {
                                    "Text": "RAIGARH(MH)",
                                    "Value": "RAIGARH(MH)"
                                },
                                {
                                    "Text": "RAIGAD",
                                    "Value": "RAIGAD"
                                },
                                {
                                    "Text": "RAIGARH",
                                    "Value": "RAIGARH"
                                },
                                {
                                    "Text": "RAIGANJ",
                                    "Value": "RAIGANJ"
                                },
                                {
                                    "Text": "RAIKOT",
                                    "Value": "RAIKOT"
                                },
                                {
                                    "Text": "RAILMAJRA",
                                    "Value": "RAILMAJRA"
                                },
                                {
                                    "Text": "RAIPUR",
                                    "Value": "RAIPUR"
                                },
                                {
                                    "Text": "RAIPUR RANI",
                                    "Value": "RAIPUR RANI"
                                },
                                {
                                    "Text": "RAIR KALAN",
                                    "Value": "RAIR KALAN"
                                },
                                {
                                    "Text": "RAIRANGPUR",
                                    "Value": "RAIRANGPUR"
                                },
                                {
                                    "Text": "RAISINGHNAGAR",
                                    "Value": "RAISINGHNAGAR"
                                },
                                {
                                    "Text": "RAISEN",
                                    "Value": "RAISEN"
                                },
                                {
                                    "Text": "RAISAR",
                                    "Value": "RAISAR"
                                },
                                {
                                    "Text": "RAJAURI",
                                    "Value": "RAJAURI"
                                },
                                {
                                    "Text": "RAJAHMUNDRY",
                                    "Value": "RAJAHMUNDRY"
                                },
                                {
                                    "Text": "RAJAM",
                                    "Value": "RAJAM"
                                },
                                {
                                    "Text": "RAJAPALAYAM",
                                    "Value": "RAJAPALAYAM"
                                },
                                {
                                    "Text": "RAJA SANSI",
                                    "Value": "RAJA SANSI"
                                },
                                {
                                    "Text": "RAJAGANGAPUR",
                                    "Value": "RAJAGANGAPUR"
                                },
                                {
                                    "Text": "RAJAMPET",
                                    "Value": "RAJAMPET"
                                },
                                {
                                    "Text": "RAJARHAT GOPALPUR",
                                    "Value": "RAJARHAT GOPALPUR"
                                },
                                {
                                    "Text": "RAJASMAND",
                                    "Value": "RAJASMAND"
                                },
                                {
                                    "Text": "RAJAUND",
                                    "Value": "RAJAUND"
                                },
                                {
                                    "Text": "RAJBALLABHPUR",
                                    "Value": "RAJBALLABHPUR"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGIR",
                                    "Value": "RAJGIR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJIM",
                                    "Value": "RAJIM"
                                },
                                {
                                    "Text": "RAJIA",
                                    "Value": "RAJIA"
                                },
                                {
                                    "Text": "RAJKOT",
                                    "Value": "RAJKOT"
                                },
                                {
                                    "Text": "RAJNANDGAON",
                                    "Value": "RAJNANDGAON"
                                },
                                {
                                    "Text": "RAJNADGAON",
                                    "Value": "RAJNADGAON"
                                },
                                {
                                    "Text": "RAJOKRI",
                                    "Value": "RAJOKRI"
                                },
                                {
                                    "Text": "RAJOLE ",
                                    "Value": "RAJOLE "
                                },
                                {
                                    "Text": "RAJOWALA ",
                                    "Value": "RAJOWALA "
                                },
                                {
                                    "Text": "RAJOSANA",
                                    "Value": "RAJOSANA"
                                },
                                {
                                    "Text": "RAJOURI",
                                    "Value": "RAJOURI"
                                },
                                {
                                    "Text": "RAJPIPLA",
                                    "Value": "RAJPIPLA"
                                },
                                {
                                    "Text": "RAJPURA",
                                    "Value": "RAJPURA"
                                },
                                {
                                    "Text": "RAJPURA TOWNSHIP ",
                                    "Value": "RAJPURA TOWNSHIP "
                                },
                                {
                                    "Text": "RAJPUR BHAIAN",
                                    "Value": "RAJPUR BHAIAN"
                                },
                                {
                                    "Text": "RAJSAMAND",
                                    "Value": "RAJSAMAND"
                                },
                                {
                                    "Text": "RAJULA",
                                    "Value": "RAJULA"
                                },
                                {
                                    "Text": "RAJUPAKALU ",
                                    "Value": "RAJUPAKALU "
                                },
                                {
                                    "Text": "RAJUR",
                                    "Value": "RAJUR"
                                },
                                {
                                    "Text": "RAJURA",
                                    "Value": "RAJURA"
                                },
                                {
                                    "Text": "RAKANPUR",
                                    "Value": "RAKANPUR"
                                },
                                {
                                    "Text": "RAMAN",
                                    "Value": "RAMAN"
                                },
                                {
                                    "Text": "RAMANAGAR",
                                    "Value": "RAMANAGAR"
                                },
                                {
                                    "Text": "RAMANATHAPURAM",
                                    "Value": "RAMANATHAPURAM"
                                },
                                {
                                    "Text": "RAMANATHGUDPALLY ",
                                    "Value": "RAMANATHGUDPALLY "
                                },
                                {
                                    "Text": "RAMACHANDRAPURAM OLD TOWN ",
                                    "Value": "RAMACHANDRAPURAM OLD TOWN "
                                },
                                {
                                    "Text": "RAMACHANDRAPURAM",
                                    "Value": "RAMACHANDRAPURAM"
                                },
                                {
                                    "Text": "RAMAGUNDAM",
                                    "Value": "RAMAGUNDAM"
                                },
                                {
                                    "Text": "RAMANAGARAM",
                                    "Value": "RAMANAGARAM"
                                },
                                {
                                    "Text": "RAMANUJGANJ",
                                    "Value": "RAMANUJGANJ"
                                },
                                {
                                    "Text": "RAMAPURAM",
                                    "Value": "RAMAPURAM"
                                },
                                {
                                    "Text": "RAMDAS",
                                    "Value": "RAMDAS"
                                },
                                {
                                    "Text": "RAMDAS (M CL)",
                                    "Value": "RAMDAS (M CL)"
                                },
                                {
                                    "Text": "RAMESWARPUR",
                                    "Value": "RAMESWARPUR"
                                },
                                {
                                    "Text": "RAMGARH CANTT",
                                    "Value": "RAMGARH CANTT"
                                },
                                {
                                    "Text": "RAMGARH",
                                    "Value": "RAMGARH"
                                },
                                {
                                    "Text": "RAMGARH",
                                    "Value": "RAMGARH"
                                },
                                {
                                    "Text": "RAMGARH CANTT.",
                                    "Value": "RAMGARH CANTT."
                                },
                                {
                                    "Text": "RAMGANJ MANDI",
                                    "Value": "RAMGANJ MANDI"
                                },
                                {
                                    "Text": "RAMNAGAR ",
                                    "Value": "RAMNAGAR "
                                },
                                {
                                    "Text": "RAMNAGAR",
                                    "Value": "RAMNAGAR"
                                },
                                {
                                    "Text": "RAMPURA PHUL",
                                    "Value": "RAMPURA PHUL"
                                },
                                {
                                    "Text": "RAMPUR",
                                    "Value": "RAMPUR"
                                },
                                {
                                    "Text": "RAMPUR",
                                    "Value": "RAMPUR"
                                },
                                {
                                    "Text": "RAMPUR JAGIR",
                                    "Value": "RAMPUR JAGIR"
                                },
                                {
                                    "Text": "RAMPURA",
                                    "Value": "RAMPURA"
                                },
                                {
                                    "Text": "RAMPURHAT",
                                    "Value": "RAMPURHAT"
                                },
                                {
                                    "Text": "RAMTEK",
                                    "Value": "RAMTEK"
                                },
                                {
                                    "Text": "RANAGHAT",
                                    "Value": "RANAGHAT"
                                },
                                {
                                    "Text": "RANBIR SINGH PORA",
                                    "Value": "RANBIR SINGH PORA"
                                },
                                {
                                    "Text": "RANCHI",
                                    "Value": "RANCHI"
                                },
                                {
                                    "Text": "RANEBENNUR",
                                    "Value": "RANEBENNUR"
                                },
                                {
                                    "Text": "RANGAREDDI",
                                    "Value": "RANGAREDDI"
                                },
                                {
                                    "Text": "RANGAREDDY",
                                    "Value": "RANGAREDDY"
                                },
                                {
                                    "Text": "RANGIA",
                                    "Value": "RANGIA"
                                },
                                {
                                    "Text": "RANGIAN",
                                    "Value": "RANGIAN"
                                },
                                {
                                    "Text": "RANGIBASAN",
                                    "Value": "RANGIBASAN"
                                },
                                {
                                    "Text": "RANGPO",
                                    "Value": "RANGPO"
                                },
                                {
                                    "Text": "RANIA",
                                    "Value": "RANIA"
                                },
                                {
                                    "Text": "RANIPET",
                                    "Value": "RANIPET"
                                },
                                {
                                    "Text": "RANIBENNUR",
                                    "Value": "RANIBENNUR"
                                },
                                {
                                    "Text": "RANIGANJ",
                                    "Value": "RANIGANJ"
                                },
                                {
                                    "Text": "RANIPETTAI",
                                    "Value": "RANIPETTAI"
                                },
                                {
                                    "Text": "RANIPOOL",
                                    "Value": "RANIPOOL"
                                },
                                {
                                    "Text": "RANIPUR",
                                    "Value": "RANIPUR"
                                },
                                {
                                    "Text": "RANJANGAON",
                                    "Value": "RANJANGAON"
                                },
                                {
                                    "Text": "RANNY",
                                    "Value": "RANNY"
                                },
                                {
                                    "Text": "RANNI",
                                    "Value": "RANNI"
                                },
                                {
                                    "Text": "RAPALLE",
                                    "Value": "RAPALLE"
                                },
                                {
                                    "Text": "RASIPURAM",
                                    "Value": "RASIPURAM"
                                },
                                {
                                    "Text": "RASUPUR BANKIYA ",
                                    "Value": "RASUPUR BANKIYA "
                                },
                                {
                                    "Text": "RASULPUR",
                                    "Value": "RASULPUR"
                                },
                                {
                                    "Text": "RATHONDA ",
                                    "Value": "RATHONDA "
                                },
                                {
                                    "Text": "RATH",
                                    "Value": "RATH"
                                },
                                {
                                    "Text": "RATIA",
                                    "Value": "RATIA"
                                },
                                {
                                    "Text": "RATLAM",
                                    "Value": "RATLAM"
                                },
                                {
                                    "Text": "RATNAGIRI",
                                    "Value": "RATNAGIRI"
                                },
                                {
                                    "Text": "RATNARI",
                                    "Value": "RATNARI"
                                },
                                {
                                    "Text": "RATTEWAL",
                                    "Value": "RATTEWAL"
                                },
                                {
                                    "Text": "RAU",
                                    "Value": "RAU"
                                },
                                {
                                    "Text": "RAULI ",
                                    "Value": "RAULI "
                                },
                                {
                                    "Text": "RAVER",
                                    "Value": "RAVER"
                                },
                                {
                                    "Text": "RAVULAPALEM",
                                    "Value": "RAVULAPALEM"
                                },
                                {
                                    "Text": "RAWAT BHATA",
                                    "Value": "RAWAT BHATA"
                                },
                                {
                                    "Text": "RAWATSAR",
                                    "Value": "RAWATSAR"
                                },
                                {
                                    "Text": "RAXAUL BAZAR",
                                    "Value": "RAXAUL BAZAR"
                                },
                                {
                                    "Text": "RAYAGADA",
                                    "Value": "RAYAGADA"
                                },
                                {
                                    "Text": "RAYA",
                                    "Value": "RAYA"
                                },
                                {
                                    "Text": "RAYACHOTI",
                                    "Value": "RAYACHOTI"
                                },
                                {
                                    "Text": "RAYADURG",
                                    "Value": "RAYADURG"
                                },
                                {
                                    "Text": "RAYINI PALEM ",
                                    "Value": "RAYINI PALEM "
                                },
                                {
                                    "Text": "RAYYA",
                                    "Value": "RAYYA"
                                },
                                {
                                    "Text": "REASI",
                                    "Value": "REASI"
                                },
                                {
                                    "Text": "REDDIAL ",
                                    "Value": "REDDIAL "
                                },
                                {
                                    "Text": "REDDICHAVADI ",
                                    "Value": "REDDICHAVADI "
                                },
                                {
                                    "Text": "REDDIPALLE",
                                    "Value": "REDDIPALLE"
                                },
                                {
                                    "Text": "RED HILLS",
                                    "Value": "RED HILLS"
                                },
                                {
                                    "Text": "REHANA JATTAN",
                                    "Value": "REHANA JATTAN"
                                },
                                {
                                    "Text": "REKANG PEO",
                                    "Value": "REKANG PEO"
                                },
                                {
                                    "Text": "RENGALI",
                                    "Value": "RENGALI"
                                },
                                {
                                    "Text": "RENUKOOT",
                                    "Value": "RENUKOOT"
                                },
                                {
                                    "Text": "REPALLE",
                                    "Value": "REPALLE"
                                },
                                {
                                    "Text": "REWA",
                                    "Value": "REWA"
                                },
                                {
                                    "Text": "REWARI",
                                    "Value": "REWARI"
                                },
                                {
                                    "Text": "RAFIGANJ",
                                    "Value": "RAFIGANJ"
                                },
                                {
                                    "Text": "RI BHOI",
                                    "Value": "RI BHOI"
                                },
                                {
                                    "Text": "RISHIKESH",
                                    "Value": "RISHIKESH"
                                },
                                {
                                    "Text": "RISHRA",
                                    "Value": "RISHRA"
                                },
                                {
                                    "Text": "RAMPUR (MOTIHARI)",
                                    "Value": "RAMPUR (MOTIHARI)"
                                },
                                {
                                    "Text": "RANIKHET",
                                    "Value": "RANIKHET"
                                },
                                {
                                    "Text": "ROBERTSGANJ",
                                    "Value": "ROBERTSGANJ"
                                },
                                {
                                    "Text": "RODHA",
                                    "Value": "RODHA"
                                },
                                {
                                    "Text": "ROHA ASHTAMI",
                                    "Value": "ROHA ASHTAMI"
                                },
                                {
                                    "Text": "ROHERIANWALI",
                                    "Value": "ROHERIANWALI"
                                },
                                {
                                    "Text": "ROHRU",
                                    "Value": "ROHRU"
                                },
                                {
                                    "Text": "ROHTAK",
                                    "Value": "ROHTAK"
                                },
                                {
                                    "Text": "ROHTAS",
                                    "Value": "ROHTAS"
                                },
                                {
                                    "Text": "ROING",
                                    "Value": "ROING"
                                },
                                {
                                    "Text": "ROORKEE",
                                    "Value": "ROORKEE"
                                },
                                {
                                    "Text": "ROORKEE",
                                    "Value": "ROORKEE"
                                },
                                {
                                    "Text": "ROPAR",
                                    "Value": "ROPAR"
                                },
                                {
                                    "Text": "RORANWALA",
                                    "Value": "RORANWALA"
                                },
                                {
                                    "Text": "ROURKELA",
                                    "Value": "ROURKELA"
                                },
                                {
                                    "Text": "RUPNARAYANPUR",
                                    "Value": "RUPNARAYANPUR"
                                },
                                {
                                    "Text": "RSARA",
                                    "Value": "RSARA"
                                },
                                {
                                    "Text": "ROSHAN PURA",
                                    "Value": "ROSHAN PURA"
                                },
                                {
                                    "Text": "RATANGARH",
                                    "Value": "RATANGARH"
                                },
                                {
                                    "Text": "R THUMMALAPALLE ",
                                    "Value": "R THUMMALAPALLE "
                                },
                                {
                                    "Text": "RUDAULI",
                                    "Value": "RUDAULI"
                                },
                                {
                                    "Text": "RUDEL",
                                    "Value": "RUDEL"
                                },
                                {
                                    "Text": "RUDRAPUR",
                                    "Value": "RUDRAPUR"
                                },
                                {
                                    "Text": "RUDRAPRAYAG",
                                    "Value": "RUDRAPRAYAG"
                                },
                                {
                                    "Text": "RUDRARAM ",
                                    "Value": "RUDRARAM "
                                },
                                {
                                    "Text": "RUPANA",
                                    "Value": "RUPANA"
                                },
                                {
                                    "Text": "RUPNAGAR",
                                    "Value": "RUPNAGAR"
                                },
                                {
                                    "Text": "RUSTAPUR ",
                                    "Value": "RUSTAPUR "
                                },
                                {
                                    "Text": "SABARKANTHA",
                                    "Value": "SABARKANTHA"
                                },
                                {
                                    "Text": "SABHRA",
                                    "Value": "SABHRA"
                                },
                                {
                                    "Text": "SABOUR",
                                    "Value": "SABOUR"
                                },
                                {
                                    "Text": "SADABAD",
                                    "Value": "SADABAD"
                                },
                                {
                                    "Text": "SADHAURA",
                                    "Value": "SADHAURA"
                                },
                                {
                                    "Text": "SADI",
                                    "Value": "SADI"
                                },
                                {
                                    "Text": "SADIQ",
                                    "Value": "SADIQ"
                                },
                                {
                                    "Text": "SADULSAHAR",
                                    "Value": "SADULSAHAR"
                                },
                                {
                                    "Text": "SAFIDON",
                                    "Value": "SAFIDON"
                                },
                                {
                                    "Text": "SAGAR",
                                    "Value": "SAGAR"
                                },
                                {
                                    "Text": "SAGAR",
                                    "Value": "SAGAR"
                                },
                                {
                                    "Text": "SAGWARA",
                                    "Value": "SAGWARA"
                                },
                                {
                                    "Text": "SAHARANPUR",
                                    "Value": "SAHARANPUR"
                                },
                                {
                                    "Text": "SAHARSA",
                                    "Value": "SAHARSA"
                                },
                                {
                                    "Text": "SAHA",
                                    "Value": "SAHA"
                                },
                                {
                                    "Text": "SAHABUDDINPUR",
                                    "Value": "SAHABUDDINPUR"
                                },
                                {
                                    "Text": "SAHAURAN",
                                    "Value": "SAHAURAN"
                                },
                                {
                                    "Text": "SAHIBZADA AJIT SINGH NAGAR",
                                    "Value": "SAHIBZADA AJIT SINGH NAGAR"
                                },
                                {
                                    "Text": "SAHIBGANJ",
                                    "Value": "SAHIBGANJ"
                                },
                                {
                                    "Text": "SAHIBABAD",
                                    "Value": "SAHIBABAD"
                                },
                                {
                                    "Text": "SAHIBZADA AJIT SINGH NAGAR",
                                    "Value": "SAHIBZADA AJIT SINGH NAGAR"
                                },
                                {
                                    "Text": "SAHJANWA",
                                    "Value": "SAHJANWA"
                                },
                                {
                                    "Text": "SAHNEWAL",
                                    "Value": "SAHNEWAL"
                                },
                                {
                                    "Text": "SAIDUL AJAIB",
                                    "Value": "SAIDUL AJAIB"
                                },
                                {
                                    "Text": "SAIHA",
                                    "Value": "SAIHA"
                                },
                                {
                                    "Text": "SAILA KHURD",
                                    "Value": "SAILA KHURD"
                                },
                                {
                                    "Text": "SAILU",
                                    "Value": "SAILU"
                                },
                                {
                                    "Text": "SAINTHIA",
                                    "Value": "SAINTHIA"
                                },
                                {
                                    "Text": "SAINI MAJRA",
                                    "Value": "SAINI MAJRA"
                                },
                                {
                                    "Text": "SAINJ",
                                    "Value": "SAINJ"
                                },
                                {
                                    "Text": "SAKAT SANALA",
                                    "Value": "SAKAT SANALA"
                                },
                                {
                                    "Text": "SALAIRANI",
                                    "Value": "SALAIRANI"
                                },
                                {
                                    "Text": "SALBARI ",
                                    "Value": "SALBARI "
                                },
                                {
                                    "Text": "SALCETTE",
                                    "Value": "SALCETTE"
                                },
                                {
                                    "Text": "SALEM",
                                    "Value": "SALEM"
                                },
                                {
                                    "Text": "SALEMPUR",
                                    "Value": "SALEMPUR"
                                },
                                {
                                    "Text": "SALEPUR",
                                    "Value": "SALEPUR"
                                },
                                {
                                    "Text": "SALIGAO",
                                    "Value": "SALIGAO"
                                },
                                {
                                    "Text": "SALKA ",
                                    "Value": "SALKA "
                                },
                                {
                                    "Text": "SALON",
                                    "Value": "SALON"
                                },
                                {
                                    "Text": "SALUR",
                                    "Value": "SALUR"
                                },
                                {
                                    "Text": "SALUNI",
                                    "Value": "SALUNI"
                                },
                                {
                                    "Text": "SAMANA",
                                    "Value": "SAMANA"
                                },
                                {
                                    "Text": "SAMALKHA",
                                    "Value": "SAMALKHA"
                                },
                                {
                                    "Text": "SAMASTIPUR",
                                    "Value": "SAMASTIPUR"
                                },
                                {
                                    "Text": "SAMADPUR HARDAS ",
                                    "Value": "SAMADPUR HARDAS "
                                },
                                {
                                    "Text": "SAMADA",
                                    "Value": "SAMADA"
                                },
                                {
                                    "Text": "SAMAIPUR",
                                    "Value": "SAMAIPUR"
                                },
                                {
                                    "Text": "SAMBALPUR",
                                    "Value": "SAMBALPUR"
                                },
                                {
                                    "Text": "SAMBA",
                                    "Value": "SAMBA"
                                },
                                {
                                    "Text": "SAMBA",
                                    "Value": "SAMBA"
                                },
                                {
                                    "Text": "SAMBHAL",
                                    "Value": "SAMBHAL"
                                },
                                {
                                    "Text": "SAMBHAR",
                                    "Value": "SAMBHAR"
                                },
                                {
                                    "Text": "SAMGAULI",
                                    "Value": "SAMGAULI"
                                },
                                {
                                    "Text": "SAMLOD",
                                    "Value": "SAMLOD"
                                },
                                {
                                    "Text": "SAMOU",
                                    "Value": "SAMOU"
                                },
                                {
                                    "Text": "SAMPLA",
                                    "Value": "SAMPLA"
                                },
                                {
                                    "Text": "SAMPURA",
                                    "Value": "SAMPURA"
                                },
                                {
                                    "Text": "SAMPURNA NAGAR",
                                    "Value": "SAMPURNA NAGAR"
                                },
                                {
                                    "Text": "SAMRALA",
                                    "Value": "SAMRALA"
                                },
                                {
                                    "Text": "SANAND",
                                    "Value": "SANAND"
                                },
                                {
                                    "Text": "SANATHAL",
                                    "Value": "SANATHAL"
                                },
                                {
                                    "Text": "SANAUR",
                                    "Value": "SANAUR"
                                },
                                {
                                    "Text": "SANAWAD",
                                    "Value": "SANAWAD"
                                },
                                {
                                    "Text": "SANCHORE",
                                    "Value": "SANCHORE"
                                },
                                {
                                    "Text": "SANDUR",
                                    "Value": "SANDUR"
                                },
                                {
                                    "Text": "SANDHAI",
                                    "Value": "SANDHAI"
                                },
                                {
                                    "Text": "SANDHAUR",
                                    "Value": "SANDHAUR"
                                },
                                {
                                    "Text": "SANDILA",
                                    "Value": "SANDILA"
                                },
                                {
                                    "Text": "SANEHWAL",
                                    "Value": "SANEHWAL"
                                },
                                {
                                    "Text": "SANETA",
                                    "Value": "SANETA"
                                },
                                {
                                    "Text": "SANGAMNER",
                                    "Value": "SANGAMNER"
                                },
                                {
                                    "Text": "SANGLI",
                                    "Value": "SANGLI"
                                },
                                {
                                    "Text": "SANGARIA",
                                    "Value": "SANGARIA"
                                },
                                {
                                    "Text": "SANGRUR",
                                    "Value": "SANGRUR"
                                },
                                {
                                    "Text": "SANGANER",
                                    "Value": "SANGANER"
                                },
                                {
                                    "Text": "SANGANA ",
                                    "Value": "SANGANA "
                                },
                                {
                                    "Text": "SANGAT",
                                    "Value": "SANGAT"
                                },
                                {
                                    "Text": "SANGLI-MIRAJ-KUPWAD",
                                    "Value": "SANGLI-MIRAJ-KUPWAD"
                                },
                                {
                                    "Text": "SANGUEM",
                                    "Value": "SANGUEM"
                                },
                                {
                                    "Text": "SANIVARAM ",
                                    "Value": "SANIVARAM "
                                },
                                {
                                    "Text": "SANJAY NAGAR ",
                                    "Value": "SANJAY NAGAR "
                                },
                                {
                                    "Text": "SANJALI",
                                    "Value": "SANJALI"
                                },
                                {
                                    "Text": "SANJAN",
                                    "Value": "SANJAN"
                                },
                                {
                                    "Text": "SANJAULI",
                                    "Value": "SANJAULI"
                                },
                                {
                                    "Text": "SANKAGIRI",
                                    "Value": "SANKAGIRI"
                                },
                                {
                                    "Text": "SANKESHWAR",
                                    "Value": "SANKESHWAR"
                                },
                                {
                                    "Text": "SANOTH",
                                    "Value": "SANOTH"
                                },
                                {
                                    "Text": "SANPERA",
                                    "Value": "SANPERA"
                                },
                                {
                                    "Text": "SANQUELIM",
                                    "Value": "SANQUELIM"
                                },
                                {
                                    "Text": "SANT KABIR NAGAR",
                                    "Value": "SANT KABIR NAGAR"
                                },
                                {
                                    "Text": "SANT RAVIDAS NAGAR",
                                    "Value": "SANT RAVIDAS NAGAR"
                                },
                                {
                                    "Text": "SANTA CRUZ",
                                    "Value": "SANTA CRUZ"
                                },
                                {
                                    "Text": "SANTA CRUZ",
                                    "Value": "SANTA CRUZ"
                                },
                                {
                                    "Text": "SAONER",
                                    "Value": "SAONER"
                                },
                                {
                                    "Text": "SAPHALE",
                                    "Value": "SAPHALE"
                                },
                                {
                                    "Text": "SARAN",
                                    "Value": "SARAN"
                                },
                                {
                                    "Text": "SARAI MIR",
                                    "Value": "SARAI MIR"
                                },
                                {
                                    "Text": "SARAIDHELA",
                                    "Value": "SARAIDHELA"
                                },
                                {
                                    "Text": "SARAIKELA",
                                    "Value": "SARAIKELA"
                                },
                                {
                                    "Text": "SARAVANAMPATTI",
                                    "Value": "SARAVANAMPATTI"
                                },
                                {
                                    "Text": "SARDAR SHAHAR",
                                    "Value": "SARDAR SHAHAR"
                                },
                                {
                                    "Text": "SARDHANA",
                                    "Value": "SARDHANA"
                                },
                                {
                                    "Text": "SARDULGARH",
                                    "Value": "SARDULGARH"
                                },
                                {
                                    "Text": "SARIGAM",
                                    "Value": "SARIGAM"
                                },
                                {
                                    "Text": "SARKAGHAT",
                                    "Value": "SARKAGHAT"
                                },
                                {
                                    "Text": "SARNA",
                                    "Value": "SARNA"
                                },
                                {
                                    "Text": "SARTHANA ",
                                    "Value": "SARTHANA "
                                },
                                {
                                    "Text": "SASARAM",
                                    "Value": "SASARAM"
                                },
                                {
                                    "Text": "SAS NAGAR ( MOHALI)",
                                    "Value": "SAS NAGAR ( MOHALI)"
                                },
                                {
                                    "Text": "SATANA",
                                    "Value": "SATANA"
                                },
                                {
                                    "Text": "SATARA",
                                    "Value": "SATARA"
                                },
                                {
                                    "Text": "SATHYAMANGALAM",
                                    "Value": "SATHYAMANGALAM"
                                },
                                {
                                    "Text": "SATHUPALLE",
                                    "Value": "SATHUPALLE"
                                },
                                {
                                    "Text": "SATLASANA",
                                    "Value": "SATLASANA"
                                },
                                {
                                    "Text": "SATNA",
                                    "Value": "SATNA"
                                },
                                {
                                    "Text": "SATTENAPALLI",
                                    "Value": "SATTENAPALLI"
                                },
                                {
                                    "Text": "SATTENAPALLE",
                                    "Value": "SATTENAPALLE"
                                },
                                {
                                    "Text": "SAUNAHA ",
                                    "Value": "SAUNAHA "
                                },
                                {
                                    "Text": "SAURI",
                                    "Value": "SAURI"
                                },
                                {
                                    "Text": "SAVARKUNDLA",
                                    "Value": "SAVARKUNDLA"
                                },
                                {
                                    "Text": "SAVAIGUDEM ",
                                    "Value": "SAVAIGUDEM "
                                },
                                {
                                    "Text": "SAVARDARI",
                                    "Value": "SAVARDARI"
                                },
                                {
                                    "Text": "SAVDA",
                                    "Value": "SAVDA"
                                },
                                {
                                    "Text": "SAVNER",
                                    "Value": "SAVNER"
                                },
                                {
                                    "Text": "SAWANTWADI",
                                    "Value": "SAWANTWADI"
                                },
                                {
                                    "Text": "SAWAI MADHOPUR",
                                    "Value": "SAWAI MADHOPUR"
                                },
                                {
                                    "Text": "SAWARGAON HADAP ",
                                    "Value": "SAWARGAON HADAP "
                                },
                                {
                                    "Text": "SAYAR ",
                                    "Value": "SAYAR "
                                },
                                {
                                    "Text": "SAYLA",
                                    "Value": "SAYLA"
                                },
                                {
                                    "Text": "SOUTH DUMDUM",
                                    "Value": "SOUTH DUMDUM"
                                },
                                {
                                    "Text": "SADAT PUR GUJRAN",
                                    "Value": "SADAT PUR GUJRAN"
                                },
                                {
                                    "Text": "SECUNDERABAD",
                                    "Value": "SECUNDERABAD"
                                },
                                {
                                    "Text": "SECUNDERABAD CANTT.",
                                    "Value": "SECUNDERABAD CANTT."
                                },
                                {
                                    "Text": "SEDAM",
                                    "Value": "SEDAM"
                                },
                                {
                                    "Text": "SEDARIYA",
                                    "Value": "SEDARIYA"
                                },
                                {
                                    "Text": "SEHJRA",
                                    "Value": "SEHJRA"
                                },
                                {
                                    "Text": "SEHORE",
                                    "Value": "SEHORE"
                                },
                                {
                                    "Text": "SELUD",
                                    "Value": "SELUD"
                                },
                                {
                                    "Text": "SEMARA CHANDRAULI",
                                    "Value": "SEMARA CHANDRAULI"
                                },
                                {
                                    "Text": "SENAPATI",
                                    "Value": "SENAPATI"
                                },
                                {
                                    "Text": "SENDHWA",
                                    "Value": "SENDHWA"
                                },
                                {
                                    "Text": "SENDRI",
                                    "Value": "SENDRI"
                                },
                                {
                                    "Text": "SEOLI ",
                                    "Value": "SEOLI "
                                },
                                {
                                    "Text": "SEOLI",
                                    "Value": "SEOLI"
                                },
                                {
                                    "Text": "SEONI",
                                    "Value": "SEONI"
                                },
                                {
                                    "Text": "SEONI MALWA",
                                    "Value": "SEONI MALWA"
                                },
                                {
                                    "Text": "SEPPA",
                                    "Value": "SEPPA"
                                },
                                {
                                    "Text": "SERAMPORE",
                                    "Value": "SERAMPORE"
                                },
                                {
                                    "Text": "SERAIKELA-KHARSAWAN",
                                    "Value": "SERAIKELA-KHARSAWAN"
                                },
                                {
                                    "Text": "SERAIKELA",
                                    "Value": "SERAIKELA"
                                },
                                {
                                    "Text": "SERAULIM",
                                    "Value": "SERAULIM"
                                },
                                {
                                    "Text": "SERCHHIP",
                                    "Value": "SERCHHIP"
                                },
                                {
                                    "Text": "SEVOOR",
                                    "Value": "SEVOOR"
                                },
                                {
                                    "Text": "SEWARHI",
                                    "Value": "SEWARHI"
                                },
                                {
                                    "Text": "SANGMESHWAR",
                                    "Value": "SANGMESHWAR"
                                },
                                {
                                    "Text": "SHAHAD",
                                    "Value": "SHAHAD"
                                },
                                {
                                    "Text": "SHADNAGAR",
                                    "Value": "SHADNAGAR"
                                },
                                {
                                    "Text": "SHAHABAD",
                                    "Value": "SHAHABAD"
                                },
                                {
                                    "Text": "SHAHDOL",
                                    "Value": "SHAHDOL"
                                },
                                {
                                    "Text": "SHAHJAHANPUR",
                                    "Value": "SHAHJAHANPUR"
                                },
                                {
                                    "Text": "SHAHID UDHAM SINGH NAGAR",
                                    "Value": "SHAHID UDHAM SINGH NAGAR"
                                },
                                {
                                    "Text": "SHAHKOT",
                                    "Value": "SHAHKOT"
                                },
                                {
                                    "Text": "SHAHPURA",
                                    "Value": "SHAHPURA"
                                },
                                {
                                    "Text": "SHAHPUR TONDA ",
                                    "Value": "SHAHPUR TONDA "
                                },
                                {
                                    "Text": "SHAHADE",
                                    "Value": "SHAHADE"
                                },
                                {
                                    "Text": "SHAHAPUR",
                                    "Value": "SHAHAPUR"
                                },
                                {
                                    "Text": "SHAHBAD",
                                    "Value": "SHAHBAD"
                                },
                                {
                                    "Text": "SHAHGANJ",
                                    "Value": "SHAHGANJ"
                                },
                                {
                                    "Text": "SHAHPUR GOVARDHANPUR BANGAR",
                                    "Value": "SHAHPUR GOVARDHANPUR BANGAR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHZADPUR",
                                    "Value": "SHAHZADPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAIKHPARA .",
                                    "Value": "SHAIKHPARA ."
                                },
                                {
                                    "Text": "SHAJAPUR",
                                    "Value": "SHAJAPUR"
                                },
                                {
                                    "Text": "SHAMLI",
                                    "Value": "SHAMLI"
                                },
                                {
                                    "Text": "SHAMSHABAD",
                                    "Value": "SHAMSHABAD"
                                },
                                {
                                    "Text": "SHAMIRPET ",
                                    "Value": "SHAMIRPET "
                                },
                                {
                                    "Text": "SHAMDOO ",
                                    "Value": "SHAMDOO "
                                },
                                {
                                    "Text": "SHAMALAJI",
                                    "Value": "SHAMALAJI"
                                },
                                {
                                    "Text": "SHAMASHPUR",
                                    "Value": "SHAMASHPUR"
                                },
                                {
                                    "Text": "SHAMCHURASI",
                                    "Value": "SHAMCHURASI"
                                },
                                {
                                    "Text": "SHAMSABAD",
                                    "Value": "SHAMSABAD"
                                },
                                {
                                    "Text": "SHAMSABAD",
                                    "Value": "SHAMSABAD"
                                },
                                {
                                    "Text": "SHANKAR",
                                    "Value": "SHANKAR"
                                },
                                {
                                    "Text": "SHANKARGARH",
                                    "Value": "SHANKARGARH"
                                },
                                {
                                    "Text": "SHANKARPALLY",
                                    "Value": "SHANKARPALLY"
                                },
                                {
                                    "Text": "SHANPUNG",
                                    "Value": "SHANPUNG"
                                },
                                {
                                    "Text": "SHAPAR",
                                    "Value": "SHAPAR"
                                },
                                {
                                    "Text": "SHARJAH",
                                    "Value": "SHARJAH"
                                },
                                {
                                    "Text": "SHAHADA",
                                    "Value": "SHAHADA"
                                },
                                {
                                    "Text": "SAHIBABAD DAULAT PUR",
                                    "Value": "SAHIBABAD DAULAT PUR"
                                },
                                {
                                    "Text": "SHEGAON",
                                    "Value": "SHEGAON"
                                },
                                {
                                    "Text": "SHEIKHPURA",
                                    "Value": "SHEIKHPURA"
                                },
                                {
                                    "Text": "SHEKTA ",
                                    "Value": "SHEKTA "
                                },
                                {
                                    "Text": "SHELAR",
                                    "Value": "SHELAR"
                                },
                                {
                                    "Text": "SHENDRA MIDC AREA ",
                                    "Value": "SHENDRA MIDC AREA "
                                },
                                {
                                    "Text": "SHEOHAR",
                                    "Value": "SHEOHAR"
                                },
                                {
                                    "Text": "SHEOPUR",
                                    "Value": "SHEOPUR"
                                },
                                {
                                    "Text": "SHEOGA ",
                                    "Value": "SHEOGA "
                                },
                                {
                                    "Text": "SHERTALLY",
                                    "Value": "SHERTALLY"
                                },
                                {
                                    "Text": "SHERKOT",
                                    "Value": "SHERKOT"
                                },
                                {
                                    "Text": "SHERPURA",
                                    "Value": "SHERPURA"
                                },
                                {
                                    "Text": "SHIHOLI MOTI",
                                    "Value": "SHIHOLI MOTI"
                                },
                                {
                                    "Text": "SHIKOHABAD",
                                    "Value": "SHIKOHABAD"
                                },
                                {
                                    "Text": "SHIKOHPUR",
                                    "Value": "SHIKOHPUR"
                                },
                                {
                                    "Text": "SHIKRAPUR",
                                    "Value": "SHIKRAPUR"
                                },
                                {
                                    "Text": "SHILLONG",
                                    "Value": "SHILLONG"
                                },
                                {
                                    "Text": "SHILARU",
                                    "Value": "SHILARU"
                                },
                                {
                                    "Text": "SHIMLA",
                                    "Value": "SHIMLA"
                                },
                                {
                                    "Text": "SHIMOGA",
                                    "Value": "SHIMOGA"
                                },
                                {
                                    "Text": "SHINDEKELGAON ",
                                    "Value": "SHINDEKELGAON "
                                },
                                {
                                    "Text": "SHIRUR",
                                    "Value": "SHIRUR"
                                },
                                {
                                    "Text": "SHIRVAL",
                                    "Value": "SHIRVAL"
                                },
                                {
                                    "Text": "SHIRPUR",
                                    "Value": "SHIRPUR"
                                },
                                {
                                    "Text": "SHIRDI",
                                    "Value": "SHIRDI"
                                },
                                {
                                    "Text": "SHIRWAL",
                                    "Value": "SHIRWAL"
                                },
                                {
                                    "Text": "SHIVPURI",
                                    "Value": "SHIVPURI"
                                },
                                {
                                    "Text": "SHIVPUR ",
                                    "Value": "SHIVPUR "
                                },
                                {
                                    "Text": "SHALIMAR BAGH",
                                    "Value": "SHALIMAR BAGH"
                                },
                                {
                                    "Text": "SHOHRATGARH",
                                    "Value": "SHOHRATGARH"
                                },
                                {
                                    "Text": "SHOPIAN",
                                    "Value": "SHOPIAN"
                                },
                                {
                                    "Text": "SHORANUR",
                                    "Value": "SHORANUR"
                                },
                                {
                                    "Text": "SHERPUR",
                                    "Value": "SHERPUR"
                                },
                                {
                                    "Text": "SHRAWASTI",
                                    "Value": "SHRAWASTI"
                                },
                                {
                                    "Text": "SHRIRAMPUR",
                                    "Value": "SHRIRAMPUR"
                                },
                                {
                                    "Text": "SHRIGONDA",
                                    "Value": "SHRIGONDA"
                                },
                                {
                                    "Text": "SHUJALPUR",
                                    "Value": "SHUJALPUR"
                                },
                                {
                                    "Text": "SHUKARTAL BANGAR",
                                    "Value": "SHUKARTAL BANGAR"
                                },
                                {
                                    "Text": "SHUKLAGANJ",
                                    "Value": "SHUKLAGANJ"
                                },
                                {
                                    "Text": "SIBSAGAR",
                                    "Value": "SIBSAGAR"
                                },
                                {
                                    "Text": "SIBSAGAR",
                                    "Value": "SIBSAGAR"
                                },
                                {
                                    "Text": "SIDDIPET",
                                    "Value": "SIDDIPET"
                                },
                                {
                                    "Text": "SIDDHARTHNAGAR",
                                    "Value": "SIDDHARTHNAGAR"
                                },
                                {
                                    "Text": "SIDDALOOR ",
                                    "Value": "SIDDALOOR "
                                },
                                {
                                    "Text": "SIDHI",
                                    "Value": "SIDHI"
                                },
                                {
                                    "Text": "SIDHPUR",
                                    "Value": "SIDHPUR"
                                },
                                {
                                    "Text": "SIDHWAN BET",
                                    "Value": "SIDHWAN BET"
                                },
                                {
                                    "Text": "SIDSAR",
                                    "Value": "SIDSAR"
                                },
                                {
                                    "Text": "SIGNAL VILLAGE",
                                    "Value": "SIGNAL VILLAGE"
                                },
                                {
                                    "Text": "SIHORA",
                                    "Value": "SIHORA"
                                },
                                {
                                    "Text": "SIHOR",
                                    "Value": "SIHOR"
                                },
                                {
                                    "Text": "SIKAR",
                                    "Value": "SIKAR"
                                },
                                {
                                    "Text": "SIKANDERPUR BADHA",
                                    "Value": "SIKANDERPUR BADHA"
                                },
                                {
                                    "Text": "SIKANDRABAD",
                                    "Value": "SIKANDRABAD"
                                },
                                {
                                    "Text": "SIKHWALA",
                                    "Value": "SIKHWALA"
                                },
                                {
                                    "Text": "SILVASSA",
                                    "Value": "SILVASSA"
                                },
                                {
                                    "Text": "SILAI BARA GAON ",
                                    "Value": "SILAI BARA GAON "
                                },
                                {
                                    "Text": "SILCHAR",
                                    "Value": "SILCHAR"
                                },
                                {
                                    "Text": "SILIGURI",
                                    "Value": "SILIGURI"
                                },
                                {
                                    "Text": "SILLOD",
                                    "Value": "SILLOD"
                                },
                                {
                                    "Text": "SILVASSA",
                                    "Value": "SILVASSA"
                                },
                                {
                                    "Text": "SIMALIYA",
                                    "Value": "SIMALIYA"
                                },
                                {
                                    "Text": "SIMDEGA",
                                    "Value": "SIMDEGA"
                                },
                                {
                                    "Text": "SIMIKERI ",
                                    "Value": "SIMIKERI "
                                },
                                {
                                    "Text": "SIMINOI",
                                    "Value": "SIMINOI"
                                },
                                {
                                    "Text": "SINDHANUR",
                                    "Value": "SINDHANUR"
                                },
                                {
                                    "Text": "SINDHUDURG",
                                    "Value": "SINDHUDURG"
                                },
                                {
                                    "Text": "SINGRAULI",
                                    "Value": "SINGRAULI"
                                },
                                {
                                    "Text": "SINGHE WALA ",
                                    "Value": "SINGHE WALA "
                                },
                                {
                                    "Text": "SINGHAUR",
                                    "Value": "SINGHAUR"
                                },
                                {
                                    "Text": "SINGTAM",
                                    "Value": "SINGTAM"
                                },
                                {
                                    "Text": "SINNAR",
                                    "Value": "SINNAR"
                                },
                                {
                                    "Text": "SIOLIM",
                                    "Value": "SIOLIM"
                                },
                                {
                                    "Text": "SIPAHIJALA",
                                    "Value": "SIPAHIJALA"
                                },
                                {
                                    "Text": "SIRATHU",
                                    "Value": "SIRATHU"
                                },
                                {
                                    "Text": "SIRATHU",
                                    "Value": "SIRATHU"
                                },
                                {
                                    "Text": "SIRCAIM",
                                    "Value": "SIRCAIM"
                                },
                                {
                                    "Text": "SIRCILLA",
                                    "Value": "SIRCILLA"
                                },
                                {
                                    "Text": "SIRHIND",
                                    "Value": "SIRHIND"
                                },
                                {
                                    "Text": "SIRMOUR",
                                    "Value": "SIRMOUR"
                                },
                                {
                                    "Text": "SIRMAUR",
                                    "Value": "SIRMAUR"
                                },
                                {
                                    "Text": "SIRMINA ",
                                    "Value": "SIRMINA "
                                },
                                {
                                    "Text": "SIRONJ",
                                    "Value": "SIRONJ"
                                },
                                {
                                    "Text": "SIROHI",
                                    "Value": "SIROHI"
                                },
                                {
                                    "Text": "SIRSI",
                                    "Value": "SIRSI"
                                },
                                {
                                    "Text": "SIRSA",
                                    "Value": "SIRSA"
                                },
                                {
                                    "Text": "SISODARA",
                                    "Value": "SISODARA"
                                },
                                {
                                    "Text": "SISWA",
                                    "Value": "SISWA"
                                },
                                {
                                    "Text": "SITAPUR",
                                    "Value": "SITAPUR"
                                },
                                {
                                    "Text": "SITAMARHI",
                                    "Value": "SITAMARHI"
                                },
                                {
                                    "Text": "SITAPUR",
                                    "Value": "SITAPUR"
                                },
                                {
                                    "Text": "SITARGANJ",
                                    "Value": "SITARGANJ"
                                },
                                {
                                    "Text": "SITO GUNNO",
                                    "Value": "SITO GUNNO"
                                },
                                {
                                    "Text": "SIVAKASI",
                                    "Value": "SIVAKASI"
                                },
                                {
                                    "Text": "SIVAGANGA",
                                    "Value": "SIVAGANGA"
                                },
                                {
                                    "Text": "SIVAREDDYPET ",
                                    "Value": "SIVAREDDYPET "
                                },
                                {
                                    "Text": "SIVASAGAR",
                                    "Value": "SIVASAGAR"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SIWANI",
                                    "Value": "SIWANI"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SUKHRALI",
                                    "Value": "SUKHRALI"
                                },
                                {
                                    "Text": "SULTAN PUR",
                                    "Value": "SULTAN PUR"
                                },
                                {
                                    "Text": "SULTAN PUR MAJRA",
                                    "Value": "SULTAN PUR MAJRA"
                                },
                                {
                                    "Text": "SAMBHALKA",
                                    "Value": "SAMBHALKA"
                                },
                                {
                                    "Text": "SANGLI MIRAJ KUPWAD",
                                    "Value": "SANGLI MIRAJ KUPWAD"
                                },
                                {
                                    "Text": "SANGAREDDY",
                                    "Value": "SANGAREDDY"
                                },
                                {
                                    "Text": "SINGUR",
                                    "Value": "SINGUR"
                                },
                                {
                                    "Text": "SANPADA",
                                    "Value": "SANPADA"
                                },
                                {
                                    "Text": "SONARPUR",
                                    "Value": "SONARPUR"
                                },
                                {
                                    "Text": "SONAWARI",
                                    "Value": "SONAWARI"
                                },
                                {
                                    "Text": "SOHANA",
                                    "Value": "SOHANA"
                                },
                                {
                                    "Text": "SOHANPUR",
                                    "Value": "SOHANPUR"
                                },
                                {
                                    "Text": "SOHNA",
                                    "Value": "SOHNA"
                                },
                                {
                                    "Text": "SOJAT CITY",
                                    "Value": "SOJAT CITY"
                                },
                                {
                                    "Text": "SOLAN",
                                    "Value": "SOLAN"
                                },
                                {
                                    "Text": "SOLAPUR",
                                    "Value": "SOLAPUR"
                                },
                                {
                                    "Text": "SOLAIYA",
                                    "Value": "SOLAIYA"
                                },
                                {
                                    "Text": "SOMATANE",
                                    "Value": "SOMATANE"
                                },
                                {
                                    "Text": "SONAPUR",
                                    "Value": "SONAPUR"
                                },
                                {
                                    "Text": "SONBHADRA",
                                    "Value": "SONBHADRA"
                                },
                                {
                                    "Text": "SONEPAT",
                                    "Value": "SONEPAT"
                                },
                                {
                                    "Text": "SONEPUR",
                                    "Value": "SONEPUR"
                                },
                                {
                                    "Text": "SONIPAT",
                                    "Value": "SONIPAT"
                                },
                                {
                                    "Text": "SONITPUR",
                                    "Value": "SONITPUR"
                                },
                                {
                                    "Text": "SONJAMB",
                                    "Value": "SONJAMB"
                                },
                                {
                                    "Text": "SONPUR",
                                    "Value": "SONPUR"
                                },
                                {
                                    "Text": "SOPORE",
                                    "Value": "SOPORE"
                                },
                                {
                                    "Text": "SORAON",
                                    "Value": "SORAON"
                                },
                                {
                                    "Text": "SORUMONA PORIA",
                                    "Value": "SORUMONA PORIA"
                                },
                                {
                                    "Text": "SOUTH SIKKIM",
                                    "Value": "SOUTH SIKKIM"
                                },
                                {
                                    "Text": "SOUTH WEST DELHI",
                                    "Value": "SOUTH WEST DELHI"
                                },
                                {
                                    "Text": "SOUTH TRIPURA",
                                    "Value": "SOUTH TRIPURA"
                                },
                                {
                                    "Text": "SOUTH 24 PARGANAS",
                                    "Value": "SOUTH 24 PARGANAS"
                                },
                                {
                                    "Text": "SOUTH ANDAMAN",
                                    "Value": "SOUTH ANDAMAN"
                                },
                                {
                                    "Text": "SOUTH DELHI",
                                    "Value": "SOUTH DELHI"
                                },
                                {
                                    "Text": "SOUTH DINAJPUR",
                                    "Value": "SOUTH DINAJPUR"
                                },
                                {
                                    "Text": "SOUTH GARO HILLS",
                                    "Value": "SOUTH GARO HILLS"
                                },
                                {
                                    "Text": "SOUTH GOA",
                                    "Value": "SOUTH GOA"
                                },
                                {
                                    "Text": "SOUTH PARUR",
                                    "Value": "SOUTH PARUR"
                                },
                                {
                                    "Text": "SRI GANGANAGAR",
                                    "Value": "SRI GANGANAGAR"
                                },
                                {
                                    "Text": "SRI HARGOBINDPUR SAHIB",
                                    "Value": "SRI HARGOBINDPUR SAHIB"
                                },
                                {
                                    "Text": "SRIKAKULAM",
                                    "Value": "SRIKAKULAM"
                                },
                                {
                                    "Text": "SRIKALAHASTI",
                                    "Value": "SRIKALAHASTI"
                                },
                                {
                                    "Text": "SRIMADHOPUR",
                                    "Value": "SRIMADHOPUR"
                                },
                                {
                                    "Text": "SRINAGAR",
                                    "Value": "SRINAGAR"
                                },
                                {
                                    "Text": "SRINIVASPURAM ",
                                    "Value": "SRINIVASPURAM "
                                },
                                {
                                    "Text": "SRINAGAR",
                                    "Value": "SRINAGAR"
                                },
                                {
                                    "Text": "SRIPERUMBUDUR",
                                    "Value": "SRIPERUMBUDUR"
                                },
                                {
                                    "Text": "SRIRANGAM",
                                    "Value": "SRIRANGAM"
                                },
                                {
                                    "Text": "SRI VIJAYNAGAR",
                                    "Value": "SRI VIJAYNAGAR"
                                },
                                {
                                    "Text": "SURANKOTE",
                                    "Value": "SURANKOTE"
                                },
                                {
                                    "Text": "SIRAS PUR",
                                    "Value": "SIRAS PUR"
                                },
                                {
                                    "Text": "STN. GUNDRATHIMADUGU ",
                                    "Value": "STN. GUNDRATHIMADUGU "
                                },
                                {
                                    "Text": "SUALKUCHI",
                                    "Value": "SUALKUCHI"
                                },
                                {
                                    "Text": "SUBHASHNAGAR ",
                                    "Value": "SUBHASHNAGAR "
                                },
                                {
                                    "Text": "SUDHAIL",
                                    "Value": "SUDHAIL"
                                },
                                {
                                    "Text": "SUDHAR",
                                    "Value": "SUDHAR"
                                },
                                {
                                    "Text": "SUGHAD",
                                    "Value": "SUGHAD"
                                },
                                {
                                    "Text": "SUHRON ",
                                    "Value": "SUHRON "
                                },
                                {
                                    "Text": "SUJANGARH",
                                    "Value": "SUJANGARH"
                                },
                                {
                                    "Text": "SUJANPUR",
                                    "Value": "SUJANPUR"
                                },
                                {
                                    "Text": "SUKHAN WALA ",
                                    "Value": "SUKHAN WALA "
                                },
                                {
                                    "Text": "SUKHDEVPURA",
                                    "Value": "SUKHDEVPURA"
                                },
                                {
                                    "Text": "SUKHER",
                                    "Value": "SUKHER"
                                },
                                {
                                    "Text": "SULAH",
                                    "Value": "SULAH"
                                },
                                {
                                    "Text": "SULLIA",
                                    "Value": "SULLIA"
                                },
                                {
                                    "Text": "SULTANPUR",
                                    "Value": "SULTANPUR"
                                },
                                {
                                    "Text": "SULTAN BATTERY",
                                    "Value": "SULTAN BATTERY"
                                },
                                {
                                    "Text": "SULTANPUR",
                                    "Value": "SULTANPUR"
                                },
                                {
                                    "Text": "SULTANPUR LODHI",
                                    "Value": "SULTANPUR LODHI"
                                },
                                {
                                    "Text": "SULTANABAD",
                                    "Value": "SULTANABAD"
                                },
                                {
                                    "Text": "SULTHAN BATHERY",
                                    "Value": "SULTHAN BATHERY"
                                },
                                {
                                    "Text": "SULYA",
                                    "Value": "SULYA"
                                },
                                {
                                    "Text": "SUMERPUR",
                                    "Value": "SUMERPUR"
                                },
                                {
                                    "Text": "SUNABEDA",
                                    "Value": "SUNABEDA"
                                },
                                {
                                    "Text": "SUNAM",
                                    "Value": "SUNAM"
                                },
                                {
                                    "Text": "SUNDLI JUBBAL",
                                    "Value": "SUNDLI JUBBAL"
                                },
                                {
                                    "Text": "SUNDERGARH",
                                    "Value": "SUNDERGARH"
                                },
                                {
                                    "Text": "SUNDERNAGAR",
                                    "Value": "SUNDERNAGAR"
                                },
                                {
                                    "Text": "SUNDERBANI",
                                    "Value": "SUNDERBANI"
                                },
                                {
                                    "Text": "SUNDA ",
                                    "Value": "SUNDA "
                                },
                                {
                                    "Text": "SUNDARAPURAM",
                                    "Value": "SUNDARAPURAM"
                                },
                                {
                                    "Text": "SUNDARGARH",
                                    "Value": "SUNDARGARH"
                                },
                                {
                                    "Text": "SUNDARNAGAR",
                                    "Value": "SUNDARNAGAR"
                                },
                                {
                                    "Text": "SUNDLI -JUBBAL (JAI-PIDI)",
                                    "Value": "SUNDLI -JUBBAL (JAI-PIDI)"
                                },
                                {
                                    "Text": "SUPAUL",
                                    "Value": "SUPAUL"
                                },
                                {
                                    "Text": "SUPASI",
                                    "Value": "SUPASI"
                                },
                                {
                                    "Text": "SUPELA",
                                    "Value": "SUPELA"
                                },
                                {
                                    "Text": "SURATGARH",
                                    "Value": "SURATGARH"
                                },
                                {
                                    "Text": "SURAT",
                                    "Value": "SURAT"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURATHKAL",
                                    "Value": "SURATHKAL"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURENDRANAGAR",
                                    "Value": "SURENDRANAGAR"
                                },
                                {
                                    "Text": "SURENDRA NAGAR",
                                    "Value": "SURENDRA NAGAR"
                                },
                                {
                                    "Text": "SURGUJA",
                                    "Value": "SURGUJA"
                                },
                                {
                                    "Text": "SURI",
                                    "Value": "SURI"
                                },
                                {
                                    "Text": "SURLA ",
                                    "Value": "SURLA "
                                },
                                {
                                    "Text": "SURMA ",
                                    "Value": "SURMA "
                                },
                                {
                                    "Text": "SUR SINGH",
                                    "Value": "SUR SINGH"
                                },
                                {
                                    "Text": "SURYAPET",
                                    "Value": "SURYAPET"
                                },
                                {
                                    "Text": "SUSARI",
                                    "Value": "SUSARI"
                                },
                                {
                                    "Text": "SWARNAVARIGUDEM ",
                                    "Value": "SWARNAVARIGUDEM "
                                },
                                {
                                    "Text": "TADA",
                                    "Value": "TADA"
                                },
                                {
                                    "Text": "TADEPALLIGUDEM",
                                    "Value": "TADEPALLIGUDEM"
                                },
                                {
                                    "Text": "TADEGAON ",
                                    "Value": "TADEGAON "
                                },
                                {
                                    "Text": "TADIPATRI",
                                    "Value": "TADIPATRI"
                                },
                                {
                                    "Text": "TADLAPOOSALAPALLI ",
                                    "Value": "TADLAPOOSALAPALLI "
                                },
                                {
                                    "Text": "TADPATRI",
                                    "Value": "TADPATRI"
                                },
                                {
                                    "Text": "TADUVAI ",
                                    "Value": "TADUVAI "
                                },
                                {
                                    "Text": "TAHLIWAL ",
                                    "Value": "TAHLIWAL "
                                },
                                {
                                    "Text": "TAHLIWALA JATTAN",
                                    "Value": "TAHLIWALA JATTAN"
                                },
                                {
                                    "Text": "TAJANGI ",
                                    "Value": "TAJANGI "
                                },
                                {
                                    "Text": "TAJ PUL",
                                    "Value": "TAJ PUL"
                                },
                                {
                                    "Text": "TAKAVE BUDRUK",
                                    "Value": "TAKAVE BUDRUK"
                                },
                                {
                                    "Text": "TAKALIMIYA",
                                    "Value": "TAKALIMIYA"
                                },
                                {
                                    "Text": "TAKAVE BUDRUK",
                                    "Value": "TAKAVE BUDRUK"
                                },
                                {
                                    "Text": "TAKHU CHAK",
                                    "Value": "TAKHU CHAK"
                                },
                                {
                                    "Text": "TAKHATPUR",
                                    "Value": "TAKHATPUR"
                                },
                                {
                                    "Text": "TAKHU CHAK",
                                    "Value": "TAKHU CHAK"
                                },
                                {
                                    "Text": "TAKKELLA PAHAD ",
                                    "Value": "TAKKELLA PAHAD "
                                },
                                {
                                    "Text": "TALAJA",
                                    "Value": "TALAJA"
                                },
                                {
                                    "Text": "TALALA",
                                    "Value": "TALALA"
                                },
                                {
                                    "Text": "TALCHER",
                                    "Value": "TALCHER"
                                },
                                {
                                    "Text": "TALEGAON",
                                    "Value": "TALEGAON"
                                },
                                {
                                    "Text": "TALEKODE",
                                    "Value": "TALEKODE"
                                },
                                {
                                    "Text": "TALEKODE WEST ",
                                    "Value": "TALEKODE WEST "
                                },
                                {
                                    "Text": "TALEGAON DABHADE",
                                    "Value": "TALEGAON DABHADE"
                                },
                                {
                                    "Text": "TALHAN",
                                    "Value": "TALHAN"
                                },
                                {
                                    "Text": "TALIPARAMBA",
                                    "Value": "TALIPARAMBA"
                                },
                                {
                                    "Text": "TALIKULAM",
                                    "Value": "TALIKULAM"
                                },
                                {
                                    "Text": "TALLAPOLAM ",
                                    "Value": "TALLAPOLAM "
                                },
                                {
                                    "Text": "TALOD",
                                    "Value": "TALOD"
                                },
                                {
                                    "Text": "TALOJE MAJKUR",
                                    "Value": "TALOJE MAJKUR"
                                },
                                {
                                    "Text": "TALWANDI SABO",
                                    "Value": "TALWANDI SABO"
                                },
                                {
                                    "Text": "TALWARA TOWNSHIP",
                                    "Value": "TALWARA TOWNSHIP"
                                },
                                {
                                    "Text": "TALWAN",
                                    "Value": "TALWAN"
                                },
                                {
                                    "Text": "TALWANDI BHAI",
                                    "Value": "TALWANDI BHAI"
                                },
                                {
                                    "Text": "TALWANDI CHAUDRIAN",
                                    "Value": "TALWANDI CHAUDRIAN"
                                },
                                {
                                    "Text": "TALWARA",
                                    "Value": "TALWARA"
                                },
                                {
                                    "Text": "TAMENGLONG",
                                    "Value": "TAMENGLONG"
                                },
                                {
                                    "Text": "TAMLUK",
                                    "Value": "TAMLUK"
                                },
                                {
                                    "Text": "TANDUR",
                                    "Value": "TANDUR"
                                },
                                {
                                    "Text": "TANDA",
                                    "Value": "TANDA"
                                },
                                {
                                    "Text": "TANDEMVALASA ",
                                    "Value": "TANDEMVALASA "
                                },
                                {
                                    "Text": "TANGI",
                                    "Value": "TANGI"
                                },
                                {
                                    "Text": "TANGRA",
                                    "Value": "TANGRA"
                                },
                                {
                                    "Text": "TANKARA",
                                    "Value": "TANKARA"
                                },
                                {
                                    "Text": "TANKARA",
                                    "Value": "TANKARA"
                                },
                                {
                                    "Text": "TANKUA",
                                    "Value": "TANKUA"
                                },
                                {
                                    "Text": "TANUKU",
                                    "Value": "TANUKU"
                                },
                                {
                                    "Text": "TAORU",
                                    "Value": "TAORU"
                                },
                                {
                                    "Text": "TAPA MANDI",
                                    "Value": "TAPA MANDI"
                                },
                                {
                                    "Text": "TAPA",
                                    "Value": "TAPA"
                                },
                                {
                                    "Text": "TAPI",
                                    "Value": "TAPI"
                                },
                                {
                                    "Text": "TAPOKDA",
                                    "Value": "TAPOKDA"
                                },
                                {
                                    "Text": "TARAORI",
                                    "Value": "TARAORI"
                                },
                                {
                                    "Text": "TARA ",
                                    "Value": "TARA "
                                },
                                {
                                    "Text": "TARAGARH",
                                    "Value": "TARAGARH"
                                },
                                {
                                    "Text": "TARAKESWAR",
                                    "Value": "TARAKESWAR"
                                },
                                {
                                    "Text": "TARAPUR",
                                    "Value": "TARAPUR"
                                },
                                {
                                    "Text": "TAREWALA ",
                                    "Value": "TAREWALA "
                                },
                                {
                                    "Text": "TARN TARAN",
                                    "Value": "TARN TARAN"
                                },
                                {
                                    "Text": "TARSIKKA",
                                    "Value": "TARSIKKA"
                                },
                                {
                                    "Text": "TARSOD",
                                    "Value": "TARSOD"
                                },
                                {
                                    "Text": "TASGAON",
                                    "Value": "TASGAON"
                                },
                                {
                                    "Text": "TATTEKERE ",
                                    "Value": "TATTEKERE "
                                },
                                {
                                    "Text": "TAWANG",
                                    "Value": "TAWANG"
                                },
                                {
                                    "Text": "TEHNA ",
                                    "Value": "TEHNA "
                                },
                                {
                                    "Text": "TEHRI GARHWAL",
                                    "Value": "TEHRI GARHWAL"
                                },
                                {
                                    "Text": "TEHRI",
                                    "Value": "TEHRI"
                                },
                                {
                                    "Text": "TEHSIL DADRI",
                                    "Value": "TEHSIL DADRI"
                                },
                                {
                                    "Text": "TEHSIL JEWAR",
                                    "Value": "TEHSIL JEWAR"
                                },
                                {
                                    "Text": "TEHSIL PHILLAUR",
                                    "Value": "TEHSIL PHILLAUR"
                                },
                                {
                                    "Text": "TEHSIL SADAR",
                                    "Value": "TEHSIL SADAR"
                                },
                                {
                                    "Text": "TEKRIYAL ",
                                    "Value": "TEKRIYAL "
                                },
                                {
                                    "Text": "TENALI",
                                    "Value": "TENALI"
                                },
                                {
                                    "Text": "TEEN BATTI",
                                    "Value": "TEEN BATTI"
                                },
                                {
                                    "Text": "TENKASI",
                                    "Value": "TENKASI"
                                },
                                {
                                    "Text": "TEZPUR",
                                    "Value": "TEZPUR"
                                },
                                {
                                    "Text": "TEZU",
                                    "Value": "TEZU"
                                },
                                {
                                    "Text": "THADIKAL",
                                    "Value": "THADIKAL"
                                },
                                {
                                    "Text": "THALASSERY",
                                    "Value": "THALASSERY"
                                },
                                {
                                    "Text": "THAMARASSERY",
                                    "Value": "THAMARASSERY"
                                },
                                {
                                    "Text": "THANGADH",
                                    "Value": "THANGADH"
                                },
                                {
                                    "Text": "THANE",
                                    "Value": "THANE"
                                },
                                {
                                    "Text": "THANJAVUR",
                                    "Value": "THANJAVUR"
                                },
                                {
                                    "Text": "THANA CHAPPAR",
                                    "Value": "THANA CHAPPAR"
                                },
                                {
                                    "Text": "THANESAR",
                                    "Value": "THANESAR"
                                },
                                {
                                    "Text": "THANNEERMUKKAM",
                                    "Value": "THANNEERMUKKAM"
                                },
                                {
                                    "Text": "THARU ",
                                    "Value": "THARU "
                                },
                                {
                                    "Text": "THARAJ",
                                    "Value": "THARAJ"
                                },
                                {
                                    "Text": "THASKA KHADAR",
                                    "Value": "THASKA KHADAR"
                                },
                                {
                                    "Text": "THATHI KHARA ",
                                    "Value": "THATHI KHARA "
                                },
                                {
                                    "Text": "THE DANGS",
                                    "Value": "THE DANGS"
                                },
                                {
                                    "Text": "THENI",
                                    "Value": "THENI"
                                },
                                {
                                    "Text": "THEOG",
                                    "Value": "THEOG"
                                },
                                {
                                    "Text": "THIRUVANANTHAPURAM",
                                    "Value": "THIRUVANANTHAPURAM"
                                },
                                {
                                    "Text": "THIRKKAKARA",
                                    "Value": "THIRKKAKARA"
                                },
                                {
                                    "Text": "THIRTHAHALLI",
                                    "Value": "THIRTHAHALLI"
                                },
                                {
                                    "Text": "THIRUMANGALAM",
                                    "Value": "THIRUMANGALAM"
                                },
                                {
                                    "Text": "THIRUVALLUR",
                                    "Value": "THIRUVALLUR"
                                },
                                {
                                    "Text": "THIRUVARUR",
                                    "Value": "THIRUVARUR"
                                },
                                {
                                    "Text": "THIRUVERAMBUR",
                                    "Value": "THIRUVERAMBUR"
                                },
                                {
                                    "Text": "THIRUVILWAMALA",
                                    "Value": "THIRUVILWAMALA"
                                },
                                {
                                    "Text": "THIRUVOTTIYUR",
                                    "Value": "THIRUVOTTIYUR"
                                },
                                {
                                    "Text": "THISAYANVILAI",
                                    "Value": "THISAYANVILAI"
                                },
                                {
                                    "Text": "THODUPUZHA",
                                    "Value": "THODUPUZHA"
                                },
                                {
                                    "Text": "THORRUR",
                                    "Value": "THORRUR"
                                },
                                {
                                    "Text": "THOUBAL",
                                    "Value": "THOUBAL"
                                },
                                {
                                    "Text": "THRISSUR",
                                    "Value": "THRISSUR"
                                },
                                {
                                    "Text": "THRIPUNITHURA",
                                    "Value": "THRIPUNITHURA"
                                },
                                {
                                    "Text": "THROADIPATTU ",
                                    "Value": "THROADIPATTU "
                                },
                                {
                                    "Text": "THUCKALAY",
                                    "Value": "THUCKALAY"
                                },
                                {
                                    "Text": "THUMBOOR",
                                    "Value": "THUMBOOR"
                                },
                                {
                                    "Text": "THUNGAPAHAD ",
                                    "Value": "THUNGAPAHAD "
                                },
                                {
                                    "Text": "TIBRI",
                                    "Value": "TIBRI"
                                },
                                {
                                    "Text": "TIGAON",
                                    "Value": "TIGAON"
                                },
                                {
                                    "Text": "TIGRANA",
                                    "Value": "TIGRANA"
                                },
                                {
                                    "Text": "TIKAMGARH",
                                    "Value": "TIKAMGARH"
                                },
                                {
                                    "Text": "TILDA",
                                    "Value": "TILDA"
                                },
                                {
                                    "Text": "TILHAR",
                                    "Value": "TILHAR"
                                },
                                {
                                    "Text": "TILPAT",
                                    "Value": "TILPAT"
                                },
                                {
                                    "Text": "TINIDVANAM",
                                    "Value": "TINIDVANAM"
                                },
                                {
                                    "Text": "TINSUKIA",
                                    "Value": "TINSUKIA"
                                },
                                {
                                    "Text": "TIPTUR",
                                    "Value": "TIPTUR"
                                },
                                {
                                    "Text": "TIRAP",
                                    "Value": "TIRAP"
                                },
                                {
                                    "Text": "TIRUR",
                                    "Value": "TIRUR"
                                },
                                {
                                    "Text": "TIRUVALLA",
                                    "Value": "TIRUVALLA"
                                },
                                {
                                    "Text": "TIRUCHIRAPPALLI",
                                    "Value": "TIRUCHIRAPPALLI"
                                },
                                {
                                    "Text": "TIRUNELVELI",
                                    "Value": "TIRUNELVELI"
                                },
                                {
                                    "Text": "TIRUVALLUR",
                                    "Value": "TIRUVALLUR"
                                },
                                {
                                    "Text": "TIRUVANNAMALAI",
                                    "Value": "TIRUVANNAMALAI"
                                },
                                {
                                    "Text": "TIRUVARUR",
                                    "Value": "TIRUVARUR"
                                },
                                {
                                    "Text": "TIRUCHENGODE",
                                    "Value": "TIRUCHENGODE"
                                },
                                {
                                    "Text": "TIRUCHENDUR",
                                    "Value": "TIRUCHENDUR"
                                },
                                {
                                    "Text": "TIRUKOLLUR",
                                    "Value": "TIRUKOLLUR"
                                },
                                {
                                    "Text": "TIRUPATI",
                                    "Value": "TIRUPATI"
                                },
                                {
                                    "Text": "TIRUVURU",
                                    "Value": "TIRUVURU"
                                },
                                {
                                    "Text": "TIRUPATTUR",
                                    "Value": "TIRUPATTUR"
                                },
                                {
                                    "Text": "TIRUPUR",
                                    "Value": "TIRUPUR"
                                },
                                {
                                    "Text": "TIRUCHIRAPALLI",
                                    "Value": "TIRUCHIRAPALLI"
                                },
                                {
                                    "Text": "TIRUPATHUR",
                                    "Value": "TIRUPATHUR"
                                },
                                {
                                    "Text": "TIRUPPUR",
                                    "Value": "TIRUPPUR"
                                },
                                {
                                    "Text": "TIRUVILLA",
                                    "Value": "TIRUVILLA"
                                },
                                {
                                    "Text": "TIRUVUR",
                                    "Value": "TIRUVUR"
                                },
                                {
                                    "Text": "TIRWAGANJ",
                                    "Value": "TIRWAGANJ"
                                },
                                {
                                    "Text": "TITLAGARH",
                                    "Value": "TITLAGARH"
                                },
                                {
                                    "Text": "TALALA  GIR",
                                    "Value": "TALALA  GIR"
                                },
                                {
                                    "Text": "TANDA",
                                    "Value": "TANDA"
                                },
                                {
                                    "Text": "TOHANA",
                                    "Value": "TOHANA"
                                },
                                {
                                    "Text": "TONK",
                                    "Value": "TONK"
                                },
                                {
                                    "Text": "TORLIKONDA ",
                                    "Value": "TORLIKONDA "
                                },
                                {
                                    "Text": "TOSHAM",
                                    "Value": "TOSHAM"
                                },
                                {
                                    "Text": "TOTU",
                                    "Value": "TOTU"
                                },
                                {
                                    "Text": "TOWN BHONGIRI ",
                                    "Value": "TOWN BHONGIRI "
                                },
                                {
                                    "Text": "TRAL",
                                    "Value": "TRAL"
                                },
                                {
                                    "Text": "TRANOL",
                                    "Value": "TRANOL"
                                },
                                {
                                    "Text": "TRICHY",
                                    "Value": "TRICHY"
                                },
                                {
                                    "Text": "TRICHUR",
                                    "Value": "TRICHUR"
                                },
                                {
                                    "Text": "TRIMBAKESHWAR",
                                    "Value": "TRIMBAKESHWAR"
                                },
                                {
                                    "Text": "TRIPUNITHURA",
                                    "Value": "TRIPUNITHURA"
                                },
                                {
                                    "Text": "TRIPURA",
                                    "Value": "TRIPURA"
                                },
                                {
                                    "Text": "TRIPURARAM ",
                                    "Value": "TRIPURARAM "
                                },
                                {
                                    "Text": "TRIPRAYAR",
                                    "Value": "TRIPRAYAR"
                                },
                                {
                                    "Text": "TRIVANDRUM",
                                    "Value": "TRIVANDRUM"
                                },
                                {
                                    "Text": "TROMBAY",
                                    "Value": "TROMBAY"
                                },
                                {
                                    "Text": "TUENSANG",
                                    "Value": "TUENSANG"
                                },
                                {
                                    "Text": "TULSIPUR",
                                    "Value": "TULSIPUR"
                                },
                                {
                                    "Text": "TUMKUR",
                                    "Value": "TUMKUR"
                                },
                                {
                                    "Text": "TUMSAR",
                                    "Value": "TUMSAR"
                                },
                                {
                                    "Text": "TUNDLA",
                                    "Value": "TUNDLA"
                                },
                                {
                                    "Text": "TUNI",
                                    "Value": "TUNI"
                                },
                                {
                                    "Text": "TURA",
                                    "Value": "TURA"
                                },
                                {
                                    "Text": "TURAKAPETA ",
                                    "Value": "TURAKAPETA "
                                },
                                {
                                    "Text": "TURBHE",
                                    "Value": "TURBHE"
                                },
                                {
                                    "Text": "TUTICORIN",
                                    "Value": "TUTICORIN"
                                },
                                {
                                    "Text": "UCHANA KALAN",
                                    "Value": "UCHANA KALAN"
                                },
                                {
                                    "Text": "UDAIPUR",
                                    "Value": "UDAIPUR"
                                },
                                {
                                    "Text": "UDAIPUR ",
                                    "Value": "UDAIPUR "
                                },
                                {
                                    "Text": "UDAIPUR",
                                    "Value": "UDAIPUR"
                                },
                                {
                                    "Text": "UDALGURI",
                                    "Value": "UDALGURI"
                                },
                                {
                                    "Text": "UDGIR",
                                    "Value": "UDGIR"
                                },
                                {
                                    "Text": "UDHAM SINGH NAGAR",
                                    "Value": "UDHAM SINGH NAGAR"
                                },
                                {
                                    "Text": "UDHAMPUR",
                                    "Value": "UDHAMPUR"
                                },
                                {
                                    "Text": "UDUMALPET",
                                    "Value": "UDUMALPET"
                                },
                                {
                                    "Text": "UDUMALAIPETTAI",
                                    "Value": "UDUMALAIPETTAI"
                                },
                                {
                                    "Text": "UDUPI",
                                    "Value": "UDUPI"
                                },
                                {
                                    "Text": "UDWADA",
                                    "Value": "UDWADA"
                                },
                                {
                                    "Text": "UGANI ",
                                    "Value": "UGANI "
                                },
                                {
                                    "Text": "UGGI",
                                    "Value": "UGGI"
                                },
                                {
                                    "Text": "UGRAWAI ",
                                    "Value": "UGRAWAI "
                                },
                                {
                                    "Text": "UGRA KHERI",
                                    "Value": "UGRA KHERI"
                                },
                                {
                                    "Text": "UJHANI",
                                    "Value": "UJHANI"
                                },
                                {
                                    "Text": "UJIRE",
                                    "Value": "UJIRE"
                                },
                                {
                                    "Text": "UJJAIN",
                                    "Value": "UJJAIN"
                                },
                                {
                                    "Text": "UKHRUL",
                                    "Value": "UKHRUL"
                                },
                                {
                                    "Text": "UKLANA MANDI",
                                    "Value": "UKLANA MANDI"
                                },
                                {
                                    "Text": "ULHASNAGAR",
                                    "Value": "ULHASNAGAR"
                                },
                                {
                                    "Text": "ULIMELLA ",
                                    "Value": "ULIMELLA "
                                },
                                {
                                    "Text": "ULLUBERIA",
                                    "Value": "ULLUBERIA"
                                },
                                {
                                    "Text": "ULUBERIA",
                                    "Value": "ULUBERIA"
                                },
                                {
                                    "Text": "UMARIA",
                                    "Value": "UMARIA"
                                },
                                {
                                    "Text": "UMBERGOAN",
                                    "Value": "UMBERGOAN"
                                },
                                {
                                    "Text": "UMBERGOAN",
                                    "Value": "UMBERGOAN"
                                },
                                {
                                    "Text": "UMBRAJ",
                                    "Value": "UMBRAJ"
                                },
                                {
                                    "Text": "UMRED",
                                    "Value": "UMRED"
                                },
                                {
                                    "Text": "UNA",
                                    "Value": "UNA"
                                },
                                {
                                    "Text": "UNA",
                                    "Value": "UNA"
                                },
                                {
                                    "Text": "UNAKOTI",
                                    "Value": "UNAKOTI"
                                },
                                {
                                    "Text": "UNCHAHAR",
                                    "Value": "UNCHAHAR"
                                },
                                {
                                    "Text": "UNJHA",
                                    "Value": "UNJHA"
                                },
                                {
                                    "Text": "UNNAO",
                                    "Value": "UNNAO"
                                },
                                {
                                    "Text": "UNTSAL",
                                    "Value": "UNTSAL"
                                },
                                {
                                    "Text": "UPLETA",
                                    "Value": "UPLETA"
                                },
                                {
                                    "Text": "UPPER SIANG",
                                    "Value": "UPPER SIANG"
                                },
                                {
                                    "Text": "UPPER SUBANSIRI",
                                    "Value": "UPPER SUBANSIRI"
                                },
                                {
                                    "Text": "UPPINIVALASA ",
                                    "Value": "UPPINIVALASA "
                                },
                                {
                                    "Text": "UPPUR ",
                                    "Value": "UPPUR "
                                },
                                {
                                    "Text": "URALI KANCHAN",
                                    "Value": "URALI KANCHAN"
                                },
                                {
                                    "Text": "URAN ISLAMPUR",
                                    "Value": "URAN ISLAMPUR"
                                },
                                {
                                    "Text": "URAN",
                                    "Value": "URAN"
                                },
                                {
                                    "Text": "URMAR TANDA",
                                    "Value": "URMAR TANDA"
                                },
                                {
                                    "Text": "URSE",
                                    "Value": "URSE"
                                },
                                {
                                    "Text": "USGAO",
                                    "Value": "USGAO"
                                },
                                {
                                    "Text": "U.T OF DADRA & NAGAR HAVELI",
                                    "Value": "U.T OF DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "UTLAPALLY ",
                                    "Value": "UTLAPALLY "
                                },
                                {
                                    "Text": "U.T OF DADRA & NAGAR HAVELI",
                                    "Value": "U.T OF DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "UTTARPARA",
                                    "Value": "UTTARPARA"
                                },
                                {
                                    "Text": "UTRAULA",
                                    "Value": "UTRAULA"
                                },
                                {
                                    "Text": "UTTARA KANNADA",
                                    "Value": "UTTARA KANNADA"
                                },
                                {
                                    "Text": "UTTARKASHI",
                                    "Value": "UTTARKASHI"
                                },
                                {
                                    "Text": "UTTAR DINAJPUR",
                                    "Value": "UTTAR DINAJPUR"
                                },
                                {
                                    "Text": "UTWAD ",
                                    "Value": "UTWAD "
                                },
                                {
                                    "Text": "VADALI",
                                    "Value": "VADALI"
                                },
                                {
                                    "Text": "VADAKARA",
                                    "Value": "VADAKARA"
                                },
                                {
                                    "Text": "VADAKKANCHERI",
                                    "Value": "VADAKKANCHERI"
                                },
                                {
                                    "Text": "VADAVALLI",
                                    "Value": "VADAVALLI"
                                },
                                {
                                    "Text": "VADDIPA ",
                                    "Value": "VADDIPA "
                                },
                                {
                                    "Text": "VADLAKONDA ",
                                    "Value": "VADLAKONDA "
                                },
                                {
                                    "Text": "VADODARA",
                                    "Value": "VADODARA"
                                },
                                {
                                    "Text": "VADUJ",
                                    "Value": "VADUJ"
                                },
                                {
                                    "Text": "VADUJ",
                                    "Value": "VADUJ"
                                },
                                {
                                    "Text": "VAIJAPUR",
                                    "Value": "VAIJAPUR"
                                },
                                {
                                    "Text": "VAIKOM",
                                    "Value": "VAIKOM"
                                },
                                {
                                    "Text": "VAISHALI",
                                    "Value": "VAISHALI"
                                },
                                {
                                    "Text": "VALANCHERY",
                                    "Value": "VALANCHERY"
                                },
                                {
                                    "Text": "VALLIOOR",
                                    "Value": "VALLIOOR"
                                },
                                {
                                    "Text": "VALLABH VIDHYA NAGAR",
                                    "Value": "VALLABH VIDHYA NAGAR"
                                },
                                {
                                    "Text": "VALPOI",
                                    "Value": "VALPOI"
                                },
                                {
                                    "Text": "VALSAD",
                                    "Value": "VALSAD"
                                },
                                {
                                    "Text": "VALSARVAKKAM",
                                    "Value": "VALSARVAKKAM"
                                },
                                {
                                    "Text": "VANAGARAM",
                                    "Value": "VANAGARAM"
                                },
                                {
                                    "Text": "VANASGAON",
                                    "Value": "VANASGAON"
                                },
                                {
                                    "Text": "VANGANI",
                                    "Value": "VANGANI"
                                },
                                {
                                    "Text": "VANIYAMBADI",
                                    "Value": "VANIYAMBADI"
                                },
                                {
                                    "Text": "VANNANKULAM",
                                    "Value": "VANNANKULAM"
                                },
                                {
                                    "Text": "VANNEL K",
                                    "Value": "VANNEL K"
                                },
                                {
                                    "Text": "VANSDA",
                                    "Value": "VANSDA"
                                },
                                {
                                    "Text": "VAPI",
                                    "Value": "VAPI"
                                },
                                {
                                    "Text": "VARANASI",
                                    "Value": "VARANASI"
                                },
                                {
                                    "Text": "VARCA",
                                    "Value": "VARCA"
                                },
                                {
                                    "Text": "VARKALA",
                                    "Value": "VARKALA"
                                },
                                {
                                    "Text": "VARSAMEDI",
                                    "Value": "VARSAMEDI"
                                },
                                {
                                    "Text": "VASAI",
                                    "Value": "VASAI"
                                },
                                {
                                    "Text": "VASAD",
                                    "Value": "VASAD"
                                },
                                {
                                    "Text": "VASCO",
                                    "Value": "VASCO"
                                },
                                {
                                    "Text": "VASHI",
                                    "Value": "VASHI"
                                },
                                {
                                    "Text": "VASAI ROAD",
                                    "Value": "VASAI ROAD"
                                },
                                {
                                    "Text": "VATAKARA",
                                    "Value": "VATAKARA"
                                },
                                {
                                    "Text": "VATANAPPILLY",
                                    "Value": "VATANAPPILLY"
                                },
                                {
                                    "Text": "VATANAPPALLY",
                                    "Value": "VATANAPPALLY"
                                },
                                {
                                    "Text": "VAVDI",
                                    "Value": "VAVDI"
                                },
                                {
                                    "Text": "VAVILALA ",
                                    "Value": "VAVILALA "
                                },
                                {
                                    "Text": "VAZHAPADI ",
                                    "Value": "VAZHAPADI "
                                },
                                {
                                    "Text": "VALLABHIPUR",
                                    "Value": "VALLABHIPUR"
                                },
                                {
                                    "Text": "VEERLAPALEM ",
                                    "Value": "VEERLAPALEM "
                                },
                                {
                                    "Text": "VEERANNAPALEM ",
                                    "Value": "VEERANNAPALEM "
                                },
                                {
                                    "Text": "VEGAVARAM ",
                                    "Value": "VEGAVARAM "
                                },
                                {
                                    "Text": "VEJALPUR",
                                    "Value": "VEJALPUR"
                                },
                                {
                                    "Text": "VEJALPUR",
                                    "Value": "VEJALPUR"
                                },
                                {
                                    "Text": "VELIYANAD",
                                    "Value": "VELIYANAD"
                                },
                                {
                                    "Text": "VELLORE",
                                    "Value": "VELLORE"
                                },
                                {
                                    "Text": "VELLA ",
                                    "Value": "VELLA "
                                },
                                {
                                    "Text": "VELLIMALAI ",
                                    "Value": "VELLIMALAI "
                                },
                                {
                                    "Text": "VEMNOOR ",
                                    "Value": "VEMNOOR "
                                },
                                {
                                    "Text": "VEMULAKURTHI",
                                    "Value": "VEMULAKURTHI"
                                },
                                {
                                    "Text": "VEMULAWADA",
                                    "Value": "VEMULAWADA"
                                },
                                {
                                    "Text": "VENGALA RAO COLONY ",
                                    "Value": "VENGALA RAO COLONY "
                                },
                                {
                                    "Text": "VENKATAGIRI",
                                    "Value": "VENKATAGIRI"
                                },
                                {
                                    "Text": "VENKATADRI PALEM ",
                                    "Value": "VENKATADRI PALEM "
                                },
                                {
                                    "Text": "VENKATAPURAM ",
                                    "Value": "VENKATAPURAM "
                                },
                                {
                                    "Text": "VENKATAGIRIKOTE ",
                                    "Value": "VENKATAGIRIKOTE "
                                },
                                {
                                    "Text": "VENTURU ",
                                    "Value": "VENTURU "
                                },
                                {
                                    "Text": "VERAVAL",
                                    "Value": "VERAVAL"
                                },
                                {
                                    "Text": "VEREM",
                                    "Value": "VEREM"
                                },
                                {
                                    "Text": "VERNA",
                                    "Value": "VERNA"
                                },
                                {
                                    "Text": "VERNA",
                                    "Value": "VERNA"
                                },
                                {
                                    "Text": "VICARABAD",
                                    "Value": "VICARABAD"
                                },
                                {
                                    "Text": "VIDISHA",
                                    "Value": "VIDISHA"
                                },
                                {
                                    "Text": "VIJAPUR",
                                    "Value": "VIJAPUR"
                                },
                                {
                                    "Text": "VIJAYWADA",
                                    "Value": "VIJAYWADA"
                                },
                                {
                                    "Text": "VIJAYANAGAR III STAGE ",
                                    "Value": "VIJAYANAGAR III STAGE "
                                },
                                {
                                    "Text": "VIJAINAGAR",
                                    "Value": "VIJAINAGAR"
                                },
                                {
                                    "Text": "VIJAIPUR",
                                    "Value": "VIJAIPUR"
                                },
                                {
                                    "Text": "VIJAYAWADA",
                                    "Value": "VIJAYAWADA"
                                },
                                {
                                    "Text": "VIJAYPURA",
                                    "Value": "VIJAYPURA"
                                },
                                {
                                    "Text": "VIKASNAGAR",
                                    "Value": "VIKASNAGAR"
                                },
                                {
                                    "Text": "VIKRAMGAD",
                                    "Value": "VIKRAMGAD"
                                },
                                {
                                    "Text": "VILLUPURAM",
                                    "Value": "VILLUPURAM"
                                },
                                {
                                    "Text": "VINUKONDA",
                                    "Value": "VINUKONDA"
                                },
                                {
                                    "Text": "VIRAMGAM",
                                    "Value": "VIRAMGAM"
                                },
                                {
                                    "Text": "VIRAR",
                                    "Value": "VIRAR"
                                },
                                {
                                    "Text": "VIRAJPET",
                                    "Value": "VIRAJPET"
                                },
                                {
                                    "Text": "VIRUDHUNAGAR",
                                    "Value": "VIRUDHUNAGAR"
                                },
                                {
                                    "Text": "VISAKHAPATNAM",
                                    "Value": "VISAKHAPATNAM"
                                },
                                {
                                    "Text": "VISAVADAR",
                                    "Value": "VISAVADAR"
                                },
                                {
                                    "Text": "VISNAGAR",
                                    "Value": "VISNAGAR"
                                },
                                {
                                    "Text": "VITA",
                                    "Value": "VITA"
                                },
                                {
                                    "Text": "VIZIANAGARAM",
                                    "Value": "VIZIANAGARAM"
                                },
                                {
                                    "Text": "VAJRESHWARI",
                                    "Value": "VAJRESHWARI"
                                },
                                {
                                    "Text": "VIKASPURI",
                                    "Value": "VIKASPURI"
                                },
                                {
                                    "Text": "VIMAN NAGAR",
                                    "Value": "VIMAN NAGAR"
                                },
                                {
                                    "Text": "VENGURLA",
                                    "Value": "VENGURLA"
                                },
                                {
                                    "Text": "VRINDAVAN",
                                    "Value": "VRINDAVAN"
                                },
                                {
                                    "Text": "VERSOVA",
                                    "Value": "VERSOVA"
                                },
                                {
                                    "Text": "VASHIND",
                                    "Value": "VASHIND"
                                },
                                {
                                    "Text": "VASNA",
                                    "Value": "VASNA"
                                },
                                {
                                    "Text": "VITHALWADI",
                                    "Value": "VITHALWADI"
                                },
                                {
                                    "Text": "VAITARNA",
                                    "Value": "VAITARNA"
                                },
                                {
                                    "Text": "VUYYURU",
                                    "Value": "VUYYURU"
                                },
                                {
                                    "Text": "VYARA",
                                    "Value": "VYARA"
                                },
                                {
                                    "Text": "WADAKANCHERY",
                                    "Value": "WADAKANCHERY"
                                },
                                {
                                    "Text": "WADAPARTHY ",
                                    "Value": "WADAPARTHY "
                                },
                                {
                                    "Text": "WADALA KALAN ",
                                    "Value": "WADALA KALAN "
                                },
                                {
                                    "Text": "WADA",
                                    "Value": "WADA"
                                },
                                {
                                    "Text": "WADAKKANCHERY",
                                    "Value": "WADAKKANCHERY"
                                },
                                {
                                    "Text": "WADHWAN",
                                    "Value": "WADHWAN"
                                },
                                {
                                    "Text": "WADI",
                                    "Value": "WADI"
                                },
                                {
                                    "Text": "WADRAFNAGAR",
                                    "Value": "WADRAFNAGAR"
                                },
                                {
                                    "Text": "WAHABWALA",
                                    "Value": "WAHABWALA"
                                },
                                {
                                    "Text": "WAI",
                                    "Value": "WAI"
                                },
                                {
                                    "Text": "WAIDHAN",
                                    "Value": "WAIDHAN"
                                },
                                {
                                    "Text": "WAIDHAN - SINGRAULI",
                                    "Value": "WAIDHAN - SINGRAULI"
                                },
                                {
                                    "Text": "WAKULNI ",
                                    "Value": "WAKULNI "
                                },
                                {
                                    "Text": "WALAJAPET",
                                    "Value": "WALAJAPET"
                                },
                                {
                                    "Text": "WALSA KHALSA ",
                                    "Value": "WALSA KHALSA "
                                },
                                {
                                    "Text": "WANAPARTHY",
                                    "Value": "WANAPARTHY"
                                },
                                {
                                    "Text": "WANI",
                                    "Value": "WANI"
                                },
                                {
                                    "Text": "WANKANER",
                                    "Value": "WANKANER"
                                },
                                {
                                    "Text": "WARANGAL",
                                    "Value": "WARANGAL"
                                },
                                {
                                    "Text": "WARDHA",
                                    "Value": "WARDHA"
                                },
                                {
                                    "Text": "WARORA",
                                    "Value": "WARORA"
                                },
                                {
                                    "Text": "WARUD",
                                    "Value": "WARUD"
                                },
                                {
                                    "Text": "WARUDKAZI ",
                                    "Value": "WARUDKAZI "
                                },
                                {
                                    "Text": "WARYAM KHERA",
                                    "Value": "WARYAM KHERA"
                                },
                                {
                                    "Text": "WARZADI ",
                                    "Value": "WARZADI "
                                },
                                {
                                    "Text": "WASHIM",
                                    "Value": "WASHIM"
                                },
                                {
                                    "Text": "WAYANAD",
                                    "Value": "WAYANAD"
                                },
                                {
                                    "Text": "WEST NIMAR",
                                    "Value": "WEST NIMAR"
                                },
                                {
                                    "Text": "WEST CHAMPARAN",
                                    "Value": "WEST CHAMPARAN"
                                },
                                {
                                    "Text": "WEST DELHI",
                                    "Value": "WEST DELHI"
                                },
                                {
                                    "Text": "WEST GARO HILLS",
                                    "Value": "WEST GARO HILLS"
                                },
                                {
                                    "Text": "WEST GODAVARI",
                                    "Value": "WEST GODAVARI"
                                },
                                {
                                    "Text": "WEST KAMENG",
                                    "Value": "WEST KAMENG"
                                },
                                {
                                    "Text": "WEST KHASI HILLS",
                                    "Value": "WEST KHASI HILLS"
                                },
                                {
                                    "Text": "WEST MIDNAPORE",
                                    "Value": "WEST MIDNAPORE"
                                },
                                {
                                    "Text": "WEST SIANG",
                                    "Value": "WEST SIANG"
                                },
                                {
                                    "Text": "WEST SIKKIM",
                                    "Value": "WEST SIKKIM"
                                },
                                {
                                    "Text": "WEST SINGHBHUM",
                                    "Value": "WEST SINGHBHUM"
                                },
                                {
                                    "Text": "WEST TRIPURA",
                                    "Value": "WEST TRIPURA"
                                },
                                {
                                    "Text": "WAGHODIA",
                                    "Value": "WAGHODIA"
                                },
                                {
                                    "Text": "WILLIAMNAGAR",
                                    "Value": "WILLIAMNAGAR"
                                },
                                {
                                    "Text": "WARANANAGAR",
                                    "Value": "WARANANAGAR"
                                },
                                {
                                    "Text": "WANOWRIE",
                                    "Value": "WANOWRIE"
                                },
                                {
                                    "Text": "WOKHA",
                                    "Value": "WOKHA"
                                },
                                {
                                    "Text": "YADGIR",
                                    "Value": "YADGIR"
                                },
                                {
                                    "Text": "YADGARPALLY ",
                                    "Value": "YADGARPALLY "
                                },
                                {
                                    "Text": "YAIRIPOK",
                                    "Value": "YAIRIPOK"
                                },
                                {
                                    "Text": "YAMUNA NAGAR",
                                    "Value": "YAMUNA NAGAR"
                                },
                                {
                                    "Text": "YAMUNA NAGAR",
                                    "Value": "YAMUNA NAGAR"
                                },
                                {
                                    "Text": "YAMUNANAGAR",
                                    "Value": "YAMUNANAGAR"
                                },
                                {
                                    "Text": "YANAM",
                                    "Value": "YANAM"
                                },
                                {
                                    "Text": "YAVATMAL",
                                    "Value": "YAVATMAL"
                                },
                                {
                                    "Text": "YELLAPUR",
                                    "Value": "YELLAPUR"
                                },
                                {
                                    "Text": "YELLAPPAGONDA ",
                                    "Value": "YELLAPPAGONDA "
                                },
                                {
                                    "Text": "YEMMIGANUR",
                                    "Value": "YEMMIGANUR"
                                },
                                {
                                    "Text": "YENKIRYAL ",
                                    "Value": "YENKIRYAL "
                                },
                                {
                                    "Text": "YERRAGOLLA PAHAD ",
                                    "Value": "YERRAGOLLA PAHAD "
                                },
                                {
                                    "Text": "YESWANTAPUR ",
                                    "Value": "YESWANTAPUR "
                                },
                                {
                                    "Text": "YEVLA",
                                    "Value": "YEVLA"
                                },
                                {
                                    "Text": "YEVOLA",
                                    "Value": "YEVOLA"
                                },
                                {
                                    "Text": "Y G PETA ",
                                    "Value": "Y G PETA "
                                },
                                {
                                    "Text": "YINGKIONG",
                                    "Value": "YINGKIONG"
                                },
                                {
                                    "Text": "YELLAPUR",
                                    "Value": "YELLAPUR"
                                },
                                {
                                    "Text": "ZAHIRABAD",
                                    "Value": "ZAHIRABAD"
                                },
                                {
                                    "Text": "ZAINAKOTE",
                                    "Value": "ZAINAKOTE"
                                },
                                {
                                    "Text": "ZINKIBHADRA",
                                    "Value": "ZINKIBHADRA"
                                },
                                {
                                    "Text": "ZIRA",
                                    "Value": "ZIRA"
                                },
                                {
                                    "Text": "ZIRAYATHNAGAR ",
                                    "Value": "ZIRAYATHNAGAR "
                                },
                                {
                                    "Text": "ZIRAKPUR",
                                    "Value": "ZIRAKPUR"
                                },
                                {
                                    "Text": "ZIRO",
                                    "Value": "ZIRO"
                                },
                                {
                                    "Text": "ZUARINAGAR",
                                    "Value": "ZUARINAGAR"
                                },
                                {
                                    "Text": "ZIAUDDIN PUR",
                                    "Value": "ZIAUDDIN PUR"
                                },
                                {
                                    "Text": "ZUNHEBOTTO",
                                    "Value": "ZUNHEBOTTO"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": "/^[a-zA-Z\\s]+$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['country']['input'] === 'India'",
                            "validation": ""
                        },
                        "cityothers": {
                            "id": "228",
                            "label": "City Others",
                            "name": "cityothers",
                            "description": "No special characters allowed #Type name of city",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[a-zA-Z\\',.\\\\s-]{1,50}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['country']['input'] !== 'India'",
                            "validation": ""
                        },
                        "state": {
                            "id": "225",
                            "label": "State",
                            "name": "state",
                            "description": "State",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "ANDAMAN & NICOBAR ISLANDS",
                                    "Value": "ANDAMAN & NICOBAR ISLANDS"
                                },
                                {
                                    "Text": "ANDHRA PRADESH",
                                    "Value": "ANDHRA PRADESH"
                                },
                                {
                                    "Text": "ARUNACHAL PRADESH",
                                    "Value": "ARUNACHAL PRADESH"
                                },
                                {
                                    "Text": "ASSAM",
                                    "Value": "ASSAM"
                                },
                                {
                                    "Text": "BIHAR",
                                    "Value": "BIHAR"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHATTISGARH",
                                    "Value": "CHATTISGARH"
                                },
                                {
                                    "Text": "DAMAN & DIU",
                                    "Value": "DAMAN & DIU"
                                },
                                {
                                    "Text": "DELHI",
                                    "Value": "DELHI"
                                },
                                {
                                    "Text": "DADRA & NAGAR HAVELI",
                                    "Value": "DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "GOA",
                                    "Value": "GOA"
                                },
                                {
                                    "Text": "GUJARAT",
                                    "Value": "GUJARAT"
                                },
                                {
                                    "Text": "HARYANA",
                                    "Value": "HARYANA"
                                },
                                {
                                    "Text": "HIMACHAL PRADESH",
                                    "Value": "HIMACHAL PRADESH"
                                },
                                {
                                    "Text": "JAMMU & KASHMIR",
                                    "Value": "JAMMU & KASHMIR"
                                },
                                {
                                    "Text": "JHARKHAND",
                                    "Value": "JHARKHAND"
                                },
                                {
                                    "Text": "KARNATAKA",
                                    "Value": "KARNATAKA"
                                },
                                {
                                    "Text": "KERALA",
                                    "Value": "KERALA"
                                },
                                {
                                    "Text": "LAKSHADWEEP",
                                    "Value": "LAKSHADWEEP"
                                },
                                {
                                    "Text": "MAHARASHTRA",
                                    "Value": "MAHARASHTRA"
                                },
                                {
                                    "Text": "MANIPUR",
                                    "Value": "MANIPUR"
                                },
                                {
                                    "Text": "MEGHALAYA",
                                    "Value": "MEGHALAYA"
                                },
                                {
                                    "Text": "MIZORAM",
                                    "Value": "MIZORAM"
                                },
                                {
                                    "Text": "MADHYA PRADESH",
                                    "Value": "MADHYA PRADESH"
                                },
                                {
                                    "Text": "NAGALAND",
                                    "Value": "NAGALAND"
                                },
                                {
                                    "Text": "ODISHA",
                                    "Value": "ODISHA"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PUNJAB",
                                    "Value": "PUNJAB"
                                },
                                {
                                    "Text": "RAJASTHAN",
                                    "Value": "RAJASTHAN"
                                },
                                {
                                    "Text": "SIKKIM",
                                    "Value": "SIKKIM"
                                },
                                {
                                    "Text": "TAMIL NADU",
                                    "Value": "TAMIL NADU"
                                },
                                {
                                    "Text": "TELANGANA",
                                    "Value": "TELANGANA"
                                },
                                {
                                    "Text": "TRIPURA",
                                    "Value": "TRIPURA"
                                },
                                {
                                    "Text": "UTTAR PRADESH",
                                    "Value": "UTTAR PRADESH"
                                },
                                {
                                    "Text": "UTTARAKHAND",
                                    "Value": "UTTARAKHAND"
                                },
                                {
                                    "Text": "WEST BENGAL",
                                    "Value": "WEST BENGAL"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['country']['input'] === 'India'",
                            "validation": ""
                        },
                        "stateothers": {
                            "id": "229",
                            "label": "State Others",
                            "name": "stateothers",
                            "description": "State Others",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[a-zA-Z\\',.\\\\s-]{1,50}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['country']['input'] !== 'India'",
                            "validation": ""
                        },
                        "country": {
                            "id": "226",
                            "label": "Country",
                            "name": "country",
                            "description": "Country",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Austria",
                                    "Value": "Austria"
                                },
                                {
                                    "Text": "Antigua and Barbuda",
                                    "Value": "Antigua and Barbuda"
                                },
                                {
                                    "Text": "Yemen",
                                    "Value": "Yemen"
                                },
                                {
                                    "Text": "Afghanistan",
                                    "Value": "Afghanistan"
                                },
                                {
                                    "Text": "Angola",
                                    "Value": "Angola"
                                },
                                {
                                    "Text": "Anguilla",
                                    "Value": "Anguilla"
                                },
                                {
                                    "Text": "Albania",
                                    "Value": "Albania"
                                },
                                {
                                    "Text": "Andorra",
                                    "Value": "Andorra"
                                },
                                {
                                    "Text": "Aruba",
                                    "Value": "Aruba"
                                },
                                {
                                    "Text": "Armenia",
                                    "Value": "Armenia"
                                },
                                {
                                    "Text": "Australia",
                                    "Value": "Australia"
                                },
                                {
                                    "Text": "Azerbaijan",
                                    "Value": "Azerbaijan"
                                },
                                {
                                    "Text": "Belgium",
                                    "Value": "Belgium"
                                },
                                {
                                    "Text": "Bangladesh",
                                    "Value": "Bangladesh"
                                },
                                {
                                    "Text": "Barbados",
                                    "Value": "Barbados"
                                },
                                {
                                    "Text": "Bermuda",
                                    "Value": "Bermuda"
                                },
                                {
                                    "Text": "Bulgaria",
                                    "Value": "Bulgaria"
                                },
                                {
                                    "Text": "Belize",
                                    "Value": "Belize"
                                },
                                {
                                    "Text": "Bhutan",
                                    "Value": "Bhutan"
                                },
                                {
                                    "Text": "Burkina Faso",
                                    "Value": "Burkina Faso"
                                },
                                {
                                    "Text": "Belarus",
                                    "Value": "Belarus"
                                },
                                {
                                    "Text": "Brunei",
                                    "Value": "Brunei"
                                },
                                {
                                    "Text": "Bolivia",
                                    "Value": "Bolivia"
                                },
                                {
                                    "Text": "Brazil",
                                    "Value": "Brazil"
                                },
                                {
                                    "Text": "Burundi",
                                    "Value": "Burundi"
                                },
                                {
                                    "Text": "Burma",
                                    "Value": "Burma"
                                },
                                {
                                    "Text": "Bahrain",
                                    "Value": "Bahrain"
                                },
                                {
                                    "Text": "Britain",
                                    "Value": "Britain"
                                },
                                {
                                    "Text": "Bahamas",
                                    "Value": "Bahamas"
                                },
                                {
                                    "Text": "Bosnia",
                                    "Value": "Bosnia"
                                },
                                {
                                    "Text": "Myanmar",
                                    "Value": "Myanmar"
                                },
                                {
                                    "Text": "British Virgin Islands",
                                    "Value": "British Virgin Islands"
                                },
                                {
                                    "Text": "Cuba",
                                    "Value": "Cuba"
                                },
                                {
                                    "Text": "Canada",
                                    "Value": "Canada"
                                },
                                {
                                    "Text": "Switzerland",
                                    "Value": "Switzerland"
                                },
                                {
                                    "Text": "Chad",
                                    "Value": "Chad"
                                },
                                {
                                    "Text": "China",
                                    "Value": "China"
                                },
                                {
                                    "Text": "Ivory Coast",
                                    "Value": "Ivory Coast"
                                },
                                {
                                    "Text": "Sri Lanka",
                                    "Value": "Sri Lanka"
                                },
                                {
                                    "Text": "Cameroon",
                                    "Value": "Cameroon"
                                },
                                {
                                    "Text": "Canary Islands",
                                    "Value": "Canary Islands"
                                },
                                {
                                    "Text": "Colombia",
                                    "Value": "Colombia"
                                },
                                {
                                    "Text": "Comoros",
                                    "Value": "Comoros"
                                },
                                {
                                    "Text": "Cape Verde",
                                    "Value": "Cape Verde"
                                },
                                {
                                    "Text": "Costa Rica",
                                    "Value": "Costa Rica"
                                },
                                {
                                    "Text": "Curacao",
                                    "Value": "Curacao"
                                },
                                {
                                    "Text": "Cape Town",
                                    "Value": "Cape Town"
                                },
                                {
                                    "Text": "Cote dIvoire",
                                    "Value": "Cote dIvoire"
                                },
                                {
                                    "Text": "Cyprus",
                                    "Value": "Cyprus"
                                },
                                {
                                    "Text": "Cayman Islands",
                                    "Value": "Cayman Islands"
                                },
                                {
                                    "Text": "Czech",
                                    "Value": "Czech"
                                },
                                {
                                    "Text": "Germany",
                                    "Value": "Germany"
                                },
                                {
                                    "Text": "Djibouti",
                                    "Value": "Djibouti"
                                },
                                {
                                    "Text": "Denmark",
                                    "Value": "Denmark"
                                },
                                {
                                    "Text": "Dominican Republic",
                                    "Value": "Dominican Republic"
                                },
                                {
                                    "Text": "Democratic Republic of Congo",
                                    "Value": "Democratic Republic of Congo"
                                },
                                {
                                    "Text": "Benin",
                                    "Value": "Benin"
                                },
                                {
                                    "Text": "Algeria",
                                    "Value": "Algeria"
                                },
                                {
                                    "Text": "Spain",
                                    "Value": "Spain"
                                },
                                {
                                    "Text": "EastTimor",
                                    "Value": "EastTimor"
                                },
                                {
                                    "Text": "East Africa",
                                    "Value": "East Africa"
                                },
                                {
                                    "Text": "Kenya",
                                    "Value": "Kenya"
                                },
                                {
                                    "Text": "Tanzania",
                                    "Value": "Tanzania"
                                },
                                {
                                    "Text": "Uganda",
                                    "Value": "Uganda"
                                },
                                {
                                    "Text": "Ecuador",
                                    "Value": "Ecuador"
                                },
                                {
                                    "Text": "England",
                                    "Value": "England"
                                },
                                {
                                    "Text": "Equitorial Guinea",
                                    "Value": "Equitorial Guinea"
                                },
                                {
                                    "Text": "Eritrea",
                                    "Value": "Eritrea"
                                },
                                {
                                    "Text": "El Salvador",
                                    "Value": "El Salvador"
                                },
                                {
                                    "Text": "Egypt",
                                    "Value": "Egypt"
                                },
                                {
                                    "Text": "Ethiopia",
                                    "Value": "Ethiopia"
                                },
                                {
                                    "Text": "Estonia",
                                    "Value": "Estonia"
                                },
                                {
                                    "Text": "France",
                                    "Value": "France"
                                },
                                {
                                    "Text": "Finland",
                                    "Value": "Finland"
                                },
                                {
                                    "Text": "Fiji",
                                    "Value": "Fiji"
                                },
                                {
                                    "Text": "Liechtenstein",
                                    "Value": "Liechtenstein"
                                },
                                {
                                    "Text": "Falkland Islands",
                                    "Value": "Falkland Islands"
                                },
                                {
                                    "Text": "French Guiana",
                                    "Value": "French Guiana"
                                },
                                {
                                    "Text": "French Polynesia",
                                    "Value": "French Polynesia"
                                },
                                {
                                    "Text": "Great Britain",
                                    "Value": "Great Britain"
                                },
                                {
                                    "Text": "Alderney",
                                    "Value": "Alderney"
                                },
                                {
                                    "Text": "Gabon",
                                    "Value": "Gabon"
                                },
                                {
                                    "Text": "Guinea bissau",
                                    "Value": "Guinea bissau"
                                },
                                {
                                    "Text": "Gibraltar",
                                    "Value": "Gibraltar"
                                },
                                {
                                    "Text": "Guatemala",
                                    "Value": "Guatemala"
                                },
                                {
                                    "Text": "Guadeloupe",
                                    "Value": "Guadeloupe"
                                },
                                {
                                    "Text": "Ghana",
                                    "Value": "Ghana"
                                },
                                {
                                    "Text": "Gambia",
                                    "Value": "Gambia"
                                },
                                {
                                    "Text": "Greenland",
                                    "Value": "Greenland"
                                },
                                {
                                    "Text": "Greece",
                                    "Value": "Greece"
                                },
                                {
                                    "Text": "Georgia",
                                    "Value": "Georgia"
                                },
                                {
                                    "Text": "Guinea",
                                    "Value": "Guinea"
                                },
                                {
                                    "Text": "Guam",
                                    "Value": "Guam"
                                },
                                {
                                    "Text": "Guyana",
                                    "Value": "Guyana"
                                },
                                {
                                    "Text": "Hungary",
                                    "Value": "Hungary"
                                },
                                {
                                    "Text": "Honduras",
                                    "Value": "Honduras"
                                },
                                {
                                    "Text": "Hong Kong",
                                    "Value": "Hong Kong"
                                },
                                {
                                    "Text": "Croatia",
                                    "Value": "Croatia"
                                },
                                {
                                    "Text": "Italy",
                                    "Value": "Italy"
                                },
                                {
                                    "Text": "Czech Republic",
                                    "Value": "Czech Republic"
                                },
                                {
                                    "Text": "Israel",
                                    "Value": "Israel"
                                },
                                {
                                    "Text": "India",
                                    "Value": "India"
                                },
                                {
                                    "Text": "Iran",
                                    "Value": "Iran"
                                },
                                {
                                    "Text": "Ireland",
                                    "Value": "Ireland"
                                },
                                {
                                    "Text": "Iraq",
                                    "Value": "Iraq"
                                },
                                {
                                    "Text": "Iceland",
                                    "Value": "Iceland"
                                },
                                {
                                    "Text": "Japan",
                                    "Value": "Japan"
                                },
                                {
                                    "Text": "Jamaica",
                                    "Value": "Jamaica"
                                },
                                {
                                    "Text": "Jordan",
                                    "Value": "Jordan"
                                },
                                {
                                    "Text": "Cambodia",
                                    "Value": "Cambodia"
                                },
                                {
                                    "Text": "Kyrgyzstan",
                                    "Value": "Kyrgyzstan"
                                },
                                {
                                    "Text": "Kiribati",
                                    "Value": "Kiribati"
                                },
                                {
                                    "Text": "Kazhakistan",
                                    "Value": "Kazhakistan"
                                },
                                {
                                    "Text": "Kuwait",
                                    "Value": "Kuwait"
                                },
                                {
                                    "Text": "Luxembourg",
                                    "Value": "Luxembourg"
                                },
                                {
                                    "Text": "Laos",
                                    "Value": "Laos"
                                },
                                {
                                    "Text": "Libya",
                                    "Value": "Libya"
                                },
                                {
                                    "Text": "Liberia",
                                    "Value": "Liberia"
                                },
                                {
                                    "Text": "Lesotho",
                                    "Value": "Lesotho"
                                },
                                {
                                    "Text": "Lithuania",
                                    "Value": "Lithuania"
                                },
                                {
                                    "Text": "Latvia",
                                    "Value": "Latvia"
                                },
                                {
                                    "Text": "Malta",
                                    "Value": "Malta"
                                },
                                {
                                    "Text": "Morocco",
                                    "Value": "Morocco"
                                },
                                {
                                    "Text": "Malaysia",
                                    "Value": "Malaysia"
                                },
                                {
                                    "Text": "Monaco",
                                    "Value": "Monaco"
                                },
                                {
                                    "Text": "Micronesia",
                                    "Value": "Micronesia"
                                },
                                {
                                    "Text": "Macau",
                                    "Value": "Macau"
                                },
                                {
                                    "Text": "Madeira",
                                    "Value": "Madeira"
                                },
                                {
                                    "Text": "Moldova",
                                    "Value": "Moldova"
                                },
                                {
                                    "Text": "Mexico",
                                    "Value": "Mexico"
                                },
                                {
                                    "Text": "Montenegro",
                                    "Value": "Montenegro"
                                },
                                {
                                    "Text": "Mangolia",
                                    "Value": "Mangolia"
                                },
                                {
                                    "Text": "Macedonia",
                                    "Value": "Macedonia"
                                },
                                {
                                    "Text": "Maldives",
                                    "Value": "Maldives"
                                },
                                {
                                    "Text": "Mauritius",
                                    "Value": "Mauritius"
                                },
                                {
                                    "Text": "Marshall Islands",
                                    "Value": "Marshall Islands"
                                },
                                {
                                    "Text": "Martinique",
                                    "Value": "Martinique"
                                },
                                {
                                    "Text": "Monteserrat",
                                    "Value": "Monteserrat"
                                },
                                {
                                    "Text": "Malawi",
                                    "Value": "Malawi"
                                },
                                {
                                    "Text": "Mozambique",
                                    "Value": "Mozambique"
                                },
                                {
                                    "Text": "Norway",
                                    "Value": "Norway"
                                },
                                {
                                    "Text": "Nauru",
                                    "Value": "Nauru"
                                },
                                {
                                    "Text": "New Caledonia",
                                    "Value": "New Caledonia"
                                },
                                {
                                    "Text": "Nepal",
                                    "Value": "Nepal"
                                },
                                {
                                    "Text": "Nicaragua",
                                    "Value": "Nicaragua"
                                },
                                {
                                    "Text": "Northern Ireland",
                                    "Value": "Northern Ireland"
                                },
                                {
                                    "Text": "Niue",
                                    "Value": "Niue"
                                },
                                {
                                    "Text": "North Korea",
                                    "Value": "North Korea"
                                },
                                {
                                    "Text": "Netherlands",
                                    "Value": "Netherlands"
                                },
                                {
                                    "Text": "Namibia",
                                    "Value": "Namibia"
                                },
                                {
                                    "Text": "New Zealand",
                                    "Value": "New Zealand"
                                },
                                {
                                    "Text": "Oman",
                                    "Value": "Oman"
                                },
                                {
                                    "Text": "Other",
                                    "Value": "Other"
                                },
                                {
                                    "Text": "Portugal",
                                    "Value": "Portugal"
                                },
                                {
                                    "Text": "Panama",
                                    "Value": "Panama"
                                },
                                {
                                    "Text": "Peru",
                                    "Value": "Peru"
                                },
                                {
                                    "Text": "Pakistan",
                                    "Value": "Pakistan"
                                },
                                {
                                    "Text": "Poland",
                                    "Value": "Poland"
                                },
                                {
                                    "Text": "Palestine",
                                    "Value": "Palestine"
                                },
                                {
                                    "Text": "Palau",
                                    "Value": "Palau"
                                },
                                {
                                    "Text": "Papua New guinea",
                                    "Value": "Papua New guinea"
                                },
                                {
                                    "Text": "Puerto Rico",
                                    "Value": "Puerto Rico"
                                },
                                {
                                    "Text": "Paraguay",
                                    "Value": "Paraguay"
                                },
                                {
                                    "Text": "Qatar",
                                    "Value": "Qatar"
                                },
                                {
                                    "Text": "Argentina",
                                    "Value": "Argentina"
                                },
                                {
                                    "Text": "Botswana",
                                    "Value": "Botswana"
                                },
                                {
                                    "Text": "Central African Republic",
                                    "Value": "Central African Republic"
                                },
                                {
                                    "Text": "Congo",
                                    "Value": "Congo"
                                },
                                {
                                    "Text": "Chile",
                                    "Value": "Chile"
                                },
                                {
                                    "Text": "Reunion",
                                    "Value": "Reunion"
                                },
                                {
                                    "Text": "Haiti",
                                    "Value": "Haiti"
                                },
                                {
                                    "Text": "Indonesia",
                                    "Value": "Indonesia"
                                },
                                {
                                    "Text": "Mauritania",
                                    "Value": "Mauritania"
                                },
                                {
                                    "Text": "Lebanon",
                                    "Value": "Lebanon"
                                },
                                {
                                    "Text": "Madagascar",
                                    "Value": "Madagascar"
                                },
                                {
                                    "Text": "Mali",
                                    "Value": "Mali"
                                },
                                {
                                    "Text": "Niger",
                                    "Value": "Niger"
                                },
                                {
                                    "Text": "Romania",
                                    "Value": "Romania"
                                },
                                {
                                    "Text": "Republic of Congo",
                                    "Value": "Republic of Congo"
                                },
                                {
                                    "Text": "Republic of Korea",
                                    "Value": "Republic of Korea"
                                },
                                {
                                    "Text": "Uruguay",
                                    "Value": "Uruguay"
                                },
                                {
                                    "Text": "Philippines",
                                    "Value": "Philippines"
                                },
                                {
                                    "Text": "RSA",
                                    "Value": "RSA"
                                },
                                {
                                    "Text": "San Marino",
                                    "Value": "San Marino"
                                },
                                {
                                    "Text": "Russia",
                                    "Value": "Russia"
                                },
                                {
                                    "Text": "Rwanda",
                                    "Value": "Rwanda"
                                },
                                {
                                    "Text": "Sweden",
                                    "Value": "Sweden"
                                },
                                {
                                    "Text": "Saudi Arabia",
                                    "Value": "Saudi Arabia"
                                },
                                {
                                    "Text": "Scotland",
                                    "Value": "Scotland"
                                },
                                {
                                    "Text": "Swaziland",
                                    "Value": "Swaziland"
                                },
                                {
                                    "Text": "Singapore",
                                    "Value": "Singapore"
                                },
                                {
                                    "Text": "Slovakia",
                                    "Value": "Slovakia"
                                },
                                {
                                    "Text": "South Korea",
                                    "Value": "South Korea"
                                },
                                {
                                    "Text": "St Kitts and Nevis",
                                    "Value": "St Kitts and Nevis"
                                },
                                {
                                    "Text": "St Lucia",
                                    "Value": "St Lucia"
                                },
                                {
                                    "Text": "Slovenia",
                                    "Value": "Slovenia"
                                },
                                {
                                    "Text": "St Martin",
                                    "Value": "St Martin"
                                },
                                {
                                    "Text": "Surinam",
                                    "Value": "Surinam"
                                },
                                {
                                    "Text": "Solomon Islands",
                                    "Value": "Solomon Islands"
                                },
                                {
                                    "Text": "Senegal",
                                    "Value": "Senegal"
                                },
                                {
                                    "Text": "Somalia",
                                    "Value": "Somalia"
                                },
                                {
                                    "Text": "Serbia",
                                    "Value": "Serbia"
                                },
                                {
                                    "Text": "South Sudan",
                                    "Value": "South Sudan"
                                },
                                {
                                    "Text": "Sao Principe and Tome",
                                    "Value": "Sao Principe and Tome"
                                },
                                {
                                    "Text": "Sudan",
                                    "Value": "Sudan"
                                },
                                {
                                    "Text": "St Vincent and Grenadines",
                                    "Value": "St Vincent and Grenadines"
                                },
                                {
                                    "Text": "Swansea",
                                    "Value": "Swansea"
                                },
                                {
                                    "Text": "Seychelles",
                                    "Value": "Seychelles"
                                },
                                {
                                    "Text": "Syria",
                                    "Value": "Syria"
                                },
                                {
                                    "Text": "Thailand",
                                    "Value": "Thailand"
                                },
                                {
                                    "Text": "Taiwan",
                                    "Value": "Taiwan"
                                },
                                {
                                    "Text": "Tibet",
                                    "Value": "Tibet"
                                },
                                {
                                    "Text": "Togo",
                                    "Value": "Togo"
                                },
                                {
                                    "Text": "Gambia/ The Gambia",
                                    "Value": "Gambia/ The Gambia"
                                },
                                {
                                    "Text": "Tahiti",
                                    "Value": "Tahiti"
                                },
                                {
                                    "Text": "Tajikistan",
                                    "Value": "Tajikistan"
                                },
                                {
                                    "Text": "Tokelau",
                                    "Value": "Tokelau"
                                },
                                {
                                    "Text": "Turkmenistan",
                                    "Value": "Turkmenistan"
                                },
                                {
                                    "Text": "Tunisia",
                                    "Value": "Tunisia"
                                },
                                {
                                    "Text": "Tonga",
                                    "Value": "Tonga"
                                },
                                {
                                    "Text": "Turkey",
                                    "Value": "Turkey"
                                },
                                {
                                    "Text": "Trinidad and Tobago",
                                    "Value": "Trinidad and Tobago"
                                },
                                {
                                    "Text": "Turks and Caicos",
                                    "Value": "Turks and Caicos"
                                },
                                {
                                    "Text": "Tuvalu",
                                    "Value": "Tuvalu"
                                },
                                {
                                    "Text": "Ukraine",
                                    "Value": "Ukraine"
                                },
                                {
                                    "Text": "United Arab Emirates",
                                    "Value": "United Arab Emirates"
                                },
                                {
                                    "Text": "United Kingdom",
                                    "Value": "United Kingdom"
                                },
                                {
                                    "Text": "United States of America",
                                    "Value": "United States of America"
                                },
                                {
                                    "Text": "US Virgin Islands",
                                    "Value": "US Virgin Islands"
                                },
                                {
                                    "Text": "Uzbekistan",
                                    "Value": "Uzbekistan"
                                },
                                {
                                    "Text": "Vanuatu",
                                    "Value": "Vanuatu"
                                },
                                {
                                    "Text": "Vatican",
                                    "Value": "Vatican"
                                },
                                {
                                    "Text": "Vietnam",
                                    "Value": "Vietnam"
                                },
                                {
                                    "Text": "Watford",
                                    "Value": "Watford"
                                },
                                {
                                    "Text": "Sierra Leone",
                                    "Value": "Sierra Leone"
                                },
                                {
                                    "Text": "Nigeria",
                                    "Value": "Nigeria"
                                },
                                {
                                    "Text": "London",
                                    "Value": "London"
                                },
                                {
                                    "Text": "Dominica",
                                    "Value": "Dominica"
                                },
                                {
                                    "Text": "West Africa",
                                    "Value": "West Africa"
                                },
                                {
                                    "Text": "Grenada",
                                    "Value": "Grenada"
                                },
                                {
                                    "Text": "Samoa",
                                    "Value": "Samoa"
                                },
                                {
                                    "Text": "Western Sahara",
                                    "Value": "Western Sahara"
                                },
                                {
                                    "Text": "Yugoslavia",
                                    "Value": "Yugoslavia"
                                },
                                {
                                    "Text": "Venezuela",
                                    "Value": "Venezuela"
                                },
                                {
                                    "Text": "Zambia",
                                    "Value": "Zambia"
                                },
                                {
                                    "Text": "South Africa",
                                    "Value": "South Africa"
                                },
                                {
                                    "Text": "Zaire",
                                    "Value": "Zaire"
                                },
                                {
                                    "Text": "Zimbabwe",
                                    "Value": "Zimbabwe"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "expectedDurationOfStay": {
                            "id": "230",
                            "label": "Expected duration of stay at the communication address",
                            "name": "expectedDurationOfStay",
                            "description": "Expected duration of stay at the communication address",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Less than equal to 1 year",
                                    "Value": "Less than equal to 1 year"
                                },
                                {
                                    "Text": "More than 1 year",
                                    "Value": "More than 1 year"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "preferredModeOfCommunication": {
                            "id": "231",
                            "label": "Preferred Mode of Communication",
                            "name": "preferredModeOfCommunication",
                            "description": "Preferred Mode of Communication",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Call",
                                    "Value": "Call"
                                },
                                {
                                    "Text": "Email",
                                    "Value": "Email"
                                },
                                {
                                    "Text": "Letter",
                                    "Value": "Letter"
                                },
                                {
                                    "Text": "Sms",
                                    "Value": "Sms"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "preferredModeOfLanguage": {
                            "id": "232",
                            "label": "Preferred Communication Language",
                            "name": "preferredModeOfLanguage",
                            "description": "Preferred Communication Language",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Assamese",
                                    "Value": "Assamese"
                                },
                                {
                                    "Text": "Bengali",
                                    "Value": "Bengali"
                                },
                                {
                                    "Text": "English",
                                    "Value": "English"
                                },
                                {
                                    "Text": "Gujarati",
                                    "Value": "Gujarati"
                                },
                                {
                                    "Text": "Hindi",
                                    "Value": "Hindi"
                                },
                                {
                                    "Text": "Kannada",
                                    "Value": "Kannada"
                                },
                                {
                                    "Text": "Malayalam",
                                    "Value": "Malayalam"
                                },
                                {
                                    "Text": "Marathi",
                                    "Value": "Marathi"
                                },
                                {
                                    "Text": "Oriya",
                                    "Value": "Oriya"
                                },
                                {
                                    "Text": "Others",
                                    "Value": "Others"
                                },
                                {
                                    "Text": "Punjabi",
                                    "Value": "Punjabi"
                                },
                                {
                                    "Text": "Telugu",
                                    "Value": "Telugu"
                                },
                                {
                                    "Text": "Tamil",
                                    "Value": "Tamil"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "preferredModeOfLanguageOther": {
                            "id": "1387",
                            "label": "Other Preferred Communication Language",
                            "name": "preferredModeOfLanguageOther",
                            "description": "Other Preferred Communication Language",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[a-zA-Z]{1,50}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['preferredModeOfLanguage']['input'] === 'Others'",
                            "validation": ""
                        },
                        "sameAddress": {
                            "id": "1388",
                            "label": "Is your Permanent address same as Communication address ?",
                            "name": "sameAddress",
                            "description": "Is your Permanent address same as Communication address ?",
                            "mandatory": 1,
                            "type": "boolean",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        }
                    }
                },
                "permanentAddressDetails": {
                    "id": 28,
                    "name": "permanentAddressDetails",
                    "description": "Permanent Address Details",
                    "parent": 24,
                    "label": "Permanent Address Details",
                    "type": null,
                    "sizeOfArray": null,
                    "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['communicationAddressDetails']['fields']['sameAddress']['input']==='0'",
                    "validation": null,
                    "order": 4,
                    "fields": {
                        "addressLine1": {
                            "id": "1470",
                            "label": "Address Line 1",
                            "name": "addressLine1",
                            "description": "Address should be as per Valid Proof Your policy document will be sent to this address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "addressLine2": {
                            "id": "1507",
                            "label": "Address line 2",
                            "name": "addressLine2",
                            "description": "Address should be as per Valid Proof Your policy document will be sent to this address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 2,
                            "max": 30,
                            "pattern": "/^[a-zA-z\\s]{3,30}$/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "addressLine3": {
                            "id": "1508",
                            "label": "Address line 3",
                            "name": "addressLine3",
                            "description": "Address should be as per Valid Proof Your policy document will be sent to this address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 2,
                            "max": 30,
                            "pattern": "/^[a-zA-z\\s]{3,30}$/",
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "landmark": {
                            "id": "223",
                            "label": "Landmark",
                            "name": "landmark",
                            "description": "Landmark",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": null,
                            "max": 40,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "zipCode": {
                            "id": "1453",
                            "label": "Pincode",
                            "name": "zipCode",
                            "description": "Maximum 6 Numbers for Indian and 10 for NRI/OCI/PIO/FN #Zip Code of the area provided",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": "",
                            "min": 6,
                            "max": 6,
                            "pattern": "/^[1-9][0-9]{5}$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "city": {
                            "id": "1462",
                            "label": "City",
                            "name": "city",
                            "description": "Select name of city",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "",
                                    "Value": ""
                                },
                                {
                                    "Text": "MANDYA",
                                    "Value": "MANDYA"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ARMOOR",
                                    "Value": "ARMOOR"
                                },
                                {
                                    "Text": "BANSWADA",
                                    "Value": "BANSWADA"
                                },
                                {
                                    "Text": "BELLAMPALLE",
                                    "Value": "BELLAMPALLE"
                                },
                                {
                                    "Text": "BHADRACHALAM",
                                    "Value": "BHADRACHALAM"
                                },
                                {
                                    "Text": "BHAINSA",
                                    "Value": "BHAINSA"
                                },
                                {
                                    "Text": "BHONGIR",
                                    "Value": "BHONGIR"
                                },
                                {
                                    "Text": "BODHAN",
                                    "Value": "BODHAN"
                                },
                                {
                                    "Text": "BOMMAKAL",
                                    "Value": "BOMMAKAL"
                                },
                                {
                                    "Text": "CHANDANAGAR",
                                    "Value": "CHANDANAGAR"
                                },
                                {
                                    "Text": "CHIMRAJPALLE",
                                    "Value": "CHIMRAJPALLE"
                                },
                                {
                                    "Text": "CHOUTUPPAL",
                                    "Value": "CHOUTUPPAL"
                                },
                                {
                                    "Text": "DWARKA SUB CITY",
                                    "Value": "DWARKA SUB CITY"
                                },
                                {
                                    "Text": "FILM NAGAR",
                                    "Value": "FILM NAGAR"
                                },
                                {
                                    "Text": "GADWAL",
                                    "Value": "GADWAL"
                                },
                                {
                                    "Text": "GENOME VALLEY",
                                    "Value": "GENOME VALLEY"
                                },
                                {
                                    "Text": "GODAVARIKHANI",
                                    "Value": "GODAVARIKHANI"
                                },
                                {
                                    "Text": "GOPANAPALLE",
                                    "Value": "GOPANAPALLE"
                                },
                                {
                                    "Text": "GOVINDPET",
                                    "Value": "GOVINDPET"
                                },
                                {
                                    "Text": "HANUMAKONDA",
                                    "Value": "HANUMAKONDA"
                                },
                                {
                                    "Text": "HAYATNAGAR",
                                    "Value": "HAYATNAGAR"
                                },
                                {
                                    "Text": "HUNSA",
                                    "Value": "HUNSA"
                                },
                                {
                                    "Text": "HUSNABAD",
                                    "Value": "HUSNABAD"
                                },
                                {
                                    "Text": "HUZURABAD",
                                    "Value": "HUZURABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "JADCHERLA",
                                    "Value": "JADCHERLA"
                                },
                                {
                                    "Text": "JAGITYALA",
                                    "Value": "JAGITYALA"
                                },
                                {
                                    "Text": "JAMMIKUNTA",
                                    "Value": "JAMMIKUNTA"
                                },
                                {
                                    "Text": "JANGAON",
                                    "Value": "JANGAON"
                                },
                                {
                                    "Text": "JANJAON",
                                    "Value": "JANJAON"
                                },
                                {
                                    "Text": "JANKAMPET",
                                    "Value": "JANKAMPET"
                                },
                                {
                                    "Text": "JEELGUL",
                                    "Value": "JEELGUL"
                                },
                                {
                                    "Text": "JOGIPET",
                                    "Value": "JOGIPET"
                                },
                                {
                                    "Text": "K.V.RANGAREDDY",
                                    "Value": "K.V.RANGAREDDY"
                                },
                                {
                                    "Text": "KALIGOTE",
                                    "Value": "KALIGOTE"
                                },
                                {
                                    "Text": "KALWAKURTHY",
                                    "Value": "KALWAKURTHY"
                                },
                                {
                                    "Text": "KAMAREDDY",
                                    "Value": "KAMAREDDY"
                                },
                                {
                                    "Text": "KAPRA",
                                    "Value": "KAPRA"
                                },
                                {
                                    "Text": "KARIM NAGAR",
                                    "Value": "KARIM NAGAR"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KASIBUGGA",
                                    "Value": "KASIBUGGA"
                                },
                                {
                                    "Text": "KHAMMAM",
                                    "Value": "KHAMMAM"
                                },
                                {
                                    "Text": "KODADA",
                                    "Value": "KODADA"
                                },
                                {
                                    "Text": "KODAD",
                                    "Value": "KODAD"
                                },
                                {
                                    "Text": "KOMPALLE",
                                    "Value": "KOMPALLE"
                                },
                                {
                                    "Text": "KONDAGATTU",
                                    "Value": "KONDAGATTU"
                                },
                                {
                                    "Text": "KONDAPUR",
                                    "Value": "KONDAPUR"
                                },
                                {
                                    "Text": "KORATLA",
                                    "Value": "KORATLA"
                                },
                                {
                                    "Text": "KOTHAGUDEM",
                                    "Value": "KOTHAGUDEM"
                                },
                                {
                                    "Text": "KOTHAPALLE",
                                    "Value": "KOTHAPALLE"
                                },
                                {
                                    "Text": "KUKATPALLY",
                                    "Value": "KUKATPALLY"
                                },
                                {
                                    "Text": "LAXITTIPET",
                                    "Value": "LAXITTIPET"
                                },
                                {
                                    "Text": "MAHABUB NAGAR",
                                    "Value": "MAHABUB NAGAR"
                                },
                                {
                                    "Text": "MAHABUBNAGAR",
                                    "Value": "MAHABUBNAGAR"
                                },
                                {
                                    "Text": "MAHABUBABAD",
                                    "Value": "MAHABUBABAD"
                                },
                                {
                                    "Text": "MANCHERIAL",
                                    "Value": "MANCHERIAL"
                                },
                                {
                                    "Text": "MANTHANI",
                                    "Value": "MANTHANI"
                                },
                                {
                                    "Text": "MEDAK",
                                    "Value": "MEDAK"
                                },
                                {
                                    "Text": "MEDCHAL",
                                    "Value": "MEDCHAL"
                                },
                                {
                                    "Text": "MEHBUBNAGAR",
                                    "Value": "MEHBUBNAGAR"
                                },
                                {
                                    "Text": "METPALLE",
                                    "Value": "METPALLE"
                                },
                                {
                                    "Text": "MIRYALGUDA",
                                    "Value": "MIRYALGUDA"
                                },
                                {
                                    "Text": "MUGPAL",
                                    "Value": "MUGPAL"
                                },
                                {
                                    "Text": "MUNPALLE",
                                    "Value": "MUNPALLE"
                                },
                                {
                                    "Text": "NADEPALLE",
                                    "Value": "NADEPALLE"
                                },
                                {
                                    "Text": "NAKREKAL",
                                    "Value": "NAKREKAL"
                                },
                                {
                                    "Text": "NALGONDA",
                                    "Value": "NALGONDA"
                                },
                                {
                                    "Text": "NARASAMPET",
                                    "Value": "NARASAMPET"
                                },
                                {
                                    "Text": "NARAYANPET",
                                    "Value": "NARAYANPET"
                                },
                                {
                                    "Text": "NARSAMPET",
                                    "Value": "NARSAMPET"
                                },
                                {
                                    "Text": "NIRMAL",
                                    "Value": "NIRMAL"
                                },
                                {
                                    "Text": "NIZAMABAD",
                                    "Value": "NIZAMABAD"
                                },
                                {
                                    "Text": "PACHCHUNUR",
                                    "Value": "PACHCHUNUR"
                                },
                                {
                                    "Text": "PALWANCHA",
                                    "Value": "PALWANCHA"
                                },
                                {
                                    "Text": "PARKAL",
                                    "Value": "PARKAL"
                                },
                                {
                                    "Text": "PATANCHERU",
                                    "Value": "PATANCHERU"
                                },
                                {
                                    "Text": "PEDDAPALLE",
                                    "Value": "PEDDAPALLE"
                                },
                                {
                                    "Text": "PEDDAPUR",
                                    "Value": "PEDDAPUR"
                                },
                                {
                                    "Text": "PEGADAPALLI",
                                    "Value": "PEGADAPALLI"
                                },
                                {
                                    "Text": "RAGHAVAPET",
                                    "Value": "RAGHAVAPET"
                                },
                                {
                                    "Text": "RAMAGUNDAM",
                                    "Value": "RAMAGUNDAM"
                                },
                                {
                                    "Text": "RANGAREDDI",
                                    "Value": "RANGAREDDI"
                                },
                                {
                                    "Text": "RANGAREDDY",
                                    "Value": "RANGAREDDY"
                                },
                                {
                                    "Text": "REDDIPALLE",
                                    "Value": "REDDIPALLE"
                                },
                                {
                                    "Text": "SATHUPALLE",
                                    "Value": "SATHUPALLE"
                                },
                                {
                                    "Text": "SECUNDERABAD",
                                    "Value": "SECUNDERABAD"
                                },
                                {
                                    "Text": "SECUNDERABAD CANTT.",
                                    "Value": "SECUNDERABAD CANTT."
                                },
                                {
                                    "Text": "SHADNAGAR",
                                    "Value": "SHADNAGAR"
                                },
                                {
                                    "Text": "SHAMSHABAD",
                                    "Value": "SHAMSHABAD"
                                },
                                {
                                    "Text": "SHANKARPALLY",
                                    "Value": "SHANKARPALLY"
                                },
                                {
                                    "Text": "SIDDIPET",
                                    "Value": "SIDDIPET"
                                },
                                {
                                    "Text": "SIRCILLA",
                                    "Value": "SIRCILLA"
                                },
                                {
                                    "Text": "SULTANABAD",
                                    "Value": "SULTANABAD"
                                },
                                {
                                    "Text": "SURYAPET",
                                    "Value": "SURYAPET"
                                },
                                {
                                    "Text": "TANDUR",
                                    "Value": "TANDUR"
                                },
                                {
                                    "Text": "THADIKAL",
                                    "Value": "THADIKAL"
                                },
                                {
                                    "Text": "VANNEL K",
                                    "Value": "VANNEL K"
                                },
                                {
                                    "Text": "VEMULAKURTHI",
                                    "Value": "VEMULAKURTHI"
                                },
                                {
                                    "Text": "VEMULAWADA",
                                    "Value": "VEMULAWADA"
                                },
                                {
                                    "Text": "VICARABAD",
                                    "Value": "VICARABAD"
                                },
                                {
                                    "Text": "WANAPARTHY",
                                    "Value": "WANAPARTHY"
                                },
                                {
                                    "Text": "WARANGAL",
                                    "Value": "WARANGAL"
                                },
                                {
                                    "Text": "ZAHIRABAD",
                                    "Value": "ZAHIRABAD"
                                },
                                {
                                    "Text": "ABOHAR",
                                    "Value": "ABOHAR"
                                },
                                {
                                    "Text": "ABU DHABI",
                                    "Value": "ABU DHABI"
                                },
                                {
                                    "Text": "ABU ROAD",
                                    "Value": "ABU ROAD"
                                },
                                {
                                    "Text": "ACHALPUR",
                                    "Value": "ACHALPUR"
                                },
                                {
                                    "Text": "ADALAJ",
                                    "Value": "ADALAJ"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMWAL",
                                    "Value": "ADAMWAL"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADAMPUR",
                                    "Value": "ADAMPUR"
                                },
                                {
                                    "Text": "ADARCHAK ",
                                    "Value": "ADARCHAK "
                                },
                                {
                                    "Text": "ADAVDEVULAPALLY ",
                                    "Value": "ADAVDEVULAPALLY "
                                },
                                {
                                    "Text": "ADDANKI",
                                    "Value": "ADDANKI"
                                },
                                {
                                    "Text": "ADHARTAL",
                                    "Value": "ADHARTAL"
                                },
                                {
                                    "Text": "ADHEWADA",
                                    "Value": "ADHEWADA"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ADILABAD",
                                    "Value": "ADILABAD"
                                },
                                {
                                    "Text": "ADIMALI",
                                    "Value": "ADIMALI"
                                },
                                {
                                    "Text": "ADIPUR",
                                    "Value": "ADIPUR"
                                },
                                {
                                    "Text": "ADITYAPUR",
                                    "Value": "ADITYAPUR"
                                },
                                {
                                    "Text": "ADAJAN",
                                    "Value": "ADAJAN"
                                },
                                {
                                    "Text": "ADLOOR ",
                                    "Value": "ADLOOR "
                                },
                                {
                                    "Text": "AZAD NAGAR",
                                    "Value": "AZAD NAGAR"
                                },
                                {
                                    "Text": "ADONI",
                                    "Value": "ADONI"
                                },
                                {
                                    "Text": "ADOOR",
                                    "Value": "ADOOR"
                                },
                                {
                                    "Text": "AGARTALA",
                                    "Value": "AGARTALA"
                                },
                                {
                                    "Text": "AGAR",
                                    "Value": "AGAR"
                                },
                                {
                                    "Text": "AGASHI",
                                    "Value": "AGASHI"
                                },
                                {
                                    "Text": "AGONDA",
                                    "Value": "AGONDA"
                                },
                                {
                                    "Text": "AGONDH",
                                    "Value": "AGONDH"
                                },
                                {
                                    "Text": "AGRA",
                                    "Value": "AGRA"
                                },
                                {
                                    "Text": "AGROHA",
                                    "Value": "AGROHA"
                                },
                                {
                                    "Text": "ACHABAL",
                                    "Value": "ACHABAL"
                                },
                                {
                                    "Text": "AHMADPUR",
                                    "Value": "AHMADPUR"
                                },
                                {
                                    "Text": "AHMEDNAGAR",
                                    "Value": "AHMEDNAGAR"
                                },
                                {
                                    "Text": "AHMEDPUR",
                                    "Value": "AHMEDPUR"
                                },
                                {
                                    "Text": "AHMEDGARH",
                                    "Value": "AHMEDGARH"
                                },
                                {
                                    "Text": "AHMED NAGAR",
                                    "Value": "AHMED NAGAR"
                                },
                                {
                                    "Text": "AHMEDABAD",
                                    "Value": "AHMEDABAD"
                                },
                                {
                                    "Text": "AHMEDPUR ",
                                    "Value": "AHMEDPUR "
                                },
                                {
                                    "Text": "AHRWAN",
                                    "Value": "AHRWAN"
                                },
                                {
                                    "Text": "AIROLI",
                                    "Value": "AIROLI"
                                },
                                {
                                    "Text": "AIZAWL",
                                    "Value": "AIZAWL"
                                },
                                {
                                    "Text": "AJEETGARH",
                                    "Value": "AJEETGARH"
                                },
                                {
                                    "Text": "AJGAIN",
                                    "Value": "AJGAIN"
                                },
                                {
                                    "Text": "AJIT WAL",
                                    "Value": "AJIT WAL"
                                },
                                {
                                    "Text": "AJMER",
                                    "Value": "AJMER"
                                },
                                {
                                    "Text": "AJNALA",
                                    "Value": "AJNALA"
                                },
                                {
                                    "Text": "AJOD",
                                    "Value": "AJOD"
                                },
                                {
                                    "Text": "AJOL",
                                    "Value": "AJOL"
                                },
                                {
                                    "Text": "AKALTARA",
                                    "Value": "AKALTARA"
                                },
                                {
                                    "Text": "AKBARPUR",
                                    "Value": "AKBARPUR"
                                },
                                {
                                    "Text": "AKCHA",
                                    "Value": "AKCHA"
                                },
                                {
                                    "Text": "AKHNOOR",
                                    "Value": "AKHNOOR"
                                },
                                {
                                    "Text": "AKIVIDU",
                                    "Value": "AKIVIDU"
                                },
                                {
                                    "Text": "AKKAMPETA ",
                                    "Value": "AKKAMPETA "
                                },
                                {
                                    "Text": "AKKALKUWA",
                                    "Value": "AKKALKUWA"
                                },
                                {
                                    "Text": "AKKULAPETA ",
                                    "Value": "AKKULAPETA "
                                },
                                {
                                    "Text": "AKLUJ",
                                    "Value": "AKLUJ"
                                },
                                {
                                    "Text": "AKOLA",
                                    "Value": "AKOLA"
                                },
                                {
                                    "Text": "AKOT",
                                    "Value": "AKOT"
                                },
                                {
                                    "Text": "ALAGADAPA ",
                                    "Value": "ALAGADAPA "
                                },
                                {
                                    "Text": "ALAIR ",
                                    "Value": "ALAIR "
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ALAMPUR",
                                    "Value": "ALAMPUR"
                                },
                                {
                                    "Text": "ALAPPUZHA",
                                    "Value": "ALAPPUZHA"
                                },
                                {
                                    "Text": "ALAS",
                                    "Value": "ALAS"
                                },
                                {
                                    "Text": "ALATHUR",
                                    "Value": "ALATHUR"
                                },
                                {
                                    "Text": "ALDONA",
                                    "Value": "ALDONA"
                                },
                                {
                                    "Text": "ALHADPURA",
                                    "Value": "ALHADPURA"
                                },
                                {
                                    "Text": "ALIBAG",
                                    "Value": "ALIBAG"
                                },
                                {
                                    "Text": "ALIGANJ",
                                    "Value": "ALIGANJ"
                                },
                                {
                                    "Text": "ALIGARH",
                                    "Value": "ALIGARH"
                                },
                                {
                                    "Text": "ALIKAM ",
                                    "Value": "ALIKAM "
                                },
                                {
                                    "Text": "ALI PUR",
                                    "Value": "ALI PUR"
                                },
                                {
                                    "Text": "ALIPUR",
                                    "Value": "ALIPUR"
                                },
                                {
                                    "Text": "ALIPURDUAR",
                                    "Value": "ALIPURDUAR"
                                },
                                {
                                    "Text": "ALIRAJPUR",
                                    "Value": "ALIRAJPUR"
                                },
                                {
                                    "Text": "ALLAHABAD",
                                    "Value": "ALLAHABAD"
                                },
                                {
                                    "Text": "ALLAMPALLI .",
                                    "Value": "ALLAMPALLI ."
                                },
                                {
                                    "Text": "ALLAGADDA",
                                    "Value": "ALLAGADDA"
                                },
                                {
                                    "Text": "ALMORA",
                                    "Value": "ALMORA"
                                },
                                {
                                    "Text": "ALOOR ",
                                    "Value": "ALOOR "
                                },
                                {
                                    "Text": "ALLEPPEY",
                                    "Value": "ALLEPPEY"
                                },
                                {
                                    "Text": "ALUVA",
                                    "Value": "ALUVA"
                                },
                                {
                                    "Text": "ALWAYE",
                                    "Value": "ALWAYE"
                                },
                                {
                                    "Text": "ALWAR",
                                    "Value": "ALWAR"
                                },
                                {
                                    "Text": "AMALNER",
                                    "Value": "AMALNER"
                                },
                                {
                                    "Text": "AMALAPURAM",
                                    "Value": "AMALAPURAM"
                                },
                                {
                                    "Text": "AMALSAD",
                                    "Value": "AMALSAD"
                                },
                                {
                                    "Text": "AMANGALA ",
                                    "Value": "AMANGALA "
                                },
                                {
                                    "Text": "AMARGARH",
                                    "Value": "AMARGARH"
                                },
                                {
                                    "Text": "AMARKOT",
                                    "Value": "AMARKOT"
                                },
                                {
                                    "Text": "AMBAJI",
                                    "Value": "AMBAJI"
                                },
                                {
                                    "Text": "AMBALA",
                                    "Value": "AMBALA"
                                },
                                {
                                    "Text": "AMBAKAPALLE ",
                                    "Value": "AMBAKAPALLE "
                                },
                                {
                                    "Text": "AMBALATHADI ",
                                    "Value": "AMBALATHADI "
                                },
                                {
                                    "Text": "AMBALA CANTT",
                                    "Value": "AMBALA CANTT"
                                },
                                {
                                    "Text": "AMBALA CITY",
                                    "Value": "AMBALA CITY"
                                },
                                {
                                    "Text": "AMBEJOGAI",
                                    "Value": "AMBEJOGAI"
                                },
                                {
                                    "Text": "AMBERNATH",
                                    "Value": "AMBERNATH"
                                },
                                {
                                    "Text": "AMBEDKAR NAGAR",
                                    "Value": "AMBEDKAR NAGAR"
                                },
                                {
                                    "Text": "AMBEDKARNAGAR",
                                    "Value": "AMBEDKARNAGAR"
                                },
                                {
                                    "Text": "AMBELIM",
                                    "Value": "AMBELIM"
                                },
                                {
                                    "Text": "AMBIKAPUR",
                                    "Value": "AMBIKAPUR"
                                },
                                {
                                    "Text": "AMBARNATH",
                                    "Value": "AMBARNATH"
                                },
                                {
                                    "Text": "AMBUR",
                                    "Value": "AMBUR"
                                },
                                {
                                    "Text": "AMB",
                                    "Value": "AMB"
                                },
                                {
                                    "Text": "AMDADA",
                                    "Value": "AMDADA"
                                },
                                {
                                    "Text": "AMETHI",
                                    "Value": "AMETHI"
                                },
                                {
                                    "Text": "AMETHI",
                                    "Value": "AMETHI"
                                },
                                {
                                    "Text": "AMNAN",
                                    "Value": "AMNAN"
                                },
                                {
                                    "Text": "AMPATI",
                                    "Value": "AMPATI"
                                },
                                {
                                    "Text": "AMPATI",
                                    "Value": "AMPATI"
                                },
                                {
                                    "Text": "AMRAVATI",
                                    "Value": "AMRAVATI"
                                },
                                {
                                    "Text": "AMRAPUR",
                                    "Value": "AMRAPUR"
                                },
                                {
                                    "Text": "AMRELI",
                                    "Value": "AMRELI"
                                },
                                {
                                    "Text": "AMRITSAR",
                                    "Value": "AMRITSAR"
                                },
                                {
                                    "Text": "AMROHA",
                                    "Value": "AMROHA"
                                },
                                {
                                    "Text": "AMROLI",
                                    "Value": "AMROLI"
                                },
                                {
                                    "Text": "AMRUTH NAGAR ",
                                    "Value": "AMRUTH NAGAR "
                                },
                                {
                                    "Text": "AMTALA",
                                    "Value": "AMTALA"
                                },
                                {
                                    "Text": "ANAKAPALLE",
                                    "Value": "ANAKAPALLE"
                                },
                                {
                                    "Text": "ANANTAPUR",
                                    "Value": "ANANTAPUR"
                                },
                                {
                                    "Text": "ANANTHAPUR",
                                    "Value": "ANANTHAPUR"
                                },
                                {
                                    "Text": "ANANTNAG",
                                    "Value": "ANANTNAG"
                                },
                                {
                                    "Text": "ANANDPUR SAHIB",
                                    "Value": "ANANDPUR SAHIB"
                                },
                                {
                                    "Text": "ANAND",
                                    "Value": "ANAND"
                                },
                                {
                                    "Text": "ANANTHNAG",
                                    "Value": "ANANTHNAG"
                                },
                                {
                                    "Text": "ANANTHARAM ",
                                    "Value": "ANANTHARAM "
                                },
                                {
                                    "Text": "ANANTAGIRIPALLY ",
                                    "Value": "ANANTAGIRIPALLY "
                                },
                                {
                                    "Text": "ANAND NAGAR",
                                    "Value": "ANAND NAGAR"
                                },
                                {
                                    "Text": "ANANDPUR",
                                    "Value": "ANANDPUR"
                                },
                                {
                                    "Text": "ANASARAPUR",
                                    "Value": "ANASARAPUR"
                                },
                                {
                                    "Text": "ANATHARAM ",
                                    "Value": "ANATHARAM "
                                },
                                {
                                    "Text": "ANDAL GRAM",
                                    "Value": "ANDAL GRAM"
                                },
                                {
                                    "Text": "ANDHERI",
                                    "Value": "ANDHERI"
                                },
                                {
                                    "Text": "ANDUL",
                                    "Value": "ANDUL"
                                },
                                {
                                    "Text": "ANGAMALY",
                                    "Value": "ANGAMALY"
                                },
                                {
                                    "Text": "ANGUL",
                                    "Value": "ANGUL"
                                },
                                {
                                    "Text": "ANJAR",
                                    "Value": "ANJAR"
                                },
                                {
                                    "Text": "ANJAD",
                                    "Value": "ANJAD"
                                },
                                {
                                    "Text": "ANJAD",
                                    "Value": "ANJAD"
                                },
                                {
                                    "Text": "ANJANAPALLY ",
                                    "Value": "ANJANAPALLY "
                                },
                                {
                                    "Text": "ANJUNA",
                                    "Value": "ANJUNA"
                                },
                                {
                                    "Text": "ANKAPOOR ",
                                    "Value": "ANKAPOOR "
                                },
                                {
                                    "Text": "ANKLESHWAR",
                                    "Value": "ANKLESHWAR"
                                },
                                {
                                    "Text": "ANNARAM ",
                                    "Value": "ANNARAM "
                                },
                                {
                                    "Text": "ANNAVARAM ",
                                    "Value": "ANNAVARAM "
                                },
                                {
                                    "Text": "ANTARJAR",
                                    "Value": "ANTARJAR"
                                },
                                {
                                    "Text": "ANTPARA",
                                    "Value": "ANTPARA"
                                },
                                {
                                    "Text": "ANUGUL",
                                    "Value": "ANUGUL"
                                },
                                {
                                    "Text": "ANUPGARH",
                                    "Value": "ANUPGARH"
                                },
                                {
                                    "Text": "ANUPPUR",
                                    "Value": "ANUPPUR"
                                },
                                {
                                    "Text": "ANUPSHAHR",
                                    "Value": "ANUPSHAHR"
                                },
                                {
                                    "Text": "AONLA",
                                    "Value": "AONLA"
                                },
                                {
                                    "Text": "APPARAJPALLI ",
                                    "Value": "APPARAJPALLI "
                                },
                                {
                                    "Text": "APRA",
                                    "Value": "APRA"
                                },
                                {
                                    "Text": "ALTO PORVORIM",
                                    "Value": "ALTO PORVORIM"
                                },
                                {
                                    "Text": "ARA",
                                    "Value": "ARA"
                                },
                                {
                                    "Text": "ARAKONAM",
                                    "Value": "ARAKONAM"
                                },
                                {
                                    "Text": "ARAMBAGH",
                                    "Value": "ARAMBAGH"
                                },
                                {
                                    "Text": "ARAMPOONDI ",
                                    "Value": "ARAMPOONDI "
                                },
                                {
                                    "Text": "ARANTHANGI",
                                    "Value": "ARANTHANGI"
                                },
                                {
                                    "Text": "ARARIA",
                                    "Value": "ARARIA"
                                },
                                {
                                    "Text": "ARASIKERE",
                                    "Value": "ARASIKERE"
                                },
                                {
                                    "Text": "ARCOT",
                                    "Value": "ARCOT"
                                },
                                {
                                    "Text": "ARGUL ",
                                    "Value": "ARGUL "
                                },
                                {
                                    "Text": "ARIKAREVULA ",
                                    "Value": "ARIKAREVULA "
                                },
                                {
                                    "Text": "ARIYALUR",
                                    "Value": "ARIYALUR"
                                },
                                {
                                    "Text": "ARKKUPARAMBA ",
                                    "Value": "ARKKUPARAMBA "
                                },
                                {
                                    "Text": "ARMOOR",
                                    "Value": "ARMOOR"
                                },
                                {
                                    "Text": "ARNIWALA SHEIKH SUBHA",
                                    "Value": "ARNIWALA SHEIKH SUBHA"
                                },
                                {
                                    "Text": "ARNI",
                                    "Value": "ARNI"
                                },
                                {
                                    "Text": "ARNIWALA SHEIKH SUBHA",
                                    "Value": "ARNIWALA SHEIKH SUBHA"
                                },
                                {
                                    "Text": "ARNIWALA WAZIRAN",
                                    "Value": "ARNIWALA WAZIRAN"
                                },
                                {
                                    "Text": "ARPORA",
                                    "Value": "ARPORA"
                                },
                                {
                                    "Text": "ARRAH",
                                    "Value": "ARRAH"
                                },
                                {
                                    "Text": "ARRYAN WALA ",
                                    "Value": "ARRYAN WALA "
                                },
                                {
                                    "Text": "ARSIKERE",
                                    "Value": "ARSIKERE"
                                },
                                {
                                    "Text": "ARUPPUKKOTTAI",
                                    "Value": "ARUPPUKKOTTAI"
                                },
                                {
                                    "Text": "ARVI",
                                    "Value": "ARVI"
                                },
                                {
                                    "Text": "ARWAL",
                                    "Value": "ARWAL"
                                },
                                {
                                    "Text": "ASAFPUR",
                                    "Value": "ASAFPUR"
                                },
                                {
                                    "Text": "ASANSOL",
                                    "Value": "ASANSOL"
                                },
                                {
                                    "Text": "ASHOKNAGAR",
                                    "Value": "ASHOKNAGAR"
                                },
                                {
                                    "Text": "ASHOK NAGAR",
                                    "Value": "ASHOK NAGAR"
                                },
                                {
                                    "Text": "ASHOK NAGAR",
                                    "Value": "ASHOK NAGAR"
                                },
                                {
                                    "Text": "ASHTA",
                                    "Value": "ASHTA"
                                },
                                {
                                    "Text": "ASKA",
                                    "Value": "ASKA"
                                },
                                {
                                    "Text": "ASOLA",
                                    "Value": "ASOLA"
                                },
                                {
                                    "Text": "ASSANDH",
                                    "Value": "ASSANDH"
                                },
                                {
                                    "Text": "ASSONORA",
                                    "Value": "ASSONORA"
                                },
                                {
                                    "Text": "ASTA",
                                    "Value": "ASTA"
                                },
                                {
                                    "Text": "ATELI",
                                    "Value": "ATELI"
                                },
                                {
                                    "Text": "ATHANI",
                                    "Value": "ATHANI"
                                },
                                {
                                    "Text": "ATHANI",
                                    "Value": "ATHANI"
                                },
                                {
                                    "Text": "ATHGARH",
                                    "Value": "ATHGARH"
                                },
                                {
                                    "Text": "ATHNI",
                                    "Value": "ATHNI"
                                },
                                {
                                    "Text": "ATMAKUR",
                                    "Value": "ATMAKUR"
                                },
                                {
                                    "Text": "ATTAPUR",
                                    "Value": "ATTAPUR"
                                },
                                {
                                    "Text": "ATTARI",
                                    "Value": "ATTARI"
                                },
                                {
                                    "Text": "ATTUNGAL",
                                    "Value": "ATTUNGAL"
                                },
                                {
                                    "Text": "ATTUR",
                                    "Value": "ATTUR"
                                },
                                {
                                    "Text": "ATVELI ",
                                    "Value": "ATVELI "
                                },
                                {
                                    "Text": "AUJLA JOGI ",
                                    "Value": "AUJLA JOGI "
                                },
                                {
                                    "Text": "AUNDH",
                                    "Value": "AUNDH"
                                },
                                {
                                    "Text": "AURANGABAD",
                                    "Value": "AURANGABAD"
                                },
                                {
                                    "Text": "AURAIYA",
                                    "Value": "AURAIYA"
                                },
                                {
                                    "Text": "AURANGABAD(BH)",
                                    "Value": "AURANGABAD(BH)"
                                },
                                {
                                    "Text": "AURANGABAD",
                                    "Value": "AURANGABAD"
                                },
                                {
                                    "Text": "AUR",
                                    "Value": "AUR"
                                },
                                {
                                    "Text": "AVADI",
                                    "Value": "AVADI"
                                },
                                {
                                    "Text": "AVANASHI",
                                    "Value": "AVANASHI"
                                },
                                {
                                    "Text": "AVATHI",
                                    "Value": "AVATHI"
                                },
                                {
                                    "Text": "AWANTIPORA",
                                    "Value": "AWANTIPORA"
                                },
                                {
                                    "Text": "AYYAPPANTHANGAL",
                                    "Value": "AYYAPPANTHANGAL"
                                },
                                {
                                    "Text": "AZAMGARH",
                                    "Value": "AZAMGARH"
                                },
                                {
                                    "Text": "AZHIYANNUR",
                                    "Value": "AZHIYANNUR"
                                },
                                {
                                    "Text": "BABA SAHEB PETA ",
                                    "Value": "BABA SAHEB PETA "
                                },
                                {
                                    "Text": "BABA BAKALA",
                                    "Value": "BABA BAKALA"
                                },
                                {
                                    "Text": "BABHANAN",
                                    "Value": "BABHANAN"
                                },
                                {
                                    "Text": "BABINA",
                                    "Value": "BABINA"
                                },
                                {
                                    "Text": "BABRA",
                                    "Value": "BABRA"
                                },
                                {
                                    "Text": "BABURA ",
                                    "Value": "BABURA "
                                },
                                {
                                    "Text": "BABUGANJ",
                                    "Value": "BABUGANJ"
                                },
                                {
                                    "Text": "BACHHRAWAN",
                                    "Value": "BACHHRAWAN"
                                },
                                {
                                    "Text": "BADAKERA",
                                    "Value": "BADAKERA"
                                },
                                {
                                    "Text": "BADAL",
                                    "Value": "BADAL"
                                },
                                {
                                    "Text": "BADALI ALA SINGH",
                                    "Value": "BADALI ALA SINGH"
                                },
                                {
                                    "Text": "BADAULI",
                                    "Value": "BADAULI"
                                },
                                {
                                    "Text": "BADDI",
                                    "Value": "BADDI"
                                },
                                {
                                    "Text": "BADGAM",
                                    "Value": "BADGAM"
                                },
                                {
                                    "Text": "BADHNI KALAN",
                                    "Value": "BADHNI KALAN"
                                },
                                {
                                    "Text": "BADLAPUR",
                                    "Value": "BADLAPUR"
                                },
                                {
                                    "Text": "BADNAGAR",
                                    "Value": "BADNAGAR"
                                },
                                {
                                    "Text": "BADNAWAR",
                                    "Value": "BADNAWAR"
                                },
                                {
                                    "Text": "BADOL ",
                                    "Value": "BADOL "
                                },
                                {
                                    "Text": "BADUD",
                                    "Value": "BADUD"
                                },
                                {
                                    "Text": "BADVEL",
                                    "Value": "BADVEL"
                                },
                                {
                                    "Text": "BAGALKOT",
                                    "Value": "BAGALKOT"
                                },
                                {
                                    "Text": "BAGALKOT UHS CAMPUS ",
                                    "Value": "BAGALKOT UHS CAMPUS "
                                },
                                {
                                    "Text": "BAGALKOTE",
                                    "Value": "BAGALKOTE"
                                },
                                {
                                    "Text": "BAGDEHI",
                                    "Value": "BAGDEHI"
                                },
                                {
                                    "Text": "BAGESHWAR",
                                    "Value": "BAGESHWAR"
                                },
                                {
                                    "Text": "BAGHPAT",
                                    "Value": "BAGHPAT"
                                },
                                {
                                    "Text": "BAGHA PURANA",
                                    "Value": "BAGHA PURANA"
                                },
                                {
                                    "Text": "BAGHA",
                                    "Value": "BAGHA"
                                },
                                {
                                    "Text": "BAGNAN",
                                    "Value": "BAGNAN"
                                },
                                {
                                    "Text": "BAGPAT",
                                    "Value": "BAGPAT"
                                },
                                {
                                    "Text": "BAGPUR",
                                    "Value": "BAGPUR"
                                },
                                {
                                    "Text": "BAGRU",
                                    "Value": "BAGRU"
                                },
                                {
                                    "Text": "BAGRIAN ",
                                    "Value": "BAGRIAN "
                                },
                                {
                                    "Text": "BAHADURGARH",
                                    "Value": "BAHADURGARH"
                                },
                                {
                                    "Text": "BAHADURPUR",
                                    "Value": "BAHADURPUR"
                                },
                                {
                                    "Text": "BAHERI",
                                    "Value": "BAHERI"
                                },
                                {
                                    "Text": "BAHRAICH",
                                    "Value": "BAHRAICH"
                                },
                                {
                                    "Text": "BAHRAIN",
                                    "Value": "BAHRAIN"
                                },
                                {
                                    "Text": "BAHU JAMALPUR",
                                    "Value": "BAHU JAMALPUR"
                                },
                                {
                                    "Text": "BAIDPURA",
                                    "Value": "BAIDPURA"
                                },
                                {
                                    "Text": "BAIJNATH",
                                    "Value": "BAIJNATH"
                                },
                                {
                                    "Text": "BAIKUNTHPUR",
                                    "Value": "BAIKUNTHPUR"
                                },
                                {
                                    "Text": "BAINA",
                                    "Value": "BAINA"
                                },
                                {
                                    "Text": "BAIRAGARH",
                                    "Value": "BAIRAGARH"
                                },
                                {
                                    "Text": "BAJAHI ",
                                    "Value": "BAJAHI "
                                },
                                {
                                    "Text": "BAKARPUR",
                                    "Value": "BAKARPUR"
                                },
                                {
                                    "Text": "BAKHTIARPUR",
                                    "Value": "BAKHTIARPUR"
                                },
                                {
                                    "Text": "BANKNER",
                                    "Value": "BANKNER"
                                },
                                {
                                    "Text": "BAKSA",
                                    "Value": "BAKSA"
                                },
                                {
                                    "Text": "BALASORE",
                                    "Value": "BALASORE"
                                },
                                {
                                    "Text": "BALACHAUR",
                                    "Value": "BALACHAUR"
                                },
                                {
                                    "Text": "BALAGHAT",
                                    "Value": "BALAGHAT"
                                },
                                {
                                    "Text": "BALANGIR",
                                    "Value": "BALANGIR"
                                },
                                {
                                    "Text": "BALASINOR",
                                    "Value": "BALASINOR"
                                },
                                {
                                    "Text": "BALANA",
                                    "Value": "BALANA"
                                },
                                {
                                    "Text": "BALESWAR",
                                    "Value": "BALESWAR"
                                },
                                {
                                    "Text": "BALER KHANPUR ",
                                    "Value": "BALER KHANPUR "
                                },
                                {
                                    "Text": "BALIGHATTAM ",
                                    "Value": "BALIGHATTAM "
                                },
                                {
                                    "Text": "BALLARPUR",
                                    "Value": "BALLARPUR"
                                },
                                {
                                    "Text": "BALLIA",
                                    "Value": "BALLIA"
                                },
                                {
                                    "Text": "BALLIA",
                                    "Value": "BALLIA"
                                },
                                {
                                    "Text": "BALLA",
                                    "Value": "BALLA"
                                },
                                {
                                    "Text": "BALLABHGARH",
                                    "Value": "BALLABHGARH"
                                },
                                {
                                    "Text": "BALLARY",
                                    "Value": "BALLARY"
                                },
                                {
                                    "Text": "BALMATTA",
                                    "Value": "BALMATTA"
                                },
                                {
                                    "Text": "BALODA BAZAR",
                                    "Value": "BALODA BAZAR"
                                },
                                {
                                    "Text": "BALOTRA",
                                    "Value": "BALOTRA"
                                },
                                {
                                    "Text": "BALOD",
                                    "Value": "BALOD"
                                },
                                {
                                    "Text": "BALODA",
                                    "Value": "BALODA"
                                },
                                {
                                    "Text": "BALRAMPUR",
                                    "Value": "BALRAMPUR"
                                },
                                {
                                    "Text": "BALRAMPUR",
                                    "Value": "BALRAMPUR"
                                },
                                {
                                    "Text": "BALUGAON",
                                    "Value": "BALUGAON"
                                },
                                {
                                    "Text": "BALURGHAT",
                                    "Value": "BALURGHAT"
                                },
                                {
                                    "Text": "BAMAILA",
                                    "Value": "BAMAILA"
                                },
                                {
                                    "Text": "BAMOSANA",
                                    "Value": "BAMOSANA"
                                },
                                {
                                    "Text": "BAMRAULI KATARA",
                                    "Value": "BAMRAULI KATARA"
                                },
                                {
                                    "Text": "BAMUNARA",
                                    "Value": "BAMUNARA"
                                },
                                {
                                    "Text": "BANASKANTHA",
                                    "Value": "BANASKANTHA"
                                },
                                {
                                    "Text": "BANAPURA",
                                    "Value": "BANAPURA"
                                },
                                {
                                    "Text": "BANAGANAPALLE",
                                    "Value": "BANAGANAPALLE"
                                },
                                {
                                    "Text": "BANAS KANTHA",
                                    "Value": "BANAS KANTHA"
                                },
                                {
                                    "Text": "BANASINGA",
                                    "Value": "BANASINGA"
                                },
                                {
                                    "Text": "BANDA",
                                    "Value": "BANDA"
                                },
                                {
                                    "Text": "BANDIPUR",
                                    "Value": "BANDIPUR"
                                },
                                {
                                    "Text": "BANDRA",
                                    "Value": "BANDRA"
                                },
                                {
                                    "Text": "BANDIPORA",
                                    "Value": "BANDIPORA"
                                },
                                {
                                    "Text": "BANDIKUI",
                                    "Value": "BANDIKUI"
                                },
                                {
                                    "Text": "BANDIPORE",
                                    "Value": "BANDIPORE"
                                },
                                {
                                    "Text": "BANGA",
                                    "Value": "BANGA"
                                },
                                {
                                    "Text": "BANGALORE",
                                    "Value": "BANGALORE"
                                },
                                {
                                    "Text": "BANGALORE RURAL",
                                    "Value": "BANGALORE RURAL"
                                },
                                {
                                    "Text": "BANGARIGADDA ",
                                    "Value": "BANGARIGADDA "
                                },
                                {
                                    "Text": "BANGO DAM ",
                                    "Value": "BANGO DAM "
                                },
                                {
                                    "Text": "BANGARAPET",
                                    "Value": "BANGARAPET"
                                },
                                {
                                    "Text": "BANGARMAU",
                                    "Value": "BANGARMAU"
                                },
                                {
                                    "Text": "BANKA",
                                    "Value": "BANKA"
                                },
                                {
                                    "Text": "BANKURA",
                                    "Value": "BANKURA"
                                },
                                {
                                    "Text": "BANKATI ",
                                    "Value": "BANKATI "
                                },
                                {
                                    "Text": "BANNUR",
                                    "Value": "BANNUR"
                                },
                                {
                                    "Text": "BANS KHERI",
                                    "Value": "BANS KHERI"
                                },
                                {
                                    "Text": "BANSUR ALWAR",
                                    "Value": "BANSUR ALWAR"
                                },
                                {
                                    "Text": "BANSWARA",
                                    "Value": "BANSWARA"
                                },
                                {
                                    "Text": "BANS KHERI",
                                    "Value": "BANS KHERI"
                                },
                                {
                                    "Text": "BANSI",
                                    "Value": "BANSI"
                                },
                                {
                                    "Text": "BANSUR-ALWAR",
                                    "Value": "BANSUR-ALWAR"
                                },
                                {
                                    "Text": "BANSWADA",
                                    "Value": "BANSWADA"
                                },
                                {
                                    "Text": "BANTWAL",
                                    "Value": "BANTWAL"
                                },
                                {
                                    "Text": "BANTVAL",
                                    "Value": "BANTVAL"
                                },
                                {
                                    "Text": "BANUR",
                                    "Value": "BANUR"
                                },
                                {
                                    "Text": "BAPATLA",
                                    "Value": "BAPATLA"
                                },
                                {
                                    "Text": "BAPURASAPURAM",
                                    "Value": "BAPURASAPURAM"
                                },
                                {
                                    "Text": "BARASAT",
                                    "Value": "BARASAT"
                                },
                                {
                                    "Text": "BARAMATI",
                                    "Value": "BARAMATI"
                                },
                                {
                                    "Text": "BARABANKI",
                                    "Value": "BARABANKI"
                                },
                                {
                                    "Text": "BARAMULLA",
                                    "Value": "BARAMULLA"
                                },
                                {
                                    "Text": "BARAN",
                                    "Value": "BARAN"
                                },
                                {
                                    "Text": "BARAKAR",
                                    "Value": "BARAKAR"
                                },
                                {
                                    "Text": "BARACHIRKA ",
                                    "Value": "BARACHIRKA "
                                },
                                {
                                    "Text": "BARAMA",
                                    "Value": "BARAMA"
                                },
                                {
                                    "Text": "BARANA",
                                    "Value": "BARANA"
                                },
                                {
                                    "Text": "BARARA",
                                    "Value": "BARARA"
                                },
                                {
                                    "Text": "BARAULI",
                                    "Value": "BARAULI"
                                },
                                {
                                    "Text": "BARAUT",
                                    "Value": "BARAUT"
                                },
                                {
                                    "Text": "BARBIL",
                                    "Value": "BARBIL"
                                },
                                {
                                    "Text": "BARDEZ",
                                    "Value": "BARDEZ"
                                },
                                {
                                    "Text": "BARDOLI",
                                    "Value": "BARDOLI"
                                },
                                {
                                    "Text": "BARDHAMAN",
                                    "Value": "BARDHAMAN"
                                },
                                {
                                    "Text": "BAREILLY",
                                    "Value": "BAREILLY"
                                },
                                {
                                    "Text": "BARELI",
                                    "Value": "BARELI"
                                },
                                {
                                    "Text": "BARETHI",
                                    "Value": "BARETHI"
                                },
                                {
                                    "Text": "BAREWAL AWANNA",
                                    "Value": "BAREWAL AWANNA"
                                },
                                {
                                    "Text": "BARFUNG",
                                    "Value": "BARFUNG"
                                },
                                {
                                    "Text": "BARGARH",
                                    "Value": "BARGARH"
                                },
                                {
                                    "Text": "BARGARI",
                                    "Value": "BARGARI"
                                },
                                {
                                    "Text": "BARH",
                                    "Value": "BARH"
                                },
                                {
                                    "Text": "BARHAJ",
                                    "Value": "BARHAJ"
                                },
                                {
                                    "Text": "BARHALGANJ",
                                    "Value": "BARHALGANJ"
                                },
                                {
                                    "Text": "BARHERI BADI",
                                    "Value": "BARHERI BADI"
                                },
                                {
                                    "Text": "BARHI",
                                    "Value": "BARHI"
                                },
                                {
                                    "Text": "BARIPADA",
                                    "Value": "BARIPADA"
                                },
                                {
                                    "Text": "BARI BRAHMANA",
                                    "Value": "BARI BRAHMANA"
                                },
                                {
                                    "Text": "BARIAN KALAN",
                                    "Value": "BARIAN KALAN"
                                },
                                {
                                    "Text": "BARIWALA",
                                    "Value": "BARIWALA"
                                },
                                {
                                    "Text": "BARKATABAD",
                                    "Value": "BARKATABAD"
                                },
                                {
                                    "Text": "BARMER",
                                    "Value": "BARMER"
                                },
                                {
                                    "Text": "BARNALA",
                                    "Value": "BARNALA"
                                },
                                {
                                    "Text": "BARODA",
                                    "Value": "BARODA"
                                },
                                {
                                    "Text": "BARPETA",
                                    "Value": "BARPETA"
                                },
                                {
                                    "Text": "BARRACKPORE",
                                    "Value": "BARRACKPORE"
                                },
                                {
                                    "Text": "BARSHI",
                                    "Value": "BARSHI"
                                },
                                {
                                    "Text": "BARSAR",
                                    "Value": "BARSAR"
                                },
                                {
                                    "Text": "BARWALA",
                                    "Value": "BARWALA"
                                },
                                {
                                    "Text": "BARWANI",
                                    "Value": "BARWANI"
                                },
                                {
                                    "Text": "BARWAHA",
                                    "Value": "BARWAHA"
                                },
                                {
                                    "Text": "BARWALA",
                                    "Value": "BARWALA"
                                },
                                {
                                    "Text": "BASAR",
                                    "Value": "BASAR"
                                },
                                {
                                    "Text": "BASANTPURA ",
                                    "Value": "BASANTPURA "
                                },
                                {
                                    "Text": "BASAVAKALYAN",
                                    "Value": "BASAVAKALYAN"
                                },
                                {
                                    "Text": "BASKHARI",
                                    "Value": "BASKHARI"
                                },
                                {
                                    "Text": "BASKUSHLA",
                                    "Value": "BASKUSHLA"
                                },
                                {
                                    "Text": "BASNA",
                                    "Value": "BASNA"
                                },
                                {
                                    "Text": "BASNI SILAWANTAN",
                                    "Value": "BASNI SILAWANTAN"
                                },
                                {
                                    "Text": "BASODA",
                                    "Value": "BASODA"
                                },
                                {
                                    "Text": "BASSI PATHANA",
                                    "Value": "BASSI PATHANA"
                                },
                                {
                                    "Text": "BASTAR",
                                    "Value": "BASTAR"
                                },
                                {
                                    "Text": "BASTI",
                                    "Value": "BASTI"
                                },
                                {
                                    "Text": "BASWAPUR ",
                                    "Value": "BASWAPUR "
                                },
                                {
                                    "Text": "BATALA",
                                    "Value": "BATALA"
                                },
                                {
                                    "Text": "BATHINDA",
                                    "Value": "BATHINDA"
                                },
                                {
                                    "Text": "BATLAGUNDU",
                                    "Value": "BATLAGUNDU"
                                },
                                {
                                    "Text": "BAUDHGARH",
                                    "Value": "BAUDHGARH"
                                },
                                {
                                    "Text": "BAVLA",
                                    "Value": "BAVLA"
                                },
                                {
                                    "Text": "BAWAL",
                                    "Value": "BAWAL"
                                },
                                {
                                    "Text": "BAWANI KHERA",
                                    "Value": "BAWANI KHERA"
                                },
                                {
                                    "Text": "BAWNE PANGRI ",
                                    "Value": "BAWNE PANGRI "
                                },
                                {
                                    "Text": "BAZPUR",
                                    "Value": "BAZPUR"
                                },
                                {
                                    "Text": "BABAR PUR",
                                    "Value": "BABAR PUR"
                                },
                                {
                                    "Text": "BADHOI",
                                    "Value": "BADHOI"
                                },
                                {
                                    "Text": "BADHAIU",
                                    "Value": "BADHAIU"
                                },
                                {
                                    "Text": "BADAUN",
                                    "Value": "BADAUN"
                                },
                                {
                                    "Text": "BUDHWARIA",
                                    "Value": "BUDHWARIA"
                                },
                                {
                                    "Text": "BEAS",
                                    "Value": "BEAS"
                                },
                                {
                                    "Text": "BEAWAR",
                                    "Value": "BEAWAR"
                                },
                                {
                                    "Text": "BEBAD OHOL",
                                    "Value": "BEBAD OHOL"
                                },
                                {
                                    "Text": "BECHARAJI",
                                    "Value": "BECHARAJI"
                                },
                                {
                                    "Text": "BEDI APMC",
                                    "Value": "BEDI APMC"
                                },
                                {
                                    "Text": "BEDI-APMC",
                                    "Value": "BEDI-APMC"
                                },
                                {
                                    "Text": "BEED",
                                    "Value": "BEED"
                                },
                                {
                                    "Text": "BEGOWAL",
                                    "Value": "BEGOWAL"
                                },
                                {
                                    "Text": "BEGUM PUR",
                                    "Value": "BEGUM PUR"
                                },
                                {
                                    "Text": "BEGUSARAI",
                                    "Value": "BEGUSARAI"
                                },
                                {
                                    "Text": "BEGUN",
                                    "Value": "BEGUN"
                                },
                                {
                                    "Text": "BEHAT",
                                    "Value": "BEHAT"
                                },
                                {
                                    "Text": "BEHRAMPUR",
                                    "Value": "BEHRAMPUR"
                                },
                                {
                                    "Text": "BEHRAICH",
                                    "Value": "BEHRAICH"
                                },
                                {
                                    "Text": "BEHROR",
                                    "Value": "BEHROR"
                                },
                                {
                                    "Text": "BEHRAM",
                                    "Value": "BEHRAM"
                                },
                                {
                                    "Text": "BEHRAMPUR",
                                    "Value": "BEHRAMPUR"
                                },
                                {
                                    "Text": "BELDIH ",
                                    "Value": "BELDIH "
                                },
                                {
                                    "Text": "BELGAUM",
                                    "Value": "BELGAUM"
                                },
                                {
                                    "Text": "BELLARY",
                                    "Value": "BELLARY"
                                },
                                {
                                    "Text": "BELLAMPALLE",
                                    "Value": "BELLAMPALLE"
                                },
                                {
                                    "Text": "BELTHANGADY",
                                    "Value": "BELTHANGADY"
                                },
                                {
                                    "Text": "BELTHARA ROAD",
                                    "Value": "BELTHARA ROAD"
                                },
                                {
                                    "Text": "BELTOLA",
                                    "Value": "BELTOLA"
                                },
                                {
                                    "Text": "BEMBAL ",
                                    "Value": "BEMBAL "
                                },
                                {
                                    "Text": "BEMETARA",
                                    "Value": "BEMETARA"
                                },
                                {
                                    "Text": "BENAPUR",
                                    "Value": "BENAPUR"
                                },
                                {
                                    "Text": "BENAULIM",
                                    "Value": "BENAULIM"
                                },
                                {
                                    "Text": "BENGALURU",
                                    "Value": "BENGALURU"
                                },
                                {
                                    "Text": "BENNABHUPALAPATNAM ",
                                    "Value": "BENNABHUPALAPATNAM "
                                },
                                {
                                    "Text": "BEN",
                                    "Value": "BEN"
                                },
                                {
                                    "Text": "BERHAMPORE",
                                    "Value": "BERHAMPORE"
                                },
                                {
                                    "Text": "BESA ROAD ",
                                    "Value": "BESA ROAD "
                                },
                                {
                                    "Text": "BETASING",
                                    "Value": "BETASING"
                                },
                                {
                                    "Text": "BETIAH",
                                    "Value": "BETIAH"
                                },
                                {
                                    "Text": "BETTIAH",
                                    "Value": "BETTIAH"
                                },
                                {
                                    "Text": "BETUL",
                                    "Value": "BETUL"
                                },
                                {
                                    "Text": "BAGAHA-I",
                                    "Value": "BAGAHA-I"
                                },
                                {
                                    "Text": "BEGUMABAD BUDHANA",
                                    "Value": "BEGUMABAD BUDHANA"
                                },
                                {
                                    "Text": "BAGASARA",
                                    "Value": "BAGASARA"
                                },
                                {
                                    "Text": "BHADRA",
                                    "Value": "BHADRA"
                                },
                                {
                                    "Text": "BHACHAU",
                                    "Value": "BHACHAU"
                                },
                                {
                                    "Text": "BHADOHI",
                                    "Value": "BHADOHI"
                                },
                                {
                                    "Text": "BHADRACHALAM",
                                    "Value": "BHADRACHALAM"
                                },
                                {
                                    "Text": "BHADRAK",
                                    "Value": "BHADRAK"
                                },
                                {
                                    "Text": "BHADRAVATI",
                                    "Value": "BHADRAVATI"
                                },
                                {
                                    "Text": "BHADAUR",
                                    "Value": "BHADAUR"
                                },
                                {
                                    "Text": "BHADERWAH",
                                    "Value": "BHADERWAH"
                                },
                                {
                                    "Text": "BHADKODRA",
                                    "Value": "BHADKODRA"
                                },
                                {
                                    "Text": "BHADRAWATI",
                                    "Value": "BHADRAWATI"
                                },
                                {
                                    "Text": "BHADSON",
                                    "Value": "BHADSON"
                                },
                                {
                                    "Text": "BHAGALPUR",
                                    "Value": "BHAGALPUR"
                                },
                                {
                                    "Text": "BHAGTHALA KALAN ",
                                    "Value": "BHAGTHALA KALAN "
                                },
                                {
                                    "Text": "BHAGAN",
                                    "Value": "BHAGAN"
                                },
                                {
                                    "Text": "BHAGO MAJRA",
                                    "Value": "BHAGO MAJRA"
                                },
                                {
                                    "Text": "BHAGOKE",
                                    "Value": "BHAGOKE"
                                },
                                {
                                    "Text": "BHAGRANA",
                                    "Value": "BHAGRANA"
                                },
                                {
                                    "Text": "BHAGTA",
                                    "Value": "BHAGTA"
                                },
                                {
                                    "Text": "BHAINSA",
                                    "Value": "BHAINSA"
                                },
                                {
                                    "Text": "BHAINSORI ",
                                    "Value": "BHAINSORI "
                                },
                                {
                                    "Text": "BHAKARWADI ",
                                    "Value": "BHAKARWADI "
                                },
                                {
                                    "Text": "BHALGAMDA",
                                    "Value": "BHALGAMDA"
                                },
                                {
                                    "Text": "BHALONA ",
                                    "Value": "BHALONA "
                                },
                                {
                                    "Text": "BHALIABHOLKATENI",
                                    "Value": "BHALIABHOLKATENI"
                                },
                                {
                                    "Text": "BHALKI",
                                    "Value": "BHALKI"
                                },
                                {
                                    "Text": "BHAMARSI",
                                    "Value": "BHAMARSI"
                                },
                                {
                                    "Text": "BHAMBOLI",
                                    "Value": "BHAMBOLI"
                                },
                                {
                                    "Text": "BHANDARA",
                                    "Value": "BHANDARA"
                                },
                                {
                                    "Text": "BHANVAD",
                                    "Value": "BHANVAD"
                                },
                                {
                                    "Text": "BHANGALA",
                                    "Value": "BHANGALA"
                                },
                                {
                                    "Text": "BHANJANAGAR",
                                    "Value": "BHANJANAGAR"
                                },
                                {
                                    "Text": "BHANPURI",
                                    "Value": "BHANPURI"
                                },
                                {
                                    "Text": "BHANVAD",
                                    "Value": "BHANVAD"
                                },
                                {
                                    "Text": "BHAPAL ",
                                    "Value": "BHAPAL "
                                },
                                {
                                    "Text": "BHARATPUR",
                                    "Value": "BHARATPUR"
                                },
                                {
                                    "Text": "BHARUCH",
                                    "Value": "BHARUCH"
                                },
                                {
                                    "Text": "BHARMOUR",
                                    "Value": "BHARMOUR"
                                },
                                {
                                    "Text": "BHARNI",
                                    "Value": "BHARNI"
                                },
                                {
                                    "Text": "BHARTHANA",
                                    "Value": "BHARTHANA"
                                },
                                {
                                    "Text": "BHATPARA",
                                    "Value": "BHATPARA"
                                },
                                {
                                    "Text": "BHATAPARA",
                                    "Value": "BHATAPARA"
                                },
                                {
                                    "Text": "BHATINDA",
                                    "Value": "BHATINDA"
                                },
                                {
                                    "Text": "BHATKAL",
                                    "Value": "BHATKAL"
                                },
                                {
                                    "Text": "BHATEPURI ",
                                    "Value": "BHATEPURI "
                                },
                                {
                                    "Text": "BHATRAMARENAHALLI",
                                    "Value": "BHATRAMARENAHALLI"
                                },
                                {
                                    "Text": "BHATTIAN",
                                    "Value": "BHATTIAN"
                                },
                                {
                                    "Text": "BHATTU KALAN",
                                    "Value": "BHATTU KALAN"
                                },
                                {
                                    "Text": "BHAVNAGAR",
                                    "Value": "BHAVNAGAR"
                                },
                                {
                                    "Text": "BHAVANAGAR",
                                    "Value": "BHAVANAGAR"
                                },
                                {
                                    "Text": "BHAVANIPET ",
                                    "Value": "BHAVANIPET "
                                },
                                {
                                    "Text": "BHAWANIGARH",
                                    "Value": "BHAWANIGARH"
                                },
                                {
                                    "Text": "BHAWANIPATNA",
                                    "Value": "BHAWANIPATNA"
                                },
                                {
                                    "Text": "BHAWAI ",
                                    "Value": "BHAWAI "
                                },
                                {
                                    "Text": "BHAWANIPUR ",
                                    "Value": "BHAWANIPUR "
                                },
                                {
                                    "Text": "BHAYANDER",
                                    "Value": "BHAYANDER"
                                },
                                {
                                    "Text": "BHEDWAL ",
                                    "Value": "BHEDWAL "
                                },
                                {
                                    "Text": "BHEJGAON ",
                                    "Value": "BHEJGAON "
                                },
                                {
                                    "Text": "BHERIWADA ",
                                    "Value": "BHERIWADA "
                                },
                                {
                                    "Text": "BHALGAMDA",
                                    "Value": "BHALGAMDA"
                                },
                                {
                                    "Text": "BHIKHIWIND",
                                    "Value": "BHIKHIWIND"
                                },
                                {
                                    "Text": "BHIKHI",
                                    "Value": "BHIKHI"
                                },
                                {
                                    "Text": "BHILAI",
                                    "Value": "BHILAI"
                                },
                                {
                                    "Text": "BHILWARA",
                                    "Value": "BHILWARA"
                                },
                                {
                                    "Text": "BHILAI CHARODA",
                                    "Value": "BHILAI CHARODA"
                                },
                                {
                                    "Text": "BHIMAVARAM",
                                    "Value": "BHIMAVARAM"
                                },
                                {
                                    "Text": "BHIND",
                                    "Value": "BHIND"
                                },
                                {
                                    "Text": "BHINGA",
                                    "Value": "BHINGA"
                                },
                                {
                                    "Text": "BHINMAL",
                                    "Value": "BHINMAL"
                                },
                                {
                                    "Text": "BHIWADI",
                                    "Value": "BHIWADI"
                                },
                                {
                                    "Text": "BHIWANI",
                                    "Value": "BHIWANI"
                                },
                                {
                                    "Text": "BHANDUP",
                                    "Value": "BHANDUP"
                                },
                                {
                                    "Text": "BHODIPURA",
                                    "Value": "BHODIPURA"
                                },
                                {
                                    "Text": "BHOGPUR",
                                    "Value": "BHOGPUR"
                                },
                                {
                                    "Text": "BHOGA SAMUDRAM",
                                    "Value": "BHOGA SAMUDRAM"
                                },
                                {
                                    "Text": "BHOJPUR",
                                    "Value": "BHOJPUR"
                                },
                                {
                                    "Text": "BHOKHRA",
                                    "Value": "BHOKHRA"
                                },
                                {
                                    "Text": "BHOLATH",
                                    "Value": "BHOLATH"
                                },
                                {
                                    "Text": "BHONGIR",
                                    "Value": "BHONGIR"
                                },
                                {
                                    "Text": "BHONGIR GUNJ ",
                                    "Value": "BHONGIR GUNJ "
                                },
                                {
                                    "Text": "BHONRKA ",
                                    "Value": "BHONRKA "
                                },
                                {
                                    "Text": "BHOORA ",
                                    "Value": "BHOORA "
                                },
                                {
                                    "Text": "BHOPAL",
                                    "Value": "BHOPAL"
                                },
                                {
                                    "Text": "BHOPANI",
                                    "Value": "BHOPANI"
                                },
                                {
                                    "Text": "BHORING",
                                    "Value": "BHORING"
                                },
                                {
                                    "Text": "BHOSARI",
                                    "Value": "BHOSARI"
                                },
                                {
                                    "Text": "BIHARSHARIF",
                                    "Value": "BIHARSHARIF"
                                },
                                {
                                    "Text": "BEHTA HAJIPUR",
                                    "Value": "BEHTA HAJIPUR"
                                },
                                {
                                    "Text": "BHATI",
                                    "Value": "BHATI"
                                },
                                {
                                    "Text": "BHUBANESHWAR",
                                    "Value": "BHUBANESHWAR"
                                },
                                {
                                    "Text": "BHUBANESWAR",
                                    "Value": "BHUBANESWAR"
                                },
                                {
                                    "Text": "BHUCHO MANDI",
                                    "Value": "BHUCHO MANDI"
                                },
                                {
                                    "Text": "BHUJ",
                                    "Value": "BHUJ"
                                },
                                {
                                    "Text": "BHUJODI",
                                    "Value": "BHUJODI"
                                },
                                {
                                    "Text": "BHULATH",
                                    "Value": "BHULATH"
                                },
                                {
                                    "Text": "BHUNDRI",
                                    "Value": "BHUNDRI"
                                },
                                {
                                    "Text": "BHUNTAR",
                                    "Value": "BHUNTAR"
                                },
                                {
                                    "Text": "BHUSAWAL",
                                    "Value": "BHUSAWAL"
                                },
                                {
                                    "Text": "BHUSAWAL",
                                    "Value": "BHUSAWAL"
                                },
                                {
                                    "Text": "BIAORA",
                                    "Value": "BIAORA"
                                },
                                {
                                    "Text": "BICHOLIM",
                                    "Value": "BICHOLIM"
                                },
                                {
                                    "Text": "BIDADI",
                                    "Value": "BIDADI"
                                },
                                {
                                    "Text": "BIDAR",
                                    "Value": "BIDAR"
                                },
                                {
                                    "Text": "BIDAR",
                                    "Value": "BIDAR"
                                },
                                {
                                    "Text": "BIDALUR ",
                                    "Value": "BIDALUR "
                                },
                                {
                                    "Text": "BIDHAN NAGAR",
                                    "Value": "BIDHAN NAGAR"
                                },
                                {
                                    "Text": "BIDHUNA",
                                    "Value": "BIDHUNA"
                                },
                                {
                                    "Text": "BID",
                                    "Value": "BID"
                                },
                                {
                                    "Text": "BIHAR",
                                    "Value": "BIHAR"
                                },
                                {
                                    "Text": "BIHAT BIRAM",
                                    "Value": "BIHAT BIRAM"
                                },
                                {
                                    "Text": "BIJAINAGAR",
                                    "Value": "BIJAINAGAR"
                                },
                                {
                                    "Text": "BIJAPUR",
                                    "Value": "BIJAPUR"
                                },
                                {
                                    "Text": "BIJAPUR(CGH)",
                                    "Value": "BIJAPUR(CGH)"
                                },
                                {
                                    "Text": "BIJAPUR(KAR)",
                                    "Value": "BIJAPUR(KAR)"
                                },
                                {
                                    "Text": "BIJAPUR",
                                    "Value": "BIJAPUR"
                                },
                                {
                                    "Text": "BIJA",
                                    "Value": "BIJA"
                                },
                                {
                                    "Text": "BIJBEHARA",
                                    "Value": "BIJBEHARA"
                                },
                                {
                                    "Text": "BIJJAWARA ",
                                    "Value": "BIJJAWARA "
                                },
                                {
                                    "Text": "BIJJAWARA",
                                    "Value": "BIJJAWARA"
                                },
                                {
                                    "Text": "BIJNOR",
                                    "Value": "BIJNOR"
                                },
                                {
                                    "Text": "BIJOYNAGAR",
                                    "Value": "BIJOYNAGAR"
                                },
                                {
                                    "Text": "BIKANER",
                                    "Value": "BIKANER"
                                },
                                {
                                    "Text": "BIKRAMGANJ",
                                    "Value": "BIKRAMGANJ"
                                },
                                {
                                    "Text": "BILASPUR(CGH)",
                                    "Value": "BILASPUR(CGH)"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILARA",
                                    "Value": "BILARA"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILASPUR (HP)",
                                    "Value": "BILASPUR (HP)"
                                },
                                {
                                    "Text": "BILARI",
                                    "Value": "BILARI"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILASPUR",
                                    "Value": "BILASPUR"
                                },
                                {
                                    "Text": "BILGA",
                                    "Value": "BILGA"
                                },
                                {
                                    "Text": "BILGI",
                                    "Value": "BILGI"
                                },
                                {
                                    "Text": "BILHA",
                                    "Value": "BILHA"
                                },
                                {
                                    "Text": "BILIMORA",
                                    "Value": "BILIMORA"
                                },
                                {
                                    "Text": "BILLIMORA",
                                    "Value": "BILLIMORA"
                                },
                                {
                                    "Text": "BINA",
                                    "Value": "BINA"
                                },
                                {
                                    "Text": "BINDKI",
                                    "Value": "BINDKI"
                                },
                                {
                                    "Text": "BINDKI",
                                    "Value": "BINDKI"
                                },
                                {
                                    "Text": "BINOVANAGAR",
                                    "Value": "BINOVANAGAR"
                                },
                                {
                                    "Text": "BINOLA",
                                    "Value": "BINOLA"
                                },
                                {
                                    "Text": "BIRAMITRAPUR",
                                    "Value": "BIRAMITRAPUR"
                                },
                                {
                                    "Text": "BIRBHUM",
                                    "Value": "BIRBHUM"
                                },
                                {
                                    "Text": "BIRKONA",
                                    "Value": "BIRKONA"
                                },
                                {
                                    "Text": "BIRMITRAPUR",
                                    "Value": "BIRMITRAPUR"
                                },
                                {
                                    "Text": "BISALPUR",
                                    "Value": "BISALPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNA",
                                    "Value": "BISHNA"
                                },
                                {
                                    "Text": "BISTAULI KHURD",
                                    "Value": "BISTAULI KHURD"
                                },
                                {
                                    "Text": "BISWANATH CHAIRALI",
                                    "Value": "BISWANATH CHAIRALI"
                                },
                                {
                                    "Text": "BISWANATH CHARIALI",
                                    "Value": "BISWANATH CHARIALI"
                                },
                                {
                                    "Text": "BALIBAT",
                                    "Value": "BALIBAT"
                                },
                                {
                                    "Text": "BHILODA",
                                    "Value": "BHILODA"
                                },
                                {
                                    "Text": "BALLARD ESTATE",
                                    "Value": "BALLARD ESTATE"
                                },
                                {
                                    "Text": "BALAGUNDA (BELAGULA)",
                                    "Value": "BALAGUNDA (BELAGULA)"
                                },
                                {
                                    "Text": "BHALSWA JAHANGIR PUR",
                                    "Value": "BHALSWA JAHANGIR PUR"
                                },
                                {
                                    "Text": "BANDEL",
                                    "Value": "BANDEL"
                                },
                                {
                                    "Text": "BOBBILI",
                                    "Value": "BOBBILI"
                                },
                                {
                                    "Text": "BODAKDEV",
                                    "Value": "BODAKDEV"
                                },
                                {
                                    "Text": "BODELI",
                                    "Value": "BODELI"
                                },
                                {
                                    "Text": "BODHI BIGHA ",
                                    "Value": "BODHI BIGHA "
                                },
                                {
                                    "Text": "BODHAN",
                                    "Value": "BODHAN"
                                },
                                {
                                    "Text": "BODHGAYA",
                                    "Value": "BODHGAYA"
                                },
                                {
                                    "Text": "BODINAYAKKANNUR",
                                    "Value": "BODINAYAKKANNUR"
                                },
                                {
                                    "Text": "BOHA",
                                    "Value": "BOHA"
                                },
                                {
                                    "Text": "BOISAR",
                                    "Value": "BOISAR"
                                },
                                {
                                    "Text": "BOISAR II CHITRALAYA",
                                    "Value": "BOISAR II CHITRALAYA"
                                },
                                {
                                    "Text": "BOISAR II, CHITRALAYA",
                                    "Value": "BOISAR II, CHITRALAYA"
                                },
                                {
                                    "Text": "BOKARO",
                                    "Value": "BOKARO"
                                },
                                {
                                    "Text": "BOKAKHAT",
                                    "Value": "BOKAKHAT"
                                },
                                {
                                    "Text": "BOKAKHAT",
                                    "Value": "BOKAKHAT"
                                },
                                {
                                    "Text": "BOKKUDUPALLE ",
                                    "Value": "BOKKUDUPALLE "
                                },
                                {
                                    "Text": "BOLANGIR",
                                    "Value": "BOLANGIR"
                                },
                                {
                                    "Text": "BOLAGARH",
                                    "Value": "BOLAGARH"
                                },
                                {
                                    "Text": "BOLPUR",
                                    "Value": "BOLPUR"
                                },
                                {
                                    "Text": "BOL",
                                    "Value": "BOL"
                                },
                                {
                                    "Text": "BOMDILA",
                                    "Value": "BOMDILA"
                                },
                                {
                                    "Text": "BOMMAKAL",
                                    "Value": "BOMMAKAL"
                                },
                                {
                                    "Text": "BONGAIGAON",
                                    "Value": "BONGAIGAON"
                                },
                                {
                                    "Text": "BOPAL",
                                    "Value": "BOPAL"
                                },
                                {
                                    "Text": "BORAM ",
                                    "Value": "BORAM "
                                },
                                {
                                    "Text": "BORBATA ",
                                    "Value": "BORBATA "
                                },
                                {
                                    "Text": "BORBHATHA BET",
                                    "Value": "BORBHATHA BET"
                                },
                                {
                                    "Text": "BORGAON ",
                                    "Value": "BORGAON "
                                },
                                {
                                    "Text": "BORONILPUR",
                                    "Value": "BORONILPUR"
                                },
                                {
                                    "Text": "BORSAD",
                                    "Value": "BORSAD"
                                },
                                {
                                    "Text": "BORIVALI (W)",
                                    "Value": "BORIVALI (W)"
                                },
                                {
                                    "Text": "BOTAD",
                                    "Value": "BOTAD"
                                },
                                {
                                    "Text": "BOUDH",
                                    "Value": "BOUDH"
                                },
                                {
                                    "Text": "BOYTAWALA",
                                    "Value": "BOYTAWALA"
                                },
                                {
                                    "Text": "BASSI PATHTANA",
                                    "Value": "BASSI PATHTANA"
                                },
                                {
                                    "Text": "BRAHMANPALLI ",
                                    "Value": "BRAHMANPALLI "
                                },
                                {
                                    "Text": "BRAHMANAPALLE ",
                                    "Value": "BRAHMANAPALLE "
                                },
                                {
                                    "Text": "BRAHMAPORE",
                                    "Value": "BRAHMAPORE"
                                },
                                {
                                    "Text": "BRAHMAPUR",
                                    "Value": "BRAHMAPUR"
                                },
                                {
                                    "Text": "BRAMHAPURI",
                                    "Value": "BRAMHAPURI"
                                },
                                {
                                    "Text": "BAREJA",
                                    "Value": "BAREJA"
                                },
                                {
                                    "Text": "BRAJRAJ NAGAR",
                                    "Value": "BRAJRAJ NAGAR"
                                },
                                {
                                    "Text": "BARIK",
                                    "Value": "BARIK"
                                },
                                {
                                    "Text": "BURARI",
                                    "Value": "BURARI"
                                },
                                {
                                    "Text": "BISHALGARH",
                                    "Value": "BISHALGARH"
                                },
                                {
                                    "Text": "BISOKHAR",
                                    "Value": "BISOKHAR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "BISHNUPUR",
                                    "Value": "BISHNUPUR"
                                },
                                {
                                    "Text": "B.S.PURAM ",
                                    "Value": "B.S.PURAM "
                                },
                                {
                                    "Text": "BASIRHAT",
                                    "Value": "BASIRHAT"
                                },
                                {
                                    "Text": "BETASING",
                                    "Value": "BETASING"
                                },
                                {
                                    "Text": "BUDAUN",
                                    "Value": "BUDAUN"
                                },
                                {
                                    "Text": "BUDDUGONDA ",
                                    "Value": "BUDDUGONDA "
                                },
                                {
                                    "Text": "BUDGAM",
                                    "Value": "BUDGAM"
                                },
                                {
                                    "Text": "BUDGE BUDGE",
                                    "Value": "BUDGE BUDGE"
                                },
                                {
                                    "Text": "BUDHLADA",
                                    "Value": "BUDHLADA"
                                },
                                {
                                    "Text": "BUDH SINGH WALA ",
                                    "Value": "BUDH SINGH WALA "
                                },
                                {
                                    "Text": "BUDHALDA",
                                    "Value": "BUDHALDA"
                                },
                                {
                                    "Text": "BUDHANA",
                                    "Value": "BUDHANA"
                                },
                                {
                                    "Text": "BUDHERA",
                                    "Value": "BUDHERA"
                                },
                                {
                                    "Text": "BULANDSHARE",
                                    "Value": "BULANDSHARE"
                                },
                                {
                                    "Text": "BULANDSHAHAR",
                                    "Value": "BULANDSHAHAR"
                                },
                                {
                                    "Text": "BULANDSHAHR",
                                    "Value": "BULANDSHAHR"
                                },
                                {
                                    "Text": "BULDANA",
                                    "Value": "BULDANA"
                                },
                                {
                                    "Text": "BULDHANA",
                                    "Value": "BULDHANA"
                                },
                                {
                                    "Text": "BULHOWAL",
                                    "Value": "BULHOWAL"
                                },
                                {
                                    "Text": "BUNDI",
                                    "Value": "BUNDI"
                                },
                                {
                                    "Text": "BURDWAN",
                                    "Value": "BURDWAN"
                                },
                                {
                                    "Text": "BURHAR",
                                    "Value": "BURHAR"
                                },
                                {
                                    "Text": "BURHANPUR",
                                    "Value": "BURHANPUR"
                                },
                                {
                                    "Text": "BURLA",
                                    "Value": "BURLA"
                                },
                                {
                                    "Text": "BURNPUR",
                                    "Value": "BURNPUR"
                                },
                                {
                                    "Text": "BURNIHAT",
                                    "Value": "BURNIHAT"
                                },
                                {
                                    "Text": "BUTALA",
                                    "Value": "BUTALA"
                                },
                                {
                                    "Text": "BUTCHAMPETA ",
                                    "Value": "BUTCHAMPETA "
                                },
                                {
                                    "Text": "BUTIBORI",
                                    "Value": "BUTIBORI"
                                },
                                {
                                    "Text": "BUXAR",
                                    "Value": "BUXAR"
                                },
                                {
                                    "Text": "BHIWANDI",
                                    "Value": "BHIWANDI"
                                },
                                {
                                    "Text": "BAWANA",
                                    "Value": "BAWANA"
                                },
                                {
                                    "Text": "BHOWANIPORE",
                                    "Value": "BHOWANIPORE"
                                },
                                {
                                    "Text": "BILLAWAR",
                                    "Value": "BILLAWAR"
                                },
                                {
                                    "Text": "BYRNIHAT",
                                    "Value": "BYRNIHAT"
                                },
                                {
                                    "Text": "BYRNIHAT",
                                    "Value": "BYRNIHAT"
                                },
                                {
                                    "Text": "CACHAR",
                                    "Value": "CACHAR"
                                },
                                {
                                    "Text": "CALANGUTE",
                                    "Value": "CALANGUTE"
                                },
                                {
                                    "Text": "CALICUT",
                                    "Value": "CALICUT"
                                },
                                {
                                    "Text": "CANACONA",
                                    "Value": "CANACONA"
                                },
                                {
                                    "Text": "CANDOLIM",
                                    "Value": "CANDOLIM"
                                },
                                {
                                    "Text": "CANNANORE",
                                    "Value": "CANNANORE"
                                },
                                {
                                    "Text": "CANSAULIM",
                                    "Value": "CANSAULIM"
                                },
                                {
                                    "Text": "CARAMBOLIM",
                                    "Value": "CARAMBOLIM"
                                },
                                {
                                    "Text": "CAVELOSIM",
                                    "Value": "CAVELOSIM"
                                },
                                {
                                    "Text": "GRAND CAYMAN",
                                    "Value": "GRAND CAYMAN"
                                },
                                {
                                    "Text": "CBD BELAPUR",
                                    "Value": "CBD BELAPUR"
                                },
                                {
                                    "Text": "CENTRAL DELHI",
                                    "Value": "CENTRAL DELHI"
                                },
                                {
                                    "Text": "CENTRAL UNIVERSITY OF KARNATAKA,KAD",
                                    "Value": "CENTRAL UNIVERSITY OF KARNATAKA,KAD"
                                },
                                {
                                    "Text": "CHABAL KALAN",
                                    "Value": "CHABAL KALAN"
                                },
                                {
                                    "Text": "CHABEWAL",
                                    "Value": "CHABEWAL"
                                },
                                {
                                    "Text": "CHADURA",
                                    "Value": "CHADURA"
                                },
                                {
                                    "Text": "CHAIBASA",
                                    "Value": "CHAIBASA"
                                },
                                {
                                    "Text": "CHAKSU",
                                    "Value": "CHAKSU"
                                },
                                {
                                    "Text": "CHAKAN",
                                    "Value": "CHAKAN"
                                },
                                {
                                    "Text": "CHAK KALAN",
                                    "Value": "CHAK KALAN"
                                },
                                {
                                    "Text": "CHAK PAKHI",
                                    "Value": "CHAK PAKHI"
                                },
                                {
                                    "Text": "CHAKARBHATHA",
                                    "Value": "CHAKARBHATHA"
                                },
                                {
                                    "Text": "CHAKDANA",
                                    "Value": "CHAKDANA"
                                },
                                {
                                    "Text": "CHAKRADHARPUR",
                                    "Value": "CHAKRADHARPUR"
                                },
                                {
                                    "Text": "CHALISGAON",
                                    "Value": "CHALISGAON"
                                },
                                {
                                    "Text": "CHALLAKERE",
                                    "Value": "CHALLAKERE"
                                },
                                {
                                    "Text": "CHALAKUDY",
                                    "Value": "CHALAKUDY"
                                },
                                {
                                    "Text": "CHALIKKAVATTOM",
                                    "Value": "CHALIKKAVATTOM"
                                },
                                {
                                    "Text": "CHALLAVARIGUDEM ",
                                    "Value": "CHALLAVARIGUDEM "
                                },
                                {
                                    "Text": "CHALHERI ",
                                    "Value": "CHALHERI "
                                },
                                {
                                    "Text": "CHAMPA",
                                    "Value": "CHAMPA"
                                },
                                {
                                    "Text": "CHAMOLI",
                                    "Value": "CHAMOLI"
                                },
                                {
                                    "Text": "CHAMPAWAT",
                                    "Value": "CHAMPAWAT"
                                },
                                {
                                    "Text": "CHAMRAJNAGAR",
                                    "Value": "CHAMRAJNAGAR"
                                },
                                {
                                    "Text": "CHAMPHAI",
                                    "Value": "CHAMPHAI"
                                },
                                {
                                    "Text": "CHAMPADANGA",
                                    "Value": "CHAMPADANGA"
                                },
                                {
                                    "Text": "CHAMBA",
                                    "Value": "CHAMBA"
                                },
                                {
                                    "Text": "CHAMARU ",
                                    "Value": "CHAMARU "
                                },
                                {
                                    "Text": "CHAMARAJANAGAR",
                                    "Value": "CHAMARAJANAGAR"
                                },
                                {
                                    "Text": "CHAMKAUR SAHIB",
                                    "Value": "CHAMKAUR SAHIB"
                                },
                                {
                                    "Text": "CHAMPRAJPUR",
                                    "Value": "CHAMPRAJPUR"
                                },
                                {
                                    "Text": "CHAMYARI",
                                    "Value": "CHAMYARI"
                                },
                                {
                                    "Text": "CHANGANACHERRY",
                                    "Value": "CHANGANACHERRY"
                                },
                                {
                                    "Text": "CHANDAULI",
                                    "Value": "CHANDAULI"
                                },
                                {
                                    "Text": "CHANDEL",
                                    "Value": "CHANDEL"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANDRAPUR",
                                    "Value": "CHANDRAPUR"
                                },
                                {
                                    "Text": "CHANGLANG",
                                    "Value": "CHANGLANG"
                                },
                                {
                                    "Text": "CHANDRAPUR",
                                    "Value": "CHANDRAPUR"
                                },
                                {
                                    "Text": "CHANDAUSI",
                                    "Value": "CHANDAUSI"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHANNAGIRI",
                                    "Value": "CHANNAGIRI"
                                },
                                {
                                    "Text": "CHANDANGAON ",
                                    "Value": "CHANDANGAON "
                                },
                                {
                                    "Text": "CHANDAI ECO ",
                                    "Value": "CHANDAI ECO "
                                },
                                {
                                    "Text": "CHAND NAU ",
                                    "Value": "CHAND NAU "
                                },
                                {
                                    "Text": "CHANDBAJA ",
                                    "Value": "CHANDBAJA "
                                },
                                {
                                    "Text": "CHANDAN CHAUKI ",
                                    "Value": "CHANDAN CHAUKI "
                                },
                                {
                                    "Text": "CHANDANAGAR",
                                    "Value": "CHANDANAGAR"
                                },
                                {
                                    "Text": "CHANDANNAGAR",
                                    "Value": "CHANDANNAGAR"
                                },
                                {
                                    "Text": "CHANGODAR",
                                    "Value": "CHANGODAR"
                                },
                                {
                                    "Text": "CHANDER NAGAR",
                                    "Value": "CHANDER NAGAR"
                                },
                                {
                                    "Text": "CHANDGAD",
                                    "Value": "CHANDGAD"
                                },
                                {
                                    "Text": "CHANDIKHOL",
                                    "Value": "CHANDIKHOL"
                                },
                                {
                                    "Text": "CHANDIMANDIR",
                                    "Value": "CHANDIMANDIR"
                                },
                                {
                                    "Text": "CHANDOR",
                                    "Value": "CHANDOR"
                                },
                                {
                                    "Text": "CHANDPUR",
                                    "Value": "CHANDPUR"
                                },
                                {
                                    "Text": "CHANDRANAGAR",
                                    "Value": "CHANDRANAGAR"
                                },
                                {
                                    "Text": "CHANDVAD",
                                    "Value": "CHANDVAD"
                                },
                                {
                                    "Text": "CHAPRA",
                                    "Value": "CHAPRA"
                                },
                                {
                                    "Text": "CHAPAD",
                                    "Value": "CHAPAD"
                                },
                                {
                                    "Text": "CHARKHI DADRI",
                                    "Value": "CHARKHI DADRI"
                                },
                                {
                                    "Text": "CHARKHI DADRI",
                                    "Value": "CHARKHI DADRI"
                                },
                                {
                                    "Text": "CHARNA ",
                                    "Value": "CHARNA "
                                },
                                {
                                    "Text": "CHARIK ",
                                    "Value": "CHARIK "
                                },
                                {
                                    "Text": "CHATRA",
                                    "Value": "CHATRA"
                                },
                                {
                                    "Text": "CHATARSAL",
                                    "Value": "CHATARSAL"
                                },
                                {
                                    "Text": "CHATTARPUR",
                                    "Value": "CHATTARPUR"
                                },
                                {
                                    "Text": "CHAUPAL",
                                    "Value": "CHAUPAL"
                                },
                                {
                                    "Text": "CHAVAKKAD",
                                    "Value": "CHAVAKKAD"
                                },
                                {
                                    "Text": "CHAWINDA DEVI",
                                    "Value": "CHAWINDA DEVI"
                                },
                                {
                                    "Text": "CHANDRASEKHARPUR",
                                    "Value": "CHANDRASEKHARPUR"
                                },
                                {
                                    "Text": "CHEEDIGUMMALA ",
                                    "Value": "CHEEDIGUMMALA "
                                },
                                {
                                    "Text": "CHEEMALAVALASA ",
                                    "Value": "CHEEMALAVALASA "
                                },
                                {
                                    "Text": "CHEEKA",
                                    "Value": "CHEEKA"
                                },
                                {
                                    "Text": "CHEEMA",
                                    "Value": "CHEEMA"
                                },
                                {
                                    "Text": "CHEMMAD",
                                    "Value": "CHEMMAD"
                                },
                                {
                                    "Text": "CHENNAI",
                                    "Value": "CHENNAI"
                                },
                                {
                                    "Text": "CHENGANNUR",
                                    "Value": "CHENGANNUR"
                                },
                                {
                                    "Text": "CHENGALPATTU",
                                    "Value": "CHENGALPATTU"
                                },
                                {
                                    "Text": "CHENGAM",
                                    "Value": "CHENGAM"
                                },
                                {
                                    "Text": "CHENNAIPALEM ",
                                    "Value": "CHENNAIPALEM "
                                },
                                {
                                    "Text": "CHENDRAPPINNI",
                                    "Value": "CHENDRAPPINNI"
                                },
                                {
                                    "Text": "CHEPUR ",
                                    "Value": "CHEPUR "
                                },
                                {
                                    "Text": "CHEPPAD",
                                    "Value": "CHEPPAD"
                                },
                                {
                                    "Text": "CHERAI",
                                    "Value": "CHERAI"
                                },
                                {
                                    "Text": "CHERPALACHERY",
                                    "Value": "CHERPALACHERY"
                                },
                                {
                                    "Text": "CHERTHALA",
                                    "Value": "CHERTHALA"
                                },
                                {
                                    "Text": "CHERUKUNNU",
                                    "Value": "CHERUKUNNU"
                                },
                                {
                                    "Text": "CHETTUPALLE ",
                                    "Value": "CHETTUPALLE "
                                },
                                {
                                    "Text": "CHETTIKULANGARA",
                                    "Value": "CHETTIKULANGARA"
                                },
                                {
                                    "Text": "CHHATARPUR",
                                    "Value": "CHHATARPUR"
                                },
                                {
                                    "Text": "CHHANI",
                                    "Value": "CHHANI"
                                },
                                {
                                    "Text": "CHHABRA",
                                    "Value": "CHHABRA"
                                },
                                {
                                    "Text": "CHHACHHARAULI",
                                    "Value": "CHHACHHARAULI"
                                },
                                {
                                    "Text": "CHHAT",
                                    "Value": "CHHAT"
                                },
                                {
                                    "Text": "CHHATRAL",
                                    "Value": "CHHATRAL"
                                },
                                {
                                    "Text": "CHHATRAPUR",
                                    "Value": "CHHATRAPUR"
                                },
                                {
                                    "Text": "CHHEDIA PASHCHIM ",
                                    "Value": "CHHEDIA PASHCHIM "
                                },
                                {
                                    "Text": "CHHEHERTA",
                                    "Value": "CHHEHERTA"
                                },
                                {
                                    "Text": "CHHENDIPADA",
                                    "Value": "CHHENDIPADA"
                                },
                                {
                                    "Text": "CHHIBRAMAU",
                                    "Value": "CHHIBRAMAU"
                                },
                                {
                                    "Text": "CHHINDWARA",
                                    "Value": "CHHINDWARA"
                                },
                                {
                                    "Text": "CHHIBRAMAU",
                                    "Value": "CHHIBRAMAU"
                                },
                                {
                                    "Text": "CHHOTA UDAIPUR",
                                    "Value": "CHHOTA UDAIPUR"
                                },
                                {
                                    "Text": "CHHOTA BANGURDA ",
                                    "Value": "CHHOTA BANGURDA "
                                },
                                {
                                    "Text": "CHHOTA UDAIPUR",
                                    "Value": "CHHOTA UDAIPUR"
                                },
                                {
                                    "Text": "CHHUTMALPUR",
                                    "Value": "CHHUTMALPUR"
                                },
                                {
                                    "Text": "CHHAWLA",
                                    "Value": "CHHAWLA"
                                },
                                {
                                    "Text": "CHICKMAGALUR",
                                    "Value": "CHICKMAGALUR"
                                },
                                {
                                    "Text": "CHIDAMBARAM",
                                    "Value": "CHIDAMBARAM"
                                },
                                {
                                    "Text": "CHIKALIM",
                                    "Value": "CHIKALIM"
                                },
                                {
                                    "Text": "CHIKHLI",
                                    "Value": "CHIKHLI"
                                },
                                {
                                    "Text": "CHIKODI",
                                    "Value": "CHIKODI"
                                },
                                {
                                    "Text": "CHIKKABALLAPUR",
                                    "Value": "CHIKKABALLAPUR"
                                },
                                {
                                    "Text": "CHIKHLI",
                                    "Value": "CHIKHLI"
                                },
                                {
                                    "Text": "CHIKATIMAMIDI ",
                                    "Value": "CHIKATIMAMIDI "
                                },
                                {
                                    "Text": "CHIKHALI ",
                                    "Value": "CHIKHALI "
                                },
                                {
                                    "Text": "CHIKBALLAPURA",
                                    "Value": "CHIKBALLAPURA"
                                },
                                {
                                    "Text": "CHIKMAGALUR",
                                    "Value": "CHIKMAGALUR"
                                },
                                {
                                    "Text": "CHIKHIL",
                                    "Value": "CHIKHIL"
                                },
                                {
                                    "Text": "CHIKHIL",
                                    "Value": "CHIKHIL"
                                },
                                {
                                    "Text": "CHILAKALURIPET",
                                    "Value": "CHILAKALURIPET"
                                },
                                {
                                    "Text": "CHIMRAJPALLE",
                                    "Value": "CHIMRAJPALLE"
                                },
                                {
                                    "Text": "CHINSURAH R S",
                                    "Value": "CHINSURAH R S"
                                },
                                {
                                    "Text": "CHINTAMANI",
                                    "Value": "CHINTAMANI"
                                },
                                {
                                    "Text": "CHINNARANGAPURAM ",
                                    "Value": "CHINNARANGAPURAM "
                                },
                                {
                                    "Text": "CHINTALAJUTUR ",
                                    "Value": "CHINTALAJUTUR "
                                },
                                {
                                    "Text": "CHINNAVARIGUDEM ",
                                    "Value": "CHINNAVARIGUDEM "
                                },
                                {
                                    "Text": "CHINTADA ",
                                    "Value": "CHINTADA "
                                },
                                {
                                    "Text": "CHINCHAVALI",
                                    "Value": "CHINCHAVALI"
                                },
                                {
                                    "Text": "CHINCHINIM",
                                    "Value": "CHINCHINIM"
                                },
                                {
                                    "Text": "CHINNAMIRAM",
                                    "Value": "CHINNAMIRAM"
                                },
                                {
                                    "Text": "CHIPLUN",
                                    "Value": "CHIPLUN"
                                },
                                {
                                    "Text": "CHIPARI",
                                    "Value": "CHIPARI"
                                },
                                {
                                    "Text": "CHIRALA",
                                    "Value": "CHIRALA"
                                },
                                {
                                    "Text": "CHIRAWA",
                                    "Value": "CHIRAWA"
                                },
                                {
                                    "Text": "CHIRGAON",
                                    "Value": "CHIRGAON"
                                },
                                {
                                    "Text": "CHITHARA",
                                    "Value": "CHITHARA"
                                },
                                {
                                    "Text": "CHITRADURGA",
                                    "Value": "CHITRADURGA"
                                },
                                {
                                    "Text": "CHITRAKOOT",
                                    "Value": "CHITRAKOOT"
                                },
                                {
                                    "Text": "CHITTOOR",
                                    "Value": "CHITTOOR"
                                },
                                {
                                    "Text": "CHITTORGARH",
                                    "Value": "CHITTORGARH"
                                },
                                {
                                    "Text": "CHITAKODUR ",
                                    "Value": "CHITAKODUR "
                                },
                                {
                                    "Text": "CHITTIVALASA ",
                                    "Value": "CHITTIVALASA "
                                },
                                {
                                    "Text": "CHITILI PUTLI ",
                                    "Value": "CHITILI PUTLI "
                                },
                                {
                                    "Text": "CHITHARA -SHIV NADAR UNIVERSITY",
                                    "Value": "CHITHARA -SHIV NADAR UNIVERSITY"
                                },
                                {
                                    "Text": "CHIRANG",
                                    "Value": "CHIRANG"
                                },
                                {
                                    "Text": "CHEMBUR",
                                    "Value": "CHEMBUR"
                                },
                                {
                                    "Text": "CHENGAM",
                                    "Value": "CHENGAM"
                                },
                                {
                                    "Text": "CHANNAGIRI",
                                    "Value": "CHANNAGIRI"
                                },
                                {
                                    "Text": "CHOCHRA",
                                    "Value": "CHOCHRA"
                                },
                                {
                                    "Text": "CHODAVARAM ",
                                    "Value": "CHODAVARAM "
                                },
                                {
                                    "Text": "CHOGAWAN",
                                    "Value": "CHOGAWAN"
                                },
                                {
                                    "Text": "CHOLA SAHIB",
                                    "Value": "CHOLA SAHIB"
                                },
                                {
                                    "Text": "CHOMU",
                                    "Value": "CHOMU"
                                },
                                {
                                    "Text": "CHOPDA",
                                    "Value": "CHOPDA"
                                },
                                {
                                    "Text": "CHOUTUPPAL",
                                    "Value": "CHOUTUPPAL"
                                },
                                {
                                    "Text": "CHRARI SHARIEF",
                                    "Value": "CHRARI SHARIEF"
                                },
                                {
                                    "Text": "CHITTARANJON",
                                    "Value": "CHITTARANJON"
                                },
                                {
                                    "Text": "CHILLA SARODA BANGAR",
                                    "Value": "CHILLA SARODA BANGAR"
                                },
                                {
                                    "Text": "CHUKKAPUR ",
                                    "Value": "CHUKKAPUR "
                                },
                                {
                                    "Text": "CHUNAR",
                                    "Value": "CHUNAR"
                                },
                                {
                                    "Text": "CHUNATI GADA",
                                    "Value": "CHUNATI GADA"
                                },
                                {
                                    "Text": "CHUNNI KALAN",
                                    "Value": "CHUNNI KALAN"
                                },
                                {
                                    "Text": "CHURACHANDPUR",
                                    "Value": "CHURACHANDPUR"
                                },
                                {
                                    "Text": "CHURU",
                                    "Value": "CHURU"
                                },
                                {
                                    "Text": "CHUREB",
                                    "Value": "CHUREB"
                                },
                                {
                                    "Text": "CHWADI",
                                    "Value": "CHWADI"
                                },
                                {
                                    "Text": "CHINCHWAD",
                                    "Value": "CHINCHWAD"
                                },
                                {
                                    "Text": "COLABA",
                                    "Value": "COLABA"
                                },
                                {
                                    "Text": "COLACHEL",
                                    "Value": "COLACHEL"
                                },
                                {
                                    "Text": "CUMBUM",
                                    "Value": "CUMBUM"
                                },
                                {
                                    "Text": "CANDOLIM",
                                    "Value": "CANDOLIM"
                                },
                                {
                                    "Text": "CHANNAPATNA",
                                    "Value": "CHANNAPATNA"
                                },
                                {
                                    "Text": "COCHIN",
                                    "Value": "COCHIN"
                                },
                                {
                                    "Text": "COIMBATORE",
                                    "Value": "COIMBATORE"
                                },
                                {
                                    "Text": "COLONELGANJ",
                                    "Value": "COLONELGANJ"
                                },
                                {
                                    "Text": "COLVA",
                                    "Value": "COLVA"
                                },
                                {
                                    "Text": "COLVALE",
                                    "Value": "COLVALE"
                                },
                                {
                                    "Text": "CONTAI",
                                    "Value": "CONTAI"
                                },
                                {
                                    "Text": "COOCH BEHAR",
                                    "Value": "COOCH BEHAR"
                                },
                                {
                                    "Text": "COONOOR",
                                    "Value": "COONOOR"
                                },
                                {
                                    "Text": "CARTERPURI",
                                    "Value": "CARTERPURI"
                                },
                                {
                                    "Text": "CUDDALORE",
                                    "Value": "CUDDALORE"
                                },
                                {
                                    "Text": "CUDDAPAH",
                                    "Value": "CUDDAPAH"
                                },
                                {
                                    "Text": "CUNCOLIM",
                                    "Value": "CUNCOLIM"
                                },
                                {
                                    "Text": "CURCHOREM",
                                    "Value": "CURCHOREM"
                                },
                                {
                                    "Text": "CURTORIM",
                                    "Value": "CURTORIM"
                                },
                                {
                                    "Text": "CUTTACK",
                                    "Value": "CUTTACK"
                                },
                                {
                                    "Text": "DABBASPET",
                                    "Value": "DABBASPET"
                                },
                                {
                                    "Text": "DABGAON MAKTHA ",
                                    "Value": "DABGAON MAKTHA "
                                },
                                {
                                    "Text": "DABHOI",
                                    "Value": "DABHOI"
                                },
                                {
                                    "Text": "DABHADI ",
                                    "Value": "DABHADI "
                                },
                                {
                                    "Text": "DABHEL",
                                    "Value": "DABHEL"
                                },
                                {
                                    "Text": "DABRA",
                                    "Value": "DABRA"
                                },
                                {
                                    "Text": "DABWALI",
                                    "Value": "DABWALI"
                                },
                                {
                                    "Text": "DADAHUR",
                                    "Value": "DADAHUR"
                                },
                                {
                                    "Text": "DADRA & NAGAR HAVELI",
                                    "Value": "DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "DADRI",
                                    "Value": "DADRI"
                                },
                                {
                                    "Text": "DAGAVADIYA",
                                    "Value": "DAGAVADIYA"
                                },
                                {
                                    "Text": "DAHANU ROAD",
                                    "Value": "DAHANU ROAD"
                                },
                                {
                                    "Text": "DAHANU",
                                    "Value": "DAHANU"
                                },
                                {
                                    "Text": "DAHEJ",
                                    "Value": "DAHEJ"
                                },
                                {
                                    "Text": "DAHIVALI",
                                    "Value": "DAHIVALI"
                                },
                                {
                                    "Text": "DAHOD",
                                    "Value": "DAHOD"
                                },
                                {
                                    "Text": "DAKOR",
                                    "Value": "DAKOR"
                                },
                                {
                                    "Text": "DAKSHINA KANNADA",
                                    "Value": "DAKSHINA KANNADA"
                                },
                                {
                                    "Text": "DALAM",
                                    "Value": "DALAM"
                                },
                                {
                                    "Text": "DALEKE ",
                                    "Value": "DALEKE "
                                },
                                {
                                    "Text": "DALHOUSIE",
                                    "Value": "DALHOUSIE"
                                },
                                {
                                    "Text": "DALLI RAJHARA",
                                    "Value": "DALLI RAJHARA"
                                },
                                {
                                    "Text": "DALSINGHSARAI",
                                    "Value": "DALSINGHSARAI"
                                },
                                {
                                    "Text": "DALTONGANJ",
                                    "Value": "DALTONGANJ"
                                },
                                {
                                    "Text": "DALTONGUNJ",
                                    "Value": "DALTONGUNJ"
                                },
                                {
                                    "Text": "DAMAN",
                                    "Value": "DAMAN"
                                },
                                {
                                    "Text": "DAMAN",
                                    "Value": "DAMAN"
                                },
                                {
                                    "Text": "DAMOH",
                                    "Value": "DAMOH"
                                },
                                {
                                    "Text": "DANDGAON ",
                                    "Value": "DANDGAON "
                                },
                                {
                                    "Text": "DANKUNI",
                                    "Value": "DANKUNI"
                                },
                                {
                                    "Text": "DANTEWADA",
                                    "Value": "DANTEWADA"
                                },
                                {
                                    "Text": "DAPORIJO",
                                    "Value": "DAPORIJO"
                                },
                                {
                                    "Text": "DAPOLI",
                                    "Value": "DAPOLI"
                                },
                                {
                                    "Text": "DARA",
                                    "Value": "DARA"
                                },
                                {
                                    "Text": "DARBHANGA",
                                    "Value": "DARBHANGA"
                                },
                                {
                                    "Text": "DARBARIBUR",
                                    "Value": "DARBARIBUR"
                                },
                                {
                                    "Text": "DARED",
                                    "Value": "DARED"
                                },
                                {
                                    "Text": "DARJEELING",
                                    "Value": "DARJEELING"
                                },
                                {
                                    "Text": "DARJILING",
                                    "Value": "DARJILING"
                                },
                                {
                                    "Text": "DARLA",
                                    "Value": "DARLA"
                                },
                                {
                                    "Text": "DARRANG",
                                    "Value": "DARRANG"
                                },
                                {
                                    "Text": "DARYAPUR",
                                    "Value": "DARYAPUR"
                                },
                                {
                                    "Text": "DASCROI",
                                    "Value": "DASCROI"
                                },
                                {
                                    "Text": "DASNA",
                                    "Value": "DASNA"
                                },
                                {
                                    "Text": "DASHRATH PURI",
                                    "Value": "DASHRATH PURI"
                                },
                                {
                                    "Text": "DASUYA",
                                    "Value": "DASUYA"
                                },
                                {
                                    "Text": "DATARPUR",
                                    "Value": "DATARPUR"
                                },
                                {
                                    "Text": "DATIA",
                                    "Value": "DATIA"
                                },
                                {
                                    "Text": "DATTAWADI",
                                    "Value": "DATTAWADI"
                                },
                                {
                                    "Text": "DAUND",
                                    "Value": "DAUND"
                                },
                                {
                                    "Text": "DAUSA",
                                    "Value": "DAUSA"
                                },
                                {
                                    "Text": "DAVANGERE",
                                    "Value": "DAVANGERE"
                                },
                                {
                                    "Text": "DAVANGARE",
                                    "Value": "DAVANGARE"
                                },
                                {
                                    "Text": "DAVORLIM",
                                    "Value": "DAVORLIM"
                                },
                                {
                                    "Text": "DAYALPURA MIRZA",
                                    "Value": "DAYALPURA MIRZA"
                                },
                                {
                                    "Text": "DELHI CANTONMENT",
                                    "Value": "DELHI CANTONMENT"
                                },
                                {
                                    "Text": "DEBAGARH",
                                    "Value": "DEBAGARH"
                                },
                                {
                                    "Text": "DEESA",
                                    "Value": "DEESA"
                                },
                                {
                                    "Text": "DEGLOOR",
                                    "Value": "DEGLOOR"
                                },
                                {
                                    "Text": "DEGAON ",
                                    "Value": "DEGAON "
                                },
                                {
                                    "Text": "DEHGAM",
                                    "Value": "DEHGAM"
                                },
                                {
                                    "Text": "DEHLON",
                                    "Value": "DEHLON"
                                },
                                {
                                    "Text": "DEHRADUN",
                                    "Value": "DEHRADUN"
                                },
                                {
                                    "Text": "DEHRA",
                                    "Value": "DEHRA"
                                },
                                {
                                    "Text": "DEHRI",
                                    "Value": "DEHRI"
                                },
                                {
                                    "Text": "DELA",
                                    "Value": "DELA"
                                },
                                {
                                    "Text": "DELAD",
                                    "Value": "DELAD"
                                },
                                {
                                    "Text": "DELEGAVAN ",
                                    "Value": "DELEGAVAN "
                                },
                                {
                                    "Text": "DELHI",
                                    "Value": "DELHI"
                                },
                                {
                                    "Text": "DEOLI",
                                    "Value": "DEOLI"
                                },
                                {
                                    "Text": "DEOBAND",
                                    "Value": "DEOBAND"
                                },
                                {
                                    "Text": "DEOGHAR",
                                    "Value": "DEOGHAR"
                                },
                                {
                                    "Text": "DEOGARH",
                                    "Value": "DEOGARH"
                                },
                                {
                                    "Text": "DEOGAR",
                                    "Value": "DEOGAR"
                                },
                                {
                                    "Text": "DEOLI",
                                    "Value": "DEOLI"
                                },
                                {
                                    "Text": "DEOLA",
                                    "Value": "DEOLA"
                                },
                                {
                                    "Text": "DEOLALI",
                                    "Value": "DEOLALI"
                                },
                                {
                                    "Text": "DEORIA",
                                    "Value": "DEORIA"
                                },
                                {
                                    "Text": "DERA BASSI",
                                    "Value": "DERA BASSI"
                                },
                                {
                                    "Text": "DERABASSI",
                                    "Value": "DERABASSI"
                                },
                                {
                                    "Text": "DERA BABA NANAK",
                                    "Value": "DERA BABA NANAK"
                                },
                                {
                                    "Text": "DEROL",
                                    "Value": "DEROL"
                                },
                                {
                                    "Text": "DEULGAON RAJA",
                                    "Value": "DEULGAON RAJA"
                                },
                                {
                                    "Text": "DEULGAON RAJA",
                                    "Value": "DEULGAON RAJA"
                                },
                                {
                                    "Text": "DEWAS",
                                    "Value": "DEWAS"
                                },
                                {
                                    "Text": "DEVANAPPLI ",
                                    "Value": "DEVANAPPLI "
                                },
                                {
                                    "Text": "DEVAKOTTAI",
                                    "Value": "DEVAKOTTAI"
                                },
                                {
                                    "Text": "DEVANAHALLI",
                                    "Value": "DEVANAHALLI"
                                },
                                {
                                    "Text": "DEVIGARH",
                                    "Value": "DEVIGARH"
                                },
                                {
                                    "Text": "DEVULAPALLY CALAN ",
                                    "Value": "DEVULAPALLY CALAN "
                                },
                                {
                                    "Text": "DEWAS",
                                    "Value": "DEWAS"
                                },
                                {
                                    "Text": "DEWADA KHURD ",
                                    "Value": "DEWADA KHURD "
                                },
                                {
                                    "Text": "DHAD",
                                    "Value": "DHAD"
                                },
                                {
                                    "Text": "DHAKIA ",
                                    "Value": "DHAKIA "
                                },
                                {
                                    "Text": "DHALAI",
                                    "Value": "DHALAI"
                                },
                                {
                                    "Text": "DHALLE KE ",
                                    "Value": "DHALLE KE "
                                },
                                {
                                    "Text": "DHAMPUR",
                                    "Value": "DHAMPUR"
                                },
                                {
                                    "Text": "DHAMOND",
                                    "Value": "DHAMOND"
                                },
                                {
                                    "Text": "DHAMTARI",
                                    "Value": "DHAMTARI"
                                },
                                {
                                    "Text": "DHAMORAH ",
                                    "Value": "DHAMORAH "
                                },
                                {
                                    "Text": "DHAMANGAON RAILWAY",
                                    "Value": "DHAMANGAON RAILWAY"
                                },
                                {
                                    "Text": "DHAMNOD",
                                    "Value": "DHAMNOD"
                                },
                                {
                                    "Text": "DHANERA",
                                    "Value": "DHANERA"
                                },
                                {
                                    "Text": "DHANBAD",
                                    "Value": "DHANBAD"
                                },
                                {
                                    "Text": "DHANAURI",
                                    "Value": "DHANAURI"
                                },
                                {
                                    "Text": "DHANNARAM ",
                                    "Value": "DHANNARAM "
                                },
                                {
                                    "Text": "DHANKANSU KALAN ",
                                    "Value": "DHANKANSU KALAN "
                                },
                                {
                                    "Text": "DHANELI UTTARI ",
                                    "Value": "DHANELI UTTARI "
                                },
                                {
                                    "Text": "DHANAULA",
                                    "Value": "DHANAULA"
                                },
                                {
                                    "Text": "DHAND",
                                    "Value": "DHAND"
                                },
                                {
                                    "Text": "DHANKOT",
                                    "Value": "DHANKOT"
                                },
                                {
                                    "Text": "DHANYAVI",
                                    "Value": "DHANYAVI"
                                },
                                {
                                    "Text": "DHAPAI ",
                                    "Value": "DHAPAI "
                                },
                                {
                                    "Text": "DHARMAPURI",
                                    "Value": "DHARMAPURI"
                                },
                                {
                                    "Text": "DHARI",
                                    "Value": "DHARI"
                                },
                                {
                                    "Text": "DHARAMSHALA",
                                    "Value": "DHARAMSHALA"
                                },
                                {
                                    "Text": "DHARWAD",
                                    "Value": "DHARWAD"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHARAMKOT",
                                    "Value": "DHARAMKOT"
                                },
                                {
                                    "Text": "DHARAPURAM",
                                    "Value": "DHARAPURAM"
                                },
                                {
                                    "Text": "DHARIWAL",
                                    "Value": "DHARIWAL"
                                },
                                {
                                    "Text": "DHAR",
                                    "Value": "DHAR"
                                },
                                {
                                    "Text": "DHARMAPURI",
                                    "Value": "DHARMAPURI"
                                },
                                {
                                    "Text": "DHARUHERA",
                                    "Value": "DHARUHERA"
                                },
                                {
                                    "Text": "DHARWARD",
                                    "Value": "DHARWARD"
                                },
                                {
                                    "Text": "DHARNASAGARAM ",
                                    "Value": "DHARNASAGARAM "
                                },
                                {
                                    "Text": "DHARIAWAD",
                                    "Value": "DHARIAWAD"
                                },
                                {
                                    "Text": "DHARMAJ",
                                    "Value": "DHARMAJ"
                                },
                                {
                                    "Text": "DHARMANAGAR",
                                    "Value": "DHARMANAGAR"
                                },
                                {
                                    "Text": "DHARPUR",
                                    "Value": "DHARPUR"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHARAMPUR",
                                    "Value": "DHARAMPUR"
                                },
                                {
                                    "Text": "DHAURA ",
                                    "Value": "DHAURA "
                                },
                                {
                                    "Text": "DHAULIMUNHA",
                                    "Value": "DHAULIMUNHA"
                                },
                                {
                                    "Text": "DHAURRA MAFI",
                                    "Value": "DHAURRA MAFI"
                                },
                                {
                                    "Text": "DHEMAJI",
                                    "Value": "DHEMAJI"
                                },
                                {
                                    "Text": "DHENKANAL",
                                    "Value": "DHENKANAL"
                                },
                                {
                                    "Text": "DHIANPUR",
                                    "Value": "DHIANPUR"
                                },
                                {
                                    "Text": "DHILWAN",
                                    "Value": "DHILWAN"
                                },
                                {
                                    "Text": "DHANDHUKA",
                                    "Value": "DHANDHUKA"
                                },
                                {
                                    "Text": "DHOKATA",
                                    "Value": "DHOKATA"
                                },
                                {
                                    "Text": "DHOLPUR",
                                    "Value": "DHOLPUR"
                                },
                                {
                                    "Text": "DHOLASAN",
                                    "Value": "DHOLASAN"
                                },
                                {
                                    "Text": "DHOLKA",
                                    "Value": "DHOLKA"
                                },
                                {
                                    "Text": "DHONE",
                                    "Value": "DHONE"
                                },
                                {
                                    "Text": "DHORAJI",
                                    "Value": "DHORAJI"
                                },
                                {
                                    "Text": "DHOTIAN",
                                    "Value": "DHOTIAN"
                                },
                                {
                                    "Text": "DHOYANPUR ",
                                    "Value": "DHOYANPUR "
                                },
                                {
                                    "Text": "DHRANGADHRA",
                                    "Value": "DHRANGADHRA"
                                },
                                {
                                    "Text": "DHROL",
                                    "Value": "DHROL"
                                },
                                {
                                    "Text": "DHAROTI KHURD",
                                    "Value": "DHAROTI KHURD"
                                },
                                {
                                    "Text": "DAHISAR(W)",
                                    "Value": "DAHISAR(W)"
                                },
                                {
                                    "Text": "DHUBRI",
                                    "Value": "DHUBRI"
                                },
                                {
                                    "Text": "DHUDHI ",
                                    "Value": "DHUDHI "
                                },
                                {
                                    "Text": "DHULE",
                                    "Value": "DHULE"
                                },
                                {
                                    "Text": "DHUNELA",
                                    "Value": "DHUNELA"
                                },
                                {
                                    "Text": "DHUPGURI",
                                    "Value": "DHUPGURI"
                                },
                                {
                                    "Text": "DHURI",
                                    "Value": "DHURI"
                                },
                                {
                                    "Text": "DHURKOT ",
                                    "Value": "DHURKOT "
                                },
                                {
                                    "Text": "DHUSKIYA ",
                                    "Value": "DHUSKIYA "
                                },
                                {
                                    "Text": "DIAMOND HARBOUR",
                                    "Value": "DIAMOND HARBOUR"
                                },
                                {
                                    "Text": "DIBANG VALLEY",
                                    "Value": "DIBANG VALLEY"
                                },
                                {
                                    "Text": "DIBIYAPUR",
                                    "Value": "DIBIYAPUR"
                                },
                                {
                                    "Text": "DIBRUGARH",
                                    "Value": "DIBRUGARH"
                                },
                                {
                                    "Text": "DIGBOI",
                                    "Value": "DIGBOI"
                                },
                                {
                                    "Text": "DIGHI ",
                                    "Value": "DIGHI "
                                },
                                {
                                    "Text": "DIGHORI ",
                                    "Value": "DIGHORI "
                                },
                                {
                                    "Text": "DIHIBATPUR PANCHANANTALA",
                                    "Value": "DIHIBATPUR PANCHANANTALA"
                                },
                                {
                                    "Text": "DILDAR NAGAR",
                                    "Value": "DILDAR NAGAR"
                                },
                                {
                                    "Text": "DILSHAD GARDEN",
                                    "Value": "DILSHAD GARDEN"
                                },
                                {
                                    "Text": "DIMAPUR",
                                    "Value": "DIMAPUR"
                                },
                                {
                                    "Text": "DINANAGAR",
                                    "Value": "DINANAGAR"
                                },
                                {
                                    "Text": "DANAPUR",
                                    "Value": "DANAPUR"
                                },
                                {
                                    "Text": "DINDORI",
                                    "Value": "DINDORI"
                                },
                                {
                                    "Text": "DINDIGUL",
                                    "Value": "DINDIGUL"
                                },
                                {
                                    "Text": "DINDORI",
                                    "Value": "DINDORI"
                                },
                                {
                                    "Text": "DING",
                                    "Value": "DING"
                                },
                                {
                                    "Text": "DINGRIAN",
                                    "Value": "DINGRIAN"
                                },
                                {
                                    "Text": "DINGUCHA",
                                    "Value": "DINGUCHA"
                                },
                                {
                                    "Text": "DINHATA",
                                    "Value": "DINHATA"
                                },
                                {
                                    "Text": "DIPHU",
                                    "Value": "DIPHU"
                                },
                                {
                                    "Text": "DIRBA",
                                    "Value": "DIRBA"
                                },
                                {
                                    "Text": "DISPUR",
                                    "Value": "DISPUR"
                                },
                                {
                                    "Text": "DIST AHAMADNAGAR",
                                    "Value": "DIST AHAMADNAGAR"
                                },
                                {
                                    "Text": "DIU",
                                    "Value": "DIU"
                                },
                                {
                                    "Text": "DIU",
                                    "Value": "DIU"
                                },
                                {
                                    "Text": "DALLO PURA",
                                    "Value": "DALLO PURA"
                                },
                                {
                                    "Text": "DILSUKHNAGAR",
                                    "Value": "DILSUKHNAGAR"
                                },
                                {
                                    "Text": "DODA",
                                    "Value": "DODA"
                                },
                                {
                                    "Text": "DODDAHEJJUR ",
                                    "Value": "DODDAHEJJUR "
                                },
                                {
                                    "Text": "DODDABALLAPUR",
                                    "Value": "DODDABALLAPUR"
                                },
                                {
                                    "Text": "DOGACHIA",
                                    "Value": "DOGACHIA"
                                },
                                {
                                    "Text": "DOHA",
                                    "Value": "DOHA"
                                },
                                {
                                    "Text": "DOONI",
                                    "Value": "DOONI"
                                },
                                {
                                    "Text": "DOMARAIGANJ",
                                    "Value": "DOMARAIGANJ"
                                },
                                {
                                    "Text": "DOMBIVALI",
                                    "Value": "DOMBIVALI"
                                },
                                {
                                    "Text": "DOMBIVLI",
                                    "Value": "DOMBIVLI"
                                },
                                {
                                    "Text": "DOMJUR",
                                    "Value": "DOMJUR"
                                },
                                {
                                    "Text": "DONA PAULA",
                                    "Value": "DONA PAULA"
                                },
                                {
                                    "Text": "DONAR",
                                    "Value": "DONAR"
                                },
                                {
                                    "Text": "DONGAON ",
                                    "Value": "DONGAON "
                                },
                                {
                                    "Text": "DOOMDOOMA",
                                    "Value": "DOOMDOOMA"
                                },
                                {
                                    "Text": "DOOMDOOMA",
                                    "Value": "DOOMDOOMA"
                                },
                                {
                                    "Text": "DOORU SHAHBAD",
                                    "Value": "DOORU SHAHBAD"
                                },
                                {
                                    "Text": "DORAHA",
                                    "Value": "DORAHA"
                                },
                                {
                                    "Text": "DOSANJH ",
                                    "Value": "DOSANJH "
                                },
                                {
                                    "Text": "DOWNURU ",
                                    "Value": "DOWNURU "
                                },
                                {
                                    "Text": "DRAMMAN",
                                    "Value": "DRAMMAN"
                                },
                                {
                                    "Text": "DUBAI",
                                    "Value": "DUBAI"
                                },
                                {
                                    "Text": "DUBRAJPUR",
                                    "Value": "DUBRAJPUR"
                                },
                                {
                                    "Text": "DUBURI",
                                    "Value": "DUBURI"
                                },
                                {
                                    "Text": "DUDHAD ",
                                    "Value": "DUDHAD "
                                },
                                {
                                    "Text": "DULIAJAN",
                                    "Value": "DULIAJAN"
                                },
                                {
                                    "Text": "DUMARIA ",
                                    "Value": "DUMARIA "
                                },
                                {
                                    "Text": "DUMAD",
                                    "Value": "DUMAD"
                                },
                                {
                                    "Text": "DUM DUM",
                                    "Value": "DUM DUM"
                                },
                                {
                                    "Text": "DUMKA",
                                    "Value": "DUMKA"
                                },
                                {
                                    "Text": "DUNAVADA",
                                    "Value": "DUNAVADA"
                                },
                                {
                                    "Text": "DUNDAHERA",
                                    "Value": "DUNDAHERA"
                                },
                                {
                                    "Text": "DUNGARPUR",
                                    "Value": "DUNGARPUR"
                                },
                                {
                                    "Text": "DUNGURIPALI",
                                    "Value": "DUNGURIPALI"
                                },
                                {
                                    "Text": "DUNGARI",
                                    "Value": "DUNGARI"
                                },
                                {
                                    "Text": "DURGAPUR",
                                    "Value": "DURGAPUR"
                                },
                                {
                                    "Text": "DURG",
                                    "Value": "DURG"
                                },
                                {
                                    "Text": "DURUHERA",
                                    "Value": "DURUHERA"
                                },
                                {
                                    "Text": "DWARKA",
                                    "Value": "DWARKA"
                                },
                                {
                                    "Text": "DWARKA",
                                    "Value": "DWARKA"
                                },
                                {
                                    "Text": "DAYAL PUR",
                                    "Value": "DAYAL PUR"
                                },
                                {
                                    "Text": "EAST NIMAR",
                                    "Value": "EAST NIMAR"
                                },
                                {
                                    "Text": "EAST KHASIHILL",
                                    "Value": "EAST KHASIHILL"
                                },
                                {
                                    "Text": "EAST CHAMPARAN",
                                    "Value": "EAST CHAMPARAN"
                                },
                                {
                                    "Text": "EAST DELHI",
                                    "Value": "EAST DELHI"
                                },
                                {
                                    "Text": "EAST GARO HILLS",
                                    "Value": "EAST GARO HILLS"
                                },
                                {
                                    "Text": "EAST GODAVARI",
                                    "Value": "EAST GODAVARI"
                                },
                                {
                                    "Text": "EAST KAMENG",
                                    "Value": "EAST KAMENG"
                                },
                                {
                                    "Text": "EAST KHASI HILLS",
                                    "Value": "EAST KHASI HILLS"
                                },
                                {
                                    "Text": "EAST SIANG",
                                    "Value": "EAST SIANG"
                                },
                                {
                                    "Text": "EAST SIKKIM",
                                    "Value": "EAST SIKKIM"
                                },
                                {
                                    "Text": "EAST SINGHBHUM",
                                    "Value": "EAST SINGHBHUM"
                                },
                                {
                                    "Text": "EAST MIDNAPORE",
                                    "Value": "EAST MIDNAPORE"
                                },
                                {
                                    "Text": "EDAPPAL",
                                    "Value": "EDAPPAL"
                                },
                                {
                                    "Text": "EDULAPOOSALAPALLI ",
                                    "Value": "EDULAPOOSALAPALLI "
                                },
                                {
                                    "Text": "EGRA",
                                    "Value": "EGRA"
                                },
                                {
                                    "Text": "EKLINGPURA",
                                    "Value": "EKLINGPURA"
                                },
                                {
                                    "Text": "EKMAMIDI ",
                                    "Value": "EKMAMIDI "
                                },
                                {
                                    "Text": "ELLENABAD",
                                    "Value": "ELLENABAD"
                                },
                                {
                                    "Text": "ELURU",
                                    "Value": "ELURU"
                                },
                                {
                                    "Text": "ERAMALLOOR",
                                    "Value": "ERAMALLOOR"
                                },
                                {
                                    "Text": "ERNAKULAM",
                                    "Value": "ERNAKULAM"
                                },
                                {
                                    "Text": "ERODE",
                                    "Value": "ERODE"
                                },
                                {
                                    "Text": "ERRABALLE ",
                                    "Value": "ERRABALLE "
                                },
                                {
                                    "Text": "ERRIPALLE ",
                                    "Value": "ERRIPALLE "
                                },
                                {
                                    "Text": "ERU",
                                    "Value": "ERU"
                                },
                                {
                                    "Text": "ETAH",
                                    "Value": "ETAH"
                                },
                                {
                                    "Text": "ETAWAH",
                                    "Value": "ETAWAH"
                                },
                                {
                                    "Text": "ETMADPUR",
                                    "Value": "ETMADPUR"
                                },
                                {
                                    "Text": "ETTUMANOOR",
                                    "Value": "ETTUMANOOR"
                                },
                                {
                                    "Text": "FAIZABAD",
                                    "Value": "FAIZABAD"
                                },
                                {
                                    "Text": "FALNA",
                                    "Value": "FALNA"
                                },
                                {
                                    "Text": "FARIDABAD",
                                    "Value": "FARIDABAD"
                                },
                                {
                                    "Text": "FARIDKOT",
                                    "Value": "FARIDKOT"
                                },
                                {
                                    "Text": "FARIDPUR",
                                    "Value": "FARIDPUR"
                                },
                                {
                                    "Text": "FARRUKHABAD",
                                    "Value": "FARRUKHABAD"
                                },
                                {
                                    "Text": "FARRUKHNAGAR",
                                    "Value": "FARRUKHNAGAR"
                                },
                                {
                                    "Text": "FATEGHGARH CHURIAN",
                                    "Value": "FATEGHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHABAD",
                                    "Value": "FATEHABAD"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHGARH CHURIAN",
                                    "Value": "FATEHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHPUR SHEKHAWATI",
                                    "Value": "FATEHPUR SHEKHAWATI"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHABAD",
                                    "Value": "FATEHABAD"
                                },
                                {
                                    "Text": "FATEHGARH SAHIB",
                                    "Value": "FATEHGARH SAHIB"
                                },
                                {
                                    "Text": "FATEHGARH",
                                    "Value": "FATEHGARH"
                                },
                                {
                                    "Text": "FATEHGARH - UP",
                                    "Value": "FATEHGARH - UP"
                                },
                                {
                                    "Text": "FATEHGARH CHURIAN",
                                    "Value": "FATEHGARH CHURIAN"
                                },
                                {
                                    "Text": "FATEHGARH PUNJTUR",
                                    "Value": "FATEHGARH PUNJTUR"
                                },
                                {
                                    "Text": "FATEHGARH SABRAH",
                                    "Value": "FATEHGARH SABRAH"
                                },
                                {
                                    "Text": "FATEHNAGAR",
                                    "Value": "FATEHNAGAR"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATEHPUR",
                                    "Value": "FATEHPUR"
                                },
                                {
                                    "Text": "FATHEPUR",
                                    "Value": "FATHEPUR"
                                },
                                {
                                    "Text": "FATHEGARH SHUKARCHAK",
                                    "Value": "FATHEGARH SHUKARCHAK"
                                },
                                {
                                    "Text": "FATORDA",
                                    "Value": "FATORDA"
                                },
                                {
                                    "Text": "FAZALWAS",
                                    "Value": "FAZALWAS"
                                },
                                {
                                    "Text": "FAZILKA",
                                    "Value": "FAZILKA"
                                },
                                {
                                    "Text": "FEROKE",
                                    "Value": "FEROKE"
                                },
                                {
                                    "Text": "FEROZPUR",
                                    "Value": "FEROZPUR"
                                },
                                {
                                    "Text": "FEROZEPUR",
                                    "Value": "FEROZEPUR"
                                },
                                {
                                    "Text": "FEROZEPUR JHIRKA",
                                    "Value": "FEROZEPUR JHIRKA"
                                },
                                {
                                    "Text": "FEROZPUR CANTT",
                                    "Value": "FEROZPUR CANTT"
                                },
                                {
                                    "Text": "FILM NAGAR",
                                    "Value": "FILM NAGAR"
                                },
                                {
                                    "Text": "FIROZABAD",
                                    "Value": "FIROZABAD"
                                },
                                {
                                    "Text": "FIROZPUR",
                                    "Value": "FIROZPUR"
                                },
                                {
                                    "Text": "FORBESGANJ",
                                    "Value": "FORBESGANJ"
                                },
                                {
                                    "Text": "FARIDNAGAR",
                                    "Value": "FARIDNAGAR"
                                },
                                {
                                    "Text": "FEROZABAD",
                                    "Value": "FEROZABAD"
                                },
                                {
                                    "Text": "FUJAIRAH",
                                    "Value": "FUJAIRAH"
                                },
                                {
                                    "Text": "FUTANA ",
                                    "Value": "FUTANA "
                                },
                                {
                                    "Text": "GABBADA ",
                                    "Value": "GABBADA "
                                },
                                {
                                    "Text": "GADARWARA",
                                    "Value": "GADARWARA"
                                },
                                {
                                    "Text": "GADAG",
                                    "Value": "GADAG"
                                },
                                {
                                    "Text": "GADARPUR",
                                    "Value": "GADARPUR"
                                },
                                {
                                    "Text": "GADCHIROLI",
                                    "Value": "GADCHIROLI"
                                },
                                {
                                    "Text": "GADDAN DOAB",
                                    "Value": "GADDAN DOAB"
                                },
                                {
                                    "Text": "GADHINGLAJ",
                                    "Value": "GADHINGLAJ"
                                },
                                {
                                    "Text": "GADHEJALGAON ",
                                    "Value": "GADHEJALGAON "
                                },
                                {
                                    "Text": "GADMUDSHINGI",
                                    "Value": "GADMUDSHINGI"
                                },
                                {
                                    "Text": "GADWAL",
                                    "Value": "GADWAL"
                                },
                                {
                                    "Text": "GAGGO MAHAL",
                                    "Value": "GAGGO MAHAL"
                                },
                                {
                                    "Text": "GAGRET",
                                    "Value": "GAGRET"
                                },
                                {
                                    "Text": "GAHAM",
                                    "Value": "GAHAM"
                                },
                                {
                                    "Text": "GAHAUR",
                                    "Value": "GAHAUR"
                                },
                                {
                                    "Text": "GAJAPATI",
                                    "Value": "GAJAPATI"
                                },
                                {
                                    "Text": "GAJRAULA",
                                    "Value": "GAJRAULA"
                                },
                                {
                                    "Text": "GAJUWAKA",
                                    "Value": "GAJUWAKA"
                                },
                                {
                                    "Text": "GANAPAVARAM ",
                                    "Value": "GANAPAVARAM "
                                },
                                {
                                    "Text": "GANAUR",
                                    "Value": "GANAUR"
                                },
                                {
                                    "Text": "GANDHIDHAM",
                                    "Value": "GANDHIDHAM"
                                },
                                {
                                    "Text": "GANDHINAGAR",
                                    "Value": "GANDHINAGAR"
                                },
                                {
                                    "Text": "GANDERBAL",
                                    "Value": "GANDERBAL"
                                },
                                {
                                    "Text": "GANDHI NAGAR",
                                    "Value": "GANDHI NAGAR"
                                },
                                {
                                    "Text": "GANDHICHOWK",
                                    "Value": "GANDHICHOWK"
                                },
                                {
                                    "Text": "GANDEVI",
                                    "Value": "GANDEVI"
                                },
                                {
                                    "Text": "GANESWARPUR",
                                    "Value": "GANESWARPUR"
                                },
                                {
                                    "Text": "GANGANAGAR",
                                    "Value": "GANGANAGAR"
                                },
                                {
                                    "Text": "GANGAVATI",
                                    "Value": "GANGAVATI"
                                },
                                {
                                    "Text": "GANGTOK",
                                    "Value": "GANGTOK"
                                },
                                {
                                    "Text": "GANGUPAHAD ",
                                    "Value": "GANGUPAHAD "
                                },
                                {
                                    "Text": "GANGAPUR PURVI ",
                                    "Value": "GANGAPUR PURVI "
                                },
                                {
                                    "Text": "GANGAKHED",
                                    "Value": "GANGAKHED"
                                },
                                {
                                    "Text": "GANGAPUR CITY",
                                    "Value": "GANGAPUR CITY"
                                },
                                {
                                    "Text": "GANGAWATI",
                                    "Value": "GANGAWATI"
                                },
                                {
                                    "Text": "GANGOH",
                                    "Value": "GANGOH"
                                },
                                {
                                    "Text": "GANJ BASODA",
                                    "Value": "GANJ BASODA"
                                },
                                {
                                    "Text": "GANJAM",
                                    "Value": "GANJAM"
                                },
                                {
                                    "Text": "GANNAVARAM",
                                    "Value": "GANNAVARAM"
                                },
                                {
                                    "Text": "GARDHIWAL",
                                    "Value": "GARDHIWAL"
                                },
                                {
                                    "Text": "GARGOTI",
                                    "Value": "GARGOTI"
                                },
                                {
                                    "Text": "GARHSHANKAR",
                                    "Value": "GARHSHANKAR"
                                },
                                {
                                    "Text": "GARHWA",
                                    "Value": "GARHWA"
                                },
                                {
                                    "Text": "GARIABAND",
                                    "Value": "GARIABAND"
                                },
                                {
                                    "Text": "GAROBADHA",
                                    "Value": "GAROBADHA"
                                },
                                {
                                    "Text": "GAURIBIDANUR",
                                    "Value": "GAURIBIDANUR"
                                },
                                {
                                    "Text": "GAUTAM BUDDHA NAGAR",
                                    "Value": "GAUTAM BUDDHA NAGAR"
                                },
                                {
                                    "Text": "GAYA",
                                    "Value": "GAYA"
                                },
                                {
                                    "Text": "GB NAGAR",
                                    "Value": "GB NAGAR"
                                },
                                {
                                    "Text": "GB NAGAR",
                                    "Value": "GB NAGAR"
                                },
                                {
                                    "Text": "GADHADA",
                                    "Value": "GADHADA"
                                },
                                {
                                    "Text": "GENOME VALLEY",
                                    "Value": "GENOME VALLEY"
                                },
                                {
                                    "Text": "GEORAI KUBER ",
                                    "Value": "GEORAI KUBER "
                                },
                                {
                                    "Text": "GHALLKHURD",
                                    "Value": "GHALLKHURD"
                                },
                                {
                                    "Text": "GHAMROZ",
                                    "Value": "GHAMROZ"
                                },
                                {
                                    "Text": "GHANPUR ",
                                    "Value": "GHANPUR "
                                },
                                {
                                    "Text": "GHANAUR",
                                    "Value": "GHANAUR"
                                },
                                {
                                    "Text": "GHATAMPUR",
                                    "Value": "GHATAMPUR"
                                },
                                {
                                    "Text": "GHATSHILA",
                                    "Value": "GHATSHILA"
                                },
                                {
                                    "Text": "GHAZIABAD",
                                    "Value": "GHAZIABAD"
                                },
                                {
                                    "Text": "GHAZIPUR",
                                    "Value": "GHAZIPUR"
                                },
                                {
                                    "Text": "GHAZIABAD UP",
                                    "Value": "GHAZIABAD UP"
                                },
                                {
                                    "Text": "GHILOR KALAN",
                                    "Value": "GHILOR KALAN"
                                },
                                {
                                    "Text": "GHODIYAL",
                                    "Value": "GHODIYAL"
                                },
                                {
                                    "Text": "GHOGHLA",
                                    "Value": "GHOGHLA"
                                },
                                {
                                    "Text": "GHOGRA",
                                    "Value": "GHOGRA"
                                },
                                {
                                    "Text": "GHOSI",
                                    "Value": "GHOSI"
                                },
                                {
                                    "Text": "GHOTI BUDRUK",
                                    "Value": "GHOTI BUDRUK"
                                },
                                {
                                    "Text": "GHEORA",
                                    "Value": "GHEORA"
                                },
                                {
                                    "Text": "GHARONDA NEEMKA BANGAR",
                                    "Value": "GHARONDA NEEMKA BANGAR"
                                },
                                {
                                    "Text": "GHAROLI",
                                    "Value": "GHAROLI"
                                },
                                {
                                    "Text": "GHATAL",
                                    "Value": "GHATAL"
                                },
                                {
                                    "Text": "GHITORNI",
                                    "Value": "GHITORNI"
                                },
                                {
                                    "Text": "GHUDDA",
                                    "Value": "GHUDDA"
                                },
                                {
                                    "Text": "GHUGIANA ",
                                    "Value": "GHUGIANA "
                                },
                                {
                                    "Text": "GHUMAN",
                                    "Value": "GHUMAN"
                                },
                                {
                                    "Text": "GARHWAL",
                                    "Value": "GARHWAL"
                                },
                                {
                                    "Text": "GIDDARBAHA",
                                    "Value": "GIDDARBAHA"
                                },
                                {
                                    "Text": "GIDDALUR",
                                    "Value": "GIDDALUR"
                                },
                                {
                                    "Text": "GIDDERBAHA",
                                    "Value": "GIDDERBAHA"
                                },
                                {
                                    "Text": "GILJEWALA",
                                    "Value": "GILJEWALA"
                                },
                                {
                                    "Text": "GILL ROAD",
                                    "Value": "GILL ROAD"
                                },
                                {
                                    "Text": "GILL",
                                    "Value": "GILL"
                                },
                                {
                                    "Text": "GIRGITPALLE ",
                                    "Value": "GIRGITPALLE "
                                },
                                {
                                    "Text": "GIRIDIH",
                                    "Value": "GIRIDIH"
                                },
                                {
                                    "Text": "GIRIDH",
                                    "Value": "GIRIDH"
                                },
                                {
                                    "Text": "GOKAL PUR",
                                    "Value": "GOKAL PUR"
                                },
                                {
                                    "Text": "GOMTI NAGAR",
                                    "Value": "GOMTI NAGAR"
                                },
                                {
                                    "Text": "GANGARAMPUR",
                                    "Value": "GANGARAMPUR"
                                },
                                {
                                    "Text": "GOA",
                                    "Value": "GOA"
                                },
                                {
                                    "Text": "GOALPARA",
                                    "Value": "GOALPARA"
                                },
                                {
                                    "Text": "GOA VELHA",
                                    "Value": "GOA VELHA"
                                },
                                {
                                    "Text": "GOA VELHA",
                                    "Value": "GOA VELHA"
                                },
                                {
                                    "Text": "GOBI",
                                    "Value": "GOBI"
                                },
                                {
                                    "Text": "GOBICHETTIPALAYAM",
                                    "Value": "GOBICHETTIPALAYAM"
                                },
                                {
                                    "Text": "GOBINDGARH",
                                    "Value": "GOBINDGARH"
                                },
                                {
                                    "Text": "GOBORDANGA",
                                    "Value": "GOBORDANGA"
                                },
                                {
                                    "Text": "GODAVARIKHANI",
                                    "Value": "GODAVARIKHANI"
                                },
                                {
                                    "Text": "GODAMGUDA ",
                                    "Value": "GODAMGUDA "
                                },
                                {
                                    "Text": "GODBOLEMALA",
                                    "Value": "GODBOLEMALA"
                                },
                                {
                                    "Text": "GODDA",
                                    "Value": "GODDA"
                                },
                                {
                                    "Text": "GODHRA",
                                    "Value": "GODHRA"
                                },
                                {
                                    "Text": "GODHRA BHURAVAV ",
                                    "Value": "GODHRA BHURAVAV "
                                },
                                {
                                    "Text": "GODHAVI",
                                    "Value": "GODHAVI"
                                },
                                {
                                    "Text": "GOGOANI",
                                    "Value": "GOGOANI"
                                },
                                {
                                    "Text": "GOGOANI",
                                    "Value": "GOGOANI"
                                },
                                {
                                    "Text": "GOHANA",
                                    "Value": "GOHANA"
                                },
                                {
                                    "Text": "GOINDWAL",
                                    "Value": "GOINDWAL"
                                },
                                {
                                    "Text": "GOKAK",
                                    "Value": "GOKAK"
                                },
                                {
                                    "Text": "GOLAGHAT",
                                    "Value": "GOLAGHAT"
                                },
                                {
                                    "Text": "GOLATGAON ",
                                    "Value": "GOLATGAON "
                                },
                                {
                                    "Text": "GOLA GOKARAN NATH",
                                    "Value": "GOLA GOKARAN NATH"
                                },
                                {
                                    "Text": "GOLA",
                                    "Value": "GOLA"
                                },
                                {
                                    "Text": "GOLEWALA ",
                                    "Value": "GOLEWALA "
                                },
                                {
                                    "Text": "GOLEWALA",
                                    "Value": "GOLEWALA"
                                },
                                {
                                    "Text": "GOLLALAGUDUR ",
                                    "Value": "GOLLALAGUDUR "
                                },
                                {
                                    "Text": "GOMATI",
                                    "Value": "GOMATI"
                                },
                                {
                                    "Text": "GONDAL",
                                    "Value": "GONDAL"
                                },
                                {
                                    "Text": "GONDA",
                                    "Value": "GONDA"
                                },
                                {
                                    "Text": "GONDIA",
                                    "Value": "GONDIA"
                                },
                                {
                                    "Text": "GONDIPAKALAU ",
                                    "Value": "GONDIPAKALAU "
                                },
                                {
                                    "Text": "GONIANA MANDI",
                                    "Value": "GONIANA MANDI"
                                },
                                {
                                    "Text": "GONIANA",
                                    "Value": "GONIANA"
                                },
                                {
                                    "Text": "GONIKOPPAL",
                                    "Value": "GONIKOPPAL"
                                },
                                {
                                    "Text": "GOPALGANJ",
                                    "Value": "GOPALGANJ"
                                },
                                {
                                    "Text": "GOPANAPALLE",
                                    "Value": "GOPANAPALLE"
                                },
                                {
                                    "Text": "GOPINAGAR",
                                    "Value": "GOPINAGAR"
                                },
                                {
                                    "Text": "GORAYA",
                                    "Value": "GORAYA"
                                },
                                {
                                    "Text": "GORAKHPUR",
                                    "Value": "GORAKHPUR"
                                },
                                {
                                    "Text": "GORAKNATH",
                                    "Value": "GORAKNATH"
                                },
                                {
                                    "Text": "GOREGAON",
                                    "Value": "GOREGAON"
                                },
                                {
                                    "Text": "GOTIBANDH ",
                                    "Value": "GOTIBANDH "
                                },
                                {
                                    "Text": "GOTTIMUKKALA ",
                                    "Value": "GOTTIMUKKALA "
                                },
                                {
                                    "Text": "GOTUR ",
                                    "Value": "GOTUR "
                                },
                                {
                                    "Text": "GOUDGOP",
                                    "Value": "GOUDGOP"
                                },
                                {
                                    "Text": "GOVERDHAN",
                                    "Value": "GOVERDHAN"
                                },
                                {
                                    "Text": "GOVINDPET ",
                                    "Value": "GOVINDPET "
                                },
                                {
                                    "Text": "GOVINDPET",
                                    "Value": "GOVINDPET"
                                },
                                {
                                    "Text": "GOWARDHAN ",
                                    "Value": "GOWARDHAN "
                                },
                                {
                                    "Text": "GOWRISANKARA PURAM ",
                                    "Value": "GOWRISANKARA PURAM "
                                },
                                {
                                    "Text": "G.PANGIDIGUDEM ",
                                    "Value": "G.PANGIDIGUDEM "
                                },
                                {
                                    "Text": "GANDHI PADIA",
                                    "Value": "GANDHI PADIA"
                                },
                                {
                                    "Text": "GREATER NOIDA",
                                    "Value": "GREATER NOIDA"
                                },
                                {
                                    "Text": "GAROBADHA",
                                    "Value": "GAROBADHA"
                                },
                                {
                                    "Text": "GARIYADHAR",
                                    "Value": "GARIYADHAR"
                                },
                                {
                                    "Text": "GUDIYATHAM",
                                    "Value": "GUDIYATHAM"
                                },
                                {
                                    "Text": "GUDAH",
                                    "Value": "GUDAH"
                                },
                                {
                                    "Text": "GUDIVADA",
                                    "Value": "GUDIVADA"
                                },
                                {
                                    "Text": "GUDLI",
                                    "Value": "GUDLI"
                                },
                                {
                                    "Text": "GUDUR",
                                    "Value": "GUDUR"
                                },
                                {
                                    "Text": "GUDUR ",
                                    "Value": "GUDUR "
                                },
                                {
                                    "Text": "GULAOTHI",
                                    "Value": "GULAOTHI"
                                },
                                {
                                    "Text": "GULBARGA",
                                    "Value": "GULBARGA"
                                },
                                {
                                    "Text": "GUMARWIN",
                                    "Value": "GUMARWIN"
                                },
                                {
                                    "Text": "GUMIA",
                                    "Value": "GUMIA"
                                },
                                {
                                    "Text": "GUMLA",
                                    "Value": "GUMLA"
                                },
                                {
                                    "Text": "GUNA",
                                    "Value": "GUNA"
                                },
                                {
                                    "Text": "GUNDRATHIMADUGU ",
                                    "Value": "GUNDRATHIMADUGU "
                                },
                                {
                                    "Text": "GUNDUPALA ",
                                    "Value": "GUNDUPALA "
                                },
                                {
                                    "Text": "GUNTAKAL",
                                    "Value": "GUNTAKAL"
                                },
                                {
                                    "Text": "GUNTUR",
                                    "Value": "GUNTUR"
                                },
                                {
                                    "Text": "GURANDARAPALEM ",
                                    "Value": "GURANDARAPALEM "
                                },
                                {
                                    "Text": "GURDASPUR",
                                    "Value": "GURDASPUR"
                                },
                                {
                                    "Text": "GURGAON",
                                    "Value": "GURGAON"
                                },
                                {
                                    "Text": "GURGAON",
                                    "Value": "GURGAON"
                                },
                                {
                                    "Text": "GURNE KALAN",
                                    "Value": "GURNE KALAN"
                                },
                                {
                                    "Text": "GURSIA ",
                                    "Value": "GURSIA "
                                },
                                {
                                    "Text": "GURSARAI",
                                    "Value": "GURSARAI"
                                },
                                {
                                    "Text": "GURUVAYUR",
                                    "Value": "GURUVAYUR"
                                },
                                {
                                    "Text": "GURUHARSAHAI",
                                    "Value": "GURUHARSAHAI"
                                },
                                {
                                    "Text": "GURUVAYOOR",
                                    "Value": "GURUVAYOOR"
                                },
                                {
                                    "Text": "GURVAIGUDEM ",
                                    "Value": "GURVAIGUDEM "
                                },
                                {
                                    "Text": "GUSKARA",
                                    "Value": "GUSKARA"
                                },
                                {
                                    "Text": "GUSKARA",
                                    "Value": "GUSKARA"
                                },
                                {
                                    "Text": "GUWAHATI",
                                    "Value": "GUWAHATI"
                                },
                                {
                                    "Text": "GWALIOR",
                                    "Value": "GWALIOR"
                                },
                                {
                                    "Text": "HABRA",
                                    "Value": "HABRA"
                                },
                                {
                                    "Text": "HADAMTALA",
                                    "Value": "HADAMTALA"
                                },
                                {
                                    "Text": "HADGOOD",
                                    "Value": "HADGOOD"
                                },
                                {
                                    "Text": "HADIYOL",
                                    "Value": "HADIYOL"
                                },
                                {
                                    "Text": "HAIBOWAL KALAN",
                                    "Value": "HAIBOWAL KALAN"
                                },
                                {
                                    "Text": "HAIDERGARH",
                                    "Value": "HAIDERGARH"
                                },
                                {
                                    "Text": "HAILAKANDI",
                                    "Value": "HAILAKANDI"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HAJIRA",
                                    "Value": "HAJIRA"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HAJIPUR",
                                    "Value": "HAJIPUR"
                                },
                                {
                                    "Text": "HALDWANI",
                                    "Value": "HALDWANI"
                                },
                                {
                                    "Text": "HALDIA",
                                    "Value": "HALDIA"
                                },
                                {
                                    "Text": "HALLY MANDI",
                                    "Value": "HALLY MANDI"
                                },
                                {
                                    "Text": "HALOL",
                                    "Value": "HALOL"
                                },
                                {
                                    "Text": "HALVAD",
                                    "Value": "HALVAD"
                                },
                                {
                                    "Text": "HAMBRAN",
                                    "Value": "HAMBRAN"
                                },
                                {
                                    "Text": "HAMIRPUR",
                                    "Value": "HAMIRPUR"
                                },
                                {
                                    "Text": "HAMIRPUR(HP)",
                                    "Value": "HAMIRPUR(HP)"
                                },
                                {
                                    "Text": "HAMIRPUR",
                                    "Value": "HAMIRPUR"
                                },
                                {
                                    "Text": "HANUMAKONDA",
                                    "Value": "HANUMAKONDA"
                                },
                                {
                                    "Text": "HANAGODU ",
                                    "Value": "HANAGODU "
                                },
                                {
                                    "Text": "HANDIA",
                                    "Value": "HANDIA"
                                },
                                {
                                    "Text": "HANDWARA",
                                    "Value": "HANDWARA"
                                },
                                {
                                    "Text": "HANSI",
                                    "Value": "HANSI"
                                },
                                {
                                    "Text": "HANUMANGARH TOWN",
                                    "Value": "HANUMANGARH TOWN"
                                },
                                {
                                    "Text": "HANUMANGARH",
                                    "Value": "HANUMANGARH"
                                },
                                {
                                    "Text": "HANUMANTHAPUR ",
                                    "Value": "HANUMANTHAPUR "
                                },
                                {
                                    "Text": "HANUMAPUR ",
                                    "Value": "HANUMAPUR "
                                },
                                {
                                    "Text": "HANUMAN JUNCTION",
                                    "Value": "HANUMAN JUNCTION"
                                },
                                {
                                    "Text": "HAPUR",
                                    "Value": "HAPUR"
                                },
                                {
                                    "Text": "HARCHOWAL",
                                    "Value": "HARCHOWAL"
                                },
                                {
                                    "Text": "HARDA",
                                    "Value": "HARDA"
                                },
                                {
                                    "Text": "HARDOI",
                                    "Value": "HARDOI"
                                },
                                {
                                    "Text": "HARIDWAR",
                                    "Value": "HARIDWAR"
                                },
                                {
                                    "Text": "HARIDWAR",
                                    "Value": "HARIDWAR"
                                },
                                {
                                    "Text": "HARIPURDHAR",
                                    "Value": "HARIPURDHAR"
                                },
                                {
                                    "Text": "HARINDRA NAGAR (FARIDKOT) ",
                                    "Value": "HARINDRA NAGAR (FARIDKOT) "
                                },
                                {
                                    "Text": "HARI KE PATTAN",
                                    "Value": "HARI KE PATTAN"
                                },
                                {
                                    "Text": "HARIANA",
                                    "Value": "HARIANA"
                                },
                                {
                                    "Text": "HARIJ",
                                    "Value": "HARIJ"
                                },
                                {
                                    "Text": "HARIPAR PAL",
                                    "Value": "HARIPAR PAL"
                                },
                                {
                                    "Text": "HARYAU",
                                    "Value": "HARYAU"
                                },
                                {
                                    "Text": "HASANPUR",
                                    "Value": "HASANPUR"
                                },
                                {
                                    "Text": "HASSAN",
                                    "Value": "HASSAN"
                                },
                                {
                                    "Text": "HASSANPUR",
                                    "Value": "HASSANPUR"
                                },
                                {
                                    "Text": "HASTEPIMPALGAON ",
                                    "Value": "HASTEPIMPALGAON "
                                },
                                {
                                    "Text": "HATA",
                                    "Value": "HATA"
                                },
                                {
                                    "Text": "HATABUZURG",
                                    "Value": "HATABUZURG"
                                },
                                {
                                    "Text": "HATHRAS",
                                    "Value": "HATHRAS"
                                },
                                {
                                    "Text": "HATHIN",
                                    "Value": "HATHIN"
                                },
                                {
                                    "Text": "HASTSAL",
                                    "Value": "HASTSAL"
                                },
                                {
                                    "Text": "HAVERI",
                                    "Value": "HAVERI"
                                },
                                {
                                    "Text": "HAYATNAGAR",
                                    "Value": "HAYATNAGAR"
                                },
                                {
                                    "Text": "HAYATPUR",
                                    "Value": "HAYATPUR"
                                },
                                {
                                    "Text": "HAZARIBAG",
                                    "Value": "HAZARIBAG"
                                },
                                {
                                    "Text": "HAZARIBAGH",
                                    "Value": "HAZARIBAGH"
                                },
                                {
                                    "Text": "HERBERTPUR",
                                    "Value": "HERBERTPUR"
                                },
                                {
                                    "Text": "HILSA",
                                    "Value": "HILSA"
                                },
                                {
                                    "Text": "HIMATNAGAR",
                                    "Value": "HIMATNAGAR"
                                },
                                {
                                    "Text": "HIMMATNAGAR",
                                    "Value": "HIMMATNAGAR"
                                },
                                {
                                    "Text": "HINDUPUR",
                                    "Value": "HINDUPUR"
                                },
                                {
                                    "Text": "HINDAUN",
                                    "Value": "HINDAUN"
                                },
                                {
                                    "Text": "HINGANGHAT",
                                    "Value": "HINGANGHAT"
                                },
                                {
                                    "Text": "HINGOLI",
                                    "Value": "HINGOLI"
                                },
                                {
                                    "Text": "HINGNA",
                                    "Value": "HINGNA"
                                },
                                {
                                    "Text": "HINDMOTOR",
                                    "Value": "HINDMOTOR"
                                },
                                {
                                    "Text": "HIRIYUR",
                                    "Value": "HIRIYUR"
                                },
                                {
                                    "Text": "HIRPURA",
                                    "Value": "HIRPURA"
                                },
                                {
                                    "Text": "HISAR",
                                    "Value": "HISAR"
                                },
                                {
                                    "Text": "HISSAR",
                                    "Value": "HISSAR"
                                },
                                {
                                    "Text": "HAILEYMANDI",
                                    "Value": "HAILEYMANDI"
                                },
                                {
                                    "Text": "HODAL",
                                    "Value": "HODAL"
                                },
                                {
                                    "Text": "HOJAI",
                                    "Value": "HOJAI"
                                },
                                {
                                    "Text": "HOMNABAD",
                                    "Value": "HOMNABAD"
                                },
                                {
                                    "Text": "HONAVAR",
                                    "Value": "HONAVAR"
                                },
                                {
                                    "Text": "HONNENAHALLI ",
                                    "Value": "HONNENAHALLI "
                                },
                                {
                                    "Text": "HOOGHLY",
                                    "Value": "HOOGHLY"
                                },
                                {
                                    "Text": "HOSHANGABAD",
                                    "Value": "HOSHANGABAD"
                                },
                                {
                                    "Text": "HOSHIARPUR",
                                    "Value": "HOSHIARPUR"
                                },
                                {
                                    "Text": "HOSPET",
                                    "Value": "HOSPET"
                                },
                                {
                                    "Text": "HOSUR",
                                    "Value": "HOSUR"
                                },
                                {
                                    "Text": "HOWRAH",
                                    "Value": "HOWRAH"
                                },
                                {
                                    "Text": "HIRANAGAR",
                                    "Value": "HIRANAGAR"
                                },
                                {
                                    "Text": "HARIPAD",
                                    "Value": "HARIPAD"
                                },
                                {
                                    "Text": "HARISHNAGAR",
                                    "Value": "HARISHNAGAR"
                                },
                                {
                                    "Text": "HUBLI",
                                    "Value": "HUBLI"
                                },
                                {
                                    "Text": "HUDLI",
                                    "Value": "HUDLI"
                                },
                                {
                                    "Text": "HUGLI",
                                    "Value": "HUGLI"
                                },
                                {
                                    "Text": "HUNASAMARANAHALLI",
                                    "Value": "HUNASAMARANAHALLI"
                                },
                                {
                                    "Text": "HUNSA",
                                    "Value": "HUNSA"
                                },
                                {
                                    "Text": "HUNSUR",
                                    "Value": "HUNSUR"
                                },
                                {
                                    "Text": "HUPARI",
                                    "Value": "HUPARI"
                                },
                                {
                                    "Text": "HUSNABAD",
                                    "Value": "HUSNABAD"
                                },
                                {
                                    "Text": "HUSSAINPUR",
                                    "Value": "HUSSAINPUR"
                                },
                                {
                                    "Text": "HUSSAINPUR (CT)",
                                    "Value": "HUSSAINPUR (CT)"
                                },
                                {
                                    "Text": "HUZURABAD",
                                    "Value": "HUZURABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "HYDERABAD",
                                    "Value": "HYDERABAD"
                                },
                                {
                                    "Text": "IBBAN ",
                                    "Value": "IBBAN "
                                },
                                {
                                    "Text": "IBBAN",
                                    "Value": "IBBAN"
                                },
                                {
                                    "Text": "ICHALKARANJI",
                                    "Value": "ICHALKARANJI"
                                },
                                {
                                    "Text": "IDAR",
                                    "Value": "IDAR"
                                },
                                {
                                    "Text": "IDUKKI",
                                    "Value": "IDUKKI"
                                },
                                {
                                    "Text": "IGATPURI",
                                    "Value": "IGATPURI"
                                },
                                {
                                    "Text": "IGNTU AMARKANTAK .",
                                    "Value": "IGNTU AMARKANTAK ."
                                },
                                {
                                    "Text": "IKAUNA",
                                    "Value": "IKAUNA"
                                },
                                {
                                    "Text": "ILAMPILLAI",
                                    "Value": "ILAMPILLAI"
                                },
                                {
                                    "Text": "ISLAMPUR",
                                    "Value": "ISLAMPUR"
                                },
                                {
                                    "Text": "IMALYAKA",
                                    "Value": "IMALYAKA"
                                },
                                {
                                    "Text": "IMPHAL",
                                    "Value": "IMPHAL"
                                },
                                {
                                    "Text": "IMPHAL EAST",
                                    "Value": "IMPHAL EAST"
                                },
                                {
                                    "Text": "IMPHAL WEST",
                                    "Value": "IMPHAL WEST"
                                },
                                {
                                    "Text": "IMPHAL EAST",
                                    "Value": "IMPHAL EAST"
                                },
                                {
                                    "Text": "INDAPUR",
                                    "Value": "INDAPUR"
                                },
                                {
                                    "Text": "INDORE",
                                    "Value": "INDORE"
                                },
                                {
                                    "Text": "INDIRAPURAM",
                                    "Value": "INDIRAPURAM"
                                },
                                {
                                    "Text": "INDRAD",
                                    "Value": "INDRAD"
                                },
                                {
                                    "Text": "INDRAPURA",
                                    "Value": "INDRAPURA"
                                },
                                {
                                    "Text": "INDRI",
                                    "Value": "INDRI"
                                },
                                {
                                    "Text": "INDUPUR",
                                    "Value": "INDUPUR"
                                },
                                {
                                    "Text": "INNADU ",
                                    "Value": "INNADU "
                                },
                                {
                                    "Text": "IPPATLA ",
                                    "Value": "IPPATLA "
                                },
                                {
                                    "Text": "IRINJALAKUDA",
                                    "Value": "IRINJALAKUDA"
                                },
                                {
                                    "Text": "IRINJALAGUDA",
                                    "Value": "IRINJALAGUDA"
                                },
                                {
                                    "Text": "ISLAMPUR",
                                    "Value": "ISLAMPUR"
                                },
                                {
                                    "Text": "ISMAILABAD",
                                    "Value": "ISMAILABAD"
                                },
                                {
                                    "Text": "ISPUR",
                                    "Value": "ISPUR"
                                },
                                {
                                    "Text": "ISRANA",
                                    "Value": "ISRANA"
                                },
                                {
                                    "Text": "ISSAPALLI ",
                                    "Value": "ISSAPALLI "
                                },
                                {
                                    "Text": "ITANAGAR",
                                    "Value": "ITANAGAR"
                                },
                                {
                                    "Text": "ITARSI",
                                    "Value": "ITARSI"
                                },
                                {
                                    "Text": "ITAWA KALAN",
                                    "Value": "ITAWA KALAN"
                                },
                                {
                                    "Text": "JABALPUR",
                                    "Value": "JABALPUR"
                                },
                                {
                                    "Text": "JABBOWAL",
                                    "Value": "JABBOWAL"
                                },
                                {
                                    "Text": "JADCHERLA",
                                    "Value": "JADCHERLA"
                                },
                                {
                                    "Text": "JADLA",
                                    "Value": "JADLA"
                                },
                                {
                                    "Text": "JAGATSINGHPUR",
                                    "Value": "JAGATSINGHPUR"
                                },
                                {
                                    "Text": "JAGADHRI",
                                    "Value": "JAGADHRI"
                                },
                                {
                                    "Text": "JAGADHARI",
                                    "Value": "JAGADHARI"
                                },
                                {
                                    "Text": "JAGATSINGHAPUR",
                                    "Value": "JAGATSINGHAPUR"
                                },
                                {
                                    "Text": "JAGADISHPUR",
                                    "Value": "JAGADISHPUR"
                                },
                                {
                                    "Text": "JAGATPUR",
                                    "Value": "JAGATPUR"
                                },
                                {
                                    "Text": "JAGDALPUR",
                                    "Value": "JAGDALPUR"
                                },
                                {
                                    "Text": "JAGGAYYAPET",
                                    "Value": "JAGGAYYAPET"
                                },
                                {
                                    "Text": "JAGGAYAPET",
                                    "Value": "JAGGAYAPET"
                                },
                                {
                                    "Text": "JAGIROAD",
                                    "Value": "JAGIROAD"
                                },
                                {
                                    "Text": "JAGITYALA",
                                    "Value": "JAGITYALA"
                                },
                                {
                                    "Text": "JAGRAON",
                                    "Value": "JAGRAON"
                                },
                                {
                                    "Text": "JAHANGIRABAD",
                                    "Value": "JAHANGIRABAD"
                                },
                                {
                                    "Text": "JAHANPUR",
                                    "Value": "JAHANPUR"
                                },
                                {
                                    "Text": "JAIDUPALLI ",
                                    "Value": "JAIDUPALLI "
                                },
                                {
                                    "Text": "JAIMAL WALA ",
                                    "Value": "JAIMAL WALA "
                                },
                                {
                                    "Text": "JAINTIA HILLS",
                                    "Value": "JAINTIA HILLS"
                                },
                                {
                                    "Text": "JAIPUR",
                                    "Value": "JAIPUR"
                                },
                                {
                                    "Text": "JAIRAMPUR",
                                    "Value": "JAIRAMPUR"
                                },
                                {
                                    "Text": "JAISALMER",
                                    "Value": "JAISALMER"
                                },
                                {
                                    "Text": "JAIS",
                                    "Value": "JAIS"
                                },
                                {
                                    "Text": "JAISALEMER",
                                    "Value": "JAISALEMER"
                                },
                                {
                                    "Text": "JAISINGHPUR",
                                    "Value": "JAISINGHPUR"
                                },
                                {
                                    "Text": "JAITU",
                                    "Value": "JAITU"
                                },
                                {
                                    "Text": "JAJAPUR",
                                    "Value": "JAJAPUR"
                                },
                                {
                                    "Text": "JAJPUR ROAD",
                                    "Value": "JAJPUR ROAD"
                                },
                                {
                                    "Text": "JAJPUR TOWN",
                                    "Value": "JAJPUR TOWN"
                                },
                                {
                                    "Text": "JAJPUR",
                                    "Value": "JAJPUR"
                                },
                                {
                                    "Text": "JAKHAL",
                                    "Value": "JAKHAL"
                                },
                                {
                                    "Text": "JALALABAD",
                                    "Value": "JALALABAD"
                                },
                                {
                                    "Text": "JALANDHAR",
                                    "Value": "JALANDHAR"
                                },
                                {
                                    "Text": "JALAUN",
                                    "Value": "JALAUN"
                                },
                                {
                                    "Text": "JALALPUR",
                                    "Value": "JALALPUR"
                                },
                                {
                                    "Text": "JALANDHAR CANTT",
                                    "Value": "JALANDHAR CANTT"
                                },
                                {
                                    "Text": "JALGAON",
                                    "Value": "JALGAON"
                                },
                                {
                                    "Text": "JALKE ",
                                    "Value": "JALKE "
                                },
                                {
                                    "Text": "JALMANA",
                                    "Value": "JALMANA"
                                },
                                {
                                    "Text": "JALNA",
                                    "Value": "JALNA"
                                },
                                {
                                    "Text": "JALORE",
                                    "Value": "JALORE"
                                },
                                {
                                    "Text": "JALOR",
                                    "Value": "JALOR"
                                },
                                {
                                    "Text": "JALOCHI",
                                    "Value": "JALOCHI"
                                },
                                {
                                    "Text": "JALPAIGURI",
                                    "Value": "JALPAIGURI"
                                },
                                {
                                    "Text": "JAMKHED",
                                    "Value": "JAMKHED"
                                },
                                {
                                    "Text": "JAM JODHPUR",
                                    "Value": "JAM JODHPUR"
                                },
                                {
                                    "Text": "JAMANDLAPALLI ",
                                    "Value": "JAMANDLAPALLI "
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMALPUR",
                                    "Value": "JAMALPUR"
                                },
                                {
                                    "Text": "JAMBUSAR",
                                    "Value": "JAMBUSAR"
                                },
                                {
                                    "Text": "JAMDIH ",
                                    "Value": "JAMDIH "
                                },
                                {
                                    "Text": "JAMGAON",
                                    "Value": "JAMGAON"
                                },
                                {
                                    "Text": "JAMIYATPURA",
                                    "Value": "JAMIYATPURA"
                                },
                                {
                                    "Text": "JAMJODHPUR",
                                    "Value": "JAMJODHPUR"
                                },
                                {
                                    "Text": "JAMKHAMBHALIA",
                                    "Value": "JAMKHAMBHALIA"
                                },
                                {
                                    "Text": "JAMKHANDI",
                                    "Value": "JAMKHANDI"
                                },
                                {
                                    "Text": "JAMMIKUNTA",
                                    "Value": "JAMMIKUNTA"
                                },
                                {
                                    "Text": "JAMMU",
                                    "Value": "JAMMU"
                                },
                                {
                                    "Text": "JAMNAGAR",
                                    "Value": "JAMNAGAR"
                                },
                                {
                                    "Text": "JAMNER",
                                    "Value": "JAMNER"
                                },
                                {
                                    "Text": "JAMSHEDPUR",
                                    "Value": "JAMSHEDPUR"
                                },
                                {
                                    "Text": "JAMSHER",
                                    "Value": "JAMSHER"
                                },
                                {
                                    "Text": "JAMTARA",
                                    "Value": "JAMTARA"
                                },
                                {
                                    "Text": "JAMTUKAM ",
                                    "Value": "JAMTUKAM "
                                },
                                {
                                    "Text": "JAMUI",
                                    "Value": "JAMUI"
                                },
                                {
                                    "Text": "JAMURIA",
                                    "Value": "JAMURIA"
                                },
                                {
                                    "Text": "JANDIALA GURU",
                                    "Value": "JANDIALA GURU"
                                },
                                {
                                    "Text": "JANDIALA",
                                    "Value": "JANDIALA"
                                },
                                {
                                    "Text": "JANDOLI",
                                    "Value": "JANDOLI"
                                },
                                {
                                    "Text": "JANDPUR",
                                    "Value": "JANDPUR"
                                },
                                {
                                    "Text": "JANDU SINGHA",
                                    "Value": "JANDU SINGHA"
                                },
                                {
                                    "Text": "JANGAON",
                                    "Value": "JANGAON"
                                },
                                {
                                    "Text": "JANGAON BAZAR ",
                                    "Value": "JANGAON BAZAR "
                                },
                                {
                                    "Text": "JANGAREDDYGUDEM",
                                    "Value": "JANGAREDDYGUDEM"
                                },
                                {
                                    "Text": "JANGIPUR",
                                    "Value": "JANGIPUR"
                                },
                                {
                                    "Text": "JANIAL",
                                    "Value": "JANIAL"
                                },
                                {
                                    "Text": "JANJAON",
                                    "Value": "JANJAON"
                                },
                                {
                                    "Text": "JANJGIR",
                                    "Value": "JANJGIR"
                                },
                                {
                                    "Text": "JANJGIR-CHAMPA",
                                    "Value": "JANJGIR-CHAMPA"
                                },
                                {
                                    "Text": "JANKAMPET",
                                    "Value": "JANKAMPET"
                                },
                                {
                                    "Text": "JANSUI",
                                    "Value": "JANSUI"
                                },
                                {
                                    "Text": "JAORA",
                                    "Value": "JAORA"
                                },
                                {
                                    "Text": "JARG",
                                    "Value": "JARG"
                                },
                                {
                                    "Text": "JASDAN",
                                    "Value": "JASDAN"
                                },
                                {
                                    "Text": "JASHPUR",
                                    "Value": "JASHPUR"
                                },
                                {
                                    "Text": "JASRA",
                                    "Value": "JASRA"
                                },
                                {
                                    "Text": "JASSUR",
                                    "Value": "JASSUR"
                                },
                                {
                                    "Text": "JASWANT NAGAR",
                                    "Value": "JASWANT NAGAR"
                                },
                                {
                                    "Text": "JATANI",
                                    "Value": "JATANI"
                                },
                                {
                                    "Text": "JATH",
                                    "Value": "JATH"
                                },
                                {
                                    "Text": "JATHERI",
                                    "Value": "JATHERI"
                                },
                                {
                                    "Text": "JATPAR",
                                    "Value": "JATPAR"
                                },
                                {
                                    "Text": "JAUNPUR",
                                    "Value": "JAUNPUR"
                                },
                                {
                                    "Text": "JAURA CHITTRAN",
                                    "Value": "JAURA CHITTRAN"
                                },
                                {
                                    "Text": "JAVKHEDA BK ",
                                    "Value": "JAVKHEDA BK "
                                },
                                {
                                    "Text": "JAWAHAR",
                                    "Value": "JAWAHAR"
                                },
                                {
                                    "Text": "JAYGAON",
                                    "Value": "JAYGAON"
                                },
                                {
                                    "Text": "JAYSINGPUR",
                                    "Value": "JAYSINGPUR"
                                },
                                {
                                    "Text": "JEELGUL",
                                    "Value": "JEELGUL"
                                },
                                {
                                    "Text": "JEHANABAD",
                                    "Value": "JEHANABAD"
                                },
                                {
                                    "Text": "JEONDAN",
                                    "Value": "JEONDAN"
                                },
                                {
                                    "Text": "JETPUR",
                                    "Value": "JETPUR"
                                },
                                {
                                    "Text": "JEWAR",
                                    "Value": "JEWAR"
                                },
                                {
                                    "Text": "JEYPORE",
                                    "Value": "JEYPORE"
                                },
                                {
                                    "Text": "JAFFRABAD (DELHI)",
                                    "Value": "JAFFRABAD (DELHI)"
                                },
                                {
                                    "Text": "JHABUA",
                                    "Value": "JHABUA"
                                },
                                {
                                    "Text": "JHAJHA",
                                    "Value": "JHAJHA"
                                },
                                {
                                    "Text": "JHAJJAR",
                                    "Value": "JHAJJAR"
                                },
                                {
                                    "Text": "JHALRAPATAN",
                                    "Value": "JHALRAPATAN"
                                },
                                {
                                    "Text": "JHALAWAR",
                                    "Value": "JHALAWAR"
                                },
                                {
                                    "Text": "JHANSI",
                                    "Value": "JHANSI"
                                },
                                {
                                    "Text": "JHANJHARPUR",
                                    "Value": "JHANJHARPUR"
                                },
                                {
                                    "Text": "JHANJHERI",
                                    "Value": "JHANJHERI"
                                },
                                {
                                    "Text": "JHARIA",
                                    "Value": "JHARIA"
                                },
                                {
                                    "Text": "JHARSUGUDA",
                                    "Value": "JHARSUGUDA"
                                },
                                {
                                    "Text": "JHARODA MAJRA BURARI",
                                    "Value": "JHARODA MAJRA BURARI"
                                },
                                {
                                    "Text": "JHUJHUNU",
                                    "Value": "JHUJHUNU"
                                },
                                {
                                    "Text": "JHUMRI TELAIYA",
                                    "Value": "JHUMRI TELAIYA"
                                },
                                {
                                    "Text": "JHUMILA",
                                    "Value": "JHUMILA"
                                },
                                {
                                    "Text": "JHUMRI TILAIYA",
                                    "Value": "JHUMRI TILAIYA"
                                },
                                {
                                    "Text": "JHUNJHUNU",
                                    "Value": "JHUNJHUNU"
                                },
                                {
                                    "Text": "JIB",
                                    "Value": "JIB"
                                },
                                {
                                    "Text": "JIGANI",
                                    "Value": "JIGANI"
                                },
                                {
                                    "Text": "JIND",
                                    "Value": "JIND"
                                },
                                {
                                    "Text": "JITWARPUR",
                                    "Value": "JITWARPUR"
                                },
                                {
                                    "Text": "JIWAI KADIM ",
                                    "Value": "JIWAI KADIM "
                                },
                                {
                                    "Text": "JANAKPURI",
                                    "Value": "JANAKPURI"
                                },
                                {
                                    "Text": "JONA PUR",
                                    "Value": "JONA PUR"
                                },
                                {
                                    "Text": "JODA",
                                    "Value": "JODA"
                                },
                                {
                                    "Text": "JODHAN",
                                    "Value": "JODHAN"
                                },
                                {
                                    "Text": "JODHPUR",
                                    "Value": "JODHPUR"
                                },
                                {
                                    "Text": "JOGINAKA",
                                    "Value": "JOGINAKA"
                                },
                                {
                                    "Text": "JOGINAKA",
                                    "Value": "JOGINAKA"
                                },
                                {
                                    "Text": "JOGINDARNAGAR",
                                    "Value": "JOGINDARNAGAR"
                                },
                                {
                                    "Text": "JOGIPET",
                                    "Value": "JOGIPET"
                                },
                                {
                                    "Text": "JOHAL RAJU SINGH ",
                                    "Value": "JOHAL RAJU SINGH "
                                },
                                {
                                    "Text": "JOLARPET",
                                    "Value": "JOLARPET"
                                },
                                {
                                    "Text": "JOLVA ",
                                    "Value": "JOLVA "
                                },
                                {
                                    "Text": "JONNAVARIGUDEM ",
                                    "Value": "JONNAVARIGUDEM "
                                },
                                {
                                    "Text": "JORETHANG",
                                    "Value": "JORETHANG"
                                },
                                {
                                    "Text": "JORHAT",
                                    "Value": "JORHAT"
                                },
                                {
                                    "Text": "JOWAI",
                                    "Value": "JOWAI"
                                },
                                {
                                    "Text": "JOYA",
                                    "Value": "JOYA"
                                },
                                {
                                    "Text": "J P AGRAHARAM ",
                                    "Value": "J P AGRAHARAM "
                                },
                                {
                                    "Text": "J.P.NAGAR ",
                                    "Value": "J.P.NAGAR "
                                },
                                {
                                    "Text": "JAITARAN",
                                    "Value": "JAITARAN"
                                },
                                {
                                    "Text": "JUGIAL",
                                    "Value": "JUGIAL"
                                },
                                {
                                    "Text": "JUGSALAI",
                                    "Value": "JUGSALAI"
                                },
                                {
                                    "Text": "JUI",
                                    "Value": "JUI"
                                },
                                {
                                    "Text": "JUJOMURA",
                                    "Value": "JUJOMURA"
                                },
                                {
                                    "Text": "JULLANA",
                                    "Value": "JULLANA"
                                },
                                {
                                    "Text": "JUNAGADH",
                                    "Value": "JUNAGADH"
                                },
                                {
                                    "Text": "JUNDLA",
                                    "Value": "JUNDLA"
                                },
                                {
                                    "Text": "JUNNAR",
                                    "Value": "JUNNAR"
                                },
                                {
                                    "Text": "JAWALAMUKHI",
                                    "Value": "JAWALAMUKHI"
                                },
                                {
                                    "Text": "JIWAN PUR",
                                    "Value": "JIWAN PUR"
                                },
                                {
                                    "Text": "JYOTIBA PHULE NAGAR",
                                    "Value": "JYOTIBA PHULE NAGAR"
                                },
                                {
                                    "Text": "K.V.RANGAREDDY",
                                    "Value": "K.V.RANGAREDDY"
                                },
                                {
                                    "Text": "KACHCHH",
                                    "Value": "KACHCHH"
                                },
                                {
                                    "Text": "KACHIGAM",
                                    "Value": "KACHIGAM"
                                },
                                {
                                    "Text": "KADAPA",
                                    "Value": "KADAPA"
                                },
                                {
                                    "Text": "KADAMGIRI",
                                    "Value": "KADAMGIRI"
                                },
                                {
                                    "Text": "KADADHE",
                                    "Value": "KADADHE"
                                },
                                {
                                    "Text": "KADARPUR",
                                    "Value": "KADARPUR"
                                },
                                {
                                    "Text": "KADAYANALLUR",
                                    "Value": "KADAYANALLUR"
                                },
                                {
                                    "Text": "KADCHERLA ",
                                    "Value": "KADCHERLA "
                                },
                                {
                                    "Text": "KADGILL ",
                                    "Value": "KADGILL "
                                },
                                {
                                    "Text": "KADI",
                                    "Value": "KADI"
                                },
                                {
                                    "Text": "KADIYAM",
                                    "Value": "KADIYAM"
                                },
                                {
                                    "Text": "KADIRI",
                                    "Value": "KADIRI"
                                },
                                {
                                    "Text": "KADODARA",
                                    "Value": "KADODARA"
                                },
                                {
                                    "Text": "KAGAL",
                                    "Value": "KAGAL"
                                },
                                {
                                    "Text": "KAHALGAON",
                                    "Value": "KAHALGAON"
                                },
                                {
                                    "Text": "KAHALGAON",
                                    "Value": "KAHALGAON"
                                },
                                {
                                    "Text": "KAHNUWAN",
                                    "Value": "KAHNUWAN"
                                },
                                {
                                    "Text": "KAILASH",
                                    "Value": "KAILASH"
                                },
                                {
                                    "Text": "KAIMUR (BHABUA)",
                                    "Value": "KAIMUR (BHABUA)"
                                },
                                {
                                    "Text": "KAIMLA",
                                    "Value": "KAIMLA"
                                },
                                {
                                    "Text": "KAIRON",
                                    "Value": "KAIRON"
                                },
                                {
                                    "Text": "KAISERGANJ",
                                    "Value": "KAISERGANJ"
                                },
                                {
                                    "Text": "KAITHAL",
                                    "Value": "KAITHAL"
                                },
                                {
                                    "Text": "KAIYAL",
                                    "Value": "KAIYAL"
                                },
                                {
                                    "Text": "KAJARIA ",
                                    "Value": "KAJARIA "
                                },
                                {
                                    "Text": "KAKADEV",
                                    "Value": "KAKADEV"
                                },
                                {
                                    "Text": "KAKCHING",
                                    "Value": "KAKCHING"
                                },
                                {
                                    "Text": "KAKINADA",
                                    "Value": "KAKINADA"
                                },
                                {
                                    "Text": "KAKKANAD",
                                    "Value": "KAKKANAD"
                                },
                                {
                                    "Text": "KAKOD",
                                    "Value": "KAKOD"
                                },
                                {
                                    "Text": "KAKODA",
                                    "Value": "KAKODA"
                                },
                                {
                                    "Text": "KALASA",
                                    "Value": "KALASA"
                                },
                                {
                                    "Text": "KALAWALI",
                                    "Value": "KALAWALI"
                                },
                                {
                                    "Text": "KALAHANDI",
                                    "Value": "KALAHANDI"
                                },
                                {
                                    "Text": "KALA AFGANA",
                                    "Value": "KALA AFGANA"
                                },
                                {
                                    "Text": "KALA AMB",
                                    "Value": "KALA AMB"
                                },
                                {
                                    "Text": "KALAUR",
                                    "Value": "KALAUR"
                                },
                                {
                                    "Text": "KALAVAD",
                                    "Value": "KALAVAD"
                                },
                                {
                                    "Text": "KALAVAR",
                                    "Value": "KALAVAR"
                                },
                                {
                                    "Text": "KALAYAT",
                                    "Value": "KALAYAT"
                                },
                                {
                                    "Text": "KALA BAKRA",
                                    "Value": "KALA BAKRA"
                                },
                                {
                                    "Text": "KALA SANGIAN",
                                    "Value": "KALA SANGIAN"
                                },
                                {
                                    "Text": "KALADY",
                                    "Value": "KALADY"
                                },
                                {
                                    "Text": "KALAMBI",
                                    "Value": "KALAMBI"
                                },
                                {
                                    "Text": "KALAMBOLI",
                                    "Value": "KALAMBOLI"
                                },
                                {
                                    "Text": "KALAMWADI",
                                    "Value": "KALAMWADI"
                                },
                                {
                                    "Text": "KALANAUR",
                                    "Value": "KALANAUR"
                                },
                                {
                                    "Text": "KALANWALI",
                                    "Value": "KALANWALI"
                                },
                                {
                                    "Text": "KALIAGANJ",
                                    "Value": "KALIAGANJ"
                                },
                                {
                                    "Text": "KALIGOTE",
                                    "Value": "KALIGOTE"
                                },
                                {
                                    "Text": "KALIMPONG",
                                    "Value": "KALIMPONG"
                                },
                                {
                                    "Text": "KALKA",
                                    "Value": "KALKA"
                                },
                                {
                                    "Text": "KALLAKURICHI",
                                    "Value": "KALLAKURICHI"
                                },
                                {
                                    "Text": "KALLAKKURICHI",
                                    "Value": "KALLAKKURICHI"
                                },
                                {
                                    "Text": "KALLUTHOTTI JUNCTION",
                                    "Value": "KALLUTHOTTI JUNCTION"
                                },
                                {
                                    "Text": "KALMESHWAR",
                                    "Value": "KALMESHWAR"
                                },
                                {
                                    "Text": "KALNA",
                                    "Value": "KALNA"
                                },
                                {
                                    "Text": "KALOL",
                                    "Value": "KALOL"
                                },
                                {
                                    "Text": "KALOOR",
                                    "Value": "KALOOR"
                                },
                                {
                                    "Text": "KALPETTA",
                                    "Value": "KALPETTA"
                                },
                                {
                                    "Text": "KALWAKURTHY",
                                    "Value": "KALWAKURTHY"
                                },
                                {
                                    "Text": "KALWAN BK",
                                    "Value": "KALWAN BK"
                                },
                                {
                                    "Text": "KALYANI",
                                    "Value": "KALYANI"
                                },
                                {
                                    "Text": "KALYAN EAST THANE",
                                    "Value": "KALYAN EAST THANE"
                                },
                                {
                                    "Text": "KALYAN",
                                    "Value": "KALYAN"
                                },
                                {
                                    "Text": "KALYAN - DOMBIVLI",
                                    "Value": "KALYAN - DOMBIVLI"
                                },
                                {
                                    "Text": "KALYANDURG",
                                    "Value": "KALYANDURG"
                                },
                                {
                                    "Text": "KAMALI",
                                    "Value": "KAMALI"
                                },
                                {
                                    "Text": "KAMAREDDY",
                                    "Value": "KAMAREDDY"
                                },
                                {
                                    "Text": "KAMBALAPALLI ",
                                    "Value": "KAMBALAPALLI "
                                },
                                {
                                    "Text": "KAMBAM",
                                    "Value": "KAMBAM"
                                },
                                {
                                    "Text": "KAMBIL",
                                    "Value": "KAMBIL"
                                },
                                {
                                    "Text": "KAMMIANA ",
                                    "Value": "KAMMIANA "
                                },
                                {
                                    "Text": "KAMOTHE",
                                    "Value": "KAMOTHE"
                                },
                                {
                                    "Text": "KAMPTEE",
                                    "Value": "KAMPTEE"
                                },
                                {
                                    "Text": "KAMPUR",
                                    "Value": "KAMPUR"
                                },
                                {
                                    "Text": "KAMRUP",
                                    "Value": "KAMRUP"
                                },
                                {
                                    "Text": "KAMREJ",
                                    "Value": "KAMREJ"
                                },
                                {
                                    "Text": "KAMSHET",
                                    "Value": "KAMSHET"
                                },
                                {
                                    "Text": "KANAKAPURA",
                                    "Value": "KANAKAPURA"
                                },
                                {
                                    "Text": "KANCHIPURAM",
                                    "Value": "KANCHIPURAM"
                                },
                                {
                                    "Text": "KANCHAPADA",
                                    "Value": "KANCHAPADA"
                                },
                                {
                                    "Text": "KANCHRAPARA",
                                    "Value": "KANCHRAPARA"
                                },
                                {
                                    "Text": "KANDHAMAL",
                                    "Value": "KANDHAMAL"
                                },
                                {
                                    "Text": "KANDLA",
                                    "Value": "KANDLA"
                                },
                                {
                                    "Text": "KANDUKURU",
                                    "Value": "KANDUKURU"
                                },
                                {
                                    "Text": "KANGAYAM",
                                    "Value": "KANGAYAM"
                                },
                                {
                                    "Text": "KANGRA",
                                    "Value": "KANGRA"
                                },
                                {
                                    "Text": "KANGAN",
                                    "Value": "KANGAN"
                                },
                                {
                                    "Text": "KANGAN",
                                    "Value": "KANGAN"
                                },
                                {
                                    "Text": "KANGEYAM",
                                    "Value": "KANGEYAM"
                                },
                                {
                                    "Text": "KANHANGAD",
                                    "Value": "KANHANGAD"
                                },
                                {
                                    "Text": "KANINA",
                                    "Value": "KANINA"
                                },
                                {
                                    "Text": "KANJIRAPALLY",
                                    "Value": "KANJIRAPALLY"
                                },
                                {
                                    "Text": "KANKAVLI",
                                    "Value": "KANKAVLI"
                                },
                                {
                                    "Text": "KANKROLI",
                                    "Value": "KANKROLI"
                                },
                                {
                                    "Text": "KANKER",
                                    "Value": "KANKER"
                                },
                                {
                                    "Text": "KANKABATI",
                                    "Value": "KANKABATI"
                                },
                                {
                                    "Text": "KANKAWLI",
                                    "Value": "KANKAWLI"
                                },
                                {
                                    "Text": "KANNUR",
                                    "Value": "KANNUR"
                                },
                                {
                                    "Text": "KANNAUJ",
                                    "Value": "KANNAUJ"
                                },
                                {
                                    "Text": "KANNAD",
                                    "Value": "KANNAD"
                                },
                                {
                                    "Text": "KANPUR",
                                    "Value": "KANPUR"
                                },
                                {
                                    "Text": "KANPUR DEHAT",
                                    "Value": "KANPUR DEHAT"
                                },
                                {
                                    "Text": "KANPUR NAGAR",
                                    "Value": "KANPUR NAGAR"
                                },
                                {
                                    "Text": "KANTABANJI",
                                    "Value": "KANTABANJI"
                                },
                                {
                                    "Text": "KANUGULAVALASA ",
                                    "Value": "KANUGULAVALASA "
                                },
                                {
                                    "Text": "KANWARSIKA",
                                    "Value": "KANWARSIKA"
                                },
                                {
                                    "Text": "KANYAKUMARI",
                                    "Value": "KANYAKUMARI"
                                },
                                {
                                    "Text": "KAPADVANJ",
                                    "Value": "KAPADVANJ"
                                },
                                {
                                    "Text": "KAPASAN",
                                    "Value": "KAPASAN"
                                },
                                {
                                    "Text": "KAPRA",
                                    "Value": "KAPRA"
                                },
                                {
                                    "Text": "KAPTANGANJ",
                                    "Value": "KAPTANGANJ"
                                },
                                {
                                    "Text": "KAPURTHALA",
                                    "Value": "KAPURTHALA"
                                },
                                {
                                    "Text": "KARAD",
                                    "Value": "KARAD"
                                },
                                {
                                    "Text": "KARAIKAL",
                                    "Value": "KARAIKAL"
                                },
                                {
                                    "Text": "KARAULI",
                                    "Value": "KARAULI"
                                },
                                {
                                    "Text": "KARANJIA",
                                    "Value": "KARANJIA"
                                },
                                {
                                    "Text": "KARAIKUDI",
                                    "Value": "KARAIKUDI"
                                },
                                {
                                    "Text": "KARAHALLI ",
                                    "Value": "KARAHALLI "
                                },
                                {
                                    "Text": "KARAKULAM",
                                    "Value": "KARAKULAM"
                                },
                                {
                                    "Text": "KARAGOUNDEN PALAYAM",
                                    "Value": "KARAGOUNDEN PALAYAM"
                                },
                                {
                                    "Text": "KARANJA",
                                    "Value": "KARANJA"
                                },
                                {
                                    "Text": "KARAPAKKAM",
                                    "Value": "KARAPAKKAM"
                                },
                                {
                                    "Text": "KARBI ANGLONG",
                                    "Value": "KARBI ANGLONG"
                                },
                                {
                                    "Text": "KARDI",
                                    "Value": "KARDI"
                                },
                                {
                                    "Text": "KAREGAON",
                                    "Value": "KAREGAON"
                                },
                                {
                                    "Text": "KARGIL",
                                    "Value": "KARGIL"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KARIM NAGAR",
                                    "Value": "KARIM NAGAR"
                                },
                                {
                                    "Text": "KARIMGANJ",
                                    "Value": "KARIMGANJ"
                                },
                                {
                                    "Text": "KARIVALI",
                                    "Value": "KARIVALI"
                                },
                                {
                                    "Text": "KARIMNAGAR",
                                    "Value": "KARIMNAGAR"
                                },
                                {
                                    "Text": "KARIYALUR ",
                                    "Value": "KARIYALUR "
                                },
                                {
                                    "Text": "KARJAN",
                                    "Value": "KARJAN"
                                },
                                {
                                    "Text": "KARJAT",
                                    "Value": "KARJAT"
                                },
                                {
                                    "Text": "KARKALA",
                                    "Value": "KARKALA"
                                },
                                {
                                    "Text": "KARKAL",
                                    "Value": "KARKAL"
                                },
                                {
                                    "Text": "KARMAD ",
                                    "Value": "KARMAD "
                                },
                                {
                                    "Text": "KARNAL",
                                    "Value": "KARNAL"
                                },
                                {
                                    "Text": "KARTARPUR",
                                    "Value": "KARTARPUR"
                                },
                                {
                                    "Text": "KARUNAGAPALLY",
                                    "Value": "KARUNAGAPALLY"
                                },
                                {
                                    "Text": "KARUR",
                                    "Value": "KARUR"
                                },
                                {
                                    "Text": "KARUVANNUR",
                                    "Value": "KARUVANNUR"
                                },
                                {
                                    "Text": "KARWAR",
                                    "Value": "KARWAR"
                                },
                                {
                                    "Text": "KARWI MAFI",
                                    "Value": "KARWI MAFI"
                                },
                                {
                                    "Text": "KASARAGOD",
                                    "Value": "KASARAGOD"
                                },
                                {
                                    "Text": "KASARGOD",
                                    "Value": "KASARGOD"
                                },
                                {
                                    "Text": "KASARA",
                                    "Value": "KASARA"
                                },
                                {
                                    "Text": "KASARGATTA ",
                                    "Value": "KASARGATTA "
                                },
                                {
                                    "Text": "KASARAMBOLI",
                                    "Value": "KASARAMBOLI"
                                },
                                {
                                    "Text": "KASBA",
                                    "Value": "KASBA"
                                },
                                {
                                    "Text": "KASGANJ",
                                    "Value": "KASGANJ"
                                },
                                {
                                    "Text": "KASHIPUR",
                                    "Value": "KASHIPUR"
                                },
                                {
                                    "Text": "KASIBUGGA",
                                    "Value": "KASIBUGGA"
                                },
                                {
                                    "Text": "KASIMIVALASA ",
                                    "Value": "KASIMIVALASA "
                                },
                                {
                                    "Text": "KASIA",
                                    "Value": "KASIA"
                                },
                                {
                                    "Text": "KASHMIR",
                                    "Value": "KASHMIR"
                                },
                                {
                                    "Text": "KATAI",
                                    "Value": "KATAI"
                                },
                                {
                                    "Text": "KATCH",
                                    "Value": "KATCH"
                                },
                                {
                                    "Text": "KATGAON",
                                    "Value": "KATGAON"
                                },
                                {
                                    "Text": "KATHUA",
                                    "Value": "KATHUA"
                                },
                                {
                                    "Text": "KATHGARH",
                                    "Value": "KATHGARH"
                                },
                                {
                                    "Text": "KATHLAL",
                                    "Value": "KATHLAL"
                                },
                                {
                                    "Text": "KATIHAR",
                                    "Value": "KATIHAR"
                                },
                                {
                                    "Text": "KATLAHERI",
                                    "Value": "KATLAHERI"
                                },
                                {
                                    "Text": "KATNI",
                                    "Value": "KATNI"
                                },
                                {
                                    "Text": "KATOL",
                                    "Value": "KATOL"
                                },
                                {
                                    "Text": "KATRA",
                                    "Value": "KATRA"
                                },
                                {
                                    "Text": "KATRO",
                                    "Value": "KATRO"
                                },
                                {
                                    "Text": "KATTAPPANA",
                                    "Value": "KATTAPPANA"
                                },
                                {
                                    "Text": "KATTU",
                                    "Value": "KATTU"
                                },
                                {
                                    "Text": "KATWA",
                                    "Value": "KATWA"
                                },
                                {
                                    "Text": "KATWAD",
                                    "Value": "KATWAD"
                                },
                                {
                                    "Text": "KAUSHAMBI",
                                    "Value": "KAUSHAMBI"
                                },
                                {
                                    "Text": "KAVALI",
                                    "Value": "KAVALI"
                                },
                                {
                                    "Text": "KAVERIPATTINAM",
                                    "Value": "KAVERIPATTINAM"
                                },
                                {
                                    "Text": "KAWARDHA",
                                    "Value": "KAWARDHA"
                                },
                                {
                                    "Text": "KAYAMKULAM",
                                    "Value": "KAYAMKULAM"
                                },
                                {
                                    "Text": "KECHERY",
                                    "Value": "KECHERY"
                                },
                                {
                                    "Text": "KEDARKHEDA ",
                                    "Value": "KEDARKHEDA "
                                },
                                {
                                    "Text": "KEDARKHEDA",
                                    "Value": "KEDARKHEDA"
                                },
                                {
                                    "Text": "KEDMA ",
                                    "Value": "KEDMA "
                                },
                                {
                                    "Text": "KEELADI ",
                                    "Value": "KEELADI "
                                },
                                {
                                    "Text": "KEELAKARAI",
                                    "Value": "KEELAKARAI"
                                },
                                {
                                    "Text": "KEKRI",
                                    "Value": "KEKRI"
                                },
                                {
                                    "Text": "KELAMBAKKAM",
                                    "Value": "KELAMBAKKAM"
                                },
                                {
                                    "Text": "KELOMAL",
                                    "Value": "KELOMAL"
                                },
                                {
                                    "Text": "KELZAR ",
                                    "Value": "KELZAR "
                                },
                                {
                                    "Text": "KENDRAPARA",
                                    "Value": "KENDRAPARA"
                                },
                                {
                                    "Text": "KENDUJHAR",
                                    "Value": "KENDUJHAR"
                                },
                                {
                                    "Text": "KENGARI",
                                    "Value": "KENGARI"
                                },
                                {
                                    "Text": "KENGERI SATTELITE TOWN",
                                    "Value": "KENGERI SATTELITE TOWN"
                                },
                                {
                                    "Text": "KENJAKURA",
                                    "Value": "KENJAKURA"
                                },
                                {
                                    "Text": "KEONJHAR",
                                    "Value": "KEONJHAR"
                                },
                                {
                                    "Text": "KEORAR ",
                                    "Value": "KEORAR "
                                },
                                {
                                    "Text": "KERANGA",
                                    "Value": "KERANGA"
                                },
                                {
                                    "Text": "KESARPURA",
                                    "Value": "KESARPURA"
                                },
                                {
                                    "Text": "KESHOD",
                                    "Value": "KESHOD"
                                },
                                {
                                    "Text": "KESHAVAPURAM ",
                                    "Value": "KESHAVAPURAM "
                                },
                                {
                                    "Text": "KESHPUR",
                                    "Value": "KESHPUR"
                                },
                                {
                                    "Text": "KESHRISINGHPUR",
                                    "Value": "KESHRISINGHPUR"
                                },
                                {
                                    "Text": "KESINGA",
                                    "Value": "KESINGA"
                                },
                                {
                                    "Text": "KESORI",
                                    "Value": "KESORI"
                                },
                                {
                                    "Text": "KEWALA KALA ",
                                    "Value": "KEWALA KALA "
                                },
                                {
                                    "Text": "KEWALPUR",
                                    "Value": "KEWALPUR"
                                },
                                {
                                    "Text": "KEYSANPALLI ",
                                    "Value": "KEYSANPALLI "
                                },
                                {
                                    "Text": "KHABEDOGRAN ",
                                    "Value": "KHABEDOGRAN "
                                },
                                {
                                    "Text": "KHADAULI ",
                                    "Value": "KHADAULI "
                                },
                                {
                                    "Text": "KHADANI",
                                    "Value": "KHADANI"
                                },
                                {
                                    "Text": "KHADAUR SAHIB",
                                    "Value": "KHADAUR SAHIB"
                                },
                                {
                                    "Text": "KHADIAL",
                                    "Value": "KHADIAL"
                                },
                                {
                                    "Text": "KHADOL",
                                    "Value": "KHADOL"
                                },
                                {
                                    "Text": "KHADSUPA",
                                    "Value": "KHADSUPA"
                                },
                                {
                                    "Text": "KHAGARIA",
                                    "Value": "KHAGARIA"
                                },
                                {
                                    "Text": "KHAIRTHAL",
                                    "Value": "KHAIRTHAL"
                                },
                                {
                                    "Text": "KHAIRA MAJHA ",
                                    "Value": "KHAIRA MAJHA "
                                },
                                {
                                    "Text": "KHAILAR",
                                    "Value": "KHAILAR"
                                },
                                {
                                    "Text": "KHAIR",
                                    "Value": "KHAIR"
                                },
                                {
                                    "Text": "KHAIRAGARH",
                                    "Value": "KHAIRAGARH"
                                },
                                {
                                    "Text": "KHAIRAHNIYA BEERPUR",
                                    "Value": "KHAIRAHNIYA BEERPUR"
                                },
                                {
                                    "Text": "KHAIRAV",
                                    "Value": "KHAIRAV"
                                },
                                {
                                    "Text": "KHAIRTAL",
                                    "Value": "KHAIRTAL"
                                },
                                {
                                    "Text": "KHAJURI",
                                    "Value": "KHAJURI"
                                },
                                {
                                    "Text": "KHALCHIAN",
                                    "Value": "KHALCHIAN"
                                },
                                {
                                    "Text": "KHALILABAD",
                                    "Value": "KHALILABAD"
                                },
                                {
                                    "Text": "KHALRA",
                                    "Value": "KHALRA"
                                },
                                {
                                    "Text": "KHALUMBRE",
                                    "Value": "KHALUMBRE"
                                },
                                {
                                    "Text": "KHAMGAON",
                                    "Value": "KHAMGAON"
                                },
                                {
                                    "Text": "KHAMBHAT",
                                    "Value": "KHAMBHAT"
                                },
                                {
                                    "Text": "KHAMMAM",
                                    "Value": "KHAMMAM"
                                },
                                {
                                    "Text": "KHAMANO",
                                    "Value": "KHAMANO"
                                },
                                {
                                    "Text": "KHAMHARIYA ",
                                    "Value": "KHAMHARIYA "
                                },
                                {
                                    "Text": "KHAMGAON ",
                                    "Value": "KHAMGAON "
                                },
                                {
                                    "Text": "KHAMARIA ",
                                    "Value": "KHAMARIA "
                                },
                                {
                                    "Text": "KHAMANON",
                                    "Value": "KHAMANON"
                                },
                                {
                                    "Text": "KHAMBHALIA",
                                    "Value": "KHAMBHALIA"
                                },
                                {
                                    "Text": "KHAMLA",
                                    "Value": "KHAMLA"
                                },
                                {
                                    "Text": "KHANNA",
                                    "Value": "KHANNA"
                                },
                                {
                                    "Text": "KHANDWA",
                                    "Value": "KHANDWA"
                                },
                                {
                                    "Text": "KHANAPUR ",
                                    "Value": "KHANAPUR "
                                },
                                {
                                    "Text": "KHANOWAL ",
                                    "Value": "KHANOWAL "
                                },
                                {
                                    "Text": "KHANAPARA",
                                    "Value": "KHANAPARA"
                                },
                                {
                                    "Text": "KHANAURI",
                                    "Value": "KHANAURI"
                                },
                                {
                                    "Text": "KHANDAULI",
                                    "Value": "KHANDAULI"
                                },
                                {
                                    "Text": "KHANOOR",
                                    "Value": "KHANOOR"
                                },
                                {
                                    "Text": "KHANPUR",
                                    "Value": "KHANPUR"
                                },
                                {
                                    "Text": "KHARAGPUR",
                                    "Value": "KHARAGPUR"
                                },
                                {
                                    "Text": "KHARSIA",
                                    "Value": "KHARSIA"
                                },
                                {
                                    "Text": "KHARGONE",
                                    "Value": "KHARGONE"
                                },
                                {
                                    "Text": "KHARKHODA",
                                    "Value": "KHARKHODA"
                                },
                                {
                                    "Text": "KHARAR",
                                    "Value": "KHARAR"
                                },
                                {
                                    "Text": "KHARADAHA",
                                    "Value": "KHARADAHA"
                                },
                                {
                                    "Text": "KHARKODA",
                                    "Value": "KHARKODA"
                                },
                                {
                                    "Text": "KHARTULI",
                                    "Value": "KHARTULI"
                                },
                                {
                                    "Text": "KHATAULI",
                                    "Value": "KHATAULI"
                                },
                                {
                                    "Text": "KHATEGAON",
                                    "Value": "KHATEGAON"
                                },
                                {
                                    "Text": "KHATIVALI",
                                    "Value": "KHATIVALI"
                                },
                                {
                                    "Text": "KHED",
                                    "Value": "KHED"
                                },
                                {
                                    "Text": "KHEDA",
                                    "Value": "KHEDA"
                                },
                                {
                                    "Text": "KHEDBRAHMA",
                                    "Value": "KHEDBRAHMA"
                                },
                                {
                                    "Text": "KHEMKARAN",
                                    "Value": "KHEMKARAN"
                                },
                                {
                                    "Text": "KHERI",
                                    "Value": "KHERI"
                                },
                                {
                                    "Text": "KHERI",
                                    "Value": "KHERI"
                                },
                                {
                                    "Text": "KHERGAM",
                                    "Value": "KHERGAM"
                                },
                                {
                                    "Text": "KHERI NAUDH SINGH",
                                    "Value": "KHERI NAUDH SINGH"
                                },
                                {
                                    "Text": "KHIJRABAD",
                                    "Value": "KHIJRABAD"
                                },
                                {
                                    "Text": "KHAJOORI KHAS",
                                    "Value": "KHAJOORI KHAS"
                                },
                                {
                                    "Text": "KHLIEHRIAT",
                                    "Value": "KHLIEHRIAT"
                                },
                                {
                                    "Text": "KHOKHARIYA",
                                    "Value": "KHOKHARIYA"
                                },
                                {
                                    "Text": "KHONSA",
                                    "Value": "KHONSA"
                                },
                                {
                                    "Text": "KHONI, MAHARASHTRA",
                                    "Value": "KHONI, MAHARASHTRA"
                                },
                                {
                                    "Text": "KHOPOLI",
                                    "Value": "KHOPOLI"
                                },
                                {
                                    "Text": "KHORDA",
                                    "Value": "KHORDA"
                                },
                                {
                                    "Text": "KHORDHA",
                                    "Value": "KHORDHA"
                                },
                                {
                                    "Text": "KHORHANSA",
                                    "Value": "KHORHANSA"
                                },
                                {
                                    "Text": "KHOWAI",
                                    "Value": "KHOWAI"
                                },
                                {
                                    "Text": "KHAIRHA",
                                    "Value": "KHAIRHA"
                                },
                                {
                                    "Text": "KHARGHAR",
                                    "Value": "KHARGHAR"
                                },
                                {
                                    "Text": "KHERA KHURD",
                                    "Value": "KHERA KHURD"
                                },
                                {
                                    "Text": "KHUIAN SARWAR",
                                    "Value": "KHUIAN SARWAR"
                                },
                                {
                                    "Text": "KHUMBHEPHAL ",
                                    "Value": "KHUMBHEPHAL "
                                },
                                {
                                    "Text": "KHUNTI",
                                    "Value": "KHUNTI"
                                },
                                {
                                    "Text": "KHURJA",
                                    "Value": "KHURJA"
                                },
                                {
                                    "Text": "KHURAI",
                                    "Value": "KHURAI"
                                },
                                {
                                    "Text": "KHURDA",
                                    "Value": "KHURDA"
                                },
                                {
                                    "Text": "KHUTAR",
                                    "Value": "KHUTAR"
                                },
                                {
                                    "Text": "KHUTEHNA",
                                    "Value": "KHUTEHNA"
                                },
                                {
                                    "Text": "KILLE MACHINDRA GAD",
                                    "Value": "KILLE MACHINDRA GAD"
                                },
                                {
                                    "Text": "KILLON WALI",
                                    "Value": "KILLON WALI"
                                },
                                {
                                    "Text": "KIM",
                                    "Value": "KIM"
                                },
                                {
                                    "Text": "KINNAUR",
                                    "Value": "KINNAUR"
                                },
                                {
                                    "Text": "KINNIGOLI",
                                    "Value": "KINNIGOLI"
                                },
                                {
                                    "Text": "KIPHIRE",
                                    "Value": "KIPHIRE"
                                },
                                {
                                    "Text": "KIRAMCHA ",
                                    "Value": "KIRAMCHA "
                                },
                                {
                                    "Text": "KIRAOLI",
                                    "Value": "KIRAOLI"
                                },
                                {
                                    "Text": "KIRATPUR SAHIB",
                                    "Value": "KIRATPUR SAHIB"
                                },
                                {
                                    "Text": "KIRARI SULEMAN NAGAR",
                                    "Value": "KIRARI SULEMAN NAGAR"
                                },
                                {
                                    "Text": "KISHINGARH",
                                    "Value": "KISHINGARH"
                                },
                                {
                                    "Text": "KISHANGANJ",
                                    "Value": "KISHANGANJ"
                                },
                                {
                                    "Text": "KISHAN GARH",
                                    "Value": "KISHAN GARH"
                                },
                                {
                                    "Text": "KISHAN PURA",
                                    "Value": "KISHAN PURA"
                                },
                                {
                                    "Text": "KISHANGARH RENWAL",
                                    "Value": "KISHANGARH RENWAL"
                                },
                                {
                                    "Text": "KISHANGARH",
                                    "Value": "KISHANGARH"
                                },
                                {
                                    "Text": "KISHTWAR",
                                    "Value": "KISHTWAR"
                                },
                                {
                                    "Text": "KITHANA",
                                    "Value": "KITHANA"
                                },
                                {
                                    "Text": "KITUMULA ",
                                    "Value": "KITUMULA "
                                },
                                {
                                    "Text": "KANJHAWALA",
                                    "Value": "KANJHAWALA"
                                },
                                {
                                    "Text": "KAKCHING",
                                    "Value": "KAKCHING"
                                },
                                {
                                    "Text": "KANDIVALI",
                                    "Value": "KANDIVALI"
                                },
                                {
                                    "Text": "OLD KANKSA ROAD",
                                    "Value": "OLD KANKSA ROAD"
                                },
                                {
                                    "Text": "KOCHI",
                                    "Value": "KOCHI"
                                },
                                {
                                    "Text": "KODADA",
                                    "Value": "KODADA"
                                },
                                {
                                    "Text": "KODAGU",
                                    "Value": "KODAGU"
                                },
                                {
                                    "Text": "KODAIKANAL",
                                    "Value": "KODAIKANAL"
                                },
                                {
                                    "Text": "KODAD",
                                    "Value": "KODAD"
                                },
                                {
                                    "Text": "KODAKARA",
                                    "Value": "KODAKARA"
                                },
                                {
                                    "Text": "KODERMA",
                                    "Value": "KODERMA"
                                },
                                {
                                    "Text": "KODIGEHALLI ",
                                    "Value": "KODIGEHALLI "
                                },
                                {
                                    "Text": "KODIKURICHI",
                                    "Value": "KODIKURICHI"
                                },
                                {
                                    "Text": "KODINAR",
                                    "Value": "KODINAR"
                                },
                                {
                                    "Text": "KODUNGALLUR",
                                    "Value": "KODUNGALLUR"
                                },
                                {
                                    "Text": "KODUMATHI ",
                                    "Value": "KODUMATHI "
                                },
                                {
                                    "Text": "KODUR",
                                    "Value": "KODUR"
                                },
                                {
                                    "Text": "KODUVAYOOR",
                                    "Value": "KODUVAYOOR"
                                },
                                {
                                    "Text": "KOHALI",
                                    "Value": "KOHALI"
                                },
                                {
                                    "Text": "KOHARA",
                                    "Value": "KOHARA"
                                },
                                {
                                    "Text": "KOHIMA",
                                    "Value": "KOHIMA"
                                },
                                {
                                    "Text": "KOIRA ",
                                    "Value": "KOIRA "
                                },
                                {
                                    "Text": "KOIRA ",
                                    "Value": "KOIRA "
                                },
                                {
                                    "Text": "KOKRAJHAR",
                                    "Value": "KOKRAJHAR"
                                },
                                {
                                    "Text": "KOLAR",
                                    "Value": "KOLAR"
                                },
                                {
                                    "Text": "KOLASIB",
                                    "Value": "KOLASIB"
                                },
                                {
                                    "Text": "KOLAT",
                                    "Value": "KOLAT"
                                },
                                {
                                    "Text": "KOLENCHERY",
                                    "Value": "KOLENCHERY"
                                },
                                {
                                    "Text": "KOLHAPUR",
                                    "Value": "KOLHAPUR"
                                },
                                {
                                    "Text": "KOLKATA",
                                    "Value": "KOLKATA"
                                },
                                {
                                    "Text": "KOLLAM",
                                    "Value": "KOLLAM"
                                },
                                {
                                    "Text": "KOLLAPUR ",
                                    "Value": "KOLLAPUR "
                                },
                                {
                                    "Text": "KOLPAK ",
                                    "Value": "KOLPAK "
                                },
                                {
                                    "Text": "KOMARIPALEM",
                                    "Value": "KOMARIPALEM"
                                },
                                {
                                    "Text": "KOMMAGHATTA",
                                    "Value": "KOMMAGHATTA"
                                },
                                {
                                    "Text": "KOMPALLE",
                                    "Value": "KOMPALLE"
                                },
                                {
                                    "Text": "KON",
                                    "Value": "KON"
                                },
                                {
                                    "Text": "KONDA GOAN",
                                    "Value": "KONDA GOAN"
                                },
                                {
                                    "Text": "KONDLI",
                                    "Value": "KONDLI"
                                },
                                {
                                    "Text": "KONDA GOAN",
                                    "Value": "KONDA GOAN"
                                },
                                {
                                    "Text": "KONDAGATTU",
                                    "Value": "KONDAGATTU"
                                },
                                {
                                    "Text": "KONDAPUR",
                                    "Value": "KONDAPUR"
                                },
                                {
                                    "Text": "KONDOTTY",
                                    "Value": "KONDOTTY"
                                },
                                {
                                    "Text": "KONNAGAR",
                                    "Value": "KONNAGAR"
                                },
                                {
                                    "Text": "KONTHAGAI NORTH ",
                                    "Value": "KONTHAGAI NORTH "
                                },
                                {
                                    "Text": "KOOP ",
                                    "Value": "KOOP "
                                },
                                {
                                    "Text": "KOOTHATTUKULAM",
                                    "Value": "KOOTHATTUKULAM"
                                },
                                {
                                    "Text": "KOOTHANALLUR",
                                    "Value": "KOOTHANALLUR"
                                },
                                {
                                    "Text": "KOOTHUPARAMBA",
                                    "Value": "KOOTHUPARAMBA"
                                },
                                {
                                    "Text": "KOOVAPPADY",
                                    "Value": "KOOVAPPADY"
                                },
                                {
                                    "Text": "KOPERGAON",
                                    "Value": "KOPERGAON"
                                },
                                {
                                    "Text": "KOPPA",
                                    "Value": "KOPPA"
                                },
                                {
                                    "Text": "KOPPAL",
                                    "Value": "KOPPAL"
                                },
                                {
                                    "Text": "KOPRI",
                                    "Value": "KOPRI"
                                },
                                {
                                    "Text": "KORAPUT",
                                    "Value": "KORAPUT"
                                },
                                {
                                    "Text": "KORAG ",
                                    "Value": "KORAG "
                                },
                                {
                                    "Text": "KORATLA",
                                    "Value": "KORATLA"
                                },
                                {
                                    "Text": "KORATTUR",
                                    "Value": "KORATTUR"
                                },
                                {
                                    "Text": "KORATTY",
                                    "Value": "KORATTY"
                                },
                                {
                                    "Text": "KORBA",
                                    "Value": "KORBA"
                                },
                                {
                                    "Text": "KORBI ",
                                    "Value": "KORBI "
                                },
                                {
                                    "Text": "KOREGAON",
                                    "Value": "KOREGAON"
                                },
                                {
                                    "Text": "KORIYA",
                                    "Value": "KORIYA"
                                },
                                {
                                    "Text": "KORLAKOTA ",
                                    "Value": "KORLAKOTA "
                                },
                                {
                                    "Text": "KOSAMBA",
                                    "Value": "KOSAMBA"
                                },
                                {
                                    "Text": "KOSIKALAN",
                                    "Value": "KOSIKALAN"
                                },
                                {
                                    "Text": "KOSLI",
                                    "Value": "KOSLI"
                                },
                                {
                                    "Text": "KOT ISE KHAN",
                                    "Value": "KOT ISE KHAN"
                                },
                                {
                                    "Text": "KOTA",
                                    "Value": "KOTA"
                                },
                                {
                                    "Text": "KOT BUDHA",
                                    "Value": "KOT BUDHA"
                                },
                                {
                                    "Text": "KOTDWARA",
                                    "Value": "KOTDWARA"
                                },
                                {
                                    "Text": "KOTDWAR",
                                    "Value": "KOTDWAR"
                                },
                                {
                                    "Text": "KOTESHWAR",
                                    "Value": "KOTESHWAR"
                                },
                                {
                                    "Text": "KOTFATUHI",
                                    "Value": "KOTFATUHI"
                                },
                                {
                                    "Text": "KOTFATUHI",
                                    "Value": "KOTFATUHI"
                                },
                                {
                                    "Text": "KOTHAGUDEM",
                                    "Value": "KOTHAGUDEM"
                                },
                                {
                                    "Text": "KOTHAMANGALAM",
                                    "Value": "KOTHAMANGALAM"
                                },
                                {
                                    "Text": "KOTHAREDDIAL ",
                                    "Value": "KOTHAREDDIAL "
                                },
                                {
                                    "Text": "KOTHAGDI ",
                                    "Value": "KOTHAGDI "
                                },
                                {
                                    "Text": "KOTHURU ",
                                    "Value": "KOTHURU "
                                },
                                {
                                    "Text": "KOTHAPALLE",
                                    "Value": "KOTHAPALLE"
                                },
                                {
                                    "Text": "KOT ISA KHAN",
                                    "Value": "KOT ISA KHAN"
                                },
                                {
                                    "Text": "KOTKAPURA",
                                    "Value": "KOTKAPURA"
                                },
                                {
                                    "Text": "KOTKHAI",
                                    "Value": "KOTKHAI"
                                },
                                {
                                    "Text": "KOTLA ",
                                    "Value": "KOTLA "
                                },
                                {
                                    "Text": "KOTMA",
                                    "Value": "KOTMA"
                                },
                                {
                                    "Text": "KOTPUTLI",
                                    "Value": "KOTPUTLI"
                                },
                                {
                                    "Text": "KOTRA",
                                    "Value": "KOTRA"
                                },
                                {
                                    "Text": "KOTSHAMIR",
                                    "Value": "KOTSHAMIR"
                                },
                                {
                                    "Text": "KOTTARAKARA",
                                    "Value": "KOTTARAKARA"
                                },
                                {
                                    "Text": "KOTTAKKAL",
                                    "Value": "KOTTAKKAL"
                                },
                                {
                                    "Text": "KOTTAYAM",
                                    "Value": "KOTTAYAM"
                                },
                                {
                                    "Text": "KOTTAPUDUR ",
                                    "Value": "KOTTAPUDUR "
                                },
                                {
                                    "Text": "KOTTAKAL",
                                    "Value": "KOTTAKAL"
                                },
                                {
                                    "Text": "KOTTARAKKARA",
                                    "Value": "KOTTARAKKARA"
                                },
                                {
                                    "Text": "KOVILPATTI",
                                    "Value": "KOVILPATTI"
                                },
                                {
                                    "Text": "KOVUR",
                                    "Value": "KOVUR"
                                },
                                {
                                    "Text": "KOVVUR",
                                    "Value": "KOVVUR"
                                },
                                {
                                    "Text": "KOYALI",
                                    "Value": "KOYALI"
                                },
                                {
                                    "Text": "KOYILANDY",
                                    "Value": "KOYILANDY"
                                },
                                {
                                    "Text": "KOZHENCHERRY",
                                    "Value": "KOZHENCHERRY"
                                },
                                {
                                    "Text": "KOZHIKODE",
                                    "Value": "KOZHIKODE"
                                },
                                {
                                    "Text": "KOZHENCHERY",
                                    "Value": "KOZHENCHERY"
                                },
                                {
                                    "Text": "KOPAR KHAIRANE",
                                    "Value": "KOPAR KHAIRANE"
                                },
                                {
                                    "Text": "KAPAS HERA",
                                    "Value": "KAPAS HERA"
                                },
                                {
                                    "Text": "KRISHNAGAR",
                                    "Value": "KRISHNAGAR"
                                },
                                {
                                    "Text": "KRISHNA",
                                    "Value": "KRISHNA"
                                },
                                {
                                    "Text": "KRISHNAGIRI",
                                    "Value": "KRISHNAGIRI"
                                },
                                {
                                    "Text": "KRISHNAJIVADI ",
                                    "Value": "KRISHNAJIVADI "
                                },
                                {
                                    "Text": "KRISHNA BAZAR(NARSIPATNAM) ",
                                    "Value": "KRISHNA BAZAR(NARSIPATNAM) "
                                },
                                {
                                    "Text": "KARAIKAL",
                                    "Value": "KARAIKAL"
                                },
                                {
                                    "Text": "KARAMADAI",
                                    "Value": "KARAMADAI"
                                },
                                {
                                    "Text": "KARAWAL NAGAR",
                                    "Value": "KARAWAL NAGAR"
                                },
                                {
                                    "Text": "KATKAR",
                                    "Value": "KATKAR"
                                },
                                {
                                    "Text": "KHATIMA",
                                    "Value": "KHATIMA"
                                },
                                {
                                    "Text": "KUBA",
                                    "Value": "KUBA"
                                },
                                {
                                    "Text": "KUCHAMAN CITY",
                                    "Value": "KUCHAMAN CITY"
                                },
                                {
                                    "Text": "KUCHINDA",
                                    "Value": "KUCHINDA"
                                },
                                {
                                    "Text": "KUDAL",
                                    "Value": "KUDAL"
                                },
                                {
                                    "Text": "KUDAMALOOR",
                                    "Value": "KUDAMALOOR"
                                },
                                {
                                    "Text": "KUDI KHERA",
                                    "Value": "KUDI KHERA"
                                },
                                {
                                    "Text": "KUDU",
                                    "Value": "KUDU"
                                },
                                {
                                    "Text": "KUDUMULUGUMA",
                                    "Value": "KUDUMULUGUMA"
                                },
                                {
                                    "Text": "KUIANI ",
                                    "Value": "KUIANI "
                                },
                                {
                                    "Text": "KUJANG",
                                    "Value": "KUJANG"
                                },
                                {
                                    "Text": "KUKAR PIND",
                                    "Value": "KUKAR PIND"
                                },
                                {
                                    "Text": "KUKARWADA",
                                    "Value": "KUKARWADA"
                                },
                                {
                                    "Text": "KUKATPALLY",
                                    "Value": "KUKATPALLY"
                                },
                                {
                                    "Text": "KUKSHI",
                                    "Value": "KUKSHI"
                                },
                                {
                                    "Text": "KULATHUMUZHY",
                                    "Value": "KULATHUMUZHY"
                                },
                                {
                                    "Text": "KULGAM",
                                    "Value": "KULGAM"
                                },
                                {
                                    "Text": "KULITHALAI",
                                    "Value": "KULITHALAI"
                                },
                                {
                                    "Text": "KULLU",
                                    "Value": "KULLU"
                                },
                                {
                                    "Text": "KUMBAKONAM",
                                    "Value": "KUMBAKONAM"
                                },
                                {
                                    "Text": "KUM KALAN",
                                    "Value": "KUM KALAN"
                                },
                                {
                                    "Text": "KUMTA",
                                    "Value": "KUMTA"
                                },
                                {
                                    "Text": "KUNDA",
                                    "Value": "KUNDA"
                                },
                                {
                                    "Text": "KUNDAPURA",
                                    "Value": "KUNDAPURA"
                                },
                                {
                                    "Text": "KUNDAPUR",
                                    "Value": "KUNDAPUR"
                                },
                                {
                                    "Text": "KUNDLI",
                                    "Value": "KUNDLI"
                                },
                                {
                                    "Text": "KUNNAMKULAM",
                                    "Value": "KUNNAMKULAM"
                                },
                                {
                                    "Text": "KUPWARA",
                                    "Value": "KUPWARA"
                                },
                                {
                                    "Text": "KURADIHA",
                                    "Value": "KURADIHA"
                                },
                                {
                                    "Text": "KURALI",
                                    "Value": "KURALI"
                                },
                                {
                                    "Text": "KURICHITHANAM",
                                    "Value": "KURICHITHANAM"
                                },
                                {
                                    "Text": "KURMAPURAM ",
                                    "Value": "KURMAPURAM "
                                },
                                {
                                    "Text": "KURNOOL",
                                    "Value": "KURNOOL"
                                },
                                {
                                    "Text": "KURUKSHETRA",
                                    "Value": "KURUKSHETRA"
                                },
                                {
                                    "Text": "KURUNG KUMEY",
                                    "Value": "KURUNG KUMEY"
                                },
                                {
                                    "Text": "KURUD",
                                    "Value": "KURUD"
                                },
                                {
                                    "Text": "KUSARLAPUDI ",
                                    "Value": "KUSARLAPUDI "
                                },
                                {
                                    "Text": "KUSHINAGAR",
                                    "Value": "KUSHINAGAR"
                                },
                                {
                                    "Text": "KUTCHERY CHOWK",
                                    "Value": "KUTCHERY CHOWK"
                                },
                                {
                                    "Text": "KUTCH",
                                    "Value": "KUTCH"
                                },
                                {
                                    "Text": "KUTCHH",
                                    "Value": "KUTCHH"
                                },
                                {
                                    "Text": "KUWAIT",
                                    "Value": "KUWAIT"
                                },
                                {
                                    "Text": "K YELLAVARAM ",
                                    "Value": "K YELLAVARAM "
                                },
                                {
                                    "Text": "LACHAPET ",
                                    "Value": "LACHAPET "
                                },
                                {
                                    "Text": "LADSAWANGI ",
                                    "Value": "LADSAWANGI "
                                },
                                {
                                    "Text": "LADWA",
                                    "Value": "LADWA"
                                },
                                {
                                    "Text": "LAHUL & SPITI",
                                    "Value": "LAHUL & SPITI"
                                },
                                {
                                    "Text": "LAKHIMPUR",
                                    "Value": "LAKHIMPUR"
                                },
                                {
                                    "Text": "LAKHIMPUR",
                                    "Value": "LAKHIMPUR"
                                },
                                {
                                    "Text": "LAKHISARAI",
                                    "Value": "LAKHISARAI"
                                },
                                {
                                    "Text": "LAKHAN MAJRA",
                                    "Value": "LAKHAN MAJRA"
                                },
                                {
                                    "Text": "LAKSHADWEEP",
                                    "Value": "LAKSHADWEEP"
                                },
                                {
                                    "Text": "LALGANJ KATGHAR",
                                    "Value": "LALGANJ KATGHAR"
                                },
                                {
                                    "Text": "LALGUDI",
                                    "Value": "LALGUDI"
                                },
                                {
                                    "Text": "LALGANJ",
                                    "Value": "LALGANJ"
                                },
                                {
                                    "Text": "LALGANJ-KATGHAR",
                                    "Value": "LALGANJ-KATGHAR"
                                },
                                {
                                    "Text": "LALITPUR",
                                    "Value": "LALITPUR"
                                },
                                {
                                    "Text": "LAL KALAN",
                                    "Value": "LAL KALAN"
                                },
                                {
                                    "Text": "LALPUR",
                                    "Value": "LALPUR"
                                },
                                {
                                    "Text": "LALRU",
                                    "Value": "LALRU"
                                },
                                {
                                    "Text": "LALSOT",
                                    "Value": "LALSOT"
                                },
                                {
                                    "Text": "LAMBI",
                                    "Value": "LAMBI"
                                },
                                {
                                    "Text": "LAMBRA",
                                    "Value": "LAMBRA"
                                },
                                {
                                    "Text": "LAMMASINGI ",
                                    "Value": "LAMMASINGI "
                                },
                                {
                                    "Text": "LANDRAN",
                                    "Value": "LANDRAN"
                                },
                                {
                                    "Text": "LANDE KE ",
                                    "Value": "LANDE KE "
                                },
                                {
                                    "Text": "LANDRAN",
                                    "Value": "LANDRAN"
                                },
                                {
                                    "Text": "LAOJORA ",
                                    "Value": "LAOJORA "
                                },
                                {
                                    "Text": "LAPKAMAN",
                                    "Value": "LAPKAMAN"
                                },
                                {
                                    "Text": "LASALGAON",
                                    "Value": "LASALGAON"
                                },
                                {
                                    "Text": "LATEHAR",
                                    "Value": "LATEHAR"
                                },
                                {
                                    "Text": "LATUR",
                                    "Value": "LATUR"
                                },
                                {
                                    "Text": "LAWNGTLAI",
                                    "Value": "LAWNGTLAI"
                                },
                                {
                                    "Text": "LAXITTIPET",
                                    "Value": "LAXITTIPET"
                                },
                                {
                                    "Text": "LAXMIPUR ",
                                    "Value": "LAXMIPUR "
                                },
                                {
                                    "Text": "LAXMANGARH ",
                                    "Value": "LAXMANGARH "
                                },
                                {
                                    "Text": "LIBAS PUR",
                                    "Value": "LIBAS PUR"
                                },
                                {
                                    "Text": "LADNUN",
                                    "Value": "LADNUN"
                                },
                                {
                                    "Text": "LEH",
                                    "Value": "LEH"
                                },
                                {
                                    "Text": "LEHAL",
                                    "Value": "LEHAL"
                                },
                                {
                                    "Text": "LEHRAGAGA",
                                    "Value": "LEHRAGAGA"
                                },
                                {
                                    "Text": "LIMBDI",
                                    "Value": "LIMBDI"
                                },
                                {
                                    "Text": "LINGAPUR ",
                                    "Value": "LINGAPUR "
                                },
                                {
                                    "Text": "LAKHPAT",
                                    "Value": "LAKHPAT"
                                },
                                {
                                    "Text": "LAKHIMPUR KHERI",
                                    "Value": "LAKHIMPUR KHERI"
                                },
                                {
                                    "Text": "LLKAL",
                                    "Value": "LLKAL"
                                },
                                {
                                    "Text": "LOHARDAGA",
                                    "Value": "LOHARDAGA"
                                },
                                {
                                    "Text": "LOHA ",
                                    "Value": "LOHA "
                                },
                                {
                                    "Text": "LOHARDIH",
                                    "Value": "LOHARDIH"
                                },
                                {
                                    "Text": "LOHARKA",
                                    "Value": "LOHARKA"
                                },
                                {
                                    "Text": "LOHARSI",
                                    "Value": "LOHARSI"
                                },
                                {
                                    "Text": "LOHARU",
                                    "Value": "LOHARU"
                                },
                                {
                                    "Text": "LOHIAN KHAS",
                                    "Value": "LOHIAN KHAS"
                                },
                                {
                                    "Text": "LOHIT",
                                    "Value": "LOHIT"
                                },
                                {
                                    "Text": "LOHIAN KHAS",
                                    "Value": "LOHIAN KHAS"
                                },
                                {
                                    "Text": "LOHTA",
                                    "Value": "LOHTA"
                                },
                                {
                                    "Text": "LOISINGA",
                                    "Value": "LOISINGA"
                                },
                                {
                                    "Text": "LOKAMALESWARAM",
                                    "Value": "LOKAMALESWARAM"
                                },
                                {
                                    "Text": "LONAVALA",
                                    "Value": "LONAVALA"
                                },
                                {
                                    "Text": "LONAND",
                                    "Value": "LONAND"
                                },
                                {
                                    "Text": "LONGOWAL",
                                    "Value": "LONGOWAL"
                                },
                                {
                                    "Text": "LONGLENG",
                                    "Value": "LONGLENG"
                                },
                                {
                                    "Text": "LONGAON ",
                                    "Value": "LONGAON "
                                },
                                {
                                    "Text": "LONI",
                                    "Value": "LONI"
                                },
                                {
                                    "Text": "LONI",
                                    "Value": "LONI"
                                },
                                {
                                    "Text": "LOPOKE",
                                    "Value": "LOPOKE"
                                },
                                {
                                    "Text": "LOWER DIBANG VALLEY",
                                    "Value": "LOWER DIBANG VALLEY"
                                },
                                {
                                    "Text": "LOWER SUBANSIRI",
                                    "Value": "LOWER SUBANSIRI"
                                },
                                {
                                    "Text": "LUCKNOW",
                                    "Value": "LUCKNOW"
                                },
                                {
                                    "Text": "LUDHIANA",
                                    "Value": "LUDHIANA"
                                },
                                {
                                    "Text": "LUKHI",
                                    "Value": "LUKHI"
                                },
                                {
                                    "Text": "LUNAWADA",
                                    "Value": "LUNAWADA"
                                },
                                {
                                    "Text": "LUNGLEI",
                                    "Value": "LUNGLEI"
                                },
                                {
                                    "Text": "LAXMANGARH",
                                    "Value": "LAXMANGARH"
                                },
                                {
                                    "Text": "MACHALIPATNAM",
                                    "Value": "MACHALIPATNAM"
                                },
                                {
                                    "Text": "MACHHIWARA",
                                    "Value": "MACHHIWARA"
                                },
                                {
                                    "Text": "MACHAREDDY ",
                                    "Value": "MACHAREDDY "
                                },
                                {
                                    "Text": "MACHERLA ",
                                    "Value": "MACHERLA "
                                },
                                {
                                    "Text": "MACHERLA",
                                    "Value": "MACHERLA"
                                },
                                {
                                    "Text": "MACHILIPATNAM",
                                    "Value": "MACHILIPATNAM"
                                },
                                {
                                    "Text": "MADANAPALLI",
                                    "Value": "MADANAPALLI"
                                },
                                {
                                    "Text": "MADANAPALLI ",
                                    "Value": "MADANAPALLI "
                                },
                                {
                                    "Text": "MADAI ",
                                    "Value": "MADAI "
                                },
                                {
                                    "Text": "MADANPUR ",
                                    "Value": "MADANPUR "
                                },
                                {
                                    "Text": "MADAMBAKKAM",
                                    "Value": "MADAMBAKKAM"
                                },
                                {
                                    "Text": "MADANAPALLE",
                                    "Value": "MADANAPALLE"
                                },
                                {
                                    "Text": "MADHEPURA",
                                    "Value": "MADHEPURA"
                                },
                                {
                                    "Text": "MADHUBANI",
                                    "Value": "MADHUBANI"
                                },
                                {
                                    "Text": "MADHAPUR ",
                                    "Value": "MADHAPUR "
                                },
                                {
                                    "Text": "MADHAVPUR ",
                                    "Value": "MADHAVPUR "
                                },
                                {
                                    "Text": "MADHUR ",
                                    "Value": "MADHUR "
                                },
                                {
                                    "Text": "MADHAPAR",
                                    "Value": "MADHAPAR"
                                },
                                {
                                    "Text": "MADHI",
                                    "Value": "MADHI"
                                },
                                {
                                    "Text": "MADHOPUR",
                                    "Value": "MADHOPUR"
                                },
                                {
                                    "Text": "MADHUPUR",
                                    "Value": "MADHUPUR"
                                },
                                {
                                    "Text": "MADHYAMGRAM",
                                    "Value": "MADHYAMGRAM"
                                },
                                {
                                    "Text": "MADIKERI",
                                    "Value": "MADIKERI"
                                },
                                {
                                    "Text": "MADIPPAKKAM",
                                    "Value": "MADIPPAKKAM"
                                },
                                {
                                    "Text": "MADKERI",
                                    "Value": "MADKERI"
                                },
                                {
                                    "Text": "MADLAUDA",
                                    "Value": "MADLAUDA"
                                },
                                {
                                    "Text": "MADLODA",
                                    "Value": "MADLODA"
                                },
                                {
                                    "Text": "MADURAI",
                                    "Value": "MADURAI"
                                },
                                {
                                    "Text": "MAGAM",
                                    "Value": "MAGAM"
                                },
                                {
                                    "Text": "MAGDI ",
                                    "Value": "MAGDI "
                                },
                                {
                                    "Text": "MAHAD",
                                    "Value": "MAHAD"
                                },
                                {
                                    "Text": "MAHABUBNAGAR",
                                    "Value": "MAHABUBNAGAR"
                                },
                                {
                                    "Text": "MAHABUB NAGAR",
                                    "Value": "MAHABUB NAGAR"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHASAMUND",
                                    "Value": "MAHASAMUND"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHAMAYA NAGAR",
                                    "Value": "MAHAMAYA NAGAR"
                                },
                                {
                                    "Text": "MAHARAJGANJ",
                                    "Value": "MAHARAJGANJ"
                                },
                                {
                                    "Text": "MAHAGAI ",
                                    "Value": "MAHAGAI "
                                },
                                {
                                    "Text": "MAHABUBABAD",
                                    "Value": "MAHABUBABAD"
                                },
                                {
                                    "Text": "MAHAL KALAN",
                                    "Value": "MAHAL KALAN"
                                },
                                {
                                    "Text": "MAHAM",
                                    "Value": "MAHAM"
                                },
                                {
                                    "Text": "MAHAMMADPUR",
                                    "Value": "MAHAMMADPUR"
                                },
                                {
                                    "Text": "MAHATPUR",
                                    "Value": "MAHATPUR"
                                },
                                {
                                    "Text": "MAHE",
                                    "Value": "MAHE"
                                },
                                {
                                    "Text": "MAHE",
                                    "Value": "MAHE"
                                },
                                {
                                    "Text": "MAHENDRAGARH",
                                    "Value": "MAHENDRAGARH"
                                },
                                {
                                    "Text": "MAHESANA",
                                    "Value": "MAHESANA"
                                },
                                {
                                    "Text": "MAHENDRAGANJ",
                                    "Value": "MAHENDRAGANJ"
                                },
                                {
                                    "Text": "MAHETPUR",
                                    "Value": "MAHETPUR"
                                },
                                {
                                    "Text": "MAHENDARGARH",
                                    "Value": "MAHENDARGARH"
                                },
                                {
                                    "Text": "MAHENDRANAGAR",
                                    "Value": "MAHENDRANAGAR"
                                },
                                {
                                    "Text": "MAHERU",
                                    "Value": "MAHERU"
                                },
                                {
                                    "Text": "MAHISAGAR",
                                    "Value": "MAHISAGAR"
                                },
                                {
                                    "Text": "MAHIDPUR",
                                    "Value": "MAHIDPUR"
                                },
                                {
                                    "Text": "MAHILPUR",
                                    "Value": "MAHILPUR"
                                },
                                {
                                    "Text": "MAHIYAWALI",
                                    "Value": "MAHIYAWALI"
                                },
                                {
                                    "Text": "MAHENDRAGANJ",
                                    "Value": "MAHENDRAGANJ"
                                },
                                {
                                    "Text": "MAHOBA",
                                    "Value": "MAHOBA"
                                },
                                {
                                    "Text": "MAHUVA",
                                    "Value": "MAHUVA"
                                },
                                {
                                    "Text": "MAIHAR",
                                    "Value": "MAIHAR"
                                },
                                {
                                    "Text": "MAINPURI",
                                    "Value": "MAINPURI"
                                },
                                {
                                    "Text": "MAIRANG",
                                    "Value": "MAIRANG"
                                },
                                {
                                    "Text": "MAISAMMAGUDEM ",
                                    "Value": "MAISAMMAGUDEM "
                                },
                                {
                                    "Text": "MAJALGAON",
                                    "Value": "MAJALGAON"
                                },
                                {
                                    "Text": "MAJARI",
                                    "Value": "MAJARI"
                                },
                                {
                                    "Text": "MAJITHA",
                                    "Value": "MAJITHA"
                                },
                                {
                                    "Text": "MAJORDA",
                                    "Value": "MAJORDA"
                                },
                                {
                                    "Text": "MAJRA",
                                    "Value": "MAJRA"
                                },
                                {
                                    "Text": "MAJRI",
                                    "Value": "MAJRI"
                                },
                                {
                                    "Text": "MAJWIND",
                                    "Value": "MAJWIND"
                                },
                                {
                                    "Text": "MAKHU",
                                    "Value": "MAKHU"
                                },
                                {
                                    "Text": "MAKRANA",
                                    "Value": "MAKRANA"
                                },
                                {
                                    "Text": "MALAPPURAM",
                                    "Value": "MALAPPURAM"
                                },
                                {
                                    "Text": "MALA",
                                    "Value": "MALA"
                                },
                                {
                                    "Text": "MALAKPUR",
                                    "Value": "MALAKPUR"
                                },
                                {
                                    "Text": "MALAPURAM",
                                    "Value": "MALAPURAM"
                                },
                                {
                                    "Text": "MALDA",
                                    "Value": "MALDA"
                                },
                                {
                                    "Text": "MALEGAON",
                                    "Value": "MALEGAON"
                                },
                                {
                                    "Text": "MALERKOTLA",
                                    "Value": "MALERKOTLA"
                                },
                                {
                                    "Text": "MALGAON",
                                    "Value": "MALGAON"
                                },
                                {
                                    "Text": "MALIYASAN",
                                    "Value": "MALIYASAN"
                                },
                                {
                                    "Text": "MALKAPUR",
                                    "Value": "MALKAPUR"
                                },
                                {
                                    "Text": "MALKANGIRI",
                                    "Value": "MALKANGIRI"
                                },
                                {
                                    "Text": "MALKHED",
                                    "Value": "MALKHED"
                                },
                                {
                                    "Text": "MALLIAL ",
                                    "Value": "MALLIAL "
                                },
                                {
                                    "Text": "MALLANWALA",
                                    "Value": "MALLANWALA"
                                },
                                {
                                    "Text": "MALLEKAN",
                                    "Value": "MALLEKAN"
                                },
                                {
                                    "Text": "MALOUT",
                                    "Value": "MALOUT"
                                },
                                {
                                    "Text": "MALOUD",
                                    "Value": "MALOUD"
                                },
                                {
                                    "Text": "MALPURA",
                                    "Value": "MALPURA"
                                },
                                {
                                    "Text": "MALRU",
                                    "Value": "MALRU"
                                },
                                {
                                    "Text": "MALSIAN",
                                    "Value": "MALSIAN"
                                },
                                {
                                    "Text": "MALUKA",
                                    "Value": "MALUKA"
                                },
                                {
                                    "Text": "MALUR",
                                    "Value": "MALUR"
                                },
                                {
                                    "Text": "MALVAN",
                                    "Value": "MALVAN"
                                },
                                {
                                    "Text": "MALWARDEVRAMPALLI ",
                                    "Value": "MALWARDEVRAMPALLI "
                                },
                                {
                                    "Text": "MAMDOT UTTAR",
                                    "Value": "MAMDOT UTTAR"
                                },
                                {
                                    "Text": "MAMIDIPALLI ",
                                    "Value": "MAMIDIPALLI "
                                },
                                {
                                    "Text": "MAMMIT",
                                    "Value": "MAMMIT"
                                },
                                {
                                    "Text": "MANANTHAVADY",
                                    "Value": "MANANTHAVADY"
                                },
                                {
                                    "Text": "MANALI",
                                    "Value": "MANALI"
                                },
                                {
                                    "Text": "MANAVADAR",
                                    "Value": "MANAVADAR"
                                },
                                {
                                    "Text": "MANAKKODY",
                                    "Value": "MANAKKODY"
                                },
                                {
                                    "Text": "MANAULI",
                                    "Value": "MANAULI"
                                },
                                {
                                    "Text": "MANAURI BAZAR",
                                    "Value": "MANAURI BAZAR"
                                },
                                {
                                    "Text": "MANAVADAR",
                                    "Value": "MANAVADAR"
                                },
                                {
                                    "Text": "MANAWALA",
                                    "Value": "MANAWALA"
                                },
                                {
                                    "Text": "MANCHERIAL",
                                    "Value": "MANCHERIAL"
                                },
                                {
                                    "Text": "MANKACHAR",
                                    "Value": "MANKACHAR"
                                },
                                {
                                    "Text": "MANDI",
                                    "Value": "MANDI"
                                },
                                {
                                    "Text": "MANDAPETA",
                                    "Value": "MANDAPETA"
                                },
                                {
                                    "Text": "MANDVI",
                                    "Value": "MANDVI"
                                },
                                {
                                    "Text": "MANDI DABWALI",
                                    "Value": "MANDI DABWALI"
                                },
                                {
                                    "Text": "MANDIDEEP",
                                    "Value": "MANDIDEEP"
                                },
                                {
                                    "Text": "MANDI GOBINDGARH",
                                    "Value": "MANDI GOBINDGARH"
                                },
                                {
                                    "Text": "MANDI",
                                    "Value": "MANDI"
                                },
                                {
                                    "Text": "MANDLA",
                                    "Value": "MANDLA"
                                },
                                {
                                    "Text": "MANDSAUR",
                                    "Value": "MANDSAUR"
                                },
                                {
                                    "Text": "MAND",
                                    "Value": "MAND"
                                },
                                {
                                    "Text": "MANDAI BUJURG",
                                    "Value": "MANDAI BUJURG"
                                },
                                {
                                    "Text": "MANDAI KHURD",
                                    "Value": "MANDAI KHURD"
                                },
                                {
                                    "Text": "MANENDRAGARH",
                                    "Value": "MANENDRAGARH"
                                },
                                {
                                    "Text": "MANEGAON ",
                                    "Value": "MANEGAON "
                                },
                                {
                                    "Text": "MANESAR",
                                    "Value": "MANESAR"
                                },
                                {
                                    "Text": "MANGALORE URBAN",
                                    "Value": "MANGALORE URBAN"
                                },
                                {
                                    "Text": "MANGALDOI",
                                    "Value": "MANGALDOI"
                                },
                                {
                                    "Text": "MANGALORE",
                                    "Value": "MANGALORE"
                                },
                                {
                                    "Text": "MANGROL",
                                    "Value": "MANGROL"
                                },
                                {
                                    "Text": "MANGALAGIRI",
                                    "Value": "MANGALAGIRI"
                                },
                                {
                                    "Text": "MANGALORE-URBAN",
                                    "Value": "MANGALORE-URBAN"
                                },
                                {
                                    "Text": "MANGAON",
                                    "Value": "MANGAON"
                                },
                                {
                                    "Text": "MANGARH",
                                    "Value": "MANGARH"
                                },
                                {
                                    "Text": "MANGLIA",
                                    "Value": "MANGLIA"
                                },
                                {
                                    "Text": "MANGROL",
                                    "Value": "MANGROL"
                                },
                                {
                                    "Text": "MANIPAL",
                                    "Value": "MANIPAL"
                                },
                                {
                                    "Text": "MANIGILLA ",
                                    "Value": "MANIGILLA "
                                },
                                {
                                    "Text": "MANIYAMPALAYAM ",
                                    "Value": "MANIYAMPALAYAM "
                                },
                                {
                                    "Text": "MANJERI",
                                    "Value": "MANJERI"
                                },
                                {
                                    "Text": "MANJALPUR",
                                    "Value": "MANJALPUR"
                                },
                                {
                                    "Text": "MANJARI",
                                    "Value": "MANJARI"
                                },
                                {
                                    "Text": "MANJUSAR",
                                    "Value": "MANJUSAR"
                                },
                                {
                                    "Text": "MANKACHAR",
                                    "Value": "MANKACHAR"
                                },
                                {
                                    "Text": "MANKARA ",
                                    "Value": "MANKARA "
                                },
                                {
                                    "Text": "MANKAPUR",
                                    "Value": "MANKAPUR"
                                },
                                {
                                    "Text": "MANKO",
                                    "Value": "MANKO"
                                },
                                {
                                    "Text": "MANMAD",
                                    "Value": "MANMAD"
                                },
                                {
                                    "Text": "MANNEGUDA ",
                                    "Value": "MANNEGUDA "
                                },
                                {
                                    "Text": "MANNARKKAD",
                                    "Value": "MANNARKKAD"
                                },
                                {
                                    "Text": "MANOR",
                                    "Value": "MANOR"
                                },
                                {
                                    "Text": "MANOCHAHAL ",
                                    "Value": "MANOCHAHAL "
                                },
                                {
                                    "Text": "MANPUR",
                                    "Value": "MANPUR"
                                },
                                {
                                    "Text": "MANSA",
                                    "Value": "MANSA"
                                },
                                {
                                    "Text": "MANSA",
                                    "Value": "MANSA"
                                },
                                {
                                    "Text": "MANSOORWAL ",
                                    "Value": "MANSOORWAL "
                                },
                                {
                                    "Text": "MANTHANI ",
                                    "Value": "MANTHANI "
                                },
                                {
                                    "Text": "MANTHANI",
                                    "Value": "MANTHANI"
                                },
                                {
                                    "Text": "MAPUSA",
                                    "Value": "MAPUSA"
                                },
                                {
                                    "Text": "MAROL",
                                    "Value": "MAROL"
                                },
                                {
                                    "Text": "MARATHALLI",
                                    "Value": "MARATHALLI"
                                },
                                {
                                    "Text": "MARAIMALAI",
                                    "Value": "MARAIMALAI"
                                },
                                {
                                    "Text": "MARCEL",
                                    "Value": "MARCEL"
                                },
                                {
                                    "Text": "MARCELA",
                                    "Value": "MARCELA"
                                },
                                {
                                    "Text": "MARDANPUR",
                                    "Value": "MARDANPUR"
                                },
                                {
                                    "Text": "MARGAO",
                                    "Value": "MARGAO"
                                },
                                {
                                    "Text": "MARGOA",
                                    "Value": "MARGOA"
                                },
                                {
                                    "Text": "MARGOA",
                                    "Value": "MARGOA"
                                },
                                {
                                    "Text": "MARIGAON",
                                    "Value": "MARIGAON"
                                },
                                {
                                    "Text": "MARIGADI ",
                                    "Value": "MARIGADI "
                                },
                                {
                                    "Text": "MARKAPUR",
                                    "Value": "MARKAPUR"
                                },
                                {
                                    "Text": "MARLAGUDEM ",
                                    "Value": "MARLAGUDEM "
                                },
                                {
                                    "Text": "MAROLI",
                                    "Value": "MAROLI"
                                },
                                {
                                    "Text": "MARTHANDAM",
                                    "Value": "MARTHANDAM"
                                },
                                {
                                    "Text": "MARYAL ",
                                    "Value": "MARYAL "
                                },
                                {
                                    "Text": "MASLANDAPUR",
                                    "Value": "MASLANDAPUR"
                                },
                                {
                                    "Text": "MASOR KHAMBH ",
                                    "Value": "MASOR KHAMBH "
                                },
                                {
                                    "Text": "MATANHAIL",
                                    "Value": "MATANHAIL"
                                },
                                {
                                    "Text": "MATHURA",
                                    "Value": "MATHURA"
                                },
                                {
                                    "Text": "MATIGARA",
                                    "Value": "MATIGARA"
                                },
                                {
                                    "Text": "MATOOR ",
                                    "Value": "MATOOR "
                                },
                                {
                                    "Text": "MATRA",
                                    "Value": "MATRA"
                                },
                                {
                                    "Text": "MATTANUR",
                                    "Value": "MATTANUR"
                                },
                                {
                                    "Text": "MATTARAKKAL ",
                                    "Value": "MATTARAKKAL "
                                },
                                {
                                    "Text": "MATTANNUR",
                                    "Value": "MATTANNUR"
                                },
                                {
                                    "Text": "MATWADA ",
                                    "Value": "MATWADA "
                                },
                                {
                                    "Text": "MAU",
                                    "Value": "MAU"
                                },
                                {
                                    "Text": "MAUDAHA",
                                    "Value": "MAUDAHA"
                                },
                                {
                                    "Text": "MAUJPURI ",
                                    "Value": "MAUJPURI "
                                },
                                {
                                    "Text": "MAUNATH BHANJAN",
                                    "Value": "MAUNATH BHANJAN"
                                },
                                {
                                    "Text": "MAURANIPUR",
                                    "Value": "MAURANIPUR"
                                },
                                {
                                    "Text": "MAUR MANDI",
                                    "Value": "MAUR MANDI"
                                },
                                {
                                    "Text": "MAUR",
                                    "Value": "MAUR"
                                },
                                {
                                    "Text": "MAURMANDI",
                                    "Value": "MAURMANDI"
                                },
                                {
                                    "Text": "MAVELIKARA",
                                    "Value": "MAVELIKARA"
                                },
                                {
                                    "Text": "MAVELIKKARA",
                                    "Value": "MAVELIKKARA"
                                },
                                {
                                    "Text": "MAWANA",
                                    "Value": "MAWANA"
                                },
                                {
                                    "Text": "MAYILADUTHURAI",
                                    "Value": "MAYILADUTHURAI"
                                },
                                {
                                    "Text": "MAYILADUTHURAI TOWN",
                                    "Value": "MAYILADUTHURAI TOWN"
                                },
                                {
                                    "Text": "MAYAPURI",
                                    "Value": "MAYAPURI"
                                },
                                {
                                    "Text": "MAYURBHANJ",
                                    "Value": "MAYURBHANJ"
                                },
                                {
                                    "Text": "MADARIA",
                                    "Value": "MADARIA"
                                },
                                {
                                    "Text": "MEDAK",
                                    "Value": "MEDAK"
                                },
                                {
                                    "Text": "MEDCHAL",
                                    "Value": "MEDCHAL"
                                },
                                {
                                    "Text": "MEDINIPUR",
                                    "Value": "MEDINIPUR"
                                },
                                {
                                    "Text": "MEDIPALLY ",
                                    "Value": "MEDIPALLY "
                                },
                                {
                                    "Text": "MEERUT",
                                    "Value": "MEERUT"
                                },
                                {
                                    "Text": "MEGH CHAPPAR",
                                    "Value": "MEGH CHAPPAR"
                                },
                                {
                                    "Text": "MEHATPUR",
                                    "Value": "MEHATPUR"
                                },
                                {
                                    "Text": "MEHAM",
                                    "Value": "MEHAM"
                                },
                                {
                                    "Text": "MEHBUBNAGAR",
                                    "Value": "MEHBUBNAGAR"
                                },
                                {
                                    "Text": "MEHDOODAN",
                                    "Value": "MEHDOODAN"
                                },
                                {
                                    "Text": "MEHELI",
                                    "Value": "MEHELI"
                                },
                                {
                                    "Text": "MEHMA SINGHWALA",
                                    "Value": "MEHMA SINGHWALA"
                                },
                                {
                                    "Text": "MEHSANA",
                                    "Value": "MEHSANA"
                                },
                                {
                                    "Text": "MEHTA",
                                    "Value": "MEHTA"
                                },
                                {
                                    "Text": "MEMADPUR",
                                    "Value": "MEMADPUR"
                                },
                                {
                                    "Text": "MEMARI",
                                    "Value": "MEMARI"
                                },
                                {
                                    "Text": "MEMAURA",
                                    "Value": "MEMAURA"
                                },
                                {
                                    "Text": "MEMNAGAR",
                                    "Value": "MEMNAGAR"
                                },
                                {
                                    "Text": "MENDHIPATHAR",
                                    "Value": "MENDHIPATHAR"
                                },
                                {
                                    "Text": "MENDHIPATHAR",
                                    "Value": "MENDHIPATHAR"
                                },
                                {
                                    "Text": "MENDRA KALAN",
                                    "Value": "MENDRA KALAN"
                                },
                                {
                                    "Text": "MERAMANDALI",
                                    "Value": "MERAMANDALI"
                                },
                                {
                                    "Text": "MERTA CITY",
                                    "Value": "MERTA CITY"
                                },
                                {
                                    "Text": "METODA",
                                    "Value": "METODA"
                                },
                                {
                                    "Text": "METPALLE",
                                    "Value": "METPALLE"
                                },
                                {
                                    "Text": "METTUPALAYAM",
                                    "Value": "METTUPALAYAM"
                                },
                                {
                                    "Text": "METTUR DAM",
                                    "Value": "METTUR DAM"
                                },
                                {
                                    "Text": "METTUR",
                                    "Value": "METTUR"
                                },
                                {
                                    "Text": "MEGHNAGAR",
                                    "Value": "MEGHNAGAR"
                                },
                                {
                                    "Text": "MHOW",
                                    "Value": "MHOW"
                                },
                                {
                                    "Text": "MIANI KHAS",
                                    "Value": "MIANI KHAS"
                                },
                                {
                                    "Text": "MIDNAPORE",
                                    "Value": "MIDNAPORE"
                                },
                                {
                                    "Text": "MILAK ",
                                    "Value": "MILAK "
                                },
                                {
                                    "Text": "MILKIPUR",
                                    "Value": "MILKIPUR"
                                },
                                {
                                    "Text": "MIRA ROAD",
                                    "Value": "MIRA ROAD"
                                },
                                {
                                    "Text": "MIRAJ",
                                    "Value": "MIRAJ"
                                },
                                {
                                    "Text": "MIRAN KOT KALAN",
                                    "Value": "MIRAN KOT KALAN"
                                },
                                {
                                    "Text": "MIRDHAPALLI ",
                                    "Value": "MIRDHAPALLI "
                                },
                                {
                                    "Text": "MIRGANJ",
                                    "Value": "MIRGANJ"
                                },
                                {
                                    "Text": "MIRYALGUDA",
                                    "Value": "MIRYALGUDA"
                                },
                                {
                                    "Text": "MIRZAPUR",
                                    "Value": "MIRZAPUR"
                                },
                                {
                                    "Text": "MITHAPUR",
                                    "Value": "MITHAPUR"
                                },
                                {
                                    "Text": "MITHI ROHAR",
                                    "Value": "MITHI ROHAR"
                                },
                                {
                                    "Text": "M K PATNAM ",
                                    "Value": "M K PATNAM "
                                },
                                {
                                    "Text": "MALIBU TOWNE",
                                    "Value": "MALIBU TOWNE"
                                },
                                {
                                    "Text": "MALPUR",
                                    "Value": "MALPUR"
                                },
                                {
                                    "Text": "MOLAR BAND",
                                    "Value": "MOLAR BAND"
                                },
                                {
                                    "Text": "MANINAGAR",
                                    "Value": "MANINAGAR"
                                },
                                {
                                    "Text": "MANARGUDI",
                                    "Value": "MANARGUDI"
                                },
                                {
                                    "Text": "MODASA",
                                    "Value": "MODASA"
                                },
                                {
                                    "Text": "MODINAGAR",
                                    "Value": "MODINAGAR"
                                },
                                {
                                    "Text": "MOGA",
                                    "Value": "MOGA"
                                },
                                {
                                    "Text": "MOGA KTY ",
                                    "Value": "MOGA KTY "
                                },
                                {
                                    "Text": "MOGRA BADSHAHPUR",
                                    "Value": "MOGRA BADSHAHPUR"
                                },
                                {
                                    "Text": "MOHALI",
                                    "Value": "MOHALI"
                                },
                                {
                                    "Text": "MOHALI",
                                    "Value": "MOHALI"
                                },
                                {
                                    "Text": "MOHAN ",
                                    "Value": "MOHAN "
                                },
                                {
                                    "Text": "MOHALI SAS NAGAR",
                                    "Value": "MOHALI SAS NAGAR"
                                },
                                {
                                    "Text": "MOHAMMADABAD",
                                    "Value": "MOHAMMADABAD"
                                },
                                {
                                    "Text": "MOHAMMADI",
                                    "Value": "MOHAMMADI"
                                },
                                {
                                    "Text": "MOHANIA",
                                    "Value": "MOHANIA"
                                },
                                {
                                    "Text": "MOHANLALGANJ",
                                    "Value": "MOHANLALGANJ"
                                },
                                {
                                    "Text": "MOHKHED ",
                                    "Value": "MOHKHED "
                                },
                                {
                                    "Text": "MOHONE",
                                    "Value": "MOHONE"
                                },
                                {
                                    "Text": "MOKAMA",
                                    "Value": "MOKAMA"
                                },
                                {
                                    "Text": "MOKAMA",
                                    "Value": "MOKAMA"
                                },
                                {
                                    "Text": "MOKAMEH",
                                    "Value": "MOKAMEH"
                                },
                                {
                                    "Text": "MOKANDPUR",
                                    "Value": "MOKANDPUR"
                                },
                                {
                                    "Text": "MOKOKCHUNG",
                                    "Value": "MOKOKCHUNG"
                                },
                                {
                                    "Text": "MOLKACHARLA ",
                                    "Value": "MOLKACHARLA "
                                },
                                {
                                    "Text": "TUE",
                                    "Value": "MON"
                                },
                                {
                                    "Text": "MOOM",
                                    "Value": "MOOM"
                                },
                                {
                                    "Text": "MOONAK",
                                    "Value": "MOONAK"
                                },
                                {
                                    "Text": "MOOTHAKUNNAM",
                                    "Value": "MOOTHAKUNNAM"
                                },
                                {
                                    "Text": "MORADABAD",
                                    "Value": "MORADABAD"
                                },
                                {
                                    "Text": "MORANWALI ",
                                    "Value": "MORANWALI "
                                },
                                {
                                    "Text": "MORAN",
                                    "Value": "MORAN"
                                },
                                {
                                    "Text": "MORANWALI",
                                    "Value": "MORANWALI"
                                },
                                {
                                    "Text": "MORBI",
                                    "Value": "MORBI"
                                },
                                {
                                    "Text": "MORENA",
                                    "Value": "MORENA"
                                },
                                {
                                    "Text": "MORGA ",
                                    "Value": "MORGA "
                                },
                                {
                                    "Text": "MORINDA",
                                    "Value": "MORINDA"
                                },
                                {
                                    "Text": "MORMUGOA",
                                    "Value": "MORMUGOA"
                                },
                                {
                                    "Text": "MORMUGOA",
                                    "Value": "MORMUGOA"
                                },
                                {
                                    "Text": "MORVI",
                                    "Value": "MORVI"
                                },
                                {
                                    "Text": "MOTATIMBLA",
                                    "Value": "MOTATIMBLA"
                                },
                                {
                                    "Text": "MOTA MAVA",
                                    "Value": "MOTA MAVA"
                                },
                                {
                                    "Text": "MOTA",
                                    "Value": "MOTA"
                                },
                                {
                                    "Text": "MOTALA",
                                    "Value": "MOTALA"
                                },
                                {
                                    "Text": "MOTEBENNUR ",
                                    "Value": "MOTEBENNUR "
                                },
                                {
                                    "Text": "MOTEERAM ADDA",
                                    "Value": "MOTEERAM ADDA"
                                },
                                {
                                    "Text": "MOTIHARI",
                                    "Value": "MOTIHARI"
                                },
                                {
                                    "Text": "MIRA-BHAYANDAR",
                                    "Value": "MIRA-BHAYANDAR"
                                },
                                {
                                    "Text": "MIRPUR TURK",
                                    "Value": "MIRPUR TURK"
                                },
                                {
                                    "Text": "MASLANDAPUR",
                                    "Value": "MASLANDAPUR"
                                },
                                {
                                    "Text": "MUSTAFABAD, DELHI",
                                    "Value": "MUSTAFABAD, DELHI"
                                },
                                {
                                    "Text": "MITHE PUR",
                                    "Value": "MITHE PUR"
                                },
                                {
                                    "Text": "MATTAN",
                                    "Value": "MATTAN"
                                },
                                {
                                    "Text": "MOTATIMBLA",
                                    "Value": "MOTATIMBLA"
                                },
                                {
                                    "Text": "MUBARAKPUR",
                                    "Value": "MUBARAKPUR"
                                },
                                {
                                    "Text": "MUCHIMILLI ",
                                    "Value": "MUCHIMILLI "
                                },
                                {
                                    "Text": "MUDBIDRI",
                                    "Value": "MUDBIDRI"
                                },
                                {
                                    "Text": "MUDGUL CHITTEMPALLE ",
                                    "Value": "MUDGUL CHITTEMPALLE "
                                },
                                {
                                    "Text": "MUDHOL",
                                    "Value": "MUDHOL"
                                },
                                {
                                    "Text": "MUDHAL",
                                    "Value": "MUDHAL"
                                },
                                {
                                    "Text": "MUDKI",
                                    "Value": "MUDKI"
                                },
                                {
                                    "Text": "MUDUPUGAL ",
                                    "Value": "MUDUPUGAL "
                                },
                                {
                                    "Text": "MUGHALSARAI",
                                    "Value": "MUGHALSARAI"
                                },
                                {
                                    "Text": "MUGPAL",
                                    "Value": "MUGPAL"
                                },
                                {
                                    "Text": "MUHAMMADABAD",
                                    "Value": "MUHAMMADABAD"
                                },
                                {
                                    "Text": "MUKHED",
                                    "Value": "MUKHED"
                                },
                                {
                                    "Text": "MUKERIAN",
                                    "Value": "MUKERIAN"
                                },
                                {
                                    "Text": "MUKTSAR",
                                    "Value": "MUKTSAR"
                                },
                                {
                                    "Text": "MULAGAMPALLY ",
                                    "Value": "MULAGAMPALLY "
                                },
                                {
                                    "Text": "MULBAGAL",
                                    "Value": "MULBAGAL"
                                },
                                {
                                    "Text": "MULKI",
                                    "Value": "MULKI"
                                },
                                {
                                    "Text": "MULLANPUR",
                                    "Value": "MULLANPUR"
                                },
                                {
                                    "Text": "MULLANA",
                                    "Value": "MULLANA"
                                },
                                {
                                    "Text": "MULLANPUR DAKHA",
                                    "Value": "MULLANPUR DAKHA"
                                },
                                {
                                    "Text": "MULLANPUR GARIBADAS",
                                    "Value": "MULLANPUR GARIBADAS"
                                },
                                {
                                    "Text": "MUL",
                                    "Value": "MUL"
                                },
                                {
                                    "Text": "MUMBAI",
                                    "Value": "MUMBAI"
                                },
                                {
                                    "Text": "MUMBRA",
                                    "Value": "MUMBRA"
                                },
                                {
                                    "Text": "MUNAK",
                                    "Value": "MUNAK"
                                },
                                {
                                    "Text": "MUNDRA",
                                    "Value": "MUNDRA"
                                },
                                {
                                    "Text": "MUNDKA",
                                    "Value": "MUNDKA"
                                },
                                {
                                    "Text": "MUNDIYUR ",
                                    "Value": "MUNDIYUR "
                                },
                                {
                                    "Text": "MUNDA",
                                    "Value": "MUNDA"
                                },
                                {
                                    "Text": "MUNDALI",
                                    "Value": "MUNDALI"
                                },
                                {
                                    "Text": "MUNGER",
                                    "Value": "MUNGER"
                                },
                                {
                                    "Text": "MUNGELI",
                                    "Value": "MUNGELI"
                                },
                                {
                                    "Text": "MUNNUR SOMARAM ",
                                    "Value": "MUNNUR SOMARAM "
                                },
                                {
                                    "Text": "MUNPALLI ",
                                    "Value": "MUNPALLI "
                                },
                                {
                                    "Text": "MUNPALLE",
                                    "Value": "MUNPALLE"
                                },
                                {
                                    "Text": "MURARICHINTALA ",
                                    "Value": "MURARICHINTALA "
                                },
                                {
                                    "Text": "MURADABAD",
                                    "Value": "MURADABAD"
                                },
                                {
                                    "Text": "MURADNAGAR",
                                    "Value": "MURADNAGAR"
                                },
                                {
                                    "Text": "MURBAD",
                                    "Value": "MURBAD"
                                },
                                {
                                    "Text": "MURGUD",
                                    "Value": "MURGUD"
                                },
                                {
                                    "Text": "MURNAL ",
                                    "Value": "MURNAL "
                                },
                                {
                                    "Text": "MURSHIDABAD",
                                    "Value": "MURSHIDABAD"
                                },
                                {
                                    "Text": "MURTIJAPUR",
                                    "Value": "MURTIJAPUR"
                                },
                                {
                                    "Text": "MUSCAT",
                                    "Value": "MUSCAT"
                                },
                                {
                                    "Text": "MUSSOORIE",
                                    "Value": "MUSSOORIE"
                                },
                                {
                                    "Text": "MUSTAFABAD",
                                    "Value": "MUSTAFABAD"
                                },
                                {
                                    "Text": "MUVATTUPUZHA",
                                    "Value": "MUVATTUPUZHA"
                                },
                                {
                                    "Text": "MUZAFFARNAGAR",
                                    "Value": "MUZAFFARNAGAR"
                                },
                                {
                                    "Text": "MUZAFFARPUR",
                                    "Value": "MUZAFFARPUR"
                                },
                                {
                                    "Text": "MUZAFFARNAGAR",
                                    "Value": "MUZAFFARNAGAR"
                                },
                                {
                                    "Text": "MUZZAFAR NAGAR",
                                    "Value": "MUZZAFAR NAGAR"
                                },
                                {
                                    "Text": "MEWAT",
                                    "Value": "MEWAT"
                                },
                                {
                                    "Text": "MYSORE",
                                    "Value": "MYSORE"
                                },
                                {
                                    "Text": "N.PARAVUR",
                                    "Value": "N.PARAVUR"
                                },
                                {
                                    "Text": "NABARANGAPUR",
                                    "Value": "NABARANGAPUR"
                                },
                                {
                                    "Text": "NABADWIP",
                                    "Value": "NABADWIP"
                                },
                                {
                                    "Text": "NABHA",
                                    "Value": "NABHA"
                                },
                                {
                                    "Text": "NADAVARAMBA P.O",
                                    "Value": "NADAVARAMBA P.O"
                                },
                                {
                                    "Text": "NADALA",
                                    "Value": "NADALA"
                                },
                                {
                                    "Text": "NADAPURAM",
                                    "Value": "NADAPURAM"
                                },
                                {
                                    "Text": "NADAUN",
                                    "Value": "NADAUN"
                                },
                                {
                                    "Text": "NADEPALLE",
                                    "Value": "NADEPALLE"
                                },
                                {
                                    "Text": "NADIAD",
                                    "Value": "NADIAD"
                                },
                                {
                                    "Text": "NADIA",
                                    "Value": "NADIA"
                                },
                                {
                                    "Text": "NADIWADA ",
                                    "Value": "NADIWADA "
                                },
                                {
                                    "Text": "NAGAON",
                                    "Value": "NAGAON"
                                },
                                {
                                    "Text": "NAGAPATTINAM",
                                    "Value": "NAGAPATTINAM"
                                },
                                {
                                    "Text": "NAGAUR",
                                    "Value": "NAGAUR"
                                },
                                {
                                    "Text": "NAGARAM",
                                    "Value": "NAGARAM"
                                },
                                {
                                    "Text": "NAGDA",
                                    "Value": "NAGDA"
                                },
                                {
                                    "Text": "NAGDHARA",
                                    "Value": "NAGDHARA"
                                },
                                {
                                    "Text": "NAGERCOIL",
                                    "Value": "NAGERCOIL"
                                },
                                {
                                    "Text": "NAGINA",
                                    "Value": "NAGINA"
                                },
                                {
                                    "Text": "NANGAL DEWAT",
                                    "Value": "NANGAL DEWAT"
                                },
                                {
                                    "Text": "NANGAL THAKRAN",
                                    "Value": "NANGAL THAKRAN"
                                },
                                {
                                    "Text": "NAGPUR",
                                    "Value": "NAGPUR"
                                },
                                {
                                    "Text": "NAGROTA BAGWAN",
                                    "Value": "NAGROTA BAGWAN"
                                },
                                {
                                    "Text": "NAHARLAGUN",
                                    "Value": "NAHARLAGUN"
                                },
                                {
                                    "Text": "NAHAN",
                                    "Value": "NAHAN"
                                },
                                {
                                    "Text": "NAHARPUR KASAN",
                                    "Value": "NAHARPUR KASAN"
                                },
                                {
                                    "Text": "NAHARPUR",
                                    "Value": "NAHARPUR"
                                },
                                {
                                    "Text": "NAHUR",
                                    "Value": "NAHUR"
                                },
                                {
                                    "Text": "NAIGAVHAN ",
                                    "Value": "NAIGAVHAN "
                                },
                                {
                                    "Text": "NAIHATI",
                                    "Value": "NAIHATI"
                                },
                                {
                                    "Text": "NAINITAL",
                                    "Value": "NAINITAL"
                                },
                                {
                                    "Text": "NAIRA ",
                                    "Value": "NAIRA "
                                },
                                {
                                    "Text": "NAISI",
                                    "Value": "NAISI"
                                },
                                {
                                    "Text": "NAJIBABAD",
                                    "Value": "NAJIBABAD"
                                },
                                {
                                    "Text": "NAKATRANA",
                                    "Value": "NAKATRANA"
                                },
                                {
                                    "Text": "NAKODAR",
                                    "Value": "NAKODAR"
                                },
                                {
                                    "Text": "NAKREKAL",
                                    "Value": "NAKREKAL"
                                },
                                {
                                    "Text": "NALAGARH",
                                    "Value": "NALAGARH"
                                },
                                {
                                    "Text": "NALANDA",
                                    "Value": "NALANDA"
                                },
                                {
                                    "Text": "NALBARI",
                                    "Value": "NALBARI"
                                },
                                {
                                    "Text": "NALGONDA",
                                    "Value": "NALGONDA"
                                },
                                {
                                    "Text": "NALLASOPARA",
                                    "Value": "NALLASOPARA"
                                },
                                {
                                    "Text": "NALLASOPARA- WEST",
                                    "Value": "NALLASOPARA- WEST"
                                },
                                {
                                    "Text": "NALLAPUREDDYPALLE ",
                                    "Value": "NALLAPUREDDYPALLE "
                                },
                                {
                                    "Text": "NALNI ",
                                    "Value": "NALNI "
                                },
                                {
                                    "Text": "NAMAKKAL",
                                    "Value": "NAMAKKAL"
                                },
                                {
                                    "Text": "NAMCHI",
                                    "Value": "NAMCHI"
                                },
                                {
                                    "Text": "NAMCHI",
                                    "Value": "NAMCHI"
                                },
                                {
                                    "Text": "NAMPUR",
                                    "Value": "NAMPUR"
                                },
                                {
                                    "Text": "NAMSAI",
                                    "Value": "NAMSAI"
                                },
                                {
                                    "Text": "NANAKSAR KALERAN",
                                    "Value": "NANAKSAR KALERAN"
                                },
                                {
                                    "Text": "NANDYAL",
                                    "Value": "NANDYAL"
                                },
                                {
                                    "Text": "NANDED",
                                    "Value": "NANDED"
                                },
                                {
                                    "Text": "NANDURBAR",
                                    "Value": "NANDURBAR"
                                },
                                {
                                    "Text": "NANDIPAHAD ",
                                    "Value": "NANDIPAHAD "
                                },
                                {
                                    "Text": "NANDGAON ",
                                    "Value": "NANDGAON "
                                },
                                {
                                    "Text": "NANDGAON",
                                    "Value": "NANDGAON"
                                },
                                {
                                    "Text": "NANDURA",
                                    "Value": "NANDURA"
                                },
                                {
                                    "Text": "NANGAL",
                                    "Value": "NANGAL"
                                },
                                {
                                    "Text": "NANGAL KALAN",
                                    "Value": "NANGAL KALAN"
                                },
                                {
                                    "Text": "NANGAL KHERI",
                                    "Value": "NANGAL KHERI"
                                },
                                {
                                    "Text": "NANJANGUD",
                                    "Value": "NANJANGUD"
                                },
                                {
                                    "Text": "NANPARA",
                                    "Value": "NANPARA"
                                },
                                {
                                    "Text": "NAPARA",
                                    "Value": "NAPARA"
                                },
                                {
                                    "Text": "NARAYANGAON",
                                    "Value": "NARAYANGAON"
                                },
                                {
                                    "Text": "NARASARAOPET",
                                    "Value": "NARASARAOPET"
                                },
                                {
                                    "Text": "NARAINGARH",
                                    "Value": "NARAINGARH"
                                },
                                {
                                    "Text": "NARAYANPUR",
                                    "Value": "NARAYANPUR"
                                },
                                {
                                    "Text": "NARAYANPUR",
                                    "Value": "NARAYANPUR"
                                },
                                {
                                    "Text": "NARAINA",
                                    "Value": "NARAINA"
                                },
                                {
                                    "Text": "NARASAPURAPUPETA ",
                                    "Value": "NARASAPURAPUPETA "
                                },
                                {
                                    "Text": "NARASAMPET",
                                    "Value": "NARASAMPET"
                                },
                                {
                                    "Text": "NARASAPUR",
                                    "Value": "NARASAPUR"
                                },
                                {
                                    "Text": "NARASARAOPETA",
                                    "Value": "NARASARAOPETA"
                                },
                                {
                                    "Text": "NARAYANPET",
                                    "Value": "NARAYANPET"
                                },
                                {
                                    "Text": "NAREDA",
                                    "Value": "NAREDA"
                                },
                                {
                                    "Text": "NARMADA",
                                    "Value": "NARMADA"
                                },
                                {
                                    "Text": "NARMETTA ",
                                    "Value": "NARMETTA "
                                },
                                {
                                    "Text": "NARNAUD",
                                    "Value": "NARNAUD"
                                },
                                {
                                    "Text": "NARNAUL",
                                    "Value": "NARNAUL"
                                },
                                {
                                    "Text": "NARNAUND",
                                    "Value": "NARNAUND"
                                },
                                {
                                    "Text": "NARSINGHPUR",
                                    "Value": "NARSINGHPUR"
                                },
                                {
                                    "Text": "NARSAMPET",
                                    "Value": "NARSAMPET"
                                },
                                {
                                    "Text": "NARSAPUR",
                                    "Value": "NARSAPUR"
                                },
                                {
                                    "Text": "NARSINGHPUR",
                                    "Value": "NARSINGHPUR"
                                },
                                {
                                    "Text": "NARSAPURA",
                                    "Value": "NARSAPURA"
                                },
                                {
                                    "Text": "NARSIPATNAM",
                                    "Value": "NARSIPATNAM"
                                },
                                {
                                    "Text": "NARUGRAM",
                                    "Value": "NARUGRAM"
                                },
                                {
                                    "Text": "NARWANA",
                                    "Value": "NARWANA"
                                },
                                {
                                    "Text": "NASHIK",
                                    "Value": "NASHIK"
                                },
                                {
                                    "Text": "NASIK",
                                    "Value": "NASIK"
                                },
                                {
                                    "Text": "NASIRABAD",
                                    "Value": "NASIRABAD"
                                },
                                {
                                    "Text": "NASVADI",
                                    "Value": "NASVADI"
                                },
                                {
                                    "Text": "NATGRAM",
                                    "Value": "NATGRAM"
                                },
                                {
                                    "Text": "NATHDWARA",
                                    "Value": "NATHDWARA"
                                },
                                {
                                    "Text": "NATHU CHAHAL ",
                                    "Value": "NATHU CHAHAL "
                                },
                                {
                                    "Text": "NATHANA",
                                    "Value": "NATHANA"
                                },
                                {
                                    "Text": "NAUGACHHIA",
                                    "Value": "NAUGACHHIA"
                                },
                                {
                                    "Text": "NAUGARH",
                                    "Value": "NAUGARH"
                                },
                                {
                                    "Text": "NAURANGABAD ",
                                    "Value": "NAURANGABAD "
                                },
                                {
                                    "Text": "NAURA",
                                    "Value": "NAURA"
                                },
                                {
                                    "Text": "NAUSHERA MAJA SINGH",
                                    "Value": "NAUSHERA MAJA SINGH"
                                },
                                {
                                    "Text": "NAUSHERA PANNUAN",
                                    "Value": "NAUSHERA PANNUAN"
                                },
                                {
                                    "Text": "NAUSHERA",
                                    "Value": "NAUSHERA"
                                },
                                {
                                    "Text": "NAUTANWA",
                                    "Value": "NAUTANWA"
                                },
                                {
                                    "Text": "NAVELIM",
                                    "Value": "NAVELIM"
                                },
                                {
                                    "Text": "NAVI MUMBAI",
                                    "Value": "NAVI MUMBAI"
                                },
                                {
                                    "Text": "NAVSARI",
                                    "Value": "NAVSARI"
                                },
                                {
                                    "Text": "NAWADA",
                                    "Value": "NAWADA"
                                },
                                {
                                    "Text": "NAWANSHAHAR",
                                    "Value": "NAWANSHAHAR"
                                },
                                {
                                    "Text": "NAWANSHAHR",
                                    "Value": "NAWANSHAHR"
                                },
                                {
                                    "Text": "NAWABGANJ",
                                    "Value": "NAWABGANJ"
                                },
                                {
                                    "Text": "NAWAGARH",
                                    "Value": "NAWAGARH"
                                },
                                {
                                    "Text": "NAWALGARH",
                                    "Value": "NAWALGARH"
                                },
                                {
                                    "Text": "NAWAN PIND",
                                    "Value": "NAWAN PIND"
                                },
                                {
                                    "Text": "NAWANAGAR",
                                    "Value": "NAWANAGAR"
                                },
                                {
                                    "Text": "NAWANSHAHAR",
                                    "Value": "NAWANSHAHAR"
                                },
                                {
                                    "Text": "NAWAPUR",
                                    "Value": "NAWAPUR"
                                },
                                {
                                    "Text": "NAYA NANGAL",
                                    "Value": "NAYA NANGAL"
                                },
                                {
                                    "Text": "NAYAGARH",
                                    "Value": "NAYAGARH"
                                },
                                {
                                    "Text": "NAZIRA",
                                    "Value": "NAZIRA"
                                },
                                {
                                    "Text": "NEW DELHI MUNICIPAL COUNCIL",
                                    "Value": "NEW DELHI MUNICIPAL COUNCIL"
                                },
                                {
                                    "Text": "NEDUMANGAD",
                                    "Value": "NEDUMANGAD"
                                },
                                {
                                    "Text": "NEELAPALLE",
                                    "Value": "NEELAPALLE"
                                },
                                {
                                    "Text": "NEEMUCH",
                                    "Value": "NEEMUCH"
                                },
                                {
                                    "Text": "NEEM KA THANA",
                                    "Value": "NEEM KA THANA"
                                },
                                {
                                    "Text": "NEEM KA THANA",
                                    "Value": "NEEM KA THANA"
                                },
                                {
                                    "Text": "NEEMRANA",
                                    "Value": "NEEMRANA"
                                },
                                {
                                    "Text": "NELLORE",
                                    "Value": "NELLORE"
                                },
                                {
                                    "Text": "NELLUTLA ",
                                    "Value": "NELLUTLA "
                                },
                                {
                                    "Text": "NERALAKUPPE ",
                                    "Value": "NERALAKUPPE "
                                },
                                {
                                    "Text": "NERAL",
                                    "Value": "NERAL"
                                },
                                {
                                    "Text": "NERUL",
                                    "Value": "NERUL"
                                },
                                {
                                    "Text": "NER ",
                                    "Value": "NER "
                                },
                                {
                                    "Text": "NER",
                                    "Value": "NER"
                                },
                                {
                                    "Text": "NESARGI",
                                    "Value": "NESARGI"
                                },
                                {
                                    "Text": "NETRAMALI",
                                    "Value": "NETRAMALI"
                                },
                                {
                                    "Text": "NETTOOR",
                                    "Value": "NETTOOR"
                                },
                                {
                                    "Text": "NEVALGANJ ",
                                    "Value": "NEVALGANJ "
                                },
                                {
                                    "Text": "NEW DELHI",
                                    "Value": "NEW DELHI"
                                },
                                {
                                    "Text": "NEWAI",
                                    "Value": "NEWAI"
                                },
                                {
                                    "Text": "NEW ABADI ",
                                    "Value": "NEW ABADI "
                                },
                                {
                                    "Text": "NEW DUDHAI",
                                    "Value": "NEW DUDHAI"
                                },
                                {
                                    "Text": "NEYVELI",
                                    "Value": "NEYVELI"
                                },
                                {
                                    "Text": "NEYYATTINKARA",
                                    "Value": "NEYYATTINKARA"
                                },
                                {
                                    "Text": "NEYYATTINKARA",
                                    "Value": "NEYYATTINKARA"
                                },
                                {
                                    "Text": "NANGLOI JAT",
                                    "Value": "NANGLOI JAT"
                                },
                                {
                                    "Text": "NHAVA SHEVA",
                                    "Value": "NHAVA SHEVA"
                                },
                                {
                                    "Text": "NOHAR",
                                    "Value": "NOHAR"
                                },
                                {
                                    "Text": "NICOBAR",
                                    "Value": "NICOBAR"
                                },
                                {
                                    "Text": "NIDADAVOLE",
                                    "Value": "NIDADAVOLE"
                                },
                                {
                                    "Text": "NIDHIPUR",
                                    "Value": "NIDHIPUR"
                                },
                                {
                                    "Text": "NIGDI",
                                    "Value": "NIGDI"
                                },
                                {
                                    "Text": "NIGHOJE",
                                    "Value": "NIGHOJE"
                                },
                                {
                                    "Text": "NIHAL SINGH WALA",
                                    "Value": "NIHAL SINGH WALA"
                                },
                                {
                                    "Text": "NIHALSINGH WALA",
                                    "Value": "NIHALSINGH WALA"
                                },
                                {
                                    "Text": "NIJHOTA ",
                                    "Value": "NIJHOTA "
                                },
                                {
                                    "Text": "NILAMBUR",
                                    "Value": "NILAMBUR"
                                },
                                {
                                    "Text": "NIVALI",
                                    "Value": "NIVALI"
                                },
                                {
                                    "Text": "NILGIRIS",
                                    "Value": "NILGIRIS"
                                },
                                {
                                    "Text": "NILOKHERI",
                                    "Value": "NILOKHERI"
                                },
                                {
                                    "Text": "NIMAPARA",
                                    "Value": "NIMAPARA"
                                },
                                {
                                    "Text": "NIMBAHERA",
                                    "Value": "NIMBAHERA"
                                },
                                {
                                    "Text": "NIMETHA",
                                    "Value": "NIMETHA"
                                },
                                {
                                    "Text": "NINDUGONDA ",
                                    "Value": "NINDUGONDA "
                                },
                                {
                                    "Text": "NIPHAD",
                                    "Value": "NIPHAD"
                                },
                                {
                                    "Text": "NIPPANI",
                                    "Value": "NIPPANI"
                                },
                                {
                                    "Text": "NIRA",
                                    "Value": "NIRA"
                                },
                                {
                                    "Text": "NIRMAL",
                                    "Value": "NIRMAL"
                                },
                                {
                                    "Text": "NIRMALI",
                                    "Value": "NIRMALI"
                                },
                                {
                                    "Text": "NISARAYA",
                                    "Value": "NISARAYA"
                                },
                                {
                                    "Text": "NISSING",
                                    "Value": "NISSING"
                                },
                                {
                                    "Text": "NIVALI",
                                    "Value": "NIVALI"
                                },
                                {
                                    "Text": "NIWAI",
                                    "Value": "NIWAI"
                                },
                                {
                                    "Text": "NIWAROO",
                                    "Value": "NIWAROO"
                                },
                                {
                                    "Text": "NIZAMABAD",
                                    "Value": "NIZAMABAD"
                                },
                                {
                                    "Text": "NAJAFGARH",
                                    "Value": "NAJAFGARH"
                                },
                                {
                                    "Text": "NILANGA",
                                    "Value": "NILANGA"
                                },
                                {
                                    "Text": "NOCHIMEDU ",
                                    "Value": "NOCHIMEDU "
                                },
                                {
                                    "Text": "NOIDA",
                                    "Value": "NOIDA"
                                },
                                {
                                    "Text": "NOIDA",
                                    "Value": "NOIDA"
                                },
                                {
                                    "Text": "NOKHA",
                                    "Value": "NOKHA"
                                },
                                {
                                    "Text": "NONGPOH",
                                    "Value": "NONGPOH"
                                },
                                {
                                    "Text": "NONGSTOIN",
                                    "Value": "NONGSTOIN"
                                },
                                {
                                    "Text": "NOONMATI",
                                    "Value": "NOONMATI"
                                },
                                {
                                    "Text": "NOORPUR",
                                    "Value": "NOORPUR"
                                },
                                {
                                    "Text": "NORTH LAKHIMPUR",
                                    "Value": "NORTH LAKHIMPUR"
                                },
                                {
                                    "Text": "NORTH EAST DELHI",
                                    "Value": "NORTH EAST DELHI"
                                },
                                {
                                    "Text": "NORTH 24 PARGANAS",
                                    "Value": "NORTH 24 PARGANAS"
                                },
                                {
                                    "Text": "NORTH AND MIDDLE ANDAMAN",
                                    "Value": "NORTH AND MIDDLE ANDAMAN"
                                },
                                {
                                    "Text": "NORTH CACHAR HILLS",
                                    "Value": "NORTH CACHAR HILLS"
                                },
                                {
                                    "Text": "NORTH DELHI",
                                    "Value": "NORTH DELHI"
                                },
                                {
                                    "Text": "NORTH DINAJPUR",
                                    "Value": "NORTH DINAJPUR"
                                },
                                {
                                    "Text": "NORTH GOA",
                                    "Value": "NORTH GOA"
                                },
                                {
                                    "Text": "NORTH SIKKIM",
                                    "Value": "NORTH SIKKIM"
                                },
                                {
                                    "Text": "NORTH TRIPURA",
                                    "Value": "NORTH TRIPURA"
                                },
                                {
                                    "Text": "NORTH WEST DELHI",
                                    "Value": "NORTH WEST DELHI"
                                },
                                {
                                    "Text": "NORTH DUMDUM",
                                    "Value": "NORTH DUMDUM"
                                },
                                {
                                    "Text": "NORTH GUWAHATI",
                                    "Value": "NORTH GUWAHATI"
                                },
                                {
                                    "Text": "NOWGONG",
                                    "Value": "NOWGONG"
                                },
                                {
                                    "Text": "NAPARA",
                                    "Value": "NAPARA"
                                },
                                {
                                    "Text": "NSP CAMP MIRYALAGUDA ",
                                    "Value": "NSP CAMP MIRYALAGUDA "
                                },
                                {
                                    "Text": "NATEPUTE",
                                    "Value": "NATEPUTE"
                                },
                                {
                                    "Text": "NUAPADA",
                                    "Value": "NUAPADA"
                                },
                                {
                                    "Text": "NUH",
                                    "Value": "NUH"
                                },
                                {
                                    "Text": "NUMALIGARH",
                                    "Value": "NUMALIGARH"
                                },
                                {
                                    "Text": "NUNA MAJRA",
                                    "Value": "NUNA MAJRA"
                                },
                                {
                                    "Text": "NURMAHAL",
                                    "Value": "NURMAHAL"
                                },
                                {
                                    "Text": "NURPUR BEDI",
                                    "Value": "NURPUR BEDI"
                                },
                                {
                                    "Text": "NUVEM",
                                    "Value": "NUVEM"
                                },
                                {
                                    "Text": "NUZVID",
                                    "Value": "NUZVID"
                                },
                                {
                                    "Text": "NIWARI",
                                    "Value": "NIWARI"
                                },
                                {
                                    "Text": "NAZIRA",
                                    "Value": "NAZIRA"
                                },
                                {
                                    "Text": "OBRA",
                                    "Value": "OBRA"
                                },
                                {
                                    "Text": "ODDANCHATRAM",
                                    "Value": "ODDANCHATRAM"
                                },
                                {
                                    "Text": "ODWARA",
                                    "Value": "ODWARA"
                                },
                                {
                                    "Text": "OLD GOA",
                                    "Value": "OLD GOA"
                                },
                                {
                                    "Text": "OLD GOA",
                                    "Value": "OLD GOA"
                                },
                                {
                                    "Text": "ONGOLE",
                                    "Value": "ONGOLE"
                                },
                                {
                                    "Text": "OOTY",
                                    "Value": "OOTY"
                                },
                                {
                                    "Text": "OPIVADA VENKAMPETA ",
                                    "Value": "OPIVADA VENKAMPETA "
                                },
                                {
                                    "Text": "OPP R K MARBLE HAZARIBAGH",
                                    "Value": "OPP R K MARBLE HAZARIBAGH"
                                },
                                {
                                    "Text": "ORAGADAM",
                                    "Value": "ORAGADAM"
                                },
                                {
                                    "Text": "ORAI",
                                    "Value": "ORAI"
                                },
                                {
                                    "Text": "ORAVACKAL",
                                    "Value": "ORAVACKAL"
                                },
                                {
                                    "Text": "OSMANABAD",
                                    "Value": "OSMANABAD"
                                },
                                {
                                    "Text": "OTHIAN",
                                    "Value": "OTHIAN"
                                },
                                {
                                    "Text": "OTTAPALAM",
                                    "Value": "OTTAPALAM"
                                },
                                {
                                    "Text": "OZAR",
                                    "Value": "OZAR"
                                },
                                {
                                    "Text": "PACHORA",
                                    "Value": "PACHORA"
                                },
                                {
                                    "Text": "PACHRA ",
                                    "Value": "PACHRA "
                                },
                                {
                                    "Text": "PACHAAT",
                                    "Value": "PACHAAT"
                                },
                                {
                                    "Text": "PACHCHUNUR",
                                    "Value": "PACHCHUNUR"
                                },
                                {
                                    "Text": "PADAMPUR",
                                    "Value": "PADAMPUR"
                                },
                                {
                                    "Text": "PADDI JAGIR",
                                    "Value": "PADDI JAGIR"
                                },
                                {
                                    "Text": "PADRAUNA",
                                    "Value": "PADRAUNA"
                                },
                                {
                                    "Text": "PADRA",
                                    "Value": "PADRA"
                                },
                                {
                                    "Text": "PAHARPUR ",
                                    "Value": "PAHARPUR "
                                },
                                {
                                    "Text": "PAITHAN",
                                    "Value": "PAITHAN"
                                },
                                {
                                    "Text": "PAI",
                                    "Value": "PAI"
                                },
                                {
                                    "Text": "PAKALAPADU ",
                                    "Value": "PAKALAPADU "
                                },
                                {
                                    "Text": "PAKHI KALAN ",
                                    "Value": "PAKHI KALAN "
                                },
                                {
                                    "Text": "PAKHARPUR",
                                    "Value": "PAKHARPUR"
                                },
                                {
                                    "Text": "PAKRI BARAMAD DEOBARI",
                                    "Value": "PAKRI BARAMAD DEOBARI"
                                },
                                {
                                    "Text": "PAKUR",
                                    "Value": "PAKUR"
                                },
                                {
                                    "Text": "PALAKOL",
                                    "Value": "PALAKOL"
                                },
                                {
                                    "Text": "PALA",
                                    "Value": "PALA"
                                },
                                {
                                    "Text": "PALANPUR",
                                    "Value": "PALANPUR"
                                },
                                {
                                    "Text": "PALAMPUR",
                                    "Value": "PALAMPUR"
                                },
                                {
                                    "Text": "PALARIVATTOM",
                                    "Value": "PALARIVATTOM"
                                },
                                {
                                    "Text": "PALAKKAD",
                                    "Value": "PALAKKAD"
                                },
                                {
                                    "Text": "PALAMAU",
                                    "Value": "PALAMAU"
                                },
                                {
                                    "Text": "PALASAUR ",
                                    "Value": "PALASAUR "
                                },
                                {
                                    "Text": "PALACOLE",
                                    "Value": "PALACOLE"
                                },
                                {
                                    "Text": "PALAMNER",
                                    "Value": "PALAMNER"
                                },
                                {
                                    "Text": "PALAVAKKAM",
                                    "Value": "PALAVAKKAM"
                                },
                                {
                                    "Text": "PALDA",
                                    "Value": "PALDA"
                                },
                                {
                                    "Text": "PALDI",
                                    "Value": "PALDI"
                                },
                                {
                                    "Text": "PALEJ",
                                    "Value": "PALEJ"
                                },
                                {
                                    "Text": "PALITANA",
                                    "Value": "PALITANA"
                                },
                                {
                                    "Text": "PALI",
                                    "Value": "PALI"
                                },
                                {
                                    "Text": "PALI ",
                                    "Value": "PALI "
                                },
                                {
                                    "Text": "PALIA KALAN",
                                    "Value": "PALIA KALAN"
                                },
                                {
                                    "Text": "PALASA KASIBUGGA",
                                    "Value": "PALASA KASIBUGGA"
                                },
                                {
                                    "Text": "PALKHANDA",
                                    "Value": "PALKHANDA"
                                },
                                {
                                    "Text": "PALLADAM",
                                    "Value": "PALLADAM"
                                },
                                {
                                    "Text": "PALLEPAHAD ",
                                    "Value": "PALLEPAHAD "
                                },
                                {
                                    "Text": "PALLAVARAM",
                                    "Value": "PALLAVARAM"
                                },
                                {
                                    "Text": "PALLIKANAI",
                                    "Value": "PALLIKANAI"
                                },
                                {
                                    "Text": "PALLIPALAYAM",
                                    "Value": "PALLIPALAYAM"
                                },
                                {
                                    "Text": "PALLIPPURAM",
                                    "Value": "PALLIPPURAM"
                                },
                                {
                                    "Text": "PALLURUTHY",
                                    "Value": "PALLURUTHY"
                                },
                                {
                                    "Text": "PALPUR",
                                    "Value": "PALPUR"
                                },
                                {
                                    "Text": "PALUS",
                                    "Value": "PALUS"
                                },
                                {
                                    "Text": "PALVANCHA ",
                                    "Value": "PALVANCHA "
                                },
                                {
                                    "Text": "PALWAL",
                                    "Value": "PALWAL"
                                },
                                {
                                    "Text": "PALWANCHA",
                                    "Value": "PALWANCHA"
                                },
                                {
                                    "Text": "PAMAL",
                                    "Value": "PAMAL"
                                },
                                {
                                    "Text": "PAMGARH",
                                    "Value": "PAMGARH"
                                },
                                {
                                    "Text": "PAMOL",
                                    "Value": "PAMOL"
                                },
                                {
                                    "Text": "PAMPORE",
                                    "Value": "PAMPORE"
                                },
                                {
                                    "Text": "PANAJI",
                                    "Value": "PANAJI"
                                },
                                {
                                    "Text": "PANAGARH",
                                    "Value": "PANAGARH"
                                },
                                {
                                    "Text": "PANCHKULA",
                                    "Value": "PANCHKULA"
                                },
                                {
                                    "Text": "PANCH MAHALS",
                                    "Value": "PANCH MAHALS"
                                },
                                {
                                    "Text": "PANCHKULA",
                                    "Value": "PANCHKULA"
                                },
                                {
                                    "Text": "PANDHARKAWADA",
                                    "Value": "PANDHARKAWADA"
                                },
                                {
                                    "Text": "PANDHURNA",
                                    "Value": "PANDHURNA"
                                },
                                {
                                    "Text": "PANDORI GOLA ",
                                    "Value": "PANDORI GOLA "
                                },
                                {
                                    "Text": "PANDORI RANSINGH ",
                                    "Value": "PANDORI RANSINGH "
                                },
                                {
                                    "Text": "PANDORI TAKHTMAL ",
                                    "Value": "PANDORI TAKHTMAL "
                                },
                                {
                                    "Text": "PANDALAM",
                                    "Value": "PANDALAM"
                                },
                                {
                                    "Text": "PANDHARKAODA",
                                    "Value": "PANDHARKAODA"
                                },
                                {
                                    "Text": "PANDHARPUR",
                                    "Value": "PANDHARPUR"
                                },
                                {
                                    "Text": "PANDUA",
                                    "Value": "PANDUA"
                                },
                                {
                                    "Text": "PANDUKA",
                                    "Value": "PANDUKA"
                                },
                                {
                                    "Text": "PANIPAT",
                                    "Value": "PANIPAT"
                                },
                                {
                                    "Text": "PANJIM",
                                    "Value": "PANJIM"
                                },
                                {
                                    "Text": "PANJABARI",
                                    "Value": "PANJABARI"
                                },
                                {
                                    "Text": "PANJE KE",
                                    "Value": "PANJE KE"
                                },
                                {
                                    "Text": "PANJGRAIN KALAN",
                                    "Value": "PANJGRAIN KALAN"
                                },
                                {
                                    "Text": "PANNA",
                                    "Value": "PANNA"
                                },
                                {
                                    "Text": "PANVEL",
                                    "Value": "PANVEL"
                                },
                                {
                                    "Text": "PAONTA SAHIB",
                                    "Value": "PAONTA SAHIB"
                                },
                                {
                                    "Text": "PAPUM PARE",
                                    "Value": "PAPUM PARE"
                                },
                                {
                                    "Text": "PARADIP PORT",
                                    "Value": "PARADIP PORT"
                                },
                                {
                                    "Text": "PARASIYA ",
                                    "Value": "PARASIYA "
                                },
                                {
                                    "Text": "PARAM ",
                                    "Value": "PARAM "
                                },
                                {
                                    "Text": "PARA BAZAR",
                                    "Value": "PARA BAZAR"
                                },
                                {
                                    "Text": "PARA SARAY",
                                    "Value": "PARA SARAY"
                                },
                                {
                                    "Text": "PARABHANI",
                                    "Value": "PARABHANI"
                                },
                                {
                                    "Text": "PARADEEP",
                                    "Value": "PARADEEP"
                                },
                                {
                                    "Text": "PARAVUR",
                                    "Value": "PARAVUR"
                                },
                                {
                                    "Text": "PARBHANI",
                                    "Value": "PARBHANI"
                                },
                                {
                                    "Text": "PARDI",
                                    "Value": "PARDI"
                                },
                                {
                                    "Text": "PARGANAS",
                                    "Value": "PARGANAS"
                                },
                                {
                                    "Text": "PARKAL",
                                    "Value": "PARKAL"
                                },
                                {
                                    "Text": "PARLAKHEMUNDI",
                                    "Value": "PARLAKHEMUNDI"
                                },
                                {
                                    "Text": "PARLI",
                                    "Value": "PARLI"
                                },
                                {
                                    "Text": "PARMANAND",
                                    "Value": "PARMANAND"
                                },
                                {
                                    "Text": "PARNER",
                                    "Value": "PARNER"
                                },
                                {
                                    "Text": "PARSHUPURA ",
                                    "Value": "PARSHUPURA "
                                },
                                {
                                    "Text": "PARSOTTAMPUR",
                                    "Value": "PARSOTTAMPUR"
                                },
                                {
                                    "Text": "PARTHALA KHANJARPUR",
                                    "Value": "PARTHALA KHANJARPUR"
                                },
                                {
                                    "Text": "PARVATHIPURAM",
                                    "Value": "PARVATHIPURAM"
                                },
                                {
                                    "Text": "PARWANOO",
                                    "Value": "PARWANOO"
                                },
                                {
                                    "Text": "PASCHIMMIDNAPUR",
                                    "Value": "PASCHIMMIDNAPUR"
                                },
                                {
                                    "Text": "PASIGHAT",
                                    "Value": "PASIGHAT"
                                },
                                {
                                    "Text": "PASCHIMI SINGHBHUM",
                                    "Value": "PASCHIMI SINGHBHUM"
                                },
                                {
                                    "Text": "PATANCHERU",
                                    "Value": "PATANCHERU"
                                },
                                {
                                    "Text": "PATAN",
                                    "Value": "PATAN"
                                },
                                {
                                    "Text": "PATAUDI",
                                    "Value": "PATAUDI"
                                },
                                {
                                    "Text": "PATALGANGA",
                                    "Value": "PATALGANGA"
                                },
                                {
                                    "Text": "PATHANKOT",
                                    "Value": "PATHANKOT"
                                },
                                {
                                    "Text": "PATHANKOT",
                                    "Value": "PATHANKOT"
                                },
                                {
                                    "Text": "PATHANAMTHITTA",
                                    "Value": "PATHANAMTHITTA"
                                },
                                {
                                    "Text": "PATHRUD ",
                                    "Value": "PATHRUD "
                                },
                                {
                                    "Text": "PATHALGAON",
                                    "Value": "PATHALGAON"
                                },
                                {
                                    "Text": "PATHSALA",
                                    "Value": "PATHSALA"
                                },
                                {
                                    "Text": "PATHWAL",
                                    "Value": "PATHWAL"
                                },
                                {
                                    "Text": "PATIALA",
                                    "Value": "PATIALA"
                                },
                                {
                                    "Text": "PATIYALI",
                                    "Value": "PATIYALI"
                                },
                                {
                                    "Text": "PATNA",
                                    "Value": "PATNA"
                                },
                                {
                                    "Text": "PATRAN",
                                    "Value": "PATRAN"
                                },
                                {
                                    "Text": "PATRATU",
                                    "Value": "PATRATU"
                                },
                                {
                                    "Text": "PATTI PRATAPGARH",
                                    "Value": "PATTI PRATAPGARH"
                                },
                                {
                                    "Text": "PATTAMUNDAI",
                                    "Value": "PATTAMUNDAI"
                                },
                                {
                                    "Text": "PATTI",
                                    "Value": "PATTI"
                                },
                                {
                                    "Text": "PATTUKOTTAI",
                                    "Value": "PATTUKOTTAI"
                                },
                                {
                                    "Text": "PATTENAPALEM ",
                                    "Value": "PATTENAPALEM "
                                },
                                {
                                    "Text": "PATTI BASANTPUR ",
                                    "Value": "PATTI BASANTPUR "
                                },
                                {
                                    "Text": "PATTAMBI",
                                    "Value": "PATTAMBI"
                                },
                                {
                                    "Text": "PATTAN",
                                    "Value": "PATTAN"
                                },
                                {
                                    "Text": "PATTI,PRATAPGARH",
                                    "Value": "PATTI,PRATAPGARH"
                                },
                                {
                                    "Text": "PATWDH",
                                    "Value": "PATWDH"
                                },
                                {
                                    "Text": "PAURI GARHWAL",
                                    "Value": "PAURI GARHWAL"
                                },
                                {
                                    "Text": "PAYAL",
                                    "Value": "PAYAL"
                                },
                                {
                                    "Text": "PAYYANUR",
                                    "Value": "PAYYANUR"
                                },
                                {
                                    "Text": "PADAGHA",
                                    "Value": "PADAGHA"
                                },
                                {
                                    "Text": "PEDAMANDDADI ",
                                    "Value": "PEDAMANDDADI "
                                },
                                {
                                    "Text": "PEDDAPURAM",
                                    "Value": "PEDDAPURAM"
                                },
                                {
                                    "Text": "PEDDAPAHAD ",
                                    "Value": "PEDDAPAHAD "
                                },
                                {
                                    "Text": "PEDDAJUTUR ",
                                    "Value": "PEDDAJUTUR "
                                },
                                {
                                    "Text": "PEDDARANGAPURAM ",
                                    "Value": "PEDDARANGAPURAM "
                                },
                                {
                                    "Text": "PULIVENDLA BUS-STAND ",
                                    "Value": "PULIVENDLA BUS-STAND "
                                },
                                {
                                    "Text": "PEDDA BODDEPALLI ",
                                    "Value": "PEDDA BODDEPALLI "
                                },
                                {
                                    "Text": "PEDDAPALLE",
                                    "Value": "PEDDAPALLE"
                                },
                                {
                                    "Text": "PEDDAPUR",
                                    "Value": "PEDDAPUR"
                                },
                                {
                                    "Text": "PEEDAMPALLI",
                                    "Value": "PEEDAMPALLI"
                                },
                                {
                                    "Text": "PEGADAPALLI",
                                    "Value": "PEGADAPALLI"
                                },
                                {
                                    "Text": "PEHOWA",
                                    "Value": "PEHOWA"
                                },
                                {
                                    "Text": "PENDRA",
                                    "Value": "PENDRA"
                                },
                                {
                                    "Text": "PENUGONDA ",
                                    "Value": "PENUGONDA "
                                },
                                {
                                    "Text": "PEN",
                                    "Value": "PEN"
                                },
                                {
                                    "Text": "PERAMBALUR",
                                    "Value": "PERAMBALUR"
                                },
                                {
                                    "Text": "PERAMPETA ",
                                    "Value": "PERAMPETA "
                                },
                                {
                                    "Text": "PEREN",
                                    "Value": "PEREN"
                                },
                                {
                                    "Text": "PERUNGUDI",
                                    "Value": "PERUNGUDI"
                                },
                                {
                                    "Text": "PERINTHALMANNA",
                                    "Value": "PERINTHALMANNA"
                                },
                                {
                                    "Text": "PERINGANAM",
                                    "Value": "PERINGANAM"
                                },
                                {
                                    "Text": "PERIYAKULAM",
                                    "Value": "PERIYAKULAM"
                                },
                                {
                                    "Text": "PERIYANAIKENPALAYAM",
                                    "Value": "PERIYANAIKENPALAYAM"
                                },
                                {
                                    "Text": "PERKIT ",
                                    "Value": "PERKIT "
                                },
                                {
                                    "Text": "PERNEM",
                                    "Value": "PERNEM"
                                },
                                {
                                    "Text": "PERUMBAVOOR",
                                    "Value": "PERUMBAVOOR"
                                },
                                {
                                    "Text": "PERUNDURAI",
                                    "Value": "PERUNDURAI"
                                },
                                {
                                    "Text": "PERUNGALATHUR",
                                    "Value": "PERUNGALATHUR"
                                },
                                {
                                    "Text": "PETH KASBA",
                                    "Value": "PETH KASBA"
                                },
                                {
                                    "Text": "PETLAD",
                                    "Value": "PETLAD"
                                },
                                {
                                    "Text": "PHAGWARA",
                                    "Value": "PHAGWARA"
                                },
                                {
                                    "Text": "PHALTAN",
                                    "Value": "PHALTAN"
                                },
                                {
                                    "Text": "PHALODI",
                                    "Value": "PHALODI"
                                },
                                {
                                    "Text": "PHAPHRANA",
                                    "Value": "PHAPHRANA"
                                },
                                {
                                    "Text": "PHEK",
                                    "Value": "PHEK"
                                },
                                {
                                    "Text": "PHILLAUR",
                                    "Value": "PHILLAUR"
                                },
                                {
                                    "Text": "PEHLAD PUR BANGAR",
                                    "Value": "PEHLAD PUR BANGAR"
                                },
                                {
                                    "Text": "PHULERA",
                                    "Value": "PHULERA"
                                },
                                {
                                    "Text": "PHULPUR",
                                    "Value": "PHULPUR"
                                },
                                {
                                    "Text": "PHULMADDI ",
                                    "Value": "PHULMADDI "
                                },
                                {
                                    "Text": "PHUL",
                                    "Value": "PHUL"
                                },
                                {
                                    "Text": "PHULABANI",
                                    "Value": "PHULABANI"
                                },
                                {
                                    "Text": "PHULLANWALA",
                                    "Value": "PHULLANWALA"
                                },
                                {
                                    "Text": "PHURSO",
                                    "Value": "PHURSO"
                                },
                                {
                                    "Text": "PIDUGURALLA",
                                    "Value": "PIDUGURALLA"
                                },
                                {
                                    "Text": "PILERU",
                                    "Value": "PILERU"
                                },
                                {
                                    "Text": "PILIBANGA",
                                    "Value": "PILIBANGA"
                                },
                                {
                                    "Text": "PILIBHIT",
                                    "Value": "PILIBHIT"
                                },
                                {
                                    "Text": "PILLAYARKUPPAM ",
                                    "Value": "PILLAYARKUPPAM "
                                },
                                {
                                    "Text": "PILU KHERA",
                                    "Value": "PILU KHERA"
                                },
                                {
                                    "Text": "PIMPRI",
                                    "Value": "PIMPRI"
                                },
                                {
                                    "Text": "PINDI BALOCHAN",
                                    "Value": "PINDI BALOCHAN"
                                },
                                {
                                    "Text": "PINJORE",
                                    "Value": "PINJORE"
                                },
                                {
                                    "Text": "PIPARIYA",
                                    "Value": "PIPARIYA"
                                },
                                {
                                    "Text": "PIPLI ",
                                    "Value": "PIPLI "
                                },
                                {
                                    "Text": "PIPLI",
                                    "Value": "PIPLI"
                                },
                                {
                                    "Text": "PIPRI ",
                                    "Value": "PIPRI "
                                },
                                {
                                    "Text": "PIPRA ",
                                    "Value": "PIPRA "
                                },
                                {
                                    "Text": "PIPRAICH",
                                    "Value": "PIPRAICH"
                                },
                                {
                                    "Text": "PIRAVOM",
                                    "Value": "PIRAVOM"
                                },
                                {
                                    "Text": "PITHAMPUR",
                                    "Value": "PITHAMPUR"
                                },
                                {
                                    "Text": "PITHORAGARH",
                                    "Value": "PITHORAGARH"
                                },
                                {
                                    "Text": "PITHAPURAM",
                                    "Value": "PITHAPURAM"
                                },
                                {
                                    "Text": "PITHLA",
                                    "Value": "PITHLA"
                                },
                                {
                                    "Text": "POKHRAN",
                                    "Value": "POKHRAN"
                                },
                                {
                                    "Text": "PALGHAR",
                                    "Value": "PALGHAR"
                                },
                                {
                                    "Text": "PALANI",
                                    "Value": "PALANI"
                                },
                                {
                                    "Text": "PILKHUWA",
                                    "Value": "PILKHUWA"
                                },
                                {
                                    "Text": "PUL PEHLAD",
                                    "Value": "PUL PEHLAD"
                                },
                                {
                                    "Text": "PURMANDAL",
                                    "Value": "PURMANDAL"
                                },
                                {
                                    "Text": "PILANI",
                                    "Value": "PILANI"
                                },
                                {
                                    "Text": "PANAJI",
                                    "Value": "PANAJI"
                                },
                                {
                                    "Text": "PANSKURA",
                                    "Value": "PANSKURA"
                                },
                                {
                                    "Text": "POATA",
                                    "Value": "POATA"
                                },
                                {
                                    "Text": "PODILI",
                                    "Value": "PODILI"
                                },
                                {
                                    "Text": "POGATHOTA",
                                    "Value": "POGATHOTA"
                                },
                                {
                                    "Text": "POJEWAL",
                                    "Value": "POJEWAL"
                                },
                                {
                                    "Text": "POKHARIA ",
                                    "Value": "POKHARIA "
                                },
                                {
                                    "Text": "POLA ",
                                    "Value": "POLA "
                                },
                                {
                                    "Text": "POLICE LINES TARN TARAN SO",
                                    "Value": "POLICE LINES TARN TARAN SO"
                                },
                                {
                                    "Text": "POLLACHI",
                                    "Value": "POLLACHI"
                                },
                                {
                                    "Text": "POMBHURNA ",
                                    "Value": "POMBHURNA "
                                },
                                {
                                    "Text": "PONATA SAHIB",
                                    "Value": "PONATA SAHIB"
                                },
                                {
                                    "Text": "PONATA SAHIB",
                                    "Value": "PONATA SAHIB"
                                },
                                {
                                    "Text": "PONDA",
                                    "Value": "PONDA"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PONDI-UPRODA ",
                                    "Value": "PONDI-UPRODA "
                                },
                                {
                                    "Text": "PONNANI",
                                    "Value": "PONNANI"
                                },
                                {
                                    "Text": "PONNAM ",
                                    "Value": "PONNAM "
                                },
                                {
                                    "Text": "PONNUR",
                                    "Value": "PONNUR"
                                },
                                {
                                    "Text": "POONCH",
                                    "Value": "POONCH"
                                },
                                {
                                    "Text": "POONDI",
                                    "Value": "POONDI"
                                },
                                {
                                    "Text": "POONGAMOODU",
                                    "Value": "POONGAMOODU"
                                },
                                {
                                    "Text": "PORANKI",
                                    "Value": "PORANKI"
                                },
                                {
                                    "Text": "PORBANDER",
                                    "Value": "PORBANDER"
                                },
                                {
                                    "Text": "PORBANDAR",
                                    "Value": "PORBANDAR"
                                },
                                {
                                    "Text": "PORT BLAIR",
                                    "Value": "PORT BLAIR"
                                },
                                {
                                    "Text": "PORVORIM",
                                    "Value": "PORVORIM"
                                },
                                {
                                    "Text": "POR",
                                    "Value": "POR"
                                },
                                {
                                    "Text": "POST LONI",
                                    "Value": "POST LONI"
                                },
                                {
                                    "Text": "POST SURAJPUR",
                                    "Value": "POST SURAJPUR"
                                },
                                {
                                    "Text": "POTTAPALAYAM ",
                                    "Value": "POTTAPALAYAM "
                                },
                                {
                                    "Text": "POWAI",
                                    "Value": "POWAI"
                                },
                                {
                                    "Text": "POWAYAN",
                                    "Value": "POWAYAN"
                                },
                                {
                                    "Text": "PRAKASAM",
                                    "Value": "PRAKASAM"
                                },
                                {
                                    "Text": "PRANTIJ",
                                    "Value": "PRANTIJ"
                                },
                                {
                                    "Text": "PRASADRAOPETA",
                                    "Value": "PRASADRAOPETA"
                                },
                                {
                                    "Text": "PRATAPGARH",
                                    "Value": "PRATAPGARH"
                                },
                                {
                                    "Text": "PRATAPGARH",
                                    "Value": "PRATAPGARH"
                                },
                                {
                                    "Text": "PIPRALI ROAD",
                                    "Value": "PIPRALI ROAD"
                                },
                                {
                                    "Text": "PRODDATUR",
                                    "Value": "PRODDATUR"
                                },
                                {
                                    "Text": "PRODDATTUR",
                                    "Value": "PRODDATTUR"
                                },
                                {
                                    "Text": "PARASIA",
                                    "Value": "PARASIA"
                                },
                                {
                                    "Text": "PARATWADA",
                                    "Value": "PARATWADA"
                                },
                                {
                                    "Text": "PASTHAL",
                                    "Value": "PASTHAL"
                                },
                                {
                                    "Text": "POOTH KHURD",
                                    "Value": "POOTH KHURD"
                                },
                                {
                                    "Text": "POOTH KALAN",
                                    "Value": "POOTH KALAN"
                                },
                                {
                                    "Text": "PATALA",
                                    "Value": "PATALA"
                                },
                                {
                                    "Text": "PTU CAMPUS KAPURTHALA ",
                                    "Value": "PTU CAMPUS KAPURTHALA "
                                },
                                {
                                    "Text": "PUDHUPAKKAM",
                                    "Value": "PUDHUPAKKAM"
                                },
                                {
                                    "Text": "PUDUKOTTAI",
                                    "Value": "PUDUKOTTAI"
                                },
                                {
                                    "Text": "PUDUKKOTTAI",
                                    "Value": "PUDUKKOTTAI"
                                },
                                {
                                    "Text": "PUDUR ",
                                    "Value": "PUDUR "
                                },
                                {
                                    "Text": "PUDUCHERRY",
                                    "Value": "PUDUCHERRY"
                                },
                                {
                                    "Text": "PUKHRAYAN",
                                    "Value": "PUKHRAYAN"
                                },
                                {
                                    "Text": "PULAPALLI ",
                                    "Value": "PULAPALLI "
                                },
                                {
                                    "Text": "PULIVENDLAKUTCHERRY ",
                                    "Value": "PULIVENDLAKUTCHERRY "
                                },
                                {
                                    "Text": "PULIVENDULA",
                                    "Value": "PULIVENDULA"
                                },
                                {
                                    "Text": "PULUSMAMIDI ",
                                    "Value": "PULUSMAMIDI "
                                },
                                {
                                    "Text": "PULWAMA",
                                    "Value": "PULWAMA"
                                },
                                {
                                    "Text": "PUNALUR",
                                    "Value": "PUNALUR"
                                },
                                {
                                    "Text": "PUNDRI",
                                    "Value": "PUNDRI"
                                },
                                {
                                    "Text": "PUNE",
                                    "Value": "PUNE"
                                },
                                {
                                    "Text": "PUNGANUR",
                                    "Value": "PUNGANUR"
                                },
                                {
                                    "Text": "PUNJABARI",
                                    "Value": "PUNJABARI"
                                },
                                {
                                    "Text": "PURANA MOGA ",
                                    "Value": "PURANA MOGA "
                                },
                                {
                                    "Text": "PURAINA ",
                                    "Value": "PURAINA "
                                },
                                {
                                    "Text": "PURANPUR",
                                    "Value": "PURANPUR"
                                },
                                {
                                    "Text": "PURBA MEDINIPUR",
                                    "Value": "PURBA MEDINIPUR"
                                },
                                {
                                    "Text": "PURI",
                                    "Value": "PURI"
                                },
                                {
                                    "Text": "PURNEA",
                                    "Value": "PURNEA"
                                },
                                {
                                    "Text": "PURNIA",
                                    "Value": "PURNIA"
                                },
                                {
                                    "Text": "PURQUAZI",
                                    "Value": "PURQUAZI"
                                },
                                {
                                    "Text": "PURULIA",
                                    "Value": "PURULIA"
                                },
                                {
                                    "Text": "PURULIYA",
                                    "Value": "PURULIYA"
                                },
                                {
                                    "Text": "PURVI CHAMPARAN",
                                    "Value": "PURVI CHAMPARAN"
                                },
                                {
                                    "Text": "PURWA",
                                    "Value": "PURWA"
                                },
                                {
                                    "Text": "PUSAD",
                                    "Value": "PUSAD"
                                },
                                {
                                    "Text": "PUSHPARAJGARH",
                                    "Value": "PUSHPARAJGARH"
                                },
                                {
                                    "Text": "PUTHENCHIRA",
                                    "Value": "PUTHENCHIRA"
                                },
                                {
                                    "Text": "PUTTAPARTHY",
                                    "Value": "PUTTAPARTHY"
                                },
                                {
                                    "Text": "PUTTUR",
                                    "Value": "PUTTUR"
                                },
                                {
                                    "Text": "PUTTAPARTHI",
                                    "Value": "PUTTAPARTHI"
                                },
                                {
                                    "Text": "PUTTUR",
                                    "Value": "PUTTUR"
                                },
                                {
                                    "Text": "PYARARAM ",
                                    "Value": "PYARARAM "
                                },
                                {
                                    "Text": "PYNURSLA",
                                    "Value": "PYNURSLA"
                                },
                                {
                                    "Text": "QADIAN",
                                    "Value": "QADIAN"
                                },
                                {
                                    "Text": "QILLA KAVI SANTOKH ",
                                    "Value": "QILLA KAVI SANTOKH "
                                },
                                {
                                    "Text": "QUAMMRUDDIN NAGAR",
                                    "Value": "QUAMMRUDDIN NAGAR"
                                },
                                {
                                    "Text": "QUEPEM",
                                    "Value": "QUEPEM"
                                },
                                {
                                    "Text": "QUILANDI",
                                    "Value": "QUILANDI"
                                },
                                {
                                    "Text": "QUILA NAU ",
                                    "Value": "QUILA NAU "
                                },
                                {
                                    "Text": "QAZIGUND",
                                    "Value": "QAZIGUND"
                                },
                                {
                                    "Text": "RADAUR",
                                    "Value": "RADAUR"
                                },
                                {
                                    "Text": "RADHANPUR",
                                    "Value": "RADHANPUR"
                                },
                                {
                                    "Text": "RAE BARELI",
                                    "Value": "RAE BARELI"
                                },
                                {
                                    "Text": "RAEBARELI",
                                    "Value": "RAEBARELI"
                                },
                                {
                                    "Text": "RAEKOT",
                                    "Value": "RAEKOT"
                                },
                                {
                                    "Text": "RAGADAPA ",
                                    "Value": "RAGADAPA "
                                },
                                {
                                    "Text": "RAGHUDEVAPURAM",
                                    "Value": "RAGHUDEVAPURAM"
                                },
                                {
                                    "Text": "RAGHAVAPET",
                                    "Value": "RAGHAVAPET"
                                },
                                {
                                    "Text": "RAHATA",
                                    "Value": "RAHATA"
                                },
                                {
                                    "Text": "RAHIAD",
                                    "Value": "RAHIAD"
                                },
                                {
                                    "Text": "RAHON",
                                    "Value": "RAHON"
                                },
                                {
                                    "Text": "RAHURI",
                                    "Value": "RAHURI"
                                },
                                {
                                    "Text": "RAICHUR",
                                    "Value": "RAICHUR"
                                },
                                {
                                    "Text": "RAIGARH(MH)",
                                    "Value": "RAIGARH(MH)"
                                },
                                {
                                    "Text": "RAIGAD",
                                    "Value": "RAIGAD"
                                },
                                {
                                    "Text": "RAIGARH",
                                    "Value": "RAIGARH"
                                },
                                {
                                    "Text": "RAIGANJ",
                                    "Value": "RAIGANJ"
                                },
                                {
                                    "Text": "RAIKOT",
                                    "Value": "RAIKOT"
                                },
                                {
                                    "Text": "RAILMAJRA",
                                    "Value": "RAILMAJRA"
                                },
                                {
                                    "Text": "RAIPUR",
                                    "Value": "RAIPUR"
                                },
                                {
                                    "Text": "RAIPUR RANI",
                                    "Value": "RAIPUR RANI"
                                },
                                {
                                    "Text": "RAIR KALAN",
                                    "Value": "RAIR KALAN"
                                },
                                {
                                    "Text": "RAIRANGPUR",
                                    "Value": "RAIRANGPUR"
                                },
                                {
                                    "Text": "RAISINGHNAGAR",
                                    "Value": "RAISINGHNAGAR"
                                },
                                {
                                    "Text": "RAISEN",
                                    "Value": "RAISEN"
                                },
                                {
                                    "Text": "RAISAR",
                                    "Value": "RAISAR"
                                },
                                {
                                    "Text": "RAJAURI",
                                    "Value": "RAJAURI"
                                },
                                {
                                    "Text": "RAJAHMUNDRY",
                                    "Value": "RAJAHMUNDRY"
                                },
                                {
                                    "Text": "RAJAM",
                                    "Value": "RAJAM"
                                },
                                {
                                    "Text": "RAJAPALAYAM",
                                    "Value": "RAJAPALAYAM"
                                },
                                {
                                    "Text": "RAJA SANSI",
                                    "Value": "RAJA SANSI"
                                },
                                {
                                    "Text": "RAJAGANGAPUR",
                                    "Value": "RAJAGANGAPUR"
                                },
                                {
                                    "Text": "RAJAMPET",
                                    "Value": "RAJAMPET"
                                },
                                {
                                    "Text": "RAJARHAT GOPALPUR",
                                    "Value": "RAJARHAT GOPALPUR"
                                },
                                {
                                    "Text": "RAJASMAND",
                                    "Value": "RAJASMAND"
                                },
                                {
                                    "Text": "RAJAUND",
                                    "Value": "RAJAUND"
                                },
                                {
                                    "Text": "RAJBALLABHPUR",
                                    "Value": "RAJBALLABHPUR"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGARH",
                                    "Value": "RAJGARH"
                                },
                                {
                                    "Text": "RAJGIR",
                                    "Value": "RAJGIR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJGHAR",
                                    "Value": "RAJGHAR"
                                },
                                {
                                    "Text": "RAJIM",
                                    "Value": "RAJIM"
                                },
                                {
                                    "Text": "RAJIA",
                                    "Value": "RAJIA"
                                },
                                {
                                    "Text": "RAJKOT",
                                    "Value": "RAJKOT"
                                },
                                {
                                    "Text": "RAJNANDGAON",
                                    "Value": "RAJNANDGAON"
                                },
                                {
                                    "Text": "RAJNADGAON",
                                    "Value": "RAJNADGAON"
                                },
                                {
                                    "Text": "RAJOKRI",
                                    "Value": "RAJOKRI"
                                },
                                {
                                    "Text": "RAJOLE ",
                                    "Value": "RAJOLE "
                                },
                                {
                                    "Text": "RAJOWALA ",
                                    "Value": "RAJOWALA "
                                },
                                {
                                    "Text": "RAJOSANA",
                                    "Value": "RAJOSANA"
                                },
                                {
                                    "Text": "RAJOURI",
                                    "Value": "RAJOURI"
                                },
                                {
                                    "Text": "RAJPIPLA",
                                    "Value": "RAJPIPLA"
                                },
                                {
                                    "Text": "RAJPURA",
                                    "Value": "RAJPURA"
                                },
                                {
                                    "Text": "RAJPURA TOWNSHIP ",
                                    "Value": "RAJPURA TOWNSHIP "
                                },
                                {
                                    "Text": "RAJPUR BHAIAN",
                                    "Value": "RAJPUR BHAIAN"
                                },
                                {
                                    "Text": "RAJSAMAND",
                                    "Value": "RAJSAMAND"
                                },
                                {
                                    "Text": "RAJULA",
                                    "Value": "RAJULA"
                                },
                                {
                                    "Text": "RAJUPAKALU ",
                                    "Value": "RAJUPAKALU "
                                },
                                {
                                    "Text": "RAJUR",
                                    "Value": "RAJUR"
                                },
                                {
                                    "Text": "RAJURA",
                                    "Value": "RAJURA"
                                },
                                {
                                    "Text": "RAKANPUR",
                                    "Value": "RAKANPUR"
                                },
                                {
                                    "Text": "RAMAN",
                                    "Value": "RAMAN"
                                },
                                {
                                    "Text": "RAMANAGAR",
                                    "Value": "RAMANAGAR"
                                },
                                {
                                    "Text": "RAMANATHAPURAM",
                                    "Value": "RAMANATHAPURAM"
                                },
                                {
                                    "Text": "RAMANATHGUDPALLY ",
                                    "Value": "RAMANATHGUDPALLY "
                                },
                                {
                                    "Text": "RAMACHANDRAPURAM OLD TOWN ",
                                    "Value": "RAMACHANDRAPURAM OLD TOWN "
                                },
                                {
                                    "Text": "RAMACHANDRAPURAM",
                                    "Value": "RAMACHANDRAPURAM"
                                },
                                {
                                    "Text": "RAMAGUNDAM",
                                    "Value": "RAMAGUNDAM"
                                },
                                {
                                    "Text": "RAMANAGARAM",
                                    "Value": "RAMANAGARAM"
                                },
                                {
                                    "Text": "RAMANUJGANJ",
                                    "Value": "RAMANUJGANJ"
                                },
                                {
                                    "Text": "RAMAPURAM",
                                    "Value": "RAMAPURAM"
                                },
                                {
                                    "Text": "RAMDAS",
                                    "Value": "RAMDAS"
                                },
                                {
                                    "Text": "RAMDAS (M CL)",
                                    "Value": "RAMDAS (M CL)"
                                },
                                {
                                    "Text": "RAMESWARPUR",
                                    "Value": "RAMESWARPUR"
                                },
                                {
                                    "Text": "RAMGARH CANTT",
                                    "Value": "RAMGARH CANTT"
                                },
                                {
                                    "Text": "RAMGARH",
                                    "Value": "RAMGARH"
                                },
                                {
                                    "Text": "RAMGARH",
                                    "Value": "RAMGARH"
                                },
                                {
                                    "Text": "RAMGARH CANTT.",
                                    "Value": "RAMGARH CANTT."
                                },
                                {
                                    "Text": "RAMGANJ MANDI",
                                    "Value": "RAMGANJ MANDI"
                                },
                                {
                                    "Text": "RAMNAGAR ",
                                    "Value": "RAMNAGAR "
                                },
                                {
                                    "Text": "RAMNAGAR",
                                    "Value": "RAMNAGAR"
                                },
                                {
                                    "Text": "RAMPURA PHUL",
                                    "Value": "RAMPURA PHUL"
                                },
                                {
                                    "Text": "RAMPUR",
                                    "Value": "RAMPUR"
                                },
                                {
                                    "Text": "RAMPUR",
                                    "Value": "RAMPUR"
                                },
                                {
                                    "Text": "RAMPUR JAGIR",
                                    "Value": "RAMPUR JAGIR"
                                },
                                {
                                    "Text": "RAMPURA",
                                    "Value": "RAMPURA"
                                },
                                {
                                    "Text": "RAMPURHAT",
                                    "Value": "RAMPURHAT"
                                },
                                {
                                    "Text": "RAMTEK",
                                    "Value": "RAMTEK"
                                },
                                {
                                    "Text": "RANAGHAT",
                                    "Value": "RANAGHAT"
                                },
                                {
                                    "Text": "RANBIR SINGH PORA",
                                    "Value": "RANBIR SINGH PORA"
                                },
                                {
                                    "Text": "RANCHI",
                                    "Value": "RANCHI"
                                },
                                {
                                    "Text": "RANEBENNUR",
                                    "Value": "RANEBENNUR"
                                },
                                {
                                    "Text": "RANGAREDDI",
                                    "Value": "RANGAREDDI"
                                },
                                {
                                    "Text": "RANGAREDDY",
                                    "Value": "RANGAREDDY"
                                },
                                {
                                    "Text": "RANGIA",
                                    "Value": "RANGIA"
                                },
                                {
                                    "Text": "RANGIAN",
                                    "Value": "RANGIAN"
                                },
                                {
                                    "Text": "RANGIBASAN",
                                    "Value": "RANGIBASAN"
                                },
                                {
                                    "Text": "RANGPO",
                                    "Value": "RANGPO"
                                },
                                {
                                    "Text": "RANIA",
                                    "Value": "RANIA"
                                },
                                {
                                    "Text": "RANIPET",
                                    "Value": "RANIPET"
                                },
                                {
                                    "Text": "RANIBENNUR",
                                    "Value": "RANIBENNUR"
                                },
                                {
                                    "Text": "RANIGANJ",
                                    "Value": "RANIGANJ"
                                },
                                {
                                    "Text": "RANIPETTAI",
                                    "Value": "RANIPETTAI"
                                },
                                {
                                    "Text": "RANIPOOL",
                                    "Value": "RANIPOOL"
                                },
                                {
                                    "Text": "RANIPUR",
                                    "Value": "RANIPUR"
                                },
                                {
                                    "Text": "RANJANGAON",
                                    "Value": "RANJANGAON"
                                },
                                {
                                    "Text": "RANNY",
                                    "Value": "RANNY"
                                },
                                {
                                    "Text": "RANNI",
                                    "Value": "RANNI"
                                },
                                {
                                    "Text": "RAPALLE",
                                    "Value": "RAPALLE"
                                },
                                {
                                    "Text": "RASIPURAM",
                                    "Value": "RASIPURAM"
                                },
                                {
                                    "Text": "RASUPUR BANKIYA ",
                                    "Value": "RASUPUR BANKIYA "
                                },
                                {
                                    "Text": "RASULPUR",
                                    "Value": "RASULPUR"
                                },
                                {
                                    "Text": "RATHONDA ",
                                    "Value": "RATHONDA "
                                },
                                {
                                    "Text": "RATH",
                                    "Value": "RATH"
                                },
                                {
                                    "Text": "RATIA",
                                    "Value": "RATIA"
                                },
                                {
                                    "Text": "RATLAM",
                                    "Value": "RATLAM"
                                },
                                {
                                    "Text": "RATNAGIRI",
                                    "Value": "RATNAGIRI"
                                },
                                {
                                    "Text": "RATNARI",
                                    "Value": "RATNARI"
                                },
                                {
                                    "Text": "RATTEWAL",
                                    "Value": "RATTEWAL"
                                },
                                {
                                    "Text": "RAU",
                                    "Value": "RAU"
                                },
                                {
                                    "Text": "RAULI ",
                                    "Value": "RAULI "
                                },
                                {
                                    "Text": "RAVER",
                                    "Value": "RAVER"
                                },
                                {
                                    "Text": "RAVULAPALEM",
                                    "Value": "RAVULAPALEM"
                                },
                                {
                                    "Text": "RAWAT BHATA",
                                    "Value": "RAWAT BHATA"
                                },
                                {
                                    "Text": "RAWATSAR",
                                    "Value": "RAWATSAR"
                                },
                                {
                                    "Text": "RAXAUL BAZAR",
                                    "Value": "RAXAUL BAZAR"
                                },
                                {
                                    "Text": "RAYAGADA",
                                    "Value": "RAYAGADA"
                                },
                                {
                                    "Text": "RAYA",
                                    "Value": "RAYA"
                                },
                                {
                                    "Text": "RAYACHOTI",
                                    "Value": "RAYACHOTI"
                                },
                                {
                                    "Text": "RAYADURG",
                                    "Value": "RAYADURG"
                                },
                                {
                                    "Text": "RAYINI PALEM ",
                                    "Value": "RAYINI PALEM "
                                },
                                {
                                    "Text": "RAYYA",
                                    "Value": "RAYYA"
                                },
                                {
                                    "Text": "REASI",
                                    "Value": "REASI"
                                },
                                {
                                    "Text": "REDDIAL ",
                                    "Value": "REDDIAL "
                                },
                                {
                                    "Text": "REDDICHAVADI ",
                                    "Value": "REDDICHAVADI "
                                },
                                {
                                    "Text": "REDDIPALLE",
                                    "Value": "REDDIPALLE"
                                },
                                {
                                    "Text": "RED HILLS",
                                    "Value": "RED HILLS"
                                },
                                {
                                    "Text": "REHANA JATTAN",
                                    "Value": "REHANA JATTAN"
                                },
                                {
                                    "Text": "REKANG PEO",
                                    "Value": "REKANG PEO"
                                },
                                {
                                    "Text": "RENGALI",
                                    "Value": "RENGALI"
                                },
                                {
                                    "Text": "RENUKOOT",
                                    "Value": "RENUKOOT"
                                },
                                {
                                    "Text": "REPALLE",
                                    "Value": "REPALLE"
                                },
                                {
                                    "Text": "REWA",
                                    "Value": "REWA"
                                },
                                {
                                    "Text": "REWARI",
                                    "Value": "REWARI"
                                },
                                {
                                    "Text": "RAFIGANJ",
                                    "Value": "RAFIGANJ"
                                },
                                {
                                    "Text": "RI BHOI",
                                    "Value": "RI BHOI"
                                },
                                {
                                    "Text": "RISHIKESH",
                                    "Value": "RISHIKESH"
                                },
                                {
                                    "Text": "RISHRA",
                                    "Value": "RISHRA"
                                },
                                {
                                    "Text": "RAMPUR (MOTIHARI)",
                                    "Value": "RAMPUR (MOTIHARI)"
                                },
                                {
                                    "Text": "RANIKHET",
                                    "Value": "RANIKHET"
                                },
                                {
                                    "Text": "ROBERTSGANJ",
                                    "Value": "ROBERTSGANJ"
                                },
                                {
                                    "Text": "RODHA",
                                    "Value": "RODHA"
                                },
                                {
                                    "Text": "ROHA ASHTAMI",
                                    "Value": "ROHA ASHTAMI"
                                },
                                {
                                    "Text": "ROHERIANWALI",
                                    "Value": "ROHERIANWALI"
                                },
                                {
                                    "Text": "ROHRU",
                                    "Value": "ROHRU"
                                },
                                {
                                    "Text": "ROHTAK",
                                    "Value": "ROHTAK"
                                },
                                {
                                    "Text": "ROHTAS",
                                    "Value": "ROHTAS"
                                },
                                {
                                    "Text": "ROING",
                                    "Value": "ROING"
                                },
                                {
                                    "Text": "ROORKEE",
                                    "Value": "ROORKEE"
                                },
                                {
                                    "Text": "ROORKEE",
                                    "Value": "ROORKEE"
                                },
                                {
                                    "Text": "ROPAR",
                                    "Value": "ROPAR"
                                },
                                {
                                    "Text": "RORANWALA",
                                    "Value": "RORANWALA"
                                },
                                {
                                    "Text": "ROURKELA",
                                    "Value": "ROURKELA"
                                },
                                {
                                    "Text": "RUPNARAYANPUR",
                                    "Value": "RUPNARAYANPUR"
                                },
                                {
                                    "Text": "RSARA",
                                    "Value": "RSARA"
                                },
                                {
                                    "Text": "ROSHAN PURA",
                                    "Value": "ROSHAN PURA"
                                },
                                {
                                    "Text": "RATANGARH",
                                    "Value": "RATANGARH"
                                },
                                {
                                    "Text": "R THUMMALAPALLE ",
                                    "Value": "R THUMMALAPALLE "
                                },
                                {
                                    "Text": "RUDAULI",
                                    "Value": "RUDAULI"
                                },
                                {
                                    "Text": "RUDEL",
                                    "Value": "RUDEL"
                                },
                                {
                                    "Text": "RUDRAPUR",
                                    "Value": "RUDRAPUR"
                                },
                                {
                                    "Text": "RUDRAPRAYAG",
                                    "Value": "RUDRAPRAYAG"
                                },
                                {
                                    "Text": "RUDRARAM ",
                                    "Value": "RUDRARAM "
                                },
                                {
                                    "Text": "RUPANA",
                                    "Value": "RUPANA"
                                },
                                {
                                    "Text": "RUPNAGAR",
                                    "Value": "RUPNAGAR"
                                },
                                {
                                    "Text": "RUSTAPUR ",
                                    "Value": "RUSTAPUR "
                                },
                                {
                                    "Text": "SABARKANTHA",
                                    "Value": "SABARKANTHA"
                                },
                                {
                                    "Text": "SABHRA",
                                    "Value": "SABHRA"
                                },
                                {
                                    "Text": "SABOUR",
                                    "Value": "SABOUR"
                                },
                                {
                                    "Text": "SADABAD",
                                    "Value": "SADABAD"
                                },
                                {
                                    "Text": "SADHAURA",
                                    "Value": "SADHAURA"
                                },
                                {
                                    "Text": "SADI",
                                    "Value": "SADI"
                                },
                                {
                                    "Text": "SADIQ",
                                    "Value": "SADIQ"
                                },
                                {
                                    "Text": "SADULSAHAR",
                                    "Value": "SADULSAHAR"
                                },
                                {
                                    "Text": "SAFIDON",
                                    "Value": "SAFIDON"
                                },
                                {
                                    "Text": "SAGAR",
                                    "Value": "SAGAR"
                                },
                                {
                                    "Text": "SAGAR",
                                    "Value": "SAGAR"
                                },
                                {
                                    "Text": "SAGWARA",
                                    "Value": "SAGWARA"
                                },
                                {
                                    "Text": "SAHARANPUR",
                                    "Value": "SAHARANPUR"
                                },
                                {
                                    "Text": "SAHARSA",
                                    "Value": "SAHARSA"
                                },
                                {
                                    "Text": "SAHA",
                                    "Value": "SAHA"
                                },
                                {
                                    "Text": "SAHABUDDINPUR",
                                    "Value": "SAHABUDDINPUR"
                                },
                                {
                                    "Text": "SAHAURAN",
                                    "Value": "SAHAURAN"
                                },
                                {
                                    "Text": "SAHIBZADA AJIT SINGH NAGAR",
                                    "Value": "SAHIBZADA AJIT SINGH NAGAR"
                                },
                                {
                                    "Text": "SAHIBGANJ",
                                    "Value": "SAHIBGANJ"
                                },
                                {
                                    "Text": "SAHIBABAD",
                                    "Value": "SAHIBABAD"
                                },
                                {
                                    "Text": "SAHIBZADA AJIT SINGH NAGAR",
                                    "Value": "SAHIBZADA AJIT SINGH NAGAR"
                                },
                                {
                                    "Text": "SAHJANWA",
                                    "Value": "SAHJANWA"
                                },
                                {
                                    "Text": "SAHNEWAL",
                                    "Value": "SAHNEWAL"
                                },
                                {
                                    "Text": "SAIDUL AJAIB",
                                    "Value": "SAIDUL AJAIB"
                                },
                                {
                                    "Text": "SAIHA",
                                    "Value": "SAIHA"
                                },
                                {
                                    "Text": "SAILA KHURD",
                                    "Value": "SAILA KHURD"
                                },
                                {
                                    "Text": "SAILU",
                                    "Value": "SAILU"
                                },
                                {
                                    "Text": "SAINTHIA",
                                    "Value": "SAINTHIA"
                                },
                                {
                                    "Text": "SAINI MAJRA",
                                    "Value": "SAINI MAJRA"
                                },
                                {
                                    "Text": "SAINJ",
                                    "Value": "SAINJ"
                                },
                                {
                                    "Text": "SAKAT SANALA",
                                    "Value": "SAKAT SANALA"
                                },
                                {
                                    "Text": "SALAIRANI",
                                    "Value": "SALAIRANI"
                                },
                                {
                                    "Text": "SALBARI ",
                                    "Value": "SALBARI "
                                },
                                {
                                    "Text": "SALCETTE",
                                    "Value": "SALCETTE"
                                },
                                {
                                    "Text": "SALEM",
                                    "Value": "SALEM"
                                },
                                {
                                    "Text": "SALEMPUR",
                                    "Value": "SALEMPUR"
                                },
                                {
                                    "Text": "SALEPUR",
                                    "Value": "SALEPUR"
                                },
                                {
                                    "Text": "SALIGAO",
                                    "Value": "SALIGAO"
                                },
                                {
                                    "Text": "SALKA ",
                                    "Value": "SALKA "
                                },
                                {
                                    "Text": "SALON",
                                    "Value": "SALON"
                                },
                                {
                                    "Text": "SALUR",
                                    "Value": "SALUR"
                                },
                                {
                                    "Text": "SALUNI",
                                    "Value": "SALUNI"
                                },
                                {
                                    "Text": "SAMANA",
                                    "Value": "SAMANA"
                                },
                                {
                                    "Text": "SAMALKHA",
                                    "Value": "SAMALKHA"
                                },
                                {
                                    "Text": "SAMASTIPUR",
                                    "Value": "SAMASTIPUR"
                                },
                                {
                                    "Text": "SAMADPUR HARDAS ",
                                    "Value": "SAMADPUR HARDAS "
                                },
                                {
                                    "Text": "SAMADA",
                                    "Value": "SAMADA"
                                },
                                {
                                    "Text": "SAMAIPUR",
                                    "Value": "SAMAIPUR"
                                },
                                {
                                    "Text": "SAMBALPUR",
                                    "Value": "SAMBALPUR"
                                },
                                {
                                    "Text": "SAMBA",
                                    "Value": "SAMBA"
                                },
                                {
                                    "Text": "SAMBA",
                                    "Value": "SAMBA"
                                },
                                {
                                    "Text": "SAMBHAL",
                                    "Value": "SAMBHAL"
                                },
                                {
                                    "Text": "SAMBHAR",
                                    "Value": "SAMBHAR"
                                },
                                {
                                    "Text": "SAMGAULI",
                                    "Value": "SAMGAULI"
                                },
                                {
                                    "Text": "SAMLOD",
                                    "Value": "SAMLOD"
                                },
                                {
                                    "Text": "SAMOU",
                                    "Value": "SAMOU"
                                },
                                {
                                    "Text": "SAMPLA",
                                    "Value": "SAMPLA"
                                },
                                {
                                    "Text": "SAMPURA",
                                    "Value": "SAMPURA"
                                },
                                {
                                    "Text": "SAMPURNA NAGAR",
                                    "Value": "SAMPURNA NAGAR"
                                },
                                {
                                    "Text": "SAMRALA",
                                    "Value": "SAMRALA"
                                },
                                {
                                    "Text": "SANAND",
                                    "Value": "SANAND"
                                },
                                {
                                    "Text": "SANATHAL",
                                    "Value": "SANATHAL"
                                },
                                {
                                    "Text": "SANAUR",
                                    "Value": "SANAUR"
                                },
                                {
                                    "Text": "SANAWAD",
                                    "Value": "SANAWAD"
                                },
                                {
                                    "Text": "SANCHORE",
                                    "Value": "SANCHORE"
                                },
                                {
                                    "Text": "SANDUR",
                                    "Value": "SANDUR"
                                },
                                {
                                    "Text": "SANDHAI",
                                    "Value": "SANDHAI"
                                },
                                {
                                    "Text": "SANDHAUR",
                                    "Value": "SANDHAUR"
                                },
                                {
                                    "Text": "SANDILA",
                                    "Value": "SANDILA"
                                },
                                {
                                    "Text": "SANEHWAL",
                                    "Value": "SANEHWAL"
                                },
                                {
                                    "Text": "SANETA",
                                    "Value": "SANETA"
                                },
                                {
                                    "Text": "SANGAMNER",
                                    "Value": "SANGAMNER"
                                },
                                {
                                    "Text": "SANGLI",
                                    "Value": "SANGLI"
                                },
                                {
                                    "Text": "SANGARIA",
                                    "Value": "SANGARIA"
                                },
                                {
                                    "Text": "SANGRUR",
                                    "Value": "SANGRUR"
                                },
                                {
                                    "Text": "SANGANER",
                                    "Value": "SANGANER"
                                },
                                {
                                    "Text": "SANGANA ",
                                    "Value": "SANGANA "
                                },
                                {
                                    "Text": "SANGAT",
                                    "Value": "SANGAT"
                                },
                                {
                                    "Text": "SANGLI-MIRAJ-KUPWAD",
                                    "Value": "SANGLI-MIRAJ-KUPWAD"
                                },
                                {
                                    "Text": "SANGUEM",
                                    "Value": "SANGUEM"
                                },
                                {
                                    "Text": "SANIVARAM ",
                                    "Value": "SANIVARAM "
                                },
                                {
                                    "Text": "SANJAY NAGAR ",
                                    "Value": "SANJAY NAGAR "
                                },
                                {
                                    "Text": "SANJALI",
                                    "Value": "SANJALI"
                                },
                                {
                                    "Text": "SANJAN",
                                    "Value": "SANJAN"
                                },
                                {
                                    "Text": "SANJAULI",
                                    "Value": "SANJAULI"
                                },
                                {
                                    "Text": "SANKAGIRI",
                                    "Value": "SANKAGIRI"
                                },
                                {
                                    "Text": "SANKESHWAR",
                                    "Value": "SANKESHWAR"
                                },
                                {
                                    "Text": "SANOTH",
                                    "Value": "SANOTH"
                                },
                                {
                                    "Text": "SANPERA",
                                    "Value": "SANPERA"
                                },
                                {
                                    "Text": "SANQUELIM",
                                    "Value": "SANQUELIM"
                                },
                                {
                                    "Text": "SANT KABIR NAGAR",
                                    "Value": "SANT KABIR NAGAR"
                                },
                                {
                                    "Text": "SANT RAVIDAS NAGAR",
                                    "Value": "SANT RAVIDAS NAGAR"
                                },
                                {
                                    "Text": "SANTA CRUZ",
                                    "Value": "SANTA CRUZ"
                                },
                                {
                                    "Text": "SANTA CRUZ",
                                    "Value": "SANTA CRUZ"
                                },
                                {
                                    "Text": "SAONER",
                                    "Value": "SAONER"
                                },
                                {
                                    "Text": "SAPHALE",
                                    "Value": "SAPHALE"
                                },
                                {
                                    "Text": "SARAN",
                                    "Value": "SARAN"
                                },
                                {
                                    "Text": "SARAI MIR",
                                    "Value": "SARAI MIR"
                                },
                                {
                                    "Text": "SARAIDHELA",
                                    "Value": "SARAIDHELA"
                                },
                                {
                                    "Text": "SARAIKELA",
                                    "Value": "SARAIKELA"
                                },
                                {
                                    "Text": "SARAVANAMPATTI",
                                    "Value": "SARAVANAMPATTI"
                                },
                                {
                                    "Text": "SARDAR SHAHAR",
                                    "Value": "SARDAR SHAHAR"
                                },
                                {
                                    "Text": "SARDHANA",
                                    "Value": "SARDHANA"
                                },
                                {
                                    "Text": "SARDULGARH",
                                    "Value": "SARDULGARH"
                                },
                                {
                                    "Text": "SARIGAM",
                                    "Value": "SARIGAM"
                                },
                                {
                                    "Text": "SARKAGHAT",
                                    "Value": "SARKAGHAT"
                                },
                                {
                                    "Text": "SARNA",
                                    "Value": "SARNA"
                                },
                                {
                                    "Text": "SARTHANA ",
                                    "Value": "SARTHANA "
                                },
                                {
                                    "Text": "SASARAM",
                                    "Value": "SASARAM"
                                },
                                {
                                    "Text": "SAS NAGAR ( MOHALI)",
                                    "Value": "SAS NAGAR ( MOHALI)"
                                },
                                {
                                    "Text": "SATANA",
                                    "Value": "SATANA"
                                },
                                {
                                    "Text": "SATARA",
                                    "Value": "SATARA"
                                },
                                {
                                    "Text": "SATHYAMANGALAM",
                                    "Value": "SATHYAMANGALAM"
                                },
                                {
                                    "Text": "SATHUPALLE",
                                    "Value": "SATHUPALLE"
                                },
                                {
                                    "Text": "SATLASANA",
                                    "Value": "SATLASANA"
                                },
                                {
                                    "Text": "SATNA",
                                    "Value": "SATNA"
                                },
                                {
                                    "Text": "SATTENAPALLI",
                                    "Value": "SATTENAPALLI"
                                },
                                {
                                    "Text": "SATTENAPALLE",
                                    "Value": "SATTENAPALLE"
                                },
                                {
                                    "Text": "SAUNAHA ",
                                    "Value": "SAUNAHA "
                                },
                                {
                                    "Text": "SAURI",
                                    "Value": "SAURI"
                                },
                                {
                                    "Text": "SAVARKUNDLA",
                                    "Value": "SAVARKUNDLA"
                                },
                                {
                                    "Text": "SAVAIGUDEM ",
                                    "Value": "SAVAIGUDEM "
                                },
                                {
                                    "Text": "SAVARDARI",
                                    "Value": "SAVARDARI"
                                },
                                {
                                    "Text": "SAVDA",
                                    "Value": "SAVDA"
                                },
                                {
                                    "Text": "SAVNER",
                                    "Value": "SAVNER"
                                },
                                {
                                    "Text": "SAWANTWADI",
                                    "Value": "SAWANTWADI"
                                },
                                {
                                    "Text": "SAWAI MADHOPUR",
                                    "Value": "SAWAI MADHOPUR"
                                },
                                {
                                    "Text": "SAWARGAON HADAP ",
                                    "Value": "SAWARGAON HADAP "
                                },
                                {
                                    "Text": "SAYAR ",
                                    "Value": "SAYAR "
                                },
                                {
                                    "Text": "SAYLA",
                                    "Value": "SAYLA"
                                },
                                {
                                    "Text": "SOUTH DUMDUM",
                                    "Value": "SOUTH DUMDUM"
                                },
                                {
                                    "Text": "SADAT PUR GUJRAN",
                                    "Value": "SADAT PUR GUJRAN"
                                },
                                {
                                    "Text": "SECUNDERABAD",
                                    "Value": "SECUNDERABAD"
                                },
                                {
                                    "Text": "SECUNDERABAD CANTT.",
                                    "Value": "SECUNDERABAD CANTT."
                                },
                                {
                                    "Text": "SEDAM",
                                    "Value": "SEDAM"
                                },
                                {
                                    "Text": "SEDARIYA",
                                    "Value": "SEDARIYA"
                                },
                                {
                                    "Text": "SEHJRA",
                                    "Value": "SEHJRA"
                                },
                                {
                                    "Text": "SEHORE",
                                    "Value": "SEHORE"
                                },
                                {
                                    "Text": "SELUD",
                                    "Value": "SELUD"
                                },
                                {
                                    "Text": "SEMARA CHANDRAULI",
                                    "Value": "SEMARA CHANDRAULI"
                                },
                                {
                                    "Text": "SENAPATI",
                                    "Value": "SENAPATI"
                                },
                                {
                                    "Text": "SENDHWA",
                                    "Value": "SENDHWA"
                                },
                                {
                                    "Text": "SENDRI",
                                    "Value": "SENDRI"
                                },
                                {
                                    "Text": "SEOLI ",
                                    "Value": "SEOLI "
                                },
                                {
                                    "Text": "SEOLI",
                                    "Value": "SEOLI"
                                },
                                {
                                    "Text": "SEONI",
                                    "Value": "SEONI"
                                },
                                {
                                    "Text": "SEONI MALWA",
                                    "Value": "SEONI MALWA"
                                },
                                {
                                    "Text": "SEPPA",
                                    "Value": "SEPPA"
                                },
                                {
                                    "Text": "SERAMPORE",
                                    "Value": "SERAMPORE"
                                },
                                {
                                    "Text": "SERAIKELA-KHARSAWAN",
                                    "Value": "SERAIKELA-KHARSAWAN"
                                },
                                {
                                    "Text": "SERAIKELA",
                                    "Value": "SERAIKELA"
                                },
                                {
                                    "Text": "SERAULIM",
                                    "Value": "SERAULIM"
                                },
                                {
                                    "Text": "SERCHHIP",
                                    "Value": "SERCHHIP"
                                },
                                {
                                    "Text": "SEVOOR",
                                    "Value": "SEVOOR"
                                },
                                {
                                    "Text": "SEWARHI",
                                    "Value": "SEWARHI"
                                },
                                {
                                    "Text": "SANGMESHWAR",
                                    "Value": "SANGMESHWAR"
                                },
                                {
                                    "Text": "SHAHAD",
                                    "Value": "SHAHAD"
                                },
                                {
                                    "Text": "SHADNAGAR",
                                    "Value": "SHADNAGAR"
                                },
                                {
                                    "Text": "SHAHABAD",
                                    "Value": "SHAHABAD"
                                },
                                {
                                    "Text": "SHAHDOL",
                                    "Value": "SHAHDOL"
                                },
                                {
                                    "Text": "SHAHJAHANPUR",
                                    "Value": "SHAHJAHANPUR"
                                },
                                {
                                    "Text": "SHAHID UDHAM SINGH NAGAR",
                                    "Value": "SHAHID UDHAM SINGH NAGAR"
                                },
                                {
                                    "Text": "SHAHKOT",
                                    "Value": "SHAHKOT"
                                },
                                {
                                    "Text": "SHAHPURA",
                                    "Value": "SHAHPURA"
                                },
                                {
                                    "Text": "SHAHPUR TONDA ",
                                    "Value": "SHAHPUR TONDA "
                                },
                                {
                                    "Text": "SHAHADE",
                                    "Value": "SHAHADE"
                                },
                                {
                                    "Text": "SHAHAPUR",
                                    "Value": "SHAHAPUR"
                                },
                                {
                                    "Text": "SHAHBAD",
                                    "Value": "SHAHBAD"
                                },
                                {
                                    "Text": "SHAHGANJ",
                                    "Value": "SHAHGANJ"
                                },
                                {
                                    "Text": "SHAHPUR GOVARDHANPUR BANGAR",
                                    "Value": "SHAHPUR GOVARDHANPUR BANGAR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHZADPUR",
                                    "Value": "SHAHZADPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAHPUR",
                                    "Value": "SHAHPUR"
                                },
                                {
                                    "Text": "SHAIKHPARA .",
                                    "Value": "SHAIKHPARA ."
                                },
                                {
                                    "Text": "SHAJAPUR",
                                    "Value": "SHAJAPUR"
                                },
                                {
                                    "Text": "SHAMLI",
                                    "Value": "SHAMLI"
                                },
                                {
                                    "Text": "SHAMSHABAD",
                                    "Value": "SHAMSHABAD"
                                },
                                {
                                    "Text": "SHAMIRPET ",
                                    "Value": "SHAMIRPET "
                                },
                                {
                                    "Text": "SHAMDOO ",
                                    "Value": "SHAMDOO "
                                },
                                {
                                    "Text": "SHAMALAJI",
                                    "Value": "SHAMALAJI"
                                },
                                {
                                    "Text": "SHAMASHPUR",
                                    "Value": "SHAMASHPUR"
                                },
                                {
                                    "Text": "SHAMCHURASI",
                                    "Value": "SHAMCHURASI"
                                },
                                {
                                    "Text": "SHAMSABAD",
                                    "Value": "SHAMSABAD"
                                },
                                {
                                    "Text": "SHAMSABAD",
                                    "Value": "SHAMSABAD"
                                },
                                {
                                    "Text": "SHANKAR",
                                    "Value": "SHANKAR"
                                },
                                {
                                    "Text": "SHANKARGARH",
                                    "Value": "SHANKARGARH"
                                },
                                {
                                    "Text": "SHANKARPALLY",
                                    "Value": "SHANKARPALLY"
                                },
                                {
                                    "Text": "SHANPUNG",
                                    "Value": "SHANPUNG"
                                },
                                {
                                    "Text": "SHAPAR",
                                    "Value": "SHAPAR"
                                },
                                {
                                    "Text": "SHARJAH",
                                    "Value": "SHARJAH"
                                },
                                {
                                    "Text": "SHAHADA",
                                    "Value": "SHAHADA"
                                },
                                {
                                    "Text": "SAHIBABAD DAULAT PUR",
                                    "Value": "SAHIBABAD DAULAT PUR"
                                },
                                {
                                    "Text": "SHEGAON",
                                    "Value": "SHEGAON"
                                },
                                {
                                    "Text": "SHEIKHPURA",
                                    "Value": "SHEIKHPURA"
                                },
                                {
                                    "Text": "SHEKTA ",
                                    "Value": "SHEKTA "
                                },
                                {
                                    "Text": "SHELAR",
                                    "Value": "SHELAR"
                                },
                                {
                                    "Text": "SHENDRA MIDC AREA ",
                                    "Value": "SHENDRA MIDC AREA "
                                },
                                {
                                    "Text": "SHEOHAR",
                                    "Value": "SHEOHAR"
                                },
                                {
                                    "Text": "SHEOPUR",
                                    "Value": "SHEOPUR"
                                },
                                {
                                    "Text": "SHEOGA ",
                                    "Value": "SHEOGA "
                                },
                                {
                                    "Text": "SHERTALLY",
                                    "Value": "SHERTALLY"
                                },
                                {
                                    "Text": "SHERKOT",
                                    "Value": "SHERKOT"
                                },
                                {
                                    "Text": "SHERPURA",
                                    "Value": "SHERPURA"
                                },
                                {
                                    "Text": "SHIHOLI MOTI",
                                    "Value": "SHIHOLI MOTI"
                                },
                                {
                                    "Text": "SHIKOHABAD",
                                    "Value": "SHIKOHABAD"
                                },
                                {
                                    "Text": "SHIKOHPUR",
                                    "Value": "SHIKOHPUR"
                                },
                                {
                                    "Text": "SHIKRAPUR",
                                    "Value": "SHIKRAPUR"
                                },
                                {
                                    "Text": "SHILLONG",
                                    "Value": "SHILLONG"
                                },
                                {
                                    "Text": "SHILARU",
                                    "Value": "SHILARU"
                                },
                                {
                                    "Text": "SHIMLA",
                                    "Value": "SHIMLA"
                                },
                                {
                                    "Text": "SHIMOGA",
                                    "Value": "SHIMOGA"
                                },
                                {
                                    "Text": "SHINDEKELGAON ",
                                    "Value": "SHINDEKELGAON "
                                },
                                {
                                    "Text": "SHIRUR",
                                    "Value": "SHIRUR"
                                },
                                {
                                    "Text": "SHIRVAL",
                                    "Value": "SHIRVAL"
                                },
                                {
                                    "Text": "SHIRPUR",
                                    "Value": "SHIRPUR"
                                },
                                {
                                    "Text": "SHIRDI",
                                    "Value": "SHIRDI"
                                },
                                {
                                    "Text": "SHIRWAL",
                                    "Value": "SHIRWAL"
                                },
                                {
                                    "Text": "SHIVPURI",
                                    "Value": "SHIVPURI"
                                },
                                {
                                    "Text": "SHIVPUR ",
                                    "Value": "SHIVPUR "
                                },
                                {
                                    "Text": "SHALIMAR BAGH",
                                    "Value": "SHALIMAR BAGH"
                                },
                                {
                                    "Text": "SHOHRATGARH",
                                    "Value": "SHOHRATGARH"
                                },
                                {
                                    "Text": "SHOPIAN",
                                    "Value": "SHOPIAN"
                                },
                                {
                                    "Text": "SHORANUR",
                                    "Value": "SHORANUR"
                                },
                                {
                                    "Text": "SHERPUR",
                                    "Value": "SHERPUR"
                                },
                                {
                                    "Text": "SHRAWASTI",
                                    "Value": "SHRAWASTI"
                                },
                                {
                                    "Text": "SHRIRAMPUR",
                                    "Value": "SHRIRAMPUR"
                                },
                                {
                                    "Text": "SHRIGONDA",
                                    "Value": "SHRIGONDA"
                                },
                                {
                                    "Text": "SHUJALPUR",
                                    "Value": "SHUJALPUR"
                                },
                                {
                                    "Text": "SHUKARTAL BANGAR",
                                    "Value": "SHUKARTAL BANGAR"
                                },
                                {
                                    "Text": "SHUKLAGANJ",
                                    "Value": "SHUKLAGANJ"
                                },
                                {
                                    "Text": "SIBSAGAR",
                                    "Value": "SIBSAGAR"
                                },
                                {
                                    "Text": "SIBSAGAR",
                                    "Value": "SIBSAGAR"
                                },
                                {
                                    "Text": "SIDDIPET",
                                    "Value": "SIDDIPET"
                                },
                                {
                                    "Text": "SIDDHARTHNAGAR",
                                    "Value": "SIDDHARTHNAGAR"
                                },
                                {
                                    "Text": "SIDDALOOR ",
                                    "Value": "SIDDALOOR "
                                },
                                {
                                    "Text": "SIDHI",
                                    "Value": "SIDHI"
                                },
                                {
                                    "Text": "SIDHPUR",
                                    "Value": "SIDHPUR"
                                },
                                {
                                    "Text": "SIDHWAN BET",
                                    "Value": "SIDHWAN BET"
                                },
                                {
                                    "Text": "SIDSAR",
                                    "Value": "SIDSAR"
                                },
                                {
                                    "Text": "SIGNAL VILLAGE",
                                    "Value": "SIGNAL VILLAGE"
                                },
                                {
                                    "Text": "SIHORA",
                                    "Value": "SIHORA"
                                },
                                {
                                    "Text": "SIHOR",
                                    "Value": "SIHOR"
                                },
                                {
                                    "Text": "SIKAR",
                                    "Value": "SIKAR"
                                },
                                {
                                    "Text": "SIKANDERPUR BADHA",
                                    "Value": "SIKANDERPUR BADHA"
                                },
                                {
                                    "Text": "SIKANDRABAD",
                                    "Value": "SIKANDRABAD"
                                },
                                {
                                    "Text": "SIKHWALA",
                                    "Value": "SIKHWALA"
                                },
                                {
                                    "Text": "SILVASSA",
                                    "Value": "SILVASSA"
                                },
                                {
                                    "Text": "SILAI BARA GAON ",
                                    "Value": "SILAI BARA GAON "
                                },
                                {
                                    "Text": "SILCHAR",
                                    "Value": "SILCHAR"
                                },
                                {
                                    "Text": "SILIGURI",
                                    "Value": "SILIGURI"
                                },
                                {
                                    "Text": "SILLOD",
                                    "Value": "SILLOD"
                                },
                                {
                                    "Text": "SILVASSA",
                                    "Value": "SILVASSA"
                                },
                                {
                                    "Text": "SIMALIYA",
                                    "Value": "SIMALIYA"
                                },
                                {
                                    "Text": "SIMDEGA",
                                    "Value": "SIMDEGA"
                                },
                                {
                                    "Text": "SIMIKERI ",
                                    "Value": "SIMIKERI "
                                },
                                {
                                    "Text": "SIMINOI",
                                    "Value": "SIMINOI"
                                },
                                {
                                    "Text": "SINDHANUR",
                                    "Value": "SINDHANUR"
                                },
                                {
                                    "Text": "SINDHUDURG",
                                    "Value": "SINDHUDURG"
                                },
                                {
                                    "Text": "SINGRAULI",
                                    "Value": "SINGRAULI"
                                },
                                {
                                    "Text": "SINGHE WALA ",
                                    "Value": "SINGHE WALA "
                                },
                                {
                                    "Text": "SINGHAUR",
                                    "Value": "SINGHAUR"
                                },
                                {
                                    "Text": "SINGTAM",
                                    "Value": "SINGTAM"
                                },
                                {
                                    "Text": "SINNAR",
                                    "Value": "SINNAR"
                                },
                                {
                                    "Text": "SIOLIM",
                                    "Value": "SIOLIM"
                                },
                                {
                                    "Text": "SIPAHIJALA",
                                    "Value": "SIPAHIJALA"
                                },
                                {
                                    "Text": "SIRATHU",
                                    "Value": "SIRATHU"
                                },
                                {
                                    "Text": "SIRATHU",
                                    "Value": "SIRATHU"
                                },
                                {
                                    "Text": "SIRCAIM",
                                    "Value": "SIRCAIM"
                                },
                                {
                                    "Text": "SIRCILLA",
                                    "Value": "SIRCILLA"
                                },
                                {
                                    "Text": "SIRHIND",
                                    "Value": "SIRHIND"
                                },
                                {
                                    "Text": "SIRMOUR",
                                    "Value": "SIRMOUR"
                                },
                                {
                                    "Text": "SIRMAUR",
                                    "Value": "SIRMAUR"
                                },
                                {
                                    "Text": "SIRMINA ",
                                    "Value": "SIRMINA "
                                },
                                {
                                    "Text": "SIRONJ",
                                    "Value": "SIRONJ"
                                },
                                {
                                    "Text": "SIROHI",
                                    "Value": "SIROHI"
                                },
                                {
                                    "Text": "SIRSI",
                                    "Value": "SIRSI"
                                },
                                {
                                    "Text": "SIRSA",
                                    "Value": "SIRSA"
                                },
                                {
                                    "Text": "SISODARA",
                                    "Value": "SISODARA"
                                },
                                {
                                    "Text": "SISWA",
                                    "Value": "SISWA"
                                },
                                {
                                    "Text": "SITAPUR",
                                    "Value": "SITAPUR"
                                },
                                {
                                    "Text": "SITAMARHI",
                                    "Value": "SITAMARHI"
                                },
                                {
                                    "Text": "SITAPUR",
                                    "Value": "SITAPUR"
                                },
                                {
                                    "Text": "SITARGANJ",
                                    "Value": "SITARGANJ"
                                },
                                {
                                    "Text": "SITO GUNNO",
                                    "Value": "SITO GUNNO"
                                },
                                {
                                    "Text": "SIVAKASI",
                                    "Value": "SIVAKASI"
                                },
                                {
                                    "Text": "SIVAGANGA",
                                    "Value": "SIVAGANGA"
                                },
                                {
                                    "Text": "SIVAREDDYPET ",
                                    "Value": "SIVAREDDYPET "
                                },
                                {
                                    "Text": "SIVASAGAR",
                                    "Value": "SIVASAGAR"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SIWANI",
                                    "Value": "SIWANI"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SIWAN",
                                    "Value": "SIWAN"
                                },
                                {
                                    "Text": "SUKHRALI",
                                    "Value": "SUKHRALI"
                                },
                                {
                                    "Text": "SULTAN PUR",
                                    "Value": "SULTAN PUR"
                                },
                                {
                                    "Text": "SULTAN PUR MAJRA",
                                    "Value": "SULTAN PUR MAJRA"
                                },
                                {
                                    "Text": "SAMBHALKA",
                                    "Value": "SAMBHALKA"
                                },
                                {
                                    "Text": "SANGLI MIRAJ KUPWAD",
                                    "Value": "SANGLI MIRAJ KUPWAD"
                                },
                                {
                                    "Text": "SANGAREDDY",
                                    "Value": "SANGAREDDY"
                                },
                                {
                                    "Text": "SINGUR",
                                    "Value": "SINGUR"
                                },
                                {
                                    "Text": "SANPADA",
                                    "Value": "SANPADA"
                                },
                                {
                                    "Text": "SONARPUR",
                                    "Value": "SONARPUR"
                                },
                                {
                                    "Text": "SONAWARI",
                                    "Value": "SONAWARI"
                                },
                                {
                                    "Text": "SOHANA",
                                    "Value": "SOHANA"
                                },
                                {
                                    "Text": "SOHANPUR",
                                    "Value": "SOHANPUR"
                                },
                                {
                                    "Text": "SOHNA",
                                    "Value": "SOHNA"
                                },
                                {
                                    "Text": "SOJAT CITY",
                                    "Value": "SOJAT CITY"
                                },
                                {
                                    "Text": "SOLAN",
                                    "Value": "SOLAN"
                                },
                                {
                                    "Text": "SOLAPUR",
                                    "Value": "SOLAPUR"
                                },
                                {
                                    "Text": "SOLAIYA",
                                    "Value": "SOLAIYA"
                                },
                                {
                                    "Text": "SOMATANE",
                                    "Value": "SOMATANE"
                                },
                                {
                                    "Text": "SONAPUR",
                                    "Value": "SONAPUR"
                                },
                                {
                                    "Text": "SONBHADRA",
                                    "Value": "SONBHADRA"
                                },
                                {
                                    "Text": "SONEPAT",
                                    "Value": "SONEPAT"
                                },
                                {
                                    "Text": "SONEPUR",
                                    "Value": "SONEPUR"
                                },
                                {
                                    "Text": "SONIPAT",
                                    "Value": "SONIPAT"
                                },
                                {
                                    "Text": "SONITPUR",
                                    "Value": "SONITPUR"
                                },
                                {
                                    "Text": "SONJAMB",
                                    "Value": "SONJAMB"
                                },
                                {
                                    "Text": "SONPUR",
                                    "Value": "SONPUR"
                                },
                                {
                                    "Text": "SOPORE",
                                    "Value": "SOPORE"
                                },
                                {
                                    "Text": "SORAON",
                                    "Value": "SORAON"
                                },
                                {
                                    "Text": "SORUMONA PORIA",
                                    "Value": "SORUMONA PORIA"
                                },
                                {
                                    "Text": "SOUTH SIKKIM",
                                    "Value": "SOUTH SIKKIM"
                                },
                                {
                                    "Text": "SOUTH WEST DELHI",
                                    "Value": "SOUTH WEST DELHI"
                                },
                                {
                                    "Text": "SOUTH TRIPURA",
                                    "Value": "SOUTH TRIPURA"
                                },
                                {
                                    "Text": "SOUTH 24 PARGANAS",
                                    "Value": "SOUTH 24 PARGANAS"
                                },
                                {
                                    "Text": "SOUTH ANDAMAN",
                                    "Value": "SOUTH ANDAMAN"
                                },
                                {
                                    "Text": "SOUTH DELHI",
                                    "Value": "SOUTH DELHI"
                                },
                                {
                                    "Text": "SOUTH DINAJPUR",
                                    "Value": "SOUTH DINAJPUR"
                                },
                                {
                                    "Text": "SOUTH GARO HILLS",
                                    "Value": "SOUTH GARO HILLS"
                                },
                                {
                                    "Text": "SOUTH GOA",
                                    "Value": "SOUTH GOA"
                                },
                                {
                                    "Text": "SOUTH PARUR",
                                    "Value": "SOUTH PARUR"
                                },
                                {
                                    "Text": "SRI GANGANAGAR",
                                    "Value": "SRI GANGANAGAR"
                                },
                                {
                                    "Text": "SRI HARGOBINDPUR SAHIB",
                                    "Value": "SRI HARGOBINDPUR SAHIB"
                                },
                                {
                                    "Text": "SRIKAKULAM",
                                    "Value": "SRIKAKULAM"
                                },
                                {
                                    "Text": "SRIKALAHASTI",
                                    "Value": "SRIKALAHASTI"
                                },
                                {
                                    "Text": "SRIMADHOPUR",
                                    "Value": "SRIMADHOPUR"
                                },
                                {
                                    "Text": "SRINAGAR",
                                    "Value": "SRINAGAR"
                                },
                                {
                                    "Text": "SRINIVASPURAM ",
                                    "Value": "SRINIVASPURAM "
                                },
                                {
                                    "Text": "SRINAGAR",
                                    "Value": "SRINAGAR"
                                },
                                {
                                    "Text": "SRIPERUMBUDUR",
                                    "Value": "SRIPERUMBUDUR"
                                },
                                {
                                    "Text": "SRIRANGAM",
                                    "Value": "SRIRANGAM"
                                },
                                {
                                    "Text": "SRI VIJAYNAGAR",
                                    "Value": "SRI VIJAYNAGAR"
                                },
                                {
                                    "Text": "SURANKOTE",
                                    "Value": "SURANKOTE"
                                },
                                {
                                    "Text": "SIRAS PUR",
                                    "Value": "SIRAS PUR"
                                },
                                {
                                    "Text": "STN. GUNDRATHIMADUGU ",
                                    "Value": "STN. GUNDRATHIMADUGU "
                                },
                                {
                                    "Text": "SUALKUCHI",
                                    "Value": "SUALKUCHI"
                                },
                                {
                                    "Text": "SUBHASHNAGAR ",
                                    "Value": "SUBHASHNAGAR "
                                },
                                {
                                    "Text": "SUDHAIL",
                                    "Value": "SUDHAIL"
                                },
                                {
                                    "Text": "SUDHAR",
                                    "Value": "SUDHAR"
                                },
                                {
                                    "Text": "SUGHAD",
                                    "Value": "SUGHAD"
                                },
                                {
                                    "Text": "SUHRON ",
                                    "Value": "SUHRON "
                                },
                                {
                                    "Text": "SUJANGARH",
                                    "Value": "SUJANGARH"
                                },
                                {
                                    "Text": "SUJANPUR",
                                    "Value": "SUJANPUR"
                                },
                                {
                                    "Text": "SUKHAN WALA ",
                                    "Value": "SUKHAN WALA "
                                },
                                {
                                    "Text": "SUKHDEVPURA",
                                    "Value": "SUKHDEVPURA"
                                },
                                {
                                    "Text": "SUKHER",
                                    "Value": "SUKHER"
                                },
                                {
                                    "Text": "SULAH",
                                    "Value": "SULAH"
                                },
                                {
                                    "Text": "SULLIA",
                                    "Value": "SULLIA"
                                },
                                {
                                    "Text": "SULTANPUR",
                                    "Value": "SULTANPUR"
                                },
                                {
                                    "Text": "SULTAN BATTERY",
                                    "Value": "SULTAN BATTERY"
                                },
                                {
                                    "Text": "SULTANPUR",
                                    "Value": "SULTANPUR"
                                },
                                {
                                    "Text": "SULTANPUR LODHI",
                                    "Value": "SULTANPUR LODHI"
                                },
                                {
                                    "Text": "SULTANABAD",
                                    "Value": "SULTANABAD"
                                },
                                {
                                    "Text": "SULTHAN BATHERY",
                                    "Value": "SULTHAN BATHERY"
                                },
                                {
                                    "Text": "SULYA",
                                    "Value": "SULYA"
                                },
                                {
                                    "Text": "SUMERPUR",
                                    "Value": "SUMERPUR"
                                },
                                {
                                    "Text": "SUNABEDA",
                                    "Value": "SUNABEDA"
                                },
                                {
                                    "Text": "SUNAM",
                                    "Value": "SUNAM"
                                },
                                {
                                    "Text": "SUNDLI JUBBAL",
                                    "Value": "SUNDLI JUBBAL"
                                },
                                {
                                    "Text": "SUNDERGARH",
                                    "Value": "SUNDERGARH"
                                },
                                {
                                    "Text": "SUNDERNAGAR",
                                    "Value": "SUNDERNAGAR"
                                },
                                {
                                    "Text": "SUNDERBANI",
                                    "Value": "SUNDERBANI"
                                },
                                {
                                    "Text": "SUNDA ",
                                    "Value": "SUNDA "
                                },
                                {
                                    "Text": "SUNDARAPURAM",
                                    "Value": "SUNDARAPURAM"
                                },
                                {
                                    "Text": "SUNDARGARH",
                                    "Value": "SUNDARGARH"
                                },
                                {
                                    "Text": "SUNDARNAGAR",
                                    "Value": "SUNDARNAGAR"
                                },
                                {
                                    "Text": "SUNDLI -JUBBAL (JAI-PIDI)",
                                    "Value": "SUNDLI -JUBBAL (JAI-PIDI)"
                                },
                                {
                                    "Text": "SUPAUL",
                                    "Value": "SUPAUL"
                                },
                                {
                                    "Text": "SUPASI",
                                    "Value": "SUPASI"
                                },
                                {
                                    "Text": "SUPELA",
                                    "Value": "SUPELA"
                                },
                                {
                                    "Text": "SURATGARH",
                                    "Value": "SURATGARH"
                                },
                                {
                                    "Text": "SURAT",
                                    "Value": "SURAT"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURATHKAL",
                                    "Value": "SURATHKAL"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURAJPUR",
                                    "Value": "SURAJPUR"
                                },
                                {
                                    "Text": "SURENDRANAGAR",
                                    "Value": "SURENDRANAGAR"
                                },
                                {
                                    "Text": "SURENDRA NAGAR",
                                    "Value": "SURENDRA NAGAR"
                                },
                                {
                                    "Text": "SURGUJA",
                                    "Value": "SURGUJA"
                                },
                                {
                                    "Text": "SURI",
                                    "Value": "SURI"
                                },
                                {
                                    "Text": "SURLA ",
                                    "Value": "SURLA "
                                },
                                {
                                    "Text": "SURMA ",
                                    "Value": "SURMA "
                                },
                                {
                                    "Text": "SUR SINGH",
                                    "Value": "SUR SINGH"
                                },
                                {
                                    "Text": "SURYAPET",
                                    "Value": "SURYAPET"
                                },
                                {
                                    "Text": "SUSARI",
                                    "Value": "SUSARI"
                                },
                                {
                                    "Text": "SWARNAVARIGUDEM ",
                                    "Value": "SWARNAVARIGUDEM "
                                },
                                {
                                    "Text": "TADA",
                                    "Value": "TADA"
                                },
                                {
                                    "Text": "TADEPALLIGUDEM",
                                    "Value": "TADEPALLIGUDEM"
                                },
                                {
                                    "Text": "TADEGAON ",
                                    "Value": "TADEGAON "
                                },
                                {
                                    "Text": "TADIPATRI",
                                    "Value": "TADIPATRI"
                                },
                                {
                                    "Text": "TADLAPOOSALAPALLI ",
                                    "Value": "TADLAPOOSALAPALLI "
                                },
                                {
                                    "Text": "TADPATRI",
                                    "Value": "TADPATRI"
                                },
                                {
                                    "Text": "TADUVAI ",
                                    "Value": "TADUVAI "
                                },
                                {
                                    "Text": "TAHLIWAL ",
                                    "Value": "TAHLIWAL "
                                },
                                {
                                    "Text": "TAHLIWALA JATTAN",
                                    "Value": "TAHLIWALA JATTAN"
                                },
                                {
                                    "Text": "TAJANGI ",
                                    "Value": "TAJANGI "
                                },
                                {
                                    "Text": "TAJ PUL",
                                    "Value": "TAJ PUL"
                                },
                                {
                                    "Text": "TAKAVE BUDRUK",
                                    "Value": "TAKAVE BUDRUK"
                                },
                                {
                                    "Text": "TAKALIMIYA",
                                    "Value": "TAKALIMIYA"
                                },
                                {
                                    "Text": "TAKAVE BUDRUK",
                                    "Value": "TAKAVE BUDRUK"
                                },
                                {
                                    "Text": "TAKHU CHAK",
                                    "Value": "TAKHU CHAK"
                                },
                                {
                                    "Text": "TAKHATPUR",
                                    "Value": "TAKHATPUR"
                                },
                                {
                                    "Text": "TAKHU CHAK",
                                    "Value": "TAKHU CHAK"
                                },
                                {
                                    "Text": "TAKKELLA PAHAD ",
                                    "Value": "TAKKELLA PAHAD "
                                },
                                {
                                    "Text": "TALAJA",
                                    "Value": "TALAJA"
                                },
                                {
                                    "Text": "TALALA",
                                    "Value": "TALALA"
                                },
                                {
                                    "Text": "TALCHER",
                                    "Value": "TALCHER"
                                },
                                {
                                    "Text": "TALEGAON",
                                    "Value": "TALEGAON"
                                },
                                {
                                    "Text": "TALEKODE",
                                    "Value": "TALEKODE"
                                },
                                {
                                    "Text": "TALEKODE WEST ",
                                    "Value": "TALEKODE WEST "
                                },
                                {
                                    "Text": "TALEGAON DABHADE",
                                    "Value": "TALEGAON DABHADE"
                                },
                                {
                                    "Text": "TALHAN",
                                    "Value": "TALHAN"
                                },
                                {
                                    "Text": "TALIPARAMBA",
                                    "Value": "TALIPARAMBA"
                                },
                                {
                                    "Text": "TALIKULAM",
                                    "Value": "TALIKULAM"
                                },
                                {
                                    "Text": "TALLAPOLAM ",
                                    "Value": "TALLAPOLAM "
                                },
                                {
                                    "Text": "TALOD",
                                    "Value": "TALOD"
                                },
                                {
                                    "Text": "TALOJE MAJKUR",
                                    "Value": "TALOJE MAJKUR"
                                },
                                {
                                    "Text": "TALWANDI SABO",
                                    "Value": "TALWANDI SABO"
                                },
                                {
                                    "Text": "TALWARA TOWNSHIP",
                                    "Value": "TALWARA TOWNSHIP"
                                },
                                {
                                    "Text": "TALWAN",
                                    "Value": "TALWAN"
                                },
                                {
                                    "Text": "TALWANDI BHAI",
                                    "Value": "TALWANDI BHAI"
                                },
                                {
                                    "Text": "TALWANDI CHAUDRIAN",
                                    "Value": "TALWANDI CHAUDRIAN"
                                },
                                {
                                    "Text": "TALWARA",
                                    "Value": "TALWARA"
                                },
                                {
                                    "Text": "TAMENGLONG",
                                    "Value": "TAMENGLONG"
                                },
                                {
                                    "Text": "TAMLUK",
                                    "Value": "TAMLUK"
                                },
                                {
                                    "Text": "TANDUR",
                                    "Value": "TANDUR"
                                },
                                {
                                    "Text": "TANDA",
                                    "Value": "TANDA"
                                },
                                {
                                    "Text": "TANDEMVALASA ",
                                    "Value": "TANDEMVALASA "
                                },
                                {
                                    "Text": "TANGI",
                                    "Value": "TANGI"
                                },
                                {
                                    "Text": "TANGRA",
                                    "Value": "TANGRA"
                                },
                                {
                                    "Text": "TANKARA",
                                    "Value": "TANKARA"
                                },
                                {
                                    "Text": "TANKARA",
                                    "Value": "TANKARA"
                                },
                                {
                                    "Text": "TANKUA",
                                    "Value": "TANKUA"
                                },
                                {
                                    "Text": "TANUKU",
                                    "Value": "TANUKU"
                                },
                                {
                                    "Text": "TAORU",
                                    "Value": "TAORU"
                                },
                                {
                                    "Text": "TAPA MANDI",
                                    "Value": "TAPA MANDI"
                                },
                                {
                                    "Text": "TAPA",
                                    "Value": "TAPA"
                                },
                                {
                                    "Text": "TAPI",
                                    "Value": "TAPI"
                                },
                                {
                                    "Text": "TAPOKDA",
                                    "Value": "TAPOKDA"
                                },
                                {
                                    "Text": "TARAORI",
                                    "Value": "TARAORI"
                                },
                                {
                                    "Text": "TARA ",
                                    "Value": "TARA "
                                },
                                {
                                    "Text": "TARAGARH",
                                    "Value": "TARAGARH"
                                },
                                {
                                    "Text": "TARAKESWAR",
                                    "Value": "TARAKESWAR"
                                },
                                {
                                    "Text": "TARAPUR",
                                    "Value": "TARAPUR"
                                },
                                {
                                    "Text": "TAREWALA ",
                                    "Value": "TAREWALA "
                                },
                                {
                                    "Text": "TARN TARAN",
                                    "Value": "TARN TARAN"
                                },
                                {
                                    "Text": "TARSIKKA",
                                    "Value": "TARSIKKA"
                                },
                                {
                                    "Text": "TARSOD",
                                    "Value": "TARSOD"
                                },
                                {
                                    "Text": "TASGAON",
                                    "Value": "TASGAON"
                                },
                                {
                                    "Text": "TATTEKERE ",
                                    "Value": "TATTEKERE "
                                },
                                {
                                    "Text": "TAWANG",
                                    "Value": "TAWANG"
                                },
                                {
                                    "Text": "TEHNA ",
                                    "Value": "TEHNA "
                                },
                                {
                                    "Text": "TEHRI GARHWAL",
                                    "Value": "TEHRI GARHWAL"
                                },
                                {
                                    "Text": "TEHRI",
                                    "Value": "TEHRI"
                                },
                                {
                                    "Text": "TEHSIL DADRI",
                                    "Value": "TEHSIL DADRI"
                                },
                                {
                                    "Text": "TEHSIL JEWAR",
                                    "Value": "TEHSIL JEWAR"
                                },
                                {
                                    "Text": "TEHSIL PHILLAUR",
                                    "Value": "TEHSIL PHILLAUR"
                                },
                                {
                                    "Text": "TEHSIL SADAR",
                                    "Value": "TEHSIL SADAR"
                                },
                                {
                                    "Text": "TEKRIYAL ",
                                    "Value": "TEKRIYAL "
                                },
                                {
                                    "Text": "TENALI",
                                    "Value": "TENALI"
                                },
                                {
                                    "Text": "TEEN BATTI",
                                    "Value": "TEEN BATTI"
                                },
                                {
                                    "Text": "TENKASI",
                                    "Value": "TENKASI"
                                },
                                {
                                    "Text": "TEZPUR",
                                    "Value": "TEZPUR"
                                },
                                {
                                    "Text": "TEZU",
                                    "Value": "TEZU"
                                },
                                {
                                    "Text": "THADIKAL",
                                    "Value": "THADIKAL"
                                },
                                {
                                    "Text": "THALASSERY",
                                    "Value": "THALASSERY"
                                },
                                {
                                    "Text": "THAMARASSERY",
                                    "Value": "THAMARASSERY"
                                },
                                {
                                    "Text": "THANGADH",
                                    "Value": "THANGADH"
                                },
                                {
                                    "Text": "THANE",
                                    "Value": "THANE"
                                },
                                {
                                    "Text": "THANJAVUR",
                                    "Value": "THANJAVUR"
                                },
                                {
                                    "Text": "THANA CHAPPAR",
                                    "Value": "THANA CHAPPAR"
                                },
                                {
                                    "Text": "THANESAR",
                                    "Value": "THANESAR"
                                },
                                {
                                    "Text": "THANNEERMUKKAM",
                                    "Value": "THANNEERMUKKAM"
                                },
                                {
                                    "Text": "THARU ",
                                    "Value": "THARU "
                                },
                                {
                                    "Text": "THARAJ",
                                    "Value": "THARAJ"
                                },
                                {
                                    "Text": "THASKA KHADAR",
                                    "Value": "THASKA KHADAR"
                                },
                                {
                                    "Text": "THATHI KHARA ",
                                    "Value": "THATHI KHARA "
                                },
                                {
                                    "Text": "THE DANGS",
                                    "Value": "THE DANGS"
                                },
                                {
                                    "Text": "THENI",
                                    "Value": "THENI"
                                },
                                {
                                    "Text": "THEOG",
                                    "Value": "THEOG"
                                },
                                {
                                    "Text": "THIRUVANANTHAPURAM",
                                    "Value": "THIRUVANANTHAPURAM"
                                },
                                {
                                    "Text": "THIRKKAKARA",
                                    "Value": "THIRKKAKARA"
                                },
                                {
                                    "Text": "THIRTHAHALLI",
                                    "Value": "THIRTHAHALLI"
                                },
                                {
                                    "Text": "THIRUMANGALAM",
                                    "Value": "THIRUMANGALAM"
                                },
                                {
                                    "Text": "THIRUVALLUR",
                                    "Value": "THIRUVALLUR"
                                },
                                {
                                    "Text": "THIRUVARUR",
                                    "Value": "THIRUVARUR"
                                },
                                {
                                    "Text": "THIRUVERAMBUR",
                                    "Value": "THIRUVERAMBUR"
                                },
                                {
                                    "Text": "THIRUVILWAMALA",
                                    "Value": "THIRUVILWAMALA"
                                },
                                {
                                    "Text": "THIRUVOTTIYUR",
                                    "Value": "THIRUVOTTIYUR"
                                },
                                {
                                    "Text": "THISAYANVILAI",
                                    "Value": "THISAYANVILAI"
                                },
                                {
                                    "Text": "THODUPUZHA",
                                    "Value": "THODUPUZHA"
                                },
                                {
                                    "Text": "THORRUR",
                                    "Value": "THORRUR"
                                },
                                {
                                    "Text": "THOUBAL",
                                    "Value": "THOUBAL"
                                },
                                {
                                    "Text": "THRISSUR",
                                    "Value": "THRISSUR"
                                },
                                {
                                    "Text": "THRIPUNITHURA",
                                    "Value": "THRIPUNITHURA"
                                },
                                {
                                    "Text": "THROADIPATTU ",
                                    "Value": "THROADIPATTU "
                                },
                                {
                                    "Text": "THUCKALAY",
                                    "Value": "THUCKALAY"
                                },
                                {
                                    "Text": "THUMBOOR",
                                    "Value": "THUMBOOR"
                                },
                                {
                                    "Text": "THUNGAPAHAD ",
                                    "Value": "THUNGAPAHAD "
                                },
                                {
                                    "Text": "TIBRI",
                                    "Value": "TIBRI"
                                },
                                {
                                    "Text": "TIGAON",
                                    "Value": "TIGAON"
                                },
                                {
                                    "Text": "TIGRANA",
                                    "Value": "TIGRANA"
                                },
                                {
                                    "Text": "TIKAMGARH",
                                    "Value": "TIKAMGARH"
                                },
                                {
                                    "Text": "TILDA",
                                    "Value": "TILDA"
                                },
                                {
                                    "Text": "TILHAR",
                                    "Value": "TILHAR"
                                },
                                {
                                    "Text": "TILPAT",
                                    "Value": "TILPAT"
                                },
                                {
                                    "Text": "TINIDVANAM",
                                    "Value": "TINIDVANAM"
                                },
                                {
                                    "Text": "TINSUKIA",
                                    "Value": "TINSUKIA"
                                },
                                {
                                    "Text": "TIPTUR",
                                    "Value": "TIPTUR"
                                },
                                {
                                    "Text": "TIRAP",
                                    "Value": "TIRAP"
                                },
                                {
                                    "Text": "TIRUR",
                                    "Value": "TIRUR"
                                },
                                {
                                    "Text": "TIRUVALLA",
                                    "Value": "TIRUVALLA"
                                },
                                {
                                    "Text": "TIRUCHIRAPPALLI",
                                    "Value": "TIRUCHIRAPPALLI"
                                },
                                {
                                    "Text": "TIRUNELVELI",
                                    "Value": "TIRUNELVELI"
                                },
                                {
                                    "Text": "TIRUVALLUR",
                                    "Value": "TIRUVALLUR"
                                },
                                {
                                    "Text": "TIRUVANNAMALAI",
                                    "Value": "TIRUVANNAMALAI"
                                },
                                {
                                    "Text": "TIRUVARUR",
                                    "Value": "TIRUVARUR"
                                },
                                {
                                    "Text": "TIRUCHENGODE",
                                    "Value": "TIRUCHENGODE"
                                },
                                {
                                    "Text": "TIRUCHENDUR",
                                    "Value": "TIRUCHENDUR"
                                },
                                {
                                    "Text": "TIRUKOLLUR",
                                    "Value": "TIRUKOLLUR"
                                },
                                {
                                    "Text": "TIRUPATI",
                                    "Value": "TIRUPATI"
                                },
                                {
                                    "Text": "TIRUVURU",
                                    "Value": "TIRUVURU"
                                },
                                {
                                    "Text": "TIRUPATTUR",
                                    "Value": "TIRUPATTUR"
                                },
                                {
                                    "Text": "TIRUPUR",
                                    "Value": "TIRUPUR"
                                },
                                {
                                    "Text": "TIRUCHIRAPALLI",
                                    "Value": "TIRUCHIRAPALLI"
                                },
                                {
                                    "Text": "TIRUPATHUR",
                                    "Value": "TIRUPATHUR"
                                },
                                {
                                    "Text": "TIRUPPUR",
                                    "Value": "TIRUPPUR"
                                },
                                {
                                    "Text": "TIRUVILLA",
                                    "Value": "TIRUVILLA"
                                },
                                {
                                    "Text": "TIRUVUR",
                                    "Value": "TIRUVUR"
                                },
                                {
                                    "Text": "TIRWAGANJ",
                                    "Value": "TIRWAGANJ"
                                },
                                {
                                    "Text": "TITLAGARH",
                                    "Value": "TITLAGARH"
                                },
                                {
                                    "Text": "TALALA  GIR",
                                    "Value": "TALALA  GIR"
                                },
                                {
                                    "Text": "TANDA",
                                    "Value": "TANDA"
                                },
                                {
                                    "Text": "TOHANA",
                                    "Value": "TOHANA"
                                },
                                {
                                    "Text": "TONK",
                                    "Value": "TONK"
                                },
                                {
                                    "Text": "TORLIKONDA ",
                                    "Value": "TORLIKONDA "
                                },
                                {
                                    "Text": "TOSHAM",
                                    "Value": "TOSHAM"
                                },
                                {
                                    "Text": "TOTU",
                                    "Value": "TOTU"
                                },
                                {
                                    "Text": "TOWN BHONGIRI ",
                                    "Value": "TOWN BHONGIRI "
                                },
                                {
                                    "Text": "TRAL",
                                    "Value": "TRAL"
                                },
                                {
                                    "Text": "TRANOL",
                                    "Value": "TRANOL"
                                },
                                {
                                    "Text": "TRICHY",
                                    "Value": "TRICHY"
                                },
                                {
                                    "Text": "TRICHUR",
                                    "Value": "TRICHUR"
                                },
                                {
                                    "Text": "TRIMBAKESHWAR",
                                    "Value": "TRIMBAKESHWAR"
                                },
                                {
                                    "Text": "TRIPUNITHURA",
                                    "Value": "TRIPUNITHURA"
                                },
                                {
                                    "Text": "TRIPURA",
                                    "Value": "TRIPURA"
                                },
                                {
                                    "Text": "TRIPURARAM ",
                                    "Value": "TRIPURARAM "
                                },
                                {
                                    "Text": "TRIPRAYAR",
                                    "Value": "TRIPRAYAR"
                                },
                                {
                                    "Text": "TRIVANDRUM",
                                    "Value": "TRIVANDRUM"
                                },
                                {
                                    "Text": "TROMBAY",
                                    "Value": "TROMBAY"
                                },
                                {
                                    "Text": "TUENSANG",
                                    "Value": "TUENSANG"
                                },
                                {
                                    "Text": "TULSIPUR",
                                    "Value": "TULSIPUR"
                                },
                                {
                                    "Text": "TUMKUR",
                                    "Value": "TUMKUR"
                                },
                                {
                                    "Text": "TUMSAR",
                                    "Value": "TUMSAR"
                                },
                                {
                                    "Text": "TUNDLA",
                                    "Value": "TUNDLA"
                                },
                                {
                                    "Text": "TUNI",
                                    "Value": "TUNI"
                                },
                                {
                                    "Text": "TURA",
                                    "Value": "TURA"
                                },
                                {
                                    "Text": "TURAKAPETA ",
                                    "Value": "TURAKAPETA "
                                },
                                {
                                    "Text": "TURBHE",
                                    "Value": "TURBHE"
                                },
                                {
                                    "Text": "TUTICORIN",
                                    "Value": "TUTICORIN"
                                },
                                {
                                    "Text": "UCHANA KALAN",
                                    "Value": "UCHANA KALAN"
                                },
                                {
                                    "Text": "UDAIPUR",
                                    "Value": "UDAIPUR"
                                },
                                {
                                    "Text": "UDAIPUR ",
                                    "Value": "UDAIPUR "
                                },
                                {
                                    "Text": "UDAIPUR",
                                    "Value": "UDAIPUR"
                                },
                                {
                                    "Text": "UDALGURI",
                                    "Value": "UDALGURI"
                                },
                                {
                                    "Text": "UDGIR",
                                    "Value": "UDGIR"
                                },
                                {
                                    "Text": "UDHAM SINGH NAGAR",
                                    "Value": "UDHAM SINGH NAGAR"
                                },
                                {
                                    "Text": "UDHAMPUR",
                                    "Value": "UDHAMPUR"
                                },
                                {
                                    "Text": "UDUMALPET",
                                    "Value": "UDUMALPET"
                                },
                                {
                                    "Text": "UDUMALAIPETTAI",
                                    "Value": "UDUMALAIPETTAI"
                                },
                                {
                                    "Text": "UDUPI",
                                    "Value": "UDUPI"
                                },
                                {
                                    "Text": "UDWADA",
                                    "Value": "UDWADA"
                                },
                                {
                                    "Text": "UGANI ",
                                    "Value": "UGANI "
                                },
                                {
                                    "Text": "UGGI",
                                    "Value": "UGGI"
                                },
                                {
                                    "Text": "UGRAWAI ",
                                    "Value": "UGRAWAI "
                                },
                                {
                                    "Text": "UGRA KHERI",
                                    "Value": "UGRA KHERI"
                                },
                                {
                                    "Text": "UJHANI",
                                    "Value": "UJHANI"
                                },
                                {
                                    "Text": "UJIRE",
                                    "Value": "UJIRE"
                                },
                                {
                                    "Text": "UJJAIN",
                                    "Value": "UJJAIN"
                                },
                                {
                                    "Text": "UKHRUL",
                                    "Value": "UKHRUL"
                                },
                                {
                                    "Text": "UKLANA MANDI",
                                    "Value": "UKLANA MANDI"
                                },
                                {
                                    "Text": "ULHASNAGAR",
                                    "Value": "ULHASNAGAR"
                                },
                                {
                                    "Text": "ULIMELLA ",
                                    "Value": "ULIMELLA "
                                },
                                {
                                    "Text": "ULLUBERIA",
                                    "Value": "ULLUBERIA"
                                },
                                {
                                    "Text": "ULUBERIA",
                                    "Value": "ULUBERIA"
                                },
                                {
                                    "Text": "UMARIA",
                                    "Value": "UMARIA"
                                },
                                {
                                    "Text": "UMBERGOAN",
                                    "Value": "UMBERGOAN"
                                },
                                {
                                    "Text": "UMBERGOAN",
                                    "Value": "UMBERGOAN"
                                },
                                {
                                    "Text": "UMBRAJ",
                                    "Value": "UMBRAJ"
                                },
                                {
                                    "Text": "UMRED",
                                    "Value": "UMRED"
                                },
                                {
                                    "Text": "UNA",
                                    "Value": "UNA"
                                },
                                {
                                    "Text": "UNA",
                                    "Value": "UNA"
                                },
                                {
                                    "Text": "UNAKOTI",
                                    "Value": "UNAKOTI"
                                },
                                {
                                    "Text": "UNCHAHAR",
                                    "Value": "UNCHAHAR"
                                },
                                {
                                    "Text": "UNJHA",
                                    "Value": "UNJHA"
                                },
                                {
                                    "Text": "UNNAO",
                                    "Value": "UNNAO"
                                },
                                {
                                    "Text": "UNTSAL",
                                    "Value": "UNTSAL"
                                },
                                {
                                    "Text": "UPLETA",
                                    "Value": "UPLETA"
                                },
                                {
                                    "Text": "UPPER SIANG",
                                    "Value": "UPPER SIANG"
                                },
                                {
                                    "Text": "UPPER SUBANSIRI",
                                    "Value": "UPPER SUBANSIRI"
                                },
                                {
                                    "Text": "UPPINIVALASA ",
                                    "Value": "UPPINIVALASA "
                                },
                                {
                                    "Text": "UPPUR ",
                                    "Value": "UPPUR "
                                },
                                {
                                    "Text": "URALI KANCHAN",
                                    "Value": "URALI KANCHAN"
                                },
                                {
                                    "Text": "URAN ISLAMPUR",
                                    "Value": "URAN ISLAMPUR"
                                },
                                {
                                    "Text": "URAN",
                                    "Value": "URAN"
                                },
                                {
                                    "Text": "URMAR TANDA",
                                    "Value": "URMAR TANDA"
                                },
                                {
                                    "Text": "URSE",
                                    "Value": "URSE"
                                },
                                {
                                    "Text": "USGAO",
                                    "Value": "USGAO"
                                },
                                {
                                    "Text": "U.T OF DADRA & NAGAR HAVELI",
                                    "Value": "U.T OF DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "UTLAPALLY ",
                                    "Value": "UTLAPALLY "
                                },
                                {
                                    "Text": "U.T OF DADRA & NAGAR HAVELI",
                                    "Value": "U.T OF DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "UTTARPARA",
                                    "Value": "UTTARPARA"
                                },
                                {
                                    "Text": "UTRAULA",
                                    "Value": "UTRAULA"
                                },
                                {
                                    "Text": "UTTARA KANNADA",
                                    "Value": "UTTARA KANNADA"
                                },
                                {
                                    "Text": "UTTARKASHI",
                                    "Value": "UTTARKASHI"
                                },
                                {
                                    "Text": "UTTAR DINAJPUR",
                                    "Value": "UTTAR DINAJPUR"
                                },
                                {
                                    "Text": "UTWAD ",
                                    "Value": "UTWAD "
                                },
                                {
                                    "Text": "VADALI",
                                    "Value": "VADALI"
                                },
                                {
                                    "Text": "VADAKARA",
                                    "Value": "VADAKARA"
                                },
                                {
                                    "Text": "VADAKKANCHERI",
                                    "Value": "VADAKKANCHERI"
                                },
                                {
                                    "Text": "VADAVALLI",
                                    "Value": "VADAVALLI"
                                },
                                {
                                    "Text": "VADDIPA ",
                                    "Value": "VADDIPA "
                                },
                                {
                                    "Text": "VADLAKONDA ",
                                    "Value": "VADLAKONDA "
                                },
                                {
                                    "Text": "VADODARA",
                                    "Value": "VADODARA"
                                },
                                {
                                    "Text": "VADUJ",
                                    "Value": "VADUJ"
                                },
                                {
                                    "Text": "VADUJ",
                                    "Value": "VADUJ"
                                },
                                {
                                    "Text": "VAIJAPUR",
                                    "Value": "VAIJAPUR"
                                },
                                {
                                    "Text": "VAIKOM",
                                    "Value": "VAIKOM"
                                },
                                {
                                    "Text": "VAISHALI",
                                    "Value": "VAISHALI"
                                },
                                {
                                    "Text": "VALANCHERY",
                                    "Value": "VALANCHERY"
                                },
                                {
                                    "Text": "VALLIOOR",
                                    "Value": "VALLIOOR"
                                },
                                {
                                    "Text": "VALLABH VIDHYA NAGAR",
                                    "Value": "VALLABH VIDHYA NAGAR"
                                },
                                {
                                    "Text": "VALPOI",
                                    "Value": "VALPOI"
                                },
                                {
                                    "Text": "VALSAD",
                                    "Value": "VALSAD"
                                },
                                {
                                    "Text": "VALSARVAKKAM",
                                    "Value": "VALSARVAKKAM"
                                },
                                {
                                    "Text": "VANAGARAM",
                                    "Value": "VANAGARAM"
                                },
                                {
                                    "Text": "VANASGAON",
                                    "Value": "VANASGAON"
                                },
                                {
                                    "Text": "VANGANI",
                                    "Value": "VANGANI"
                                },
                                {
                                    "Text": "VANIYAMBADI",
                                    "Value": "VANIYAMBADI"
                                },
                                {
                                    "Text": "VANNANKULAM",
                                    "Value": "VANNANKULAM"
                                },
                                {
                                    "Text": "VANNEL K",
                                    "Value": "VANNEL K"
                                },
                                {
                                    "Text": "VANSDA",
                                    "Value": "VANSDA"
                                },
                                {
                                    "Text": "VAPI",
                                    "Value": "VAPI"
                                },
                                {
                                    "Text": "VARANASI",
                                    "Value": "VARANASI"
                                },
                                {
                                    "Text": "VARCA",
                                    "Value": "VARCA"
                                },
                                {
                                    "Text": "VARKALA",
                                    "Value": "VARKALA"
                                },
                                {
                                    "Text": "VARSAMEDI",
                                    "Value": "VARSAMEDI"
                                },
                                {
                                    "Text": "VASAI",
                                    "Value": "VASAI"
                                },
                                {
                                    "Text": "VASAD",
                                    "Value": "VASAD"
                                },
                                {
                                    "Text": "VASCO",
                                    "Value": "VASCO"
                                },
                                {
                                    "Text": "VASHI",
                                    "Value": "VASHI"
                                },
                                {
                                    "Text": "VASAI ROAD",
                                    "Value": "VASAI ROAD"
                                },
                                {
                                    "Text": "VATAKARA",
                                    "Value": "VATAKARA"
                                },
                                {
                                    "Text": "VATANAPPILLY",
                                    "Value": "VATANAPPILLY"
                                },
                                {
                                    "Text": "VATANAPPALLY",
                                    "Value": "VATANAPPALLY"
                                },
                                {
                                    "Text": "VAVDI",
                                    "Value": "VAVDI"
                                },
                                {
                                    "Text": "VAVILALA ",
                                    "Value": "VAVILALA "
                                },
                                {
                                    "Text": "VAZHAPADI ",
                                    "Value": "VAZHAPADI "
                                },
                                {
                                    "Text": "VALLABHIPUR",
                                    "Value": "VALLABHIPUR"
                                },
                                {
                                    "Text": "VEERLAPALEM ",
                                    "Value": "VEERLAPALEM "
                                },
                                {
                                    "Text": "VEERANNAPALEM ",
                                    "Value": "VEERANNAPALEM "
                                },
                                {
                                    "Text": "VEGAVARAM ",
                                    "Value": "VEGAVARAM "
                                },
                                {
                                    "Text": "VEJALPUR",
                                    "Value": "VEJALPUR"
                                },
                                {
                                    "Text": "VEJALPUR",
                                    "Value": "VEJALPUR"
                                },
                                {
                                    "Text": "VELIYANAD",
                                    "Value": "VELIYANAD"
                                },
                                {
                                    "Text": "VELLORE",
                                    "Value": "VELLORE"
                                },
                                {
                                    "Text": "VELLA ",
                                    "Value": "VELLA "
                                },
                                {
                                    "Text": "VELLIMALAI ",
                                    "Value": "VELLIMALAI "
                                },
                                {
                                    "Text": "VEMNOOR ",
                                    "Value": "VEMNOOR "
                                },
                                {
                                    "Text": "VEMULAKURTHI",
                                    "Value": "VEMULAKURTHI"
                                },
                                {
                                    "Text": "VEMULAWADA",
                                    "Value": "VEMULAWADA"
                                },
                                {
                                    "Text": "VENGALA RAO COLONY ",
                                    "Value": "VENGALA RAO COLONY "
                                },
                                {
                                    "Text": "VENKATAGIRI",
                                    "Value": "VENKATAGIRI"
                                },
                                {
                                    "Text": "VENKATADRI PALEM ",
                                    "Value": "VENKATADRI PALEM "
                                },
                                {
                                    "Text": "VENKATAPURAM ",
                                    "Value": "VENKATAPURAM "
                                },
                                {
                                    "Text": "VENKATAGIRIKOTE ",
                                    "Value": "VENKATAGIRIKOTE "
                                },
                                {
                                    "Text": "VENTURU ",
                                    "Value": "VENTURU "
                                },
                                {
                                    "Text": "VERAVAL",
                                    "Value": "VERAVAL"
                                },
                                {
                                    "Text": "VEREM",
                                    "Value": "VEREM"
                                },
                                {
                                    "Text": "VERNA",
                                    "Value": "VERNA"
                                },
                                {
                                    "Text": "VERNA",
                                    "Value": "VERNA"
                                },
                                {
                                    "Text": "VICARABAD",
                                    "Value": "VICARABAD"
                                },
                                {
                                    "Text": "VIDISHA",
                                    "Value": "VIDISHA"
                                },
                                {
                                    "Text": "VIJAPUR",
                                    "Value": "VIJAPUR"
                                },
                                {
                                    "Text": "VIJAYWADA",
                                    "Value": "VIJAYWADA"
                                },
                                {
                                    "Text": "VIJAYANAGAR III STAGE ",
                                    "Value": "VIJAYANAGAR III STAGE "
                                },
                                {
                                    "Text": "VIJAINAGAR",
                                    "Value": "VIJAINAGAR"
                                },
                                {
                                    "Text": "VIJAIPUR",
                                    "Value": "VIJAIPUR"
                                },
                                {
                                    "Text": "VIJAYAWADA",
                                    "Value": "VIJAYAWADA"
                                },
                                {
                                    "Text": "VIJAYPURA",
                                    "Value": "VIJAYPURA"
                                },
                                {
                                    "Text": "VIKASNAGAR",
                                    "Value": "VIKASNAGAR"
                                },
                                {
                                    "Text": "VIKRAMGAD",
                                    "Value": "VIKRAMGAD"
                                },
                                {
                                    "Text": "VILLUPURAM",
                                    "Value": "VILLUPURAM"
                                },
                                {
                                    "Text": "VINUKONDA",
                                    "Value": "VINUKONDA"
                                },
                                {
                                    "Text": "VIRAMGAM",
                                    "Value": "VIRAMGAM"
                                },
                                {
                                    "Text": "VIRAR",
                                    "Value": "VIRAR"
                                },
                                {
                                    "Text": "VIRAJPET",
                                    "Value": "VIRAJPET"
                                },
                                {
                                    "Text": "VIRUDHUNAGAR",
                                    "Value": "VIRUDHUNAGAR"
                                },
                                {
                                    "Text": "VISAKHAPATNAM",
                                    "Value": "VISAKHAPATNAM"
                                },
                                {
                                    "Text": "VISAVADAR",
                                    "Value": "VISAVADAR"
                                },
                                {
                                    "Text": "VISNAGAR",
                                    "Value": "VISNAGAR"
                                },
                                {
                                    "Text": "VITA",
                                    "Value": "VITA"
                                },
                                {
                                    "Text": "VIZIANAGARAM",
                                    "Value": "VIZIANAGARAM"
                                },
                                {
                                    "Text": "VAJRESHWARI",
                                    "Value": "VAJRESHWARI"
                                },
                                {
                                    "Text": "VIKASPURI",
                                    "Value": "VIKASPURI"
                                },
                                {
                                    "Text": "VIMAN NAGAR",
                                    "Value": "VIMAN NAGAR"
                                },
                                {
                                    "Text": "VENGURLA",
                                    "Value": "VENGURLA"
                                },
                                {
                                    "Text": "VRINDAVAN",
                                    "Value": "VRINDAVAN"
                                },
                                {
                                    "Text": "VERSOVA",
                                    "Value": "VERSOVA"
                                },
                                {
                                    "Text": "VASHIND",
                                    "Value": "VASHIND"
                                },
                                {
                                    "Text": "VASNA",
                                    "Value": "VASNA"
                                },
                                {
                                    "Text": "VITHALWADI",
                                    "Value": "VITHALWADI"
                                },
                                {
                                    "Text": "VAITARNA",
                                    "Value": "VAITARNA"
                                },
                                {
                                    "Text": "VUYYURU",
                                    "Value": "VUYYURU"
                                },
                                {
                                    "Text": "VYARA",
                                    "Value": "VYARA"
                                },
                                {
                                    "Text": "WADAKANCHERY",
                                    "Value": "WADAKANCHERY"
                                },
                                {
                                    "Text": "WADAPARTHY ",
                                    "Value": "WADAPARTHY "
                                },
                                {
                                    "Text": "WADALA KALAN ",
                                    "Value": "WADALA KALAN "
                                },
                                {
                                    "Text": "WADA",
                                    "Value": "WADA"
                                },
                                {
                                    "Text": "WADAKKANCHERY",
                                    "Value": "WADAKKANCHERY"
                                },
                                {
                                    "Text": "WADHWAN",
                                    "Value": "WADHWAN"
                                },
                                {
                                    "Text": "WADI",
                                    "Value": "WADI"
                                },
                                {
                                    "Text": "WADRAFNAGAR",
                                    "Value": "WADRAFNAGAR"
                                },
                                {
                                    "Text": "WAHABWALA",
                                    "Value": "WAHABWALA"
                                },
                                {
                                    "Text": "WAI",
                                    "Value": "WAI"
                                },
                                {
                                    "Text": "WAIDHAN",
                                    "Value": "WAIDHAN"
                                },
                                {
                                    "Text": "WAIDHAN - SINGRAULI",
                                    "Value": "WAIDHAN - SINGRAULI"
                                },
                                {
                                    "Text": "WAKULNI ",
                                    "Value": "WAKULNI "
                                },
                                {
                                    "Text": "WALAJAPET",
                                    "Value": "WALAJAPET"
                                },
                                {
                                    "Text": "WALSA KHALSA ",
                                    "Value": "WALSA KHALSA "
                                },
                                {
                                    "Text": "WANAPARTHY",
                                    "Value": "WANAPARTHY"
                                },
                                {
                                    "Text": "WANI",
                                    "Value": "WANI"
                                },
                                {
                                    "Text": "WANKANER",
                                    "Value": "WANKANER"
                                },
                                {
                                    "Text": "WARANGAL",
                                    "Value": "WARANGAL"
                                },
                                {
                                    "Text": "WARDHA",
                                    "Value": "WARDHA"
                                },
                                {
                                    "Text": "WARORA",
                                    "Value": "WARORA"
                                },
                                {
                                    "Text": "WARUD",
                                    "Value": "WARUD"
                                },
                                {
                                    "Text": "WARUDKAZI ",
                                    "Value": "WARUDKAZI "
                                },
                                {
                                    "Text": "WARYAM KHERA",
                                    "Value": "WARYAM KHERA"
                                },
                                {
                                    "Text": "WARZADI ",
                                    "Value": "WARZADI "
                                },
                                {
                                    "Text": "WASHIM",
                                    "Value": "WASHIM"
                                },
                                {
                                    "Text": "WAYANAD",
                                    "Value": "WAYANAD"
                                },
                                {
                                    "Text": "WEST NIMAR",
                                    "Value": "WEST NIMAR"
                                },
                                {
                                    "Text": "WEST CHAMPARAN",
                                    "Value": "WEST CHAMPARAN"
                                },
                                {
                                    "Text": "WEST DELHI",
                                    "Value": "WEST DELHI"
                                },
                                {
                                    "Text": "WEST GARO HILLS",
                                    "Value": "WEST GARO HILLS"
                                },
                                {
                                    "Text": "WEST GODAVARI",
                                    "Value": "WEST GODAVARI"
                                },
                                {
                                    "Text": "WEST KAMENG",
                                    "Value": "WEST KAMENG"
                                },
                                {
                                    "Text": "WEST KHASI HILLS",
                                    "Value": "WEST KHASI HILLS"
                                },
                                {
                                    "Text": "WEST MIDNAPORE",
                                    "Value": "WEST MIDNAPORE"
                                },
                                {
                                    "Text": "WEST SIANG",
                                    "Value": "WEST SIANG"
                                },
                                {
                                    "Text": "WEST SIKKIM",
                                    "Value": "WEST SIKKIM"
                                },
                                {
                                    "Text": "WEST SINGHBHUM",
                                    "Value": "WEST SINGHBHUM"
                                },
                                {
                                    "Text": "WEST TRIPURA",
                                    "Value": "WEST TRIPURA"
                                },
                                {
                                    "Text": "WAGHODIA",
                                    "Value": "WAGHODIA"
                                },
                                {
                                    "Text": "WILLIAMNAGAR",
                                    "Value": "WILLIAMNAGAR"
                                },
                                {
                                    "Text": "WARANANAGAR",
                                    "Value": "WARANANAGAR"
                                },
                                {
                                    "Text": "WANOWRIE",
                                    "Value": "WANOWRIE"
                                },
                                {
                                    "Text": "WOKHA",
                                    "Value": "WOKHA"
                                },
                                {
                                    "Text": "YADGIR",
                                    "Value": "YADGIR"
                                },
                                {
                                    "Text": "YADGARPALLY ",
                                    "Value": "YADGARPALLY "
                                },
                                {
                                    "Text": "YAIRIPOK",
                                    "Value": "YAIRIPOK"
                                },
                                {
                                    "Text": "YAMUNA NAGAR",
                                    "Value": "YAMUNA NAGAR"
                                },
                                {
                                    "Text": "YAMUNA NAGAR",
                                    "Value": "YAMUNA NAGAR"
                                },
                                {
                                    "Text": "YAMUNANAGAR",
                                    "Value": "YAMUNANAGAR"
                                },
                                {
                                    "Text": "YANAM",
                                    "Value": "YANAM"
                                },
                                {
                                    "Text": "YAVATMAL",
                                    "Value": "YAVATMAL"
                                },
                                {
                                    "Text": "YELLAPUR",
                                    "Value": "YELLAPUR"
                                },
                                {
                                    "Text": "YELLAPPAGONDA ",
                                    "Value": "YELLAPPAGONDA "
                                },
                                {
                                    "Text": "YEMMIGANUR",
                                    "Value": "YEMMIGANUR"
                                },
                                {
                                    "Text": "YENKIRYAL ",
                                    "Value": "YENKIRYAL "
                                },
                                {
                                    "Text": "YERRAGOLLA PAHAD ",
                                    "Value": "YERRAGOLLA PAHAD "
                                },
                                {
                                    "Text": "YESWANTAPUR ",
                                    "Value": "YESWANTAPUR "
                                },
                                {
                                    "Text": "YEVLA",
                                    "Value": "YEVLA"
                                },
                                {
                                    "Text": "YEVOLA",
                                    "Value": "YEVOLA"
                                },
                                {
                                    "Text": "Y G PETA ",
                                    "Value": "Y G PETA "
                                },
                                {
                                    "Text": "YINGKIONG",
                                    "Value": "YINGKIONG"
                                },
                                {
                                    "Text": "YELLAPUR",
                                    "Value": "YELLAPUR"
                                },
                                {
                                    "Text": "ZAHIRABAD",
                                    "Value": "ZAHIRABAD"
                                },
                                {
                                    "Text": "ZAINAKOTE",
                                    "Value": "ZAINAKOTE"
                                },
                                {
                                    "Text": "ZINKIBHADRA",
                                    "Value": "ZINKIBHADRA"
                                },
                                {
                                    "Text": "ZIRA",
                                    "Value": "ZIRA"
                                },
                                {
                                    "Text": "ZIRAYATHNAGAR ",
                                    "Value": "ZIRAYATHNAGAR "
                                },
                                {
                                    "Text": "ZIRAKPUR",
                                    "Value": "ZIRAKPUR"
                                },
                                {
                                    "Text": "ZIRO",
                                    "Value": "ZIRO"
                                },
                                {
                                    "Text": "ZUARINAGAR",
                                    "Value": "ZUARINAGAR"
                                },
                                {
                                    "Text": "ZIAUDDIN PUR",
                                    "Value": "ZIAUDDIN PUR"
                                },
                                {
                                    "Text": "ZUNHEBOTTO",
                                    "Value": "ZUNHEBOTTO"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": "/^[a-zA-Z\\s]{1,50}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['country']['input'] === 'India'",
                            "validation": ""
                        },
                        "cityOther": {
                            "id": "1454",
                            "label": "Other City",
                            "name": "cityOther",
                            "description": "No special characters allowed #Type name of city",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": "/^[a-zA-Z\\',.\\\\s-]{1,50}$/",
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['country']['input'] !== 'India'",
                            "validation": ""
                        },
                        "state": {
                            "id": "1463",
                            "label": "State",
                            "name": "state",
                            "description": "State",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "ANDAMAN & NICOBAR ISLANDS",
                                    "Value": "ANDAMAN & NICOBAR ISLANDS"
                                },
                                {
                                    "Text": "ANDHRA PRADESH",
                                    "Value": "ANDHRA PRADESH"
                                },
                                {
                                    "Text": "ARUNACHAL PRADESH",
                                    "Value": "ARUNACHAL PRADESH"
                                },
                                {
                                    "Text": "ASSAM",
                                    "Value": "ASSAM"
                                },
                                {
                                    "Text": "BIHAR",
                                    "Value": "BIHAR"
                                },
                                {
                                    "Text": "CHANDIGARH",
                                    "Value": "CHANDIGARH"
                                },
                                {
                                    "Text": "CHATTISGARH",
                                    "Value": "CHATTISGARH"
                                },
                                {
                                    "Text": "DAMAN & DIU",
                                    "Value": "DAMAN & DIU"
                                },
                                {
                                    "Text": "DELHI",
                                    "Value": "DELHI"
                                },
                                {
                                    "Text": "DADRA & NAGAR HAVELI",
                                    "Value": "DADRA & NAGAR HAVELI"
                                },
                                {
                                    "Text": "GOA",
                                    "Value": "GOA"
                                },
                                {
                                    "Text": "GUJARAT",
                                    "Value": "GUJARAT"
                                },
                                {
                                    "Text": "HARYANA",
                                    "Value": "HARYANA"
                                },
                                {
                                    "Text": "HIMACHAL PRADESH",
                                    "Value": "HIMACHAL PRADESH"
                                },
                                {
                                    "Text": "JAMMU & KASHMIR",
                                    "Value": "JAMMU & KASHMIR"
                                },
                                {
                                    "Text": "JHARKHAND",
                                    "Value": "JHARKHAND"
                                },
                                {
                                    "Text": "KARNATAKA",
                                    "Value": "KARNATAKA"
                                },
                                {
                                    "Text": "KERALA",
                                    "Value": "KERALA"
                                },
                                {
                                    "Text": "LAKSHADWEEP",
                                    "Value": "LAKSHADWEEP"
                                },
                                {
                                    "Text": "MAHARASHTRA",
                                    "Value": "MAHARASHTRA"
                                },
                                {
                                    "Text": "MANIPUR",
                                    "Value": "MANIPUR"
                                },
                                {
                                    "Text": "MEGHALAYA",
                                    "Value": "MEGHALAYA"
                                },
                                {
                                    "Text": "MIZORAM",
                                    "Value": "MIZORAM"
                                },
                                {
                                    "Text": "MADHYA PRADESH",
                                    "Value": "MADHYA PRADESH"
                                },
                                {
                                    "Text": "NAGALAND",
                                    "Value": "NAGALAND"
                                },
                                {
                                    "Text": "ODISHA",
                                    "Value": "ODISHA"
                                },
                                {
                                    "Text": "PONDICHERRY",
                                    "Value": "PONDICHERRY"
                                },
                                {
                                    "Text": "PUNJAB",
                                    "Value": "PUNJAB"
                                },
                                {
                                    "Text": "RAJASTHAN",
                                    "Value": "RAJASTHAN"
                                },
                                {
                                    "Text": "SIKKIM",
                                    "Value": "SIKKIM"
                                },
                                {
                                    "Text": "TAMIL NADU",
                                    "Value": "TAMIL NADU"
                                },
                                {
                                    "Text": "TELANGANA",
                                    "Value": "TELANGANA"
                                },
                                {
                                    "Text": "TRIPURA",
                                    "Value": "TRIPURA"
                                },
                                {
                                    "Text": "UTTAR PRADESH",
                                    "Value": "UTTAR PRADESH"
                                },
                                {
                                    "Text": "UTTARAKHAND",
                                    "Value": "UTTARAKHAND"
                                },
                                {
                                    "Text": "WEST BENGAL",
                                    "Value": "WEST BENGAL"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['country']['input'] === 'India'",
                            "validation": ""
                        },
                        "stateOther": {
                            "id": "1455",
                            "label": "Other State",
                            "name": "stateOther",
                            "description": "Enter State in case not residing in India",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 50,
                            "pattern": null,
                            "input": "",
                            "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['permanentAddressDetails']['fields']['country']['input'] !== 'India'",
                            "validation": ""
                        },
                        "country": {
                            "id": "1504",
                            "label": "Country",
                            "name": "country",
                            "description": "Country",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Austria",
                                    "Value": "Austria"
                                },
                                {
                                    "Text": "Antigua and Barbuda",
                                    "Value": "Antigua and Barbuda"
                                },
                                {
                                    "Text": "Yemen",
                                    "Value": "Yemen"
                                },
                                {
                                    "Text": "Afghanistan",
                                    "Value": "Afghanistan"
                                },
                                {
                                    "Text": "Angola",
                                    "Value": "Angola"
                                },
                                {
                                    "Text": "Anguilla",
                                    "Value": "Anguilla"
                                },
                                {
                                    "Text": "Albania",
                                    "Value": "Albania"
                                },
                                {
                                    "Text": "Andorra",
                                    "Value": "Andorra"
                                },
                                {
                                    "Text": "Aruba",
                                    "Value": "Aruba"
                                },
                                {
                                    "Text": "Armenia",
                                    "Value": "Armenia"
                                },
                                {
                                    "Text": "Australia",
                                    "Value": "Australia"
                                },
                                {
                                    "Text": "Azerbaijan",
                                    "Value": "Azerbaijan"
                                },
                                {
                                    "Text": "Belgium",
                                    "Value": "Belgium"
                                },
                                {
                                    "Text": "Bangladesh",
                                    "Value": "Bangladesh"
                                },
                                {
                                    "Text": "Barbados",
                                    "Value": "Barbados"
                                },
                                {
                                    "Text": "Bermuda",
                                    "Value": "Bermuda"
                                },
                                {
                                    "Text": "Bulgaria",
                                    "Value": "Bulgaria"
                                },
                                {
                                    "Text": "Belize",
                                    "Value": "Belize"
                                },
                                {
                                    "Text": "Bhutan",
                                    "Value": "Bhutan"
                                },
                                {
                                    "Text": "Burkina Faso",
                                    "Value": "Burkina Faso"
                                },
                                {
                                    "Text": "Belarus",
                                    "Value": "Belarus"
                                },
                                {
                                    "Text": "Brunei",
                                    "Value": "Brunei"
                                },
                                {
                                    "Text": "Bolivia",
                                    "Value": "Bolivia"
                                },
                                {
                                    "Text": "Brazil",
                                    "Value": "Brazil"
                                },
                                {
                                    "Text": "Burundi",
                                    "Value": "Burundi"
                                },
                                {
                                    "Text": "Burma",
                                    "Value": "Burma"
                                },
                                {
                                    "Text": "Bahrain",
                                    "Value": "Bahrain"
                                },
                                {
                                    "Text": "Britain",
                                    "Value": "Britain"
                                },
                                {
                                    "Text": "Bahamas",
                                    "Value": "Bahamas"
                                },
                                {
                                    "Text": "Bosnia",
                                    "Value": "Bosnia"
                                },
                                {
                                    "Text": "Myanmar",
                                    "Value": "Myanmar"
                                },
                                {
                                    "Text": "British Virgin Islands",
                                    "Value": "British Virgin Islands"
                                },
                                {
                                    "Text": "Cuba",
                                    "Value": "Cuba"
                                },
                                {
                                    "Text": "Canada",
                                    "Value": "Canada"
                                },
                                {
                                    "Text": "Switzerland",
                                    "Value": "Switzerland"
                                },
                                {
                                    "Text": "Chad",
                                    "Value": "Chad"
                                },
                                {
                                    "Text": "China",
                                    "Value": "China"
                                },
                                {
                                    "Text": "Ivory Coast",
                                    "Value": "Ivory Coast"
                                },
                                {
                                    "Text": "Sri Lanka",
                                    "Value": "Sri Lanka"
                                },
                                {
                                    "Text": "Cameroon",
                                    "Value": "Cameroon"
                                },
                                {
                                    "Text": "Canary Islands",
                                    "Value": "Canary Islands"
                                },
                                {
                                    "Text": "Colombia",
                                    "Value": "Colombia"
                                },
                                {
                                    "Text": "Comoros",
                                    "Value": "Comoros"
                                },
                                {
                                    "Text": "Cape Verde",
                                    "Value": "Cape Verde"
                                },
                                {
                                    "Text": "Costa Rica",
                                    "Value": "Costa Rica"
                                },
                                {
                                    "Text": "Curacao",
                                    "Value": "Curacao"
                                },
                                {
                                    "Text": "Cape Town",
                                    "Value": "Cape Town"
                                },
                                {
                                    "Text": "Cote dIvoire",
                                    "Value": "Cote dIvoire"
                                },
                                {
                                    "Text": "Cyprus",
                                    "Value": "Cyprus"
                                },
                                {
                                    "Text": "Cayman Islands",
                                    "Value": "Cayman Islands"
                                },
                                {
                                    "Text": "Czech",
                                    "Value": "Czech"
                                },
                                {
                                    "Text": "Germany",
                                    "Value": "Germany"
                                },
                                {
                                    "Text": "Djibouti",
                                    "Value": "Djibouti"
                                },
                                {
                                    "Text": "Denmark",
                                    "Value": "Denmark"
                                },
                                {
                                    "Text": "Dominican Republic",
                                    "Value": "Dominican Republic"
                                },
                                {
                                    "Text": "Democratic Republic of Congo",
                                    "Value": "Democratic Republic of Congo"
                                },
                                {
                                    "Text": "Benin",
                                    "Value": "Benin"
                                },
                                {
                                    "Text": "Algeria",
                                    "Value": "Algeria"
                                },
                                {
                                    "Text": "Spain",
                                    "Value": "Spain"
                                },
                                {
                                    "Text": "EastTimor",
                                    "Value": "EastTimor"
                                },
                                {
                                    "Text": "East Africa",
                                    "Value": "East Africa"
                                },
                                {
                                    "Text": "Kenya",
                                    "Value": "Kenya"
                                },
                                {
                                    "Text": "Tanzania",
                                    "Value": "Tanzania"
                                },
                                {
                                    "Text": "Uganda",
                                    "Value": "Uganda"
                                },
                                {
                                    "Text": "Ecuador",
                                    "Value": "Ecuador"
                                },
                                {
                                    "Text": "England",
                                    "Value": "England"
                                },
                                {
                                    "Text": "Equitorial Guinea",
                                    "Value": "Equitorial Guinea"
                                },
                                {
                                    "Text": "Eritrea",
                                    "Value": "Eritrea"
                                },
                                {
                                    "Text": "El Salvador",
                                    "Value": "El Salvador"
                                },
                                {
                                    "Text": "Egypt",
                                    "Value": "Egypt"
                                },
                                {
                                    "Text": "Ethiopia",
                                    "Value": "Ethiopia"
                                },
                                {
                                    "Text": "Estonia",
                                    "Value": "Estonia"
                                },
                                {
                                    "Text": "France",
                                    "Value": "France"
                                },
                                {
                                    "Text": "Finland",
                                    "Value": "Finland"
                                },
                                {
                                    "Text": "Fiji",
                                    "Value": "Fiji"
                                },
                                {
                                    "Text": "Liechtenstein",
                                    "Value": "Liechtenstein"
                                },
                                {
                                    "Text": "Falkland Islands",
                                    "Value": "Falkland Islands"
                                },
                                {
                                    "Text": "French Guiana",
                                    "Value": "French Guiana"
                                },
                                {
                                    "Text": "French Polynesia",
                                    "Value": "French Polynesia"
                                },
                                {
                                    "Text": "Great Britain",
                                    "Value": "Great Britain"
                                },
                                {
                                    "Text": "Alderney",
                                    "Value": "Alderney"
                                },
                                {
                                    "Text": "Gabon",
                                    "Value": "Gabon"
                                },
                                {
                                    "Text": "Guinea bissau",
                                    "Value": "Guinea bissau"
                                },
                                {
                                    "Text": "Gibraltar",
                                    "Value": "Gibraltar"
                                },
                                {
                                    "Text": "Guatemala",
                                    "Value": "Guatemala"
                                },
                                {
                                    "Text": "Guadeloupe",
                                    "Value": "Guadeloupe"
                                },
                                {
                                    "Text": "Ghana",
                                    "Value": "Ghana"
                                },
                                {
                                    "Text": "Gambia",
                                    "Value": "Gambia"
                                },
                                {
                                    "Text": "Greenland",
                                    "Value": "Greenland"
                                },
                                {
                                    "Text": "Greece",
                                    "Value": "Greece"
                                },
                                {
                                    "Text": "Georgia",
                                    "Value": "Georgia"
                                },
                                {
                                    "Text": "Guinea",
                                    "Value": "Guinea"
                                },
                                {
                                    "Text": "Guam",
                                    "Value": "Guam"
                                },
                                {
                                    "Text": "Guyana",
                                    "Value": "Guyana"
                                },
                                {
                                    "Text": "Hungary",
                                    "Value": "Hungary"
                                },
                                {
                                    "Text": "Honduras",
                                    "Value": "Honduras"
                                },
                                {
                                    "Text": "Hong Kong",
                                    "Value": "Hong Kong"
                                },
                                {
                                    "Text": "Croatia",
                                    "Value": "Croatia"
                                },
                                {
                                    "Text": "Italy",
                                    "Value": "Italy"
                                },
                                {
                                    "Text": "Czech Republic",
                                    "Value": "Czech Republic"
                                },
                                {
                                    "Text": "Israel",
                                    "Value": "Israel"
                                },
                                {
                                    "Text": "India",
                                    "Value": "India"
                                },
                                {
                                    "Text": "Iran",
                                    "Value": "Iran"
                                },
                                {
                                    "Text": "Ireland",
                                    "Value": "Ireland"
                                },
                                {
                                    "Text": "Iraq",
                                    "Value": "Iraq"
                                },
                                {
                                    "Text": "Iceland",
                                    "Value": "Iceland"
                                },
                                {
                                    "Text": "Japan",
                                    "Value": "Japan"
                                },
                                {
                                    "Text": "Jamaica",
                                    "Value": "Jamaica"
                                },
                                {
                                    "Text": "Jordan",
                                    "Value": "Jordan"
                                },
                                {
                                    "Text": "Cambodia",
                                    "Value": "Cambodia"
                                },
                                {
                                    "Text": "Kyrgyzstan",
                                    "Value": "Kyrgyzstan"
                                },
                                {
                                    "Text": "Kiribati",
                                    "Value": "Kiribati"
                                },
                                {
                                    "Text": "Kazhakistan",
                                    "Value": "Kazhakistan"
                                },
                                {
                                    "Text": "Kuwait",
                                    "Value": "Kuwait"
                                },
                                {
                                    "Text": "Luxembourg",
                                    "Value": "Luxembourg"
                                },
                                {
                                    "Text": "Laos",
                                    "Value": "Laos"
                                },
                                {
                                    "Text": "Libya",
                                    "Value": "Libya"
                                },
                                {
                                    "Text": "Liberia",
                                    "Value": "Liberia"
                                },
                                {
                                    "Text": "Lesotho",
                                    "Value": "Lesotho"
                                },
                                {
                                    "Text": "Lithuania",
                                    "Value": "Lithuania"
                                },
                                {
                                    "Text": "Latvia",
                                    "Value": "Latvia"
                                },
                                {
                                    "Text": "Malta",
                                    "Value": "Malta"
                                },
                                {
                                    "Text": "Morocco",
                                    "Value": "Morocco"
                                },
                                {
                                    "Text": "Malaysia",
                                    "Value": "Malaysia"
                                },
                                {
                                    "Text": "Monaco",
                                    "Value": "Monaco"
                                },
                                {
                                    "Text": "Micronesia",
                                    "Value": "Micronesia"
                                },
                                {
                                    "Text": "Macau",
                                    "Value": "Macau"
                                },
                                {
                                    "Text": "Madeira",
                                    "Value": "Madeira"
                                },
                                {
                                    "Text": "Moldova",
                                    "Value": "Moldova"
                                },
                                {
                                    "Text": "Mexico",
                                    "Value": "Mexico"
                                },
                                {
                                    "Text": "Montenegro",
                                    "Value": "Montenegro"
                                },
                                {
                                    "Text": "Mangolia",
                                    "Value": "Mangolia"
                                },
                                {
                                    "Text": "Macedonia",
                                    "Value": "Macedonia"
                                },
                                {
                                    "Text": "Maldives",
                                    "Value": "Maldives"
                                },
                                {
                                    "Text": "Mauritius",
                                    "Value": "Mauritius"
                                },
                                {
                                    "Text": "Marshall Islands",
                                    "Value": "Marshall Islands"
                                },
                                {
                                    "Text": "Martinique",
                                    "Value": "Martinique"
                                },
                                {
                                    "Text": "Monteserrat",
                                    "Value": "Monteserrat"
                                },
                                {
                                    "Text": "Malawi",
                                    "Value": "Malawi"
                                },
                                {
                                    "Text": "Mozambique",
                                    "Value": "Mozambique"
                                },
                                {
                                    "Text": "Norway",
                                    "Value": "Norway"
                                },
                                {
                                    "Text": "Nauru",
                                    "Value": "Nauru"
                                },
                                {
                                    "Text": "New Caledonia",
                                    "Value": "New Caledonia"
                                },
                                {
                                    "Text": "Nepal",
                                    "Value": "Nepal"
                                },
                                {
                                    "Text": "Nicaragua",
                                    "Value": "Nicaragua"
                                },
                                {
                                    "Text": "Northern Ireland",
                                    "Value": "Northern Ireland"
                                },
                                {
                                    "Text": "Niue",
                                    "Value": "Niue"
                                },
                                {
                                    "Text": "North Korea",
                                    "Value": "North Korea"
                                },
                                {
                                    "Text": "Netherlands",
                                    "Value": "Netherlands"
                                },
                                {
                                    "Text": "Namibia",
                                    "Value": "Namibia"
                                },
                                {
                                    "Text": "New Zealand",
                                    "Value": "New Zealand"
                                },
                                {
                                    "Text": "Oman",
                                    "Value": "Oman"
                                },
                                {
                                    "Text": "Other",
                                    "Value": "Other"
                                },
                                {
                                    "Text": "Portugal",
                                    "Value": "Portugal"
                                },
                                {
                                    "Text": "Panama",
                                    "Value": "Panama"
                                },
                                {
                                    "Text": "Peru",
                                    "Value": "Peru"
                                },
                                {
                                    "Text": "Pakistan",
                                    "Value": "Pakistan"
                                },
                                {
                                    "Text": "Poland",
                                    "Value": "Poland"
                                },
                                {
                                    "Text": "Palestine",
                                    "Value": "Palestine"
                                },
                                {
                                    "Text": "Palau",
                                    "Value": "Palau"
                                },
                                {
                                    "Text": "Papua New guinea",
                                    "Value": "Papua New guinea"
                                },
                                {
                                    "Text": "Puerto Rico",
                                    "Value": "Puerto Rico"
                                },
                                {
                                    "Text": "Paraguay",
                                    "Value": "Paraguay"
                                },
                                {
                                    "Text": "Qatar",
                                    "Value": "Qatar"
                                },
                                {
                                    "Text": "Argentina",
                                    "Value": "Argentina"
                                },
                                {
                                    "Text": "Botswana",
                                    "Value": "Botswana"
                                },
                                {
                                    "Text": "Central African Republic",
                                    "Value": "Central African Republic"
                                },
                                {
                                    "Text": "Congo",
                                    "Value": "Congo"
                                },
                                {
                                    "Text": "Chile",
                                    "Value": "Chile"
                                },
                                {
                                    "Text": "Reunion",
                                    "Value": "Reunion"
                                },
                                {
                                    "Text": "Haiti",
                                    "Value": "Haiti"
                                },
                                {
                                    "Text": "Indonesia",
                                    "Value": "Indonesia"
                                },
                                {
                                    "Text": "Mauritania",
                                    "Value": "Mauritania"
                                },
                                {
                                    "Text": "Lebanon",
                                    "Value": "Lebanon"
                                },
                                {
                                    "Text": "Madagascar",
                                    "Value": "Madagascar"
                                },
                                {
                                    "Text": "Mali",
                                    "Value": "Mali"
                                },
                                {
                                    "Text": "Niger",
                                    "Value": "Niger"
                                },
                                {
                                    "Text": "Romania",
                                    "Value": "Romania"
                                },
                                {
                                    "Text": "Republic of Congo",
                                    "Value": "Republic of Congo"
                                },
                                {
                                    "Text": "Republic of Korea",
                                    "Value": "Republic of Korea"
                                },
                                {
                                    "Text": "Uruguay",
                                    "Value": "Uruguay"
                                },
                                {
                                    "Text": "Philippines",
                                    "Value": "Philippines"
                                },
                                {
                                    "Text": "RSA",
                                    "Value": "RSA"
                                },
                                {
                                    "Text": "San Marino",
                                    "Value": "San Marino"
                                },
                                {
                                    "Text": "Russia",
                                    "Value": "Russia"
                                },
                                {
                                    "Text": "Rwanda",
                                    "Value": "Rwanda"
                                },
                                {
                                    "Text": "Sweden",
                                    "Value": "Sweden"
                                },
                                {
                                    "Text": "Saudi Arabia",
                                    "Value": "Saudi Arabia"
                                },
                                {
                                    "Text": "Scotland",
                                    "Value": "Scotland"
                                },
                                {
                                    "Text": "Swaziland",
                                    "Value": "Swaziland"
                                },
                                {
                                    "Text": "Singapore",
                                    "Value": "Singapore"
                                },
                                {
                                    "Text": "Slovakia",
                                    "Value": "Slovakia"
                                },
                                {
                                    "Text": "South Korea",
                                    "Value": "South Korea"
                                },
                                {
                                    "Text": "St Kitts and Nevis",
                                    "Value": "St Kitts and Nevis"
                                },
                                {
                                    "Text": "St Lucia",
                                    "Value": "St Lucia"
                                },
                                {
                                    "Text": "Slovenia",
                                    "Value": "Slovenia"
                                },
                                {
                                    "Text": "St Martin",
                                    "Value": "St Martin"
                                },
                                {
                                    "Text": "Surinam",
                                    "Value": "Surinam"
                                },
                                {
                                    "Text": "Solomon Islands",
                                    "Value": "Solomon Islands"
                                },
                                {
                                    "Text": "Senegal",
                                    "Value": "Senegal"
                                },
                                {
                                    "Text": "Somalia",
                                    "Value": "Somalia"
                                },
                                {
                                    "Text": "Serbia",
                                    "Value": "Serbia"
                                },
                                {
                                    "Text": "South Sudan",
                                    "Value": "South Sudan"
                                },
                                {
                                    "Text": "Sao Principe and Tome",
                                    "Value": "Sao Principe and Tome"
                                },
                                {
                                    "Text": "Sudan",
                                    "Value": "Sudan"
                                },
                                {
                                    "Text": "St Vincent and Grenadines",
                                    "Value": "St Vincent and Grenadines"
                                },
                                {
                                    "Text": "Swansea",
                                    "Value": "Swansea"
                                },
                                {
                                    "Text": "Seychelles",
                                    "Value": "Seychelles"
                                },
                                {
                                    "Text": "Syria",
                                    "Value": "Syria"
                                },
                                {
                                    "Text": "Thailand",
                                    "Value": "Thailand"
                                },
                                {
                                    "Text": "Taiwan",
                                    "Value": "Taiwan"
                                },
                                {
                                    "Text": "Tibet",
                                    "Value": "Tibet"
                                },
                                {
                                    "Text": "Togo",
                                    "Value": "Togo"
                                },
                                {
                                    "Text": "Gambia/ The Gambia",
                                    "Value": "Gambia/ The Gambia"
                                },
                                {
                                    "Text": "Tahiti",
                                    "Value": "Tahiti"
                                },
                                {
                                    "Text": "Tajikistan",
                                    "Value": "Tajikistan"
                                },
                                {
                                    "Text": "Tokelau",
                                    "Value": "Tokelau"
                                },
                                {
                                    "Text": "Turkmenistan",
                                    "Value": "Turkmenistan"
                                },
                                {
                                    "Text": "Tunisia",
                                    "Value": "Tunisia"
                                },
                                {
                                    "Text": "Tonga",
                                    "Value": "Tonga"
                                },
                                {
                                    "Text": "Turkey",
                                    "Value": "Turkey"
                                },
                                {
                                    "Text": "Trinidad and Tobago",
                                    "Value": "Trinidad and Tobago"
                                },
                                {
                                    "Text": "Turks and Caicos",
                                    "Value": "Turks and Caicos"
                                },
                                {
                                    "Text": "Tuvalu",
                                    "Value": "Tuvalu"
                                },
                                {
                                    "Text": "Ukraine",
                                    "Value": "Ukraine"
                                },
                                {
                                    "Text": "United Arab Emirates",
                                    "Value": "United Arab Emirates"
                                },
                                {
                                    "Text": "United Kingdom",
                                    "Value": "United Kingdom"
                                },
                                {
                                    "Text": "United States of America",
                                    "Value": "United States of America"
                                },
                                {
                                    "Text": "US Virgin Islands",
                                    "Value": "US Virgin Islands"
                                },
                                {
                                    "Text": "Uzbekistan",
                                    "Value": "Uzbekistan"
                                },
                                {
                                    "Text": "Vanuatu",
                                    "Value": "Vanuatu"
                                },
                                {
                                    "Text": "Vatican",
                                    "Value": "Vatican"
                                },
                                {
                                    "Text": "Vietnam",
                                    "Value": "Vietnam"
                                },
                                {
                                    "Text": "Watford",
                                    "Value": "Watford"
                                },
                                {
                                    "Text": "Sierra Leone",
                                    "Value": "Sierra Leone"
                                },
                                {
                                    "Text": "Nigeria",
                                    "Value": "Nigeria"
                                },
                                {
                                    "Text": "London",
                                    "Value": "London"
                                },
                                {
                                    "Text": "Dominica",
                                    "Value": "Dominica"
                                },
                                {
                                    "Text": "West Africa",
                                    "Value": "West Africa"
                                },
                                {
                                    "Text": "Grenada",
                                    "Value": "Grenada"
                                },
                                {
                                    "Text": "Samoa",
                                    "Value": "Samoa"
                                },
                                {
                                    "Text": "Western Sahara",
                                    "Value": "Western Sahara"
                                },
                                {
                                    "Text": "Yugoslavia",
                                    "Value": "Yugoslavia"
                                },
                                {
                                    "Text": "Venezuela",
                                    "Value": "Venezuela"
                                },
                                {
                                    "Text": "Zambia",
                                    "Value": "Zambia"
                                },
                                {
                                    "Text": "South Africa",
                                    "Value": "South Africa"
                                },
                                {
                                    "Text": "Zaire",
                                    "Value": "Zaire"
                                },
                                {
                                    "Text": "Zimbabwe",
                                    "Value": "Zimbabwe"
                                }
                            ],
                            "default": "",
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "preferredAddressType": {
                            "id": "1386",
                            "label": "Which of the above address is your Preferred Communication Address Type ?",
                            "name": "preferredAddressType",
                            "description": "Which of the above address is your Preferred Communication Address Type ?",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Correspondence",
                                    "Value": "Correspondence"
                                },
                                {
                                    "Text": "Permanent ",
                                    "Value": "Permanent "
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        }
                    }
                },
                "nriDetails": {
                    "id": 41,
                    "name": "nriDetails",
                    "description": "Section to capture FATCA details of the Proposer",
                    "parent": 24,
                    "label": "NRI Details",
                    "type": null,
                    "sizeOfArray": null,
                    "visibility": "formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['residentStatus']['input'] ==='NRI'",
                    "validation": null,
                    "order": 5,
                    "fields": {
                        "addressForeign": {
                            "id": "1675",
                            "label": "Address of foreign residence.",
                            "name": "addressForeign",
                            "description": "Address should be as per Valid Proof Your policy document will be sent to this address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "details": {
                            "id": "1676",
                            "label": "The name of your regular medical physician while abroad, with full contact information. -Telephone No, Address, E-mail address, etc",
                            "name": "details",
                            "description": "Enter your doctor details",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "addressLine": {
                            "id": "1677",
                            "label": "Permanent address in India.",
                            "name": "addressLine",
                            "description": "Address should be as per Valid Proof Your policy document will be sent to this address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "nationality": {
                            "id": "1678",
                            "label": "Nationality",
                            "name": "nationality",
                            "description": "Nationality",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Indian",
                                    "Value": "indian"
                                },
                                {
                                    "Text": "Non Indian",
                                    "Value": "nonIndian"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": "",
                            "validation": ""
                        },
                        "dateForLeavingIndia": {
                            "id": "1679",
                            "label": "Date of first leaving India.",
                            "name": "dateForLeavingIndia",
                            "description": "Please provide valid Date of first leaving India",
                            "mandatory": 1,
                            "type": "date",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": "new Date(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['nriDetails']['fields']['dateForLeavingIndia']['input']) < new Date() && new Date(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['nriDetails']['fields']['dateForLeavingIndia']['input']) > new Date(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['personalDetails']['fields']['dateOfBirth']['input'])"
                        },
                        "dateWhenYouIntendToLeaveFromIndiaAfterYourCur": {
                            "id": "1680",
                            "label": "Date when you intend to leave from India after your current visit.",
                            "name": "dateWhenYouIntendToLeaveFromIndiaAfterYourCur",
                            "description": "Invalid Date when you intend to leave from India after your current visit",
                            "mandatory": 1,
                            "type": "date",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": "new Date(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['nriDetails']['fields']['dateWhenYouIntendToLeaveFromIndiaAfterYourCur']['input']) > new Date()"
                        },
                        "durationOfStay": {
                            "id": "1681",
                            "label": "Duration of your stay abroad.",
                            "name": "durationOfStay",
                            "description": "Duration must be in format eg. \"20 Days\" or \"03 Months\" or \"02 Years\"",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 20,
                            "pattern": "/^[a-zA-Z0-9\\s]*$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "dateOfReturnIfKnown": {
                            "id": "1682",
                            "label": "Date of return if known.",
                            "name": "dateOfReturnIfKnown",
                            "description": "Please provide valid Date of return if known.",
                            "mandatory": 1,
                            "type": "date",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": "(formInfo['fieldGroups']['proposerDetails']['fieldGroups']['nriDetails']['fields']['dateOfReturnIfKnown']['input'] > formInfo['fieldGroups']['proposerDetails']['fieldGroups']['nriDetails']['fields']['dateForLeavingIndia']['input'])"
                        },
                        "purposeOfYourStay": {
                            "id": "1683",
                            "label": "Purpose of your stay abroad.",
                            "name": "purposeOfYourStay",
                            "description": "Please provide Purpose of your stay abroad.",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[a-zA-Z\\s]*$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "nameAddress": {
                            "id": "1684",
                            "label": "Name and address of person to whom the policy document is to be sent in India?",
                            "name": "nameAddress",
                            "description": "Please provide Name and single space and address",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 100,
                            "pattern": "/^[#.0-9a-zA-Z\\s,-]+$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "bankAccountNumber": {
                            "id": "1685",
                            "label": "Please state your NRI Bank account number and the name of the bank.",
                            "name": "bankAccountNumber",
                            "description": "Please state valid NRI Bank account number and the name of the bank.",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 20,
                            "pattern": "/^[#0-9a-zA-Z\\s]+$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "sourceOfPremium": {
                            "id": "1686",
                            "label": "The source from which the premiums will be paid?",
                            "name": "sourceOfPremium",
                            "description": "Please provide The source from which the premiums will be paid?",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 20,
                            "pattern": "/^[#a-zA-Z\\s]+$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "passportNumber": {
                            "id": "1687",
                            "label": "Passport / PIO Card Number.",
                            "name": "passportNumber",
                            "description": "Please provide valid Passport / PIO Card Number.",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": 1,
                            "max": 10,
                            "pattern": "/^[#0-9a-zA-Z]+$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        },
                        "dateOfIssue": {
                            "id": "1688",
                            "label": "Date and place of issue.",
                            "name": "dateOfIssue",
                            "description": "Date must be in DD-MM-YYYY format with single space and Place of Issue",
                            "mandatory": 1,
                            "type": "text",
                            "value": null,
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": "/^[a-zA-Z0-9 -]*$/",
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        }
                    }
                },
                "premiumPayment": {
                    "id": 71,
                    "name": "premiumPayment",
                    "description": "Section to capture premium payment details",
                    "parent": 24,
                    "label": "Premium Payment",
                    "type": null,
                    "sizeOfArray": null,
                    "visibility": null,
                    "validation": null,
                    "order": 5,
                    "fields": {
                        "premiumpayment": {
                            "id": "1513",
                            "label": "Premium Paid By?",
                            "name": "premiumpayment",
                            "description": "Premium paid by?",
                            "mandatory": 1,
                            "type": "single-select",
                            "value": [
                                {
                                    "Text": "Proposer",
                                    "Value": "Proposer"
                                },
                                {
                                    "Text": "Others",
                                    "Value": "Others"
                                }
                            ],
                            "default": null,
                            "min": null,
                            "max": null,
                            "pattern": null,
                            "input": "",
                            "visibility": null,
                            "validation": ""
                        }
                    }
                }
            }
        },
       
    }
}
export {
    FORMINFO
}